/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 137);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(4)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(144);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(246).Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      r.strip();
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(245)(module)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(213)
var ieee754 = __webpack_require__(214)
var isArray = __webpack_require__(92)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 5 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(81);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;
var BN = __webpack_require__(3);
var minAssert = __webpack_require__(7);
var minUtils = __webpack_require__(124);

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w, bits) {
  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
  naf.fill(0);

  var ws = 1 << (w + 1);
  var k = num.clone();

  for (var i = 0; i < naf.length; i++) {
    var z;
    var mod = k.andln(ws - 1);
    if (k.isOdd()) {
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }

    naf[i] = z;
    k.iushrn(1);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    []
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {

    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      var m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      var m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
           this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
                                     bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;



/***/ }),
/* 9 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Context__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__connect_connect__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hooks_useDispatch__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks_useSelector__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hooks_useStore__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_batch__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_reactBatchedUpdates__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_shallowEqual__ = __webpack_require__(73);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport connectAdvanced */
/* unused harmony reexport ReactReduxContext */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__connect_connect__["a"]; });
/* unused harmony reexport batch */
/* unused harmony reexport useDispatch */
/* unused harmony reexport createDispatchHook */
/* unused harmony reexport useSelector */
/* unused harmony reexport createSelectorHook */
/* unused harmony reexport useStore */
/* unused harmony reexport createStoreHook */
/* unused harmony reexport shallowEqual */










Object(__WEBPACK_IMPORTED_MODULE_7__utils_batch__["b" /* setBatch */])(__WEBPACK_IMPORTED_MODULE_8__utils_reactBatchedUpdates__["a" /* unstable_batchedUpdates */]);


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(7);
var inherits = __webpack_require__(1);

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(150);


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(0).Buffer
var Transform = __webpack_require__(49).Transform
var StringDecoder = __webpack_require__(53).StringDecoder
var inherits = __webpack_require__(1)

function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  if (this._final) {
    this.__final = this._final
    this._final = null
  }
  this._decoder = null
  this._encoding = null
}
inherits(CipherBase, Transform)

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc)
  }

  var outData = this._update(data)
  if (this.hashMode) return this

  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }

  return outData
}

CipherBase.prototype.setAutoPadding = function () {}
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this.__final())
  } catch (e) {
    err = e
  }

  done(err)
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0)
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings')

  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }

  return out
}

module.exports = CipherBase


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReactReduxContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ReactReduxContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);
/* unused harmony default export */ var _unused_webpack_default_export = (ReactReduxContext);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(182);

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button_css__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Button_css__);
var Button=function Button(props){var allClasses=["Button"];if(props.otherClass){allClasses.push(props.otherClass);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:allClasses.join(" "),onClick:props.clicked},props.children);};/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(1)
var MD5 = __webpack_require__(48)
var RIPEMD160 = __webpack_require__(54)
var sha = __webpack_require__(34)
var Base = __webpack_require__(13)

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(33);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(__webpack_require__(25));
util.inherits = __webpack_require__(1);
/*</replacement>*/

var Readable = __webpack_require__(97);
var Writable = __webpack_require__(52);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536

// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = __webpack_require__(0).Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

  var bytes = Buffer.allocUnsafe(size)

  if (size > 0) {  // getRandomValues fails on IE if size == 0
    if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
      // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
      for (var generated = 0; generated < size; generated += MAX_BYTES) {
        // buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES))
      }
    } else {
      crypto.getRandomValues(bytes)
    }
  }

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(9)))

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Spinner_css__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Spinner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Spinner_css__);
var Spinner=function Spinner(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"Loader"},'Loading...');};/* harmony default export */ __webpack_exports__["a"] = (Spinner);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(0).Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function isObject(arg) {
  var type = typeof arg;
  return Boolean(arg) && (type === 'object' || type === 'function');
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4).Buffer))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4).Buffer))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);
var assert = __webpack_require__(7);

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = exports;

asn1.bignum = __webpack_require__(3);

asn1.define = __webpack_require__(331).define;
asn1.base = __webpack_require__(29);
asn1.constants = __webpack_require__(130);
asn1.decoders = __webpack_require__(336);
asn1.encoders = __webpack_require__(338);


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var base = exports;

base.Reporter = __webpack_require__(333).Reporter;
base.DecoderBuffer = __webpack_require__(129).DecoderBuffer;
base.EncoderBuffer = __webpack_require__(129).EncoderBuffer;
base.Node = __webpack_require__(334);


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserRouter; });
/* unused harmony export HashRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Link; });
/* unused harmony export NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(66);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__ = __webpack_require__(40);











/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["b" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  BrowserRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["b" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  HashRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    getUserConfirmation: PropTypes.func,
    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

var resolveToLocation = function resolveToLocation(to, currentLocation) {
  return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
  return typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, currentLocation) : to;
};

var forwardRefShim = function forwardRefShim(C) {
  return C;
};

var forwardRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef === "undefined") {
  forwardRef = forwardRefShim;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var LinkAnchor = forwardRef(function (_ref, forwardedRef) {
  var innerRef = _ref.innerRef,
      navigate = _ref.navigate,
      _onClick = _ref.onClick,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["innerRef", "navigate", "onClick"]);

  var target = rest.target;

  var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    onClick: function onClick(event) {
      try {
        if (_onClick) _onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && ( // ignore everything but left clicks
      !target || target === "_self") && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();
          navigate();
        }
    }
  }); // React 15 compat


  if (forwardRefShim !== forwardRef) {
    props.ref = forwardedRef || innerRef;
  } else {
    props.ref = innerRef;
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("a", props);
});

if (false) {
  LinkAnchor.displayName = "LinkAnchor";
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link = forwardRef(function (_ref2, forwardedRef) {
  var _ref2$component = _ref2.component,
      component = _ref2$component === void 0 ? LinkAnchor : _ref2$component,
      replace = _ref2.replace,
      to = _ref2.to,
      innerRef = _ref2.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["component", "replace", "to", "innerRef"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Link> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context.history;
    var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
    var href = location ? history.createHref(location) : "";

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      href: href,
      navigate: function navigate() {
        var location = resolveToLocation(to, context.location);
        var method = replace ? history.replace : history.push;
        method(location);
      }
    }); // React 15 compat


    if (forwardRefShim !== forwardRef) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props);
  });
});

if (false) {
  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]);
  var refType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]);
  Link.displayName = "Link";
  Link.propTypes = {
    innerRef: refType,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    to: toType.isRequired
  };
}

var forwardRefShim$1 = function forwardRefShim(C) {
  return C;
};

var forwardRef$1 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef$1 === "undefined") {
  forwardRef$1 = forwardRefShim$1;
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


var NavLink = forwardRef$1(function (_ref, forwardedRef) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      locationProp = _ref.location,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      innerRef = _ref.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "strict", "style", "to", "innerRef"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <NavLink> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var currentLocation = locationProp || context.location;
    var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
    var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    var match = escapedPath ? Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["d" /* matchPath */])(currentLocation.pathname, {
      path: escapedPath,
      exact: exact,
      strict: strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
    var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
    var style = isActive ? Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styleProp, {}, activeStyle) : styleProp;

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({
      "aria-current": isActive && ariaCurrent || null,
      className: className,
      style: style,
      to: toLocation
    }, rest); // React 15 compat


    if (forwardRefShim$1 !== forwardRef$1) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Link, props);
  });
});

if (false) {
  NavLink.displayName = "NavLink";
  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true"]);
  NavLink.propTypes = _extends({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.object,
    className: PropTypes.string,
    exact: PropTypes.bool,
    isActive: PropTypes.func,
    location: PropTypes.object,
    strict: PropTypes.bool,
    style: PropTypes.object
  });
}


//# sourceMappingURL=react-router-dom.js.map


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(154)();
}


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__(259)
exports.sha1 = __webpack_require__(260)
exports.sha224 = __webpack_require__(261)
exports.sha256 = __webpack_require__(101)
exports.sha384 = __webpack_require__(262)
exports.sha512 = __webpack_require__(102)


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = __webpack_require__(0).Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(0).Buffer
var MD5 = __webpack_require__(48)

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(3);
var utils = __webpack_require__(8);
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  this._bitLength = this.n ? this.n.bitLength() : 0;

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1, this._bitLength);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  for (var j = 0; j < naf.length; j += doubles.step) {
    var nafW = 0;
    for (var k = j + doubles.step - 1; k >= j; k--)
      nafW = (nafW << 1) + naf[k];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (var j = 0; j < repr.length; j++) {
      var nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w, this._bitLength);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var k = 0; i >= 0 && naf[i] === 0; i--)
      k++;
    if (i >= 0)
      k++;
    acc = acc.dblp(k);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
                                                       points,
                                                       coeffs,
                                                       len,
                                                       jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  for (var i = 0; i < len; i++) {
    var p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (var i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b] /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (var j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (var i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (var j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (var j = 0; j < len; j++) {
      var z = tmp[j];
      var p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (var i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
                          bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len)) ;
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(330)
var aesid = __webpack_require__(341)
var fixProc = __webpack_require__(342)
var ciphers = __webpack_require__(57)
var compat = __webpack_require__(55)
var Buffer = __webpack_require__(0).Buffer
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = Buffer.from(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen, 'sha1')
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ''));
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(163);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__batch__ = __webpack_require__(70);
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  var batch = Object(__WEBPACK_IMPORTED_MODULE_0__batch__["a" /* getBatch */])(); // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?

  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      batch(function () {
        for (var i = 0; i < listeners.length; i++) {
          listeners[i]();
        }
      });
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub) {
    this.store = store;
    this.parentSub = parentSub;
    this.unsubscribe = null;
    this.listeners = nullListeners;
    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.handleChangeWrapper = function handleChangeWrapper() {
    if (this.onStateChange) {
      this.onStateChange();
    }
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(93);
var isFunction = __webpack_require__(46);
var isObject = __webpack_require__(24);
var isStamp = __webpack_require__(94);
var isComposable = __webpack_require__(236);

var assign = __webpack_require__(47);
var merge = __webpack_require__(95);

var slice = Array.prototype.slice;

/**
 * Creates new factory instance.
 * @returns {Function} The new factory function.
 */
function createFactory() {
  return function Stamp(options) {
    var descriptor = Stamp.compose || {};
    // Next line was optimized for most JS VMs. Please, be careful here!
    var obj = {__proto__: descriptor.methods}; // jshint ignore:line

    merge(obj, descriptor.deepProperties);
    assign(obj, descriptor.properties);
    Object.defineProperties(obj, descriptor.propertyDescriptors || {});

    if (!descriptor.initializers || descriptor.initializers.length === 0) return obj;

    if (options === undefined) options = {};
    var inits = descriptor.initializers;
    var length = inits.length;
    for (var i = 0; i < length; i += 1) {
      var initializer = inits[i];
      if (isFunction(initializer)) {
        var returnedValue = initializer.call(obj, options,
          {instance: obj, stamp: Stamp, args: slice.apply(arguments)});
        obj = returnedValue === undefined ? obj : returnedValue;
      }
    }

    return obj;
  };
}

/**
 * Returns a new stamp given a descriptor and a compose function implementation.
 * @param {Descriptor} [descriptor={}] The information about the object the stamp will be creating.
 * @param {Compose} composeFunction The "compose" function implementation.
 * @returns {Stamp}
 */
function createStamp(descriptor, composeFunction) {
  var Stamp = createFactory();

  if (descriptor.staticDeepProperties) {
    merge(Stamp, descriptor.staticDeepProperties);
  }
  if (descriptor.staticProperties) {
    assign(Stamp, descriptor.staticProperties);
  }
  if (descriptor.staticPropertyDescriptors) {
    Object.defineProperties(Stamp, descriptor.staticPropertyDescriptors);
  }

  var composeImplementation = isFunction(Stamp.compose) ? Stamp.compose : composeFunction;
  Stamp.compose = function _compose() {
    'use strict'; // to make sure `this` is not pointing to `global` or `window`
    return composeImplementation.apply(this, arguments);
  };
  assign(Stamp.compose, descriptor);

  return Stamp;
}

function concatAssignFunctions(dstObject, srcArray, propName) {
  if (!isArray(srcArray)) return;

  var length = srcArray.length;
  var dstArray = dstObject[propName] || [];
  dstObject[propName] = dstArray;
  for (var i = 0; i < length; i += 1) {
    var fn = srcArray[i];
    if (isFunction(fn) && dstArray.indexOf(fn) < 0) {
      dstArray.push(fn);
    }
  }
}


function combineProperties(dstObject, srcObject, propName, action) {
  if (!isObject(srcObject[propName])) return;
  if (!isObject(dstObject[propName])) dstObject[propName] = {};
  action(dstObject[propName], srcObject[propName]);
}

function deepMergeAssign(dstObject, srcObject, propName) {
  combineProperties(dstObject, srcObject, propName, merge);
}
function mergeAssign(dstObject, srcObject, propName) {
  combineProperties(dstObject, srcObject, propName, assign);
}

/**
 * Mutates the dstDescriptor by merging the srcComposable data into it.
 * @param {Descriptor} dstDescriptor The descriptor object to merge into.
 * @param {Composable} [srcComposable] The composable
 * (either descriptor or stamp) to merge data form.
 */
function mergeComposable(dstDescriptor, srcComposable) {
  var srcDescriptor = (srcComposable && srcComposable.compose) || srcComposable;

  mergeAssign(dstDescriptor, srcDescriptor, 'methods');
  mergeAssign(dstDescriptor, srcDescriptor, 'properties');
  deepMergeAssign(dstDescriptor, srcDescriptor, 'deepProperties');
  mergeAssign(dstDescriptor, srcDescriptor, 'propertyDescriptors');
  mergeAssign(dstDescriptor, srcDescriptor, 'staticProperties');
  deepMergeAssign(dstDescriptor, srcDescriptor, 'staticDeepProperties');
  mergeAssign(dstDescriptor, srcDescriptor, 'staticPropertyDescriptors');
  mergeAssign(dstDescriptor, srcDescriptor, 'configuration');
  deepMergeAssign(dstDescriptor, srcDescriptor, 'deepConfiguration');
  concatAssignFunctions(dstDescriptor, srcDescriptor.initializers, 'initializers');
  concatAssignFunctions(dstDescriptor, srcDescriptor.composers, 'composers');
}

/**
 * Given the list of composables (stamp descriptors and stamps) returns
 * a new stamp (composable factory function).
 * @typedef {Function} Compose
 * @param {...(Composable)} [arguments] The list of composables.
 * @returns {Stamp} A new stamp (aka composable factory function)
 */
module.exports = function compose() {
  'use strict'; // to make sure `this` is not pointing to `global` or `window`
  var descriptor = {};
  var composables = [];
  if (isComposable(this)) {
    mergeComposable(descriptor, this);
    composables.push(this);
  }

  for (var i = 0; i < arguments.length; i++) {
    var arg = arguments[i];
    if (isComposable(arg)) {
      mergeComposable(descriptor, arg);
      composables.push(arg);
    }
  }

  var stamp = createStamp(descriptor, compose);

  var composers = descriptor.composers;
  if (isArray(composers) && composers.length > 0) {
    for (var j = 0; j < composers.length; j += 1) {
      var composer = composers[j];
      var returnedValue = composer({stamp: stamp, composables: composables});
      stamp = isStamp(returnedValue) ? returnedValue : stamp;
    }
  }

  return stamp;
};


/**
 * The Stamp Descriptor
 * @typedef {Function|Object} Descriptor
 * @returns {Stamp} A new stamp based on this Stamp
 * @property {Object} [methods] Methods or other data used as object instances' prototype
 * @property {Array<Function>} [initializers] List of initializers called for each object instance
 * @property {Array<Function>} [composers] List of callbacks called each time a composition happens
 * @property {Object} [properties] Shallow assigned properties of object instances
 * @property {Object} [deepProperties] Deeply merged properties of object instances
 * @property {Object} [staticProperties] Shallow assigned properties of Stamps
 * @property {Object} [staticDeepProperties] Deeply merged properties of Stamps
 * @property {Object} [configuration] Shallow assigned properties of Stamp arbitrary metadata
 * @property {Object} [deepConfiguration] Deeply merged properties of Stamp arbitrary metadata
 * @property {Object} [propertyDescriptors] ES5 Property Descriptors applied to object instances
 * @property {Object} [staticPropertyDescriptors] ES5 Property Descriptors applied to Stamps
 */

/**
 * The Stamp factory function
 * @typedef {Function} Stamp
 * @returns {*} Instantiated object
 * @property {Descriptor} compose - The Stamp descriptor and composition function
 */

/**
 * A composable object - stamp or descriptor
 * @typedef {Stamp|Descriptor} Composable
 */



/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = function isFunction(arg) {
  return typeof arg === 'function';
};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = Object.assign;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(1)
var HashBase = __webpack_require__(96)
var Buffer = __webpack_require__(0).Buffer

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(50).EventEmitter;
var inherits = __webpack_require__(1);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(51);
Stream.Writable = __webpack_require__(255);
Stream.Duplex = __webpack_require__(256);
Stream.Transform = __webpack_require__(257);
Stream.PassThrough = __webpack_require__(258);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(97);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(52);
exports.Duplex = __webpack_require__(18);
exports.Transform = __webpack_require__(100);
exports.PassThrough = __webpack_require__(254);


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(33);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(__webpack_require__(25));
util.inherits = __webpack_require__(1);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(253)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(98);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(0).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(99);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(18);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(18);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(251).setImmediate, __webpack_require__(5)))

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(0).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(4).Buffer
var inherits = __webpack_require__(1)
var HashBase = __webpack_require__(96)

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

exports.pbkdf2 = __webpack_require__(263)
exports.pbkdf2Sync = __webpack_require__(105)


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(7);

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var ciphers = __webpack_require__(296)
var deciphers = __webpack_require__(304)
var modes = __webpack_require__(119)

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var modeModules = {
  ECB: __webpack_require__(297),
  CBC: __webpack_require__(298),
  CFB: __webpack_require__(299),
  CFB8: __webpack_require__(300),
  CFB1: __webpack_require__(301),
  OFB: __webpack_require__(302),
  CTR: __webpack_require__(117),
  GCM: __webpack_require__(117)
}

var modes = __webpack_require__(119)

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = __webpack_require__(307);
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var bn = __webpack_require__(3);
var randomBytes = __webpack_require__(19);
module.exports = crt;
function blind(priv) {
  var r = getr(priv);
  var blinder = r.toRed(bn.mont(priv.modulus))
  .redPow(new bn(priv.publicExponent)).fromRed();
  return {
    blinder: blinder,
    unblinder:r.invm(priv.modulus)
  };
}
function crt(msg, priv) {
  var blinds = blind(priv);
  var len = priv.modulus.byteLength();
  var mod = bn.mont(priv.modulus);
  var blinded = new bn(msg).mul(blinds.blinder).umod(priv.modulus);
  var c1 = blinded.toRed(bn.mont(priv.prime1));
  var c2 = blinded.toRed(bn.mont(priv.prime2));
  var qinv = priv.coefficient;
  var p = priv.prime1;
  var q = priv.prime2;
  var m1 = c1.redPow(priv.exponent1);
  var m2 = c2.redPow(priv.exponent2);
  m1 = m1.fromRed();
  m2 = m2.fromRed();
  var h = m1.isub(m2).imul(qinv).umod(p);
  h.imul(q);
  m2.iadd(h);
  return new Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
}
crt.getr = getr;
function getr(priv) {
  var len = priv.modulus.byteLength();
  var r = new bn(randomBytes(len));
  while (r.cmp(priv.modulus) >=  0 || !r.umod(priv.prime1) || !r.umod(priv.prime2)) {
    r = new bn(randomBytes(len));
  }
  return r;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4).Buffer))

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = exports;

elliptic.version = __webpack_require__(312).version;
elliptic.utils = __webpack_require__(8);
elliptic.rand = __webpack_require__(59);
elliptic.curve = __webpack_require__(125);
elliptic.curves = __webpack_require__(62);

// Protocols
elliptic.ec = __webpack_require__(323);
elliptic.eddsa = __webpack_require__(327);


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curves = exports;

var hash = __webpack_require__(63);
var curve = __webpack_require__(125);
var utils = __webpack_require__(8);

var assert = utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new curve.edwards(options);
  else
    this.curve = new curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve
      });
      return curve;
    }
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
  ]
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
  ]
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
  ]
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f'
  ]
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650'
  ]
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9'
  ]
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658'
  ]
});

var pre;
try {
  pre = __webpack_require__(322);
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3'
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15'
    }
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre
  ]
});


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var hash = exports;

hash.utils = __webpack_require__(11);
hash.common = __webpack_require__(27);
hash.sha = __webpack_require__(316);
hash.ripemd = __webpack_require__(320);
hash.hmac = __webpack_require__(321);

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(140);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(145);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MemoryRouter */
/* unused harmony export Prompt */
/* unused harmony export Redirect */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Router; });
/* unused harmony export StaticRouter */
/* unused harmony export Switch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return context; });
/* unused harmony export generatePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return matchPath; });
/* unused harmony export useHistory */
/* unused harmony export useLocation */
/* unused harmony export useParams */
/* unused harmony export useRouteMatch */
/* unused harmony export withRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__);













// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = Object(__WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__["a" /* default */])();
  context.displayName = name;
  return context;
};

var context =
/*#__PURE__*/
createNamedContext("Router");

/**
 * The public API for putting history on context.
 */

var Router =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        if (_this._isMounted) {
          _this.setState({
            location: location
          });
        } else {
          _this._pendingLocation = location;
        }
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
      children: this.props.children || null,
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    });
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Router.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  };

  Router.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(prevProps.history === this.props.history, "You cannot change <Router history>") : void 0;
  };
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  MemoryRouter.propTypes = {
    initialEntries: PropTypes.array,
    initialIndex: PropTypes.number,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node
  };

  MemoryRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.") : void 0;
  };
}

var Lifecycle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Prompt> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    if (!when || context.staticContext) return null;
    var method = context.history.block;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) {
  var messageType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
  Prompt.propTypes = {
    when: PropTypes.bool,
    message: messageType.isRequired
  };
}

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default.a.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Redirect> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context.history,
        staticContext = context.staticContext;
    var method = push ? history.push : history.replace;
    var location = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        var prevLocation = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(prevProps.to);

        if (!Object(__WEBPACK_IMPORTED_MODULE_3_history__["f" /* locationsAreEqual */])(prevLocation, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
          key: prevLocation.key
        }))) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {
  Redirect.propTypes = {
    push: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  };
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default()(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string" || Array.isArray(options)) {
    options = {
      path: options
    };
  }

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (!path && path !== "") return null;
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.count(children) === 0;
}

function evalChildrenDev(children, props, path) {
  var value = children(props);
   false ? warning(value !== undefined, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? " path=\"" + path + "\"" : "") + ">, but you ") + "should have returned a React element or `null`") : void 0;
  return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context$1) {
      !context$1 ?  false ? invariant(false, "You should not use <Route> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;

      var props = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, context$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && children.length === 0) {
        children = null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
        value: props
      }, props.match ? children ? typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : children : component ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, props) : render ? render(props) : null : typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : null);
    });
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Route.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    component: function component(props, propName) {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    exact: PropTypes.bool,
    location: PropTypes.object,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    render: PropTypes.func,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool
  };

  Route.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored") : void 0;
  };

  Route.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createPath */])(location);
}

function staticHandler(methodName) {
  return function () {
      false ? invariant(false, "You cannot %s with <StaticRouter>", methodName) : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) ;
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        _this$props$context = _this$props.context,
        context = _this$props$context === void 0 ? {} : _this$props$context;
    context.action = action;
    context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  StaticRouter.propTypes = {
    basename: PropTypes.string,
    context: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  StaticRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <Switch> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.forEach(_this.props.children, function (child) {
        if (match == null && __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, child.props, {
            path: path
          })) : context.match;
        }
      });
      return match ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Switch.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
  };

  Switch.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";

  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <" + displayName + " /> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, remainingProps, context, {
        ref: wrappedComponentRef
      }));
    });
  };

  C.displayName = displayName;
  C.WrappedComponent = Component;

  if (false) {
    C.propTypes = {
      wrappedComponentRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
    };
  }

  return __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default()(C, Component);
}

var useContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useContext;
function useHistory() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useHistory()") : invariant(false) : void 0;
  }

  return useContext(context).history;
}
function useLocation() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useLocation()") : invariant(false) : void 0;
  }

  return useContext(context).location;
}
function useParams() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useParams()") : invariant(false) : void 0;
  }

  var match = useContext(context).match;
  return match ? match.params : {};
}
function useRouteMatch(path) {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useRouteMatch()") : invariant(false) : void 0;
  }

  return path ? matchPath(useLocation().pathname, path) : useContext(context).match;
}

if (false) {
  if (typeof window !== "undefined") {
    var global = window;
    var key = "__react_router_build__";
    var buildNames = {
      cjs: "CommonJS",
      esm: "ES modules",
      umd: "UMD"
    };

    if (global[key] && global[key] !== "esm") {
      var initialBuildName = buildNames[global[key]];
      var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
      // loading 2 different builds.

      throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }

    global[key] = "esm";
  }
}


//# sourceMappingURL=react-router.js.map


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(40);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(41);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBatch; });
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_Subscription__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_useIsomorphicLayoutEffect__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Context__ = __webpack_require__(14);








 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? __WEBPACK_IMPORTED_MODULE_8__Context__["a" /* ReactReduxContext */] : _ref2$context,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);

  __WEBPACK_IMPORTED_MODULE_3_invariant___default()(renderCountProp === undefined, "renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
  __WEBPACK_IMPORTED_MODULE_3_invariant___default()(!withRef, 'withRef is removed. To access the wrapped instance, use a ref on the connected component');
  var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
  __WEBPACK_IMPORTED_MODULE_3_invariant___default()(storeKey === 'store', 'storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {
      invariant(isValidElementType(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? __WEBPACK_IMPORTED_MODULE_4_react__["useMemo"] : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var forwardedRef = props.forwardedRef,
            wrapperProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["forwardedRef"]);

        return [props.context, forwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          forwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && Object(__WEBPACK_IMPORTED_MODULE_5_react_is__["isContextConsumer"])(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useContext"])(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
      __WEBPACK_IMPORTED_MODULE_3_invariant___default()(didStoreComeFromProps || didStoreComeFromContext, "Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options.")); // Based on the previous check, one of these must be true

      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var subscription = new __WEBPACK_IMPORTED_MODULE_6__utils_Subscription__["a" /* default */](store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useReducer"])(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();
      var lastWrapperProps = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(wrapperProps);
      var childPropsFromStoreUpdate = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();
      var renderIsScheduled = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      Object(__WEBPACK_IMPORTED_MODULE_7__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
        // We want to capture the wrapper props and child props we used for later comparisons
        lastWrapperProps.current = wrapperProps;
        lastChildProps.current = actualChildProps;
        renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

        if (childPropsFromStoreUpdate.current) {
          childPropsFromStoreUpdate.current = null;
          notifyNestedSubs();
        }
      }); // Our re-subscribe logic only runs when the store/subscription setup changes

      Object(__WEBPACK_IMPORTED_MODULE_7__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
        // If we're not subscribed to the store, nothing to do here
        if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

        var didUnsubscribe = false;
        var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

        var checkForUpdates = function checkForUpdates() {
          if (didUnsubscribe) {
            // Don't run stale listeners.
            // Redux doesn't guarantee unsubscriptions happen until next dispatch.
            return;
          }

          var latestStoreState = store.getState();
          var newChildProps, error;

          try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
          } catch (e) {
            error = e;
            lastThrownError = e;
          }

          if (!error) {
            lastThrownError = null;
          } // If the child props haven't changed, nothing to do here - cascade the subscription update


          if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) {
              notifyNestedSubs();
            }
          } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

            forceComponentUpdateDispatch({
              type: 'STORE_UPDATED',
              payload: {
                error: error
              }
            });
          }
        }; // Actually subscribe to the nearest connected ancestor (or store)


        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe(); // Pull data from the store after first render in case the store has
        // changed since we began.

        checkForUpdates();

        var unsubscribeWrapper = function unsubscribeWrapper() {
          didUnsubscribe = true;
          subscription.tryUnsubscribe();
          subscription.onStateChange = null;

          if (lastThrownError) {
            // It's possible that we caught an error due to a bad mapState function, but the
            // parent re-rendered without this component and we're about to unmount.
            // This shouldn't happen as long as we do top-down subscriptions correctly, but
            // if we ever do those wrong, this throw will surface the error in our tests.
            // In that case, throw the error from here so it doesn't get lost.
            throw lastThrownError;
          }
        };

        return unsubscribeWrapper;
      }, [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, actualChildProps, {
          ref: forwardedRef
        }));
      }, [forwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;

    if (forwardRef) {
      var forwarded = __WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function forwardConnectRef(props, ref) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Connect, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
          forwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(forwarded, WrappedComponent);
    }

    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useIsomorphicLayoutEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var isHopefullyDomEnvironment = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
var useIsomorphicLayoutEffect = isHopefullyDomEnvironment ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* unused harmony export applyMiddleware */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bindActionCreators; });
/* unused harmony export combineReducers */
/* unused harmony export compose */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(167);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(77);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(78);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStoreHook;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Context__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useReduxContext__ = __webpack_require__(80);



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {Function} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */];
  }

  var useReduxContext = context === __WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_2__useReduxContext__["a" /* useReduxContext */] : function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore = createStoreHook();

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useReduxContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Context__ = __webpack_require__(14);



/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext() {
  var contextValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__components_Context__["a" /* ReactReduxContext */]);
  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(contextValue, 'could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
  return contextValue;
}

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(6);
var normalizeHeaderName = __webpack_require__(187);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(85);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(85);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);
var settle = __webpack_require__(188);
var buildURL = __webpack_require__(82);
var buildFullPath = __webpack_require__(190);
var parseHeaders = __webpack_require__(193);
var isURLSameOrigin = __webpack_require__(194);
var createError = __webpack_require__(86);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(195);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(189);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Input_css__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Input_css__);
var Input=function Input(props){var allClasses=["Input"];if(props.otherClass){allClasses.push(props.otherClass);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:props.placeHolder,onChange:props.onChange,className:allClasses.join(" ")});};/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DisplayModal_css__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DisplayModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DisplayModal_css__);
/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DisplayModal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'myModal',className:'modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'close'},'\xD7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,props.header)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,props.fi),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,props.fii)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Button_Button__["a" /* default */],{clicked:props.clicked},'Ok')))));});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Backdrop_css__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Backdrop_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Backdrop_css__);
var backdrop=function backdrop(props){return props.show?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Backdrop',onClick:props.clicked}):null;};/* harmony default export */ __webpack_exports__["a"] = (backdrop);

/***/ }),
/* 92 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = Array.isArray;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(46);

module.exports = function isStamp(arg) {
  return isFunction(arg) && isFunction(arg.compose);
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(237);
var isObject = __webpack_require__(24);
var isArray = __webpack_require__(93);

/**
 * The 'src' argument plays the command role.
 * The returned values is always of the same type as the 'src'.
 * @param dst The object to merge into
 * @param src The object to merge from
 * @returns {*}
 */
function mergeOne(dst, src) {
  if (src === undefined) return dst;

  // According to specification arrays must be concatenated.
  // Also, the '.concat' creates a new array instance. Overrides the 'dst'.
  if (isArray(src)) return (isArray(dst) ? dst : []).concat(src);

  // Now deal with non plain 'src' object. 'src' overrides 'dst'
  // Note that functions are also assigned! We do not deep merge functions.
  if (!isPlainObject(src)) return src;

  // See if 'dst' is allowed to be mutated.
  // If not - it's overridden with a new plain object.
  var returnValue = isObject(dst) ? dst : {};

  var keys = Object.keys(src);
  for (var i = 0; i < keys.length; i += 1) {
    var key = keys[i];

    var srcValue = src[key];
    // Do not merge properties with the 'undefined' value.
    if (srcValue !== undefined) {
      var dstValue = returnValue[key];
      // Recursive calls to mergeOne() must allow only plain objects or arrays in dst
      var newDst = isPlainObject(dstValue) || isArray(srcValue) ? dstValue : {};

      // deep merge each property. Recursion!
      returnValue[key] = mergeOne(newDst, srcValue);
    }
  }

  return returnValue;
}

module.exports = function (dst) {
  for (var i = 1; i < arguments.length; i++) {
    dst = mergeOne(dst, arguments[i]);
  }
  return dst;
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(0).Buffer
var Transform = __webpack_require__(49).Transform
var inherits = __webpack_require__(1)

function throwIfNotStringOrBuffer (val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer')
  }
}

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data')
  if (this._finalized) throw new Error('Digest already called')
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(33);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(92);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(50).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(98);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(0).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(__webpack_require__(25));
util.inherits = __webpack_require__(1);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(248);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(249);
var destroyImpl = __webpack_require__(99);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(18);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(53).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(18);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(53).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(9)))

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(50).EventEmitter;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(33);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(18);

/*<replacement>*/
var util = Object.create(__webpack_require__(25));
util.inherits = __webpack_require__(1);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(1)
var Hash = __webpack_require__(22)
var Buffer = __webpack_require__(0).Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(1)
var Hash = __webpack_require__(22)
var Buffer = __webpack_require__(0).Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

function checkBuffer (buf, name) {
  if (typeof buf !== 'string' && !Buffer.isBuffer(buf)) {
    throw new TypeError(name + ' must be a buffer or string')
  }
}

module.exports = function (password, salt, iterations, keylen) {
  checkBuffer(password, 'Password')
  checkBuffer(salt, 'Salt')

  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4).Buffer))

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var defaultEncoding
/* istanbul ignore next */
if (process.browser) {
  defaultEncoding = 'utf-8'
} else {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
}
module.exports = defaultEncoding

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var md5 = __webpack_require__(106)
var RIPEMD160 = __webpack_require__(54)
var sha = __webpack_require__(34)

var checkParameters = __webpack_require__(103)
var defaultEncoding = __webpack_require__(104)
var Buffer = __webpack_require__(0).Buffer
var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }
  function rmd160Func (data) {
    return new RIPEMD160().update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(password, salt, iterations, keylen)

  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var MD5 = __webpack_require__(48)

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var ERROR_MSG_INPUT = 'Input must be an string, Buffer or Uint8Array'

// For convenience, let people hash a string, not just a Uint8Array
function normalizeInput (input) {
  var ret
  if (input instanceof Uint8Array) {
    ret = input
  } else if (input instanceof Buffer) {
    ret = new Uint8Array(input)
  } else if (typeof (input) === 'string') {
    ret = new Uint8Array(Buffer.from(input, 'utf8'))
  } else {
    throw new Error(ERROR_MSG_INPUT)
  }
  return ret
}

// Converts a Uint8Array to a hexadecimal string
// For example, toHex([255, 0, 255]) returns "ff00ff"
function toHex (bytes) {
  return Array.prototype.map.call(bytes, function (n) {
    return (n < 16 ? '0' : '') + n.toString(16)
  }).join('')
}

// Converts any value in [0...2^32-1] to an 8-character hex string
function uint32ToHex (val) {
  return (0x100000000 + val).toString(16).substring(1)
}

// For debugging: prints out hash state in the same format as the RFC
// sample computation exactly, so that you can diff
function debugPrint (label, arr, size) {
  var msg = '\n' + label + ' = '
  for (var i = 0; i < arr.length; i += 2) {
    if (size === 32) {
      msg += uint32ToHex(arr[i]).toUpperCase()
      msg += ' '
      msg += uint32ToHex(arr[i + 1]).toUpperCase()
    } else if (size === 64) {
      msg += uint32ToHex(arr[i + 1]).toUpperCase()
      msg += uint32ToHex(arr[i]).toUpperCase()
    } else throw new Error('Invalid size ' + size)
    if (i % 6 === 4) {
      msg += '\n' + new Array(label.length + 4).join(' ')
    } else if (i < arr.length - 2) {
      msg += ' '
    }
  }
  console.log(msg)
}

// For performance testing: generates N bytes of input, hashes M times
// Measures and prints MB/second hash performance each time
function testSpeed (hashFn, N, M) {
  var startMs = new Date().getTime()

  var input = new Uint8Array(N)
  for (var i = 0; i < N; i++) {
    input[i] = i % 256
  }
  var genMs = new Date().getTime()
  console.log('Generated random input in ' + (genMs - startMs) + 'ms')
  startMs = genMs

  for (i = 0; i < M; i++) {
    var hashHex = hashFn(input)
    var hashMs = new Date().getTime()
    var ms = hashMs - startMs
    startMs = hashMs
    console.log('Hashed in ' + ms + 'ms: ' + hashHex.substring(0, 20) + '...')
    console.log(Math.round(N / (1 << 20) / (ms / 1000) * 100) / 100 + ' MB PER SECOND')
  }
}

module.exports = {
  normalizeInput: normalizeInput,
  toHex: toHex,
  debugPrint: debugPrint,
  testSpeed: testSpeed
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4).Buffer))

/***/ }),
/* 108 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 109 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 110 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__(19)
exports.createHash = exports.Hash = __webpack_require__(17)
exports.createHmac = exports.Hmac = __webpack_require__(113)

var algos = __webpack_require__(290)
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = __webpack_require__(55)
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = __webpack_require__(291)

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = __webpack_require__(306)

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = __webpack_require__(310)

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = __webpack_require__(344)

var publicEncrypt = __webpack_require__(345)

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = __webpack_require__(348)

exports.randomFill = rf.randomFill
exports.randomFillSync = rf.randomFillSync

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(1)
var Legacy = __webpack_require__(289)
var Base = __webpack_require__(13)
var Buffer = __webpack_require__(0).Buffer
var md5 = __webpack_require__(106)
var RIPEMD160 = __webpack_require__(54)

var sha = __webpack_require__(34)

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}


/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(7);
var inherits = __webpack_require__(1);

var utils = __webpack_require__(115);
var Cipher = __webpack_require__(56);

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(26)
var Buffer = __webpack_require__(0).Buffer
var incr32 = __webpack_require__(118)

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),
/* 118 */
/***/ (function(module, exports) {

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32


/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(35)
var Buffer = __webpack_require__(0).Buffer
var Transform = __webpack_require__(13)
var inherits = __webpack_require__(1)
var GHASH = __webpack_require__(303)
var xor = __webpack_require__(26)
var incr32 = __webpack_require__(118)

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(35)
var Buffer = __webpack_require__(0).Buffer
var Transform = __webpack_require__(13)
var inherits = __webpack_require__(1)

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var randomBytes = __webpack_require__(19);
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__(3);
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__(123);
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__(3);
var brorand = __webpack_require__(59);

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = exports;

curve.base = __webpack_require__(37);
curve.short = __webpack_require__(313);
curve.mont = __webpack_require__(314);
curve.edwards = __webpack_require__(315);


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);
var common = __webpack_require__(27);
var shaCommon = __webpack_require__(126);
var assert = __webpack_require__(7);

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);
var common = __webpack_require__(27);
var assert = __webpack_require__(7);

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(1);
var Reporter = __webpack_require__(29).Reporter;
var Buffer = __webpack_require__(4).Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__(335);


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(1);

var asn1 = __webpack_require__(28);
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
                                                    options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(1);
var Buffer = __webpack_require__(4).Buffer;

var asn1 = __webpack_require__(28);
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}


/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var createHash = __webpack_require__(17)
var Buffer = __webpack_require__(0).Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}


/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var BN = __webpack_require__(3)
var Buffer = __webpack_require__(0).Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(138);
module.exports = __webpack_require__(143);


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(139).enable();
  window.Promise = __webpack_require__(141);
}

// fetch() polyfill for making API calls.
__webpack_require__(142);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(39);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(64);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(64);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 142 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducer_reducer__ = __webpack_require__(351);
var store=Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* createStore */])(__WEBPACK_IMPORTED_MODULE_7__reducer_reducer__["a" /* default */]);__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */],null)),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.3
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(39),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("307"):void 0;return a}
var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.3",
unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.3
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(2),n=__webpack_require__(39),r=__webpack_require__(146);function ba(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[c,d,e,f,g,h],k=0;a=Error(b.replace(/%s/g,function(){return l[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function x(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:x("227");function ca(a,b,c,d,e,f,g,h,l){var k=Array.prototype.slice.call(arguments,3);try{b.apply(c,k)}catch(m){this.onError(m)}}
var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,l){da=!1;ea=null;ca.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,l){ja.apply(this,arguments);if(da){if(da){var k=ea;da=!1;ea=null}else x("198"),k=void 0;fa||(fa=!0,ha=k)}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:x("96",a);if(!oa[c]){b.extractEvents?void 0:x("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?x("99",h):void 0;pa[h]=f;var l=f.phasedRegistrationNames;if(l){for(e in l)l.hasOwnProperty(e)&&qa(l[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:x("98",d,a)}}}}
function qa(a,b,c){ra[a]?x("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={},ta=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ka(d,b,void 0,a);a.currentTarget=null}function xa(a,b){null==b?x("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
var Ba={injectEventPluginOrder:function(a){la?x("101"):void 0;la=Array.prototype.slice.call(a);na()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?x("102",c):void 0,ma[c]=d,b=!0)}b&&na()}};
function Ca(a,b){var c=a.stateNode;if(!c)return null;var d=ta(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?x("231",b,typeof c):void 0;
return c}function Da(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a&&(ya(a,Aa),za?x("95"):void 0,fa))throw a=ha,fa=!1,ha=null,a;}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}
function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;x("33")}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ma(a,b,c){if(b=Ca(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ca(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}
function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||!window.document||!window.document.createElement);function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),$a=Wa("transitionend"),ab="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bb=null,cb=null,db=null;
function eb(){if(db)return db;var a,b=cb,c=b.length,d,e="value"in bb?bb.value:bb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return db=e.slice(a,1<d?1-d:void 0)}function fb(){return!0}function gb(){return!1}
function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?fb:gb;this.isPropagationStopped=gb;return this}
n(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=fb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=fb)},persist:function(){this.isPersistent=fb},isPersistent:gb,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=gb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;hb(c);return c};hb(y);function ib(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function jb(a){a instanceof this?void 0:x("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function hb(a){a.eventPool=[];a.getPooled=ib;a.release=jb}var kb=y.extend({data:null}),lb=y.extend({data:null}),mb=[9,13,27,32],nb=Ra&&"CompositionEvent"in window,ob=null;Ra&&"documentMode"in document&&(ob=document.documentMode);
var pb=Ra&&"TextEvent"in window&&!ob,qb=Ra&&(!nb||ob&&8<ob&&11>=ob),rb=String.fromCharCode(32),sb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},tb=!1;
function ub(a,b){switch(a){case "keyup":return-1!==mb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function vb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var wb=!1;function xb(a,b){switch(a){case "compositionend":return vb(b);case "keypress":if(32!==b.which)return null;tb=!0;return rb;case "textInput":return a=b.data,a===rb&&tb?null:a;default:return null}}
function yb(a,b){if(wb)return"compositionend"===a||!nb&&ub(a,b)?(a=eb(),db=cb=bb=null,wb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return qb&&"ko"!==b.locale?null:b.data;default:return null}}
var zb={eventTypes:sb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(nb)b:{switch(a){case "compositionstart":e=sb.compositionStart;break b;case "compositionend":e=sb.compositionEnd;break b;case "compositionupdate":e=sb.compositionUpdate;break b}e=void 0}else wb?ub(a,c)&&(e=sb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=sb.compositionStart);e?(qb&&"ko"!==c.locale&&(wb||e!==sb.compositionStart?e===sb.compositionEnd&&wb&&(f=eb()):(bb=d,cb="value"in bb?bb.value:bb.textContent,wb=
!0)),e=kb.getPooled(e,b,c,d),f?e.data=f:(f=vb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=pb?xb(a,c):yb(a,c))?(b=lb.getPooled(sb.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Ab=null,Bb=null,Cb=null;function Db(a){if(a=ua(a)){"function"!==typeof Ab?x("280"):void 0;var b=ta(a.stateNode);Ab(a.stateNode,a.type,b)}}function Eb(a){Bb?Cb?Cb.push(a):Cb=[a]:Bb=a}function Fb(){if(Bb){var a=Bb,b=Cb;Cb=Bb=null;Db(a);if(b)for(a=0;a<b.length;a++)Db(b[a])}}
function Gb(a,b){return a(b)}function Hb(a,b,c){return a(b,c)}function Ib(){}var Jb=!1;function Kb(a,b){if(Jb)return a(b);Jb=!0;try{return Gb(a,b)}finally{if(Jb=!1,null!==Bb||null!==Cb)Ib(),Fb()}}var Lb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Mb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Lb[a.type]:"textarea"===b?!0:!1}
function Nb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Ob(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Pb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Qb(a){var b=Pb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Rb(a){a._valueTracker||(a._valueTracker=Qb(a))}function Sb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Pb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Tb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Tb.hasOwnProperty("ReactCurrentDispatcher")||(Tb.ReactCurrentDispatcher={current:null});
var Ub=/^(.*)[\\\/]/,z="function"===typeof Symbol&&Symbol.for,Vb=z?Symbol.for("react.element"):60103,Wb=z?Symbol.for("react.portal"):60106,Xb=z?Symbol.for("react.fragment"):60107,Yb=z?Symbol.for("react.strict_mode"):60108,Zb=z?Symbol.for("react.profiler"):60114,$b=z?Symbol.for("react.provider"):60109,ac=z?Symbol.for("react.context"):60110,bc=z?Symbol.for("react.concurrent_mode"):60111,cc=z?Symbol.for("react.forward_ref"):60112,dc=z?Symbol.for("react.suspense"):60113,ec=z?Symbol.for("react.memo"):
60115,fc=z?Symbol.for("react.lazy"):60116,gc="function"===typeof Symbol&&Symbol.iterator;function hc(a){if(null===a||"object"!==typeof a)return null;a=gc&&a[gc]||a["@@iterator"];return"function"===typeof a?a:null}
function ic(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case bc:return"ConcurrentMode";case Xb:return"Fragment";case Wb:return"Portal";case Zb:return"Profiler";case Yb:return"StrictMode";case dc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ac:return"Context.Consumer";case $b:return"Context.Provider";case cc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case ec:return ic(a.type);case fc:if(a=1===a._status?a._result:null)return ic(a)}return null}function jc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=ic(a.type);c=null;d&&(c=ic(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ub,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var kc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,lc=Object.prototype.hasOwnProperty,mc={},nc={};
function oc(a){if(lc.call(nc,a))return!0;if(lc.call(mc,a))return!1;if(kc.test(a))return nc[a]=!0;mc[a]=!0;return!1}function pc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function qc(a,b,c,d){if(null===b||"undefined"===typeof b||pc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new C(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new C(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new C(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new C(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new C(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){D[a]=new C(a,3,!0,a,null)});
["capture","download"].forEach(function(a){D[a]=new C(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){D[a]=new C(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){D[a]=new C(a,5,!1,a.toLowerCase(),null)});var rc=/[\-:]([a-z])/g;function sc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(rc,
sc);D[b]=new C(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new C(a,1,!1,a.toLowerCase(),null)});
function tc(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(qc(b,c,e,d)&&(c=null),d||null===e?oc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function uc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function vc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=uc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function xc(a,b){b=b.checked;null!=b&&tc(a,"checked",b,!1)}
function yc(a,b){xc(a,b);var c=uc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&zc(a,b.type,uc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Ac(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Bc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Cc(a,b,c){a=y.getPooled(Bc.change,a,b,c);a.type="change";Eb(c);Qa(a);return a}var Dc=null,Ec=null;function Fc(a){Da(a)}
function Gc(a){var b=Ja(a);if(Sb(b))return a}function Hc(a,b){if("change"===a)return b}var Ic=!1;Ra&&(Ic=Ob("input")&&(!document.documentMode||9<document.documentMode));function Jc(){Dc&&(Dc.detachEvent("onpropertychange",Kc),Ec=Dc=null)}function Kc(a){"value"===a.propertyName&&Gc(Ec)&&(a=Cc(Ec,a,Nb(a)),Kb(Fc,a))}function Lc(a,b,c){"focus"===a?(Jc(),Dc=b,Ec=c,Dc.attachEvent("onpropertychange",Kc)):"blur"===a&&Jc()}function Mc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Gc(Ec)}
function Nc(a,b){if("click"===a)return Gc(b)}function Oc(a,b){if("input"===a||"change"===a)return Gc(b)}
var Pc={eventTypes:Bc,_isInputEventSupported:Ic,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Hc:Mb(e)?Ic?f=Oc:(f=Mc,g=Lc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Nc);if(f&&(f=f(a,b)))return Cc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&zc(e,"number",e.value)}},Qc=y.extend({view:null,detail:null}),Rc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Sc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Rc[a])?!!b[a]:!1}function Tc(){return Sc}
var Uc=0,Vc=0,Wc=!1,Xc=!1,Yc=Qc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Tc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Uc;Uc=a.screenX;return Wc?"mousemove"===a.type?a.screenX-b:0:(Wc=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Vc;Vc=a.screenY;return Xc?"mousemove"===a.type?a.screenY-b:0:(Xc=!0,0)}}),Zc=Yc.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),$c={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},ad={eventTypes:$c,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,l=void 0,k=void 0;if("mouseout"===a||"mouseover"===a)g=Yc,h=$c.mouseLeave,l=$c.mouseEnter,k="mouse";
else if("pointerout"===a||"pointerover"===a)g=Zc,h=$c.pointerLeave,l=$c.pointerEnter,k="pointer";var m=null==f?e:Ja(f);e=null==b?e:Ja(b);a=g.getPooled(h,f,c,d);a.type=k+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(l,b,c,d);c.type=k+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;k=0;for(g=b;g;g=La(g))k++;g=0;for(l=e;l;l=La(l))g++;for(;0<k-g;)b=La(b),k--;for(;0<g-k;)e=La(e),g--;for(;k--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){k=
f.alternate;if(null!==k&&k===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){k=d.alternate;if(null!==k&&k===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function bd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var cd=Object.prototype.hasOwnProperty;
function dd(a,b){if(bd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!cd.call(b,c[d])||!bd(a[c[d]],b[c[d]]))return!1;return!0}function ed(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function fd(a){2!==ed(a)?x("188"):void 0}
function gd(a){var b=a.alternate;if(!b)return b=ed(a),3===b?x("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return fd(e),a;if(g===d)return fd(e),b;g=g.sibling}x("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:x("189")}}c.alternate!==d?x("190"):void 0}3!==c.tag?x("188"):void 0;return c.stateNode.current===c?a:b}function hd(a){a=gd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var id=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),jd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),kd=Qc.extend({relatedTarget:null});function ld(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var md={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},od=Qc.extend({key:function(a){if(a.key){var b=md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ld(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?nd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Tc,charCode:function(a){return"keypress"===
a.type?ld(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ld(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),pd=Yc.extend({dataTransfer:null}),qd=Qc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Tc}),rd=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),sd=Yc.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["abort","abort"],[Xa,"animationEnd"],[Ya,"animationIteration"],[Za,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[$a,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],ud={},vd={};function wd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};ud[a]=b;vd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){wd(a,!0)});td.forEach(function(a){wd(a,!1)});
var xd={eventTypes:ud,isInteractiveTopLevelEventType:function(a){a=vd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===ld(c))return null;case "keydown":case "keyup":a=od;break;case "blur":case "focus":a=kd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=Yc;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Xa:case Ya:case Za:a=id;break;case $a:a=rd;break;case "scroll":a=Qc;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=Zc;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},yd=xd.isInteractiveTopLevelEventType,
zd=[];function Ad(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Nb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<oa.length;h++){var l=oa[h];l&&(l=l.extractEvents(d,b,f,e))&&(g=xa(g,l))}Da(g)}}var Bd=!0;
function E(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!1)}function Ed(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!0)}function Cd(a,b){Hb(Dd,a,b)}
function Dd(a,b){if(Bd){var c=Nb(b);c=Ha(c);null===c||"number"!==typeof c.tag||2===ed(c)||(c=null);if(zd.length){var d=zd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Kb(Ad,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>zd.length&&zd.push(a)}}}var Fd={},Gd=0,Hd="_reactListenersID"+(""+Math.random()).slice(2);
function Id(a){Object.prototype.hasOwnProperty.call(a,Hd)||(a[Hd]=Gd++,Fd[a[Hd]]={});return Fd[a[Hd]]}function Jd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Kd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Ld(a,b){var c=Kd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Kd(c)}}function Md(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Md(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Nd(){for(var a=window,b=Jd();b instanceof a.HTMLIFrameElement;){try{a=b.contentDocument.defaultView}catch(c){break}b=Jd(a.document)}return b}function Od(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
function Pd(){var a=Nd();if(Od(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{b=(b=a.ownerDocument)&&b.defaultView||window;var c=b.getSelection&&b.getSelection();if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(A){b=null;break a}var f=0,g=-1,h=-1,l=0,k=0,m=a,p=null;b:for(;;){for(var t;;){m!==b||0!==d&&3!==m.nodeType||(g=f+d);m!==e||0!==c&&3!==m.nodeType||(h=f+c);3===m.nodeType&&(f+=m.nodeValue.length);
if(null===(t=m.firstChild))break;p=m;m=t}for(;;){if(m===a)break b;p===b&&++l===d&&(g=f);p===e&&++k===c&&(h=f);if(null!==(t=m.nextSibling))break;m=p;p=m.parentNode}m=t}b=-1===g||-1===h?null:{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;return{focusedElem:a,selectionRange:b}}
function Qd(a){var b=Nd(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Md(c.ownerDocument.documentElement,c)){if(null!==d&&Od(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ld(c,f);var g=Ld(c,
d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
var Rd=Ra&&"documentMode"in document&&11>=document.documentMode,Sd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Td=null,Ud=null,Vd=null,Wd=!1;
function Xd(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(Wd||null==Td||Td!==Jd(c))return null;c=Td;"selectionStart"in c&&Od(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Vd&&dd(Vd,c)?null:(Vd=c,a=y.getPooled(Sd.select,Ud,a,b),a.type="select",a.target=Td,Qa(a),a)}
var Yd={eventTypes:Sd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Id(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Mb(e)||"true"===e.contentEditable)Td=e,Ud=b,Vd=null;break;case "blur":Vd=Ud=Td=null;break;case "mousedown":Wd=!0;break;case "contextmenu":case "mouseup":case "dragend":return Wd=!1,Xd(c,d);case "selectionchange":if(Rd)break;
case "keydown":case "keyup":return Xd(c,d)}return null}};Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ta=Ka;ua=Ia;va=Ja;Ba.injectEventPluginsByName({SimpleEventPlugin:xd,EnterLeaveEventPlugin:ad,ChangeEventPlugin:Pc,SelectEventPlugin:Yd,BeforeInputEventPlugin:zb});function Zd(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function $d(a,b){a=n({children:void 0},b);if(b=Zd(b.children))a.children=b;return a}function ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+uc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function be(a,b){null!=b.dangerouslySetInnerHTML?x("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?x("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:x("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:uc(c)}}
function de(a,b){var c=uc(b.value),d=uc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function he(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ie=void 0,je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==fe.svg||"innerHTML"in a)a.innerHTML=b;else{ie=ie||document.createElement("div");ie.innerHTML="<svg>"+b+"</svg>";for(b=ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},me=["Webkit","ms","Moz","O"];Object.keys(le).forEach(function(a){me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);le[b]=le[a]})});function ne(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||le.hasOwnProperty(a)&&le[a]?(""+b).trim():b+"px"}
function oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ne(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var pe=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function qe(a,b){b&&(pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?x("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?x("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:x("61")),null!=b.style&&"object"!==typeof b.style?x("62",""):void 0)}
function re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Id(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ed("scroll",a);break;case "focus":case "blur":Ed("focus",a);Ed("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Ob(e)&&Ed(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===ab.indexOf(e)&&E(e,a)}c[e]=!0}}}function te(){}var ue=null,ve=null;
function we(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function xe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
var ye="function"===typeof setTimeout?setTimeout:void 0,ze="function"===typeof clearTimeout?clearTimeout:void 0,Ae=r.unstable_scheduleCallback,Be=r.unstable_cancelCallback;
function Ce(a,b,c,d,e){a[Ga]=e;"input"===c&&"radio"===e.type&&null!=e.name&&xc(a,e);re(c,d);d=re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?oe(a,h):"dangerouslySetInnerHTML"===g?je(a,h):"children"===g?ke(a,h):tc(a,g,h,d)}switch(c){case "input":yc(a,e);break;case "textarea":de(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?ae(a,!!e.multiple,e.defaultValue,
!0):ae(a,!!e.multiple,e.multiple?[]:"",!1))}}function De(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ee(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Fe=[],Ge=-1;function F(a){0>Ge||(a.current=Fe[Ge],Fe[Ge]=null,Ge--)}function G(a,b){Ge++;Fe[Ge]=a.current;a.current=b}var He={},H={current:He},I={current:!1},Ie=He;
function Je(a,b){var c=a.type.contextTypes;if(!c)return He;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function J(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ke(a){F(I,a);F(H,a)}function Le(a){F(I,a);F(H,a)}
function Me(a,b,c){H.current!==He?x("168"):void 0;G(H,b,a);G(I,c,a)}function Ne(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:x("108",ic(b)||"Unknown",e);return n({},c,d)}function Oe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||He;Ie=H.current;G(H,b,a);G(I,I.current,a);return!0}
function Pe(a,b,c){var d=a.stateNode;d?void 0:x("169");c?(b=Ne(a,b,Ie),d.__reactInternalMemoizedMergedChildContext=b,F(I,a),F(H,a),G(H,b,a)):F(I,a);G(I,c,a)}var Qe=null,Re=null;function Se(a){return function(b){try{return a(b)}catch(c){}}}
function Te(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Qe=Se(function(a){return b.onCommitFiberRoot(c,a)});Re=Se(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Ue(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.contextDependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function K(a,b,c,d){return new Ue(a,b,c,d)}
function Ve(a){a=a.prototype;return!(!a||!a.isReactComponent)}function We(a){if("function"===typeof a)return Ve(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===cc)return 11;if(a===ec)return 14}return 2}
function Xe(a,b){var c=a.alternate;null===c?(c=K(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.contextDependencies=a.contextDependencies;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function Ye(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ve(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Xb:return Ze(c.children,e,f,b);case bc:return $e(c,e|3,f,b);case Yb:return $e(c,e|2,f,b);case Zb:return a=K(12,c,b,e|4),a.elementType=Zb,a.type=Zb,a.expirationTime=f,a;case dc:return a=K(13,c,b,e),a.elementType=dc,a.type=dc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case $b:g=10;break a;case ac:g=9;break a;case cc:g=11;break a;case ec:g=
14;break a;case fc:g=16;d=null;break a}x("130",null==a?a:typeof a,"")}b=K(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Ze(a,b,c,d){a=K(7,a,d,b);a.expirationTime=c;return a}function $e(a,b,c,d){a=K(8,a,d,b);b=0===(b&1)?Yb:bc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function af(a,b,c){a=K(6,a,null,b);a.expirationTime=c;return a}
function bf(a,b,c){b=K(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function cf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);df(b,a)}
function ef(a,b){a.didError=!1;if(0===b)a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0;else{b<a.latestPingedTime&&(a.latestPingedTime=0);var c=a.latestPendingTime;0!==c&&(c>b?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>b&&(a.earliestPendingTime=a.latestPendingTime));c=a.earliestSuspendedTime;0===c?cf(a,b):b<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,cf(a,b)):
b>c&&cf(a,b)}df(0,a)}function ff(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);df(b,a)}
function gf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function df(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}function L(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function hf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var jf=(new aa.Component).refs;
function kf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var tf={isMounted:function(a){return(a=a._reactInternalFiber)?2===ed(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.tag=rf;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=lf();c=mf(c,a);var d=nf(c);d.tag=
sf;void 0!==b&&null!==b&&(d.callback=b);of();pf(a,d);qf(a,c)}};function uf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!dd(c,d)||!dd(e,f):!0}
function vf(a,b,c){var d=!1,e=He;var f=b.contextType;"object"===typeof f&&null!==f?f=M(f):(e=J(b)?Ie:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Je(a,e):He);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=tf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function wf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&tf.enqueueReplaceState(b,b.state,null)}
function xf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=jf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=M(f):(f=J(b)?Ie:H.current,e.context=Je(a,f));f=a.updateQueue;null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(kf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&tf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var zf=Array.isArray;
function Af(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?x("309"):void 0,d=c.stateNode);d?void 0:x("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===jf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?x("284"):void 0;c._owner?void 0:x("290",a)}return a}
function Bf(a,b){"textarea"!==a.type&&x("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Cf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Xe(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=af(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function l(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Af(a,b,c),d.return=a,d;d=Ye(c.type,c.key,c.props,null,a.mode,d);d.ref=Af(a,b,c);d.return=a;return d}function k(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=bf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Ze(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=af(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Vb:return c=Ye(b.type,b.key,b.props,null,a.mode,c),c.ref=Af(a,null,b),c.return=a,c;case Wb:return b=bf(b,a.mode,c),b.return=a,b}if(zf(b)||
hc(b))return b=Ze(b,a.mode,c,null),b.return=a,b;Bf(a,b)}return null}function t(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Vb:return c.key===e?c.type===Xb?m(a,b,c.props.children,d,e):l(a,b,c,d):null;case Wb:return c.key===e?k(a,b,c,d):null}if(zf(c)||hc(c))return null!==e?null:m(a,b,c,d,null);Bf(a,c)}return null}function A(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Vb:return a=a.get(null===d.key?c:d.key)||null,d.type===Xb?m(b,a,d.props.children,e,d.key):l(b,a,d,e);case Wb:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(zf(d)||hc(d))return a=a.get(c)||null,m(b,a,d,e,null);Bf(b,d)}return null}function v(e,g,h,k){for(var l=null,m=null,q=g,u=g=0,B=null;null!==q&&u<h.length;u++){q.index>u?(B=q,q=null):B=q.sibling;var w=t(e,q,h[u],k);if(null===w){null===q&&(q=B);break}a&&
q&&null===w.alternate&&b(e,q);g=f(w,g,u);null===m?l=w:m.sibling=w;m=w;q=B}if(u===h.length)return c(e,q),l;if(null===q){for(;u<h.length;u++)if(q=p(e,h[u],k))g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;return l}for(q=d(e,q);u<h.length;u++)if(B=A(q,e,u,h[u],k))a&&null!==B.alternate&&q.delete(null===B.key?u:B.key),g=f(B,g,u),null===m?l=B:m.sibling=B,m=B;a&&q.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=hc(h);"function"!==typeof l?x("150"):void 0;h=l.call(h);null==h?x("151"):void 0;
for(var m=l=null,q=g,u=g=0,B=null,w=h.next();null!==q&&!w.done;u++,w=h.next()){q.index>u?(B=q,q=null):B=q.sibling;var v=t(e,q,w.value,k);if(null===v){q||(q=B);break}a&&q&&null===v.alternate&&b(e,q);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;q=B}if(w.done)return c(e,q),l;if(null===q){for(;!w.done;u++,w=h.next())w=p(e,w.value,k),null!==w&&(g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);return l}for(q=d(e,q);!w.done;u++,w=h.next())w=A(q,e,u,w.value,k),null!==w&&(a&&null!==w.alternate&&q.delete(null===w.key?u:
w.key),g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Xb&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Vb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Xb:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Xb?f.props.children:f.props,h);d.ref=Af(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===Xb?(d=Ze(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ye(f.type,f.key,f.props,null,a.mode,h),h.ref=Af(a,d,f),h.return=a,a=h)}return g(a);case Wb:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=bf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=af(f,a.mode,h),d.return=a,a=d),g(a);if(zf(f))return v(a,d,f,h);if(hc(f))return R(a,d,f,h);l&&Bf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,x("152",h.displayName||h.name||"Component")}return c(a,d)}}var Df=Cf(!0),Ef=Cf(!1),Ff={},N={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?x("174"):void 0;return a}
function Jf(a,b){G(Hf,b,a);G(Gf,a,a);G(N,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:he(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=he(b,c)}F(N,a);G(N,b,a)}function Kf(a){F(N,a);F(Gf,a);F(Hf,a)}function Lf(a){If(Hf.current);var b=If(N.current);var c=he(b,a.type);b!==c&&(G(Gf,a,a),G(N,c,a))}function Mf(a){Gf.current===a&&(F(N,a),F(Gf,a))}
var Nf=0,Of=2,Pf=4,Qf=8,Rf=16,Sf=32,Tf=64,Uf=128,Vf=Tb.ReactCurrentDispatcher,Wf=0,Xf=null,O=null,P=null,Yf=null,Q=null,Zf=null,$f=0,ag=null,bg=0,cg=!1,dg=null,eg=0;function fg(){x("307")}function gg(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!bd(a[c],b[c]))return!1;return!0}
function hg(a,b,c,d,e,f){Wf=f;Xf=b;P=null!==a?a.memoizedState:null;Vf.current=null===P?ig:jg;b=c(d,e);if(cg){do cg=!1,eg+=1,P=null!==a?a.memoizedState:null,Zf=Yf,ag=Q=O=null,Vf.current=jg,b=c(d,e);while(cg);dg=null;eg=0}Vf.current=kg;a=Xf;a.memoizedState=Yf;a.expirationTime=$f;a.updateQueue=ag;a.effectTag|=bg;a=null!==O&&null!==O.next;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;a?x("300"):void 0;return b}function lg(){Vf.current=kg;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;cg=!1;dg=null;eg=0}
function mg(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===Q?Yf=Q=a:Q=Q.next=a;return Q}function ng(){if(null!==Zf)Q=Zf,Zf=Q.next,O=P,P=null!==O?O.next:null;else{null===P?x("310"):void 0;O=P;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};Q=null===Q?Yf=a:Q.next=a;P=O.next}return Q}function og(a,b){return"function"===typeof b?b(a):b}
function pg(a){var b=ng(),c=b.queue;null===c?x("311"):void 0;if(0<eg){var d=c.dispatch;if(null!==dg){var e=dg.get(c);if(void 0!==e){dg.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.eagerReducer=a;c.eagerState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==d){var h=e=null,
l=d,k=!1;do{var m=l.expirationTime;m<Wf?(k||(k=!0,h=g,e=f),m>$f&&($f=m)):f=l.eagerReducer===a?l.eagerState:a(f,l.action);g=l;l=l.next}while(null!==l&&l!==d);k||(h=g,e=f);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.eagerReducer=a;c.eagerState=f}return[b.memoizedState,c.dispatch]}
function rg(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===ag?(ag={lastEffect:null},ag.lastEffect=a.next=a):(b=ag.lastEffect,null===b?ag.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,ag.lastEffect=a));return a}function sg(a,b,c,d){var e=mg();bg|=a;e.memoizedState=rg(b,c,void 0,void 0===d?null:d)}
function tg(a,b,c,d){var e=ng();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&gg(d,g.deps)){rg(Nf,c,f,d);return}}bg|=a;e.memoizedState=rg(b,c,f,d)}function ug(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function vg(){}
function wg(a,b,c){25>eg?void 0:x("301");var d=a.alternate;if(a===Xf||null!==d&&d===Xf)if(cg=!0,a={expirationTime:Wf,action:c,eagerReducer:null,eagerState:null,next:null},null===dg&&(dg=new Map),c=dg.get(b),void 0===c)dg.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{of();var e=lf();e=mf(e,a);var f={expirationTime:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===
d||0===d.expirationTime)&&(d=b.eagerReducer,null!==d))try{var l=b.eagerState,k=d(l,c);f.eagerReducer=d;f.eagerState=k;if(bd(k,l))return}catch(m){}finally{}qf(a,e)}}
var kg={readContext:M,useCallback:fg,useContext:fg,useEffect:fg,useImperativeHandle:fg,useLayoutEffect:fg,useMemo:fg,useReducer:fg,useRef:fg,useState:fg,useDebugValue:fg},ig={readContext:M,useCallback:function(a,b){mg().memoizedState=[a,void 0===b?null:b];return a},useContext:M,useEffect:function(a,b){return sg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return sg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,b){return sg(4,Pf|Sf,a,b)},
useMemo:function(a,b){var c=mg();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=mg();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,eagerReducer:a,eagerState:b};a=a.dispatch=wg.bind(null,Xf,a);return[d.memoizedState,a]},useRef:function(a){var b=mg();a={current:a};return b.memoizedState=a},useState:function(a){var b=mg();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,eagerReducer:og,
eagerState:a};a=a.dispatch=wg.bind(null,Xf,a);return[b.memoizedState,a]},useDebugValue:vg},jg={readContext:M,useCallback:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:M,useEffect:function(a,b){return tg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return tg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,b){return tg(4,Pf|Sf,a,b)},
useMemo:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:pg,useRef:function(){return ng().memoizedState},useState:function(a){return pg(og,a)},useDebugValue:vg},xg=null,yg=null,zg=!1;
function Ag(a,b){var c=K(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Bg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Cg(a){if(zg){var b=yg;if(b){var c=b;if(!Bg(a,b)){b=De(c);if(!b||!Bg(a,b)){a.effectTag|=2;zg=!1;xg=a;return}Ag(xg,c)}xg=a;yg=Ee(b)}else a.effectTag|=2,zg=!1,xg=a}}function Dg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;xg=a}function Eg(a){if(a!==xg)return!1;if(!zg)return Dg(a),zg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!xe(b,a.memoizedProps))for(b=yg;b;)Ag(a,b),b=De(b);Dg(a);yg=xg?De(a.stateNode):null;return!0}function Fg(){yg=xg=null;zg=!1}
var Gg=Tb.ReactCurrentOwner,qg=!1;function S(a,b,c,d){b.child=null===a?Ef(b,null,c,d):Df(b,a.child,c,d)}function Hg(a,b,c,d,e){c=c.render;var f=b.ref;Ig(b,e);d=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
function Kg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ve(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Lg(a,b,g,d,e,f);a=Ye(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:dd,c(e,d)&&a.ref===b.ref))return Jg(a,b,f);b.effectTag|=1;a=Xe(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function Lg(a,b,c,d,e,f){return null!==a&&dd(a.memoizedProps,d)&&a.ref===b.ref&&(qg=!1,e<f)?Jg(a,b,f):Mg(a,b,c,d,f)}function Ng(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Mg(a,b,c,d,e){var f=J(c)?Ie:H.current;f=Je(b,f);Ig(b,e);c=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
function Og(a,b,c,d,e){if(J(c)){var f=!0;Oe(b)}else f=!1;Ig(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),vf(b,c,d,e),xf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var l=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k);Pg=!1;var t=b.memoizedState;l=g.state=t;var A=b.updateQueue;null!==A&&(yf(b,A,d,g,e),l=b.memoizedState);h!==d||t!==l||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),l=b.memoizedState),(h=Pg||uf(b,c,h,d,t,l,k))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=l),g.props=d,g.state=l,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:L(b.type,h),l=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k)),m=c.getDerivedStateFromProps,(p="function"===
typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k),Pg=!1,l=b.memoizedState,t=g.state=l,A=b.updateQueue,null!==A&&(yf(b,A,d,g,e),t=b.memoizedState),h!==d||l!==t||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),t=b.memoizedState),(m=Pg||uf(b,c,h,d,l,t,k))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
typeof g.componentWillUpdate&&g.componentWillUpdate(d,t,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,t,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
t),g.props=d,g.state=t,g.context=k,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),d=!1);return Qg(a,b,c,d,f,e)}
function Qg(a,b,c,d,e,f){Ng(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Pe(b,c,!1),Jg(a,b,f);d=b.stateNode;Gg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Df(b,a.child,null,f),b.child=Df(b,null,h,f)):S(a,b,h,f);b.memoizedState=d.state;e&&Pe(b,c,!0);return b.child}function Rg(a){var b=a.stateNode;b.pendingContext?Me(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Me(a,b.context,!1);Jf(a,b.containerInfo)}
function Sg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=Ze(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=Ze(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=Ef(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=Xe(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=Xe(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=Df(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=Ze(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=Ze(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=Df(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
function Jg(a,b,c){null!==a&&(b.contextDependencies=a.contextDependencies);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?x("153"):void 0;if(null!==b.child){a=b.child;c=Xe(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Xe(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Tg(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||I.current)qg=!0;else{if(d<c){qg=!1;switch(b.tag){case 3:Rg(b);Fg();break;case 5:Lf(b);break;case 1:J(b.type)&&Oe(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Ug(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Sg(a,b,c);b=Jg(a,b,c);return null!==b?b.sibling:null}}return Jg(a,b,c)}}else qg=!1;b.expirationTime=0;switch(b.tag){case 2:d=
b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Je(b,H.current);Ig(b,c);e=hg(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;lg();if(J(d)){var f=!0;Oe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&kf(b,d,g,a);e.updater=tf;b.stateNode=e;e._reactInternalFiber=b;xf(b,d,a,c);b=Qg(null,b,d,!0,f,
c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=hf(e);b.type=a;e=b.tag=We(a);f=L(a,f);g=void 0;switch(e){case 0:g=Mg(null,b,a,f,c);break;case 1:g=Og(null,b,a,f,c);break;case 11:g=Hg(null,b,a,f,c);break;case 14:g=Kg(null,b,a,L(a.type,f),d,c);break;default:x("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Mg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,
e=b.elementType===d?e:L(d,e),Og(a,b,d,e,c);case 3:Rg(b);d=b.updateQueue;null===d?x("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;yf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Fg(),b=Jg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)yg=Ee(b.stateNode.containerInfo),xg=b,e=zg=!0;e?(b.effectTag|=2,b.child=Ef(b,null,d,c)):(S(a,b,d,c),Fg());b=b.child}return b;case 5:return Lf(b),null===a&&Cg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,
g=e.children,xe(d,e)?g=null:null!==f&&xe(d,f)&&(b.effectTag|=16),Ng(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(S(a,b,g,c),b=b.child),b;case 6:return null===a&&Cg(b),null;case 13:return Sg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Df(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Hg(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,
c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Ug(b,f);if(null!==g){var h=g.value;f=bd(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!I.current){b=Jg(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var l=h.contextDependencies;if(null!==l){g=h.child;for(var k=l.first;null!==k;){if(k.context===d&&0!==
(k.observedBits&f)){1===h.tag&&(k=nf(c),k.tag=sf,pf(h,k));h.expirationTime<c&&(h.expirationTime=c);k=h.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);k=c;for(var m=h.return;null!==m;){var p=m.alternate;if(m.childExpirationTime<k)m.childExpirationTime=k,null!==p&&p.childExpirationTime<k&&(p.childExpirationTime=k);else if(null!==p&&p.childExpirationTime<k)p.childExpirationTime=k;else break;m=m.return}l.expirationTime<c&&(l.expirationTime=c);break}k=k.next}}else g=10===h.tag?h.type===b.type?
null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Ig(b,c),e=M(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=L(e,b.pendingProps),f=L(e.type,f),Kg(a,b,e,f,d,c);case 15:return Lg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===
d?e:L(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,J(d)?(a=!0,Oe(b)):a=!1,Ig(b,c),vf(b,d,e,c),xf(b,d,e,c),Qg(null,b,d,!0,a,c)}x("156")}var Vg={current:null},Wg=null,Xg=null,Yg=null;function Ug(a,b){var c=a.type._context;G(Vg,c._currentValue,a);c._currentValue=b}function Zg(a){var b=Vg.current;F(Vg,a);a.type._context._currentValue=b}function Ig(a,b){Wg=a;Yg=Xg=null;var c=a.contextDependencies;null!==c&&c.expirationTime>=b&&(qg=!0);a.contextDependencies=null}
function M(a,b){if(Yg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Yg=a,b=1073741823;b={context:a,observedBits:b,next:null};null===Xg?(null===Wg?x("308"):void 0,Xg=b,Wg.contextDependencies={first:b,expirationTime:0}):Xg=Xg.next=b}return a._currentValue}var $g=0,rf=1,sf=2,ah=3,Pg=!1;function bh(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function ch(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:$g,payload:null,callback:null,next:null,nextEffect:null}}function dh(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bh(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bh(a.memoizedState),e=c.updateQueue=bh(c.memoizedState)):d=a.updateQueue=ch(e):null===e&&(e=c.updateQueue=ch(d));null===e||d===e?dh(d,b):null===d.lastUpdate||null===e.lastUpdate?(dh(d,b),dh(e,b)):(dh(d,b),e.lastUpdate=b)}
function eh(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bh(a.memoizedState):fh(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function fh(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=ch(b));return b}
function gh(a,b,c,d,e,f){switch(c.tag){case rf:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case ah:a.effectTag=a.effectTag&-2049|64;case $g:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case sf:Pg=!0}return d}
function yf(a,b,c,d,e){Pg=!1;b=fh(a,b);for(var f=b.baseState,g=null,h=0,l=b.firstUpdate,k=f;null!==l;){var m=l.expirationTime;m<e?(null===g&&(g=l,f=k),h<m&&(h=m)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=32,l.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=l:(b.lastEffect.nextEffect=l,b.lastEffect=l)));l=l.next}m=null;for(l=b.firstCapturedUpdate;null!==l;){var p=l.expirationTime;p<e?(null===m&&(m=l,null===g&&(f=k)),h<p&&(h=p)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=
32,l.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=l:(b.lastCapturedEffect.nextEffect=l,b.lastCapturedEffect=l)));l=l.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=k}
function hh(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);ih(b.firstEffect,c);b.firstEffect=b.lastEffect=null;ih(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function ih(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?x("191",c):void 0;c.call(d)}a=a.nextEffect}}
function jh(a,b){return{value:a,source:b,stack:jc(b)}}function kh(a){a.effectTag|=4}var lh=void 0,mh=void 0,nh=void 0,oh=void 0;lh=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};mh=function(){};
nh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(N.current);a=null;switch(c){case "input":f=vc(g,f);d=vc(g,d);a=[];break;case "option":f=$d(g,f);d=$d(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=be(g,f);d=be(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=te)}qe(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var l=f[c];for(g in l)l.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ra.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var k=d[c];l=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&k!==l&&(null!=k||null!=l))if("style"===c)if(l){for(g in l)!l.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in k)k.hasOwnProperty(g)&&l[g]!==k[g]&&(h||
(h={}),h[g]=k[g])}else h||(a||(a=[]),a.push(c,h)),h=k;else"dangerouslySetInnerHTML"===c?(k=k?k.__html:void 0,l=l?l.__html:void 0,null!=k&&l!==k&&(a=a||[]).push(c,""+k)):"children"===c?l===k||"string"!==typeof k&&"number"!==typeof k||(a=a||[]).push(c,""+k):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ra.hasOwnProperty(c)?(null!=k&&se(e,c),a||l===k||(a=[])):(a=a||[]).push(c,k))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&kh(b)}};oh=function(a,b,c,d){c!==d&&kh(b)};
var ph="function"===typeof WeakSet?WeakSet:Set;function qh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=jc(c));null!==c&&ic(c.type);b=b.value;null!==a&&1===a.tag&&ic(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function rh(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){sh(a,c)}else b.current=null}
function th(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Nf){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Nf&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function uh(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=ne("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function vh(a){"function"===typeof Re&&Re(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(void 0!==d){var e=a;try{d()}catch(f){sh(e,f)}}c=c.next}while(c!==b)}break;case 1:rh(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){sh(a,f)}break;case 5:rh(a);break;case 4:wh(a)}}
function xh(a){return 5===a.tag||3===a.tag||4===a.tag}
function yh(a){a:{for(var b=a.return;null!==b;){if(xh(b)){var c=b;break a}b=b.return}x("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:x("161")}c.effectTag&16&&(ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||xh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&
2)continue b;if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=te)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function wh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?x("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(vh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag){if(null!==b.child){d=b.stateNode.containerInfo;e=!0;b.child.return=b;b=b.child;continue}}else if(vh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function zh(a,b){switch(b.tag){case 0:case 11:case 14:case 15:th(Pf,Qf,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Ce(c,f,e,a,d,b)}break;case 6:null===b.stateNode?x("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=lf()));null!==a&&uh(a,d);c=
b.updateQueue;if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new ph);c.forEach(function(a){var c=Ah.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:x("163")}}var Bh="function"===typeof WeakMap?WeakMap:Map;function Ch(a,b,c){c=nf(c);c.tag=ah;c.payload={element:null};var d=b.value;c.callback=function(){Dh(d);qh(a,b)};return c}
function Eh(a,b,c){c=nf(c);c.tag=ah;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Fh?Fh=new Set([this]):Fh.add(this));var c=b.value,e=b.stack;qh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Gh(a){switch(a.tag){case 1:J(a.type)&&Ke(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Le(a),b=a.effectTag,0!==(b&64)?x("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 4:return Kf(a),null;case 10:return Zg(a),null;default:return null}}
var Hh=Tb.ReactCurrentDispatcher,Ih=Tb.ReactCurrentOwner,Jh=1073741822,Kh=!1,T=null,Lh=null,U=0,Mh=-1,Nh=!1,V=null,Oh=!1,Ph=null,Qh=null,Rh=null,Fh=null;function Sh(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ke(b);break;case 3:Kf(b);Le(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Zg(b)}a=a.return}Lh=null;U=0;Mh=-1;Nh=!1;T=null}
function Th(){for(;null!==V;){var a=V.effectTag;a&16&&ke(V.stateNode,"");if(a&128){var b=V.alternate;null!==b&&(b=b.ref,null!==b&&("function"===typeof b?b(null):b.current=null))}switch(a&14){case 2:yh(V);V.effectTag&=-3;break;case 6:yh(V);V.effectTag&=-3;zh(V.alternate,V);break;case 4:zh(V.alternate,V);break;case 8:a=V,wh(a),a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null,a=a.alternate,null!==a&&(a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null)}V=V.nextEffect}}
function Uh(){for(;null!==V;){if(V.effectTag&256)a:{var a=V.alternate,b=V;switch(b.tag){case 0:case 11:case 15:th(Of,Nf,b);break a;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:L(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break a;case 3:case 5:case 6:case 4:case 17:break a;default:x("163")}}V=V.nextEffect}}
function Vh(a,b){for(;null!==V;){var c=V.effectTag;if(c&36){var d=V.alternate,e=V,f=b;switch(e.tag){case 0:case 11:case 15:th(Rf,Sf,e);break;case 1:var g=e.stateNode;if(e.effectTag&4)if(null===d)g.componentDidMount();else{var h=e.elementType===e.type?d.memoizedProps:L(e.type,d.memoizedProps);g.componentDidUpdate(h,d.memoizedState,g.__reactInternalSnapshotBeforeUpdate)}d=e.updateQueue;null!==d&&hh(e,d,g,f);break;case 3:d=e.updateQueue;if(null!==d){g=null;if(null!==e.child)switch(e.child.tag){case 5:g=
e.child.stateNode;break;case 1:g=e.child.stateNode}hh(e,d,g,f)}break;case 5:f=e.stateNode;null===d&&e.effectTag&4&&we(e.type,e.memoizedProps)&&f.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:x("163")}}c&128&&(e=V.ref,null!==e&&(f=V.stateNode,"function"===typeof e?e(f):e.current=f));c&512&&(Ph=a);V=V.nextEffect}}
function Wh(a,b){Rh=Qh=Ph=null;var c=W;W=!0;do{if(b.effectTag&512){var d=!1,e=void 0;try{var f=b;th(Uf,Nf,f);th(Nf,Tf,f)}catch(g){d=!0,e=g}d&&sh(b,e)}b=b.nextEffect}while(null!==b);W=c;c=a.expirationTime;0!==c&&Xh(a,c);X||W||Yh(1073741823,!1)}function of(){null!==Qh&&Be(Qh);null!==Rh&&Rh()}
function Zh(a,b){Oh=Kh=!0;a.current===b?x("177"):void 0;var c=a.pendingCommitExpirationTime;0===c?x("261"):void 0;a.pendingCommitExpirationTime=0;var d=b.expirationTime,e=b.childExpirationTime;ef(a,e>d?e:d);Ih.current=null;d=void 0;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ue=Bd;ve=Pd();Bd=!1;for(V=d;null!==V;){e=!1;var f=void 0;try{Uh()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){e=!1;
f=void 0;try{Th()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}Qd(ve);ve=null;Bd=!!ue;ue=null;a.current=b;for(V=d;null!==V;){e=!1;f=void 0;try{Vh(a,c)}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}if(null!==d&&null!==Ph){var g=Wh.bind(null,a,d);Qh=r.unstable_runWithPriority(r.unstable_NormalPriority,function(){return Ae(g)});Rh=g}Kh=Oh=!1;"function"===typeof Qe&&Qe(b.stateNode);c=b.expirationTime;b=b.childExpirationTime;b=
b>c?b:c;0===b&&(Fh=null);$h(a,b)}
function ai(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){T=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:J(b.type)&&Ke(b);break;case 3:Kf(b);Le(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)Eg(b),b.effectTag&=-3;mh(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)nh(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
128);else if(g){var l=If(N.current);if(Eg(b)){g=b;e=g.stateNode;var k=g.type,m=g.memoizedProps,p=h;e[Fa]=g;e[Ga]=m;f=void 0;h=k;switch(h){case "iframe":case "object":E("load",e);break;case "video":case "audio":for(k=0;k<ab.length;k++)E(ab[k],e);break;case "source":E("error",e);break;case "img":case "image":case "link":E("error",e);E("load",e);break;case "form":E("reset",e);E("submit",e);break;case "details":E("toggle",e);break;case "input":wc(e,m);E("invalid",e);se(p,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};E("invalid",e);se(p,"onChange");break;case "textarea":ce(e,m),E("invalid",e),se(p,"onChange")}qe(h,m);k=null;for(f in m)m.hasOwnProperty(f)&&(l=m[f],"children"===f?"string"===typeof l?e.textContent!==l&&(k=["children",l]):"number"===typeof l&&e.textContent!==""+l&&(k=["children",""+l]):ra.hasOwnProperty(f)&&null!=l&&se(p,f));switch(h){case "input":Rb(e);Ac(e,m,!0);break;case "textarea":Rb(e);ee(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=te)}f=k;g.updateQueue=f;g=null!==f?!0:!1;g&&kh(b)}else{m=b;e=f;p=g;k=9===h.nodeType?h:h.ownerDocument;l===fe.html&&(l=ge(e));l===fe.html?"script"===e?(e=k.createElement("div"),e.innerHTML="<script>\x3c/script>",k=e.removeChild(e.firstChild)):"string"===typeof p.is?k=k.createElement(e,{is:p.is}):(k=k.createElement(e),"select"===e&&p.multiple&&(k.multiple=!0)):k=k.createElementNS(l,e);e=k;e[Fa]=m;e[Ga]=g;lh(e,b,!1,!1);p=e;k=f;m=g;var t=h,A=re(k,m);switch(k){case "iframe":case "object":E("load",
p);h=m;break;case "video":case "audio":for(h=0;h<ab.length;h++)E(ab[h],p);h=m;break;case "source":E("error",p);h=m;break;case "img":case "image":case "link":E("error",p);E("load",p);h=m;break;case "form":E("reset",p);E("submit",p);h=m;break;case "details":E("toggle",p);h=m;break;case "input":wc(p,m);h=vc(p,m);E("invalid",p);se(t,"onChange");break;case "option":h=$d(p,m);break;case "select":p._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});E("invalid",p);se(t,"onChange");break;case "textarea":ce(p,
m);h=be(p,m);E("invalid",p);se(t,"onChange");break;default:h=m}qe(k,h);l=void 0;var v=k,R=p,u=h;for(l in u)if(u.hasOwnProperty(l)){var q=u[l];"style"===l?oe(R,q):"dangerouslySetInnerHTML"===l?(q=q?q.__html:void 0,null!=q&&je(R,q)):"children"===l?"string"===typeof q?("textarea"!==v||""!==q)&&ke(R,q):"number"===typeof q&&ke(R,""+q):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ra.hasOwnProperty(l)?null!=q&&se(t,l):null!=q&&tc(R,l,q,A))}switch(k){case "input":Rb(p);
Ac(p,m,!1);break;case "textarea":Rb(p);ee(p,m);break;case "option":null!=m.value&&p.setAttribute("value",""+uc(m.value));break;case "select":h=p;h.multiple=!!m.multiple;p=m.value;null!=p?ae(h,!!m.multiple,p,!1):null!=m.defaultValue&&ae(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(p.onclick=te)}(g=we(f,g))&&kh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?x("166"):void 0;break;case 6:e&&null!=b.stateNode?oh(e,b,e.memoizedProps,g):("string"!==
typeof g&&(null===b.stateNode?x("166"):void 0),e=If(Hf.current),If(N.current),Eg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Fa]=g,(g=f.nodeValue!==e)&&kh(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Fa]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;T=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);mh(b);break;case 10:Zg(b);break;case 9:break;case 14:break;case 17:J(b.type)&&Ke(b);break;case 18:break;default:x("156")}T=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==T)return T;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&
(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gh(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
function bi(a){var b=Tg(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=ai(a));Ih.current=null;return b}
function ci(a,b){Kh?x("243"):void 0;of();Kh=!0;var c=Hh.current;Hh.current=kg;var d=a.nextExpirationTimeToWorkOn;if(d!==U||a!==Lh||null===T)Sh(),Lh=a,U=d,T=Xe(Lh.current,null,U),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==T&&!di();)T=bi(T);else for(;null!==T;)T=bi(T)}catch(u){if(Yg=Xg=Wg=null,lg(),null===T)e=!0,Dh(u);else{null===T?x("271"):void 0;var f=T,g=f.return;if(null===g)e=!0,Dh(u);else{a:{var h=a,l=g,k=f,m=u;g=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==
m&&"object"===typeof m&&"function"===typeof m.then){var p=m;m=l;var t=-1,A=-1;do{if(13===m.tag){var v=m.alternate;if(null!==v&&(v=v.memoizedState,null!==v)){A=10*(1073741822-v.timedOutAt);break}v=m.pendingProps.maxDuration;if("number"===typeof v)if(0>=v)t=0;else if(-1===t||v<t)t=v}m=m.return}while(null!==m);m=l;do{if(v=13===m.tag)v=void 0===m.memoizedProps.fallback?!1:null===m.memoizedState;if(v){l=m.updateQueue;null===l?(l=new Set,l.add(p),m.updateQueue=l):l.add(p);if(0===(m.mode&1)){m.effectTag|=
64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(g=nf(1073741823),g.tag=sf,pf(k,g)));k.expirationTime=1073741823;break a}k=h;l=g;var R=k.pingCache;null===R?(R=k.pingCache=new Bh,v=new Set,R.set(p,v)):(v=R.get(p),void 0===v&&(v=new Set,R.set(p,v)));v.has(l)||(v.add(l),k=ei.bind(null,k,p,l),p.then(k,k));-1===t?h=1073741823:(-1===A&&(A=10*(1073741822-gf(h,g))-5E3),h=A+t);0<=h&&Mh<h&&(Mh=h);m.effectTag|=2048;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error((ic(k.type)||"A React component")+
" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+jc(k))}Nh=!0;m=jh(m,k);h=l;do{switch(h.tag){case 3:h.effectTag|=2048;h.expirationTime=g;g=Ch(h,m,g);eh(h,g);break a;case 1:if(t=m,A=h.type,k=h.stateNode,0===(h.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==k&&"function"===typeof k.componentDidCatch&&(null===Fh||!Fh.has(k)))){h.effectTag|=2048;
h.expirationTime=g;g=Eh(h,t,g);eh(h,g);break a}}h=h.return}while(null!==h)}T=ai(f);continue}}}break}while(1);Kh=!1;Hh.current=c;Yg=Xg=Wg=null;lg();if(e)Lh=null,a.finishedWork=null;else if(null!==T)a.finishedWork=null;else{c=a.current.alternate;null===c?x("281"):void 0;Lh=null;if(Nh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<d||0!==f&&f<d||0!==g&&g<d){ff(a,d);fi(a,c,d,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;
b=a.expirationTime=1073741823;fi(a,c,d,b,-1);return}}b&&-1!==Mh?(ff(a,d),b=10*(1073741822-gf(a,d)),b<Mh&&(Mh=b),b=10*(1073741822-lf()),b=Mh-b,fi(a,c,d,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=d,a.finishedWork=c)}}
function sh(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Fh||!Fh.has(d))){a=jh(b,a);a=Eh(c,a,1073741823);pf(c,a);qf(c,1073741823);return}break;case 3:a=jh(b,a);a=Ch(c,a,1073741823);pf(c,a);qf(c,1073741823);return}c=c.return}3===a.tag&&(c=jh(b,a),c=Ch(a,c,1073741823),pf(a,c),qf(a,1073741823))}
function mf(a,b){var c=r.unstable_getCurrentPriorityLevel(),d=void 0;if(0===(b.mode&1))d=1073741823;else if(Kh&&!Oh)d=U;else{switch(c){case r.unstable_ImmediatePriority:d=1073741823;break;case r.unstable_UserBlockingPriority:d=1073741822-10*(((1073741822-a+15)/10|0)+1);break;case r.unstable_NormalPriority:d=1073741822-25*(((1073741822-a+500)/25|0)+1);break;case r.unstable_LowPriority:case r.unstable_IdlePriority:d=1;break;default:x("313")}null!==Lh&&d===U&&--d}c===r.unstable_UserBlockingPriority&&
(0===gi||d<gi)&&(gi=d);return d}function ei(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==Lh&&U===c)Lh=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;df(c,a);c=a.expirationTime;0!==c&&Xh(a,c)}}function Ah(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=lf();b=mf(b,a);a=hi(a,b);null!==a&&(cf(a,b),b=a.expirationTime,0!==b&&Xh(a,b))}
function hi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
function qf(a,b){a=hi(a,b);null!==a&&(!Kh&&0!==U&&b>U&&Sh(),cf(a,b),Kh&&!Oh&&Lh===a||Xh(a,a.expirationTime),ii>ji&&(ii=0,x("185")))}function ki(a,b,c,d,e){return r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){return a(b,c,d,e)})}var li=null,Y=null,mi=0,ni=void 0,W=!1,oi=null,Z=0,gi=0,pi=!1,qi=null,X=!1,ri=!1,si=null,ti=r.unstable_now(),ui=1073741822-(ti/10|0),vi=ui,ji=50,ii=0,wi=null;function xi(){ui=1073741822-((r.unstable_now()-ti)/10|0)}
function yi(a,b){if(0!==mi){if(b<mi)return;null!==ni&&r.unstable_cancelCallback(ni)}mi=b;a=r.unstable_now()-ti;ni=r.unstable_scheduleCallback(zi,{timeout:10*(1073741822-b)-a})}function fi(a,b,c,d,e){a.expirationTime=d;0!==e||di()?0<e&&(a.timeoutHandle=ye(Ai.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Ai(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;xi();vi=ui;Bi(a,c)}function $h(a,b){a.expirationTime=b;a.finishedWork=null}
function lf(){if(W)return vi;Ci();if(0===Z||1===Z)xi(),vi=ui;return vi}function Xh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===Y?(li=Y=a,a.nextScheduledRoot=a):(Y=Y.nextScheduledRoot=a,Y.nextScheduledRoot=li)):b>a.expirationTime&&(a.expirationTime=b);W||(X?ri&&(oi=a,Z=1073741823,Di(a,1073741823,!1)):1073741823===b?Yh(1073741823,!1):yi(a,b))}
function Ci(){var a=0,b=null;if(null!==Y)for(var c=Y,d=li;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===Y?x("244"):void 0;if(d===d.nextScheduledRoot){li=Y=d.nextScheduledRoot=null;break}else if(d===li)li=e=d.nextScheduledRoot,Y.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===Y){Y=c;Y.nextScheduledRoot=li;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===Y)break;if(1073741823===
a)break;c=d;d=d.nextScheduledRoot}}oi=b;Z=a}var Ei=!1;function di(){return Ei?!0:r.unstable_shouldYield()?Ei=!0:!1}function zi(){try{if(!di()&&null!==li){xi();var a=li;do{var b=a.expirationTime;0!==b&&ui<=b&&(a.nextExpirationTimeToWorkOn=ui);a=a.nextScheduledRoot}while(a!==li)}Yh(0,!0)}finally{Ei=!1}}
function Yh(a,b){Ci();if(b)for(xi(),vi=ui;null!==oi&&0!==Z&&a<=Z&&!(Ei&&ui>Z);)Di(oi,Z,ui>Z),Ci(),xi(),vi=ui;else for(;null!==oi&&0!==Z&&a<=Z;)Di(oi,Z,!1),Ci();b&&(mi=0,ni=null);0!==Z&&yi(oi,Z);ii=0;wi=null;if(null!==si)for(a=si,si=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){pi||(pi=!0,qi=d)}}if(pi)throw a=qi,qi=null,pi=!1,a;}function Bi(a,b){W?x("253"):void 0;oi=a;Z=b;Di(a,b,!1);Yh(1073741823,!1)}
function Di(a,b,c){W?x("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&(di()?a.finishedWork=d:Fi(a,d,b)))}else d=a.finishedWork,null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&Fi(a,d,b));W=!1}
function Fi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===si?si=[d]:si.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===wi?ii++:(wi=a,ii=0);r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){Zh(a,b)})}function Dh(a){null===oi?x("246"):void 0;oi.expirationTime=0;pi||(pi=!0,qi=a)}function Gi(a,b){var c=X;X=!0;try{return a(b)}finally{(X=c)||W||Yh(1073741823,!1)}}
function Hi(a,b){if(X&&!ri){ri=!0;try{return a(b)}finally{ri=!1}}return a(b)}function Ii(a,b,c){X||W||0===gi||(Yh(gi,!1),gi=0);var d=X;X=!0;try{return r.unstable_runWithPriority(r.unstable_UserBlockingPriority,function(){return a(b,c)})}finally{(X=d)||W||Yh(1073741823,!1)}}
function Ji(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===ed(c)&&1===c.tag?void 0:x("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(J(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);x("171");g=void 0}if(1===c.tag){var h=c.type;if(J(h)){c=Ne(c,h,g);break a}}c=g}else c=He;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
of();pf(f,e);qf(f,d);return d}function Ki(a,b,c,d){var e=b.current,f=lf();e=mf(f,e);return Ji(a,b,c,e,d)}function Li(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Mi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Wb,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Ab=function(a,b,c){switch(b){case "input":yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);e?void 0:x("90");Sb(d);yc(d,e)}}}break;case "textarea":de(a,c);break;case "select":b=c.value,null!=b&&ae(a,!!c.multiple,b,!1)}};
function Ni(a){var b=1073741822-25*(((1073741822-lf()+500)/25|0)+1);b>=Jh&&(b=Jh-1);this._expirationTime=Jh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Ni.prototype.render=function(a){this._defer?void 0:x("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Oi;Ji(a,b,null,c,d._onCommit);return d};
Ni.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Ni.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:x("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?x("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Bi(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};Ni.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Oi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Oi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Oi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?x("191",c):void 0;c()}}};
function Pi(a,b,c){b=K(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Pi.prototype.render=function(a,b){var c=this._internalRoot,d=new Oi;b=void 0===b?null:b;null!==b&&d.then(b);Ki(a,c,null,d._onCommit);return d};Pi.prototype.unmount=function(a){var b=this._internalRoot,c=new Oi;a=void 0===a?null:a;null!==a&&c.then(a);Ki(null,b,null,c._onCommit);return c};Pi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Oi;c=void 0===c?null:c;null!==c&&e.then(c);Ki(b,d,a,e._onCommit);return e};
Pi.prototype.createBatch=function(){var a=new Ni(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Qi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Gb=Gi;Hb=Ii;Ib=function(){W||0===gi||(Yh(gi,!1),gi=0)};
function Ri(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Pi(a,!1,b)}
function Si(a,b,c,d,e){var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Li(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Ri(c,d);if("function"===typeof e){var h=e;e=function(){var a=Li(f._internalRoot);h.call(a)}}Hi(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Li(f._internalRoot)}
function Ti(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Qi(b)?void 0:x("200");return Mi(a,b,null,c)}
var Vi={createPortal:Ti,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?x("188"):x("268",Object.keys(a)));a=hd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!0,c)},render:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){Qi(c)?void 0:x("200");null==a||void 0===a._reactInternalFiber?
x("38"):void 0;return Si(a,b,c,!1,d)},unmountComponentAtNode:function(a){Qi(a)?void 0:x("40");return a._reactRootContainer?(Hi(function(){Si(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Ti.apply(void 0,arguments)},unstable_batchedUpdates:Gi,unstable_interactiveUpdates:Ii,flushSync:function(a,b){W?x("187"):void 0;var c=X;X=!0;try{return ki(a,b)}finally{X=c,Yh(1073741823,!1)}},unstable_createRoot:Ui,unstable_flushControlled:function(a){var b=
X;X=!0;try{ki(a)}finally{(X=b)||W||Yh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ba.injectEventPluginsByName,pa,Qa,function(a){ya(a,Pa)},Eb,Fb,Dd,Da]}};function Ui(a,b){Qi(a)?void 0:x("299","unstable_createRoot");return new Pi(a,!0,null!=b&&!0===b.hydrate)}
(function(a){var b=a.findFiberByHostInstance;return Te(n({},a,{overrideProps:null,currentDispatcherRef:Tb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.8.3",rendererPackageName:"react-dom"});var Wi={default:Vi},Xi=Wi&&Vi||Wi;module.exports=Xi.default||Xi;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(147);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.6
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_UI_Header_Header__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_css__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Pages_FriendList_FriendList__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Pages_SendRequest_SendRequest__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_UI_Navigation_SideDrawer_SideDrawer__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_Pages_UpdateProfile_UpdateProfile__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Components_Pages_FriendRequests_FriendRequests__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Components_Pages_ViewProfile_ViewProfile__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Components_Pages_Chats_Chats__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__HelperFiles_AeClient__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Components_UI_Spinner_Spinner__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_this.state={isOpen:"normal",showBackdrop:false,frClicked:false,loading:false,profileData:null,imageUrl:""},_this.changeHeaderImage=function(result){__WEBPACK_IMPORTED_MODULE_11_axios___default.a.get('https://ipfs.io/ipfs/'+result).then(function(result){_this.setState({imageUrl:result.data,loading:false});}).catch(function(error){console.error(error);});},_this.openNavigationDrawer=function(){if(_this.state.isOpen==="normal"){_this.setState({isOpen:"fromOpen",showBackdrop:true});return;}if(_this.state.isOpen==="fromOpen"){_this.setState({isOpen:"fromClose",showBackdrop:false});return;}if(_this.state.isOpen==="fromClose"){_this.setState({isOpen:"fromOpen",showBackdrop:true});return;}},_this.goToFriendRequests=function(back){_this.openNavigationDrawer();_this.setState({isOpen:"normal"});},_this.goToViewProfile=function(){_this.setState({isOpen:"normal",showBackdrop:false});},_this.toggleLoader=function(){_this.setState({loading:!_this.state.loading});},_this.url="https://cdn-media-1.freecodecamp.org/imgr/MJAkxbh.png",_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'componentDidMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this2=this;var client,decodedUsersProfile;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({loading:true});_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_14__HelperFiles_AeClient__["a" /* default */])();case 3:client=_context.sent;this.props.setClient(client);_context.next=7;return this.props.client.methods.get_profile();case 7:decodedUsersProfile=_context.sent.decodedResult;this.props.setUsersProfile(decodedUsersProfile);if(!(decodedUsersProfile.name!=="")){_context.next=13;break;}__WEBPACK_IMPORTED_MODULE_11_axios___default.a.get('https://ipfs.io/ipfs/'+decodedUsersProfile.image).then(function(result){_this2.props.setGeneralImage(result.data);}).catch(function(error){console.error(error);});this.setState({loading:false,profileData:decodedUsersProfile});return _context.abrupt('return');case 13:this.setState({loading:false,profileData:decodedUsersProfile});case 14:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref2.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Pages_FriendList_FriendList__["a" /* default */],null));return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.state.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Components_UI_Spinner_Spinner__["a" /* default */],null):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Components_UI_Header_Header__["a" /* default */],{imageUrl:this.state.imageUrl,navToggle:this.openNavigationDrawer,profToggle:this.toggleRegProfile}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_Navigation_SideDrawer_SideDrawer__["a" /* default */],{frClicked:this.goToFriendRequests,mpClicked:this.goToViewProfile,showBackdrop:this.state.showBackdrop,navToggle:this.openNavigationDrawer,isOpen:this.state.isOpen}),this.props.client==="null"?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["c" /* Route */],{exact:true,path:'/',component:__WEBPACK_IMPORTED_MODULE_4__Components_Pages_FriendList_FriendList__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["c" /* Route */],{exact:true,path:'/current_chat',component:__WEBPACK_IMPORTED_MODULE_10__Components_Pages_Chats_Chats__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["c" /* Route */],{path:'/friend_requests',component:__WEBPACK_IMPORTED_MODULE_8__Components_Pages_FriendRequests_FriendRequests__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["c" /* Route */],{path:'/user_profile',component:__WEBPACK_IMPORTED_MODULE_9__Components_Pages_ViewProfile_ViewProfile__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["c" /* Route */],{path:'/update_profile',component:__WEBPACK_IMPORTED_MODULE_7__Components_Pages_UpdateProfile_UpdateProfile__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["c" /* Route */],{path:'/send_requests',component:__WEBPACK_IMPORTED_MODULE_5__Components_Pages_SendRequest_SendRequest__["a" /* default */]})));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{client:state.client};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setClient:function setClient(client){return dispatch({type:"SET_CLIENT",client:client});},setGeneralImage:function setGeneralImage(imageData){return dispatch({type:"SET_GENERAL_IMAGE",generalImage:imageData});},setUsersProfile:function setUsersProfile(profile){return dispatch({type:"SET_USER_PROFILE",usersProfile:profile});}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(App));

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(151);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 151 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header_css__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Header_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dp_png__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dp_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__dp_png__);
var Header=function Header(props){var usersDp=__WEBPACK_IMPORTED_MODULE_4__dp_png___default.a;if(props.generalImage!==""){usersDp=props.generalImage;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/update_profile'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:props.generalImage,alt:'Profile',className:'header-img',onClick:props.profToggle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{style:{textDecoration:'none'},to:'/'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'appname'},'AEchat')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-drawer',onClick:props.navToggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-i'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-i'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-i'})));};var mapStateToProps=function mapStateToProps(state){return{generalImage:state.generalImage};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(Header));

/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(155);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gud__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(32);






var MAX_SIGNED_31_BIT_INT = 1073741823;

function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + __WEBPACK_IMPORTED_MODULE_3_gud___default()() + '__';

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Provider, _Component);

    function Provider() {
      var _this;

      _this = _Component.apply(this, arguments) || this;
      _this.emitter = createEventEmitter(_this.props.value);
      return _this;
    }

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0;
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

          if (false) {
            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    _proto.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, _Provider$childContex);

  var Consumer =
  /*#__PURE__*/
  function (_Component2) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Consumer, _Component2);

    function Consumer() {
      var _this2;

      _this2 = _Component2.apply(this, arguments) || this;
      _this2.state = {
        value: _this2.getValue()
      };

      _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;

        if ((observedBits & changedBits) !== 0) {
          _this2.setState({
            value: _this2.getValue()
          });
        }
      };

      return _this2;
    }

    var _proto2 = Consumer.prototype;

    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }

      var observedBits = this.props.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    _proto2.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    _proto2.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, _Consumer$contextType);
  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

var index = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext || createReactContext;

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 159 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(162)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function z(a){return y(a)===m}
exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Context__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(42);





function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    var subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](store);
    subscription.onStateChange = subscription.notifyNestedSubs;
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return store.getState();
  }, [store]);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var subscription = contextValue.subscription;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || __WEBPACK_IMPORTED_MODULE_2__Context__["a" /* ReactReduxContext */];
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

Provider.propTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    subscribe: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    getState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  }),
  context: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Provider);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(172);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(76);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(168);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5), __webpack_require__(75)(module)))

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(76);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(77);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, {}, stateProps, {}, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(173);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(78);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createDispatchHook */
/* unused harmony export useDispatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Context__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useStore__ = __webpack_require__(79);


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {Function} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_0__components_Context__["a" /* ReactReduxContext */];
  }

  var useStore = context === __WEBPACK_IMPORTED_MODULE_0__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_1__useStore__["b" /* useStore */] : Object(__WEBPACK_IMPORTED_MODULE_1__useStore__["a" /* createStoreHook */])(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch = createDispatchHook();

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createSelectorHook */
/* unused harmony export useSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useReduxContext__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_useIsomorphicLayoutEffect__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Context__ = __webpack_require__(14);







var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestSelector = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestSelectedState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var selectedState;

  try {
    if (selector !== latestSelector.current || latestSubscriptionCallbackError.current) {
      selectedState = selector(store.getState());
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    var errorMessage = "An error occurred while selecting the store state: " + err.message + ".";

    if (latestSubscriptionCallbackError.current) {
      errorMessage += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\nOriginal stack trace:";
    }

    throw new Error(errorMessage);
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    latestSelector.current = selector;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    function checkForUpdates() {
      try {
        var newSelectedState = latestSelector.current(store.getState());

        if (equalityFn(newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = newSelectedState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender({});
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {Function} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_5__components_Context__["a" /* ReactReduxContext */];
  }

  var useReduxContext = context === __WEBPACK_IMPORTED_MODULE_5__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_2__useReduxContext__["a" /* useReduxContext */] : function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(selector, "You must pass a selector to useSelectors");

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    return useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector = createSelectorHook();

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_react_dom__, "unstable_batchedUpdates")) __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_dom__["unstable_batchedUpdates"]; });
/* eslint-disable import/no-unresolved */


/***/ }),
/* 177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UI_Friend_Friend__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FriendList_css__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FriendList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FriendList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UI_ActionButton_ActionButton__ = __webpack_require__(198);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FriendList=function(_React$Component){_inherits(FriendList,_React$Component);function FriendList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FriendList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FriendList.__proto__||Object.getPrototypeOf(FriendList)).call.apply(_ref,[this].concat(args))),_this),_this.state={usersFriend:[]},_this.handleusersFriendClicked=function(userFriend){_this.props.setCurrentChat(userFriend);_this.props.history.push("/current_chat");},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FriendList,[{key:'componentDidMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this2=this;var friendList,myArr;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0://console.log("friend start mount")
if(this.props.prevImage!=null){this.props.setGeneralImage(this.props.prevImage);}_context.next=3;return this.props.contractInstance.methods.get_friends();case 3:friendList=_context.sent.decodedResult;myArr=[];friendList.map(function(el,index){//console.log("el",el);
__WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('https://ipfs.io/ipfs/'+el.image).then(function(result){var imageString=result.data;var data=Object.assign({},el,{imageString:imageString});myArr.push(data);//console.log("the index is "+index +" and the length is "+myArr.length );
//console.log("My Array",myArr);
// if(index==(myArr.length-1)){
//console.log("inside update")
//console.log(myArr);
_this2.setState({usersFriend:myArr});//console.log("inside update",this.state.usersFriend);
// }
}).catch(function(error){console.error(error);});});//console.log("friend start mount",friendList);
// //console.log("new friend list",newFriendList);
// this.setState({usersFriend:newFriendList});
//console.log("friend start mount");
case 6:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref2.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'FriendList'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,'Friends'),this.state.usersFriend.map(function(el){//console.log(el);
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_Friend_Friend__["a" /* default */],{name:el.name,clicked:function clicked(event){_this3.handleusersFriendClicked(el);},imageString:el.imageString});}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */],{to:'/send_requests'},'   ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__UI_ActionButton_ActionButton__["a" /* default */],null)));}}]);return FriendList;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){return{contractInstance:state.client,prevImage:state.prevImage};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setGeneralImage:function setGeneralImage(imageData){return dispatch({type:"SET_GENERAL_IMAGE",generalImage:imageData});},setCurrentChat:function setCurrentChat(newCurrentChat){return dispatch({type:"SET_CURRENT_CHAT",currentChat:newCurrentChat});}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(FriendList));

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Friend_css__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Friend_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Friend_css__);
var Friend=function Friend(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Friend',onClick:props.clicked},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:props.imageString,alt:props.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,props.name));};/* harmony default export */ __webpack_exports__["a"] = (Friend);

/***/ }),
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);
var bind = __webpack_require__(81);
var Axios = __webpack_require__(183);
var mergeConfig = __webpack_require__(87);
var defaults = __webpack_require__(84);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(88);
axios.CancelToken = __webpack_require__(196);
axios.isCancel = __webpack_require__(83);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(197);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);
var buildURL = __webpack_require__(82);
var InterceptorManager = __webpack_require__(184);
var dispatchRequest = __webpack_require__(185);
var mergeConfig = __webpack_require__(87);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);
var transformData = __webpack_require__(186);
var isCancel = __webpack_require__(83);
var defaults = __webpack_require__(84);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(86);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(191);
var combineURLs = __webpack_require__(192);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(88);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionButton_css__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ActionButton_css__);
var ActionButton=function ActionButton(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ActionButton',onClick:props.handler},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'actionplus'},'+'));};/* harmony default export */ __webpack_exports__["a"] = (ActionButton);

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UI_Input_Input__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UI_Button_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SendRequest_css__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SendRequest_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SendRequest_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UI_Spinner_Spinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UI_DisplayModal_DisplayModal__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SendRequest=function(_Component){_inherits(SendRequest,_Component);function SendRequest(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,SendRequest);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SendRequest.__proto__||Object.getPrototypeOf(SendRequest)).call.apply(_ref,[this].concat(args))),_this),_this.state={loading:false,aeAddress:"",noProfile:false},_this.inputChangedHandler=function(event){_this.setState({aeAddress:event.target.value});//console.log(this.state.aeAddress);
},_this.handleSubmitButton=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var profile;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0://console.log(this.state.aeAddress)
_this.setState({loading:true});_context.next=3;return _this.props.client.methods.get_profile();case 3:profile=_context.sent.decodedResult;if(!(profile.name==="")){_context.next=7;break;}_this.setState({loading:false,noProfile:true});//console.log("You must update your profile");
return _context.abrupt('return');case 7:_context.next=9;return _this.props.client.methods.send_friend_request(_this.state.aeAddress);case 9:_this.setState({loading:false});_this.props.history.goBack();case 11:case'end':return _context.stop();}}},_callee,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SendRequest,[{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'SendRequest'},this.state.noProfile?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__UI_DisplayModal_DisplayModal__["a" /* default */],{header:'Update Profile',fi:'You must update your profile before you can send a friend request',fii:'Please click the button below to do so',clicked:function clicked(){_this3.setState({noProfile:false},function(){//console.log(this.state.noProfile);
_this3.props.history.push("/update_profile");});}}):null,this.state.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__UI_Spinner_Spinner__["a" /* default */],null):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_Input_Input__["a" /* default */],{placeHolder:'Friends AE Address',onChange:this.inputChangedHandler}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'SendRequestButton'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UI_Button_Button__["a" /* default */],{clicked:this.handleSubmitButton},'Send Request'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'div-space'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UI_Button_Button__["a" /* default */],{clicked:function clicked(){_this3.props.history.goBack();}},'Back'))));}}]);return SendRequest;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{client:state.client};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps)(SendRequest));

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SideDrawer_css__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SideDrawer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SideDrawer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavigationItems_NavigationItems__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Backdrop_Backdrop__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HigherOrder_hoc__ = __webpack_require__(211);
var sideDrawer=function sideDrawer(props){var classNames=["SideDrawer"];if(props.isOpen==="fromOpen"){//console.log(props.isOpen);
classNames.push("open");}else if(props.isOpen==="fromClose"){//console.log(props.isOpen)
classNames.push("close");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__HigherOrder_hoc__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames.join(" ")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__NavigationItems_NavigationItems__["a" /* default */],{frClicked:props.frClicked,mpClicked:props.mpClicked})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Backdrop_Backdrop__["a" /* default */],{show:props.showBackdrop,clicked:props.navToggle}));};/* harmony default export */ __webpack_exports__["a"] = (sideDrawer);

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavigationItems_css__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavigationItems_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__NavigationItems_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(30);
var NavigationItems=function NavigationItems(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NavigationItems'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{className:'a',to:'friend_requests'},'  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'Item',onClick:props.frClicked},'Friend requests')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{className:'a',to:'user_profile'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'Item',onClick:props.mpClicked},'My Profile')));};/* harmony default export */ __webpack_exports__["a"] = (NavigationItems);

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var hoc=function hoc(props){return props.children;};/* harmony default export */ __webpack_exports__["a"] = (hoc);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UpdateProfile_css__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UpdateProfile_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__UpdateProfile_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UI_Input_Input__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UI_Button_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UI_Spinner_Spinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UI_Backdrop_Backdrop__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HelperFiles_ipfs__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateProfile=function(_React$Component){_inherits(UpdateProfile,_React$Component);function UpdateProfile(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,UpdateProfile);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UpdateProfile.__proto__||Object.getPrototypeOf(UpdateProfile)).call.apply(_ref,[this].concat(args))),_this),_this.state={name:'',about:'',file:null,showLoader:false},_this.handleSubmit=function(){var name=_this.state.name;var about=_this.state.about;var file=_this.state.file;//console.log(file.type);
if(name.trim()!==""&&about.trim()!==""&&file!=null){_this.setState({showLoader:!_this.state.showLoader});var imageHash=_this.addFileToIpfs(file);}},_this.addFileToIpfs=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(file){var fileType,prefix,reader,myResult;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0://console.log(ipfs,"ipfs");
fileType=file.type;//console.log(fileType);
prefix='data:'+fileType+';base64,';reader=new window.FileReader();reader.readAsArrayBuffer(file);myResult="";reader.onloadend=function(){__WEBPACK_IMPORTED_MODULE_8__HelperFiles_ipfs__["b" /* ipfs */].add(prefix+Object(__WEBPACK_IMPORTED_MODULE_8__HelperFiles_ipfs__["a" /* base64ArrayBuffer */])(Buffer(reader.result)),function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(err,result){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!err){_context2.next=2;break;}return _context2.abrupt('return');case 2:myResult=result;//console.log(result,"Am hashz");
__WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('https://ipfs.io/ipfs/'+result).then(function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(result){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.call("register_profile",[_this.state.name,_this.state.about,myResult]);case 2:_this.props.setGeneralImage(result.data);_this.setState({showLoader:!_this.state.showLoader});_this.props.history.goBack();case 5:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x4){return _ref4.apply(this,arguments);};}()).catch(function(error){console.error(error);});case 4:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2,_x3){return _ref3.apply(this,arguments);};}());// //console.log(reader.result)
};case 6:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.nameChangedHandler=function(event){_this.setState({name:event.target.value});},_this.aboutChangedHandler=function(event){_this.setState({about:event.target.value});},_this.fileChangedHandler=function(event){_this.setState({file:event.target.files[0]});//console.log(event.target.files[0])
},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UpdateProfile,[{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"UpdateProfile"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__UI_Backdrop_Backdrop__["a" /* default */],{show:this.state.showLoader}),this.state.showLoader?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__UI_Spinner_Spinner__["a" /* default */],null):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{onChange:this.fileChangedHandler,placeHolder:'Choose Your Profile Picture',otherClass:"UPInput",type:'file',style:{display:"block",margin:"0 auto",background:"#f7296e",borderRadius:"10px",color:"white",border:"none",cursor:"pointer"}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UI_Input_Input__["a" /* default */],{value:this.state.name,onChange:this.nameChangedHandler,placeHolder:'Full Name',otherClass:"UPInputi"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UI_Input_Input__["a" /* default */],{value:this.state.about,onChange:this.aboutChangedHandler,placeHolder:'Profile About',otherClass:"UPInputii"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__UI_Button_Button__["a" /* default */],{otherClass:"UPInputiv",clicked:this.handleSubmit},'Submit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__UI_Button_Button__["a" /* default */],{otherClass:"UPInputiv",clicked:function clicked(){_this3.props.history.goBack();}},'Back'));}}]);return UpdateProfile;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){return{client:state.client};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setGeneralImage:function setGeneralImage(imageData){return dispatch({type:"SET_GENERAL_IMAGE",generalImage:imageData});}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(UpdateProfile));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4).Buffer))

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 214 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = base64ArrayBuffer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ipfs; });
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/* eslint-disable *//* eslint-disable */var initialize=null;(function webpackUniversalModuleDefinition(root,factory){if((typeof exports==='undefined'?'undefined':_typeof(exports))==='object'&&( false?'undefined':_typeof(module))==='object')module.exports=factory();else if(typeof define==='function'&&__webpack_require__(217))define("IPFS",[],factory);else if((typeof exports==='undefined'?'undefined':_typeof(exports))==='object')exports["IPFS"]=factory();else root["IPFS"]=factory();})(this,function(){return(/******/function(modules){// webpackBootstrap
/******/// The module cache
/******/var installedModules={};/******//******/// The require function
/******/function __webpack_require__(moduleId){/******//******/// Check if module is in cache
/******/if(installedModules[moduleId])/******/return installedModules[moduleId].exports;/******//******/// Create a new module (and put it into the cache)
/******/var module=installedModules[moduleId]={/******/i:moduleId,/******/l:false,/******/exports:{}/******/};/******//******/// Execute the module function
/******/modules[moduleId].call(module.exports,module,module.exports,__webpack_require__);/******//******/// Flag the module as loaded
/******/module.l=true;/******//******/// Return the exports of the module
/******/return module.exports;/******/}/******//******//******/// expose the modules object (__webpack_modules__)
/******/__webpack_require__.m=modules;/******//******/// expose the module cache
/******/__webpack_require__.c=installedModules;/******//******/// identity function for calling harmory imports with the correct context
/******/__webpack_require__.i=function(value){return value;};/******//******/// define getter function for harmory exports
/******/__webpack_require__.d=function(exports,name,getter){/******/Object.defineProperty(exports,name,{/******/configurable:false,/******/enumerable:true,/******/get:getter/******/});/******/};/******//******/// Object.prototype.hasOwnProperty.call
/******/__webpack_require__.o=function(object,property){return Object.prototype.hasOwnProperty.call(object,property);};/******//******/// __webpack_public_path__
/******/__webpack_require__.p="";/******//******/// Load entry module and return exports
/******/return __webpack_require__(__webpack_require__.s=1);/******/}(/************************************************************************//******/[/* 0 *//***/function(module,exports){"use strict";"use strict";var XMLHttpRequest=window.XMLHttpRequest;// eslint-disable-line
module.exports=XMLHttpRequest;/***/},/* 1 *//***/function(module,exports,__webpack_require__){"use strict";'use strict';var XMLHttpRequest=__webpack_require__(0);module.exports=IPFS;/**
        * The constructor object
        * @param {Object} `provider` the provider object
        * @return {Object} `ipfs` returns an IPFS instance
        * @throws if the `new` flag is not used
        */function IPFS(provider){if(!(this instanceof IPFS)){throw new Error('[ipfs-mini] IPFS instance must be instantiated with "new" flag (e.g. var ipfs = new IPFS("http://localhost:8545");).');}var self=this;self.setProvider(provider||{});}/**
        * Sets the provider of the IPFS instance
        * @param {Object} `provider` the provider object
        * @throws if the provider object is not an object
        */IPFS.prototype.setProvider=function setProvider(provider){if((typeof provider==='undefined'?'undefined':_typeof(provider))!=='object'){throw new Error('[ifpsjs] provider must be type Object, got \''+(typeof provider==='undefined'?'undefined':_typeof(provider))+'\'.');}var self=this;var data=self.provider=Object.assign({host:'127.0.0.1',pinning:true,port:'5001',protocol:'http',base:'/api/v0'},provider||{});self.requestBase=String(data.protocol+'://'+data.host+':'+data.port+data.base);};/**
        * Sends an async data packet to an IPFS node
        * @param {Object} `opts` the options object
        * @param {Function} `cb` the provider callback
        * @callback returns an error if any, or the data from IPFS
        */IPFS.prototype.sendAsync=function sendAsync(opts,cb){var self=this;var request=new XMLHttpRequest();// eslint-disable-line
var options=opts||{};var callback=cb||function emptyCallback(){};request.onreadystatechange=function(){if(request.readyState===4&&request.timeout!==1){if(request.status!==200){callback(new Error('[ipfs-mini] status '+request.status+': '+request.responseText),null);}else{try{callback(null,options.jsonParse?JSON.parse(request.responseText):request.responseText);}catch(jsonError){callback(new Error('[ipfs-mini] while parsing data: \''+String(request.responseText)+'\', error: '+String(jsonError)+' with provider: \''+self.requestBase+'\'',null));}}}};var pinningURI=self.provider.pinning&&opts.uri==='/add'?'?pin=true':'';if(options.payload){request.open('POST',''+self.requestBase+opts.uri+pinningURI);}else{request.open('GET',''+self.requestBase+opts.uri+pinningURI);}if(options.accept){request.setRequestHeader('accept',options.accept);}if(options.payload&&options.boundary){request.setRequestHeader('Content-Type','multipart/form-data; boundary='+options.boundary);request.send(options.payload);}else{request.send();}};/**
        * creates a boundary that isn't part of the payload
        */function createBoundary(data){while(true){var boundary='----IPFSMini'+Math.random()*100000+'.'+Math.random()*100000;if(data.indexOf(boundary)===-1){return boundary;}}}/**
        * Add an string or buffer to IPFS
        * @param {String|Buffer} `input` a single string or buffer
        * @param {Function} `callback` a callback, with (error, ipfsHash String)
        * @callback {String} `ipfsHash` returns an IPFS hash string
        */IPFS.prototype.add=function addData(input,callback){var data=(typeof input==='undefined'?'undefined':_typeof(input))==='object'&&input.isBuffer?input.toString('binary'):input;var boundary=createBoundary(data);var payload='--'+boundary+'\r\nContent-Disposition: form-data; name="path"\r\nContent-Type: application/octet-stream\r\n\r\n'+data+'\r\n--'+boundary+'--';var addCallback=function addCallback(err,result){return callback(err,!err?result.Hash:null);};this.sendAsync({jsonParse:true,accept:'application/json',uri:'/add',payload:payload,boundary:boundary},addCallback);};/**
        * Add an JSON object to IPFS
        * @param {Object} `jsonData` a single JSON object
        * @param {Function} `callback` a callback, with (error, ipfsHash String)
        * @callback {String} `ipfsHash` returns an IPFS hash string
        */IPFS.prototype.addJSON=function addJson(jsonData,callback){var self=this;self.add(JSON.stringify(jsonData),callback);};/**
        * Get an object stat `/object/stat` for an IPFS hash
        * @param {String} `ipfsHash` a single IPFS hash String
        * @param {Function} `callback` a callback, with (error, stats Object)
        * @callback {Object} `stats` returns the stats object for that IPFS hash
        */IPFS.prototype.stat=function cat(ipfsHash,callback){var self=this;self.sendAsync({jsonParse:true,uri:'/object/stat/'+ipfsHash},callback);};/**
        * Get the data from an IPFS hash
        * @param {String} `ipfsHash` a single IPFS hash String
        * @param {Function} `callback` a callback, with (error, stats Object)
        * @callback {String} `data` returns the output data
        */IPFS.prototype.cat=function cat(ipfsHash,callback){var self=this;self.sendAsync({uri:'/cat/'+ipfsHash},callback);};initialize=function initialize(){return new IPFS({host:'ipfs.infura.io',protocol:'https'});};/**
        * Get the data from an IPFS hash that is a JSON object
        * @param {String} `ipfsHash` a single IPFS hash String
        * @param {Function} `callback` a callback, with (error, json Object)
        * @callback {Object} `data` returns the output data JSON object
        */IPFS.prototype.catJSON=function cat(ipfsHash,callback){var self=this;self.cat(ipfsHash,function(jsonError,jsonResult){// eslint-disable-line
if(jsonError){return callback(jsonError,null);}try{callback(null,JSON.parse(jsonResult));}catch(jsonParseError){callback(jsonParseError,null);}});};/***/}/******/]));});;//# sourceMappingURL=ipfs-mini.js.map
function base64ArrayBuffer(arrayBuffer){var base64='';var encodings='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';var bytes=new Uint8Array(arrayBuffer);var byteLength=bytes.byteLength;var byteRemainder=byteLength%3;var mainLength=byteLength-byteRemainder;var a=void 0;var b=void 0;var c=void 0;var d=void 0;var chunk=void 0;// Main loop deals with bytes in chunks of 3
for(var i=0;i<mainLength;i+=3){// Combine the three bytes into a single integer
chunk=bytes[i]<<16|bytes[i+1]<<8|bytes[i+2];// Use bitmasks to extract 6-bit segments from the triplet
a=(chunk&16515072)>>18;// 16515072 = (2^6 - 1) << 18
b=(chunk&258048)>>12;// 258048   = (2^6 - 1) << 12
c=(chunk&4032)>>6;// 4032     = (2^6 - 1) << 6
d=chunk&63;// 63       = 2^6 - 1
// Convert the raw binary segments to the appropriate ASCII encoding
base64+=encodings[a]+encodings[b]+encodings[c]+encodings[d];}// Deal with the remaining bytes and padding
if(byteRemainder===1){chunk=bytes[mainLength];a=(chunk&252)>>2;// 252 = (2^6 - 1) << 2
// Set the 4 least significant bits to zero
b=(chunk&3)<<4;// 3   = 2^2 - 1
base64+=''+encodings[a]+encodings[b]+'==';}else if(byteRemainder===2){chunk=bytes[mainLength]<<8|bytes[mainLength+1];a=(chunk&64512)>>10;// 64512 = (2^6 - 1) << 10
b=(chunk&1008)>>4;// 1008  = (2^6 - 1) << 4
// Set the 2 least significant bits to zero
c=(chunk&15)<<2;// 15    = 2^4 - 1
base64+=''+encodings[a]+encodings[b]+encodings[c]+'=';}return base64;}var ipfs=initialize();function upload(){var reader=new FileReader();reader.onloadend=function(){var photo=document.getElementById("photo");var fileType=photo.files[0].type;var prefix='data:'+fileType+';base64,';var buf=buffer.Buffer(reader.result);var base64buf=prefix+base64ArrayBuffer(buf);// Convert data into buffer
ipfs.add(base64buf,function(err,result){// Upload buffer to IPFS
if(err){console.error(err);return;}var url='https://ipfs.io/ipfs/'+result;var hashBtn=document.getElementById("hash");hashBtn.innerHTML=url;});};var photo=document.getElementById("photo");reader.readAsArrayBuffer(photo.files[0]);// Read Provided File
}function download(){var hashBtn=document.getElementById("hash")||this;var url=hashBtn.innerHTML;if(!url)return;var req=new XMLHttpRequest();req.responseType="text/html";req.onload=function(e){var img=new Image();img.onload=function onload(){document.body.appendChild(img);};img.src=this.response;};req.open('GET',url,true);req.send();}// default {ipfs:ipfs,base64ArrayBuffer:base64ArrayBuffer};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(75)(module)))

/***/ }),
/* 217 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FriendRequest_FriendRequest__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FriendRequests_css__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FriendRequests_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FriendRequests_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UI_Spinner_Spinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UI_Button_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UI_DisplayModal_DisplayModal__ = __webpack_require__(90);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FriendRequests=function(_Component){_inherits(FriendRequests,_Component);function FriendRequests(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,FriendRequests);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FriendRequests.__proto__||Object.getPrototypeOf(FriendRequests)).call.apply(_ref,[this].concat(args))),_this),_this.state={loading:true,friendReqList:[],noProfile:false},_this.handleAcceptButton=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(pKey){var profile,friendRequest,myArr;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({loading:true});_context.next=3;return _this.props.client.methods.get_profile();case 3:profile=_context.sent.decodedResult;if(!(profile.name==="")){_context.next=7;break;}_this.setState({loading:false,noProfile:true});//console.log("You must update your profile");
return _context.abrupt('return');case 7:_context.next=9;return _this.props.client.methods.accept_friend_request(pKey);case 9:_context.next=11;return _this.props.client.methods.get_friend_request();case 11:friendRequest=_context.sent.decodedResult;myArr=[];friendRequest.map(function(el,index){__WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('https://ipfs.io/ipfs/'+el.image).then(function(result){var imageString=result.data;var data=Object.assign({},el,{imageString:imageString});myArr.push(data);if(index===friendRequest.length-1){_this.setState({loading:false,friendReqList:myArr});}return data;}).catch(function(error){_this.setState({loading:false});console.error(error);});});if(friendRequest.length===0){_this.setState({loading:false,friendReqList:myArr});}case 15:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.handleRejectButton=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(pKey){var friendRequest,myArr;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0://console.log("reject");
_this.setState({loading:true});_context2.next=3;return _this.props.client.methods.reject_friend_request(pKey);case 3:_context2.next=5;return _this.props.client.methods.get_friend_request();case 5:friendRequest=_context2.sent.decodedResult;myArr=[];friendRequest.map(function(el,index){__WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('https://ipfs.io/ipfs/'+el.image).then(function(result){var imageString=result.data;var data=Object.assign({},el,{imageString:imageString});myArr.push(data);if(index===friendRequest.length-1){_this.setState({loading:false,friendReqList:myArr});}return data;}).catch(function(error){_this.setState({loading:false});console.error(error);});});if(friendRequest.length===0){_this.setState({loading:false,friendReqList:myArr});}case 9:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FriendRequests,[{key:'componentDidMount',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _this3=this;var friendRequest,myArr;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return this.props.client.methods.get_friend_request();case 2:friendRequest=_context3.sent.decodedResult;//console.log(friendRequest);
myArr=[];friendRequest.map(function(el,index){__WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('https://ipfs.io/ipfs/'+el.image).then(function(result){var imageString=result.data;var data=Object.assign({},el,{imageString:imageString});myArr.push(data);if(index===friendRequest.length-1){_this3.setState({loading:false,friendReqList:myArr});}return data;}).catch(function(error){_this3.setState({loading:false});console.error(error);});});case 5:case'end':return _context3.stop();}}},_callee3,this);}));function componentDidMount(){return _ref4.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'FriendRequests'},this.state.noProfile?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__UI_DisplayModal_DisplayModal__["a" /* default */],{header:'Update Profile',fi:'You must update your profile before you can send a friend request',fii:'Please click the button below to do so',clicked:function clicked(){_this4.setState({noProfile:false},function(){//console.log(this.state.noProfile);
_this4.props.history.push("/update_profile");});}}):null,this.state.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__UI_Spinner_Spinner__["a" /* default */],null):null,this.state.friendReqList.map(function(el){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FriendRequest_FriendRequest__["a" /* default */],{reject:function reject(){return _this4.handleRejectButton(el.user);},imageString:el.imageString,accept:function accept(){return _this4.handleAcceptButton(el.user);},name:el.name,pKey:el.user});}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__UI_Button_Button__["a" /* default */],{clicked:function clicked(){_this4.props.history.goBack();}},'Back'));}}]);return FriendRequests;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{client:state.client};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps)(FriendRequests));

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FriendRequest_css__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FriendRequest_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FriendRequest_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UI_Button_Button__ = __webpack_require__(16);
var FriendRequest=function FriendRequest(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FriendRequest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:props.imageString,alt:props.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'FRKey'},props.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_Button_Button__["a" /* default */],{clicked:props.accept,otherClass:'FRConfirm'},'Confirm'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_Button_Button__["a" /* default */],{clicked:props.reject,otherClass:'FRReject'},'Reject'));};/* harmony default export */ __webpack_exports__["a"] = (FriendRequest);

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ViewProfile_css__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ViewProfile_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ViewProfile_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dp_png__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dp_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__dp_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UI_Button_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UI_Spinner_Spinner__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ViewProfile=function(_Component){_inherits(ViewProfile,_Component);function ViewProfile(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ViewProfile);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ViewProfile.__proto__||Object.getPrototypeOf(ViewProfile)).call.apply(_ref,[this].concat(args))),_this),_this.state={dpHash:__WEBPACK_IMPORTED_MODULE_3__dp_png___default.a,name:"",about:"",loading:true},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ViewProfile,[{key:'componentDidMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this2=this;var profile;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.client.methods.get_profile();case 2:profile=_context.sent.decodedResult;if(profile){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('https://ipfs.io/ipfs/'+profile.image).then(function(response){//console.log(response);
_this2.setState({dpHash:response.data});_this2.setState({loading:false});}).catch(function(err){console.error(err);_this2.setState({loading:false});});this.setState({name:profile.name,about:profile.about});}else{this.setState({loading:false});}//console.log(profile);
case 4:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref2.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ViewProfile'},this.state.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__UI_Spinner_Spinner__["a" /* default */],null):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:this.state.dpHash,alt:this.state.name,className:'VPImage'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,this.state.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,this.state.about),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__UI_Button_Button__["a" /* default */],{clicked:function clicked(){_this3.props.history.goBack();}},'Back'));}}]);return ViewProfile;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{client:state.client};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps)(ViewProfile));

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChatList_ChatList__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UI_Button_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UI_Spinner_Spinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Chats_css__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Chats_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Chats_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Chats=function(_Component){_inherits(Chats,_Component);function Chats(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Chats);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Chats.__proto__||Object.getPrototypeOf(Chats)).call.apply(_ref,[this].concat(args))),_this),_this.timeInterval=null,_this.state={inputValue:"",messages:[],loading:false},_this.handleSendMessage=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var allMessages;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.contractInstance.methods.send_message(_this.props.currentChat.user,_this.state.inputValue,_this.getTime());case 2:_this.setState({inputValue:""});_context.next=5;return _this.props.contractInstance.methods.get_friend_message(_this.props.currentChat.user);case 5:allMessages=_context.sent.decodedResult;_this.setState({messages:allMessages.reverse()});// this.setState({messages:allMessages.reverse()});
case 7:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.handleInputChange=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this.setState({inputValue:event.target.value});case 1:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}(),_this.getTime=function(){var d=new Date();d.toLocaleString();// -> "2/1/2013 7:37:08 AM"
d.toLocaleDateString();// -> "2/1/2013"
return d.toLocaleTimeString();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Chats,[{key:'componentDidMount',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var _this3=this;var allMessages;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:this.setState({loading:true});__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('https://ipfs.io/ipfs/'+this.props.currentChat.image).then(function(result){_this3.props.setPrevImage(_this3.props.generalImage);_this3.props.setGeneralImage(result.data);}).catch(function(error){console.error(error);});_context4.next=4;return this.props.contractInstance.methods.get_friend_message(this.props.currentChat.user);case 4:allMessages=_context4.sent.decodedResult;this.setState({loading:false,messages:allMessages.reverse()});this.timeInterval=setInterval(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var allMessages;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this3.props.contractInstance.methods.get_friend_message(_this3.props.currentChat.user);case 2:allMessages=_context3.sent.decodedResult;_this3.setState({messages:allMessages.reverse()});case 4:case'end':return _context3.stop();}}},_callee3,_this3);})),5000);case 7:case'end':return _context4.stop();}}},_callee4,this);}));function componentDidMount(){return _ref4.apply(this,arguments);}return componentDidMount;}()},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.timeInterval);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.state.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__UI_Spinner_Spinner__["a" /* default */],null):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ChatList_ChatList__["a" /* default */],{messages:this.state.messages}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ChatsMessageDiv'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{className:'ChatsInput',placeholder:'Enter Message',value:this.state.inputValue,onChange:this.handleInputChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UI_Button_Button__["a" /* default */],{clicked:this.handleSendMessage,otherClass:'ChatsButton'},'Send')));}}]);return Chats;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{contractInstance:state.client,currentChat:state.currentChat,generalImage:state.generalImage};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setGeneralImage:function setGeneralImage(imageData){return dispatch({type:"SET_GENERAL_IMAGE",generalImage:imageData});},setPrevImage:function setPrevImage(prevImg){return dispatch({type:"SET_PREV_IMAGE",prevImage:prevImg});}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Chats));

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChatList_css__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChatList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ChatList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReceivedMessage_ReceivedMessage__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SentMessages_SentMessages__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Chats=function(_Component){_inherits(Chats,_Component);function Chats(){_classCallCheck(this,Chats);return _possibleConstructorReturn(this,(Chats.__proto__||Object.getPrototypeOf(Chats)).apply(this,arguments));}_createClass(Chats,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ChatList'},this.props.messages.map(function(el){if(_this2.props.profile.user===el.sender){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SentMessages_SentMessages__["a" /* default */],{text:el.message,time:el.time});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ReceivedMessage_ReceivedMessage__["a" /* default */],{text:el.message,time:el.time});}}));}}]);return Chats;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{profile:state.usersProfile};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps)(Chats));

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReceivedMessage_css__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReceivedMessage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ReceivedMessage_css__);
/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ReceivedMessage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'receivedMessageDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'receivedMessageText'},props.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'receivedMessageTime'},props.time)));});

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SentMessages_css__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SentMessages_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SentMessages_css__);
/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SentMessages'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sentMessageDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'sentMessageText'},props.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'sentMessageTime'},props.time)));});

/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aeternity_aepp_sdk__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aeternity_aepp_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__aeternity_aepp_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Config_Config__ = __webpack_require__(349);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var getClient=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var client,contractInstance;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1__aeternity_aepp_sdk__["Aepp"])({parent:window.parent});case 3:client=_context.sent;_context.next=6;return client.getContractInstance(__WEBPACK_IMPORTED_MODULE_2__Config_Config__["a" /* default */].contractSource,{contractAddress:__WEBPACK_IMPORTED_MODULE_2__Config_Config__["a" /* default */].contractAddress});case 6:contractInstance=_context.sent;return _context.abrupt('return',contractInstance);case 10:_context.prev=10;_context.t0=_context['catch'](0);console.error(_context.t0);case 13:case'end':return _context.stop();}}},_callee,_this,[[0,10]]);}));return function getClient(){return _ref.apply(this,arguments);};}();/* harmony default export */ __webpack_exports__["a"] = (getClient);

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(234),__webpack_require__(235),__webpack_require__(238),__webpack_require__(241),__webpack_require__(243),__webpack_require__(15),__webpack_require__(244),__webpack_require__(247),__webpack_require__(265),__webpack_require__(269),__webpack_require__(272),__webpack_require__(275),__webpack_require__(278),__webpack_require__(34),__webpack_require__(279),__webpack_require__(283),__webpack_require__(286),__webpack_require__(287)):"function"==typeof define&&define.amd?define([,,,,,,,,,,,,,,,,,],t):"object"==typeof exports?exports.Ae=t(require("bignumber.js"),require("@stamp/required"),require("@stamp/it"),require("tweetnacl"),require("joi-browser"),require("axios"),require("rlp"),require("@aeternity/bip39"),require("bs58check"),require("ed2curve"),require("tweetnacl-auth"),require("blakejs"),require("aes-js"),require("sha.js"),require("websocket"),require("uuid"),require("bip32-path"),require("libsodium-wrappers-sumo")):e.Ae=t(e[void 0],e[void 0],e[void 0],e[void 0],e[void 0],e[void 0],e[void 0],e[void 0],e[void 0],e[void 0],e[void 0],e[void 0],e[void 0],e[void 0],e[void 0],e[void 0],e[void 0],e[void 0])}(window,(function(e,t,n,r,a,o,i,c,s,u,f,l,p,d,h,v,y,g){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var a=t[r]={i:r,l:!1,exports:{}};return e[r].call(a.exports,a,a.exports,n),a.l=!0,a.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var a in e)n.d(r,a,function(t){return e[t]}.bind(null,a));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=178)}([function(e,t,n){e.exports=n(138)},function(e,t){e.exports=function(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}},function(e,t,n){"use strict";n.d(t,"E",(function(){return b})),n.d(t,"A",(function(){return m})),n.d(t,"b",(function(){return x})),n.d(t,"q",(function(){return w})),n.d(t,"d",(function(){return O})),n.d(t,"o",(function(){return j})),n.d(t,"p",(function(){return k})),n.d(t,"k",(function(){return T})),n.d(t,"l",(function(){return I})),n.d(t,"m",(function(){return P})),n.d(t,"s",(function(){return A})),n.d(t,"j",(function(){return _})),n.d(t,"i",(function(){return S})),n.d(t,"B",(function(){return B})),n.d(t,"a",(function(){return U})),n.d(t,"D",(function(){return M})),n.d(t,"u",(function(){return q})),n.d(t,"r",(function(){return L})),n.d(t,"g",(function(){return K})),n.d(t,"f",(function(){return H})),n.d(t,"x",(function(){return W})),n.d(t,"y",(function(){return Y})),n.d(t,"t",(function(){return Q})),n.d(t,"h",(function(){return z})),n.d(t,"C",(function(){return X})),n.d(t,"z",(function(){return Ge})),n.d(t,"w",(function(){return Xe})),n.d(t,"v",(function(){return ft})),n.d(t,"e",(function(){return lt})),n.d(t,"n",(function(){return pt})),n.d(t,"c",(function(){return dt}));var r,a,o,i,c,s,u,f,l,p=n(1),d=n.n(p),h=n(6),v=n.n(h),y=n(3),g=n.n(y),b=1,m=0,x=["chain","test"],w=5e4,O=84600,j=0,k=.05,T=12,I={31:g()(3).times(1e14),30:g()(5).times(1e14),29:g()(8).times(1e14),28:g()(13).times(1e14),27:g()(21).times(1e14),26:g()(34).times(1e14),25:g()(55).times(1e14),24:g()(89).times(1e14),23:g()(144).times(1e14),22:g()(233).times(1e14),21:g()(377).times(1e14),20:g()(610).times(1e14),19:g()(987).times(1e14),18:g()(1597).times(1e14),17:g()(2584).times(1e14),16:g()(4181).times(1e14),15:g()(6765).times(1e14),14:g()(10946).times(1e14),13:g()(17711).times(1e14),12:g()(28657).times(1e14),11:g()(46368).times(1e14),10:g()(75025).times(1e14),9:g()(121393).times(1e14),8:g()(196418).times(1e14),7:g()(317811).times(1e14),6:g()(514229).times(1e14),5:g()(832040).times(1e14),4:g()(1346269).times(1e14),3:g()(2178309).times(1e14),2:g()(3524578).times(1e14),1:g()(5702887).times(1e14)},P={13:g()(0),12:g()(480),8:g()(31).times(480),4:g()(62).times(480)},A=11,C=function(e,t,n){return[e,t,n]},E=function(e,t){return[e,t]},_=1e9,S=5e4,B={account:"account",signed:"signedTx",spend:"spendTx",nameClaim:"nameClaimTx",namePreClaim:"namePreClaimTx",nameUpdate:"nameUpdateTx",nameRevoke:"nameRevokeTx",nameTransfer:"nameTransfer",contract:"contract",contractCreate:"contractCreateTx",contractCall:"contractCallTx",contractCallResult:"contractCallResult",oracleRegister:"oracleRegister",oracleExtend:"oracleExtend",oracleQuery:"oracleQuery",oracleResponse:"oracleResponse",channelCreate:"channelCreate",channelCloseMutual:"channelCloseMutual",channelCloseSolo:"channelCloseSolo",channelSlash:"channelSlash",channelDeposit:"channelDeposit",channelWithdraw:"channelWithdraw",channelSettle:"channelSettle",channelOffChain:"channelOffChain",channel:"channel",channelSnapshotSolo:"channelSnapshotSolo",channelOffChainUpdateTransfer:"channelOffChainUpdateTransfer",channelOffChainUpdateDeposit:"channelOffChainUpdateDeposit",channelOffChainUpdateWithdrawal:"channelOffChainUpdateWithdrawal",channelOffChainCreateContract:"channelOffChainCreateContract",channelOffChainCallContract:"channelOffChainCallContract",channelReconnect:"channelReconnect",proofOfInclusion:"proofOfInclusion",stateTrees:"stateTrees",merklePatriciaTree:"merklePatriciaTree",merklePatriciaTreeValue:"merklePatriciaTreeValue",contractsTree:"contractsTree",contractCallsTree:"contractCallsTree",channelsTree:"channelsTree",nameserviceTree:"nameserviceTree",oraclesTree:"oraclesTree",accountsTree:"accountsTree",gaAttach:"gaAttach",gaMeta:"gaMeta",sophiaByteCode:"sophiaByteCode"},N=1,R=3,D=4,V=5,F=6,U={NO_ABI:0,SOPHIA:1,SOLIDITY:2,FATE:3},M={FATE:"fate",AEVM:"aevm"},q={1:(r={},d()(r,B.contractCreate,{vmVersion:[N],abiVersion:[U.SOPHIA]}),d()(r,B.contractCall,{vmVersion:[N],abiVersion:[U.SOPHIA]}),d()(r,B.oracleRegister,{vmVersion:[N],abiVersion:[U.NO_ABI,U.SOPHIA]}),r),2:(a={},d()(a,B.contractCreate,{vmVersion:[R],abiVersion:[U.SOPHIA]}),d()(a,B.contractCall,{vmVersion:[R,N],abiVersion:[U.SOPHIA]}),d()(a,B.oracleRegister,{vmVersion:[R],abiVersion:[U.NO_ABI,U.SOPHIA]}),a),3:(o={},d()(o,B.contractCreate,{vmVersion:[D],abiVersion:[U.SOPHIA]}),d()(o,B.contractCall,{vmVersion:[D,N,R],abiVersion:[U.SOPHIA]}),d()(o,B.oracleRegister,{vmVersion:[],abiVersion:[U.NO_ABI,U.SOPHIA]}),o),4:(i={},d()(i,B.contractCreate,{vmVersion:[V,F],abiVersion:[U.FATE,U.SOPHIA]}),d()(i,B.contractCall,{vmVersion:[V,F,D,N,R],abiVersion:[U.FATE,U.SOPHIA]}),d()(i,B.oracleRegister,{vmVersion:[],abiVersion:[U.NO_ABI,U.SOPHIA]}),i)},L=(c={},d()(c,10,B.account),d()(c,A,B.signed),d()(c,12,B.spend),d()(c,32,B.nameClaim),d()(c,33,B.namePreClaim),d()(c,34,B.nameUpdate),d()(c,35,B.nameRevoke),d()(c,36,B.nameTransfer),d()(c,40,B.contract),d()(c,42,B.contractCreate),d()(c,43,B.contractCall),d()(c,41,B.contractCallResult),d()(c,22,B.oracleRegister),d()(c,25,B.oracleExtend),d()(c,23,B.oracleQuery),d()(c,24,B.oracleResponse),d()(c,50,B.channelCreate),d()(c,53,B.channelCloseMutual),d()(c,54,B.channelCloseSolo),d()(c,55,B.channelSlash),d()(c,51,B.channelDeposit),d()(c,52,B.channelWithdraw),d()(c,56,B.channelSettle),d()(c,57,B.channelOffChain),d()(c,58,B.channel),d()(c,59,B.channelSnapshotSolo),d()(c,570,B.channelOffChainUpdateTransfer),d()(c,571,B.channelOffChainUpdateDeposit),d()(c,572,B.channelOffChainUpdateWithdrawal),d()(c,573,B.channelOffChainCreateContract),d()(c,574,B.channelOffChainCallContract),d()(c,575,B.channelReconnect),d()(c,60,B.proofOfInclusion),d()(c,62,B.stateTrees),d()(c,63,B.merklePatriciaTree),d()(c,64,B.merklePatriciaTreeValue),d()(c,621,B.contractsTree),d()(c,622,B.contractCallsTree),d()(c,623,B.channelsTree),d()(c,624,B.nameserviceTree),d()(c,625,B.oraclesTree),d()(c,626,B.accountsTree),d()(c,80,B.gaAttach),d()(c,81,B.gaMeta),d()(c,70,B.sophiaByteCode),c),K={int:"int",id:"id",ids:"ids",string:"string",binary:"binary",rlpBinary:"rlpBinary",rlpBinaries:"rlpBinaries",rawBinary:"rawBinary",bool:"bool",hex:"hex",signatures:"signatures",pointers:"pointers",offChainUpdates:"offChainUpdates",callStack:"callStack",proofOfInclusion:"proofOfInclusion",mptree:"mptree",callReturnType:"callReturnType",ctVersion:"ctVersion",sophiaCodeTypeInfo:"sophiaCodeTypeInfo",payload:"payload"},H=2e4,W=function(e){switch(e){case B.gaAttach:case B.contractCreate:return g()(75e3);case B.gaMeta:case B.contractCall:return g()(45e4);default:return g()(15e3)}},Y=function(e){return function(t){var n=t.txSize,r=t.relativeTtl;switch(e){case B.oracleRegister:case B.oracleExtend:case B.oracleQuery:case B.oracleResponse:return g()(n).times(20).plus(Math.ceil(32e3*r/Math.floor(175200)));default:return g()(n).times(20)}}},Q={ak:1,nm:2,cm:3,ok:4,ct:5,ch:6},z=(l=Q,Object.entries(l).reduce((function(e,t){var n=v()(t,2),r=n[0];return(e[n[1]]=r)&&e}),{})),G=function(e){return e},X=(s={},d()(s,K.int,(function(e){var t=e.value,n=e.isMinusValue;return G("".concat(t,n?" must be >= 0":" is not of type Number or BigNumber"))})),d()(s,K.id,(function(e){var t=e.value,n=e.prefix;return G("'".concat(t,"' prefix doesn't match expected prefix '").concat(n,"' or ID_TAG for prefix not found"))})),d()(s,K.binary,(function(e){var t=e.prefix,n=e.value;return G("'".concat(n,"' prefix doesn't match expected prefix '").concat(t,"'"))})),d()(s,K.string,(function(e){e.value;return G("Not a string")})),d()(s,K.pointers,(function(e){e.value;return G('Value must be of type Array and contains only object\'s like \'{key: "account_pubkey", id: "ak_lkamsflkalsdalksdlasdlasdlamd"}\'')})),d()(s,K.ctVersion,(function(e){e.value;return G('Value must be an object with "vmVersion" and "abiVersion" fields')})),s),$=[C("tag",K.int),C("VSN",K.int)],J=[].concat($,[C("nonce",K.int),C("balance",K.int)]),Z=[].concat($,[C("sourceCodeHash",K.rawBinary),C("typeInfo",K.sophiaCodeTypeInfo),C("byteCode",K.rawBinary),C("compilerVersion",K.string),C("payable",K.bool)]),ee=[].concat($,[C("sourceCodeHash",K.rawBinary),C("typeInfo",K.sophiaCodeTypeInfo),C("byteCode",K.rawBinary),C("compilerVersion",K.string)]),te=[].concat($,[C("sourceCodeHash",K.rawBinary),C("typeInfo",K.sophiaCodeTypeInfo),C("byteCode",K.rawBinary)]),ne=[].concat($,[C("flags",K.int),C("nonce",K.int),C("balance",K.int),C("gaContract",K.id,["ct","nm"]),C("gaAuthFun",K.binary,"cb")]),re=[].concat($,[C("senderId",K.id,"ak"),C("recipientId",K.id,["ak","nm"]),C("amount",K.int),C("fee",K.int),C("ttl",K.int),C("nonce",K.int),C("payload",K.payload)]),ae=[].concat($,[C("signatures",K.signatures),C("encodedTx",K.rlpBinary)]),oe=[].concat($,[C("accountId",K.id,"ak"),C("nonce",K.int),C("commitmentId",K.id,"cm"),C("fee",K.int),C("ttl",K.int)]),ie=[].concat($,[C("accountId",K.id,"ak"),C("nonce",K.int),C("name",K.binary,"nm"),C("nameSalt",K.int),C("fee",K.int),C("ttl",K.int)]),ce=[].concat($,[C("accountId",K.id,"ak"),C("nonce",K.int),C("name",K.binary,"nm"),C("nameSalt",K.int),C("nameFee",K.int),C("fee",K.int),C("ttl",K.int)]),se=[].concat($,[C("accountId",K.id,"ak"),C("nonce",K.int),C("nameId",K.id,"nm"),C("nameTtl",K.int),C("pointers",K.pointers),C("clientTtl",K.int),C("fee",K.int),C("ttl",K.int)]),ue=[].concat($,[C("accountId",K.id,"ak"),C("nonce",K.int),C("nameId",K.id,"nm"),C("recipientId",K.id,["ak","nm"]),C("fee",K.int),C("ttl",K.int)]),fe=[].concat($,[C("accountId",K.id,"ak"),C("nonce",K.int),C("nameId",K.id,"nm"),C("fee",K.int),C("ttl",K.int)]),le=[].concat($,[C("owner",K.id,"ak"),C("ctVersion",K.int),C("code",K.binary,"cb"),C("log",K.binary,"cb"),C("active",K.bool),C("referers",K.ids,"ak"),C("deposit",K.int)]),pe=[].concat($,[C("ownerId",K.id,"ak"),C("nonce",K.int),C("code",K.binary,"cb"),C("authFun",K.rawBinary),C("ctVersion",K.ctVersion),C("fee",K.int),C("ttl",K.int),C("gas",K.int),C("gasPrice",K.int),C("callData",K.binary,"cb")]),de=[].concat($,[C("gaId",K.id,"ak"),C("authData",K.binary,"cb"),C("abiVersion",K.int),C("fee",K.int),C("gas",K.int),C("gasPrice",K.int),C("ttl",K.int),C("tx",K.rlpBinary)]),he=[].concat($,[C("ownerId",K.id,"ak"),C("nonce",K.int),C("code",K.binary,"cb"),C("ctVersion",K.ctVersion),C("fee",K.int),C("ttl",K.int),C("deposit",K.int),C("amount",K.int),C("gas",K.int),C("gasPrice",K.int),C("callData",K.binary,"cb")]),ve=[].concat($,[C("callerId",K.id,"ak"),C("nonce",K.int),C("contractId",K.id,["ct","nm"]),C("abiVersion",K.int),C("fee",K.int),C("ttl",K.int),C("amount",K.int),C("gas",K.int),C("gasPrice",K.int),C("callData",K.binary,"cb")]),ye=[].concat($,[C("callerId",K.id,"ak"),C("callerNonce",K.int),C("height",K.int),C("contractId",K.id,"ct"),C("gasPrice",K.int),C("gasUsed",K.int),C("returnValue",K.binary,"cb"),C("returnType",K.callReturnType),C("log",K.rawBinary)]),ge=[].concat($,[C("accountId",K.id,"ak"),C("nonce",K.int),C("queryFormat",K.string),C("responseFormat",K.string),C("queryFee",K.int),C("oracleTtlType",K.int),C("oracleTtlValue",K.int),C("fee",K.int),C("ttl",K.int),C("abiVersion",K.int)]),be=[].concat($,[C("oracleId",K.id,["ok","nm"]),C("nonce",K.int),C("oracleTtlType",K.int),C("oracleTtlValue",K.int),C("fee",K.int),C("ttl",K.int)]),me=[].concat($,[C("senderId",K.id,"ak"),C("nonce",K.int),C("oracleId",K.id,["ok","nm"]),C("query",K.string),C("queryFee",K.int),C("queryTtlType",K.int),C("queryTtlValue",K.int),C("responseTtlType",K.int),C("responseTtlValue",K.int),C("fee",K.int),C("ttl",K.int)]),xe=[].concat($,[C("oracleId",K.id,"ok"),C("nonce",K.int),C("queryId",K.binary,"oq"),C("response",K.string),C("responseTtlType",K.int),C("responseTtlValue",K.int),C("fee",K.int),C("ttl",K.int)]),we=[].concat($,[C("initiator",K.id,"ak"),C("initiatorAmount",K.int),C("responder",K.id,"ak"),C("responderAmount",K.int),C("channelReserve",K.int),C("lockPeriod",K.int),C("ttl",K.int),C("fee",K.int),C("delegateIds",K.string),C("stateHash",K.binary,"st"),C("nonce",K.int)]),Oe=[].concat($,[C("channelId",K.id,"ch"),C("fromId",K.id,"ak"),C("amount",K.int),C("ttl",K.int),C("fee",K.int),C("stateHash",K.binary,"st"),C("round",K.int),C("nonce",K.int)]),je=[].concat($,[C("channelId",K.id,"ch"),C("toId",K.id,"ak"),C("amount",K.int),C("ttl",K.int),C("fee",K.int),C("stateHash",K.binary,"st"),C("round",K.int),C("nonce",K.int)]),ke=[].concat($,[C("channelId",K.id,"ch"),C("fromId",K.id,"ak"),C("initiatorAmountFinal",K.int),C("responderAmountFinal",K.int),C("ttl",K.int),C("fee",K.int),C("nonce",K.int)]),Te=[].concat($,[C("channelId",K.id,"ch"),C("fromId",K.id,"ak"),C("payload",K.binary,"tx"),C("poi",K.binary,"pi"),C("ttl",K.int),C("fee",K.int),C("nonce",K.int)]),Ie=[].concat($,[C("channelId",K.id,"ch"),C("fromId",K.id,"ak"),C("payload",K.binary,"tx"),C("poi",K.binary,"pi"),C("ttl",K.int),C("fee",K.int),C("nonce",K.int)]),Pe=[].concat($,[C("channelId",K.id,"ch"),C("fromId",K.id,"ak"),C("initiatorAmountFinal",K.int),C("responderAmountFinal",K.int),C("ttl",K.int),C("fee",K.int),C("nonce",K.int)]),Ae=[].concat($,[C("channelId",K.id,"ch"),C("round",K.int),C("updates",K.offChainUpdates),C("stateHash",K.binary,"st")]),Ce=[].concat($,[C("channelId",K.id,"ch"),C("round",K.int),C("stateHash",K.binary,"st")]),Ee=[].concat($,[C("initiator",K.id,"ak"),C("responder",K.id,"ak"),C("channelAmount",K.int),C("initiatorAmount",K.int),C("responderAmount",K.int),C("channelReserve",K.int),C("delegateIds",K.ids),C("stateHash",K.hex),C("round",K.int),C("soloRound",K.int),C("lockPeriod",K.int),C("lockedUntil",K.int)]),_e=[].concat($,[C("initiator",K.id,"ak"),C("responder",K.id,"ak"),C("channelAmount",K.int),C("initiatorAmount",K.int),C("responderAmount",K.int),C("channelReserve",K.int),C("delegateIds",K.ids),C("stateHash",K.hex),C("round",K.int),C("soloRound",K.int),C("lockPeriod",K.int),C("lockedUntil",K.int),C("initiatorAuth",K.binary,"cb"),C("responderAuth",K.binary,"cb")]),Se=[].concat($,[C("channelId",K.id,"ch"),C("fromId",K.id,"ak"),C("payload",K.binary,"tx"),C("ttl",K.int),C("fee",K.int),C("nonce",K.int)]),Be=[].concat($,[C("owner",K.id,"ak"),C("ctVersion",K.int),C("code",K.binary,"cb"),C("deposit",K.int),C("callData",K.binary,"cb")]),Ne=[].concat($,[C("caller",K.id,"ak"),C("contract",K.id,"ct"),C("abiVersion",K.int),C("amount",K.int),C("callData",K.binary,"cb"),C("callStack",K.callStack),C("gasPrice",K.int),C("gasLimit",K.int)]),Re=[].concat($,[C("channelId",K.id,"ch"),C("round",K.int),C("role",K.string),C("pubkey",K.id,"ak")]),De=[].concat($,[C("from",K.id,"ak"),C("to",K.id,"ak"),C("amount",K.int)]),Ve=[].concat($,[C("from",K.id,"ak"),C("amount",K.int)]),Fe=[].concat($,[C("from",K.id,"ak"),C("amount",K.int)]),Ue=[].concat($,[C("accounts",K.mptrees),C("calls",K.mptrees),C("channels",K.mptrees),C("contracts",K.mptrees),C("ns",K.mptrees),C("oracles",K.mptrees)]),Me=[].concat($,[C("contracts",K.rlpBinary),C("calls",K.rlpBinary),C("channels",K.rlpBinary),C("ns",K.rlpBinary),C("oracles",K.rlpBinary),C("accounts",K.rlpBinary)]),qe=[].concat($,[C("values",K.rlpBinaries)]),Le=[].concat($,[C("key",K.hex),C("value",K.rawBinary)]),Ke=[].concat($,[C("contracts",K.rlpBinary)]),He=[].concat($,[C("calls",K.rlpBinary)]),We=[].concat($,[C("channels",K.rlpBinary)]),Ye=[].concat($,[C("mtree",K.rlpBinary)]),Qe=[].concat($,[C("otree",K.rlpBinary)]),ze=[].concat($,[C("accounts",K.rlpBinary)]),Ge=(u={},d()(u,B.account,{1:E(J,10),2:E(ne,10)}),d()(u,B.signed,{1:E(ae,A)}),d()(u,B.spend,{1:E(re,12)}),d()(u,B.namePreClaim,{1:E(oe,33)}),d()(u,B.nameClaim,{1:E(ie,32),2:E(ce,32)}),d()(u,B.nameUpdate,{1:E(se,34)}),d()(u,B.nameTransfer,{1:E(ue,36)}),d()(u,B.nameRevoke,{1:E(fe,35)}),d()(u,B.contract,{1:E(le,40)}),d()(u,B.contractCreate,{1:E(he,42)}),d()(u,B.contractCall,{1:E(ve,43)}),d()(u,B.contractCallResult,{1:E(ye,41)}),d()(u,B.oracleRegister,{1:E(ge,22)}),d()(u,B.oracleExtend,{1:E(be,25)}),d()(u,B.oracleQuery,{1:E(me,23)}),d()(u,B.oracleResponse,{1:E(xe,24)}),d()(u,B.channelCreate,{1:E(we,50)}),d()(u,B.channelCloseMutual,{1:E(ke,53)}),d()(u,B.channelCloseSolo,{1:E(Te,54)}),d()(u,B.channelSlash,{1:E(Ie,55)}),d()(u,B.channelDeposit,{1:E(Oe,51)}),d()(u,B.channelWithdraw,{1:E(je,52)}),d()(u,B.channelSettle,{1:E(Pe,56)}),d()(u,B.channelOffChain,{1:E(Ae,57),2:E(Ce,57)}),d()(u,B.channel,{1:E(Ee,58),2:E(_e,58)}),d()(u,B.channelSnapshotSolo,{1:E(Se,59)}),d()(u,B.channelOffChainUpdateTransfer,{1:E(De,570)}),d()(u,B.channelOffChainUpdateDeposit,{1:E(Ve,571)}),d()(u,B.channelOffChainUpdateWithdrawal,{1:E(Fe,572)}),d()(u,B.channelOffChainCreateContract,{1:E(Be,573)}),d()(u,B.channelOffChainCallContract,{1:E(Ne,574)}),d()(u,B.channelReconnect,{1:E(Re,575)}),d()(u,B.proofOfInclusion,{1:E(Ue,60)}),d()(u,B.stateTrees,{1:E(Me,62)}),d()(u,B.merklePatriciaTree,{1:E(qe,63)}),d()(u,B.merklePatriciaTreeValue,{1:E(Le,64)}),d()(u,B.contractsTree,{1:E(Ke,621)}),d()(u,B.contractCallsTree,{1:E(He,622)}),d()(u,B.channelsTree,{1:E(We,623)}),d()(u,B.nameserviceTree,{1:E(Ye,624)}),d()(u,B.oraclesTree,{1:E(Qe,625)}),d()(u,B.accountsTree,{1:E(ze,626)}),d()(u,B.gaAttach,{1:E(pe,80)}),d()(u,B.gaMeta,{1:E(de,81)}),u),Xe=(f={},d()(f,10,{1:E(J,10),2:E(ne,10)}),d()(f,A,{1:E(ae,A)}),d()(f,12,{1:E(re,12)}),d()(f,33,{1:E(oe,33)}),d()(f,32,{1:E(ie,32),2:E(ce,32)}),d()(f,34,{1:E(se,34)}),d()(f,36,{1:E(ue,36)}),d()(f,35,{1:E(fe,35)}),d()(f,40,{1:E(le,40)}),d()(f,42,{1:E(he,42)}),d()(f,43,{1:E(ve,43)}),d()(f,41,{1:E(ye,41)}),d()(f,22,{1:E(ge,22)}),d()(f,25,{1:E(be,25)}),d()(f,23,{1:E(me,23)}),d()(f,24,{1:E(xe,24)}),d()(f,50,{1:E(we,50)}),d()(f,53,{1:E(ke,53)}),d()(f,54,{1:E(Te,54)}),d()(f,55,{1:E(Ie,55)}),d()(f,51,{1:E(Oe,51)}),d()(f,52,{1:E(je,52)}),d()(f,56,{1:E(Pe,56)}),d()(f,57,{1:E(Ae,57),2:E(Ce,57)}),d()(f,58,{1:E(Ee,58),2:E(_e,58)}),d()(f,59,{1:E(Se,59)}),d()(f,570,{1:E(De,570)}),d()(f,571,{1:E(Ve,571)}),d()(f,572,{1:E(Fe,572)}),d()(f,573,{1:E(Be,573)}),d()(f,574,{1:E(Ne,574)}),d()(f,575,{1:E(Re,575)}),d()(f,60,{1:E(Ue,60)}),d()(f,62,{1:E(Me,62)}),d()(f,63,{1:E(qe,63)}),d()(f,64,{1:E(Le,64)}),d()(f,621,{1:E(Ke,621)}),d()(f,622,{1:E(He,622)}),d()(f,623,{1:E(We,623)}),d()(f,624,{1:E(Ye,624)}),d()(f,625,{1:E(Qe,625)}),d()(f,626,{1:E(ze,626)}),d()(f,80,{1:E(pe,80)}),d()(f,81,{1:E(de,81)}),d()(f,70,{1:E(te,70),2:E(ee,70),3:E(Z,70)}),f),$e="error",Je="warning",Ze=function(e,t,n){return[e,t,n]},et="insufficientFee",tt="expiredTTL",nt="insufficientBalanceForAmountFee",rt="insufficientBalanceForAmount",at="nonceUsed",ot="nonceHigh",it="minGasPrice",ct="vmAndAbiVersion",st="insufficientBalanceForFeeNameFee",ut={invalidSignature:{key:"InvalidSignature",type:$e,txKey:"signature"},insufficientFee:{key:"InsufficientFee",type:$e,txKey:"fee"},expiredTTL:{key:"ExpiredTTL",type:$e,txKey:"ttl"},insufficientBalanceForAmountFee:{key:"InsufficientBalanceForAmountFee",type:Je,txKey:"fee"},insufficientBalanceForAmount:{key:"InsufficientBalanceForAmount",type:Je,txKey:"amount"},nonceUsed:{key:"NonceUsed",type:$e,txKey:"nonce"},nonceHigh:{key:"NonceHigh",type:Je,txKey:"nonce"},minGasPrice:{key:"minGasPrice",type:$e,txKey:"gasPrice"},vmAndAbiVersion:{key:"vmAndAbiVersion",type:$e,txKey:"ctVersion"},insufficientBalanceForFeeNameFee:{key:"insufficientBalanceForFeeNameFee",type:$e,txKey:"nameFee"}},ft=[Ze((function(){return"The signature cannot be verified, please verify that you used the correct network id and the correct private key for the sender address"}),"signature",ut.invalidSignature)],lt=[Ze((function(e){e.ctVersion;var t=e.consensusProtocolVersion,n=e.txType;return"Wrong abi/vm version, Supported is: ".concat(q[t]?JSON.stringify(q[t][n]):" None for this protocol "+t)}),ct,ut.vmAndAbiVersion),Ze((function(){return"The gasPrice must be bigger then ".concat(_)}),it,ut.minGasPrice)],pt=[Ze((function(e){var t=e.balance;return"The account balance ".concat(t," is not enough to execute the transaction")}),st,ut.insufficientBalanceForFeeNameFee)],dt=[Ze((function(e){var t=e.minFee;return"The fee for the transaction is too low, the minimum fee for this transaction is ".concat(t)}),et,ut.insufficientFee),Ze((function(e){var t=e.height;return"The TTL is already expired, the current height is ".concat(t)}),tt,ut.expiredTTL),Ze((function(e){var t=e.balance;return"The account balance ".concat(t," is not enough to execute the transaction")}),nt,ut.insufficientBalanceForAmountFee),Ze((function(e){var t=e.balance;return"The account balance ".concat(t," is not enough to execute the transaction")}),rt,ut.insufficientBalanceForAmount),Ze((function(e){var t=e.accountNonce;return"The nonce is invalid(already used). Next valid nonce is ".concat(t+1,")")}),at,ut.nonceUsed),Ze((function(e){var t=e.accountNonce;return"The nonce is technically valid but will not be processed immediately by the node (next valid nonce is ".concat(t+1,")")}),ot,ut.nonceHigh)]},function(t,n){t.exports=e},function(e,t,n){var r=n(99),a=n(11)((function(e,t){return r({},e,t)}));e.exports=a},function(e,t,n){"use strict";n.r(t),function(e){n.d(t,"isBase64",(function(){return x})),n.d(t,"ADDRESS_FORMAT",(function(){return w})),n.d(t,"formatAddress",(function(){return O})),n.d(t,"isAddressValid",(function(){return j})),n.d(t,"addressToHex",(function(){return k})),n.d(t,"addressFromDecimal",(function(){return T})),n.d(t,"hash",(function(){return I})),n.d(t,"nameId",(function(){return P})),n.d(t,"sha256hash",(function(){return A})),n.d(t,"salt",(function(){return C})),n.d(t,"encodeBase64Check",(function(){return E})),n.d(t,"checkSumFn",(function(){return _})),n.d(t,"decodeBase64Check",(function(){return S})),n.d(t,"encodeBase58Check",(function(){return B})),n.d(t,"decodeBase58Check",(function(){return N})),n.d(t,"hexStringToByte",(function(){return R})),n.d(t,"encodeUnsigned",(function(){return D})),n.d(t,"encodeContractAddress",(function(){return V})),n.d(t,"generateKeyPairFromSecret",(function(){return F})),n.d(t,"generateKeyPair",(function(){return U})),n.d(t,"encryptPublicKey",(function(){return M})),n.d(t,"encryptPrivateKey",(function(){return q})),n.d(t,"encryptKey",(function(){return L})),n.d(t,"decryptKey",(function(){return K})),n.d(t,"sign",(function(){return H})),n.d(t,"verify",(function(){return W})),n.d(t,"prepareTx",(function(){return Y})),n.d(t,"personalMessageToBinary",(function(){return Q})),n.d(t,"signPersonalMessage",(function(){return z})),n.d(t,"verifyPersonalMessage",(function(){return G})),n.d(t,"aeEncodeKey",(function(){return X})),n.d(t,"generateSaveWallet",(function(){return $})),n.d(t,"decryptPrivateKey",(function(){return J})),n.d(t,"decryptPubKey",(function(){return Z})),n.d(t,"assertedType",(function(){return ee})),n.d(t,"decodeTx",(function(){return te})),n.d(t,"encodeTx",(function(){return ne})),n.d(t,"isValidKeypair",(function(){return re})),n.d(t,"envKeypair",(function(){return ae})),n.d(t,"decode",(function(){return oe})),n.d(t,"encode",(function(){return ie})),n.d(t,"rlp",(function(){return ce})),n.d(t,"deserialize",(function(){return ve})),n.d(t,"encryptData",(function(){return ye})),n.d(t,"decryptData",(function(){return ge}));var r=n(6),a=n.n(r),o=n(76),i=n.n(o),c=n(47),s=n(106),u=n(77),f=n.n(u),l=n(16),p=n.n(l),d=n(107),h=n.n(d),v=n(108),y=n.n(v),g=n(17),b=n(9),m=h.a.ModeOfOperation.ecb;function x(e){if(e.length%4>0||e.match(/[^0-9a-z+/=]/i))return!1;var t=e.indexOf("=");return!(-1!==t&&!e.slice(t).match(/={1,2}/))}var w={sophia:1,api:2,raw:3};function O(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:w.api,t=arguments.length>1?arguments[1]:void 0;switch(e){case w.api:return t;case w.sophia:return"0x".concat(Object(b.decode)(t,"ak").toString("hex"))}}function j(e){var t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"ak";try{t=32===N(ee(e,n)).length}catch(e){t=!1}return t}function k(e){return"0x".concat(N(ee(e,"ak")).toString("hex"))}function T(e){return X(Object(g.toBytes)(e,!0))}function I(t){return e.from(Object(s.blake2b)(t,null,32))}function P(t){var n=e.allocUnsafe(32).fill(0);if(t){for(var r=t.split("."),a=0;a<r.length;a++)n=I(e.concat([n,I(r[a])]));return n}return n}function A(e){return y()("sha256").update(e).digest()}function C(){return Math.floor(Math.random()*Math.floor(Number.MAX_SAFE_INTEGER))}function E(t){var n=e.from(t),r=_(t);return e.concat([n,r],n.length+4).toString("base64")}function _(e){return A(A(e)).slice(0,4)}function S(t){var n=function(e){var t=e.slice(0,-4),n=e.slice(-4),r=_(t);if(n.equals(r))return t}(e.from(t,"base64"));if(!n)throw new Error("Invalid checksum");return e.from(n)}function B(t){return i.a.encode(e.from(t))}function N(e){return i.a.decode(e)}function R(e){if(!e)return new Uint8Array;for(var t=[],n=0,r=e.length;n<r;n+=2)t.push(parseInt(e.substr(n,2),16));return new Uint8Array(t)}function D(t){var n=e.allocUnsafe(4);return n.writeUInt32BE(t),n.slice(n.findIndex((function(e){return 0!==e})))}function V(t,n){var r=N(ee(t,"ak")),a=e.concat([r,D(n)]);return"ct_".concat(B(I(a)))}function F(e){return p.a.sign.keyPair.fromSecretKey(e)}function U(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0],n=p.a.sign.keyPair(),r=e.from(n.publicKey),a=e.from(n.secretKey);return t?{publicKey:r,secretKey:a}:{publicKey:"ak_".concat(B(r)),secretKey:a.toString("hex")}}function M(e,t){return L(e,Object(g.rightPad)(32,t))}function q(e,t){return L(e,Object(g.leftPad)(64,t))}function L(e,t){var n=A(e);return new m(n).encrypt(t)}function K(t,n){var r=e.from(n),a=A(t),o=new m(a);return e.from(o.decrypt(r))}function H(t,n){return p.a.sign.detached(e.from(t),e.from(n))}function W(e,t,n){return p.a.sign.detached.verify(new Uint8Array(e),t,n)}function Y(t,n){return[e.from([11]),e.from([1]),[e.from(t)],n]}function Q(t){var n=e.from("æternity Signed Message:\n","utf8"),r=e.from(t,"utf8");if(r.length>=253)throw new Error("message too long");return e.concat([e.from([n.length]),n,e.from([r.length]),r])}function z(e,t){return H(Q(e),t)}function G(e,t,n){return W(Q(e),t,n)}function X(t){var n=B(e.from(t,"hex"));return"ak_".concat(n)}function $(e){var t=U(!0);return{publicKey:M(e,t.publicKey),secretKey:q(e,t.secretKey)}}function J(e,t){return K(e,t)}function Z(e,t){return K(e,t).slice(0,65)}function ee(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(RegExp("^".concat(t,"_.+$")).test(e))return e.split("_")[1];if(!n)throw Error("Data doesn't match expected type ".concat(t));return!1}function te(t){return c.decode(e.from(S(ee(t,"tx"))))}function ne(e){var t=E(c.encode(e));return"tx_".concat(t)}function re(t,n){var r=e.from("TheMessage");return W(r,H(r,t),n)}function ae(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n={secretKey:e.WALLET_PRIV,publicKey:e.WALLET_PUB};if(n.publicKey&&n.secretKey)return n;if(!t)throw Error("Environment variables WALLET_PRIV and WALLET_PUB need to be set")}var oe=c.decode,ie=c.encode,ce=c,se={SIGNED_TX:11,CHANNEL_CREATE_TX:50,CHANNEL_CLOSE_MUTUAL_TX:53,CHANNEL_OFFCHAIN_TX:57,CHANNEL_OFFCHAIN_UPDATE_TRANSFER:570};function ue(e,t){if(t){var n=Object.entries(se).find((function(t){var n=a()(t,2),r=(n[0],n[1]);return e===r}));return n?n[0]:e}return e}function fe(e){return e.readIntBE(0,e.length)}function le(e){var t={1:"ak",2:"nm",3:"cm",4:"ok",5:"ct",6:"ch"}[e.readUIntBE(0,1)],n=B(e.slice(1,e.length));return"".concat(t,"_").concat(n)}function pe(e){for(var t=[],n=0;n<e.length;n++)t.push(B(e[n]));return t}function de(e,t){var n=fe(e[0]),r={tag:ue(n,t.prettyTags),version:fe(e[1])};switch(n){case se.CHANNEL_OFFCHAIN_UPDATE_TRANSFER:return Object.assign(r,{from:le(e[2]),to:le(e[3]),amount:fe(e[4])})}return r}function he(e,t){for(var n=[],r=0;r<e.length;r++)n.push(de(oe(e[r]),t));return n}function ve(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{prettyTags:!1},n=fe(e[0]),r={tag:ue(n,t.prettyTags),version:fe(e[1])};switch(n){case se.SIGNED_TX:return Object.assign(r,{signatures:pe(e[2]),tx:ve(oe(e[3]),t)});case se.CHANNEL_CREATE_TX:return Object.assign(r,{initiator:le(e[2]),initiatorAmount:fe(e[3]),responder:le(e[4]),responderAmount:fe(e[5]),channelReserve:fe(e[6]),lockPeriod:fe(e[7]),ttl:fe(e[8]),fee:fe(e[9])});case se.CHANNEL_CLOSE_MUTUAL_TX:return Object.assign(r,{channelId:le(e[2]),initiatorAmount:fe(e[3]),responderAmount:fe(e[4]),ttl:fe(e[5]),fee:fe(e[6]),nonce:fe(e[7])});case se.CHANNEL_OFFCHAIN_TX:return Object.assign(r,{channelId:le(e[2]),round:fe(e[3]),updates:he(e[4],t),state:B(e[5])})}}function ye(t,n){var r=p.a.box.keyPair(),a=N(ee(n,"ak")),o=p.a.randomBytes(p.a.box.nonceLength),i=p.a.box(e.from(t),o,f.a.convertPublicKey(a),r.secretKey);return{ciphertext:e.from(i).toString("hex"),ephemPubKey:e.from(r.publicKey).toString("hex"),nonce:e.from(o).toString("hex"),version:"x25519-xsalsa20-poly1305"}}function ge(t,n){var r=f.a.convertSecretKey(e.from(t,"hex")),a=e.from(n.nonce,"hex"),o=e.from(n.ciphertext,"hex"),i=e.from(n.ephemPubKey,"hex"),c=p.a.box.open(o,a,i,r);return c?e.from(c):c}}.call(this,n(22).Buffer)},function(e,t,n){var r=n(88),a=n(139),o=n(89);e.exports=function(e,t){return r(e)||a(e,t)||o()}},function(e,n){e.exports=t},function(e,t,n){var r=n(91)(0);e.exports=r},function(e,t,n){"use strict";n.r(t),function(e){n.d(t,"createSalt",(function(){return T})),n.d(t,"buildContractId",(function(){return P})),n.d(t,"buildHash",(function(){return A})),n.d(t,"oracleQueryId",(function(){return C})),n.d(t,"formatSalt",(function(){return E})),n.d(t,"produceNameId",(function(){return _})),n.d(t,"commitmentHash",(function(){return S})),n.d(t,"decode",(function(){return B})),n.d(t,"encode",(function(){return N})),n.d(t,"writeId",(function(){return R})),n.d(t,"readId",(function(){return D})),n.d(t,"writeInt",(function(){return V})),n.d(t,"readInt",(function(){return F})),n.d(t,"buildPointers",(function(){return U})),n.d(t,"readPointers",(function(){return M})),n.d(t,"isNameValid",(function(){return q})),n.d(t,"classify",(function(){return L})),n.d(t,"getMinimumNameFee",(function(){return K})),n.d(t,"computeBidFee",(function(){return H})),n.d(t,"computeAuctionEndBlock",(function(){return W}));var r=n(112),a=n.n(r),o=n(111),i=n.n(o),c=n(55),s=n.n(c),u=n(78),f=n.n(u),l=n(110),p=n.n(l),d=n(6),h=n.n(d),v=n(29),y=n.n(v),g=n(12),b=n.n(g),m=n(3),x=n.n(m),w=n(5),O=n(17),j=n(2),k=n(109),T=w.salt,I=["tx","st","ss","pi","ov","or","cb","cs","ba"];function P(t,n){var r=e.from([].concat(b()(B(t,"ak")),b()(Object(O.toBytes)(n))));return N(Object(w.hash)(r),"ct")}function A(e,t){return N(Object(w.hash)(t),e)}function C(t,n,r){var a,o;return N(Object(w.hash)(e.from([].concat(b()(B(t,"ak")),b()((a=n,o=Object(O.toBytes)(a,!0),e.concat([e.alloc(32-o.length),o]))),b()(B(r,"ok"))))),"oq")}function E(t){return e.from(t.toString(16).padStart(64,"0"),"hex")}function _(e){return N("chain"===y()(e.split("."))?Object(w.hash)(e.toLowerCase()):Object(w.nameId)(e),"nm")}function S(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:T(),r=y()(t.split("."));return"cm_".concat("chain"===r?Object(w.encodeBase58Check)(Object(w.hash)(e.concat([e.from(t.toLowerCase()),E(n)]))):Object(w.encodeBase58Check)(Object(w.hash)(e.concat([Object(w.nameId)(t.toLowerCase()),E(n)]))))}function B(e,t){return t||(t=e.split("_")[0]),I.includes(t)?Object(w.decodeBase64Check)(Object(w.assertedType)(e,t)):Object(w.decodeBase58Check)(Object(w.assertedType)(e,t))}function N(e,t){return"".concat(t,"_").concat(I.includes(t)?Object(w.encodeBase64Check)(e):Object(w.encodeBase58Check)(e))}function R(t){var n=t.slice(0,2),r=j.t[n];if(!r)throw new Error("Id tag for prefix ".concat(n," not found."));return e.from([].concat(b()(Object(O.toBytes)(r)),b()(B(t,n))))}function D(e){var t=e.readUIntBE(0,1),n=j.h[t];if(!n)throw new Error("Prefix for id-tag ".concat(t," not found."));return N(e.slice(1,e.length),n)}function V(e){return Object(O.toBytes)(e,!0)}function F(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:e.from([]);return x()(t.toString("hex"),16).toString(10)}function U(e){return e.map((function(e){return[Object(O.toBytes)(e.key),R(e.id)]}))}function M(e){return e.map((function(e){var t=h()(e,2),n=t[0],r=t[1];return Object.assign({key:n.toString(),id:D(r)})}))}function q(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if((!e||"string"!=typeof e)&&t)throw new Error("AENS: Name must be a string");if(!j.b.includes(y()(e.split(".")))){if(t)throw new Error("AENS: Invalid name domain. Possible domains [".concat(j.b,"]"));return!1}return!0}function L(e){var t={ak:"account_pubkey",ok:"oracle_pubkey",ct:"contract_pubkey",ch:"channel"};if(!e.match(/^[a-z]{2}_.+/))throw Error("Not a valid hash");var n=e.substr(0,2);if(n in t)return t[n];throw Error("Unknown class ".concat(n))}function K(e){var t=e.replace(".chain","").length;return j.l[t>=j.k?j.k:t]}function H(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:j.o,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:j.p;if(Number(n)!==n||n%1==0)throw new Error("Increment must be float. Current increment ".concat(n));if(n<j.p)throw new Error("minimum increment percentage is ".concat(j.p));return Object(k.a)(x()(x()(t).eq(j.o)?K(e):t).times(x()(j.p).plus(1)))}function W(e,t){return p()([[f()(5),s()(j.m[4].plus(t))],[f()(9),s()(j.m[8].plus(t))],[i()(j.k),s()(j.m[12].plus(t))],[a.a,s()(x()(t))]])(e.replace(".chain","").length).toString(10)}t.default={readPointers:M,buildPointers:U,buildContractId:P,readId:D,writeId:R,readInt:F,writeInt:V,encode:N,decode:B,commitmentHash:S,formatSalt:E,oracleQueryId:C,createSalt:T,buildHash:A,isNameValid:q,produceNameId:_,classify:L}}.call(this,n(22).Buffer)},function(e,t,n){"use strict";n.r(t),function(e){n.d(t,"calculateMinFee",(function(){return w})),n.d(t,"calculateFee",(function(){return j})),n.d(t,"validateParams",(function(){return k})),n.d(t,"buildRawTx",(function(){return T})),n.d(t,"unpackRawTx",(function(){return I})),n.d(t,"buildTx",(function(){return P})),n.d(t,"unpackTx",(function(){return A})),n.d(t,"buildTxHash",(function(){return C}));var r=n(13),a=n.n(r),o=n(12),i=n.n(o),c=n(1),s=n.n(c),u=n(6),f=n.n(u),l=n(3),p=n(5),d=n(2),h=n(9),v=n(17),y=n(79);function g(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function b(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?g(n,!0).forEach((function(t){s()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):g(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var m={delta:"delta",block:"block"};function x(e){var t=Object.entries(e).find((function(e){var t=f()(e,1)[0];return["oracleTtl","queryTtl","responseTtl"].includes(t)}))||["",{}],n=f()(t,2)[1].value;return void 0===n?500:n}function w(e,t){var n=t.gas,r=void 0===n?0:n,a=t.params,o=t.vsn,i=Object(l.BigNumber)(1e9);if(!a)return Object(l.BigNumber)(d.f).times(i).toString(10);for(var c=O(e,{params:b({},a,{fee:0}),multiplier:i,gas:r,vsn:o}),s=Object(l.BigNumber)(0);!c.eq(s);)s=c=O(e,{params:b({},a,{fee:c}),multiplier:i,gas:r,vsn:o});return s.toString(10)}function O(e,t){var n=t.params,r=(t.gas,t.multiplier),a=t.vsn,o=P(b({},n),e,{vsn:a}).rlpEncoded.length;return Object(d.x)(e).plus(Object(d.y)(e)({txSize:o,relativeTtl:x(n)})).times(r)}function j(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1?arguments[1]:void 0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=n.gas,a=void 0===r?0:r,o=n.params,i=n.showWarning,c=void 0===i||i,s=n.vsn;!o&&c&&console.warn("Can't build transaction fee, we will use DEFAULT_FEE(".concat(d.f,")"));var u=w(t,{params:o,gas:a,vsn:s});return e&&Object(l.BigNumber)(u).gt(Object(l.BigNumber)(e))&&c&&console.warn("Transaction fee is lower then min fee! Min fee: ".concat(u)),e||u}function k(e,t,n){var r=n.excludeKeys,o=void 0===r?[]:r;return t.filter((function(e){var t=f()(e,1)[0];return!o.includes(t)&&"payload"!==t})).reduce((function(t,n){var r=f()(n,3),o=r[0],i=r[1],c=r[2];return Object.assign(t,function(e,t,n,r){var o=function(e,r){return e?{}:s()({},t,d.C[n](r))};if(null==e)return s()({},t,"Field is required");switch(n){case d.g.int:var i=(!isNaN(e)||l.BigNumber.isBigNumber(e))&&Object(l.BigNumber)(e).lt(0);return o((!isNaN(e)||l.BigNumber.isBigNumber(e))&&Object(l.BigNumber)(e).gte(0),{value:e,isMinusValue:i});case d.g.id:return Array.isArray(r)?o(r.find((function(t){return t===e.split("_")[0]}))&&d.t[e.split("_")[0]],{value:e,prefix:r}):o(Object(p.assertedType)(e,r)&&d.t[e.split("_")[0]]&&e.split("_")[0]===r,{value:e,prefix:r});case d.g.binary:return o(e.split("_")[0]===r,{prefix:r,value:e});case d.g.string:return o(!0);case d.g.ctVersion:return o("object"===a()(e)&&Object.prototype.hasOwnProperty.call(e,"abiVersion")&&Object.prototype.hasOwnProperty.call(e,"vmVersion"));case d.g.pointers:return o(Array.isArray(e)&&!e.find((function(e){return e!==Object(e)})),{value:e});default:return{}}}(e[o],o,i,c))}),{})}function T(t,n){var r=(arguments.length>2&&void 0!==arguments[2]?arguments[2]:{}).excludeKeys,a=void 0===r?[]:r,o=k(t=function(e){return Object.entries(e).reduce((function(e,t){var n=f()(t,2),r=n[0],a=n[1];return e[r]=a,["oracleTtl","queryTtl","responseTtl"].includes(r)&&(e["".concat(r,"Type")]=a.type===m.delta?0:1,e["".concat(r,"Value")]=a.value),e}),{})}(t),n,{excludeKeys:a});if(Object.keys(o).length)throw new Error("Transaction build error. "+JSON.stringify(o));return n.filter((function(e){var t=f()(e,1)[0];return!a.includes(t)})).map((function(n){var r=f()(n,3),a=r[0],o=r[1],c=r[2];return function(t,n,r){switch(n){case d.g.int:return Object(h.writeInt)(t);case d.g.id:return Object(h.writeId)(t);case d.g.ids:return t.map(h.writeId);case d.g.bool:return e.from([t?1:0]);case d.g.binary:return Object(h.decode)(t,r);case d.g.hex:return e.from(t,"hex");case d.g.signatures:return t.map(e.from);case d.g.payload:return"string"==typeof t&&"ba"===t.split("_")[0]?Object(h.decode)(t,"ba"):Object(v.toBytes)(t);case d.g.string:return Object(v.toBytes)(t);case d.g.pointers:return Object(h.buildPointers)(t);case d.g.mptree:return t.map(y.b);case d.g.ctVersion:return e.from([].concat(i()(Object(v.toBytes)(t.vmVersion)),[0],i()(Object(v.toBytes)(t.abiVersion))));case d.g.callReturnType:switch(t){case"ok":return Object(h.writeInt)(0);case"error":return Object(h.writeInt)(1);case"revert":return Object(h.writeInt)(2);default:return t}default:return t}}(t[a],o,c)}))}function I(t,n){return n.reduce((function(n,r,a){var o=f()(r,3),i=o[0],c=o[1],u=o[2];return Object.assign(n,s()({},i,function(t,n,r){if(!t)return"";switch(n){case d.g.ctVersion:var a=f()(t,3),o=a[0],i=a[2];return{vmVersion:Object(h.readInt)(e.from([o])),abiVersion:Object(h.readInt)(e.from([i]))};case d.g.int:return Object(h.readInt)(t);case d.g.id:return Object(h.readId)(t);case d.g.ids:return t.map(h.readId);case d.g.bool:return 1===t[0];case d.g.binary:return Object(h.encode)(t,r);case d.g.string:return t.toString();case d.g.payload:return Object(h.encode)(t,"ba");case d.g.pointers:return Object(h.readPointers)(t);case d.g.rlpBinary:return A(t,!0);case d.g.rlpBinaries:return t.map((function(e){return A(e,!0)}));case d.g.rawBinary:return t;case d.g.hex:return t.toString("hex");case d.g.offChainUpdates:return t.map((function(e){return A(e,!0)}));case d.g.callStack:return[Object(h.readInt)(t)];case d.g.mptree:return t.map(y.a);case d.g.callReturnType:switch(Object(h.readInt)(t)){case"0":return"ok";case"1":return"error";case"2":return"revert";default:return t}case d.g.sophiaCodeTypeInfo:return t.reduce((function(e,t){var n=f()(t,4),r=n[0],a=n[1],o=n[2],i=n[3];return b({},e,s()({},a.toString(),{funHash:r,argType:o,outType:i}))}),{});default:return t}}(t[a],c,u)))}),{})}function P(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=n.excludeKeys,a=void 0===r?[]:r,o=n.prefix,i=void 0===o?"tx":o,c=n.vsn,s=void 0===c?d.E:c;if(!d.z[t])throw new Error("Transaction serialization not implemented for "+t);if(!d.z[t][s])throw new Error("Transaction serialization not implemented for "+t+" version "+s);var u=f()(d.z[t][s],2),l=u[0],v=T(b({},e,{VSN:s,tag:u[1]}),l,{excludeKeys:a}).filter((function(e){return void 0!==e})),y=p.rlp.encode(v);return{tx:Object(h.encode)(y,i),rlpEncoded:y,binary:v,txObject:I(v,l)}}function A(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"tx",r=t?e:Object(h.decode)(e,n),a=p.rlp.decode(r),o=Object(h.readInt)(a[0]);if(!d.w[o])throw new Error("Transaction deserialization not implemented for tag "+o);var i=Object(h.readInt)(a[1]);if(!d.w[o][i])throw new Error("Transaction deserialization not implemented for tag "+o+" version "+i);var c=f()(d.w[o][i],1)[0];return{txType:d.r[o],tx:I(a,c),rlpEncoded:r,binary:a}}function C(e){return"string"==typeof e&&-1!==e.indexOf("tx_")?Object(h.buildHash)("th",A(e).rlpEncoded):Object(h.buildHash)("th",e)}t.default={calculateMinFee:w,calculateFee:j,unpackTx:A,unpackRawTx:I,buildTx:P,buildRawTx:T,validateParams:k,buildTxHash:C}}.call(this,n(22).Buffer)},function(e,t,n){var r=n(15),a=n(57);e.exports=function(e){return function t(n,o){switch(arguments.length){case 0:return t;case 1:return a(n)?t:r((function(t){return e(n,t)}));default:return a(n)&&a(o)?t:a(n)?r((function(t){return e(t,o)})):a(o)?r((function(t){return e(n,t)})):e(n,o)}}}},function(e,t,n){var r=n(140),a=n(90),o=n(141);e.exports=function(e){return r(e)||a(e)||o()}},function(e,t){function n(e){return(n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function r(t){return"function"==typeof Symbol&&"symbol"===n(Symbol.iterator)?e.exports=r=function(e){return n(e)}:e.exports=r=function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":n(e)},r(t)}e.exports=r},function(e,t){e.exports=n},function(e,t,n){var r=n(57);e.exports=function(e){return function t(n){return 0===arguments.length||r(n)?t:e.apply(this,arguments)}}},function(e,t){e.exports=r},function(e,t,n){"use strict";n.r(t),function(e){n.d(t,"leftPad",(function(){return a})),n.d(t,"rightPad",(function(){return o})),n.d(t,"bigNumberToByteArray",(function(){return i})),n.d(t,"toBytes",(function(){return c}));var r=n(3);function a(t,n){var r=t-n.length;if(r>0){var a=new Uint8Array(r);return a.fill(0,r),e.concat([a,n])}return n}function o(t,n){var r=t-n.length;if(r>0){var a=new Uint8Array(r);return a.fill(0,r),e.concat([n,a])}return n}function i(t){var n=t.toString(16);return n.length%2>0&&(n="0"+n),e.from(n,"hex")}function c(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(void 0!==e){if(Number.isInteger(e)||r.BigNumber.isBigNumber(e)||t)return r.BigNumber.isBigNumber(e)||(e=Object(r.BigNumber)(e)),i(e);if("string"==typeof e)return e.toString("utf-8");throw new Error("Byte serialization not supported")}}}.call(this,n(22).Buffer)},function(e,t){e.exports=a},function(e,t,n){"use strict";n.d(t,"c",(function(){return c})),n.d(t,"b",(function(){return s})),n.d(t,"a",(function(){return u}));var r=n(116),a=n.n(r),o=n(80),i=n.n(o);function c(e){return e.replace(/_./g,(function(e){return i()(e[1])}))}function s(e){return e.replace(/[A-Z]/g,(function(e){return"_".concat(a()(e))}))}function u(e){return!(e.length%2!=0||!e.match(/^[0-9a-f]+$/i))}},function(e,t,n){"use strict";var r=n(0),a=n.n(r),o=n(1),i=n.n(o),c=n(4),s=n.n(c),u=n(14),f=n.n(u),l=n(42),p=n(43),d=n(25),h=n(10),v=n(3),y=n(5),g=n(9);function b(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function m(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?b(n,!0).forEach((function(t){i()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):b(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var x=f()(l.a,d.a,p.a,{methods:{send:function(e){var t,n,r,o,i,c,u=arguments;return a.a.async((function(f){for(;;)switch(f.prev=f.next){case 0:return t=u.length>1&&void 0!==u[1]?u[1]:{},n=s()(this.Ae.defaults,t),f.t0=a.a,f.t1=this,f.next=6,a.a.awrap(this.address(n));case 6:return f.t2=f.sent,f.t3=f.t1.getAccount.call(f.t1,f.t2),f.next=10,f.t0.awrap.call(f.t0,f.t3);case 10:if(r=f.sent,o=r.contractId,i=r.authFun,!o){f.next=19;break}return f.next=16,a.a.awrap(this.signUsingGA(e,m({},n,{authFun:i})));case 16:f.t4=f.sent,f.next=22;break;case 19:return f.next=21,a.a.awrap(this.signTransaction(e,n));case 21:f.t4=f.sent;case 22:return c=f.t4,f.abrupt("return",this.sendTransaction(c,n));case 24:case"end":return f.stop()}}),null,this)},spend:function(e,t){var n,r,o,i=arguments;return a.a.async((function(c){for(;;)switch(c.prev=c.next){case 0:return n=i.length>2&&void 0!==i[2]?i[2]:{},r=s()(this.Ae.defaults,n),c.next=4,a.a.awrap(this.resolveRecipientName(t,n));case 4:return t=c.sent,c.t0=a.a,c.t1=this,c.t2=s.a,c.t3=r,c.next=11,a.a.awrap(this.address(r));case 11:return c.t4=c.sent,c.t5=t,c.t6=e,c.t7={senderId:c.t4,recipientId:c.t5,amount:c.t6},c.t8=(0,c.t2)(c.t3,c.t7),c.t9=c.t1.spendTx.call(c.t1,c.t8),c.next=19,c.t0.awrap.call(c.t0,c.t9);case 19:return o=c.sent,c.abrupt("return",this.send(o,r));case 21:case"end":return c.stop()}}),null,this)},transferFunds:function(e,t){var n,r,o,i,c,u,f,l=arguments;return a.a.async((function(p){for(;;)switch(p.prev=p.next){case 0:if(n=l.length>2&&void 0!==l[2]?l[2]:{excludeFee:!1},!(e<0||e>1)){p.next=3;break}throw new Error("Percentage should be a number between 0 and 1, got ".concat(e));case 3:return r=s()(this.Ae.defaults,n),p.t0=v.BigNumber,p.t1=a.a,p.t2=this,p.next=9,a.a.awrap(this.address());case 9:return p.t3=p.sent,p.t4=p.t2.balance.call(p.t2,p.t3),p.next=13,p.t1.awrap.call(p.t1,p.t4);case 13:return p.t5=p.sent,p.t6=e,o=(0,p.t0)(p.t5).times(p.t6),p.t7=a.a,p.t8=this,p.t9=s.a,p.t10=r,p.next=22,a.a.awrap(this.address());case 22:return p.t11=p.sent,p.t12=t,p.t13=o,p.t14={senderId:p.t11,recipientId:p.t12,amount:p.t13},p.t15=(0,p.t9)(p.t10,p.t14),p.t16=p.t8.spendTx.call(p.t8,p.t15),p.next=30,p.t7.awrap.call(p.t7,p.t16);case 30:if(i=p.sent,c=h.default.unpackTx(i),u=c.tx,f=o,!n.excludeFee)for(;f.plus(u.fee).gt(o);)f=o.minus(u.fee);return p.t17=a.a,p.t18=this,p.t19=s.a,p.t20=r,p.next=40,a.a.awrap(this.address());case 40:return p.t21=p.sent,p.t22=t,p.t23=f,p.t24={senderId:p.t21,recipientId:p.t22,amount:p.t23},p.t25=(0,p.t19)(p.t20,p.t24),p.t26=p.t18.spendTx.call(p.t18,p.t25),p.next=48,p.t17.awrap.call(p.t17,p.t26);case 48:return i=p.sent,p.abrupt("return",this.send(i,r));case 50:case"end":return p.stop()}}),null,this)},destroyInstance:function(){var e=this;["destroyClient","destroyServer"].forEach((function(t){return e[t]&&"function"==typeof e[t]&&e[t]()}))},resolveRecipientName:function(e,t){var n,r,o;return a.a.async((function(i){for(;;)switch(i.prev=i.next){case 0:if(n=t.verify,r=void 0!==n&&n,!Object(y.isAddressValid)(e)){i.next=3;break}return i.abrupt("return",e);case 3:if(!Object(g.isNameValid)(e)){i.next=12;break}if(!r){i.next=11;break}return i.next=7,a.a.awrap(this.getName(e));case 7:if(o=i.sent,o.pointers.find((function(e){return"ak"===e.id.split("_")[0]}))){i.next=11;break}throw new Error("Name ".concat(e," do not have pointers for account"));case 11:return i.abrupt("return",Object(g.produceNameId)(e));case 12:throw new Error("Invalid recipient name or address: "+e);case 13:case"end":return i.stop()}}),null,this)},signUsingGA:function(e){var t,n,r,o=arguments;return a.a.async((function(a){for(;;)switch(a.prev=a.next){case 0:return t=o.length>1&&void 0!==o[1]?o[1]:{},n=t.authData,r=t.authFun,a.abrupt("return",this.createMetaTx(e,n,r,t));case 3:case"end":return a.stop()}}),null,this)}},deepProps:{Ae:{defaults:{}}},deepConfiguration:{Ae:{methods:["signUsingGA"]}}});t.a=x},function(e,t,n){"use strict";var r=n(24),a=n.n(r),o=n(65),i=n.n(o),c=n(115),s=n.n(c),u=n(114),f=n.n(u),l=n(113),p=n.n(l),d=n(0),h=n.n(d),v=n(14);function y(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1?arguments[1]:void 0,n=t.stamp,r=t.args,a=t.instance;return n.compose.deepConfiguration.AsyncInit.initializers.reduce((function(t,a){var o;return h.a.async((function(i){for(;;)switch(i.prev=i.next){case 0:return i.next=2,h.a.awrap(Promise.resolve(t));case 2:if(t=i.sent,"function"!=typeof a){i.next=8;break}return i.next=6,h.a.awrap(Promise.resolve(a.call(t,e,{stamp:n,args:r,instance:t})));case 6:return o=i.sent,i.abrupt("return",void 0===o?t:o);case 8:return i.abrupt("return",t);case 9:case"end":return i.stop()}}))}),a)}var g=n.n(v)()({deepConf:{AsyncInit:{initializers:[]}},composers:function(e){var t=e.stamp,n=e.composables;t.compose.deepConfiguration.AsyncInit.initializers=p()([y],f()(s.a,i()(n.map((function(e){return a()(["compose","deepConfiguration","AsyncInit","initializers"],e)||(e.compose||e).initializers||[]}))))),t.compose.initializers=[y]}});t.a=g},function(e,t,n){"use strict";(function(e){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var r=n(135),a=n(136),o=n(137);function i(){return s.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function c(e,t){if(i()<t)throw new RangeError("Invalid typed array length");return s.TYPED_ARRAY_SUPPORT?(e=new Uint8Array(t)).__proto__=s.prototype:(null===e&&(e=new s(t)),e.length=t),e}function s(e,t,n){if(!(s.TYPED_ARRAY_SUPPORT||this instanceof s))return new s(e,t,n);if("number"==typeof e){if("string"==typeof t)throw new Error("If encoding is specified then the first argument must be a string");return l(this,e)}return u(this,e,t,n)}function u(e,t,n,r){if("number"==typeof t)throw new TypeError('"value" argument must not be a number');return"undefined"!=typeof ArrayBuffer&&t instanceof ArrayBuffer?function(e,t,n,r){if(t.byteLength,n<0||t.byteLength<n)throw new RangeError("'offset' is out of bounds");if(t.byteLength<n+(r||0))throw new RangeError("'length' is out of bounds");t=void 0===n&&void 0===r?new Uint8Array(t):void 0===r?new Uint8Array(t,n):new Uint8Array(t,n,r);s.TYPED_ARRAY_SUPPORT?(e=t).__proto__=s.prototype:e=p(e,t);return e}(e,t,n,r):"string"==typeof t?function(e,t,n){"string"==typeof n&&""!==n||(n="utf8");if(!s.isEncoding(n))throw new TypeError('"encoding" must be a valid string encoding');var r=0|h(t,n),a=(e=c(e,r)).write(t,n);a!==r&&(e=e.slice(0,a));return e}(e,t,n):function(e,t){if(s.isBuffer(t)){var n=0|d(t.length);return 0===(e=c(e,n)).length?e:(t.copy(e,0,0,n),e)}if(t){if("undefined"!=typeof ArrayBuffer&&t.buffer instanceof ArrayBuffer||"length"in t)return"number"!=typeof t.length||(r=t.length)!=r?c(e,0):p(e,t);if("Buffer"===t.type&&o(t.data))return p(e,t.data)}var r;throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}(e,t)}function f(e){if("number"!=typeof e)throw new TypeError('"size" argument must be a number');if(e<0)throw new RangeError('"size" argument must not be negative')}function l(e,t){if(f(t),e=c(e,t<0?0:0|d(t)),!s.TYPED_ARRAY_SUPPORT)for(var n=0;n<t;++n)e[n]=0;return e}function p(e,t){var n=t.length<0?0:0|d(t.length);e=c(e,n);for(var r=0;r<n;r+=1)e[r]=255&t[r];return e}function d(e){if(e>=i())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+i().toString(16)+" bytes");return 0|e}function h(e,t){if(s.isBuffer(e))return e.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(e)||e instanceof ArrayBuffer))return e.byteLength;"string"!=typeof e&&(e=""+e);var n=e.length;if(0===n)return 0;for(var r=!1;;)switch(t){case"ascii":case"latin1":case"binary":return n;case"utf8":case"utf-8":case void 0:return q(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*n;case"hex":return n>>>1;case"base64":return L(e).length;default:if(r)return q(e).length;t=(""+t).toLowerCase(),r=!0}}function v(e,t,n){var r=!1;if((void 0===t||t<0)&&(t=0),t>this.length)return"";if((void 0===n||n>this.length)&&(n=this.length),n<=0)return"";if((n>>>=0)<=(t>>>=0))return"";for(e||(e="utf8");;)switch(e){case"hex":return E(this,t,n);case"utf8":case"utf-8":return I(this,t,n);case"ascii":return A(this,t,n);case"latin1":case"binary":return C(this,t,n);case"base64":return T(this,t,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return _(this,t,n);default:if(r)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase(),r=!0}}function y(e,t,n){var r=e[t];e[t]=e[n],e[n]=r}function g(e,t,n,r,a){if(0===e.length)return-1;if("string"==typeof n?(r=n,n=0):n>2147483647?n=2147483647:n<-2147483648&&(n=-2147483648),n=+n,isNaN(n)&&(n=a?0:e.length-1),n<0&&(n=e.length+n),n>=e.length){if(a)return-1;n=e.length-1}else if(n<0){if(!a)return-1;n=0}if("string"==typeof t&&(t=s.from(t,r)),s.isBuffer(t))return 0===t.length?-1:b(e,t,n,r,a);if("number"==typeof t)return t&=255,s.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?a?Uint8Array.prototype.indexOf.call(e,t,n):Uint8Array.prototype.lastIndexOf.call(e,t,n):b(e,[t],n,r,a);throw new TypeError("val must be string, number or Buffer")}function b(e,t,n,r,a){var o,i=1,c=e.length,s=t.length;if(void 0!==r&&("ucs2"===(r=String(r).toLowerCase())||"ucs-2"===r||"utf16le"===r||"utf-16le"===r)){if(e.length<2||t.length<2)return-1;i=2,c/=2,s/=2,n/=2}function u(e,t){return 1===i?e[t]:e.readUInt16BE(t*i)}if(a){var f=-1;for(o=n;o<c;o++)if(u(e,o)===u(t,-1===f?0:o-f)){if(-1===f&&(f=o),o-f+1===s)return f*i}else-1!==f&&(o-=o-f),f=-1}else for(n+s>c&&(n=c-s),o=n;o>=0;o--){for(var l=!0,p=0;p<s;p++)if(u(e,o+p)!==u(t,p)){l=!1;break}if(l)return o}return-1}function m(e,t,n,r){n=Number(n)||0;var a=e.length-n;r?(r=Number(r))>a&&(r=a):r=a;var o=t.length;if(o%2!=0)throw new TypeError("Invalid hex string");r>o/2&&(r=o/2);for(var i=0;i<r;++i){var c=parseInt(t.substr(2*i,2),16);if(isNaN(c))return i;e[n+i]=c}return i}function x(e,t,n,r){return K(q(t,e.length-n),e,n,r)}function w(e,t,n,r){return K(function(e){for(var t=[],n=0;n<e.length;++n)t.push(255&e.charCodeAt(n));return t}(t),e,n,r)}function O(e,t,n,r){return w(e,t,n,r)}function j(e,t,n,r){return K(L(t),e,n,r)}function k(e,t,n,r){return K(function(e,t){for(var n,r,a,o=[],i=0;i<e.length&&!((t-=2)<0);++i)n=e.charCodeAt(i),r=n>>8,a=n%256,o.push(a),o.push(r);return o}(t,e.length-n),e,n,r)}function T(e,t,n){return 0===t&&n===e.length?r.fromByteArray(e):r.fromByteArray(e.slice(t,n))}function I(e,t,n){n=Math.min(e.length,n);for(var r=[],a=t;a<n;){var o,i,c,s,u=e[a],f=null,l=u>239?4:u>223?3:u>191?2:1;if(a+l<=n)switch(l){case 1:u<128&&(f=u);break;case 2:128==(192&(o=e[a+1]))&&(s=(31&u)<<6|63&o)>127&&(f=s);break;case 3:o=e[a+1],i=e[a+2],128==(192&o)&&128==(192&i)&&(s=(15&u)<<12|(63&o)<<6|63&i)>2047&&(s<55296||s>57343)&&(f=s);break;case 4:o=e[a+1],i=e[a+2],c=e[a+3],128==(192&o)&&128==(192&i)&&128==(192&c)&&(s=(15&u)<<18|(63&o)<<12|(63&i)<<6|63&c)>65535&&s<1114112&&(f=s)}null===f?(f=65533,l=1):f>65535&&(f-=65536,r.push(f>>>10&1023|55296),f=56320|1023&f),r.push(f),a+=l}return function(e){var t=e.length;if(t<=P)return String.fromCharCode.apply(String,e);var n="",r=0;for(;r<t;)n+=String.fromCharCode.apply(String,e.slice(r,r+=P));return n}(r)}t.Buffer=s,t.SlowBuffer=function(e){+e!=e&&(e=0);return s.alloc(+e)},t.INSPECT_MAX_BYTES=50,s.TYPED_ARRAY_SUPPORT=void 0!==e.TYPED_ARRAY_SUPPORT?e.TYPED_ARRAY_SUPPORT:function(){try{var e=new Uint8Array(1);return e.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===e.foo()&&"function"==typeof e.subarray&&0===e.subarray(1,1).byteLength}catch(e){return!1}}(),t.kMaxLength=i(),s.poolSize=8192,s._augment=function(e){return e.__proto__=s.prototype,e},s.from=function(e,t,n){return u(null,e,t,n)},s.TYPED_ARRAY_SUPPORT&&(s.prototype.__proto__=Uint8Array.prototype,s.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&s[Symbol.species]===s&&Object.defineProperty(s,Symbol.species,{value:null,configurable:!0})),s.alloc=function(e,t,n){return function(e,t,n,r){return f(t),t<=0?c(e,t):void 0!==n?"string"==typeof r?c(e,t).fill(n,r):c(e,t).fill(n):c(e,t)}(null,e,t,n)},s.allocUnsafe=function(e){return l(null,e)},s.allocUnsafeSlow=function(e){return l(null,e)},s.isBuffer=function(e){return!(null==e||!e._isBuffer)},s.compare=function(e,t){if(!s.isBuffer(e)||!s.isBuffer(t))throw new TypeError("Arguments must be Buffers");if(e===t)return 0;for(var n=e.length,r=t.length,a=0,o=Math.min(n,r);a<o;++a)if(e[a]!==t[a]){n=e[a],r=t[a];break}return n<r?-1:r<n?1:0},s.isEncoding=function(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},s.concat=function(e,t){if(!o(e))throw new TypeError('"list" argument must be an Array of Buffers');if(0===e.length)return s.alloc(0);var n;if(void 0===t)for(t=0,n=0;n<e.length;++n)t+=e[n].length;var r=s.allocUnsafe(t),a=0;for(n=0;n<e.length;++n){var i=e[n];if(!s.isBuffer(i))throw new TypeError('"list" argument must be an Array of Buffers');i.copy(r,a),a+=i.length}return r},s.byteLength=h,s.prototype._isBuffer=!0,s.prototype.swap16=function(){var e=this.length;if(e%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var t=0;t<e;t+=2)y(this,t,t+1);return this},s.prototype.swap32=function(){var e=this.length;if(e%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var t=0;t<e;t+=4)y(this,t,t+3),y(this,t+1,t+2);return this},s.prototype.swap64=function(){var e=this.length;if(e%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var t=0;t<e;t+=8)y(this,t,t+7),y(this,t+1,t+6),y(this,t+2,t+5),y(this,t+3,t+4);return this},s.prototype.toString=function(){var e=0|this.length;return 0===e?"":0===arguments.length?I(this,0,e):v.apply(this,arguments)},s.prototype.equals=function(e){if(!s.isBuffer(e))throw new TypeError("Argument must be a Buffer");return this===e||0===s.compare(this,e)},s.prototype.inspect=function(){var e="",n=t.INSPECT_MAX_BYTES;return this.length>0&&(e=this.toString("hex",0,n).match(/.{2}/g).join(" "),this.length>n&&(e+=" ... ")),"<Buffer "+e+">"},s.prototype.compare=function(e,t,n,r,a){if(!s.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(void 0===t&&(t=0),void 0===n&&(n=e?e.length:0),void 0===r&&(r=0),void 0===a&&(a=this.length),t<0||n>e.length||r<0||a>this.length)throw new RangeError("out of range index");if(r>=a&&t>=n)return 0;if(r>=a)return-1;if(t>=n)return 1;if(this===e)return 0;for(var o=(a>>>=0)-(r>>>=0),i=(n>>>=0)-(t>>>=0),c=Math.min(o,i),u=this.slice(r,a),f=e.slice(t,n),l=0;l<c;++l)if(u[l]!==f[l]){o=u[l],i=f[l];break}return o<i?-1:i<o?1:0},s.prototype.includes=function(e,t,n){return-1!==this.indexOf(e,t,n)},s.prototype.indexOf=function(e,t,n){return g(this,e,t,n,!0)},s.prototype.lastIndexOf=function(e,t,n){return g(this,e,t,n,!1)},s.prototype.write=function(e,t,n,r){if(void 0===t)r="utf8",n=this.length,t=0;else if(void 0===n&&"string"==typeof t)r=t,n=this.length,t=0;else{if(!isFinite(t))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");t|=0,isFinite(n)?(n|=0,void 0===r&&(r="utf8")):(r=n,n=void 0)}var a=this.length-t;if((void 0===n||n>a)&&(n=a),e.length>0&&(n<0||t<0)||t>this.length)throw new RangeError("Attempt to write outside buffer bounds");r||(r="utf8");for(var o=!1;;)switch(r){case"hex":return m(this,e,t,n);case"utf8":case"utf-8":return x(this,e,t,n);case"ascii":return w(this,e,t,n);case"latin1":case"binary":return O(this,e,t,n);case"base64":return j(this,e,t,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return k(this,e,t,n);default:if(o)throw new TypeError("Unknown encoding: "+r);r=(""+r).toLowerCase(),o=!0}},s.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var P=4096;function A(e,t,n){var r="";n=Math.min(e.length,n);for(var a=t;a<n;++a)r+=String.fromCharCode(127&e[a]);return r}function C(e,t,n){var r="";n=Math.min(e.length,n);for(var a=t;a<n;++a)r+=String.fromCharCode(e[a]);return r}function E(e,t,n){var r=e.length;(!t||t<0)&&(t=0),(!n||n<0||n>r)&&(n=r);for(var a="",o=t;o<n;++o)a+=M(e[o]);return a}function _(e,t,n){for(var r=e.slice(t,n),a="",o=0;o<r.length;o+=2)a+=String.fromCharCode(r[o]+256*r[o+1]);return a}function S(e,t,n){if(e%1!=0||e<0)throw new RangeError("offset is not uint");if(e+t>n)throw new RangeError("Trying to access beyond buffer length")}function B(e,t,n,r,a,o){if(!s.isBuffer(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(t>a||t<o)throw new RangeError('"value" argument is out of bounds');if(n+r>e.length)throw new RangeError("Index out of range")}function N(e,t,n,r){t<0&&(t=65535+t+1);for(var a=0,o=Math.min(e.length-n,2);a<o;++a)e[n+a]=(t&255<<8*(r?a:1-a))>>>8*(r?a:1-a)}function R(e,t,n,r){t<0&&(t=4294967295+t+1);for(var a=0,o=Math.min(e.length-n,4);a<o;++a)e[n+a]=t>>>8*(r?a:3-a)&255}function D(e,t,n,r,a,o){if(n+r>e.length)throw new RangeError("Index out of range");if(n<0)throw new RangeError("Index out of range")}function V(e,t,n,r,o){return o||D(e,0,n,4),a.write(e,t,n,r,23,4),n+4}function F(e,t,n,r,o){return o||D(e,0,n,8),a.write(e,t,n,r,52,8),n+8}s.prototype.slice=function(e,t){var n,r=this.length;if((e=~~e)<0?(e+=r)<0&&(e=0):e>r&&(e=r),(t=void 0===t?r:~~t)<0?(t+=r)<0&&(t=0):t>r&&(t=r),t<e&&(t=e),s.TYPED_ARRAY_SUPPORT)(n=this.subarray(e,t)).__proto__=s.prototype;else{var a=t-e;n=new s(a,void 0);for(var o=0;o<a;++o)n[o]=this[o+e]}return n},s.prototype.readUIntLE=function(e,t,n){e|=0,t|=0,n||S(e,t,this.length);for(var r=this[e],a=1,o=0;++o<t&&(a*=256);)r+=this[e+o]*a;return r},s.prototype.readUIntBE=function(e,t,n){e|=0,t|=0,n||S(e,t,this.length);for(var r=this[e+--t],a=1;t>0&&(a*=256);)r+=this[e+--t]*a;return r},s.prototype.readUInt8=function(e,t){return t||S(e,1,this.length),this[e]},s.prototype.readUInt16LE=function(e,t){return t||S(e,2,this.length),this[e]|this[e+1]<<8},s.prototype.readUInt16BE=function(e,t){return t||S(e,2,this.length),this[e]<<8|this[e+1]},s.prototype.readUInt32LE=function(e,t){return t||S(e,4,this.length),(this[e]|this[e+1]<<8|this[e+2]<<16)+16777216*this[e+3]},s.prototype.readUInt32BE=function(e,t){return t||S(e,4,this.length),16777216*this[e]+(this[e+1]<<16|this[e+2]<<8|this[e+3])},s.prototype.readIntLE=function(e,t,n){e|=0,t|=0,n||S(e,t,this.length);for(var r=this[e],a=1,o=0;++o<t&&(a*=256);)r+=this[e+o]*a;return r>=(a*=128)&&(r-=Math.pow(2,8*t)),r},s.prototype.readIntBE=function(e,t,n){e|=0,t|=0,n||S(e,t,this.length);for(var r=t,a=1,o=this[e+--r];r>0&&(a*=256);)o+=this[e+--r]*a;return o>=(a*=128)&&(o-=Math.pow(2,8*t)),o},s.prototype.readInt8=function(e,t){return t||S(e,1,this.length),128&this[e]?-1*(255-this[e]+1):this[e]},s.prototype.readInt16LE=function(e,t){t||S(e,2,this.length);var n=this[e]|this[e+1]<<8;return 32768&n?4294901760|n:n},s.prototype.readInt16BE=function(e,t){t||S(e,2,this.length);var n=this[e+1]|this[e]<<8;return 32768&n?4294901760|n:n},s.prototype.readInt32LE=function(e,t){return t||S(e,4,this.length),this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24},s.prototype.readInt32BE=function(e,t){return t||S(e,4,this.length),this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]},s.prototype.readFloatLE=function(e,t){return t||S(e,4,this.length),a.read(this,e,!0,23,4)},s.prototype.readFloatBE=function(e,t){return t||S(e,4,this.length),a.read(this,e,!1,23,4)},s.prototype.readDoubleLE=function(e,t){return t||S(e,8,this.length),a.read(this,e,!0,52,8)},s.prototype.readDoubleBE=function(e,t){return t||S(e,8,this.length),a.read(this,e,!1,52,8)},s.prototype.writeUIntLE=function(e,t,n,r){(e=+e,t|=0,n|=0,r)||B(this,e,t,n,Math.pow(2,8*n)-1,0);var a=1,o=0;for(this[t]=255&e;++o<n&&(a*=256);)this[t+o]=e/a&255;return t+n},s.prototype.writeUIntBE=function(e,t,n,r){(e=+e,t|=0,n|=0,r)||B(this,e,t,n,Math.pow(2,8*n)-1,0);var a=n-1,o=1;for(this[t+a]=255&e;--a>=0&&(o*=256);)this[t+a]=e/o&255;return t+n},s.prototype.writeUInt8=function(e,t,n){return e=+e,t|=0,n||B(this,e,t,1,255,0),s.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),this[t]=255&e,t+1},s.prototype.writeUInt16LE=function(e,t,n){return e=+e,t|=0,n||B(this,e,t,2,65535,0),s.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):N(this,e,t,!0),t+2},s.prototype.writeUInt16BE=function(e,t,n){return e=+e,t|=0,n||B(this,e,t,2,65535,0),s.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):N(this,e,t,!1),t+2},s.prototype.writeUInt32LE=function(e,t,n){return e=+e,t|=0,n||B(this,e,t,4,4294967295,0),s.TYPED_ARRAY_SUPPORT?(this[t+3]=e>>>24,this[t+2]=e>>>16,this[t+1]=e>>>8,this[t]=255&e):R(this,e,t,!0),t+4},s.prototype.writeUInt32BE=function(e,t,n){return e=+e,t|=0,n||B(this,e,t,4,4294967295,0),s.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):R(this,e,t,!1),t+4},s.prototype.writeIntLE=function(e,t,n,r){if(e=+e,t|=0,!r){var a=Math.pow(2,8*n-1);B(this,e,t,n,a-1,-a)}var o=0,i=1,c=0;for(this[t]=255&e;++o<n&&(i*=256);)e<0&&0===c&&0!==this[t+o-1]&&(c=1),this[t+o]=(e/i>>0)-c&255;return t+n},s.prototype.writeIntBE=function(e,t,n,r){if(e=+e,t|=0,!r){var a=Math.pow(2,8*n-1);B(this,e,t,n,a-1,-a)}var o=n-1,i=1,c=0;for(this[t+o]=255&e;--o>=0&&(i*=256);)e<0&&0===c&&0!==this[t+o+1]&&(c=1),this[t+o]=(e/i>>0)-c&255;return t+n},s.prototype.writeInt8=function(e,t,n){return e=+e,t|=0,n||B(this,e,t,1,127,-128),s.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),e<0&&(e=255+e+1),this[t]=255&e,t+1},s.prototype.writeInt16LE=function(e,t,n){return e=+e,t|=0,n||B(this,e,t,2,32767,-32768),s.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):N(this,e,t,!0),t+2},s.prototype.writeInt16BE=function(e,t,n){return e=+e,t|=0,n||B(this,e,t,2,32767,-32768),s.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):N(this,e,t,!1),t+2},s.prototype.writeInt32LE=function(e,t,n){return e=+e,t|=0,n||B(this,e,t,4,2147483647,-2147483648),s.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8,this[t+2]=e>>>16,this[t+3]=e>>>24):R(this,e,t,!0),t+4},s.prototype.writeInt32BE=function(e,t,n){return e=+e,t|=0,n||B(this,e,t,4,2147483647,-2147483648),e<0&&(e=4294967295+e+1),s.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):R(this,e,t,!1),t+4},s.prototype.writeFloatLE=function(e,t,n){return V(this,e,t,!0,n)},s.prototype.writeFloatBE=function(e,t,n){return V(this,e,t,!1,n)},s.prototype.writeDoubleLE=function(e,t,n){return F(this,e,t,!0,n)},s.prototype.writeDoubleBE=function(e,t,n){return F(this,e,t,!1,n)},s.prototype.copy=function(e,t,n,r){if(n||(n=0),r||0===r||(r=this.length),t>=e.length&&(t=e.length),t||(t=0),r>0&&r<n&&(r=n),r===n)return 0;if(0===e.length||0===this.length)return 0;if(t<0)throw new RangeError("targetStart out of bounds");if(n<0||n>=this.length)throw new RangeError("sourceStart out of bounds");if(r<0)throw new RangeError("sourceEnd out of bounds");r>this.length&&(r=this.length),e.length-t<r-n&&(r=e.length-t+n);var a,o=r-n;if(this===e&&n<t&&t<r)for(a=o-1;a>=0;--a)e[a+t]=this[a+n];else if(o<1e3||!s.TYPED_ARRAY_SUPPORT)for(a=0;a<o;++a)e[a+t]=this[a+n];else Uint8Array.prototype.set.call(e,this.subarray(n,n+o),t);return o},s.prototype.fill=function(e,t,n,r){if("string"==typeof e){if("string"==typeof t?(r=t,t=0,n=this.length):"string"==typeof n&&(r=n,n=this.length),1===e.length){var a=e.charCodeAt(0);a<256&&(e=a)}if(void 0!==r&&"string"!=typeof r)throw new TypeError("encoding must be a string");if("string"==typeof r&&!s.isEncoding(r))throw new TypeError("Unknown encoding: "+r)}else"number"==typeof e&&(e&=255);if(t<0||this.length<t||this.length<n)throw new RangeError("Out of range index");if(n<=t)return this;var o;if(t>>>=0,n=void 0===n?this.length:n>>>0,e||(e=0),"number"==typeof e)for(o=t;o<n;++o)this[o]=e;else{var i=s.isBuffer(e)?e:q(new s(e,r).toString()),c=i.length;for(o=0;o<n-t;++o)this[o+t]=i[o%c]}return this};var U=/[^+\/0-9A-Za-z-_]/g;function M(e){return e<16?"0"+e.toString(16):e.toString(16)}function q(e,t){var n;t=t||1/0;for(var r=e.length,a=null,o=[],i=0;i<r;++i){if((n=e.charCodeAt(i))>55295&&n<57344){if(!a){if(n>56319){(t-=3)>-1&&o.push(239,191,189);continue}if(i+1===r){(t-=3)>-1&&o.push(239,191,189);continue}a=n;continue}if(n<56320){(t-=3)>-1&&o.push(239,191,189),a=n;continue}n=65536+(a-55296<<10|n-56320)}else a&&(t-=3)>-1&&o.push(239,191,189);if(a=null,n<128){if((t-=1)<0)break;o.push(n)}else if(n<2048){if((t-=2)<0)break;o.push(n>>6|192,63&n|128)}else if(n<65536){if((t-=3)<0)break;o.push(n>>12|224,n>>6&63|128,63&n|128)}else{if(!(n<1114112))throw new Error("Invalid code point");if((t-=4)<0)break;o.push(n>>18|240,n>>12&63|128,n>>6&63|128,63&n|128)}}return o}function L(e){return r.toByteArray(function(e){if((e=function(e){return e.trim?e.trim():e.replace(/^\s+|\s+$/g,"")}(e).replace(U,"")).length<2)return"";for(;e.length%4!=0;)e+="=";return e}(e))}function K(e,t,n,r){for(var a=0;a<r&&!(a+n>=t.length||a>=e.length);++a)t[a+n]=e[a];return a}}).call(this,n(134))},function(e,t,n){var r=n(15),a=n(32),o=n(146),i=!{toString:null}.propertyIsEnumerable("toString"),c=["constructor","valueOf","isPrototypeOf","toString","propertyIsEnumerable","hasOwnProperty","toLocaleString"],s=function(){"use strict";return arguments.propertyIsEnumerable("length")}(),u=function(e,t){for(var n=0;n<e.length;){if(e[n]===t)return!0;n+=1}return!1},f="function"!=typeof Object.keys||s?r((function(e){if(Object(e)!==e)return[];var t,n,r=[],f=s&&o(e);for(t in e)!a(t,e)||f&&"length"===t||(r[r.length]=t);if(i)for(n=c.length-1;n>=0;)a(t=c[n],e)&&!u(r,t)&&(r[r.length]=t),n-=1;return r})):r((function(e){return Object(e)!==e?[]:Object.keys(e)}));e.exports=f},function(e,t,n){var r=n(11)((function(e,t){for(var n=t,r=0;r<e.length;){if(null==n)return;n=n[e[r]],r+=1}return n}));e.exports=r},function(e,t,n){"use strict";(function(e){var r=n(0),a=n.n(r),o=n(14),i=n.n(o),c=n(7),s=n(5),u=n(10),f=n(2),l="ae_mainnet";var p=i()({init:function(e){var t=e.networkId;!this.networkId&&t&&(this.networkId=t)},methods:{signTransaction:function(t){var n,r,o,i,c,l=arguments;return a.a.async((function(p){for(;;)switch(p.prev=p.next){case 0:return n=l.length>1&&void 0!==l[1]?l[1]:{},r=this.getNetworkId(),o=s.decodeBase64Check(s.assertedType(t,"tx")),i=e.concat([e.from(r),o]),p.next=6,a.a.awrap(this.sign(i,n));case 6:return p.t0=p.sent,c=[p.t0],p.abrupt("return",Object(u.buildTx)({encodedTx:o,signatures:c},f.B.signed).tx);case 9:case"end":return p.stop()}}),null,this)},getNetworkId:function(){return this.networkId||!!this.selectedNode&&this.selectedNode.networkId||l}},deepConf:{Ae:{methods:["sign","address","signTransaction","getNetworkId"]}}},Object(c.required)({methods:{sign:c.required,address:c.required}}));t.a=p}).call(this,n(22).Buffer)},function(e,t,n){"use strict";(function(e){n.d(t,"a",(function(){return O}));var r=n(6),a=n.n(r),o=n(1),i=n.n(o),c=n(4),s=n.n(c),u=n(0),f=n.n(u),l=n(20),p=n(5),d=n(64),h=n(45),v=n(62),y=n(3),g=n.n(y),b=n(27);function m(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function x(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?m(n,!0).forEach((function(t){i()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):m(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function w(e,t){return function(n,r){var a,o,i,c;return f.a.async((function(s){for(;;)switch(s.prev=s.next){case 0:return s.next=2,f.a.awrap(this.send(e,t));case 2:return a=s.sent,o=a.hash,i=a.rawTx,s.next=7,f.a.awrap(this.getTxInfo(o));case 7:return c=s.sent,s.abrupt("return","ok"===c.returnType?n({hash:o,rawTx:i,result:c}):"function"==typeof r?r(c):this.handleCallError(c));case 9:case"end":return s.stop()}}),null,this)}}var O=l.a.compose(h.a,v.a,{methods:{contractCompile:function(e){var t,n,r,a=this,o=arguments;return f.a.async((function(i){for(;;)switch(i.prev=i.next){case 0:return t=o.length>1&&void 0!==o[1]?o[1]:{},n=s()(this.Ae.defaults,t),i.next=4,f.a.awrap(this.compileContractAPI(e,t));case 4:return r=i.sent,i.abrupt("return",Object.freeze(Object.assign({encodeCall:function(r,o){return f.a.async((function(i){for(;;)switch(i.prev=i.next){case 0:return i.abrupt("return",a.contractEncodeCall(e,r,o,s()(n,t)));case 1:case"end":return i.stop()}}))},deploy:function(t){var o,i=arguments;return f.a.async((function(c){for(;;)switch(c.prev=c.next){case 0:return o=i.length>1&&void 0!==i[1]?i[1]:{},c.abrupt("return",a.contractDeploy(r,e,t,s()(n,o)));case 2:case"end":return c.stop()}}))},deployStatic:function(t){var o,i=arguments;return f.a.async((function(c){for(;;)switch(c.prev=c.next){case 0:return o=i.length>1&&void 0!==i[1]?i[1]:{},c.abrupt("return",a.contractCallStatic(e,null,"init",t,{bytecode:r,top:o.top,options:s()(n,o)}));case 2:case"end":return c.stop()}}))}},{bytecode:r})));case 6:case"end":return i.stop()}}),null,this)},contractCallStatic:function(e,t,n){var r,a,o,i,c,u,l,p,d,h,v,y,g,b=arguments;return f.a.async((function(m){for(;;)switch(m.prev=m.next){case 0:if(r=b.length>3&&void 0!==b[3]?b[3]:[],a=b.length>4&&void 0!==b[4]?b[4]:{},o=a.top,i=a.options,c=void 0===i?{}:i,u=a.bytecode,!(l=s()(this.Ae.defaults,c)).onAccount){m.next=9;break}return m.next=6,f.a.awrap(this.address(l));case 6:m.t0=m.sent,m.next=12;break;case 9:return m.next=11,f.a.awrap(this.address().catch((function(e){return l.dryRunAccount.pub})));case 11:m.t0=m.sent;case 12:if(p=m.t0,!Array.isArray(r)){m.next=19;break}return m.next=16,f.a.awrap(this.contractEncodeCall(e,n,r,l));case 16:m.t1=m.sent,m.next=20;break;case 19:m.t1=r;case 20:if(d=m.t1,!o||isNaN(o)){m.next=25;break}return m.next=24,f.a.awrap(this.getKeyBlock(o));case 24:o=m.sent.hash;case 25:if(!o){m.next=32;break}return m.next=28,f.a.awrap(this.getAccount(p,{hash:o}));case 28:m.t3=m.sent.nonce,m.t2=m.t3+1,m.next=33;break;case 32:m.t2=void 0;case 33:if(h=m.t2,"init"!==n){m.next=42;break}return m.next=37,f.a.awrap(this.contractCreateTx(s()(l,{callData:d,code:u,ownerId:p,nonce:h})));case 37:return v=m.sent,y=v.tx,m.abrupt("return",this.dryRunContractTx(y,p,e,n,x({},l,{top:o})));case 42:return m.next=44,f.a.awrap(this.contractCallTx(s()(l,{callerId:p,contractId:t,callData:d,nonce:h})));case 44:return g=m.sent,m.abrupt("return",this.dryRunContractTx(g,p,e,n,x({},l,{top:o})));case 46:case"end":return m.stop()}}),null,this)},contractDeploy:function(e,t){var n,r,a,o,i,c,u,l,p=this,d=arguments;return f.a.async((function(h){for(;;)switch(h.prev=h.next){case 0:if(n=d.length>2&&void 0!==d[2]?d[2]:[],r=d.length>3&&void 0!==d[3]?d[3]:{},a=s()(this.Ae.defaults,r),!Array.isArray(n)){h.next=9;break}return h.next=6,f.a.awrap(this.contractEncodeCall(t,"init",n,a));case 6:h.t0=h.sent,h.next=10;break;case 9:h.t0=n;case 10:return o=h.t0,h.next=13,f.a.awrap(this.address(a));case 13:return i=h.sent,h.next=16,f.a.awrap(this.contractCreateTx(s()(a,{callData:o,code:e,ownerId:i})));case 16:return c=h.sent,u=c.tx,l=c.contractId,h.abrupt("return",w(u,a).call(this,(function(e){var n=e.hash,r=e.rawTx,o=e.result;return Object.freeze({result:o,owner:i,transaction:n,rawTx:r,address:l,call:function(e){var n,r,o=arguments;return f.a.async((function(i){for(;;)switch(i.prev=i.next){case 0:return n=o.length>1&&void 0!==o[1]?o[1]:[],r=o.length>2&&void 0!==o[2]?o[2]:{},i.abrupt("return",p.contractCall(t,l,e,n,s()(a,r)));case 3:case"end":return i.stop()}}))},callStatic:function(e){var n,r,o=arguments;return f.a.async((function(i){for(;;)switch(i.prev=i.next){case 0:return n=o.length>1&&void 0!==o[1]?o[1]:[],r=o.length>2&&void 0!==o[2]?o[2]:{},i.abrupt("return",p.contractCallStatic(t,l,e,n,x({},r,{options:x({onAccount:a.onAccount},s()(a,r.options))})));case 3:case"end":return i.stop()}}))},createdAt:new Date})})));case 20:case"end":return h.stop()}}),null,this)},contractCall:function(e,t,n){var r,a,o,i,c=this,u=arguments;return f.a.async((function(l){for(;;)switch(l.prev=l.next){case 0:return r=u.length>3&&void 0!==u[3]?u[3]:[],a=u.length>4&&void 0!==u[4]?u[4]:{},o=s()(this.Ae.defaults,a),l.t0=f.a,l.t1=this,l.t2=s.a,l.t3=o,l.next=9,f.a.awrap(this.address(o));case 9:if(l.t4=l.sent,l.t5=t,!Array.isArray(r)){l.next=17;break}return l.next=14,f.a.awrap(this.contractEncodeCall(e,n,r,o));case 14:l.t6=l.sent,l.next=18;break;case 17:l.t6=r;case 18:return l.t7=l.t6,l.t8={callerId:l.t4,contractId:l.t5,callData:l.t7},l.t9=(0,l.t2)(l.t3,l.t8),l.t10=l.t1.contractCallTx.call(l.t1,l.t9),l.next=24,l.t0.awrap.call(l.t0,l.t10);case 24:return i=l.sent,l.abrupt("return",w(i,o).call(this,(function(t){var r=t.hash,a=t.rawTx,i=t.result;return{hash:r,rawTx:a,result:i,decode:function(){return c.contractDecodeData(e,n,i.returnValue,i.returnType,o)}}})));case 26:case"end":return l.stop()}}),null,this)},contractEncodeCall:function(e,t,n,r){return f.a.async((function(a){for(;;)switch(a.prev=a.next){case 0:return a.abrupt("return",this.contractEncodeCallDataAPI(e,t,n,r));case 1:case"end":return a.stop()}}),null,this)},contractDecodeData:function(e,t,n,r,a){return f.a.async((function(o){for(;;)switch(o.prev=o.next){case 0:return o.abrupt("return",this.contractDecodeCallResultAPI(e,t,n,r,a));case 1:case"end":return o.stop()}}),null,this)},dryRunContractTx:function(e,t,n,r){var o,i,c,s,u,l,p,d,h,v,y,b=this,m=arguments;return f.a.async((function(x){for(;;)switch(x.prev=x.next){case 0:return o=m.length>4&&void 0!==m[4]?m[4]:{},i=o.top,c=g()(o.dryRunAccount.amount).gt(g()(o.amount||0))?o.dryRunAccount.amount:o.amount,s={amount:c,pubKey:t},x.t0=a.a,x.next=7,f.a.awrap(this.txDryRun([e],[s],i));case 7:if(x.t1=x.sent.results,u=(0,x.t0)(x.t1,1),l=u[0],p=l.result,d=l.callObj,h=l.reason,"ok"===p){x.next=15;break}throw new Error("Dry run error, "+h);case 15:if(v=d.returnType,y=d.returnValue,"ok"===v){x.next=19;break}return x.next=19,f.a.awrap(this.handleCallError(d));case 19:return x.abrupt("return",{result:d,decode:function(){return b.contractDecodeData(n,r,y,v,o)}});case 20:case"end":return x.stop()}}),null,this)},handleCallError:function(t){var n,r,a;return f.a.async((function(o){for(;;)switch(o.prev=o.next){case 0:if(n=e.from(t.returnValue).toString(),!Object(p.isBase64)(n.slice(3))){o.next=4;break}throw r=e.from(n.slice(3),"base64").toString(),Object.assign(Error("Invocation failed: ".concat(n,". Decoded: ").concat(r)),s()(t,{error:n,decodedError:r}));case 4:return o.next=6,f.a.awrap(this.contractDecodeDataAPI("string",n));case 6:throw a=o.sent,Object.assign(Error("Invocation failed: ".concat(n,". Decoded: ").concat(a)),s()(t,{error:n,decodedError:a}));case 8:case"end":return o.stop()}}),null,this)}},deepProps:{Ae:{defaults:{deposit:0,gasPrice:1e9,amount:0,gas:1579e3,options:"",dryRunAccount:{pub:"ak_11111111111111111111111111111111273Yts",amount:"100000000000000000000000000000000000"}}}}}),j=O.compose(b.b).compose(d.a);t.b=j}).call(this,n(22).Buffer)},function(e,t,n){"use strict";var r=n(13),a=n.n(r),o=n(6),i=n.n(o),c=n(1),s=n.n(c),u=n(0),f=n.n(u),l=n(63),p=function(e,t){return{name:e,instance:t,url:t.url,internalUrl:t.internalUrl,networkId:t.nodeNetworkId,version:t.version,consensusProtocolVersion:t.consensusProtocolVersion}},d=n(21);function h(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function v(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?h(n,!0).forEach((function(t){s()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):h(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}n.d(t,"a",(function(){return y}));var y=d.a.compose({init:function(){var e,t,n,r,a,o,i,c,s,u=this,d=arguments;return f.a.async((function(h){for(;;)switch(h.prev=h.next){case 0:if(e=d.length>0&&void 0!==d[0]?d[0]:{},t=e.nodes,n=void 0===t?[]:t,r=e.url,a=void 0===r?this.url:r,o=e.internalUrl,i=void 0===o?this.internalUrl:o,c=e.forceCompatibility,s=void 0!==c&&c,this.pool=new Map,this.validateNodes(n),n.forEach((function(e){var t=e.name,n=e.instance;u.pool.set(t,p(t,n))})),n.length&&this.selectNode(n[0].name),!a){h.next=11;break}return h.t0=this,h.next=9,f.a.awrap(Object(l.a)({url:a,internalUrl:i,forceCompatibility:s}));case 9:h.t1=h.sent,h.t0.addNode.call(h.t0,"default",h.t1,!0);case 11:case"end":return h.stop()}}),null,this)},propertyDescriptors:{api:{enumerable:!0,configurable:!1,get:function(){return function(e){if(!e||!e.instance)throw new Error("You can't use Node API. Node is not connected or not defined!");return e.instance.api}(this.selectedNode)}}},methods:{addNode:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(this.pool.has(e))throw new Error("Node with name ".concat(e," already exist"));this.validateNodes([{name:e,instance:t}]),this.pool.set(e,p(e,t)),!n&&this.selectedNode||this.selectNode(e)},selectNode:function(e){if(!this.pool.has(e))throw new Error("Node with name ".concat(e," not in pool"));this.selectedNode=this.pool.get(e)},getNetworkId:function(){return this.networkId||this.selectedNode.networkId||"ae_mainnet"},isNodeConnected:function(){return!!this.selectedNode.instance},getNodeInfo:function(){if(!this.isNodeConnected())throw new Error("Can not get node info. Node is not connected");return v({name:this.selectedNode.name},this.selectedNode.instance.getNodeInfo())},getNodesInPool:function(){return Array.from(this.pool.entries()).map((function(e){var t=i()(e,2);return v({name:t[0]},t[1].instance.getNodeInfo())}))},validateNodes:function(e){var t=["Swagger","api","consensusProtocolVersion","genesisHash","methods"];e.forEach((function(e,n){if("object"!==a()(e))throw new Error('Node must be an object with "name" and "instance" props');if(["name","instance"].find((function(t){return!e[t]})))throw new Error("Node object on index ".concat(n,' must contain node "name" and "ins"'));if(!e.instance||"object"!==a()(e.instance)||t.find((function(t){return!(t in e.instance)})))throw new Error("Invalid node instance object")}))}},props:{selectedNode:{}}});t.b=y},function(e,t,n){var r=n(15)((function(e){for(var t={},n=0;n<e.length;)t[e[n][0]]=e[n][1],n+=1;return t}));e.exports=r},function(e,t,n){var r=n(91)(-1);e.exports=r},function(e,t,n){var r=n(59),a=n(11)(r);e.exports=a},function(e,t){e.exports=o},function(e,t){e.exports=function(e,t){return Object.prototype.hasOwnProperty.call(t,e)}},function(e,t,n){var r=n(72)(1,"join");e.exports=r},function(e,t,n){var r=n(15),a=n(160),o=r((function(e){return a(e,[])}));e.exports=o},function(e,t,n){"use strict";var r,a,o,i,c,s,u,f,l,p,d,h,v,y=n(13),g=n.n(y),b=n(3),m=n.n(b);t.a={stringify:function(){var e,t,n,r=/[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,a={"\b":"\\b","\t":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"};function o(e){return r.lastIndex=0,r.test(e)?'"'+e.replace(r,(function(e){var t=a[e];return"string"==typeof t?t:"\\u"+("0000"+e.charCodeAt(0).toString(16)).slice(-4)}))+'"':'"'+e+'"'}return function(r,a,i){var c;if(e="",t="","number"==typeof i)for(c=0;c<i;c+=1)t+=" ";else"string"==typeof i&&(t=i);if(n=a,a&&"function"!=typeof a&&("object"!==g()(a)||"number"!=typeof a.length))throw new Error("JSON.stringify");return function r(a,i){var c,s,u,f,l,p=e,d=i[a],h=null!=d&&(d instanceof m.a||m.a.isBigNumber(d)||m()(d).toString(10)===d);switch(d&&"object"===g()(d)&&"function"==typeof d.toJSON&&(d=d.toJSON(a)),"function"==typeof n&&(d=n.call(i,a,d)),g()(d)){case"string":return h?d:o(d);case"number":return isFinite(d)?String(d):"null";case"boolean":case"null":return String(d);case"object":if(!d)return"null";if(e+=t,l=[],"[object Array]"===Object.prototype.toString.apply(d)){for(f=d.length,c=0;c<f;c+=1)l[c]=r(c,d)||"null";return u=0===l.length?"[]":e?"[\n"+e+l.join(",\n"+e)+"\n"+p+"]":"["+l.join(",")+"]",e=p,u}if(n&&"object"===g()(n))for(f=n.length,c=0;c<f;c+=1)"string"==typeof n[c]&&(u=r(s=n[c],d))&&l.push(o(s)+(e?": ":":")+u);else Object.keys(d).forEach((function(t){var n=r(t,d);n&&l.push(o(t)+(e?": ":":")+n)}));return u=0===l.length?"{}":e?"{\n"+e+l.join(",\n"+e)+"\n"+p+"}":"{"+l.join(",")+"}",e=p,u}}("",{"":r})}}(),parse:(i={strict:!1,storeAsString:!1},c={'"':'"',"\\":"\\","/":"/",b:"\b",f:"\f",n:"\n",r:"\r",t:"\t"},u=function(e){throw{name:"SyntaxError",message:e,at:r,text:o}},f=function(e){return e&&e!==a&&u("Expected '"+e+"' instead of '"+a+"'"),a=o.charAt(r),r+=1,a},l=function(){var e,t="";for("-"===a&&(t="-",f("-"));a>="0"&&a<="9";)t+=a,f();if("."===a)for(t+=".";f()&&a>="0"&&a<="9";)t+=a;if("e"===a||"E"===a)for(t+=a,f(),"-"!==a&&"+"!==a||(t+=a,f());a>="0"&&a<="9";)t+=a,f();if(e=+t,isFinite(e))return t.length>15?t:e;u("Bad number")},p=function(){var e,t,n,r="";if('"'===a)for(;f();){if('"'===a)return f(),r;if("\\"===a)if(f(),"u"===a){for(n=0,t=0;t<4&&(e=parseInt(f(),16),isFinite(e));t+=1)n=16*n+e;r+=String.fromCharCode(n)}else{if("string"!=typeof c[a])break;r+=c[a]}else r+=a}u("Bad string")},d=function(){for(;a&&a<=" ";)f()},h=function(){var e=[];if("["===a){if(f("["),d(),"]"===a)return f("]"),e;for(;a;){if(e.push(s()),d(),"]"===a)return f("]"),e;f(","),d()}}u("Bad array")},v=function(){var e,t={};if("{"===a){if(f("{"),d(),"}"===a)return f("}"),t;for(;a;){if(e=p(),d(),f(":"),!0===i.strict&&Object.hasOwnProperty.call(t,e)&&u('Duplicate key "'+e+'"'),t[e]=s(),d(),"}"===a)return f("}"),t;f(","),d()}}u("Bad object")},s=function(){switch(d(),a){case"{":return v();case"[":return h();case'"':return p();case"-":return l();default:return a>="0"&&a<="9"?l():function(){switch(a){case"t":return f("t"),f("r"),f("u"),f("e"),!0;case"f":return f("f"),f("a"),f("l"),f("s"),f("e"),!1;case"n":return f("n"),f("u"),f("l"),f("l"),null}u("Unexpected '"+a+"'")}()}},function(e,t){var n;return o=e+"",r=0,a=" ",n=s(),d(),a&&u("Syntax error"),"function"==typeof t?function e(n,r){var a,o=n[r];return o&&"object"===g()(o)&&Object.keys(o).forEach((function(t){void 0!==(a=e(o,t))?o[t]=a:delete o[t]})),t.call(n,r,o)}({"":n},""):n})}},function(e,t,n){var r=n(15)((function(e){return null===e?"Null":void 0===e?"Undefined":Object.prototype.toString.call(e).slice(8,-1)}));e.exports=r},function(e,t,n){var r=n(11),a=n(93),o=n(46),i=r((function(e,t){return a(o(e),t)}));e.exports=i},function(e,t,n){var r=n(70),a=n(142);e.exports=function(e,t,n){return function(){if(0===arguments.length)return n();var o=Array.prototype.slice.call(arguments,0),i=o.pop();if(!r(i)){for(var c=0;c<e.length;){if("function"==typeof i[e[c]])return i[e[c]].apply(i,o);c+=1}if(a(i)){var s=t.apply(null,o);return s(i)}}return n.apply(this,arguments)}}},function(e,t){e.exports={init:function(){return this.xf["@@transducer/init"]()},result:function(e){return this.xf["@@transducer/result"](e)}}},function(e,t,n){var r=n(11),a=n(49),o=n(23),i=r((function(e,t){return a((function(n,r){return n[r]=e(t[r],r,t),n}),{},o(t))}));e.exports=i},function(e,t,n){"use strict";(function(e){var r=n(28),a=n.n(r),o=n(0),i=n.n(o),c=n(14),s=n.n(c),u=n(21),f=n(52),l=n(60),p=n(5);var d=s()(u.a,{init:function(t){var n,r,o;return i.a.async((function(c){for(;;)switch(c.prev=c.next){case 0:return n=t.accounts,r=void 0===n?[]:n,o=t.keypair,c.t0=a.a,c.next=4,i.a.awrap(Promise.all(r.map((function(e){return i.a.async((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,i.a.awrap(e.address());case 2:return t.t0=t.sent,t.t1=e,t.abrupt("return",[t.t0,t.t1]);case 5:case"end":return t.stop()}}))}))));case 4:if(c.t1=c.sent,this.accounts=(0,c.t0)(c.t1),!(o=o||Object(p.envKeypair)(e.env,!0))){c.next=10;break}return c.next=10,i.a.awrap(this.addAccount(Object(f.a)({keypair:o}),{select:!this.Selector.address}));case 10:this._acc=Object(f.a)({keypair:Object(p.generateKeyPair)()});case 11:case"end":return c.stop()}}),null,this)},props:{accounts:{}},methods:{signWith:function(e,t){var n;return i.a.async((function(r){for(;;)switch(r.prev=r.next){case 0:if(void 0!==(n=this.accounts[e])){r.next=3;break}throw Error("Account for ".concat(e," not available"));case 3:return r.abrupt("return",n.sign(t));case 4:case"end":return r.stop()}}),null,this)},addAccount:function(e){var t,n,r,a=arguments;return i.a.async((function(o){for(;;)switch(o.prev=o.next){case 0:return t=a.length>1&&void 0!==a[1]?a[1]:{},n=t.select,o.next=3,i.a.awrap(e.address());case 3:r=o.sent,this.accounts[r]=e,n&&this.selectAccount(r);case 6:case"end":return o.stop()}}),null,this)},removeAccount:function(e){this.accounts[e]&&delete this.accounts[e],this.Selector.address===e&&(this.Selector.address=void 0)},setKeypair:function(e){var t=this.accounts[this.Selector.address]||this._acc;Object.prototype.hasOwnProperty.call(e,"priv")&&Object.prototype.hasOwnProperty.call(e,"pub")&&(e={secretKey:e.priv,publicKey:e.pub},console.warn("pub/priv naming for accounts has been deprecated, please use secretKey/publicKey")),t.setSecret(e),this.accounts[e.publicKey]=t,delete this.accounts[this.Selector.address],this.selectAccount(e.publicKey)},addresses:function(){return Object.keys(this.accounts)}}},l.a);t.a=d}).call(this,n(148))},function(e,t,n){"use strict";var r=n(14),a=n.n(r),o=n(7),i=a()({deepConf:{Ae:{methods:["spendTx","namePreclaimTx","nameClaimTx","nameTransferTx","nameUpdateTx","nameRevokeTx","contractCreateTx","contractCallTx","oracleRegisterTx","oracleExtendTx","oraclePostQueryTx","oracleRespondTx","getAccountNonce","channelCloseSoloTx","channelSlashTx","channelSettleTx","channelSnapshotSoloTx","getVmVersion","prepareTxParams"]}}},Object(o.required)({methods:{spendTx:o.required,namePreclaimTx:o.required,nameClaimTx:o.required,nameTransferTx:o.required,nameUpdateTx:o.required,nameRevokeTx:o.required,contractCreateTx:o.required,contractCallTx:o.required,oracleRegisterTx:o.required,oracleExtendTx:o.required,oraclePostQueryTx:o.required,oracleRespondTx:o.required,getAccountNonce:o.required,channelCloseSoloTx:o.required,channelSlashTx:o.required,channelSettleTx:o.required,channelSnapshotSoloTx:o.required,getVmVersion:o.required,prepareTxParams:o.required}}));t.a=i},function(e,t,n){"use strict";var r=n(66),a=n(7),o=r.a.compose({deepProps:{Chain:{defaults:{waitMined:!0}}},statics:{waitMined:function(e){return this.deepProps({Chain:{defaults:{waitMined:e}}})}},deepConf:{Ae:{methods:["sendTransaction","height","awaitHeight","poll","balance","getBalance","tx","mempool","topBlock","getTxInfo","txDryRun","getName","getNodeInfo","getAccount"]}}},Object(a.required)({methods:{sendTransaction:a.required,height:a.required,awaitHeight:a.required,topBlock:a.required,poll:a.required,balance:a.required,getBalance:a.required,tx:a.required,getTxInfo:a.required,mempool:a.required,txDryRun:a.required,getAccount:a.required}}));t.a=o},function(e,t,n){"use strict";(function(e){var r=n(6),a=n.n(r),o=n(1),i=n.n(o),c=n(28),s=n.n(c),u=n(0),f=n.n(u),l=n(4),p=n.n(l),d=n(5),h=n(9),v=n(20),y=n(2);function g(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function b(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?g(n,!0).forEach((function(t){i()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):g(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var m=v.a.compose({methods:{aensQuery:function(e){var t,n,r,a=this,o=arguments;return f.a.async((function(i){for(;;)switch(i.prev=i.next){case 0:return t=o.length>1&&void 0!==o[1]?o[1]:{},Object(h.isNameValid)(e),i.next=4,f.a.awrap(this.getName(e));case 4:return n=i.sent,r=n.id,i.abrupt("return",Object.freeze(Object.assign(n,{pointers:n.pointers||[],update:function(n,o){return f.a.async((function(i){for(;;)switch(i.prev=i.next){case 0:return i.t0=b,i.t1={},i.next=4,f.a.awrap(a.aensUpdate(r,n,p()(t,o)));case 4:return i.t2=i.sent,i.t3={},i.next=8,f.a.awrap(a.aensQuery(e));case 8:return i.t4=i.sent,i.abrupt("return",(0,i.t0)(i.t1,i.t2,i.t3,i.t4));case 10:case"end":return i.stop()}}))},transfer:function(n,o){return f.a.async((function(i){for(;;)switch(i.prev=i.next){case 0:return i.t0=b,i.t1={},i.next=4,f.a.awrap(a.aensTransfer(r,n,p()(t,o)));case 4:return i.t2=i.sent,i.t3={},i.next=8,f.a.awrap(a.aensQuery(e));case 8:return i.t4=i.sent,i.abrupt("return",(0,i.t0)(i.t1,i.t2,i.t3,i.t4));case 10:case"end":return i.stop()}}))},revoke:function(e){return f.a.async((function(n){for(;;)switch(n.prev=n.next){case 0:return n.abrupt("return",a.aensRevoke(r,p()(t,e)));case 1:case"end":return n.stop()}}))}})));case 7:case"end":return i.stop()}}),null,this)},aensPreclaim:function(e){var t,n,r,a,o,i,c,s=this,u=arguments;return f.a.async((function(l){for(;;)switch(l.prev=l.next){case 0:return t=u.length>1&&void 0!==u[1]?u[1]:{},Object(h.isNameValid)(e),n=p()(this.Ae.defaults,t),r=Object(d.salt)(),l.next=6,f.a.awrap(this.height());case 6:return a=l.sent,o=Object(h.commitmentHash)(e,r),l.t0=f.a,l.t1=this,l.t2=p.a,l.t3=n,l.next=14,f.a.awrap(this.address(n));case 14:return l.t4=l.sent,l.t5=o,l.t6={accountId:l.t4,commitmentId:l.t5},l.t7=(0,l.t2)(l.t3,l.t6),l.t8=l.t1.namePreclaimTx.call(l.t1,l.t7),l.next=21,l.t0.awrap.call(l.t0,l.t8);case 21:return i=l.sent,l.next=24,f.a.awrap(this.send(i,n));case 24:return c=l.sent,l.abrupt("return",Object.freeze(b({},c,{height:a,claim:function(t){return s.aensClaim(e,r,b({},t,{onAccount:n.onAccount}))},salt:r,commitmentId:o})));case 26:case"end":return l.stop()}}),null,this)},aensClaim:function(t,n){var r,o,i,c,s,u,l,v,y,g,b,m,x=arguments;return f.a.async((function(w){for(;;)switch(w.prev=w.next){case 0:if(r=x.length>2&&void 0!==x[2]?x[2]:{},o=this.getNodeInfo(),i=o.version,c=i.split("."),s=a()(c,1),u=s[0],l=5==+u&&"5.0.0-rc.1"!==i?2:1,r.vsn=r.vsn||l,Object(h.isNameValid)(t),2!==(v=p()(this.Ae.defaults,r)).vsn){w.next=12;break}if(y=Object(h.getMinimumNameFee)(t),v.nameFee===this.Ae.defaults.nameFee||!y.gt(v.nameFee)){w.next=11;break}throw new Error("the provided fee ".concat(v.nameFee," is not enough to execute the claim, required: ").concat(y));case 11:v.nameFee=v.nameFee!==this.Ae.defaults.nameFee?v.nameFee:y;case 12:return w.t0=f.a,w.t1=this,w.t2=p.a,w.t3=v,w.next=18,f.a.awrap(this.address(v));case 18:return w.t4=w.sent,w.t5=n,w.t6="nm_".concat(Object(d.encodeBase58Check)(e.from(t))),w.t7={accountId:w.t4,nameSalt:w.t5,name:w.t6},w.t8=(0,w.t2)(w.t3,w.t7),w.t9=w.t1.nameClaimTx.call(w.t1,w.t8),w.next=26,w.t0.awrap.call(w.t0,w.t9);case 26:return g=w.sent,w.next=29,f.a.awrap(this.send(g,v));case 29:if(b=w.sent,!(1===v.vsn||t.split(".")[0].length>12)){w.next=41;break}if(delete v.vsn,!v.waitMined){w.next=38;break}return w.next=35,f.a.awrap(this.aensQuery(t,v));case 35:w.t10=w.sent,w.next=39;break;case 38:w.t10={};case 39:return m=w.t10,w.abrupt("return",Object.assign(b,m));case 41:return w.abrupt("return",b);case 42:case"end":return w.stop()}}),null,this)},aensUpdate:function(e,t){var n,r,a,o=arguments;return f.a.async((function(i){for(;;)switch(i.prev=i.next){case 0:return n=o.length>2&&void 0!==o[2]?o[2]:{},r=p()(this.Ae.defaults,n),i.t0=f.a,i.t1=this,i.t2=p.a,i.t3=r,i.t4=e,i.next=9,f.a.awrap(this.address(r));case 9:return i.t5=i.sent,i.t6=[s()([["id",t],["key",Object(h.classify)(t)]])],i.t7={nameId:i.t4,accountId:i.t5,pointers:i.t6},i.t8=(0,i.t2)(i.t3,i.t7),i.t9=i.t1.nameUpdateTx.call(i.t1,i.t8),i.next=16,i.t0.awrap.call(i.t0,i.t9);case 16:return a=i.sent,i.abrupt("return",this.send(a,r));case 18:case"end":return i.stop()}}),null,this)},aensTransfer:function(e,t){var n,r,a,o=arguments;return f.a.async((function(i){for(;;)switch(i.prev=i.next){case 0:return n=o.length>2&&void 0!==o[2]?o[2]:{},r=p()(this.Ae.defaults,n),i.t0=f.a,i.t1=this,i.t2=p.a,i.t3=r,i.t4=e,i.next=9,f.a.awrap(this.address(r));case 9:return i.t5=i.sent,i.t6=t,i.t7={nameId:i.t4,accountId:i.t5,recipientId:i.t6},i.t8=(0,i.t2)(i.t3,i.t7),i.t9=i.t1.nameTransferTx.call(i.t1,i.t8),i.next=16,i.t0.awrap.call(i.t0,i.t9);case 16:return a=i.sent,i.abrupt("return",this.send(a,r));case 18:case"end":return i.stop()}}),null,this)},aensRevoke:function(e){var t,n,r,a=arguments;return f.a.async((function(o){for(;;)switch(o.prev=o.next){case 0:return t=a.length>1&&void 0!==a[1]?a[1]:{},n=p()(this.Ae.defaults,t),o.t0=f.a,o.t1=this,o.t2=p.a,o.t3=n,o.t4=e,o.next=9,f.a.awrap(this.address(n));case 9:return o.t5=o.sent,o.t6={nameId:o.t4,accountId:o.t5},o.t7=(0,o.t2)(o.t3,o.t6),o.t8=o.t1.nameRevokeTx.call(o.t1,o.t7),o.next=15,o.t0.awrap.call(o.t0,o.t8);case 15:return r=o.sent,o.abrupt("return",this.send(r,n));case 17:case"end":return o.stop()}}),null,this)},aensBid:function(e){var t,n,r=arguments;return f.a.async((function(a){for(;;)switch(a.prev=a.next){case 0:return t=r.length>1&&void 0!==r[1]?r[1]:y.o,n=r.length>2&&void 0!==r[2]?r[2]:{},a.abrupt("return",this.aensClaim(e,0,b({},n,{nameFee:t,vsn:2})));case 3:case"end":return a.stop()}}),null,this)}},deepProps:{Ae:{defaults:{clientTtl:y.d,nameTtl:y.q,nameFee:y.o}}}});t.a=m}).call(this,n(22).Buffer)},function(e,t,n){"use strict";var r=n(14),a=n.n(r),o=n(7),i=a()({deepConf:{Contract:{methods:["contractEncodeCallDataAPI","contractDecodeDataAPI","compileContractAPI","contractDecodeCallDataBySourceAPI","contractDecodeCallDataByCodeAPI","contractGetACI","setCompilerUrl","getCompilerVersion","contractDecodeCallResultAPI"]}}},Object(o.required)({methods:{contractEncodeCallDataAPI:o.required,contractDecodeDataAPI:o.required,compileContractAPI:o.required,contractGetACI:o.required,setCompilerUrl:o.required,getCompilerVersion:o.required,contractDecodeCallResultAPI:o.required}}));t.a=i},function(e,t,n){var r=n(11),a=n(24),o=r((function(e,t){return a([e],t)}));e.exports=o},function(e,t){e.exports=i},function(e,t){e.exports=function(e,t){switch(e){case 0:return function(){return t.apply(this,arguments)};case 1:return function(e){return t.apply(this,arguments)};case 2:return function(e,n){return t.apply(this,arguments)};case 3:return function(e,n,r){return t.apply(this,arguments)};case 4:return function(e,n,r,a){return t.apply(this,arguments)};case 5:return function(e,n,r,a,o){return t.apply(this,arguments)};case 6:return function(e,n,r,a,o,i){return t.apply(this,arguments)};case 7:return function(e,n,r,a,o,i,c){return t.apply(this,arguments)};case 8:return function(e,n,r,a,o,i,c,s){return t.apply(this,arguments)};case 9:return function(e,n,r,a,o,i,c,s,u){return t.apply(this,arguments)};case 10:return function(e,n,r,a,o,i,c,s,u,f){return t.apply(this,arguments)};default:throw new Error("First argument to _arity must be a non-negative integer no greater than ten")}}},function(e,t,n){var r=n(95),a=n(143),o=n(144);function i(e,t,n){for(var r=n.next();!r.done;){if((t=e["@@transducer/step"](t,r.value))&&t["@@transducer/reduced"]){t=t["@@transducer/value"];break}r=n.next()}return e["@@transducer/result"](t)}function c(e,t,n,r){return e["@@transducer/result"](n[r](o(e["@@transducer/step"],e),t))}var s="undefined"!=typeof Symbol?Symbol.iterator:"@@iterator";e.exports=function(e,t,n){if("function"==typeof e&&(e=a(e)),r(n))return function(e,t,n){for(var r=0,a=n.length;r<a;){if((t=e["@@transducer/step"](t,n[r]))&&t["@@transducer/reduced"]){t=t["@@transducer/value"];break}r+=1}return e["@@transducer/result"](t)}(e,t,n);if("function"==typeof n["fantasy-land/reduce"])return c(e,t,n,"fantasy-land/reduce");if(null!=n[s])return i(e,t,n[s]());if("function"==typeof n.next)return i(e,t,n);if("function"==typeof n.reduce)return c(e,t,n,"reduce");throw new TypeError("reduce: list must be array or iterable")}},function(e,t,n){var r=n(15),a=n(11),o=n(57);e.exports=function(e){return function t(n,i,c){switch(arguments.length){case 0:return t;case 1:return o(n)?t:a((function(t,r){return e(n,t,r)}));case 2:return o(n)&&o(i)?t:o(n)?a((function(t,n){return e(t,i,n)})):o(i)?a((function(t,r){return e(n,t,r)})):r((function(t){return e(n,i,t)}));default:return o(n)&&o(i)&&o(c)?t:o(n)&&o(i)?a((function(t,n){return e(t,n,c)})):o(n)&&o(c)?a((function(t,n){return e(t,i,n)})):o(i)&&o(c)?a((function(t,r){return e(n,t,r)})):o(n)?r((function(t){return e(t,i,c)})):o(i)?r((function(t){return e(n,t,c)})):o(c)?r((function(t){return e(n,i,t)})):e(n,i,c)}}}},function(e,t,n){var r=n(154),a=n(11),o=n(155),i=a((function(e,t){return o(r(e),t)}));e.exports=i},function(e,t,n){"use strict";(function(e){var r=n(13),a=n.n(r),o=n(0),i=n.n(o),c=n(25),s=n(5),u=n(19),f=n(9),l=new WeakMap;var p=c.a.compose({init:function(t){var n=t.keypair,r=t.gaId;if(this.isGa=!!r,r){if(!s.isAddressValid(r))throw new Error("Invalid GA address");l.set(this,{publicKey:r})}else!function(t){if(!t||"object"!==a()(t))throw new Error("KeyPair must be an object");if(t.pub&&t.priv&&(t={publicKey:t.pub,secretKey:t.priv}),!t.secretKey||!t.publicKey)throw new Error('KeyPair must must have "secretKey", "publicKey" properties');if("string"!=typeof t.publicKey||-1===t.publicKey.indexOf("ak_"))throw new Error('Public Key must be a base58c string with "ak_" prefix');if(!e.isBuffer(t.secretKey)&&"string"==typeof t.secretKey&&!Object(u.a)(t.secretKey))throw new Error("Secret key must be hex string or Buffer");var n=e.from(Object(f.decode)(t.publicKey,"ak"));if(!s.isValidKeypair(e.from(t.secretKey,"hex"),n))throw new Error("Invalid Key Pair")}(n),Object.prototype.hasOwnProperty.call(n,"priv")&&Object.prototype.hasOwnProperty.call(n,"pub")&&(n={secretKey:n.priv,publicKey:n.pub},console.warn("pub/priv naming for accounts has been deprecated, please use secretKey/publicKey")),this.setSecret(n)},props:{isGa:!1},methods:{sign:function(e){return i.a.async((function(t){for(;;)switch(t.prev=t.next){case 0:if(!this.isGa){t.next=2;break}throw new Error("You are trying to sign data using GA account without keypair");case 2:return t.abrupt("return",Promise.resolve(s.sign(e,l.get(this).secretKey)));case 3:case"end":return t.stop()}}),null,this)},address:function(){var e,t=arguments;return i.a.async((function(n){for(;;)switch(n.prev=n.next){case 0:return e=t.length>0&&void 0!==t[0]?t[0]:s.ADDRESS_FORMAT.api,n.abrupt("return",Promise.resolve(s.formatAddress(e,l.get(this).publicKey)));case 2:case"end":return n.stop()}}),null,this)},setSecret:function(t){l.set(this,{secretKey:e.isBuffer(t.secretKey)?t.secretKey:e.from(t.secretKey,"hex"),publicKey:t.publicKey})}}});t.a=p}).call(this,n(22).Buffer)},function(e,t,n){var r=n(15)((function(e){return null==e}));e.exports=r},function(e,t,n){var r=n(15),a=n(23),o=r((function(e){for(var t=a(e),n=t.length,r=[],o=0;o<n;)r[o]=e[t[o]],o+=1;return r}));e.exports=o},function(e,t,n){var r=n(15)((function(e){return function(){return e}}));e.exports=r},function(e,t,n){var r=n(11)((function(e,t){for(var n={},r=0;r<e.length;)e[r]in t&&(n[e[r]]=t[e[r]]),r+=1;return n}));e.exports=r},function(e,t){e.exports=function(e){return null!=e&&"object"==typeof e&&!0===e["@@functional/placeholder"]}},function(e,t,n){var r=n(48),a=n(15),o=n(11),i=n(71),c=o((function(e,t){return 1===e?a(t):r(e,i(e,[],t))}));e.exports=c},function(e,t,n){var r=n(149);e.exports=function(e,t){return r(t,e,0)>=0}},function(e,t,n){"use strict";var r=n(0),a=n.n(r),o=n(25),i=n(7),c=n.n(i),s=n(5);var u=o.a.compose({init:function(e){var t;return a.a.async((function(n){for(;;)switch(n.prev=n.next){case 0:if((t=e.address)||(t=Object.keys(this.accounts)[0]),!t||Object(s.assertedType)(t,"ak",!0)){n.next=4;break}throw new Error("Invalid account address");case 4:this.Selector.address=t;case 5:case"end":return n.stop()}}),null,this)},methods:{sign:function(e){var t,n,r=arguments;return a.a.async((function(a){for(;;)switch(a.prev=a.next){case 0:if(t=r.length>1&&void 0!==r[1]?r[1]:{},!(n=t.onAccount)||Object(s.assertedType)(n,"ak",!0)){a.next=3;break}throw new Error('Invalid account address, check "onAccount" value');case 3:return a.abrupt("return",this.signWith(n||this.Selector.address,e));case 4:case"end":return a.stop()}}),null,this)},address:function(){var e,t,n=arguments;return a.a.async((function(r){for(;;)switch(r.prev=r.next){case 0:if(e=n.length>0&&void 0!==n[0]?n[0]:{},!(t=e.onAccount)){r.next=7;break}if(Object(s.assertedType)(t,"ak",!0)){r.next=4;break}throw new Error('Invalid account address, check "onAccount" value');case 4:if(this.accounts[t]){r.next=6;break}throw Error("Account for ".concat(t," not available"));case 6:return r.abrupt("return",Promise.resolve(t));case 7:if(!this.Selector.address){r.next=9;break}return r.abrupt("return",Promise.resolve(this.Selector.address));case 9:throw new Error("You don't have selected account");case 10:case"end":return r.stop()}}),null,this)},selectAccount:function(e){if(!e||!Object(s.assertedType)(e,"ak",!0))throw new Error("Invalid account address");if(!this.accounts[e])throw Error("Account for ".concat(e," not available"));this.Selector.address=e}},deepProps:{Selector:{}}},c()({methods:{signWith:c.a}}));t.a=u},function(e,t,n){"use strict";(function(e){var r=n(0),a=n.n(r),o=n(1),i=n.n(o),c=n(12),s=n.n(c),u=n(6),f=n.n(u),l=n(5),p=n(9),d=n(3),h=n(2),v=n(10),y=n(27);function g(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function b(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?g(n,!0).forEach((function(t){i()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):g(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var m={signature:function(t){var n=t.rlpEncoded,r=t.signature,a=t.ownerPublicKey,o=t.networkId,i=void 0===o?"ae_mainnet":o,c=e.concat([e.from(i),n]);return Object(l.verify)(c,r,Object(l.decodeBase58Check)(Object(l.assertedType)(a,"ak")))},insufficientFee:function(e){var t=e.minFee,n=e.fee;return Object(d.BigNumber)(t).lte(Object(d.BigNumber)(n))},expiredTTL:function(e){var t=e.ttl,n=e.height;return Object(d.BigNumber)(t).eq(0)||Object(d.BigNumber)(t).gte(Object(d.BigNumber)(n))},insufficientBalanceForAmountFee:function(e){var t=e.balance,n=e.amount,r=void 0===n?0:n,a=e.fee;return Object(d.BigNumber)(t).gt(Object(d.BigNumber)(r).plus(a))},insufficientBalanceForAmount:function(e){var t=e.balance,n=e.amount,r=void 0===n?0:n;return Object(d.BigNumber)(t).gt(Object(d.BigNumber)(r))},nonceUsed:function(e){var t=e.accountNonce,n=e.nonce;return Object(d.BigNumber)(n).gt(Object(d.BigNumber)(t))},nonceHigh:function(e){var t=e.accountNonce,n=e.nonce;return!Object(d.BigNumber)(n).gt(Object(d.BigNumber)(t).plus(1))},minGasPrice:function(e){var t=e.gasPrice;return isNaN(t)||Object(d.BigNumber)(t).gte(Object(d.BigNumber)(h.j))},vmAndAbiVersion:function(e){var t=e.ctVersion,n=e.abiVersion,r=e.consensusProtocolVersion,a=e.txType;t||(t={abiVersion:n});var o=h.u[r];if(!o)return!0;var i=o[a];return!Object.entries(t).reduce((function(e,t){var n=f()(t,2),r=n[0],a=n[1];return[].concat(s()(e),[void 0===a||i[r].includes(parseInt(a))])}),[]).includes(!1)},insufficientBalanceForFeeNameFee:function(e){var t=e.nameFee,n=e.fee,r=e.balance;return 1===e.VSN||Object(d.BigNumber)(r).gt(Object(d.BigNumber)(t).plus(n))}},x=function(e,t){var n,r,o,i,c,s;return a.a.async((function(u){for(;;)switch(u.prev=u.next){case 0:return n=t.ownerPublicKey,r=0,o=0,u.prev=3,u.next=6,a.a.awrap(e.api.getAccountByPubkey(n));case 6:i=u.sent,c=i.nonce,s=i.balance,r=c,o=s,u.next=16;break;case 13:u.prev=13,u.t0=u.catch(3),console.log("We can not get info about this publicKey");case 16:return u.t1=b,u.next=19,a.a.awrap(e.api.getCurrentKeyBlockHeight());case 19:return u.t2=u.sent.height,u.t3=o,u.t4=r,u.t5=n,u.t6={height:u.t2,balance:u.t3,accountNonce:u.t4,ownerPublicKey:u.t5},u.t7=e.getNodeInfo(),u.abrupt("return",(0,u.t1)(u.t6,u.t7));case 26:case"end":return u.stop()}}),null,null,[[3,13]])},w=function(e,t){return e.reduce((function(e,n){var r=f()(n,3),a=r[0],o=r[1],i=r[2],c=(i.key,i.type),s=i.txKey;return m[o](t)||e.push({msg:a(t),txKey:s,type:c}),e}),[])};var O=function(e){return e[["senderId","accountId","ownerId","callerId","oracleId","fromId","initiator","gaId"].find((function(t){return e[t]}))].replace("ok_","ak_")};function j(e,t){switch(e){case h.B.contractCreate:case h.B.contractCall:case h.B.oracleRegister:return w(h.e,t);case h.B.nameClaim:return w(h.n,t);default:return[]}}var k=y.a.compose({methods:{verifyTx:function(e,t){var n,r,o,i,c,u,f,l,p;return a.a.async((function(d){for(;;)switch(d.prev=d.next){case 0:return n=e.tx,r=e.signatures,o=e.rlpEncoded,t=t||this.getNetworkId()||"ae_mainnet",i=O(n),c=Object.prototype.hasOwnProperty.call(n,"gas")?+n.gas:0,u=h.r[+n.tag],d.t0=b,d.t1={minFee:Object(v.calculateFee)(0,u,{gas:c,params:n,showWarning:!1})},d.next=9,a.a.awrap(x(this,{ownerPublicKey:i}));case 9:return d.t2=d.sent,d.t3={},d.t4=n,d.t5={txType:u},f=(0,d.t0)(d.t1,d.t2,d.t3,d.t4,d.t5),l=r&&r.length?w(h.v,{rlpEncoded:o,signature:r[0].raw,ownerPublicKey:i,networkId:t}):[],p=w(h.c,f),d.abrupt("return",[].concat(s()(p),s()(l),s()(j(u,f))));case 17:case"end":return d.stop()}}),null,this)},unpackAndVerify:function(e){var t,n,r,o,i,c,s,u,f,l,d,y=arguments;return a.a.async((function(g){for(;;)switch(g.prev=g.next){case 0:if(t=y.length>1&&void 0!==y[1]?y[1]:{},n=t.networkId,r=Object(v.unpackTx)(e),o=r.tx,i=r.rlpEncoded,c=r.txType,+o.tag!==h.s){g.next=13;break}return s=o.encodedTx,u=s.txType,f=s.tx,l=o.signatures.map((function(e){return{raw:e,hash:Object(p.encode)(e,"sg")}})),d=o.encodedTx.rlpEncoded,g.next=8,a.a.awrap(this.verifyTx({tx:f,signatures:l,rlpEncoded:d},n));case 8:return g.t0=g.sent,g.t1=f,g.t2=l,g.t3=u,g.abrupt("return",{validation:g.t0,tx:g.t1,signatures:g.t2,txType:g.t3});case 13:return g.next=15,a.a.awrap(this.verifyTx({tx:o,rlpEncoded:i},n));case 15:return g.t4=g.sent,g.t5=o,g.t6=c,g.abrupt("return",{validation:g.t4,tx:g.t5,txType:g.t6});case 19:case"end":return g.stop()}}),null,this)}}});t.a=k}).call(this,n(22).Buffer)},function(e,t,n){"use strict";var r=n(1),a=n.n(r),o=n(4),i=n.n(o),c=n(24),s=n.n(c),u=n(46),f=n.n(u),l=n(81),p=n.n(l),d=n(0),h=n.n(d),v=n(68),y=n(29),g=n.n(y);function b(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function m(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?b(n,!0).forEach((function(t){a()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):b(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function x(e,t){var n=e.functions.find((function(e){return e.name===t}));if(!n&&"init"!==t)throw new Error("Function ".concat(t," doesn't exist in contract"));return m({},n,{bindings:{state:e.state,typedef:e.type_defs,contractName:e.name}})}var w=function(e){return function(){return m({},e.aci?e.aci.functions.reduce((function(t,n){var r=n.name,o=n.arguments,i=n.stateful;return m({},t,a()({},r,Object.assign((function(){var t=O(o)(arguments),n=t.opt,a=t.args;return"init"===r?e.deploy(a,n):e.call(r,a,m({callStatic:!i},n))}),{get:function(){var t=O(o)(arguments),n=t.opt,a=t.args;return e.call(r,a,m({},n,{callStatic:!0}))},send:function(){var t=O(o)(arguments),n=t.opt,a=t.args;return"init"===r?e.deploy(a,n):e.call(r,a,m({},n,{callStatic:!1}))}})))}),{}):{},{},e.aci?{init:Object.assign((function(){var t=x(e.aci,"init"),n=t.arguments,r=O(n)(arguments),a=r.opt,o=r.args;return e.deploy(o,a)}),{get:function(){var t=x(e.aci,"init"),n=t.arguments,r=O(n)(arguments),a=r.opt,o=r.args;return e.deploy(o,m({},a,{callStatic:!0}))},send:function(){var t=x(e.aci,"init"),n=t.arguments,r=O(n)(arguments),a=r.opt,o=r.args;return e.deploy(o,m({},a,{callStatic:!1}))}})}:{})}},O=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];return function(t){return{opt:t.length>e.length?g()(t):{},args:Object.values(t).slice(0,e.length)}}},j=n(21),k=n(3);function T(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function I(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?T(n,!0).forEach((function(t){a()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):T(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function P(e,t){var n;return h.a.async((function(r){for(;;)switch(r.prev=r.next){case 0:if(e&&e.arguments){r.next=2;break}return r.abrupt("return",t);case 2:if(!(e.arguments.length>t.length)){r.next=4;break}throw new Error('Function "'.concat(e.name,'" require ').concat(e.arguments.length," arguments of types [").concat(e.arguments.map((function(e){return JSON.stringify(e.type)})),"] but get [").concat(t.map(JSON.stringify),"]"));case 4:return Object(v.c)(e,t),n=e.bindings,r.abrupt("return",Promise.all(e.arguments.map((function(e,r){var a;return h.a.async((function(o){for(;;)switch(o.prev=o.next){case 0:return a=e.type,o.abrupt("return",Object(v.a)(a,t[r],{bindings:n}));case 2:case"end":return o.stop()}}))}))));case 7:case"end":return r.stop()}}))}var A=function(e){var t=e.client,n=e.instance;return function(e){var r,a,o,c,s,u,f=arguments;return h.a.async((function(l){for(;;)switch(l.prev=l.next){case 0:if(r=f.length>1&&void 0!==f[1]?f[1]:[],a=f.length>2&&void 0!==f[2]?f[2]:{},o=i()(n.options,a),c=x(n.aci,e),s=o.source||n.source,e){l.next=7;break}throw new Error("Function name is required");case 7:if(n.deployInfo.address){l.next=9;break}throw new Error("You need to deploy contract before calling!");case 9:if(!Object(k.BigNumber)(o.amount).gt(0)||!Object.prototype.hasOwnProperty.call(c,"payable")||c.payable){l.next=11;break}throw new Error('You try to pay "'.concat(o.amount,'" to function "').concat(e,'" which is not payable. Only payable function can accept tokens'));case 11:if(o.skipArgsConvert){l.next=17;break}return l.next=14,h.a.awrap(P(c,r));case 14:l.t0=l.sent,l.next=18;break;case 17:l.t0=r;case 18:if(r=l.t0,!o.callStatic){l.next=25;break}return l.next=22,h.a.awrap(t.contractCallStatic(s,n.deployInfo.address,e,r,{top:o.top,options:o}));case 22:l.t1=l.sent,l.next=28;break;case 25:return l.next=27,h.a.awrap(t.contractCall(s,n.deployInfo.address,e,r,o));case 27:l.t1=l.sent;case 28:return u=l.t1,l.t2=I,l.t3={},l.t4=u,l.t5=h.a,l.t6=v.b,l.t7=c.returns,l.next=37,h.a.awrap(u.decode());case 37:return l.t8=l.sent,l.t9=I({},o,{bindings:c.bindings}),l.t10=(0,l.t6)(l.t7,l.t8,l.t9),l.next=42,l.t5.awrap.call(l.t5,l.t10);case 42:return l.t11=l.sent,l.t12={decodedResult:l.t11},l.abrupt("return",(0,l.t2)(l.t3,l.t4,l.t12));case 45:case"end":return l.stop()}}))}},C=function(e){var t=e.client,n=e.instance;return function(){var e,r,a,o,c,s,u,f,l,p,d,v,y=arguments;return h.a.async((function(g){for(;;)switch(g.prev=g.next){case 0:if(e=y.length>0&&void 0!==y[0]?y[0]:[],r=y.length>1&&void 0!==y[1]?y[1]:{},a=i()(n.options,r),o=x(n.aci,"init"),c=a.source||n.source,n.compiled){g.next=8;break}return g.next=8,h.a.awrap(n.compile(a));case 8:if(a.skipArgsConvert){g.next=14;break}return g.next=11,h.a.awrap(P(o,e));case 11:g.t0=g.sent,g.next=15;break;case 14:g.t0=e;case 15:if(e=g.t0,!a.callStatic){g.next=20;break}return g.abrupt("return",t.contractCallStatic(c,null,"init",e,{top:a.top,options:a,bytecode:n.compiled}));case 20:return g.next=22,h.a.awrap(t.contractDeploy(n.compiled,a.source||n.source,e,a));case 22:return s=g.sent,u=s.owner,f=s.transaction,l=s.address,p=s.createdAt,d=s.result,v=s.rawTx,n.deployInfo={owner:u,transaction:f,address:l,createdAt:p,result:d,rawTx:v},g.abrupt("return",n.deployInfo);case 31:case"end":return g.stop()}}))}},E=function(e){var t=e.client,n=e.instance;return function(){var e,r,a,o=arguments;return h.a.async((function(i){for(;;)switch(i.prev=i.next){case 0:return e=o.length>0&&void 0!==o[0]?o[0]:{},i.next=3,h.a.awrap(t.contractCompile(n.source,I({},n.options,{},e)));case 3:return r=i.sent,a=r.bytecode,n.compiled=a,i.abrupt("return",n.compiled);case 7:case"end":return i.stop()}}))}};t.a=j.a.compose({methods:{getContractInstance:function(e){var t,n,r,a,o,c,u,l,d=arguments;return h.a.async((function(v){for(;;)switch(v.prev=v.next){case 0:if(t=d.length>1&&void 0!==d[1]?d[1]:{},n=t.aci,r=t.contractAddress,a=t.filesystem,o=void 0===a?{}:a,c=t.opt,v.t0=n,v.t0){v.next=6;break}return v.next=5,h.a.awrap(this.contractGetACI(e,{filesystem:o}));case 5:v.t0=v.sent;case 6:return n=v.t0,u={skipArgsConvert:!1,skipTransformDecoded:!1,callStatic:!1,deposit:0,gasPrice:1e9,amount:0,gas:1579e3,top:null,waitMined:!0,verify:!1,filesystem:o},(l={interface:p()(null,f()("interface",n)),aci:p()(null,s()(["encoded_aci","contract"],n)),source:e,compiled:null,deployInfo:{address:r},options:i()(u,c),compilerVersion:this.compilerVersion,setOptions:function(e){this.options=i()(this.options,e)}}).compile=E({client:this,instance:l}),l.deploy=C({client:this,instance:l}),l.call=A({client:this,instance:l}),l.methods=w(l)(),v.abrupt("return",l);case 14:case"end":return v.stop()}}),null,this)}}})},function(e,t,n){"use strict";var r=n(34),a=n.n(r),o=n(53),i=n.n(o),c=n(30),s=n.n(c),u=n(0),f=n.n(u),l=n(14),p=n.n(l),d=n(31),h=n.n(d),v=n(21),y=n(54),g=n.n(y),b=n(65),m=n.n(b),x=n(123),w=n.n(x),O=n(29),j=n.n(O),k=n(4),T=n.n(k),I=n(122),P=n.n(I),A=n(46),C=n.n(A),E=n(86),_=n.n(E),S=n(121),B=n.n(S),N=n(120),R=n.n(N),D=n(8),V=n.n(D),F=n(85),U=n.n(F),M=n(28),q=n.n(M),L=n(75),K=n.n(L),H=n(119),W=n.n(H),Y=n(37),Q=n.n(Y),z=n(84),G=n.n(z),X=n(83),$=n.n(X),J=n(118),Z=n.n(J),ee=n(56),te=n.n(ee),ne=n(51),re=n.n(ne),ae=n(40),oe=n.n(ae),ie=n(23),ce=n.n(ie),se=n(117),ue=n.n(se),fe=n(33),le=n.n(fe),pe=n(36),de=n.n(pe),he=n(24),ve=n.n(he),ye=n(6),ge=n.n(ye),be=n(82),me=n.n(be),xe=n(35),we=n(19),Oe=n(3),je=n.n(Oe);function ke(e,t){return me()(t).reduce((function(e,t){var n=ge()(t,2),r=n[0],a=n[1];return e.replace("{".concat(r,"}"),a)}),e)}function Te(e,t,n){var r=function(){var n=ve()(e,t).match(/^#\/definitions\/(.+)/);if(void 0!==n)return n[1];throw Error("Reference path does not meet specification: ".concat(e))}();if(r in n)return n[r];throw Error("Couldn't find definition for ".concat(r))}function Ie(e,t,n){var r=Error(e);return Object.assign(r,{spec:t,value:n})}var Pe={integer:function(e,t,n){if("Number"===de()(e)||je()(e).toString(10)===e)return"Number"===de()(e)?Math.floor(e):e;throw Ie("Not an integer",t,e)},enum:function(e,t,n){var r=t.enum;if(s()(e,r))return e;throw Ie("Not one of [".concat(le()(", ",r),"]"),t,e)},string:function(e,t,n){if("String"===de()(e))return e;throw Ie("Not a string",t,e)},object:function(e,t,n){if("Object"===de()(e)){var r=(t.required||[]).map(we.c),a=Re(t.properties),o=ue()(r,ce()(e));if(o.length>0)throw Ie("Required properties missing: ".concat(le()(", ",o)),t,e);return oe()((function(e,t){return function(e,t){try{return t()}catch(t){throw Object.assign(t,{path:[e].concat(t.path||[])})}}(t,(function(){return Ae(e,a[t],n)}))}),re()(i.a,te()(ce()(a),e)))}throw Ie("Not an object",t,e)},array:function(e,t,n){if("Array"===de()(e))return e.map((function(e){return Ae(e,t.items,n)}));throw Ie("Not an array",t,e)},schema:function(e,t,n){return Ae(e,Te(["schema","$ref"],t,n),n)},$ref:function(e,t,n){return Ae(e,Te(["$ref"],t,n),n)},allOf:function(e,t,n){return Z()(t.allOf.map((function(t){return Ae(e,t,n)})))}};function Ae(e,t,n){return(Pe[function(e){if("schema"in e)return"schema";if("$ref"in e)return"$ref";if("enum"in e)return"enum";if("allOf"in e)return"allOf";if("type"in e)return e.type;throw Object.assign(Error("Could not determine type"),{spec:e})}(t)]||function(){throw Object.assign(Error("Unsupported type"),{spec:t})})(e,t,n)}var Ce={headers:{"Content-Type":"application/json"},transformResponse:[function(e){try{return xe.a.parse(e)}catch(t){return e}}],transformRequest:[function(e){try{return xe.a.stringify(e)}catch(t){return e}}]},Ee={get:function(e){return function(t,n){return h.a.get(t,[Ce,e,n].reduce($.a))}},post:function(e){return function(t,n){return h.a.post(t,n,$()(Ce,e))}}};function _e(e){var t=G()((function(e){return e.required?"req":"opts"}),e),n=t.req,r=t.opts,a=G()((function(e){return e.in}),e),o=a.path,i=a.query,c=a.body;return{pathArgs:Q()("name",o||[]),queryArgs:Q()("name",i||[]),bodyArgs:Q()("name",c||[]),req:n||[],opts:r||[]}}function Se(e){return e.map((function(e){return W()("name",Object(we.c)(e.name),e)}))}var Be=K()((function(e,t){return({Object:function(t){return q()(me()(t).map((function(t){var n=t[0],r=t[1];return[e(n),Be(e,r)]})))},Array:function(t){return t.map(Be(e))}}[de()(t)]||U.a)(t)}));function Ne(e){return Be(we.b,e)}function Re(e){return Be(we.c,e)}function De(e,t,n){var r=t.length?"".concat(le()(", ",Q()("name",t))):null,a=n.length?"{".concat(le()(", ",Q()("name",n)),"}"):null;return"".concat(e," (").concat(le()(", ",[r,a].filter(U.a)),")")}function Ve(e){if(1===e.length)return V()(e);throw Error("Expected exactly one element in ".concat(e))}function Fe(e){var t=e.config,n=t.method,r=t.url,o=e.response,i=o.status,c=o.data,s=o.statusText,u=R()("reason",c)?c.reason:c?a()(c):s;return"".concat(n.toUpperCase()," to ").concat(r," failed with ").concat(i,": ").concat(u)}function Ue(e,t){var n=e.match(/^#\/(.+)$/);if(void 0!==n){var r=ve()(n[1].split("/"),t);if(null!=r)return r}throw Error("Could not resolve reference: ".concat(e))}var Me=p()({init:function(e,t){var n=this,r=e.swag,o=void 0===r?this.swag:r,c=e.axiosConfig,s=(t.stamp,o.paths),u=_()(C()("name"),m()(g()(oe()((function(e,t){return g()(oe()((function(e,r){return function(e,t,n,r){var o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:{},c=o.config,s=o.errorHandler;delete(c=c||{}).transformResponse;var u=n.operationId,l=n.description,p=(n.parameters||[]).map((function(e){return e.$ref?Ue(e.$ref,r):e})),d="".concat(V()(u).toLowerCase()).concat(B()(1,u)),h=Se(p),v=_e(h),y=v.pathArgs,g=v.queryArgs,b=v.bodyArgs,m=v.req,x=v.opts,O=Q()("name",x),k=_()(C()("name"),h),I=De(d,m,x),A=Ee[t](c);return function(n,o){var c=function(){var n,c,u,l,p,h,v,x,C,E,_=arguments;return f.a.async((function(S){for(;;)switch(S.prev=S.next){case 0:return n=this.Swagger.defaults,S.prev=1,c=function(){if(_.length===m.length)return[Array.from(_),n];if(_.length===m.length+1)return[P()(1,_),T()(n,j()(_))];throw Error("Function call doesn't conform to ".concat(I))}(),u=ge()(c,2),l=u[0],(p=u[1]).debug&&console.log("Invoked ".concat(d," with ").concat(a()(l)," ").concat(a()(p))),h=T()(re()(i.a,te()(O,p)),w()(Q()("name",m),l)),v=oe()((function(e,t){try{return Ae(e,k[t],r.definitions)}catch(r){var n=[t].concat(r.path||[]);throw Object.assign(r,{path:n,value:e,message:"validating ".concat(le()(" -> ",n),": ").concat(r.message)})}}),h),x=ke(e,Ne(te()(y,v))),C=Ne(function(){if("get"===t)return{params:te()(g,v)};if("post"===t)return v[Ve(b)];throw Error("Unsupported method ".concat(t))}()),p.debug&&console.log("Going to ".concat(t.toUpperCase()," ").concat(o).concat(x," with ").concat(a()(C))),S.prev=9,S.next=12,f.a.awrap(A("".concat(o).concat(x),C).catch(this.axiosError(s)));case 12:return E=S.sent,S.abrupt("return",p.fullResponse?E:Re(E.data));case 16:throw S.prev=16,S.t0=S.catch(9),ve()(["response","data"],S.t0)&&(S.t0.message=Fe(S.t0)),S.t0;case 20:S.next=26;break;case 22:throw S.prev=22,S.t1=S.catch(1),S.t1.message="While calling ".concat(I,", ").concat(S.t1.message),S.t1;case 26:case"end":return S.stop()}}),null,this,[[1,22],[9,16]])}.bind(n);return Object.assign(c,{signature:I,description:l}),Object.defineProperties(c,{name:{value:d,writable:!1},length:{value:m.length+(x.length?1:0),writable:!1}})}}(t,r,e,o,c)(n,n.urlFor(o.basePath,e))}),e))}),s))));return Object.assign(this,{methods:ce()(u),api:u})},deepProps:{Swagger:{defaults:{debug:!1,txEncoding:"json"}}},statics:{debugSwagger:function(e){return this.deepProps({Swagger:{defaults:{debug:e}}})}}}),qe=n(67);function Le(e,t){return f.a.async((function(n){for(;;)switch(n.prev=n.next){case 0:return n.next=2,f.a.awrap(h.a.get("".concat(e,"/api"),t));case 2:return n.abrupt("return",n.sent.data);case 3:case"end":return n.stop()}}))}var Ke=function(e){var t=e.url,n=e.internalUrl;return function(e,r){var o=r.tags,c=r.operationId;if(s()("external",o))return"".concat(t).concat(e);if(!i()(n)&&s()("internal",o))return"".concat(n).concat(e);throw Error("Method ".concat(c," is unsupported. No interface for ").concat(a()(o)))}};var He=p()(v.a,{init:function(e){var t,n,r,a,o,i,c,s;return f.a.async((function(u){for(;;)switch(u.prev=u.next){case 0:if(e.name,t=e.url,n=void 0===t?this.url:t,r=e.internalUrl,a=void 0===r?this.internalUrl:r,o=e.axiosConfig,i=(o=void 0===o?{}:o).config,c=o.errorHandler,n){u.next=5;break}throw new Error('"url" required');case 5:return n=n.replace(/\/?$/,""),a=a?a.replace(/\/?$/,""):n,u.next=9,f.a.awrap(Le(n,i).catch(this.axiosError(c)));case 9:return s=u.sent,this.version=s.info.version,u.abrupt("return",Object.assign(this,{url:n,internalUrl:a,swag:s,urlFor:Ke({url:n,internalUrl:a})}));case 12:case"end":return u.stop()}}),null,this)},methods:{axiosError:function(e){return function(t){throw e&&"function"==typeof e&&e(t),t}},getNodeInfo:function(){return{url:this.url,internalUrl:this.internalUrl,nodeNetworkId:this.nodeNetworkId,version:this.version,consensusProtocolVersion:this.consensusProtocolVersion}},getConsensusProtocolVersion:function(){var e,t,n,r,a=arguments;return f.a.async((function(o){for(;;)switch(o.prev=o.next){case 0:if(e=a.length>0&&void 0!==a[0]?a[0]:[],t=a.length>1?a[1]:void 0,e){o.next=4;break}throw new Error("Protocols must be an array");case 4:if(t){o.next=8;break}return o.next=7,f.a.awrap(this.api.getCurrentKeyBlock());case 7:t=o.sent.height;case 8:if(!(t<0)){o.next=10;break}throw new Error("height must be a number >= 0");case 10:return n=e.reduce((function(e,n){var r=e.effectiveAtHeight,a=e.version;return t>=n.effectiveAtHeight&&n.effectiveAtHeight>r?{effectiveAtHeight:n.effectiveAtHeight,version:n.version}:{effectiveAtHeight:r,version:a}}),{effectiveAtHeight:-1,version:0}),r=n.version,o.abrupt("return",r);case 12:case"end":return o.stop()}}),null,this)}},props:{version:null,consensusProtocolVersion:null,nodeNetworkId:null}},Me,{init:function(e){var t,n,r,a,o,i,c;return f.a.async((function(s){for(;;)switch(s.prev=s.next){case 0:return t=e.forceCompatibility,n=void 0!==t&&t,s.next=3,f.a.awrap(this.api.getStatus());case 3:return r=s.sent,a=r.nodeRevision,o=r.genesisKeyBlockHash,i=r.networkId,c=r.protocols,s.next=10,f.a.awrap(this.getConsensusProtocolVersion(c));case 10:if(this.consensusProtocolVersion=s.sent,Object(qe.a)(this.version.split("-")[0],We,Ye)||n){s.next=13;break}throw new Error("Unsupported node version ".concat(this.version,". ")+"Supported: >= ".concat(We," < ").concat(Ye));case 13:return this.nodeNetworkId=i,s.abrupt("return",Object.assign(this,{revision:a,genesisHash:o}));case 15:case"end":return s.stop()}}),null,this)}}),We="3.0.1",Ye="6.0.0";t.a=He},function(e,t,n){"use strict";var r=n(1),a=n.n(r),o=n(0),i=n.n(o),c=n(4),s=n.n(c),u=n(31),f=n.n(u),l=n(35),p=n(14);var d=function(e){return i.a.async((function(t){for(;;)switch(t.prev=t.next){case 0:return t.prev=0,t.next=3,i.a.awrap(e);case 3:return t.abrupt("return",t.sent.data);case 6:if(t.prev=6,t.t0=t.catch(0),t.t0.response){t.next=10;break}throw t.t0;case 10:throw Object.assign(Error("Http request for ".concat(t.t0.config.url," failed with status code ").concat(t.t0.response.status,". Status: ").concat(t.t0.response.statusText,". \nError data: ").concat(JSON.stringify(t.t0.response.data))),{error:t.t0});case 11:case"end":return t.stop()}}),null,null,[[0,6]])},h=n.n(p)()({init:function(e){var t=e.baseUrl;this.baseUrl=t},methods:{changeBaseUrl:function(e){this.baseUrl=e},get:function(e,t){return i.a.async((function(n){for(;;)switch(n.prev=n.next){case 0:return n.abrupt("return",d(f.a.get("".concat(this.baseUrl).concat(e),s()(this.httpConfig,t))));case 1:case"end":return n.stop()}}),null,this)},post:function(e,t,n){return i.a.async((function(r){for(;;)switch(r.prev=r.next){case 0:return r.abrupt("return",d(f.a.post("".concat(this.baseUrl).concat(e),t,s()(this.httpConfig,n))));case 1:case"end":return r.stop()}}),null,this)},put:function(e,t,n){return i.a.async((function(r){for(;;)switch(r.prev=r.next){case 0:return r.abrupt("return",d(f.a.put("".concat(this.baseUrl).concat(e),t,s()(this.httpConfig,n))));case 1:case"end":return r.stop()}}),null,this)},delete:function(e,t){return i.a.async((function(n){for(;;)switch(n.prev=n.next){case 0:return n.abrupt("return",d(f.a.delete("".concat(this.baseUrl).concat(e),s()(this.httpConfig,t))));case 1:case"end":return n.stop()}}),null,this)}},props:{httpConfig:{headers:{"Content-Type":"application/json"},transformResponse:[function(e){try{return l.a.parse(e)}catch(t){return e}}]}}}),v=n(45),y=n(67),g=n(21),b=n(2);function m(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}var x=g.a.compose(v.a,{init:function(e){var t,n,r,a;return i.a.async((function(o){for(;;)switch(o.prev=o.next){case 0:return t=e.compilerUrl,n=void 0===t?this.compilerUrl:t,r=e.forceCompatibility,a=void 0!==r&&r,this.http=h({baseUrl:n}),o.next=4,i.a.awrap(this.checkCompatibility({force:!0,forceCompatibility:a}));case 4:case"end":return o.stop()}}),null,this)},methods:{contractEncodeCallDataAPI:function(e,t){var n,r,a=arguments;return i.a.async((function(o){for(;;)switch(o.prev=o.next){case 0:return n=a.length>2&&void 0!==a[2]?a[2]:[],r=a.length>3&&void 0!==a[3]?a[3]:{},this.isInit(),r=this.prepareCompilerOption(r),o.abrupt("return",this.http.post("/encode-calldata",{source:e,function:t,arguments:n,options:r},r).then((function(e){return e.calldata})));case 5:case"end":return o.stop()}}),null,this)},contractDecodeDataAPI:function(e,t){var n,r=arguments;return i.a.async((function(a){for(;;)switch(a.prev=a.next){case 0:return n=r.length>2&&void 0!==r[2]?r[2]:{},this.isInit(),a.abrupt("return",this.http.post("/decode-data",{data:t,"sophia-type":e},n).then((function(e){return e.data})));case 3:case"end":return a.stop()}}),null,this)},compileContractAPI:function(e){var t,n=arguments;return i.a.async((function(r){for(;;)switch(r.prev=r.next){case 0:return t=n.length>1&&void 0!==n[1]?n[1]:{},this.isInit(),t=this.prepareCompilerOption(t),r.abrupt("return",this.http.post("/compile",{code:e,options:t},t).then((function(e){return e.bytecode})));case 4:case"end":return r.stop()}}),null,this)},contractGetACI:function(e){var t,n=arguments;return i.a.async((function(r){for(;;)switch(r.prev=r.next){case 0:return t=n.length>1&&void 0!==n[1]?n[1]:{},this.isInit(),t=this.prepareCompilerOption(t),r.abrupt("return",this.http.post("/aci",{code:e,options:t},t));case 4:case"end":return r.stop()}}),null,this)},contractDecodeCallDataByCodeAPI:function(e,t){var n,r,a=arguments;return i.a.async((function(o){for(;;)switch(o.prev=o.next){case 0:return n=a.length>2&&void 0!==a[2]?a[2]:this.compilerOptions.backend,r=a.length>3&&void 0!==a[3]?a[3]:{},this.isInit(),o.abrupt("return",this.http.post("/decode-calldata/bytecode",{bytecode:e,calldata:t,backend:n},r));case 4:case"end":return o.stop()}}),null,this)},contractDecodeCallDataBySourceAPI:function(e,t,n){var r,a=arguments;return i.a.async((function(o){for(;;)switch(o.prev=o.next){case 0:return r=a.length>3&&void 0!==a[3]?a[3]:{},this.isInit(),r=this.prepareCompilerOption(r),o.abrupt("return",this.http.post("/decode-calldata/source",{function:t,source:e,calldata:n},r));case 4:case"end":return o.stop()}}),null,this)},contractDecodeCallResultAPI:function(e,t,n,r){var a,o=arguments;return i.a.async((function(i){for(;;)switch(i.prev=i.next){case 0:return a=o.length>4&&void 0!==o[4]?o[4]:{},this.isInit(),a=this.prepareCompilerOption(a),i.abrupt("return",this.http.post("/decode-call-result",{function:t,source:e,"call-result":r,"call-value":n,options:a},a));case 4:case"end":return i.stop()}}),null,this)},setCompilerUrl:function(e){var t,n,r,a=arguments;return i.a.async((function(o){for(;;)switch(o.prev=o.next){case 0:return t=a.length>1&&void 0!==a[1]?a[1]:{},n=t.forceCompatibility,r=void 0!==n&&n,this.http.changeBaseUrl(e),this.compilerVersion=null,o.next=5,i.a.awrap(this.checkCompatibility({forceCompatibility:r}));case 5:case"end":return o.stop()}}),null,this)},getCompilerVersion:function(){var e,t=arguments;return i.a.async((function(n){for(;;)switch(n.prev=n.next){case 0:return e=t.length>0&&void 0!==t[0]?t[0]:{},n.abrupt("return",this.http.get("/version",e).then((function(e){return e.version})));case 2:case"end":return n.stop()}}),null,this)},isInit:function(){if(null===this.compilerVersion)throw Error("Compiler not defined");return!0},checkCompatibility:function(){var e,t,n,r,a,o,c=arguments;return i.a.async((function(s){for(;;)switch(s.prev=s.next){case 0:return e=c.length>0&&void 0!==c[0]?c[0]:{},t=e.force,n=void 0!==t&&t,r=e.forceCompatibility,a=void 0!==r&&r,s.next=3,i.a.awrap(this.getCompilerVersion().catch((function(e){return null})));case 3:if(this.compilerVersion=s.sent,this.compilerVersion||n){s.next=6;break}throw new Error("Compiler do not respond");case 6:if(a||!this.compilerVersion||Object(y.a)(this.compilerVersion.split("-")[0],w,O)){s.next=10;break}throw o=this.compilerVersion,this.compilerVersion=null,new Error("Unsupported compiler version ".concat(o,". ")+"Supported: >= ".concat(w," < ").concat(O));case 10:case"end":return s.stop()}}),null,this)},prepareCompilerOption:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?m(n,!0).forEach((function(t){a()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):m(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}({},this.compilerOptions,{},e,{file_system:e.filesystem||{}})}},props:{compilerVersion:null,compilerOptions:{backend:b.D.FATE}}}),w="3.1.0",O="5.0.0";t.a=x},function(e,t,n){var r=n(15)(n(158)(!0));e.exports=r},function(e,t,n){"use strict";var r=n(7),a=n(14),o=n.n(a)()({deepConf:{Contract:{methods:["getOracle","getOracleQueries","getOracleQuery"]}}},Object(r.required)({methods:{getOracle:r.required,getOracleQueries:r.required,getOracleQuery:r.required}}));t.a=o},function(e,t,n){"use strict";var r=n(12),a=n.n(r);t.a=function(e,t,n){var r=e.split("-")[0].split("."),o=t.split("-")[0].split("."),i=n.split("-")[0].split("."),c=Math.max.apply(Math,a()(r).concat(a()(o),a()(i)))+1,s=function(e){return e.reverse().reduce((function(e,t,n){return e+t*Math.pow(c,n)}),0)},u=s(r),f=s(o),l=s(i);return u>=f&&u<l}},function(e,t,n){"use strict";(function(e){n.d(t,"a",(function(){return b})),n.d(t,"b",(function(){return m})),n.d(t,"c",(function(){return O}));var r=n(12),a=n.n(r),o=n(13),i=n.n(o),c=n(6),s=n.n(c),u=n(1),f=n.n(u),l=n(18),p=n.n(l);function d(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function h(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?d(n,!0).forEach((function(t){f()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):d(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var v=["int","string","tuple","address","bool","list","map","record","option","oracle","oracleQuery","hash","signature","bytes","variant"].reduce((function(e,t){return h({},e,f()({},t,t))}),{});function y(e,t){var n="object"===i()(e)?Object.keys(e)[0].split("."):e.split("."),r=s()(n,2)[1],o=[].concat(a()(t.typedef),[{name:"state",typedef:t.state,vars:[]}]).find((function(e){return e.name===r}));return o.vars.length&&(o.typedef=function(e,t){var n=Object.entries(t.typedef),r=s()(n,1),a=s()(r[0],2),o=a[0],i=a[1],c=Object.entries(e),u=s()(c,1),l=s()(u[0],2)[1];switch(o){case v.variant:return f()({},o,i.map((function(e){var n=s()(Object.entries(e)[0],2),r=n[0],a=n[1];return f()({},r,a.map((function(e){var n=t.vars.map((function(e){return e.name})).indexOf(e);return-1===n?e:l[n]})))})))}}(e,o)),o.typedef}function g(e){var t=(arguments.length>1&&void 0!==arguments[1]?arguments[1]:{}).bindings,n=Array.isArray(e)?e:[e],r=s()(n,1)[0];if(("string"==typeof r&&-1!==r.indexOf(t.contractName)||"object"===i()(r)&&Object.keys(r)[0]&&-1!==Object.keys(r)[0].indexOf(t.contractName))&&(r=y(r,t)),"object"===i()(r)){var a=Object.entries(r),o=s()(a,1),c=s()(o[0],2);return{t:c[0],generic:c[1]}}if("string"==typeof r)return{t:r}}function b(t,n){var r=(arguments.length>2&&void 0!==arguments[2]?arguments[2]:{}).bindings,a=g(t,{bindings:r}),o=a.t,i=a.generic;switch(o){case v.string:return'"'.concat(n,'"');case v.list:return"[".concat(n.map((function(e){return b(i,e,{bindings:r})})),"]");case v.tuple:return"(".concat(n.map((function(e,t){return b(i[t],e,{bindings:r})})),")");case v.option:return void 0===n?"None":"Some(".concat(b(i,n,{bindings:r}),")");case v.hash:case v.bytes:case v.signature:return"#".concat("string"==typeof n?n:e.from(n).toString("hex"));case v.record:return"{".concat(i.reduce((function(e,t,a){var o=t.name,i=t.type;return e+="".concat(0!==a?",":"").concat(o," = ").concat(b(i,n[o],{bindings:r}))}),""),"}");case v.map:return function(e,t,n){var r=n.bindings;e instanceof Map&&(e=Array.from(e.entries()));!Array.isArray(e)&&e instanceof Object&&(e=Object.entries(e));return"{".concat(e.reduce((function(e,n,a){var o=s()(n,2),i=o[0],c=o[1];return 0!==a&&(e+=","),e+="[".concat(b(t[0],i,{bindings:r}),"] = ").concat(b(t[1],c,{bindings:r}))}),""),"}")}(n,i,{bindings:r});case v.variant:return function(e,t,n){var r=n.bindings,a="string"==typeof e?[[e,[]]]:Object.entries(e),o=s()(a,1),i=s()(o[0],2),c=i[0],u=i[1],f=Object.entries(t.find((function(e){return Object.keys(e)[0].toLowerCase()===c.toLowerCase()}))),l=s()(f,1),p=s()(l[0],2),d=p[0],h=p[1];return"".concat(d).concat(h.length?"(".concat(u.slice(0,h.length).map((function(e,t){return b(h[t],e,{bindings:r})})),")"):"")}(n,i,{bindings:r})}return"".concat(n)}function m(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=n.skipTransformDecoded,a=void 0!==r&&r,o=(n.addressPrefix,n.bindings);if(a)return t;var i=g(e,{bindings:o}),c=i.t,u=i.generic;switch(c){case v.bool:return!!t;case v.address:return 0===t?0:t;case v.hash:case v.bytes:case v.signature:return t.split("#")[1];case v.map:var l=s()(u,2),p=l[0],d=l[1];return t.reduce((function(e,t){var n=s()(t,2),r=n[0],a=n[1];return r=m(p,r,{bindings:o}),a=m(d,a,{bindings:o}),e.push([r,a]),e}),[]);case v.option:if("None"===t)return;var y=Object.entries(t),b=s()(y,1),x=s()(b[0],2),w=x[0],O=s()(x[1],1)[0];return"Some"===w?m(u,O,{bindings:o}):void 0;case v.list:return t.map((function(e){return m(u,e,{bindings:o})}));case v.tuple:return t.map((function(e,t){return m(u[t],e,{bindings:o})}));case v.record:var j=u.reduce((function(e,t){return h({},e,f()({},t.name,{type:t.type}))}),{});return Object.entries(t).reduce((function(e,t){var n=s()(t,2),r=n[0],a=n[1];return h({},e,f()({},r,m(j[r].type,a,{bindings:o})))}),{})}return t}function x(t){return t.map((function(t){var n=t.path,r=t.type,a=t.context,o=Object.prototype.hasOwnProperty.call(a,"value")?a.value:a.label;switch(o="object"===i()(o)?JSON.stringify(o).slice(1).slice(0,-1):o,r){case"string.base":return h({},t,{message:'Value "'.concat(o,'" at path: [').concat(n,"] not a string")});case"number.base":return h({},t,{message:'Value "'.concat(o,'" at path: [').concat(n,"] not a number")});case"boolean.base":return h({},t,{message:'Value "'.concat(o,'" at path: [').concat(n,"] not a boolean")});case"array.base":return h({},t,{message:'Value "'.concat(o,'" at path: [').concat(n,"] not a array")});case"object.base":return h({},t,{message:"Value '".concat(o,"' at path: [").concat(n,"] not a object")});case"object.type":return h({},t,{message:"Value '".concat(o,"' at path: [").concat(n,"] not a ").concat(a.type)});case"binary.bufferCheck":return h({},t,{message:"Value '".concat(e.from(o).toString("hex"),"' at path: [").concat(n,"] not a ").concat(a.size," bytes")});default:return t}}))}var w=p.a.extend((function(t){return{name:"binary",base:t.any(),pre:function(t,n,r){if(r.convert&&"string"==typeof t)try{return e.from(t,"hex")}catch(e){return}return e.from(t)},rules:[{name:"bufferCheck",params:{size:t.number().required()},validate:function(t,n,r,a){return n="string"===n?e.from(n,"hex"):e.from(n),e.isBuffer(n)?n.length!==t.size?this.createError("binary.bufferCheck",{value:n,size:t.size},r,a):n:this.createError("binary.base",{value:n},r,a)}}]}}));function O(e,t){var n=p.a.array().ordered(e.arguments.map((function(n,r){return function e(t){var n,r,o=(arguments.length>1&&void 0!==arguments[1]?arguments[1]:{}).bindings,i=g(t,{bindings:o}),c=i.t,u=i.generic;switch(Object.keys(v).includes(c)||(c=v.address),c){case v.int:return p.a.number().error(x);case v.variant:return p.a.alternatives().try([(n=p.a.string()).valid.apply(n,a()(u.reduce((function(e,t){var n=Object.entries(t),r=s()(n,1),a=s()(r[0],2),o=a[0],i=a[1];return i&&i.length||e.push(o),e}),[]))),(r=p.a.object(u.reduce((function(e,t){var n=Object.keys(t)[0];return h({},e,f()({},n,p.a.array()))}),{}))).or.apply(r,a()(u.map((function(e){return Object.keys(e)[0]}))))]);case v.string:return p.a.string().error(x);case v.address:return p.a.string().regex(/^(ak_|ct_|ok_|oq_)/).error(x);case v.bool:return p.a.boolean().error(x);case v.list:return p.a.array().items(e(u,{bindings:o})).error(x);case v.tuple:return p.a.array().ordered(u.map((function(t){return e(t,{bindings:o}).required()}))).label("Tuple argument").error(x);case v.record:return p.a.object(u.reduce((function(t,n){var r=n.name,a=n.type;return h({},t,f()({},r,e(a,{bindings:o})))}),{})).error(x);case v.hash:return w.binary().bufferCheck(32).error(x);case v.bytes:return w.binary().bufferCheck(u).error(x);case v.signature:return w.binary().bufferCheck(64).error(x);case v.option:return e(u,{bindings:o}).optional().error(x);default:return p.a.any()}}(n.type,{bindings:e.bindings}).label("[".concat(t[r],"]"))}))).sparse(!0).label("Argument"),r=p.a.validate(t,n,{abortEarly:!1}).error;if(r)throw r}}).call(this,n(22).Buffer)},function(e,t){e.exports=c},function(e,t){e.exports=Array.isArray||function(e){return null!=e&&e.length>=0&&"[object Array]"===Object.prototype.toString.call(e)}},function(e,t,n){var r=n(48),a=n(57);e.exports=function e(t,n,o){return function(){for(var i=[],c=0,s=t,u=0;u<n.length||c<arguments.length;){var f;u<n.length&&(!a(n[u])||c>=arguments.length)?f=n[u]:(f=arguments[c],c+=1),i[u]=f,a(f)||(s-=1),u+=1}return s<=0?o.apply(this,i):r(s,e(t,i,o))}}},function(e,t,n){var r=n(11),a=n(159),o=n(58),i=n(34),c=r((function(e,t){return o(e+1,(function(){var n=arguments[e];if(null!=n&&a(n[t]))return n[t].apply(n,Array.prototype.slice.call(arguments,0,e));throw new TypeError(i(n)+' does not have a method named "'+t+'"')}))}));e.exports=c},function(e,t,n){var r=n(50)(n(49));e.exports=r},function(e,t,n){var r=n(15),a=n(58),o=r((function(e){return a(e.length,(function(t,n){var r=Array.prototype.slice.call(arguments,0);return r[0]=n,r[1]=t,e.apply(this,r)}))}));e.exports=o},function(e,t,n){var r=n(15),a=n(58),o=r((function(e){return a(e.length,e)}));e.exports=o},function(e,t){e.exports=s},function(e,t){e.exports=u},function(e,t,n){var r=n(11)((function(e,t){return e<t}));e.exports=r},function(e,t,n){"use strict";(function(e){n.d(t,"a",(function(){return s})),n.d(t,"b",(function(){return u}));var r=n(6),a=n.n(r),o=n(1),i=n.n(o);n(5);function c(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function s(e){return{rootHash:e[0].toString("hex"),nodes:e[1].reduce((function(e,t){return function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?c(n,!0).forEach((function(t){i()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):c(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}({},e,i()({},t[0].toString("hex"),t[1]))}),{})}}function u(t){return[e.from(t.rootHash,"hex"),Object.entries(t.nodes).map((function(t){var n=a()(t,2),r=n[0],o=n[1];return[e.from(r,"hex"),o]}))]}}).call(this,n(22).Buffer)},function(e,t,n){var r=n(72)(0,"toUpperCase");e.exports=r},function(e,t,n){var r=n(11)((function(e,t){return null==t||t!=t?e:t}));e.exports=r},function(e,t,n){var r=n(15),a=n(32),o=r((function(e){var t=[];for(var n in e)a(n,e)&&(t[t.length]=[n,e[n]]);return t}));e.exports=o},function(e,t,n){var r=n(11),a=n(164),o=r((function(e,t){return a((function(e,t,n){return n}),e,t)}));e.exports=o},function(e,t,n){var r=n(100),a=n(11)(r("groupBy",n(101)((function(e,t){return null==e&&(e=[]),e.push(t),e}),null)));e.exports=a},function(e,t,n){var r=n(15)(n(167));e.exports=r},function(e,t,n){var r=n(101)((function(e,t){return t}),null);e.exports=r},function(e,t){e.exports=f},function(e,t){e.exports=function(e){if(Array.isArray(e))return e}},function(e,t){e.exports=function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}},function(e,t){e.exports=function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}},function(e,t,n){var r=n(11),a=n(92),o=r((function(e,t){var n=e<0?t.length+e:e;return a(t)?t.charAt(n):t[n]}));e.exports=o},function(e,t){e.exports=function(e){return"[object String]"===Object.prototype.toString.call(e)}},function(e,t,n){var r=n(11),a=n(38),o=n(94),i=n(49),c=n(145),s=n(58),u=n(23),f=r(a(["fantasy-land/map","map"],c,(function(e,t){switch(Object.prototype.toString.call(t)){case"[object Function]":return s(t.length,(function(){return e.call(this,t.apply(this,arguments))}));case"[object Object]":return i((function(n,r){return n[r]=e(t[r]),n}),{},u(t));default:return o(e,t)}})));e.exports=f},function(e,t){e.exports=function(e,t){for(var n=0,r=t.length,a=Array(r);n<r;)a[n]=e(t[n]),n+=1;return a}},function(e,t,n){var r=n(15),a=n(70),o=n(92),i=r((function(e){return!!a(e)||!!e&&("object"==typeof e&&(!o(e)&&(1===e.nodeType?!!e.length:0===e.length||e.length>0&&(e.hasOwnProperty(0)&&e.hasOwnProperty(e.length-1)))))}));e.exports=i},function(e,t){e.exports=function(e,t,n){for(var r=0,a=n.length;r<a;){if(e(t,n[r]))return!0;r+=1}return!1}},function(e,t){e.exports="function"==typeof Object.is?Object.is:function(e,t){return e===t?0!==e||1/e==1/t:e!=e&&t!=t}},function(e,t){e.exports=function(e){return"[object Object]"===Object.prototype.toString.call(e)}},function(e,t,n){var r=n(32);e.exports="function"==typeof Object.assign?Object.assign:function(e){if(null==e)throw new TypeError("Cannot convert undefined or null to object");for(var t=Object(e),n=1,a=arguments.length;n<a;){var o=arguments[n];if(null!=o)for(var i in o)r(i,o)&&(t[i]=o[i]);n+=1}return t}},function(e,t,n){var r=n(70);e.exports=function(e,t){return function(){var n=arguments.length;if(0===n)return t();var a=arguments[n-1];return r(a)||"function"!=typeof a[e]?t.apply(this,arguments):a[e].apply(a,Array.prototype.slice.call(arguments,0,n-1))}}},function(e,t,n){var r=n(71),a=n(38),o=n(32),i=n(49),c=r(4,[],a([],n(166),(function(e,t,n,r){return i((function(r,a){var i=n(a);return r[i]=e(o(i,r)?r[i]:t,a),r}),{},r)})));e.exports=c},function(e,t,n){var r=n(100),a=n(50)(r("slice",(function(e,t,n){return Array.prototype.slice.call(n,e,t)})));e.exports=a},function(e,t){e.exports=function(e){return e&&e["@@transducer/reduced"]?e:{"@@transducer/value":e,"@@transducer/reduced":!0}}},function(e,t,n){"use strict";n.r(t),function(e){n.d(t,"deriveKeyUsingArgon2id",(function(){return b})),n.d(t,"getAddressFromPriv",(function(){return T})),n.d(t,"recover",(function(){return I})),n.d(t,"dump",(function(){return P})),n.d(t,"validateKeyObj",(function(){return A}));var r=n(1),a=n.n(r),o=n(0),i=n.n(o),c=n(16),s=n.n(c),u=n(129),f=n.n(u),l=n(5),p=n(19);function d(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function h(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?d(n,!0).forEach((function(t){a()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):d(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var v=n(174),y={crypto:{secret_type:"ed25519",symmetric_alg:"xsalsa20-poly1305",kdf:"argon2id",kdf_params:{memlimit_kib:65536,opslimit:3,parallelism:1}}},g={argon2id:b};function b(t,n,r){var a,o,c;return i.a.async((function(s){for(;;)switch(s.prev=s.next){case 0:return a=r.kdf_params,o=a.memlimit_kib,c=a.opslimit,s.abrupt("return",v.ready.then((function(){var r,a;return i.a.async((function(i){for(;;)switch(i.prev=i.next){case 0:return a=(r=v).crypto_pwhash(32,t,n,c,1024*o,r.crypto_pwhash_ALG_ARGON2ID13),i.abrupt("return",e.from(a));case 3:case"end":return i.stop()}}))})));case 2:case"end":return s.stop()}}))}var m={"xsalsa20-poly1305":{encrypt:function(e){var t=e.plaintext,n=e.key,r=e.nonce;return s.a.secretbox(t,r,n)},decrypt:function(e){var t=e.ciphertext,n=e.key,r=e.nonce,a=s.a.secretbox.open(t,r,n);if(!a)throw new Error("Invalid password or nonce");return a}}};function x(t,n){return t&&t.constructor===String?(!n&&Object(p.a)(t)&&(n="hex"),!n&&Object(l.isBase64)(t)&&(n="base64"),e.from(t,n)):t}function w(e,t,n){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:y.crypto.symmetric_alg;if(!m[r])throw new Error(r+" is not available");return m[r].encrypt({plaintext:e,nonce:n,key:t})}function O(e,t,n,r){if(!m[r])throw new Error(r+" is not available");return m[r].decrypt({ciphertext:e,nonce:n,key:t})}function j(e,t){var n,r=arguments;return i.a.async((function(a){for(;;)switch(a.prev=a.next){case 0:if(n=r.length>2&&void 0!==r[2]?r[2]:{kdf_params:y.crypto.kdf_params,kdf:y.crypto.kdf},null!=e&&t){a.next=3;break}throw new Error("Must provide password and nonce to derive a key");case 3:if(Object.prototype.hasOwnProperty.call(g,n.kdf)){a.next=5;break}throw new Error("Unsupported kdf type");case 5:return a.abrupt("return",g[n.kdf](e,t,n));case 6:case"end":return a.stop()}}))}function k(t,n,r,a,o){var i=arguments.length>5&&void 0!==arguments[5]?arguments[5]:{},c=Object.assign({},y.crypto,i);return Object.assign({name:t,version:1,public_key:T(r),id:f.a.v4()},{crypto:Object.assign({secret_type:c.secret_type,symmetric_alg:c.symmetric_alg,ciphertext:e.from(w(e.from(r),n,a,c.symmetric_alg)).toString("hex"),cipher_params:{nonce:e.from(a).toString("hex")}},{kdf:c.kdf,kdf_params:h({},c.kdf_params,{salt:e.from(o).toString("hex")})})})}function T(t){var n=s.a.sign.keyPair.fromSecretKey(x(t)),r=e.from(n.publicKey);return"ak_".concat(Object(l.encodeBase58Check)(r))}function I(t,n){var r,a,o,c,s;return i.a.async((function(u){for(;;)switch(u.prev=u.next){case 0:return A(n),r=Uint8Array.from(x(n.crypto.cipher_params.nonce)),a=Uint8Array.from(x(n.crypto.kdf_params.salt)),o=n.crypto.kdf_params,c=n.crypto.kdf,u.t0=i.a,u.t1=O,u.t2=Uint8Array.from(x(n.crypto.ciphertext)),u.next=10,i.a.awrap(j(t,a,{kdf:c,kdf_params:o}));case 10:return u.t3=u.sent,u.t4=r,u.t5=n.crypto.symmetric_alg,u.t6=(0,u.t1)(u.t2,u.t3,u.t4,u.t5),u.next=16,u.t0.awrap.call(u.t0,u.t6);case 16:if(s=u.sent){u.next=19;break}throw new Error("Invalid password");case 19:return u.abrupt("return",e.from(s).toString("hex"));case 20:case"end":return u.stop()}}))}function P(e,t,n){var r,a,o,c,u=arguments;return i.a.async((function(f){for(;;)switch(f.prev=f.next){case 0:return r=u.length>3&&void 0!==u[3]?u[3]:s.a.randomBytes(24),a=u.length>4&&void 0!==u[4]?u[4]:s.a.randomBytes(16),o=u.length>5&&void 0!==u[5]?u[5]:{},c=Object.assign({},y.crypto,o),f.t0=k,f.t1=e,f.next=8,i.a.awrap(j(t,a,c));case 8:return f.t2=f.sent,f.t3=n,f.t4=r,f.t5=a,f.t6=c,f.abrupt("return",(0,f.t0)(f.t1,f.t2,f.t3,f.t4,f.t5,f.t6));case 14:case"end":return f.stop()}}))}function A(e){var t=["crypto","id","version","public_key"].filter((function(t){return!Object.prototype.hasOwnProperty.call(e,t)}));if(t.length)throw new Error("Invalid key file format. Require properties: ".concat(t));var n=["cipher_params","ciphertext","symmetric_alg","kdf","kdf_params"].filter((function(t){return!Object.prototype.hasOwnProperty.call(e.crypto,t)}));if(n.length)throw new Error("Invalid key file format. Require properties: ".concat(n));return!0}}.call(this,n(22).Buffer)},function(e,t,n){"use strict";(function(e){var r=n(16),a=n.n(r),o=n(87),i=n(130),c=n(69),s=n(5),u=e.from("ed25519 seed"),f=2147483648,l=function(t){return e.from(t).toString("hex")};function p(e,t){var n=""===e?[]:Object(i.fromString)(e).toPathArray();return n.forEach((function(e,t){if(e<f)throw new Error("Segment #".concat(t+1," is not hardened"))})),n.reduce((function(e,t){return h(e,t)}),t)}function d(e){var t=Object(o.full)(e,u);return{secretKey:t.slice(0,32),chainCode:t.slice(32)}}function h(t,n){var r=t.secretKey,a=t.chainCode;if(n<f)throw new Error("Child index #".concat(n," is not supported"));var i=e.allocUnsafe(4);i.writeUInt32BE(n,0);var c=e.concat([e.alloc(1,0),r,i]),s=Object(o.full)(c,a);return{secretKey:s.slice(0,32),chainCode:s.slice(32)}}t.a={getSaveHDWalletAccounts:function(t,n,r){var o={secretKey:Object(s.decryptKey)(n,e.from(t.secretKey,"hex")),chainCode:Object(s.decryptKey)(n,e.from(t.chainCode,"hex"))};return new Array(r).fill().map((function(e,t){return function(e){var t=e.secretKey,n=e.publicKey;return{secretKey:l(t),publicKey:"ak_".concat(Object(s.encodeBase58Check)(n))}}((n=p("".concat(t,"h/0h/0h"),o).secretKey,a.a.sign.keyPair.fromSeed(n)));var n}))},generateSaveHDWallet:function(e,t){if(!Object(c.validateMnemonic)(e))throw new Error("Invalid mnemonic");var n=function(e,t){if(!["m","m/"].includes(e.slice(0,2)))throw new Error("Invalid path");var n=d(t);return p(e.slice(2),n)}("m/44h/457h",Object(c.mnemonicToSeed)(e));return{secretKey:l(Object(s.encryptKey)(t,n.secretKey)),chainCode:l(Object(s.encryptKey)(t,n.chainCode))}},generateMnemonic:function(){return Object(c.generateMnemonic)()},deriveChild:h,getMasterKeyFromSeed:d}}).call(this,n(22).Buffer)},function(e,t){e.exports=l},function(e,t){e.exports=p},function(e,t){e.exports=d},function(e,t,n){"use strict";n.d(t,"a",(function(){return a}));var r=n(3);function a(e){return e.integerValue(r.BigNumber.ROUND_CEIL)}},function(e,t,n){var r=n(48),a=n(15),o=n(93),i=n(147),c=n(73),s=a((function(e){var t=c(i,0,o((function(e){return e[0].length}),e));return r(t,(function(){for(var t=0;t<e.length;){if(e[t][0].apply(this,arguments))return e[t][1].apply(this,arguments);t+=1}}))}));e.exports=s},function(e,t,n){var r=n(11)((function(e,t){return e<=t}));e.exports=r},function(e,t){e.exports=function(){return!0}},function(e,t,n){var r=n(59),a=n(11),o=n(74),i=n(51),c=a((function(e,t){return i(o(r)(e),t)}));e.exports=c},function(e,t,n){var r=n(96),a=n(11)((function(e,t){for(var n,a=0,o=t.length,i=[];a<o;)n=t[a],r(e,n,i)||(i[i.length]=n),a+=1;return i}));e.exports=a},function(e,t,n){var r=n(97),a=n(11)(r);e.exports=a},function(e,t,n){var r=n(72)(0,"toLowerCase");e.exports=r},function(e,t,n){var r=n(11),a=n(163),o=r((function(e,t){for(var n=[],r=0,o=e.length,i=t.length,c=new a,s=0;s<i;s+=1)c.add(t[s]);for(;r<o;)c.add(e[r])&&(n[n.length]=e[r]),r+=1;return n}));e.exports=o},function(e,t,n){var r=n(99),a=n(15)((function(e){return r.apply(null,[{}].concat(e))}));e.exports=a},function(e,t,n){var r=n(50)((function(e,t,n){var r={};for(var a in n)r[a]=n[a];return r[e]=t,r}));e.exports=r},function(e,t,n){var r=n(11),a=n(168),o=r((function(e,t){return a([e],t)}));e.exports=o},function(e,t,n){var r=n(11),a=n(38),o=n(169),i=n(102),c=r(a(["drop"],o,(function(e,t){return i(Math.max(0,e),1/0,t)})));e.exports=c},function(e,t,n){var r=n(11),a=n(38),o=n(170),i=r(a([],n(173),o));e.exports=i},function(e,t,n){var r=n(11)((function(e,t){for(var n=0,r=Math.min(e.length,t.length),a={};n<r;)a[e[n]]=t[n],n+=1;return a}));e.exports=r},function(e,t,n){var r=n(88),a=n(90),o=n(89);e.exports=function(e){return r(e)||a(e)||o()}},function(e,t){e.exports=h},function(e,t,n){"use strict";var r,a="object"==typeof Reflect?Reflect:null,o=a&&"function"==typeof a.apply?a.apply:function(e,t,n){return Function.prototype.apply.call(e,t,n)};r=a&&"function"==typeof a.ownKeys?a.ownKeys:Object.getOwnPropertySymbols?function(e){return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e))}:function(e){return Object.getOwnPropertyNames(e)};var i=Number.isNaN||function(e){return e!=e};function c(){c.init.call(this)}e.exports=c,c.EventEmitter=c,c.prototype._events=void 0,c.prototype._eventsCount=0,c.prototype._maxListeners=void 0;var s=10;function u(e){return void 0===e._maxListeners?c.defaultMaxListeners:e._maxListeners}function f(e,t,n,r){var a,o,i,c;if("function"!=typeof n)throw new TypeError('The "listener" argument must be of type Function. Received type '+typeof n);if(void 0===(o=e._events)?(o=e._events=Object.create(null),e._eventsCount=0):(void 0!==o.newListener&&(e.emit("newListener",t,n.listener?n.listener:n),o=e._events),i=o[t]),void 0===i)i=o[t]=n,++e._eventsCount;else if("function"==typeof i?i=o[t]=r?[n,i]:[i,n]:r?i.unshift(n):i.push(n),(a=u(e))>0&&i.length>a&&!i.warned){i.warned=!0;var s=new Error("Possible EventEmitter memory leak detected. "+i.length+" "+String(t)+" listeners added. Use emitter.setMaxListeners() to increase limit");s.name="MaxListenersExceededWarning",s.emitter=e,s.type=t,s.count=i.length,c=s,console&&console.warn&&console.warn(c)}return e}function l(){for(var e=[],t=0;t<arguments.length;t++)e.push(arguments[t]);this.fired||(this.target.removeListener(this.type,this.wrapFn),this.fired=!0,o(this.listener,this.target,e))}function p(e,t,n){var r={fired:!1,wrapFn:void 0,target:e,type:t,listener:n},a=l.bind(r);return a.listener=n,r.wrapFn=a,a}function d(e,t,n){var r=e._events;if(void 0===r)return[];var a=r[t];return void 0===a?[]:"function"==typeof a?n?[a.listener||a]:[a]:n?function(e){for(var t=new Array(e.length),n=0;n<t.length;++n)t[n]=e[n].listener||e[n];return t}(a):v(a,a.length)}function h(e){var t=this._events;if(void 0!==t){var n=t[e];if("function"==typeof n)return 1;if(void 0!==n)return n.length}return 0}function v(e,t){for(var n=new Array(t),r=0;r<t;++r)n[r]=e[r];return n}Object.defineProperty(c,"defaultMaxListeners",{enumerable:!0,get:function(){return s},set:function(e){if("number"!=typeof e||e<0||i(e))throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received '+e+".");s=e}}),c.init=function(){void 0!==this._events&&this._events!==Object.getPrototypeOf(this)._events||(this._events=Object.create(null),this._eventsCount=0),this._maxListeners=this._maxListeners||void 0},c.prototype.setMaxListeners=function(e){if("number"!=typeof e||e<0||i(e))throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received '+e+".");return this._maxListeners=e,this},c.prototype.getMaxListeners=function(){return u(this)},c.prototype.emit=function(e){for(var t=[],n=1;n<arguments.length;n++)t.push(arguments[n]);var r="error"===e,a=this._events;if(void 0!==a)r=r&&void 0===a.error;else if(!r)return!1;if(r){var i;if(t.length>0&&(i=t[0]),i instanceof Error)throw i;var c=new Error("Unhandled error."+(i?" ("+i.message+")":""));throw c.context=i,c}var s=a[e];if(void 0===s)return!1;if("function"==typeof s)o(s,this,t);else{var u=s.length,f=v(s,u);for(n=0;n<u;++n)o(f[n],this,t)}return!0},c.prototype.addListener=function(e,t){return f(this,e,t,!1)},c.prototype.on=c.prototype.addListener,c.prototype.prependListener=function(e,t){return f(this,e,t,!0)},c.prototype.once=function(e,t){if("function"!=typeof t)throw new TypeError('The "listener" argument must be of type Function. Received type '+typeof t);return this.on(e,p(this,e,t)),this},c.prototype.prependOnceListener=function(e,t){if("function"!=typeof t)throw new TypeError('The "listener" argument must be of type Function. Received type '+typeof t);return this.prependListener(e,p(this,e,t)),this},c.prototype.removeListener=function(e,t){var n,r,a,o,i;if("function"!=typeof t)throw new TypeError('The "listener" argument must be of type Function. Received type '+typeof t);if(void 0===(r=this._events))return this;if(void 0===(n=r[e]))return this;if(n===t||n.listener===t)0==--this._eventsCount?this._events=Object.create(null):(delete r[e],r.removeListener&&this.emit("removeListener",e,n.listener||t));else if("function"!=typeof n){for(a=-1,o=n.length-1;o>=0;o--)if(n[o]===t||n[o].listener===t){i=n[o].listener,a=o;break}if(a<0)return this;0===a?n.shift():function(e,t){for(;t+1<e.length;t++)e[t]=e[t+1];e.pop()}(n,a),1===n.length&&(r[e]=n[0]),void 0!==r.removeListener&&this.emit("removeListener",e,i||t)}return this},c.prototype.off=c.prototype.removeListener,c.prototype.removeAllListeners=function(e){var t,n,r;if(void 0===(n=this._events))return this;if(void 0===n.removeListener)return 0===arguments.length?(this._events=Object.create(null),this._eventsCount=0):void 0!==n[e]&&(0==--this._eventsCount?this._events=Object.create(null):delete n[e]),this;if(0===arguments.length){var a,o=Object.keys(n);for(r=0;r<o.length;++r)"removeListener"!==(a=o[r])&&this.removeAllListeners(a);return this.removeAllListeners("removeListener"),this._events=Object.create(null),this._eventsCount=0,this}if("function"==typeof(t=n[e]))this.removeListener(e,t);else if(void 0!==t)for(r=t.length-1;r>=0;r--)this.removeListener(e,t[r]);return this},c.prototype.listeners=function(e){return d(this,e,!0)},c.prototype.rawListeners=function(e){return d(this,e,!1)},c.listenerCount=function(e,t){return"function"==typeof e.listenerCount?e.listenerCount(t):h.call(e,t)},c.prototype.listenerCount=h,c.prototype.eventNames=function(){return this._eventsCount>0?r(this._events):[]}},function(e,t,n){var r=n(48),a=n(15)((function(e){var t,n=!1;return r(e.length,(function(){return n?t:(n=!0,t=e.apply(this,arguments))}))}));e.exports=a},function(e,t,n){var r=n(11)((function(e,t){var n={};for(var r in t)e(t[r],r,t)&&(n[r]=t[r]);return n}));e.exports=r},function(e,t){e.exports=v},function(e,t){e.exports=y},function(e,t,n){var r=n(175),a=n(176);e.exports=function(e,t,n){var o=t&&n||0;"string"==typeof e&&(t="binary"===e?new Array(16):null,e=null);var i=(e=e||{}).random||(e.rng||r)();if(i[6]=15&i[6]|64,i[8]=63&i[8]|128,t)for(var c=0;c<16;++c)t[o+c]=i[c];return t||a(i)}},function(e,t,n){var r=n(75)((function(e){return e.apply(this,Array.prototype.slice.call(arguments,1))}));e.exports=r},function(e,t,n){var r=n(11)(n(38)(["find"],n(177),(function(e,t){for(var n=0,r=t.length;n<r;){if(e(t[n]))return t[n];n+=1}})));e.exports=r},function(e,t){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){"use strict";t.byteLength=function(e){var t=u(e),n=t[0],r=t[1];return 3*(n+r)/4-r},t.toByteArray=function(e){var t,n,r=u(e),i=r[0],c=r[1],s=new o(function(e,t,n){return 3*(t+n)/4-n}(0,i,c)),f=0,l=c>0?i-4:i;for(n=0;n<l;n+=4)t=a[e.charCodeAt(n)]<<18|a[e.charCodeAt(n+1)]<<12|a[e.charCodeAt(n+2)]<<6|a[e.charCodeAt(n+3)],s[f++]=t>>16&255,s[f++]=t>>8&255,s[f++]=255&t;2===c&&(t=a[e.charCodeAt(n)]<<2|a[e.charCodeAt(n+1)]>>4,s[f++]=255&t);1===c&&(t=a[e.charCodeAt(n)]<<10|a[e.charCodeAt(n+1)]<<4|a[e.charCodeAt(n+2)]>>2,s[f++]=t>>8&255,s[f++]=255&t);return s},t.fromByteArray=function(e){for(var t,n=e.length,a=n%3,o=[],i=0,c=n-a;i<c;i+=16383)o.push(f(e,i,i+16383>c?c:i+16383));1===a?(t=e[n-1],o.push(r[t>>2]+r[t<<4&63]+"==")):2===a&&(t=(e[n-2]<<8)+e[n-1],o.push(r[t>>10]+r[t>>4&63]+r[t<<2&63]+"="));return o.join("")};for(var r=[],a=[],o="undefined"!=typeof Uint8Array?Uint8Array:Array,i="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",c=0,s=i.length;c<s;++c)r[c]=i[c],a[i.charCodeAt(c)]=c;function u(e){var t=e.length;if(t%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var n=e.indexOf("=");return-1===n&&(n=t),[n,n===t?0:4-n%4]}function f(e,t,n){for(var a,o,i=[],c=t;c<n;c+=3)a=(e[c]<<16&16711680)+(e[c+1]<<8&65280)+(255&e[c+2]),i.push(r[(o=a)>>18&63]+r[o>>12&63]+r[o>>6&63]+r[63&o]);return i.join("")}a["-".charCodeAt(0)]=62,a["_".charCodeAt(0)]=63},function(e,t){t.read=function(e,t,n,r,a){var o,i,c=8*a-r-1,s=(1<<c)-1,u=s>>1,f=-7,l=n?a-1:0,p=n?-1:1,d=e[t+l];for(l+=p,o=d&(1<<-f)-1,d>>=-f,f+=c;f>0;o=256*o+e[t+l],l+=p,f-=8);for(i=o&(1<<-f)-1,o>>=-f,f+=r;f>0;i=256*i+e[t+l],l+=p,f-=8);if(0===o)o=1-u;else{if(o===s)return i?NaN:1/0*(d?-1:1);i+=Math.pow(2,r),o-=u}return(d?-1:1)*i*Math.pow(2,o-r)},t.write=function(e,t,n,r,a,o){var i,c,s,u=8*o-a-1,f=(1<<u)-1,l=f>>1,p=23===a?Math.pow(2,-24)-Math.pow(2,-77):0,d=r?0:o-1,h=r?1:-1,v=t<0||0===t&&1/t<0?1:0;for(t=Math.abs(t),isNaN(t)||t===1/0?(c=isNaN(t)?1:0,i=f):(i=Math.floor(Math.log(t)/Math.LN2),t*(s=Math.pow(2,-i))<1&&(i--,s*=2),(t+=i+l>=1?p/s:p*Math.pow(2,1-l))*s>=2&&(i++,s/=2),i+l>=f?(c=0,i=f):i+l>=1?(c=(t*s-1)*Math.pow(2,a),i+=l):(c=t*Math.pow(2,l-1)*Math.pow(2,a),i=0));a>=8;e[n+d]=255&c,d+=h,c/=256,a-=8);for(i=i<<a|c,u+=a;u>0;e[n+d]=255&i,d+=h,i/=256,u-=8);e[n+d-h]|=128*v}},function(e,t){var n={}.toString;e.exports=Array.isArray||function(e){return"[object Array]"==n.call(e)}},function(e,t,n){var r=function(e){"use strict";var t,n=Object.prototype,r=n.hasOwnProperty,a="function"==typeof Symbol?Symbol:{},o=a.iterator||"@@iterator",i=a.asyncIterator||"@@asyncIterator",c=a.toStringTag||"@@toStringTag";function s(e,t,n,r){var a=t&&t.prototype instanceof v?t:v,o=Object.create(a.prototype),i=new P(r||[]);return o._invoke=function(e,t,n){var r=f;return function(a,o){if(r===p)throw new Error("Generator is already running");if(r===d){if("throw"===a)throw o;return C()}for(n.method=a,n.arg=o;;){var i=n.delegate;if(i){var c=k(i,n);if(c){if(c===h)continue;return c}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if(r===f)throw r=d,n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);r=p;var s=u(e,t,n);if("normal"===s.type){if(r=n.done?d:l,s.arg===h)continue;return{value:s.arg,done:n.done}}"throw"===s.type&&(r=d,n.method="throw",n.arg=s.arg)}}}(e,n,i),o}function u(e,t,n){try{return{type:"normal",arg:e.call(t,n)}}catch(e){return{type:"throw",arg:e}}}e.wrap=s;var f="suspendedStart",l="suspendedYield",p="executing",d="completed",h={};function v(){}function y(){}function g(){}var b={};b[o]=function(){return this};var m=Object.getPrototypeOf,x=m&&m(m(A([])));x&&x!==n&&r.call(x,o)&&(b=x);var w=g.prototype=v.prototype=Object.create(b);function O(e){["next","throw","return"].forEach((function(t){e[t]=function(e){return this._invoke(t,e)}}))}function j(e){var t;this._invoke=function(n,a){function o(){return new Promise((function(t,o){!function t(n,a,o,i){var c=u(e[n],e,a);if("throw"!==c.type){var s=c.arg,f=s.value;return f&&"object"==typeof f&&r.call(f,"__await")?Promise.resolve(f.__await).then((function(e){t("next",e,o,i)}),(function(e){t("throw",e,o,i)})):Promise.resolve(f).then((function(e){s.value=e,o(s)}),(function(e){return t("throw",e,o,i)}))}i(c.arg)}(n,a,t,o)}))}return t=t?t.then(o,o):o()}}function k(e,n){var r=e.iterator[n.method];if(r===t){if(n.delegate=null,"throw"===n.method){if(e.iterator.return&&(n.method="return",n.arg=t,k(e,n),"throw"===n.method))return h;n.method="throw",n.arg=new TypeError("The iterator does not provide a 'throw' method")}return h}var a=u(r,e.iterator,n.arg);if("throw"===a.type)return n.method="throw",n.arg=a.arg,n.delegate=null,h;var o=a.arg;return o?o.done?(n[e.resultName]=o.value,n.next=e.nextLoc,"return"!==n.method&&(n.method="next",n.arg=t),n.delegate=null,h):o:(n.method="throw",n.arg=new TypeError("iterator result is not an object"),n.delegate=null,h)}function T(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function I(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function P(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(T,this),this.reset(!0)}function A(e){if(e){var n=e[o];if(n)return n.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var a=-1,i=function n(){for(;++a<e.length;)if(r.call(e,a))return n.value=e[a],n.done=!1,n;return n.value=t,n.done=!0,n};return i.next=i}}return{next:C}}function C(){return{value:t,done:!0}}return y.prototype=w.constructor=g,g.constructor=y,g[c]=y.displayName="GeneratorFunction",e.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===y||"GeneratorFunction"===(t.displayName||t.name))},e.mark=function(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,g):(e.__proto__=g,c in e||(e[c]="GeneratorFunction")),e.prototype=Object.create(w),e},e.awrap=function(e){return{__await:e}},O(j.prototype),j.prototype[i]=function(){return this},e.AsyncIterator=j,e.async=function(t,n,r,a){var o=new j(s(t,n,r,a));return e.isGeneratorFunction(n)?o:o.next().then((function(e){return e.done?e.value:o.next()}))},O(w),w[c]="Generator",w[o]=function(){return this},w.toString=function(){return"[object Generator]"},e.keys=function(e){var t=[];for(var n in e)t.push(n);return t.reverse(),function n(){for(;t.length;){var r=t.pop();if(r in e)return n.value=r,n.done=!1,n}return n.done=!0,n}},e.values=A,P.prototype={constructor:P,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=t,this.done=!1,this.delegate=null,this.method="next",this.arg=t,this.tryEntries.forEach(I),!e)for(var n in this)"t"===n.charAt(0)&&r.call(this,n)&&!isNaN(+n.slice(1))&&(this[n]=t)},stop:function(){this.done=!0;var e=this.tryEntries[0].completion;if("throw"===e.type)throw e.arg;return this.rval},dispatchException:function(e){if(this.done)throw e;var n=this;function a(r,a){return c.type="throw",c.arg=e,n.next=r,a&&(n.method="next",n.arg=t),!!a}for(var o=this.tryEntries.length-1;o>=0;--o){var i=this.tryEntries[o],c=i.completion;if("root"===i.tryLoc)return a("end");if(i.tryLoc<=this.prev){var s=r.call(i,"catchLoc"),u=r.call(i,"finallyLoc");if(s&&u){if(this.prev<i.catchLoc)return a(i.catchLoc,!0);if(this.prev<i.finallyLoc)return a(i.finallyLoc)}else if(s){if(this.prev<i.catchLoc)return a(i.catchLoc,!0)}else{if(!u)throw new Error("try statement without catch or finally");if(this.prev<i.finallyLoc)return a(i.finallyLoc)}}}},abrupt:function(e,t){for(var n=this.tryEntries.length-1;n>=0;--n){var a=this.tryEntries[n];if(a.tryLoc<=this.prev&&r.call(a,"finallyLoc")&&this.prev<a.finallyLoc){var o=a;break}}o&&("break"===e||"continue"===e)&&o.tryLoc<=t&&t<=o.finallyLoc&&(o=null);var i=o?o.completion:{};return i.type=e,i.arg=t,o?(this.method="next",this.next=o.finallyLoc,h):this.complete(i)},complete:function(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),h},finish:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.finallyLoc===e)return this.complete(n.completion,n.afterLoc),I(n),h}},catch:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.tryLoc===e){var r=n.completion;if("throw"===r.type){var a=r.arg;I(n)}return a}}throw new Error("illegal catch attempt")},delegateYield:function(e,n,r){return this.delegate={iterator:A(e),resultName:n,nextLoc:r},"next"===this.method&&(this.arg=t),h}},e}(e.exports);try{regeneratorRuntime=r}catch(e){Function("r","regeneratorRuntime = r")(r)}},function(e,t){e.exports=function(e,t){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)){var n=[],r=!0,a=!1,o=void 0;try{for(var i,c=e[Symbol.iterator]();!(r=(i=c.next()).done)&&(n.push(i.value),!t||n.length!==t);r=!0);}catch(e){a=!0,o=e}finally{try{r||null==c.return||c.return()}finally{if(a)throw o}}return n}}},function(e,t){e.exports=function(e){if(Array.isArray(e)){for(var t=0,n=new Array(e.length);t<e.length;t++)n[t]=e[t];return n}}},function(e,t){e.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}},function(e,t){e.exports=function(e){return null!=e&&"function"==typeof e["@@transducer/step"]}},function(e,t){var n=function(){function e(e){this.f=e}return e.prototype["@@transducer/init"]=function(){throw new Error("init not implemented on XWrap")},e.prototype["@@transducer/result"]=function(e){return e},e.prototype["@@transducer/step"]=function(e,t){return this.f(e,t)},e}();e.exports=function(e){return new n(e)}},function(e,t,n){var r=n(48),a=n(11)((function(e,t){return r(e.length,(function(){return e.apply(t,arguments)}))}));e.exports=a},function(e,t,n){var r=n(11),a=n(39),o=function(){function e(e,t){this.xf=t,this.f=e}return e.prototype["@@transducer/init"]=a.init,e.prototype["@@transducer/result"]=a.result,e.prototype["@@transducer/step"]=function(e,t){return this.xf["@@transducer/step"](e,this.f(t))},e}(),i=r((function(e,t){return new o(e,t)}));e.exports=i},function(e,t,n){var r=n(32),a=Object.prototype.toString,o=function(){return"[object Arguments]"===a.call(arguments)?function(e){return"[object Arguments]"===a.call(e)}:function(e){return r("callee",e)}}();e.exports=o},function(e,t,n){var r=n(11)((function(e,t){return t>e?t:e}));e.exports=r},function(e,t){var n,r,a=e.exports={};function o(){throw new Error("setTimeout has not been defined")}function i(){throw new Error("clearTimeout has not been defined")}function c(e){if(n===setTimeout)return setTimeout(e,0);if((n===o||!n)&&setTimeout)return n=setTimeout,setTimeout(e,0);try{return n(e,0)}catch(t){try{return n.call(null,e,0)}catch(t){return n.call(this,e,0)}}}!function(){try{n="function"==typeof setTimeout?setTimeout:o}catch(e){n=o}try{r="function"==typeof clearTimeout?clearTimeout:i}catch(e){r=i}}();var s,u=[],f=!1,l=-1;function p(){f&&s&&(f=!1,s.length?u=s.concat(u):l=-1,u.length&&d())}function d(){if(!f){var e=c(p);f=!0;for(var t=u.length;t;){for(s=u,u=[];++l<t;)s&&s[l].run();l=-1,t=u.length}s=null,f=!1,function(e){if(r===clearTimeout)return clearTimeout(e);if((r===i||!r)&&clearTimeout)return r=clearTimeout,clearTimeout(e);try{r(e)}catch(t){try{return r.call(null,e)}catch(t){return r.call(this,e)}}}(e)}}function h(e,t){this.fun=e,this.array=t}function v(){}a.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];u.push(new h(e,t)),1!==u.length||f||c(d)},h.prototype.run=function(){this.fun.apply(null,this.array)},a.title="browser",a.browser=!0,a.env={},a.argv=[],a.version="",a.versions={},a.on=v,a.addListener=v,a.once=v,a.off=v,a.removeListener=v,a.removeAllListeners=v,a.emit=v,a.prependListener=v,a.prependOnceListener=v,a.listeners=function(e){return[]},a.binding=function(e){throw new Error("process.binding is not supported")},a.cwd=function(){return"/"},a.chdir=function(e){throw new Error("process.chdir is not supported")},a.umask=function(){return 0}},function(e,t,n){var r=n(150);e.exports=function(e,t,n){var a,o;if("function"==typeof e.indexOf)switch(typeof t){case"number":if(0===t){for(a=1/t;n<e.length;){if(0===(o=e[n])&&1/o===a)return n;n+=1}return-1}if(t!=t){for(;n<e.length;){if("number"==typeof(o=e[n])&&o!=o)return n;n+=1}return-1}return e.indexOf(t,n);case"string":case"boolean":case"function":case"undefined":return e.indexOf(t,n);case"object":if(null===t)return e.indexOf(t,n)}for(;n<e.length;){if(r(e[n],t))return n;n+=1}return-1}},function(e,t,n){var r=n(11),a=n(151),o=r((function(e,t){return a(e,t,[],[])}));e.exports=o},function(e,t,n){var r=n(152),a=n(96),o=n(153),i=n(32),c=n(97),s=n(23),u=n(36);function f(e,t,n,o){var i=r(e),c=r(t);function s(e,t){return l(e,t,n.slice(),o.slice())}return!a((function(e,t){return!a(s,t,e)}),c,i)}function l(e,t,n,r){if(c(e,t))return!0;var a=u(e);if(a!==u(t))return!1;if(null==e||null==t)return!1;if("function"==typeof e["fantasy-land/equals"]||"function"==typeof t["fantasy-land/equals"])return"function"==typeof e["fantasy-land/equals"]&&e["fantasy-land/equals"](t)&&"function"==typeof t["fantasy-land/equals"]&&t["fantasy-land/equals"](e);if("function"==typeof e.equals||"function"==typeof t.equals)return"function"==typeof e.equals&&e.equals(t)&&"function"==typeof t.equals&&t.equals(e);switch(a){case"Arguments":case"Array":case"Object":if("function"==typeof e.constructor&&"Promise"===o(e.constructor))return e===t;break;case"Boolean":case"Number":case"String":if(typeof e!=typeof t||!c(e.valueOf(),t.valueOf()))return!1;break;case"Date":if(!c(e.valueOf(),t.valueOf()))return!1;break;case"Error":return e.name===t.name&&e.message===t.message;case"RegExp":if(e.source!==t.source||e.global!==t.global||e.ignoreCase!==t.ignoreCase||e.multiline!==t.multiline||e.sticky!==t.sticky||e.unicode!==t.unicode)return!1}for(var p=n.length-1;p>=0;){if(n[p]===e)return r[p]===t;p-=1}switch(a){case"Map":return e.size===t.size&&f(e.entries(),t.entries(),n.concat([e]),r.concat([t]));case"Set":return e.size===t.size&&f(e.values(),t.values(),n.concat([e]),r.concat([t]));case"Arguments":case"Array":case"Object":case"Boolean":case"Number":case"String":case"Date":case"Error":case"RegExp":case"Int8Array":case"Uint8Array":case"Uint8ClampedArray":case"Int16Array":case"Uint16Array":case"Int32Array":case"Uint32Array":case"Float32Array":case"Float64Array":case"ArrayBuffer":break;default:return!1}var d=s(e);if(d.length!==s(t).length)return!1;var h=n.concat([e]),v=r.concat([t]);for(p=d.length-1;p>=0;){var y=d[p];if(!i(y,t)||!l(t[y],e[y],h,v))return!1;p-=1}return!0}e.exports=l},function(e,t){e.exports=function(e){for(var t,n=[];!(t=e.next()).done;)n.push(t.value);return n}},function(e,t){e.exports=function(e){var t=String(e).match(/^function (\w*)/);return null==t?"":t[1]}},function(e,t){e.exports=function(e){return function(){return!e.apply(this,arguments)}}},function(e,t,n){var r=n(11),a=n(38),o=n(156),i=n(98),c=n(49),s=n(157),u=n(23),f=r(a(["filter"],s,(function(e,t){return i(t)?c((function(n,r){return e(t[r])&&(n[r]=t[r]),n}),{},u(t)):o(e,t)})));e.exports=f},function(e,t){e.exports=function(e,t){for(var n=0,r=t.length,a=[];n<r;)e(t[n])&&(a[a.length]=t[n]),n+=1;return a}},function(e,t,n){var r=n(11),a=n(39),o=function(){function e(e,t){this.xf=t,this.f=e}return e.prototype["@@transducer/init"]=a.init,e.prototype["@@transducer/result"]=a.result,e.prototype["@@transducer/step"]=function(e,t){return this.f(t)?this.xf["@@transducer/step"](e,t):e},e}(),i=r((function(e,t){return new o(e,t)}));e.exports=i},function(e,t,n){var r=n(95);e.exports=function(e){return function t(n){for(var a,o,i,c=[],s=0,u=n.length;s<u;){if(r(n[s]))for(i=0,o=(a=e?t(n[s]):n[s]).length;i<o;)c[c.length]=a[i],i+=1;else c[c.length]=n[s];s+=1}return c}}},function(e,t){e.exports=function(e){return"[object Function]"===Object.prototype.toString.call(e)}},function(e,t,n){var r=n(59),a=n(94),o=n(161),i=n(162),c=n(23),s=n(51);e.exports=function e(t,n){var u=function(a){var o=n.concat([t]);return r(a,o)?"<Circular>":e(a,o)},f=function(e,t){return a((function(t){return o(t)+": "+u(e[t])}),t.slice().sort())};switch(Object.prototype.toString.call(t)){case"[object Arguments]":return"(function() { return arguments; }("+a(u,t).join(", ")+"))";case"[object Array]":return"["+a(u,t).concat(f(t,s((function(e){return/^\d+$/.test(e)}),c(t)))).join(", ")+"]";case"[object Boolean]":return"object"==typeof t?"new Boolean("+u(t.valueOf())+")":t.toString();case"[object Date]":return"new Date("+(isNaN(t.valueOf())?u(NaN):o(i(t)))+")";case"[object Null]":return"null";case"[object Number]":return"object"==typeof t?"new Number("+u(t.valueOf())+")":1/t==-1/0?"-0":t.toString(10);case"[object String]":return"object"==typeof t?"new String("+u(t.valueOf())+")":o(t);case"[object Undefined]":return"undefined";default:if("function"==typeof t.toString){var l=t.toString();if("[object Object]"!==l)return l}return"{"+f(t,c(t)).join(", ")+"}"}}},function(e,t){e.exports=function(e){return'"'+e.replace(/\\/g,"\\\\").replace(/[\b]/g,"\\b").replace(/\f/g,"\\f").replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/\t/g,"\\t").replace(/\v/g,"\\v").replace(/\0/g,"\\0").replace(/"/g,'\\"')+'"'}},function(e,t){var n=function(e){return(e<10?"0":"")+e},r="function"==typeof Date.prototype.toISOString?function(e){return e.toISOString()}:function(e){return e.getUTCFullYear()+"-"+n(e.getUTCMonth()+1)+"-"+n(e.getUTCDate())+"T"+n(e.getUTCHours())+":"+n(e.getUTCMinutes())+":"+n(e.getUTCSeconds())+"."+(e.getUTCMilliseconds()/1e3).toFixed(3).slice(2,5)+"Z"};e.exports=r},function(e,t,n){var r=n(59),a=function(){function e(){this._nativeSet="function"==typeof Set?new Set:null,this._items={}}return e.prototype.add=function(e){return!o(e,!0,this)},e.prototype.has=function(e){return o(e,!1,this)},e}();function o(e,t,n){var a,o=typeof e;switch(o){case"string":case"number":return 0===e&&1/e==-1/0?!!n._items["-0"]||(t&&(n._items["-0"]=!0),!1):null!==n._nativeSet?t?(a=n._nativeSet.size,n._nativeSet.add(e),n._nativeSet.size===a):n._nativeSet.has(e):o in n._items?e in n._items[o]||(t&&(n._items[o][e]=!0),!1):(t&&(n._items[o]={},n._items[o][e]=!0),!1);case"boolean":if(o in n._items){var i=e?1:0;return!!n._items[o][i]||(t&&(n._items[o][i]=!0),!1)}return t&&(n._items[o]=e?[!1,!0]:[!0,!1]),!1;case"function":return null!==n._nativeSet?t?(a=n._nativeSet.size,n._nativeSet.add(e),n._nativeSet.size===a):n._nativeSet.has(e):o in n._items?!!r(e,n._items[o])||(t&&n._items[o].push(e),!1):(t&&(n._items[o]=[e]),!1);case"undefined":return!!n._items[o]||(t&&(n._items[o]=!0),!1);case"object":if(null===e)return!!n._items.null||(t&&(n._items.null=!0),!1);default:return(o=Object.prototype.toString.call(e))in n._items?!!r(e,n._items[o])||(t&&n._items[o].push(e),!1):(t&&(n._items[o]=[e]),!1)}}e.exports=a},function(e,t,n){var r=n(50),a=n(98),o=n(165),i=r((function e(t,n,r){return o((function(n,r,o){return a(r)&&a(o)?e(t,r,o):t(n,r,o)}),n,r)}));e.exports=i},function(e,t,n){var r=n(50),a=n(32),o=r((function(e,t,n){var r,o={};for(r in t)a(r,t)&&(o[r]=a(r,n)?e(r,t[r],n[r]):t[r]);for(r in n)a(r,n)&&!a(r,o)&&(o[r]=n[r]);return o}));e.exports=o},function(e,t,n){var r=n(71),a=n(32),o=n(39),i=function(){function e(e,t,n,r){this.valueFn=e,this.valueAcc=t,this.keyFn=n,this.xf=r,this.inputs={}}return e.prototype["@@transducer/init"]=o.init,e.prototype["@@transducer/result"]=function(e){var t;for(t in this.inputs)if(a(t,this.inputs)&&(e=this.xf["@@transducer/step"](e,this.inputs[t]))["@@transducer/reduced"]){e=e["@@transducer/value"];break}return this.inputs=null,this.xf["@@transducer/result"](e)},e.prototype["@@transducer/step"]=function(e,t){var n=this.keyFn(t);return this.inputs[n]=this.inputs[n]||[n,this.valueAcc],this.inputs[n][1]=this.valueFn(this.inputs[n][1],t),e},e}(),c=r(4,[],(function(e,t,n,r){return new i(e,t,n,r)}));e.exports=c},function(e,t){e.exports=function(e){return e}},function(e,t,n){var r=n(11),a=n(32),o=r((function(e,t){if(0===e.length)return!1;for(var n=t,r=0;r<e.length;){if(!a(e[r],n))return!1;n=n[e[r]],r+=1}return!0}));e.exports=o},function(e,t,n){var r=n(11),a=n(39),o=function(){function e(e,t){this.xf=t,this.n=e}return e.prototype["@@transducer/init"]=a.init,e.prototype["@@transducer/result"]=a.result,e.prototype["@@transducer/step"]=function(e,t){return this.n>0?(this.n-=1,e):this.xf["@@transducer/step"](e,t)},e}(),i=r((function(e,t){return new o(e,t)}));e.exports=i},function(e,t,n){var r=n(171);e.exports=function(e,t){return r(e<t.length?t.length-e:0,t)}},function(e,t,n){var r=n(11),a=n(38),o=n(172),i=n(102),c=r(a(["take"],o,(function(e,t){return i(0,e<0?1/0:e,t)})));e.exports=c},function(e,t,n){var r=n(11),a=n(103),o=n(39),i=function(){function e(e,t){this.xf=t,this.n=e,this.i=0}return e.prototype["@@transducer/init"]=o.init,e.prototype["@@transducer/result"]=o.result,e.prototype["@@transducer/step"]=function(e,t){this.i+=1;var n=0===this.n?e:this.xf["@@transducer/step"](e,t);return this.n>=0&&this.i>=this.n?a(n):n},e}(),c=r((function(e,t){return new i(e,t)}));e.exports=c},function(e,t,n){var r=n(11),a=n(39),o=function(){function e(e,t){this.xf=t,this.pos=0,this.full=!1,this.acc=new Array(e)}return e.prototype["@@transducer/init"]=a.init,e.prototype["@@transducer/result"]=function(e){return this.acc=null,this.xf["@@transducer/result"](e)},e.prototype["@@transducer/step"]=function(e,t){return this.full&&(e=this.xf["@@transducer/step"](e,this.acc[this.pos])),this.store(t),e},e.prototype.store=function(e){this.acc[this.pos]=e,this.pos+=1,this.pos===this.acc.length&&(this.pos=0,this.full=!0)},e}(),i=r((function(e,t){return new o(e,t)}));e.exports=i},function(e,t){e.exports=g},function(e,t){var n="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof window.msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto);if(n){var r=new Uint8Array(16);e.exports=function(){return n(r),r}}else{var a=new Array(16);e.exports=function(){for(var e,t=0;t<16;t++)0==(3&t)&&(e=4294967296*Math.random()),a[t]=e>>>((3&t)<<3)&255;return a}}},function(e,t){for(var n=[],r=0;r<256;++r)n[r]=(r+256).toString(16).substr(1);e.exports=function(e,t){var r=t||0,a=n;return[a[e[r++]],a[e[r++]],a[e[r++]],a[e[r++]],"-",a[e[r++]],a[e[r++]],"-",a[e[r++]],a[e[r++]],"-",a[e[r++]],a[e[r++]],"-",a[e[r++]],a[e[r++]],a[e[r++]],a[e[r++]],a[e[r++]],a[e[r++]]].join("")}},function(e,t,n){var r=n(11),a=n(103),o=n(39),i=function(){function e(e,t){this.xf=t,this.f=e,this.found=!1}return e.prototype["@@transducer/init"]=o.init,e.prototype["@@transducer/result"]=function(e){return this.found||(e=this.xf["@@transducer/step"](e,void 0)),this.xf["@@transducer/result"](e)},e.prototype["@@transducer/step"]=function(e,t){return this.f(t)&&(this.found=!0,e=a(this.xf["@@transducer/step"](e,t))),e},e}(),c=r((function(e,t){return new i(e,t)}));e.exports=c},function(e,t,n){"use strict";n.r(t);var r=n(5),a=n(104),o=n(17),i=n(10),c=n(9),s=n(105),u=n(20),f=n(43),l=n(6),p=n.n(l),d=n(23),h=n.n(d),v=n(8),y=n.n(v),g=n(0),b=n.n(g),m=n(1),x=n.n(m),w=n(4),O=n.n(w);var j=n(66).a.compose({methods:{getOracle:function(e){return b.a.async((function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",this.api.getOracleByPubkey(e));case 1:case"end":return t.stop()}}),null,this)},getOracleQueries:function(e){return b.a.async((function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",this.api.getOracleQueriesByPubkey(e));case 1:case"end":return t.stop()}}),null,this)},getOracleQuery:function(e,t){return b.a.async((function(n){for(;;)switch(n.prev=n.next){case 0:return n.abrupt("return",this.api.getOracleQueryByPubkeyAndQueryId(e,t));case 1:case"end":return n.stop()}}),null,this)}}}),k=n(3),T=n.n(k),I=[{name:"exa",magnitude:18},{name:"giga",magnitude:9},{name:"",magnitude:0},{name:"pico",magnitude:-12}],P=function(e){return I.reduce((function(t,n){return Math.abs(n.magnitude-e)<Math.abs(t.magnitude-e)?n:t}))},A=function(e){return I.find((function(t){return t.magnitude<=e}))||I[I.length-1]},C=function(e){k.BigNumber.isBigNumber(e)||(e=Object(k.BigNumber)(e));var t=(e.e<0?P:A)(e.e),n=t.name,r=t.magnitude,a=e.shiftedBy(-r).precision(9+Math.min(e.e-r,0)).toFixed();return"".concat(a).concat(n?" ":"").concat(n)},E=n(61),_=n(27);function S(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function B(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?S(n,!0).forEach((function(t){x()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):S(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function N(e){return b.a.async((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,b.a.awrap(new Promise((function(t){return setTimeout(t,e)})));case 2:case"end":return t.stop()}}))}var R=f.a.compose(j,E.a,_.b,{init:function(e){var t=e.verifyTx,n=void 0!==t&&t;this.verifyTxBeforeSend=n},methods:{sendTransaction:function(e){var t,n,r,a,o,i,c,s,u,f,l=this,p=arguments;return b.a.async((function(d){for(;;)switch(d.prev=d.next){case 0:if(t=p.length>1&&void 0!==p[1]?p[1]:{},n=O()(this.Chain.defaults,t),r=n.waitMined,a=n.verify,!this.verifyTxBeforeSend&&!a){d.next=11;break}return d.next=5,b.a.awrap(this.unpackAndVerify(e));case 5:if(o=d.sent,i=o.validation,c=o.tx,s=o.txType,!i.length){d.next=11;break}throw Object.assign(Error("Transaction verification error"),{code:"TX_VERIFICATION_ERROR",errorData:{validation:i,tx:c,txType:s},txHash:e});case 11:return d.prev=11,d.next=14,b.a.awrap(this.api.postTransaction({tx:e}));case 14:if(u=d.sent,f=u.txHash,!r){d.next=26;break}return d.t1=B,d.t2={},d.next=21,b.a.awrap(this.poll(f,t));case 21:d.t3=d.sent,d.t4={rawTx:e},d.t0=(0,d.t1)(d.t2,d.t3,d.t4),d.next=27;break;case 26:d.t0={hash:f,rawTx:e};case 27:return d.abrupt("return",d.t0);case 30:throw d.prev=30,d.t5=d.catch(11),Object.assign(new Error(d.t5.message),{rawTx:e,verifyTx:function(){return l.unpackAndVerify(e)}});case 33:case"end":return d.stop()}}),null,this,[[11,30]])},balance:function(e){var t,n,r,a,o,i,c,s=arguments;return b.a.async((function(u){for(;;)switch(u.prev=u.next){case 0:return t=s.length>1&&void 0!==s[1]?s[1]:{},n=t.height,r=t.hash,a=t.format,o=void 0!==a&&a,u.next=3,b.a.awrap(this.getAccount(e,{hash:r,height:n}));case 3:return i=u.sent,c=i.balance,u.abrupt("return",o?C(c):c.toString());case 6:case"end":return u.stop()}}),null,this)},getBalance:function(e){var t,n,r,a,o,i,c,s=arguments;return b.a.async((function(u){for(;;)switch(u.prev=u.next){case 0:return t=s.length>1&&void 0!==s[1]?s[1]:{},n=t.height,r=t.hash,a=t.format,o=void 0!==a&&a,u.next=3,b.a.awrap(this.getAccount(e,{hash:r,height:n}).catch((function(e){return{balance:0}})));case 3:return i=u.sent,c=i.balance,u.abrupt("return",o?C(c):c.toString());case 6:case"end":return u.stop()}}),null,this)},getAccount:function(e){var t,n,r,a=arguments;return b.a.async((function(o){for(;;)switch(o.prev=o.next){case 0:if(t=a.length>1&&void 0!==a[1]?a[1]:{},n=t.height,r=t.hash,!n){o.next=3;break}return o.abrupt("return",this.api.getAccountByPubkeyAndHeight(e,n));case 3:if(!r){o.next=5;break}return o.abrupt("return",this.api.getAccountByPubkeyAndHash(e,r));case 5:return o.abrupt("return",this.api.getAccountByPubkey(e));case 6:case"end":return o.stop()}}),null,this)},topBlock:function(){var e;return b.a.async((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,b.a.awrap(this.api.getTopBlock());case 2:return e=t.sent,t.abrupt("return",e[y()(h()(e))]);case 4:case"end":return t.stop()}}),null,this)},tx:function(e){var t,n,r=arguments;return b.a.async((function(a){for(;;)switch(a.prev=a.next){case 0:return t=r.length>1&&void 0!==r[1]&&r[1],a.next=3,b.a.awrap(this.api.getTransactionByHash(e));case 3:if(n=a.sent,!["ContractCreateTx","ContractCallTx"].includes(n.tx.type)||!t){a.next=19;break}return a.prev=5,a.t0=B,a.t1={},a.t2=n,a.t3={},a.next=12,b.a.awrap(this.getTxInfo(e));case 12:return a.t4=a.sent,a.abrupt("return",(0,a.t0)(a.t1,a.t2,a.t3,a.t4));case 16:return a.prev=16,a.t5=a.catch(5),a.abrupt("return",n);case 19:return a.abrupt("return",n);case 20:case"end":return a.stop()}}),null,this,[[5,16]])},height:function(){return b.a.async((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,b.a.awrap(this.api.getCurrentKeyBlockHeight());case 2:return e.abrupt("return",e.sent.height);case 3:case"end":return e.stop()}}),null,this)},awaitHeight:function(e){var t,n,r,a,o,i,c,s=arguments;return b.a.async((function(u){for(;;)switch(u.prev=u.next){case 0:return c=function(t){var n;return b.a.async((function(a){for(;;)switch(a.prev=a.next){case 0:return a.next=2,b.a.awrap(i.height());case 2:if(!((n=a.sent)>=e)){a.next=5;break}return a.abrupt("return",n);case 5:if(!(t>0)){a.next=9;break}return a.next=8,b.a.awrap(N(r));case 8:return a.abrupt("return",c(t-1));case 9:throw Error("Giving up after ".concat(o*r,"ms, current=").concat(n,", h=").concat(e));case 10:case"end":return a.stop()}}))},t=s.length>1&&void 0!==s[1]?s[1]:{},n=t.interval,r=void 0===n?5e3:n,a=t.attempts,o=void 0===a?20:a,i=this,u.abrupt("return",c(o));case 4:case"end":return u.stop()}}),null,this)},poll:function(e){var t,n,r,a,o,i,c,s,u=arguments;return b.a.async((function(f){for(;;)switch(f.prev=f.next){case 0:return s=function(){var t;return b.a.async((function(n){for(;;)switch(n.prev=n.next){case 0:return n.next=2,b.a.awrap(i.tx(e));case 2:if(-1===(t=n.sent).blockHeight){n.next=5;break}return n.abrupt("return",t);case 5:return n.next=7,b.a.awrap(i.height());case 7:if(n.t0=n.sent,n.t1=c,!(n.t0<n.t1)){n.next=13;break}return n.next=12,b.a.awrap(N(o));case 12:return n.abrupt("return",s());case 13:throw new Error("Giving up after ".concat(r," blocks mined. TxHash ").concat(e));case 14:case"end":return n.stop()}}))},t=u.length>1&&void 0!==u[1]?u[1]:{},n=t.blocks,r=void 0===n?10:n,a=t.interval,o=void 0===a?5e3:a,i=this,f.next=5,b.a.awrap(this.height());case 5:return f.t0=f.sent,f.t1=r,c=f.t0+f.t1,f.abrupt("return",s());case 9:case"end":return f.stop()}}),null,this)},getTxInfo:function(e){return b.a.async((function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",this.api.getTransactionInfoByHash(e).then((function(e){return e.callInfo?e.callInfo:e})));case 1:case"end":return t.stop()}}),null,this)},mempool:function(){return b.a.async((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",this.api.getPendingTransactions());case 1:case"end":return e.stop()}}),null,this)},getCurrentGeneration:function(){return b.a.async((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",this.api.getCurrentGeneration());case 1:case"end":return e.stop()}}),null,this)},getGeneration:function(e){return b.a.async((function(t){for(;;)switch(t.prev=t.next){case 0:if("string"!=typeof e){t.next=2;break}return t.abrupt("return",this.api.getGenerationByHash(e));case 2:if("number"!=typeof e){t.next=4;break}return t.abrupt("return",this.api.getGenerationByHeight(e));case 4:throw new Error("Invalid param, param must be hash or height");case 5:case"end":return t.stop()}}),null,this)},getMicroBlockHeader:function(e){return b.a.async((function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",this.api.getMicroBlockHeaderByHash(e));case 1:case"end":return t.stop()}}),null,this)},getMicroBlockTransactions:function(e){return b.a.async((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,b.a.awrap(this.api.getMicroBlockTransactionsByHash(e));case 2:return t.abrupt("return",t.sent.transactions);case 3:case"end":return t.stop()}}),null,this)},getKeyBlock:function(e){return b.a.async((function(t){for(;;)switch(t.prev=t.next){case 0:if("string"!=typeof e){t.next=2;break}return t.abrupt("return",this.api.getKeyBlockByHash(e));case 2:if("number"!=typeof e){t.next=4;break}return t.abrupt("return",this.api.getKeyBlockByHeight(e));case 4:throw new Error("Invalid param, param must be hash or height");case 5:case"end":return t.stop()}}),null,this)},txDryRun:function(e,t,n){var r,a,o,i;return b.a.async((function(c){for(;;)switch(c.prev=c.next){case 0:return r=this.getNodeInfo(),a=r.version,o=a.split("."),i=p()(o,1),5==+i[0]&&"5.0.0-rc.1"!==a&&(e=e.map((function(e){return{tx:e}}))),c.abrupt("return",this.api.dryRunTxs({txs:e,accounts:t,top:n}));case 4:case"end":return c.stop()}}),null,this)},getContractByteCode:function(e){return b.a.async((function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",this.api.getContractCode(e));case 1:case"end":return t.stop()}}),null,this)},getContract:function(e){return b.a.async((function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",this.api.getContract(e));case 1:case"end":return t.stop()}}),null,this)},getName:function(e){return b.a.async((function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",this.api.getNameEntryByName(e));case 1:case"end":return t.stop()}}),null,this)}}}),D=n(63),V=n(42),F=n(29),U=n.n(F),M=n(30),q=n.n(M),L=n(2);function K(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function H(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?K(n,!0).forEach((function(t){x()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):K(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function W(){var e,t,n,r,a=arguments;return b.a.async((function(o){for(;;)switch(o.prev=o.next){case 0:if(e=a.length>0&&void 0!==a[0]?a[0]:L.A,t=!(a.length>1&&void 0!==a[1])||a[1],0!==e){o.next=4;break}return o.abrupt("return",0);case 4:if(!(e<0)){o.next=6;break}throw new Error("ttl must be greater than 0");case 6:if(!t){o.next=12;break}return o.next=9,b.a.awrap(this.api.getCurrentKeyBlock());case 9:return n=o.sent,r=n.height,o.abrupt("return",+r+e);case 12:return o.abrupt("return",e);case 13:case"end":return o.stop()}}),null,this)}var Y=R.compose(V.a,{init:function(e){var t=e.nativeMode,n=void 0===t||t,r=e.showWarning,a=void 0!==r&&r;this.nativeMode=n,this.showWarning=a},props:{nativeMode:null,showWarning:null},methods:{spendTx:function(e){var t,n,r,a,o,c,s,u,f,l,p,d=arguments;return b.a.async((function(h){for(;;)switch(h.prev=h.next){case 0:return t=e.senderId,n=e.recipientId,r=e.amount,a=e.payload,o=void 0===a?"":a,h.next=3,b.a.awrap(this.prepareTxParams(L.B.spend,H({senderId:t},y()(d),{payload:o})));case 3:if(c=h.sent,s=c.fee,u=c.ttl,f=c.nonce,!this.nativeMode){h.next=11;break}h.t0=Object(i.buildTx)(O()(y()(d),{recipientId:n,senderId:t,nonce:f,ttl:u,fee:s,payload:o}),L.B.spend),h.next=14;break;case 11:return h.next=13,b.a.awrap(this.api.postSpend(O()(y()(d),{amount:parseInt(r),recipientId:n,senderId:t,nonce:f,ttl:u,fee:parseInt(s),payload:o})));case 13:h.t0=h.sent;case 14:return l=h.t0,p=l.tx,h.abrupt("return",p);case 17:case"end":return h.stop()}}),null,this)},namePreclaimTx:function(e){var t,n,r,a,o,c,s,u=arguments;return b.a.async((function(f){for(;;)switch(f.prev=f.next){case 0:return t=e.accountId,e.commitmentId,f.next=3,b.a.awrap(this.prepareTxParams(L.B.namePreClaim,H({senderId:t},y()(u))));case 3:if(n=f.sent,r=n.fee,a=n.ttl,o=n.nonce,!this.nativeMode){f.next=11;break}f.t0=Object(i.buildTx)(O()(y()(u),{nonce:o,ttl:a,fee:r}),L.B.namePreClaim),f.next=14;break;case 11:return f.next=13,b.a.awrap(this.api.postNamePreclaim(O()(y()(u),{nonce:o,ttl:a,fee:parseInt(r)})));case 13:f.t0=f.sent;case 14:return c=f.t0,s=c.tx,f.abrupt("return",s);case 17:case"end":return f.stop()}}),null,this)},nameClaimTx:function(e){var t,n,r,a,o,c,s,u,f,l=arguments;return b.a.async((function(p){for(;;)switch(p.prev=p.next){case 0:return t=e.accountId,e.name,e.nameSalt,n=e.vsn,r=void 0===n?2:n,p.next=3,b.a.awrap(this.prepareTxParams(L.B.nameClaim,H({senderId:t},y()(l),{vsn:r})));case 3:if(a=p.sent,o=a.fee,c=a.ttl,s=a.nonce,!this.nativeMode){p.next=11;break}p.t0=Object(i.buildTx)(O()(y()(l),{nonce:s,ttl:c,fee:o}),L.B.nameClaim,{vsn:r}),p.next=14;break;case 11:return p.next=13,b.a.awrap(this.api.postNameClaim(O()(y()(l),{nonce:s,ttl:c,fee:parseInt(o)})));case 13:p.t0=p.sent;case 14:return u=p.t0,f=u.tx,p.abrupt("return",f);case 17:case"end":return p.stop()}}),null,this)},nameTransferTx:function(e){var t,n,r,a,o,c,s,u,f=arguments;return b.a.async((function(l){for(;;)switch(l.prev=l.next){case 0:return t=e.accountId,e.nameId,n=e.recipientId,l.next=3,b.a.awrap(this.prepareTxParams(L.B.nameTransfer,H({senderId:t},y()(f))));case 3:if(r=l.sent,a=r.fee,o=r.ttl,c=r.nonce,!this.nativeMode){l.next=11;break}l.t0=Object(i.buildTx)(O()(y()(f),{recipientId:n,nonce:c,ttl:o,fee:a}),L.B.nameTransfer),l.next=14;break;case 11:return l.next=13,b.a.awrap(this.api.postNameTransfer(O()(y()(f),{recipientId:n,nonce:c,ttl:o,fee:parseInt(a)})));case 13:l.t0=l.sent;case 14:return s=l.t0,u=s.tx,l.abrupt("return",u);case 17:case"end":return l.stop()}}),null,this)},nameUpdateTx:function(e){var t,n,r,a,o,c,s,u=arguments;return b.a.async((function(f){for(;;)switch(f.prev=f.next){case 0:return t=e.accountId,e.nameId,e.nameTtl,e.pointers,e.clientTtl,f.next=3,b.a.awrap(this.prepareTxParams(L.B.nameUpdate,H({senderId:t},y()(u))));case 3:if(n=f.sent,r=n.fee,a=n.ttl,o=n.nonce,!this.nativeMode){f.next=11;break}f.t0=Object(i.buildTx)(O()(y()(u),{nonce:o,ttl:a,fee:r}),L.B.nameUpdate),f.next=14;break;case 11:return f.next=13,b.a.awrap(this.api.postNameUpdate(O()(y()(u),{nonce:o,ttl:a,fee:parseInt(r)})));case 13:f.t0=f.sent;case 14:return c=f.t0,s=c.tx,f.abrupt("return",s);case 17:case"end":return f.stop()}}),null,this)},nameRevokeTx:function(e){var t,n,r,a,o,c,s,u=arguments;return b.a.async((function(f){for(;;)switch(f.prev=f.next){case 0:return t=e.accountId,e.nameId,f.next=3,b.a.awrap(this.prepareTxParams(L.B.nameRevoke,H({senderId:t},y()(u))));case 3:if(n=f.sent,r=n.fee,a=n.ttl,o=n.nonce,!this.nativeMode){f.next=11;break}f.t0=Object(i.buildTx)(O()(y()(u),{nonce:o,ttl:a,fee:r}),L.B.nameRevoke),f.next=14;break;case 11:return f.next=13,b.a.awrap(this.api.postNameRevoke(O()(y()(u),{nonce:o,ttl:a,fee:parseInt(r)})));case 13:f.t0=f.sent;case 14:return c=f.t0,s=c.tx,f.abrupt("return",s);case 17:case"end":return f.stop()}}),null,this)},contractCreateTx:function(e){var t,n,r,a,o,s,u,f,l,p=arguments;return b.a.async((function(d){for(;;)switch(d.prev=d.next){case 0:return t=e.ownerId,e.code,e.vmVersion,e.abiVersion,e.deposit,e.amount,n=e.gas,r=e.gasPrice,a=void 0===r?L.j:r,e.callData,e.backend,o=this.getVmVersion(L.B.contractCreate,y()(p)),d.next=4,b.a.awrap(this.prepareTxParams(L.B.contractCreate,H({senderId:t},y()(p),{ctVersion:o,gasPrice:a})));case 4:return s=d.sent,u=s.fee,f=s.ttl,l=s.nonce,d.abrupt("return",this.nativeMode?H({},Object(i.buildTx)(O()(y()(p),{nonce:l,ttl:f,fee:u,ctVersion:o,gasPrice:a}),L.B.contractCreate),{contractId:Object(c.buildContractId)(t,l)}):this.api.postContractCreate(O()(y()(p),{nonce:l,ttl:f,fee:parseInt(u),gas:parseInt(n),gasPrice:a,vmVersion:o.vmVersion,abiVersion:o.abiVersion})));case 9:case"end":return d.stop()}}),null,this)},contractCallTx:function(e){var t,n,r,a,o,c,s,u,f,l,p,d=arguments;return b.a.async((function(h){for(;;)switch(h.prev=h.next){case 0:return t=e.callerId,e.contractId,e.abiVersion,e.amount,n=e.gas,r=e.gasPrice,a=void 0===r?L.j:r,e.callData,e.backend,o=this.getVmVersion(L.B.contractCall,y()(d)),h.next=4,b.a.awrap(this.prepareTxParams(L.B.contractCall,H({senderId:t},y()(d),{gasPrice:a,abiVersion:o.abiVersion})));case 4:if(c=h.sent,s=c.fee,u=c.ttl,f=c.nonce,!this.nativeMode){h.next=12;break}h.t0=Object(i.buildTx)(O()(y()(d),{nonce:f,ttl:u,fee:s,abiVersion:o.abiVersion,gasPrice:a}),L.B.contractCall),h.next=15;break;case 12:return h.next=14,b.a.awrap(this.api.postContractCall(O()(y()(d),{nonce:f,ttl:u,fee:parseInt(s),gas:parseInt(n),gasPrice:a,abiVersion:o.abiVersion})));case 14:h.t0=h.sent;case 15:return l=h.t0,p=l.tx,h.abrupt("return",p);case 18:case"end":return h.stop()}}),null,this)},prepareTxParams:function(e,t){var n,r,a,o,c,s,u,f,l,p,d=arguments;return b.a.async((function(h){for(;;)switch(h.prev=h.next){case 0:return n=t.senderId,r=t.nonce,a=t.ttl,o=t.fee,c=t.gas,s=t.absoluteTtl,u=t.vsn,h.next=3,b.a.awrap(this.getAccount(n).catch((function(e){return{nonce:0}})));case 3:return f=h.sent,r=f.contractId?0:r||f.nonce+1,h.next=7,b.a.awrap(W.bind(this)(a,!s));case 7:return l=h.sent,p=Object(i.calculateFee)(o,e,{showWarning:this.showWarning,gas:c,params:O()(U()(d),{nonce:r,ttl:l}),vsn:u}),h.abrupt("return",{fee:p,ttl:l,nonce:r});case 10:case"end":return h.stop()}}),null,this)},oracleRegisterTx:function(e){var t,n,r,a,o,c,s,u,f,l,p,d,h,v=arguments;return b.a.async((function(g){for(;;)switch(g.prev=g.next){case 0:return t=e.accountId,n=e.queryFormat,r=e.responseFormat,a=e.queryFee,o=e.oracleTtl,c=e.abiVersion,s=void 0===c?L.a.NO_ABI:c,g.next=3,b.a.awrap(this.prepareTxParams(L.B.oracleRegister,H({senderId:t},y()(v),{abiVersion:s})));case 3:if(u=g.sent,f=u.fee,l=u.ttl,p=u.nonce,!this.nativeMode){g.next=11;break}g.t0=Object(i.buildTx)({accountId:t,queryFee:a,abiVersion:s,fee:f,oracleTtl:o,nonce:p,ttl:l,queryFormat:n,responseFormat:r},L.B.oracleRegister),g.next=14;break;case 11:return g.next=13,b.a.awrap(this.api.postOracleRegister({accountId:t,queryFee:a,abiVersion:s,fee:parseInt(f),oracleTtl:o,nonce:p,ttl:l,queryFormat:n,responseFormat:r}));case 13:g.t0=g.sent;case 14:return d=g.t0,h=d.tx,g.abrupt("return",h);case 17:case"end":return g.stop()}}),null,this)},oracleExtendTx:function(e){var t,n,r,a,o,c,s,u,f,l=arguments;return b.a.async((function(p){for(;;)switch(p.prev=p.next){case 0:return t=e.oracleId,n=e.callerId,r=e.oracleTtl,p.next=3,b.a.awrap(this.prepareTxParams(L.B.oracleExtend,H({senderId:n},y()(l))));case 3:if(a=p.sent,o=a.fee,c=a.ttl,s=a.nonce,!this.nativeMode){p.next=11;break}p.t0=Object(i.buildTx)({oracleId:t,fee:o,oracleTtl:r,nonce:s,ttl:c},L.B.oracleExtend),p.next=14;break;case 11:return p.next=13,b.a.awrap(this.api.postOracleExtend({oracleId:t,fee:parseInt(o),oracleTtl:r,nonce:s,ttl:c}));case 13:p.t0=p.sent;case 14:return u=p.t0,f=u.tx,p.abrupt("return",f);case 17:case"end":return p.stop()}}),null,this)},oraclePostQueryTx:function(e){var t,n,r,a,o,s,u,f,l,p,d,h,v=arguments;return b.a.async((function(g){for(;;)switch(g.prev=g.next){case 0:return t=e.oracleId,n=e.responseTtl,r=e.query,a=e.queryTtl,o=e.queryFee,s=e.senderId,g.next=3,b.a.awrap(this.prepareTxParams(L.B.oracleQuery,H({senderId:s},y()(v))));case 3:if(u=g.sent,f=u.fee,l=u.ttl,p=u.nonce,!this.nativeMode){g.next=11;break}g.t0=Object(i.buildTx)({oracleId:t,responseTtl:n,query:r,queryTtl:a,fee:f,queryFee:o,ttl:l,nonce:p,senderId:s},L.B.oracleQuery),g.next=14;break;case 11:return g.next=13,b.a.awrap(this.api.postOracleQuery({oracleId:t,responseTtl:n,query:r,queryTtl:a,fee:parseInt(f),queryFee:o,ttl:l,nonce:p,senderId:s}));case 13:g.t0=g.sent;case 14:return d=g.t0,h=d.tx,g.abrupt("return",{tx:h,queryId:Object(c.oracleQueryId)(s,p,t)});case 17:case"end":return g.stop()}}),null,this)},oracleRespondTx:function(e){var t,n,r,a,o,c,s,u,f,l,p,d=arguments;return b.a.async((function(h){for(;;)switch(h.prev=h.next){case 0:return t=e.oracleId,n=e.callerId,r=e.responseTtl,a=e.queryId,o=e.response,h.next=3,b.a.awrap(this.prepareTxParams(L.B.oracleResponse,H({senderId:n},y()(d))));case 3:if(c=h.sent,s=c.fee,u=c.ttl,f=c.nonce,!this.nativeMode){h.next=11;break}h.t0=Object(i.buildTx)({oracleId:t,responseTtl:r,queryId:a,response:o,fee:s,ttl:u,nonce:f},L.B.oracleResponse),h.next=14;break;case 11:return h.next=13,b.a.awrap(this.api.postOracleRespond({oracleId:t,responseTtl:r,queryId:a,response:o,fee:parseInt(s),ttl:u,nonce:f}));case 13:h.t0=h.sent;case 14:return l=h.t0,p=l.tx,h.abrupt("return",p);case 17:case"end":return h.stop()}}),null,this)},channelCloseSoloTx:function(e){var t,n,r,a,o,c,s,u,f,l,p=arguments;return b.a.async((function(d){for(;;)switch(d.prev=d.next){case 0:return t=e.channelId,n=e.fromId,r=e.payload,a=e.poi,d.next=3,b.a.awrap(this.prepareTxParams(L.B.channelCloseSolo,H({senderId:n},y()(p),{payload:r})));case 3:if(o=d.sent,c=o.fee,s=o.ttl,u=o.nonce,!this.nativeMode){d.next=11;break}d.t0=Object(i.buildTx)(O()(y()(p),{channelId:t,fromId:n,payload:r,poi:a,ttl:s,fee:c,nonce:u}),L.B.channelCloseSolo),d.next=14;break;case 11:return d.next=13,b.a.awrap(this.api.postChannelCloseSolo(O()(y()(p),{channelId:t,fromId:n,payload:r,poi:a,ttl:s,fee:parseInt(c),nonce:u})));case 13:d.t0=d.sent;case 14:return f=d.t0,l=f.tx,d.abrupt("return",l);case 17:case"end":return d.stop()}}),null,this)},channelSlashTx:function(e){var t,n,r,a,o,c,s,u,f,l,p=arguments;return b.a.async((function(d){for(;;)switch(d.prev=d.next){case 0:return t=e.channelId,n=e.fromId,r=e.payload,a=e.poi,d.next=3,b.a.awrap(this.prepareTxParams(L.B.channelSlash,H({senderId:n},y()(p),{payload:r})));case 3:if(o=d.sent,c=o.fee,s=o.ttl,u=o.nonce,!this.nativeMode){d.next=11;break}d.t0=Object(i.buildTx)(O()(y()(p),{channelId:t,fromId:n,payload:r,poi:a,ttl:s,fee:c,nonce:u}),L.B.channelSlash),d.next=14;break;case 11:return d.next=13,b.a.awrap(this.api.postChannelSlash(O()(y()(p),{channelId:t,fromId:n,payload:r,poi:a,ttl:s,fee:parseInt(c),nonce:u})));case 13:d.t0=d.sent;case 14:return f=d.t0,l=f.tx,d.abrupt("return",l);case 17:case"end":return d.stop()}}),null,this)},channelSettleTx:function(e){var t,n,r,a,o,c,s,u,f,l,p=arguments;return b.a.async((function(d){for(;;)switch(d.prev=d.next){case 0:return t=e.channelId,n=e.fromId,r=e.initiatorAmountFinal,a=e.responderAmountFinal,d.next=3,b.a.awrap(this.prepareTxParams(L.B.channelSettle,H({senderId:n},y()(p))));case 3:if(o=d.sent,c=o.fee,s=o.ttl,u=o.nonce,!this.nativeMode){d.next=11;break}d.t0=Object(i.buildTx)(O()(y()(p),{channelId:t,fromId:n,initiatorAmountFinal:r,responderAmountFinal:a,ttl:s,fee:c,nonce:u}),L.B.channelSettle),d.next=14;break;case 11:return d.next=13,b.a.awrap(this.api.postChannelSettle(O()(y()(p),{channelId:t,fromId:n,initiatorAmountFinal:parseInt(r),responderAmountFinal:parseInt(a),ttl:s,fee:parseInt(c),nonce:u})));case 13:d.t0=d.sent;case 14:return f=d.t0,l=f.tx,d.abrupt("return",l);case 17:case"end":return d.stop()}}),null,this)},channelSnapshotSoloTx:function(e){var t,n,r,a,o,c,s,u,f,l=arguments;return b.a.async((function(p){for(;;)switch(p.prev=p.next){case 0:return t=e.channelId,n=e.fromId,r=e.payload,p.next=3,b.a.awrap(this.prepareTxParams(L.B.channelSnapshotSolo,H({senderId:n},y()(l),{payload:r})));case 3:if(a=p.sent,o=a.fee,c=a.ttl,s=a.nonce,!this.nativeMode){p.next=11;break}p.t0=Object(i.buildTx)(O()(y()(l),{channelId:t,fromId:n,payload:r,ttl:c,fee:o,nonce:s}),L.B.channelSnapshotSolo),p.next=14;break;case 11:return p.next=13,b.a.awrap(this.api.postChannelSnapshotSolo(O()(y()(l),{channelId:t,fromId:n,payload:r,ttl:c,fee:parseInt(o),nonce:s})));case 13:p.t0=p.sent;case 14:return u=p.t0,f=u.tx,p.abrupt("return",f);case 17:case"end":return p.stop()}}),null,this)},gaAttachTx:function(e){var t,n,r,a,o,s,u,f,l=arguments;return b.a.async((function(p){for(;;)switch(p.prev=p.next){case 0:return t=e.ownerId,e.code,e.vmVersion,e.abiVersion,e.authFun,e.gas,n=e.gasPrice,r=void 0===n?L.j:n,e.callData,e.backend,a=this.getVmVersion(L.B.contractCreate,y()(l)),p.next=4,b.a.awrap(this.prepareTxParams(L.B.gaAttach,H({senderId:t},y()(l),{ctVersion:a,gasPrice:r})));case 4:return o=p.sent,s=o.fee,u=o.ttl,f=o.nonce,p.abrupt("return",H({},Object(i.buildTx)(O()(y()(l),{nonce:f,ttl:u,fee:s,ctVersion:a,gasPrice:r}),L.B.gaAttach),{contractId:Object(c.buildContractId)(t,f)}));case 9:case"end":return p.stop()}}),null,this)},getAccountNonce:function(e,t){var n,r;return b.a.async((function(a){for(;;)switch(a.prev=a.next){case 0:if(!t){a.next=2;break}return a.abrupt("return",t);case 2:return a.next=4,b.a.awrap(this.api.getAccountByPubkey(e).catch((function(){return{nonce:0}})));case 4:return n=a.sent,r=n.nonce,a.abrupt("return",r+1);case 7:case"end":return a.stop()}}),null,this)},getVmVersion:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.vmVersion,r=t.abiVersion,a=t.backend,o=this.getNodeInfo().consensusProtocolVersion,i=L.u[o];if(!i)throw new Error("Not supported consensus protocol version");var c=i[e];if(!c)throw new Error("Not supported tx type");if(this.compilerVersion){var s=this.compilerVersion.split("."),u=p()(s,1)[0];if(4==+u&&4!==o)throw new Error("Compiler ".concat(this.compilerVersion," support only consensus protocol 4(Lima)"));if(+u<=3&&o>3)throw new Error("Compiler ".concat(this.compilerVersion," support only consensus protocol less then 3(Fortuna)"));if(a===L.D.FATE&&o<4)throw new Error("You can use FATE only after Lima HF");a=a||this.compilerOptions.backend}var f={abiVersion:void 0!==r?r:a===L.D.AEVM?c.abiVersion[1]:(L.D.FATE,c.abiVersion[0]),vmVersion:void 0!==n?n:a===L.D.AEVM?c.vmVersion[1]:(L.D.FATE,c.vmVersion[0])};if(c.vmVersion.length&&!q()(f.vmVersion,c.vmVersion))throw new Error("VM VERSION ".concat(f.vmVersion," do not support by this node. Supported: [").concat(c.vmVersion,"]"));if(c.abiVersion.length&&!q()(f.abiVersion,c.abiVersion))throw new Error("ABI VERSION ".concat(f.abiVersion," do not support by this node. Supported: [").concat(c.abiVersion,"]"));return f}}}),Q=n(25),z=n(41),G=n(52),X=n(44),$=n(26),J=n(13),Z=n.n(J),ee=function(e){return function(t,n){var r;return b.a.async((function(a){for(;;)switch(a.prev=a.next){case 0:if("object"===Z()(t)){a.next=2;break}throw new Error("AuthData must be an object");case 2:if(!t.gas||!T()(t.gas).gt(L.i)){a.next=4;break}throw new Error("the maximum gas value for ga authFun is ".concat(L.i,", got ").concat(t.gas));case 4:if(r=t.gas||L.i,!t.callData){a.next=11;break}if("cb"===t.callData.split("_")[0]){a.next=8;break}throw new Error('Auth data must be a string with "cb" prefix.');case 8:return a.abrupt("return",{authCallData:t.callData,gas:r});case 11:if(t.source&&t.args){a.next=13;break}throw new Error("Auth data must contain source code and arguments.");case 13:return a.next=15,b.a.awrap(e.contractEncodeCall(t.source,n,t.args));case 15:return a.t0=a.sent,a.t1=r,a.abrupt("return",{authCallData:a.t0,gas:a.t1});case 18:case"end":return a.stop()}}))}},te=function(e){return function(t,n){var a,o,c,s,u;return b.a.async((function(f){for(;;)switch(f.prev=f.next){case 0:return f.next=2,b.a.awrap(e.contractCompile(t));case 2:return a=f.sent,o=a.bytecode,f.next=6,b.a.awrap(Object(i.unpackTx)(o,!1,"cb"));case 6:if(c=f.sent,(s=c.tx.typeInfo)[n]){f.next=10;break}return f.abrupt("return",{bytecode:o,authFun:Object(r.hash)(n)});case 10:return u=s[n].funHash,f.abrupt("return",{bytecode:o,authFun:u});case 12:case"end":return f.stop()}}))}},ne=function(e){return Object(i.buildTx)({encodedTx:e,signatures:[]},L.B.signed)};function re(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function ae(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?re(n,!0).forEach((function(t){x()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):re(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var oe=$.a.compose({methods:{createGeneralizeAccount:function(e,t,n){var r,a,o,i,c,s,u,f,l,p,d,h,v,y=arguments;return b.a.async((function(g){for(;;)switch(g.prev=g.next){case 0:return r=y.length>3&&void 0!==y[3]?y[3]:{},a=O()(this.Ae.defaults,r),g.next=4,b.a.awrap(this.address(a));case 4:return o=g.sent,g.next=7,b.a.awrap(this.isGA(o));case 7:if(!g.sent){g.next=9;break}throw new Error("Account ".concat(o," is already GA"));case 9:return g.next=11,b.a.awrap(te(this)(t,e));case 11:return i=g.sent,c=i.authFun,s=i.bytecode,g.next=16,b.a.awrap(this.contractEncodeCall(t,"init",n));case 16:return u=g.sent,g.next=19,b.a.awrap(this.gaAttachTx(O()(a,{ownerId:o,code:s,callData:u,authFun:c})));case 19:return f=g.sent,l=f.tx,p=f.contractId,g.next=24,b.a.awrap(this.send(l,a));case 24:return d=g.sent,h=d.hash,v=d.rawTx,g.abrupt("return",Object.freeze({owner:o,transaction:h,rawTx:v,gaContractId:p}));case 28:case"end":return g.stop()}}),null,this)},createMetaTx:function(e,t,n){var a,o,c,s,u,f,l,p,d,h,v,y,g,m,x,w,j,k,T=arguments;return b.a.async((function(I){for(;;)switch(I.prev=I.next){case 0:if(a=T.length>3&&void 0!==T[3]?T[3]:{},t){I.next=3;break}throw new Error("authData is required");case 3:return I.next=5,b.a.awrap(ee(this)(t,n));case 5:return o=I.sent,c=o.authCallData,s=o.gas,u=O()(this.Ae.defaults,a),f=Object(r.decodeBase64Check)(Object(r.assertedType)(e,"tx")),l=ne(f),p=l.rlpEncoded,I.next=13,b.a.awrap(this.getVmVersion(L.B.contractCall));case 13:return d=I.sent,h=d.abiVersion,I.t0=ae,I.t1={},I.t2=u,I.t3=p,I.next=21,b.a.awrap(this.address(u));case 21:return I.t4=I.sent,I.t5=h,I.t6=c,I.t7=s,I.t8={tx:I.t3,gaId:I.t4,abiVersion:I.t5,authData:I.t6,gas:I.t7},v=(0,I.t0)(I.t1,I.t2,I.t8),I.next=29,b.a.awrap(this.prepareTxParams(L.B.gaMeta,v));case 29:return y=I.sent,g=y.fee,m=y.ttl,x=Object(i.buildTx)(ae({},v,{fee:"".concat(g),ttl:m}),L.B.gaMeta),w=x.rlpEncoded,j=ne(w),k=j.tx,I.abrupt("return",k);case 35:case"end":return I.stop()}}),null,this)},isGA:function(e){var t,n;return b.a.async((function(r){for(;;)switch(r.prev=r.next){case 0:return r.next=2,b.a.awrap(this.getAccount(e));case 2:return t=r.sent,n=t.contractId,r.abrupt("return",!!n);case 5:case"end":return r.stop()}}),null,this)}}});var ie=n(64),ce=n(28),se=n.n(ce),ue=n(12),fe=n.n(ue),le=n(133),pe=n.n(le),de=n(74),he=n.n(de),ve=n(45),ye=n(132),ge=n.n(ye),be=n(14),me=n.n(be),xe=n(131),we=n.n(xe);function Oe(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function je(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Oe(n,!0).forEach((function(t){x()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Oe(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var ke=me()({init:function(e){var t=e.self,n=void 0===t?window:t,r=this.receive.bind(this);n.addEventListener("message",r,!1),this.destroyServer=function(){return n.removeEventListener("message",r,!1)}},methods:{receive:function(e){var t,n,r,a,o,i,c,s;return b.a.async((function(u){for(;;)switch(u.prev=u.next){case 0:if(s=function(){return Promise.reject(Error("Error: No such method ".concat(o)))},t=e.data,n=e.origin,r=e.source,"object"===Z()(t)&&"2.0"===t.jsonrpc){u.next=4;break}return u.abrupt("return");case 4:a=t.id,o=t.method,i=t.params,c=t.session,ge()((this.rpcMethods[o]||s).bind(this),{params:i,session:this.rpcSessions[c],origin:n}).then((function(e){var t="object"===Z()(e)&&"[object Object]"===Object.prototype.toString.call(e)?Object.entries(e).filter((function(e){var t=p()(e,2);t[0];return"function"!=typeof t[1]})).reduce((function(e,t){var n=p()(t,2),r=n[0],a=n[1];return je({},e,x()({},r,a))}),{}):e;r.postMessage({jsonrpc:"2.0",id:a,result:{resolve:t}},"*")})).catch((function(e){r.postMessage({jsonrpc:"2.0",id:a,result:{reject:e.message}},"*")}));case 6:case"end":return u.stop()}}),null,this)},createSession:function(){var e=we()();return this.rpcSessions[e]={id:e},e}},props:{rpcSessions:{}},deepProps:{rpcMethods:{hello:function(){return Promise.resolve(this.createSession())}}}}),Te=he()(q.a),Ie=[{pred:Te(Y.compose.deepConfiguration.Ae.methods),handler:"onTx",error:"Creating transaction [{}] rejected"},{pred:Te(R.compose.deepConfiguration.Ae.methods),handler:"onChain",error:"Chain operation [{}] rejected"},{pred:Te(Q.a.compose.deepConfiguration.Ae.methods),handler:"onAccount",error:"Account operation [{}] rejected"},{pred:Te(ve.a.compose.deepConfiguration.Contract.methods),handler:"onContract",error:"Contract operation [{}] rejected"}];var Pe=u.a.compose(z.a,R,Y,$.b,oe,ke,{init:function(e,t){var n=this,r=e.onTx,a=void 0===r?this.onTx:r,o=e.onChain,i=void 0===o?this.onChain:o,c=e.onAccount,s=void 0===c?this.onAccount:c,u=e.onContract,f=void 0===u?this.onContract:u,l=t.stamp;this.onTx=a,this.onChain=i,this.onAccount=s,this.onContract=f;var p=[].concat(fe()(l.compose.deepConfiguration.Ae.methods),fe()(l.compose.deepConfiguration.Contract.methods));this.rpcMethods=Object.assign(se()(p.map((function(e){return[e,function(t){var r=t.params,a=t.session;return n.rpc(e,r,a)}]}))),this.rpcMethods)},methods:{rpc:function(e,t,n){var r,a,o;return b.a.async((function(i){for(;;)switch(i.prev=i.next){case 0:if(r=pe()((function(t){return(0,t.pred)(e)}),Ie),a=r.handler,o=r.error,void 0!==a){i.next=5;break}return i.abrupt("return",Promise.reject(Error("Unknown method ".concat(e))));case 5:return i.next=7,b.a.awrap(this[a](e,t,n));case 7:if(!i.sent){i.next=11;break}return i.abrupt("return",this[e].apply(this,t));case 11:return i.abrupt("return",Promise.reject(Error(o.replace(/{}/,e))));case 12:case"end":return i.stop()}}),null,this)},onTx:function(){return console.log("Implement onTx!"),Promise.resolve(!1)},onChain:function(){return console.log("Implement onChain!"),Promise.resolve(!1)},onAccount:function(){return console.log("Implement onAccount!"),Promise.resolve(!1)},onContract:function(){return console.log("Implement onContract!"),Promise.resolve(!1)}},deepProps:{rpcMethods:{sign:function(e){var t,n;return b.a.async((function(r){for(;;)switch(r.prev=r.next){case 0:return t=e.params,n=e.session,r.next=3,b.a.awrap(this.onAccount("sign",t,n));case 3:if(!r.sent){r.next=7;break}return r.abrupt("return",this.signWith(n.address,t[0]));case 7:return r.abrupt("return",Promise.reject(Error("Signing rejected")));case 8:case"end":return r.stop()}}),null,this)},address:function(e){var t,n;return b.a.async((function(r){for(;;)switch(r.prev=r.next){case 0:return t=e.params,n=e.session,r.next=3,b.a.awrap(this.onAccount("address",t,n));case 3:if(!r.sent){r.next=7;break}return r.abrupt("return",Promise.resolve(n.address));case 7:return r.abrupt("return",Promise.reject(Error("Address rejected")));case 8:case"end":return r.stop()}}),null,this)},hello:function(){var e;return b.a.async((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,b.a.awrap(ke.compose.deepProperties.rpcMethods.hello.call(this));case 2:return e=t.sent,t.next=5,b.a.awrap(this.address());case 5:return this.rpcSessions[e].address=t.sent,t.abrupt("return",Promise.resolve(e));case 7:case"end":return t.stop()}}),null,this)}}}}),Ae=n(24),Ce=n.n(Ae),Ee=n(21);var _e=me()(Ee.a,{init:function(e,t){var n,r,a,o,i,c,s,u,f=this;return b.a.async((function(l){for(;;)switch(l.prev=l.next){case 0:if(s=function(e){var t=e.data;if("object"===Z()(t)&&"webpackOk"!==t.type){var n=t.result,r=n.resolve,a=n.reject,o=t.id;c[o]&&(void 0!==r?c[o].resolve(r):a&&c[o].reject(a),delete c[o])}},n=e.parent,r=void 0===n?window.parent:n,a=e.self,o=void 0===a?window:a,t.stamp,r!==o){l.next=5;break}throw new Error("rpc client: Can't send messages to itself");case 5:return i=0,c={},this.post=function(e,t){var n=new Promise((function(e,t){c[i]={resolve:e,reject:t}}));return r.postMessage({jsonrpc:"2.0",id:i,method:e,params:t,session:f.session},"*"),i++,n},u=s,o.addEventListener("message",u,!1),this.destroyClient=function(){return o.removeEventListener("message",u,!1)},l.next=13,b.a.awrap(this.post("hello"));case 13:this.session=l.sent;case 14:case"end":return l.stop()}}),null,this)},props:{handler:null},methods:{},composers:function(e){var t=e.stamp,n=(e.composables,[].concat(fe()(Ce()(["compose","deepConfiguration","Ae","methods"],t)||[]),fe()(Ce()(["compose","deepConfiguration","Contract","methods"],t)||[]))),r=se()(n.map((function(e){return[e,(t=e,function(){for(var e=arguments.length,n=new Array(e),r=0;r<e;r++)n[r]=arguments[r];return this.post(t,n)})];var t})));t.compose.methods&&["signTransaction","getNetworkId"].forEach((function(e){return delete t.compose.methods[e]})),t.compose.methods=Object.assign(r,t.compose.methods)}});function Se(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function Be(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Se(n,!0).forEach((function(t){x()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Se(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function Ne(e){var t,n,r,a=this;return b.a.async((function(o){for(;;)switch(o.prev=o.next){case 0:return o.next=2,b.a.awrap(this.getOracle(e));case 2:return t=o.sent,o.next=5,b.a.awrap(this.getOracleQueries(e));case 5:return n=o.sent,r=n.oracleQueries,o.abrupt("return",Be({},t,{queries:r,pollQueries:function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=n.interval;return a.pollForQueries(e,t,{interval:r})},postQuery:function(t,n){return a.postQueryToOracle(e,t,n)},respondToQuery:function(t,n,r){return a.respondToQuery(e,t,n,r)},extendOracle:function(t,n){return a.extendOracleTtl(e,t,n)},getQuery:function(t){return b.a.async((function(n){for(;;)switch(n.prev=n.next){case 0:return n.abrupt("return",Re.bind(a)(e,t));case 1:case"end":return n.stop()}}))}}));case 8:case"end":return o.stop()}}),null,this)}function Re(e,t){var n=this;return b.a.async((function(a){for(;;)switch(a.prev=a.next){case 0:return a.t0=Be,a.t1={},a.next=4,b.a.awrap(this.getOracleQuery(e,t));case 4:return a.t2=a.sent,a.t3={respond:function(r,a){return n.respondToQuery(e,t,r,a)},pollForResponse:function(r){var a=r.attempts,o=r.interval;return n.pollForQueryResponse(e,t,{attempts:a,interval:o})},decode:function(e){return Object(r.decodeBase64Check)(e.slice(3))}},a.abrupt("return",(0,a.t0)(a.t1,a.t2,a.t3));case 7:case"end":return a.stop()}}),null,this)}var De=u.a.compose({methods:{registerOracle:function(e,t){var n,r,a,o,i=arguments;return b.a.async((function(c){for(;;)switch(c.prev=c.next){case 0:return n=i.length>2&&void 0!==i[2]?i[2]:{},r=O()(this.Ae.defaults,n),c.next=4,b.a.awrap(this.address(r));case 4:return a=c.sent,c.next=7,b.a.awrap(this.oracleRegisterTx(O()(r,{accountId:a,queryFormat:e,responseFormat:t})));case 7:return o=c.sent,c.t0=Be,c.t1={},c.next=12,b.a.awrap(this.send(o,r));case 12:return c.t2=c.sent,c.t3={},c.next=16,b.a.awrap(Ne.bind(this)("ok_".concat(a.slice(3))));case 16:return c.t4=c.sent,c.abrupt("return",(0,c.t0)(c.t1,c.t2,c.t3,c.t4));case 18:case"end":return c.stop()}}),null,this)},respondToQuery:function(e,t,n){var r,a,o,i,c=arguments;return b.a.async((function(s){for(;;)switch(s.prev=s.next){case 0:return r=c.length>3&&void 0!==c[3]?c[3]:{},a=O()(this.Ae.defaults,r),s.next=4,b.a.awrap(this.address(a));case 4:return o=s.sent,s.next=7,b.a.awrap(this.oracleRespondTx(O()(a,{oracleId:e,queryId:t,callerId:o,response:n})));case 7:return i=s.sent,s.t0=Be,s.t1={},s.next=12,b.a.awrap(this.send(i,a));case 12:return s.t2=s.sent,s.t3={},s.next=16,b.a.awrap(Ne.bind(this)(e));case 16:return s.t4=s.sent,s.abrupt("return",(0,s.t0)(s.t1,s.t2,s.t3,s.t4));case 18:case"end":return s.stop()}}),null,this)},extendOracleTtl:function(e,t){var n,r,a,o,i=arguments;return b.a.async((function(c){for(;;)switch(c.prev=c.next){case 0:return n=i.length>2&&void 0!==i[2]?i[2]:{},r=O()(this.Ae.defaults,n),c.next=4,b.a.awrap(this.address(r));case 4:return a=c.sent,c.next=7,b.a.awrap(this.oracleExtendTx(O()(r,{oracleId:e,callerId:a,oracleTtl:t})));case 7:return o=c.sent,c.t0=Be,c.t1={},c.next=12,b.a.awrap(this.send(o,r));case 12:return c.t2=c.sent,c.t3={},c.next=16,b.a.awrap(Ne.bind(this)(e));case 16:return c.t4=c.sent,c.abrupt("return",(0,c.t0)(c.t1,c.t2,c.t3,c.t4));case 18:case"end":return c.stop()}}),null,this)},postQueryToOracle:function(e,t){var n,r,a,o,i,c,s=arguments;return b.a.async((function(u){for(;;)switch(u.prev=u.next){case 0:return n=s.length>2&&void 0!==s[2]?s[2]:{},r=O()(this.Ae.defaults,n),u.next=4,b.a.awrap(this.address(r));case 4:return a=u.sent,u.next=7,b.a.awrap(this.oraclePostQueryTx(O()(r,{oracleId:e,senderId:a,query:t})));case 7:return o=u.sent,i=o.tx,c=o.queryId,u.t0=Be,u.t1={},u.next=14,b.a.awrap(this.send(i,r));case 14:return u.t2=u.sent,u.t3={},u.t4=b.a,u.next=19,b.a.awrap(Ne.bind(this)(e));case 19:return u.t5=c,u.t6=u.sent.getQuery(u.t5),u.next=23,u.t4.awrap.call(u.t4,u.t6);case 23:return u.t7=u.sent,u.abrupt("return",(0,u.t0)(u.t1,u.t2,u.t3,u.t7));case 25:case"end":return u.stop()}}),null,this)},pollForQueryResponse:function(e,t){var n,a,o,i,c,s,u,f,l=arguments;return b.a.async((function(p){for(;;)switch(p.prev=p.next){case 0:return f=function(n){var a;return b.a.async((function(i){for(;;)switch(i.prev=i.next){case 0:return i.next=2,b.a.awrap(this.getOracleQuery(e,t));case 2:if((a=i.sent).response===s){i.next=5;break}return i.abrupt("return",{response:a.response,decode:function(){return Object(r.decodeBase64Check)(a.response.slice(3))}});case 5:if(!(n>0)){i.next=9;break}return i.next=8,b.a.awrap(u(c));case 8:return i.abrupt("return",f.bind(this)(n-1));case 9:throw Error("Giving up after ".concat(o*c,"ms"));case 10:case"end":return i.stop()}}),null,this)},u=function(e){return b.a.async((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,b.a.awrap(new Promise((function(t){return setTimeout(t,e)})));case 2:case"end":return t.stop()}}))},n=l.length>2&&void 0!==l[2]?l[2]:{},a=n.attempts,o=void 0===a?20:a,i=n.interval,c=void 0===i?5e3:i,s="or_Xfbg4g==",p.abrupt("return",f.bind(this)(o));case 5:case"end":return p.stop()}}),null,this)},pollForQueries:function(e,t){var n,r,a,o,i,c,s,u=arguments;return b.a.async((function(f){for(;;)switch(f.prev=f.next){case 0:return c=function(){var n,r,a;return b.a.async((function(o){for(;;)switch(o.prev=o.next){case 0:return o.next=2,b.a.awrap(this.getOracleQueries(e));case 2:n=o.sent,r=n.oracleQueries,(a=r.filter((function(e){var t=e.id;return!i.includes(t)}))).length&&(i=[].concat(fe()(i),fe()(a.map((function(e){return e.id})))),t(a));case 6:case"end":return o.stop()}}),null,this)},n=u.length>2&&void 0!==u[2]?u[2]:{},r=n.interval,a=void 0===r?5e3:r,f.next=4,b.a.awrap(this.getOracleQueries(e));case 4:if(f.t0=f.sent.oracleQueries,f.t0){f.next=7;break}f.t0=[];case 7:return o=f.t0,i=o.map((function(e){return e.id})),t(o),s=setInterval(c.bind(this),a),f.abrupt("return",(function(){return clearInterval(s)}));case 12:case"end":return f.stop()}}),null,this)},getOracleObject:Ne,getQueryObject:Re},deepProps:{Ae:{defaults:{queryFee:3e4,oracleTtl:{type:"delta",value:500},queryTtl:{type:"delta",value:10},responseTtl:{type:"delta",value:10}}}}}),Ve=u.a.compose($.a,X.a,De,oe,_e),Fe=n(60),Ue=n(73),Me=n.n(Ue),qe=n(19),Le=n(128),Ke=n.n(Le),He=n(127),We=n.n(He),Ye=n(124),Qe=n.n(Ye),ze=n(40),Ge=n.n(ze),Xe=n(54),$e=n.n(Xe),Je=n(33),Ze=n.n(Je),et=n(125),tt=n(126),nt=n(35);function rt(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function at(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?rt(n,!0).forEach((function(t){x()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):rt(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var ot=1e4,it=5e3,ct=new WeakMap,st=new WeakMap,ut=new WeakMap,ft=new WeakMap,lt=new WeakMap,pt=new WeakMap,dt=new WeakMap,ht=new WeakMap,vt=new WeakMap,yt=new WeakMap,gt=new WeakMap,bt=new WeakMap,mt=new WeakMap,xt=new WeakMap,wt=new WeakMap,Ot=new WeakMap;function jt(e,t){var n=Ze()("&",$e()(Ge()((function(e,t){return"".concat(Object(qe.b)(t),"=").concat(encodeURIComponent(e))}),t)));return"".concat(e,"?").concat(n)}function kt(e){for(var t,n=arguments.length,r=new Array(n>1?n-1:0),a=1;a<n;a++)r[a-1]=arguments[a];(t=pt.get(e)).emit.apply(t,r)}function Tt(e,t){if(!t)throw new Error("State Channels FSM entered unknown state");ft.set(e,t),t.handler.enter&&t.handler.enter(e),Et(e)}function It(e,t){t!==st.get(e)&&(st.set(e,t),kt(e,"statusChanged",t))}function Pt(e,t){ut.set(e,t),kt(e,"stateChanged",t)}function At(e,t){lt.get(e).send(nt.a.stringify(t))}function Ct(e,t,n){vt.set(e,[].concat(fe()(vt.get(e)||[]),[{guard:t,action:n}])),Et(e)}function Et(e){var t,n,r,a,o;return b.a.async((function(i){for(;;)switch(i.prev=i.next){case 0:if(t=yt.get(e),n=vt.get(e)||[],!t&&n.length){i.next=4;break}return i.abrupt("return");case 4:if(r=ft.get(e),-1!==(a=n.findIndex((function(t){return t.guard(e,r)})))){i.next=8;break}return i.abrupt("return");case 8:return vt.set(e,n.filter((function(e,t){return a!==t}))),yt.set(e,!0),i.next=12,b.a.awrap(Promise.resolve(n[a].action(e,r)));case 12:o=i.sent,yt.set(e,!1),Tt(e,o);case 15:case"end":return i.stop()}}))}function _t(e,t){var n,r,a;return b.a.async((function(o){for(;;)switch(o.prev=o.next){case 0:return n=ft.get(e),r=n.handler,a=n.state,o.t0=Tt,o.t1=e,o.next=5,b.a.awrap(Promise.resolve(r(e,t,a)));case 5:o.t2=o.sent,(0,o.t0)(o.t1,o.t2);case 7:case"end":return o.stop()}}))}function St(e){clearTimeout(xt.get(e)),clearTimeout(wt.get(e)),xt.set(e,setTimeout((function(){At(e,{jsonrpc:"2.0",method:"channels.system",params:{action:"ping"}}),wt.set(e,setTimeout((function(){Rt(e),kt(e,"error",Error("Server pong timed out"))}),it))}),ot))}function Bt(e,t){var n=nt.a.parse(t);if(n.id){var r=mt.get(e).get(n.id);try{r(n)}finally{mt.get(e).delete(n.id)}}else"channels.message"===n.method?kt(e,"message",n.params.data.message):"channels.system.pong"===n.method?n.params.channel_id!==bt.get(e)&&null!=bt.get(e)||St(e):(dt.set(e,[].concat(fe()(dt.get(e)||[]),[n])),function e(t){var n,r,a,o;return b.a.async((function(i){for(;;)switch(i.prev=i.next){case 0:if(n=dt.get(t),!ht.get(t)&&n.length){i.next=3;break}return i.abrupt("return");case 3:return r=Qe()(n),a=r[0],o=r.slice(1),dt.set(t,o||[]),ht.set(t,!0),i.next=8,b.a.awrap(_t(t,a));case 8:ht.set(t,!1),e(t);case 10:case"end":return i.stop()}}))}(e))}function Nt(e,t,n){return new Promise((function(r,a){var o=gt.set(e,gt.get(e)+1).get(e);mt.get(e).set(o,(function(e){return e.result?r(e.result):e.error?a(function(e){var t=e.error.data||[],n=p()(t,1)[0],r=(n=void 0===n?{}:n).message;return r?Error("".concat(e.error.message,": ").concat(r)):Error(e.error.message)}(e)):void 0})),At(e,{jsonrpc:"2.0",method:t,id:o,params:n})}))}function Rt(e){lt.get(e).close(),clearTimeout(xt.get(e)),clearTimeout(wt.get(e))}function Dt(e,t){function n(e,t,n){var r=We()(n),a=e[t];e[t]=function(){r.apply(void 0,arguments),"function"==typeof a&&a.apply(void 0,arguments)}}return new Promise((function(r,a){var o=new et.w3cwebsocket(e);Object.entries(t).forEach((function(e){var t=p()(e,2),n=t[0],r=t[1];o[n]=r})),n(o,"onopen",(function(){return r(o)})),n(o,"onerror",(function(e){return a(e)}))}))}function Vt(e,t){var n,r,a,o,i;return b.a.async((function(c){for(;;)switch(c.prev=c.next){case 0:return n=["sign","url"],r=Ke()((function(e,t){return!n.includes(t)}),t),a=t.url,o=jt(a,at({},r,{protocol:"json-rpc"})),ct.set(e,t),r.existingFsmId?ft.set(e,{handler:Lt}):ft.set(e,{handler:qt}),pt.set(e,new tt.EventEmitter),gt.set(e,0),mt.set(e,new Map),It(e,"connecting"),c.next=12,b.a.awrap(Dt(o,{onopen:function(){It(e,"connected"),r.reconnectTx&&(Tt(e,{handler:zt}),setTimeout((function(){return b.a.async((function(t){for(;;)switch(t.prev=t.next){case 0:return t.t0=Pt,t.t1=e,t.next=4,b.a.awrap(Nt(e,"channels.get.offchain_state",{}));case 4:return t.t2=t.sent.signed_tx,t.abrupt("return",(0,t.t0)(t.t1,t.t2));case 6:case"end":return t.stop()}}))}),0)),St(e)},onclose:function(){It(e,"disconnected"),clearTimeout(xt.get(e)),clearTimeout(wt.get(e))},onmessage:function(t){var n=t.data;return Bt(e,n)}}));case 12:i=c.sent,lt.set(e,i);case 14:case"end":return c.stop()}}))}function Ft(e){return"tx_".concat(Object(r.encodeBase64Check)(e))}function Ut(e,t){var n,r,a,o,c,s,u;return b.a.async((function(f){for(;;)switch(f.prev=f.next){case 0:return n=Object(i.unpackTx)(e).tx,r=n.signatures,a=n.encodedTx,f.next=3,b.a.awrap(t(Ft(a.rlpEncoded)));case 3:if("string"!=typeof(o=f.sent)){f.next=7;break}return c=Object(i.unpackTx)(o),s=c.tx,u=c.txType,f.abrupt("return",Ft(Object(i.buildTx)({signatures:r.concat(s.signatures),encodedTx:s.encodedTx.rlpEncoded},u).rlpEncoded));case 7:return f.abrupt("return",o);case 8:case"end":return f.stop()}}))}function Mt(e,t,n){return n&&n.reject&&n.reject(Object.assign(Error("Unexpected message received:\n\n".concat(JSON.stringify(t))),{wsMessage:t})),{handler:zt}}function qt(e,t,n){return"channels.info"===t.method?["channel_accept","funding_created"].includes(t.params.data.event)?(It(e,{channel_accept:"accepted",funding_created:"halfSigned"}[t.params.data.event]),{handler:Kt}):"channel_reestablished"===t.params.data.event?{handler:Yt}:"fsm_up"===t.params.data.event?(Ot.set(e,t.params.data.fsm_id),{handler:qt}):{handler:qt}:"channels.error"===t.method?(kt(e,"error",new Error(t.payload.message)),{handler:pn}):void 0}function Lt(e,t,n){return b.a.async((function(r){for(;;)switch(r.prev=r.next){case 0:if("channels.info"!==t.method){r.next=10;break}if("fsm_up"!==t.params.data.event){r.next=10;break}return Ot.set(e,t.params.data.fsm_id),r.t0=Pt,r.t1=e,r.next=7,b.a.awrap(Nt(e,"channels.get.offchain_state",{}));case 7:return r.t2=r.sent.signed_tx,(0,r.t0)(r.t1,r.t2),r.abrupt("return",{handler:zt});case 10:return r.abrupt("return",Mt(0,t,n));case 11:case"end":return r.stop()}}))}function Kt(e,t,n){var r,a,o;return b.a.async((function(n){for(;;)switch(n.prev=n.next){case 0:if(r={initiator:"initiator_sign",responder:"responder_sign"}[ct.get(e).role],t.method!=="channels.sign.".concat(r)){n.next=13;break}if(!t.params.data.tx){n.next=8;break}return n.next=5,b.a.awrap(ct.get(e).sign(r,t.params.data.tx));case 5:return a=n.sent,At(e,{jsonrpc:"2.0",method:"channels.".concat(r),params:{tx:a}}),n.abrupt("return",{handler:Ht});case 8:return n.next=10,b.a.awrap(Ut(t.params.data.signed_tx,(function(t){return ct.get(e).sign(r,t)})));case 10:return o=n.sent,At(e,{jsonrpc:"2.0",method:"channels.".concat(r),params:{signed_tx:o}}),n.abrupt("return",{handler:Ht});case 13:case"end":return n.stop()}}))}function Ht(e,t,n){if("channels.on_chain_tx"===t.method){if("funding_signed"===t.params.data.info&&"initiator"===ct.get(e).role)return{handler:Wt};if("funding_created"===t.params.data.info&&"responder"===ct.get(e).role)return{handler:Wt}}if("channels.info"===t.method&&"funding_signed"===t.params.data.event&&"initiator"===ct.get(e).role)return It(e,"signed"),{handler:Ht}}function Wt(e,t,n){if("channels.info"===t.method){var r={funding_created:Wt,own_funding_locked:Wt,funding_locked:Yt}[t.params.data.event];if(r)return{handler:r}}if("channels.on_chain_tx"===t.method)return kt(e,"onChainTx",t.params.data.tx,{info:t.params.data.info,type:t.params.data.type}),{handler:Wt}}function Yt(e,t,n){if("channels.info"===t.method&&"open"===t.params.data.event)return bt.set(e,t.params.channel_id),{handler:Qt}}function Qt(e,t,n){if("channels.update"===t.method)return Pt(e,t.params.data.state),{handler:zt}}function zt(e,t,n){return b.a.async((function(r){for(;;)switch(r.prev=r.next){case 0:r.t0=t.method,r.next="channels.info"===r.t0?3:"channels.on_chain_tx"===r.t0?20:"channels.leave"===r.t0?22:"channels.update"===r.t0?23:"channels.sign.shutdown_sign_ack"===r.t0?25:26;break;case 3:r.t1=t.params.data.event,r.next="update"===r.t1?6:"withdraw_created"===r.t1?6:"deposit_created"===r.t1?6:"own_withdraw_locked"===r.t1?7:"withdraw_locked"===r.t1?7:"own_deposit_locked"===r.t1?7:"deposit_locked"===r.t1?7:"peer_disconnected"===r.t1?7:"channel_reestablished"===r.t1?7:"open"===r.t1?7:"fsm_up"===r.t1?9:"close_mutual"===r.t1?11:"closing"===r.t1?12:"closed_confirmed"===r.t1?14:"died"===r.t1?16:"shutdown"===r.t1?18:19;break;case 6:return r.abrupt("return",{handler:$t});case 7:return kt(e,t.params.data.event),r.abrupt("return",{handler:zt});case 9:return Ot.set(e,t.params.data.fsm_id),r.abrupt("return",{handler:zt});case 11:return r.abrupt("return",{handler:zt});case 12:return It(e,"closing"),r.abrupt("return",{handler:zt});case 14:return It(e,"closed"),r.abrupt("return",{handler:pn});case 16:return It(e,"died"),r.abrupt("return",{handler:pn});case 18:return r.abrupt("return",{handler:zt});case 19:return r.abrupt("break",26);case 20:return kt(e,"onChainTx",t.params.data.tx,{info:t.params.data.info,type:t.params.data.type}),r.abrupt("return",{handler:zt});case 22:return r.abrupt("return",{handler:zt});case 23:return Pt(e,t.params.data.state),r.abrupt("return",{handler:zt});case 25:return r.abrupt("return",$t(e,t,n));case 26:case"end":return r.stop()}}))}function Gt(e,t,n){var r,a,o,i,c;return b.a.async((function(s){for(;;)switch(s.prev=s.next){case 0:if("channels.sign.update"!==t.method){s.next=17;break}if(r=n.sign,!t.params.data.tx){s.next=8;break}return s.next=5,b.a.awrap(r(t.params.data.tx,{updates:t.params.data.updates}));case 5:return a=s.sent,At(e,{jsonrpc:"2.0",method:"channels.update",params:{tx:a}}),s.abrupt("return",{handler:Xt,state:n});case 8:return s.next=10,b.a.awrap(Ut(t.params.data.signed_tx,(function(e){return r(e,{updates:t.params.data.updates})})));case 10:if("string"!=typeof(o=s.sent)){s.next=14;break}return At(e,{jsonrpc:"2.0",method:"channels.update",params:{signed_tx:o}}),s.abrupt("return",{handler:Xt,state:n});case 14:if("number"!=typeof o){s.next=17;break}return At(e,{jsonrpc:"2.0",method:"channels.update",params:{error:o}}),s.abrupt("return",{handler:Gt,state:n});case 17:if("channels.error"!==t.method){s.next=20;break}return n.reject(new Error(t.data.message)),s.abrupt("return",{handler:zt});case 20:if(!t.error){s.next=24;break}return i=t.error.data,(c=void 0===i?[]:i).find((function(e){return 1001===e.code}))?n.reject(new Error("Insufficient balance")):c.find((function(e){return 1002===e.code}))?n.reject(new Error("Amount cannot be negative")):n.reject(new Error(t.error.message)),s.abrupt("return",{handler:zt});case 24:if("channels.conflict"!==t.method){s.next=27;break}return n.resolve({accepted:!1,errorCode:t.params.data.error_code,errorMessage:t.params.data.error_msg}),s.abrupt("return",{handler:zt});case 27:if("channels.info"!==t.method){s.next=31;break}if("aborted_update"!==t.params.data.event){s.next=31;break}return n.resolve({accepted:!1}),s.abrupt("return",{handler:zt});case 31:return s.abrupt("return",Mt(0,t,n));case 32:case"end":return s.stop()}}))}function Xt(e,t,n){return"channels.update"===t.method?(Pt(e,t.params.data.state),n.resolve({accepted:!0,signedTx:t.params.data.state}),{handler:zt}):"channels.conflict"===t.method?(n.resolve({accepted:!1,errorCode:t.params.data.error_code,errorMessage:t.params.data.error_msg}),{handler:zt}):"channels.info"===t.method&&"aborted_update"===t.params.data.event?(n.resolve({accepted:!1}),{handler:zt}):t.error?(n.reject(new Error(t.error.message)),{handler:zt}):Mt(0,t,n)}function $t(e,t,n){var a,o,i,c,s;return b.a.async((function(u){for(;;)switch(u.prev=u.next){case 0:if(a=t.method.match(/^channels\.sign\.([^.]+)$/)||[],o=p()(a,2),!(i=o[1])){u.next=22;break}if(!t.params.data.tx){u.next=11;break}return u.next=5,b.a.awrap(ct.get(e).sign(i,t.params.data.tx,{updates:t.params.data.updates}));case 5:if(!(c=u.sent)){u.next=9;break}return At(e,{jsonrpc:"2.0",method:"channels.".concat(i),params:{tx:c}}),u.abrupt("return",{handler:zt});case 9:u.next=20;break;case 11:return u.next=13,b.a.awrap(Ut(t.params.data.signed_tx,(function(n){return ct.get(e).sign(i,n,{updates:t.params.data.updates})})));case 13:if("string"!=typeof(s=u.sent)){u.next=17;break}return At(e,{jsonrpc:"2.0",method:"channels.".concat(i),params:{signed_tx:s}}),u.abrupt("return",{handler:zt});case 17:if("number"!=typeof s){u.next=20;break}return At(e,{jsonrpc:"2.0",method:"channels.".concat(i),params:{error:s}}),u.abrupt("return",{handler:Jt,state:n});case 20:return At(e,{jsonrpc:"2.0",method:"channels.update.new",params:{from:Object(r.generateKeyPair)().publicKey,to:Object(r.generateKeyPair)().publicKey,amount:1}}),u.abrupt("return",{handler:Jt,state:n});case 22:return u.abrupt("return",Mt(0,t,n));case 23:case"end":return u.stop()}}))}function Jt(e,t,n){return t.error?{handler:Jt,state:n}:"channels.conflict"===t.method?{handler:zt}:Mt(0,t,n)}function Zt(e,t,n){var r,a;return b.a.async((function(o){for(;;)switch(o.prev=o.next){case 0:if("channels.sign.shutdown_sign"!==t.method){o.next=12;break}if(!t.params.data.tx){o.next=7;break}return o.next=4,b.a.awrap(n.sign(t.params.data.tx));case 4:return r=o.sent,At(e,{jsonrpc:"2.0",method:"channels.shutdown_sign",params:{tx:r}}),o.abrupt("return",{handler:en,state:n});case 7:return o.next=9,b.a.awrap(Ut(t.params.data.signed_tx,(function(e){return n.sign(e)})));case 9:return a=o.sent,At(e,{jsonrpc:"2.0",method:"channels.shutdown_sign",params:{signed_tx:a}}),o.abrupt("return",{handler:en,state:n});case 12:return o.abrupt("return",Mt(0,t,n));case 13:case"end":return o.stop()}}))}function en(e,t,n){return"channels.on_chain_tx"===t.method?(n.resolve(t.params.data.tx),{handler:pn}):Mt(0,t,n)}function tn(e,t,n){return"channels.leave"===t.method?(n.resolve({channelId:t.params.channel_id,signedTx:t.params.data.state}),Rt(e),{handler:pn}):"channels.error"===t.method?(n.reject(new Error(t.data.message)),{handler:zt}):Mt(0,t,n)}function nn(e,t,n){var r,a,o;return b.a.async((function(i){for(;;)switch(i.prev=i.next){case 0:if("channels.sign.withdraw_tx"!==t.method){i.next=17;break}if(r=n.sign,!t.params.data.tx){i.next=8;break}return i.next=5,b.a.awrap(r(t.params.data.tx,{updates:t.params.data.updates}));case 5:return a=i.sent,At(e,{jsonrpc:"2.0",method:"channels.withdraw_tx",params:{tx:a}}),i.abrupt("return",{handler:rn,state:n});case 8:return i.next=10,b.a.awrap(Ut(t.params.data.signed_tx,(function(e){return r(e,{updates:t.params.data.updates})})));case 10:if("string"!=typeof(o=i.sent)){i.next=14;break}return At(e,{jsonrpc:"2.0",method:"channels.withdraw_tx",params:{signed_tx:o}}),i.abrupt("return",{handler:rn,state:n});case 14:if("number"!=typeof o){i.next=17;break}return At(e,{jsonrpc:"2.0",method:"channels.withdraw_tx",params:{error:o}}),i.abrupt("return",{handler:rn,state:n});case 17:return i.abrupt("return",Mt(0,t,n));case 18:case"end":return i.stop()}}))}function rn(e,t,n){if("channels.on_chain_tx"===t.method)return n.onOnChainTx&&n.onOnChainTx(t.params.data.tx),{handler:rn,state:n};if("channels.info"===t.method&&["own_withdraw_locked","withdraw_locked"].includes(t.params.data.event)){var r={own_withdraw_locked:n.onOwnWithdrawLocked,withdraw_locked:n.onWithdrawLocked}[t.params.data.event];return r&&r(),{handler:rn,state:n}}return"channels.update"===t.method?(Pt(e,t.params.data.state),n.resolve({accepted:!0,signedTx:t.params.data.state}),{handler:zt}):"channels.conflict"===t.method?(n.resolve({accepted:!1,errorCode:t.params.data.error_code,errorMessage:t.params.data.error_msg}),{handler:zt}):"channels.info"===t.method&&"aborted_update"===t.params.data.event?(n.resolve({accepted:!1}),{handler:zt}):Mt(0,t,n)}function an(e,t,n){var r,a,o;return b.a.async((function(i){for(;;)switch(i.prev=i.next){case 0:if("channels.sign.deposit_tx"!==t.method){i.next=17;break}if(r=n.sign,!t.params.data.tx){i.next=8;break}return i.next=5,b.a.awrap(r(t.params.data.tx,{updates:t.params.data.updates}));case 5:return a=i.sent,At(e,{jsonrpc:"2.0",method:"channels.deposit_tx",params:{tx:a}}),i.abrupt("return",{handler:on,state:n});case 8:return i.next=10,b.a.awrap(Ut(t.params.data.signed_tx,(function(e){return r(e,{updates:t.params.data.updates})})));case 10:if("string"!=typeof(o=i.sent)){i.next=14;break}return At(e,{jsonrpc:"2.0",method:"channels.deposit_tx",params:{signed_tx:o}}),i.abrupt("return",{handler:on,state:n});case 14:if("number"!=typeof o){i.next=17;break}return At(e,{jsonrpc:"2.0",method:"channels.deposit_tx",params:{error:o}}),i.abrupt("return",{handler:on,state:n});case 17:return i.abrupt("return",Mt(0,t,n));case 18:case"end":return i.stop()}}))}function on(e,t,n){if("channels.on_chain_tx"===t.method)return n.onOnChainTx&&n.onOnChainTx(t.params.data.tx),{handler:on,state:n};if("channels.info"===t.method&&["own_deposit_locked","deposit_locked"].includes(t.params.data.event)){var r={own_deposit_locked:n.onOwnDepositLocked,deposit_locked:n.onDepositLocked}[t.params.data.event];return r&&r(),{handler:on,state:n}}return"channels.update"===t.method?(Pt(e,t.params.data.state),n.resolve({accepted:!0,signedTx:t.params.data.state}),{handler:zt}):"channels.conflict"===t.method?(n.resolve({accepted:!1,errorCode:t.params.data.error_code,errorMessage:t.params.data.error_msg}),{handler:zt}):"channels.info"===t.method&&"aborted_update"===t.params.data.event?(n.resolve({accepted:!1}),{handler:zt}):Mt(0,t,n)}function cn(e,t,n){var r,a;return b.a.async((function(o){for(;;)switch(o.prev=o.next){case 0:if("channels.sign.update"!==t.method){o.next=16;break}if(!t.params.data.tx){o.next=7;break}return o.next=4,b.a.awrap(n.sign(t.params.data.tx));case 4:return r=o.sent,At(e,{jsonrpc:"2.0",method:"channels.update",params:{tx:r}}),o.abrupt("return",{handler:sn,state:n});case 7:return o.next=9,b.a.awrap(Ut(t.params.data.signed_tx,(function(e){return n.sign(e)})));case 9:if("string"!=typeof(a=o.sent)){o.next=13;break}return At(e,{jsonrpc:"2.0",method:"channels.update",params:{signed_tx:a}}),o.abrupt("return",{handler:sn,state:n});case 13:if("number"!=typeof a){o.next=16;break}return At(e,{jsonrpc:"2.0",method:"channels.update",params:{error:a}}),o.abrupt("return",{handler:sn,state:n});case 16:return o.abrupt("return",Mt(0,t,n));case 17:case"end":return o.stop()}}))}function sn(e,t,n){if("channels.update"===t.method){var a=Object(i.unpackTx)(t.params.data.state).tx.encodedTx.tx.round,o=ct.get(e)[{initiator:"initiatorId",responder:"responderId"}[ct.get(e).role]];return Pt(e,t.params.data.state),n.resolve({accepted:!0,address:Object(r.encodeContractAddress)(o,a),signedTx:t.params.data.state}),{handler:zt}}return"channels.conflict"===t.method?(n.resolve({accepted:!1,errorCode:t.params.data.error_code,errorMessage:t.params.data.error_msg}),{handler:zt}):"channels.info"===t.method&&"aborted_update"===t.params.data.event?(n.resolve({accepted:!1}),{handler:zt}):Mt(0,t,n)}function un(e,t,n){var r,a;return b.a.async((function(o){for(;;)switch(o.prev=o.next){case 0:if("channels.sign.update"!==t.method){o.next=16;break}if(!t.params.data.tx){o.next=7;break}return o.next=4,b.a.awrap(n.sign(t.params.data.tx));case 4:return r=o.sent,At(e,{jsonrpc:"2.0",method:"channels.update",params:{tx:r}}),o.abrupt("return",{handler:fn,state:n});case 7:return o.next=9,b.a.awrap(Ut(t.params.data.signed_tx,(function(e){return n.sign(e)})));case 9:if("string"!=typeof(a=o.sent)){o.next=13;break}return At(e,{jsonrpc:"2.0",method:"channels.update",params:{signed_tx:a}}),o.abrupt("return",{handler:fn,state:n});case 13:if("number"!=typeof a){o.next=16;break}return At(e,{jsonrpc:"2.0",method:"channels.update",params:{error:a}}),o.abrupt("return",{handler:fn,state:n});case 16:return o.abrupt("return",Mt(0,t,n));case 17:case"end":return o.stop()}}))}function fn(e,t,n){return"channels.update"===t.method?(Pt(e,t.params.data.state),n.resolve({accepted:!0,signedTx:t.params.data.state}),{handler:zt}):"channels.conflict"===t.method?(n.resolve({accepted:!1,errorCode:t.params.data.error_code,errorMessage:t.params.data.error_msg}),{handler:zt}):"channels.info"===t.method&&"aborted_update"===t.params.data.event?(n.resolve({accepted:!1}),{handler:zt}):Mt(0,t,n)}function ln(e,t,n){return"channels.calls_pruned.reply"===t.method?(n.resolve(),{handler:zt}):(n.reject(new Error("Unexpected message received")),{handler:pn})}function pn(e,t,n){return{handler:pn}}function dn(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function hn(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?dn(n,!0).forEach((function(t){x()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):dn(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function vn(e){return Object.entries(e).reduce((function(e,t){var n=p()(t,2),r=n[0],a=n[1];return hn({},e,x()({},Object(qe.c)(r),a))}),{})}zt.enter=function(e){It(e,"open")};var yn=Ee.a.compose({init:function(e){return b.a.async((function(t){for(;;)switch(t.prev=t.next){case 0:Vt(this,e);case 1:case"end":return t.stop()}}),null,this)},methods:{on:function(e,t){pt.get(this).on(e,t)},off:function(e,t){pt.get(this).removeListener(e,t)},status:function(){return st.get(this)},state:function(){return b.a.async((function(e){for(;;)switch(e.prev=e.next){case 0:return e.t0=vn,e.next=3,b.a.awrap(Nt(this,"channels.get.offchain_state",{}));case 3:return e.t1=e.sent,e.abrupt("return",(0,e.t0)(e.t1));case 5:case"end":return e.stop()}}),null,this)},round:function(){if(!ut.get(this))return null;var e=Object(i.unpackTx)(ut.get(this)).tx.encodedTx,t=e.txType,n=e.tx;switch(t){case L.B.channelCreate:return 1;case L.B.channelOffChain:case L.B.channelWithdraw:case L.B.channelDeposit:return parseInt(n.round,10);default:return null}},id:function(){return bt.get(this)},fsmId:function(){return Ot.get(this)},update:function(e,t,n,r,a){var o=this;return new Promise((function(i,c){Ct(o,(function(e,t){return t.handler===zt}),(function(o,s){return At(o,{jsonrpc:"2.0",method:"channels.update.new",params:{from:e,to:t,amount:n,meta:a}}),{handler:Gt,state:{resolve:i,reject:c,sign:r}}}))}))},poi:function(e){var t,n;return b.a.async((function(r){for(;;)switch(r.prev=r.next){case 0:return t=e.accounts,n=e.contracts,r.next=3,b.a.awrap(Nt(this,"channels.get.poi",{accounts:t,contracts:n}));case 3:return r.abrupt("return",r.sent.poi);case 4:case"end":return r.stop()}}),null,this)},balances:function(e){return b.a.async((function(t){for(;;)switch(t.prev=t.next){case 0:return t.t0=Me.a,t.t1=function(e,t){return hn({},e,x()({},t.account,t.balance))},t.t2={},t.next=5,b.a.awrap(Nt(this,"channels.get.balances",{accounts:e}));case 5:return t.t3=t.sent,t.abrupt("return",(0,t.t0)(t.t1,t.t2,t.t3));case 7:case"end":return t.stop()}}),null,this)},leave:function(){var e=this;return new Promise((function(t,n){Ct(e,(function(e,t){return t.handler===zt}),(function(e,r){return At(e,{jsonrpc:"2.0",method:"channels.leave",params:{}}),{handler:tn,state:{resolve:t,reject:n}}}))}))},shutdown:function(e){var t=this;return new Promise((function(n,r){Ct(t,(function(e,t){return t.handler===zt}),(function(t,a){return At(t,{jsonrpc:"2.0",method:"channels.shutdown",params:{}}),{handler:Zt,state:{sign:e,resolve:n,reject:r}}}))}))},sendMessage:function(e,t){var n=this,r=e;"object"===Z()(e)&&(r=JSON.stringify(e));var a=function(e){return At(e,{jsonrpc:"2.0",method:"channels.message",params:{info:r,to:t}})};if("connecting"===this.status()){this.on("statusChanged",(function e(t){"connecting"!==t&&(setTimeout((function(){return a(n)}),500),n.off("statusChanged",e))}))}else a(this)},withdraw:function(e,t){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},a=r.onOnChainTx,o=r.onOwnWithdrawLocked,i=r.onWithdrawLocked;return new Promise((function(r,c){Ct(n,(function(e,t){return t.handler===zt}),(function(n,s){return At(n,{jsonrpc:"2.0",method:"channels.withdraw",params:{amount:e}}),{handler:nn,state:{sign:t,resolve:r,reject:c,onOnChainTx:a,onOwnWithdrawLocked:o,onWithdrawLocked:i}}}))}))},deposit:function(e,t){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},a=r.onOnChainTx,o=r.onOwnDepositLocked,i=r.onDepositLocked;return new Promise((function(r,c){Ct(n,(function(e,t){return t.handler===zt}),(function(n,s){return At(n,{jsonrpc:"2.0",method:"channels.deposit",params:{amount:e}}),{handler:an,state:{sign:t,resolve:r,reject:c,onOnChainTx:a,onOwnDepositLocked:o,onDepositLocked:i}}}))}))},createContract:function(e,t){var n=this,r=e.code,a=e.callData,o=e.deposit,i=e.vmVersion,c=e.abiVersion;return new Promise((function(e,s){Ct(n,(function(e,t){return t.handler===zt}),(function(n,u){return At(n,{jsonrpc:"2.0",method:"channels.update.new_contract",params:{code:r,call_data:a,deposit:o,vm_version:i,abi_version:c}}),{handler:cn,state:{sign:t,resolve:e,reject:s}}}))}))},callContract:function(e,t){var n=this,r=e.amount,a=e.callData,o=e.contract,i=e.abiVersion;return new Promise((function(e,c){Ct(n,(function(e,t){return t.handler===zt}),(function(n,s){return At(n,{jsonrpc:"2.0",method:"channels.update.call_contract",params:{amount:r,call_data:a,contract_id:o,abi_version:i}}),{handler:un,state:{resolve:e,reject:c,sign:t}}}))}))},callContractStatic:function(e){var t,n,r,a;return b.a.async((function(o){for(;;)switch(o.prev=o.next){case 0:return t=e.amount,n=e.callData,r=e.contract,a=e.abiVersion,o.t0=vn,o.next=4,b.a.awrap(Nt(this,"channels.dry_run.call_contract",{amount:t,call_data:n,contract_id:r,abi_version:a}));case 4:return o.t1=o.sent,o.abrupt("return",(0,o.t0)(o.t1));case 6:case"end":return o.stop()}}),null,this)},getContractCall:function(e){var t,n,r;return b.a.async((function(a){for(;;)switch(a.prev=a.next){case 0:return t=e.caller,n=e.contract,r=e.round,a.t0=vn,a.next=4,b.a.awrap(Nt(this,"channels.get.contract_call",{caller_id:t,contract_id:n,round:r}));case 4:return a.t1=a.sent,a.abrupt("return",(0,a.t0)(a.t1));case 6:case"end":return a.stop()}}),null,this)},getContractState:function(e){var t;return b.a.async((function(n){for(;;)switch(n.prev=n.next){case 0:return n.next=2,b.a.awrap(Nt(this,"channels.get.contract",{pubkey:e}));case 2:return t=n.sent,n.abrupt("return",vn(hn({},t,{contract:vn(t.contract)})));case 4:case"end":return n.stop()}}),null,this)},disconnect:function(){return Rt(this)},cleanContractCalls:function(){var e=this;return new Promise((function(t,n){Ct(e,(function(e,t){return t.handler===zt}),(function(e,r){return At(e,{jsonrpc:"2.0",method:"channels.clean_contract_calls",params:{}}),{handler:ln,state:{resolve:t,reject:n}}}))}))}},statics:{reconnect:function(e,t){var n;return b.a.async((function(r){for(;;)switch(r.prev=r.next){case 0:return n=e.sign,r.t0=yn,r.t1=hn,r.t2={},r.t3=e,r.next=7,b.a.awrap(n("reconnect",Object(i.buildTx)(t,L.B.channelReconnect).tx));case 7:return r.t4=r.sent,r.t5={reconnectTx:r.t4},r.t6=(0,r.t1)(r.t2,r.t3,r.t5),r.abrupt("return",(0,r.t0)(r.t6));case 11:case"end":return r.stop()}}))}}}),gn=yn,bn=u.a.compose(z.a,R,_.b,Y,X.a,$.b,De,oe,{init:function(){},props:{process:{}}}),mn=bn,xn=n(62);n.d(t,"Account",(function(){return Q.a})),n.d(t,"Accounts",(function(){return z.a})),n.d(t,"Ae",(function(){return u.a})),n.d(t,"Aens",(function(){return X.a})),n.d(t,"Aepp",(function(){return Ve})),n.d(t,"Bytes",(function(){return o})),n.d(t,"Contract",(function(){return $.b})),n.d(t,"ContractCompilerAPI",(function(){return ie.a})),n.d(t,"ContractACI",(function(){return xn.a})),n.d(t,"ChainNode",(function(){return R})),n.d(t,"Channel",(function(){return gn})),n.d(t,"Crypto",(function(){return r})),n.d(t,"Keystore",(function(){return a})),n.d(t,"Chain",(function(){return f.a})),n.d(t,"GeneralizeAccount",(function(){return oe})),n.d(t,"HdWallet",(function(){return s.a})),n.d(t,"MemoryAccount",(function(){return G.a})),n.d(t,"Node",(function(){return D.a})),n.d(t,"NodePool",(function(){return _.b})),n.d(t,"Oracle",(function(){return De})),n.d(t,"OracleNodeAPI",(function(){return j})),n.d(t,"Selector",(function(){return Fe.a})),n.d(t,"Transaction",(function(){return Y})),n.d(t,"TransactionValidator",(function(){return E.a})),n.d(t,"Tx",(function(){return V.a})),n.d(t,"TxBuilder",(function(){return i})),n.d(t,"TxBuilderHelper",(function(){return c})),n.d(t,"Universal",(function(){return mn})),n.d(t,"Wallet",(function(){return Pe}))}])}));
//# sourceMappingURL=aepp-sdk.browser.js.map

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;;(function (globalObject) {
  'use strict';

/*
 *      bignumber.js v9.0.0
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2019 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */


  var BigNumber,
    isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i,
    mathceil = Math.ceil,
    mathfloor = Math.floor,

    bignumberError = '[BigNumber Error] ',
    tooManyDigits = bignumberError + 'Number primitive has more than 15 significant digits: ',

    BASE = 1e14,
    LOG_BASE = 14,
    MAX_SAFE_INTEGER = 0x1fffffffffffff,         // 2^53 - 1
    // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13],
    SQRT_BASE = 1e7,

    // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9;                                   // 0 to MAX_INT32


  /*
   * Create and return a BigNumber constructor.
   */
  function clone(configObject) {
    var div, convertBase, parseNumeric,
      P = BigNumber.prototype = { constructor: BigNumber, toString: null, valueOf: null },
      ONE = new BigNumber(1),


      //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------


      // The default values below must be integers within the inclusive ranges stated.
      // The values can also be changed at run-time using BigNumber.set.

      // The maximum number of decimal places for operations involving division.
      DECIMAL_PLACES = 20,                     // 0 to MAX

      // The rounding mode used when rounding to the above decimal places, and when using
      // toExponential, toFixed, toFormat and toPrecision, and round (default value).
      // UP         0 Away from zero.
      // DOWN       1 Towards zero.
      // CEIL       2 Towards +Infinity.
      // FLOOR      3 Towards -Infinity.
      // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
      // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
      // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
      // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
      // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
      ROUNDING_MODE = 4,                       // 0 to 8

      // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]

      // The exponent value at and beneath which toString returns exponential notation.
      // Number type: -7
      TO_EXP_NEG = -7,                         // 0 to -MAX

      // The exponent value at and above which toString returns exponential notation.
      // Number type: 21
      TO_EXP_POS = 21,                         // 0 to MAX

      // RANGE : [MIN_EXP, MAX_EXP]

      // The minimum exponent value, beneath which underflow to zero occurs.
      // Number type: -324  (5e-324)
      MIN_EXP = -1e7,                          // -1 to -MAX

      // The maximum exponent value, above which overflow to Infinity occurs.
      // Number type:  308  (1.7976931348623157e+308)
      // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
      MAX_EXP = 1e7,                           // 1 to MAX

      // Whether to use cryptographically-secure random number generation, if available.
      CRYPTO = false,                          // true or false

      // The modulo mode used when calculating the modulus: a mod n.
      // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
      // The remainder (r) is calculated as: r = a - n * q.
      //
      // UP        0 The remainder is positive if the dividend is negative, else is negative.
      // DOWN      1 The remainder has the same sign as the dividend.
      //             This modulo mode is commonly known as 'truncated division' and is
      //             equivalent to (a % n) in JavaScript.
      // FLOOR     3 The remainder has the same sign as the divisor (Python %).
      // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
      // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
      //             The remainder is always positive.
      //
      // The truncated division, floored division, Euclidian division and IEEE 754 remainder
      // modes are commonly used for the modulus operation.
      // Although the other rounding modes can also be used, they may not give useful results.
      MODULO_MODE = 1,                         // 0 to 9

      // The maximum number of significant digits of the result of the exponentiatedBy operation.
      // If POW_PRECISION is 0, there will be unlimited significant digits.
      POW_PRECISION = 0,                    // 0 to MAX

      // The format specification used by the BigNumber.prototype.toFormat method.
      FORMAT = {
        prefix: '',
        groupSize: 3,
        secondaryGroupSize: 0,
        groupSeparator: ',',
        decimalSeparator: '.',
        fractionGroupSize: 0,
        fractionGroupSeparator: '\xA0',      // non-breaking space
        suffix: ''
      },

      // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
      // '-', '.', whitespace, or repeated character.
      // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
      ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz';


    //------------------------------------------------------------------------------------------


    // CONSTRUCTOR


    /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */
    function BigNumber(v, b) {
      var alphabet, c, caseChanged, e, i, isNum, len, str,
        x = this;

      // Enable constructor call without `new`.
      if (!(x instanceof BigNumber)) return new BigNumber(v, b);

      if (b == null) {

        if (v && v._isBigNumber === true) {
          x.s = v.s;

          if (!v.c || v.e > MAX_EXP) {
            x.c = x.e = null;
          } else if (v.e < MIN_EXP) {
            x.c = [x.e = 0];
          } else {
            x.e = v.e;
            x.c = v.c.slice();
          }

          return;
        }

        if ((isNum = typeof v == 'number') && v * 0 == 0) {

          // Use `1 / n` to handle minus zero also.
          x.s = 1 / v < 0 ? (v = -v, -1) : 1;

          // Fast path for integers, where n < 2147483648 (2**31).
          if (v === ~~v) {
            for (e = 0, i = v; i >= 10; i /= 10, e++);

            if (e > MAX_EXP) {
              x.c = x.e = null;
            } else {
              x.e = e;
              x.c = [v];
            }

            return;
          }

          str = String(v);
        } else {

          if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);

          x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
        }

        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');

        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {

          // Determine exponent.
          if (e < 0) e = i;
          e += +str.slice(i + 1);
          str = str.substring(0, i);
        } else if (e < 0) {

          // Integer.
          e = str.length;
        }

      } else {

        // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
        intCheck(b, 2, ALPHABET.length, 'Base');

        // Allow exponential notation to be used with base 10 argument, while
        // also rounding to DECIMAL_PLACES as with other bases.
        if (b == 10) {
          x = new BigNumber(v);
          return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
        }

        str = String(v);

        if (isNum = typeof v == 'number') {

          // Avoid potential interpretation of Infinity and NaN as base 44+ values.
          if (v * 0 != 0) return parseNumeric(x, str, isNum, b);

          x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;

          // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
          if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, '').length > 15) {
            throw Error
             (tooManyDigits + v);
          }
        } else {
          x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
        }

        alphabet = ALPHABET.slice(0, b);
        e = i = 0;

        // Check that str is a valid base b number.
        // Don't use RegExp, so alphabet can contain special characters.
        for (len = str.length; i < len; i++) {
          if (alphabet.indexOf(c = str.charAt(i)) < 0) {
            if (c == '.') {

              // If '.' is not the first character and it has not be found before.
              if (i > e) {
                e = len;
                continue;
              }
            } else if (!caseChanged) {

              // Allow e.g. hexadecimal 'FF' as well as 'ff'.
              if (str == str.toUpperCase() && (str = str.toLowerCase()) ||
                  str == str.toLowerCase() && (str = str.toUpperCase())) {
                caseChanged = true;
                i = -1;
                e = 0;
                continue;
              }
            }

            return parseNumeric(x, String(v), isNum, b);
          }
        }

        // Prevent later check for length on converted number.
        isNum = false;
        str = convertBase(str, b, 10, x.s);

        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        else e = str.length;
      }

      // Determine leading zeros.
      for (i = 0; str.charCodeAt(i) === 48; i++);

      // Determine trailing zeros.
      for (len = str.length; str.charCodeAt(--len) === 48;);

      if (str = str.slice(i, ++len)) {
        len -= i;

        // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
        if (isNum && BigNumber.DEBUG &&
          len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) {
            throw Error
             (tooManyDigits + (x.s * v));
        }

         // Overflow?
        if ((e = e - i - 1) > MAX_EXP) {

          // Infinity.
          x.c = x.e = null;

        // Underflow?
        } else if (e < MIN_EXP) {

          // Zero.
          x.c = [x.e = 0];
        } else {
          x.e = e;
          x.c = [];

          // Transform base

          // e is the base 10 exponent.
          // i is where to slice str to get the first element of the coefficient array.
          i = (e + 1) % LOG_BASE;
          if (e < 0) i += LOG_BASE;  // i < 1

          if (i < len) {
            if (i) x.c.push(+str.slice(0, i));

            for (len -= LOG_BASE; i < len;) {
              x.c.push(+str.slice(i, i += LOG_BASE));
            }

            i = LOG_BASE - (str = str.slice(i)).length;
          } else {
            i -= len;
          }

          for (; i--; str += '0');
          x.c.push(+str);
        }
      } else {

        // Zero.
        x.c = [x.e = 0];
      }
    }


    // CONSTRUCTOR PROPERTIES


    BigNumber.clone = clone;

    BigNumber.ROUND_UP = 0;
    BigNumber.ROUND_DOWN = 1;
    BigNumber.ROUND_CEIL = 2;
    BigNumber.ROUND_FLOOR = 3;
    BigNumber.ROUND_HALF_UP = 4;
    BigNumber.ROUND_HALF_DOWN = 5;
    BigNumber.ROUND_HALF_EVEN = 6;
    BigNumber.ROUND_HALF_CEIL = 7;
    BigNumber.ROUND_HALF_FLOOR = 8;
    BigNumber.EUCLID = 9;


    /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */
    BigNumber.config = BigNumber.set = function (obj) {
      var p, v;

      if (obj != null) {

        if (typeof obj == 'object') {

          // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
          // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
          if (obj.hasOwnProperty(p = 'DECIMAL_PLACES')) {
            v = obj[p];
            intCheck(v, 0, MAX, p);
            DECIMAL_PLACES = v;
          }

          // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
          // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
          if (obj.hasOwnProperty(p = 'ROUNDING_MODE')) {
            v = obj[p];
            intCheck(v, 0, 8, p);
            ROUNDING_MODE = v;
          }

          // EXPONENTIAL_AT {number|number[]}
          // Integer, -MAX to MAX inclusive or
          // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
          // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
          if (obj.hasOwnProperty(p = 'EXPONENTIAL_AT')) {
            v = obj[p];
            if (v && v.pop) {
              intCheck(v[0], -MAX, 0, p);
              intCheck(v[1], 0, MAX, p);
              TO_EXP_NEG = v[0];
              TO_EXP_POS = v[1];
            } else {
              intCheck(v, -MAX, MAX, p);
              TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
            }
          }

          // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
          // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
          // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
          if (obj.hasOwnProperty(p = 'RANGE')) {
            v = obj[p];
            if (v && v.pop) {
              intCheck(v[0], -MAX, -1, p);
              intCheck(v[1], 1, MAX, p);
              MIN_EXP = v[0];
              MAX_EXP = v[1];
            } else {
              intCheck(v, -MAX, MAX, p);
              if (v) {
                MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
              } else {
                throw Error
                 (bignumberError + p + ' cannot be zero: ' + v);
              }
            }
          }

          // CRYPTO {boolean} true or false.
          // '[BigNumber Error] CRYPTO not true or false: {v}'
          // '[BigNumber Error] crypto unavailable'
          if (obj.hasOwnProperty(p = 'CRYPTO')) {
            v = obj[p];
            if (v === !!v) {
              if (v) {
                if (typeof crypto != 'undefined' && crypto &&
                 (crypto.getRandomValues || crypto.randomBytes)) {
                  CRYPTO = v;
                } else {
                  CRYPTO = !v;
                  throw Error
                   (bignumberError + 'crypto unavailable');
                }
              } else {
                CRYPTO = v;
              }
            } else {
              throw Error
               (bignumberError + p + ' not true or false: ' + v);
            }
          }

          // MODULO_MODE {number} Integer, 0 to 9 inclusive.
          // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
          if (obj.hasOwnProperty(p = 'MODULO_MODE')) {
            v = obj[p];
            intCheck(v, 0, 9, p);
            MODULO_MODE = v;
          }

          // POW_PRECISION {number} Integer, 0 to MAX inclusive.
          // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
          if (obj.hasOwnProperty(p = 'POW_PRECISION')) {
            v = obj[p];
            intCheck(v, 0, MAX, p);
            POW_PRECISION = v;
          }

          // FORMAT {object}
          // '[BigNumber Error] FORMAT not an object: {v}'
          if (obj.hasOwnProperty(p = 'FORMAT')) {
            v = obj[p];
            if (typeof v == 'object') FORMAT = v;
            else throw Error
             (bignumberError + p + ' not an object: ' + v);
          }

          // ALPHABET {string}
          // '[BigNumber Error] ALPHABET invalid: {v}'
          if (obj.hasOwnProperty(p = 'ALPHABET')) {
            v = obj[p];

            // Disallow if only one character,
            // or if it contains '+', '-', '.', whitespace, or a repeated character.
            if (typeof v == 'string' && !/^.$|[+-.\s]|(.).*\1/.test(v)) {
              ALPHABET = v;
            } else {
              throw Error
               (bignumberError + p + ' invalid: ' + v);
            }
          }

        } else {

          // '[BigNumber Error] Object expected: {v}'
          throw Error
           (bignumberError + 'Object expected: ' + obj);
        }
      }

      return {
        DECIMAL_PLACES: DECIMAL_PLACES,
        ROUNDING_MODE: ROUNDING_MODE,
        EXPONENTIAL_AT: [TO_EXP_NEG, TO_EXP_POS],
        RANGE: [MIN_EXP, MAX_EXP],
        CRYPTO: CRYPTO,
        MODULO_MODE: MODULO_MODE,
        POW_PRECISION: POW_PRECISION,
        FORMAT: FORMAT,
        ALPHABET: ALPHABET
      };
    };


    /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */
    BigNumber.isBigNumber = function (v) {
      if (!v || v._isBigNumber !== true) return false;
      if (!BigNumber.DEBUG) return true;

      var i, n,
        c = v.c,
        e = v.e,
        s = v.s;

      out: if ({}.toString.call(c) == '[object Array]') {

        if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {

          // If the first element is zero, the BigNumber value must be zero.
          if (c[0] === 0) {
            if (e === 0 && c.length === 1) return true;
            break out;
          }

          // Calculate number of digits that c[0] should have, based on the exponent.
          i = (e + 1) % LOG_BASE;
          if (i < 1) i += LOG_BASE;

          // Calculate number of digits of c[0].
          //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
          if (String(c[0]).length == i) {

            for (i = 0; i < c.length; i++) {
              n = c[i];
              if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
            }

            // Last element cannot be zero, unless it is the only element.
            if (n !== 0) return true;
          }
        }

      // Infinity/NaN
      } else if (c === null && e === null && (s === null || s === 1 || s === -1)) {
        return true;
      }

      throw Error
        (bignumberError + 'Invalid BigNumber: ' + v);
    };


    /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */
    BigNumber.maximum = BigNumber.max = function () {
      return maxOrMin(arguments, P.lt);
    };


    /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */
    BigNumber.minimum = BigNumber.min = function () {
      return maxOrMin(arguments, P.gt);
    };


    /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */
    BigNumber.random = (function () {
      var pow2_53 = 0x20000000000000;

      // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
      // Check if Math.random() produces more than 32 bits of randomness.
      // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
      // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
      var random53bitInt = (Math.random() * pow2_53) & 0x1fffff
       ? function () { return mathfloor(Math.random() * pow2_53); }
       : function () { return ((Math.random() * 0x40000000 | 0) * 0x800000) +
         (Math.random() * 0x800000 | 0); };

      return function (dp) {
        var a, b, e, k, v,
          i = 0,
          c = [],
          rand = new BigNumber(ONE);

        if (dp == null) dp = DECIMAL_PLACES;
        else intCheck(dp, 0, MAX);

        k = mathceil(dp / LOG_BASE);

        if (CRYPTO) {

          // Browsers supporting crypto.getRandomValues.
          if (crypto.getRandomValues) {

            a = crypto.getRandomValues(new Uint32Array(k *= 2));

            for (; i < k;) {

              // 53 bits:
              // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
              // 11111 11111111 11111111 11111111 11100000 00000000 00000000
              // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
              //                                     11111 11111111 11111111
              // 0x20000 is 2^21.
              v = a[i] * 0x20000 + (a[i + 1] >>> 11);

              // Rejection sampling:
              // 0 <= v < 9007199254740992
              // Probability that v >= 9e15, is
              // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
              if (v >= 9e15) {
                b = crypto.getRandomValues(new Uint32Array(2));
                a[i] = b[0];
                a[i + 1] = b[1];
              } else {

                // 0 <= v <= 8999999999999999
                // 0 <= (v % 1e14) <= 99999999999999
                c.push(v % 1e14);
                i += 2;
              }
            }
            i = k / 2;

          // Node.js supporting crypto.randomBytes.
          } else if (crypto.randomBytes) {

            // buffer
            a = crypto.randomBytes(k *= 7);

            for (; i < k;) {

              // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
              // 0x100000000 is 2^32, 0x1000000 is 2^24
              // 11111 11111111 11111111 11111111 11111111 11111111 11111111
              // 0 <= v < 9007199254740992
              v = ((a[i] & 31) * 0x1000000000000) + (a[i + 1] * 0x10000000000) +
                 (a[i + 2] * 0x100000000) + (a[i + 3] * 0x1000000) +
                 (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];

              if (v >= 9e15) {
                crypto.randomBytes(7).copy(a, i);
              } else {

                // 0 <= (v % 1e14) <= 99999999999999
                c.push(v % 1e14);
                i += 7;
              }
            }
            i = k / 7;
          } else {
            CRYPTO = false;
            throw Error
             (bignumberError + 'crypto unavailable');
          }
        }

        // Use Math.random.
        if (!CRYPTO) {

          for (; i < k;) {
            v = random53bitInt();
            if (v < 9e15) c[i++] = v % 1e14;
          }
        }

        k = c[--i];
        dp %= LOG_BASE;

        // Convert trailing digits to zeros according to dp.
        if (k && dp) {
          v = POWS_TEN[LOG_BASE - dp];
          c[i] = mathfloor(k / v) * v;
        }

        // Remove trailing elements which are zero.
        for (; c[i] === 0; c.pop(), i--);

        // Zero?
        if (i < 0) {
          c = [e = 0];
        } else {

          // Remove leading elements which are zero and adjust exponent accordingly.
          for (e = -1 ; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);

          // Count the digits of the first element of c to determine leading zeros, and...
          for (i = 1, v = c[0]; v >= 10; v /= 10, i++);

          // adjust the exponent accordingly.
          if (i < LOG_BASE) e -= LOG_BASE - i;
        }

        rand.e = e;
        rand.c = c;
        return rand;
      };
    })();


    /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */
    BigNumber.sum = function () {
      var i = 1,
        args = arguments,
        sum = new BigNumber(args[0]);
      for (; i < args.length;) sum = sum.plus(args[i++]);
      return sum;
    };


    // PRIVATE FUNCTIONS


    // Called by BigNumber and BigNumber.prototype.toString.
    convertBase = (function () {
      var decimal = '0123456789';

      /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */
      function toBaseOut(str, baseIn, baseOut, alphabet) {
        var j,
          arr = [0],
          arrL,
          i = 0,
          len = str.length;

        for (; i < len;) {
          for (arrL = arr.length; arrL--; arr[arrL] *= baseIn);

          arr[0] += alphabet.indexOf(str.charAt(i++));

          for (j = 0; j < arr.length; j++) {

            if (arr[j] > baseOut - 1) {
              if (arr[j + 1] == null) arr[j + 1] = 0;
              arr[j + 1] += arr[j] / baseOut | 0;
              arr[j] %= baseOut;
            }
          }
        }

        return arr.reverse();
      }

      // Convert a numeric string of baseIn to a numeric string of baseOut.
      // If the caller is toString, we are converting from base 10 to baseOut.
      // If the caller is BigNumber, we are converting from baseIn to base 10.
      return function (str, baseIn, baseOut, sign, callerIsToString) {
        var alphabet, d, e, k, r, x, xc, y,
          i = str.indexOf('.'),
          dp = DECIMAL_PLACES,
          rm = ROUNDING_MODE;

        // Non-integer.
        if (i >= 0) {
          k = POW_PRECISION;

          // Unlimited precision.
          POW_PRECISION = 0;
          str = str.replace('.', '');
          y = new BigNumber(baseIn);
          x = y.pow(str.length - i);
          POW_PRECISION = k;

          // Convert str as if an integer, then restore the fraction part by dividing the
          // result by its base raised to a power.

          y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, '0'),
           10, baseOut, decimal);
          y.e = y.c.length;
        }

        // Convert the number as integer.

        xc = toBaseOut(str, baseIn, baseOut, callerIsToString
         ? (alphabet = ALPHABET, decimal)
         : (alphabet = decimal, ALPHABET));

        // xc now represents str as an integer and converted to baseOut. e is the exponent.
        e = k = xc.length;

        // Remove trailing zeros.
        for (; xc[--k] == 0; xc.pop());

        // Zero?
        if (!xc[0]) return alphabet.charAt(0);

        // Does str represent an integer? If so, no need for the division.
        if (i < 0) {
          --e;
        } else {
          x.c = xc;
          x.e = e;

          // The sign is needed for correct rounding.
          x.s = sign;
          x = div(x, y, dp, rm, baseOut);
          xc = x.c;
          r = x.r;
          e = x.e;
        }

        // xc now represents str converted to baseOut.

        // THe index of the rounding digit.
        d = e + dp + 1;

        // The rounding digit: the digit to the right of the digit that may be rounded up.
        i = xc[d];

        // Look at the rounding digits and mode to determine whether to round up.

        k = baseOut / 2;
        r = r || d < 0 || xc[d + 1] != null;

        r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
              : i > k || i == k &&(rm == 4 || r || rm == 6 && xc[d - 1] & 1 ||
               rm == (x.s < 0 ? 8 : 7));

        // If the index of the rounding digit is not greater than zero, or xc represents
        // zero, then the result of the base conversion is zero or, if rounding up, a value
        // such as 0.00001.
        if (d < 1 || !xc[0]) {

          // 1^-dp or 0
          str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
        } else {

          // Truncate xc to the required number of decimal places.
          xc.length = d;

          // Round up?
          if (r) {

            // Rounding up may mean the previous digit has to be rounded up and so on.
            for (--baseOut; ++xc[--d] > baseOut;) {
              xc[d] = 0;

              if (!d) {
                ++e;
                xc = [1].concat(xc);
              }
            }
          }

          // Determine trailing zeros.
          for (k = xc.length; !xc[--k];);

          // E.g. [4, 11, 15] becomes 4bf.
          for (i = 0, str = ''; i <= k; str += alphabet.charAt(xc[i++]));

          // Add leading zeros, decimal point and trailing zeros as required.
          str = toFixedPoint(str, e, alphabet.charAt(0));
        }

        // The caller will add the sign.
        return str;
      };
    })();


    // Perform division in the specified base. Called by div and convertBase.
    div = (function () {

      // Assume non-zero x and k.
      function multiply(x, k, base) {
        var m, temp, xlo, xhi,
          carry = 0,
          i = x.length,
          klo = k % SQRT_BASE,
          khi = k / SQRT_BASE | 0;

        for (x = x.slice(); i--;) {
          xlo = x[i] % SQRT_BASE;
          xhi = x[i] / SQRT_BASE | 0;
          m = khi * xlo + xhi * klo;
          temp = klo * xlo + ((m % SQRT_BASE) * SQRT_BASE) + carry;
          carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
          x[i] = temp % base;
        }

        if (carry) x = [carry].concat(x);

        return x;
      }

      function compare(a, b, aL, bL) {
        var i, cmp;

        if (aL != bL) {
          cmp = aL > bL ? 1 : -1;
        } else {

          for (i = cmp = 0; i < aL; i++) {

            if (a[i] != b[i]) {
              cmp = a[i] > b[i] ? 1 : -1;
              break;
            }
          }
        }

        return cmp;
      }

      function subtract(a, b, aL, base) {
        var i = 0;

        // Subtract b from a.
        for (; aL--;) {
          a[aL] -= i;
          i = a[aL] < b[aL] ? 1 : 0;
          a[aL] = i * base + a[aL] - b[aL];
        }

        // Remove leading zeros.
        for (; !a[0] && a.length > 1; a.splice(0, 1));
      }

      // x: dividend, y: divisor.
      return function (x, y, dp, rm, base) {
        var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0,
          yL, yz,
          s = x.s == y.s ? 1 : -1,
          xc = x.c,
          yc = y.c;

        // Either NaN, Infinity or 0?
        if (!xc || !xc[0] || !yc || !yc[0]) {

          return new BigNumber(

           // Return NaN if either NaN, or both Infinity or 0.
           !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN :

            // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            xc && xc[0] == 0 || !yc ? s * 0 : s / 0
         );
        }

        q = new BigNumber(s);
        qc = q.c = [];
        e = x.e - y.e;
        s = dp + e + 1;

        if (!base) {
          base = BASE;
          e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
          s = s / LOG_BASE | 0;
        }

        // Result exponent may be one less then the current value of e.
        // The coefficients of the BigNumbers from convertBase may have trailing zeros.
        for (i = 0; yc[i] == (xc[i] || 0); i++);

        if (yc[i] > (xc[i] || 0)) e--;

        if (s < 0) {
          qc.push(1);
          more = true;
        } else {
          xL = xc.length;
          yL = yc.length;
          i = 0;
          s += 2;

          // Normalise xc and yc so highest order digit of yc is >= base / 2.

          n = mathfloor(base / (yc[0] + 1));

          // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
          // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
          if (n > 1) {
            yc = multiply(yc, n, base);
            xc = multiply(xc, n, base);
            yL = yc.length;
            xL = xc.length;
          }

          xi = yL;
          rem = xc.slice(0, yL);
          remL = rem.length;

          // Add zeros to make remainder as long as divisor.
          for (; remL < yL; rem[remL++] = 0);
          yz = yc.slice();
          yz = [0].concat(yz);
          yc0 = yc[0];
          if (yc[1] >= base / 2) yc0++;
          // Not necessary, but to prevent trial digit n > base, when using base 3.
          // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;

          do {
            n = 0;

            // Compare divisor and remainder.
            cmp = compare(yc, rem, yL, remL);

            // If divisor < remainder.
            if (cmp < 0) {

              // Calculate trial digit, n.

              rem0 = rem[0];
              if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);

              // n is how many times the divisor goes into the current remainder.
              n = mathfloor(rem0 / yc0);

              //  Algorithm:
              //  product = divisor multiplied by trial digit (n).
              //  Compare product and remainder.
              //  If product is greater than remainder:
              //    Subtract divisor from product, decrement trial digit.
              //  Subtract product from remainder.
              //  If product was less than remainder at the last compare:
              //    Compare new remainder and divisor.
              //    If remainder is greater than divisor:
              //      Subtract divisor from remainder, increment trial digit.

              if (n > 1) {

                // n may be > base only when base is 3.
                if (n >= base) n = base - 1;

                // product = divisor * trial digit.
                prod = multiply(yc, n, base);
                prodL = prod.length;
                remL = rem.length;

                // Compare product and remainder.
                // If product > remainder then trial digit n too high.
                // n is 1 too high about 5% of the time, and is not known to have
                // ever been more than 1 too high.
                while (compare(prod, rem, prodL, remL) == 1) {
                  n--;

                  // Subtract divisor from product.
                  subtract(prod, yL < prodL ? yz : yc, prodL, base);
                  prodL = prod.length;
                  cmp = 1;
                }
              } else {

                // n is 0 or 1, cmp is -1.
                // If n is 0, there is no need to compare yc and rem again below,
                // so change cmp to 1 to avoid it.
                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                if (n == 0) {

                  // divisor < remainder, so n must be at least 1.
                  cmp = n = 1;
                }

                // product = divisor
                prod = yc.slice();
                prodL = prod.length;
              }

              if (prodL < remL) prod = [0].concat(prod);

              // Subtract product from remainder.
              subtract(rem, prod, remL, base);
              remL = rem.length;

               // If product was < remainder.
              if (cmp == -1) {

                // Compare divisor and new remainder.
                // If divisor < new remainder, subtract divisor from remainder.
                // Trial digit n too low.
                // n is 1 too low about 5% of the time, and very rarely 2 too low.
                while (compare(yc, rem, yL, remL) < 1) {
                  n++;

                  // Subtract divisor from remainder.
                  subtract(rem, yL < remL ? yz : yc, remL, base);
                  remL = rem.length;
                }
              }
            } else if (cmp === 0) {
              n++;
              rem = [0];
            } // else cmp === 1 and n will be 0

            // Add the next digit, n, to the result array.
            qc[i++] = n;

            // Update the remainder.
            if (rem[0]) {
              rem[remL++] = xc[xi] || 0;
            } else {
              rem = [xc[xi]];
              remL = 1;
            }
          } while ((xi++ < xL || rem[0] != null) && s--);

          more = rem[0] != null;

          // Leading zero?
          if (!qc[0]) qc.splice(0, 1);
        }

        if (base == BASE) {

          // To calculate q.e, first get the number of digits of qc[0].
          for (i = 1, s = qc[0]; s >= 10; s /= 10, i++);

          round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);

        // Caller is convertBase.
        } else {
          q.e = e;
          q.r = +more;
        }

        return q;
      };
    })();


    /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */
    function format(n, i, rm, id) {
      var c0, e, ne, len, str;

      if (rm == null) rm = ROUNDING_MODE;
      else intCheck(rm, 0, 8);

      if (!n.c) return n.toString();

      c0 = n.c[0];
      ne = n.e;

      if (i == null) {
        str = coeffToString(n.c);
        str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS)
         ? toExponential(str, ne)
         : toFixedPoint(str, ne, '0');
      } else {
        n = round(new BigNumber(n), i, rm);

        // n.e may have changed if the value was rounded up.
        e = n.e;

        str = coeffToString(n.c);
        len = str.length;

        // toPrecision returns exponential notation if the number of significant digits
        // specified is less than the number of digits necessary to represent the integer
        // part of the value in fixed-point notation.

        // Exponential notation.
        if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {

          // Append zeros?
          for (; len < i; str += '0', len++);
          str = toExponential(str, e);

        // Fixed-point notation.
        } else {
          i -= ne;
          str = toFixedPoint(str, e, '0');

          // Append zeros?
          if (e + 1 > len) {
            if (--i > 0) for (str += '.'; i--; str += '0');
          } else {
            i += e - len;
            if (i > 0) {
              if (e + 1 == len) str += '.';
              for (; i--; str += '0');
            }
          }
        }
      }

      return n.s < 0 && c0 ? '-' + str : str;
    }


    // Handle BigNumber.max and BigNumber.min.
    function maxOrMin(args, method) {
      var n,
        i = 1,
        m = new BigNumber(args[0]);

      for (; i < args.length; i++) {
        n = new BigNumber(args[i]);

        // If any number is NaN, return NaN.
        if (!n.s) {
          m = n;
          break;
        } else if (method.call(m, n)) {
          m = n;
        }
      }

      return m;
    }


    /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */
    function normalise(n, c, e) {
      var i = 1,
        j = c.length;

       // Remove trailing zeros.
      for (; !c[--j]; c.pop());

      // Calculate the base 10 exponent. First get the number of digits of c[0].
      for (j = c[0]; j >= 10; j /= 10, i++);

      // Overflow?
      if ((e = i + e * LOG_BASE - 1) > MAX_EXP) {

        // Infinity.
        n.c = n.e = null;

      // Underflow?
      } else if (e < MIN_EXP) {

        // Zero.
        n.c = [n.e = 0];
      } else {
        n.e = e;
        n.c = c;
      }

      return n;
    }


    // Handle values that fail the validity test in BigNumber.
    parseNumeric = (function () {
      var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i,
        dotAfter = /^([^.]+)\.$/,
        dotBefore = /^\.([^.]+)$/,
        isInfinityOrNaN = /^-?(Infinity|NaN)$/,
        whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;

      return function (x, str, isNum, b) {
        var base,
          s = isNum ? str : str.replace(whitespaceOrPlus, '');

        // No exception on ±Infinity or NaN.
        if (isInfinityOrNaN.test(s)) {
          x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
        } else {
          if (!isNum) {

            // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
            s = s.replace(basePrefix, function (m, p1, p2) {
              base = (p2 = p2.toLowerCase()) == 'x' ? 16 : p2 == 'b' ? 2 : 8;
              return !b || b == base ? p1 : m;
            });

            if (b) {
              base = b;

              // E.g. '1.' to '1', '.1' to '0.1'
              s = s.replace(dotAfter, '$1').replace(dotBefore, '0.$1');
            }

            if (str != s) return new BigNumber(s, base);
          }

          // '[BigNumber Error] Not a number: {n}'
          // '[BigNumber Error] Not a base {b} number: {n}'
          if (BigNumber.DEBUG) {
            throw Error
              (bignumberError + 'Not a' + (b ? ' base ' + b : '') + ' number: ' + str);
          }

          // NaN
          x.s = null;
        }

        x.c = x.e = null;
      }
    })();


    /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */
    function round(x, sd, rm, r) {
      var d, i, j, k, n, ni, rd,
        xc = x.c,
        pows10 = POWS_TEN;

      // if x is not Infinity or NaN...
      if (xc) {

        // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
        // n is a base 1e14 number, the value of the element of array x.c containing rd.
        // ni is the index of n within x.c.
        // d is the number of digits of n.
        // i is the index of rd within n including leading zeros.
        // j is the actual index of rd within n (if < 0, rd is a leading zero).
        out: {

          // Get the number of digits of the first element of xc.
          for (d = 1, k = xc[0]; k >= 10; k /= 10, d++);
          i = sd - d;

          // If the rounding digit is in the first element of xc...
          if (i < 0) {
            i += LOG_BASE;
            j = sd;
            n = xc[ni = 0];

            // Get the rounding digit at index j of n.
            rd = n / pows10[d - j - 1] % 10 | 0;
          } else {
            ni = mathceil((i + 1) / LOG_BASE);

            if (ni >= xc.length) {

              if (r) {

                // Needed by sqrt.
                for (; xc.length <= ni; xc.push(0));
                n = rd = 0;
                d = 1;
                i %= LOG_BASE;
                j = i - LOG_BASE + 1;
              } else {
                break out;
              }
            } else {
              n = k = xc[ni];

              // Get the number of digits of n.
              for (d = 1; k >= 10; k /= 10, d++);

              // Get the index of rd within n.
              i %= LOG_BASE;

              // Get the index of rd within n, adjusted for leading zeros.
              // The number of leading zeros of n is given by LOG_BASE - d.
              j = i - LOG_BASE + d;

              // Get the rounding digit at index j of n.
              rd = j < 0 ? 0 : n / pows10[d - j - 1] % 10 | 0;
            }
          }

          r = r || sd < 0 ||

          // Are there any non-zero digits after the rounding digit?
          // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
          // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
           xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);

          r = rm < 4
           ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
           : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 &&

            // Check whether the digit to the left of the rounding digit is odd.
            ((i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10) & 1 ||
             rm == (x.s < 0 ? 8 : 7));

          if (sd < 1 || !xc[0]) {
            xc.length = 0;

            if (r) {

              // Convert sd to decimal places.
              sd -= x.e + 1;

              // 1, 0.1, 0.01, 0.001, 0.0001 etc.
              xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
              x.e = -sd || 0;
            } else {

              // Zero.
              xc[0] = x.e = 0;
            }

            return x;
          }

          // Remove excess digits.
          if (i == 0) {
            xc.length = ni;
            k = 1;
            ni--;
          } else {
            xc.length = ni + 1;
            k = pows10[LOG_BASE - i];

            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of n.
            xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
          }

          // Round up?
          if (r) {

            for (; ;) {

              // If the digit to be rounded up is in the first element of xc...
              if (ni == 0) {

                // i will be the length of xc[0] before k is added.
                for (i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                j = xc[0] += k;
                for (k = 1; j >= 10; j /= 10, k++);

                // if i != k the length has increased.
                if (i != k) {
                  x.e++;
                  if (xc[0] == BASE) xc[0] = 1;
                }

                break;
              } else {
                xc[ni] += k;
                if (xc[ni] != BASE) break;
                xc[ni--] = 0;
                k = 1;
              }
            }
          }

          // Remove trailing zeros.
          for (i = xc.length; xc[--i] === 0; xc.pop());
        }

        // Overflow? Infinity.
        if (x.e > MAX_EXP) {
          x.c = x.e = null;

        // Underflow? Zero.
        } else if (x.e < MIN_EXP) {
          x.c = [x.e = 0];
        }
      }

      return x;
    }


    function valueOf(n) {
      var str,
        e = n.e;

      if (e === null) return n.toString();

      str = coeffToString(n.c);

      str = e <= TO_EXP_NEG || e >= TO_EXP_POS
        ? toExponential(str, e)
        : toFixedPoint(str, e, '0');

      return n.s < 0 ? '-' + str : str;
    }


    // PROTOTYPE/INSTANCE METHODS


    /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */
    P.absoluteValue = P.abs = function () {
      var x = new BigNumber(this);
      if (x.s < 0) x.s = 1;
      return x;
    };


    /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */
    P.comparedTo = function (y, b) {
      return compare(this, new BigNumber(y, b));
    };


    /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */
    P.decimalPlaces = P.dp = function (dp, rm) {
      var c, n, v,
        x = this;

      if (dp != null) {
        intCheck(dp, 0, MAX);
        if (rm == null) rm = ROUNDING_MODE;
        else intCheck(rm, 0, 8);

        return round(new BigNumber(x), dp + x.e + 1, rm);
      }

      if (!(c = x.c)) return null;
      n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;

      // Subtract the number of trailing zeros of the last number.
      if (v = c[v]) for (; v % 10 == 0; v /= 10, n--);
      if (n < 0) n = 0;

      return n;
    };


    /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */
    P.dividedBy = P.div = function (y, b) {
      return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
    };


    /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */
    P.dividedToIntegerBy = P.idiv = function (y, b) {
      return div(this, new BigNumber(y, b), 0, 1);
    };


    /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */
    P.exponentiatedBy = P.pow = function (n, m) {
      var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y,
        x = this;

      n = new BigNumber(n);

      // Allow NaN and ±Infinity, but not other non-integers.
      if (n.c && !n.isInteger()) {
        throw Error
          (bignumberError + 'Exponent not an integer: ' + valueOf(n));
      }

      if (m != null) m = new BigNumber(m);

      // Exponent of MAX_SAFE_INTEGER is 15.
      nIsBig = n.e > 14;

      // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
      if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {

        // The sign of the result of pow when x is negative depends on the evenness of n.
        // If +n overflows to ±Infinity, the evenness of n would be not be known.
        y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? 2 - isOdd(n) : +valueOf(n)));
        return m ? y.mod(m) : y;
      }

      nIsNeg = n.s < 0;

      if (m) {

        // x % m returns NaN if abs(m) is zero, or m is NaN.
        if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);

        isModExp = !nIsNeg && x.isInteger() && m.isInteger();

        if (isModExp) x = x.mod(m);

      // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
      // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
      } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0
        // [1, 240000000]
        ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7
        // [80000000000000]  [99999750000000]
        : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {

        // If x is negative and n is odd, k = -0, else k = 0.
        k = x.s < 0 && isOdd(n) ? -0 : 0;

        // If x >= 1, k = ±Infinity.
        if (x.e > -1) k = 1 / k;

        // If n is negative return ±0, else return ±Infinity.
        return new BigNumber(nIsNeg ? 1 / k : k);

      } else if (POW_PRECISION) {

        // Truncating each coefficient array to a length of k after each multiplication
        // equates to truncating significant digits to POW_PRECISION + [28, 41],
        // i.e. there will be a minimum of 28 guard digits retained.
        k = mathceil(POW_PRECISION / LOG_BASE + 2);
      }

      if (nIsBig) {
        half = new BigNumber(0.5);
        if (nIsNeg) n.s = 1;
        nIsOdd = isOdd(n);
      } else {
        i = Math.abs(+valueOf(n));
        nIsOdd = i % 2;
      }

      y = new BigNumber(ONE);

      // Performs 54 loop iterations for n of 9007199254740991.
      for (; ;) {

        if (nIsOdd) {
          y = y.times(x);
          if (!y.c) break;

          if (k) {
            if (y.c.length > k) y.c.length = k;
          } else if (isModExp) {
            y = y.mod(m);    //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
          }
        }

        if (i) {
          i = mathfloor(i / 2);
          if (i === 0) break;
          nIsOdd = i % 2;
        } else {
          n = n.times(half);
          round(n, n.e + 1, 1);

          if (n.e > 14) {
            nIsOdd = isOdd(n);
          } else {
            i = +valueOf(n);
            if (i === 0) break;
            nIsOdd = i % 2;
          }
        }

        x = x.times(x);

        if (k) {
          if (x.c && x.c.length > k) x.c.length = k;
        } else if (isModExp) {
          x = x.mod(m);    //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
        }
      }

      if (isModExp) return y;
      if (nIsNeg) y = ONE.div(y);

      return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
    };


    /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */
    P.integerValue = function (rm) {
      var n = new BigNumber(this);
      if (rm == null) rm = ROUNDING_MODE;
      else intCheck(rm, 0, 8);
      return round(n, n.e + 1, rm);
    };


    /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */
    P.isEqualTo = P.eq = function (y, b) {
      return compare(this, new BigNumber(y, b)) === 0;
    };


    /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */
    P.isFinite = function () {
      return !!this.c;
    };


    /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */
    P.isGreaterThan = P.gt = function (y, b) {
      return compare(this, new BigNumber(y, b)) > 0;
    };


    /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */
    P.isGreaterThanOrEqualTo = P.gte = function (y, b) {
      return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;

    };


    /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */
    P.isInteger = function () {
      return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
    };


    /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */
    P.isLessThan = P.lt = function (y, b) {
      return compare(this, new BigNumber(y, b)) < 0;
    };


    /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */
    P.isLessThanOrEqualTo = P.lte = function (y, b) {
      return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
    };


    /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */
    P.isNaN = function () {
      return !this.s;
    };


    /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */
    P.isNegative = function () {
      return this.s < 0;
    };


    /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */
    P.isPositive = function () {
      return this.s > 0;
    };


    /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */
    P.isZero = function () {
      return !!this.c && this.c[0] == 0;
    };


    /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */
    P.minus = function (y, b) {
      var i, j, t, xLTy,
        x = this,
        a = x.s;

      y = new BigNumber(y, b);
      b = y.s;

      // Either NaN?
      if (!a || !b) return new BigNumber(NaN);

      // Signs differ?
      if (a != b) {
        y.s = -b;
        return x.plus(y);
      }

      var xe = x.e / LOG_BASE,
        ye = y.e / LOG_BASE,
        xc = x.c,
        yc = y.c;

      if (!xe || !ye) {

        // Either Infinity?
        if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);

        // Either zero?
        if (!xc[0] || !yc[0]) {

          // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
          return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x :

           // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
           ROUNDING_MODE == 3 ? -0 : 0);
        }
      }

      xe = bitFloor(xe);
      ye = bitFloor(ye);
      xc = xc.slice();

      // Determine which is the bigger number.
      if (a = xe - ye) {

        if (xLTy = a < 0) {
          a = -a;
          t = xc;
        } else {
          ye = xe;
          t = yc;
        }

        t.reverse();

        // Prepend zeros to equalise exponents.
        for (b = a; b--; t.push(0));
        t.reverse();
      } else {

        // Exponents equal. Check digit by digit.
        j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;

        for (a = b = 0; b < j; b++) {

          if (xc[b] != yc[b]) {
            xLTy = xc[b] < yc[b];
            break;
          }
        }
      }

      // x < y? Point xc to the array of the bigger number.
      if (xLTy) t = xc, xc = yc, yc = t, y.s = -y.s;

      b = (j = yc.length) - (i = xc.length);

      // Append zeros to xc if shorter.
      // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
      if (b > 0) for (; b--; xc[i++] = 0);
      b = BASE - 1;

      // Subtract yc from xc.
      for (; j > a;) {

        if (xc[--j] < yc[j]) {
          for (i = j; i && !xc[--i]; xc[i] = b);
          --xc[i];
          xc[j] += BASE;
        }

        xc[j] -= yc[j];
      }

      // Remove leading zeros and adjust exponent accordingly.
      for (; xc[0] == 0; xc.splice(0, 1), --ye);

      // Zero?
      if (!xc[0]) {

        // Following IEEE 754 (2008) 6.3,
        // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
        y.s = ROUNDING_MODE == 3 ? -1 : 1;
        y.c = [y.e = 0];
        return y;
      }

      // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
      // for finite x and y.
      return normalise(y, xc, ye);
    };


    /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */
    P.modulo = P.mod = function (y, b) {
      var q, s,
        x = this;

      y = new BigNumber(y, b);

      // Return NaN if x is Infinity or NaN, or y is NaN or zero.
      if (!x.c || !y.s || y.c && !y.c[0]) {
        return new BigNumber(NaN);

      // Return x if y is Infinity or x is zero.
      } else if (!y.c || x.c && !x.c[0]) {
        return new BigNumber(x);
      }

      if (MODULO_MODE == 9) {

        // Euclidian division: q = sign(y) * floor(x / abs(y))
        // r = x - qy    where  0 <= r < abs(y)
        s = y.s;
        y.s = 1;
        q = div(x, y, 0, 3);
        y.s = s;
        q.s *= s;
      } else {
        q = div(x, y, 0, MODULO_MODE);
      }

      y = x.minus(q.times(y));

      // To match JavaScript %, ensure sign of zero is sign of dividend.
      if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;

      return y;
    };


    /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */
    P.multipliedBy = P.times = function (y, b) {
      var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc,
        base, sqrtBase,
        x = this,
        xc = x.c,
        yc = (y = new BigNumber(y, b)).c;

      // Either NaN, ±Infinity or ±0?
      if (!xc || !yc || !xc[0] || !yc[0]) {

        // Return NaN if either is NaN, or one is 0 and the other is Infinity.
        if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) {
          y.c = y.e = y.s = null;
        } else {
          y.s *= x.s;

          // Return ±Infinity if either is ±Infinity.
          if (!xc || !yc) {
            y.c = y.e = null;

          // Return ±0 if either is ±0.
          } else {
            y.c = [0];
            y.e = 0;
          }
        }

        return y;
      }

      e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
      y.s *= x.s;
      xcL = xc.length;
      ycL = yc.length;

      // Ensure xc points to longer array and xcL to its length.
      if (xcL < ycL) zc = xc, xc = yc, yc = zc, i = xcL, xcL = ycL, ycL = i;

      // Initialise the result array with zeros.
      for (i = xcL + ycL, zc = []; i--; zc.push(0));

      base = BASE;
      sqrtBase = SQRT_BASE;

      for (i = ycL; --i >= 0;) {
        c = 0;
        ylo = yc[i] % sqrtBase;
        yhi = yc[i] / sqrtBase | 0;

        for (k = xcL, j = i + k; j > i;) {
          xlo = xc[--k] % sqrtBase;
          xhi = xc[k] / sqrtBase | 0;
          m = yhi * xlo + xhi * ylo;
          xlo = ylo * xlo + ((m % sqrtBase) * sqrtBase) + zc[j] + c;
          c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
          zc[j--] = xlo % base;
        }

        zc[j] = c;
      }

      if (c) {
        ++e;
      } else {
        zc.splice(0, 1);
      }

      return normalise(y, zc, e);
    };


    /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */
    P.negated = function () {
      var x = new BigNumber(this);
      x.s = -x.s || null;
      return x;
    };


    /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */
    P.plus = function (y, b) {
      var t,
        x = this,
        a = x.s;

      y = new BigNumber(y, b);
      b = y.s;

      // Either NaN?
      if (!a || !b) return new BigNumber(NaN);

      // Signs differ?
       if (a != b) {
        y.s = -b;
        return x.minus(y);
      }

      var xe = x.e / LOG_BASE,
        ye = y.e / LOG_BASE,
        xc = x.c,
        yc = y.c;

      if (!xe || !ye) {

        // Return ±Infinity if either ±Infinity.
        if (!xc || !yc) return new BigNumber(a / 0);

        // Either zero?
        // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
        if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
      }

      xe = bitFloor(xe);
      ye = bitFloor(ye);
      xc = xc.slice();

      // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
      if (a = xe - ye) {
        if (a > 0) {
          ye = xe;
          t = yc;
        } else {
          a = -a;
          t = xc;
        }

        t.reverse();
        for (; a--; t.push(0));
        t.reverse();
      }

      a = xc.length;
      b = yc.length;

      // Point xc to the longer array, and b to the shorter length.
      if (a - b < 0) t = yc, yc = xc, xc = t, b = a;

      // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
      for (a = 0; b;) {
        a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
        xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
      }

      if (a) {
        xc = [a].concat(xc);
        ++ye;
      }

      // No need to check for zero, as +x + +y != 0 && -x + -y != 0
      // ye = MAX_EXP + 1 possible
      return normalise(y, xc, ye);
    };


    /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */
    P.precision = P.sd = function (sd, rm) {
      var c, n, v,
        x = this;

      if (sd != null && sd !== !!sd) {
        intCheck(sd, 1, MAX);
        if (rm == null) rm = ROUNDING_MODE;
        else intCheck(rm, 0, 8);

        return round(new BigNumber(x), sd, rm);
      }

      if (!(c = x.c)) return null;
      v = c.length - 1;
      n = v * LOG_BASE + 1;

      if (v = c[v]) {

        // Subtract the number of trailing zeros of the last element.
        for (; v % 10 == 0; v /= 10, n--);

        // Add the number of digits of the first element.
        for (v = c[0]; v >= 10; v /= 10, n++);
      }

      if (sd && x.e + 1 > n) n = x.e + 1;

      return n;
    };


    /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */
    P.shiftedBy = function (k) {
      intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
      return this.times('1e' + k);
    };


    /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */
    P.squareRoot = P.sqrt = function () {
      var m, n, r, rep, t,
        x = this,
        c = x.c,
        s = x.s,
        e = x.e,
        dp = DECIMAL_PLACES + 4,
        half = new BigNumber('0.5');

      // Negative/NaN/Infinity/zero?
      if (s !== 1 || !c || !c[0]) {
        return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
      }

      // Initial estimate.
      s = Math.sqrt(+valueOf(x));

      // Math.sqrt underflow/overflow?
      // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
      if (s == 0 || s == 1 / 0) {
        n = coeffToString(c);
        if ((n.length + e) % 2 == 0) n += '0';
        s = Math.sqrt(+n);
        e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);

        if (s == 1 / 0) {
          n = '1e' + e;
        } else {
          n = s.toExponential();
          n = n.slice(0, n.indexOf('e') + 1) + e;
        }

        r = new BigNumber(n);
      } else {
        r = new BigNumber(s + '');
      }

      // Check for zero.
      // r could be zero if MIN_EXP is changed after the this value was created.
      // This would cause a division by zero (x/t) and hence Infinity below, which would cause
      // coeffToString to throw.
      if (r.c[0]) {
        e = r.e;
        s = e + dp;
        if (s < 3) s = 0;

        // Newton-Raphson iteration.
        for (; ;) {
          t = r;
          r = half.times(t.plus(div(x, t, dp, 1)));

          if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {

            // The exponent of r may here be one less than the final result exponent,
            // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
            // are indexed correctly.
            if (r.e < e) --s;
            n = n.slice(s - 3, s + 1);

            // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
            // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
            // iteration.
            if (n == '9999' || !rep && n == '4999') {

              // On the first iteration only, check to see if rounding up gives the
              // exact result as the nines may infinitely repeat.
              if (!rep) {
                round(t, t.e + DECIMAL_PLACES + 2, 0);

                if (t.times(t).eq(x)) {
                  r = t;
                  break;
                }
              }

              dp += 4;
              s += 4;
              rep = 1;
            } else {

              // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
              // result. If not, then there are further digits and m will be truthy.
              if (!+n || !+n.slice(1) && n.charAt(0) == '5') {

                // Truncate to the first rounding digit.
                round(r, r.e + DECIMAL_PLACES + 2, 1);
                m = !r.times(r).eq(x);
              }

              break;
            }
          }
        }
      }

      return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
    };


    /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */
    P.toExponential = function (dp, rm) {
      if (dp != null) {
        intCheck(dp, 0, MAX);
        dp++;
      }
      return format(this, dp, rm, 1);
    };


    /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */
    P.toFixed = function (dp, rm) {
      if (dp != null) {
        intCheck(dp, 0, MAX);
        dp = dp + this.e + 1;
      }
      return format(this, dp, rm);
    };


    /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */
    P.toFormat = function (dp, rm, format) {
      var str,
        x = this;

      if (format == null) {
        if (dp != null && rm && typeof rm == 'object') {
          format = rm;
          rm = null;
        } else if (dp && typeof dp == 'object') {
          format = dp;
          dp = rm = null;
        } else {
          format = FORMAT;
        }
      } else if (typeof format != 'object') {
        throw Error
          (bignumberError + 'Argument not an object: ' + format);
      }

      str = x.toFixed(dp, rm);

      if (x.c) {
        var i,
          arr = str.split('.'),
          g1 = +format.groupSize,
          g2 = +format.secondaryGroupSize,
          groupSeparator = format.groupSeparator || '',
          intPart = arr[0],
          fractionPart = arr[1],
          isNeg = x.s < 0,
          intDigits = isNeg ? intPart.slice(1) : intPart,
          len = intDigits.length;

        if (g2) i = g1, g1 = g2, g2 = i, len -= i;

        if (g1 > 0 && len > 0) {
          i = len % g1 || g1;
          intPart = intDigits.substr(0, i);
          for (; i < len; i += g1) intPart += groupSeparator + intDigits.substr(i, g1);
          if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
          if (isNeg) intPart = '-' + intPart;
        }

        str = fractionPart
         ? intPart + (format.decimalSeparator || '') + ((g2 = +format.fractionGroupSize)
          ? fractionPart.replace(new RegExp('\\d{' + g2 + '}\\B', 'g'),
           '$&' + (format.fractionGroupSeparator || ''))
          : fractionPart)
         : intPart;
      }

      return (format.prefix || '') + str + (format.suffix || '');
    };


    /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */
    P.toFraction = function (md) {
      var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s,
        x = this,
        xc = x.c;

      if (md != null) {
        n = new BigNumber(md);

        // Throw if md is less than one or is not an integer, unless it is Infinity.
        if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) {
          throw Error
            (bignumberError + 'Argument ' +
              (n.isInteger() ? 'out of range: ' : 'not an integer: ') + valueOf(n));
        }
      }

      if (!xc) return new BigNumber(x);

      d = new BigNumber(ONE);
      n1 = d0 = new BigNumber(ONE);
      d1 = n0 = new BigNumber(ONE);
      s = coeffToString(xc);

      // Determine initial denominator.
      // d is a power of 10 and the minimum max denominator that specifies the value exactly.
      e = d.e = s.length - x.e - 1;
      d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
      md = !md || n.comparedTo(d) > 0 ? (e > 0 ? d : n1) : n;

      exp = MAX_EXP;
      MAX_EXP = 1 / 0;
      n = new BigNumber(s);

      // n0 = d1 = 0
      n0.c[0] = 0;

      for (; ;)  {
        q = div(n, d, 0, 1);
        d2 = d0.plus(q.times(d1));
        if (d2.comparedTo(md) == 1) break;
        d0 = d1;
        d1 = d2;
        n1 = n0.plus(q.times(d2 = n1));
        n0 = d2;
        d = n.minus(q.times(d2 = d));
        n = d2;
      }

      d2 = div(md.minus(d0), d1, 0, 1);
      n0 = n0.plus(d2.times(n1));
      d0 = d0.plus(d2.times(d1));
      n0.s = n1.s = x.s;
      e = e * 2;

      // Determine which fraction is closer to x, n0/d0 or n1/d1
      r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(
          div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [n1, d1] : [n0, d0];

      MAX_EXP = exp;

      return r;
    };


    /*
     * Return the value of this BigNumber converted to a number primitive.
     */
    P.toNumber = function () {
      return +valueOf(this);
    };


    /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */
    P.toPrecision = function (sd, rm) {
      if (sd != null) intCheck(sd, 1, MAX);
      return format(this, sd, rm, 2);
    };


    /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */
    P.toString = function (b) {
      var str,
        n = this,
        s = n.s,
        e = n.e;

      // Infinity or NaN?
      if (e === null) {
        if (s) {
          str = 'Infinity';
          if (s < 0) str = '-' + str;
        } else {
          str = 'NaN';
        }
      } else {
        if (b == null) {
          str = e <= TO_EXP_NEG || e >= TO_EXP_POS
           ? toExponential(coeffToString(n.c), e)
           : toFixedPoint(coeffToString(n.c), e, '0');
        } else if (b === 10) {
          n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
          str = toFixedPoint(coeffToString(n.c), n.e, '0');
        } else {
          intCheck(b, 2, ALPHABET.length, 'Base');
          str = convertBase(toFixedPoint(coeffToString(n.c), e, '0'), 10, b, s, true);
        }

        if (s < 0 && n.c[0]) str = '-' + str;
      }

      return str;
    };


    /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */
    P.valueOf = P.toJSON = function () {
      return valueOf(this);
    };


    P._isBigNumber = true;

    if (configObject != null) BigNumber.set(configObject);

    return BigNumber;
  }


  // PRIVATE HELPER FUNCTIONS

  // These functions don't need access to variables,
  // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.


  function bitFloor(n) {
    var i = n | 0;
    return n > 0 || n === i ? i : i - 1;
  }


  // Return a coefficient array as a string of base 10 digits.
  function coeffToString(a) {
    var s, z,
      i = 1,
      j = a.length,
      r = a[0] + '';

    for (; i < j;) {
      s = a[i++] + '';
      z = LOG_BASE - s.length;
      for (; z--; s = '0' + s);
      r += s;
    }

    // Determine trailing zeros.
    for (j = r.length; r.charCodeAt(--j) === 48;);

    return r.slice(0, j + 1 || 1);
  }


  // Compare the value of BigNumbers x and y.
  function compare(x, y) {
    var a, b,
      xc = x.c,
      yc = y.c,
      i = x.s,
      j = y.s,
      k = x.e,
      l = y.e;

    // Either NaN?
    if (!i || !j) return null;

    a = xc && !xc[0];
    b = yc && !yc[0];

    // Either zero?
    if (a || b) return a ? b ? 0 : -j : i;

    // Signs differ?
    if (i != j) return i;

    a = i < 0;
    b = k == l;

    // Either Infinity?
    if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;

    // Compare exponents.
    if (!b) return k > l ^ a ? 1 : -1;

    j = (k = xc.length) < (l = yc.length) ? k : l;

    // Compare digit by digit.
    for (i = 0; i < j; i++) if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;

    // Compare lengths.
    return k == l ? 0 : k > l ^ a ? 1 : -1;
  }


  /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */
  function intCheck(n, min, max, name) {
    if (n < min || n > max || n !== mathfloor(n)) {
      throw Error
       (bignumberError + (name || 'Argument') + (typeof n == 'number'
         ? n < min || n > max ? ' out of range: ' : ' not an integer: '
         : ' not a primitive number: ') + String(n));
    }
  }


  // Assumes finite n.
  function isOdd(n) {
    var k = n.c.length - 1;
    return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
  }


  function toExponential(str, e) {
    return (str.length > 1 ? str.charAt(0) + '.' + str.slice(1) : str) +
     (e < 0 ? 'e' : 'e+') + e;
  }


  function toFixedPoint(str, e, z) {
    var len, zs;

    // Negative exponent?
    if (e < 0) {

      // Prepend zeros.
      for (zs = z + '.'; ++e; zs += z);
      str = zs + str;

    // Positive exponent
    } else {
      len = str.length;

      // Append zeros.
      if (++e > len) {
        for (zs = z, e -= len; --e; zs += z);
        str += zs;
      } else if (e < len) {
        str = str.slice(0, e) + '.' + str.slice(e);
      }
    }

    return str;
  }


  // EXPORT


  BigNumber = clone();
  BigNumber['default'] = BigNumber.BigNumber = BigNumber;

  // AMD.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return BigNumber; }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  // Node.js and other environments that support module.exports.
  } else if (typeof module != 'undefined' && module.exports) {
    module.exports = BigNumber;

  // Browser.
  } else {
    if (!globalObject) {
      globalObject = typeof self != 'undefined' && self ? self : window;
    }

    globalObject.BigNumber = BigNumber;
  }
})(this);


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var compose = __webpack_require__(45);
var assign = __webpack_require__(47);
var isObject = __webpack_require__(24);

function required(settings) {
  'use strict';
  var Stamp = this && this.compose ? this : Required; // jshint ignore:line
  var prevSettings = Stamp.compose.deepConfiguration && Stamp.compose.deepConfiguration.Required;

  // filter out non stamp things
  var newSettings = assign({}, compose(prevSettings, settings).compose);

  return Stamp.compose({deepConfiguration: {Required: newSettings}});
}

function checkDescriptorHaveThese(descriptor, settings) {
  if (!descriptor || !settings) return;
  // Traverse settings and find if there is anything required.
  var settingsKeys = Object.keys(settings);
  for (var i = 0; i < settingsKeys.length; i++) {
    var settingsKey = settingsKeys[i];
    var settingsValue = settings[settingsKey];
    if (isObject(settingsValue)) {
      var metadataKeys = Object.keys(settingsValue);
      for (var j = 0; j < metadataKeys.length; j++) {
        var metadataKey = metadataKeys[j];
        var metadataValue = settingsValue[metadataKey];
        if (metadataValue === Required || metadataValue === required) {
          // We found one thing which have to be provided. Let's check if it exists.
          if (!descriptor[settingsKey] || descriptor[settingsKey][metadataKey] === undefined) {
            throw new Error('Required: There must be ' + metadataKey + ' in this stamp ' + settingsKey);
          }
        }
      }
    }
  }
}

var Required = compose({
  initializers: [function (_, opts) {
    var descriptor = opts.stamp.compose;
    var settings = descriptor.deepConfiguration && descriptor.deepConfiguration.Required;
    checkDescriptorHaveThese(descriptor, settings);
  }],
  staticProperties: {
    required: required
  }
});

Object.freeze(required);
Object.freeze(Required);

module.exports = Required;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

// More proper implementation would be
// isDescriptor(obj) || isStamp(obj)
// but there is no sense since stamp is function and function is object.
module.exports = __webpack_require__(24);


/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports = function isPlainObject(value) {
  return Boolean(value) && typeof value === 'object' &&
    Object.getPrototypeOf(value) === Object.prototype;
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var compose = __webpack_require__(45);
var Shortcut = __webpack_require__(239);
var isStamp = __webpack_require__(94);
var isString = __webpack_require__(240);
var isObject = __webpack_require__(24);
var isFunction = __webpack_require__(46);
var merge = __webpack_require__(95);
var assign = __webpack_require__(47);

var concat = Array.prototype.concat;
function extractFunctions() {
  var fns = concat.apply([], arguments).filter(isFunction);
  return fns.length === 0 ? undefined : fns;
}

function standardiseDescriptor(descr) {
  if (!isObject(descr)) return descr;

  var methods = descr.methods;
  var properties = descr.properties;
  var props = descr.props;
  var initializers = descr.initializers;
  var init = descr.init;
  var composers = descr.composers;
  var deepProperties = descr.deepProperties;
  var deepProps = descr.deepProps;
  var pd = descr.propertyDescriptors;
  var staticProperties = descr.staticProperties;
  var statics = descr.statics;
  var staticDeepProperties = descr.staticDeepProperties;
  var deepStatics = descr.deepStatics;
  var configuration = descr.configuration;
  var conf = descr.conf;
  var deepConfiguration = descr.deepConfiguration;
  var deepConf = descr.deepConf;

  var p = isObject(props) || isObject(properties) ?
    assign({}, props, properties) : undefined;

  var dp = isObject(deepProps) ? merge({}, deepProps) : undefined;
  dp = isObject(deepProperties) ? merge(dp, deepProperties) : dp;

  var sp = isObject(statics) || isObject(staticProperties) ?
    assign({}, statics, staticProperties) : undefined;

  var sdp = isObject(deepStatics) ? merge({}, deepStatics) : undefined;
  sdp = isObject(staticDeepProperties) ? merge(sdp, staticDeepProperties) : sdp;

  var spd = descr.staticPropertyDescriptors;
  if (isString(descr.name)) spd = assign({}, spd || {}, { name: { value: descr.name } });

  var c = isObject(conf) || isObject(configuration) ?
    assign({}, conf, configuration) : undefined;

  var dc = isObject(deepConf) ? merge({}, deepConf) : undefined;
  dc = isObject(deepConfiguration) ? merge(dc, deepConfiguration) : dc;

  var ii = extractFunctions(init, initializers);

  var cc = extractFunctions(composers);

  var descriptor = {};
  if (methods) descriptor.methods = methods;
  if (p) descriptor.properties = p;
  if (ii) descriptor.initializers = ii;
  if (cc) descriptor.composers = cc;
  if (dp) descriptor.deepProperties = dp;
  if (sp) descriptor.staticProperties = sp;
  if (sdp) descriptor.staticDeepProperties = sdp;
  if (pd) descriptor.propertyDescriptors = pd;
  if (spd) descriptor.staticPropertyDescriptors = spd;
  if (c) descriptor.configuration = c;
  if (dc) descriptor.deepConfiguration = dc;

  return descriptor;
}

function stampit() {
  'use strict'; // to make sure `this` is not pointing to `global` or `window`
  var length = arguments.length, args = [];
  for (var i = 0; i < length; i += 1) {
    var arg = arguments[i];
    args.push(isStamp(arg) ? arg : standardiseDescriptor(arg));
  }

  return compose.apply(this || baseStampit, args); // jshint ignore:line
}

var baseStampit = Shortcut.compose({
  staticProperties: {
    create: function () { return this.apply(this, arguments); },
    compose: stampit // infecting
  }
});

var shortcuts = Shortcut.compose.staticProperties;
for (var prop in shortcuts) stampit[prop] = shortcuts[prop].bind(baseStampit);
stampit.compose = stampit.bind();

module.exports = stampit;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var compose = __webpack_require__(45);

function createShortcut(propName) {
  return function (arg) {
    'use strict';
    var param = {};
    param[propName] = arg;
    return this && this.compose ? this.compose(param) : compose(param);
  };
}

var properties = createShortcut('properties');
var staticProperties = createShortcut('staticProperties');
var configuration = createShortcut('configuration');
var deepProperties = createShortcut('deepProperties');
var staticDeepProperties = createShortcut('staticDeepProperties');
var deepConfiguration = createShortcut('deepConfiguration');
var initializers = createShortcut('initializers');

module.exports = compose({
  staticProperties: {
    methods: createShortcut('methods'),

    props: properties,
    properties: properties,

    statics: staticProperties,
    staticProperties: staticProperties,

    conf: configuration,
    configuration: configuration,

    deepProps: deepProperties,
    deepProperties: deepProperties,

    deepStatics: staticDeepProperties,
    staticDeepProperties: staticDeepProperties,

    deepConf: deepConfiguration,
    deepConfiguration: deepConfiguration,

    init: initializers,
    initializers: initializers,

    composers: createShortcut('composers'),

    propertyDescriptors: createShortcut('propertyDescriptors'),

    staticPropertyDescriptors: createShortcut('staticPropertyDescriptors')
  }
});


/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports = function isString(arg) {
  return typeof arg === 'string';
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

(function(nacl) {
'use strict';

// Ported in 2014 by Dmitry Chestnykh and Devi Mandiri.
// Public domain.
//
// Implementation derived from TweetNaCl version 20140427.
// See for details: http://tweetnacl.cr.yp.to/

var gf = function(init) {
  var i, r = new Float64Array(16);
  if (init) for (i = 0; i < init.length; i++) r[i] = init[i];
  return r;
};

//  Pluggable, initialized in high-level API below.
var randombytes = function(/* x, n */) { throw new Error('no PRNG'); };

var _0 = new Uint8Array(16);
var _9 = new Uint8Array(32); _9[0] = 9;

var gf0 = gf(),
    gf1 = gf([1]),
    _121665 = gf([0xdb41, 1]),
    D = gf([0x78a3, 0x1359, 0x4dca, 0x75eb, 0xd8ab, 0x4141, 0x0a4d, 0x0070, 0xe898, 0x7779, 0x4079, 0x8cc7, 0xfe73, 0x2b6f, 0x6cee, 0x5203]),
    D2 = gf([0xf159, 0x26b2, 0x9b94, 0xebd6, 0xb156, 0x8283, 0x149a, 0x00e0, 0xd130, 0xeef3, 0x80f2, 0x198e, 0xfce7, 0x56df, 0xd9dc, 0x2406]),
    X = gf([0xd51a, 0x8f25, 0x2d60, 0xc956, 0xa7b2, 0x9525, 0xc760, 0x692c, 0xdc5c, 0xfdd6, 0xe231, 0xc0a4, 0x53fe, 0xcd6e, 0x36d3, 0x2169]),
    Y = gf([0x6658, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666]),
    I = gf([0xa0b0, 0x4a0e, 0x1b27, 0xc4ee, 0xe478, 0xad2f, 0x1806, 0x2f43, 0xd7a7, 0x3dfb, 0x0099, 0x2b4d, 0xdf0b, 0x4fc1, 0x2480, 0x2b83]);

function ts64(x, i, h, l) {
  x[i]   = (h >> 24) & 0xff;
  x[i+1] = (h >> 16) & 0xff;
  x[i+2] = (h >>  8) & 0xff;
  x[i+3] = h & 0xff;
  x[i+4] = (l >> 24)  & 0xff;
  x[i+5] = (l >> 16)  & 0xff;
  x[i+6] = (l >>  8)  & 0xff;
  x[i+7] = l & 0xff;
}

function vn(x, xi, y, yi, n) {
  var i,d = 0;
  for (i = 0; i < n; i++) d |= x[xi+i]^y[yi+i];
  return (1 & ((d - 1) >>> 8)) - 1;
}

function crypto_verify_16(x, xi, y, yi) {
  return vn(x,xi,y,yi,16);
}

function crypto_verify_32(x, xi, y, yi) {
  return vn(x,xi,y,yi,32);
}

function core_salsa20(o, p, k, c) {
  var j0  = c[ 0] & 0xff | (c[ 1] & 0xff)<<8 | (c[ 2] & 0xff)<<16 | (c[ 3] & 0xff)<<24,
      j1  = k[ 0] & 0xff | (k[ 1] & 0xff)<<8 | (k[ 2] & 0xff)<<16 | (k[ 3] & 0xff)<<24,
      j2  = k[ 4] & 0xff | (k[ 5] & 0xff)<<8 | (k[ 6] & 0xff)<<16 | (k[ 7] & 0xff)<<24,
      j3  = k[ 8] & 0xff | (k[ 9] & 0xff)<<8 | (k[10] & 0xff)<<16 | (k[11] & 0xff)<<24,
      j4  = k[12] & 0xff | (k[13] & 0xff)<<8 | (k[14] & 0xff)<<16 | (k[15] & 0xff)<<24,
      j5  = c[ 4] & 0xff | (c[ 5] & 0xff)<<8 | (c[ 6] & 0xff)<<16 | (c[ 7] & 0xff)<<24,
      j6  = p[ 0] & 0xff | (p[ 1] & 0xff)<<8 | (p[ 2] & 0xff)<<16 | (p[ 3] & 0xff)<<24,
      j7  = p[ 4] & 0xff | (p[ 5] & 0xff)<<8 | (p[ 6] & 0xff)<<16 | (p[ 7] & 0xff)<<24,
      j8  = p[ 8] & 0xff | (p[ 9] & 0xff)<<8 | (p[10] & 0xff)<<16 | (p[11] & 0xff)<<24,
      j9  = p[12] & 0xff | (p[13] & 0xff)<<8 | (p[14] & 0xff)<<16 | (p[15] & 0xff)<<24,
      j10 = c[ 8] & 0xff | (c[ 9] & 0xff)<<8 | (c[10] & 0xff)<<16 | (c[11] & 0xff)<<24,
      j11 = k[16] & 0xff | (k[17] & 0xff)<<8 | (k[18] & 0xff)<<16 | (k[19] & 0xff)<<24,
      j12 = k[20] & 0xff | (k[21] & 0xff)<<8 | (k[22] & 0xff)<<16 | (k[23] & 0xff)<<24,
      j13 = k[24] & 0xff | (k[25] & 0xff)<<8 | (k[26] & 0xff)<<16 | (k[27] & 0xff)<<24,
      j14 = k[28] & 0xff | (k[29] & 0xff)<<8 | (k[30] & 0xff)<<16 | (k[31] & 0xff)<<24,
      j15 = c[12] & 0xff | (c[13] & 0xff)<<8 | (c[14] & 0xff)<<16 | (c[15] & 0xff)<<24;

  var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7,
      x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14,
      x15 = j15, u;

  for (var i = 0; i < 20; i += 2) {
    u = x0 + x12 | 0;
    x4 ^= u<<7 | u>>>(32-7);
    u = x4 + x0 | 0;
    x8 ^= u<<9 | u>>>(32-9);
    u = x8 + x4 | 0;
    x12 ^= u<<13 | u>>>(32-13);
    u = x12 + x8 | 0;
    x0 ^= u<<18 | u>>>(32-18);

    u = x5 + x1 | 0;
    x9 ^= u<<7 | u>>>(32-7);
    u = x9 + x5 | 0;
    x13 ^= u<<9 | u>>>(32-9);
    u = x13 + x9 | 0;
    x1 ^= u<<13 | u>>>(32-13);
    u = x1 + x13 | 0;
    x5 ^= u<<18 | u>>>(32-18);

    u = x10 + x6 | 0;
    x14 ^= u<<7 | u>>>(32-7);
    u = x14 + x10 | 0;
    x2 ^= u<<9 | u>>>(32-9);
    u = x2 + x14 | 0;
    x6 ^= u<<13 | u>>>(32-13);
    u = x6 + x2 | 0;
    x10 ^= u<<18 | u>>>(32-18);

    u = x15 + x11 | 0;
    x3 ^= u<<7 | u>>>(32-7);
    u = x3 + x15 | 0;
    x7 ^= u<<9 | u>>>(32-9);
    u = x7 + x3 | 0;
    x11 ^= u<<13 | u>>>(32-13);
    u = x11 + x7 | 0;
    x15 ^= u<<18 | u>>>(32-18);

    u = x0 + x3 | 0;
    x1 ^= u<<7 | u>>>(32-7);
    u = x1 + x0 | 0;
    x2 ^= u<<9 | u>>>(32-9);
    u = x2 + x1 | 0;
    x3 ^= u<<13 | u>>>(32-13);
    u = x3 + x2 | 0;
    x0 ^= u<<18 | u>>>(32-18);

    u = x5 + x4 | 0;
    x6 ^= u<<7 | u>>>(32-7);
    u = x6 + x5 | 0;
    x7 ^= u<<9 | u>>>(32-9);
    u = x7 + x6 | 0;
    x4 ^= u<<13 | u>>>(32-13);
    u = x4 + x7 | 0;
    x5 ^= u<<18 | u>>>(32-18);

    u = x10 + x9 | 0;
    x11 ^= u<<7 | u>>>(32-7);
    u = x11 + x10 | 0;
    x8 ^= u<<9 | u>>>(32-9);
    u = x8 + x11 | 0;
    x9 ^= u<<13 | u>>>(32-13);
    u = x9 + x8 | 0;
    x10 ^= u<<18 | u>>>(32-18);

    u = x15 + x14 | 0;
    x12 ^= u<<7 | u>>>(32-7);
    u = x12 + x15 | 0;
    x13 ^= u<<9 | u>>>(32-9);
    u = x13 + x12 | 0;
    x14 ^= u<<13 | u>>>(32-13);
    u = x14 + x13 | 0;
    x15 ^= u<<18 | u>>>(32-18);
  }
   x0 =  x0 +  j0 | 0;
   x1 =  x1 +  j1 | 0;
   x2 =  x2 +  j2 | 0;
   x3 =  x3 +  j3 | 0;
   x4 =  x4 +  j4 | 0;
   x5 =  x5 +  j5 | 0;
   x6 =  x6 +  j6 | 0;
   x7 =  x7 +  j7 | 0;
   x8 =  x8 +  j8 | 0;
   x9 =  x9 +  j9 | 0;
  x10 = x10 + j10 | 0;
  x11 = x11 + j11 | 0;
  x12 = x12 + j12 | 0;
  x13 = x13 + j13 | 0;
  x14 = x14 + j14 | 0;
  x15 = x15 + j15 | 0;

  o[ 0] = x0 >>>  0 & 0xff;
  o[ 1] = x0 >>>  8 & 0xff;
  o[ 2] = x0 >>> 16 & 0xff;
  o[ 3] = x0 >>> 24 & 0xff;

  o[ 4] = x1 >>>  0 & 0xff;
  o[ 5] = x1 >>>  8 & 0xff;
  o[ 6] = x1 >>> 16 & 0xff;
  o[ 7] = x1 >>> 24 & 0xff;

  o[ 8] = x2 >>>  0 & 0xff;
  o[ 9] = x2 >>>  8 & 0xff;
  o[10] = x2 >>> 16 & 0xff;
  o[11] = x2 >>> 24 & 0xff;

  o[12] = x3 >>>  0 & 0xff;
  o[13] = x3 >>>  8 & 0xff;
  o[14] = x3 >>> 16 & 0xff;
  o[15] = x3 >>> 24 & 0xff;

  o[16] = x4 >>>  0 & 0xff;
  o[17] = x4 >>>  8 & 0xff;
  o[18] = x4 >>> 16 & 0xff;
  o[19] = x4 >>> 24 & 0xff;

  o[20] = x5 >>>  0 & 0xff;
  o[21] = x5 >>>  8 & 0xff;
  o[22] = x5 >>> 16 & 0xff;
  o[23] = x5 >>> 24 & 0xff;

  o[24] = x6 >>>  0 & 0xff;
  o[25] = x6 >>>  8 & 0xff;
  o[26] = x6 >>> 16 & 0xff;
  o[27] = x6 >>> 24 & 0xff;

  o[28] = x7 >>>  0 & 0xff;
  o[29] = x7 >>>  8 & 0xff;
  o[30] = x7 >>> 16 & 0xff;
  o[31] = x7 >>> 24 & 0xff;

  o[32] = x8 >>>  0 & 0xff;
  o[33] = x8 >>>  8 & 0xff;
  o[34] = x8 >>> 16 & 0xff;
  o[35] = x8 >>> 24 & 0xff;

  o[36] = x9 >>>  0 & 0xff;
  o[37] = x9 >>>  8 & 0xff;
  o[38] = x9 >>> 16 & 0xff;
  o[39] = x9 >>> 24 & 0xff;

  o[40] = x10 >>>  0 & 0xff;
  o[41] = x10 >>>  8 & 0xff;
  o[42] = x10 >>> 16 & 0xff;
  o[43] = x10 >>> 24 & 0xff;

  o[44] = x11 >>>  0 & 0xff;
  o[45] = x11 >>>  8 & 0xff;
  o[46] = x11 >>> 16 & 0xff;
  o[47] = x11 >>> 24 & 0xff;

  o[48] = x12 >>>  0 & 0xff;
  o[49] = x12 >>>  8 & 0xff;
  o[50] = x12 >>> 16 & 0xff;
  o[51] = x12 >>> 24 & 0xff;

  o[52] = x13 >>>  0 & 0xff;
  o[53] = x13 >>>  8 & 0xff;
  o[54] = x13 >>> 16 & 0xff;
  o[55] = x13 >>> 24 & 0xff;

  o[56] = x14 >>>  0 & 0xff;
  o[57] = x14 >>>  8 & 0xff;
  o[58] = x14 >>> 16 & 0xff;
  o[59] = x14 >>> 24 & 0xff;

  o[60] = x15 >>>  0 & 0xff;
  o[61] = x15 >>>  8 & 0xff;
  o[62] = x15 >>> 16 & 0xff;
  o[63] = x15 >>> 24 & 0xff;
}

function core_hsalsa20(o,p,k,c) {
  var j0  = c[ 0] & 0xff | (c[ 1] & 0xff)<<8 | (c[ 2] & 0xff)<<16 | (c[ 3] & 0xff)<<24,
      j1  = k[ 0] & 0xff | (k[ 1] & 0xff)<<8 | (k[ 2] & 0xff)<<16 | (k[ 3] & 0xff)<<24,
      j2  = k[ 4] & 0xff | (k[ 5] & 0xff)<<8 | (k[ 6] & 0xff)<<16 | (k[ 7] & 0xff)<<24,
      j3  = k[ 8] & 0xff | (k[ 9] & 0xff)<<8 | (k[10] & 0xff)<<16 | (k[11] & 0xff)<<24,
      j4  = k[12] & 0xff | (k[13] & 0xff)<<8 | (k[14] & 0xff)<<16 | (k[15] & 0xff)<<24,
      j5  = c[ 4] & 0xff | (c[ 5] & 0xff)<<8 | (c[ 6] & 0xff)<<16 | (c[ 7] & 0xff)<<24,
      j6  = p[ 0] & 0xff | (p[ 1] & 0xff)<<8 | (p[ 2] & 0xff)<<16 | (p[ 3] & 0xff)<<24,
      j7  = p[ 4] & 0xff | (p[ 5] & 0xff)<<8 | (p[ 6] & 0xff)<<16 | (p[ 7] & 0xff)<<24,
      j8  = p[ 8] & 0xff | (p[ 9] & 0xff)<<8 | (p[10] & 0xff)<<16 | (p[11] & 0xff)<<24,
      j9  = p[12] & 0xff | (p[13] & 0xff)<<8 | (p[14] & 0xff)<<16 | (p[15] & 0xff)<<24,
      j10 = c[ 8] & 0xff | (c[ 9] & 0xff)<<8 | (c[10] & 0xff)<<16 | (c[11] & 0xff)<<24,
      j11 = k[16] & 0xff | (k[17] & 0xff)<<8 | (k[18] & 0xff)<<16 | (k[19] & 0xff)<<24,
      j12 = k[20] & 0xff | (k[21] & 0xff)<<8 | (k[22] & 0xff)<<16 | (k[23] & 0xff)<<24,
      j13 = k[24] & 0xff | (k[25] & 0xff)<<8 | (k[26] & 0xff)<<16 | (k[27] & 0xff)<<24,
      j14 = k[28] & 0xff | (k[29] & 0xff)<<8 | (k[30] & 0xff)<<16 | (k[31] & 0xff)<<24,
      j15 = c[12] & 0xff | (c[13] & 0xff)<<8 | (c[14] & 0xff)<<16 | (c[15] & 0xff)<<24;

  var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7,
      x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14,
      x15 = j15, u;

  for (var i = 0; i < 20; i += 2) {
    u = x0 + x12 | 0;
    x4 ^= u<<7 | u>>>(32-7);
    u = x4 + x0 | 0;
    x8 ^= u<<9 | u>>>(32-9);
    u = x8 + x4 | 0;
    x12 ^= u<<13 | u>>>(32-13);
    u = x12 + x8 | 0;
    x0 ^= u<<18 | u>>>(32-18);

    u = x5 + x1 | 0;
    x9 ^= u<<7 | u>>>(32-7);
    u = x9 + x5 | 0;
    x13 ^= u<<9 | u>>>(32-9);
    u = x13 + x9 | 0;
    x1 ^= u<<13 | u>>>(32-13);
    u = x1 + x13 | 0;
    x5 ^= u<<18 | u>>>(32-18);

    u = x10 + x6 | 0;
    x14 ^= u<<7 | u>>>(32-7);
    u = x14 + x10 | 0;
    x2 ^= u<<9 | u>>>(32-9);
    u = x2 + x14 | 0;
    x6 ^= u<<13 | u>>>(32-13);
    u = x6 + x2 | 0;
    x10 ^= u<<18 | u>>>(32-18);

    u = x15 + x11 | 0;
    x3 ^= u<<7 | u>>>(32-7);
    u = x3 + x15 | 0;
    x7 ^= u<<9 | u>>>(32-9);
    u = x7 + x3 | 0;
    x11 ^= u<<13 | u>>>(32-13);
    u = x11 + x7 | 0;
    x15 ^= u<<18 | u>>>(32-18);

    u = x0 + x3 | 0;
    x1 ^= u<<7 | u>>>(32-7);
    u = x1 + x0 | 0;
    x2 ^= u<<9 | u>>>(32-9);
    u = x2 + x1 | 0;
    x3 ^= u<<13 | u>>>(32-13);
    u = x3 + x2 | 0;
    x0 ^= u<<18 | u>>>(32-18);

    u = x5 + x4 | 0;
    x6 ^= u<<7 | u>>>(32-7);
    u = x6 + x5 | 0;
    x7 ^= u<<9 | u>>>(32-9);
    u = x7 + x6 | 0;
    x4 ^= u<<13 | u>>>(32-13);
    u = x4 + x7 | 0;
    x5 ^= u<<18 | u>>>(32-18);

    u = x10 + x9 | 0;
    x11 ^= u<<7 | u>>>(32-7);
    u = x11 + x10 | 0;
    x8 ^= u<<9 | u>>>(32-9);
    u = x8 + x11 | 0;
    x9 ^= u<<13 | u>>>(32-13);
    u = x9 + x8 | 0;
    x10 ^= u<<18 | u>>>(32-18);

    u = x15 + x14 | 0;
    x12 ^= u<<7 | u>>>(32-7);
    u = x12 + x15 | 0;
    x13 ^= u<<9 | u>>>(32-9);
    u = x13 + x12 | 0;
    x14 ^= u<<13 | u>>>(32-13);
    u = x14 + x13 | 0;
    x15 ^= u<<18 | u>>>(32-18);
  }

  o[ 0] = x0 >>>  0 & 0xff;
  o[ 1] = x0 >>>  8 & 0xff;
  o[ 2] = x0 >>> 16 & 0xff;
  o[ 3] = x0 >>> 24 & 0xff;

  o[ 4] = x5 >>>  0 & 0xff;
  o[ 5] = x5 >>>  8 & 0xff;
  o[ 6] = x5 >>> 16 & 0xff;
  o[ 7] = x5 >>> 24 & 0xff;

  o[ 8] = x10 >>>  0 & 0xff;
  o[ 9] = x10 >>>  8 & 0xff;
  o[10] = x10 >>> 16 & 0xff;
  o[11] = x10 >>> 24 & 0xff;

  o[12] = x15 >>>  0 & 0xff;
  o[13] = x15 >>>  8 & 0xff;
  o[14] = x15 >>> 16 & 0xff;
  o[15] = x15 >>> 24 & 0xff;

  o[16] = x6 >>>  0 & 0xff;
  o[17] = x6 >>>  8 & 0xff;
  o[18] = x6 >>> 16 & 0xff;
  o[19] = x6 >>> 24 & 0xff;

  o[20] = x7 >>>  0 & 0xff;
  o[21] = x7 >>>  8 & 0xff;
  o[22] = x7 >>> 16 & 0xff;
  o[23] = x7 >>> 24 & 0xff;

  o[24] = x8 >>>  0 & 0xff;
  o[25] = x8 >>>  8 & 0xff;
  o[26] = x8 >>> 16 & 0xff;
  o[27] = x8 >>> 24 & 0xff;

  o[28] = x9 >>>  0 & 0xff;
  o[29] = x9 >>>  8 & 0xff;
  o[30] = x9 >>> 16 & 0xff;
  o[31] = x9 >>> 24 & 0xff;
}

function crypto_core_salsa20(out,inp,k,c) {
  core_salsa20(out,inp,k,c);
}

function crypto_core_hsalsa20(out,inp,k,c) {
  core_hsalsa20(out,inp,k,c);
}

var sigma = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
            // "expand 32-byte k"

function crypto_stream_salsa20_xor(c,cpos,m,mpos,b,n,k) {
  var z = new Uint8Array(16), x = new Uint8Array(64);
  var u, i;
  for (i = 0; i < 16; i++) z[i] = 0;
  for (i = 0; i < 8; i++) z[i] = n[i];
  while (b >= 64) {
    crypto_core_salsa20(x,z,k,sigma);
    for (i = 0; i < 64; i++) c[cpos+i] = m[mpos+i] ^ x[i];
    u = 1;
    for (i = 8; i < 16; i++) {
      u = u + (z[i] & 0xff) | 0;
      z[i] = u & 0xff;
      u >>>= 8;
    }
    b -= 64;
    cpos += 64;
    mpos += 64;
  }
  if (b > 0) {
    crypto_core_salsa20(x,z,k,sigma);
    for (i = 0; i < b; i++) c[cpos+i] = m[mpos+i] ^ x[i];
  }
  return 0;
}

function crypto_stream_salsa20(c,cpos,b,n,k) {
  var z = new Uint8Array(16), x = new Uint8Array(64);
  var u, i;
  for (i = 0; i < 16; i++) z[i] = 0;
  for (i = 0; i < 8; i++) z[i] = n[i];
  while (b >= 64) {
    crypto_core_salsa20(x,z,k,sigma);
    for (i = 0; i < 64; i++) c[cpos+i] = x[i];
    u = 1;
    for (i = 8; i < 16; i++) {
      u = u + (z[i] & 0xff) | 0;
      z[i] = u & 0xff;
      u >>>= 8;
    }
    b -= 64;
    cpos += 64;
  }
  if (b > 0) {
    crypto_core_salsa20(x,z,k,sigma);
    for (i = 0; i < b; i++) c[cpos+i] = x[i];
  }
  return 0;
}

function crypto_stream(c,cpos,d,n,k) {
  var s = new Uint8Array(32);
  crypto_core_hsalsa20(s,n,k,sigma);
  var sn = new Uint8Array(8);
  for (var i = 0; i < 8; i++) sn[i] = n[i+16];
  return crypto_stream_salsa20(c,cpos,d,sn,s);
}

function crypto_stream_xor(c,cpos,m,mpos,d,n,k) {
  var s = new Uint8Array(32);
  crypto_core_hsalsa20(s,n,k,sigma);
  var sn = new Uint8Array(8);
  for (var i = 0; i < 8; i++) sn[i] = n[i+16];
  return crypto_stream_salsa20_xor(c,cpos,m,mpos,d,sn,s);
}

/*
* Port of Andrew Moon's Poly1305-donna-16. Public domain.
* https://github.com/floodyberry/poly1305-donna
*/

var poly1305 = function(key) {
  this.buffer = new Uint8Array(16);
  this.r = new Uint16Array(10);
  this.h = new Uint16Array(10);
  this.pad = new Uint16Array(8);
  this.leftover = 0;
  this.fin = 0;

  var t0, t1, t2, t3, t4, t5, t6, t7;

  t0 = key[ 0] & 0xff | (key[ 1] & 0xff) << 8; this.r[0] = ( t0                     ) & 0x1fff;
  t1 = key[ 2] & 0xff | (key[ 3] & 0xff) << 8; this.r[1] = ((t0 >>> 13) | (t1 <<  3)) & 0x1fff;
  t2 = key[ 4] & 0xff | (key[ 5] & 0xff) << 8; this.r[2] = ((t1 >>> 10) | (t2 <<  6)) & 0x1f03;
  t3 = key[ 6] & 0xff | (key[ 7] & 0xff) << 8; this.r[3] = ((t2 >>>  7) | (t3 <<  9)) & 0x1fff;
  t4 = key[ 8] & 0xff | (key[ 9] & 0xff) << 8; this.r[4] = ((t3 >>>  4) | (t4 << 12)) & 0x00ff;
  this.r[5] = ((t4 >>>  1)) & 0x1ffe;
  t5 = key[10] & 0xff | (key[11] & 0xff) << 8; this.r[6] = ((t4 >>> 14) | (t5 <<  2)) & 0x1fff;
  t6 = key[12] & 0xff | (key[13] & 0xff) << 8; this.r[7] = ((t5 >>> 11) | (t6 <<  5)) & 0x1f81;
  t7 = key[14] & 0xff | (key[15] & 0xff) << 8; this.r[8] = ((t6 >>>  8) | (t7 <<  8)) & 0x1fff;
  this.r[9] = ((t7 >>>  5)) & 0x007f;

  this.pad[0] = key[16] & 0xff | (key[17] & 0xff) << 8;
  this.pad[1] = key[18] & 0xff | (key[19] & 0xff) << 8;
  this.pad[2] = key[20] & 0xff | (key[21] & 0xff) << 8;
  this.pad[3] = key[22] & 0xff | (key[23] & 0xff) << 8;
  this.pad[4] = key[24] & 0xff | (key[25] & 0xff) << 8;
  this.pad[5] = key[26] & 0xff | (key[27] & 0xff) << 8;
  this.pad[6] = key[28] & 0xff | (key[29] & 0xff) << 8;
  this.pad[7] = key[30] & 0xff | (key[31] & 0xff) << 8;
};

poly1305.prototype.blocks = function(m, mpos, bytes) {
  var hibit = this.fin ? 0 : (1 << 11);
  var t0, t1, t2, t3, t4, t5, t6, t7, c;
  var d0, d1, d2, d3, d4, d5, d6, d7, d8, d9;

  var h0 = this.h[0],
      h1 = this.h[1],
      h2 = this.h[2],
      h3 = this.h[3],
      h4 = this.h[4],
      h5 = this.h[5],
      h6 = this.h[6],
      h7 = this.h[7],
      h8 = this.h[8],
      h9 = this.h[9];

  var r0 = this.r[0],
      r1 = this.r[1],
      r2 = this.r[2],
      r3 = this.r[3],
      r4 = this.r[4],
      r5 = this.r[5],
      r6 = this.r[6],
      r7 = this.r[7],
      r8 = this.r[8],
      r9 = this.r[9];

  while (bytes >= 16) {
    t0 = m[mpos+ 0] & 0xff | (m[mpos+ 1] & 0xff) << 8; h0 += ( t0                     ) & 0x1fff;
    t1 = m[mpos+ 2] & 0xff | (m[mpos+ 3] & 0xff) << 8; h1 += ((t0 >>> 13) | (t1 <<  3)) & 0x1fff;
    t2 = m[mpos+ 4] & 0xff | (m[mpos+ 5] & 0xff) << 8; h2 += ((t1 >>> 10) | (t2 <<  6)) & 0x1fff;
    t3 = m[mpos+ 6] & 0xff | (m[mpos+ 7] & 0xff) << 8; h3 += ((t2 >>>  7) | (t3 <<  9)) & 0x1fff;
    t4 = m[mpos+ 8] & 0xff | (m[mpos+ 9] & 0xff) << 8; h4 += ((t3 >>>  4) | (t4 << 12)) & 0x1fff;
    h5 += ((t4 >>>  1)) & 0x1fff;
    t5 = m[mpos+10] & 0xff | (m[mpos+11] & 0xff) << 8; h6 += ((t4 >>> 14) | (t5 <<  2)) & 0x1fff;
    t6 = m[mpos+12] & 0xff | (m[mpos+13] & 0xff) << 8; h7 += ((t5 >>> 11) | (t6 <<  5)) & 0x1fff;
    t7 = m[mpos+14] & 0xff | (m[mpos+15] & 0xff) << 8; h8 += ((t6 >>>  8) | (t7 <<  8)) & 0x1fff;
    h9 += ((t7 >>> 5)) | hibit;

    c = 0;

    d0 = c;
    d0 += h0 * r0;
    d0 += h1 * (5 * r9);
    d0 += h2 * (5 * r8);
    d0 += h3 * (5 * r7);
    d0 += h4 * (5 * r6);
    c = (d0 >>> 13); d0 &= 0x1fff;
    d0 += h5 * (5 * r5);
    d0 += h6 * (5 * r4);
    d0 += h7 * (5 * r3);
    d0 += h8 * (5 * r2);
    d0 += h9 * (5 * r1);
    c += (d0 >>> 13); d0 &= 0x1fff;

    d1 = c;
    d1 += h0 * r1;
    d1 += h1 * r0;
    d1 += h2 * (5 * r9);
    d1 += h3 * (5 * r8);
    d1 += h4 * (5 * r7);
    c = (d1 >>> 13); d1 &= 0x1fff;
    d1 += h5 * (5 * r6);
    d1 += h6 * (5 * r5);
    d1 += h7 * (5 * r4);
    d1 += h8 * (5 * r3);
    d1 += h9 * (5 * r2);
    c += (d1 >>> 13); d1 &= 0x1fff;

    d2 = c;
    d2 += h0 * r2;
    d2 += h1 * r1;
    d2 += h2 * r0;
    d2 += h3 * (5 * r9);
    d2 += h4 * (5 * r8);
    c = (d2 >>> 13); d2 &= 0x1fff;
    d2 += h5 * (5 * r7);
    d2 += h6 * (5 * r6);
    d2 += h7 * (5 * r5);
    d2 += h8 * (5 * r4);
    d2 += h9 * (5 * r3);
    c += (d2 >>> 13); d2 &= 0x1fff;

    d3 = c;
    d3 += h0 * r3;
    d3 += h1 * r2;
    d3 += h2 * r1;
    d3 += h3 * r0;
    d3 += h4 * (5 * r9);
    c = (d3 >>> 13); d3 &= 0x1fff;
    d3 += h5 * (5 * r8);
    d3 += h6 * (5 * r7);
    d3 += h7 * (5 * r6);
    d3 += h8 * (5 * r5);
    d3 += h9 * (5 * r4);
    c += (d3 >>> 13); d3 &= 0x1fff;

    d4 = c;
    d4 += h0 * r4;
    d4 += h1 * r3;
    d4 += h2 * r2;
    d4 += h3 * r1;
    d4 += h4 * r0;
    c = (d4 >>> 13); d4 &= 0x1fff;
    d4 += h5 * (5 * r9);
    d4 += h6 * (5 * r8);
    d4 += h7 * (5 * r7);
    d4 += h8 * (5 * r6);
    d4 += h9 * (5 * r5);
    c += (d4 >>> 13); d4 &= 0x1fff;

    d5 = c;
    d5 += h0 * r5;
    d5 += h1 * r4;
    d5 += h2 * r3;
    d5 += h3 * r2;
    d5 += h4 * r1;
    c = (d5 >>> 13); d5 &= 0x1fff;
    d5 += h5 * r0;
    d5 += h6 * (5 * r9);
    d5 += h7 * (5 * r8);
    d5 += h8 * (5 * r7);
    d5 += h9 * (5 * r6);
    c += (d5 >>> 13); d5 &= 0x1fff;

    d6 = c;
    d6 += h0 * r6;
    d6 += h1 * r5;
    d6 += h2 * r4;
    d6 += h3 * r3;
    d6 += h4 * r2;
    c = (d6 >>> 13); d6 &= 0x1fff;
    d6 += h5 * r1;
    d6 += h6 * r0;
    d6 += h7 * (5 * r9);
    d6 += h8 * (5 * r8);
    d6 += h9 * (5 * r7);
    c += (d6 >>> 13); d6 &= 0x1fff;

    d7 = c;
    d7 += h0 * r7;
    d7 += h1 * r6;
    d7 += h2 * r5;
    d7 += h3 * r4;
    d7 += h4 * r3;
    c = (d7 >>> 13); d7 &= 0x1fff;
    d7 += h5 * r2;
    d7 += h6 * r1;
    d7 += h7 * r0;
    d7 += h8 * (5 * r9);
    d7 += h9 * (5 * r8);
    c += (d7 >>> 13); d7 &= 0x1fff;

    d8 = c;
    d8 += h0 * r8;
    d8 += h1 * r7;
    d8 += h2 * r6;
    d8 += h3 * r5;
    d8 += h4 * r4;
    c = (d8 >>> 13); d8 &= 0x1fff;
    d8 += h5 * r3;
    d8 += h6 * r2;
    d8 += h7 * r1;
    d8 += h8 * r0;
    d8 += h9 * (5 * r9);
    c += (d8 >>> 13); d8 &= 0x1fff;

    d9 = c;
    d9 += h0 * r9;
    d9 += h1 * r8;
    d9 += h2 * r7;
    d9 += h3 * r6;
    d9 += h4 * r5;
    c = (d9 >>> 13); d9 &= 0x1fff;
    d9 += h5 * r4;
    d9 += h6 * r3;
    d9 += h7 * r2;
    d9 += h8 * r1;
    d9 += h9 * r0;
    c += (d9 >>> 13); d9 &= 0x1fff;

    c = (((c << 2) + c)) | 0;
    c = (c + d0) | 0;
    d0 = c & 0x1fff;
    c = (c >>> 13);
    d1 += c;

    h0 = d0;
    h1 = d1;
    h2 = d2;
    h3 = d3;
    h4 = d4;
    h5 = d5;
    h6 = d6;
    h7 = d7;
    h8 = d8;
    h9 = d9;

    mpos += 16;
    bytes -= 16;
  }
  this.h[0] = h0;
  this.h[1] = h1;
  this.h[2] = h2;
  this.h[3] = h3;
  this.h[4] = h4;
  this.h[5] = h5;
  this.h[6] = h6;
  this.h[7] = h7;
  this.h[8] = h8;
  this.h[9] = h9;
};

poly1305.prototype.finish = function(mac, macpos) {
  var g = new Uint16Array(10);
  var c, mask, f, i;

  if (this.leftover) {
    i = this.leftover;
    this.buffer[i++] = 1;
    for (; i < 16; i++) this.buffer[i] = 0;
    this.fin = 1;
    this.blocks(this.buffer, 0, 16);
  }

  c = this.h[1] >>> 13;
  this.h[1] &= 0x1fff;
  for (i = 2; i < 10; i++) {
    this.h[i] += c;
    c = this.h[i] >>> 13;
    this.h[i] &= 0x1fff;
  }
  this.h[0] += (c * 5);
  c = this.h[0] >>> 13;
  this.h[0] &= 0x1fff;
  this.h[1] += c;
  c = this.h[1] >>> 13;
  this.h[1] &= 0x1fff;
  this.h[2] += c;

  g[0] = this.h[0] + 5;
  c = g[0] >>> 13;
  g[0] &= 0x1fff;
  for (i = 1; i < 10; i++) {
    g[i] = this.h[i] + c;
    c = g[i] >>> 13;
    g[i] &= 0x1fff;
  }
  g[9] -= (1 << 13);

  mask = (c ^ 1) - 1;
  for (i = 0; i < 10; i++) g[i] &= mask;
  mask = ~mask;
  for (i = 0; i < 10; i++) this.h[i] = (this.h[i] & mask) | g[i];

  this.h[0] = ((this.h[0]       ) | (this.h[1] << 13)                    ) & 0xffff;
  this.h[1] = ((this.h[1] >>>  3) | (this.h[2] << 10)                    ) & 0xffff;
  this.h[2] = ((this.h[2] >>>  6) | (this.h[3] <<  7)                    ) & 0xffff;
  this.h[3] = ((this.h[3] >>>  9) | (this.h[4] <<  4)                    ) & 0xffff;
  this.h[4] = ((this.h[4] >>> 12) | (this.h[5] <<  1) | (this.h[6] << 14)) & 0xffff;
  this.h[5] = ((this.h[6] >>>  2) | (this.h[7] << 11)                    ) & 0xffff;
  this.h[6] = ((this.h[7] >>>  5) | (this.h[8] <<  8)                    ) & 0xffff;
  this.h[7] = ((this.h[8] >>>  8) | (this.h[9] <<  5)                    ) & 0xffff;

  f = this.h[0] + this.pad[0];
  this.h[0] = f & 0xffff;
  for (i = 1; i < 8; i++) {
    f = (((this.h[i] + this.pad[i]) | 0) + (f >>> 16)) | 0;
    this.h[i] = f & 0xffff;
  }

  mac[macpos+ 0] = (this.h[0] >>> 0) & 0xff;
  mac[macpos+ 1] = (this.h[0] >>> 8) & 0xff;
  mac[macpos+ 2] = (this.h[1] >>> 0) & 0xff;
  mac[macpos+ 3] = (this.h[1] >>> 8) & 0xff;
  mac[macpos+ 4] = (this.h[2] >>> 0) & 0xff;
  mac[macpos+ 5] = (this.h[2] >>> 8) & 0xff;
  mac[macpos+ 6] = (this.h[3] >>> 0) & 0xff;
  mac[macpos+ 7] = (this.h[3] >>> 8) & 0xff;
  mac[macpos+ 8] = (this.h[4] >>> 0) & 0xff;
  mac[macpos+ 9] = (this.h[4] >>> 8) & 0xff;
  mac[macpos+10] = (this.h[5] >>> 0) & 0xff;
  mac[macpos+11] = (this.h[5] >>> 8) & 0xff;
  mac[macpos+12] = (this.h[6] >>> 0) & 0xff;
  mac[macpos+13] = (this.h[6] >>> 8) & 0xff;
  mac[macpos+14] = (this.h[7] >>> 0) & 0xff;
  mac[macpos+15] = (this.h[7] >>> 8) & 0xff;
};

poly1305.prototype.update = function(m, mpos, bytes) {
  var i, want;

  if (this.leftover) {
    want = (16 - this.leftover);
    if (want > bytes)
      want = bytes;
    for (i = 0; i < want; i++)
      this.buffer[this.leftover + i] = m[mpos+i];
    bytes -= want;
    mpos += want;
    this.leftover += want;
    if (this.leftover < 16)
      return;
    this.blocks(this.buffer, 0, 16);
    this.leftover = 0;
  }

  if (bytes >= 16) {
    want = bytes - (bytes % 16);
    this.blocks(m, mpos, want);
    mpos += want;
    bytes -= want;
  }

  if (bytes) {
    for (i = 0; i < bytes; i++)
      this.buffer[this.leftover + i] = m[mpos+i];
    this.leftover += bytes;
  }
};

function crypto_onetimeauth(out, outpos, m, mpos, n, k) {
  var s = new poly1305(k);
  s.update(m, mpos, n);
  s.finish(out, outpos);
  return 0;
}

function crypto_onetimeauth_verify(h, hpos, m, mpos, n, k) {
  var x = new Uint8Array(16);
  crypto_onetimeauth(x,0,m,mpos,n,k);
  return crypto_verify_16(h,hpos,x,0);
}

function crypto_secretbox(c,m,d,n,k) {
  var i;
  if (d < 32) return -1;
  crypto_stream_xor(c,0,m,0,d,n,k);
  crypto_onetimeauth(c, 16, c, 32, d - 32, c);
  for (i = 0; i < 16; i++) c[i] = 0;
  return 0;
}

function crypto_secretbox_open(m,c,d,n,k) {
  var i;
  var x = new Uint8Array(32);
  if (d < 32) return -1;
  crypto_stream(x,0,32,n,k);
  if (crypto_onetimeauth_verify(c, 16,c, 32,d - 32,x) !== 0) return -1;
  crypto_stream_xor(m,0,c,0,d,n,k);
  for (i = 0; i < 32; i++) m[i] = 0;
  return 0;
}

function set25519(r, a) {
  var i;
  for (i = 0; i < 16; i++) r[i] = a[i]|0;
}

function car25519(o) {
  var i, v, c = 1;
  for (i = 0; i < 16; i++) {
    v = o[i] + c + 65535;
    c = Math.floor(v / 65536);
    o[i] = v - c * 65536;
  }
  o[0] += c-1 + 37 * (c-1);
}

function sel25519(p, q, b) {
  var t, c = ~(b-1);
  for (var i = 0; i < 16; i++) {
    t = c & (p[i] ^ q[i]);
    p[i] ^= t;
    q[i] ^= t;
  }
}

function pack25519(o, n) {
  var i, j, b;
  var m = gf(), t = gf();
  for (i = 0; i < 16; i++) t[i] = n[i];
  car25519(t);
  car25519(t);
  car25519(t);
  for (j = 0; j < 2; j++) {
    m[0] = t[0] - 0xffed;
    for (i = 1; i < 15; i++) {
      m[i] = t[i] - 0xffff - ((m[i-1]>>16) & 1);
      m[i-1] &= 0xffff;
    }
    m[15] = t[15] - 0x7fff - ((m[14]>>16) & 1);
    b = (m[15]>>16) & 1;
    m[14] &= 0xffff;
    sel25519(t, m, 1-b);
  }
  for (i = 0; i < 16; i++) {
    o[2*i] = t[i] & 0xff;
    o[2*i+1] = t[i]>>8;
  }
}

function neq25519(a, b) {
  var c = new Uint8Array(32), d = new Uint8Array(32);
  pack25519(c, a);
  pack25519(d, b);
  return crypto_verify_32(c, 0, d, 0);
}

function par25519(a) {
  var d = new Uint8Array(32);
  pack25519(d, a);
  return d[0] & 1;
}

function unpack25519(o, n) {
  var i;
  for (i = 0; i < 16; i++) o[i] = n[2*i] + (n[2*i+1] << 8);
  o[15] &= 0x7fff;
}

function A(o, a, b) {
  for (var i = 0; i < 16; i++) o[i] = a[i] + b[i];
}

function Z(o, a, b) {
  for (var i = 0; i < 16; i++) o[i] = a[i] - b[i];
}

function M(o, a, b) {
  var v, c,
     t0 = 0,  t1 = 0,  t2 = 0,  t3 = 0,  t4 = 0,  t5 = 0,  t6 = 0,  t7 = 0,
     t8 = 0,  t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0,
    t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0,
    t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0,
    b0 = b[0],
    b1 = b[1],
    b2 = b[2],
    b3 = b[3],
    b4 = b[4],
    b5 = b[5],
    b6 = b[6],
    b7 = b[7],
    b8 = b[8],
    b9 = b[9],
    b10 = b[10],
    b11 = b[11],
    b12 = b[12],
    b13 = b[13],
    b14 = b[14],
    b15 = b[15];

  v = a[0];
  t0 += v * b0;
  t1 += v * b1;
  t2 += v * b2;
  t3 += v * b3;
  t4 += v * b4;
  t5 += v * b5;
  t6 += v * b6;
  t7 += v * b7;
  t8 += v * b8;
  t9 += v * b9;
  t10 += v * b10;
  t11 += v * b11;
  t12 += v * b12;
  t13 += v * b13;
  t14 += v * b14;
  t15 += v * b15;
  v = a[1];
  t1 += v * b0;
  t2 += v * b1;
  t3 += v * b2;
  t4 += v * b3;
  t5 += v * b4;
  t6 += v * b5;
  t7 += v * b6;
  t8 += v * b7;
  t9 += v * b8;
  t10 += v * b9;
  t11 += v * b10;
  t12 += v * b11;
  t13 += v * b12;
  t14 += v * b13;
  t15 += v * b14;
  t16 += v * b15;
  v = a[2];
  t2 += v * b0;
  t3 += v * b1;
  t4 += v * b2;
  t5 += v * b3;
  t6 += v * b4;
  t7 += v * b5;
  t8 += v * b6;
  t9 += v * b7;
  t10 += v * b8;
  t11 += v * b9;
  t12 += v * b10;
  t13 += v * b11;
  t14 += v * b12;
  t15 += v * b13;
  t16 += v * b14;
  t17 += v * b15;
  v = a[3];
  t3 += v * b0;
  t4 += v * b1;
  t5 += v * b2;
  t6 += v * b3;
  t7 += v * b4;
  t8 += v * b5;
  t9 += v * b6;
  t10 += v * b7;
  t11 += v * b8;
  t12 += v * b9;
  t13 += v * b10;
  t14 += v * b11;
  t15 += v * b12;
  t16 += v * b13;
  t17 += v * b14;
  t18 += v * b15;
  v = a[4];
  t4 += v * b0;
  t5 += v * b1;
  t6 += v * b2;
  t7 += v * b3;
  t8 += v * b4;
  t9 += v * b5;
  t10 += v * b6;
  t11 += v * b7;
  t12 += v * b8;
  t13 += v * b9;
  t14 += v * b10;
  t15 += v * b11;
  t16 += v * b12;
  t17 += v * b13;
  t18 += v * b14;
  t19 += v * b15;
  v = a[5];
  t5 += v * b0;
  t6 += v * b1;
  t7 += v * b2;
  t8 += v * b3;
  t9 += v * b4;
  t10 += v * b5;
  t11 += v * b6;
  t12 += v * b7;
  t13 += v * b8;
  t14 += v * b9;
  t15 += v * b10;
  t16 += v * b11;
  t17 += v * b12;
  t18 += v * b13;
  t19 += v * b14;
  t20 += v * b15;
  v = a[6];
  t6 += v * b0;
  t7 += v * b1;
  t8 += v * b2;
  t9 += v * b3;
  t10 += v * b4;
  t11 += v * b5;
  t12 += v * b6;
  t13 += v * b7;
  t14 += v * b8;
  t15 += v * b9;
  t16 += v * b10;
  t17 += v * b11;
  t18 += v * b12;
  t19 += v * b13;
  t20 += v * b14;
  t21 += v * b15;
  v = a[7];
  t7 += v * b0;
  t8 += v * b1;
  t9 += v * b2;
  t10 += v * b3;
  t11 += v * b4;
  t12 += v * b5;
  t13 += v * b6;
  t14 += v * b7;
  t15 += v * b8;
  t16 += v * b9;
  t17 += v * b10;
  t18 += v * b11;
  t19 += v * b12;
  t20 += v * b13;
  t21 += v * b14;
  t22 += v * b15;
  v = a[8];
  t8 += v * b0;
  t9 += v * b1;
  t10 += v * b2;
  t11 += v * b3;
  t12 += v * b4;
  t13 += v * b5;
  t14 += v * b6;
  t15 += v * b7;
  t16 += v * b8;
  t17 += v * b9;
  t18 += v * b10;
  t19 += v * b11;
  t20 += v * b12;
  t21 += v * b13;
  t22 += v * b14;
  t23 += v * b15;
  v = a[9];
  t9 += v * b0;
  t10 += v * b1;
  t11 += v * b2;
  t12 += v * b3;
  t13 += v * b4;
  t14 += v * b5;
  t15 += v * b6;
  t16 += v * b7;
  t17 += v * b8;
  t18 += v * b9;
  t19 += v * b10;
  t20 += v * b11;
  t21 += v * b12;
  t22 += v * b13;
  t23 += v * b14;
  t24 += v * b15;
  v = a[10];
  t10 += v * b0;
  t11 += v * b1;
  t12 += v * b2;
  t13 += v * b3;
  t14 += v * b4;
  t15 += v * b5;
  t16 += v * b6;
  t17 += v * b7;
  t18 += v * b8;
  t19 += v * b9;
  t20 += v * b10;
  t21 += v * b11;
  t22 += v * b12;
  t23 += v * b13;
  t24 += v * b14;
  t25 += v * b15;
  v = a[11];
  t11 += v * b0;
  t12 += v * b1;
  t13 += v * b2;
  t14 += v * b3;
  t15 += v * b4;
  t16 += v * b5;
  t17 += v * b6;
  t18 += v * b7;
  t19 += v * b8;
  t20 += v * b9;
  t21 += v * b10;
  t22 += v * b11;
  t23 += v * b12;
  t24 += v * b13;
  t25 += v * b14;
  t26 += v * b15;
  v = a[12];
  t12 += v * b0;
  t13 += v * b1;
  t14 += v * b2;
  t15 += v * b3;
  t16 += v * b4;
  t17 += v * b5;
  t18 += v * b6;
  t19 += v * b7;
  t20 += v * b8;
  t21 += v * b9;
  t22 += v * b10;
  t23 += v * b11;
  t24 += v * b12;
  t25 += v * b13;
  t26 += v * b14;
  t27 += v * b15;
  v = a[13];
  t13 += v * b0;
  t14 += v * b1;
  t15 += v * b2;
  t16 += v * b3;
  t17 += v * b4;
  t18 += v * b5;
  t19 += v * b6;
  t20 += v * b7;
  t21 += v * b8;
  t22 += v * b9;
  t23 += v * b10;
  t24 += v * b11;
  t25 += v * b12;
  t26 += v * b13;
  t27 += v * b14;
  t28 += v * b15;
  v = a[14];
  t14 += v * b0;
  t15 += v * b1;
  t16 += v * b2;
  t17 += v * b3;
  t18 += v * b4;
  t19 += v * b5;
  t20 += v * b6;
  t21 += v * b7;
  t22 += v * b8;
  t23 += v * b9;
  t24 += v * b10;
  t25 += v * b11;
  t26 += v * b12;
  t27 += v * b13;
  t28 += v * b14;
  t29 += v * b15;
  v = a[15];
  t15 += v * b0;
  t16 += v * b1;
  t17 += v * b2;
  t18 += v * b3;
  t19 += v * b4;
  t20 += v * b5;
  t21 += v * b6;
  t22 += v * b7;
  t23 += v * b8;
  t24 += v * b9;
  t25 += v * b10;
  t26 += v * b11;
  t27 += v * b12;
  t28 += v * b13;
  t29 += v * b14;
  t30 += v * b15;

  t0  += 38 * t16;
  t1  += 38 * t17;
  t2  += 38 * t18;
  t3  += 38 * t19;
  t4  += 38 * t20;
  t5  += 38 * t21;
  t6  += 38 * t22;
  t7  += 38 * t23;
  t8  += 38 * t24;
  t9  += 38 * t25;
  t10 += 38 * t26;
  t11 += 38 * t27;
  t12 += 38 * t28;
  t13 += 38 * t29;
  t14 += 38 * t30;
  // t15 left as is

  // first car
  c = 1;
  v =  t0 + c + 65535; c = Math.floor(v / 65536);  t0 = v - c * 65536;
  v =  t1 + c + 65535; c = Math.floor(v / 65536);  t1 = v - c * 65536;
  v =  t2 + c + 65535; c = Math.floor(v / 65536);  t2 = v - c * 65536;
  v =  t3 + c + 65535; c = Math.floor(v / 65536);  t3 = v - c * 65536;
  v =  t4 + c + 65535; c = Math.floor(v / 65536);  t4 = v - c * 65536;
  v =  t5 + c + 65535; c = Math.floor(v / 65536);  t5 = v - c * 65536;
  v =  t6 + c + 65535; c = Math.floor(v / 65536);  t6 = v - c * 65536;
  v =  t7 + c + 65535; c = Math.floor(v / 65536);  t7 = v - c * 65536;
  v =  t8 + c + 65535; c = Math.floor(v / 65536);  t8 = v - c * 65536;
  v =  t9 + c + 65535; c = Math.floor(v / 65536);  t9 = v - c * 65536;
  v = t10 + c + 65535; c = Math.floor(v / 65536); t10 = v - c * 65536;
  v = t11 + c + 65535; c = Math.floor(v / 65536); t11 = v - c * 65536;
  v = t12 + c + 65535; c = Math.floor(v / 65536); t12 = v - c * 65536;
  v = t13 + c + 65535; c = Math.floor(v / 65536); t13 = v - c * 65536;
  v = t14 + c + 65535; c = Math.floor(v / 65536); t14 = v - c * 65536;
  v = t15 + c + 65535; c = Math.floor(v / 65536); t15 = v - c * 65536;
  t0 += c-1 + 37 * (c-1);

  // second car
  c = 1;
  v =  t0 + c + 65535; c = Math.floor(v / 65536);  t0 = v - c * 65536;
  v =  t1 + c + 65535; c = Math.floor(v / 65536);  t1 = v - c * 65536;
  v =  t2 + c + 65535; c = Math.floor(v / 65536);  t2 = v - c * 65536;
  v =  t3 + c + 65535; c = Math.floor(v / 65536);  t3 = v - c * 65536;
  v =  t4 + c + 65535; c = Math.floor(v / 65536);  t4 = v - c * 65536;
  v =  t5 + c + 65535; c = Math.floor(v / 65536);  t5 = v - c * 65536;
  v =  t6 + c + 65535; c = Math.floor(v / 65536);  t6 = v - c * 65536;
  v =  t7 + c + 65535; c = Math.floor(v / 65536);  t7 = v - c * 65536;
  v =  t8 + c + 65535; c = Math.floor(v / 65536);  t8 = v - c * 65536;
  v =  t9 + c + 65535; c = Math.floor(v / 65536);  t9 = v - c * 65536;
  v = t10 + c + 65535; c = Math.floor(v / 65536); t10 = v - c * 65536;
  v = t11 + c + 65535; c = Math.floor(v / 65536); t11 = v - c * 65536;
  v = t12 + c + 65535; c = Math.floor(v / 65536); t12 = v - c * 65536;
  v = t13 + c + 65535; c = Math.floor(v / 65536); t13 = v - c * 65536;
  v = t14 + c + 65535; c = Math.floor(v / 65536); t14 = v - c * 65536;
  v = t15 + c + 65535; c = Math.floor(v / 65536); t15 = v - c * 65536;
  t0 += c-1 + 37 * (c-1);

  o[ 0] = t0;
  o[ 1] = t1;
  o[ 2] = t2;
  o[ 3] = t3;
  o[ 4] = t4;
  o[ 5] = t5;
  o[ 6] = t6;
  o[ 7] = t7;
  o[ 8] = t8;
  o[ 9] = t9;
  o[10] = t10;
  o[11] = t11;
  o[12] = t12;
  o[13] = t13;
  o[14] = t14;
  o[15] = t15;
}

function S(o, a) {
  M(o, a, a);
}

function inv25519(o, i) {
  var c = gf();
  var a;
  for (a = 0; a < 16; a++) c[a] = i[a];
  for (a = 253; a >= 0; a--) {
    S(c, c);
    if(a !== 2 && a !== 4) M(c, c, i);
  }
  for (a = 0; a < 16; a++) o[a] = c[a];
}

function pow2523(o, i) {
  var c = gf();
  var a;
  for (a = 0; a < 16; a++) c[a] = i[a];
  for (a = 250; a >= 0; a--) {
      S(c, c);
      if(a !== 1) M(c, c, i);
  }
  for (a = 0; a < 16; a++) o[a] = c[a];
}

function crypto_scalarmult(q, n, p) {
  var z = new Uint8Array(32);
  var x = new Float64Array(80), r, i;
  var a = gf(), b = gf(), c = gf(),
      d = gf(), e = gf(), f = gf();
  for (i = 0; i < 31; i++) z[i] = n[i];
  z[31]=(n[31]&127)|64;
  z[0]&=248;
  unpack25519(x,p);
  for (i = 0; i < 16; i++) {
    b[i]=x[i];
    d[i]=a[i]=c[i]=0;
  }
  a[0]=d[0]=1;
  for (i=254; i>=0; --i) {
    r=(z[i>>>3]>>>(i&7))&1;
    sel25519(a,b,r);
    sel25519(c,d,r);
    A(e,a,c);
    Z(a,a,c);
    A(c,b,d);
    Z(b,b,d);
    S(d,e);
    S(f,a);
    M(a,c,a);
    M(c,b,e);
    A(e,a,c);
    Z(a,a,c);
    S(b,a);
    Z(c,d,f);
    M(a,c,_121665);
    A(a,a,d);
    M(c,c,a);
    M(a,d,f);
    M(d,b,x);
    S(b,e);
    sel25519(a,b,r);
    sel25519(c,d,r);
  }
  for (i = 0; i < 16; i++) {
    x[i+16]=a[i];
    x[i+32]=c[i];
    x[i+48]=b[i];
    x[i+64]=d[i];
  }
  var x32 = x.subarray(32);
  var x16 = x.subarray(16);
  inv25519(x32,x32);
  M(x16,x16,x32);
  pack25519(q,x16);
  return 0;
}

function crypto_scalarmult_base(q, n) {
  return crypto_scalarmult(q, n, _9);
}

function crypto_box_keypair(y, x) {
  randombytes(x, 32);
  return crypto_scalarmult_base(y, x);
}

function crypto_box_beforenm(k, y, x) {
  var s = new Uint8Array(32);
  crypto_scalarmult(s, x, y);
  return crypto_core_hsalsa20(k, _0, s, sigma);
}

var crypto_box_afternm = crypto_secretbox;
var crypto_box_open_afternm = crypto_secretbox_open;

function crypto_box(c, m, d, n, y, x) {
  var k = new Uint8Array(32);
  crypto_box_beforenm(k, y, x);
  return crypto_box_afternm(c, m, d, n, k);
}

function crypto_box_open(m, c, d, n, y, x) {
  var k = new Uint8Array(32);
  crypto_box_beforenm(k, y, x);
  return crypto_box_open_afternm(m, c, d, n, k);
}

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function crypto_hashblocks_hl(hh, hl, m, n) {
  var wh = new Int32Array(16), wl = new Int32Array(16),
      bh0, bh1, bh2, bh3, bh4, bh5, bh6, bh7,
      bl0, bl1, bl2, bl3, bl4, bl5, bl6, bl7,
      th, tl, i, j, h, l, a, b, c, d;

  var ah0 = hh[0],
      ah1 = hh[1],
      ah2 = hh[2],
      ah3 = hh[3],
      ah4 = hh[4],
      ah5 = hh[5],
      ah6 = hh[6],
      ah7 = hh[7],

      al0 = hl[0],
      al1 = hl[1],
      al2 = hl[2],
      al3 = hl[3],
      al4 = hl[4],
      al5 = hl[5],
      al6 = hl[6],
      al7 = hl[7];

  var pos = 0;
  while (n >= 128) {
    for (i = 0; i < 16; i++) {
      j = 8 * i + pos;
      wh[i] = (m[j+0] << 24) | (m[j+1] << 16) | (m[j+2] << 8) | m[j+3];
      wl[i] = (m[j+4] << 24) | (m[j+5] << 16) | (m[j+6] << 8) | m[j+7];
    }
    for (i = 0; i < 80; i++) {
      bh0 = ah0;
      bh1 = ah1;
      bh2 = ah2;
      bh3 = ah3;
      bh4 = ah4;
      bh5 = ah5;
      bh6 = ah6;
      bh7 = ah7;

      bl0 = al0;
      bl1 = al1;
      bl2 = al2;
      bl3 = al3;
      bl4 = al4;
      bl5 = al5;
      bl6 = al6;
      bl7 = al7;

      // add
      h = ah7;
      l = al7;

      a = l & 0xffff; b = l >>> 16;
      c = h & 0xffff; d = h >>> 16;

      // Sigma1
      h = ((ah4 >>> 14) | (al4 << (32-14))) ^ ((ah4 >>> 18) | (al4 << (32-18))) ^ ((al4 >>> (41-32)) | (ah4 << (32-(41-32))));
      l = ((al4 >>> 14) | (ah4 << (32-14))) ^ ((al4 >>> 18) | (ah4 << (32-18))) ^ ((ah4 >>> (41-32)) | (al4 << (32-(41-32))));

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      // Ch
      h = (ah4 & ah5) ^ (~ah4 & ah6);
      l = (al4 & al5) ^ (~al4 & al6);

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      // K
      h = K[i*2];
      l = K[i*2+1];

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      // w
      h = wh[i%16];
      l = wl[i%16];

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      b += a >>> 16;
      c += b >>> 16;
      d += c >>> 16;

      th = c & 0xffff | d << 16;
      tl = a & 0xffff | b << 16;

      // add
      h = th;
      l = tl;

      a = l & 0xffff; b = l >>> 16;
      c = h & 0xffff; d = h >>> 16;

      // Sigma0
      h = ((ah0 >>> 28) | (al0 << (32-28))) ^ ((al0 >>> (34-32)) | (ah0 << (32-(34-32)))) ^ ((al0 >>> (39-32)) | (ah0 << (32-(39-32))));
      l = ((al0 >>> 28) | (ah0 << (32-28))) ^ ((ah0 >>> (34-32)) | (al0 << (32-(34-32)))) ^ ((ah0 >>> (39-32)) | (al0 << (32-(39-32))));

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      // Maj
      h = (ah0 & ah1) ^ (ah0 & ah2) ^ (ah1 & ah2);
      l = (al0 & al1) ^ (al0 & al2) ^ (al1 & al2);

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      b += a >>> 16;
      c += b >>> 16;
      d += c >>> 16;

      bh7 = (c & 0xffff) | (d << 16);
      bl7 = (a & 0xffff) | (b << 16);

      // add
      h = bh3;
      l = bl3;

      a = l & 0xffff; b = l >>> 16;
      c = h & 0xffff; d = h >>> 16;

      h = th;
      l = tl;

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      b += a >>> 16;
      c += b >>> 16;
      d += c >>> 16;

      bh3 = (c & 0xffff) | (d << 16);
      bl3 = (a & 0xffff) | (b << 16);

      ah1 = bh0;
      ah2 = bh1;
      ah3 = bh2;
      ah4 = bh3;
      ah5 = bh4;
      ah6 = bh5;
      ah7 = bh6;
      ah0 = bh7;

      al1 = bl0;
      al2 = bl1;
      al3 = bl2;
      al4 = bl3;
      al5 = bl4;
      al6 = bl5;
      al7 = bl6;
      al0 = bl7;

      if (i%16 === 15) {
        for (j = 0; j < 16; j++) {
          // add
          h = wh[j];
          l = wl[j];

          a = l & 0xffff; b = l >>> 16;
          c = h & 0xffff; d = h >>> 16;

          h = wh[(j+9)%16];
          l = wl[(j+9)%16];

          a += l & 0xffff; b += l >>> 16;
          c += h & 0xffff; d += h >>> 16;

          // sigma0
          th = wh[(j+1)%16];
          tl = wl[(j+1)%16];
          h = ((th >>> 1) | (tl << (32-1))) ^ ((th >>> 8) | (tl << (32-8))) ^ (th >>> 7);
          l = ((tl >>> 1) | (th << (32-1))) ^ ((tl >>> 8) | (th << (32-8))) ^ ((tl >>> 7) | (th << (32-7)));

          a += l & 0xffff; b += l >>> 16;
          c += h & 0xffff; d += h >>> 16;

          // sigma1
          th = wh[(j+14)%16];
          tl = wl[(j+14)%16];
          h = ((th >>> 19) | (tl << (32-19))) ^ ((tl >>> (61-32)) | (th << (32-(61-32)))) ^ (th >>> 6);
          l = ((tl >>> 19) | (th << (32-19))) ^ ((th >>> (61-32)) | (tl << (32-(61-32)))) ^ ((tl >>> 6) | (th << (32-6)));

          a += l & 0xffff; b += l >>> 16;
          c += h & 0xffff; d += h >>> 16;

          b += a >>> 16;
          c += b >>> 16;
          d += c >>> 16;

          wh[j] = (c & 0xffff) | (d << 16);
          wl[j] = (a & 0xffff) | (b << 16);
        }
      }
    }

    // add
    h = ah0;
    l = al0;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[0];
    l = hl[0];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[0] = ah0 = (c & 0xffff) | (d << 16);
    hl[0] = al0 = (a & 0xffff) | (b << 16);

    h = ah1;
    l = al1;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[1];
    l = hl[1];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[1] = ah1 = (c & 0xffff) | (d << 16);
    hl[1] = al1 = (a & 0xffff) | (b << 16);

    h = ah2;
    l = al2;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[2];
    l = hl[2];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[2] = ah2 = (c & 0xffff) | (d << 16);
    hl[2] = al2 = (a & 0xffff) | (b << 16);

    h = ah3;
    l = al3;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[3];
    l = hl[3];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[3] = ah3 = (c & 0xffff) | (d << 16);
    hl[3] = al3 = (a & 0xffff) | (b << 16);

    h = ah4;
    l = al4;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[4];
    l = hl[4];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[4] = ah4 = (c & 0xffff) | (d << 16);
    hl[4] = al4 = (a & 0xffff) | (b << 16);

    h = ah5;
    l = al5;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[5];
    l = hl[5];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[5] = ah5 = (c & 0xffff) | (d << 16);
    hl[5] = al5 = (a & 0xffff) | (b << 16);

    h = ah6;
    l = al6;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[6];
    l = hl[6];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[6] = ah6 = (c & 0xffff) | (d << 16);
    hl[6] = al6 = (a & 0xffff) | (b << 16);

    h = ah7;
    l = al7;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[7];
    l = hl[7];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[7] = ah7 = (c & 0xffff) | (d << 16);
    hl[7] = al7 = (a & 0xffff) | (b << 16);

    pos += 128;
    n -= 128;
  }

  return n;
}

function crypto_hash(out, m, n) {
  var hh = new Int32Array(8),
      hl = new Int32Array(8),
      x = new Uint8Array(256),
      i, b = n;

  hh[0] = 0x6a09e667;
  hh[1] = 0xbb67ae85;
  hh[2] = 0x3c6ef372;
  hh[3] = 0xa54ff53a;
  hh[4] = 0x510e527f;
  hh[5] = 0x9b05688c;
  hh[6] = 0x1f83d9ab;
  hh[7] = 0x5be0cd19;

  hl[0] = 0xf3bcc908;
  hl[1] = 0x84caa73b;
  hl[2] = 0xfe94f82b;
  hl[3] = 0x5f1d36f1;
  hl[4] = 0xade682d1;
  hl[5] = 0x2b3e6c1f;
  hl[6] = 0xfb41bd6b;
  hl[7] = 0x137e2179;

  crypto_hashblocks_hl(hh, hl, m, n);
  n %= 128;

  for (i = 0; i < n; i++) x[i] = m[b-n+i];
  x[n] = 128;

  n = 256-128*(n<112?1:0);
  x[n-9] = 0;
  ts64(x, n-8,  (b / 0x20000000) | 0, b << 3);
  crypto_hashblocks_hl(hh, hl, x, n);

  for (i = 0; i < 8; i++) ts64(out, 8*i, hh[i], hl[i]);

  return 0;
}

function add(p, q) {
  var a = gf(), b = gf(), c = gf(),
      d = gf(), e = gf(), f = gf(),
      g = gf(), h = gf(), t = gf();

  Z(a, p[1], p[0]);
  Z(t, q[1], q[0]);
  M(a, a, t);
  A(b, p[0], p[1]);
  A(t, q[0], q[1]);
  M(b, b, t);
  M(c, p[3], q[3]);
  M(c, c, D2);
  M(d, p[2], q[2]);
  A(d, d, d);
  Z(e, b, a);
  Z(f, d, c);
  A(g, d, c);
  A(h, b, a);

  M(p[0], e, f);
  M(p[1], h, g);
  M(p[2], g, f);
  M(p[3], e, h);
}

function cswap(p, q, b) {
  var i;
  for (i = 0; i < 4; i++) {
    sel25519(p[i], q[i], b);
  }
}

function pack(r, p) {
  var tx = gf(), ty = gf(), zi = gf();
  inv25519(zi, p[2]);
  M(tx, p[0], zi);
  M(ty, p[1], zi);
  pack25519(r, ty);
  r[31] ^= par25519(tx) << 7;
}

function scalarmult(p, q, s) {
  var b, i;
  set25519(p[0], gf0);
  set25519(p[1], gf1);
  set25519(p[2], gf1);
  set25519(p[3], gf0);
  for (i = 255; i >= 0; --i) {
    b = (s[(i/8)|0] >> (i&7)) & 1;
    cswap(p, q, b);
    add(q, p);
    add(p, p);
    cswap(p, q, b);
  }
}

function scalarbase(p, s) {
  var q = [gf(), gf(), gf(), gf()];
  set25519(q[0], X);
  set25519(q[1], Y);
  set25519(q[2], gf1);
  M(q[3], X, Y);
  scalarmult(p, q, s);
}

function crypto_sign_keypair(pk, sk, seeded) {
  var d = new Uint8Array(64);
  var p = [gf(), gf(), gf(), gf()];
  var i;

  if (!seeded) randombytes(sk, 32);
  crypto_hash(d, sk, 32);
  d[0] &= 248;
  d[31] &= 127;
  d[31] |= 64;

  scalarbase(p, d);
  pack(pk, p);

  for (i = 0; i < 32; i++) sk[i+32] = pk[i];
  return 0;
}

var L = new Float64Array([0xed, 0xd3, 0xf5, 0x5c, 0x1a, 0x63, 0x12, 0x58, 0xd6, 0x9c, 0xf7, 0xa2, 0xde, 0xf9, 0xde, 0x14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x10]);

function modL(r, x) {
  var carry, i, j, k;
  for (i = 63; i >= 32; --i) {
    carry = 0;
    for (j = i - 32, k = i - 12; j < k; ++j) {
      x[j] += carry - 16 * x[i] * L[j - (i - 32)];
      carry = Math.floor((x[j] + 128) / 256);
      x[j] -= carry * 256;
    }
    x[j] += carry;
    x[i] = 0;
  }
  carry = 0;
  for (j = 0; j < 32; j++) {
    x[j] += carry - (x[31] >> 4) * L[j];
    carry = x[j] >> 8;
    x[j] &= 255;
  }
  for (j = 0; j < 32; j++) x[j] -= carry * L[j];
  for (i = 0; i < 32; i++) {
    x[i+1] += x[i] >> 8;
    r[i] = x[i] & 255;
  }
}

function reduce(r) {
  var x = new Float64Array(64), i;
  for (i = 0; i < 64; i++) x[i] = r[i];
  for (i = 0; i < 64; i++) r[i] = 0;
  modL(r, x);
}

// Note: difference from C - smlen returned, not passed as argument.
function crypto_sign(sm, m, n, sk) {
  var d = new Uint8Array(64), h = new Uint8Array(64), r = new Uint8Array(64);
  var i, j, x = new Float64Array(64);
  var p = [gf(), gf(), gf(), gf()];

  crypto_hash(d, sk, 32);
  d[0] &= 248;
  d[31] &= 127;
  d[31] |= 64;

  var smlen = n + 64;
  for (i = 0; i < n; i++) sm[64 + i] = m[i];
  for (i = 0; i < 32; i++) sm[32 + i] = d[32 + i];

  crypto_hash(r, sm.subarray(32), n+32);
  reduce(r);
  scalarbase(p, r);
  pack(sm, p);

  for (i = 32; i < 64; i++) sm[i] = sk[i];
  crypto_hash(h, sm, n + 64);
  reduce(h);

  for (i = 0; i < 64; i++) x[i] = 0;
  for (i = 0; i < 32; i++) x[i] = r[i];
  for (i = 0; i < 32; i++) {
    for (j = 0; j < 32; j++) {
      x[i+j] += h[i] * d[j];
    }
  }

  modL(sm.subarray(32), x);
  return smlen;
}

function unpackneg(r, p) {
  var t = gf(), chk = gf(), num = gf(),
      den = gf(), den2 = gf(), den4 = gf(),
      den6 = gf();

  set25519(r[2], gf1);
  unpack25519(r[1], p);
  S(num, r[1]);
  M(den, num, D);
  Z(num, num, r[2]);
  A(den, r[2], den);

  S(den2, den);
  S(den4, den2);
  M(den6, den4, den2);
  M(t, den6, num);
  M(t, t, den);

  pow2523(t, t);
  M(t, t, num);
  M(t, t, den);
  M(t, t, den);
  M(r[0], t, den);

  S(chk, r[0]);
  M(chk, chk, den);
  if (neq25519(chk, num)) M(r[0], r[0], I);

  S(chk, r[0]);
  M(chk, chk, den);
  if (neq25519(chk, num)) return -1;

  if (par25519(r[0]) === (p[31]>>7)) Z(r[0], gf0, r[0]);

  M(r[3], r[0], r[1]);
  return 0;
}

function crypto_sign_open(m, sm, n, pk) {
  var i;
  var t = new Uint8Array(32), h = new Uint8Array(64);
  var p = [gf(), gf(), gf(), gf()],
      q = [gf(), gf(), gf(), gf()];

  if (n < 64) return -1;

  if (unpackneg(q, pk)) return -1;

  for (i = 0; i < n; i++) m[i] = sm[i];
  for (i = 0; i < 32; i++) m[i+32] = pk[i];
  crypto_hash(h, m, n);
  reduce(h);
  scalarmult(p, q, h);

  scalarbase(q, sm.subarray(32));
  add(p, q);
  pack(t, p);

  n -= 64;
  if (crypto_verify_32(sm, 0, t, 0)) {
    for (i = 0; i < n; i++) m[i] = 0;
    return -1;
  }

  for (i = 0; i < n; i++) m[i] = sm[i + 64];
  return n;
}

var crypto_secretbox_KEYBYTES = 32,
    crypto_secretbox_NONCEBYTES = 24,
    crypto_secretbox_ZEROBYTES = 32,
    crypto_secretbox_BOXZEROBYTES = 16,
    crypto_scalarmult_BYTES = 32,
    crypto_scalarmult_SCALARBYTES = 32,
    crypto_box_PUBLICKEYBYTES = 32,
    crypto_box_SECRETKEYBYTES = 32,
    crypto_box_BEFORENMBYTES = 32,
    crypto_box_NONCEBYTES = crypto_secretbox_NONCEBYTES,
    crypto_box_ZEROBYTES = crypto_secretbox_ZEROBYTES,
    crypto_box_BOXZEROBYTES = crypto_secretbox_BOXZEROBYTES,
    crypto_sign_BYTES = 64,
    crypto_sign_PUBLICKEYBYTES = 32,
    crypto_sign_SECRETKEYBYTES = 64,
    crypto_sign_SEEDBYTES = 32,
    crypto_hash_BYTES = 64;

nacl.lowlevel = {
  crypto_core_hsalsa20: crypto_core_hsalsa20,
  crypto_stream_xor: crypto_stream_xor,
  crypto_stream: crypto_stream,
  crypto_stream_salsa20_xor: crypto_stream_salsa20_xor,
  crypto_stream_salsa20: crypto_stream_salsa20,
  crypto_onetimeauth: crypto_onetimeauth,
  crypto_onetimeauth_verify: crypto_onetimeauth_verify,
  crypto_verify_16: crypto_verify_16,
  crypto_verify_32: crypto_verify_32,
  crypto_secretbox: crypto_secretbox,
  crypto_secretbox_open: crypto_secretbox_open,
  crypto_scalarmult: crypto_scalarmult,
  crypto_scalarmult_base: crypto_scalarmult_base,
  crypto_box_beforenm: crypto_box_beforenm,
  crypto_box_afternm: crypto_box_afternm,
  crypto_box: crypto_box,
  crypto_box_open: crypto_box_open,
  crypto_box_keypair: crypto_box_keypair,
  crypto_hash: crypto_hash,
  crypto_sign: crypto_sign,
  crypto_sign_keypair: crypto_sign_keypair,
  crypto_sign_open: crypto_sign_open,

  crypto_secretbox_KEYBYTES: crypto_secretbox_KEYBYTES,
  crypto_secretbox_NONCEBYTES: crypto_secretbox_NONCEBYTES,
  crypto_secretbox_ZEROBYTES: crypto_secretbox_ZEROBYTES,
  crypto_secretbox_BOXZEROBYTES: crypto_secretbox_BOXZEROBYTES,
  crypto_scalarmult_BYTES: crypto_scalarmult_BYTES,
  crypto_scalarmult_SCALARBYTES: crypto_scalarmult_SCALARBYTES,
  crypto_box_PUBLICKEYBYTES: crypto_box_PUBLICKEYBYTES,
  crypto_box_SECRETKEYBYTES: crypto_box_SECRETKEYBYTES,
  crypto_box_BEFORENMBYTES: crypto_box_BEFORENMBYTES,
  crypto_box_NONCEBYTES: crypto_box_NONCEBYTES,
  crypto_box_ZEROBYTES: crypto_box_ZEROBYTES,
  crypto_box_BOXZEROBYTES: crypto_box_BOXZEROBYTES,
  crypto_sign_BYTES: crypto_sign_BYTES,
  crypto_sign_PUBLICKEYBYTES: crypto_sign_PUBLICKEYBYTES,
  crypto_sign_SECRETKEYBYTES: crypto_sign_SECRETKEYBYTES,
  crypto_sign_SEEDBYTES: crypto_sign_SEEDBYTES,
  crypto_hash_BYTES: crypto_hash_BYTES,

  gf: gf,
  D: D,
  L: L,
  pack25519: pack25519,
  unpack25519: unpack25519,
  M: M,
  A: A,
  S: S,
  Z: Z,
  pow2523: pow2523,
  add: add,
  set25519: set25519,
  modL: modL,
  scalarmult: scalarmult,
  scalarbase: scalarbase,
};

/* High-level API */

function checkLengths(k, n) {
  if (k.length !== crypto_secretbox_KEYBYTES) throw new Error('bad key size');
  if (n.length !== crypto_secretbox_NONCEBYTES) throw new Error('bad nonce size');
}

function checkBoxLengths(pk, sk) {
  if (pk.length !== crypto_box_PUBLICKEYBYTES) throw new Error('bad public key size');
  if (sk.length !== crypto_box_SECRETKEYBYTES) throw new Error('bad secret key size');
}

function checkArrayTypes() {
  for (var i = 0; i < arguments.length; i++) {
    if (!(arguments[i] instanceof Uint8Array))
      throw new TypeError('unexpected type, use Uint8Array');
  }
}

function cleanup(arr) {
  for (var i = 0; i < arr.length; i++) arr[i] = 0;
}

nacl.randomBytes = function(n) {
  var b = new Uint8Array(n);
  randombytes(b, n);
  return b;
};

nacl.secretbox = function(msg, nonce, key) {
  checkArrayTypes(msg, nonce, key);
  checkLengths(key, nonce);
  var m = new Uint8Array(crypto_secretbox_ZEROBYTES + msg.length);
  var c = new Uint8Array(m.length);
  for (var i = 0; i < msg.length; i++) m[i+crypto_secretbox_ZEROBYTES] = msg[i];
  crypto_secretbox(c, m, m.length, nonce, key);
  return c.subarray(crypto_secretbox_BOXZEROBYTES);
};

nacl.secretbox.open = function(box, nonce, key) {
  checkArrayTypes(box, nonce, key);
  checkLengths(key, nonce);
  var c = new Uint8Array(crypto_secretbox_BOXZEROBYTES + box.length);
  var m = new Uint8Array(c.length);
  for (var i = 0; i < box.length; i++) c[i+crypto_secretbox_BOXZEROBYTES] = box[i];
  if (c.length < 32) return null;
  if (crypto_secretbox_open(m, c, c.length, nonce, key) !== 0) return null;
  return m.subarray(crypto_secretbox_ZEROBYTES);
};

nacl.secretbox.keyLength = crypto_secretbox_KEYBYTES;
nacl.secretbox.nonceLength = crypto_secretbox_NONCEBYTES;
nacl.secretbox.overheadLength = crypto_secretbox_BOXZEROBYTES;

nacl.scalarMult = function(n, p) {
  checkArrayTypes(n, p);
  if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error('bad n size');
  if (p.length !== crypto_scalarmult_BYTES) throw new Error('bad p size');
  var q = new Uint8Array(crypto_scalarmult_BYTES);
  crypto_scalarmult(q, n, p);
  return q;
};

nacl.scalarMult.base = function(n) {
  checkArrayTypes(n);
  if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error('bad n size');
  var q = new Uint8Array(crypto_scalarmult_BYTES);
  crypto_scalarmult_base(q, n);
  return q;
};

nacl.scalarMult.scalarLength = crypto_scalarmult_SCALARBYTES;
nacl.scalarMult.groupElementLength = crypto_scalarmult_BYTES;

nacl.box = function(msg, nonce, publicKey, secretKey) {
  var k = nacl.box.before(publicKey, secretKey);
  return nacl.secretbox(msg, nonce, k);
};

nacl.box.before = function(publicKey, secretKey) {
  checkArrayTypes(publicKey, secretKey);
  checkBoxLengths(publicKey, secretKey);
  var k = new Uint8Array(crypto_box_BEFORENMBYTES);
  crypto_box_beforenm(k, publicKey, secretKey);
  return k;
};

nacl.box.after = nacl.secretbox;

nacl.box.open = function(msg, nonce, publicKey, secretKey) {
  var k = nacl.box.before(publicKey, secretKey);
  return nacl.secretbox.open(msg, nonce, k);
};

nacl.box.open.after = nacl.secretbox.open;

nacl.box.keyPair = function() {
  var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
  var sk = new Uint8Array(crypto_box_SECRETKEYBYTES);
  crypto_box_keypair(pk, sk);
  return {publicKey: pk, secretKey: sk};
};

nacl.box.keyPair.fromSecretKey = function(secretKey) {
  checkArrayTypes(secretKey);
  if (secretKey.length !== crypto_box_SECRETKEYBYTES)
    throw new Error('bad secret key size');
  var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
  crypto_scalarmult_base(pk, secretKey);
  return {publicKey: pk, secretKey: new Uint8Array(secretKey)};
};

nacl.box.publicKeyLength = crypto_box_PUBLICKEYBYTES;
nacl.box.secretKeyLength = crypto_box_SECRETKEYBYTES;
nacl.box.sharedKeyLength = crypto_box_BEFORENMBYTES;
nacl.box.nonceLength = crypto_box_NONCEBYTES;
nacl.box.overheadLength = nacl.secretbox.overheadLength;

nacl.sign = function(msg, secretKey) {
  checkArrayTypes(msg, secretKey);
  if (secretKey.length !== crypto_sign_SECRETKEYBYTES)
    throw new Error('bad secret key size');
  var signedMsg = new Uint8Array(crypto_sign_BYTES+msg.length);
  crypto_sign(signedMsg, msg, msg.length, secretKey);
  return signedMsg;
};

nacl.sign.open = function(signedMsg, publicKey) {
  checkArrayTypes(signedMsg, publicKey);
  if (publicKey.length !== crypto_sign_PUBLICKEYBYTES)
    throw new Error('bad public key size');
  var tmp = new Uint8Array(signedMsg.length);
  var mlen = crypto_sign_open(tmp, signedMsg, signedMsg.length, publicKey);
  if (mlen < 0) return null;
  var m = new Uint8Array(mlen);
  for (var i = 0; i < m.length; i++) m[i] = tmp[i];
  return m;
};

nacl.sign.detached = function(msg, secretKey) {
  var signedMsg = nacl.sign(msg, secretKey);
  var sig = new Uint8Array(crypto_sign_BYTES);
  for (var i = 0; i < sig.length; i++) sig[i] = signedMsg[i];
  return sig;
};

nacl.sign.detached.verify = function(msg, sig, publicKey) {
  checkArrayTypes(msg, sig, publicKey);
  if (sig.length !== crypto_sign_BYTES)
    throw new Error('bad signature size');
  if (publicKey.length !== crypto_sign_PUBLICKEYBYTES)
    throw new Error('bad public key size');
  var sm = new Uint8Array(crypto_sign_BYTES + msg.length);
  var m = new Uint8Array(crypto_sign_BYTES + msg.length);
  var i;
  for (i = 0; i < crypto_sign_BYTES; i++) sm[i] = sig[i];
  for (i = 0; i < msg.length; i++) sm[i+crypto_sign_BYTES] = msg[i];
  return (crypto_sign_open(m, sm, sm.length, publicKey) >= 0);
};

nacl.sign.keyPair = function() {
  var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
  var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
  crypto_sign_keypair(pk, sk);
  return {publicKey: pk, secretKey: sk};
};

nacl.sign.keyPair.fromSecretKey = function(secretKey) {
  checkArrayTypes(secretKey);
  if (secretKey.length !== crypto_sign_SECRETKEYBYTES)
    throw new Error('bad secret key size');
  var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
  for (var i = 0; i < pk.length; i++) pk[i] = secretKey[32+i];
  return {publicKey: pk, secretKey: new Uint8Array(secretKey)};
};

nacl.sign.keyPair.fromSeed = function(seed) {
  checkArrayTypes(seed);
  if (seed.length !== crypto_sign_SEEDBYTES)
    throw new Error('bad seed size');
  var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
  var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
  for (var i = 0; i < 32; i++) sk[i] = seed[i];
  crypto_sign_keypair(pk, sk, true);
  return {publicKey: pk, secretKey: sk};
};

nacl.sign.publicKeyLength = crypto_sign_PUBLICKEYBYTES;
nacl.sign.secretKeyLength = crypto_sign_SECRETKEYBYTES;
nacl.sign.seedLength = crypto_sign_SEEDBYTES;
nacl.sign.signatureLength = crypto_sign_BYTES;

nacl.hash = function(msg) {
  checkArrayTypes(msg);
  var h = new Uint8Array(crypto_hash_BYTES);
  crypto_hash(h, msg, msg.length);
  return h;
};

nacl.hash.hashLength = crypto_hash_BYTES;

nacl.verify = function(x, y) {
  checkArrayTypes(x, y);
  // Zero length arguments are considered not equal.
  if (x.length === 0 || y.length === 0) return false;
  if (x.length !== y.length) return false;
  return (vn(x, 0, y, 0, x.length) === 0) ? true : false;
};

nacl.setPRNG = function(fn) {
  randombytes = fn;
};

(function() {
  // Initialize PRNG if environment provides CSPRNG.
  // If not, methods calling randombytes will throw.
  var crypto = typeof self !== 'undefined' ? (self.crypto || self.msCrypto) : null;
  if (crypto && crypto.getRandomValues) {
    // Browsers.
    var QUOTA = 65536;
    nacl.setPRNG(function(x, n) {
      var i, v = new Uint8Array(n);
      for (i = 0; i < n; i += QUOTA) {
        crypto.getRandomValues(v.subarray(i, i + Math.min(n - i, QUOTA)));
      }
      for (i = 0; i < n; i++) x[i] = v[i];
      cleanup(v);
    });
  } else if (true) {
    // Node.js.
    crypto = __webpack_require__(242);
    if (crypto && crypto.randomBytes) {
      nacl.setPRNG(function(x, n) {
        var i, v = crypto.randomBytes(n);
        for (i = 0; i < n; i++) x[i] = v[i];
        cleanup(v);
      });
    }
  }
})();

})(typeof module !== 'undefined' && module.exports ? module.exports : (self.nacl = self.nacl || {}));


/***/ }),
/* 242 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Joi", [], factory);
	else if(typeof exports === 'object')
		exports["Joi"] = factory();
	else
		root["Joi"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 32);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer, process) {

// Load modules

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Assert = __webpack_require__(17);
var Crypto = __webpack_require__(15);
var Path = __webpack_require__(37);
var Util = __webpack_require__(16);

var Escape = __webpack_require__(18);

// Declare internals

var internals = {};

// Clone object or array

exports.clone = function (obj, seen) {

    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) {

        return obj;
    }

    seen = seen || new Map();

    var lookup = seen.get(obj);
    if (lookup) {
        return lookup;
    }

    var newObj = void 0;
    var cloneDeep = false;

    if (!Array.isArray(obj)) {
        if (Buffer.isBuffer(obj)) {
            newObj = Buffer.from(obj);
        } else if (obj instanceof Date) {
            newObj = new Date(obj.getTime());
        } else if (obj instanceof RegExp) {
            newObj = new RegExp(obj);
        } else {
            var proto = Object.getPrototypeOf(obj);
            if (proto && proto.isImmutable) {

                newObj = obj;
            } else {
                newObj = Object.create(proto);
                cloneDeep = true;
            }
        }
    } else {
        newObj = [];
        cloneDeep = true;
    }

    seen.set(obj, newObj);

    if (cloneDeep) {
        var keys = Object.getOwnPropertyNames(obj);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            var descriptor = Object.getOwnPropertyDescriptor(obj, key);
            if (descriptor && (descriptor.get || descriptor.set)) {

                Object.defineProperty(newObj, key, descriptor);
            } else {
                newObj[key] = exports.clone(obj[key], seen);
            }
        }
    }

    return newObj;
};

// Merge all the properties of source into target, source wins in conflict, and by default null and undefined from source are applied

/*eslint-disable */
exports.merge = function (target, source, isNullOverride /* = true */, isMergeArrays /* = true */) {
    /*eslint-enable */

    exports.assert(target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object', 'Invalid target value: must be an object');
    exports.assert(source === null || source === undefined || (typeof source === 'undefined' ? 'undefined' : _typeof(source)) === 'object', 'Invalid source value: must be null, undefined, or an object');

    if (!source) {
        return target;
    }

    if (Array.isArray(source)) {
        exports.assert(Array.isArray(target), 'Cannot merge array onto an object');
        if (isMergeArrays === false) {
            // isMergeArrays defaults to true
            target.length = 0; // Must not change target assignment
        }

        for (var i = 0; i < source.length; ++i) {
            target.push(exports.clone(source[i]));
        }

        return target;
    }

    var keys = Object.keys(source);
    for (var _i = 0; _i < keys.length; ++_i) {
        var key = keys[_i];
        if (key === '__proto__') {
            continue;
        }

        var value = source[key];
        if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {

            if (!target[key] || _typeof(target[key]) !== 'object' || Array.isArray(target[key]) !== Array.isArray(value) || value instanceof Date || Buffer.isBuffer(value) || value instanceof RegExp) {

                target[key] = exports.clone(value);
            } else {
                exports.merge(target[key], value, isNullOverride, isMergeArrays);
            }
        } else {
            if (value !== null && value !== undefined) {
                // Explicit to preserve empty strings

                target[key] = value;
            } else if (isNullOverride !== false) {
                // Defaults to true
                target[key] = value;
            }
        }
    }

    return target;
};

// Apply options to a copy of the defaults

exports.applyToDefaults = function (defaults, options, isNullOverride) {

    exports.assert(defaults && (typeof defaults === 'undefined' ? 'undefined' : _typeof(defaults)) === 'object', 'Invalid defaults value: must be an object');
    exports.assert(!options || options === true || (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object', 'Invalid options value: must be true, falsy or an object');

    if (!options) {
        // If no options, return null
        return null;
    }

    var copy = exports.clone(defaults);

    if (options === true) {
        // If options is set to true, use defaults
        return copy;
    }

    return exports.merge(copy, options, isNullOverride === true, false);
};

// Clone an object except for the listed keys which are shallow copied

exports.cloneWithShallow = function (source, keys) {

    if (!source || (typeof source === 'undefined' ? 'undefined' : _typeof(source)) !== 'object') {

        return source;
    }

    var storage = internals.store(source, keys); // Move shallow copy items to storage
    var copy = exports.clone(source); // Deep copy the rest
    internals.restore(copy, source, storage); // Shallow copy the stored items and restore
    return copy;
};

internals.store = function (source, keys) {

    var storage = {};
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var value = exports.reach(source, key);
        if (value !== undefined) {
            storage[key] = value;
            internals.reachSet(source, key, undefined);
        }
    }

    return storage;
};

internals.restore = function (copy, source, storage) {

    var keys = Object.keys(storage);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        internals.reachSet(copy, key, storage[key]);
        internals.reachSet(source, key, storage[key]);
    }
};

internals.reachSet = function (obj, key, value) {

    var path = key.split('.');
    var ref = obj;
    for (var i = 0; i < path.length; ++i) {
        var segment = path[i];
        if (i + 1 === path.length) {
            ref[segment] = value;
        }

        ref = ref[segment];
    }
};

// Apply options to defaults except for the listed keys which are shallow copied from option without merging

exports.applyToDefaultsWithShallow = function (defaults, options, keys) {

    exports.assert(defaults && (typeof defaults === 'undefined' ? 'undefined' : _typeof(defaults)) === 'object', 'Invalid defaults value: must be an object');
    exports.assert(!options || options === true || (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object', 'Invalid options value: must be true, falsy or an object');
    exports.assert(keys && Array.isArray(keys), 'Invalid keys');

    if (!options) {
        // If no options, return null
        return null;
    }

    var copy = exports.cloneWithShallow(defaults, keys);

    if (options === true) {
        // If options is set to true, use defaults
        return copy;
    }

    var storage = internals.store(options, keys); // Move shallow copy items to storage
    exports.merge(copy, options, false, false); // Deep copy the rest
    internals.restore(copy, options, storage); // Shallow copy the stored items and restore
    return copy;
};

// Deep object or array comparison

exports.deepEqual = function (obj, ref, options, seen) {

    options = options || { prototype: true };

    var type = typeof obj === 'undefined' ? 'undefined' : _typeof(obj);

    if (type !== (typeof ref === 'undefined' ? 'undefined' : _typeof(ref))) {
        return false;
    }

    if (type !== 'object' || obj === null || ref === null) {

        if (obj === ref) {
            // Copied from Deep-eql, copyright(c) 2013 Jake Luer, jake@alogicalparadox.com, MIT Licensed, https://github.com/chaijs/deep-eql
            return obj !== 0 || 1 / obj === 1 / ref; // -0 / +0
        }

        return obj !== obj && ref !== ref; // NaN
    }

    seen = seen || [];
    if (seen.indexOf(obj) !== -1) {
        return true; // If previous comparison failed, it would have stopped execution
    }

    seen.push(obj);

    if (Array.isArray(obj)) {
        if (!Array.isArray(ref)) {
            return false;
        }

        if (!options.part && obj.length !== ref.length) {
            return false;
        }

        for (var i = 0; i < obj.length; ++i) {
            if (options.part) {
                var found = false;
                for (var j = 0; j < ref.length; ++j) {
                    if (exports.deepEqual(obj[i], ref[j], options)) {
                        found = true;
                        break;
                    }
                }

                return found;
            }

            if (!exports.deepEqual(obj[i], ref[i], options)) {
                return false;
            }
        }

        return true;
    }

    if (Buffer.isBuffer(obj)) {
        if (!Buffer.isBuffer(ref)) {
            return false;
        }

        if (obj.length !== ref.length) {
            return false;
        }

        for (var _i2 = 0; _i2 < obj.length; ++_i2) {
            if (obj[_i2] !== ref[_i2]) {
                return false;
            }
        }

        return true;
    }

    if (obj instanceof Date) {
        return ref instanceof Date && obj.getTime() === ref.getTime();
    }

    if (obj instanceof RegExp) {
        return ref instanceof RegExp && obj.toString() === ref.toString();
    }

    if (options.prototype) {
        if (Object.getPrototypeOf(obj) !== Object.getPrototypeOf(ref)) {
            return false;
        }
    }

    var keys = Object.getOwnPropertyNames(obj);

    if (!options.part && keys.length !== Object.getOwnPropertyNames(ref).length) {
        return false;
    }

    for (var _i3 = 0; _i3 < keys.length; ++_i3) {
        var key = keys[_i3];
        var descriptor = Object.getOwnPropertyDescriptor(obj, key);
        if (descriptor.get) {
            if (!exports.deepEqual(descriptor, Object.getOwnPropertyDescriptor(ref, key), options, seen)) {
                return false;
            }
        } else if (!exports.deepEqual(obj[key], ref[key], options, seen)) {
            return false;
        }
    }

    return true;
};

// Remove duplicate items from array

exports.unique = function (array, key) {

    var result = void 0;
    if (key) {
        result = [];
        var index = new Set();
        array.forEach(function (item) {

            var identifier = item[key];
            if (!index.has(identifier)) {
                index.add(identifier);
                result.push(item);
            }
        });
    } else {
        result = Array.from(new Set(array));
    }

    return result;
};

// Convert array into object

exports.mapToObject = function (array, key) {

    if (!array) {
        return null;
    }

    var obj = {};
    for (var i = 0; i < array.length; ++i) {
        if (key) {
            if (array[i][key]) {
                obj[array[i][key]] = true;
            }
        } else {
            obj[array[i]] = true;
        }
    }

    return obj;
};

// Find the common unique items in two arrays

exports.intersect = function (array1, array2, justFirst) {

    if (!array1 || !array2) {
        return [];
    }

    var common = [];
    var hash = Array.isArray(array1) ? exports.mapToObject(array1) : array1;
    var found = {};
    for (var i = 0; i < array2.length; ++i) {
        if (hash[array2[i]] && !found[array2[i]]) {
            if (justFirst) {
                return array2[i];
            }

            common.push(array2[i]);
            found[array2[i]] = true;
        }
    }

    return justFirst ? null : common;
};

// Test if the reference contains the values

exports.contain = function (ref, values, options) {

    /*
        string -> string(s)
        array -> item(s)
        object -> key(s)
        object -> object (key:value)
    */

    var valuePairs = null;
    if ((typeof ref === 'undefined' ? 'undefined' : _typeof(ref)) === 'object' && (typeof values === 'undefined' ? 'undefined' : _typeof(values)) === 'object' && !Array.isArray(ref) && !Array.isArray(values)) {

        valuePairs = values;
        values = Object.keys(values);
    } else {
        values = [].concat(values);
    }

    options = options || {}; // deep, once, only, part

    exports.assert(typeof ref === 'string' || (typeof ref === 'undefined' ? 'undefined' : _typeof(ref)) === 'object', 'Reference must be string or an object');
    exports.assert(values.length, 'Values array cannot be empty');

    var compare = void 0;
    var compareFlags = void 0;
    if (options.deep) {
        compare = exports.deepEqual;

        var hasOnly = options.hasOwnProperty('only');
        var hasPart = options.hasOwnProperty('part');

        compareFlags = {
            prototype: hasOnly ? options.only : hasPart ? !options.part : false,
            part: hasOnly ? !options.only : hasPart ? options.part : true
        };
    } else {
        compare = function compare(a, b) {
            return a === b;
        };
    }

    var misses = false;
    var matches = new Array(values.length);
    for (var i = 0; i < matches.length; ++i) {
        matches[i] = 0;
    }

    if (typeof ref === 'string') {
        var pattern = '(';
        for (var _i4 = 0; _i4 < values.length; ++_i4) {
            var value = values[_i4];
            exports.assert(typeof value === 'string', 'Cannot compare string reference to non-string value');
            pattern += (_i4 ? '|' : '') + exports.escapeRegex(value);
        }

        var regex = new RegExp(pattern + ')', 'g');
        var leftovers = ref.replace(regex, function ($0, $1) {

            var index = values.indexOf($1);
            ++matches[index];
            return ''; // Remove from string
        });

        misses = !!leftovers;
    } else if (Array.isArray(ref)) {
        for (var _i5 = 0; _i5 < ref.length; ++_i5) {
            var matched = false;
            for (var j = 0; j < values.length && matched === false; ++j) {
                matched = compare(values[j], ref[_i5], compareFlags) && j;
            }

            if (matched !== false) {
                ++matches[matched];
            } else {
                misses = true;
            }
        }
    } else {
        var keys = Object.getOwnPropertyNames(ref);
        for (var _i6 = 0; _i6 < keys.length; ++_i6) {
            var key = keys[_i6];
            var pos = values.indexOf(key);
            if (pos !== -1) {
                if (valuePairs && !compare(valuePairs[key], ref[key], compareFlags)) {

                    return false;
                }

                ++matches[pos];
            } else {
                misses = true;
            }
        }
    }

    var result = false;
    for (var _i7 = 0; _i7 < matches.length; ++_i7) {
        result = result || !!matches[_i7];
        if (options.once && matches[_i7] > 1 || !options.part && !matches[_i7]) {

            return false;
        }
    }

    if (options.only && misses) {

        return false;
    }

    return result;
};

// Flatten array

exports.flatten = function (array, target) {

    var result = target || [];

    for (var i = 0; i < array.length; ++i) {
        if (Array.isArray(array[i])) {
            exports.flatten(array[i], result);
        } else {
            result.push(array[i]);
        }
    }

    return result;
};

// Convert an object key chain string ('a.b.c') to reference (object[a][b][c])

exports.reach = function (obj, chain, options) {

    if (chain === false || chain === null || typeof chain === 'undefined') {

        return obj;
    }

    options = options || {};
    if (typeof options === 'string') {
        options = { separator: options };
    }

    var path = chain.split(options.separator || '.');
    var ref = obj;
    for (var i = 0; i < path.length; ++i) {
        var key = path[i];
        if (key[0] === '-' && Array.isArray(ref)) {
            key = key.slice(1, key.length);
            key = ref.length - key;
        }

        if (!ref || !(((typeof ref === 'undefined' ? 'undefined' : _typeof(ref)) === 'object' || typeof ref === 'function') && key in ref) || (typeof ref === 'undefined' ? 'undefined' : _typeof(ref)) !== 'object' && options.functions === false) {
            // Only object and function can have properties

            exports.assert(!options.strict || i + 1 === path.length, 'Missing segment', key, 'in reach path ', chain);
            exports.assert((typeof ref === 'undefined' ? 'undefined' : _typeof(ref)) === 'object' || options.functions === true || typeof ref !== 'function', 'Invalid segment', key, 'in reach path ', chain);
            ref = options.default;
            break;
        }

        ref = ref[key];
    }

    return ref;
};

exports.reachTemplate = function (obj, template, options) {

    return template.replace(/{([^}]+)}/g, function ($0, chain) {

        var value = exports.reach(obj, chain, options);
        return value === undefined || value === null ? '' : value;
    });
};

exports.formatStack = function (stack) {

    var trace = [];
    for (var i = 0; i < stack.length; ++i) {
        var item = stack[i];
        trace.push([item.getFileName(), item.getLineNumber(), item.getColumnNumber(), item.getFunctionName(), item.isConstructor()]);
    }

    return trace;
};

exports.formatTrace = function (trace) {

    var display = [];

    for (var i = 0; i < trace.length; ++i) {
        var row = trace[i];
        display.push((row[4] ? 'new ' : '') + row[3] + ' (' + row[0] + ':' + row[1] + ':' + row[2] + ')');
    }

    return display;
};

exports.callStack = function (slice) {

    // http://code.google.com/p/v8/wiki/JavaScriptStackTraceApi

    var v8 = Error.prepareStackTrace;
    Error.prepareStackTrace = function (_, stack) {

        return stack;
    };

    var capture = {};
    Error.captureStackTrace(capture, this);
    var stack = capture.stack;

    Error.prepareStackTrace = v8;

    var trace = exports.formatStack(stack);

    return trace.slice(1 + slice);
};

exports.displayStack = function (slice) {

    var trace = exports.callStack(slice === undefined ? 1 : slice + 1);

    return exports.formatTrace(trace);
};

exports.abortThrow = false;

exports.abort = function (message, hideStack) {

    if (process.env.NODE_ENV === 'test' || exports.abortThrow === true) {
        throw new Error(message || 'Unknown error');
    }

    var stack = '';
    if (!hideStack) {
        stack = exports.displayStack(1).join('\n\t');
    }
    console.log('ABORT: ' + message + '\n\t' + stack);
    process.exit(1);
};

exports.assert = function (condition) {

    if (condition) {
        return;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    if (args.length === 1 && args[0] instanceof Error) {
        throw args[0];
    }

    var msgs = args.filter(function (arg) {
        return arg !== '';
    }).map(function (arg) {

        return typeof arg === 'string' ? arg : arg instanceof Error ? arg.message : exports.stringify(arg);
    });

    throw new Assert.AssertionError({
        message: msgs.join(' ') || 'Unknown error',
        actual: false,
        expected: true,
        operator: '==',
        stackStartFunction: exports.assert
    });
};

exports.Bench = function () {

    this.ts = 0;
    this.reset();
};

exports.Bench.prototype.reset = function () {

    this.ts = exports.Bench.now();
};

exports.Bench.prototype.elapsed = function () {

    return exports.Bench.now() - this.ts;
};

exports.Bench.now = function () {

    var ts = process.hrtime();
    return ts[0] * 1e3 + ts[1] / 1e6;
};

// Escape string for Regex construction

exports.escapeRegex = function (string) {

    // Escape ^$.*+-?=!:|\/()[]{},
    return string.replace(/[\^\$\.\*\+\-\?\=\!\:\|\\\/\(\)\[\]\{\}\,]/g, '\\$&');
};

// Base64url (RFC 4648) encode

exports.base64urlEncode = function (value, encoding) {

    exports.assert(typeof value === 'string' || Buffer.isBuffer(value), 'value must be string or buffer');
    var buf = Buffer.isBuffer(value) ? value : Buffer.from(value, encoding || 'binary');
    return buf.toString('base64').replace(/\+/g, '-').replace(/\//g, '_').replace(/\=/g, '');
};

// Base64url (RFC 4648) decode

exports.base64urlDecode = function (value, encoding) {

    if (typeof value !== 'string') {

        throw new Error('Value not a string');
    }

    if (!/^[\w\-]*$/.test(value)) {

        throw new Error('Invalid character');
    }

    var buf = Buffer.from(value, 'base64');
    return encoding === 'buffer' ? buf : buf.toString(encoding || 'binary');
};

// Escape attribute value for use in HTTP header

exports.escapeHeaderAttribute = function (attribute) {

    // Allowed value characters: !#$%&'()*+,-./:;<=>?@[]^_`{|}~ and space, a-z, A-Z, 0-9, \, "

    exports.assert(/^[ \w\!#\$%&'\(\)\*\+,\-\.\/\:;<\=>\?@\[\]\^`\{\|\}~\"\\]*$/.test(attribute), 'Bad attribute value (' + attribute + ')');

    return attribute.replace(/\\/g, '\\\\').replace(/\"/g, '\\"'); // Escape quotes and slash
};

exports.escapeHtml = function (string) {

    return Escape.escapeHtml(string);
};

exports.escapeJavaScript = function (string) {

    return Escape.escapeJavaScript(string);
};

exports.escapeJson = function (string) {

    return Escape.escapeJson(string);
};

exports.once = function (method) {

    if (method._hoekOnce) {
        return method;
    }

    var once = false;
    var wrapped = function wrapped() {

        if (!once) {
            once = true;

            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            method.apply(null, args);
        }
    };

    wrapped._hoekOnce = true;
    return wrapped;
};

exports.isInteger = Number.isSafeInteger;

exports.ignore = function () {};

exports.inherits = Util.inherits;

exports.format = Util.format;

exports.transform = function (source, transform, options) {

    exports.assert(source === null || source === undefined || (typeof source === 'undefined' ? 'undefined' : _typeof(source)) === 'object' || Array.isArray(source), 'Invalid source object: must be null, undefined, an object, or an array');
    var separator = (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object' && options !== null ? options.separator || '.' : '.';

    if (Array.isArray(source)) {
        var results = [];
        for (var i = 0; i < source.length; ++i) {
            results.push(exports.transform(source[i], transform, options));
        }
        return results;
    }

    var result = {};
    var keys = Object.keys(transform);

    for (var _i8 = 0; _i8 < keys.length; ++_i8) {
        var key = keys[_i8];
        var path = key.split(separator);
        var sourcePath = transform[key];

        exports.assert(typeof sourcePath === 'string', 'All mappings must be "." delineated strings');

        var segment = void 0;
        var res = result;

        while (path.length > 1) {
            segment = path.shift();
            if (!res[segment]) {
                res[segment] = {};
            }
            res = res[segment];
        }
        segment = path.shift();
        res[segment] = exports.reach(source, sourcePath, options);
    }

    return result;
};

exports.uniqueFilename = function (path, extension) {

    if (extension) {
        extension = extension[0] !== '.' ? '.' + extension : extension;
    } else {
        extension = '';
    }

    path = Path.resolve(path);
    var name = [Date.now(), process.pid, Crypto.randomBytes(8).toString('hex')].join('-') + extension;
    return Path.join(path, name);
};

exports.stringify = function () {

    try {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        return JSON.stringify.apply(null, args);
    } catch (err) {
        return '[Cannot display object: ' + err.message + ']';
    }
};

exports.shallow = function (source) {

    var target = {};
    var keys = Object.keys(source);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        target[key] = source[key];
    }

    return target;
};

exports.wait = function (timeout) {

    return new Promise(function (resolve) {
        return setTimeout(resolve, timeout);
    });
};

exports.block = function () {

    return new Promise(exports.ignore);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer, __webpack_require__(7)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var Hoek = __webpack_require__(0);

// Declare internals

var internals = {};

exports.create = function (key, options) {

    Hoek.assert(typeof key === 'string', 'Invalid reference key:', key);

    var settings = Hoek.clone(options); // options can be reused and modified

    var ref = function ref(value, validationOptions) {

        return Hoek.reach(ref.isContext ? validationOptions.context : value, ref.key, settings);
    };

    ref.isContext = key[0] === (settings && settings.contextPrefix || '$');
    ref.key = ref.isContext ? key.slice(1) : key;
    ref.path = ref.key.split(settings && settings.separator || '.');
    ref.depth = ref.path.length;
    ref.root = ref.path[0];
    ref.isJoi = true;

    ref.toString = function () {

        return (ref.isContext ? 'context:' : 'ref:') + ref.key;
    };

    return ref;
};

exports.isRef = function (ref) {

    return typeof ref === 'function' && ref.isJoi;
};

exports.push = function (array, ref) {

    if (exports.isRef(ref) && !ref.isContext) {

        array.push(ref.root);
    }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Hoek = __webpack_require__(0);
var Settings = __webpack_require__(11);
var Ref = __webpack_require__(1);
var Errors = __webpack_require__(6);
var Alternatives = null; // Delay-loaded to prevent circular dependencies
var Cast = null;

// Declare internals

var internals = {
    Set: __webpack_require__(9)
};

internals.defaults = {
    abortEarly: true,
    convert: true,
    allowUnknown: false,
    skipFunctions: false,
    stripUnknown: false,
    language: {},
    presence: 'optional',
    strip: false,
    noDefaults: false,
    escapeHtml: false

    // context: null
};

module.exports = internals.Any = function () {
    function _class() {
        _classCallCheck(this, _class);

        Cast = Cast || __webpack_require__(4);

        this.isJoi = true;
        this._type = 'any';
        this._settings = null;
        this._valids = new internals.Set();
        this._invalids = new internals.Set();
        this._tests = [];
        this._refs = [];
        this._flags = {
            /*
             presence: 'optional',                   // optional, required, forbidden, ignore
             allowOnly: false,
             allowUnknown: undefined,
             default: undefined,
             forbidden: false,
             encoding: undefined,
             insensitive: false,
             trim: false,
             normalize: undefined,                   // NFC, NFD, NFKC, NFKD
             case: undefined,                        // upper, lower
             empty: undefined,
             func: false,
             raw: false
             */
        };

        this._description = null;
        this._unit = null;
        this._notes = [];
        this._tags = [];
        this._examples = [];
        this._meta = [];

        this._inner = {}; // Hash of arrays of immutable objects
    }

    _class.prototype._init = function _init() {

        return this;
    };

    _class.prototype.createError = function createError(type, context, state, options) {
        var flags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this._flags;


        return Errors.create(type, context, state, options, flags);
    };

    _class.prototype.createOverrideError = function createOverrideError(type, context, state, options, message, template) {

        return Errors.create(type, context, state, options, this._flags, message, template);
    };

    _class.prototype.checkOptions = function checkOptions(options) {

        var Schemas = __webpack_require__(21);
        var result = Schemas.options.validate(options);
        if (result.error) {
            throw new Error(result.error.details[0].message);
        }
    };

    _class.prototype.clone = function clone() {

        var obj = Object.create(Object.getPrototypeOf(this));

        obj.isJoi = true;
        obj._currentJoi = this._currentJoi;
        obj._type = this._type;
        obj._settings = this._settings;
        obj._baseType = this._baseType;
        obj._valids = this._valids.slice();
        obj._invalids = this._invalids.slice();
        obj._tests = this._tests.slice();
        obj._refs = this._refs.slice();
        obj._flags = Hoek.clone(this._flags);

        obj._description = this._description;
        obj._unit = this._unit;
        obj._notes = this._notes.slice();
        obj._tags = this._tags.slice();
        obj._examples = this._examples.slice();
        obj._meta = this._meta.slice();

        obj._inner = {};
        var inners = Object.keys(this._inner);
        for (var i = 0; i < inners.length; ++i) {
            var key = inners[i];
            obj._inner[key] = this._inner[key] ? this._inner[key].slice() : null;
        }

        return obj;
    };

    _class.prototype.concat = function concat(schema) {

        Hoek.assert(schema instanceof internals.Any, 'Invalid schema object');
        Hoek.assert(this._type === 'any' || schema._type === 'any' || schema._type === this._type, 'Cannot merge type', this._type, 'with another type:', schema._type);

        var obj = this.clone();

        if (this._type === 'any' && schema._type !== 'any') {

            // Reset values as if we were "this"
            var tmpObj = schema.clone();
            var keysToRestore = ['_settings', '_valids', '_invalids', '_tests', '_refs', '_flags', '_description', '_unit', '_notes', '_tags', '_examples', '_meta', '_inner'];

            for (var i = 0; i < keysToRestore.length; ++i) {
                tmpObj[keysToRestore[i]] = obj[keysToRestore[i]];
            }

            obj = tmpObj;
        }

        obj._settings = obj._settings ? Settings.concat(obj._settings, schema._settings) : schema._settings;
        obj._valids.merge(schema._valids, schema._invalids);
        obj._invalids.merge(schema._invalids, schema._valids);
        obj._tests = obj._tests.concat(schema._tests);
        obj._refs = obj._refs.concat(schema._refs);
        Hoek.merge(obj._flags, schema._flags);

        obj._description = schema._description || obj._description;
        obj._unit = schema._unit || obj._unit;
        obj._notes = obj._notes.concat(schema._notes);
        obj._tags = obj._tags.concat(schema._tags);
        obj._examples = obj._examples.concat(schema._examples);
        obj._meta = obj._meta.concat(schema._meta);

        var inners = Object.keys(schema._inner);
        var isObject = obj._type === 'object';
        for (var _i = 0; _i < inners.length; ++_i) {
            var key = inners[_i];
            var source = schema._inner[key];
            if (source) {
                var target = obj._inner[key];
                if (target) {
                    if (isObject && key === 'children') {
                        var keys = {};

                        for (var j = 0; j < target.length; ++j) {
                            keys[target[j].key] = j;
                        }

                        for (var _j = 0; _j < source.length; ++_j) {
                            var sourceKey = source[_j].key;
                            if (keys[sourceKey] >= 0) {
                                target[keys[sourceKey]] = {
                                    key: sourceKey,
                                    schema: target[keys[sourceKey]].schema.concat(source[_j].schema)
                                };
                            } else {
                                target.push(source[_j]);
                            }
                        }
                    } else {
                        obj._inner[key] = obj._inner[key].concat(source);
                    }
                } else {
                    obj._inner[key] = source.slice();
                }
            }
        }

        return obj;
    };

    _class.prototype._test = function _test(name, arg, func, options) {

        var obj = this.clone();
        obj._tests.push({ func: func, name: name, arg: arg, options: options });
        return obj;
    };

    _class.prototype.options = function options(_options) {

        Hoek.assert(!_options.context, 'Cannot override context');
        this.checkOptions(_options);

        var obj = this.clone();
        obj._settings = Settings.concat(obj._settings, _options);
        return obj;
    };

    _class.prototype.strict = function strict(isStrict) {

        var obj = this.clone();

        var convert = isStrict === undefined ? false : !isStrict;
        obj._settings = Settings.concat(obj._settings, { convert: convert });
        return obj;
    };

    _class.prototype.raw = function raw(isRaw) {

        var value = isRaw === undefined ? true : isRaw;

        if (this._flags.raw === value) {
            return this;
        }

        var obj = this.clone();
        obj._flags.raw = value;
        return obj;
    };

    _class.prototype.error = function error(err) {

        Hoek.assert(err && (err instanceof Error || typeof err === 'function'), 'Must provide a valid Error object or a function');

        var obj = this.clone();
        obj._flags.error = err;
        return obj;
    };

    _class.prototype.allow = function allow() {
        for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
            values[_key] = arguments[_key];
        }

        var obj = this.clone();
        values = Hoek.flatten(values);
        for (var i = 0; i < values.length; ++i) {
            var value = values[i];

            Hoek.assert(value !== undefined, 'Cannot call allow/valid/invalid with undefined');
            obj._invalids.remove(value);
            obj._valids.add(value, obj._refs);
        }
        return obj;
    };

    _class.prototype.valid = function valid() {

        var obj = this.allow.apply(this, arguments);
        obj._flags.allowOnly = true;
        return obj;
    };

    _class.prototype.invalid = function invalid() {
        for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            values[_key2] = arguments[_key2];
        }

        var obj = this.clone();
        values = Hoek.flatten(values);
        for (var i = 0; i < values.length; ++i) {
            var value = values[i];

            Hoek.assert(value !== undefined, 'Cannot call allow/valid/invalid with undefined');
            obj._valids.remove(value);
            obj._invalids.add(value, obj._refs);
        }

        return obj;
    };

    _class.prototype.required = function required() {

        if (this._flags.presence === 'required') {
            return this;
        }

        var obj = this.clone();
        obj._flags.presence = 'required';
        return obj;
    };

    _class.prototype.optional = function optional() {

        if (this._flags.presence === 'optional') {
            return this;
        }

        var obj = this.clone();
        obj._flags.presence = 'optional';
        return obj;
    };

    _class.prototype.forbidden = function forbidden() {

        if (this._flags.presence === 'forbidden') {
            return this;
        }

        var obj = this.clone();
        obj._flags.presence = 'forbidden';
        return obj;
    };

    _class.prototype.strip = function strip() {

        if (this._flags.strip) {
            return this;
        }

        var obj = this.clone();
        obj._flags.strip = true;
        return obj;
    };

    _class.prototype.applyFunctionToChildren = function applyFunctionToChildren(children, fn, args, root) {

        children = [].concat(children);

        if (children.length !== 1 || children[0] !== '') {
            root = root ? root + '.' : '';

            var extraChildren = (children[0] === '' ? children.slice(1) : children).map(function (child) {

                return root + child;
            });

            throw new Error('unknown key(s) ' + extraChildren.join(', '));
        }

        return this[fn].apply(this, args);
    };

    _class.prototype.default = function _default(value, description) {

        if (typeof value === 'function' && !Ref.isRef(value)) {

            if (!value.description && description) {

                value.description = description;
            }

            if (!this._flags.func) {
                Hoek.assert(typeof value.description === 'string' && value.description.length > 0, 'description must be provided when default value is a function');
            }
        }

        var obj = this.clone();
        obj._flags.default = value;
        Ref.push(obj._refs, value);
        return obj;
    };

    _class.prototype.empty = function empty(schema) {

        var obj = this.clone();
        if (schema === undefined) {
            delete obj._flags.empty;
        } else {
            obj._flags.empty = Cast.schema(this._currentJoi, schema);
        }
        return obj;
    };

    _class.prototype.when = function when(condition, options) {

        Hoek.assert(options && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object', 'Invalid options');
        Hoek.assert(options.then !== undefined || options.otherwise !== undefined, 'options must have at least one of "then" or "otherwise"');

        var then = options.hasOwnProperty('then') ? this.concat(Cast.schema(this._currentJoi, options.then)) : undefined;
        var otherwise = options.hasOwnProperty('otherwise') ? this.concat(Cast.schema(this._currentJoi, options.otherwise)) : undefined;

        Alternatives = Alternatives || __webpack_require__(10);

        var alternativeOptions = { then: then, otherwise: otherwise };
        if (Object.prototype.hasOwnProperty.call(options, 'is')) {
            alternativeOptions.is = options.is;
        }
        var obj = Alternatives.when(condition, alternativeOptions);
        obj._flags.presence = 'ignore';
        obj._baseType = this;

        return obj;
    };

    _class.prototype.description = function description(desc) {

        Hoek.assert(desc && typeof desc === 'string', 'Description must be a non-empty string');

        var obj = this.clone();
        obj._description = desc;
        return obj;
    };

    _class.prototype.notes = function notes(_notes) {

        Hoek.assert(_notes && (typeof _notes === 'string' || Array.isArray(_notes)), 'Notes must be a non-empty string or array');

        var obj = this.clone();
        obj._notes = obj._notes.concat(_notes);
        return obj;
    };

    _class.prototype.tags = function tags(_tags) {

        Hoek.assert(_tags && (typeof _tags === 'string' || Array.isArray(_tags)), 'Tags must be a non-empty string or array');

        var obj = this.clone();
        obj._tags = obj._tags.concat(_tags);
        return obj;
    };

    _class.prototype.meta = function meta(_meta) {

        Hoek.assert(_meta !== undefined, 'Meta cannot be undefined');

        var obj = this.clone();
        obj._meta = obj._meta.concat(_meta);
        return obj;
    };

    _class.prototype.example = function example() {

        Hoek.assert(arguments.length === 1, 'Missing example');
        var value = arguments.length <= 0 ? undefined : arguments[0];

        var obj = this.clone();
        obj._examples.push(value);
        return obj;
    };

    _class.prototype.unit = function unit(name) {

        Hoek.assert(name && typeof name === 'string', 'Unit name must be a non-empty string');

        var obj = this.clone();
        obj._unit = name;
        return obj;
    };

    _class.prototype._prepareEmptyValue = function _prepareEmptyValue(value) {

        if (typeof value === 'string' && this._flags.trim) {
            return value.trim();
        }

        return value;
    };

    _class.prototype._validate = function _validate(value, state, options, reference) {
        var _this = this;

        var originalValue = value;

        // Setup state and settings

        state = state || { key: '', path: [], parent: null, reference: reference };

        if (this._settings) {
            options = Settings.concat(options, this._settings);
        }

        var errors = [];
        var finish = function finish() {

            var finalValue = void 0;

            if (value !== undefined) {
                finalValue = _this._flags.raw ? originalValue : value;
            } else if (options.noDefaults) {
                finalValue = value;
            } else if (Ref.isRef(_this._flags.default)) {
                finalValue = _this._flags.default(state.parent, options);
            } else if (typeof _this._flags.default === 'function' && !(_this._flags.func && !_this._flags.default.description)) {

                var args = void 0;

                if (state.parent !== null && _this._flags.default.length > 0) {

                    args = [Hoek.clone(state.parent), options];
                }

                var defaultValue = internals._try(_this._flags.default, args);
                finalValue = defaultValue.value;
                if (defaultValue.error) {
                    errors.push(_this.createError('any.default', { error: defaultValue.error }, state, options));
                }
            } else {
                finalValue = Hoek.clone(_this._flags.default);
            }

            if (errors.length && typeof _this._flags.error === 'function') {
                var change = _this._flags.error.call(_this, errors);

                if (typeof change === 'string') {
                    errors = [_this.createOverrideError('override', { reason: errors }, state, options, change)];
                } else {
                    errors = [].concat(change).map(function (err) {

                        return err instanceof Error ? err : _this.createOverrideError(err.type || 'override', err.context, state, options, err.message, err.template);
                    });
                }
            }

            return {
                value: _this._flags.strip ? undefined : finalValue,
                finalValue: finalValue,
                errors: errors.length ? errors : null
            };
        };

        if (this._coerce) {
            var coerced = this._coerce.call(this, value, state, options);
            if (coerced.errors) {
                value = coerced.value;
                errors = errors.concat(coerced.errors);
                return finish(); // Coerced error always aborts early
            }

            value = coerced.value;
        }

        if (this._flags.empty && !this._flags.empty._validate(this._prepareEmptyValue(value), null, internals.defaults).errors) {
            value = undefined;
        }

        // Check presence requirements

        var presence = this._flags.presence || options.presence;
        if (presence === 'optional') {
            if (value === undefined) {
                var isDeepDefault = this._flags.hasOwnProperty('default') && this._flags.default === undefined;
                if (isDeepDefault && this._type === 'object') {
                    value = {};
                } else {
                    return finish();
                }
            }
        } else if (presence === 'required' && value === undefined) {

            errors.push(this.createError('any.required', null, state, options));
            return finish();
        } else if (presence === 'forbidden') {
            if (value === undefined) {
                return finish();
            }

            errors.push(this.createError('any.unknown', null, state, options));
            return finish();
        }

        // Check allowed and denied values using the original value

        if (this._valids.has(value, state, options, this._flags.insensitive)) {
            return finish();
        }

        if (this._invalids.has(value, state, options, this._flags.insensitive)) {
            errors.push(this.createError(value === '' ? 'any.empty' : 'any.invalid', { value: value, invalids: this._invalids.values({ stripUndefined: true }) }, state, options));
            if (options.abortEarly || value === undefined) {
                // No reason to keep validating missing value

                return finish();
            }
        }

        // Convert value and validate type

        if (this._base) {
            var base = this._base.call(this, value, state, options);
            if (base.errors) {
                value = base.value;
                errors = errors.concat(base.errors);
                return finish(); // Base error always aborts early
            }

            if (base.value !== value) {
                value = base.value;

                // Check allowed and denied values using the converted value

                if (this._valids.has(value, state, options, this._flags.insensitive)) {
                    return finish();
                }

                if (this._invalids.has(value, state, options, this._flags.insensitive)) {
                    errors.push(this.createError(value === '' ? 'any.empty' : 'any.invalid', { value: value, invalids: this._invalids.values({ stripUndefined: true }) }, state, options));
                    if (options.abortEarly) {
                        return finish();
                    }
                }
            }
        }

        // Required values did not match

        if (this._flags.allowOnly) {
            errors.push(this.createError('any.allowOnly', { value: value, valids: this._valids.values({ stripUndefined: true }) }, state, options));
            if (options.abortEarly) {
                return finish();
            }
        }

        // Validate tests

        for (var i = 0; i < this._tests.length; ++i) {
            var test = this._tests[i];
            var ret = test.func.call(this, value, state, options);
            if (ret instanceof Errors.Err) {
                errors.push(ret);
                if (options.abortEarly) {
                    return finish();
                }
            } else {
                value = ret;
            }
        }

        return finish();
    };

    _class.prototype._validateWithOptions = function _validateWithOptions(value, options, callback) {

        if (options) {
            this.checkOptions(options);
        }

        var settings = Settings.concat(internals.defaults, options);
        var result = this._validate(value, null, settings);
        var errors = Errors.process(result.errors, value);

        if (callback) {
            return callback(errors, result.value);
        }

        return {
            error: errors,
            value: result.value,
            then: function then(resolve, reject) {

                if (errors) {
                    return Promise.reject(errors).catch(reject);
                }

                return Promise.resolve(result.value).then(resolve);
            },
            catch: function _catch(reject) {

                if (errors) {
                    return Promise.reject(errors).catch(reject);
                }

                return Promise.resolve(result.value);
            }
        };
    };

    _class.prototype.validate = function validate(value, options, callback) {

        if (typeof options === 'function') {
            return this._validateWithOptions(value, null, options);
        }

        return this._validateWithOptions(value, options, callback);
    };

    _class.prototype.describe = function describe() {
        var _this2 = this;

        var description = {
            type: this._type
        };

        var flags = Object.keys(this._flags);
        if (flags.length) {
            if (['empty', 'default', 'lazy', 'label'].some(function (flag) {
                return _this2._flags.hasOwnProperty(flag);
            })) {
                description.flags = {};
                for (var i = 0; i < flags.length; ++i) {
                    var flag = flags[i];
                    if (flag === 'empty') {
                        description.flags[flag] = this._flags[flag].describe();
                    } else if (flag === 'default') {
                        if (Ref.isRef(this._flags[flag])) {
                            description.flags[flag] = this._flags[flag].toString();
                        } else if (typeof this._flags[flag] === 'function') {
                            description.flags[flag] = {
                                description: this._flags[flag].description,
                                function: this._flags[flag]
                            };
                        } else {
                            description.flags[flag] = this._flags[flag];
                        }
                    } else if (flag === 'lazy' || flag === 'label') {
                        // We don't want it in the description
                    } else {
                        description.flags[flag] = this._flags[flag];
                    }
                }
            } else {
                description.flags = this._flags;
            }
        }

        if (this._settings) {
            description.options = Hoek.clone(this._settings);
        }

        if (this._baseType) {
            description.base = this._baseType.describe();
        }

        if (this._description) {
            description.description = this._description;
        }

        if (this._notes.length) {
            description.notes = this._notes;
        }

        if (this._tags.length) {
            description.tags = this._tags;
        }

        if (this._meta.length) {
            description.meta = this._meta;
        }

        if (this._examples.length) {
            description.examples = this._examples;
        }

        if (this._unit) {
            description.unit = this._unit;
        }

        var valids = this._valids.values();
        if (valids.length) {
            description.valids = valids.map(function (v) {

                return Ref.isRef(v) ? v.toString() : v;
            });
        }

        var invalids = this._invalids.values();
        if (invalids.length) {
            description.invalids = invalids.map(function (v) {

                return Ref.isRef(v) ? v.toString() : v;
            });
        }

        description.rules = [];

        for (var _i2 = 0; _i2 < this._tests.length; ++_i2) {
            var validator = this._tests[_i2];
            var item = { name: validator.name };

            if (validator.arg !== void 0) {
                item.arg = Ref.isRef(validator.arg) ? validator.arg.toString() : validator.arg;
            }

            var options = validator.options;
            if (options) {
                if (options.hasRef) {
                    item.arg = {};
                    var keys = Object.keys(validator.arg);
                    for (var j = 0; j < keys.length; ++j) {
                        var key = keys[j];
                        var value = validator.arg[key];
                        item.arg[key] = Ref.isRef(value) ? value.toString() : value;
                    }
                }

                if (typeof options.description === 'string') {
                    item.description = options.description;
                } else if (typeof options.description === 'function') {
                    item.description = options.description(item.arg);
                }
            }

            description.rules.push(item);
        }

        if (!description.rules.length) {
            delete description.rules;
        }

        var label = this._getLabel();
        if (label) {
            description.label = label;
        }

        return description;
    };

    _class.prototype.label = function label(name) {

        Hoek.assert(name && typeof name === 'string', 'Label name must be a non-empty string');

        var obj = this.clone();
        obj._flags.label = name;
        return obj;
    };

    _class.prototype._getLabel = function _getLabel(def) {

        return this._flags.label || def;
    };

    _createClass(_class, [{
        key: 'schemaType',
        get: function get() {

            return this._type;
        }
    }]);

    return _class;
}();

internals.Any.prototype.isImmutable = true; // Prevents Hoek from deep cloning schema objects

// Aliases

internals.Any.prototype.only = internals.Any.prototype.equal = internals.Any.prototype.valid;
internals.Any.prototype.disallow = internals.Any.prototype.not = internals.Any.prototype.invalid;
internals.Any.prototype.exist = internals.Any.prototype.required;

internals._try = function (fn, args) {

    var err = void 0;
    var result = void 0;

    try {
        result = fn.apply(null, args);
    } catch (e) {
        err = e;
    }

    return {
        value: result,
        error: err
    };
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(33)
var ieee754 = __webpack_require__(34)
var isArray = __webpack_require__(35)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Hoek = __webpack_require__(0);
var Ref = __webpack_require__(1);

// Type modules are delay-loaded to prevent circular dependencies


// Declare internals

var internals = {};

exports.schema = function (Joi, config) {

    if (config !== undefined && config !== null && (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object') {

        if (config.isJoi) {
            return config;
        }

        if (Array.isArray(config)) {
            return Joi.alternatives().try(config);
        }

        if (config instanceof RegExp) {
            return Joi.string().regex(config);
        }

        if (config instanceof Date) {
            return Joi.date().valid(config);
        }

        return Joi.object().keys(config);
    }

    if (typeof config === 'string') {
        return Joi.string().valid(config);
    }

    if (typeof config === 'number') {
        return Joi.number().valid(config);
    }

    if (typeof config === 'boolean') {
        return Joi.boolean().valid(config);
    }

    if (Ref.isRef(config)) {
        return Joi.valid(config);
    }

    Hoek.assert(config === null, 'Invalid schema content:', config);

    return Joi.valid(null);
};

exports.ref = function (id) {

    return Ref.isRef(id) ? id : Ref.create(id);
};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Hoek = __webpack_require__(0);
var Language = __webpack_require__(20);

// Declare internals

var internals = {
    annotations: Symbol('joi-annotations')
};

internals.stringify = function (value, wrapArrays) {

    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

    if (value === null) {
        return 'null';
    }

    if (type === 'string') {
        return value;
    }

    if (value instanceof exports.Err || type === 'function' || type === 'symbol') {
        return value.toString();
    }

    if (type === 'object') {
        if (Array.isArray(value)) {
            var partial = '';

            for (var i = 0; i < value.length; ++i) {
                partial = partial + (partial.length ? ', ' : '') + internals.stringify(value[i], wrapArrays);
            }

            return wrapArrays ? '[' + partial + ']' : partial;
        }

        return value.toString();
    }

    return JSON.stringify(value);
};

exports.Err = function () {
    function _class(type, context, state, options, flags, message, template) {
        _classCallCheck(this, _class);

        this.isJoi = true;
        this.type = type;
        this.context = context || {};
        this.context.key = state.path[state.path.length - 1];
        this.context.label = state.key;
        this.path = state.path;
        this.options = options;
        this.flags = flags;
        this.message = message;
        this.template = template;

        var localized = this.options.language;

        if (this.flags.label) {
            this.context.label = this.flags.label;
        } else if (localized && ( // language can be null for arrays exclusion check
        this.context.label === '' || this.context.label === null)) {
            this.context.label = localized.root || Language.errors.root;
        }
    }

    _class.prototype.toString = function toString() {
        var _this = this;

        if (this.message) {
            return this.message;
        }

        var format = void 0;

        if (this.template) {
            format = this.template;
        }

        var localized = this.options.language;

        format = format || Hoek.reach(localized, this.type) || Hoek.reach(Language.errors, this.type);

        if (format === undefined) {
            return 'Error code "' + this.type + '" is not defined, your custom type is missing the correct language definition';
        }

        var wrapArrays = Hoek.reach(localized, 'messages.wrapArrays');
        if (typeof wrapArrays !== 'boolean') {
            wrapArrays = Language.errors.messages.wrapArrays;
        }

        if (format === null) {
            var childrenString = internals.stringify(this.context.reason, wrapArrays);
            if (wrapArrays) {
                return childrenString.slice(1, -1);
            }
            return childrenString;
        }

        var hasKey = /\{\{\!?label\}\}/.test(format);
        var skipKey = format.length > 2 && format[0] === '!' && format[1] === '!';

        if (skipKey) {
            format = format.slice(2);
        }

        if (!hasKey && !skipKey) {
            var localizedKey = Hoek.reach(localized, 'key');
            if (typeof localizedKey === 'string') {
                format = localizedKey + format;
            } else {
                format = Hoek.reach(Language.errors, 'key') + format;
            }
        }

        return format.replace(/\{\{(\!?)([^}]+)\}\}/g, function ($0, isSecure, name) {

            var value = Hoek.reach(_this.context, name);
            var normalized = internals.stringify(value, wrapArrays);
            return isSecure && _this.options.escapeHtml ? Hoek.escapeHtml(normalized) : normalized;
        });
    };

    return _class;
}();

exports.create = function (type, context, state, options, flags, message, template) {

    return new exports.Err(type, context, state, options, flags, message, template);
};

exports.process = function (errors, object) {

    if (!errors || !errors.length) {
        return null;
    }

    // Construct error

    var message = '';
    var details = [];

    var processErrors = function processErrors(localErrors, parent) {

        for (var i = 0; i < localErrors.length; ++i) {
            var item = localErrors[i];

            if (item instanceof Error) {
                return item;
            }

            if (item.flags.error && typeof item.flags.error !== 'function') {
                return item.flags.error;
            }

            var itemMessage = void 0;
            if (parent === undefined) {
                itemMessage = item.toString();
                message = message + (message ? '. ' : '') + itemMessage;
            }

            // Do not push intermediate errors, we're only interested in leafs

            if (item.context.reason && item.context.reason.length) {
                var _override = processErrors(item.context.reason, item.path);
                if (_override) {
                    return _override;
                }
            } else {
                details.push({
                    message: itemMessage || item.toString(),
                    path: item.path,
                    type: item.type,
                    context: item.context
                });
            }
        }
    };

    var override = processErrors(errors);
    if (override) {
        return override;
    }

    var error = new Error(message);
    error.isJoi = true;
    error.name = 'ValidationError';
    error.details = details;
    error._object = object;
    error.annotate = internals.annotate;
    return error;
};

// Inspired by json-stringify-safe
internals.safeStringify = function (obj, spaces) {

    return JSON.stringify(obj, internals.serializer(), spaces);
};

internals.serializer = function () {

    var keys = [];
    var stack = [];

    var cycleReplacer = function cycleReplacer(key, value) {

        if (stack[0] === value) {
            return '[Circular ~]';
        }

        return '[Circular ~.' + keys.slice(0, stack.indexOf(value)).join('.') + ']';
    };

    return function (key, value) {

        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            if (~thisPos) {
                stack.length = thisPos + 1;
                keys.length = thisPos + 1;
                keys[thisPos] = key;
            } else {
                stack.push(this);
                keys.push(key);
            }

            if (~stack.indexOf(value)) {
                value = cycleReplacer.call(this, key, value);
            }
        } else {
            stack.push(value);
        }

        if (value) {
            var annotations = value[internals.annotations];
            if (annotations) {
                if (Array.isArray(value)) {
                    var annotated = [];

                    for (var i = 0; i < value.length; ++i) {
                        if (annotations.errors[i]) {
                            annotated.push('_$idx$_' + annotations.errors[i].sort().join(', ') + '_$end$_');
                        }
                        annotated.push(value[i]);
                    }

                    value = annotated;
                } else {
                    var errorKeys = Object.keys(annotations.errors);
                    for (var _i = 0; _i < errorKeys.length; ++_i) {
                        var errorKey = errorKeys[_i];
                        value[errorKey + '_$key$_' + annotations.errors[errorKey].sort().join(', ') + '_$end$_'] = value[errorKey];
                        value[errorKey] = undefined;
                    }

                    var missingKeys = Object.keys(annotations.missing);
                    for (var _i2 = 0; _i2 < missingKeys.length; ++_i2) {
                        var missingKey = missingKeys[_i2];
                        value['_$miss$_' + missingKey + '|' + annotations.missing[missingKey] + '_$end$_'] = '__missing__';
                    }
                }

                return value;
            }
        }

        if (value === Infinity || value === -Infinity || Number.isNaN(value) || typeof value === 'function' || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'symbol') {
            return '[' + value.toString() + ']';
        }

        return value;
    };
};

internals.annotate = function (stripColorCodes) {

    var redFgEscape = stripColorCodes ? '' : '\x1B[31m';
    var redBgEscape = stripColorCodes ? '' : '\x1B[41m';
    var endColor = stripColorCodes ? '' : '\x1B[0m';

    if (_typeof(this._object) !== 'object') {
        return this.details[0].message;
    }

    var obj = Hoek.clone(this._object || {});

    for (var i = this.details.length - 1; i >= 0; --i) {
        // Reverse order to process deepest child first
        var pos = i + 1;
        var error = this.details[i];
        var path = error.path;
        var ref = obj;
        for (var j = 0;; ++j) {
            var seg = path[j];

            if (ref.isImmutable) {
                ref = ref.clone(); // joi schemas are not cloned by hoek, we have to take this extra step
            }

            if (j + 1 < path.length && ref[seg] && typeof ref[seg] !== 'string') {

                ref = ref[seg];
            } else {
                var refAnnotations = ref[internals.annotations] = ref[internals.annotations] || { errors: {}, missing: {} };
                var value = ref[seg];
                var cacheKey = seg || error.context.label;

                if (value !== undefined) {
                    refAnnotations.errors[cacheKey] = refAnnotations.errors[cacheKey] || [];
                    refAnnotations.errors[cacheKey].push(pos);
                } else {
                    refAnnotations.missing[cacheKey] = pos;
                }

                break;
            }
        }
    }

    var replacers = {
        key: /_\$key\$_([, \d]+)_\$end\$_\"/g,
        missing: /\"_\$miss\$_([^\|]+)\|(\d+)_\$end\$_\"\: \"__missing__\"/g,
        arrayIndex: /\s*\"_\$idx\$_([, \d]+)_\$end\$_\",?\n(.*)/g,
        specials: /"\[(NaN|Symbol.*|-?Infinity|function.*|\(.*)\]"/g
    };

    var message = internals.safeStringify(obj, 2).replace(replacers.key, function ($0, $1) {
        return '" ' + redFgEscape + '[' + $1 + ']' + endColor;
    }).replace(replacers.missing, function ($0, $1, $2) {
        return redBgEscape + '"' + $1 + '"' + endColor + redFgEscape + ' [' + $2 + ']: -- missing --' + endColor;
    }).replace(replacers.arrayIndex, function ($0, $1, $2) {
        return '\n' + $2 + ' ' + redFgEscape + '[' + $1 + ']' + endColor;
    }).replace(replacers.specials, function ($0, $1) {
        return $1;
    });

    message = message + '\n' + redFgEscape;

    for (var _i3 = 0; _i3 < this.details.length; ++_i3) {
        var _pos = _i3 + 1;
        message = message + '\n[' + _pos + '] ' + this.details[_i3].message;
    }

    message = message + endColor;

    return message;
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Hoek = __webpack_require__(0);
var Any = __webpack_require__(2);
var Cast = __webpack_require__(4);
var Errors = __webpack_require__(6);
var Lazy = __webpack_require__(26);
var Ref = __webpack_require__(1);
var Settings = __webpack_require__(11);

// Declare internals

var internals = {
    alternatives: __webpack_require__(10),
    array: __webpack_require__(22),
    boolean: __webpack_require__(24),
    binary: __webpack_require__(23),
    date: __webpack_require__(12),
    func: __webpack_require__(25),
    number: __webpack_require__(27),
    object: __webpack_require__(13),
    string: __webpack_require__(28)
};

internals.callWithDefaults = function (schema, args) {
    var _schema;

    Hoek.assert(this, 'Must be invoked on a Joi instance.');

    if (this._defaults) {
        schema = this._defaults(schema);
    }

    schema._currentJoi = this;

    return (_schema = schema)._init.apply(_schema, _toConsumableArray(args));
};

internals.root = function () {

    var any = new Any();

    var root = any.clone();
    Any.prototype._currentJoi = root;
    root._currentJoi = root;

    root.any = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        Hoek.assert(args.length === 0, 'Joi.any() does not allow arguments.');

        return internals.callWithDefaults.call(this, any, args);
    };

    root.alternatives = root.alt = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return internals.callWithDefaults.call(this, internals.alternatives, args);
    };

    root.array = function () {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        Hoek.assert(args.length === 0, 'Joi.array() does not allow arguments.');

        return internals.callWithDefaults.call(this, internals.array, args);
    };

    root.boolean = root.bool = function () {
        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
        }

        Hoek.assert(args.length === 0, 'Joi.boolean() does not allow arguments.');

        return internals.callWithDefaults.call(this, internals.boolean, args);
    };

    root.binary = function () {
        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
        }

        Hoek.assert(args.length === 0, 'Joi.binary() does not allow arguments.');

        return internals.callWithDefaults.call(this, internals.binary, args);
    };

    root.date = function () {
        for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            args[_key6] = arguments[_key6];
        }

        Hoek.assert(args.length === 0, 'Joi.date() does not allow arguments.');

        return internals.callWithDefaults.call(this, internals.date, args);
    };

    root.func = function () {
        for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            args[_key7] = arguments[_key7];
        }

        Hoek.assert(args.length === 0, 'Joi.func() does not allow arguments.');

        return internals.callWithDefaults.call(this, internals.func, args);
    };

    root.number = function () {
        for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
            args[_key8] = arguments[_key8];
        }

        Hoek.assert(args.length === 0, 'Joi.number() does not allow arguments.');

        return internals.callWithDefaults.call(this, internals.number, args);
    };

    root.object = function () {
        for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
            args[_key9] = arguments[_key9];
        }

        return internals.callWithDefaults.call(this, internals.object, args);
    };

    root.string = function () {
        for (var _len10 = arguments.length, args = Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
            args[_key10] = arguments[_key10];
        }

        Hoek.assert(args.length === 0, 'Joi.string() does not allow arguments.');

        return internals.callWithDefaults.call(this, internals.string, args);
    };

    root.ref = function () {

        return Ref.create.apply(Ref, arguments);
    };

    root.isRef = function (ref) {

        return Ref.isRef(ref);
    };

    root.validate = function (value) /*, [schema], [options], callback */{
        var _ref;

        var last = (_ref = (arguments.length <= 1 ? 0 : arguments.length - 1) - 1 + 1, arguments.length <= _ref ? undefined : arguments[_ref]);
        var callback = typeof last === 'function' ? last : null;

        var count = (arguments.length <= 1 ? 0 : arguments.length - 1) - (callback ? 1 : 0);
        if (count === 0) {
            return any.validate(value, callback);
        }

        var options = count === 2 ? arguments.length <= 2 ? undefined : arguments[2] : {};
        var schema = root.compile(arguments.length <= 1 ? undefined : arguments[1]);

        return schema._validateWithOptions(value, options, callback);
    };

    root.describe = function () {

        var schema = arguments.length ? root.compile(arguments.length <= 0 ? undefined : arguments[0]) : any;
        return schema.describe();
    };

    root.compile = function (schema) {

        try {
            return Cast.schema(this, schema);
        } catch (err) {
            if (err.hasOwnProperty('path')) {
                err.message = err.message + '(' + err.path + ')';
            }
            throw err;
        }
    };

    root.assert = function (value, schema, message) {

        root.attempt(value, schema, message);
    };

    root.attempt = function (value, schema, message) {

        var result = root.validate(value, schema);
        var error = result.error;
        if (error) {
            if (!message) {
                if (typeof error.annotate === 'function') {
                    error.message = error.annotate();
                }
                throw error;
            }

            if (!(message instanceof Error)) {
                if (typeof error.annotate === 'function') {
                    error.message = message + ' ' + error.annotate();
                }
                throw error;
            }

            throw message;
        }

        return result.value;
    };

    root.reach = function (schema, path) {

        Hoek.assert(schema && schema instanceof Any, 'you must provide a joi schema');
        Hoek.assert(Array.isArray(path) || typeof path === 'string', 'path must be a string or an array of strings');

        var reach = function reach(sourceSchema, schemaPath) {

            if (!schemaPath.length) {
                return sourceSchema;
            }

            var children = sourceSchema._inner.children;
            if (!children) {
                return;
            }

            var key = schemaPath.shift();
            for (var i = 0; i < children.length; ++i) {
                var child = children[i];
                if (child.key === key) {
                    return reach(child.schema, schemaPath);
                }
            }
        };

        var schemaPath = typeof path === 'string' ? path ? path.split('.') : [] : path.slice();

        return reach(schema, schemaPath);
    };

    root.lazy = function (fn) {

        return Lazy.set(fn);
    };

    root.defaults = function (fn) {
        var _this = this;

        Hoek.assert(typeof fn === 'function', 'Defaults must be a function');

        var joi = Object.create(this.any());
        joi = fn(joi);

        Hoek.assert(joi && joi instanceof this.constructor, 'defaults() must return a schema');

        _extends(joi, this, joi.clone()); // Re-add the types from `this` but also keep the settings from joi's potential new defaults

        joi._defaults = function (schema) {

            if (_this._defaults) {
                schema = _this._defaults(schema);
                Hoek.assert(schema instanceof _this.constructor, 'defaults() must return a schema');
            }

            schema = fn(schema);
            Hoek.assert(schema instanceof _this.constructor, 'defaults() must return a schema');
            return schema;
        };

        return joi;
    };

    root.extend = function () {
        var _this2 = this;

        for (var _len11 = arguments.length, args = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
            args[_key11] = arguments[_key11];
        }

        var extensions = Hoek.flatten(args);
        Hoek.assert(extensions.length > 0, 'You need to provide at least one extension');

        this.assert(extensions, root.extensionsSchema);

        var joi = Object.create(this.any());
        _extends(joi, this);

        var _loop = function _loop(i) {
            var extension = extensions[i];

            if (typeof extension === 'function') {
                extension = extension(joi);
            }

            _this2.assert(extension, root.extensionSchema);

            var base = (extension.base || _this2.any()).clone(); // Cloning because we're going to override language afterwards
            var ctor = base.constructor;
            var type = function (_ctor) {
                _inherits(type, _ctor);

                // eslint-disable-line no-loop-func

                function type() {
                    _classCallCheck(this, type);

                    var _this3 = _possibleConstructorReturn(this, _ctor.call(this));

                    if (extension.base) {
                        _extends(_this3, base);
                    }

                    _this3._type = extension.name;

                    if (extension.language) {
                        _this3._settings = Settings.concat(_this3._settings, {
                            language: _defineProperty({}, extension.name, extension.language)
                        });
                    }
                    return _this3;
                }

                return type;
            }(ctor);

            if (extension.coerce) {
                type.prototype._coerce = function (value, state, options) {

                    if (ctor.prototype._coerce) {
                        var baseRet = ctor.prototype._coerce.call(this, value, state, options);

                        if (baseRet.errors) {
                            return baseRet;
                        }

                        value = baseRet.value;
                    }

                    var ret = extension.coerce.call(this, value, state, options);
                    if (ret instanceof Errors.Err) {
                        return { value: value, errors: ret };
                    }

                    return { value: ret };
                };
            }
            if (extension.pre) {
                type.prototype._base = function (value, state, options) {

                    if (ctor.prototype._base) {
                        var baseRet = ctor.prototype._base.call(this, value, state, options);

                        if (baseRet.errors) {
                            return baseRet;
                        }

                        value = baseRet.value;
                    }

                    var ret = extension.pre.call(this, value, state, options);
                    if (ret instanceof Errors.Err) {
                        return { value: value, errors: ret };
                    }

                    return { value: ret };
                };
            }

            if (extension.rules) {
                var _loop2 = function _loop2(j) {
                    var rule = extension.rules[j];
                    var ruleArgs = rule.params ? rule.params instanceof Any ? rule.params._inner.children.map(function (k) {
                        return k.key;
                    }) : Object.keys(rule.params) : [];
                    var validateArgs = rule.params ? Cast.schema(_this2, rule.params) : null;

                    type.prototype[rule.name] = function () {
                        for (var _len12 = arguments.length, rArgs = Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
                            rArgs[_key12] = arguments[_key12];
                        }

                        // eslint-disable-line no-loop-func

                        if (rArgs.length > ruleArgs.length) {
                            throw new Error('Unexpected number of arguments');
                        }

                        var hasRef = false;
                        var arg = {};

                        for (var k = 0; k < ruleArgs.length; ++k) {
                            arg[ruleArgs[k]] = rArgs[k];
                            if (!hasRef && Ref.isRef(rArgs[k])) {
                                hasRef = true;
                            }
                        }

                        if (validateArgs) {
                            arg = joi.attempt(arg, validateArgs);
                        }

                        var schema = void 0;
                        if (rule.validate) {
                            var validate = function validate(value, state, options) {

                                return rule.validate.call(this, arg, value, state, options);
                            };

                            schema = this._test(rule.name, arg, validate, {
                                description: rule.description,
                                hasRef: hasRef
                            });
                        } else {
                            schema = this.clone();
                        }

                        if (rule.setup) {
                            var newSchema = rule.setup.call(schema, arg);
                            if (newSchema !== undefined) {
                                Hoek.assert(newSchema instanceof Any, 'Setup of extension Joi.' + this._type + '().' + rule.name + '() must return undefined or a Joi object');
                                schema = newSchema;
                            }
                        }

                        return schema;
                    };
                };

                for (var j = 0; j < extension.rules.length; ++j) {
                    _loop2(j);
                }
            }

            if (extension.describe) {
                type.prototype.describe = function () {

                    var description = ctor.prototype.describe.call(this);
                    return extension.describe.call(this, description);
                };
            }

            var instance = new type();
            joi[extension.name] = function () {
                for (var _len13 = arguments.length, extArgs = Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
                    extArgs[_key13] = arguments[_key13];
                }

                return internals.callWithDefaults.call(this, instance, extArgs);
            };
        };

        for (var i = 0; i < extensions.length; ++i) {
            _loop(i);
        }

        return joi;
    };

    root.extensionSchema = internals.object.keys({
        base: internals.object.type(Any, 'Joi object'),
        name: internals.string.required(),
        coerce: internals.func.arity(3),
        pre: internals.func.arity(3),
        language: internals.object,
        describe: internals.func.arity(1),
        rules: internals.array.items(internals.object.keys({
            name: internals.string.required(),
            setup: internals.func.arity(1),
            validate: internals.func.arity(4),
            params: [internals.object.pattern(/.*/, internals.object.type(Any, 'Joi object')), internals.object.type(internals.object.constructor, 'Joi object')],
            description: [internals.string, internals.func.arity(1)]
        }).or('setup', 'validate'))
    }).strict();

    root.extensionsSchema = internals.array.items([internals.object, internals.func.arity(1)]).strict();

    root.version = __webpack_require__(36).version;

    return root;
};

module.exports = internals.root();

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Ref = __webpack_require__(1);

var internals = {};

internals.extendedCheckForValue = function (value, insensitive) {

    var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);

    if (valueType === 'object') {
        if (value instanceof Date) {
            return function (item) {

                return item instanceof Date && value.getTime() === item.getTime();
            };
        }
        if (Buffer.isBuffer(value)) {
            return function (item) {

                return Buffer.isBuffer(item) && value.length === item.length && value.toString('binary') === item.toString('binary');
            };
        }
    } else if (insensitive && valueType === 'string') {
        var lowercaseValue = value.toLowerCase();
        return function (item) {

            return typeof item === 'string' && lowercaseValue === item.toLowerCase();
        };
    }

    return null;
};

module.exports = function () {
    function InternalSet(from) {
        _classCallCheck(this, InternalSet);

        this._set = new Set(from);
        this._hasRef = false;
    }

    InternalSet.prototype.add = function add(value, refs) {

        var isRef = Ref.isRef(value);
        if (!isRef && this.has(value, null, null, false)) {

            return this;
        }

        if (refs !== undefined) {
            // If it's a merge, we don't have any refs
            Ref.push(refs, value);
        }

        this._set.add(value);

        this._hasRef |= isRef;

        return this;
    };

    InternalSet.prototype.merge = function merge(add, remove) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {

            for (var _iterator = add._set[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                this.add(item);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = remove._set[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _item = _step2.value;

                this.remove(_item);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        return this;
    };

    InternalSet.prototype.remove = function remove(value) {

        this._set.delete(value);
        return this;
    };

    InternalSet.prototype.has = function has(value, state, options, insensitive) {

        if (!this._set.size) {
            return false;
        }

        var hasValue = this._set.has(value);
        if (hasValue) {
            return hasValue;
        }

        var extendedCheck = internals.extendedCheckForValue(value, insensitive);
        if (!extendedCheck) {
            if (state && this._hasRef) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = this._set[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var item = _step3.value;

                        if (Ref.isRef(item)) {
                            item = item(state.reference || state.parent, options);
                            if (value === item || Array.isArray(item) && item.includes(value)) {
                                return true;
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }

            return false;
        }

        return this._has(value, state, options, extendedCheck);
    };

    InternalSet.prototype._has = function _has(value, state, options, check) {

        var checkRef = !!(state && this._hasRef);

        var isReallyEqual = function isReallyEqual(item) {

            if (value === item) {
                return true;
            }

            return check(item);
        };

        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = this._set[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var item = _step4.value;

                if (checkRef && Ref.isRef(item)) {
                    // Only resolve references if there is a state, otherwise it's a merge
                    item = item(state.reference || state.parent, options);

                    if (Array.isArray(item)) {
                        if (item.find(isReallyEqual)) {
                            return true;
                        }
                        continue;
                    }
                }

                if (isReallyEqual(item)) {
                    return true;
                }
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }

        return false;
    };

    InternalSet.prototype.values = function values(options) {

        if (options && options.stripUndefined) {
            var values = [];

            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = this._set[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var item = _step5.value;

                    if (item !== undefined) {
                        values.push(item);
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            return values;
        }

        return Array.from(this._set);
    };

    InternalSet.prototype.slice = function slice() {

        var set = new InternalSet(this._set);
        set._hasRef = this._hasRef;
        return set;
    };

    InternalSet.prototype.concat = function concat(source) {

        var set = new InternalSet([].concat(_toConsumableArray(this._set), _toConsumableArray(source._set)));
        set._hasRef = !!(this._hasRef | source._hasRef);
        return set;
    };

    return InternalSet;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Hoek = __webpack_require__(0);
var Any = __webpack_require__(2);
var Cast = __webpack_require__(4);
var Ref = __webpack_require__(1);

// Declare internals

var internals = {};

internals.Alternatives = function (_Any) {
    _inherits(_class, _Any);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _Any.call(this));

        _this._type = 'alternatives';
        _this._invalids.remove(null);
        _this._inner.matches = [];
        return _this;
    }

    _class.prototype._init = function _init() {

        return arguments.length ? this.try.apply(this, arguments) : this;
    };

    _class.prototype._base = function _base(value, state, options) {

        var errors = [];
        var il = this._inner.matches.length;
        var baseType = this._baseType;

        for (var i = 0; i < il; ++i) {
            var item = this._inner.matches[i];
            if (!item.schema) {
                var schema = item.peek || item.is;
                var input = item.is ? item.ref(state.reference || state.parent, options) : value;
                var failed = schema._validate(input, null, options, state.parent).errors;

                if (failed) {
                    if (item.otherwise) {
                        return item.otherwise._validate(value, state, options);
                    }
                } else if (item.then) {
                    return item.then._validate(value, state, options);
                }

                if (i === il - 1 && baseType) {
                    return baseType._validate(value, state, options);
                }

                continue;
            }

            var result = item.schema._validate(value, state, options);
            if (!result.errors) {
                // Found a valid match
                return result;
            }

            errors = errors.concat(result.errors);
        }

        if (errors.length) {
            return { errors: this.createError('alternatives.child', { reason: errors }, state, options) };
        }

        return { errors: this.createError('alternatives.base', null, state, options) };
    };

    _class.prototype.try = function _try() {
        for (var _len = arguments.length, schemas = Array(_len), _key = 0; _key < _len; _key++) {
            schemas[_key] = arguments[_key];
        }

        schemas = Hoek.flatten(schemas);
        Hoek.assert(schemas.length, 'Cannot add other alternatives without at least one schema');

        var obj = this.clone();

        for (var i = 0; i < schemas.length; ++i) {
            var cast = Cast.schema(this._currentJoi, schemas[i]);
            if (cast._refs.length) {
                obj._refs = obj._refs.concat(cast._refs);
            }
            obj._inner.matches.push({ schema: cast });
        }

        return obj;
    };

    _class.prototype.when = function when(condition, options) {

        var schemaCondition = false;
        Hoek.assert(Ref.isRef(condition) || typeof condition === 'string' || (schemaCondition = condition instanceof Any), 'Invalid condition:', condition);
        Hoek.assert(options, 'Missing options');
        Hoek.assert((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object', 'Invalid options');
        if (schemaCondition) {
            Hoek.assert(!options.hasOwnProperty('is'), '"is" can not be used with a schema condition');
        } else {
            Hoek.assert(options.hasOwnProperty('is'), 'Missing "is" directive');
        }
        Hoek.assert(options.then !== undefined || options.otherwise !== undefined, 'options must have at least one of "then" or "otherwise"');

        var obj = this.clone();
        var is = void 0;
        if (!schemaCondition) {
            is = Cast.schema(this._currentJoi, options.is);

            if (options.is === null || !(Ref.isRef(options.is) || options.is instanceof Any)) {

                // Only apply required if this wasn't already a schema or a ref, we'll suppose people know what they're doing
                is = is.required();
            }
        }

        var item = {
            ref: schemaCondition ? null : Cast.ref(condition),
            peek: schemaCondition ? condition : null,
            is: is,
            then: options.then !== undefined ? Cast.schema(this._currentJoi, options.then) : undefined,
            otherwise: options.otherwise !== undefined ? Cast.schema(this._currentJoi, options.otherwise) : undefined
        };

        if (obj._baseType) {

            item.then = item.then && obj._baseType.concat(item.then);
            item.otherwise = item.otherwise && obj._baseType.concat(item.otherwise);
        }

        if (!schemaCondition) {
            Ref.push(obj._refs, item.ref);
            obj._refs = obj._refs.concat(item.is._refs);
        }

        if (item.then && item.then._refs) {
            obj._refs = obj._refs.concat(item.then._refs);
        }

        if (item.otherwise && item.otherwise._refs) {
            obj._refs = obj._refs.concat(item.otherwise._refs);
        }

        obj._inner.matches.push(item);

        return obj;
    };

    _class.prototype.describe = function describe() {

        var description = Any.prototype.describe.call(this);
        var alternatives = [];
        for (var i = 0; i < this._inner.matches.length; ++i) {
            var item = this._inner.matches[i];
            if (item.schema) {

                // try()

                alternatives.push(item.schema.describe());
            } else {

                // when()

                var when = item.is ? {
                    ref: item.ref.toString(),
                    is: item.is.describe()
                } : {
                    peek: item.peek.describe()
                };

                if (item.then) {
                    when.then = item.then.describe();
                }

                if (item.otherwise) {
                    when.otherwise = item.otherwise.describe();
                }

                alternatives.push(when);
            }
        }

        description.alternatives = alternatives;
        return description;
    };

    return _class;
}(Any);

module.exports = new internals.Alternatives();

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Hoek = __webpack_require__(0);

// Declare internals

var internals = {};

exports.concat = function (target, source) {

    if (!source) {
        return target;
    }

    var obj = _extends({}, target);

    var sKeys = Object.keys(source);
    for (var i = 0; i < sKeys.length; ++i) {
        var key = sKeys[i];
        if (key !== 'language' || !obj.hasOwnProperty(key)) {

            obj[key] = source[key];
        } else {
            obj[key] = Hoek.applyToDefaults(obj[key], source[key]);
        }
    }

    return obj;
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Any = __webpack_require__(2);
var Ref = __webpack_require__(1);
var Hoek = __webpack_require__(0);

// Declare internals

var internals = {};

internals.isoDate = /^(?:[-+]\d{2})?(?:\d{4}(?!\d{2}\b))(?:(-?)(?:(?:0[1-9]|1[0-2])(?:\1(?:[12]\d|0[1-9]|3[01]))?|W(?:[0-4]\d|5[0-2])(?:-?[1-7])?|(?:00[1-9]|0[1-9]\d|[12]\d{2}|3(?:[0-5]\d|6[1-6])))(?![T]$|[T][\d]+Z$)(?:[T\s](?:(?:(?:[01]\d|2[0-3])(?:(:?)[0-5]\d)?|24\:?00)(?:[.,]\d+(?!:))?)(?:\2[0-5]\d(?:[.,]\d+)?)?(?:[Z]|(?:[+-])(?:[01]\d|2[0-3])(?::?[0-5]\d)?)?)?)?$/;
internals.invalidDate = new Date('');
internals.isIsoDate = function () {

    var isoString = internals.isoDate.toString();

    return function (date) {

        return date && date.toString() === isoString;
    };
}();

internals.Date = function (_Any) {
    _inherits(_class, _Any);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _Any.call(this));

        _this._type = 'date';
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var result = {
            value: options.convert && internals.Date.toDate(value, this._flags.format, this._flags.timestamp, this._flags.multiplier) || value
        };

        if (result.value instanceof Date && !isNaN(result.value.getTime())) {
            result.errors = null;
        } else if (!options.convert) {
            result.errors = this.createError('date.strict', null, state, options);
        } else {
            var type = void 0;
            if (internals.isIsoDate(this._flags.format)) {
                type = 'isoDate';
            } else if (this._flags.timestamp) {
                type = 'timestamp.' + this._flags.timestamp;
            } else {
                type = 'base';
            }

            result.errors = this.createError('date.' + type, null, state, options);
        }

        return result;
    };

    _class.toDate = function toDate(value, format, timestamp, multiplier) {

        if (value instanceof Date) {
            return value;
        }

        if (typeof value === 'string' || typeof value === 'number' && !isNaN(value) && isFinite(value)) {

            if (typeof value === 'string' && /^[+-]?\d+(\.\d+)?$/.test(value)) {

                value = parseFloat(value);
            }

            var date = void 0;
            if (format && internals.isIsoDate(format)) {
                date = format.test(value) ? new Date(value) : internals.invalidDate;
            } else if (timestamp && multiplier) {
                date = /^\s*$/.test(value) ? internals.invalidDate : new Date(value * multiplier);
            } else {
                date = new Date(value);
            }

            if (!isNaN(date.getTime())) {
                return date;
            }
        }

        return null;
    };

    _class.prototype.iso = function iso() {

        if (this._flags.format === internals.isoDate) {
            return this;
        }

        var obj = this.clone();
        obj._flags.format = internals.isoDate;
        return obj;
    };

    _class.prototype.timestamp = function timestamp() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'javascript';


        var allowed = ['javascript', 'unix'];
        Hoek.assert(allowed.includes(type), '"type" must be one of "' + allowed.join('", "') + '"');

        if (this._flags.timestamp === type) {
            return this;
        }

        var obj = this.clone();
        obj._flags.timestamp = type;
        obj._flags.multiplier = type === 'unix' ? 1000 : 1;
        return obj;
    };

    _class.prototype._isIsoDate = function _isIsoDate(value) {

        return internals.isoDate.test(value);
    };

    return _class;
}(Any);

internals.compare = function (type, compare) {

    return function (date) {

        var isNow = date === 'now';
        var isRef = Ref.isRef(date);

        if (!isNow && !isRef) {
            date = internals.Date.toDate(date);
        }

        Hoek.assert(date, 'Invalid date format');

        return this._test(type, date, function (value, state, options) {

            var compareTo = void 0;
            if (isNow) {
                compareTo = Date.now();
            } else if (isRef) {
                compareTo = internals.Date.toDate(date(state.reference || state.parent, options));

                if (!compareTo) {
                    return this.createError('date.ref', { ref: date.key }, state, options);
                }

                compareTo = compareTo.getTime();
            } else {
                compareTo = date.getTime();
            }

            if (compare(value.getTime(), compareTo)) {
                return value;
            }

            return this.createError('date.' + type, { limit: new Date(compareTo) }, state, options);
        });
    };
};

internals.Date.prototype.min = internals.compare('min', function (value, date) {
    return value >= date;
});
internals.Date.prototype.max = internals.compare('max', function (value, date) {
    return value <= date;
});
internals.Date.prototype.greater = internals.compare('greater', function (value, date) {
    return value > date;
});
internals.Date.prototype.less = internals.compare('less', function (value, date) {
    return value < date;
});

module.exports = new internals.Date();

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Hoek = __webpack_require__(0);
var Topo = __webpack_require__(31);
var Any = __webpack_require__(2);
var Errors = __webpack_require__(6);
var Cast = __webpack_require__(4);

// Declare internals

var internals = {};

internals.Object = function (_Any) {
    _inherits(_class, _Any);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _Any.call(this));

        _this._type = 'object';
        _this._inner.children = null;
        _this._inner.renames = [];
        _this._inner.dependencies = [];
        _this._inner.patterns = [];
        return _this;
    }

    _class.prototype._init = function _init() {

        return arguments.length ? this.keys.apply(this, arguments) : this;
    };

    _class.prototype._base = function _base(value, state, options) {

        var target = value;
        var errors = [];
        var finish = function finish() {

            return {
                value: target,
                errors: errors.length ? errors : null
            };
        };

        if (typeof value === 'string' && options.convert) {

            value = internals.safeParse(value);
        }

        var type = this._flags.func ? 'function' : 'object';
        if (!value || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== type || Array.isArray(value)) {

            errors.push(this.createError(type + '.base', null, state, options));
            return finish();
        }

        // Skip if there are no other rules to test

        if (!this._inner.renames.length && !this._inner.dependencies.length && !this._inner.children && // null allows any keys
        !this._inner.patterns.length) {

            target = value;
            return finish();
        }

        // Ensure target is a local copy (parsed) or shallow copy

        if (target === value) {
            if (type === 'object') {
                target = Object.create(Object.getPrototypeOf(value));
            } else {
                target = function target() {
                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    return value.apply(this, args);
                };

                target.prototype = Hoek.clone(value.prototype);
            }

            var valueKeys = Object.keys(value);
            for (var i = 0; i < valueKeys.length; ++i) {
                target[valueKeys[i]] = value[valueKeys[i]];
            }
        } else {
            target = value;
        }

        // Rename keys

        var renamed = {};
        for (var _i = 0; _i < this._inner.renames.length; ++_i) {
            var rename = this._inner.renames[_i];

            if (rename.isRegExp) {
                var targetKeys = Object.keys(target);
                var matchedTargetKeys = [];

                for (var j = 0; j < targetKeys.length; ++j) {
                    if (rename.from.test(targetKeys[j])) {
                        matchedTargetKeys.push(targetKeys[j]);
                    }
                }

                var allUndefined = matchedTargetKeys.every(function (key) {
                    return target[key] === undefined;
                });
                if (rename.options.ignoreUndefined && allUndefined) {
                    continue;
                }

                if (!rename.options.multiple && renamed[rename.to]) {

                    errors.push(this.createError('object.rename.regex.multiple', { from: matchedTargetKeys, to: rename.to }, state, options));
                    if (options.abortEarly) {
                        return finish();
                    }
                }

                if (Object.prototype.hasOwnProperty.call(target, rename.to) && !rename.options.override && !renamed[rename.to]) {

                    errors.push(this.createError('object.rename.regex.override', { from: matchedTargetKeys, to: rename.to }, state, options));
                    if (options.abortEarly) {
                        return finish();
                    }
                }

                if (allUndefined) {
                    delete target[rename.to];
                } else {
                    target[rename.to] = target[matchedTargetKeys[matchedTargetKeys.length - 1]];
                }

                renamed[rename.to] = true;

                if (!rename.options.alias) {
                    for (var _j = 0; _j < matchedTargetKeys.length; ++_j) {
                        delete target[matchedTargetKeys[_j]];
                    }
                }
            } else {
                if (rename.options.ignoreUndefined && target[rename.from] === undefined) {
                    continue;
                }

                if (!rename.options.multiple && renamed[rename.to]) {

                    errors.push(this.createError('object.rename.multiple', { from: rename.from, to: rename.to }, state, options));
                    if (options.abortEarly) {
                        return finish();
                    }
                }

                if (Object.prototype.hasOwnProperty.call(target, rename.to) && !rename.options.override && !renamed[rename.to]) {

                    errors.push(this.createError('object.rename.override', { from: rename.from, to: rename.to }, state, options));
                    if (options.abortEarly) {
                        return finish();
                    }
                }

                if (target[rename.from] === undefined) {
                    delete target[rename.to];
                } else {
                    target[rename.to] = target[rename.from];
                }

                renamed[rename.to] = true;

                if (!rename.options.alias) {
                    delete target[rename.from];
                }
            }
        }

        // Validate schema

        if (!this._inner.children && // null allows any keys
        !this._inner.patterns.length && !this._inner.dependencies.length) {

            return finish();
        }

        var unprocessed = new Set(Object.keys(target));

        if (this._inner.children) {
            var stripProps = [];

            for (var _i2 = 0; _i2 < this._inner.children.length; ++_i2) {
                var child = this._inner.children[_i2];
                var key = child.key;
                var item = target[key];

                unprocessed.delete(key);

                var localState = { key: key, path: state.path.concat(key), parent: target, reference: state.reference };
                var result = child.schema._validate(item, localState, options);
                if (result.errors) {
                    errors.push(this.createError('object.child', { key: key, child: child.schema._getLabel(key), reason: result.errors }, localState, options));

                    if (options.abortEarly) {
                        return finish();
                    }
                } else {
                    if (child.schema._flags.strip || result.value === undefined && result.value !== item) {
                        stripProps.push(key);
                        target[key] = result.finalValue;
                    } else if (result.value !== undefined) {
                        target[key] = result.value;
                    }
                }
            }

            for (var _i3 = 0; _i3 < stripProps.length; ++_i3) {
                delete target[stripProps[_i3]];
            }
        }

        // Unknown keys

        if (unprocessed.size && this._inner.patterns.length) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {

                for (var _iterator = unprocessed[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _key2 = _step.value;

                    var _localState = {
                        key: _key2,
                        path: state.path.concat(_key2),
                        parent: target,
                        reference: state.reference
                    };
                    var _item = target[_key2];

                    for (var _i4 = 0; _i4 < this._inner.patterns.length; ++_i4) {
                        var pattern = this._inner.patterns[_i4];

                        if (pattern.regex ? pattern.regex.test(_key2) : !pattern.schema.validate(_key2).error) {

                            unprocessed.delete(_key2);

                            var _result = pattern.rule._validate(_item, _localState, options);
                            if (_result.errors) {
                                errors.push(this.createError('object.child', {
                                    key: _key2,
                                    child: pattern.rule._getLabel(_key2),
                                    reason: _result.errors
                                }, _localState, options));

                                if (options.abortEarly) {
                                    return finish();
                                }
                            }

                            target[_key2] = _result.value;
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }

        if (unprocessed.size && (this._inner.children || this._inner.patterns.length)) {
            if (options.stripUnknown && this._flags.allowUnknown !== true || options.skipFunctions) {

                var stripUnknown = options.stripUnknown ? options.stripUnknown === true ? true : !!options.stripUnknown.objects : false;

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = unprocessed[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var _key3 = _step2.value;

                        if (stripUnknown) {
                            delete target[_key3];
                            unprocessed.delete(_key3);
                        } else if (typeof target[_key3] === 'function') {
                            unprocessed.delete(_key3);
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }

            if (this._flags.allowUnknown !== undefined ? !this._flags.allowUnknown : !options.allowUnknown) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {

                    for (var _iterator3 = unprocessed[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var unprocessedKey = _step3.value;

                        errors.push(this.createError('object.allowUnknown', { child: unprocessedKey }, {
                            key: unprocessedKey,
                            path: state.path.concat(unprocessedKey)
                        }, options, {}));
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
        }

        // Validate dependencies

        for (var _i5 = 0; _i5 < this._inner.dependencies.length; ++_i5) {
            var dep = this._inner.dependencies[_i5];
            var err = internals[dep.type].call(this, dep.key !== null && target[dep.key], dep.peers, target, { key: dep.key, path: dep.key === null ? state.path : state.path.concat(dep.key) }, options);
            if (err instanceof Errors.Err) {
                errors.push(err);
                if (options.abortEarly) {
                    return finish();
                }
            }
        }

        return finish();
    };

    _class.prototype.keys = function keys(schema) {

        Hoek.assert(schema === null || schema === undefined || (typeof schema === 'undefined' ? 'undefined' : _typeof(schema)) === 'object', 'Object schema must be a valid object');
        Hoek.assert(!schema || !(schema instanceof Any), 'Object schema cannot be a joi schema');

        var obj = this.clone();

        if (!schema) {
            obj._inner.children = null;
            return obj;
        }

        var children = Object.keys(schema);

        if (!children.length) {
            obj._inner.children = [];
            return obj;
        }

        var topo = new Topo();
        if (obj._inner.children) {
            for (var i = 0; i < obj._inner.children.length; ++i) {
                var child = obj._inner.children[i];

                // Only add the key if we are not going to replace it later
                if (!children.includes(child.key)) {
                    topo.add(child, { after: child._refs, group: child.key });
                }
            }
        }

        for (var _i6 = 0; _i6 < children.length; ++_i6) {
            var key = children[_i6];
            var _child = schema[key];
            try {
                var cast = Cast.schema(this._currentJoi, _child);
                topo.add({ key: key, schema: cast }, { after: cast._refs, group: key });
            } catch (castErr) {
                if (castErr.hasOwnProperty('path')) {
                    castErr.path = key + '.' + castErr.path;
                } else {
                    castErr.path = key;
                }
                throw castErr;
            }
        }

        obj._inner.children = topo.nodes;

        return obj;
    };

    _class.prototype.append = function append(schema) {
        // Skip any changes
        if (schema === null || schema === undefined || Object.keys(schema).length === 0) {
            return this;
        }

        return this.keys(schema);
    };

    _class.prototype.unknown = function unknown(allow) {

        var value = allow !== false;

        if (this._flags.allowUnknown === value) {
            return this;
        }

        var obj = this.clone();
        obj._flags.allowUnknown = value;
        return obj;
    };

    _class.prototype.length = function length(limit) {

        Hoek.assert(Number.isSafeInteger(limit) && limit >= 0, 'limit must be a positive integer');

        return this._test('length', limit, function (value, state, options) {

            if (Object.keys(value).length === limit) {
                return value;
            }

            return this.createError('object.length', { limit: limit }, state, options);
        });
    };

    _class.prototype.min = function min(limit) {

        Hoek.assert(Number.isSafeInteger(limit) && limit >= 0, 'limit must be a positive integer');

        return this._test('min', limit, function (value, state, options) {

            if (Object.keys(value).length >= limit) {
                return value;
            }

            return this.createError('object.min', { limit: limit }, state, options);
        });
    };

    _class.prototype.max = function max(limit) {

        Hoek.assert(Number.isSafeInteger(limit) && limit >= 0, 'limit must be a positive integer');

        return this._test('max', limit, function (value, state, options) {

            if (Object.keys(value).length <= limit) {
                return value;
            }

            return this.createError('object.max', { limit: limit }, state, options);
        });
    };

    _class.prototype.pattern = function pattern(_pattern, schema) {

        var isRegExp = _pattern instanceof RegExp;
        Hoek.assert(isRegExp || _pattern instanceof Any, 'pattern must be a regex or schema');
        Hoek.assert(schema !== undefined, 'Invalid rule');

        if (isRegExp) {
            _pattern = new RegExp(_pattern.source, _pattern.ignoreCase ? 'i' : undefined); // Future version should break this and forbid unsupported regex flags
        }

        try {
            schema = Cast.schema(this._currentJoi, schema);
        } catch (castErr) {
            if (castErr.hasOwnProperty('path')) {
                castErr.message = castErr.message + '(' + castErr.path + ')';
            }

            throw castErr;
        }

        var obj = this.clone();
        if (isRegExp) {
            obj._inner.patterns.push({ regex: _pattern, rule: schema });
        } else {
            obj._inner.patterns.push({ schema: _pattern, rule: schema });
        }
        return obj;
    };

    _class.prototype.schema = function schema() {

        return this._test('schema', null, function (value, state, options) {

            if (value instanceof Any) {
                return value;
            }

            return this.createError('object.schema', null, state, options);
        });
    };

    _class.prototype.with = function _with(key, peers) {

        Hoek.assert(arguments.length === 2, 'Invalid number of arguments, expected 2.');

        return this._dependency('with', key, peers);
    };

    _class.prototype.without = function without(key, peers) {

        Hoek.assert(arguments.length === 2, 'Invalid number of arguments, expected 2.');

        return this._dependency('without', key, peers);
    };

    _class.prototype.xor = function xor() {
        for (var _len2 = arguments.length, peers = Array(_len2), _key4 = 0; _key4 < _len2; _key4++) {
            peers[_key4] = arguments[_key4];
        }

        peers = Hoek.flatten(peers);
        return this._dependency('xor', null, peers);
    };

    _class.prototype.or = function or() {
        for (var _len3 = arguments.length, peers = Array(_len3), _key5 = 0; _key5 < _len3; _key5++) {
            peers[_key5] = arguments[_key5];
        }

        peers = Hoek.flatten(peers);
        return this._dependency('or', null, peers);
    };

    _class.prototype.and = function and() {
        for (var _len4 = arguments.length, peers = Array(_len4), _key6 = 0; _key6 < _len4; _key6++) {
            peers[_key6] = arguments[_key6];
        }

        peers = Hoek.flatten(peers);
        return this._dependency('and', null, peers);
    };

    _class.prototype.nand = function nand() {
        for (var _len5 = arguments.length, peers = Array(_len5), _key7 = 0; _key7 < _len5; _key7++) {
            peers[_key7] = arguments[_key7];
        }

        peers = Hoek.flatten(peers);
        return this._dependency('nand', null, peers);
    };

    _class.prototype.requiredKeys = function requiredKeys() {
        for (var _len6 = arguments.length, children = Array(_len6), _key8 = 0; _key8 < _len6; _key8++) {
            children[_key8] = arguments[_key8];
        }

        children = Hoek.flatten(children);
        return this.applyFunctionToChildren(children, 'required');
    };

    _class.prototype.optionalKeys = function optionalKeys() {
        for (var _len7 = arguments.length, children = Array(_len7), _key9 = 0; _key9 < _len7; _key9++) {
            children[_key9] = arguments[_key9];
        }

        children = Hoek.flatten(children);
        return this.applyFunctionToChildren(children, 'optional');
    };

    _class.prototype.forbiddenKeys = function forbiddenKeys() {
        for (var _len8 = arguments.length, children = Array(_len8), _key10 = 0; _key10 < _len8; _key10++) {
            children[_key10] = arguments[_key10];
        }

        children = Hoek.flatten(children);
        return this.applyFunctionToChildren(children, 'forbidden');
    };

    _class.prototype.rename = function rename(from, to, options) {

        Hoek.assert(typeof from === 'string' || from instanceof RegExp, 'Rename missing the from argument');
        Hoek.assert(typeof to === 'string', 'Rename missing the to argument');
        Hoek.assert(to !== from, 'Cannot rename key to same name:', from);

        for (var i = 0; i < this._inner.renames.length; ++i) {
            Hoek.assert(this._inner.renames[i].from !== from, 'Cannot rename the same key multiple times');
        }

        var obj = this.clone();

        obj._inner.renames.push({
            from: from,
            to: to,
            options: Hoek.applyToDefaults(internals.renameDefaults, options || {}),
            isRegExp: from instanceof RegExp
        });

        return obj;
    };

    _class.prototype.applyFunctionToChildren = function applyFunctionToChildren(children, fn, args, root) {

        children = [].concat(children);
        Hoek.assert(children.length > 0, 'expected at least one children');

        var groupedChildren = internals.groupChildren(children);
        var obj = void 0;

        if ('' in groupedChildren) {
            obj = this[fn].apply(this, args);
            delete groupedChildren[''];
        } else {
            obj = this.clone();
        }

        if (obj._inner.children) {
            root = root ? root + '.' : '';

            for (var i = 0; i < obj._inner.children.length; ++i) {
                var child = obj._inner.children[i];
                var group = groupedChildren[child.key];

                if (group) {
                    obj._inner.children[i] = {
                        key: child.key,
                        _refs: child._refs,
                        schema: child.schema.applyFunctionToChildren(group, fn, args, root + child.key)
                    };

                    delete groupedChildren[child.key];
                }
            }
        }

        var remaining = Object.keys(groupedChildren);
        Hoek.assert(remaining.length === 0, 'unknown key(s)', remaining.join(', '));

        return obj;
    };

    _class.prototype._dependency = function _dependency(type, key, peers) {

        peers = [].concat(peers);
        for (var i = 0; i < peers.length; ++i) {
            Hoek.assert(typeof peers[i] === 'string', type, 'peers must be a string or array of strings');
        }

        var obj = this.clone();
        obj._inner.dependencies.push({ type: type, key: key, peers: peers });
        return obj;
    };

    _class.prototype.describe = function describe(shallow) {

        var description = Any.prototype.describe.call(this);

        if (description.rules) {
            for (var i = 0; i < description.rules.length; ++i) {
                var rule = description.rules[i];
                // Coverage off for future-proof descriptions, only object().assert() is use right now
                if ( /* $lab:coverage:off$ */rule.arg && _typeof(rule.arg) === 'object' && rule.arg.schema && rule.arg.ref /* $lab:coverage:on$ */) {
                        rule.arg = {
                            schema: rule.arg.schema.describe(),
                            ref: rule.arg.ref.toString()
                        };
                    }
            }
        }

        if (this._inner.children && !shallow) {

            description.children = {};
            for (var _i7 = 0; _i7 < this._inner.children.length; ++_i7) {
                var child = this._inner.children[_i7];
                description.children[child.key] = child.schema.describe();
            }
        }

        if (this._inner.dependencies.length) {
            description.dependencies = Hoek.clone(this._inner.dependencies);
        }

        if (this._inner.patterns.length) {
            description.patterns = [];

            for (var _i8 = 0; _i8 < this._inner.patterns.length; ++_i8) {
                var pattern = this._inner.patterns[_i8];
                if (pattern.regex) {
                    description.patterns.push({ regex: pattern.regex.toString(), rule: pattern.rule.describe() });
                } else {
                    description.patterns.push({ schema: pattern.schema.describe(), rule: pattern.rule.describe() });
                }
            }
        }

        if (this._inner.renames.length > 0) {
            description.renames = Hoek.clone(this._inner.renames);
        }

        return description;
    };

    _class.prototype.assert = function assert(ref, schema, message) {

        ref = Cast.ref(ref);
        Hoek.assert(ref.isContext || ref.depth > 1, 'Cannot use assertions for root level references - use direct key rules instead');
        message = message || 'pass the assertion test';

        try {
            schema = Cast.schema(this._currentJoi, schema);
        } catch (castErr) {
            if (castErr.hasOwnProperty('path')) {
                castErr.message = castErr.message + '(' + castErr.path + ')';
            }

            throw castErr;
        }

        var key = ref.path[ref.path.length - 1];
        var path = ref.path.join('.');

        return this._test('assert', { schema: schema, ref: ref }, function (value, state, options) {

            var result = schema._validate(ref(value), null, options, value);
            if (!result.errors) {
                return value;
            }

            var localState = Hoek.merge({}, state);
            localState.key = key;
            localState.path = ref.path;
            return this.createError('object.assert', { ref: path, message: message }, localState, options);
        });
    };

    _class.prototype.type = function type(constructor) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : constructor.name;


        Hoek.assert(typeof constructor === 'function', 'type must be a constructor function');
        var typeData = {
            name: name,
            ctor: constructor
        };

        return this._test('type', typeData, function (value, state, options) {

            if (value instanceof constructor) {
                return value;
            }

            return this.createError('object.type', { type: typeData.name }, state, options);
        });
    };

    return _class;
}(Any);

internals.safeParse = function (value) {

    try {
        return JSON.parse(value);
    } catch (parseErr) {}

    return value;
};

internals.renameDefaults = {
    alias: false, // Keep old value in place
    multiple: false, // Allow renaming multiple keys into the same target
    override: false // Overrides an existing key
};

internals.groupChildren = function (children) {

    children.sort();

    var grouped = {};

    for (var i = 0; i < children.length; ++i) {
        var child = children[i];
        Hoek.assert(typeof child === 'string', 'children must be strings');
        var group = child.split('.')[0];
        var childGroup = grouped[group] = grouped[group] || [];
        childGroup.push(child.substring(group.length + 1));
    }

    return grouped;
};

internals.keysToLabels = function (schema, keys) {

    var children = schema._inner.children;

    if (!children) {
        return keys;
    }

    var findLabel = function findLabel(key) {

        var matchingChild = children.find(function (child) {
            return child.key === key;
        });
        return matchingChild ? matchingChild.schema._getLabel(key) : key;
    };

    if (Array.isArray(keys)) {
        return keys.map(findLabel);
    }

    return findLabel(keys);
};

internals.with = function (value, peers, parent, state, options) {

    if (value === undefined) {
        return value;
    }

    for (var i = 0; i < peers.length; ++i) {
        var peer = peers[i];
        if (!Object.prototype.hasOwnProperty.call(parent, peer) || parent[peer] === undefined) {

            return this.createError('object.with', {
                main: state.key,
                mainWithLabel: internals.keysToLabels(this, state.key),
                peer: peer,
                peerWithLabel: internals.keysToLabels(this, peer)
            }, state, options);
        }
    }

    return value;
};

internals.without = function (value, peers, parent, state, options) {

    if (value === undefined) {
        return value;
    }

    for (var i = 0; i < peers.length; ++i) {
        var peer = peers[i];
        if (Object.prototype.hasOwnProperty.call(parent, peer) && parent[peer] !== undefined) {

            return this.createError('object.without', {
                main: state.key,
                mainWithLabel: internals.keysToLabels(this, state.key),
                peer: peer,
                peerWithLabel: internals.keysToLabels(this, peer)
            }, state, options);
        }
    }

    return value;
};

internals.xor = function (value, peers, parent, state, options) {

    var present = [];
    for (var i = 0; i < peers.length; ++i) {
        var peer = peers[i];
        if (Object.prototype.hasOwnProperty.call(parent, peer) && parent[peer] !== undefined) {

            present.push(peer);
        }
    }

    if (present.length === 1) {
        return value;
    }

    var context = { peers: peers, peersWithLabels: internals.keysToLabels(this, peers) };

    if (present.length === 0) {
        return this.createError('object.missing', context, state, options);
    }

    return this.createError('object.xor', context, state, options);
};

internals.or = function (value, peers, parent, state, options) {

    for (var i = 0; i < peers.length; ++i) {
        var peer = peers[i];
        if (Object.prototype.hasOwnProperty.call(parent, peer) && parent[peer] !== undefined) {
            return value;
        }
    }

    return this.createError('object.missing', {
        peers: peers,
        peersWithLabels: internals.keysToLabels(this, peers)
    }, state, options);
};

internals.and = function (value, peers, parent, state, options) {

    var missing = [];
    var present = [];
    var count = peers.length;
    for (var i = 0; i < count; ++i) {
        var peer = peers[i];
        if (!Object.prototype.hasOwnProperty.call(parent, peer) || parent[peer] === undefined) {

            missing.push(peer);
        } else {
            present.push(peer);
        }
    }

    var aon = missing.length === count || present.length === count;

    if (!aon) {

        return this.createError('object.and', {
            present: present,
            presentWithLabels: internals.keysToLabels(this, present),
            missing: missing,
            missingWithLabels: internals.keysToLabels(this, missing)
        }, state, options);
    }
};

internals.nand = function (value, peers, parent, state, options) {

    var present = [];
    for (var i = 0; i < peers.length; ++i) {
        var peer = peers[i];
        if (Object.prototype.hasOwnProperty.call(parent, peer) && parent[peer] !== undefined) {

            present.push(peer);
        }
    }

    var values = Hoek.clone(peers);
    var main = values.splice(0, 1)[0];
    var allPresent = present.length === peers.length;
    return allPresent ? this.createError('object.nand', {
        main: main,
        mainWithLabel: internals.keysToLabels(this, main),
        peers: values,
        peersWithLabels: internals.keysToLabels(this, values)
    }, state, options) : null;
};

module.exports = new internals.Object();

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules


// Delcare internals

var internals = {
  rfc3986: {}
};

internals.generate = function () {

  /**
   * elements separated by forward slash ("/") are alternatives.
   */
  var or = '|';

  /**
   * Rule to support zero-padded addresses.
   */
  var zeroPad = '0?';

  /**
   * DIGIT = %x30-39 ; 0-9
   */
  var digit = '0-9';
  var digitOnly = '[' + digit + ']';

  /**
   * ALPHA = %x41-5A / %x61-7A   ; A-Z / a-z
   */
  var alpha = 'a-zA-Z';
  var alphaOnly = '[' + alpha + ']';

  /**
   * IPv4
   * cidr       = DIGIT                ; 0-9
   *            / %x31-32 DIGIT         ; 10-29
   *            / "3" %x30-32           ; 30-32
   */
  internals.rfc3986.ipv4Cidr = digitOnly + or + '[1-2]' + digitOnly + or + '3' + '[0-2]';

  /**
   * IPv6
   * cidr       = DIGIT                 ; 0-9
   *            / %x31-39 DIGIT         ; 10-99
   *            / "1" %x0-1 DIGIT       ; 100-119
   *            / "12" %x0-8            ; 120-128
   */
  internals.rfc3986.ipv6Cidr = '(?:' + zeroPad + zeroPad + digitOnly + or + zeroPad + '[1-9]' + digitOnly + or + '1' + '[01]' + digitOnly + or + '12[0-8])';

  /**
   * HEXDIG = DIGIT / "A" / "B" / "C" / "D" / "E" / "F"
   */
  var hexDigit = digit + 'A-Fa-f';
  var hexDigitOnly = '[' + hexDigit + ']';

  /**
   * unreserved = ALPHA / DIGIT / "-" / "." / "_" / "~"
   */
  var unreserved = alpha + digit + '-\\._~';

  /**
   * sub-delims = "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
   */
  var subDelims = '!\\$&\'\\(\\)\\*\\+,;=';

  /**
   * pct-encoded = "%" HEXDIG HEXDIG
   */
  var pctEncoded = '%' + hexDigit;

  /**
   * pchar = unreserved / pct-encoded / sub-delims / ":" / "@"
   */
  var pchar = unreserved + pctEncoded + subDelims + ':@';
  var pcharOnly = '[' + pchar + ']';

  /**
   * dec-octet   = DIGIT                 ; 0-9
   *            / %x31-39 DIGIT         ; 10-99
   *            / "1" 2DIGIT            ; 100-199
   *            / "2" %x30-34 DIGIT     ; 200-249
   *            / "25" %x30-35          ; 250-255
   */
  var decOctect = '(?:' + zeroPad + zeroPad + digitOnly + or + zeroPad + '[1-9]' + digitOnly + or + '1' + digitOnly + digitOnly + or + '2' + '[0-4]' + digitOnly + or + '25' + '[0-5])';

  /**
   * IPv4address = dec-octet "." dec-octet "." dec-octet "." dec-octet
   */
  internals.rfc3986.IPv4address = '(?:' + decOctect + '\\.){3}' + decOctect;

  /**
   * h16 = 1*4HEXDIG ; 16 bits of address represented in hexadecimal
   * ls32 = ( h16 ":" h16 ) / IPv4address ; least-significant 32 bits of address
   * IPv6address =                            6( h16 ":" ) ls32
   *             /                       "::" 5( h16 ":" ) ls32
   *             / [               h16 ] "::" 4( h16 ":" ) ls32
   *             / [ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
   *             / [ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
   *             / [ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
   *             / [ *4( h16 ":" ) h16 ] "::"              ls32
   *             / [ *5( h16 ":" ) h16 ] "::"              h16
   *             / [ *6( h16 ":" ) h16 ] "::"
   */
  var h16 = hexDigitOnly + '{1,4}';
  var ls32 = '(?:' + h16 + ':' + h16 + '|' + internals.rfc3986.IPv4address + ')';
  var IPv6SixHex = '(?:' + h16 + ':){6}' + ls32;
  var IPv6FiveHex = '::(?:' + h16 + ':){5}' + ls32;
  var IPv6FourHex = '(?:' + h16 + ')?::(?:' + h16 + ':){4}' + ls32;
  var IPv6ThreeHex = '(?:(?:' + h16 + ':){0,1}' + h16 + ')?::(?:' + h16 + ':){3}' + ls32;
  var IPv6TwoHex = '(?:(?:' + h16 + ':){0,2}' + h16 + ')?::(?:' + h16 + ':){2}' + ls32;
  var IPv6OneHex = '(?:(?:' + h16 + ':){0,3}' + h16 + ')?::' + h16 + ':' + ls32;
  var IPv6NoneHex = '(?:(?:' + h16 + ':){0,4}' + h16 + ')?::' + ls32;
  var IPv6NoneHex2 = '(?:(?:' + h16 + ':){0,5}' + h16 + ')?::' + h16;
  var IPv6NoneHex3 = '(?:(?:' + h16 + ':){0,6}' + h16 + ')?::';
  internals.rfc3986.IPv6address = '(?:' + IPv6SixHex + or + IPv6FiveHex + or + IPv6FourHex + or + IPv6ThreeHex + or + IPv6TwoHex + or + IPv6OneHex + or + IPv6NoneHex + or + IPv6NoneHex2 + or + IPv6NoneHex3 + ')';

  /**
   * IPvFuture = "v" 1*HEXDIG "." 1*( unreserved / sub-delims / ":" )
   */
  internals.rfc3986.IPvFuture = 'v' + hexDigitOnly + '+\\.[' + unreserved + subDelims + ':]+';

  /**
   * scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
   */
  internals.rfc3986.scheme = alphaOnly + '[' + alpha + digit + '+-\\.]*';

  /**
   * userinfo = *( unreserved / pct-encoded / sub-delims / ":" )
   */
  var userinfo = '[' + unreserved + pctEncoded + subDelims + ':]*';

  /**
   * IP-literal = "[" ( IPv6address / IPvFuture  ) "]"
   */
  var IPLiteral = '\\[(?:' + internals.rfc3986.IPv6address + or + internals.rfc3986.IPvFuture + ')\\]';

  /**
   * reg-name = *( unreserved / pct-encoded / sub-delims )
   */
  var regName = '[' + unreserved + pctEncoded + subDelims + ']{0,255}';

  /**
   * host = IP-literal / IPv4address / reg-name
   */
  var host = '(?:' + IPLiteral + or + internals.rfc3986.IPv4address + or + regName + ')';

  /**
   * port = *DIGIT
   */
  var port = digitOnly + '*';

  /**
   * authority   = [ userinfo "@" ] host [ ":" port ]
   */
  var authority = '(?:' + userinfo + '@)?' + host + '(?::' + port + ')?';

  /**
   * segment       = *pchar
   * segment-nz    = 1*pchar
   * path          = path-abempty    ; begins with "/" or is empty
   *               / path-absolute   ; begins with "/" but not "//"
   *               / path-noscheme   ; begins with a non-colon segment
   *               / path-rootless   ; begins with a segment
   *               / path-empty      ; zero characters
   * path-abempty  = *( "/" segment )
   * path-absolute = "/" [ segment-nz *( "/" segment ) ]
   * path-rootless = segment-nz *( "/" segment )
   */
  var segment = pcharOnly + '*';
  var segmentNz = pcharOnly + '+';
  var segmentNzNc = '[' + unreserved + pctEncoded + subDelims + '@' + ']+';
  var pathEmpty = '';
  var pathAbEmpty = '(?:\\/' + segment + ')*';
  var pathAbsolute = '\\/(?:' + segmentNz + pathAbEmpty + ')?';
  var pathRootless = segmentNz + pathAbEmpty;
  var pathNoScheme = segmentNzNc + pathAbEmpty;

  /**
   * hier-part = "//" authority path
   */
  internals.rfc3986.hierPart = '(?:' + '(?:\\/\\/' + authority + pathAbEmpty + ')' + or + pathAbsolute + or + pathRootless + ')';

  /**
   * relative-part = "//" authority path-abempty
   *                 / path-absolute
   *                 / path-noscheme
   *                 / path-empty
   */
  internals.rfc3986.relativeRef = '(?:' + '(?:\\/\\/' + authority + pathAbEmpty + ')' + or + pathAbsolute + or + pathNoScheme + or + pathEmpty + ')';

  /**
   * query = *( pchar / "/" / "?" )
   */
  internals.rfc3986.query = '[' + pchar + '\\/\\?]*(?=#|$)'; //Finish matching either at the fragment part or end of the line.

  /**
   * fragment = *( pchar / "/" / "?" )
   */
  internals.rfc3986.fragment = '[' + pchar + '\\/\\?]*';
};

internals.generate();

module.exports = internals.rfc3986;

/***/ }),
/* 15 */
/***/ (function(module, exports) {



/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(40);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(39);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(7)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__(16);
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

// Declare internals

var internals = {};

exports.escapeJavaScript = function (input) {

    if (!input) {
        return '';
    }

    var escaped = '';

    for (var i = 0; i < input.length; ++i) {

        var charCode = input.charCodeAt(i);

        if (internals.isSafe(charCode)) {
            escaped += input[i];
        } else {
            escaped += internals.escapeJavaScriptChar(charCode);
        }
    }

    return escaped;
};

exports.escapeHtml = function (input) {

    if (!input) {
        return '';
    }

    var escaped = '';

    for (var i = 0; i < input.length; ++i) {

        var charCode = input.charCodeAt(i);

        if (internals.isSafe(charCode)) {
            escaped += input[i];
        } else {
            escaped += internals.escapeHtmlChar(charCode);
        }
    }

    return escaped;
};

exports.escapeJson = function (input) {

    if (!input) {
        return '';
    }

    var lessThan = 0x3C;
    var greaterThan = 0x3E;
    var andSymbol = 0x26;
    var lineSeperator = 0x2028;

    // replace method
    var charCode = void 0;
    return input.replace(/[<>&\u2028\u2029]/g, function (match) {

        charCode = match.charCodeAt(0);

        if (charCode === lessThan) {
            return '\\u003c';
        } else if (charCode === greaterThan) {
            return '\\u003e';
        } else if (charCode === andSymbol) {
            return '\\u0026';
        } else if (charCode === lineSeperator) {
            return '\\u2028';
        }
        return '\\u2029';
    });
};

internals.escapeJavaScriptChar = function (charCode) {

    if (charCode >= 256) {
        return '\\u' + internals.padLeft('' + charCode, 4);
    }

    var hexValue = Buffer.from(String.fromCharCode(charCode), 'ascii').toString('hex');
    return '\\x' + internals.padLeft(hexValue, 2);
};

internals.escapeHtmlChar = function (charCode) {

    var namedEscape = internals.namedHtml[charCode];
    if (typeof namedEscape !== 'undefined') {
        return namedEscape;
    }

    if (charCode >= 256) {
        return '&#' + charCode + ';';
    }

    var hexValue = Buffer.from(String.fromCharCode(charCode), 'ascii').toString('hex');
    return '&#x' + internals.padLeft(hexValue, 2) + ';';
};

internals.padLeft = function (str, len) {

    while (str.length < len) {
        str = '0' + str;
    }

    return str;
};

internals.isSafe = function (charCode) {

    return typeof internals.safeCharCodes[charCode] !== 'undefined';
};

internals.namedHtml = {
    '38': '&amp;',
    '60': '&lt;',
    '62': '&gt;',
    '34': '&quot;',
    '160': '&nbsp;',
    '162': '&cent;',
    '163': '&pound;',
    '164': '&curren;',
    '169': '&copy;',
    '174': '&reg;'
};

internals.safeCharCodes = function () {

    var safe = {};

    for (var i = 32; i < 123; ++i) {

        if (i >= 97 || // a-z
        i >= 65 && i <= 90 || // A-Z
        i >= 48 && i <= 57 || // 0-9
        i === 32 || // space
        i === 46 || // .
        i === 44 || // ,
        i === 45 || // -
        i === 58 || // :
        i === 95) {
            // _

            safe[i] = null;
        }
    }

    return safe;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

// Load modules

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Punycode = __webpack_require__(38);

// Declare internals

var internals = {
    hasOwn: Object.prototype.hasOwnProperty,
    indexOf: Array.prototype.indexOf,
    defaultThreshold: 16,
    maxIPv6Groups: 8,

    categories: {
        valid: 1,
        dnsWarn: 7,
        rfc5321: 15,
        cfws: 31,
        deprecated: 63,
        rfc5322: 127,
        error: 255
    },

    diagnoses: {

        // Address is valid

        valid: 0,

        // Address is valid for SMTP but has unusual elements

        rfc5321TLD: 9,
        rfc5321TLDNumeric: 10,
        rfc5321QuotedString: 11,
        rfc5321AddressLiteral: 12,

        // Address is valid for message, but must be modified for envelope

        cfwsComment: 17,
        cfwsFWS: 18,

        // Address contains non-ASCII when the allowUnicode option is false
        // Has to be > internals.defaultThreshold so that it's rejected
        // without an explicit errorLevel:
        undesiredNonAscii: 25,

        // Address contains deprecated elements, but may still be valid in some contexts

        deprecatedLocalPart: 33,
        deprecatedFWS: 34,
        deprecatedQTEXT: 35,
        deprecatedQP: 36,
        deprecatedComment: 37,
        deprecatedCTEXT: 38,
        deprecatedIPv6: 39,
        deprecatedCFWSNearAt: 49,

        // Address is only valid according to broad definition in RFC 5322, but is otherwise invalid

        rfc5322Domain: 65,
        rfc5322TooLong: 66,
        rfc5322LocalTooLong: 67,
        rfc5322DomainTooLong: 68,
        rfc5322LabelTooLong: 69,
        rfc5322DomainLiteral: 70,
        rfc5322DomainLiteralOBSDText: 71,
        rfc5322IPv6GroupCount: 72,
        rfc5322IPv62x2xColon: 73,
        rfc5322IPv6BadCharacter: 74,
        rfc5322IPv6MaxGroups: 75,
        rfc5322IPv6ColonStart: 76,
        rfc5322IPv6ColonEnd: 77,

        // Address is invalid for any purpose

        errExpectingDTEXT: 129,
        errNoLocalPart: 130,
        errNoDomain: 131,
        errConsecutiveDots: 132,
        errATEXTAfterCFWS: 133,
        errATEXTAfterQS: 134,
        errATEXTAfterDomainLiteral: 135,
        errExpectingQPair: 136,
        errExpectingATEXT: 137,
        errExpectingQTEXT: 138,
        errExpectingCTEXT: 139,
        errBackslashEnd: 140,
        errDotStart: 141,
        errDotEnd: 142,
        errDomainHyphenStart: 143,
        errDomainHyphenEnd: 144,
        errUnclosedQuotedString: 145,
        errUnclosedComment: 146,
        errUnclosedDomainLiteral: 147,
        errFWSCRLFx2: 148,
        errFWSCRLFEnd: 149,
        errCRNoLF: 150,
        errUnknownTLD: 160,
        errDomainTooShort: 161
    },

    components: {
        localpart: 0,
        domain: 1,
        literal: 2,
        contextComment: 3,
        contextFWS: 4,
        contextQuotedString: 5,
        contextQuotedPair: 6
    }
};

internals.specials = function () {

    var specials = '()<>[]:;@\\,."'; // US-ASCII visible characters not valid for atext (http://tools.ietf.org/html/rfc5322#section-3.2.3)
    var lookup = new Array(0x100);
    lookup.fill(false);

    for (var i = 0; i < specials.length; ++i) {
        lookup[specials.codePointAt(i)] = true;
    }

    return function (code) {

        return lookup[code];
    };
}();

internals.c0Controls = function () {

    var lookup = new Array(0x100);
    lookup.fill(false);

    // add C0 control characters

    for (var i = 0; i < 33; ++i) {
        lookup[i] = true;
    }

    return function (code) {

        return lookup[code];
    };
}();

internals.c1Controls = function () {

    var lookup = new Array(0x100);
    lookup.fill(false);

    // add C1 control characters

    for (var i = 127; i < 160; ++i) {
        lookup[i] = true;
    }

    return function (code) {

        return lookup[code];
    };
}();

internals.regex = {
    ipV4: /\b(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    ipV6: /^[a-fA-F\d]{0,4}$/
};

internals.normalizeSupportsNul = '\0'.normalize('NFC') === '\0';

// $lab:coverage:off$
internals.nulNormalize = function (email) {

    return email.split('\0').map(function (part) {
        return part.normalize('NFC');
    }).join('\0');
};
// $lab:coverage:on$


internals.normalize = function (email) {

    // $lab:coverage:off$
    if (!internals.normalizeSupportsNul && email.indexOf('\0') >= 0) {
        return internals.nulNormalize(email);
    }
    // $lab:coverage:on$

    return email.normalize('NFC');
};

internals.checkIpV6 = function (items) {

    return items.every(function (value) {
        return internals.regex.ipV6.test(value);
    });
};

internals.validDomain = function (tldAtom, options) {

    if (options.tldBlacklist) {
        if (Array.isArray(options.tldBlacklist)) {
            return internals.indexOf.call(options.tldBlacklist, tldAtom) === -1;
        }

        return !internals.hasOwn.call(options.tldBlacklist, tldAtom);
    }

    if (Array.isArray(options.tldWhitelist)) {
        return internals.indexOf.call(options.tldWhitelist, tldAtom) !== -1;
    }

    return internals.hasOwn.call(options.tldWhitelist, tldAtom);
};

/**
 * Check that an email address conforms to RFCs 5321, 5322, 6530 and others
 *
 * We distinguish clearly between a Mailbox as defined by RFC 5321 and an
 * addr-spec as defined by RFC 5322. Depending on the context, either can be
 * regarded as a valid email address. The RFC 5321 Mailbox specification is
 * more restrictive (comments, white space and obsolete forms are not allowed).
 *
 * @param {string} email The email address to check. See README for specifics.
 * @param {Object} options The (optional) options:
 *   {*} errorLevel Determines the boundary between valid and invalid
 *     addresses.
 *   {*} tldBlacklist The set of domains to consider invalid.
 *   {*} tldWhitelist The set of domains to consider valid.
 *   {*} allowUnicode Whether to allow non-ASCII characters, defaults to true.
 *   {*} minDomainAtoms The minimum number of domain atoms which must be present
 *     for the address to be valid.
 * @param {function(number|boolean)} callback The (optional) callback handler.
 * @return {*}
 */

exports.validate = internals.validate = function (email, options, callback) {

    options = options || {};
    email = internals.normalize(email);

    // The callback function is deprecated.
    // $lab:coverage:off$
    if (typeof options === 'function') {
        callback = options;
        options = {};
    }

    if (typeof callback !== 'function') {
        callback = null;
    }
    // $lab:coverage:on$

    var diagnose = void 0;
    var threshold = void 0;

    if (typeof options.errorLevel === 'number') {
        diagnose = true;
        threshold = options.errorLevel;
    } else {
        diagnose = !!options.errorLevel;
        threshold = internals.diagnoses.valid;
    }

    if (options.tldWhitelist) {
        if (typeof options.tldWhitelist === 'string') {
            options.tldWhitelist = [options.tldWhitelist];
        } else if (_typeof(options.tldWhitelist) !== 'object') {
            throw new TypeError('expected array or object tldWhitelist');
        }
    }

    if (options.tldBlacklist) {
        if (typeof options.tldBlacklist === 'string') {
            options.tldBlacklist = [options.tldBlacklist];
        } else if (_typeof(options.tldBlacklist) !== 'object') {
            throw new TypeError('expected array or object tldBlacklist');
        }
    }

    if (options.minDomainAtoms && (options.minDomainAtoms !== (+options.minDomainAtoms | 0) || options.minDomainAtoms < 0)) {
        throw new TypeError('expected positive integer minDomainAtoms');
    }

    var maxResult = internals.diagnoses.valid;
    var updateResult = function updateResult(value) {

        if (value > maxResult) {
            maxResult = value;
        }
    };

    var allowUnicode = options.allowUnicode === undefined || !!options.allowUnicode;
    if (!allowUnicode && /[^\x00-\x7f]/.test(email)) {
        updateResult(internals.diagnoses.undesiredNonAscii);
    }

    var context = {
        now: internals.components.localpart,
        prev: internals.components.localpart,
        stack: [internals.components.localpart]
    };

    var prevToken = '';

    var parseData = {
        local: '',
        domain: ''
    };
    var atomData = {
        locals: [''],
        domains: ['']
    };

    var elementCount = 0;
    var elementLength = 0;
    var crlfCount = 0;
    var charCode = void 0;

    var hyphenFlag = false;
    var assertEnd = false;

    var emailLength = email.length;

    var token = void 0; // Token is used outside the loop, must declare similarly
    for (var i = 0; i < emailLength; i += token.length) {
        // Utilize codepoints to account for Unicode surrogate pairs
        token = String.fromCodePoint(email.codePointAt(i));

        switch (context.now) {
            // Local-part
            case internals.components.localpart:
                // http://tools.ietf.org/html/rfc5322#section-3.4.1
                //   local-part      =   dot-atom / quoted-string / obs-local-part
                //
                //   dot-atom        =   [CFWS] dot-atom-text [CFWS]
                //
                //   dot-atom-text   =   1*atext *("." 1*atext)
                //
                //   quoted-string   =   [CFWS]
                //                       DQUOTE *([FWS] qcontent) [FWS] DQUOTE
                //                       [CFWS]
                //
                //   obs-local-part  =   word *("." word)
                //
                //   word            =   atom / quoted-string
                //
                //   atom            =   [CFWS] 1*atext [CFWS]
                switch (token) {
                    // Comment
                    case '(':
                        if (elementLength === 0) {
                            // Comments are OK at the beginning of an element
                            updateResult(elementCount === 0 ? internals.diagnoses.cfwsComment : internals.diagnoses.deprecatedComment);
                        } else {
                            updateResult(internals.diagnoses.cfwsComment);
                            // Cannot start a comment in an element, should be end
                            assertEnd = true;
                        }

                        context.stack.push(context.now);
                        context.now = internals.components.contextComment;
                        break;

                    // Next dot-atom element
                    case '.':
                        if (elementLength === 0) {
                            // Another dot, already?
                            updateResult(elementCount === 0 ? internals.diagnoses.errDotStart : internals.diagnoses.errConsecutiveDots);
                        } else {
                            // The entire local-part can be a quoted string for RFC 5321; if one atom is quoted it's an RFC 5322 obsolete form
                            if (assertEnd) {
                                updateResult(internals.diagnoses.deprecatedLocalPart);
                            }

                            // CFWS & quoted strings are OK again now we're at the beginning of an element (although they are obsolete forms)
                            assertEnd = false;
                            elementLength = 0;
                            ++elementCount;
                            parseData.local += token;
                            atomData.locals[elementCount] = '';
                        }

                        break;

                    // Quoted string
                    case '"':
                        if (elementLength === 0) {
                            // The entire local-part can be a quoted string for RFC 5321; if one atom is quoted it's an RFC 5322 obsolete form
                            updateResult(elementCount === 0 ? internals.diagnoses.rfc5321QuotedString : internals.diagnoses.deprecatedLocalPart);

                            parseData.local += token;
                            atomData.locals[elementCount] += token;
                            elementLength += Buffer.byteLength(token, 'utf8');

                            // Quoted string must be the entire element
                            assertEnd = true;
                            context.stack.push(context.now);
                            context.now = internals.components.contextQuotedString;
                        } else {
                            updateResult(internals.diagnoses.errExpectingATEXT);
                        }

                        break;

                    // Folding white space
                    case '\r':
                        if (emailLength === ++i || email[i] !== '\n') {
                            // Fatal error
                            updateResult(internals.diagnoses.errCRNoLF);
                            break;
                        }

                    // Fallthrough

                    case ' ':
                    case '\t':
                        if (elementLength === 0) {
                            updateResult(elementCount === 0 ? internals.diagnoses.cfwsFWS : internals.diagnoses.deprecatedFWS);
                        } else {
                            // We can't start FWS in the middle of an element, better be end
                            assertEnd = true;
                        }

                        context.stack.push(context.now);
                        context.now = internals.components.contextFWS;
                        prevToken = token;
                        break;

                    case '@':
                        // At this point we should have a valid local-part
                        // $lab:coverage:off$
                        if (context.stack.length !== 1) {
                            throw new Error('unexpected item on context stack');
                        }
                        // $lab:coverage:on$

                        if (parseData.local.length === 0) {
                            // Fatal error
                            updateResult(internals.diagnoses.errNoLocalPart);
                        } else if (elementLength === 0) {
                            // Fatal error
                            updateResult(internals.diagnoses.errDotEnd);
                        }
                        // http://tools.ietf.org/html/rfc5321#section-4.5.3.1.1 the maximum total length of a user name or other local-part is 64
                        //    octets
                        else if (Buffer.byteLength(parseData.local, 'utf8') > 64) {
                                updateResult(internals.diagnoses.rfc5322LocalTooLong);
                            }
                            // http://tools.ietf.org/html/rfc5322#section-3.4.1 comments and folding white space SHOULD NOT be used around "@" in the
                            //    addr-spec
                            //
                            // http://tools.ietf.org/html/rfc2119
                            // 4. SHOULD NOT this phrase, or the phrase "NOT RECOMMENDED" mean that there may exist valid reasons in particular
                            //    circumstances when the particular behavior is acceptable or even useful, but the full implications should be understood
                            //    and the case carefully weighed before implementing any behavior described with this label.
                            else if (context.prev === internals.components.contextComment || context.prev === internals.components.contextFWS) {
                                    updateResult(internals.diagnoses.deprecatedCFWSNearAt);
                                }

                        // Clear everything down for the domain parsing
                        context.now = internals.components.domain;
                        context.stack[0] = internals.components.domain;
                        elementCount = 0;
                        elementLength = 0;
                        assertEnd = false; // CFWS can only appear at the end of the element
                        break;

                    // ATEXT
                    default:
                        // http://tools.ietf.org/html/rfc5322#section-3.2.3
                        //    atext = ALPHA / DIGIT / ; Printable US-ASCII
                        //            "!" / "#" /     ;  characters not including
                        //            "$" / "%" /     ;  specials.  Used for atoms.
                        //            "&" / "'" /
                        //            "*" / "+" /
                        //            "-" / "/" /
                        //            "=" / "?" /
                        //            "^" / "_" /
                        //            "`" / "{" /
                        //            "|" / "}" /
                        //            "~"
                        if (assertEnd) {
                            // We have encountered atext where it is no longer valid
                            switch (context.prev) {
                                case internals.components.contextComment:
                                case internals.components.contextFWS:
                                    updateResult(internals.diagnoses.errATEXTAfterCFWS);
                                    break;

                                case internals.components.contextQuotedString:
                                    updateResult(internals.diagnoses.errATEXTAfterQS);
                                    break;

                                // $lab:coverage:off$
                                default:
                                    throw new Error('more atext found where none is allowed, but unrecognized prev context: ' + context.prev);
                                // $lab:coverage:on$
                            }
                        } else {
                            context.prev = context.now;
                            charCode = token.codePointAt(0);

                            // Especially if charCode == 10
                            if (internals.specials(charCode) || internals.c0Controls(charCode) || internals.c1Controls(charCode)) {

                                // Fatal error
                                updateResult(internals.diagnoses.errExpectingATEXT);
                            }

                            parseData.local += token;
                            atomData.locals[elementCount] += token;
                            elementLength += Buffer.byteLength(token, 'utf8');
                        }
                }

                break;

            case internals.components.domain:
                // http://tools.ietf.org/html/rfc5322#section-3.4.1
                //   domain          =   dot-atom / domain-literal / obs-domain
                //
                //   dot-atom        =   [CFWS] dot-atom-text [CFWS]
                //
                //   dot-atom-text   =   1*atext *("." 1*atext)
                //
                //   domain-literal  =   [CFWS] "[" *([FWS] dtext) [FWS] "]" [CFWS]
                //
                //   dtext           =   %d33-90 /          ; Printable US-ASCII
                //                       %d94-126 /         ;  characters not including
                //                       obs-dtext          ;  "[", "]", or "\"
                //
                //   obs-domain      =   atom *("." atom)
                //
                //   atom            =   [CFWS] 1*atext [CFWS]

                // http://tools.ietf.org/html/rfc5321#section-4.1.2
                //   Mailbox        = Local-part "@" ( Domain / address-literal )
                //
                //   Domain         = sub-domain *("." sub-domain)
                //
                //   address-literal  = "[" ( IPv4-address-literal /
                //                    IPv6-address-literal /
                //                    General-address-literal ) "]"
                //                    ; See Section 4.1.3

                // http://tools.ietf.org/html/rfc5322#section-3.4.1
                //      Note: A liberal syntax for the domain portion of addr-spec is
                //      given here.  However, the domain portion contains addressing
                //      information specified by and used in other protocols (e.g.,
                //      [RFC1034], [RFC1035], [RFC1123], [RFC5321]).  It is therefore
                //      incumbent upon implementations to conform to the syntax of
                //      addresses for the context in which they are used.
                //
                // is_email() author's note: it's not clear how to interpret this in
                // he context of a general email address validator. The conclusion I
                // have reached is this: "addressing information" must comply with
                // RFC 5321 (and in turn RFC 1035), anything that is "semantically
                // invisible" must comply only with RFC 5322.
                switch (token) {
                    // Comment
                    case '(':
                        if (elementLength === 0) {
                            // Comments at the start of the domain are deprecated in the text, comments at the start of a subdomain are obs-domain
                            // http://tools.ietf.org/html/rfc5322#section-3.4.1
                            updateResult(elementCount === 0 ? internals.diagnoses.deprecatedCFWSNearAt : internals.diagnoses.deprecatedComment);
                        } else {
                            // We can't start a comment mid-element, better be at the end
                            assertEnd = true;
                            updateResult(internals.diagnoses.cfwsComment);
                        }

                        context.stack.push(context.now);
                        context.now = internals.components.contextComment;
                        break;

                    // Next dot-atom element
                    case '.':
                        var punycodeLength = Punycode.encode(atomData.domains[elementCount]).length;
                        if (elementLength === 0) {
                            // Another dot, already? Fatal error.
                            updateResult(elementCount === 0 ? internals.diagnoses.errDotStart : internals.diagnoses.errConsecutiveDots);
                        } else if (hyphenFlag) {
                            // Previous subdomain ended in a hyphen. Fatal error.
                            updateResult(internals.diagnoses.errDomainHyphenEnd);
                        } else if (punycodeLength > 63) {
                            // RFC 5890 specifies that domain labels that are encoded using the Punycode algorithm
                            // must adhere to the <= 63 octet requirement.
                            // This includes string prefixes from the Punycode algorithm.
                            //
                            // https://tools.ietf.org/html/rfc5890#section-2.3.2.1
                            // labels          63 octets or less

                            updateResult(internals.diagnoses.rfc5322LabelTooLong);
                        }

                        // CFWS is OK again now we're at the beginning of an element (although
                        // it may be obsolete CFWS)
                        assertEnd = false;
                        elementLength = 0;
                        ++elementCount;
                        atomData.domains[elementCount] = '';
                        parseData.domain += token;

                        break;

                    // Domain literal
                    case '[':
                        if (parseData.domain.length === 0) {
                            // Domain literal must be the only component
                            assertEnd = true;
                            elementLength += Buffer.byteLength(token, 'utf8');
                            context.stack.push(context.now);
                            context.now = internals.components.literal;
                            parseData.domain += token;
                            atomData.domains[elementCount] += token;
                            parseData.literal = '';
                        } else {
                            // Fatal error
                            updateResult(internals.diagnoses.errExpectingATEXT);
                        }

                        break;

                    // Folding white space
                    case '\r':
                        if (emailLength === ++i || email[i] !== '\n') {
                            // Fatal error
                            updateResult(internals.diagnoses.errCRNoLF);
                            break;
                        }

                    // Fallthrough

                    case ' ':
                    case '\t':
                        if (elementLength === 0) {
                            updateResult(elementCount === 0 ? internals.diagnoses.deprecatedCFWSNearAt : internals.diagnoses.deprecatedFWS);
                        } else {
                            // We can't start FWS in the middle of an element, so this better be the end
                            updateResult(internals.diagnoses.cfwsFWS);
                            assertEnd = true;
                        }

                        context.stack.push(context.now);
                        context.now = internals.components.contextFWS;
                        prevToken = token;
                        break;

                    // This must be ATEXT
                    default:
                        // RFC 5322 allows any atext...
                        // http://tools.ietf.org/html/rfc5322#section-3.2.3
                        //    atext = ALPHA / DIGIT / ; Printable US-ASCII
                        //            "!" / "#" /     ;  characters not including
                        //            "$" / "%" /     ;  specials.  Used for atoms.
                        //            "&" / "'" /
                        //            "*" / "+" /
                        //            "-" / "/" /
                        //            "=" / "?" /
                        //            "^" / "_" /
                        //            "`" / "{" /
                        //            "|" / "}" /
                        //            "~"

                        // But RFC 5321 only allows letter-digit-hyphen to comply with DNS rules
                        //   (RFCs 1034 & 1123)
                        // http://tools.ietf.org/html/rfc5321#section-4.1.2
                        //   sub-domain     = Let-dig [Ldh-str]
                        //
                        //   Let-dig        = ALPHA / DIGIT
                        //
                        //   Ldh-str        = *( ALPHA / DIGIT / "-" ) Let-dig
                        //
                        if (assertEnd) {
                            // We have encountered ATEXT where it is no longer valid
                            switch (context.prev) {
                                case internals.components.contextComment:
                                case internals.components.contextFWS:
                                    updateResult(internals.diagnoses.errATEXTAfterCFWS);
                                    break;

                                case internals.components.literal:
                                    updateResult(internals.diagnoses.errATEXTAfterDomainLiteral);
                                    break;

                                // $lab:coverage:off$
                                default:
                                    throw new Error('more atext found where none is allowed, but unrecognized prev context: ' + context.prev);
                                // $lab:coverage:on$
                            }
                        }

                        charCode = token.codePointAt(0);
                        // Assume this token isn't a hyphen unless we discover it is
                        hyphenFlag = false;

                        if (internals.specials(charCode) || internals.c0Controls(charCode) || internals.c1Controls(charCode)) {
                            // Fatal error
                            updateResult(internals.diagnoses.errExpectingATEXT);
                        } else if (token === '-') {
                            if (elementLength === 0) {
                                // Hyphens cannot be at the beginning of a subdomain, fatal error
                                updateResult(internals.diagnoses.errDomainHyphenStart);
                            }

                            hyphenFlag = true;
                        }
                        // Check if it's a neither a number nor a latin/unicode letter
                        else if (charCode < 48 || charCode > 122 && charCode < 192 || charCode > 57 && charCode < 65 || charCode > 90 && charCode < 97) {
                                // This is not an RFC 5321 subdomain, but still OK by RFC 5322
                                updateResult(internals.diagnoses.rfc5322Domain);
                            }

                        parseData.domain += token;
                        atomData.domains[elementCount] += token;
                        elementLength += Buffer.byteLength(token, 'utf8');
                }

                break;

            // Domain literal
            case internals.components.literal:
                // http://tools.ietf.org/html/rfc5322#section-3.4.1
                //   domain-literal  =   [CFWS] "[" *([FWS] dtext) [FWS] "]" [CFWS]
                //
                //   dtext           =   %d33-90 /          ; Printable US-ASCII
                //                       %d94-126 /         ;  characters not including
                //                       obs-dtext          ;  "[", "]", or "\"
                //
                //   obs-dtext       =   obs-NO-WS-CTL / quoted-pair
                switch (token) {
                    // End of domain literal
                    case ']':
                        if (maxResult < internals.categories.deprecated) {
                            // Could be a valid RFC 5321 address literal, so let's check

                            // http://tools.ietf.org/html/rfc5321#section-4.1.2
                            //   address-literal  = "[" ( IPv4-address-literal /
                            //                    IPv6-address-literal /
                            //                    General-address-literal ) "]"
                            //                    ; See Section 4.1.3
                            //
                            // http://tools.ietf.org/html/rfc5321#section-4.1.3
                            //   IPv4-address-literal  = Snum 3("."  Snum)
                            //
                            //   IPv6-address-literal  = "IPv6:" IPv6-addr
                            //
                            //   General-address-literal  = Standardized-tag ":" 1*dcontent
                            //
                            //   Standardized-tag  = Ldh-str
                            //                     ; Standardized-tag MUST be specified in a
                            //                     ; Standards-Track RFC and registered with IANA
                            //
                            //   dcontent      = %d33-90 / ; Printable US-ASCII
                            //                 %d94-126 ; excl. "[", "\", "]"
                            //
                            //   Snum          = 1*3DIGIT
                            //                 ; representing a decimal integer
                            //                 ; value in the range 0 through 255
                            //
                            //   IPv6-addr     = IPv6-full / IPv6-comp / IPv6v4-full / IPv6v4-comp
                            //
                            //   IPv6-hex      = 1*4HEXDIG
                            //
                            //   IPv6-full     = IPv6-hex 7(":" IPv6-hex)
                            //
                            //   IPv6-comp     = [IPv6-hex *5(":" IPv6-hex)] "::"
                            //                 [IPv6-hex *5(":" IPv6-hex)]
                            //                 ; The "::" represents at least 2 16-bit groups of
                            //                 ; zeros.  No more than 6 groups in addition to the
                            //                 ; "::" may be present.
                            //
                            //   IPv6v4-full   = IPv6-hex 5(":" IPv6-hex) ":" IPv4-address-literal
                            //
                            //   IPv6v4-comp   = [IPv6-hex *3(":" IPv6-hex)] "::"
                            //                 [IPv6-hex *3(":" IPv6-hex) ":"]
                            //                 IPv4-address-literal
                            //                 ; The "::" represents at least 2 16-bit groups of
                            //                 ; zeros.  No more than 4 groups in addition to the
                            //                 ; "::" and IPv4-address-literal may be present.

                            var index = -1;
                            var addressLiteral = parseData.literal;
                            var matchesIP = internals.regex.ipV4.exec(addressLiteral);

                            // Maybe extract IPv4 part from the end of the address-literal
                            if (matchesIP) {
                                index = matchesIP.index;
                                if (index !== 0) {
                                    // Convert IPv4 part to IPv6 format for futher testing
                                    addressLiteral = addressLiteral.slice(0, index) + '0:0';
                                }
                            }

                            if (index === 0) {
                                // Nothing there except a valid IPv4 address, so...
                                updateResult(internals.diagnoses.rfc5321AddressLiteral);
                            } else if (addressLiteral.slice(0, 5).toLowerCase() !== 'ipv6:') {
                                updateResult(internals.diagnoses.rfc5322DomainLiteral);
                            } else {
                                var match = addressLiteral.slice(5);
                                var maxGroups = internals.maxIPv6Groups;
                                var groups = match.split(':');
                                index = match.indexOf('::');

                                if (!~index) {
                                    // Need exactly the right number of groups
                                    if (groups.length !== maxGroups) {
                                        updateResult(internals.diagnoses.rfc5322IPv6GroupCount);
                                    }
                                } else if (index !== match.lastIndexOf('::')) {
                                    updateResult(internals.diagnoses.rfc5322IPv62x2xColon);
                                } else {
                                    if (index === 0 || index === match.length - 2) {
                                        // RFC 4291 allows :: at the start or end of an address with 7 other groups in addition
                                        ++maxGroups;
                                    }

                                    if (groups.length > maxGroups) {
                                        updateResult(internals.diagnoses.rfc5322IPv6MaxGroups);
                                    } else if (groups.length === maxGroups) {
                                        // Eliding a single "::"
                                        updateResult(internals.diagnoses.deprecatedIPv6);
                                    }
                                }

                                // IPv6 testing strategy
                                if (match[0] === ':' && match[1] !== ':') {
                                    updateResult(internals.diagnoses.rfc5322IPv6ColonStart);
                                } else if (match[match.length - 1] === ':' && match[match.length - 2] !== ':') {
                                    updateResult(internals.diagnoses.rfc5322IPv6ColonEnd);
                                } else if (internals.checkIpV6(groups)) {
                                    updateResult(internals.diagnoses.rfc5321AddressLiteral);
                                } else {
                                    updateResult(internals.diagnoses.rfc5322IPv6BadCharacter);
                                }
                            }
                        } else {
                            updateResult(internals.diagnoses.rfc5322DomainLiteral);
                        }

                        parseData.domain += token;
                        atomData.domains[elementCount] += token;
                        elementLength += Buffer.byteLength(token, 'utf8');
                        context.prev = context.now;
                        context.now = context.stack.pop();
                        break;

                    case '\\':
                        updateResult(internals.diagnoses.rfc5322DomainLiteralOBSDText);
                        context.stack.push(context.now);
                        context.now = internals.components.contextQuotedPair;
                        break;

                    // Folding white space
                    case '\r':
                        if (emailLength === ++i || email[i] !== '\n') {
                            updateResult(internals.diagnoses.errCRNoLF);
                            break;
                        }

                    // Fallthrough

                    case ' ':
                    case '\t':
                        updateResult(internals.diagnoses.cfwsFWS);

                        context.stack.push(context.now);
                        context.now = internals.components.contextFWS;
                        prevToken = token;
                        break;

                    // DTEXT
                    default:
                        // http://tools.ietf.org/html/rfc5322#section-3.4.1
                        //   dtext         =   %d33-90 /  ; Printable US-ASCII
                        //                     %d94-126 / ;  characters not including
                        //                     obs-dtext  ;  "[", "]", or "\"
                        //
                        //   obs-dtext     =   obs-NO-WS-CTL / quoted-pair
                        //
                        //   obs-NO-WS-CTL =   %d1-8 /    ; US-ASCII control
                        //                     %d11 /     ;  characters that do not
                        //                     %d12 /     ;  include the carriage
                        //                     %d14-31 /  ;  return, line feed, and
                        //                     %d127      ;  white space characters
                        charCode = token.codePointAt(0);

                        // '\r', '\n', ' ', and '\t' have already been parsed above
                        if (charCode !== 127 && internals.c1Controls(charCode) || charCode === 0 || token === '[') {
                            // Fatal error
                            updateResult(internals.diagnoses.errExpectingDTEXT);
                            break;
                        } else if (internals.c0Controls(charCode) || charCode === 127) {
                            updateResult(internals.diagnoses.rfc5322DomainLiteralOBSDText);
                        }

                        parseData.literal += token;
                        parseData.domain += token;
                        atomData.domains[elementCount] += token;
                        elementLength += Buffer.byteLength(token, 'utf8');
                }

                break;

            // Quoted string
            case internals.components.contextQuotedString:
                // http://tools.ietf.org/html/rfc5322#section-3.2.4
                //   quoted-string = [CFWS]
                //                   DQUOTE *([FWS] qcontent) [FWS] DQUOTE
                //                   [CFWS]
                //
                //   qcontent      = qtext / quoted-pair
                switch (token) {
                    // Quoted pair
                    case '\\':
                        context.stack.push(context.now);
                        context.now = internals.components.contextQuotedPair;
                        break;

                    // Folding white space. Spaces are allowed as regular characters inside a quoted string - it's only FWS if we include '\t' or '\r\n'
                    case '\r':
                        if (emailLength === ++i || email[i] !== '\n') {
                            // Fatal error
                            updateResult(internals.diagnoses.errCRNoLF);
                            break;
                        }

                    // Fallthrough

                    case '\t':
                        // http://tools.ietf.org/html/rfc5322#section-3.2.2
                        //   Runs of FWS, comment, or CFWS that occur between lexical tokens in
                        //   a structured header field are semantically interpreted as a single
                        //   space character.

                        // http://tools.ietf.org/html/rfc5322#section-3.2.4
                        //   the CRLF in any FWS/CFWS that appears within the quoted-string [is]
                        //   semantically "invisible" and therefore not part of the
                        //   quoted-string

                        parseData.local += ' ';
                        atomData.locals[elementCount] += ' ';
                        elementLength += Buffer.byteLength(token, 'utf8');

                        updateResult(internals.diagnoses.cfwsFWS);
                        context.stack.push(context.now);
                        context.now = internals.components.contextFWS;
                        prevToken = token;
                        break;

                    // End of quoted string
                    case '"':
                        parseData.local += token;
                        atomData.locals[elementCount] += token;
                        elementLength += Buffer.byteLength(token, 'utf8');
                        context.prev = context.now;
                        context.now = context.stack.pop();
                        break;

                    // QTEXT
                    default:
                        // http://tools.ietf.org/html/rfc5322#section-3.2.4
                        //   qtext          =   %d33 /             ; Printable US-ASCII
                        //                      %d35-91 /          ;  characters not including
                        //                      %d93-126 /         ;  "\" or the quote character
                        //                      obs-qtext
                        //
                        //   obs-qtext      =   obs-NO-WS-CTL
                        //
                        //   obs-NO-WS-CTL  =   %d1-8 /            ; US-ASCII control
                        //                      %d11 /             ;  characters that do not
                        //                      %d12 /             ;  include the carriage
                        //                      %d14-31 /          ;  return, line feed, and
                        //                      %d127              ;  white space characters
                        charCode = token.codePointAt(0);

                        if (charCode !== 127 && internals.c1Controls(charCode) || charCode === 0 || charCode === 10) {
                            updateResult(internals.diagnoses.errExpectingQTEXT);
                        } else if (internals.c0Controls(charCode) || charCode === 127) {
                            updateResult(internals.diagnoses.deprecatedQTEXT);
                        }

                        parseData.local += token;
                        atomData.locals[elementCount] += token;
                        elementLength += Buffer.byteLength(token, 'utf8');
                }

                // http://tools.ietf.org/html/rfc5322#section-3.4.1
                //   If the string can be represented as a dot-atom (that is, it contains
                //   no characters other than atext characters or "." surrounded by atext
                //   characters), then the dot-atom form SHOULD be used and the quoted-
                //   string form SHOULD NOT be used.

                break;
            // Quoted pair
            case internals.components.contextQuotedPair:
                // http://tools.ietf.org/html/rfc5322#section-3.2.1
                //   quoted-pair     =   ("\" (VCHAR / WSP)) / obs-qp
                //
                //   VCHAR           =  %d33-126   ; visible (printing) characters
                //   WSP             =  SP / HTAB  ; white space
                //
                //   obs-qp          =   "\" (%d0 / obs-NO-WS-CTL / LF / CR)
                //
                //   obs-NO-WS-CTL   =   %d1-8 /   ; US-ASCII control
                //                       %d11 /    ;  characters that do not
                //                       %d12 /    ;  include the carriage
                //                       %d14-31 / ;  return, line feed, and
                //                       %d127     ;  white space characters
                //
                // i.e. obs-qp       =  "\" (%d0-8, %d10-31 / %d127)
                charCode = token.codePointAt(0);

                if (charCode !== 127 && internals.c1Controls(charCode)) {
                    // Fatal error
                    updateResult(internals.diagnoses.errExpectingQPair);
                } else if (charCode < 31 && charCode !== 9 || charCode === 127) {
                    // ' ' and '\t' are allowed
                    updateResult(internals.diagnoses.deprecatedQP);
                }

                // At this point we know where this qpair occurred so we could check to see if the character actually needed to be quoted at all.
                // http://tools.ietf.org/html/rfc5321#section-4.1.2
                //   the sending system SHOULD transmit the form that uses the minimum quoting possible.

                context.prev = context.now;
                // End of qpair
                context.now = context.stack.pop();
                var escapeToken = '\\' + token;

                switch (context.now) {
                    case internals.components.contextComment:
                        break;

                    case internals.components.contextQuotedString:
                        parseData.local += escapeToken;
                        atomData.locals[elementCount] += escapeToken;

                        // The maximum sizes specified by RFC 5321 are octet counts, so we must include the backslash
                        elementLength += 2;
                        break;

                    case internals.components.literal:
                        parseData.domain += escapeToken;
                        atomData.domains[elementCount] += escapeToken;

                        // The maximum sizes specified by RFC 5321 are octet counts, so we must include the backslash
                        elementLength += 2;
                        break;

                    // $lab:coverage:off$
                    default:
                        throw new Error('quoted pair logic invoked in an invalid context: ' + context.now);
                    // $lab:coverage:on$
                }
                break;

            // Comment
            case internals.components.contextComment:
                // http://tools.ietf.org/html/rfc5322#section-3.2.2
                //   comment  = "(" *([FWS] ccontent) [FWS] ")"
                //
                //   ccontent = ctext / quoted-pair / comment
                switch (token) {
                    // Nested comment
                    case '(':
                        // Nested comments are ok
                        context.stack.push(context.now);
                        context.now = internals.components.contextComment;
                        break;

                    // End of comment
                    case ')':
                        context.prev = context.now;
                        context.now = context.stack.pop();
                        break;

                    // Quoted pair
                    case '\\':
                        context.stack.push(context.now);
                        context.now = internals.components.contextQuotedPair;
                        break;

                    // Folding white space
                    case '\r':
                        if (emailLength === ++i || email[i] !== '\n') {
                            // Fatal error
                            updateResult(internals.diagnoses.errCRNoLF);
                            break;
                        }

                    // Fallthrough

                    case ' ':
                    case '\t':
                        updateResult(internals.diagnoses.cfwsFWS);

                        context.stack.push(context.now);
                        context.now = internals.components.contextFWS;
                        prevToken = token;
                        break;

                    // CTEXT
                    default:
                        // http://tools.ietf.org/html/rfc5322#section-3.2.3
                        //   ctext         = %d33-39 /  ; Printable US-ASCII
                        //                   %d42-91 /  ;  characters not including
                        //                   %d93-126 / ;  "(", ")", or "\"
                        //                   obs-ctext
                        //
                        //   obs-ctext     = obs-NO-WS-CTL
                        //
                        //   obs-NO-WS-CTL = %d1-8 /    ; US-ASCII control
                        //                   %d11 /     ;  characters that do not
                        //                   %d12 /     ;  include the carriage
                        //                   %d14-31 /  ;  return, line feed, and
                        //                   %d127      ;  white space characters
                        charCode = token.codePointAt(0);

                        if (charCode === 0 || charCode === 10 || charCode !== 127 && internals.c1Controls(charCode)) {
                            // Fatal error
                            updateResult(internals.diagnoses.errExpectingCTEXT);
                            break;
                        } else if (internals.c0Controls(charCode) || charCode === 127) {
                            updateResult(internals.diagnoses.deprecatedCTEXT);
                        }
                }

                break;

            // Folding white space
            case internals.components.contextFWS:
                // http://tools.ietf.org/html/rfc5322#section-3.2.2
                //   FWS     =   ([*WSP CRLF] 1*WSP) /  obs-FWS
                //                                   ; Folding white space

                // But note the erratum:
                // http://www.rfc-editor.org/errata_search.php?rfc=5322&eid=1908:
                //   In the obsolete syntax, any amount of folding white space MAY be
                //   inserted where the obs-FWS rule is allowed.  This creates the
                //   possibility of having two consecutive "folds" in a line, and
                //   therefore the possibility that a line which makes up a folded header
                //   field could be composed entirely of white space.
                //
                //   obs-FWS =   1*([CRLF] WSP)

                if (prevToken === '\r') {
                    if (token === '\r') {
                        // Fatal error
                        updateResult(internals.diagnoses.errFWSCRLFx2);
                        break;
                    }

                    if (++crlfCount > 1) {
                        // Multiple folds => obsolete FWS
                        updateResult(internals.diagnoses.deprecatedFWS);
                    } else {
                        crlfCount = 1;
                    }
                }

                switch (token) {
                    case '\r':
                        if (emailLength === ++i || email[i] !== '\n') {
                            // Fatal error
                            updateResult(internals.diagnoses.errCRNoLF);
                        }

                        break;

                    case ' ':
                    case '\t':
                        break;

                    default:
                        if (prevToken === '\r') {
                            // Fatal error
                            updateResult(internals.diagnoses.errFWSCRLFEnd);
                        }

                        crlfCount = 0;

                        // End of FWS
                        context.prev = context.now;
                        context.now = context.stack.pop();

                        // Look at this token again in the parent context
                        --i;
                }

                prevToken = token;
                break;

            // Unexpected context
            // $lab:coverage:off$
            default:
                throw new Error('unknown context: ' + context.now);
            // $lab:coverage:on$
        } // Primary state machine

        if (maxResult > internals.categories.rfc5322) {
            // Fatal error, no point continuing
            break;
        }
    } // Token loop

    // Check for errors
    if (maxResult < internals.categories.rfc5322) {
        var _punycodeLength = Punycode.encode(parseData.domain).length;
        // Fatal errors
        if (context.now === internals.components.contextQuotedString) {
            updateResult(internals.diagnoses.errUnclosedQuotedString);
        } else if (context.now === internals.components.contextQuotedPair) {
            updateResult(internals.diagnoses.errBackslashEnd);
        } else if (context.now === internals.components.contextComment) {
            updateResult(internals.diagnoses.errUnclosedComment);
        } else if (context.now === internals.components.literal) {
            updateResult(internals.diagnoses.errUnclosedDomainLiteral);
        } else if (token === '\r') {
            updateResult(internals.diagnoses.errFWSCRLFEnd);
        } else if (parseData.domain.length === 0) {
            updateResult(internals.diagnoses.errNoDomain);
        } else if (elementLength === 0) {
            updateResult(internals.diagnoses.errDotEnd);
        } else if (hyphenFlag) {
            updateResult(internals.diagnoses.errDomainHyphenEnd);
        }

        // Other errors
        else if (_punycodeLength > 255) {
                // http://tools.ietf.org/html/rfc5321#section-4.5.3.1.2
                //   The maximum total length of a domain name or number is 255 octets.
                updateResult(internals.diagnoses.rfc5322DomainTooLong);
            } else if (Buffer.byteLength(parseData.local, 'utf8') + _punycodeLength + /* '@' */1 > 254) {
                // http://tools.ietf.org/html/rfc5321#section-4.1.2
                //   Forward-path   = Path
                //
                //   Path           = "<" [ A-d-l ":" ] Mailbox ">"
                //
                // http://tools.ietf.org/html/rfc5321#section-4.5.3.1.3
                //   The maximum total length of a reverse-path or forward-path is 256 octets (including the punctuation and element separators).
                //
                // Thus, even without (obsolete) routing information, the Mailbox can only be 254 characters long. This is confirmed by this verified
                // erratum to RFC 3696:
                //
                // http://www.rfc-editor.org/errata_search.php?rfc=3696&eid=1690
                //   However, there is a restriction in RFC 2821 on the length of an address in MAIL and RCPT commands of 254 characters.  Since
                //   addresses that do not fit in those fields are not normally useful, the upper limit on address lengths should normally be considered
                //   to be 254.
                updateResult(internals.diagnoses.rfc5322TooLong);
            } else if (elementLength > 63) {
                // http://tools.ietf.org/html/rfc1035#section-2.3.4
                // labels   63 octets or less
                updateResult(internals.diagnoses.rfc5322LabelTooLong);
            } else if (options.minDomainAtoms && atomData.domains.length < options.minDomainAtoms) {
                updateResult(internals.diagnoses.errDomainTooShort);
            } else if (options.tldWhitelist || options.tldBlacklist) {
                var tldAtom = atomData.domains[elementCount];

                if (!internals.validDomain(tldAtom, options)) {
                    updateResult(internals.diagnoses.errUnknownTLD);
                }
            }
    } // Check for errors

    // Finish
    if (maxResult < internals.categories.dnsWarn) {
        // Per RFC 5321, domain atoms are limited to letter-digit-hyphen, so we only need to check code <= 57 to check for a digit
        var code = atomData.domains[elementCount].codePointAt(0);

        if (code <= 57) {
            updateResult(internals.diagnoses.rfc5321TLDNumeric);
        }
    }

    if (maxResult < threshold) {
        maxResult = internals.diagnoses.valid;
    }

    var finishResult = diagnose ? maxResult : maxResult < internals.defaultThreshold;

    // $lab:coverage:off$
    if (callback) {
        callback(finishResult);
    }
    // $lab:coverage:on$

    return finishResult;
};

exports.diagnoses = internals.validate.diagnoses = function () {

    var diag = {};
    var keys = Object.keys(internals.diagnoses);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        diag[key] = internals.diagnoses[key];
    }

    return diag;
}();

exports.normalize = internals.normalize;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules


// Declare internals

var internals = {};

exports.errors = {
    root: 'value',
    key: '"{{!label}}" ',
    messages: {
        wrapArrays: true
    },
    any: {
        unknown: 'is not allowed',
        invalid: 'contains an invalid value',
        empty: 'is not allowed to be empty',
        required: 'is required',
        allowOnly: 'must be one of {{valids}}',
        default: 'threw an error when running default method'
    },
    alternatives: {
        base: 'not matching any of the allowed alternatives',
        child: null
    },
    array: {
        base: 'must be an array',
        includes: 'at position {{pos}} does not match any of the allowed types',
        includesSingle: 'single value of "{{!label}}" does not match any of the allowed types',
        includesOne: 'at position {{pos}} fails because {{reason}}',
        includesOneSingle: 'single value of "{{!label}}" fails because {{reason}}',
        includesRequiredUnknowns: 'does not contain {{unknownMisses}} required value(s)',
        includesRequiredKnowns: 'does not contain {{knownMisses}}',
        includesRequiredBoth: 'does not contain {{knownMisses}} and {{unknownMisses}} other required value(s)',
        excludes: 'at position {{pos}} contains an excluded value',
        excludesSingle: 'single value of "{{!label}}" contains an excluded value',
        min: 'must contain at least {{limit}} items',
        max: 'must contain less than or equal to {{limit}} items',
        length: 'must contain {{limit}} items',
        ordered: 'at position {{pos}} fails because {{reason}}',
        orderedLength: 'at position {{pos}} fails because array must contain at most {{limit}} items',
        ref: 'references "{{ref}}" which is not a positive integer',
        sparse: 'must not be a sparse array',
        unique: 'position {{pos}} contains a duplicate value'
    },
    boolean: {
        base: 'must be a boolean'
    },
    binary: {
        base: 'must be a buffer or a string',
        min: 'must be at least {{limit}} bytes',
        max: 'must be less than or equal to {{limit}} bytes',
        length: 'must be {{limit}} bytes'
    },
    date: {
        base: 'must be a number of milliseconds or valid date string',
        format: 'must be a string with one of the following formats {{format}}',
        strict: 'must be a valid date',
        min: 'must be larger than or equal to "{{limit}}"',
        max: 'must be less than or equal to "{{limit}}"',
        less: 'must be less than "{{limit}}"',
        greater: 'must be greater than "{{limit}}"',
        isoDate: 'must be a valid ISO 8601 date',
        timestamp: {
            javascript: 'must be a valid timestamp or number of milliseconds',
            unix: 'must be a valid timestamp or number of seconds'
        },
        ref: 'references "{{ref}}" which is not a date'
    },
    function: {
        base: 'must be a Function',
        arity: 'must have an arity of {{n}}',
        minArity: 'must have an arity greater or equal to {{n}}',
        maxArity: 'must have an arity lesser or equal to {{n}}',
        ref: 'must be a Joi reference',
        class: 'must be a class'
    },
    lazy: {
        base: '!!schema error: lazy schema must be set',
        schema: '!!schema error: lazy schema function must return a schema'
    },
    object: {
        base: 'must be an object',
        child: '!!child "{{!child}}" fails because {{reason}}',
        min: 'must have at least {{limit}} children',
        max: 'must have less than or equal to {{limit}} children',
        length: 'must have {{limit}} children',
        allowUnknown: '!!"{{!child}}" is not allowed',
        with: '!!"{{mainWithLabel}}" missing required peer "{{peerWithLabel}}"',
        without: '!!"{{mainWithLabel}}" conflict with forbidden peer "{{peerWithLabel}}"',
        missing: 'must contain at least one of {{peersWithLabels}}',
        xor: 'contains a conflict between exclusive peers {{peersWithLabels}}',
        or: 'must contain at least one of {{peersWithLabels}}',
        and: 'contains {{presentWithLabels}} without its required peers {{missingWithLabels}}',
        nand: '!!"{{mainWithLabel}}" must not exist simultaneously with {{peersWithLabels}}',
        assert: '!!"{{ref}}" validation failed because "{{ref}}" failed to {{message}}',
        rename: {
            multiple: 'cannot rename child "{{from}}" because multiple renames are disabled and another key was already renamed to "{{to}}"',
            override: 'cannot rename child "{{from}}" because override is disabled and target "{{to}}" exists',
            regex: {
                multiple: 'cannot rename children {{from}} because multiple renames are disabled and another key was already renamed to "{{to}}"',
                override: 'cannot rename children {{from}} because override is disabled and target "{{to}}" exists'
            }
        },
        type: 'must be an instance of "{{type}}"',
        schema: 'must be a Joi instance'
    },
    number: {
        base: 'must be a number',
        min: 'must be larger than or equal to {{limit}}',
        max: 'must be less than or equal to {{limit}}',
        less: 'must be less than {{limit}}',
        greater: 'must be greater than {{limit}}',
        float: 'must be a float or double',
        integer: 'must be an integer',
        negative: 'must be a negative number',
        positive: 'must be a positive number',
        precision: 'must have no more than {{limit}} decimal places',
        ref: 'references "{{ref}}" which is not a number',
        multiple: 'must be a multiple of {{multiple}}',
        port: 'must be a valid port'
    },
    string: {
        base: 'must be a string',
        min: 'length must be at least {{limit}} characters long',
        max: 'length must be less than or equal to {{limit}} characters long',
        length: 'length must be {{limit}} characters long',
        alphanum: 'must only contain alpha-numeric characters',
        token: 'must only contain alpha-numeric and underscore characters',
        regex: {
            base: 'with value "{{!value}}" fails to match the required pattern: {{pattern}}',
            name: 'with value "{{!value}}" fails to match the {{name}} pattern',
            invert: {
                base: 'with value "{{!value}}" matches the inverted pattern: {{pattern}}',
                name: 'with value "{{!value}}" matches the inverted {{name}} pattern'
            }
        },
        email: 'must be a valid email',
        uri: 'must be a valid uri',
        uriRelativeOnly: 'must be a valid relative uri',
        uriCustomScheme: 'must be a valid uri with a scheme matching the {{scheme}} pattern',
        isoDate: 'must be a valid ISO 8601 date',
        guid: 'must be a valid GUID',
        hex: 'must only contain hexadecimal characters',
        hexAlign: 'hex decoded representation must be byte aligned',
        base64: 'must be a valid base64 string',
        hostname: 'must be a valid hostname',
        normalize: 'must be unicode normalized in the {{form}} form',
        lowercase: 'must only contain lowercase characters',
        uppercase: 'must only contain uppercase characters',
        trim: 'must not have leading or trailing whitespace',
        creditCard: 'must be a credit card',
        ref: 'references "{{ref}}" which is not a number',
        ip: 'must be a valid ip address with a {{cidr}} CIDR',
        ipVersion: 'must be a valid ip address of one of the following versions {{version}} with a {{cidr}} CIDR'
    }
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var Joi = __webpack_require__(8);

// Declare internals

var internals = {};

exports.options = Joi.object({
    abortEarly: Joi.boolean(),
    convert: Joi.boolean(),
    allowUnknown: Joi.boolean(),
    skipFunctions: Joi.boolean(),
    stripUnknown: [Joi.boolean(), Joi.object({ arrays: Joi.boolean(), objects: Joi.boolean() }).or('arrays', 'objects')],
    language: Joi.object(),
    presence: Joi.string().only('required', 'optional', 'forbidden', 'ignore'),
    raw: Joi.boolean(),
    context: Joi.object(),
    strip: Joi.boolean(),
    noDefaults: Joi.boolean(),
    escapeHtml: Joi.boolean()
}).strict();

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Any = __webpack_require__(2);
var Cast = __webpack_require__(4);
var Ref = __webpack_require__(1);
var Hoek = __webpack_require__(0);

// Declare internals

var internals = {};

internals.fastSplice = function (arr, i) {

    var pos = i;
    while (pos < arr.length) {
        arr[pos++] = arr[pos];
    }

    --arr.length;
};

internals.Array = function (_Any) {
    _inherits(_class, _Any);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _Any.call(this));

        _this._type = 'array';
        _this._inner.items = [];
        _this._inner.ordereds = [];
        _this._inner.inclusions = [];
        _this._inner.exclusions = [];
        _this._inner.requireds = [];
        _this._flags.sparse = false;
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var result = {
            value: value
        };

        if (typeof value === 'string' && options.convert) {

            internals.safeParse(value, result);
        }

        var isArray = Array.isArray(result.value);
        var wasArray = isArray;
        if (options.convert && this._flags.single && !isArray) {
            result.value = [result.value];
            isArray = true;
        }

        if (!isArray) {
            result.errors = this.createError('array.base', null, state, options);
            return result;
        }

        if (this._inner.inclusions.length || this._inner.exclusions.length || this._inner.requireds.length || this._inner.ordereds.length || !this._flags.sparse) {

            // Clone the array so that we don't modify the original
            if (wasArray) {
                result.value = result.value.slice(0);
            }

            result.errors = this._checkItems.call(this, result.value, wasArray, state, options);

            if (result.errors && wasArray && options.convert && this._flags.single) {

                // Attempt a 2nd pass by putting the array inside one.
                var previousErrors = result.errors;

                result.value = [result.value];
                result.errors = this._checkItems.call(this, result.value, wasArray, state, options);

                if (result.errors) {

                    // Restore previous errors and value since this didn't validate either.
                    result.errors = previousErrors;
                    result.value = result.value[0];
                }
            }
        }

        return result;
    };

    _class.prototype._checkItems = function _checkItems(items, wasArray, state, options) {

        var errors = [];
        var errored = void 0;

        var requireds = this._inner.requireds.slice();
        var ordereds = this._inner.ordereds.slice();
        var inclusions = this._inner.inclusions.concat(requireds);

        var il = items.length;
        for (var i = 0; i < il; ++i) {
            errored = false;
            var item = items[i];
            var isValid = false;
            var key = wasArray ? i : state.key;
            var path = wasArray ? state.path.concat(i) : state.path;
            var localState = { key: key, path: path, parent: state.parent, reference: state.reference };
            var res = void 0;

            // Sparse

            if (!this._flags.sparse && item === undefined) {
                errors.push(this.createError('array.sparse', null, { key: state.key, path: localState.path, pos: i }, options));

                if (options.abortEarly) {
                    return errors;
                }

                ordereds.shift();

                continue;
            }

            // Exclusions

            for (var j = 0; j < this._inner.exclusions.length; ++j) {
                res = this._inner.exclusions[j]._validate(item, localState, {}); // Not passing options to use defaults

                if (!res.errors) {
                    errors.push(this.createError(wasArray ? 'array.excludes' : 'array.excludesSingle', { pos: i, value: item }, { key: state.key, path: localState.path }, options));
                    errored = true;

                    if (options.abortEarly) {
                        return errors;
                    }

                    ordereds.shift();

                    break;
                }
            }

            if (errored) {
                continue;
            }

            // Ordered
            if (this._inner.ordereds.length) {
                if (ordereds.length > 0) {
                    var ordered = ordereds.shift();
                    res = ordered._validate(item, localState, options);
                    if (!res.errors) {
                        if (ordered._flags.strip) {
                            internals.fastSplice(items, i);
                            --i;
                            --il;
                        } else if (!this._flags.sparse && res.value === undefined) {
                            errors.push(this.createError('array.sparse', null, { key: state.key, path: localState.path, pos: i }, options));

                            if (options.abortEarly) {
                                return errors;
                            }

                            continue;
                        } else {
                            items[i] = res.value;
                        }
                    } else {
                        errors.push(this.createError('array.ordered', { pos: i, reason: res.errors, value: item }, { key: state.key, path: localState.path }, options));
                        if (options.abortEarly) {
                            return errors;
                        }
                    }
                    continue;
                } else if (!this._inner.items.length) {
                    errors.push(this.createError('array.orderedLength', { pos: i, limit: this._inner.ordereds.length }, { key: state.key, path: localState.path }, options));
                    if (options.abortEarly) {
                        return errors;
                    }
                    continue;
                }
            }

            // Requireds

            var requiredChecks = [];
            var jl = requireds.length;
            for (var _j = 0; _j < jl; ++_j) {
                res = requiredChecks[_j] = requireds[_j]._validate(item, localState, options);
                if (!res.errors) {
                    items[i] = res.value;
                    isValid = true;
                    internals.fastSplice(requireds, _j);
                    --_j;
                    --jl;

                    if (!this._flags.sparse && res.value === undefined) {
                        errors.push(this.createError('array.sparse', null, { key: state.key, path: localState.path, pos: i }, options));

                        if (options.abortEarly) {
                            return errors;
                        }
                    }

                    break;
                }
            }

            if (isValid) {
                continue;
            }

            // Inclusions

            var stripUnknown = options.stripUnknown ? options.stripUnknown === true ? true : !!options.stripUnknown.arrays : false;

            jl = inclusions.length;
            for (var _j2 = 0; _j2 < jl; ++_j2) {
                var inclusion = inclusions[_j2];

                // Avoid re-running requireds that already didn't match in the previous loop
                var previousCheck = requireds.indexOf(inclusion);
                if (previousCheck !== -1) {
                    res = requiredChecks[previousCheck];
                } else {
                    res = inclusion._validate(item, localState, options);

                    if (!res.errors) {
                        if (inclusion._flags.strip) {
                            internals.fastSplice(items, i);
                            --i;
                            --il;
                        } else if (!this._flags.sparse && res.value === undefined) {
                            errors.push(this.createError('array.sparse', null, { key: state.key, path: localState.path, pos: i }, options));
                            errored = true;
                        } else {
                            items[i] = res.value;
                        }
                        isValid = true;
                        break;
                    }
                }

                // Return the actual error if only one inclusion defined
                if (jl === 1) {
                    if (stripUnknown) {
                        internals.fastSplice(items, i);
                        --i;
                        --il;
                        isValid = true;
                        break;
                    }

                    errors.push(this.createError(wasArray ? 'array.includesOne' : 'array.includesOneSingle', { pos: i, reason: res.errors, value: item }, { key: state.key, path: localState.path }, options));
                    errored = true;

                    if (options.abortEarly) {
                        return errors;
                    }

                    break;
                }
            }

            if (errored) {
                continue;
            }

            if (this._inner.inclusions.length && !isValid) {
                if (stripUnknown) {
                    internals.fastSplice(items, i);
                    --i;
                    --il;
                    continue;
                }

                errors.push(this.createError(wasArray ? 'array.includes' : 'array.includesSingle', { pos: i, value: item }, { key: state.key, path: localState.path }, options));

                if (options.abortEarly) {
                    return errors;
                }
            }
        }

        if (requireds.length) {
            this._fillMissedErrors.call(this, errors, requireds, state, options);
        }

        if (ordereds.length) {
            this._fillOrderedErrors.call(this, errors, ordereds, state, options);
        }

        return errors.length ? errors : null;
    };

    _class.prototype.describe = function describe() {

        var description = Any.prototype.describe.call(this);

        if (this._inner.ordereds.length) {
            description.orderedItems = [];

            for (var i = 0; i < this._inner.ordereds.length; ++i) {
                description.orderedItems.push(this._inner.ordereds[i].describe());
            }
        }

        if (this._inner.items.length) {
            description.items = [];

            for (var _i = 0; _i < this._inner.items.length; ++_i) {
                description.items.push(this._inner.items[_i].describe());
            }
        }

        return description;
    };

    _class.prototype.items = function items() {
        var _this2 = this;

        var obj = this.clone();

        for (var _len = arguments.length, schemas = Array(_len), _key = 0; _key < _len; _key++) {
            schemas[_key] = arguments[_key];
        }

        Hoek.flatten(schemas).forEach(function (type, index) {

            try {
                type = Cast.schema(_this2._currentJoi, type);
            } catch (castErr) {
                if (castErr.hasOwnProperty('path')) {
                    castErr.path = index + '.' + castErr.path;
                } else {
                    castErr.path = index;
                }
                castErr.message = castErr.message + '(' + castErr.path + ')';
                throw castErr;
            }

            obj._inner.items.push(type);

            if (type._flags.presence === 'required') {
                obj._inner.requireds.push(type);
            } else if (type._flags.presence === 'forbidden') {
                obj._inner.exclusions.push(type.optional());
            } else {
                obj._inner.inclusions.push(type);
            }
        });

        return obj;
    };

    _class.prototype.ordered = function ordered() {
        var _this3 = this;

        var obj = this.clone();

        for (var _len2 = arguments.length, schemas = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            schemas[_key2] = arguments[_key2];
        }

        Hoek.flatten(schemas).forEach(function (type, index) {

            try {
                type = Cast.schema(_this3._currentJoi, type);
            } catch (castErr) {
                if (castErr.hasOwnProperty('path')) {
                    castErr.path = index + '.' + castErr.path;
                } else {
                    castErr.path = index;
                }
                castErr.message = castErr.message + '(' + castErr.path + ')';
                throw castErr;
            }
            obj._inner.ordereds.push(type);
        });

        return obj;
    };

    _class.prototype.min = function min(limit) {

        var isRef = Ref.isRef(limit);

        Hoek.assert(Number.isSafeInteger(limit) && limit >= 0 || isRef, 'limit must be a positive integer or reference');

        return this._test('min', limit, function (value, state, options) {

            var compareTo = void 0;
            if (isRef) {
                compareTo = limit(state.reference || state.parent, options);

                if (!(Number.isSafeInteger(compareTo) && compareTo >= 0)) {
                    return this.createError('array.ref', { ref: limit.key }, state, options);
                }
            } else {
                compareTo = limit;
            }

            if (value.length >= compareTo) {
                return value;
            }

            return this.createError('array.min', { limit: limit, value: value }, state, options);
        });
    };

    _class.prototype.max = function max(limit) {

        var isRef = Ref.isRef(limit);

        Hoek.assert(Number.isSafeInteger(limit) && limit >= 0 || isRef, 'limit must be a positive integer or reference');

        return this._test('max', limit, function (value, state, options) {

            var compareTo = void 0;
            if (isRef) {
                compareTo = limit(state.reference || state.parent, options);

                if (!(Number.isSafeInteger(compareTo) && compareTo >= 0)) {
                    return this.createError('array.ref', { ref: limit.key }, state, options);
                }
            } else {
                compareTo = limit;
            }

            if (value.length <= compareTo) {
                return value;
            }

            return this.createError('array.max', { limit: limit, value: value }, state, options);
        });
    };

    _class.prototype.length = function length(limit) {

        var isRef = Ref.isRef(limit);

        Hoek.assert(Number.isSafeInteger(limit) && limit >= 0 || isRef, 'limit must be a positive integer or reference');

        return this._test('length', limit, function (value, state, options) {

            var compareTo = void 0;
            if (isRef) {
                compareTo = limit(state.reference || state.parent, options);

                if (!(Number.isSafeInteger(compareTo) && compareTo >= 0)) {
                    return this.createError('array.ref', { ref: limit.key }, state, options);
                }
            } else {
                compareTo = limit;
            }

            if (value.length === compareTo) {
                return value;
            }

            return this.createError('array.length', { limit: limit, value: value }, state, options);
        });
    };

    _class.prototype.unique = function unique(comparator) {

        Hoek.assert(comparator === undefined || typeof comparator === 'function' || typeof comparator === 'string', 'comparator must be a function or a string');

        var settings = {};

        if (typeof comparator === 'string') {
            settings.path = comparator;
        } else if (typeof comparator === 'function') {
            settings.comparator = comparator;
        }

        return this._test('unique', settings, function (value, state, options) {

            var found = {
                string: Object.create(null),
                number: Object.create(null),
                undefined: Object.create(null),
                boolean: Object.create(null),
                object: new Map(),
                function: new Map(),
                custom: new Map()
            };

            var compare = settings.comparator || Hoek.deepEqual;

            for (var i = 0; i < value.length; ++i) {
                var item = settings.path ? Hoek.reach(value[i], settings.path) : value[i];
                var records = settings.comparator ? found.custom : found[typeof item === 'undefined' ? 'undefined' : _typeof(item)];

                // All available types are supported, so it's not possible to reach 100% coverage without ignoring this line.
                // I still want to keep the test for future js versions with new types (eg. Symbol).
                if ( /* $lab:coverage:off$ */records /* $lab:coverage:on$ */) {
                        if (records instanceof Map) {
                            var entries = records.entries();
                            var current = void 0;
                            while (!(current = entries.next()).done) {
                                if (compare(current.value[0], item)) {
                                    var localState = {
                                        key: state.key,
                                        path: state.path.concat(i),
                                        parent: state.parent,
                                        reference: state.reference
                                    };

                                    var context = {
                                        pos: i,
                                        value: value[i],
                                        dupePos: current.value[1],
                                        dupeValue: value[current.value[1]]
                                    };

                                    if (settings.path) {
                                        context.path = settings.path;
                                    }

                                    return this.createError('array.unique', context, localState, options);
                                }
                            }

                            records.set(item, i);
                        } else {
                            if (records[item] !== undefined) {
                                var _localState = {
                                    key: state.key,
                                    path: state.path.concat(i),
                                    parent: state.parent,
                                    reference: state.reference
                                };

                                var _context = {
                                    pos: i,
                                    value: value[i],
                                    dupePos: records[item],
                                    dupeValue: value[records[item]]
                                };

                                if (settings.path) {
                                    _context.path = settings.path;
                                }

                                return this.createError('array.unique', _context, _localState, options);
                            }

                            records[item] = i;
                        }
                    }
            }

            return value;
        });
    };

    _class.prototype.sparse = function sparse(enabled) {

        var value = enabled === undefined ? true : !!enabled;

        if (this._flags.sparse === value) {
            return this;
        }

        var obj = this.clone();
        obj._flags.sparse = value;
        return obj;
    };

    _class.prototype.single = function single(enabled) {

        var value = enabled === undefined ? true : !!enabled;

        if (this._flags.single === value) {
            return this;
        }

        var obj = this.clone();
        obj._flags.single = value;
        return obj;
    };

    _class.prototype._fillMissedErrors = function _fillMissedErrors(errors, requireds, state, options) {

        var knownMisses = [];
        var unknownMisses = 0;
        for (var i = 0; i < requireds.length; ++i) {
            var label = requireds[i]._getLabel();
            if (label) {
                knownMisses.push(label);
            } else {
                ++unknownMisses;
            }
        }

        if (knownMisses.length) {
            if (unknownMisses) {
                errors.push(this.createError('array.includesRequiredBoth', { knownMisses: knownMisses, unknownMisses: unknownMisses }, { key: state.key, path: state.path }, options));
            } else {
                errors.push(this.createError('array.includesRequiredKnowns', { knownMisses: knownMisses }, { key: state.key, path: state.path }, options));
            }
        } else {
            errors.push(this.createError('array.includesRequiredUnknowns', { unknownMisses: unknownMisses }, { key: state.key, path: state.path }, options));
        }
    };

    _class.prototype._fillOrderedErrors = function _fillOrderedErrors(errors, ordereds, state, options) {

        var requiredOrdereds = [];

        for (var i = 0; i < ordereds.length; ++i) {
            var presence = Hoek.reach(ordereds[i], '_flags.presence');
            if (presence === 'required') {
                requiredOrdereds.push(ordereds[i]);
            }
        }

        if (requiredOrdereds.length) {
            this._fillMissedErrors.call(this, errors, requiredOrdereds, state, options);
        }
    };

    return _class;
}(Any);

internals.safeParse = function (value, result) {

    try {
        var converted = JSON.parse(value);
        if (Array.isArray(converted)) {
            result.value = converted;
        }
    } catch (e) {}
};

module.exports = new internals.Array();

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

// Load modules

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Any = __webpack_require__(2);
var Hoek = __webpack_require__(0);

// Declare internals

var internals = {};

internals.Binary = function (_Any) {
    _inherits(_class, _Any);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _Any.call(this));

        _this._type = 'binary';
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var result = {
            value: value
        };

        if (typeof value === 'string' && options.convert) {

            try {
                result.value = Buffer.from(value, this._flags.encoding);
            } catch (e) {}
        }

        result.errors = Buffer.isBuffer(result.value) ? null : this.createError('binary.base', null, state, options);
        return result;
    };

    _class.prototype.encoding = function encoding(_encoding) {

        Hoek.assert(Buffer.isEncoding(_encoding), 'Invalid encoding:', _encoding);

        if (this._flags.encoding === _encoding) {
            return this;
        }

        var obj = this.clone();
        obj._flags.encoding = _encoding;
        return obj;
    };

    _class.prototype.min = function min(limit) {

        Hoek.assert(Number.isSafeInteger(limit) && limit >= 0, 'limit must be a positive integer');

        return this._test('min', limit, function (value, state, options) {

            if (value.length >= limit) {
                return value;
            }

            return this.createError('binary.min', { limit: limit, value: value }, state, options);
        });
    };

    _class.prototype.max = function max(limit) {

        Hoek.assert(Number.isSafeInteger(limit) && limit >= 0, 'limit must be a positive integer');

        return this._test('max', limit, function (value, state, options) {

            if (value.length <= limit) {
                return value;
            }

            return this.createError('binary.max', { limit: limit, value: value }, state, options);
        });
    };

    _class.prototype.length = function length(limit) {

        Hoek.assert(Number.isSafeInteger(limit) && limit >= 0, 'limit must be a positive integer');

        return this._test('length', limit, function (value, state, options) {

            if (value.length === limit) {
                return value;
            }

            return this.createError('binary.length', { limit: limit, value: value }, state, options);
        });
    };

    return _class;
}(Any);

module.exports = new internals.Binary();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Any = __webpack_require__(2);
var Hoek = __webpack_require__(0);

// Declare internals

var internals = {
    Set: __webpack_require__(9)
};

internals.Boolean = function (_Any) {
    _inherits(_class, _Any);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _Any.call(this));

        _this._type = 'boolean';
        _this._flags.insensitive = true;
        _this._inner.truthySet = new internals.Set();
        _this._inner.falsySet = new internals.Set();
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var result = {
            value: value
        };

        if (typeof value === 'string' && options.convert) {

            var normalized = this._flags.insensitive ? value.toLowerCase() : value;
            result.value = normalized === 'true' ? true : normalized === 'false' ? false : value;
        }

        if (typeof result.value !== 'boolean') {
            result.value = this._inner.truthySet.has(value, null, null, this._flags.insensitive) ? true : this._inner.falsySet.has(value, null, null, this._flags.insensitive) ? false : value;
        }

        result.errors = typeof result.value === 'boolean' ? null : this.createError('boolean.base', null, state, options);
        return result;
    };

    _class.prototype.truthy = function truthy() {
        for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
            values[_key] = arguments[_key];
        }

        var obj = this.clone();
        values = Hoek.flatten(values);
        for (var i = 0; i < values.length; ++i) {
            var value = values[i];

            Hoek.assert(value !== undefined, 'Cannot call truthy with undefined');
            obj._inner.truthySet.add(value);
        }
        return obj;
    };

    _class.prototype.falsy = function falsy() {
        for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            values[_key2] = arguments[_key2];
        }

        var obj = this.clone();
        values = Hoek.flatten(values);
        for (var i = 0; i < values.length; ++i) {
            var value = values[i];

            Hoek.assert(value !== undefined, 'Cannot call falsy with undefined');
            obj._inner.falsySet.add(value);
        }
        return obj;
    };

    _class.prototype.insensitive = function insensitive(enabled) {

        var insensitive = enabled === undefined ? true : !!enabled;

        if (this._flags.insensitive === insensitive) {
            return this;
        }

        var obj = this.clone();
        obj._flags.insensitive = insensitive;
        return obj;
    };

    _class.prototype.describe = function describe() {

        var description = Any.prototype.describe.call(this);
        description.truthy = [true].concat(this._inner.truthySet.values());
        description.falsy = [false].concat(this._inner.falsySet.values());
        return description;
    };

    return _class;
}(Any);

module.exports = new internals.Boolean();

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Hoek = __webpack_require__(0);
var ObjectType = __webpack_require__(13);
var Ref = __webpack_require__(1);

// Declare internals

var internals = {};

internals.Func = function (_ObjectType$construct) {
    _inherits(_class, _ObjectType$construct);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _ObjectType$construct.call(this));

        _this._flags.func = true;
        return _this;
    }

    _class.prototype.arity = function arity(n) {

        Hoek.assert(Number.isSafeInteger(n) && n >= 0, 'n must be a positive integer');

        return this._test('arity', n, function (value, state, options) {

            if (value.length === n) {
                return value;
            }

            return this.createError('function.arity', { n: n }, state, options);
        });
    };

    _class.prototype.minArity = function minArity(n) {

        Hoek.assert(Number.isSafeInteger(n) && n > 0, 'n must be a strict positive integer');

        return this._test('minArity', n, function (value, state, options) {

            if (value.length >= n) {
                return value;
            }

            return this.createError('function.minArity', { n: n }, state, options);
        });
    };

    _class.prototype.maxArity = function maxArity(n) {

        Hoek.assert(Number.isSafeInteger(n) && n >= 0, 'n must be a positive integer');

        return this._test('maxArity', n, function (value, state, options) {

            if (value.length <= n) {
                return value;
            }

            return this.createError('function.maxArity', { n: n }, state, options);
        });
    };

    _class.prototype.ref = function ref() {

        return this._test('ref', null, function (value, state, options) {

            if (Ref.isRef(value)) {
                return value;
            }

            return this.createError('function.ref', null, state, options);
        });
    };

    _class.prototype.class = function _class() {

        return this._test('class', null, function (value, state, options) {

            if (/^\s*class\s/.test(value.toString())) {
                return value;
            }

            return this.createError('function.class', null, state, options);
        });
    };

    return _class;
}(ObjectType.constructor);

module.exports = new internals.Func();

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Any = __webpack_require__(2);
var Hoek = __webpack_require__(0);

// Declare internals

var internals = {};

internals.Lazy = function (_Any) {
    _inherits(_class, _Any);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _Any.call(this));

        _this._type = 'lazy';
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var result = { value: value };
        var lazy = this._flags.lazy;

        if (!lazy) {
            result.errors = this.createError('lazy.base', null, state, options);
            return result;
        }

        var schema = lazy();

        if (!(schema instanceof Any)) {
            result.errors = this.createError('lazy.schema', null, state, options);
            return result;
        }

        return schema._validate(value, state, options);
    };

    _class.prototype.set = function set(fn) {

        Hoek.assert(typeof fn === 'function', 'You must provide a function as first argument');

        var obj = this.clone();
        obj._flags.lazy = fn;
        return obj;
    };

    return _class;
}(Any);

module.exports = new internals.Lazy();

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Any = __webpack_require__(2);
var Ref = __webpack_require__(1);
var Hoek = __webpack_require__(0);

// Declare internals

var internals = {
    precisionRx: /(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/
};

internals.Number = function (_Any) {
    _inherits(_class, _Any);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _Any.call(this));

        _this._type = 'number';
        _this._invalids.add(Infinity);
        _this._invalids.add(-Infinity);
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var result = {
            errors: null,
            value: value
        };

        if (typeof value === 'string' && options.convert) {

            var number = parseFloat(value);
            result.value = isNaN(number) || !isFinite(value) ? NaN : number;
        }

        var isNumber = typeof result.value === 'number' && !isNaN(result.value);

        if (options.convert && 'precision' in this._flags && isNumber) {

            // This is conceptually equivalent to using toFixed but it should be much faster
            var precision = Math.pow(10, this._flags.precision);
            result.value = Math.round(result.value * precision) / precision;
        }

        result.errors = isNumber ? null : this.createError('number.base', null, state, options);
        return result;
    };

    _class.prototype.multiple = function multiple(base) {

        var isRef = Ref.isRef(base);

        if (!isRef) {
            Hoek.assert(typeof base === 'number' && isFinite(base), 'multiple must be a number');
            Hoek.assert(base > 0, 'multiple must be greater than 0');
        }

        return this._test('multiple', base, function (value, state, options) {

            var divisor = isRef ? base(state.reference || state.parent, options) : base;

            if (isRef && (typeof divisor !== 'number' || !isFinite(divisor))) {
                return this.createError('number.ref', { ref: base.key }, state, options);
            }

            if (value % divisor === 0) {
                return value;
            }

            return this.createError('number.multiple', { multiple: base, value: value }, state, options);
        });
    };

    _class.prototype.integer = function integer() {

        return this._test('integer', undefined, function (value, state, options) {

            return Number.isSafeInteger(value) ? value : this.createError('number.integer', { value: value }, state, options);
        });
    };

    _class.prototype.negative = function negative() {

        return this._test('negative', undefined, function (value, state, options) {

            if (value < 0) {
                return value;
            }

            return this.createError('number.negative', { value: value }, state, options);
        });
    };

    _class.prototype.positive = function positive() {

        return this._test('positive', undefined, function (value, state, options) {

            if (value > 0) {
                return value;
            }

            return this.createError('number.positive', { value: value }, state, options);
        });
    };

    _class.prototype.precision = function precision(limit) {

        Hoek.assert(Number.isSafeInteger(limit), 'limit must be an integer');
        Hoek.assert(!('precision' in this._flags), 'precision already set');

        var obj = this._test('precision', limit, function (value, state, options) {

            var places = value.toString().match(internals.precisionRx);
            var decimals = Math.max((places[1] ? places[1].length : 0) - (places[2] ? parseInt(places[2], 10) : 0), 0);
            if (decimals <= limit) {
                return value;
            }

            return this.createError('number.precision', { limit: limit, value: value }, state, options);
        });

        obj._flags.precision = limit;
        return obj;
    };

    _class.prototype.port = function port() {

        return this._test('port', undefined, function (value, state, options) {

            if (!Number.isSafeInteger(value) || value < 0 || value > 65535) {
                return this.createError('number.port', { value: value }, state, options);
            }

            return value;
        });
    };

    return _class;
}(Any);

internals.compare = function (type, compare) {

    return function (limit) {

        var isRef = Ref.isRef(limit);
        var isNumber = typeof limit === 'number' && !isNaN(limit);

        Hoek.assert(isNumber || isRef, 'limit must be a number or reference');

        return this._test(type, limit, function (value, state, options) {

            var compareTo = void 0;
            if (isRef) {
                compareTo = limit(state.reference || state.parent, options);

                if (!(typeof compareTo === 'number' && !isNaN(compareTo))) {
                    return this.createError('number.ref', { ref: limit.key }, state, options);
                }
            } else {
                compareTo = limit;
            }

            if (compare(value, compareTo)) {
                return value;
            }

            return this.createError('number.' + type, { limit: compareTo, value: value }, state, options);
        });
    };
};

internals.Number.prototype.min = internals.compare('min', function (value, limit) {
    return value >= limit;
});
internals.Number.prototype.max = internals.compare('max', function (value, limit) {
    return value <= limit;
});
internals.Number.prototype.greater = internals.compare('greater', function (value, limit) {
    return value > limit;
});
internals.Number.prototype.less = internals.compare('less', function (value, limit) {
    return value < limit;
});

module.exports = new internals.Number();

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

// Load modules

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Net = __webpack_require__(15);
var Hoek = __webpack_require__(0);
var Isemail = void 0; // Loaded on demand
var Any = __webpack_require__(2);
var Ref = __webpack_require__(1);
var JoiDate = __webpack_require__(12);
var Uri = __webpack_require__(30);
var Ip = __webpack_require__(29);

// Declare internals

var internals = {
    uriRegex: Uri.createUriRegex(),
    ipRegex: Ip.createIpRegex(['ipv4', 'ipv6', 'ipvfuture'], 'optional'),
    guidBrackets: {
        '{': '}', '[': ']', '(': ')', '': ''
    },
    guidVersions: {
        uuidv1: '1',
        uuidv2: '2',
        uuidv3: '3',
        uuidv4: '4',
        uuidv5: '5'
    },
    cidrPresences: ['required', 'optional', 'forbidden'],
    normalizationForms: ['NFC', 'NFD', 'NFKC', 'NFKD']
};

internals.String = function (_Any) {
    _inherits(_class, _Any);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _Any.call(this));

        _this._type = 'string';
        _this._invalids.add('');
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        if (typeof value === 'string' && options.convert) {

            if (this._flags.normalize) {
                value = value.normalize(this._flags.normalize);
            }

            if (this._flags.case) {
                value = this._flags.case === 'upper' ? value.toLocaleUpperCase() : value.toLocaleLowerCase();
            }

            if (this._flags.trim) {
                value = value.trim();
            }

            if (this._inner.replacements) {

                for (var i = 0; i < this._inner.replacements.length; ++i) {
                    var replacement = this._inner.replacements[i];
                    value = value.replace(replacement.pattern, replacement.replacement);
                }
            }

            if (this._flags.truncate) {
                for (var _i = 0; _i < this._tests.length; ++_i) {
                    var test = this._tests[_i];
                    if (test.name === 'max') {
                        value = value.slice(0, test.arg);
                        break;
                    }
                }
            }

            if (this._flags.byteAligned && value.length % 2 !== 0) {
                value = '0' + value;
            }
        }

        return {
            value: value,
            errors: typeof value === 'string' ? null : this.createError('string.base', { value: value }, state, options)
        };
    };

    _class.prototype.insensitive = function insensitive() {

        if (this._flags.insensitive) {
            return this;
        }

        var obj = this.clone();
        obj._flags.insensitive = true;
        return obj;
    };

    _class.prototype.creditCard = function creditCard() {

        return this._test('creditCard', undefined, function (value, state, options) {

            var i = value.length;
            var sum = 0;
            var mul = 1;

            while (i--) {
                var char = value.charAt(i) * mul;
                sum = sum + (char - (char > 9) * 9);
                mul = mul ^ 3;
            }

            var check = sum % 10 === 0 && sum > 0;
            return check ? value : this.createError('string.creditCard', { value: value }, state, options);
        });
    };

    _class.prototype.regex = function regex(pattern, patternOptions) {

        Hoek.assert(pattern instanceof RegExp, 'pattern must be a RegExp');

        var patternObject = {
            pattern: new RegExp(pattern.source, pattern.ignoreCase ? 'i' : undefined) // Future version should break this and forbid unsupported regex flags
        };

        if (typeof patternOptions === 'string') {
            patternObject.name = patternOptions;
        } else if ((typeof patternOptions === 'undefined' ? 'undefined' : _typeof(patternOptions)) === 'object') {
            patternObject.invert = !!patternOptions.invert;

            if (patternOptions.name) {
                patternObject.name = patternOptions.name;
            }
        }

        var errorCode = ['string.regex', patternObject.invert ? '.invert' : '', patternObject.name ? '.name' : '.base'].join('');

        return this._test('regex', patternObject, function (value, state, options) {

            var patternMatch = patternObject.pattern.test(value);

            if (patternMatch ^ patternObject.invert) {
                return value;
            }

            return this.createError(errorCode, { name: patternObject.name, pattern: patternObject.pattern, value: value }, state, options);
        });
    };

    _class.prototype.alphanum = function alphanum() {

        return this._test('alphanum', undefined, function (value, state, options) {

            if (/^[a-zA-Z0-9]+$/.test(value)) {
                return value;
            }

            return this.createError('string.alphanum', { value: value }, state, options);
        });
    };

    _class.prototype.token = function token() {

        return this._test('token', undefined, function (value, state, options) {

            if (/^\w+$/.test(value)) {
                return value;
            }

            return this.createError('string.token', { value: value }, state, options);
        });
    };

    _class.prototype.email = function email(isEmailOptions) {

        if (isEmailOptions) {
            Hoek.assert((typeof isEmailOptions === 'undefined' ? 'undefined' : _typeof(isEmailOptions)) === 'object', 'email options must be an object');
            Hoek.assert(typeof isEmailOptions.checkDNS === 'undefined', 'checkDNS option is not supported');
            Hoek.assert(typeof isEmailOptions.tldWhitelist === 'undefined' || _typeof(isEmailOptions.tldWhitelist) === 'object', 'tldWhitelist must be an array or object');
            Hoek.assert(typeof isEmailOptions.minDomainAtoms === 'undefined' || Number.isSafeInteger(isEmailOptions.minDomainAtoms) && isEmailOptions.minDomainAtoms > 0, 'minDomainAtoms must be a positive integer');
            Hoek.assert(typeof isEmailOptions.errorLevel === 'undefined' || typeof isEmailOptions.errorLevel === 'boolean' || Number.isSafeInteger(isEmailOptions.errorLevel) && isEmailOptions.errorLevel >= 0, 'errorLevel must be a non-negative integer or boolean');
        }

        return this._test('email', isEmailOptions, function (value, state, options) {

            Isemail = Isemail || __webpack_require__(19);

            try {
                var result = Isemail.validate(value, isEmailOptions);
                if (result === true || result === 0) {
                    return value;
                }
            } catch (e) {}

            return this.createError('string.email', { value: value }, state, options);
        });
    };

    _class.prototype.ip = function ip() {
        var ipOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


        var regex = internals.ipRegex;
        Hoek.assert((typeof ipOptions === 'undefined' ? 'undefined' : _typeof(ipOptions)) === 'object', 'options must be an object');

        if (ipOptions.cidr) {
            Hoek.assert(typeof ipOptions.cidr === 'string', 'cidr must be a string');
            ipOptions.cidr = ipOptions.cidr.toLowerCase();

            Hoek.assert(Hoek.contain(internals.cidrPresences, ipOptions.cidr), 'cidr must be one of ' + internals.cidrPresences.join(', '));

            // If we only received a `cidr` setting, create a regex for it. But we don't need to create one if `cidr` is "optional" since that is the default
            if (!ipOptions.version && ipOptions.cidr !== 'optional') {
                regex = Ip.createIpRegex(['ipv4', 'ipv6', 'ipvfuture'], ipOptions.cidr);
            }
        } else {

            // Set our default cidr strategy
            ipOptions.cidr = 'optional';
        }

        var versions = void 0;
        if (ipOptions.version) {
            if (!Array.isArray(ipOptions.version)) {
                ipOptions.version = [ipOptions.version];
            }

            Hoek.assert(ipOptions.version.length >= 1, 'version must have at least 1 version specified');

            versions = [];
            for (var i = 0; i < ipOptions.version.length; ++i) {
                var version = ipOptions.version[i];
                Hoek.assert(typeof version === 'string', 'version at position ' + i + ' must be a string');
                version = version.toLowerCase();
                Hoek.assert(Ip.versions[version], 'version at position ' + i + ' must be one of ' + Object.keys(Ip.versions).join(', '));
                versions.push(version);
            }

            // Make sure we have a set of versions
            versions = Hoek.unique(versions);

            regex = Ip.createIpRegex(versions, ipOptions.cidr);
        }

        return this._test('ip', ipOptions, function (value, state, options) {

            if (regex.test(value)) {
                return value;
            }

            if (versions) {
                return this.createError('string.ipVersion', { value: value, cidr: ipOptions.cidr, version: versions }, state, options);
            }

            return this.createError('string.ip', { value: value, cidr: ipOptions.cidr }, state, options);
        });
    };

    _class.prototype.uri = function uri(uriOptions) {

        var customScheme = '';
        var allowRelative = false;
        var relativeOnly = false;
        var regex = internals.uriRegex;

        if (uriOptions) {
            Hoek.assert((typeof uriOptions === 'undefined' ? 'undefined' : _typeof(uriOptions)) === 'object', 'options must be an object');

            if (uriOptions.scheme) {
                Hoek.assert(uriOptions.scheme instanceof RegExp || typeof uriOptions.scheme === 'string' || Array.isArray(uriOptions.scheme), 'scheme must be a RegExp, String, or Array');

                if (!Array.isArray(uriOptions.scheme)) {
                    uriOptions.scheme = [uriOptions.scheme];
                }

                Hoek.assert(uriOptions.scheme.length >= 1, 'scheme must have at least 1 scheme specified');

                // Flatten the array into a string to be used to match the schemes.
                for (var i = 0; i < uriOptions.scheme.length; ++i) {
                    var scheme = uriOptions.scheme[i];
                    Hoek.assert(scheme instanceof RegExp || typeof scheme === 'string', 'scheme at position ' + i + ' must be a RegExp or String');

                    // Add OR separators if a value already exists
                    customScheme = customScheme + (customScheme ? '|' : '');

                    // If someone wants to match HTTP or HTTPS for example then we need to support both RegExp and String so we don't escape their pattern unknowingly.
                    if (scheme instanceof RegExp) {
                        customScheme = customScheme + scheme.source;
                    } else {
                        Hoek.assert(/[a-zA-Z][a-zA-Z0-9+-\.]*/.test(scheme), 'scheme at position ' + i + ' must be a valid scheme');
                        customScheme = customScheme + Hoek.escapeRegex(scheme);
                    }
                }
            }

            if (uriOptions.allowRelative) {
                allowRelative = true;
            }

            if (uriOptions.relativeOnly) {
                relativeOnly = true;
            }
        }

        if (customScheme || allowRelative || relativeOnly) {
            regex = Uri.createUriRegex(customScheme, allowRelative, relativeOnly);
        }

        return this._test('uri', uriOptions, function (value, state, options) {

            if (regex.test(value)) {
                return value;
            }

            if (relativeOnly) {
                return this.createError('string.uriRelativeOnly', { value: value }, state, options);
            }

            if (customScheme) {
                return this.createError('string.uriCustomScheme', { scheme: customScheme, value: value }, state, options);
            }

            return this.createError('string.uri', { value: value }, state, options);
        });
    };

    _class.prototype.isoDate = function isoDate() {

        return this._test('isoDate', undefined, function (value, state, options) {

            if (JoiDate._isIsoDate(value)) {
                if (!options.convert) {
                    return value;
                }

                var d = new Date(value);
                if (!isNaN(d.getTime())) {
                    return d.toISOString();
                }
            }

            return this.createError('string.isoDate', { value: value }, state, options);
        });
    };

    _class.prototype.guid = function guid(guidOptions) {

        var versionNumbers = '';

        if (guidOptions && guidOptions.version) {
            if (!Array.isArray(guidOptions.version)) {
                guidOptions.version = [guidOptions.version];
            }

            Hoek.assert(guidOptions.version.length >= 1, 'version must have at least 1 valid version specified');
            var versions = new Set();

            for (var i = 0; i < guidOptions.version.length; ++i) {
                var version = guidOptions.version[i];
                Hoek.assert(typeof version === 'string', 'version at position ' + i + ' must be a string');
                version = version.toLowerCase();
                var versionNumber = internals.guidVersions[version];
                Hoek.assert(versionNumber, 'version at position ' + i + ' must be one of ' + Object.keys(internals.guidVersions).join(', '));
                Hoek.assert(!versions.has(versionNumber), 'version at position ' + i + ' must not be a duplicate.');

                versionNumbers += versionNumber;
                versions.add(versionNumber);
            }
        }

        var guidRegex = new RegExp('^([\\[{\\(]?)[0-9A-F]{8}([:-]?)[0-9A-F]{4}\\2?[' + (versionNumbers || '0-9A-F') + '][0-9A-F]{3}\\2?[' + (versionNumbers ? '89AB' : '0-9A-F') + '][0-9A-F]{3}\\2?[0-9A-F]{12}([\\]}\\)]?)$', 'i');

        return this._test('guid', guidOptions, function (value, state, options) {

            var results = guidRegex.exec(value);

            if (!results) {
                return this.createError('string.guid', { value: value }, state, options);
            }

            // Matching braces
            if (internals.guidBrackets[results[1]] !== results[results.length - 1]) {
                return this.createError('string.guid', { value: value }, state, options);
            }

            return value;
        });
    };

    _class.prototype.hex = function hex() {
        var hexOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


        Hoek.assert((typeof hexOptions === 'undefined' ? 'undefined' : _typeof(hexOptions)) === 'object', 'hex options must be an object');
        Hoek.assert(typeof hexOptions.byteAligned === 'undefined' || typeof hexOptions.byteAligned === 'boolean', 'byteAligned must be boolean');

        var byteAligned = hexOptions.byteAligned === true;
        var regex = /^[a-f0-9]+$/i;

        var obj = this._test('hex', regex, function (value, state, options) {

            if (regex.test(value)) {
                if (byteAligned && value.length % 2 !== 0) {
                    return this.createError('string.hexAlign', { value: value }, state, options);
                }
                return value;
            }

            return this.createError('string.hex', { value: value }, state, options);
        });

        if (byteAligned) {
            obj._flags.byteAligned = true;
        }

        return obj;
    };

    _class.prototype.base64 = function base64() {
        var base64Options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


        // Validation.
        Hoek.assert((typeof base64Options === 'undefined' ? 'undefined' : _typeof(base64Options)) === 'object', 'base64 options must be an object');
        Hoek.assert(typeof base64Options.paddingRequired === 'undefined' || typeof base64Options.paddingRequired === 'boolean', 'paddingRequired must be boolean');

        // Determine if padding is required.
        var paddingRequired = base64Options.paddingRequired === false ? base64Options.paddingRequired : base64Options.paddingRequired || true;

        // Set validation based on preference.
        var regex = paddingRequired ?
        // Padding is required.
        /^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/
        // Padding is optional.
        : /^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}(==)?|[A-Za-z0-9+\/]{3}=?)?$/;

        return this._test('base64', regex, function (value, state, options) {

            if (regex.test(value)) {
                return value;
            }

            return this.createError('string.base64', { value: value }, state, options);
        });
    };

    _class.prototype.hostname = function hostname() {

        var regex = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/;

        return this._test('hostname', undefined, function (value, state, options) {

            if (value.length <= 255 && regex.test(value) || Net.isIPv6(value)) {

                return value;
            }

            return this.createError('string.hostname', { value: value }, state, options);
        });
    };

    _class.prototype.normalize = function normalize() {
        var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'NFC';


        Hoek.assert(Hoek.contain(internals.normalizationForms, form), 'normalization form must be one of ' + internals.normalizationForms.join(', '));

        var obj = this._test('normalize', form, function (value, state, options) {

            if (options.convert || value === value.normalize(form)) {

                return value;
            }

            return this.createError('string.normalize', { value: value, form: form }, state, options);
        });

        obj._flags.normalize = form;
        return obj;
    };

    _class.prototype.lowercase = function lowercase() {

        var obj = this._test('lowercase', undefined, function (value, state, options) {

            if (options.convert || value === value.toLocaleLowerCase()) {

                return value;
            }

            return this.createError('string.lowercase', { value: value }, state, options);
        });

        obj._flags.case = 'lower';
        return obj;
    };

    _class.prototype.uppercase = function uppercase() {

        var obj = this._test('uppercase', undefined, function (value, state, options) {

            if (options.convert || value === value.toLocaleUpperCase()) {

                return value;
            }

            return this.createError('string.uppercase', { value: value }, state, options);
        });

        obj._flags.case = 'upper';
        return obj;
    };

    _class.prototype.trim = function trim() {

        var obj = this._test('trim', undefined, function (value, state, options) {

            if (options.convert || value === value.trim()) {

                return value;
            }

            return this.createError('string.trim', { value: value }, state, options);
        });

        obj._flags.trim = true;
        return obj;
    };

    _class.prototype.replace = function replace(pattern, replacement) {

        if (typeof pattern === 'string') {
            pattern = new RegExp(Hoek.escapeRegex(pattern), 'g');
        }

        Hoek.assert(pattern instanceof RegExp, 'pattern must be a RegExp');
        Hoek.assert(typeof replacement === 'string', 'replacement must be a String');

        // This can not be considere a test like trim, we can't "reject"
        // anything from this rule, so just clone the current object
        var obj = this.clone();

        if (!obj._inner.replacements) {
            obj._inner.replacements = [];
        }

        obj._inner.replacements.push({
            pattern: pattern,
            replacement: replacement
        });

        return obj;
    };

    _class.prototype.truncate = function truncate(enabled) {

        var value = enabled === undefined ? true : !!enabled;

        if (this._flags.truncate === value) {
            return this;
        }

        var obj = this.clone();
        obj._flags.truncate = value;
        return obj;
    };

    return _class;
}(Any);

internals.compare = function (type, compare) {

    return function (limit, encoding) {

        var isRef = Ref.isRef(limit);

        Hoek.assert(Number.isSafeInteger(limit) && limit >= 0 || isRef, 'limit must be a positive integer or reference');
        Hoek.assert(!encoding || Buffer.isEncoding(encoding), 'Invalid encoding:', encoding);

        return this._test(type, limit, function (value, state, options) {

            var compareTo = void 0;
            if (isRef) {
                compareTo = limit(state.reference || state.parent, options);

                if (!Number.isSafeInteger(compareTo)) {
                    return this.createError('string.ref', { ref: limit.key }, state, options);
                }
            } else {
                compareTo = limit;
            }

            if (compare(value, compareTo, encoding)) {
                return value;
            }

            return this.createError('string.' + type, { limit: compareTo, value: value, encoding: encoding }, state, options);
        });
    };
};

internals.String.prototype.min = internals.compare('min', function (value, limit, encoding) {

    var length = encoding ? Buffer.byteLength(value, encoding) : value.length;
    return length >= limit;
});

internals.String.prototype.max = internals.compare('max', function (value, limit, encoding) {

    var length = encoding ? Buffer.byteLength(value, encoding) : value.length;
    return length <= limit;
});

internals.String.prototype.length = internals.compare('length', function (value, limit, encoding) {

    var length = encoding ? Buffer.byteLength(value, encoding) : value.length;
    return length === limit;
});

// Aliases

internals.String.prototype.uuid = internals.String.prototype.guid;

module.exports = new internals.String();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var RFC3986 = __webpack_require__(14);

// Declare internals

var internals = {
    Ip: {
        cidrs: {
            ipv4: {
                required: '\\/(?:' + RFC3986.ipv4Cidr + ')',
                optional: '(?:\\/(?:' + RFC3986.ipv4Cidr + '))?',
                forbidden: ''
            },
            ipv6: {
                required: '\\/' + RFC3986.ipv6Cidr,
                optional: '(?:\\/' + RFC3986.ipv6Cidr + ')?',
                forbidden: ''
            },
            ipvfuture: {
                required: '\\/' + RFC3986.ipv6Cidr,
                optional: '(?:\\/' + RFC3986.ipv6Cidr + ')?',
                forbidden: ''
            }
        },
        versions: {
            ipv4: RFC3986.IPv4address,
            ipv6: RFC3986.IPv6address,
            ipvfuture: RFC3986.IPvFuture
        }
    }
};

internals.Ip.createIpRegex = function (versions, cidr) {

    var regex = void 0;
    for (var i = 0; i < versions.length; ++i) {
        var version = versions[i];
        if (!regex) {
            regex = '^(?:' + internals.Ip.versions[version] + internals.Ip.cidrs[version][cidr];
        } else {
            regex += '|' + internals.Ip.versions[version] + internals.Ip.cidrs[version][cidr];
        }
    }

    return new RegExp(regex + ')$');
};

module.exports = internals.Ip;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load Modules

var RFC3986 = __webpack_require__(14);

// Declare internals

var internals = {
    Uri: {
        createUriRegex: function createUriRegex(optionalScheme, allowRelative, relativeOnly) {

            var scheme = RFC3986.scheme;
            var prefix = void 0;

            if (relativeOnly) {
                prefix = '(?:' + RFC3986.relativeRef + ')';
            } else {
                // If we were passed a scheme, use it instead of the generic one
                if (optionalScheme) {

                    // Have to put this in a non-capturing group to handle the OR statements
                    scheme = '(?:' + optionalScheme + ')';
                }

                var withScheme = '(?:' + scheme + ':' + RFC3986.hierPart + ')';

                prefix = allowRelative ? '(?:' + withScheme + '|' + RFC3986.relativeRef + ')' : withScheme;
            }

            /**
             * URI = scheme ":" hier-part [ "?" query ] [ "#" fragment ]
             *
             * OR
             *
             * relative-ref = relative-part [ "?" query ] [ "#" fragment ]
             */
            return new RegExp('^' + prefix + '(?:\\?' + RFC3986.query + ')?' + '(?:#' + RFC3986.fragment + ')?$');
        }
    }
};

module.exports = internals.Uri;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var Hoek = __webpack_require__(0);

// Declare internals

var internals = {};

exports = module.exports = internals.Topo = function () {

    this._items = [];
    this.nodes = [];
};

internals.Topo.prototype.add = function (nodes, options) {
    var _this = this;

    options = options || {};

    // Validate rules

    var before = [].concat(options.before || []);
    var after = [].concat(options.after || []);
    var group = options.group || '?';
    var sort = options.sort || 0; // Used for merging only

    Hoek.assert(before.indexOf(group) === -1, 'Item cannot come before itself:', group);
    Hoek.assert(before.indexOf('?') === -1, 'Item cannot come before unassociated items');
    Hoek.assert(after.indexOf(group) === -1, 'Item cannot come after itself:', group);
    Hoek.assert(after.indexOf('?') === -1, 'Item cannot come after unassociated items');

    [].concat(nodes).forEach(function (node, i) {

        var item = {
            seq: _this._items.length,
            sort: sort,
            before: before,
            after: after,
            group: group,
            node: node
        };

        _this._items.push(item);
    });

    // Insert event

    var error = this._sort();
    Hoek.assert(!error, 'item', group !== '?' ? 'added into group ' + group : '', 'created a dependencies error');

    return this.nodes;
};

internals.Topo.prototype.merge = function (others) {

    others = [].concat(others);
    for (var i = 0; i < others.length; ++i) {
        var other = others[i];
        if (other) {
            for (var j = 0; j < other._items.length; ++j) {
                var item = Hoek.shallow(other._items[j]);
                this._items.push(item);
            }
        }
    }

    // Sort items

    this._items.sort(internals.mergeSort);
    for (var _i = 0; _i < this._items.length; ++_i) {
        this._items[_i].seq = _i;
    }

    var error = this._sort();
    Hoek.assert(!error, 'merge created a dependencies error');

    return this.nodes;
};

internals.mergeSort = function (a, b) {

    return a.sort === b.sort ? 0 : a.sort < b.sort ? -1 : 1;
};

internals.Topo.prototype._sort = function () {

    // Construct graph

    var graph = {};
    var graphAfters = Object.create(null); // A prototype can bungle lookups w/ false positives
    var groups = Object.create(null);

    for (var i = 0; i < this._items.length; ++i) {
        var item = this._items[i];
        var seq = item.seq; // Unique across all items
        var group = item.group;

        // Determine Groups

        groups[group] = groups[group] || [];
        groups[group].push(seq);

        // Build intermediary graph using 'before'

        graph[seq] = item.before;

        // Build second intermediary graph with 'after'

        var after = item.after;
        for (var j = 0; j < after.length; ++j) {
            graphAfters[after[j]] = (graphAfters[after[j]] || []).concat(seq);
        }
    }

    // Expand intermediary graph

    var graphNodes = Object.keys(graph);
    for (var _i2 = 0; _i2 < graphNodes.length; ++_i2) {
        var node = graphNodes[_i2];
        var expandedGroups = [];

        var graphNodeItems = Object.keys(graph[node]);
        for (var _j = 0; _j < graphNodeItems.length; ++_j) {
            var _group = graph[node][graphNodeItems[_j]];
            groups[_group] = groups[_group] || [];

            for (var k = 0; k < groups[_group].length; ++k) {
                expandedGroups.push(groups[_group][k]);
            }
        }
        graph[node] = expandedGroups;
    }

    // Merge intermediary graph using graphAfters into final graph

    var afterNodes = Object.keys(graphAfters);
    for (var _i3 = 0; _i3 < afterNodes.length; ++_i3) {
        var _group2 = afterNodes[_i3];

        if (groups[_group2]) {
            for (var _j2 = 0; _j2 < groups[_group2].length; ++_j2) {
                var _node = groups[_group2][_j2];
                graph[_node] = graph[_node].concat(graphAfters[_group2]);
            }
        }
    }

    // Compile ancestors

    var children = void 0;
    var ancestors = {};
    graphNodes = Object.keys(graph);
    for (var _i4 = 0; _i4 < graphNodes.length; ++_i4) {
        var _node2 = graphNodes[_i4];
        children = graph[_node2];

        for (var _j3 = 0; _j3 < children.length; ++_j3) {
            ancestors[children[_j3]] = (ancestors[children[_j3]] || []).concat(_node2);
        }
    }

    // Topo sort

    var visited = {};
    var sorted = [];

    for (var _i5 = 0; _i5 < this._items.length; ++_i5) {
        // Really looping thru item.seq values out of order
        var next = _i5;

        if (ancestors[_i5]) {
            next = null;
            for (var _j4 = 0; _j4 < this._items.length; ++_j4) {
                // As above, these are item.seq values
                if (visited[_j4] === true) {
                    continue;
                }

                if (!ancestors[_j4]) {
                    ancestors[_j4] = [];
                }

                var shouldSeeCount = ancestors[_j4].length;
                var seenCount = 0;
                for (var _k = 0; _k < shouldSeeCount; ++_k) {
                    if (visited[ancestors[_j4][_k]]) {
                        ++seenCount;
                    }
                }

                if (seenCount === shouldSeeCount) {
                    next = _j4;
                    break;
                }
            }
        }

        if (next !== null) {
            visited[next] = true;
            sorted.push(next);
        }
    }

    if (sorted.length !== this._items.length) {
        return new Error('Invalid dependencies');
    }

    var seqIndex = {};
    for (var _i6 = 0; _i6 < this._items.length; ++_i6) {
        var _item = this._items[_i6];
        seqIndex[_item.seq] = _item;
    }

    var sortedNodes = [];
    this._items = sorted.map(function (value) {

        var sortedItem = seqIndex[value];
        sortedNodes.push(sortedItem.node);
        return sortedItem;
    });

    this.nodes = sortedNodes;
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Joi = __webpack_require__(8);

module.exports = Joi;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return (b64.length * 3 / 4) - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr((len * 3 / 4) - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0; i < l; i += 4) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),
/* 34 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 35 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = {"_args":[["joi@13.4.0","/Users/jeff/projects/joi-browser"]],"_development":true,"_from":"joi@13.4.0","_id":"joi@13.4.0","_inBundle":false,"_integrity":"sha512-JuK4GjEu6j7zr9FuVe2MAseZ6si/8/HaY0qMAejfDFHp7jcH4OKE937mIHM5VT4xDS0q7lpQbszbxKV9rm0yUg==","_location":"/joi","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"joi@13.4.0","name":"joi","escapedName":"joi","rawSpec":"13.4.0","saveSpec":null,"fetchSpec":"13.4.0"},"_requiredBy":["#DEV:/"],"_resolved":"https://registry.npmjs.org/joi/-/joi-13.4.0.tgz","_spec":"13.4.0","_where":"/Users/jeff/projects/joi-browser","bugs":{"url":"https://github.com/hapijs/joi/issues"},"dependencies":{"hoek":"5.x.x","isemail":"3.x.x","topo":"3.x.x"},"description":"Object schema validation","devDependencies":{"code":"5.x.x","hapitoc":"1.x.x","lab":"15.x.x"},"engines":{"node":">=8.9.0"},"homepage":"https://github.com/hapijs/joi","keywords":["hapi","schema","validation"],"license":"BSD-3-Clause","main":"lib/index.js","name":"joi","repository":{"type":"git","url":"git://github.com/hapijs/joi.git"},"scripts":{"test":"lab -t 100 -a code -L","test-cov-html":"lab -r html -o coverage.html -a code","test-debug":"lab -a code","toc":"hapitoc","version":"npm run toc && git add API.md README.md"},"version":"13.4.0"}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe =
    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
var splitPath = function(filename) {
  return splitPathRe.exec(filename).slice(1);
};

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function(path) {
  var result = splitPath(path),
      root = result[0],
      dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
};


exports.basename = function(path, ext) {
  var f = splitPath(path)[2];
  // TODO: make this comparison case-insensitive on windows?
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};


exports.extname = function(path) {
  return splitPath(path)[3];
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41)(module), __webpack_require__(5)))

/***/ }),
/* 39 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ })
/******/ ]);
});

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {
Object.defineProperty(exports, "__esModule", { value: true });
var BN = __webpack_require__(3);
/**
 * RLP Encoding based on: https://github.com/ethereum/wiki/wiki/%5BEnglish%5D-RLP
 * This function takes in a data, convert it to buffer if not, and a length for recursion
 * @param input - will be converted to buffer
 * @returns returns buffer of encoded data
 **/
function encode(input) {
    if (Array.isArray(input)) {
        var output = [];
        for (var i = 0; i < input.length; i++) {
            output.push(encode(input[i]));
        }
        var buf = Buffer.concat(output);
        return Buffer.concat([encodeLength(buf.length, 192), buf]);
    }
    else {
        var inputBuf = toBuffer(input);
        return inputBuf.length === 1 && inputBuf[0] < 128
            ? inputBuf
            : Buffer.concat([encodeLength(inputBuf.length, 128), inputBuf]);
    }
}
exports.encode = encode;
/**
 * Parse integers. Check if there is no leading zeros
 * @param v The value to parse
 * @param base The base to parse the integer into
 */
function safeParseInt(v, base) {
    if (v.slice(0, 2) === '00') {
        throw new Error('invalid RLP: extra zeros');
    }
    return parseInt(v, base);
}
function encodeLength(len, offset) {
    if (len < 56) {
        return Buffer.from([len + offset]);
    }
    else {
        var hexLength = intToHex(len);
        var lLength = hexLength.length / 2;
        var firstByte = intToHex(offset + 55 + lLength);
        return Buffer.from(firstByte + hexLength, 'hex');
    }
}
function decode(input, stream) {
    if (stream === void 0) { stream = false; }
    if (!input || input.length === 0) {
        return Buffer.from([]);
    }
    var inputBuffer = toBuffer(input);
    var decoded = _decode(inputBuffer);
    if (stream) {
        return decoded;
    }
    if (decoded.remainder.length !== 0) {
        throw new Error('invalid remainder');
    }
    return decoded.data;
}
exports.decode = decode;
/**
 * Get the length of the RLP input
 * @param input
 * @returns The length of the input or an empty Buffer if no input
 */
function getLength(input) {
    if (!input || input.length === 0) {
        return Buffer.from([]);
    }
    var inputBuffer = toBuffer(input);
    var firstByte = inputBuffer[0];
    if (firstByte <= 0x7f) {
        return inputBuffer.length;
    }
    else if (firstByte <= 0xb7) {
        return firstByte - 0x7f;
    }
    else if (firstByte <= 0xbf) {
        return firstByte - 0xb6;
    }
    else if (firstByte <= 0xf7) {
        // a list between  0-55 bytes long
        return firstByte - 0xbf;
    }
    else {
        // a list  over 55 bytes long
        var llength = firstByte - 0xf6;
        var length = safeParseInt(inputBuffer.slice(1, llength).toString('hex'), 16);
        return llength + length;
    }
}
exports.getLength = getLength;
/** Decode an input with RLP */
function _decode(input) {
    var length, llength, data, innerRemainder, d;
    var decoded = [];
    var firstByte = input[0];
    if (firstByte <= 0x7f) {
        // a single byte whose value is in the [0x00, 0x7f] range, that byte is its own RLP encoding.
        return {
            data: input.slice(0, 1),
            remainder: input.slice(1),
        };
    }
    else if (firstByte <= 0xb7) {
        // string is 0-55 bytes long. A single byte with value 0x80 plus the length of the string followed by the string
        // The range of the first byte is [0x80, 0xb7]
        length = firstByte - 0x7f;
        // set 0x80 null to 0
        if (firstByte === 0x80) {
            data = Buffer.from([]);
        }
        else {
            data = input.slice(1, length);
        }
        if (length === 2 && data[0] < 0x80) {
            throw new Error('invalid rlp encoding: byte must be less 0x80');
        }
        return {
            data: data,
            remainder: input.slice(length),
        };
    }
    else if (firstByte <= 0xbf) {
        llength = firstByte - 0xb6;
        length = safeParseInt(input.slice(1, llength).toString('hex'), 16);
        data = input.slice(llength, length + llength);
        if (data.length < length) {
            throw new Error('invalid RLP');
        }
        return {
            data: data,
            remainder: input.slice(length + llength),
        };
    }
    else if (firstByte <= 0xf7) {
        // a list between  0-55 bytes long
        length = firstByte - 0xbf;
        innerRemainder = input.slice(1, length);
        while (innerRemainder.length) {
            d = _decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(length),
        };
    }
    else {
        // a list  over 55 bytes long
        llength = firstByte - 0xf6;
        length = safeParseInt(input.slice(1, llength).toString('hex'), 16);
        var totalLength = llength + length;
        if (totalLength > input.length) {
            throw new Error('invalid rlp: total length is larger than the data');
        }
        innerRemainder = input.slice(llength, totalLength);
        if (innerRemainder.length === 0) {
            throw new Error('invalid rlp, List has a invalid length');
        }
        while (innerRemainder.length) {
            d = _decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(totalLength),
        };
    }
}
/** Check if a string is prefixed by 0x */
function isHexPrefixed(str) {
    return str.slice(0, 2) === '0x';
}
/** Removes 0x from a given String */
function stripHexPrefix(str) {
    if (typeof str !== 'string') {
        return str;
    }
    return isHexPrefixed(str) ? str.slice(2) : str;
}
/** Transform an integer into its hexadecimal value */
function intToHex(integer) {
    if (integer < 0) {
        throw new Error('Invalid integer as argument, must be unsigned!');
    }
    var hex = integer.toString(16);
    return hex.length % 2 ? "0" + hex : hex;
}
/** Pad a string to be even */
function padToEven(a) {
    return a.length % 2 ? "0" + a : a;
}
/** Transform an integer into a Buffer */
function intToBuffer(integer) {
    var hex = intToHex(integer);
    return Buffer.from(hex, 'hex');
}
/** Transform anything into a Buffer */
function toBuffer(v) {
    if (!Buffer.isBuffer(v)) {
        if (typeof v === 'string') {
            if (isHexPrefixed(v)) {
                return Buffer.from(padToEven(stripHexPrefix(v)), 'hex');
            }
            else {
                return Buffer.from(v);
            }
        }
        else if (typeof v === 'number') {
            if (!v) {
                return Buffer.from([]);
            }
            else {
                return intToBuffer(v);
            }
        }
        else if (v === null || v === undefined) {
            return Buffer.from([]);
        }
        else if (v instanceof Uint8Array) {
            return Buffer.from(v);
        }
        else if (BN.isBN(v)) {
            // converts a BN to a Buffer
            return Buffer.from(v.toArray());
        }
        else {
            throw new Error('invalid type');
        }
    }
    return v;
}
//# sourceMappingURL=index.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4).Buffer))

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 246 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(0).Buffer
var createHash = __webpack_require__(17)
var pbkdf2 = __webpack_require__(55).pbkdf2Sync
var randomBytes = __webpack_require__(19)

var ENGLISH_WORDLIST = __webpack_require__(264)
var DEFAULT_WORDLIST = ENGLISH_WORDLIST

var INVALID_MNEMONIC = 'Invalid mnemonic'
var INVALID_ENTROPY = 'Invalid entropy'
var INVALID_CHECKSUM = 'Invalid mnemonic checksum'

function lpad (str, padString, length) {
  while (str.length < length) str = padString + str
  return str
}

function binaryToByte (bin) {
  return parseInt(bin, 2)
}

function bytesToBinary (bytes) {
  return bytes.map(function (x) {
    return lpad(x.toString(2), '0', 8)
  }).join('')
}

function deriveChecksumBits (entropyBuffer) {
  var ENT = entropyBuffer.length * 8
  var CS = ENT / 32
  var hash = createHash('sha256').update(entropyBuffer).digest()

  return bytesToBinary([].slice.call(hash)).slice(0, CS)
}

function salt (password) {
  return 'mnemonic' + (password || '')
}

function normalizeString (str) {
  if (typeof str.normalize === 'function') {
    return str.normalize('NFKD')
  }
  return str
}

function mnemonicToSeed (mnemonic, password) {
  var mnemonicBuffer = Buffer.from(normalizeString(mnemonic), 'utf8')
  var saltBuffer = Buffer.from(normalizeString(salt(password)), 'utf8')

  return pbkdf2(mnemonicBuffer, saltBuffer, 2048, 64, 'sha512')
}

function mnemonicToSeedHex (mnemonic, password) {
  return mnemonicToSeed(mnemonic, password).toString('hex')
}

function mnemonicToEntropy (mnemonic, wordlist) {
  wordlist = wordlist || DEFAULT_WORDLIST

  var words = normalizeString(mnemonic).split(' ')
  if (words.length % 3 !== 0) throw new Error(INVALID_MNEMONIC)

  // convert word indices to 11 bit binary strings
  var bits = words.map(function (word) {
    var index = wordlist.indexOf(word)
    if (index === -1) throw new Error(INVALID_MNEMONIC)

    return lpad(index.toString(2), '0', 11)
  }).join('')

  // split the binary string into ENT/CS
  var dividerIndex = Math.floor(bits.length / 33) * 32
  var entropyBits = bits.slice(0, dividerIndex)
  var checksumBits = bits.slice(dividerIndex)

  // calculate the checksum and compare
  var entropyBytes = entropyBits.match(/(.{1,8})/g).map(binaryToByte)
  if (entropyBytes.length < 16) throw new Error(INVALID_ENTROPY)
  if (entropyBytes.length > 32) throw new Error(INVALID_ENTROPY)
  if (entropyBytes.length % 4 !== 0) throw new Error(INVALID_ENTROPY)

  var entropy = Buffer.from(entropyBytes)
  var newChecksum = deriveChecksumBits(entropy)
  if (newChecksum !== checksumBits) throw new Error(INVALID_CHECKSUM)

  return entropy.toString('hex')
}

function entropyToMnemonic (entropy, wordlist) {
  if (!Buffer.isBuffer(entropy)) entropy = Buffer.from(entropy, 'hex')
  wordlist = wordlist || DEFAULT_WORDLIST

  // 128 <= ENT <= 256
  if (entropy.length < 16) throw new TypeError(INVALID_ENTROPY)
  if (entropy.length > 32) throw new TypeError(INVALID_ENTROPY)
  if (entropy.length % 4 !== 0) throw new TypeError(INVALID_ENTROPY)

  var entropyBits = bytesToBinary([].slice.call(entropy))
  var checksumBits = deriveChecksumBits(entropy)

  var bits = entropyBits + checksumBits
  var chunks = bits.match(/(.{1,11})/g)
  var words = chunks.map(function (binary) {
    var index = binaryToByte(binary)
    return wordlist[index]
  })

  return words.join(' ')
}

function generateMnemonic (strength, rng, wordlist) {
  strength = strength || 128
  if (strength % 32 !== 0) throw new TypeError(INVALID_ENTROPY)
  rng = rng || randomBytes

  return entropyToMnemonic(rng(strength / 8), wordlist)
}

function validateMnemonic (mnemonic, wordlist) {
  try {
    mnemonicToEntropy(mnemonic, wordlist)
  } catch (e) {
    return false
  }

  return true
}

module.exports = {
  mnemonicToSeed: mnemonicToSeed,
  mnemonicToSeedHex: mnemonicToSeedHex,
  mnemonicToEntropy: mnemonicToEntropy,
  entropyToMnemonic: entropyToMnemonic,
  generateMnemonic: generateMnemonic,
  validateMnemonic: validateMnemonic,
  wordlists: {
    EN: ENGLISH_WORDLIST,

    english: ENGLISH_WORDLIST
  }
}


/***/ }),
/* 248 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(0).Buffer;
var util = __webpack_require__(250);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 250 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(252);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(9)))

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(100);

/*<replacement>*/
var util = Object.create(__webpack_require__(25));
util.inherits = __webpack_require__(1);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(52);


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(18);


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(51).Transform


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(51).PassThrough


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__(1)
var Hash = __webpack_require__(22)
var Buffer = __webpack_require__(0).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__(1)
var Hash = __webpack_require__(22)
var Buffer = __webpack_require__(0).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(1)
var Sha256 = __webpack_require__(101)
var Hash = __webpack_require__(22)
var Buffer = __webpack_require__(0).Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(1)
var SHA512 = __webpack_require__(102)
var Hash = __webpack_require__(22)
var Buffer = __webpack_require__(0).Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var checkParameters = __webpack_require__(103)
var defaultEncoding = __webpack_require__(104)
var sync = __webpack_require__(105)
var Buffer = __webpack_require__(0).Buffer

var ZERO_BUF
var subtle = global.crypto && global.crypto.subtle
var toBrowser = {
  'sha': 'SHA-1',
  'sha-1': 'SHA-1',
  'sha1': 'SHA-1',
  'sha256': 'SHA-256',
  'sha-256': 'SHA-256',
  'sha384': 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  'sha512': 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}

function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, {name: 'PBKDF2'}, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    process.nextTick(function () {
      callback(null, out)
    })
  }, function (e) {
    process.nextTick(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof global.Promise !== 'function') {
    return process.nextTick(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
  }

  checkParameters(password, salt, iterations, keylen)
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(9)))

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports = ["abandon","ability","able","about","above","absent","absorb","abstract","absurd","abuse","access","accident","account","accuse","achieve","acid","acoustic","acquire","across","act","action","actor","actress","actual","adapt","add","addict","address","adjust","admit","adult","advance","advice","aerobic","affair","afford","afraid","again","age","agent","agree","ahead","aim","air","airport","aisle","alarm","album","alcohol","alert","alien","all","alley","allow","almost","alone","alpha","already","also","alter","always","amateur","amazing","among","amount","amused","analyst","anchor","ancient","anger","angle","angry","animal","ankle","announce","annual","another","answer","antenna","antique","anxiety","any","apart","apology","appear","apple","approve","april","arch","arctic","area","arena","argue","arm","armed","armor","army","around","arrange","arrest","arrive","arrow","art","artefact","artist","artwork","ask","aspect","assault","asset","assist","assume","asthma","athlete","atom","attack","attend","attitude","attract","auction","audit","august","aunt","author","auto","autumn","average","avocado","avoid","awake","aware","away","awesome","awful","awkward","axis","baby","bachelor","bacon","badge","bag","balance","balcony","ball","bamboo","banana","banner","bar","barely","bargain","barrel","base","basic","basket","battle","beach","bean","beauty","because","become","beef","before","begin","behave","behind","believe","below","belt","bench","benefit","best","betray","better","between","beyond","bicycle","bid","bike","bind","biology","bird","birth","bitter","black","blade","blame","blanket","blast","bleak","bless","blind","blood","blossom","blouse","blue","blur","blush","board","boat","body","boil","bomb","bone","bonus","book","boost","border","boring","borrow","boss","bottom","bounce","box","boy","bracket","brain","brand","brass","brave","bread","breeze","brick","bridge","brief","bright","bring","brisk","broccoli","broken","bronze","broom","brother","brown","brush","bubble","buddy","budget","buffalo","build","bulb","bulk","bullet","bundle","bunker","burden","burger","burst","bus","business","busy","butter","buyer","buzz","cabbage","cabin","cable","cactus","cage","cake","call","calm","camera","camp","can","canal","cancel","candy","cannon","canoe","canvas","canyon","capable","capital","captain","car","carbon","card","cargo","carpet","carry","cart","case","cash","casino","castle","casual","cat","catalog","catch","category","cattle","caught","cause","caution","cave","ceiling","celery","cement","census","century","cereal","certain","chair","chalk","champion","change","chaos","chapter","charge","chase","chat","cheap","check","cheese","chef","cherry","chest","chicken","chief","child","chimney","choice","choose","chronic","chuckle","chunk","churn","cigar","cinnamon","circle","citizen","city","civil","claim","clap","clarify","claw","clay","clean","clerk","clever","click","client","cliff","climb","clinic","clip","clock","clog","close","cloth","cloud","clown","club","clump","cluster","clutch","coach","coast","coconut","code","coffee","coil","coin","collect","color","column","combine","come","comfort","comic","common","company","concert","conduct","confirm","congress","connect","consider","control","convince","cook","cool","copper","copy","coral","core","corn","correct","cost","cotton","couch","country","couple","course","cousin","cover","coyote","crack","cradle","craft","cram","crane","crash","crater","crawl","crazy","cream","credit","creek","crew","cricket","crime","crisp","critic","crop","cross","crouch","crowd","crucial","cruel","cruise","crumble","crunch","crush","cry","crystal","cube","culture","cup","cupboard","curious","current","curtain","curve","cushion","custom","cute","cycle","dad","damage","damp","dance","danger","daring","dash","daughter","dawn","day","deal","debate","debris","decade","december","decide","decline","decorate","decrease","deer","defense","define","defy","degree","delay","deliver","demand","demise","denial","dentist","deny","depart","depend","deposit","depth","deputy","derive","describe","desert","design","desk","despair","destroy","detail","detect","develop","device","devote","diagram","dial","diamond","diary","dice","diesel","diet","differ","digital","dignity","dilemma","dinner","dinosaur","direct","dirt","disagree","discover","disease","dish","dismiss","disorder","display","distance","divert","divide","divorce","dizzy","doctor","document","dog","doll","dolphin","domain","donate","donkey","donor","door","dose","double","dove","draft","dragon","drama","drastic","draw","dream","dress","drift","drill","drink","drip","drive","drop","drum","dry","duck","dumb","dune","during","dust","dutch","duty","dwarf","dynamic","eager","eagle","early","earn","earth","easily","east","easy","echo","ecology","economy","edge","edit","educate","effort","egg","eight","either","elbow","elder","electric","elegant","element","elephant","elevator","elite","else","embark","embody","embrace","emerge","emotion","employ","empower","empty","enable","enact","end","endless","endorse","enemy","energy","enforce","engage","engine","enhance","enjoy","enlist","enough","enrich","enroll","ensure","enter","entire","entry","envelope","episode","equal","equip","era","erase","erode","erosion","error","erupt","escape","essay","essence","estate","eternal","ethics","evidence","evil","evoke","evolve","exact","example","excess","exchange","excite","exclude","excuse","execute","exercise","exhaust","exhibit","exile","exist","exit","exotic","expand","expect","expire","explain","expose","express","extend","extra","eye","eyebrow","fabric","face","faculty","fade","faint","faith","fall","false","fame","family","famous","fan","fancy","fantasy","farm","fashion","fat","fatal","father","fatigue","fault","favorite","feature","february","federal","fee","feed","feel","female","fence","festival","fetch","fever","few","fiber","fiction","field","figure","file","film","filter","final","find","fine","finger","finish","fire","firm","first","fiscal","fish","fit","fitness","fix","flag","flame","flash","flat","flavor","flee","flight","flip","float","flock","floor","flower","fluid","flush","fly","foam","focus","fog","foil","fold","follow","food","foot","force","forest","forget","fork","fortune","forum","forward","fossil","foster","found","fox","fragile","frame","frequent","fresh","friend","fringe","frog","front","frost","frown","frozen","fruit","fuel","fun","funny","furnace","fury","future","gadget","gain","galaxy","gallery","game","gap","garage","garbage","garden","garlic","garment","gas","gasp","gate","gather","gauge","gaze","general","genius","genre","gentle","genuine","gesture","ghost","giant","gift","giggle","ginger","giraffe","girl","give","glad","glance","glare","glass","glide","glimpse","globe","gloom","glory","glove","glow","glue","goat","goddess","gold","good","goose","gorilla","gospel","gossip","govern","gown","grab","grace","grain","grant","grape","grass","gravity","great","green","grid","grief","grit","grocery","group","grow","grunt","guard","guess","guide","guilt","guitar","gun","gym","habit","hair","half","hammer","hamster","hand","happy","harbor","hard","harsh","harvest","hat","have","hawk","hazard","head","health","heart","heavy","hedgehog","height","hello","helmet","help","hen","hero","hidden","high","hill","hint","hip","hire","history","hobby","hockey","hold","hole","holiday","hollow","home","honey","hood","hope","horn","horror","horse","hospital","host","hotel","hour","hover","hub","huge","human","humble","humor","hundred","hungry","hunt","hurdle","hurry","hurt","husband","hybrid","ice","icon","idea","identify","idle","ignore","ill","illegal","illness","image","imitate","immense","immune","impact","impose","improve","impulse","inch","include","income","increase","index","indicate","indoor","industry","infant","inflict","inform","inhale","inherit","initial","inject","injury","inmate","inner","innocent","input","inquiry","insane","insect","inside","inspire","install","intact","interest","into","invest","invite","involve","iron","island","isolate","issue","item","ivory","jacket","jaguar","jar","jazz","jealous","jeans","jelly","jewel","job","join","joke","journey","joy","judge","juice","jump","jungle","junior","junk","just","kangaroo","keen","keep","ketchup","key","kick","kid","kidney","kind","kingdom","kiss","kit","kitchen","kite","kitten","kiwi","knee","knife","knock","know","lab","label","labor","ladder","lady","lake","lamp","language","laptop","large","later","latin","laugh","laundry","lava","law","lawn","lawsuit","layer","lazy","leader","leaf","learn","leave","lecture","left","leg","legal","legend","leisure","lemon","lend","length","lens","leopard","lesson","letter","level","liar","liberty","library","license","life","lift","light","like","limb","limit","link","lion","liquid","list","little","live","lizard","load","loan","lobster","local","lock","logic","lonely","long","loop","lottery","loud","lounge","love","loyal","lucky","luggage","lumber","lunar","lunch","luxury","lyrics","machine","mad","magic","magnet","maid","mail","main","major","make","mammal","man","manage","mandate","mango","mansion","manual","maple","marble","march","margin","marine","market","marriage","mask","mass","master","match","material","math","matrix","matter","maximum","maze","meadow","mean","measure","meat","mechanic","medal","media","melody","melt","member","memory","mention","menu","mercy","merge","merit","merry","mesh","message","metal","method","middle","midnight","milk","million","mimic","mind","minimum","minor","minute","miracle","mirror","misery","miss","mistake","mix","mixed","mixture","mobile","model","modify","mom","moment","monitor","monkey","monster","month","moon","moral","more","morning","mosquito","mother","motion","motor","mountain","mouse","move","movie","much","muffin","mule","multiply","muscle","museum","mushroom","music","must","mutual","myself","mystery","myth","naive","name","napkin","narrow","nasty","nation","nature","near","neck","need","negative","neglect","neither","nephew","nerve","nest","net","network","neutral","never","news","next","nice","night","noble","noise","nominee","noodle","normal","north","nose","notable","note","nothing","notice","novel","now","nuclear","number","nurse","nut","oak","obey","object","oblige","obscure","observe","obtain","obvious","occur","ocean","october","odor","off","offer","office","often","oil","okay","old","olive","olympic","omit","once","one","onion","online","only","open","opera","opinion","oppose","option","orange","orbit","orchard","order","ordinary","organ","orient","original","orphan","ostrich","other","outdoor","outer","output","outside","oval","oven","over","own","owner","oxygen","oyster","ozone","pact","paddle","page","pair","palace","palm","panda","panel","panic","panther","paper","parade","parent","park","parrot","party","pass","patch","path","patient","patrol","pattern","pause","pave","payment","peace","peanut","pear","peasant","pelican","pen","penalty","pencil","people","pepper","perfect","permit","person","pet","phone","photo","phrase","physical","piano","picnic","picture","piece","pig","pigeon","pill","pilot","pink","pioneer","pipe","pistol","pitch","pizza","place","planet","plastic","plate","play","please","pledge","pluck","plug","plunge","poem","poet","point","polar","pole","police","pond","pony","pool","popular","portion","position","possible","post","potato","pottery","poverty","powder","power","practice","praise","predict","prefer","prepare","present","pretty","prevent","price","pride","primary","print","priority","prison","private","prize","problem","process","produce","profit","program","project","promote","proof","property","prosper","protect","proud","provide","public","pudding","pull","pulp","pulse","pumpkin","punch","pupil","puppy","purchase","purity","purpose","purse","push","put","puzzle","pyramid","quality","quantum","quarter","question","quick","quit","quiz","quote","rabbit","raccoon","race","rack","radar","radio","rail","rain","raise","rally","ramp","ranch","random","range","rapid","rare","rate","rather","raven","raw","razor","ready","real","reason","rebel","rebuild","recall","receive","recipe","record","recycle","reduce","reflect","reform","refuse","region","regret","regular","reject","relax","release","relief","rely","remain","remember","remind","remove","render","renew","rent","reopen","repair","repeat","replace","report","require","rescue","resemble","resist","resource","response","result","retire","retreat","return","reunion","reveal","review","reward","rhythm","rib","ribbon","rice","rich","ride","ridge","rifle","right","rigid","ring","riot","ripple","risk","ritual","rival","river","road","roast","robot","robust","rocket","romance","roof","rookie","room","rose","rotate","rough","round","route","royal","rubber","rude","rug","rule","run","runway","rural","sad","saddle","sadness","safe","sail","salad","salmon","salon","salt","salute","same","sample","sand","satisfy","satoshi","sauce","sausage","save","say","scale","scan","scare","scatter","scene","scheme","school","science","scissors","scorpion","scout","scrap","screen","script","scrub","sea","search","season","seat","second","secret","section","security","seed","seek","segment","select","sell","seminar","senior","sense","sentence","series","service","session","settle","setup","seven","shadow","shaft","shallow","share","shed","shell","sheriff","shield","shift","shine","ship","shiver","shock","shoe","shoot","shop","short","shoulder","shove","shrimp","shrug","shuffle","shy","sibling","sick","side","siege","sight","sign","silent","silk","silly","silver","similar","simple","since","sing","siren","sister","situate","six","size","skate","sketch","ski","skill","skin","skirt","skull","slab","slam","sleep","slender","slice","slide","slight","slim","slogan","slot","slow","slush","small","smart","smile","smoke","smooth","snack","snake","snap","sniff","snow","soap","soccer","social","sock","soda","soft","solar","soldier","solid","solution","solve","someone","song","soon","sorry","sort","soul","sound","soup","source","south","space","spare","spatial","spawn","speak","special","speed","spell","spend","sphere","spice","spider","spike","spin","spirit","split","spoil","sponsor","spoon","sport","spot","spray","spread","spring","spy","square","squeeze","squirrel","stable","stadium","staff","stage","stairs","stamp","stand","start","state","stay","steak","steel","stem","step","stereo","stick","still","sting","stock","stomach","stone","stool","story","stove","strategy","street","strike","strong","struggle","student","stuff","stumble","style","subject","submit","subway","success","such","sudden","suffer","sugar","suggest","suit","summer","sun","sunny","sunset","super","supply","supreme","sure","surface","surge","surprise","surround","survey","suspect","sustain","swallow","swamp","swap","swarm","swear","sweet","swift","swim","swing","switch","sword","symbol","symptom","syrup","system","table","tackle","tag","tail","talent","talk","tank","tape","target","task","taste","tattoo","taxi","teach","team","tell","ten","tenant","tennis","tent","term","test","text","thank","that","theme","then","theory","there","they","thing","this","thought","three","thrive","throw","thumb","thunder","ticket","tide","tiger","tilt","timber","time","tiny","tip","tired","tissue","title","toast","tobacco","today","toddler","toe","together","toilet","token","tomato","tomorrow","tone","tongue","tonight","tool","tooth","top","topic","topple","torch","tornado","tortoise","toss","total","tourist","toward","tower","town","toy","track","trade","traffic","tragic","train","transfer","trap","trash","travel","tray","treat","tree","trend","trial","tribe","trick","trigger","trim","trip","trophy","trouble","truck","true","truly","trumpet","trust","truth","try","tube","tuition","tumble","tuna","tunnel","turkey","turn","turtle","twelve","twenty","twice","twin","twist","two","type","typical","ugly","umbrella","unable","unaware","uncle","uncover","under","undo","unfair","unfold","unhappy","uniform","unique","unit","universe","unknown","unlock","until","unusual","unveil","update","upgrade","uphold","upon","upper","upset","urban","urge","usage","use","used","useful","useless","usual","utility","vacant","vacuum","vague","valid","valley","valve","van","vanish","vapor","various","vast","vault","vehicle","velvet","vendor","venture","venue","verb","verify","version","very","vessel","veteran","viable","vibrant","vicious","victory","video","view","village","vintage","violin","virtual","virus","visa","visit","visual","vital","vivid","vocal","voice","void","volcano","volume","vote","voyage","wage","wagon","wait","walk","wall","walnut","want","warfare","warm","warrior","wash","wasp","waste","water","wave","way","wealth","weapon","wear","weasel","weather","web","wedding","weekend","weird","welcome","west","wet","whale","what","wheat","wheel","when","where","whip","whisper","wide","width","wife","wild","will","win","window","wine","wing","wink","winner","winter","wire","wisdom","wise","wish","witness","wolf","woman","wonder","wood","wool","word","work","world","worry","worth","wrap","wreck","wrestle","wrist","write","wrong","yard","year","yellow","you","young","youth","zebra","zero","zone","zoo"]

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createHash = __webpack_require__(17)
var bs58checkBase = __webpack_require__(266)

// SHA256(SHA256(buffer))
function sha256x2 (buffer) {
  var tmp = createHash('sha256').update(buffer).digest()
  return createHash('sha256').update(tmp).digest()
}

module.exports = bs58checkBase(sha256x2)


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var base58 = __webpack_require__(267)
var Buffer = __webpack_require__(0).Buffer

module.exports = function (checksumFn) {
  // Encode a buffer as a base58-check encoded string
  function encode (payload) {
    var checksum = checksumFn(payload)

    return base58.encode(Buffer.concat([
      payload,
      checksum
    ], payload.length + 4))
  }

  function decodeRaw (buffer) {
    var payload = buffer.slice(0, -4)
    var checksum = buffer.slice(-4)
    var newChecksum = checksumFn(payload)

    if (checksum[0] ^ newChecksum[0] |
        checksum[1] ^ newChecksum[1] |
        checksum[2] ^ newChecksum[2] |
        checksum[3] ^ newChecksum[3]) return

    return payload
  }

  // Decode a base58-check encoded string to a buffer, no result if checksum is wrong
  function decodeUnsafe (string) {
    var buffer = base58.decodeUnsafe(string)
    if (!buffer) return

    return decodeRaw(buffer)
  }

  function decode (string) {
    var buffer = base58.decode(string)
    var payload = decodeRaw(buffer, checksumFn)
    if (!payload) throw new Error('Invalid checksum')
    return payload
  }

  return {
    encode: encode,
    decode: decode,
    decodeUnsafe: decodeUnsafe
  }
}


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var basex = __webpack_require__(268)
var ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'

module.exports = basex(ALPHABET)


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
// @ts-ignore
var _Buffer = __webpack_require__(0).Buffer
function base (ALPHABET) {
  if (ALPHABET.length >= 255) { throw new TypeError('Alphabet too long') }
  var BASE_MAP = new Uint8Array(256)
  for (var j = 0; j < BASE_MAP.length; j++) {
    BASE_MAP[j] = 255
  }
  for (var i = 0; i < ALPHABET.length; i++) {
    var x = ALPHABET.charAt(i)
    var xc = x.charCodeAt(0)
    if (BASE_MAP[xc] !== 255) { throw new TypeError(x + ' is ambiguous') }
    BASE_MAP[xc] = i
  }
  var BASE = ALPHABET.length
  var LEADER = ALPHABET.charAt(0)
  var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
  var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
  function encode (source) {
    if (Array.isArray(source) || source instanceof Uint8Array) { source = _Buffer.from(source) }
    if (!_Buffer.isBuffer(source)) { throw new TypeError('Expected Buffer') }
    if (source.length === 0) { return '' }
        // Skip & count leading zeroes.
    var zeroes = 0
    var length = 0
    var pbegin = 0
    var pend = source.length
    while (pbegin !== pend && source[pbegin] === 0) {
      pbegin++
      zeroes++
    }
        // Allocate enough space in big-endian base58 representation.
    var size = ((pend - pbegin) * iFACTOR + 1) >>> 0
    var b58 = new Uint8Array(size)
        // Process the bytes.
    while (pbegin !== pend) {
      var carry = source[pbegin]
            // Apply "b58 = b58 * 256 + ch".
      var i = 0
      for (var it1 = size - 1; (carry !== 0 || i < length) && (it1 !== -1); it1--, i++) {
        carry += (256 * b58[it1]) >>> 0
        b58[it1] = (carry % BASE) >>> 0
        carry = (carry / BASE) >>> 0
      }
      if (carry !== 0) { throw new Error('Non-zero carry') }
      length = i
      pbegin++
    }
        // Skip leading zeroes in base58 result.
    var it2 = size - length
    while (it2 !== size && b58[it2] === 0) {
      it2++
    }
        // Translate the result into a string.
    var str = LEADER.repeat(zeroes)
    for (; it2 < size; ++it2) { str += ALPHABET.charAt(b58[it2]) }
    return str
  }
  function decodeUnsafe (source) {
    if (typeof source !== 'string') { throw new TypeError('Expected String') }
    if (source.length === 0) { return _Buffer.alloc(0) }
    var psz = 0
        // Skip leading spaces.
    if (source[psz] === ' ') { return }
        // Skip and count leading '1's.
    var zeroes = 0
    var length = 0
    while (source[psz] === LEADER) {
      zeroes++
      psz++
    }
        // Allocate enough space in big-endian base256 representation.
    var size = (((source.length - psz) * FACTOR) + 1) >>> 0 // log(58) / log(256), rounded up.
    var b256 = new Uint8Array(size)
        // Process the characters.
    while (source[psz]) {
            // Decode character
      var carry = BASE_MAP[source.charCodeAt(psz)]
            // Invalid character
      if (carry === 255) { return }
      var i = 0
      for (var it3 = size - 1; (carry !== 0 || i < length) && (it3 !== -1); it3--, i++) {
        carry += (BASE * b256[it3]) >>> 0
        b256[it3] = (carry % 256) >>> 0
        carry = (carry / 256) >>> 0
      }
      if (carry !== 0) { throw new Error('Non-zero carry') }
      length = i
      psz++
    }
        // Skip trailing spaces.
    if (source[psz] === ' ') { return }
        // Skip leading zeroes in b256.
    var it4 = size - length
    while (it4 !== size && b256[it4] === 0) {
      it4++
    }
    var vch = _Buffer.allocUnsafe(zeroes + (size - it4))
    vch.fill(0x00, 0, zeroes)
    var j = zeroes
    while (it4 !== size) {
      vch[j++] = b256[it4++]
    }
    return vch
  }
  function decode (string) {
    var buffer = decodeUnsafe(string)
    if (buffer) { return buffer }
    throw new Error('Non-base' + BASE + ' character')
  }
  return {
    encode: encode,
    decodeUnsafe: decodeUnsafe,
    decode: decode
  }
}
module.exports = base


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * ed2curve: convert Ed25519 signing key pair into Curve25519
 * key pair suitable for Diffie-Hellman key exchange.
 *
 * Written by Dmitry Chestnykh in 2014. Public domain.
 */
/* jshint newcap: false */
(function(root, f) {
  'use strict';
  if (typeof module !== 'undefined' && module.exports) module.exports = f(__webpack_require__(270));
  else root.ed2curve = f(root.nacl);
}(this, function(nacl) {
  'use strict';
  if (!nacl) throw new Error('tweetnacl not loaded');

  // -- Operations copied from TweetNaCl.js. --

  var gf = function(init) {
    var i, r = new Float64Array(16);
    if (init) for (i = 0; i < init.length; i++) r[i] = init[i];
    return r;
  };

  var gf0 = gf(),
      gf1 = gf([1]),
      D = gf([0x78a3, 0x1359, 0x4dca, 0x75eb, 0xd8ab, 0x4141, 0x0a4d, 0x0070, 0xe898, 0x7779, 0x4079, 0x8cc7, 0xfe73, 0x2b6f, 0x6cee, 0x5203]),
      I = gf([0xa0b0, 0x4a0e, 0x1b27, 0xc4ee, 0xe478, 0xad2f, 0x1806, 0x2f43, 0xd7a7, 0x3dfb, 0x0099, 0x2b4d, 0xdf0b, 0x4fc1, 0x2480, 0x2b83]);



  function car25519(o) {
    var c;
    var i;
    for (i = 0; i < 16; i++) {
      o[i] += 65536;
      c = Math.floor(o[i] / 65536);
      o[(i+1)*(i<15?1:0)] += c - 1 + 37 * (c-1) * (i===15?1:0);
      o[i] -= (c * 65536);
    }
  }

  function sel25519(p, q, b) {
    var t, c = ~(b-1);
    for (var i = 0; i < 16; i++) {
      t = c & (p[i] ^ q[i]);
      p[i] ^= t;
      q[i] ^= t;
    }
  }

  function unpack25519(o, n) {
    var i;
    for (i = 0; i < 16; i++) o[i] = n[2*i] + (n[2*i+1] << 8);
    o[15] &= 0x7fff;
  }

  // addition
  function A(o, a, b) {
    var i;
    for (i = 0; i < 16; i++) o[i] = (a[i] + b[i])|0;
  }

  // subtraction
  function Z(o, a, b) {
    var i;
    for (i = 0; i < 16; i++) o[i] = (a[i] - b[i])|0;
  }

  // multiplication
  function M(o, a, b) {
    var i, j, t = new Float64Array(31);
    for (i = 0; i < 31; i++) t[i] = 0;
    for (i = 0; i < 16; i++) {
      for (j = 0; j < 16; j++) {
        t[i+j] += a[i] * b[j];
      }
    }
    for (i = 0; i < 15; i++) {
      t[i] += 38 * t[i+16];
    }
    for (i = 0; i < 16; i++) o[i] = t[i];
    car25519(o);
    car25519(o);
  }

  // squaring
  function S(o, a) {
    M(o, a, a);
  }

  // inversion
  function inv25519(o, i) {
    var c = gf();
    var a;
    for (a = 0; a < 16; a++) c[a] = i[a];
    for (a = 253; a >= 0; a--) {
      S(c, c);
      if(a !== 2 && a !== 4) M(c, c, i);
    }
    for (a = 0; a < 16; a++) o[a] = c[a];
  }

  function pack25519(o, n) {
    var i, j, b;
    var m = gf(), t = gf();
    for (i = 0; i < 16; i++) t[i] = n[i];
    car25519(t);
    car25519(t);
    car25519(t);
    for (j = 0; j < 2; j++) {
      m[0] = t[0] - 0xffed;
      for (i = 1; i < 15; i++) {
        m[i] = t[i] - 0xffff - ((m[i-1]>>16) & 1);
        m[i-1] &= 0xffff;
      }
      m[15] = t[15] - 0x7fff - ((m[14]>>16) & 1);
      b = (m[15]>>16) & 1;
      m[14] &= 0xffff;
      sel25519(t, m, 1-b);
    }
    for (i = 0; i < 16; i++) {
      o[2*i] = t[i] & 0xff;
      o[2*i+1] = t[i] >> 8;
    }
  }


  function par25519(a) {
    var d = new Uint8Array(32);
    pack25519(d, a);
    return d[0] & 1;
  }



  function vn(x, xi, y, yi, n) {
    var i, d = 0;
    for (i = 0; i < n; i++) d |= x[xi + i] ^ y[yi + i];
    return (1 & ((d - 1) >>> 8)) - 1;
  }


  function crypto_verify_32(x, xi, y, yi) {
    return vn(x, xi, y, yi, 32);
  }

  function neq25519(a, b) {
    var c = new Uint8Array(32), d = new Uint8Array(32);
    pack25519(c, a);
    pack25519(d, b);
    return crypto_verify_32(c, 0, d, 0);
  }


  function pow2523(o, i) {
    var c = gf();
    var a;
    for (a = 0; a < 16; a++) c[a] = i[a];
    for (a = 250; a >= 0; a--) {
      S(c, c);
      if (a !== 1) M(c, c, i);
    }
    for (a = 0; a < 16; a++) o[a] = c[a];
  }

  function set25519(r, a) {
    var i;
    for (i = 0; i < 16; i++) r[i] = a[i] | 0;
  }

  function unpackneg(r, p) {
    var t = gf(), chk = gf(), num = gf(),
      den = gf(), den2 = gf(), den4 = gf(),
      den6 = gf();

    set25519(r[2], gf1);
    unpack25519(r[1], p);
    S(num, r[1]);
    M(den, num, D);
    Z(num, num, r[2]);
    A(den, r[2], den);

    S(den2, den);
    S(den4, den2);
    M(den6, den4, den2);
    M(t, den6, num);
    M(t, t, den);

    pow2523(t, t);
    M(t, t, num);
    M(t, t, den);
    M(t, t, den);
    M(r[0], t, den);

    S(chk, r[0]);
    M(chk, chk, den);
    if (neq25519(chk, num)) M(r[0], r[0], I);

    S(chk, r[0]);
    M(chk, chk, den);
    if (neq25519(chk, num)) return -1;

    if (par25519(r[0]) === (p[31] >> 7)) Z(r[0], gf0, r[0]);

    M(r[3], r[0], r[1]);
    return 0;
  }

  // ----

  // Converts Ed25519 public key to Curve25519 public key.
  // montgomeryX = (edwardsY + 1)*inverse(1 - edwardsY) mod p
  function convertPublicKey(pk) {
    var z = new Uint8Array(32),
      q = [gf(), gf(), gf(), gf()],
      a = gf(), b = gf();

    if (unpackneg(q, pk)) return null; // reject invalid key

    var y = q[1];

    A(a, gf1, y);
    Z(b, gf1, y);
    inv25519(b, b);
    M(a, a, b);

    pack25519(z, a);
    return z;
  }

  // Converts Ed25519 secret key to Curve25519 secret key.
  function convertSecretKey(sk) {
    var d = new Uint8Array(64), o = new Uint8Array(32), i;
    nacl.lowlevel.crypto_hash(d, sk, 32);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    for (i = 0; i < 32; i++) o[i] = d[i];
    for (i = 0; i < 64; i++) d[i] = 0;
    return o;
  }

  function convertKeyPair(edKeyPair) {
    var publicKey = convertPublicKey(edKeyPair.publicKey);
    if (!publicKey) return null;
    return {
      publicKey: publicKey,
      secretKey: convertSecretKey(edKeyPair.secretKey)
    };
  }

  return {
    convertPublicKey: convertPublicKey,
    convertSecretKey: convertSecretKey,
    convertKeyPair: convertKeyPair,
  };

}));


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

(function(nacl) {
'use strict';

// Ported in 2014 by Dmitry Chestnykh and Devi Mandiri.
// Public domain.
//
// Implementation derived from TweetNaCl version 20140427.
// See for details: http://tweetnacl.cr.yp.to/

var gf = function(init) {
  var i, r = new Float64Array(16);
  if (init) for (i = 0; i < init.length; i++) r[i] = init[i];
  return r;
};

//  Pluggable, initialized in high-level API below.
var randombytes = function(/* x, n */) { throw new Error('no PRNG'); };

var _0 = new Uint8Array(16);
var _9 = new Uint8Array(32); _9[0] = 9;

var gf0 = gf(),
    gf1 = gf([1]),
    _121665 = gf([0xdb41, 1]),
    D = gf([0x78a3, 0x1359, 0x4dca, 0x75eb, 0xd8ab, 0x4141, 0x0a4d, 0x0070, 0xe898, 0x7779, 0x4079, 0x8cc7, 0xfe73, 0x2b6f, 0x6cee, 0x5203]),
    D2 = gf([0xf159, 0x26b2, 0x9b94, 0xebd6, 0xb156, 0x8283, 0x149a, 0x00e0, 0xd130, 0xeef3, 0x80f2, 0x198e, 0xfce7, 0x56df, 0xd9dc, 0x2406]),
    X = gf([0xd51a, 0x8f25, 0x2d60, 0xc956, 0xa7b2, 0x9525, 0xc760, 0x692c, 0xdc5c, 0xfdd6, 0xe231, 0xc0a4, 0x53fe, 0xcd6e, 0x36d3, 0x2169]),
    Y = gf([0x6658, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666]),
    I = gf([0xa0b0, 0x4a0e, 0x1b27, 0xc4ee, 0xe478, 0xad2f, 0x1806, 0x2f43, 0xd7a7, 0x3dfb, 0x0099, 0x2b4d, 0xdf0b, 0x4fc1, 0x2480, 0x2b83]);

function ts64(x, i, h, l) {
  x[i]   = (h >> 24) & 0xff;
  x[i+1] = (h >> 16) & 0xff;
  x[i+2] = (h >>  8) & 0xff;
  x[i+3] = h & 0xff;
  x[i+4] = (l >> 24)  & 0xff;
  x[i+5] = (l >> 16)  & 0xff;
  x[i+6] = (l >>  8)  & 0xff;
  x[i+7] = l & 0xff;
}

function vn(x, xi, y, yi, n) {
  var i,d = 0;
  for (i = 0; i < n; i++) d |= x[xi+i]^y[yi+i];
  return (1 & ((d - 1) >>> 8)) - 1;
}

function crypto_verify_16(x, xi, y, yi) {
  return vn(x,xi,y,yi,16);
}

function crypto_verify_32(x, xi, y, yi) {
  return vn(x,xi,y,yi,32);
}

function core_salsa20(o, p, k, c) {
  var j0  = c[ 0] & 0xff | (c[ 1] & 0xff)<<8 | (c[ 2] & 0xff)<<16 | (c[ 3] & 0xff)<<24,
      j1  = k[ 0] & 0xff | (k[ 1] & 0xff)<<8 | (k[ 2] & 0xff)<<16 | (k[ 3] & 0xff)<<24,
      j2  = k[ 4] & 0xff | (k[ 5] & 0xff)<<8 | (k[ 6] & 0xff)<<16 | (k[ 7] & 0xff)<<24,
      j3  = k[ 8] & 0xff | (k[ 9] & 0xff)<<8 | (k[10] & 0xff)<<16 | (k[11] & 0xff)<<24,
      j4  = k[12] & 0xff | (k[13] & 0xff)<<8 | (k[14] & 0xff)<<16 | (k[15] & 0xff)<<24,
      j5  = c[ 4] & 0xff | (c[ 5] & 0xff)<<8 | (c[ 6] & 0xff)<<16 | (c[ 7] & 0xff)<<24,
      j6  = p[ 0] & 0xff | (p[ 1] & 0xff)<<8 | (p[ 2] & 0xff)<<16 | (p[ 3] & 0xff)<<24,
      j7  = p[ 4] & 0xff | (p[ 5] & 0xff)<<8 | (p[ 6] & 0xff)<<16 | (p[ 7] & 0xff)<<24,
      j8  = p[ 8] & 0xff | (p[ 9] & 0xff)<<8 | (p[10] & 0xff)<<16 | (p[11] & 0xff)<<24,
      j9  = p[12] & 0xff | (p[13] & 0xff)<<8 | (p[14] & 0xff)<<16 | (p[15] & 0xff)<<24,
      j10 = c[ 8] & 0xff | (c[ 9] & 0xff)<<8 | (c[10] & 0xff)<<16 | (c[11] & 0xff)<<24,
      j11 = k[16] & 0xff | (k[17] & 0xff)<<8 | (k[18] & 0xff)<<16 | (k[19] & 0xff)<<24,
      j12 = k[20] & 0xff | (k[21] & 0xff)<<8 | (k[22] & 0xff)<<16 | (k[23] & 0xff)<<24,
      j13 = k[24] & 0xff | (k[25] & 0xff)<<8 | (k[26] & 0xff)<<16 | (k[27] & 0xff)<<24,
      j14 = k[28] & 0xff | (k[29] & 0xff)<<8 | (k[30] & 0xff)<<16 | (k[31] & 0xff)<<24,
      j15 = c[12] & 0xff | (c[13] & 0xff)<<8 | (c[14] & 0xff)<<16 | (c[15] & 0xff)<<24;

  var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7,
      x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14,
      x15 = j15, u;

  for (var i = 0; i < 20; i += 2) {
    u = x0 + x12 | 0;
    x4 ^= u<<7 | u>>>(32-7);
    u = x4 + x0 | 0;
    x8 ^= u<<9 | u>>>(32-9);
    u = x8 + x4 | 0;
    x12 ^= u<<13 | u>>>(32-13);
    u = x12 + x8 | 0;
    x0 ^= u<<18 | u>>>(32-18);

    u = x5 + x1 | 0;
    x9 ^= u<<7 | u>>>(32-7);
    u = x9 + x5 | 0;
    x13 ^= u<<9 | u>>>(32-9);
    u = x13 + x9 | 0;
    x1 ^= u<<13 | u>>>(32-13);
    u = x1 + x13 | 0;
    x5 ^= u<<18 | u>>>(32-18);

    u = x10 + x6 | 0;
    x14 ^= u<<7 | u>>>(32-7);
    u = x14 + x10 | 0;
    x2 ^= u<<9 | u>>>(32-9);
    u = x2 + x14 | 0;
    x6 ^= u<<13 | u>>>(32-13);
    u = x6 + x2 | 0;
    x10 ^= u<<18 | u>>>(32-18);

    u = x15 + x11 | 0;
    x3 ^= u<<7 | u>>>(32-7);
    u = x3 + x15 | 0;
    x7 ^= u<<9 | u>>>(32-9);
    u = x7 + x3 | 0;
    x11 ^= u<<13 | u>>>(32-13);
    u = x11 + x7 | 0;
    x15 ^= u<<18 | u>>>(32-18);

    u = x0 + x3 | 0;
    x1 ^= u<<7 | u>>>(32-7);
    u = x1 + x0 | 0;
    x2 ^= u<<9 | u>>>(32-9);
    u = x2 + x1 | 0;
    x3 ^= u<<13 | u>>>(32-13);
    u = x3 + x2 | 0;
    x0 ^= u<<18 | u>>>(32-18);

    u = x5 + x4 | 0;
    x6 ^= u<<7 | u>>>(32-7);
    u = x6 + x5 | 0;
    x7 ^= u<<9 | u>>>(32-9);
    u = x7 + x6 | 0;
    x4 ^= u<<13 | u>>>(32-13);
    u = x4 + x7 | 0;
    x5 ^= u<<18 | u>>>(32-18);

    u = x10 + x9 | 0;
    x11 ^= u<<7 | u>>>(32-7);
    u = x11 + x10 | 0;
    x8 ^= u<<9 | u>>>(32-9);
    u = x8 + x11 | 0;
    x9 ^= u<<13 | u>>>(32-13);
    u = x9 + x8 | 0;
    x10 ^= u<<18 | u>>>(32-18);

    u = x15 + x14 | 0;
    x12 ^= u<<7 | u>>>(32-7);
    u = x12 + x15 | 0;
    x13 ^= u<<9 | u>>>(32-9);
    u = x13 + x12 | 0;
    x14 ^= u<<13 | u>>>(32-13);
    u = x14 + x13 | 0;
    x15 ^= u<<18 | u>>>(32-18);
  }
   x0 =  x0 +  j0 | 0;
   x1 =  x1 +  j1 | 0;
   x2 =  x2 +  j2 | 0;
   x3 =  x3 +  j3 | 0;
   x4 =  x4 +  j4 | 0;
   x5 =  x5 +  j5 | 0;
   x6 =  x6 +  j6 | 0;
   x7 =  x7 +  j7 | 0;
   x8 =  x8 +  j8 | 0;
   x9 =  x9 +  j9 | 0;
  x10 = x10 + j10 | 0;
  x11 = x11 + j11 | 0;
  x12 = x12 + j12 | 0;
  x13 = x13 + j13 | 0;
  x14 = x14 + j14 | 0;
  x15 = x15 + j15 | 0;

  o[ 0] = x0 >>>  0 & 0xff;
  o[ 1] = x0 >>>  8 & 0xff;
  o[ 2] = x0 >>> 16 & 0xff;
  o[ 3] = x0 >>> 24 & 0xff;

  o[ 4] = x1 >>>  0 & 0xff;
  o[ 5] = x1 >>>  8 & 0xff;
  o[ 6] = x1 >>> 16 & 0xff;
  o[ 7] = x1 >>> 24 & 0xff;

  o[ 8] = x2 >>>  0 & 0xff;
  o[ 9] = x2 >>>  8 & 0xff;
  o[10] = x2 >>> 16 & 0xff;
  o[11] = x2 >>> 24 & 0xff;

  o[12] = x3 >>>  0 & 0xff;
  o[13] = x3 >>>  8 & 0xff;
  o[14] = x3 >>> 16 & 0xff;
  o[15] = x3 >>> 24 & 0xff;

  o[16] = x4 >>>  0 & 0xff;
  o[17] = x4 >>>  8 & 0xff;
  o[18] = x4 >>> 16 & 0xff;
  o[19] = x4 >>> 24 & 0xff;

  o[20] = x5 >>>  0 & 0xff;
  o[21] = x5 >>>  8 & 0xff;
  o[22] = x5 >>> 16 & 0xff;
  o[23] = x5 >>> 24 & 0xff;

  o[24] = x6 >>>  0 & 0xff;
  o[25] = x6 >>>  8 & 0xff;
  o[26] = x6 >>> 16 & 0xff;
  o[27] = x6 >>> 24 & 0xff;

  o[28] = x7 >>>  0 & 0xff;
  o[29] = x7 >>>  8 & 0xff;
  o[30] = x7 >>> 16 & 0xff;
  o[31] = x7 >>> 24 & 0xff;

  o[32] = x8 >>>  0 & 0xff;
  o[33] = x8 >>>  8 & 0xff;
  o[34] = x8 >>> 16 & 0xff;
  o[35] = x8 >>> 24 & 0xff;

  o[36] = x9 >>>  0 & 0xff;
  o[37] = x9 >>>  8 & 0xff;
  o[38] = x9 >>> 16 & 0xff;
  o[39] = x9 >>> 24 & 0xff;

  o[40] = x10 >>>  0 & 0xff;
  o[41] = x10 >>>  8 & 0xff;
  o[42] = x10 >>> 16 & 0xff;
  o[43] = x10 >>> 24 & 0xff;

  o[44] = x11 >>>  0 & 0xff;
  o[45] = x11 >>>  8 & 0xff;
  o[46] = x11 >>> 16 & 0xff;
  o[47] = x11 >>> 24 & 0xff;

  o[48] = x12 >>>  0 & 0xff;
  o[49] = x12 >>>  8 & 0xff;
  o[50] = x12 >>> 16 & 0xff;
  o[51] = x12 >>> 24 & 0xff;

  o[52] = x13 >>>  0 & 0xff;
  o[53] = x13 >>>  8 & 0xff;
  o[54] = x13 >>> 16 & 0xff;
  o[55] = x13 >>> 24 & 0xff;

  o[56] = x14 >>>  0 & 0xff;
  o[57] = x14 >>>  8 & 0xff;
  o[58] = x14 >>> 16 & 0xff;
  o[59] = x14 >>> 24 & 0xff;

  o[60] = x15 >>>  0 & 0xff;
  o[61] = x15 >>>  8 & 0xff;
  o[62] = x15 >>> 16 & 0xff;
  o[63] = x15 >>> 24 & 0xff;
}

function core_hsalsa20(o,p,k,c) {
  var j0  = c[ 0] & 0xff | (c[ 1] & 0xff)<<8 | (c[ 2] & 0xff)<<16 | (c[ 3] & 0xff)<<24,
      j1  = k[ 0] & 0xff | (k[ 1] & 0xff)<<8 | (k[ 2] & 0xff)<<16 | (k[ 3] & 0xff)<<24,
      j2  = k[ 4] & 0xff | (k[ 5] & 0xff)<<8 | (k[ 6] & 0xff)<<16 | (k[ 7] & 0xff)<<24,
      j3  = k[ 8] & 0xff | (k[ 9] & 0xff)<<8 | (k[10] & 0xff)<<16 | (k[11] & 0xff)<<24,
      j4  = k[12] & 0xff | (k[13] & 0xff)<<8 | (k[14] & 0xff)<<16 | (k[15] & 0xff)<<24,
      j5  = c[ 4] & 0xff | (c[ 5] & 0xff)<<8 | (c[ 6] & 0xff)<<16 | (c[ 7] & 0xff)<<24,
      j6  = p[ 0] & 0xff | (p[ 1] & 0xff)<<8 | (p[ 2] & 0xff)<<16 | (p[ 3] & 0xff)<<24,
      j7  = p[ 4] & 0xff | (p[ 5] & 0xff)<<8 | (p[ 6] & 0xff)<<16 | (p[ 7] & 0xff)<<24,
      j8  = p[ 8] & 0xff | (p[ 9] & 0xff)<<8 | (p[10] & 0xff)<<16 | (p[11] & 0xff)<<24,
      j9  = p[12] & 0xff | (p[13] & 0xff)<<8 | (p[14] & 0xff)<<16 | (p[15] & 0xff)<<24,
      j10 = c[ 8] & 0xff | (c[ 9] & 0xff)<<8 | (c[10] & 0xff)<<16 | (c[11] & 0xff)<<24,
      j11 = k[16] & 0xff | (k[17] & 0xff)<<8 | (k[18] & 0xff)<<16 | (k[19] & 0xff)<<24,
      j12 = k[20] & 0xff | (k[21] & 0xff)<<8 | (k[22] & 0xff)<<16 | (k[23] & 0xff)<<24,
      j13 = k[24] & 0xff | (k[25] & 0xff)<<8 | (k[26] & 0xff)<<16 | (k[27] & 0xff)<<24,
      j14 = k[28] & 0xff | (k[29] & 0xff)<<8 | (k[30] & 0xff)<<16 | (k[31] & 0xff)<<24,
      j15 = c[12] & 0xff | (c[13] & 0xff)<<8 | (c[14] & 0xff)<<16 | (c[15] & 0xff)<<24;

  var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7,
      x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14,
      x15 = j15, u;

  for (var i = 0; i < 20; i += 2) {
    u = x0 + x12 | 0;
    x4 ^= u<<7 | u>>>(32-7);
    u = x4 + x0 | 0;
    x8 ^= u<<9 | u>>>(32-9);
    u = x8 + x4 | 0;
    x12 ^= u<<13 | u>>>(32-13);
    u = x12 + x8 | 0;
    x0 ^= u<<18 | u>>>(32-18);

    u = x5 + x1 | 0;
    x9 ^= u<<7 | u>>>(32-7);
    u = x9 + x5 | 0;
    x13 ^= u<<9 | u>>>(32-9);
    u = x13 + x9 | 0;
    x1 ^= u<<13 | u>>>(32-13);
    u = x1 + x13 | 0;
    x5 ^= u<<18 | u>>>(32-18);

    u = x10 + x6 | 0;
    x14 ^= u<<7 | u>>>(32-7);
    u = x14 + x10 | 0;
    x2 ^= u<<9 | u>>>(32-9);
    u = x2 + x14 | 0;
    x6 ^= u<<13 | u>>>(32-13);
    u = x6 + x2 | 0;
    x10 ^= u<<18 | u>>>(32-18);

    u = x15 + x11 | 0;
    x3 ^= u<<7 | u>>>(32-7);
    u = x3 + x15 | 0;
    x7 ^= u<<9 | u>>>(32-9);
    u = x7 + x3 | 0;
    x11 ^= u<<13 | u>>>(32-13);
    u = x11 + x7 | 0;
    x15 ^= u<<18 | u>>>(32-18);

    u = x0 + x3 | 0;
    x1 ^= u<<7 | u>>>(32-7);
    u = x1 + x0 | 0;
    x2 ^= u<<9 | u>>>(32-9);
    u = x2 + x1 | 0;
    x3 ^= u<<13 | u>>>(32-13);
    u = x3 + x2 | 0;
    x0 ^= u<<18 | u>>>(32-18);

    u = x5 + x4 | 0;
    x6 ^= u<<7 | u>>>(32-7);
    u = x6 + x5 | 0;
    x7 ^= u<<9 | u>>>(32-9);
    u = x7 + x6 | 0;
    x4 ^= u<<13 | u>>>(32-13);
    u = x4 + x7 | 0;
    x5 ^= u<<18 | u>>>(32-18);

    u = x10 + x9 | 0;
    x11 ^= u<<7 | u>>>(32-7);
    u = x11 + x10 | 0;
    x8 ^= u<<9 | u>>>(32-9);
    u = x8 + x11 | 0;
    x9 ^= u<<13 | u>>>(32-13);
    u = x9 + x8 | 0;
    x10 ^= u<<18 | u>>>(32-18);

    u = x15 + x14 | 0;
    x12 ^= u<<7 | u>>>(32-7);
    u = x12 + x15 | 0;
    x13 ^= u<<9 | u>>>(32-9);
    u = x13 + x12 | 0;
    x14 ^= u<<13 | u>>>(32-13);
    u = x14 + x13 | 0;
    x15 ^= u<<18 | u>>>(32-18);
  }

  o[ 0] = x0 >>>  0 & 0xff;
  o[ 1] = x0 >>>  8 & 0xff;
  o[ 2] = x0 >>> 16 & 0xff;
  o[ 3] = x0 >>> 24 & 0xff;

  o[ 4] = x5 >>>  0 & 0xff;
  o[ 5] = x5 >>>  8 & 0xff;
  o[ 6] = x5 >>> 16 & 0xff;
  o[ 7] = x5 >>> 24 & 0xff;

  o[ 8] = x10 >>>  0 & 0xff;
  o[ 9] = x10 >>>  8 & 0xff;
  o[10] = x10 >>> 16 & 0xff;
  o[11] = x10 >>> 24 & 0xff;

  o[12] = x15 >>>  0 & 0xff;
  o[13] = x15 >>>  8 & 0xff;
  o[14] = x15 >>> 16 & 0xff;
  o[15] = x15 >>> 24 & 0xff;

  o[16] = x6 >>>  0 & 0xff;
  o[17] = x6 >>>  8 & 0xff;
  o[18] = x6 >>> 16 & 0xff;
  o[19] = x6 >>> 24 & 0xff;

  o[20] = x7 >>>  0 & 0xff;
  o[21] = x7 >>>  8 & 0xff;
  o[22] = x7 >>> 16 & 0xff;
  o[23] = x7 >>> 24 & 0xff;

  o[24] = x8 >>>  0 & 0xff;
  o[25] = x8 >>>  8 & 0xff;
  o[26] = x8 >>> 16 & 0xff;
  o[27] = x8 >>> 24 & 0xff;

  o[28] = x9 >>>  0 & 0xff;
  o[29] = x9 >>>  8 & 0xff;
  o[30] = x9 >>> 16 & 0xff;
  o[31] = x9 >>> 24 & 0xff;
}

function crypto_core_salsa20(out,inp,k,c) {
  core_salsa20(out,inp,k,c);
}

function crypto_core_hsalsa20(out,inp,k,c) {
  core_hsalsa20(out,inp,k,c);
}

var sigma = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
            // "expand 32-byte k"

function crypto_stream_salsa20_xor(c,cpos,m,mpos,b,n,k) {
  var z = new Uint8Array(16), x = new Uint8Array(64);
  var u, i;
  for (i = 0; i < 16; i++) z[i] = 0;
  for (i = 0; i < 8; i++) z[i] = n[i];
  while (b >= 64) {
    crypto_core_salsa20(x,z,k,sigma);
    for (i = 0; i < 64; i++) c[cpos+i] = m[mpos+i] ^ x[i];
    u = 1;
    for (i = 8; i < 16; i++) {
      u = u + (z[i] & 0xff) | 0;
      z[i] = u & 0xff;
      u >>>= 8;
    }
    b -= 64;
    cpos += 64;
    mpos += 64;
  }
  if (b > 0) {
    crypto_core_salsa20(x,z,k,sigma);
    for (i = 0; i < b; i++) c[cpos+i] = m[mpos+i] ^ x[i];
  }
  return 0;
}

function crypto_stream_salsa20(c,cpos,b,n,k) {
  var z = new Uint8Array(16), x = new Uint8Array(64);
  var u, i;
  for (i = 0; i < 16; i++) z[i] = 0;
  for (i = 0; i < 8; i++) z[i] = n[i];
  while (b >= 64) {
    crypto_core_salsa20(x,z,k,sigma);
    for (i = 0; i < 64; i++) c[cpos+i] = x[i];
    u = 1;
    for (i = 8; i < 16; i++) {
      u = u + (z[i] & 0xff) | 0;
      z[i] = u & 0xff;
      u >>>= 8;
    }
    b -= 64;
    cpos += 64;
  }
  if (b > 0) {
    crypto_core_salsa20(x,z,k,sigma);
    for (i = 0; i < b; i++) c[cpos+i] = x[i];
  }
  return 0;
}

function crypto_stream(c,cpos,d,n,k) {
  var s = new Uint8Array(32);
  crypto_core_hsalsa20(s,n,k,sigma);
  var sn = new Uint8Array(8);
  for (var i = 0; i < 8; i++) sn[i] = n[i+16];
  return crypto_stream_salsa20(c,cpos,d,sn,s);
}

function crypto_stream_xor(c,cpos,m,mpos,d,n,k) {
  var s = new Uint8Array(32);
  crypto_core_hsalsa20(s,n,k,sigma);
  var sn = new Uint8Array(8);
  for (var i = 0; i < 8; i++) sn[i] = n[i+16];
  return crypto_stream_salsa20_xor(c,cpos,m,mpos,d,sn,s);
}

/*
* Port of Andrew Moon's Poly1305-donna-16. Public domain.
* https://github.com/floodyberry/poly1305-donna
*/

var poly1305 = function(key) {
  this.buffer = new Uint8Array(16);
  this.r = new Uint16Array(10);
  this.h = new Uint16Array(10);
  this.pad = new Uint16Array(8);
  this.leftover = 0;
  this.fin = 0;

  var t0, t1, t2, t3, t4, t5, t6, t7;

  t0 = key[ 0] & 0xff | (key[ 1] & 0xff) << 8; this.r[0] = ( t0                     ) & 0x1fff;
  t1 = key[ 2] & 0xff | (key[ 3] & 0xff) << 8; this.r[1] = ((t0 >>> 13) | (t1 <<  3)) & 0x1fff;
  t2 = key[ 4] & 0xff | (key[ 5] & 0xff) << 8; this.r[2] = ((t1 >>> 10) | (t2 <<  6)) & 0x1f03;
  t3 = key[ 6] & 0xff | (key[ 7] & 0xff) << 8; this.r[3] = ((t2 >>>  7) | (t3 <<  9)) & 0x1fff;
  t4 = key[ 8] & 0xff | (key[ 9] & 0xff) << 8; this.r[4] = ((t3 >>>  4) | (t4 << 12)) & 0x00ff;
  this.r[5] = ((t4 >>>  1)) & 0x1ffe;
  t5 = key[10] & 0xff | (key[11] & 0xff) << 8; this.r[6] = ((t4 >>> 14) | (t5 <<  2)) & 0x1fff;
  t6 = key[12] & 0xff | (key[13] & 0xff) << 8; this.r[7] = ((t5 >>> 11) | (t6 <<  5)) & 0x1f81;
  t7 = key[14] & 0xff | (key[15] & 0xff) << 8; this.r[8] = ((t6 >>>  8) | (t7 <<  8)) & 0x1fff;
  this.r[9] = ((t7 >>>  5)) & 0x007f;

  this.pad[0] = key[16] & 0xff | (key[17] & 0xff) << 8;
  this.pad[1] = key[18] & 0xff | (key[19] & 0xff) << 8;
  this.pad[2] = key[20] & 0xff | (key[21] & 0xff) << 8;
  this.pad[3] = key[22] & 0xff | (key[23] & 0xff) << 8;
  this.pad[4] = key[24] & 0xff | (key[25] & 0xff) << 8;
  this.pad[5] = key[26] & 0xff | (key[27] & 0xff) << 8;
  this.pad[6] = key[28] & 0xff | (key[29] & 0xff) << 8;
  this.pad[7] = key[30] & 0xff | (key[31] & 0xff) << 8;
};

poly1305.prototype.blocks = function(m, mpos, bytes) {
  var hibit = this.fin ? 0 : (1 << 11);
  var t0, t1, t2, t3, t4, t5, t6, t7, c;
  var d0, d1, d2, d3, d4, d5, d6, d7, d8, d9;

  var h0 = this.h[0],
      h1 = this.h[1],
      h2 = this.h[2],
      h3 = this.h[3],
      h4 = this.h[4],
      h5 = this.h[5],
      h6 = this.h[6],
      h7 = this.h[7],
      h8 = this.h[8],
      h9 = this.h[9];

  var r0 = this.r[0],
      r1 = this.r[1],
      r2 = this.r[2],
      r3 = this.r[3],
      r4 = this.r[4],
      r5 = this.r[5],
      r6 = this.r[6],
      r7 = this.r[7],
      r8 = this.r[8],
      r9 = this.r[9];

  while (bytes >= 16) {
    t0 = m[mpos+ 0] & 0xff | (m[mpos+ 1] & 0xff) << 8; h0 += ( t0                     ) & 0x1fff;
    t1 = m[mpos+ 2] & 0xff | (m[mpos+ 3] & 0xff) << 8; h1 += ((t0 >>> 13) | (t1 <<  3)) & 0x1fff;
    t2 = m[mpos+ 4] & 0xff | (m[mpos+ 5] & 0xff) << 8; h2 += ((t1 >>> 10) | (t2 <<  6)) & 0x1fff;
    t3 = m[mpos+ 6] & 0xff | (m[mpos+ 7] & 0xff) << 8; h3 += ((t2 >>>  7) | (t3 <<  9)) & 0x1fff;
    t4 = m[mpos+ 8] & 0xff | (m[mpos+ 9] & 0xff) << 8; h4 += ((t3 >>>  4) | (t4 << 12)) & 0x1fff;
    h5 += ((t4 >>>  1)) & 0x1fff;
    t5 = m[mpos+10] & 0xff | (m[mpos+11] & 0xff) << 8; h6 += ((t4 >>> 14) | (t5 <<  2)) & 0x1fff;
    t6 = m[mpos+12] & 0xff | (m[mpos+13] & 0xff) << 8; h7 += ((t5 >>> 11) | (t6 <<  5)) & 0x1fff;
    t7 = m[mpos+14] & 0xff | (m[mpos+15] & 0xff) << 8; h8 += ((t6 >>>  8) | (t7 <<  8)) & 0x1fff;
    h9 += ((t7 >>> 5)) | hibit;

    c = 0;

    d0 = c;
    d0 += h0 * r0;
    d0 += h1 * (5 * r9);
    d0 += h2 * (5 * r8);
    d0 += h3 * (5 * r7);
    d0 += h4 * (5 * r6);
    c = (d0 >>> 13); d0 &= 0x1fff;
    d0 += h5 * (5 * r5);
    d0 += h6 * (5 * r4);
    d0 += h7 * (5 * r3);
    d0 += h8 * (5 * r2);
    d0 += h9 * (5 * r1);
    c += (d0 >>> 13); d0 &= 0x1fff;

    d1 = c;
    d1 += h0 * r1;
    d1 += h1 * r0;
    d1 += h2 * (5 * r9);
    d1 += h3 * (5 * r8);
    d1 += h4 * (5 * r7);
    c = (d1 >>> 13); d1 &= 0x1fff;
    d1 += h5 * (5 * r6);
    d1 += h6 * (5 * r5);
    d1 += h7 * (5 * r4);
    d1 += h8 * (5 * r3);
    d1 += h9 * (5 * r2);
    c += (d1 >>> 13); d1 &= 0x1fff;

    d2 = c;
    d2 += h0 * r2;
    d2 += h1 * r1;
    d2 += h2 * r0;
    d2 += h3 * (5 * r9);
    d2 += h4 * (5 * r8);
    c = (d2 >>> 13); d2 &= 0x1fff;
    d2 += h5 * (5 * r7);
    d2 += h6 * (5 * r6);
    d2 += h7 * (5 * r5);
    d2 += h8 * (5 * r4);
    d2 += h9 * (5 * r3);
    c += (d2 >>> 13); d2 &= 0x1fff;

    d3 = c;
    d3 += h0 * r3;
    d3 += h1 * r2;
    d3 += h2 * r1;
    d3 += h3 * r0;
    d3 += h4 * (5 * r9);
    c = (d3 >>> 13); d3 &= 0x1fff;
    d3 += h5 * (5 * r8);
    d3 += h6 * (5 * r7);
    d3 += h7 * (5 * r6);
    d3 += h8 * (5 * r5);
    d3 += h9 * (5 * r4);
    c += (d3 >>> 13); d3 &= 0x1fff;

    d4 = c;
    d4 += h0 * r4;
    d4 += h1 * r3;
    d4 += h2 * r2;
    d4 += h3 * r1;
    d4 += h4 * r0;
    c = (d4 >>> 13); d4 &= 0x1fff;
    d4 += h5 * (5 * r9);
    d4 += h6 * (5 * r8);
    d4 += h7 * (5 * r7);
    d4 += h8 * (5 * r6);
    d4 += h9 * (5 * r5);
    c += (d4 >>> 13); d4 &= 0x1fff;

    d5 = c;
    d5 += h0 * r5;
    d5 += h1 * r4;
    d5 += h2 * r3;
    d5 += h3 * r2;
    d5 += h4 * r1;
    c = (d5 >>> 13); d5 &= 0x1fff;
    d5 += h5 * r0;
    d5 += h6 * (5 * r9);
    d5 += h7 * (5 * r8);
    d5 += h8 * (5 * r7);
    d5 += h9 * (5 * r6);
    c += (d5 >>> 13); d5 &= 0x1fff;

    d6 = c;
    d6 += h0 * r6;
    d6 += h1 * r5;
    d6 += h2 * r4;
    d6 += h3 * r3;
    d6 += h4 * r2;
    c = (d6 >>> 13); d6 &= 0x1fff;
    d6 += h5 * r1;
    d6 += h6 * r0;
    d6 += h7 * (5 * r9);
    d6 += h8 * (5 * r8);
    d6 += h9 * (5 * r7);
    c += (d6 >>> 13); d6 &= 0x1fff;

    d7 = c;
    d7 += h0 * r7;
    d7 += h1 * r6;
    d7 += h2 * r5;
    d7 += h3 * r4;
    d7 += h4 * r3;
    c = (d7 >>> 13); d7 &= 0x1fff;
    d7 += h5 * r2;
    d7 += h6 * r1;
    d7 += h7 * r0;
    d7 += h8 * (5 * r9);
    d7 += h9 * (5 * r8);
    c += (d7 >>> 13); d7 &= 0x1fff;

    d8 = c;
    d8 += h0 * r8;
    d8 += h1 * r7;
    d8 += h2 * r6;
    d8 += h3 * r5;
    d8 += h4 * r4;
    c = (d8 >>> 13); d8 &= 0x1fff;
    d8 += h5 * r3;
    d8 += h6 * r2;
    d8 += h7 * r1;
    d8 += h8 * r0;
    d8 += h9 * (5 * r9);
    c += (d8 >>> 13); d8 &= 0x1fff;

    d9 = c;
    d9 += h0 * r9;
    d9 += h1 * r8;
    d9 += h2 * r7;
    d9 += h3 * r6;
    d9 += h4 * r5;
    c = (d9 >>> 13); d9 &= 0x1fff;
    d9 += h5 * r4;
    d9 += h6 * r3;
    d9 += h7 * r2;
    d9 += h8 * r1;
    d9 += h9 * r0;
    c += (d9 >>> 13); d9 &= 0x1fff;

    c = (((c << 2) + c)) | 0;
    c = (c + d0) | 0;
    d0 = c & 0x1fff;
    c = (c >>> 13);
    d1 += c;

    h0 = d0;
    h1 = d1;
    h2 = d2;
    h3 = d3;
    h4 = d4;
    h5 = d5;
    h6 = d6;
    h7 = d7;
    h8 = d8;
    h9 = d9;

    mpos += 16;
    bytes -= 16;
  }
  this.h[0] = h0;
  this.h[1] = h1;
  this.h[2] = h2;
  this.h[3] = h3;
  this.h[4] = h4;
  this.h[5] = h5;
  this.h[6] = h6;
  this.h[7] = h7;
  this.h[8] = h8;
  this.h[9] = h9;
};

poly1305.prototype.finish = function(mac, macpos) {
  var g = new Uint16Array(10);
  var c, mask, f, i;

  if (this.leftover) {
    i = this.leftover;
    this.buffer[i++] = 1;
    for (; i < 16; i++) this.buffer[i] = 0;
    this.fin = 1;
    this.blocks(this.buffer, 0, 16);
  }

  c = this.h[1] >>> 13;
  this.h[1] &= 0x1fff;
  for (i = 2; i < 10; i++) {
    this.h[i] += c;
    c = this.h[i] >>> 13;
    this.h[i] &= 0x1fff;
  }
  this.h[0] += (c * 5);
  c = this.h[0] >>> 13;
  this.h[0] &= 0x1fff;
  this.h[1] += c;
  c = this.h[1] >>> 13;
  this.h[1] &= 0x1fff;
  this.h[2] += c;

  g[0] = this.h[0] + 5;
  c = g[0] >>> 13;
  g[0] &= 0x1fff;
  for (i = 1; i < 10; i++) {
    g[i] = this.h[i] + c;
    c = g[i] >>> 13;
    g[i] &= 0x1fff;
  }
  g[9] -= (1 << 13);

  mask = (c ^ 1) - 1;
  for (i = 0; i < 10; i++) g[i] &= mask;
  mask = ~mask;
  for (i = 0; i < 10; i++) this.h[i] = (this.h[i] & mask) | g[i];

  this.h[0] = ((this.h[0]       ) | (this.h[1] << 13)                    ) & 0xffff;
  this.h[1] = ((this.h[1] >>>  3) | (this.h[2] << 10)                    ) & 0xffff;
  this.h[2] = ((this.h[2] >>>  6) | (this.h[3] <<  7)                    ) & 0xffff;
  this.h[3] = ((this.h[3] >>>  9) | (this.h[4] <<  4)                    ) & 0xffff;
  this.h[4] = ((this.h[4] >>> 12) | (this.h[5] <<  1) | (this.h[6] << 14)) & 0xffff;
  this.h[5] = ((this.h[6] >>>  2) | (this.h[7] << 11)                    ) & 0xffff;
  this.h[6] = ((this.h[7] >>>  5) | (this.h[8] <<  8)                    ) & 0xffff;
  this.h[7] = ((this.h[8] >>>  8) | (this.h[9] <<  5)                    ) & 0xffff;

  f = this.h[0] + this.pad[0];
  this.h[0] = f & 0xffff;
  for (i = 1; i < 8; i++) {
    f = (((this.h[i] + this.pad[i]) | 0) + (f >>> 16)) | 0;
    this.h[i] = f & 0xffff;
  }

  mac[macpos+ 0] = (this.h[0] >>> 0) & 0xff;
  mac[macpos+ 1] = (this.h[0] >>> 8) & 0xff;
  mac[macpos+ 2] = (this.h[1] >>> 0) & 0xff;
  mac[macpos+ 3] = (this.h[1] >>> 8) & 0xff;
  mac[macpos+ 4] = (this.h[2] >>> 0) & 0xff;
  mac[macpos+ 5] = (this.h[2] >>> 8) & 0xff;
  mac[macpos+ 6] = (this.h[3] >>> 0) & 0xff;
  mac[macpos+ 7] = (this.h[3] >>> 8) & 0xff;
  mac[macpos+ 8] = (this.h[4] >>> 0) & 0xff;
  mac[macpos+ 9] = (this.h[4] >>> 8) & 0xff;
  mac[macpos+10] = (this.h[5] >>> 0) & 0xff;
  mac[macpos+11] = (this.h[5] >>> 8) & 0xff;
  mac[macpos+12] = (this.h[6] >>> 0) & 0xff;
  mac[macpos+13] = (this.h[6] >>> 8) & 0xff;
  mac[macpos+14] = (this.h[7] >>> 0) & 0xff;
  mac[macpos+15] = (this.h[7] >>> 8) & 0xff;
};

poly1305.prototype.update = function(m, mpos, bytes) {
  var i, want;

  if (this.leftover) {
    want = (16 - this.leftover);
    if (want > bytes)
      want = bytes;
    for (i = 0; i < want; i++)
      this.buffer[this.leftover + i] = m[mpos+i];
    bytes -= want;
    mpos += want;
    this.leftover += want;
    if (this.leftover < 16)
      return;
    this.blocks(this.buffer, 0, 16);
    this.leftover = 0;
  }

  if (bytes >= 16) {
    want = bytes - (bytes % 16);
    this.blocks(m, mpos, want);
    mpos += want;
    bytes -= want;
  }

  if (bytes) {
    for (i = 0; i < bytes; i++)
      this.buffer[this.leftover + i] = m[mpos+i];
    this.leftover += bytes;
  }
};

function crypto_onetimeauth(out, outpos, m, mpos, n, k) {
  var s = new poly1305(k);
  s.update(m, mpos, n);
  s.finish(out, outpos);
  return 0;
}

function crypto_onetimeauth_verify(h, hpos, m, mpos, n, k) {
  var x = new Uint8Array(16);
  crypto_onetimeauth(x,0,m,mpos,n,k);
  return crypto_verify_16(h,hpos,x,0);
}

function crypto_secretbox(c,m,d,n,k) {
  var i;
  if (d < 32) return -1;
  crypto_stream_xor(c,0,m,0,d,n,k);
  crypto_onetimeauth(c, 16, c, 32, d - 32, c);
  for (i = 0; i < 16; i++) c[i] = 0;
  return 0;
}

function crypto_secretbox_open(m,c,d,n,k) {
  var i;
  var x = new Uint8Array(32);
  if (d < 32) return -1;
  crypto_stream(x,0,32,n,k);
  if (crypto_onetimeauth_verify(c, 16,c, 32,d - 32,x) !== 0) return -1;
  crypto_stream_xor(m,0,c,0,d,n,k);
  for (i = 0; i < 32; i++) m[i] = 0;
  return 0;
}

function set25519(r, a) {
  var i;
  for (i = 0; i < 16; i++) r[i] = a[i]|0;
}

function car25519(o) {
  var i, v, c = 1;
  for (i = 0; i < 16; i++) {
    v = o[i] + c + 65535;
    c = Math.floor(v / 65536);
    o[i] = v - c * 65536;
  }
  o[0] += c-1 + 37 * (c-1);
}

function sel25519(p, q, b) {
  var t, c = ~(b-1);
  for (var i = 0; i < 16; i++) {
    t = c & (p[i] ^ q[i]);
    p[i] ^= t;
    q[i] ^= t;
  }
}

function pack25519(o, n) {
  var i, j, b;
  var m = gf(), t = gf();
  for (i = 0; i < 16; i++) t[i] = n[i];
  car25519(t);
  car25519(t);
  car25519(t);
  for (j = 0; j < 2; j++) {
    m[0] = t[0] - 0xffed;
    for (i = 1; i < 15; i++) {
      m[i] = t[i] - 0xffff - ((m[i-1]>>16) & 1);
      m[i-1] &= 0xffff;
    }
    m[15] = t[15] - 0x7fff - ((m[14]>>16) & 1);
    b = (m[15]>>16) & 1;
    m[14] &= 0xffff;
    sel25519(t, m, 1-b);
  }
  for (i = 0; i < 16; i++) {
    o[2*i] = t[i] & 0xff;
    o[2*i+1] = t[i]>>8;
  }
}

function neq25519(a, b) {
  var c = new Uint8Array(32), d = new Uint8Array(32);
  pack25519(c, a);
  pack25519(d, b);
  return crypto_verify_32(c, 0, d, 0);
}

function par25519(a) {
  var d = new Uint8Array(32);
  pack25519(d, a);
  return d[0] & 1;
}

function unpack25519(o, n) {
  var i;
  for (i = 0; i < 16; i++) o[i] = n[2*i] + (n[2*i+1] << 8);
  o[15] &= 0x7fff;
}

function A(o, a, b) {
  for (var i = 0; i < 16; i++) o[i] = a[i] + b[i];
}

function Z(o, a, b) {
  for (var i = 0; i < 16; i++) o[i] = a[i] - b[i];
}

function M(o, a, b) {
  var v, c,
     t0 = 0,  t1 = 0,  t2 = 0,  t3 = 0,  t4 = 0,  t5 = 0,  t6 = 0,  t7 = 0,
     t8 = 0,  t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0,
    t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0,
    t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0,
    b0 = b[0],
    b1 = b[1],
    b2 = b[2],
    b3 = b[3],
    b4 = b[4],
    b5 = b[5],
    b6 = b[6],
    b7 = b[7],
    b8 = b[8],
    b9 = b[9],
    b10 = b[10],
    b11 = b[11],
    b12 = b[12],
    b13 = b[13],
    b14 = b[14],
    b15 = b[15];

  v = a[0];
  t0 += v * b0;
  t1 += v * b1;
  t2 += v * b2;
  t3 += v * b3;
  t4 += v * b4;
  t5 += v * b5;
  t6 += v * b6;
  t7 += v * b7;
  t8 += v * b8;
  t9 += v * b9;
  t10 += v * b10;
  t11 += v * b11;
  t12 += v * b12;
  t13 += v * b13;
  t14 += v * b14;
  t15 += v * b15;
  v = a[1];
  t1 += v * b0;
  t2 += v * b1;
  t3 += v * b2;
  t4 += v * b3;
  t5 += v * b4;
  t6 += v * b5;
  t7 += v * b6;
  t8 += v * b7;
  t9 += v * b8;
  t10 += v * b9;
  t11 += v * b10;
  t12 += v * b11;
  t13 += v * b12;
  t14 += v * b13;
  t15 += v * b14;
  t16 += v * b15;
  v = a[2];
  t2 += v * b0;
  t3 += v * b1;
  t4 += v * b2;
  t5 += v * b3;
  t6 += v * b4;
  t7 += v * b5;
  t8 += v * b6;
  t9 += v * b7;
  t10 += v * b8;
  t11 += v * b9;
  t12 += v * b10;
  t13 += v * b11;
  t14 += v * b12;
  t15 += v * b13;
  t16 += v * b14;
  t17 += v * b15;
  v = a[3];
  t3 += v * b0;
  t4 += v * b1;
  t5 += v * b2;
  t6 += v * b3;
  t7 += v * b4;
  t8 += v * b5;
  t9 += v * b6;
  t10 += v * b7;
  t11 += v * b8;
  t12 += v * b9;
  t13 += v * b10;
  t14 += v * b11;
  t15 += v * b12;
  t16 += v * b13;
  t17 += v * b14;
  t18 += v * b15;
  v = a[4];
  t4 += v * b0;
  t5 += v * b1;
  t6 += v * b2;
  t7 += v * b3;
  t8 += v * b4;
  t9 += v * b5;
  t10 += v * b6;
  t11 += v * b7;
  t12 += v * b8;
  t13 += v * b9;
  t14 += v * b10;
  t15 += v * b11;
  t16 += v * b12;
  t17 += v * b13;
  t18 += v * b14;
  t19 += v * b15;
  v = a[5];
  t5 += v * b0;
  t6 += v * b1;
  t7 += v * b2;
  t8 += v * b3;
  t9 += v * b4;
  t10 += v * b5;
  t11 += v * b6;
  t12 += v * b7;
  t13 += v * b8;
  t14 += v * b9;
  t15 += v * b10;
  t16 += v * b11;
  t17 += v * b12;
  t18 += v * b13;
  t19 += v * b14;
  t20 += v * b15;
  v = a[6];
  t6 += v * b0;
  t7 += v * b1;
  t8 += v * b2;
  t9 += v * b3;
  t10 += v * b4;
  t11 += v * b5;
  t12 += v * b6;
  t13 += v * b7;
  t14 += v * b8;
  t15 += v * b9;
  t16 += v * b10;
  t17 += v * b11;
  t18 += v * b12;
  t19 += v * b13;
  t20 += v * b14;
  t21 += v * b15;
  v = a[7];
  t7 += v * b0;
  t8 += v * b1;
  t9 += v * b2;
  t10 += v * b3;
  t11 += v * b4;
  t12 += v * b5;
  t13 += v * b6;
  t14 += v * b7;
  t15 += v * b8;
  t16 += v * b9;
  t17 += v * b10;
  t18 += v * b11;
  t19 += v * b12;
  t20 += v * b13;
  t21 += v * b14;
  t22 += v * b15;
  v = a[8];
  t8 += v * b0;
  t9 += v * b1;
  t10 += v * b2;
  t11 += v * b3;
  t12 += v * b4;
  t13 += v * b5;
  t14 += v * b6;
  t15 += v * b7;
  t16 += v * b8;
  t17 += v * b9;
  t18 += v * b10;
  t19 += v * b11;
  t20 += v * b12;
  t21 += v * b13;
  t22 += v * b14;
  t23 += v * b15;
  v = a[9];
  t9 += v * b0;
  t10 += v * b1;
  t11 += v * b2;
  t12 += v * b3;
  t13 += v * b4;
  t14 += v * b5;
  t15 += v * b6;
  t16 += v * b7;
  t17 += v * b8;
  t18 += v * b9;
  t19 += v * b10;
  t20 += v * b11;
  t21 += v * b12;
  t22 += v * b13;
  t23 += v * b14;
  t24 += v * b15;
  v = a[10];
  t10 += v * b0;
  t11 += v * b1;
  t12 += v * b2;
  t13 += v * b3;
  t14 += v * b4;
  t15 += v * b5;
  t16 += v * b6;
  t17 += v * b7;
  t18 += v * b8;
  t19 += v * b9;
  t20 += v * b10;
  t21 += v * b11;
  t22 += v * b12;
  t23 += v * b13;
  t24 += v * b14;
  t25 += v * b15;
  v = a[11];
  t11 += v * b0;
  t12 += v * b1;
  t13 += v * b2;
  t14 += v * b3;
  t15 += v * b4;
  t16 += v * b5;
  t17 += v * b6;
  t18 += v * b7;
  t19 += v * b8;
  t20 += v * b9;
  t21 += v * b10;
  t22 += v * b11;
  t23 += v * b12;
  t24 += v * b13;
  t25 += v * b14;
  t26 += v * b15;
  v = a[12];
  t12 += v * b0;
  t13 += v * b1;
  t14 += v * b2;
  t15 += v * b3;
  t16 += v * b4;
  t17 += v * b5;
  t18 += v * b6;
  t19 += v * b7;
  t20 += v * b8;
  t21 += v * b9;
  t22 += v * b10;
  t23 += v * b11;
  t24 += v * b12;
  t25 += v * b13;
  t26 += v * b14;
  t27 += v * b15;
  v = a[13];
  t13 += v * b0;
  t14 += v * b1;
  t15 += v * b2;
  t16 += v * b3;
  t17 += v * b4;
  t18 += v * b5;
  t19 += v * b6;
  t20 += v * b7;
  t21 += v * b8;
  t22 += v * b9;
  t23 += v * b10;
  t24 += v * b11;
  t25 += v * b12;
  t26 += v * b13;
  t27 += v * b14;
  t28 += v * b15;
  v = a[14];
  t14 += v * b0;
  t15 += v * b1;
  t16 += v * b2;
  t17 += v * b3;
  t18 += v * b4;
  t19 += v * b5;
  t20 += v * b6;
  t21 += v * b7;
  t22 += v * b8;
  t23 += v * b9;
  t24 += v * b10;
  t25 += v * b11;
  t26 += v * b12;
  t27 += v * b13;
  t28 += v * b14;
  t29 += v * b15;
  v = a[15];
  t15 += v * b0;
  t16 += v * b1;
  t17 += v * b2;
  t18 += v * b3;
  t19 += v * b4;
  t20 += v * b5;
  t21 += v * b6;
  t22 += v * b7;
  t23 += v * b8;
  t24 += v * b9;
  t25 += v * b10;
  t26 += v * b11;
  t27 += v * b12;
  t28 += v * b13;
  t29 += v * b14;
  t30 += v * b15;

  t0  += 38 * t16;
  t1  += 38 * t17;
  t2  += 38 * t18;
  t3  += 38 * t19;
  t4  += 38 * t20;
  t5  += 38 * t21;
  t6  += 38 * t22;
  t7  += 38 * t23;
  t8  += 38 * t24;
  t9  += 38 * t25;
  t10 += 38 * t26;
  t11 += 38 * t27;
  t12 += 38 * t28;
  t13 += 38 * t29;
  t14 += 38 * t30;
  // t15 left as is

  // first car
  c = 1;
  v =  t0 + c + 65535; c = Math.floor(v / 65536);  t0 = v - c * 65536;
  v =  t1 + c + 65535; c = Math.floor(v / 65536);  t1 = v - c * 65536;
  v =  t2 + c + 65535; c = Math.floor(v / 65536);  t2 = v - c * 65536;
  v =  t3 + c + 65535; c = Math.floor(v / 65536);  t3 = v - c * 65536;
  v =  t4 + c + 65535; c = Math.floor(v / 65536);  t4 = v - c * 65536;
  v =  t5 + c + 65535; c = Math.floor(v / 65536);  t5 = v - c * 65536;
  v =  t6 + c + 65535; c = Math.floor(v / 65536);  t6 = v - c * 65536;
  v =  t7 + c + 65535; c = Math.floor(v / 65536);  t7 = v - c * 65536;
  v =  t8 + c + 65535; c = Math.floor(v / 65536);  t8 = v - c * 65536;
  v =  t9 + c + 65535; c = Math.floor(v / 65536);  t9 = v - c * 65536;
  v = t10 + c + 65535; c = Math.floor(v / 65536); t10 = v - c * 65536;
  v = t11 + c + 65535; c = Math.floor(v / 65536); t11 = v - c * 65536;
  v = t12 + c + 65535; c = Math.floor(v / 65536); t12 = v - c * 65536;
  v = t13 + c + 65535; c = Math.floor(v / 65536); t13 = v - c * 65536;
  v = t14 + c + 65535; c = Math.floor(v / 65536); t14 = v - c * 65536;
  v = t15 + c + 65535; c = Math.floor(v / 65536); t15 = v - c * 65536;
  t0 += c-1 + 37 * (c-1);

  // second car
  c = 1;
  v =  t0 + c + 65535; c = Math.floor(v / 65536);  t0 = v - c * 65536;
  v =  t1 + c + 65535; c = Math.floor(v / 65536);  t1 = v - c * 65536;
  v =  t2 + c + 65535; c = Math.floor(v / 65536);  t2 = v - c * 65536;
  v =  t3 + c + 65535; c = Math.floor(v / 65536);  t3 = v - c * 65536;
  v =  t4 + c + 65535; c = Math.floor(v / 65536);  t4 = v - c * 65536;
  v =  t5 + c + 65535; c = Math.floor(v / 65536);  t5 = v - c * 65536;
  v =  t6 + c + 65535; c = Math.floor(v / 65536);  t6 = v - c * 65536;
  v =  t7 + c + 65535; c = Math.floor(v / 65536);  t7 = v - c * 65536;
  v =  t8 + c + 65535; c = Math.floor(v / 65536);  t8 = v - c * 65536;
  v =  t9 + c + 65535; c = Math.floor(v / 65536);  t9 = v - c * 65536;
  v = t10 + c + 65535; c = Math.floor(v / 65536); t10 = v - c * 65536;
  v = t11 + c + 65535; c = Math.floor(v / 65536); t11 = v - c * 65536;
  v = t12 + c + 65535; c = Math.floor(v / 65536); t12 = v - c * 65536;
  v = t13 + c + 65535; c = Math.floor(v / 65536); t13 = v - c * 65536;
  v = t14 + c + 65535; c = Math.floor(v / 65536); t14 = v - c * 65536;
  v = t15 + c + 65535; c = Math.floor(v / 65536); t15 = v - c * 65536;
  t0 += c-1 + 37 * (c-1);

  o[ 0] = t0;
  o[ 1] = t1;
  o[ 2] = t2;
  o[ 3] = t3;
  o[ 4] = t4;
  o[ 5] = t5;
  o[ 6] = t6;
  o[ 7] = t7;
  o[ 8] = t8;
  o[ 9] = t9;
  o[10] = t10;
  o[11] = t11;
  o[12] = t12;
  o[13] = t13;
  o[14] = t14;
  o[15] = t15;
}

function S(o, a) {
  M(o, a, a);
}

function inv25519(o, i) {
  var c = gf();
  var a;
  for (a = 0; a < 16; a++) c[a] = i[a];
  for (a = 253; a >= 0; a--) {
    S(c, c);
    if(a !== 2 && a !== 4) M(c, c, i);
  }
  for (a = 0; a < 16; a++) o[a] = c[a];
}

function pow2523(o, i) {
  var c = gf();
  var a;
  for (a = 0; a < 16; a++) c[a] = i[a];
  for (a = 250; a >= 0; a--) {
      S(c, c);
      if(a !== 1) M(c, c, i);
  }
  for (a = 0; a < 16; a++) o[a] = c[a];
}

function crypto_scalarmult(q, n, p) {
  var z = new Uint8Array(32);
  var x = new Float64Array(80), r, i;
  var a = gf(), b = gf(), c = gf(),
      d = gf(), e = gf(), f = gf();
  for (i = 0; i < 31; i++) z[i] = n[i];
  z[31]=(n[31]&127)|64;
  z[0]&=248;
  unpack25519(x,p);
  for (i = 0; i < 16; i++) {
    b[i]=x[i];
    d[i]=a[i]=c[i]=0;
  }
  a[0]=d[0]=1;
  for (i=254; i>=0; --i) {
    r=(z[i>>>3]>>>(i&7))&1;
    sel25519(a,b,r);
    sel25519(c,d,r);
    A(e,a,c);
    Z(a,a,c);
    A(c,b,d);
    Z(b,b,d);
    S(d,e);
    S(f,a);
    M(a,c,a);
    M(c,b,e);
    A(e,a,c);
    Z(a,a,c);
    S(b,a);
    Z(c,d,f);
    M(a,c,_121665);
    A(a,a,d);
    M(c,c,a);
    M(a,d,f);
    M(d,b,x);
    S(b,e);
    sel25519(a,b,r);
    sel25519(c,d,r);
  }
  for (i = 0; i < 16; i++) {
    x[i+16]=a[i];
    x[i+32]=c[i];
    x[i+48]=b[i];
    x[i+64]=d[i];
  }
  var x32 = x.subarray(32);
  var x16 = x.subarray(16);
  inv25519(x32,x32);
  M(x16,x16,x32);
  pack25519(q,x16);
  return 0;
}

function crypto_scalarmult_base(q, n) {
  return crypto_scalarmult(q, n, _9);
}

function crypto_box_keypair(y, x) {
  randombytes(x, 32);
  return crypto_scalarmult_base(y, x);
}

function crypto_box_beforenm(k, y, x) {
  var s = new Uint8Array(32);
  crypto_scalarmult(s, x, y);
  return crypto_core_hsalsa20(k, _0, s, sigma);
}

var crypto_box_afternm = crypto_secretbox;
var crypto_box_open_afternm = crypto_secretbox_open;

function crypto_box(c, m, d, n, y, x) {
  var k = new Uint8Array(32);
  crypto_box_beforenm(k, y, x);
  return crypto_box_afternm(c, m, d, n, k);
}

function crypto_box_open(m, c, d, n, y, x) {
  var k = new Uint8Array(32);
  crypto_box_beforenm(k, y, x);
  return crypto_box_open_afternm(m, c, d, n, k);
}

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function crypto_hashblocks_hl(hh, hl, m, n) {
  var wh = new Int32Array(16), wl = new Int32Array(16),
      bh0, bh1, bh2, bh3, bh4, bh5, bh6, bh7,
      bl0, bl1, bl2, bl3, bl4, bl5, bl6, bl7,
      th, tl, i, j, h, l, a, b, c, d;

  var ah0 = hh[0],
      ah1 = hh[1],
      ah2 = hh[2],
      ah3 = hh[3],
      ah4 = hh[4],
      ah5 = hh[5],
      ah6 = hh[6],
      ah7 = hh[7],

      al0 = hl[0],
      al1 = hl[1],
      al2 = hl[2],
      al3 = hl[3],
      al4 = hl[4],
      al5 = hl[5],
      al6 = hl[6],
      al7 = hl[7];

  var pos = 0;
  while (n >= 128) {
    for (i = 0; i < 16; i++) {
      j = 8 * i + pos;
      wh[i] = (m[j+0] << 24) | (m[j+1] << 16) | (m[j+2] << 8) | m[j+3];
      wl[i] = (m[j+4] << 24) | (m[j+5] << 16) | (m[j+6] << 8) | m[j+7];
    }
    for (i = 0; i < 80; i++) {
      bh0 = ah0;
      bh1 = ah1;
      bh2 = ah2;
      bh3 = ah3;
      bh4 = ah4;
      bh5 = ah5;
      bh6 = ah6;
      bh7 = ah7;

      bl0 = al0;
      bl1 = al1;
      bl2 = al2;
      bl3 = al3;
      bl4 = al4;
      bl5 = al5;
      bl6 = al6;
      bl7 = al7;

      // add
      h = ah7;
      l = al7;

      a = l & 0xffff; b = l >>> 16;
      c = h & 0xffff; d = h >>> 16;

      // Sigma1
      h = ((ah4 >>> 14) | (al4 << (32-14))) ^ ((ah4 >>> 18) | (al4 << (32-18))) ^ ((al4 >>> (41-32)) | (ah4 << (32-(41-32))));
      l = ((al4 >>> 14) | (ah4 << (32-14))) ^ ((al4 >>> 18) | (ah4 << (32-18))) ^ ((ah4 >>> (41-32)) | (al4 << (32-(41-32))));

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      // Ch
      h = (ah4 & ah5) ^ (~ah4 & ah6);
      l = (al4 & al5) ^ (~al4 & al6);

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      // K
      h = K[i*2];
      l = K[i*2+1];

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      // w
      h = wh[i%16];
      l = wl[i%16];

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      b += a >>> 16;
      c += b >>> 16;
      d += c >>> 16;

      th = c & 0xffff | d << 16;
      tl = a & 0xffff | b << 16;

      // add
      h = th;
      l = tl;

      a = l & 0xffff; b = l >>> 16;
      c = h & 0xffff; d = h >>> 16;

      // Sigma0
      h = ((ah0 >>> 28) | (al0 << (32-28))) ^ ((al0 >>> (34-32)) | (ah0 << (32-(34-32)))) ^ ((al0 >>> (39-32)) | (ah0 << (32-(39-32))));
      l = ((al0 >>> 28) | (ah0 << (32-28))) ^ ((ah0 >>> (34-32)) | (al0 << (32-(34-32)))) ^ ((ah0 >>> (39-32)) | (al0 << (32-(39-32))));

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      // Maj
      h = (ah0 & ah1) ^ (ah0 & ah2) ^ (ah1 & ah2);
      l = (al0 & al1) ^ (al0 & al2) ^ (al1 & al2);

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      b += a >>> 16;
      c += b >>> 16;
      d += c >>> 16;

      bh7 = (c & 0xffff) | (d << 16);
      bl7 = (a & 0xffff) | (b << 16);

      // add
      h = bh3;
      l = bl3;

      a = l & 0xffff; b = l >>> 16;
      c = h & 0xffff; d = h >>> 16;

      h = th;
      l = tl;

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      b += a >>> 16;
      c += b >>> 16;
      d += c >>> 16;

      bh3 = (c & 0xffff) | (d << 16);
      bl3 = (a & 0xffff) | (b << 16);

      ah1 = bh0;
      ah2 = bh1;
      ah3 = bh2;
      ah4 = bh3;
      ah5 = bh4;
      ah6 = bh5;
      ah7 = bh6;
      ah0 = bh7;

      al1 = bl0;
      al2 = bl1;
      al3 = bl2;
      al4 = bl3;
      al5 = bl4;
      al6 = bl5;
      al7 = bl6;
      al0 = bl7;

      if (i%16 === 15) {
        for (j = 0; j < 16; j++) {
          // add
          h = wh[j];
          l = wl[j];

          a = l & 0xffff; b = l >>> 16;
          c = h & 0xffff; d = h >>> 16;

          h = wh[(j+9)%16];
          l = wl[(j+9)%16];

          a += l & 0xffff; b += l >>> 16;
          c += h & 0xffff; d += h >>> 16;

          // sigma0
          th = wh[(j+1)%16];
          tl = wl[(j+1)%16];
          h = ((th >>> 1) | (tl << (32-1))) ^ ((th >>> 8) | (tl << (32-8))) ^ (th >>> 7);
          l = ((tl >>> 1) | (th << (32-1))) ^ ((tl >>> 8) | (th << (32-8))) ^ ((tl >>> 7) | (th << (32-7)));

          a += l & 0xffff; b += l >>> 16;
          c += h & 0xffff; d += h >>> 16;

          // sigma1
          th = wh[(j+14)%16];
          tl = wl[(j+14)%16];
          h = ((th >>> 19) | (tl << (32-19))) ^ ((tl >>> (61-32)) | (th << (32-(61-32)))) ^ (th >>> 6);
          l = ((tl >>> 19) | (th << (32-19))) ^ ((th >>> (61-32)) | (tl << (32-(61-32)))) ^ ((tl >>> 6) | (th << (32-6)));

          a += l & 0xffff; b += l >>> 16;
          c += h & 0xffff; d += h >>> 16;

          b += a >>> 16;
          c += b >>> 16;
          d += c >>> 16;

          wh[j] = (c & 0xffff) | (d << 16);
          wl[j] = (a & 0xffff) | (b << 16);
        }
      }
    }

    // add
    h = ah0;
    l = al0;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[0];
    l = hl[0];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[0] = ah0 = (c & 0xffff) | (d << 16);
    hl[0] = al0 = (a & 0xffff) | (b << 16);

    h = ah1;
    l = al1;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[1];
    l = hl[1];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[1] = ah1 = (c & 0xffff) | (d << 16);
    hl[1] = al1 = (a & 0xffff) | (b << 16);

    h = ah2;
    l = al2;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[2];
    l = hl[2];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[2] = ah2 = (c & 0xffff) | (d << 16);
    hl[2] = al2 = (a & 0xffff) | (b << 16);

    h = ah3;
    l = al3;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[3];
    l = hl[3];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[3] = ah3 = (c & 0xffff) | (d << 16);
    hl[3] = al3 = (a & 0xffff) | (b << 16);

    h = ah4;
    l = al4;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[4];
    l = hl[4];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[4] = ah4 = (c & 0xffff) | (d << 16);
    hl[4] = al4 = (a & 0xffff) | (b << 16);

    h = ah5;
    l = al5;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[5];
    l = hl[5];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[5] = ah5 = (c & 0xffff) | (d << 16);
    hl[5] = al5 = (a & 0xffff) | (b << 16);

    h = ah6;
    l = al6;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[6];
    l = hl[6];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[6] = ah6 = (c & 0xffff) | (d << 16);
    hl[6] = al6 = (a & 0xffff) | (b << 16);

    h = ah7;
    l = al7;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[7];
    l = hl[7];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[7] = ah7 = (c & 0xffff) | (d << 16);
    hl[7] = al7 = (a & 0xffff) | (b << 16);

    pos += 128;
    n -= 128;
  }

  return n;
}

function crypto_hash(out, m, n) {
  var hh = new Int32Array(8),
      hl = new Int32Array(8),
      x = new Uint8Array(256),
      i, b = n;

  hh[0] = 0x6a09e667;
  hh[1] = 0xbb67ae85;
  hh[2] = 0x3c6ef372;
  hh[3] = 0xa54ff53a;
  hh[4] = 0x510e527f;
  hh[5] = 0x9b05688c;
  hh[6] = 0x1f83d9ab;
  hh[7] = 0x5be0cd19;

  hl[0] = 0xf3bcc908;
  hl[1] = 0x84caa73b;
  hl[2] = 0xfe94f82b;
  hl[3] = 0x5f1d36f1;
  hl[4] = 0xade682d1;
  hl[5] = 0x2b3e6c1f;
  hl[6] = 0xfb41bd6b;
  hl[7] = 0x137e2179;

  crypto_hashblocks_hl(hh, hl, m, n);
  n %= 128;

  for (i = 0; i < n; i++) x[i] = m[b-n+i];
  x[n] = 128;

  n = 256-128*(n<112?1:0);
  x[n-9] = 0;
  ts64(x, n-8,  (b / 0x20000000) | 0, b << 3);
  crypto_hashblocks_hl(hh, hl, x, n);

  for (i = 0; i < 8; i++) ts64(out, 8*i, hh[i], hl[i]);

  return 0;
}

function add(p, q) {
  var a = gf(), b = gf(), c = gf(),
      d = gf(), e = gf(), f = gf(),
      g = gf(), h = gf(), t = gf();

  Z(a, p[1], p[0]);
  Z(t, q[1], q[0]);
  M(a, a, t);
  A(b, p[0], p[1]);
  A(t, q[0], q[1]);
  M(b, b, t);
  M(c, p[3], q[3]);
  M(c, c, D2);
  M(d, p[2], q[2]);
  A(d, d, d);
  Z(e, b, a);
  Z(f, d, c);
  A(g, d, c);
  A(h, b, a);

  M(p[0], e, f);
  M(p[1], h, g);
  M(p[2], g, f);
  M(p[3], e, h);
}

function cswap(p, q, b) {
  var i;
  for (i = 0; i < 4; i++) {
    sel25519(p[i], q[i], b);
  }
}

function pack(r, p) {
  var tx = gf(), ty = gf(), zi = gf();
  inv25519(zi, p[2]);
  M(tx, p[0], zi);
  M(ty, p[1], zi);
  pack25519(r, ty);
  r[31] ^= par25519(tx) << 7;
}

function scalarmult(p, q, s) {
  var b, i;
  set25519(p[0], gf0);
  set25519(p[1], gf1);
  set25519(p[2], gf1);
  set25519(p[3], gf0);
  for (i = 255; i >= 0; --i) {
    b = (s[(i/8)|0] >> (i&7)) & 1;
    cswap(p, q, b);
    add(q, p);
    add(p, p);
    cswap(p, q, b);
  }
}

function scalarbase(p, s) {
  var q = [gf(), gf(), gf(), gf()];
  set25519(q[0], X);
  set25519(q[1], Y);
  set25519(q[2], gf1);
  M(q[3], X, Y);
  scalarmult(p, q, s);
}

function crypto_sign_keypair(pk, sk, seeded) {
  var d = new Uint8Array(64);
  var p = [gf(), gf(), gf(), gf()];
  var i;

  if (!seeded) randombytes(sk, 32);
  crypto_hash(d, sk, 32);
  d[0] &= 248;
  d[31] &= 127;
  d[31] |= 64;

  scalarbase(p, d);
  pack(pk, p);

  for (i = 0; i < 32; i++) sk[i+32] = pk[i];
  return 0;
}

var L = new Float64Array([0xed, 0xd3, 0xf5, 0x5c, 0x1a, 0x63, 0x12, 0x58, 0xd6, 0x9c, 0xf7, 0xa2, 0xde, 0xf9, 0xde, 0x14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x10]);

function modL(r, x) {
  var carry, i, j, k;
  for (i = 63; i >= 32; --i) {
    carry = 0;
    for (j = i - 32, k = i - 12; j < k; ++j) {
      x[j] += carry - 16 * x[i] * L[j - (i - 32)];
      carry = (x[j] + 128) >> 8;
      x[j] -= carry * 256;
    }
    x[j] += carry;
    x[i] = 0;
  }
  carry = 0;
  for (j = 0; j < 32; j++) {
    x[j] += carry - (x[31] >> 4) * L[j];
    carry = x[j] >> 8;
    x[j] &= 255;
  }
  for (j = 0; j < 32; j++) x[j] -= carry * L[j];
  for (i = 0; i < 32; i++) {
    x[i+1] += x[i] >> 8;
    r[i] = x[i] & 255;
  }
}

function reduce(r) {
  var x = new Float64Array(64), i;
  for (i = 0; i < 64; i++) x[i] = r[i];
  for (i = 0; i < 64; i++) r[i] = 0;
  modL(r, x);
}

// Note: difference from C - smlen returned, not passed as argument.
function crypto_sign(sm, m, n, sk) {
  var d = new Uint8Array(64), h = new Uint8Array(64), r = new Uint8Array(64);
  var i, j, x = new Float64Array(64);
  var p = [gf(), gf(), gf(), gf()];

  crypto_hash(d, sk, 32);
  d[0] &= 248;
  d[31] &= 127;
  d[31] |= 64;

  var smlen = n + 64;
  for (i = 0; i < n; i++) sm[64 + i] = m[i];
  for (i = 0; i < 32; i++) sm[32 + i] = d[32 + i];

  crypto_hash(r, sm.subarray(32), n+32);
  reduce(r);
  scalarbase(p, r);
  pack(sm, p);

  for (i = 32; i < 64; i++) sm[i] = sk[i];
  crypto_hash(h, sm, n + 64);
  reduce(h);

  for (i = 0; i < 64; i++) x[i] = 0;
  for (i = 0; i < 32; i++) x[i] = r[i];
  for (i = 0; i < 32; i++) {
    for (j = 0; j < 32; j++) {
      x[i+j] += h[i] * d[j];
    }
  }

  modL(sm.subarray(32), x);
  return smlen;
}

function unpackneg(r, p) {
  var t = gf(), chk = gf(), num = gf(),
      den = gf(), den2 = gf(), den4 = gf(),
      den6 = gf();

  set25519(r[2], gf1);
  unpack25519(r[1], p);
  S(num, r[1]);
  M(den, num, D);
  Z(num, num, r[2]);
  A(den, r[2], den);

  S(den2, den);
  S(den4, den2);
  M(den6, den4, den2);
  M(t, den6, num);
  M(t, t, den);

  pow2523(t, t);
  M(t, t, num);
  M(t, t, den);
  M(t, t, den);
  M(r[0], t, den);

  S(chk, r[0]);
  M(chk, chk, den);
  if (neq25519(chk, num)) M(r[0], r[0], I);

  S(chk, r[0]);
  M(chk, chk, den);
  if (neq25519(chk, num)) return -1;

  if (par25519(r[0]) === (p[31]>>7)) Z(r[0], gf0, r[0]);

  M(r[3], r[0], r[1]);
  return 0;
}

function crypto_sign_open(m, sm, n, pk) {
  var i, mlen;
  var t = new Uint8Array(32), h = new Uint8Array(64);
  var p = [gf(), gf(), gf(), gf()],
      q = [gf(), gf(), gf(), gf()];

  mlen = -1;
  if (n < 64) return -1;

  if (unpackneg(q, pk)) return -1;

  for (i = 0; i < n; i++) m[i] = sm[i];
  for (i = 0; i < 32; i++) m[i+32] = pk[i];
  crypto_hash(h, m, n);
  reduce(h);
  scalarmult(p, q, h);

  scalarbase(q, sm.subarray(32));
  add(p, q);
  pack(t, p);

  n -= 64;
  if (crypto_verify_32(sm, 0, t, 0)) {
    for (i = 0; i < n; i++) m[i] = 0;
    return -1;
  }

  for (i = 0; i < n; i++) m[i] = sm[i + 64];
  mlen = n;
  return mlen;
}

var crypto_secretbox_KEYBYTES = 32,
    crypto_secretbox_NONCEBYTES = 24,
    crypto_secretbox_ZEROBYTES = 32,
    crypto_secretbox_BOXZEROBYTES = 16,
    crypto_scalarmult_BYTES = 32,
    crypto_scalarmult_SCALARBYTES = 32,
    crypto_box_PUBLICKEYBYTES = 32,
    crypto_box_SECRETKEYBYTES = 32,
    crypto_box_BEFORENMBYTES = 32,
    crypto_box_NONCEBYTES = crypto_secretbox_NONCEBYTES,
    crypto_box_ZEROBYTES = crypto_secretbox_ZEROBYTES,
    crypto_box_BOXZEROBYTES = crypto_secretbox_BOXZEROBYTES,
    crypto_sign_BYTES = 64,
    crypto_sign_PUBLICKEYBYTES = 32,
    crypto_sign_SECRETKEYBYTES = 64,
    crypto_sign_SEEDBYTES = 32,
    crypto_hash_BYTES = 64;

nacl.lowlevel = {
  crypto_core_hsalsa20: crypto_core_hsalsa20,
  crypto_stream_xor: crypto_stream_xor,
  crypto_stream: crypto_stream,
  crypto_stream_salsa20_xor: crypto_stream_salsa20_xor,
  crypto_stream_salsa20: crypto_stream_salsa20,
  crypto_onetimeauth: crypto_onetimeauth,
  crypto_onetimeauth_verify: crypto_onetimeauth_verify,
  crypto_verify_16: crypto_verify_16,
  crypto_verify_32: crypto_verify_32,
  crypto_secretbox: crypto_secretbox,
  crypto_secretbox_open: crypto_secretbox_open,
  crypto_scalarmult: crypto_scalarmult,
  crypto_scalarmult_base: crypto_scalarmult_base,
  crypto_box_beforenm: crypto_box_beforenm,
  crypto_box_afternm: crypto_box_afternm,
  crypto_box: crypto_box,
  crypto_box_open: crypto_box_open,
  crypto_box_keypair: crypto_box_keypair,
  crypto_hash: crypto_hash,
  crypto_sign: crypto_sign,
  crypto_sign_keypair: crypto_sign_keypair,
  crypto_sign_open: crypto_sign_open,

  crypto_secretbox_KEYBYTES: crypto_secretbox_KEYBYTES,
  crypto_secretbox_NONCEBYTES: crypto_secretbox_NONCEBYTES,
  crypto_secretbox_ZEROBYTES: crypto_secretbox_ZEROBYTES,
  crypto_secretbox_BOXZEROBYTES: crypto_secretbox_BOXZEROBYTES,
  crypto_scalarmult_BYTES: crypto_scalarmult_BYTES,
  crypto_scalarmult_SCALARBYTES: crypto_scalarmult_SCALARBYTES,
  crypto_box_PUBLICKEYBYTES: crypto_box_PUBLICKEYBYTES,
  crypto_box_SECRETKEYBYTES: crypto_box_SECRETKEYBYTES,
  crypto_box_BEFORENMBYTES: crypto_box_BEFORENMBYTES,
  crypto_box_NONCEBYTES: crypto_box_NONCEBYTES,
  crypto_box_ZEROBYTES: crypto_box_ZEROBYTES,
  crypto_box_BOXZEROBYTES: crypto_box_BOXZEROBYTES,
  crypto_sign_BYTES: crypto_sign_BYTES,
  crypto_sign_PUBLICKEYBYTES: crypto_sign_PUBLICKEYBYTES,
  crypto_sign_SECRETKEYBYTES: crypto_sign_SECRETKEYBYTES,
  crypto_sign_SEEDBYTES: crypto_sign_SEEDBYTES,
  crypto_hash_BYTES: crypto_hash_BYTES
};

/* High-level API */

function checkLengths(k, n) {
  if (k.length !== crypto_secretbox_KEYBYTES) throw new Error('bad key size');
  if (n.length !== crypto_secretbox_NONCEBYTES) throw new Error('bad nonce size');
}

function checkBoxLengths(pk, sk) {
  if (pk.length !== crypto_box_PUBLICKEYBYTES) throw new Error('bad public key size');
  if (sk.length !== crypto_box_SECRETKEYBYTES) throw new Error('bad secret key size');
}

function checkArrayTypes() {
  var t, i;
  for (i = 0; i < arguments.length; i++) {
     if ((t = Object.prototype.toString.call(arguments[i])) !== '[object Uint8Array]')
       throw new TypeError('unexpected type ' + t + ', use Uint8Array');
  }
}

function cleanup(arr) {
  for (var i = 0; i < arr.length; i++) arr[i] = 0;
}

// TODO: Completely remove this in v0.15.
if (!nacl.util) {
  nacl.util = {};
  nacl.util.decodeUTF8 = nacl.util.encodeUTF8 = nacl.util.encodeBase64 = nacl.util.decodeBase64 = function() {
    throw new Error('nacl.util moved into separate package: https://github.com/dchest/tweetnacl-util-js');
  };
}

nacl.randomBytes = function(n) {
  var b = new Uint8Array(n);
  randombytes(b, n);
  return b;
};

nacl.secretbox = function(msg, nonce, key) {
  checkArrayTypes(msg, nonce, key);
  checkLengths(key, nonce);
  var m = new Uint8Array(crypto_secretbox_ZEROBYTES + msg.length);
  var c = new Uint8Array(m.length);
  for (var i = 0; i < msg.length; i++) m[i+crypto_secretbox_ZEROBYTES] = msg[i];
  crypto_secretbox(c, m, m.length, nonce, key);
  return c.subarray(crypto_secretbox_BOXZEROBYTES);
};

nacl.secretbox.open = function(box, nonce, key) {
  checkArrayTypes(box, nonce, key);
  checkLengths(key, nonce);
  var c = new Uint8Array(crypto_secretbox_BOXZEROBYTES + box.length);
  var m = new Uint8Array(c.length);
  for (var i = 0; i < box.length; i++) c[i+crypto_secretbox_BOXZEROBYTES] = box[i];
  if (c.length < 32) return false;
  if (crypto_secretbox_open(m, c, c.length, nonce, key) !== 0) return false;
  return m.subarray(crypto_secretbox_ZEROBYTES);
};

nacl.secretbox.keyLength = crypto_secretbox_KEYBYTES;
nacl.secretbox.nonceLength = crypto_secretbox_NONCEBYTES;
nacl.secretbox.overheadLength = crypto_secretbox_BOXZEROBYTES;

nacl.scalarMult = function(n, p) {
  checkArrayTypes(n, p);
  if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error('bad n size');
  if (p.length !== crypto_scalarmult_BYTES) throw new Error('bad p size');
  var q = new Uint8Array(crypto_scalarmult_BYTES);
  crypto_scalarmult(q, n, p);
  return q;
};

nacl.scalarMult.base = function(n) {
  checkArrayTypes(n);
  if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error('bad n size');
  var q = new Uint8Array(crypto_scalarmult_BYTES);
  crypto_scalarmult_base(q, n);
  return q;
};

nacl.scalarMult.scalarLength = crypto_scalarmult_SCALARBYTES;
nacl.scalarMult.groupElementLength = crypto_scalarmult_BYTES;

nacl.box = function(msg, nonce, publicKey, secretKey) {
  var k = nacl.box.before(publicKey, secretKey);
  return nacl.secretbox(msg, nonce, k);
};

nacl.box.before = function(publicKey, secretKey) {
  checkArrayTypes(publicKey, secretKey);
  checkBoxLengths(publicKey, secretKey);
  var k = new Uint8Array(crypto_box_BEFORENMBYTES);
  crypto_box_beforenm(k, publicKey, secretKey);
  return k;
};

nacl.box.after = nacl.secretbox;

nacl.box.open = function(msg, nonce, publicKey, secretKey) {
  var k = nacl.box.before(publicKey, secretKey);
  return nacl.secretbox.open(msg, nonce, k);
};

nacl.box.open.after = nacl.secretbox.open;

nacl.box.keyPair = function() {
  var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
  var sk = new Uint8Array(crypto_box_SECRETKEYBYTES);
  crypto_box_keypair(pk, sk);
  return {publicKey: pk, secretKey: sk};
};

nacl.box.keyPair.fromSecretKey = function(secretKey) {
  checkArrayTypes(secretKey);
  if (secretKey.length !== crypto_box_SECRETKEYBYTES)
    throw new Error('bad secret key size');
  var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
  crypto_scalarmult_base(pk, secretKey);
  return {publicKey: pk, secretKey: new Uint8Array(secretKey)};
};

nacl.box.publicKeyLength = crypto_box_PUBLICKEYBYTES;
nacl.box.secretKeyLength = crypto_box_SECRETKEYBYTES;
nacl.box.sharedKeyLength = crypto_box_BEFORENMBYTES;
nacl.box.nonceLength = crypto_box_NONCEBYTES;
nacl.box.overheadLength = nacl.secretbox.overheadLength;

nacl.sign = function(msg, secretKey) {
  checkArrayTypes(msg, secretKey);
  if (secretKey.length !== crypto_sign_SECRETKEYBYTES)
    throw new Error('bad secret key size');
  var signedMsg = new Uint8Array(crypto_sign_BYTES+msg.length);
  crypto_sign(signedMsg, msg, msg.length, secretKey);
  return signedMsg;
};

nacl.sign.open = function(signedMsg, publicKey) {
  if (arguments.length !== 2)
    throw new Error('nacl.sign.open accepts 2 arguments; did you mean to use nacl.sign.detached.verify?');
  checkArrayTypes(signedMsg, publicKey);
  if (publicKey.length !== crypto_sign_PUBLICKEYBYTES)
    throw new Error('bad public key size');
  var tmp = new Uint8Array(signedMsg.length);
  var mlen = crypto_sign_open(tmp, signedMsg, signedMsg.length, publicKey);
  if (mlen < 0) return null;
  var m = new Uint8Array(mlen);
  for (var i = 0; i < m.length; i++) m[i] = tmp[i];
  return m;
};

nacl.sign.detached = function(msg, secretKey) {
  var signedMsg = nacl.sign(msg, secretKey);
  var sig = new Uint8Array(crypto_sign_BYTES);
  for (var i = 0; i < sig.length; i++) sig[i] = signedMsg[i];
  return sig;
};

nacl.sign.detached.verify = function(msg, sig, publicKey) {
  checkArrayTypes(msg, sig, publicKey);
  if (sig.length !== crypto_sign_BYTES)
    throw new Error('bad signature size');
  if (publicKey.length !== crypto_sign_PUBLICKEYBYTES)
    throw new Error('bad public key size');
  var sm = new Uint8Array(crypto_sign_BYTES + msg.length);
  var m = new Uint8Array(crypto_sign_BYTES + msg.length);
  var i;
  for (i = 0; i < crypto_sign_BYTES; i++) sm[i] = sig[i];
  for (i = 0; i < msg.length; i++) sm[i+crypto_sign_BYTES] = msg[i];
  return (crypto_sign_open(m, sm, sm.length, publicKey) >= 0);
};

nacl.sign.keyPair = function() {
  var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
  var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
  crypto_sign_keypair(pk, sk);
  return {publicKey: pk, secretKey: sk};
};

nacl.sign.keyPair.fromSecretKey = function(secretKey) {
  checkArrayTypes(secretKey);
  if (secretKey.length !== crypto_sign_SECRETKEYBYTES)
    throw new Error('bad secret key size');
  var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
  for (var i = 0; i < pk.length; i++) pk[i] = secretKey[32+i];
  return {publicKey: pk, secretKey: new Uint8Array(secretKey)};
};

nacl.sign.keyPair.fromSeed = function(seed) {
  checkArrayTypes(seed);
  if (seed.length !== crypto_sign_SEEDBYTES)
    throw new Error('bad seed size');
  var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
  var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
  for (var i = 0; i < 32; i++) sk[i] = seed[i];
  crypto_sign_keypair(pk, sk, true);
  return {publicKey: pk, secretKey: sk};
};

nacl.sign.publicKeyLength = crypto_sign_PUBLICKEYBYTES;
nacl.sign.secretKeyLength = crypto_sign_SECRETKEYBYTES;
nacl.sign.seedLength = crypto_sign_SEEDBYTES;
nacl.sign.signatureLength = crypto_sign_BYTES;

nacl.hash = function(msg) {
  checkArrayTypes(msg);
  var h = new Uint8Array(crypto_hash_BYTES);
  crypto_hash(h, msg, msg.length);
  return h;
};

nacl.hash.hashLength = crypto_hash_BYTES;

nacl.verify = function(x, y) {
  checkArrayTypes(x, y);
  // Zero length arguments are considered not equal.
  if (x.length === 0 || y.length === 0) return false;
  if (x.length !== y.length) return false;
  return (vn(x, 0, y, 0, x.length) === 0) ? true : false;
};

nacl.setPRNG = function(fn) {
  randombytes = fn;
};

(function() {
  // Initialize PRNG if environment provides CSPRNG.
  // If not, methods calling randombytes will throw.
  var crypto = typeof self !== 'undefined' ? (self.crypto || self.msCrypto) : null;
  if (crypto && crypto.getRandomValues) {
    // Browsers.
    var QUOTA = 65536;
    nacl.setPRNG(function(x, n) {
      var i, v = new Uint8Array(n);
      for (i = 0; i < n; i += QUOTA) {
        crypto.getRandomValues(v.subarray(i, i + Math.min(n - i, QUOTA)));
      }
      for (i = 0; i < n; i++) x[i] = v[i];
      cleanup(v);
    });
  } else if (true) {
    // Node.js.
    crypto = __webpack_require__(271);
    if (crypto && crypto.randomBytes) {
      nacl.setPRNG(function(x, n) {
        var i, v = crypto.randomBytes(n);
        for (i = 0; i < n; i++) x[i] = v[i];
        cleanup(v);
      });
    }
  }
})();

})(typeof module !== 'undefined' && module.exports ? module.exports : (self.nacl = self.nacl || {}));


/***/ }),
/* 271 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

(function(root, f) {
  'use strict';
  if (typeof module !== 'undefined' && module.exports) module.exports = f(__webpack_require__(273));
  else root.nacl.auth = f(root.nacl);

}(this, function(nacl) {
  'use strict';

  if (!nacl) throw new Error('tweetnacl not loaded');

  var BLOCK_SIZE = 128, HASH_SIZE = 64;

  function hmac(message, key) {
    var buf = new Uint8Array(BLOCK_SIZE + Math.max(HASH_SIZE, message.length));
    var i, innerHash;

    if (key.length > BLOCK_SIZE)
      key = nacl.hash(key);

    for (i = 0; i < BLOCK_SIZE; i++) buf[i] = 0x36;
    for (i = 0; i < key.length; i++) buf[i] ^= key[i];
    buf.set(message, BLOCK_SIZE);
    innerHash = nacl.hash(buf.subarray(0, BLOCK_SIZE + message.length));

    for (i = 0; i < BLOCK_SIZE; i++) buf[i] = 0x5c;
    for (i = 0; i < key.length; i++) buf[i] ^= key[i];
    buf.set(innerHash, BLOCK_SIZE);
    return nacl.hash(buf.subarray(0, BLOCK_SIZE + innerHash.length));
  }

  function auth(message, key) {
    var out = new Uint8Array(32);
    out.set(hmac(message, key).subarray(0, 32));
    return out;
  }

  auth.full = function (message, key) {
    return hmac(message, key);
  };

  auth.authLength = 32;
  auth.authFullLength = 64;
  auth.keyLength = 32;

  return auth;

}));


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

(function(nacl) {
'use strict';

// Ported in 2014 by Dmitry Chestnykh and Devi Mandiri.
// Public domain.
//
// Implementation derived from TweetNaCl version 20140427.
// See for details: http://tweetnacl.cr.yp.to/

var gf = function(init) {
  var i, r = new Float64Array(16);
  if (init) for (i = 0; i < init.length; i++) r[i] = init[i];
  return r;
};

//  Pluggable, initialized in high-level API below.
var randombytes = function(/* x, n */) { throw new Error('no PRNG'); };

var _0 = new Uint8Array(16);
var _9 = new Uint8Array(32); _9[0] = 9;

var gf0 = gf(),
    gf1 = gf([1]),
    _121665 = gf([0xdb41, 1]),
    D = gf([0x78a3, 0x1359, 0x4dca, 0x75eb, 0xd8ab, 0x4141, 0x0a4d, 0x0070, 0xe898, 0x7779, 0x4079, 0x8cc7, 0xfe73, 0x2b6f, 0x6cee, 0x5203]),
    D2 = gf([0xf159, 0x26b2, 0x9b94, 0xebd6, 0xb156, 0x8283, 0x149a, 0x00e0, 0xd130, 0xeef3, 0x80f2, 0x198e, 0xfce7, 0x56df, 0xd9dc, 0x2406]),
    X = gf([0xd51a, 0x8f25, 0x2d60, 0xc956, 0xa7b2, 0x9525, 0xc760, 0x692c, 0xdc5c, 0xfdd6, 0xe231, 0xc0a4, 0x53fe, 0xcd6e, 0x36d3, 0x2169]),
    Y = gf([0x6658, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666]),
    I = gf([0xa0b0, 0x4a0e, 0x1b27, 0xc4ee, 0xe478, 0xad2f, 0x1806, 0x2f43, 0xd7a7, 0x3dfb, 0x0099, 0x2b4d, 0xdf0b, 0x4fc1, 0x2480, 0x2b83]);

function ts64(x, i, h, l) {
  x[i]   = (h >> 24) & 0xff;
  x[i+1] = (h >> 16) & 0xff;
  x[i+2] = (h >>  8) & 0xff;
  x[i+3] = h & 0xff;
  x[i+4] = (l >> 24)  & 0xff;
  x[i+5] = (l >> 16)  & 0xff;
  x[i+6] = (l >>  8)  & 0xff;
  x[i+7] = l & 0xff;
}

function vn(x, xi, y, yi, n) {
  var i,d = 0;
  for (i = 0; i < n; i++) d |= x[xi+i]^y[yi+i];
  return (1 & ((d - 1) >>> 8)) - 1;
}

function crypto_verify_16(x, xi, y, yi) {
  return vn(x,xi,y,yi,16);
}

function crypto_verify_32(x, xi, y, yi) {
  return vn(x,xi,y,yi,32);
}

function core_salsa20(o, p, k, c) {
  var j0  = c[ 0] & 0xff | (c[ 1] & 0xff)<<8 | (c[ 2] & 0xff)<<16 | (c[ 3] & 0xff)<<24,
      j1  = k[ 0] & 0xff | (k[ 1] & 0xff)<<8 | (k[ 2] & 0xff)<<16 | (k[ 3] & 0xff)<<24,
      j2  = k[ 4] & 0xff | (k[ 5] & 0xff)<<8 | (k[ 6] & 0xff)<<16 | (k[ 7] & 0xff)<<24,
      j3  = k[ 8] & 0xff | (k[ 9] & 0xff)<<8 | (k[10] & 0xff)<<16 | (k[11] & 0xff)<<24,
      j4  = k[12] & 0xff | (k[13] & 0xff)<<8 | (k[14] & 0xff)<<16 | (k[15] & 0xff)<<24,
      j5  = c[ 4] & 0xff | (c[ 5] & 0xff)<<8 | (c[ 6] & 0xff)<<16 | (c[ 7] & 0xff)<<24,
      j6  = p[ 0] & 0xff | (p[ 1] & 0xff)<<8 | (p[ 2] & 0xff)<<16 | (p[ 3] & 0xff)<<24,
      j7  = p[ 4] & 0xff | (p[ 5] & 0xff)<<8 | (p[ 6] & 0xff)<<16 | (p[ 7] & 0xff)<<24,
      j8  = p[ 8] & 0xff | (p[ 9] & 0xff)<<8 | (p[10] & 0xff)<<16 | (p[11] & 0xff)<<24,
      j9  = p[12] & 0xff | (p[13] & 0xff)<<8 | (p[14] & 0xff)<<16 | (p[15] & 0xff)<<24,
      j10 = c[ 8] & 0xff | (c[ 9] & 0xff)<<8 | (c[10] & 0xff)<<16 | (c[11] & 0xff)<<24,
      j11 = k[16] & 0xff | (k[17] & 0xff)<<8 | (k[18] & 0xff)<<16 | (k[19] & 0xff)<<24,
      j12 = k[20] & 0xff | (k[21] & 0xff)<<8 | (k[22] & 0xff)<<16 | (k[23] & 0xff)<<24,
      j13 = k[24] & 0xff | (k[25] & 0xff)<<8 | (k[26] & 0xff)<<16 | (k[27] & 0xff)<<24,
      j14 = k[28] & 0xff | (k[29] & 0xff)<<8 | (k[30] & 0xff)<<16 | (k[31] & 0xff)<<24,
      j15 = c[12] & 0xff | (c[13] & 0xff)<<8 | (c[14] & 0xff)<<16 | (c[15] & 0xff)<<24;

  var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7,
      x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14,
      x15 = j15, u;

  for (var i = 0; i < 20; i += 2) {
    u = x0 + x12 | 0;
    x4 ^= u<<7 | u>>>(32-7);
    u = x4 + x0 | 0;
    x8 ^= u<<9 | u>>>(32-9);
    u = x8 + x4 | 0;
    x12 ^= u<<13 | u>>>(32-13);
    u = x12 + x8 | 0;
    x0 ^= u<<18 | u>>>(32-18);

    u = x5 + x1 | 0;
    x9 ^= u<<7 | u>>>(32-7);
    u = x9 + x5 | 0;
    x13 ^= u<<9 | u>>>(32-9);
    u = x13 + x9 | 0;
    x1 ^= u<<13 | u>>>(32-13);
    u = x1 + x13 | 0;
    x5 ^= u<<18 | u>>>(32-18);

    u = x10 + x6 | 0;
    x14 ^= u<<7 | u>>>(32-7);
    u = x14 + x10 | 0;
    x2 ^= u<<9 | u>>>(32-9);
    u = x2 + x14 | 0;
    x6 ^= u<<13 | u>>>(32-13);
    u = x6 + x2 | 0;
    x10 ^= u<<18 | u>>>(32-18);

    u = x15 + x11 | 0;
    x3 ^= u<<7 | u>>>(32-7);
    u = x3 + x15 | 0;
    x7 ^= u<<9 | u>>>(32-9);
    u = x7 + x3 | 0;
    x11 ^= u<<13 | u>>>(32-13);
    u = x11 + x7 | 0;
    x15 ^= u<<18 | u>>>(32-18);

    u = x0 + x3 | 0;
    x1 ^= u<<7 | u>>>(32-7);
    u = x1 + x0 | 0;
    x2 ^= u<<9 | u>>>(32-9);
    u = x2 + x1 | 0;
    x3 ^= u<<13 | u>>>(32-13);
    u = x3 + x2 | 0;
    x0 ^= u<<18 | u>>>(32-18);

    u = x5 + x4 | 0;
    x6 ^= u<<7 | u>>>(32-7);
    u = x6 + x5 | 0;
    x7 ^= u<<9 | u>>>(32-9);
    u = x7 + x6 | 0;
    x4 ^= u<<13 | u>>>(32-13);
    u = x4 + x7 | 0;
    x5 ^= u<<18 | u>>>(32-18);

    u = x10 + x9 | 0;
    x11 ^= u<<7 | u>>>(32-7);
    u = x11 + x10 | 0;
    x8 ^= u<<9 | u>>>(32-9);
    u = x8 + x11 | 0;
    x9 ^= u<<13 | u>>>(32-13);
    u = x9 + x8 | 0;
    x10 ^= u<<18 | u>>>(32-18);

    u = x15 + x14 | 0;
    x12 ^= u<<7 | u>>>(32-7);
    u = x12 + x15 | 0;
    x13 ^= u<<9 | u>>>(32-9);
    u = x13 + x12 | 0;
    x14 ^= u<<13 | u>>>(32-13);
    u = x14 + x13 | 0;
    x15 ^= u<<18 | u>>>(32-18);
  }
   x0 =  x0 +  j0 | 0;
   x1 =  x1 +  j1 | 0;
   x2 =  x2 +  j2 | 0;
   x3 =  x3 +  j3 | 0;
   x4 =  x4 +  j4 | 0;
   x5 =  x5 +  j5 | 0;
   x6 =  x6 +  j6 | 0;
   x7 =  x7 +  j7 | 0;
   x8 =  x8 +  j8 | 0;
   x9 =  x9 +  j9 | 0;
  x10 = x10 + j10 | 0;
  x11 = x11 + j11 | 0;
  x12 = x12 + j12 | 0;
  x13 = x13 + j13 | 0;
  x14 = x14 + j14 | 0;
  x15 = x15 + j15 | 0;

  o[ 0] = x0 >>>  0 & 0xff;
  o[ 1] = x0 >>>  8 & 0xff;
  o[ 2] = x0 >>> 16 & 0xff;
  o[ 3] = x0 >>> 24 & 0xff;

  o[ 4] = x1 >>>  0 & 0xff;
  o[ 5] = x1 >>>  8 & 0xff;
  o[ 6] = x1 >>> 16 & 0xff;
  o[ 7] = x1 >>> 24 & 0xff;

  o[ 8] = x2 >>>  0 & 0xff;
  o[ 9] = x2 >>>  8 & 0xff;
  o[10] = x2 >>> 16 & 0xff;
  o[11] = x2 >>> 24 & 0xff;

  o[12] = x3 >>>  0 & 0xff;
  o[13] = x3 >>>  8 & 0xff;
  o[14] = x3 >>> 16 & 0xff;
  o[15] = x3 >>> 24 & 0xff;

  o[16] = x4 >>>  0 & 0xff;
  o[17] = x4 >>>  8 & 0xff;
  o[18] = x4 >>> 16 & 0xff;
  o[19] = x4 >>> 24 & 0xff;

  o[20] = x5 >>>  0 & 0xff;
  o[21] = x5 >>>  8 & 0xff;
  o[22] = x5 >>> 16 & 0xff;
  o[23] = x5 >>> 24 & 0xff;

  o[24] = x6 >>>  0 & 0xff;
  o[25] = x6 >>>  8 & 0xff;
  o[26] = x6 >>> 16 & 0xff;
  o[27] = x6 >>> 24 & 0xff;

  o[28] = x7 >>>  0 & 0xff;
  o[29] = x7 >>>  8 & 0xff;
  o[30] = x7 >>> 16 & 0xff;
  o[31] = x7 >>> 24 & 0xff;

  o[32] = x8 >>>  0 & 0xff;
  o[33] = x8 >>>  8 & 0xff;
  o[34] = x8 >>> 16 & 0xff;
  o[35] = x8 >>> 24 & 0xff;

  o[36] = x9 >>>  0 & 0xff;
  o[37] = x9 >>>  8 & 0xff;
  o[38] = x9 >>> 16 & 0xff;
  o[39] = x9 >>> 24 & 0xff;

  o[40] = x10 >>>  0 & 0xff;
  o[41] = x10 >>>  8 & 0xff;
  o[42] = x10 >>> 16 & 0xff;
  o[43] = x10 >>> 24 & 0xff;

  o[44] = x11 >>>  0 & 0xff;
  o[45] = x11 >>>  8 & 0xff;
  o[46] = x11 >>> 16 & 0xff;
  o[47] = x11 >>> 24 & 0xff;

  o[48] = x12 >>>  0 & 0xff;
  o[49] = x12 >>>  8 & 0xff;
  o[50] = x12 >>> 16 & 0xff;
  o[51] = x12 >>> 24 & 0xff;

  o[52] = x13 >>>  0 & 0xff;
  o[53] = x13 >>>  8 & 0xff;
  o[54] = x13 >>> 16 & 0xff;
  o[55] = x13 >>> 24 & 0xff;

  o[56] = x14 >>>  0 & 0xff;
  o[57] = x14 >>>  8 & 0xff;
  o[58] = x14 >>> 16 & 0xff;
  o[59] = x14 >>> 24 & 0xff;

  o[60] = x15 >>>  0 & 0xff;
  o[61] = x15 >>>  8 & 0xff;
  o[62] = x15 >>> 16 & 0xff;
  o[63] = x15 >>> 24 & 0xff;
}

function core_hsalsa20(o,p,k,c) {
  var j0  = c[ 0] & 0xff | (c[ 1] & 0xff)<<8 | (c[ 2] & 0xff)<<16 | (c[ 3] & 0xff)<<24,
      j1  = k[ 0] & 0xff | (k[ 1] & 0xff)<<8 | (k[ 2] & 0xff)<<16 | (k[ 3] & 0xff)<<24,
      j2  = k[ 4] & 0xff | (k[ 5] & 0xff)<<8 | (k[ 6] & 0xff)<<16 | (k[ 7] & 0xff)<<24,
      j3  = k[ 8] & 0xff | (k[ 9] & 0xff)<<8 | (k[10] & 0xff)<<16 | (k[11] & 0xff)<<24,
      j4  = k[12] & 0xff | (k[13] & 0xff)<<8 | (k[14] & 0xff)<<16 | (k[15] & 0xff)<<24,
      j5  = c[ 4] & 0xff | (c[ 5] & 0xff)<<8 | (c[ 6] & 0xff)<<16 | (c[ 7] & 0xff)<<24,
      j6  = p[ 0] & 0xff | (p[ 1] & 0xff)<<8 | (p[ 2] & 0xff)<<16 | (p[ 3] & 0xff)<<24,
      j7  = p[ 4] & 0xff | (p[ 5] & 0xff)<<8 | (p[ 6] & 0xff)<<16 | (p[ 7] & 0xff)<<24,
      j8  = p[ 8] & 0xff | (p[ 9] & 0xff)<<8 | (p[10] & 0xff)<<16 | (p[11] & 0xff)<<24,
      j9  = p[12] & 0xff | (p[13] & 0xff)<<8 | (p[14] & 0xff)<<16 | (p[15] & 0xff)<<24,
      j10 = c[ 8] & 0xff | (c[ 9] & 0xff)<<8 | (c[10] & 0xff)<<16 | (c[11] & 0xff)<<24,
      j11 = k[16] & 0xff | (k[17] & 0xff)<<8 | (k[18] & 0xff)<<16 | (k[19] & 0xff)<<24,
      j12 = k[20] & 0xff | (k[21] & 0xff)<<8 | (k[22] & 0xff)<<16 | (k[23] & 0xff)<<24,
      j13 = k[24] & 0xff | (k[25] & 0xff)<<8 | (k[26] & 0xff)<<16 | (k[27] & 0xff)<<24,
      j14 = k[28] & 0xff | (k[29] & 0xff)<<8 | (k[30] & 0xff)<<16 | (k[31] & 0xff)<<24,
      j15 = c[12] & 0xff | (c[13] & 0xff)<<8 | (c[14] & 0xff)<<16 | (c[15] & 0xff)<<24;

  var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7,
      x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14,
      x15 = j15, u;

  for (var i = 0; i < 20; i += 2) {
    u = x0 + x12 | 0;
    x4 ^= u<<7 | u>>>(32-7);
    u = x4 + x0 | 0;
    x8 ^= u<<9 | u>>>(32-9);
    u = x8 + x4 | 0;
    x12 ^= u<<13 | u>>>(32-13);
    u = x12 + x8 | 0;
    x0 ^= u<<18 | u>>>(32-18);

    u = x5 + x1 | 0;
    x9 ^= u<<7 | u>>>(32-7);
    u = x9 + x5 | 0;
    x13 ^= u<<9 | u>>>(32-9);
    u = x13 + x9 | 0;
    x1 ^= u<<13 | u>>>(32-13);
    u = x1 + x13 | 0;
    x5 ^= u<<18 | u>>>(32-18);

    u = x10 + x6 | 0;
    x14 ^= u<<7 | u>>>(32-7);
    u = x14 + x10 | 0;
    x2 ^= u<<9 | u>>>(32-9);
    u = x2 + x14 | 0;
    x6 ^= u<<13 | u>>>(32-13);
    u = x6 + x2 | 0;
    x10 ^= u<<18 | u>>>(32-18);

    u = x15 + x11 | 0;
    x3 ^= u<<7 | u>>>(32-7);
    u = x3 + x15 | 0;
    x7 ^= u<<9 | u>>>(32-9);
    u = x7 + x3 | 0;
    x11 ^= u<<13 | u>>>(32-13);
    u = x11 + x7 | 0;
    x15 ^= u<<18 | u>>>(32-18);

    u = x0 + x3 | 0;
    x1 ^= u<<7 | u>>>(32-7);
    u = x1 + x0 | 0;
    x2 ^= u<<9 | u>>>(32-9);
    u = x2 + x1 | 0;
    x3 ^= u<<13 | u>>>(32-13);
    u = x3 + x2 | 0;
    x0 ^= u<<18 | u>>>(32-18);

    u = x5 + x4 | 0;
    x6 ^= u<<7 | u>>>(32-7);
    u = x6 + x5 | 0;
    x7 ^= u<<9 | u>>>(32-9);
    u = x7 + x6 | 0;
    x4 ^= u<<13 | u>>>(32-13);
    u = x4 + x7 | 0;
    x5 ^= u<<18 | u>>>(32-18);

    u = x10 + x9 | 0;
    x11 ^= u<<7 | u>>>(32-7);
    u = x11 + x10 | 0;
    x8 ^= u<<9 | u>>>(32-9);
    u = x8 + x11 | 0;
    x9 ^= u<<13 | u>>>(32-13);
    u = x9 + x8 | 0;
    x10 ^= u<<18 | u>>>(32-18);

    u = x15 + x14 | 0;
    x12 ^= u<<7 | u>>>(32-7);
    u = x12 + x15 | 0;
    x13 ^= u<<9 | u>>>(32-9);
    u = x13 + x12 | 0;
    x14 ^= u<<13 | u>>>(32-13);
    u = x14 + x13 | 0;
    x15 ^= u<<18 | u>>>(32-18);
  }

  o[ 0] = x0 >>>  0 & 0xff;
  o[ 1] = x0 >>>  8 & 0xff;
  o[ 2] = x0 >>> 16 & 0xff;
  o[ 3] = x0 >>> 24 & 0xff;

  o[ 4] = x5 >>>  0 & 0xff;
  o[ 5] = x5 >>>  8 & 0xff;
  o[ 6] = x5 >>> 16 & 0xff;
  o[ 7] = x5 >>> 24 & 0xff;

  o[ 8] = x10 >>>  0 & 0xff;
  o[ 9] = x10 >>>  8 & 0xff;
  o[10] = x10 >>> 16 & 0xff;
  o[11] = x10 >>> 24 & 0xff;

  o[12] = x15 >>>  0 & 0xff;
  o[13] = x15 >>>  8 & 0xff;
  o[14] = x15 >>> 16 & 0xff;
  o[15] = x15 >>> 24 & 0xff;

  o[16] = x6 >>>  0 & 0xff;
  o[17] = x6 >>>  8 & 0xff;
  o[18] = x6 >>> 16 & 0xff;
  o[19] = x6 >>> 24 & 0xff;

  o[20] = x7 >>>  0 & 0xff;
  o[21] = x7 >>>  8 & 0xff;
  o[22] = x7 >>> 16 & 0xff;
  o[23] = x7 >>> 24 & 0xff;

  o[24] = x8 >>>  0 & 0xff;
  o[25] = x8 >>>  8 & 0xff;
  o[26] = x8 >>> 16 & 0xff;
  o[27] = x8 >>> 24 & 0xff;

  o[28] = x9 >>>  0 & 0xff;
  o[29] = x9 >>>  8 & 0xff;
  o[30] = x9 >>> 16 & 0xff;
  o[31] = x9 >>> 24 & 0xff;
}

function crypto_core_salsa20(out,inp,k,c) {
  core_salsa20(out,inp,k,c);
}

function crypto_core_hsalsa20(out,inp,k,c) {
  core_hsalsa20(out,inp,k,c);
}

var sigma = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
            // "expand 32-byte k"

function crypto_stream_salsa20_xor(c,cpos,m,mpos,b,n,k) {
  var z = new Uint8Array(16), x = new Uint8Array(64);
  var u, i;
  for (i = 0; i < 16; i++) z[i] = 0;
  for (i = 0; i < 8; i++) z[i] = n[i];
  while (b >= 64) {
    crypto_core_salsa20(x,z,k,sigma);
    for (i = 0; i < 64; i++) c[cpos+i] = m[mpos+i] ^ x[i];
    u = 1;
    for (i = 8; i < 16; i++) {
      u = u + (z[i] & 0xff) | 0;
      z[i] = u & 0xff;
      u >>>= 8;
    }
    b -= 64;
    cpos += 64;
    mpos += 64;
  }
  if (b > 0) {
    crypto_core_salsa20(x,z,k,sigma);
    for (i = 0; i < b; i++) c[cpos+i] = m[mpos+i] ^ x[i];
  }
  return 0;
}

function crypto_stream_salsa20(c,cpos,b,n,k) {
  var z = new Uint8Array(16), x = new Uint8Array(64);
  var u, i;
  for (i = 0; i < 16; i++) z[i] = 0;
  for (i = 0; i < 8; i++) z[i] = n[i];
  while (b >= 64) {
    crypto_core_salsa20(x,z,k,sigma);
    for (i = 0; i < 64; i++) c[cpos+i] = x[i];
    u = 1;
    for (i = 8; i < 16; i++) {
      u = u + (z[i] & 0xff) | 0;
      z[i] = u & 0xff;
      u >>>= 8;
    }
    b -= 64;
    cpos += 64;
  }
  if (b > 0) {
    crypto_core_salsa20(x,z,k,sigma);
    for (i = 0; i < b; i++) c[cpos+i] = x[i];
  }
  return 0;
}

function crypto_stream(c,cpos,d,n,k) {
  var s = new Uint8Array(32);
  crypto_core_hsalsa20(s,n,k,sigma);
  var sn = new Uint8Array(8);
  for (var i = 0; i < 8; i++) sn[i] = n[i+16];
  return crypto_stream_salsa20(c,cpos,d,sn,s);
}

function crypto_stream_xor(c,cpos,m,mpos,d,n,k) {
  var s = new Uint8Array(32);
  crypto_core_hsalsa20(s,n,k,sigma);
  var sn = new Uint8Array(8);
  for (var i = 0; i < 8; i++) sn[i] = n[i+16];
  return crypto_stream_salsa20_xor(c,cpos,m,mpos,d,sn,s);
}

/*
* Port of Andrew Moon's Poly1305-donna-16. Public domain.
* https://github.com/floodyberry/poly1305-donna
*/

var poly1305 = function(key) {
  this.buffer = new Uint8Array(16);
  this.r = new Uint16Array(10);
  this.h = new Uint16Array(10);
  this.pad = new Uint16Array(8);
  this.leftover = 0;
  this.fin = 0;

  var t0, t1, t2, t3, t4, t5, t6, t7;

  t0 = key[ 0] & 0xff | (key[ 1] & 0xff) << 8; this.r[0] = ( t0                     ) & 0x1fff;
  t1 = key[ 2] & 0xff | (key[ 3] & 0xff) << 8; this.r[1] = ((t0 >>> 13) | (t1 <<  3)) & 0x1fff;
  t2 = key[ 4] & 0xff | (key[ 5] & 0xff) << 8; this.r[2] = ((t1 >>> 10) | (t2 <<  6)) & 0x1f03;
  t3 = key[ 6] & 0xff | (key[ 7] & 0xff) << 8; this.r[3] = ((t2 >>>  7) | (t3 <<  9)) & 0x1fff;
  t4 = key[ 8] & 0xff | (key[ 9] & 0xff) << 8; this.r[4] = ((t3 >>>  4) | (t4 << 12)) & 0x00ff;
  this.r[5] = ((t4 >>>  1)) & 0x1ffe;
  t5 = key[10] & 0xff | (key[11] & 0xff) << 8; this.r[6] = ((t4 >>> 14) | (t5 <<  2)) & 0x1fff;
  t6 = key[12] & 0xff | (key[13] & 0xff) << 8; this.r[7] = ((t5 >>> 11) | (t6 <<  5)) & 0x1f81;
  t7 = key[14] & 0xff | (key[15] & 0xff) << 8; this.r[8] = ((t6 >>>  8) | (t7 <<  8)) & 0x1fff;
  this.r[9] = ((t7 >>>  5)) & 0x007f;

  this.pad[0] = key[16] & 0xff | (key[17] & 0xff) << 8;
  this.pad[1] = key[18] & 0xff | (key[19] & 0xff) << 8;
  this.pad[2] = key[20] & 0xff | (key[21] & 0xff) << 8;
  this.pad[3] = key[22] & 0xff | (key[23] & 0xff) << 8;
  this.pad[4] = key[24] & 0xff | (key[25] & 0xff) << 8;
  this.pad[5] = key[26] & 0xff | (key[27] & 0xff) << 8;
  this.pad[6] = key[28] & 0xff | (key[29] & 0xff) << 8;
  this.pad[7] = key[30] & 0xff | (key[31] & 0xff) << 8;
};

poly1305.prototype.blocks = function(m, mpos, bytes) {
  var hibit = this.fin ? 0 : (1 << 11);
  var t0, t1, t2, t3, t4, t5, t6, t7, c;
  var d0, d1, d2, d3, d4, d5, d6, d7, d8, d9;

  var h0 = this.h[0],
      h1 = this.h[1],
      h2 = this.h[2],
      h3 = this.h[3],
      h4 = this.h[4],
      h5 = this.h[5],
      h6 = this.h[6],
      h7 = this.h[7],
      h8 = this.h[8],
      h9 = this.h[9];

  var r0 = this.r[0],
      r1 = this.r[1],
      r2 = this.r[2],
      r3 = this.r[3],
      r4 = this.r[4],
      r5 = this.r[5],
      r6 = this.r[6],
      r7 = this.r[7],
      r8 = this.r[8],
      r9 = this.r[9];

  while (bytes >= 16) {
    t0 = m[mpos+ 0] & 0xff | (m[mpos+ 1] & 0xff) << 8; h0 += ( t0                     ) & 0x1fff;
    t1 = m[mpos+ 2] & 0xff | (m[mpos+ 3] & 0xff) << 8; h1 += ((t0 >>> 13) | (t1 <<  3)) & 0x1fff;
    t2 = m[mpos+ 4] & 0xff | (m[mpos+ 5] & 0xff) << 8; h2 += ((t1 >>> 10) | (t2 <<  6)) & 0x1fff;
    t3 = m[mpos+ 6] & 0xff | (m[mpos+ 7] & 0xff) << 8; h3 += ((t2 >>>  7) | (t3 <<  9)) & 0x1fff;
    t4 = m[mpos+ 8] & 0xff | (m[mpos+ 9] & 0xff) << 8; h4 += ((t3 >>>  4) | (t4 << 12)) & 0x1fff;
    h5 += ((t4 >>>  1)) & 0x1fff;
    t5 = m[mpos+10] & 0xff | (m[mpos+11] & 0xff) << 8; h6 += ((t4 >>> 14) | (t5 <<  2)) & 0x1fff;
    t6 = m[mpos+12] & 0xff | (m[mpos+13] & 0xff) << 8; h7 += ((t5 >>> 11) | (t6 <<  5)) & 0x1fff;
    t7 = m[mpos+14] & 0xff | (m[mpos+15] & 0xff) << 8; h8 += ((t6 >>>  8) | (t7 <<  8)) & 0x1fff;
    h9 += ((t7 >>> 5)) | hibit;

    c = 0;

    d0 = c;
    d0 += h0 * r0;
    d0 += h1 * (5 * r9);
    d0 += h2 * (5 * r8);
    d0 += h3 * (5 * r7);
    d0 += h4 * (5 * r6);
    c = (d0 >>> 13); d0 &= 0x1fff;
    d0 += h5 * (5 * r5);
    d0 += h6 * (5 * r4);
    d0 += h7 * (5 * r3);
    d0 += h8 * (5 * r2);
    d0 += h9 * (5 * r1);
    c += (d0 >>> 13); d0 &= 0x1fff;

    d1 = c;
    d1 += h0 * r1;
    d1 += h1 * r0;
    d1 += h2 * (5 * r9);
    d1 += h3 * (5 * r8);
    d1 += h4 * (5 * r7);
    c = (d1 >>> 13); d1 &= 0x1fff;
    d1 += h5 * (5 * r6);
    d1 += h6 * (5 * r5);
    d1 += h7 * (5 * r4);
    d1 += h8 * (5 * r3);
    d1 += h9 * (5 * r2);
    c += (d1 >>> 13); d1 &= 0x1fff;

    d2 = c;
    d2 += h0 * r2;
    d2 += h1 * r1;
    d2 += h2 * r0;
    d2 += h3 * (5 * r9);
    d2 += h4 * (5 * r8);
    c = (d2 >>> 13); d2 &= 0x1fff;
    d2 += h5 * (5 * r7);
    d2 += h6 * (5 * r6);
    d2 += h7 * (5 * r5);
    d2 += h8 * (5 * r4);
    d2 += h9 * (5 * r3);
    c += (d2 >>> 13); d2 &= 0x1fff;

    d3 = c;
    d3 += h0 * r3;
    d3 += h1 * r2;
    d3 += h2 * r1;
    d3 += h3 * r0;
    d3 += h4 * (5 * r9);
    c = (d3 >>> 13); d3 &= 0x1fff;
    d3 += h5 * (5 * r8);
    d3 += h6 * (5 * r7);
    d3 += h7 * (5 * r6);
    d3 += h8 * (5 * r5);
    d3 += h9 * (5 * r4);
    c += (d3 >>> 13); d3 &= 0x1fff;

    d4 = c;
    d4 += h0 * r4;
    d4 += h1 * r3;
    d4 += h2 * r2;
    d4 += h3 * r1;
    d4 += h4 * r0;
    c = (d4 >>> 13); d4 &= 0x1fff;
    d4 += h5 * (5 * r9);
    d4 += h6 * (5 * r8);
    d4 += h7 * (5 * r7);
    d4 += h8 * (5 * r6);
    d4 += h9 * (5 * r5);
    c += (d4 >>> 13); d4 &= 0x1fff;

    d5 = c;
    d5 += h0 * r5;
    d5 += h1 * r4;
    d5 += h2 * r3;
    d5 += h3 * r2;
    d5 += h4 * r1;
    c = (d5 >>> 13); d5 &= 0x1fff;
    d5 += h5 * r0;
    d5 += h6 * (5 * r9);
    d5 += h7 * (5 * r8);
    d5 += h8 * (5 * r7);
    d5 += h9 * (5 * r6);
    c += (d5 >>> 13); d5 &= 0x1fff;

    d6 = c;
    d6 += h0 * r6;
    d6 += h1 * r5;
    d6 += h2 * r4;
    d6 += h3 * r3;
    d6 += h4 * r2;
    c = (d6 >>> 13); d6 &= 0x1fff;
    d6 += h5 * r1;
    d6 += h6 * r0;
    d6 += h7 * (5 * r9);
    d6 += h8 * (5 * r8);
    d6 += h9 * (5 * r7);
    c += (d6 >>> 13); d6 &= 0x1fff;

    d7 = c;
    d7 += h0 * r7;
    d7 += h1 * r6;
    d7 += h2 * r5;
    d7 += h3 * r4;
    d7 += h4 * r3;
    c = (d7 >>> 13); d7 &= 0x1fff;
    d7 += h5 * r2;
    d7 += h6 * r1;
    d7 += h7 * r0;
    d7 += h8 * (5 * r9);
    d7 += h9 * (5 * r8);
    c += (d7 >>> 13); d7 &= 0x1fff;

    d8 = c;
    d8 += h0 * r8;
    d8 += h1 * r7;
    d8 += h2 * r6;
    d8 += h3 * r5;
    d8 += h4 * r4;
    c = (d8 >>> 13); d8 &= 0x1fff;
    d8 += h5 * r3;
    d8 += h6 * r2;
    d8 += h7 * r1;
    d8 += h8 * r0;
    d8 += h9 * (5 * r9);
    c += (d8 >>> 13); d8 &= 0x1fff;

    d9 = c;
    d9 += h0 * r9;
    d9 += h1 * r8;
    d9 += h2 * r7;
    d9 += h3 * r6;
    d9 += h4 * r5;
    c = (d9 >>> 13); d9 &= 0x1fff;
    d9 += h5 * r4;
    d9 += h6 * r3;
    d9 += h7 * r2;
    d9 += h8 * r1;
    d9 += h9 * r0;
    c += (d9 >>> 13); d9 &= 0x1fff;

    c = (((c << 2) + c)) | 0;
    c = (c + d0) | 0;
    d0 = c & 0x1fff;
    c = (c >>> 13);
    d1 += c;

    h0 = d0;
    h1 = d1;
    h2 = d2;
    h3 = d3;
    h4 = d4;
    h5 = d5;
    h6 = d6;
    h7 = d7;
    h8 = d8;
    h9 = d9;

    mpos += 16;
    bytes -= 16;
  }
  this.h[0] = h0;
  this.h[1] = h1;
  this.h[2] = h2;
  this.h[3] = h3;
  this.h[4] = h4;
  this.h[5] = h5;
  this.h[6] = h6;
  this.h[7] = h7;
  this.h[8] = h8;
  this.h[9] = h9;
};

poly1305.prototype.finish = function(mac, macpos) {
  var g = new Uint16Array(10);
  var c, mask, f, i;

  if (this.leftover) {
    i = this.leftover;
    this.buffer[i++] = 1;
    for (; i < 16; i++) this.buffer[i] = 0;
    this.fin = 1;
    this.blocks(this.buffer, 0, 16);
  }

  c = this.h[1] >>> 13;
  this.h[1] &= 0x1fff;
  for (i = 2; i < 10; i++) {
    this.h[i] += c;
    c = this.h[i] >>> 13;
    this.h[i] &= 0x1fff;
  }
  this.h[0] += (c * 5);
  c = this.h[0] >>> 13;
  this.h[0] &= 0x1fff;
  this.h[1] += c;
  c = this.h[1] >>> 13;
  this.h[1] &= 0x1fff;
  this.h[2] += c;

  g[0] = this.h[0] + 5;
  c = g[0] >>> 13;
  g[0] &= 0x1fff;
  for (i = 1; i < 10; i++) {
    g[i] = this.h[i] + c;
    c = g[i] >>> 13;
    g[i] &= 0x1fff;
  }
  g[9] -= (1 << 13);

  mask = (c ^ 1) - 1;
  for (i = 0; i < 10; i++) g[i] &= mask;
  mask = ~mask;
  for (i = 0; i < 10; i++) this.h[i] = (this.h[i] & mask) | g[i];

  this.h[0] = ((this.h[0]       ) | (this.h[1] << 13)                    ) & 0xffff;
  this.h[1] = ((this.h[1] >>>  3) | (this.h[2] << 10)                    ) & 0xffff;
  this.h[2] = ((this.h[2] >>>  6) | (this.h[3] <<  7)                    ) & 0xffff;
  this.h[3] = ((this.h[3] >>>  9) | (this.h[4] <<  4)                    ) & 0xffff;
  this.h[4] = ((this.h[4] >>> 12) | (this.h[5] <<  1) | (this.h[6] << 14)) & 0xffff;
  this.h[5] = ((this.h[6] >>>  2) | (this.h[7] << 11)                    ) & 0xffff;
  this.h[6] = ((this.h[7] >>>  5) | (this.h[8] <<  8)                    ) & 0xffff;
  this.h[7] = ((this.h[8] >>>  8) | (this.h[9] <<  5)                    ) & 0xffff;

  f = this.h[0] + this.pad[0];
  this.h[0] = f & 0xffff;
  for (i = 1; i < 8; i++) {
    f = (((this.h[i] + this.pad[i]) | 0) + (f >>> 16)) | 0;
    this.h[i] = f & 0xffff;
  }

  mac[macpos+ 0] = (this.h[0] >>> 0) & 0xff;
  mac[macpos+ 1] = (this.h[0] >>> 8) & 0xff;
  mac[macpos+ 2] = (this.h[1] >>> 0) & 0xff;
  mac[macpos+ 3] = (this.h[1] >>> 8) & 0xff;
  mac[macpos+ 4] = (this.h[2] >>> 0) & 0xff;
  mac[macpos+ 5] = (this.h[2] >>> 8) & 0xff;
  mac[macpos+ 6] = (this.h[3] >>> 0) & 0xff;
  mac[macpos+ 7] = (this.h[3] >>> 8) & 0xff;
  mac[macpos+ 8] = (this.h[4] >>> 0) & 0xff;
  mac[macpos+ 9] = (this.h[4] >>> 8) & 0xff;
  mac[macpos+10] = (this.h[5] >>> 0) & 0xff;
  mac[macpos+11] = (this.h[5] >>> 8) & 0xff;
  mac[macpos+12] = (this.h[6] >>> 0) & 0xff;
  mac[macpos+13] = (this.h[6] >>> 8) & 0xff;
  mac[macpos+14] = (this.h[7] >>> 0) & 0xff;
  mac[macpos+15] = (this.h[7] >>> 8) & 0xff;
};

poly1305.prototype.update = function(m, mpos, bytes) {
  var i, want;

  if (this.leftover) {
    want = (16 - this.leftover);
    if (want > bytes)
      want = bytes;
    for (i = 0; i < want; i++)
      this.buffer[this.leftover + i] = m[mpos+i];
    bytes -= want;
    mpos += want;
    this.leftover += want;
    if (this.leftover < 16)
      return;
    this.blocks(this.buffer, 0, 16);
    this.leftover = 0;
  }

  if (bytes >= 16) {
    want = bytes - (bytes % 16);
    this.blocks(m, mpos, want);
    mpos += want;
    bytes -= want;
  }

  if (bytes) {
    for (i = 0; i < bytes; i++)
      this.buffer[this.leftover + i] = m[mpos+i];
    this.leftover += bytes;
  }
};

function crypto_onetimeauth(out, outpos, m, mpos, n, k) {
  var s = new poly1305(k);
  s.update(m, mpos, n);
  s.finish(out, outpos);
  return 0;
}

function crypto_onetimeauth_verify(h, hpos, m, mpos, n, k) {
  var x = new Uint8Array(16);
  crypto_onetimeauth(x,0,m,mpos,n,k);
  return crypto_verify_16(h,hpos,x,0);
}

function crypto_secretbox(c,m,d,n,k) {
  var i;
  if (d < 32) return -1;
  crypto_stream_xor(c,0,m,0,d,n,k);
  crypto_onetimeauth(c, 16, c, 32, d - 32, c);
  for (i = 0; i < 16; i++) c[i] = 0;
  return 0;
}

function crypto_secretbox_open(m,c,d,n,k) {
  var i;
  var x = new Uint8Array(32);
  if (d < 32) return -1;
  crypto_stream(x,0,32,n,k);
  if (crypto_onetimeauth_verify(c, 16,c, 32,d - 32,x) !== 0) return -1;
  crypto_stream_xor(m,0,c,0,d,n,k);
  for (i = 0; i < 32; i++) m[i] = 0;
  return 0;
}

function set25519(r, a) {
  var i;
  for (i = 0; i < 16; i++) r[i] = a[i]|0;
}

function car25519(o) {
  var i, v, c = 1;
  for (i = 0; i < 16; i++) {
    v = o[i] + c + 65535;
    c = Math.floor(v / 65536);
    o[i] = v - c * 65536;
  }
  o[0] += c-1 + 37 * (c-1);
}

function sel25519(p, q, b) {
  var t, c = ~(b-1);
  for (var i = 0; i < 16; i++) {
    t = c & (p[i] ^ q[i]);
    p[i] ^= t;
    q[i] ^= t;
  }
}

function pack25519(o, n) {
  var i, j, b;
  var m = gf(), t = gf();
  for (i = 0; i < 16; i++) t[i] = n[i];
  car25519(t);
  car25519(t);
  car25519(t);
  for (j = 0; j < 2; j++) {
    m[0] = t[0] - 0xffed;
    for (i = 1; i < 15; i++) {
      m[i] = t[i] - 0xffff - ((m[i-1]>>16) & 1);
      m[i-1] &= 0xffff;
    }
    m[15] = t[15] - 0x7fff - ((m[14]>>16) & 1);
    b = (m[15]>>16) & 1;
    m[14] &= 0xffff;
    sel25519(t, m, 1-b);
  }
  for (i = 0; i < 16; i++) {
    o[2*i] = t[i] & 0xff;
    o[2*i+1] = t[i]>>8;
  }
}

function neq25519(a, b) {
  var c = new Uint8Array(32), d = new Uint8Array(32);
  pack25519(c, a);
  pack25519(d, b);
  return crypto_verify_32(c, 0, d, 0);
}

function par25519(a) {
  var d = new Uint8Array(32);
  pack25519(d, a);
  return d[0] & 1;
}

function unpack25519(o, n) {
  var i;
  for (i = 0; i < 16; i++) o[i] = n[2*i] + (n[2*i+1] << 8);
  o[15] &= 0x7fff;
}

function A(o, a, b) {
  for (var i = 0; i < 16; i++) o[i] = a[i] + b[i];
}

function Z(o, a, b) {
  for (var i = 0; i < 16; i++) o[i] = a[i] - b[i];
}

function M(o, a, b) {
  var v, c,
     t0 = 0,  t1 = 0,  t2 = 0,  t3 = 0,  t4 = 0,  t5 = 0,  t6 = 0,  t7 = 0,
     t8 = 0,  t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0,
    t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0,
    t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0,
    b0 = b[0],
    b1 = b[1],
    b2 = b[2],
    b3 = b[3],
    b4 = b[4],
    b5 = b[5],
    b6 = b[6],
    b7 = b[7],
    b8 = b[8],
    b9 = b[9],
    b10 = b[10],
    b11 = b[11],
    b12 = b[12],
    b13 = b[13],
    b14 = b[14],
    b15 = b[15];

  v = a[0];
  t0 += v * b0;
  t1 += v * b1;
  t2 += v * b2;
  t3 += v * b3;
  t4 += v * b4;
  t5 += v * b5;
  t6 += v * b6;
  t7 += v * b7;
  t8 += v * b8;
  t9 += v * b9;
  t10 += v * b10;
  t11 += v * b11;
  t12 += v * b12;
  t13 += v * b13;
  t14 += v * b14;
  t15 += v * b15;
  v = a[1];
  t1 += v * b0;
  t2 += v * b1;
  t3 += v * b2;
  t4 += v * b3;
  t5 += v * b4;
  t6 += v * b5;
  t7 += v * b6;
  t8 += v * b7;
  t9 += v * b8;
  t10 += v * b9;
  t11 += v * b10;
  t12 += v * b11;
  t13 += v * b12;
  t14 += v * b13;
  t15 += v * b14;
  t16 += v * b15;
  v = a[2];
  t2 += v * b0;
  t3 += v * b1;
  t4 += v * b2;
  t5 += v * b3;
  t6 += v * b4;
  t7 += v * b5;
  t8 += v * b6;
  t9 += v * b7;
  t10 += v * b8;
  t11 += v * b9;
  t12 += v * b10;
  t13 += v * b11;
  t14 += v * b12;
  t15 += v * b13;
  t16 += v * b14;
  t17 += v * b15;
  v = a[3];
  t3 += v * b0;
  t4 += v * b1;
  t5 += v * b2;
  t6 += v * b3;
  t7 += v * b4;
  t8 += v * b5;
  t9 += v * b6;
  t10 += v * b7;
  t11 += v * b8;
  t12 += v * b9;
  t13 += v * b10;
  t14 += v * b11;
  t15 += v * b12;
  t16 += v * b13;
  t17 += v * b14;
  t18 += v * b15;
  v = a[4];
  t4 += v * b0;
  t5 += v * b1;
  t6 += v * b2;
  t7 += v * b3;
  t8 += v * b4;
  t9 += v * b5;
  t10 += v * b6;
  t11 += v * b7;
  t12 += v * b8;
  t13 += v * b9;
  t14 += v * b10;
  t15 += v * b11;
  t16 += v * b12;
  t17 += v * b13;
  t18 += v * b14;
  t19 += v * b15;
  v = a[5];
  t5 += v * b0;
  t6 += v * b1;
  t7 += v * b2;
  t8 += v * b3;
  t9 += v * b4;
  t10 += v * b5;
  t11 += v * b6;
  t12 += v * b7;
  t13 += v * b8;
  t14 += v * b9;
  t15 += v * b10;
  t16 += v * b11;
  t17 += v * b12;
  t18 += v * b13;
  t19 += v * b14;
  t20 += v * b15;
  v = a[6];
  t6 += v * b0;
  t7 += v * b1;
  t8 += v * b2;
  t9 += v * b3;
  t10 += v * b4;
  t11 += v * b5;
  t12 += v * b6;
  t13 += v * b7;
  t14 += v * b8;
  t15 += v * b9;
  t16 += v * b10;
  t17 += v * b11;
  t18 += v * b12;
  t19 += v * b13;
  t20 += v * b14;
  t21 += v * b15;
  v = a[7];
  t7 += v * b0;
  t8 += v * b1;
  t9 += v * b2;
  t10 += v * b3;
  t11 += v * b4;
  t12 += v * b5;
  t13 += v * b6;
  t14 += v * b7;
  t15 += v * b8;
  t16 += v * b9;
  t17 += v * b10;
  t18 += v * b11;
  t19 += v * b12;
  t20 += v * b13;
  t21 += v * b14;
  t22 += v * b15;
  v = a[8];
  t8 += v * b0;
  t9 += v * b1;
  t10 += v * b2;
  t11 += v * b3;
  t12 += v * b4;
  t13 += v * b5;
  t14 += v * b6;
  t15 += v * b7;
  t16 += v * b8;
  t17 += v * b9;
  t18 += v * b10;
  t19 += v * b11;
  t20 += v * b12;
  t21 += v * b13;
  t22 += v * b14;
  t23 += v * b15;
  v = a[9];
  t9 += v * b0;
  t10 += v * b1;
  t11 += v * b2;
  t12 += v * b3;
  t13 += v * b4;
  t14 += v * b5;
  t15 += v * b6;
  t16 += v * b7;
  t17 += v * b8;
  t18 += v * b9;
  t19 += v * b10;
  t20 += v * b11;
  t21 += v * b12;
  t22 += v * b13;
  t23 += v * b14;
  t24 += v * b15;
  v = a[10];
  t10 += v * b0;
  t11 += v * b1;
  t12 += v * b2;
  t13 += v * b3;
  t14 += v * b4;
  t15 += v * b5;
  t16 += v * b6;
  t17 += v * b7;
  t18 += v * b8;
  t19 += v * b9;
  t20 += v * b10;
  t21 += v * b11;
  t22 += v * b12;
  t23 += v * b13;
  t24 += v * b14;
  t25 += v * b15;
  v = a[11];
  t11 += v * b0;
  t12 += v * b1;
  t13 += v * b2;
  t14 += v * b3;
  t15 += v * b4;
  t16 += v * b5;
  t17 += v * b6;
  t18 += v * b7;
  t19 += v * b8;
  t20 += v * b9;
  t21 += v * b10;
  t22 += v * b11;
  t23 += v * b12;
  t24 += v * b13;
  t25 += v * b14;
  t26 += v * b15;
  v = a[12];
  t12 += v * b0;
  t13 += v * b1;
  t14 += v * b2;
  t15 += v * b3;
  t16 += v * b4;
  t17 += v * b5;
  t18 += v * b6;
  t19 += v * b7;
  t20 += v * b8;
  t21 += v * b9;
  t22 += v * b10;
  t23 += v * b11;
  t24 += v * b12;
  t25 += v * b13;
  t26 += v * b14;
  t27 += v * b15;
  v = a[13];
  t13 += v * b0;
  t14 += v * b1;
  t15 += v * b2;
  t16 += v * b3;
  t17 += v * b4;
  t18 += v * b5;
  t19 += v * b6;
  t20 += v * b7;
  t21 += v * b8;
  t22 += v * b9;
  t23 += v * b10;
  t24 += v * b11;
  t25 += v * b12;
  t26 += v * b13;
  t27 += v * b14;
  t28 += v * b15;
  v = a[14];
  t14 += v * b0;
  t15 += v * b1;
  t16 += v * b2;
  t17 += v * b3;
  t18 += v * b4;
  t19 += v * b5;
  t20 += v * b6;
  t21 += v * b7;
  t22 += v * b8;
  t23 += v * b9;
  t24 += v * b10;
  t25 += v * b11;
  t26 += v * b12;
  t27 += v * b13;
  t28 += v * b14;
  t29 += v * b15;
  v = a[15];
  t15 += v * b0;
  t16 += v * b1;
  t17 += v * b2;
  t18 += v * b3;
  t19 += v * b4;
  t20 += v * b5;
  t21 += v * b6;
  t22 += v * b7;
  t23 += v * b8;
  t24 += v * b9;
  t25 += v * b10;
  t26 += v * b11;
  t27 += v * b12;
  t28 += v * b13;
  t29 += v * b14;
  t30 += v * b15;

  t0  += 38 * t16;
  t1  += 38 * t17;
  t2  += 38 * t18;
  t3  += 38 * t19;
  t4  += 38 * t20;
  t5  += 38 * t21;
  t6  += 38 * t22;
  t7  += 38 * t23;
  t8  += 38 * t24;
  t9  += 38 * t25;
  t10 += 38 * t26;
  t11 += 38 * t27;
  t12 += 38 * t28;
  t13 += 38 * t29;
  t14 += 38 * t30;
  // t15 left as is

  // first car
  c = 1;
  v =  t0 + c + 65535; c = Math.floor(v / 65536);  t0 = v - c * 65536;
  v =  t1 + c + 65535; c = Math.floor(v / 65536);  t1 = v - c * 65536;
  v =  t2 + c + 65535; c = Math.floor(v / 65536);  t2 = v - c * 65536;
  v =  t3 + c + 65535; c = Math.floor(v / 65536);  t3 = v - c * 65536;
  v =  t4 + c + 65535; c = Math.floor(v / 65536);  t4 = v - c * 65536;
  v =  t5 + c + 65535; c = Math.floor(v / 65536);  t5 = v - c * 65536;
  v =  t6 + c + 65535; c = Math.floor(v / 65536);  t6 = v - c * 65536;
  v =  t7 + c + 65535; c = Math.floor(v / 65536);  t7 = v - c * 65536;
  v =  t8 + c + 65535; c = Math.floor(v / 65536);  t8 = v - c * 65536;
  v =  t9 + c + 65535; c = Math.floor(v / 65536);  t9 = v - c * 65536;
  v = t10 + c + 65535; c = Math.floor(v / 65536); t10 = v - c * 65536;
  v = t11 + c + 65535; c = Math.floor(v / 65536); t11 = v - c * 65536;
  v = t12 + c + 65535; c = Math.floor(v / 65536); t12 = v - c * 65536;
  v = t13 + c + 65535; c = Math.floor(v / 65536); t13 = v - c * 65536;
  v = t14 + c + 65535; c = Math.floor(v / 65536); t14 = v - c * 65536;
  v = t15 + c + 65535; c = Math.floor(v / 65536); t15 = v - c * 65536;
  t0 += c-1 + 37 * (c-1);

  // second car
  c = 1;
  v =  t0 + c + 65535; c = Math.floor(v / 65536);  t0 = v - c * 65536;
  v =  t1 + c + 65535; c = Math.floor(v / 65536);  t1 = v - c * 65536;
  v =  t2 + c + 65535; c = Math.floor(v / 65536);  t2 = v - c * 65536;
  v =  t3 + c + 65535; c = Math.floor(v / 65536);  t3 = v - c * 65536;
  v =  t4 + c + 65535; c = Math.floor(v / 65536);  t4 = v - c * 65536;
  v =  t5 + c + 65535; c = Math.floor(v / 65536);  t5 = v - c * 65536;
  v =  t6 + c + 65535; c = Math.floor(v / 65536);  t6 = v - c * 65536;
  v =  t7 + c + 65535; c = Math.floor(v / 65536);  t7 = v - c * 65536;
  v =  t8 + c + 65535; c = Math.floor(v / 65536);  t8 = v - c * 65536;
  v =  t9 + c + 65535; c = Math.floor(v / 65536);  t9 = v - c * 65536;
  v = t10 + c + 65535; c = Math.floor(v / 65536); t10 = v - c * 65536;
  v = t11 + c + 65535; c = Math.floor(v / 65536); t11 = v - c * 65536;
  v = t12 + c + 65535; c = Math.floor(v / 65536); t12 = v - c * 65536;
  v = t13 + c + 65535; c = Math.floor(v / 65536); t13 = v - c * 65536;
  v = t14 + c + 65535; c = Math.floor(v / 65536); t14 = v - c * 65536;
  v = t15 + c + 65535; c = Math.floor(v / 65536); t15 = v - c * 65536;
  t0 += c-1 + 37 * (c-1);

  o[ 0] = t0;
  o[ 1] = t1;
  o[ 2] = t2;
  o[ 3] = t3;
  o[ 4] = t4;
  o[ 5] = t5;
  o[ 6] = t6;
  o[ 7] = t7;
  o[ 8] = t8;
  o[ 9] = t9;
  o[10] = t10;
  o[11] = t11;
  o[12] = t12;
  o[13] = t13;
  o[14] = t14;
  o[15] = t15;
}

function S(o, a) {
  M(o, a, a);
}

function inv25519(o, i) {
  var c = gf();
  var a;
  for (a = 0; a < 16; a++) c[a] = i[a];
  for (a = 253; a >= 0; a--) {
    S(c, c);
    if(a !== 2 && a !== 4) M(c, c, i);
  }
  for (a = 0; a < 16; a++) o[a] = c[a];
}

function pow2523(o, i) {
  var c = gf();
  var a;
  for (a = 0; a < 16; a++) c[a] = i[a];
  for (a = 250; a >= 0; a--) {
      S(c, c);
      if(a !== 1) M(c, c, i);
  }
  for (a = 0; a < 16; a++) o[a] = c[a];
}

function crypto_scalarmult(q, n, p) {
  var z = new Uint8Array(32);
  var x = new Float64Array(80), r, i;
  var a = gf(), b = gf(), c = gf(),
      d = gf(), e = gf(), f = gf();
  for (i = 0; i < 31; i++) z[i] = n[i];
  z[31]=(n[31]&127)|64;
  z[0]&=248;
  unpack25519(x,p);
  for (i = 0; i < 16; i++) {
    b[i]=x[i];
    d[i]=a[i]=c[i]=0;
  }
  a[0]=d[0]=1;
  for (i=254; i>=0; --i) {
    r=(z[i>>>3]>>>(i&7))&1;
    sel25519(a,b,r);
    sel25519(c,d,r);
    A(e,a,c);
    Z(a,a,c);
    A(c,b,d);
    Z(b,b,d);
    S(d,e);
    S(f,a);
    M(a,c,a);
    M(c,b,e);
    A(e,a,c);
    Z(a,a,c);
    S(b,a);
    Z(c,d,f);
    M(a,c,_121665);
    A(a,a,d);
    M(c,c,a);
    M(a,d,f);
    M(d,b,x);
    S(b,e);
    sel25519(a,b,r);
    sel25519(c,d,r);
  }
  for (i = 0; i < 16; i++) {
    x[i+16]=a[i];
    x[i+32]=c[i];
    x[i+48]=b[i];
    x[i+64]=d[i];
  }
  var x32 = x.subarray(32);
  var x16 = x.subarray(16);
  inv25519(x32,x32);
  M(x16,x16,x32);
  pack25519(q,x16);
  return 0;
}

function crypto_scalarmult_base(q, n) {
  return crypto_scalarmult(q, n, _9);
}

function crypto_box_keypair(y, x) {
  randombytes(x, 32);
  return crypto_scalarmult_base(y, x);
}

function crypto_box_beforenm(k, y, x) {
  var s = new Uint8Array(32);
  crypto_scalarmult(s, x, y);
  return crypto_core_hsalsa20(k, _0, s, sigma);
}

var crypto_box_afternm = crypto_secretbox;
var crypto_box_open_afternm = crypto_secretbox_open;

function crypto_box(c, m, d, n, y, x) {
  var k = new Uint8Array(32);
  crypto_box_beforenm(k, y, x);
  return crypto_box_afternm(c, m, d, n, k);
}

function crypto_box_open(m, c, d, n, y, x) {
  var k = new Uint8Array(32);
  crypto_box_beforenm(k, y, x);
  return crypto_box_open_afternm(m, c, d, n, k);
}

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function crypto_hashblocks_hl(hh, hl, m, n) {
  var wh = new Int32Array(16), wl = new Int32Array(16),
      bh0, bh1, bh2, bh3, bh4, bh5, bh6, bh7,
      bl0, bl1, bl2, bl3, bl4, bl5, bl6, bl7,
      th, tl, i, j, h, l, a, b, c, d;

  var ah0 = hh[0],
      ah1 = hh[1],
      ah2 = hh[2],
      ah3 = hh[3],
      ah4 = hh[4],
      ah5 = hh[5],
      ah6 = hh[6],
      ah7 = hh[7],

      al0 = hl[0],
      al1 = hl[1],
      al2 = hl[2],
      al3 = hl[3],
      al4 = hl[4],
      al5 = hl[5],
      al6 = hl[6],
      al7 = hl[7];

  var pos = 0;
  while (n >= 128) {
    for (i = 0; i < 16; i++) {
      j = 8 * i + pos;
      wh[i] = (m[j+0] << 24) | (m[j+1] << 16) | (m[j+2] << 8) | m[j+3];
      wl[i] = (m[j+4] << 24) | (m[j+5] << 16) | (m[j+6] << 8) | m[j+7];
    }
    for (i = 0; i < 80; i++) {
      bh0 = ah0;
      bh1 = ah1;
      bh2 = ah2;
      bh3 = ah3;
      bh4 = ah4;
      bh5 = ah5;
      bh6 = ah6;
      bh7 = ah7;

      bl0 = al0;
      bl1 = al1;
      bl2 = al2;
      bl3 = al3;
      bl4 = al4;
      bl5 = al5;
      bl6 = al6;
      bl7 = al7;

      // add
      h = ah7;
      l = al7;

      a = l & 0xffff; b = l >>> 16;
      c = h & 0xffff; d = h >>> 16;

      // Sigma1
      h = ((ah4 >>> 14) | (al4 << (32-14))) ^ ((ah4 >>> 18) | (al4 << (32-18))) ^ ((al4 >>> (41-32)) | (ah4 << (32-(41-32))));
      l = ((al4 >>> 14) | (ah4 << (32-14))) ^ ((al4 >>> 18) | (ah4 << (32-18))) ^ ((ah4 >>> (41-32)) | (al4 << (32-(41-32))));

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      // Ch
      h = (ah4 & ah5) ^ (~ah4 & ah6);
      l = (al4 & al5) ^ (~al4 & al6);

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      // K
      h = K[i*2];
      l = K[i*2+1];

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      // w
      h = wh[i%16];
      l = wl[i%16];

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      b += a >>> 16;
      c += b >>> 16;
      d += c >>> 16;

      th = c & 0xffff | d << 16;
      tl = a & 0xffff | b << 16;

      // add
      h = th;
      l = tl;

      a = l & 0xffff; b = l >>> 16;
      c = h & 0xffff; d = h >>> 16;

      // Sigma0
      h = ((ah0 >>> 28) | (al0 << (32-28))) ^ ((al0 >>> (34-32)) | (ah0 << (32-(34-32)))) ^ ((al0 >>> (39-32)) | (ah0 << (32-(39-32))));
      l = ((al0 >>> 28) | (ah0 << (32-28))) ^ ((ah0 >>> (34-32)) | (al0 << (32-(34-32)))) ^ ((ah0 >>> (39-32)) | (al0 << (32-(39-32))));

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      // Maj
      h = (ah0 & ah1) ^ (ah0 & ah2) ^ (ah1 & ah2);
      l = (al0 & al1) ^ (al0 & al2) ^ (al1 & al2);

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      b += a >>> 16;
      c += b >>> 16;
      d += c >>> 16;

      bh7 = (c & 0xffff) | (d << 16);
      bl7 = (a & 0xffff) | (b << 16);

      // add
      h = bh3;
      l = bl3;

      a = l & 0xffff; b = l >>> 16;
      c = h & 0xffff; d = h >>> 16;

      h = th;
      l = tl;

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      b += a >>> 16;
      c += b >>> 16;
      d += c >>> 16;

      bh3 = (c & 0xffff) | (d << 16);
      bl3 = (a & 0xffff) | (b << 16);

      ah1 = bh0;
      ah2 = bh1;
      ah3 = bh2;
      ah4 = bh3;
      ah5 = bh4;
      ah6 = bh5;
      ah7 = bh6;
      ah0 = bh7;

      al1 = bl0;
      al2 = bl1;
      al3 = bl2;
      al4 = bl3;
      al5 = bl4;
      al6 = bl5;
      al7 = bl6;
      al0 = bl7;

      if (i%16 === 15) {
        for (j = 0; j < 16; j++) {
          // add
          h = wh[j];
          l = wl[j];

          a = l & 0xffff; b = l >>> 16;
          c = h & 0xffff; d = h >>> 16;

          h = wh[(j+9)%16];
          l = wl[(j+9)%16];

          a += l & 0xffff; b += l >>> 16;
          c += h & 0xffff; d += h >>> 16;

          // sigma0
          th = wh[(j+1)%16];
          tl = wl[(j+1)%16];
          h = ((th >>> 1) | (tl << (32-1))) ^ ((th >>> 8) | (tl << (32-8))) ^ (th >>> 7);
          l = ((tl >>> 1) | (th << (32-1))) ^ ((tl >>> 8) | (th << (32-8))) ^ ((tl >>> 7) | (th << (32-7)));

          a += l & 0xffff; b += l >>> 16;
          c += h & 0xffff; d += h >>> 16;

          // sigma1
          th = wh[(j+14)%16];
          tl = wl[(j+14)%16];
          h = ((th >>> 19) | (tl << (32-19))) ^ ((tl >>> (61-32)) | (th << (32-(61-32)))) ^ (th >>> 6);
          l = ((tl >>> 19) | (th << (32-19))) ^ ((th >>> (61-32)) | (tl << (32-(61-32)))) ^ ((tl >>> 6) | (th << (32-6)));

          a += l & 0xffff; b += l >>> 16;
          c += h & 0xffff; d += h >>> 16;

          b += a >>> 16;
          c += b >>> 16;
          d += c >>> 16;

          wh[j] = (c & 0xffff) | (d << 16);
          wl[j] = (a & 0xffff) | (b << 16);
        }
      }
    }

    // add
    h = ah0;
    l = al0;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[0];
    l = hl[0];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[0] = ah0 = (c & 0xffff) | (d << 16);
    hl[0] = al0 = (a & 0xffff) | (b << 16);

    h = ah1;
    l = al1;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[1];
    l = hl[1];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[1] = ah1 = (c & 0xffff) | (d << 16);
    hl[1] = al1 = (a & 0xffff) | (b << 16);

    h = ah2;
    l = al2;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[2];
    l = hl[2];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[2] = ah2 = (c & 0xffff) | (d << 16);
    hl[2] = al2 = (a & 0xffff) | (b << 16);

    h = ah3;
    l = al3;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[3];
    l = hl[3];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[3] = ah3 = (c & 0xffff) | (d << 16);
    hl[3] = al3 = (a & 0xffff) | (b << 16);

    h = ah4;
    l = al4;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[4];
    l = hl[4];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[4] = ah4 = (c & 0xffff) | (d << 16);
    hl[4] = al4 = (a & 0xffff) | (b << 16);

    h = ah5;
    l = al5;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[5];
    l = hl[5];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[5] = ah5 = (c & 0xffff) | (d << 16);
    hl[5] = al5 = (a & 0xffff) | (b << 16);

    h = ah6;
    l = al6;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[6];
    l = hl[6];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[6] = ah6 = (c & 0xffff) | (d << 16);
    hl[6] = al6 = (a & 0xffff) | (b << 16);

    h = ah7;
    l = al7;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[7];
    l = hl[7];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[7] = ah7 = (c & 0xffff) | (d << 16);
    hl[7] = al7 = (a & 0xffff) | (b << 16);

    pos += 128;
    n -= 128;
  }

  return n;
}

function crypto_hash(out, m, n) {
  var hh = new Int32Array(8),
      hl = new Int32Array(8),
      x = new Uint8Array(256),
      i, b = n;

  hh[0] = 0x6a09e667;
  hh[1] = 0xbb67ae85;
  hh[2] = 0x3c6ef372;
  hh[3] = 0xa54ff53a;
  hh[4] = 0x510e527f;
  hh[5] = 0x9b05688c;
  hh[6] = 0x1f83d9ab;
  hh[7] = 0x5be0cd19;

  hl[0] = 0xf3bcc908;
  hl[1] = 0x84caa73b;
  hl[2] = 0xfe94f82b;
  hl[3] = 0x5f1d36f1;
  hl[4] = 0xade682d1;
  hl[5] = 0x2b3e6c1f;
  hl[6] = 0xfb41bd6b;
  hl[7] = 0x137e2179;

  crypto_hashblocks_hl(hh, hl, m, n);
  n %= 128;

  for (i = 0; i < n; i++) x[i] = m[b-n+i];
  x[n] = 128;

  n = 256-128*(n<112?1:0);
  x[n-9] = 0;
  ts64(x, n-8,  (b / 0x20000000) | 0, b << 3);
  crypto_hashblocks_hl(hh, hl, x, n);

  for (i = 0; i < 8; i++) ts64(out, 8*i, hh[i], hl[i]);

  return 0;
}

function add(p, q) {
  var a = gf(), b = gf(), c = gf(),
      d = gf(), e = gf(), f = gf(),
      g = gf(), h = gf(), t = gf();

  Z(a, p[1], p[0]);
  Z(t, q[1], q[0]);
  M(a, a, t);
  A(b, p[0], p[1]);
  A(t, q[0], q[1]);
  M(b, b, t);
  M(c, p[3], q[3]);
  M(c, c, D2);
  M(d, p[2], q[2]);
  A(d, d, d);
  Z(e, b, a);
  Z(f, d, c);
  A(g, d, c);
  A(h, b, a);

  M(p[0], e, f);
  M(p[1], h, g);
  M(p[2], g, f);
  M(p[3], e, h);
}

function cswap(p, q, b) {
  var i;
  for (i = 0; i < 4; i++) {
    sel25519(p[i], q[i], b);
  }
}

function pack(r, p) {
  var tx = gf(), ty = gf(), zi = gf();
  inv25519(zi, p[2]);
  M(tx, p[0], zi);
  M(ty, p[1], zi);
  pack25519(r, ty);
  r[31] ^= par25519(tx) << 7;
}

function scalarmult(p, q, s) {
  var b, i;
  set25519(p[0], gf0);
  set25519(p[1], gf1);
  set25519(p[2], gf1);
  set25519(p[3], gf0);
  for (i = 255; i >= 0; --i) {
    b = (s[(i/8)|0] >> (i&7)) & 1;
    cswap(p, q, b);
    add(q, p);
    add(p, p);
    cswap(p, q, b);
  }
}

function scalarbase(p, s) {
  var q = [gf(), gf(), gf(), gf()];
  set25519(q[0], X);
  set25519(q[1], Y);
  set25519(q[2], gf1);
  M(q[3], X, Y);
  scalarmult(p, q, s);
}

function crypto_sign_keypair(pk, sk, seeded) {
  var d = new Uint8Array(64);
  var p = [gf(), gf(), gf(), gf()];
  var i;

  if (!seeded) randombytes(sk, 32);
  crypto_hash(d, sk, 32);
  d[0] &= 248;
  d[31] &= 127;
  d[31] |= 64;

  scalarbase(p, d);
  pack(pk, p);

  for (i = 0; i < 32; i++) sk[i+32] = pk[i];
  return 0;
}

var L = new Float64Array([0xed, 0xd3, 0xf5, 0x5c, 0x1a, 0x63, 0x12, 0x58, 0xd6, 0x9c, 0xf7, 0xa2, 0xde, 0xf9, 0xde, 0x14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x10]);

function modL(r, x) {
  var carry, i, j, k;
  for (i = 63; i >= 32; --i) {
    carry = 0;
    for (j = i - 32, k = i - 12; j < k; ++j) {
      x[j] += carry - 16 * x[i] * L[j - (i - 32)];
      carry = Math.floor((x[j] + 128) / 256);
      x[j] -= carry * 256;
    }
    x[j] += carry;
    x[i] = 0;
  }
  carry = 0;
  for (j = 0; j < 32; j++) {
    x[j] += carry - (x[31] >> 4) * L[j];
    carry = x[j] >> 8;
    x[j] &= 255;
  }
  for (j = 0; j < 32; j++) x[j] -= carry * L[j];
  for (i = 0; i < 32; i++) {
    x[i+1] += x[i] >> 8;
    r[i] = x[i] & 255;
  }
}

function reduce(r) {
  var x = new Float64Array(64), i;
  for (i = 0; i < 64; i++) x[i] = r[i];
  for (i = 0; i < 64; i++) r[i] = 0;
  modL(r, x);
}

// Note: difference from C - smlen returned, not passed as argument.
function crypto_sign(sm, m, n, sk) {
  var d = new Uint8Array(64), h = new Uint8Array(64), r = new Uint8Array(64);
  var i, j, x = new Float64Array(64);
  var p = [gf(), gf(), gf(), gf()];

  crypto_hash(d, sk, 32);
  d[0] &= 248;
  d[31] &= 127;
  d[31] |= 64;

  var smlen = n + 64;
  for (i = 0; i < n; i++) sm[64 + i] = m[i];
  for (i = 0; i < 32; i++) sm[32 + i] = d[32 + i];

  crypto_hash(r, sm.subarray(32), n+32);
  reduce(r);
  scalarbase(p, r);
  pack(sm, p);

  for (i = 32; i < 64; i++) sm[i] = sk[i];
  crypto_hash(h, sm, n + 64);
  reduce(h);

  for (i = 0; i < 64; i++) x[i] = 0;
  for (i = 0; i < 32; i++) x[i] = r[i];
  for (i = 0; i < 32; i++) {
    for (j = 0; j < 32; j++) {
      x[i+j] += h[i] * d[j];
    }
  }

  modL(sm.subarray(32), x);
  return smlen;
}

function unpackneg(r, p) {
  var t = gf(), chk = gf(), num = gf(),
      den = gf(), den2 = gf(), den4 = gf(),
      den6 = gf();

  set25519(r[2], gf1);
  unpack25519(r[1], p);
  S(num, r[1]);
  M(den, num, D);
  Z(num, num, r[2]);
  A(den, r[2], den);

  S(den2, den);
  S(den4, den2);
  M(den6, den4, den2);
  M(t, den6, num);
  M(t, t, den);

  pow2523(t, t);
  M(t, t, num);
  M(t, t, den);
  M(t, t, den);
  M(r[0], t, den);

  S(chk, r[0]);
  M(chk, chk, den);
  if (neq25519(chk, num)) M(r[0], r[0], I);

  S(chk, r[0]);
  M(chk, chk, den);
  if (neq25519(chk, num)) return -1;

  if (par25519(r[0]) === (p[31]>>7)) Z(r[0], gf0, r[0]);

  M(r[3], r[0], r[1]);
  return 0;
}

function crypto_sign_open(m, sm, n, pk) {
  var i;
  var t = new Uint8Array(32), h = new Uint8Array(64);
  var p = [gf(), gf(), gf(), gf()],
      q = [gf(), gf(), gf(), gf()];

  if (n < 64) return -1;

  if (unpackneg(q, pk)) return -1;

  for (i = 0; i < n; i++) m[i] = sm[i];
  for (i = 0; i < 32; i++) m[i+32] = pk[i];
  crypto_hash(h, m, n);
  reduce(h);
  scalarmult(p, q, h);

  scalarbase(q, sm.subarray(32));
  add(p, q);
  pack(t, p);

  n -= 64;
  if (crypto_verify_32(sm, 0, t, 0)) {
    for (i = 0; i < n; i++) m[i] = 0;
    return -1;
  }

  for (i = 0; i < n; i++) m[i] = sm[i + 64];
  return n;
}

var crypto_secretbox_KEYBYTES = 32,
    crypto_secretbox_NONCEBYTES = 24,
    crypto_secretbox_ZEROBYTES = 32,
    crypto_secretbox_BOXZEROBYTES = 16,
    crypto_scalarmult_BYTES = 32,
    crypto_scalarmult_SCALARBYTES = 32,
    crypto_box_PUBLICKEYBYTES = 32,
    crypto_box_SECRETKEYBYTES = 32,
    crypto_box_BEFORENMBYTES = 32,
    crypto_box_NONCEBYTES = crypto_secretbox_NONCEBYTES,
    crypto_box_ZEROBYTES = crypto_secretbox_ZEROBYTES,
    crypto_box_BOXZEROBYTES = crypto_secretbox_BOXZEROBYTES,
    crypto_sign_BYTES = 64,
    crypto_sign_PUBLICKEYBYTES = 32,
    crypto_sign_SECRETKEYBYTES = 64,
    crypto_sign_SEEDBYTES = 32,
    crypto_hash_BYTES = 64;

nacl.lowlevel = {
  crypto_core_hsalsa20: crypto_core_hsalsa20,
  crypto_stream_xor: crypto_stream_xor,
  crypto_stream: crypto_stream,
  crypto_stream_salsa20_xor: crypto_stream_salsa20_xor,
  crypto_stream_salsa20: crypto_stream_salsa20,
  crypto_onetimeauth: crypto_onetimeauth,
  crypto_onetimeauth_verify: crypto_onetimeauth_verify,
  crypto_verify_16: crypto_verify_16,
  crypto_verify_32: crypto_verify_32,
  crypto_secretbox: crypto_secretbox,
  crypto_secretbox_open: crypto_secretbox_open,
  crypto_scalarmult: crypto_scalarmult,
  crypto_scalarmult_base: crypto_scalarmult_base,
  crypto_box_beforenm: crypto_box_beforenm,
  crypto_box_afternm: crypto_box_afternm,
  crypto_box: crypto_box,
  crypto_box_open: crypto_box_open,
  crypto_box_keypair: crypto_box_keypair,
  crypto_hash: crypto_hash,
  crypto_sign: crypto_sign,
  crypto_sign_keypair: crypto_sign_keypair,
  crypto_sign_open: crypto_sign_open,

  crypto_secretbox_KEYBYTES: crypto_secretbox_KEYBYTES,
  crypto_secretbox_NONCEBYTES: crypto_secretbox_NONCEBYTES,
  crypto_secretbox_ZEROBYTES: crypto_secretbox_ZEROBYTES,
  crypto_secretbox_BOXZEROBYTES: crypto_secretbox_BOXZEROBYTES,
  crypto_scalarmult_BYTES: crypto_scalarmult_BYTES,
  crypto_scalarmult_SCALARBYTES: crypto_scalarmult_SCALARBYTES,
  crypto_box_PUBLICKEYBYTES: crypto_box_PUBLICKEYBYTES,
  crypto_box_SECRETKEYBYTES: crypto_box_SECRETKEYBYTES,
  crypto_box_BEFORENMBYTES: crypto_box_BEFORENMBYTES,
  crypto_box_NONCEBYTES: crypto_box_NONCEBYTES,
  crypto_box_ZEROBYTES: crypto_box_ZEROBYTES,
  crypto_box_BOXZEROBYTES: crypto_box_BOXZEROBYTES,
  crypto_sign_BYTES: crypto_sign_BYTES,
  crypto_sign_PUBLICKEYBYTES: crypto_sign_PUBLICKEYBYTES,
  crypto_sign_SECRETKEYBYTES: crypto_sign_SECRETKEYBYTES,
  crypto_sign_SEEDBYTES: crypto_sign_SEEDBYTES,
  crypto_hash_BYTES: crypto_hash_BYTES,

  gf: gf,
  D: D,
  L: L,
  pack25519: pack25519,
  unpack25519: unpack25519,
  M: M,
  A: A,
  S: S,
  Z: Z,
  pow2523: pow2523,
  add: add,
  set25519: set25519,
  modL: modL,
  scalarmult: scalarmult,
  scalarbase: scalarbase,
};

/* High-level API */

function checkLengths(k, n) {
  if (k.length !== crypto_secretbox_KEYBYTES) throw new Error('bad key size');
  if (n.length !== crypto_secretbox_NONCEBYTES) throw new Error('bad nonce size');
}

function checkBoxLengths(pk, sk) {
  if (pk.length !== crypto_box_PUBLICKEYBYTES) throw new Error('bad public key size');
  if (sk.length !== crypto_box_SECRETKEYBYTES) throw new Error('bad secret key size');
}

function checkArrayTypes() {
  for (var i = 0; i < arguments.length; i++) {
    if (!(arguments[i] instanceof Uint8Array))
      throw new TypeError('unexpected type, use Uint8Array');
  }
}

function cleanup(arr) {
  for (var i = 0; i < arr.length; i++) arr[i] = 0;
}

nacl.randomBytes = function(n) {
  var b = new Uint8Array(n);
  randombytes(b, n);
  return b;
};

nacl.secretbox = function(msg, nonce, key) {
  checkArrayTypes(msg, nonce, key);
  checkLengths(key, nonce);
  var m = new Uint8Array(crypto_secretbox_ZEROBYTES + msg.length);
  var c = new Uint8Array(m.length);
  for (var i = 0; i < msg.length; i++) m[i+crypto_secretbox_ZEROBYTES] = msg[i];
  crypto_secretbox(c, m, m.length, nonce, key);
  return c.subarray(crypto_secretbox_BOXZEROBYTES);
};

nacl.secretbox.open = function(box, nonce, key) {
  checkArrayTypes(box, nonce, key);
  checkLengths(key, nonce);
  var c = new Uint8Array(crypto_secretbox_BOXZEROBYTES + box.length);
  var m = new Uint8Array(c.length);
  for (var i = 0; i < box.length; i++) c[i+crypto_secretbox_BOXZEROBYTES] = box[i];
  if (c.length < 32) return null;
  if (crypto_secretbox_open(m, c, c.length, nonce, key) !== 0) return null;
  return m.subarray(crypto_secretbox_ZEROBYTES);
};

nacl.secretbox.keyLength = crypto_secretbox_KEYBYTES;
nacl.secretbox.nonceLength = crypto_secretbox_NONCEBYTES;
nacl.secretbox.overheadLength = crypto_secretbox_BOXZEROBYTES;

nacl.scalarMult = function(n, p) {
  checkArrayTypes(n, p);
  if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error('bad n size');
  if (p.length !== crypto_scalarmult_BYTES) throw new Error('bad p size');
  var q = new Uint8Array(crypto_scalarmult_BYTES);
  crypto_scalarmult(q, n, p);
  return q;
};

nacl.scalarMult.base = function(n) {
  checkArrayTypes(n);
  if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error('bad n size');
  var q = new Uint8Array(crypto_scalarmult_BYTES);
  crypto_scalarmult_base(q, n);
  return q;
};

nacl.scalarMult.scalarLength = crypto_scalarmult_SCALARBYTES;
nacl.scalarMult.groupElementLength = crypto_scalarmult_BYTES;

nacl.box = function(msg, nonce, publicKey, secretKey) {
  var k = nacl.box.before(publicKey, secretKey);
  return nacl.secretbox(msg, nonce, k);
};

nacl.box.before = function(publicKey, secretKey) {
  checkArrayTypes(publicKey, secretKey);
  checkBoxLengths(publicKey, secretKey);
  var k = new Uint8Array(crypto_box_BEFORENMBYTES);
  crypto_box_beforenm(k, publicKey, secretKey);
  return k;
};

nacl.box.after = nacl.secretbox;

nacl.box.open = function(msg, nonce, publicKey, secretKey) {
  var k = nacl.box.before(publicKey, secretKey);
  return nacl.secretbox.open(msg, nonce, k);
};

nacl.box.open.after = nacl.secretbox.open;

nacl.box.keyPair = function() {
  var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
  var sk = new Uint8Array(crypto_box_SECRETKEYBYTES);
  crypto_box_keypair(pk, sk);
  return {publicKey: pk, secretKey: sk};
};

nacl.box.keyPair.fromSecretKey = function(secretKey) {
  checkArrayTypes(secretKey);
  if (secretKey.length !== crypto_box_SECRETKEYBYTES)
    throw new Error('bad secret key size');
  var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
  crypto_scalarmult_base(pk, secretKey);
  return {publicKey: pk, secretKey: new Uint8Array(secretKey)};
};

nacl.box.publicKeyLength = crypto_box_PUBLICKEYBYTES;
nacl.box.secretKeyLength = crypto_box_SECRETKEYBYTES;
nacl.box.sharedKeyLength = crypto_box_BEFORENMBYTES;
nacl.box.nonceLength = crypto_box_NONCEBYTES;
nacl.box.overheadLength = nacl.secretbox.overheadLength;

nacl.sign = function(msg, secretKey) {
  checkArrayTypes(msg, secretKey);
  if (secretKey.length !== crypto_sign_SECRETKEYBYTES)
    throw new Error('bad secret key size');
  var signedMsg = new Uint8Array(crypto_sign_BYTES+msg.length);
  crypto_sign(signedMsg, msg, msg.length, secretKey);
  return signedMsg;
};

nacl.sign.open = function(signedMsg, publicKey) {
  checkArrayTypes(signedMsg, publicKey);
  if (publicKey.length !== crypto_sign_PUBLICKEYBYTES)
    throw new Error('bad public key size');
  var tmp = new Uint8Array(signedMsg.length);
  var mlen = crypto_sign_open(tmp, signedMsg, signedMsg.length, publicKey);
  if (mlen < 0) return null;
  var m = new Uint8Array(mlen);
  for (var i = 0; i < m.length; i++) m[i] = tmp[i];
  return m;
};

nacl.sign.detached = function(msg, secretKey) {
  var signedMsg = nacl.sign(msg, secretKey);
  var sig = new Uint8Array(crypto_sign_BYTES);
  for (var i = 0; i < sig.length; i++) sig[i] = signedMsg[i];
  return sig;
};

nacl.sign.detached.verify = function(msg, sig, publicKey) {
  checkArrayTypes(msg, sig, publicKey);
  if (sig.length !== crypto_sign_BYTES)
    throw new Error('bad signature size');
  if (publicKey.length !== crypto_sign_PUBLICKEYBYTES)
    throw new Error('bad public key size');
  var sm = new Uint8Array(crypto_sign_BYTES + msg.length);
  var m = new Uint8Array(crypto_sign_BYTES + msg.length);
  var i;
  for (i = 0; i < crypto_sign_BYTES; i++) sm[i] = sig[i];
  for (i = 0; i < msg.length; i++) sm[i+crypto_sign_BYTES] = msg[i];
  return (crypto_sign_open(m, sm, sm.length, publicKey) >= 0);
};

nacl.sign.keyPair = function() {
  var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
  var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
  crypto_sign_keypair(pk, sk);
  return {publicKey: pk, secretKey: sk};
};

nacl.sign.keyPair.fromSecretKey = function(secretKey) {
  checkArrayTypes(secretKey);
  if (secretKey.length !== crypto_sign_SECRETKEYBYTES)
    throw new Error('bad secret key size');
  var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
  for (var i = 0; i < pk.length; i++) pk[i] = secretKey[32+i];
  return {publicKey: pk, secretKey: new Uint8Array(secretKey)};
};

nacl.sign.keyPair.fromSeed = function(seed) {
  checkArrayTypes(seed);
  if (seed.length !== crypto_sign_SEEDBYTES)
    throw new Error('bad seed size');
  var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
  var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
  for (var i = 0; i < 32; i++) sk[i] = seed[i];
  crypto_sign_keypair(pk, sk, true);
  return {publicKey: pk, secretKey: sk};
};

nacl.sign.publicKeyLength = crypto_sign_PUBLICKEYBYTES;
nacl.sign.secretKeyLength = crypto_sign_SECRETKEYBYTES;
nacl.sign.seedLength = crypto_sign_SEEDBYTES;
nacl.sign.signatureLength = crypto_sign_BYTES;

nacl.hash = function(msg) {
  checkArrayTypes(msg);
  var h = new Uint8Array(crypto_hash_BYTES);
  crypto_hash(h, msg, msg.length);
  return h;
};

nacl.hash.hashLength = crypto_hash_BYTES;

nacl.verify = function(x, y) {
  checkArrayTypes(x, y);
  // Zero length arguments are considered not equal.
  if (x.length === 0 || y.length === 0) return false;
  if (x.length !== y.length) return false;
  return (vn(x, 0, y, 0, x.length) === 0) ? true : false;
};

nacl.setPRNG = function(fn) {
  randombytes = fn;
};

(function() {
  // Initialize PRNG if environment provides CSPRNG.
  // If not, methods calling randombytes will throw.
  var crypto = typeof self !== 'undefined' ? (self.crypto || self.msCrypto) : null;
  if (crypto && crypto.getRandomValues) {
    // Browsers.
    var QUOTA = 65536;
    nacl.setPRNG(function(x, n) {
      var i, v = new Uint8Array(n);
      for (i = 0; i < n; i += QUOTA) {
        crypto.getRandomValues(v.subarray(i, i + Math.min(n - i, QUOTA)));
      }
      for (i = 0; i < n; i++) x[i] = v[i];
      cleanup(v);
    });
  } else if (true) {
    // Node.js.
    crypto = __webpack_require__(274);
    if (crypto && crypto.randomBytes) {
      nacl.setPRNG(function(x, n) {
        var i, v = crypto.randomBytes(n);
        for (i = 0; i < n; i++) x[i] = v[i];
        cleanup(v);
      });
    }
  }
})();

})(typeof module !== 'undefined' && module.exports ? module.exports : (self.nacl = self.nacl || {}));


/***/ }),
/* 274 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var b2b = __webpack_require__(276)
var b2s = __webpack_require__(277)

module.exports = {
  blake2b: b2b.blake2b,
  blake2bHex: b2b.blake2bHex,
  blake2bInit: b2b.blake2bInit,
  blake2bUpdate: b2b.blake2bUpdate,
  blake2bFinal: b2b.blake2bFinal,
  blake2s: b2s.blake2s,
  blake2sHex: b2s.blake2sHex,
  blake2sInit: b2s.blake2sInit,
  blake2sUpdate: b2s.blake2sUpdate,
  blake2sFinal: b2s.blake2sFinal
}


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

// Blake2B in pure Javascript
// Adapted from the reference implementation in RFC7693
// Ported to Javascript by DC - https://github.com/dcposch

var util = __webpack_require__(107)

// 64-bit unsigned addition
// Sets v[a,a+1] += v[b,b+1]
// v should be a Uint32Array
function ADD64AA (v, a, b) {
  var o0 = v[a] + v[b]
  var o1 = v[a + 1] + v[b + 1]
  if (o0 >= 0x100000000) {
    o1++
  }
  v[a] = o0
  v[a + 1] = o1
}

// 64-bit unsigned addition
// Sets v[a,a+1] += b
// b0 is the low 32 bits of b, b1 represents the high 32 bits
function ADD64AC (v, a, b0, b1) {
  var o0 = v[a] + b0
  if (b0 < 0) {
    o0 += 0x100000000
  }
  var o1 = v[a + 1] + b1
  if (o0 >= 0x100000000) {
    o1++
  }
  v[a] = o0
  v[a + 1] = o1
}

// Little-endian byte access
function B2B_GET32 (arr, i) {
  return (arr[i] ^
  (arr[i + 1] << 8) ^
  (arr[i + 2] << 16) ^
  (arr[i + 3] << 24))
}

// G Mixing function
// The ROTRs are inlined for speed
function B2B_G (a, b, c, d, ix, iy) {
  var x0 = m[ix]
  var x1 = m[ix + 1]
  var y0 = m[iy]
  var y1 = m[iy + 1]

  ADD64AA(v, a, b) // v[a,a+1] += v[b,b+1] ... in JS we must store a uint64 as two uint32s
  ADD64AC(v, a, x0, x1) // v[a, a+1] += x ... x0 is the low 32 bits of x, x1 is the high 32 bits

  // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated to the right by 32 bits
  var xor0 = v[d] ^ v[a]
  var xor1 = v[d + 1] ^ v[a + 1]
  v[d] = xor1
  v[d + 1] = xor0

  ADD64AA(v, c, d)

  // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 24 bits
  xor0 = v[b] ^ v[c]
  xor1 = v[b + 1] ^ v[c + 1]
  v[b] = (xor0 >>> 24) ^ (xor1 << 8)
  v[b + 1] = (xor1 >>> 24) ^ (xor0 << 8)

  ADD64AA(v, a, b)
  ADD64AC(v, a, y0, y1)

  // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated right by 16 bits
  xor0 = v[d] ^ v[a]
  xor1 = v[d + 1] ^ v[a + 1]
  v[d] = (xor0 >>> 16) ^ (xor1 << 16)
  v[d + 1] = (xor1 >>> 16) ^ (xor0 << 16)

  ADD64AA(v, c, d)

  // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 63 bits
  xor0 = v[b] ^ v[c]
  xor1 = v[b + 1] ^ v[c + 1]
  v[b] = (xor1 >>> 31) ^ (xor0 << 1)
  v[b + 1] = (xor0 >>> 31) ^ (xor1 << 1)
}

// Initialization Vector
var BLAKE2B_IV32 = new Uint32Array([
  0xF3BCC908, 0x6A09E667, 0x84CAA73B, 0xBB67AE85,
  0xFE94F82B, 0x3C6EF372, 0x5F1D36F1, 0xA54FF53A,
  0xADE682D1, 0x510E527F, 0x2B3E6C1F, 0x9B05688C,
  0xFB41BD6B, 0x1F83D9AB, 0x137E2179, 0x5BE0CD19
])

var SIGMA8 = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3,
  11, 8, 12, 0, 5, 2, 15, 13, 10, 14, 3, 6, 7, 1, 9, 4,
  7, 9, 3, 1, 13, 12, 11, 14, 2, 6, 5, 10, 4, 0, 15, 8,
  9, 0, 5, 7, 2, 4, 10, 15, 14, 1, 11, 12, 6, 8, 3, 13,
  2, 12, 6, 10, 0, 11, 8, 3, 4, 13, 7, 5, 15, 14, 1, 9,
  12, 5, 1, 15, 14, 13, 4, 10, 0, 7, 6, 3, 9, 2, 8, 11,
  13, 11, 7, 14, 12, 1, 3, 9, 5, 0, 15, 4, 8, 6, 2, 10,
  6, 15, 14, 9, 11, 3, 0, 8, 12, 2, 13, 7, 1, 4, 10, 5,
  10, 2, 8, 4, 7, 6, 1, 5, 15, 11, 9, 14, 3, 12, 13, 0,
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3
]

// These are offsets into a uint64 buffer.
// Multiply them all by 2 to make them offsets into a uint32 buffer,
// because this is Javascript and we don't have uint64s
var SIGMA82 = new Uint8Array(SIGMA8.map(function (x) { return x * 2 }))

// Compression function. 'last' flag indicates last block.
// Note we're representing 16 uint64s as 32 uint32s
var v = new Uint32Array(32)
var m = new Uint32Array(32)
function blake2bCompress (ctx, last) {
  var i = 0

  // init work variables
  for (i = 0; i < 16; i++) {
    v[i] = ctx.h[i]
    v[i + 16] = BLAKE2B_IV32[i]
  }

  // low 64 bits of offset
  v[24] = v[24] ^ ctx.t
  v[25] = v[25] ^ (ctx.t / 0x100000000)
  // high 64 bits not supported, offset may not be higher than 2**53-1

  // last block flag set ?
  if (last) {
    v[28] = ~v[28]
    v[29] = ~v[29]
  }

  // get little-endian words
  for (i = 0; i < 32; i++) {
    m[i] = B2B_GET32(ctx.b, 4 * i)
  }

  // twelve rounds of mixing
  // uncomment the DebugPrint calls to log the computation
  // and match the RFC sample documentation
  // util.debugPrint('          m[16]', m, 64)
  for (i = 0; i < 12; i++) {
    // util.debugPrint('   (i=' + (i < 10 ? ' ' : '') + i + ') v[16]', v, 64)
    B2B_G(0, 8, 16, 24, SIGMA82[i * 16 + 0], SIGMA82[i * 16 + 1])
    B2B_G(2, 10, 18, 26, SIGMA82[i * 16 + 2], SIGMA82[i * 16 + 3])
    B2B_G(4, 12, 20, 28, SIGMA82[i * 16 + 4], SIGMA82[i * 16 + 5])
    B2B_G(6, 14, 22, 30, SIGMA82[i * 16 + 6], SIGMA82[i * 16 + 7])
    B2B_G(0, 10, 20, 30, SIGMA82[i * 16 + 8], SIGMA82[i * 16 + 9])
    B2B_G(2, 12, 22, 24, SIGMA82[i * 16 + 10], SIGMA82[i * 16 + 11])
    B2B_G(4, 14, 16, 26, SIGMA82[i * 16 + 12], SIGMA82[i * 16 + 13])
    B2B_G(6, 8, 18, 28, SIGMA82[i * 16 + 14], SIGMA82[i * 16 + 15])
  }
  // util.debugPrint('   (i=12) v[16]', v, 64)

  for (i = 0; i < 16; i++) {
    ctx.h[i] = ctx.h[i] ^ v[i] ^ v[i + 16]
  }
  // util.debugPrint('h[8]', ctx.h, 64)
}

// Creates a BLAKE2b hashing context
// Requires an output length between 1 and 64 bytes
// Takes an optional Uint8Array key
function blake2bInit (outlen, key) {
  if (outlen === 0 || outlen > 64) {
    throw new Error('Illegal output length, expected 0 < length <= 64')
  }
  if (key && key.length > 64) {
    throw new Error('Illegal key, expected Uint8Array with 0 < length <= 64')
  }

  // state, 'param block'
  var ctx = {
    b: new Uint8Array(128),
    h: new Uint32Array(16),
    t: 0, // input count
    c: 0, // pointer within buffer
    outlen: outlen // output length in bytes
  }

  // initialize hash state
  for (var i = 0; i < 16; i++) {
    ctx.h[i] = BLAKE2B_IV32[i]
  }
  var keylen = key ? key.length : 0
  ctx.h[0] ^= 0x01010000 ^ (keylen << 8) ^ outlen

  // key the hash, if applicable
  if (key) {
    blake2bUpdate(ctx, key)
    // at the end
    ctx.c = 128
  }

  return ctx
}

// Updates a BLAKE2b streaming hash
// Requires hash context and Uint8Array (byte array)
function blake2bUpdate (ctx, input) {
  for (var i = 0; i < input.length; i++) {
    if (ctx.c === 128) { // buffer full ?
      ctx.t += ctx.c // add counters
      blake2bCompress(ctx, false) // compress (not last)
      ctx.c = 0 // counter to zero
    }
    ctx.b[ctx.c++] = input[i]
  }
}

// Completes a BLAKE2b streaming hash
// Returns a Uint8Array containing the message digest
function blake2bFinal (ctx) {
  ctx.t += ctx.c // mark last block offset

  while (ctx.c < 128) { // fill up with zeros
    ctx.b[ctx.c++] = 0
  }
  blake2bCompress(ctx, true) // final block flag = 1

  // little endian convert and store
  var out = new Uint8Array(ctx.outlen)
  for (var i = 0; i < ctx.outlen; i++) {
    out[i] = ctx.h[i >> 2] >> (8 * (i & 3))
  }
  return out
}

// Computes the BLAKE2B hash of a string or byte array, and returns a Uint8Array
//
// Returns a n-byte Uint8Array
//
// Parameters:
// - input - the input bytes, as a string, Buffer or Uint8Array
// - key - optional key Uint8Array, up to 64 bytes
// - outlen - optional output length in bytes, default 64
function blake2b (input, key, outlen) {
  // preprocess inputs
  outlen = outlen || 64
  input = util.normalizeInput(input)

  // do the math
  var ctx = blake2bInit(outlen, key)
  blake2bUpdate(ctx, input)
  return blake2bFinal(ctx)
}

// Computes the BLAKE2B hash of a string or byte array
//
// Returns an n-byte hash in hex, all lowercase
//
// Parameters:
// - input - the input bytes, as a string, Buffer, or Uint8Array
// - key - optional key Uint8Array, up to 64 bytes
// - outlen - optional output length in bytes, default 64
function blake2bHex (input, key, outlen) {
  var output = blake2b(input, key, outlen)
  return util.toHex(output)
}

module.exports = {
  blake2b: blake2b,
  blake2bHex: blake2bHex,
  blake2bInit: blake2bInit,
  blake2bUpdate: blake2bUpdate,
  blake2bFinal: blake2bFinal
}


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

// BLAKE2s hash function in pure Javascript
// Adapted from the reference implementation in RFC7693
// Ported to Javascript by DC - https://github.com/dcposch

var util = __webpack_require__(107)

// Little-endian byte access.
// Expects a Uint8Array and an index
// Returns the little-endian uint32 at v[i..i+3]
function B2S_GET32 (v, i) {
  return v[i] ^ (v[i + 1] << 8) ^ (v[i + 2] << 16) ^ (v[i + 3] << 24)
}

// Mixing function G.
function B2S_G (a, b, c, d, x, y) {
  v[a] = v[a] + v[b] + x
  v[d] = ROTR32(v[d] ^ v[a], 16)
  v[c] = v[c] + v[d]
  v[b] = ROTR32(v[b] ^ v[c], 12)
  v[a] = v[a] + v[b] + y
  v[d] = ROTR32(v[d] ^ v[a], 8)
  v[c] = v[c] + v[d]
  v[b] = ROTR32(v[b] ^ v[c], 7)
}

// 32-bit right rotation
// x should be a uint32
// y must be between 1 and 31, inclusive
function ROTR32 (x, y) {
  return (x >>> y) ^ (x << (32 - y))
}

// Initialization Vector.
var BLAKE2S_IV = new Uint32Array([
  0x6A09E667, 0xBB67AE85, 0x3C6EF372, 0xA54FF53A,
  0x510E527F, 0x9B05688C, 0x1F83D9AB, 0x5BE0CD19])

var SIGMA = new Uint8Array([
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3,
  11, 8, 12, 0, 5, 2, 15, 13, 10, 14, 3, 6, 7, 1, 9, 4,
  7, 9, 3, 1, 13, 12, 11, 14, 2, 6, 5, 10, 4, 0, 15, 8,
  9, 0, 5, 7, 2, 4, 10, 15, 14, 1, 11, 12, 6, 8, 3, 13,
  2, 12, 6, 10, 0, 11, 8, 3, 4, 13, 7, 5, 15, 14, 1, 9,
  12, 5, 1, 15, 14, 13, 4, 10, 0, 7, 6, 3, 9, 2, 8, 11,
  13, 11, 7, 14, 12, 1, 3, 9, 5, 0, 15, 4, 8, 6, 2, 10,
  6, 15, 14, 9, 11, 3, 0, 8, 12, 2, 13, 7, 1, 4, 10, 5,
  10, 2, 8, 4, 7, 6, 1, 5, 15, 11, 9, 14, 3, 12, 13, 0])

// Compression function. "last" flag indicates last block
var v = new Uint32Array(16)
var m = new Uint32Array(16)
function blake2sCompress (ctx, last) {
  var i = 0
  for (i = 0; i < 8; i++) { // init work variables
    v[i] = ctx.h[i]
    v[i + 8] = BLAKE2S_IV[i]
  }

  v[12] ^= ctx.t // low 32 bits of offset
  v[13] ^= (ctx.t / 0x100000000) // high 32 bits
  if (last) { // last block flag set ?
    v[14] = ~v[14]
  }

  for (i = 0; i < 16; i++) { // get little-endian words
    m[i] = B2S_GET32(ctx.b, 4 * i)
  }

  // ten rounds of mixing
  // uncomment the DebugPrint calls to log the computation
  // and match the RFC sample documentation
  // util.debugPrint('          m[16]', m, 32)
  for (i = 0; i < 10; i++) {
    // util.debugPrint('   (i=' + i + ')  v[16]', v, 32)
    B2S_G(0, 4, 8, 12, m[SIGMA[i * 16 + 0]], m[SIGMA[i * 16 + 1]])
    B2S_G(1, 5, 9, 13, m[SIGMA[i * 16 + 2]], m[SIGMA[i * 16 + 3]])
    B2S_G(2, 6, 10, 14, m[SIGMA[i * 16 + 4]], m[SIGMA[i * 16 + 5]])
    B2S_G(3, 7, 11, 15, m[SIGMA[i * 16 + 6]], m[SIGMA[i * 16 + 7]])
    B2S_G(0, 5, 10, 15, m[SIGMA[i * 16 + 8]], m[SIGMA[i * 16 + 9]])
    B2S_G(1, 6, 11, 12, m[SIGMA[i * 16 + 10]], m[SIGMA[i * 16 + 11]])
    B2S_G(2, 7, 8, 13, m[SIGMA[i * 16 + 12]], m[SIGMA[i * 16 + 13]])
    B2S_G(3, 4, 9, 14, m[SIGMA[i * 16 + 14]], m[SIGMA[i * 16 + 15]])
  }
  // util.debugPrint('   (i=10) v[16]', v, 32)

  for (i = 0; i < 8; i++) {
    ctx.h[i] ^= v[i] ^ v[i + 8]
  }
  // util.debugPrint('h[8]', ctx.h, 32)
}

// Creates a BLAKE2s hashing context
// Requires an output length between 1 and 32 bytes
// Takes an optional Uint8Array key
function blake2sInit (outlen, key) {
  if (!(outlen > 0 && outlen <= 32)) {
    throw new Error('Incorrect output length, should be in [1, 32]')
  }
  var keylen = key ? key.length : 0
  if (key && !(keylen > 0 && keylen <= 32)) {
    throw new Error('Incorrect key length, should be in [1, 32]')
  }

  var ctx = {
    h: new Uint32Array(BLAKE2S_IV), // hash state
    b: new Uint32Array(64), // input block
    c: 0, // pointer within block
    t: 0, // input count
    outlen: outlen // output length in bytes
  }
  ctx.h[0] ^= 0x01010000 ^ (keylen << 8) ^ outlen

  if (keylen > 0) {
    blake2sUpdate(ctx, key)
    ctx.c = 64 // at the end
  }

  return ctx
}

// Updates a BLAKE2s streaming hash
// Requires hash context and Uint8Array (byte array)
function blake2sUpdate (ctx, input) {
  for (var i = 0; i < input.length; i++) {
    if (ctx.c === 64) { // buffer full ?
      ctx.t += ctx.c // add counters
      blake2sCompress(ctx, false) // compress (not last)
      ctx.c = 0 // counter to zero
    }
    ctx.b[ctx.c++] = input[i]
  }
}

// Completes a BLAKE2s streaming hash
// Returns a Uint8Array containing the message digest
function blake2sFinal (ctx) {
  ctx.t += ctx.c // mark last block offset
  while (ctx.c < 64) { // fill up with zeros
    ctx.b[ctx.c++] = 0
  }
  blake2sCompress(ctx, true) // final block flag = 1

  // little endian convert and store
  var out = new Uint8Array(ctx.outlen)
  for (var i = 0; i < ctx.outlen; i++) {
    out[i] = (ctx.h[i >> 2] >> (8 * (i & 3))) & 0xFF
  }
  return out
}

// Computes the BLAKE2S hash of a string or byte array, and returns a Uint8Array
//
// Returns a n-byte Uint8Array
//
// Parameters:
// - input - the input bytes, as a string, Buffer, or Uint8Array
// - key - optional key Uint8Array, up to 32 bytes
// - outlen - optional output length in bytes, default 64
function blake2s (input, key, outlen) {
  // preprocess inputs
  outlen = outlen || 32
  input = util.normalizeInput(input)

  // do the math
  var ctx = blake2sInit(outlen, key)
  blake2sUpdate(ctx, input)
  return blake2sFinal(ctx)
}

// Computes the BLAKE2S hash of a string or byte array
//
// Returns an n-byte hash in hex, all lowercase
//
// Parameters:
// - input - the input bytes, as a string, Buffer, or Uint8Array
// - key - optional key Uint8Array, up to 32 bytes
// - outlen - optional output length in bytes, default 64
function blake2sHex (input, key, outlen) {
  var output = blake2s(input, key, outlen)
  return util.toHex(output)
}

module.exports = {
  blake2s: blake2s,
  blake2sHex: blake2sHex,
  blake2sInit: blake2sInit,
  blake2sUpdate: blake2sUpdate,
  blake2sFinal: blake2sFinal
}


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

/*! MIT License. Copyright 2015-2018 Richard Moore <me@ricmoo.com>. See LICENSE.txt. */
(function(root) {
    "use strict";

    function checkInt(value) {
        return (parseInt(value) === value);
    }

    function checkInts(arrayish) {
        if (!checkInt(arrayish.length)) { return false; }

        for (var i = 0; i < arrayish.length; i++) {
            if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) {
                return false;
            }
        }

        return true;
    }

    function coerceArray(arg, copy) {

        // ArrayBuffer view
        if (arg.buffer && arg.name === 'Uint8Array') {

            if (copy) {
                if (arg.slice) {
                    arg = arg.slice();
                } else {
                    arg = Array.prototype.slice.call(arg);
                }
            }

            return arg;
        }

        // It's an array; check it is a valid representation of a byte
        if (Array.isArray(arg)) {
            if (!checkInts(arg)) {
                throw new Error('Array contains invalid value: ' + arg);
            }

            return new Uint8Array(arg);
        }

        // Something else, but behaves like an array (maybe a Buffer? Arguments?)
        if (checkInt(arg.length) && checkInts(arg)) {
            return new Uint8Array(arg);
        }

        throw new Error('unsupported array-like object');
    }

    function createArray(length) {
        return new Uint8Array(length);
    }

    function copyArray(sourceArray, targetArray, targetStart, sourceStart, sourceEnd) {
        if (sourceStart != null || sourceEnd != null) {
            if (sourceArray.slice) {
                sourceArray = sourceArray.slice(sourceStart, sourceEnd);
            } else {
                sourceArray = Array.prototype.slice.call(sourceArray, sourceStart, sourceEnd);
            }
        }
        targetArray.set(sourceArray, targetStart);
    }



    var convertUtf8 = (function() {
        function toBytes(text) {
            var result = [], i = 0;
            text = encodeURI(text);
            while (i < text.length) {
                var c = text.charCodeAt(i++);

                // if it is a % sign, encode the following 2 bytes as a hex value
                if (c === 37) {
                    result.push(parseInt(text.substr(i, 2), 16))
                    i += 2;

                // otherwise, just the actual byte
                } else {
                    result.push(c)
                }
            }

            return coerceArray(result);
        }

        function fromBytes(bytes) {
            var result = [], i = 0;

            while (i < bytes.length) {
                var c = bytes[i];

                if (c < 128) {
                    result.push(String.fromCharCode(c));
                    i++;
                } else if (c > 191 && c < 224) {
                    result.push(String.fromCharCode(((c & 0x1f) << 6) | (bytes[i + 1] & 0x3f)));
                    i += 2;
                } else {
                    result.push(String.fromCharCode(((c & 0x0f) << 12) | ((bytes[i + 1] & 0x3f) << 6) | (bytes[i + 2] & 0x3f)));
                    i += 3;
                }
            }

            return result.join('');
        }

        return {
            toBytes: toBytes,
            fromBytes: fromBytes,
        }
    })();

    var convertHex = (function() {
        function toBytes(text) {
            var result = [];
            for (var i = 0; i < text.length; i += 2) {
                result.push(parseInt(text.substr(i, 2), 16));
            }

            return result;
        }

        // http://ixti.net/development/javascript/2011/11/11/base64-encodedecode-of-utf8-in-browser-with-js.html
        var Hex = '0123456789abcdef';

        function fromBytes(bytes) {
                var result = [];
                for (var i = 0; i < bytes.length; i++) {
                    var v = bytes[i];
                    result.push(Hex[(v & 0xf0) >> 4] + Hex[v & 0x0f]);
                }
                return result.join('');
        }

        return {
            toBytes: toBytes,
            fromBytes: fromBytes,
        }
    })();


    // Number of rounds by keysize
    var numberOfRounds = {16: 10, 24: 12, 32: 14}

    // Round constant words
    var rcon = [0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91];

    // S-box and Inverse S-box (S is for Substitution)
    var S = [0x63, 0x7c, 0x77, 0x7b, 0xf2, 0x6b, 0x6f, 0xc5, 0x30, 0x01, 0x67, 0x2b, 0xfe, 0xd7, 0xab, 0x76, 0xca, 0x82, 0xc9, 0x7d, 0xfa, 0x59, 0x47, 0xf0, 0xad, 0xd4, 0xa2, 0xaf, 0x9c, 0xa4, 0x72, 0xc0, 0xb7, 0xfd, 0x93, 0x26, 0x36, 0x3f, 0xf7, 0xcc, 0x34, 0xa5, 0xe5, 0xf1, 0x71, 0xd8, 0x31, 0x15, 0x04, 0xc7, 0x23, 0xc3, 0x18, 0x96, 0x05, 0x9a, 0x07, 0x12, 0x80, 0xe2, 0xeb, 0x27, 0xb2, 0x75, 0x09, 0x83, 0x2c, 0x1a, 0x1b, 0x6e, 0x5a, 0xa0, 0x52, 0x3b, 0xd6, 0xb3, 0x29, 0xe3, 0x2f, 0x84, 0x53, 0xd1, 0x00, 0xed, 0x20, 0xfc, 0xb1, 0x5b, 0x6a, 0xcb, 0xbe, 0x39, 0x4a, 0x4c, 0x58, 0xcf, 0xd0, 0xef, 0xaa, 0xfb, 0x43, 0x4d, 0x33, 0x85, 0x45, 0xf9, 0x02, 0x7f, 0x50, 0x3c, 0x9f, 0xa8, 0x51, 0xa3, 0x40, 0x8f, 0x92, 0x9d, 0x38, 0xf5, 0xbc, 0xb6, 0xda, 0x21, 0x10, 0xff, 0xf3, 0xd2, 0xcd, 0x0c, 0x13, 0xec, 0x5f, 0x97, 0x44, 0x17, 0xc4, 0xa7, 0x7e, 0x3d, 0x64, 0x5d, 0x19, 0x73, 0x60, 0x81, 0x4f, 0xdc, 0x22, 0x2a, 0x90, 0x88, 0x46, 0xee, 0xb8, 0x14, 0xde, 0x5e, 0x0b, 0xdb, 0xe0, 0x32, 0x3a, 0x0a, 0x49, 0x06, 0x24, 0x5c, 0xc2, 0xd3, 0xac, 0x62, 0x91, 0x95, 0xe4, 0x79, 0xe7, 0xc8, 0x37, 0x6d, 0x8d, 0xd5, 0x4e, 0xa9, 0x6c, 0x56, 0xf4, 0xea, 0x65, 0x7a, 0xae, 0x08, 0xba, 0x78, 0x25, 0x2e, 0x1c, 0xa6, 0xb4, 0xc6, 0xe8, 0xdd, 0x74, 0x1f, 0x4b, 0xbd, 0x8b, 0x8a, 0x70, 0x3e, 0xb5, 0x66, 0x48, 0x03, 0xf6, 0x0e, 0x61, 0x35, 0x57, 0xb9, 0x86, 0xc1, 0x1d, 0x9e, 0xe1, 0xf8, 0x98, 0x11, 0x69, 0xd9, 0x8e, 0x94, 0x9b, 0x1e, 0x87, 0xe9, 0xce, 0x55, 0x28, 0xdf, 0x8c, 0xa1, 0x89, 0x0d, 0xbf, 0xe6, 0x42, 0x68, 0x41, 0x99, 0x2d, 0x0f, 0xb0, 0x54, 0xbb, 0x16];
    var Si =[0x52, 0x09, 0x6a, 0xd5, 0x30, 0x36, 0xa5, 0x38, 0xbf, 0x40, 0xa3, 0x9e, 0x81, 0xf3, 0xd7, 0xfb, 0x7c, 0xe3, 0x39, 0x82, 0x9b, 0x2f, 0xff, 0x87, 0x34, 0x8e, 0x43, 0x44, 0xc4, 0xde, 0xe9, 0xcb, 0x54, 0x7b, 0x94, 0x32, 0xa6, 0xc2, 0x23, 0x3d, 0xee, 0x4c, 0x95, 0x0b, 0x42, 0xfa, 0xc3, 0x4e, 0x08, 0x2e, 0xa1, 0x66, 0x28, 0xd9, 0x24, 0xb2, 0x76, 0x5b, 0xa2, 0x49, 0x6d, 0x8b, 0xd1, 0x25, 0x72, 0xf8, 0xf6, 0x64, 0x86, 0x68, 0x98, 0x16, 0xd4, 0xa4, 0x5c, 0xcc, 0x5d, 0x65, 0xb6, 0x92, 0x6c, 0x70, 0x48, 0x50, 0xfd, 0xed, 0xb9, 0xda, 0x5e, 0x15, 0x46, 0x57, 0xa7, 0x8d, 0x9d, 0x84, 0x90, 0xd8, 0xab, 0x00, 0x8c, 0xbc, 0xd3, 0x0a, 0xf7, 0xe4, 0x58, 0x05, 0xb8, 0xb3, 0x45, 0x06, 0xd0, 0x2c, 0x1e, 0x8f, 0xca, 0x3f, 0x0f, 0x02, 0xc1, 0xaf, 0xbd, 0x03, 0x01, 0x13, 0x8a, 0x6b, 0x3a, 0x91, 0x11, 0x41, 0x4f, 0x67, 0xdc, 0xea, 0x97, 0xf2, 0xcf, 0xce, 0xf0, 0xb4, 0xe6, 0x73, 0x96, 0xac, 0x74, 0x22, 0xe7, 0xad, 0x35, 0x85, 0xe2, 0xf9, 0x37, 0xe8, 0x1c, 0x75, 0xdf, 0x6e, 0x47, 0xf1, 0x1a, 0x71, 0x1d, 0x29, 0xc5, 0x89, 0x6f, 0xb7, 0x62, 0x0e, 0xaa, 0x18, 0xbe, 0x1b, 0xfc, 0x56, 0x3e, 0x4b, 0xc6, 0xd2, 0x79, 0x20, 0x9a, 0xdb, 0xc0, 0xfe, 0x78, 0xcd, 0x5a, 0xf4, 0x1f, 0xdd, 0xa8, 0x33, 0x88, 0x07, 0xc7, 0x31, 0xb1, 0x12, 0x10, 0x59, 0x27, 0x80, 0xec, 0x5f, 0x60, 0x51, 0x7f, 0xa9, 0x19, 0xb5, 0x4a, 0x0d, 0x2d, 0xe5, 0x7a, 0x9f, 0x93, 0xc9, 0x9c, 0xef, 0xa0, 0xe0, 0x3b, 0x4d, 0xae, 0x2a, 0xf5, 0xb0, 0xc8, 0xeb, 0xbb, 0x3c, 0x83, 0x53, 0x99, 0x61, 0x17, 0x2b, 0x04, 0x7e, 0xba, 0x77, 0xd6, 0x26, 0xe1, 0x69, 0x14, 0x63, 0x55, 0x21, 0x0c, 0x7d];

    // Transformations for encryption
    var T1 = [0xc66363a5, 0xf87c7c84, 0xee777799, 0xf67b7b8d, 0xfff2f20d, 0xd66b6bbd, 0xde6f6fb1, 0x91c5c554, 0x60303050, 0x02010103, 0xce6767a9, 0x562b2b7d, 0xe7fefe19, 0xb5d7d762, 0x4dababe6, 0xec76769a, 0x8fcaca45, 0x1f82829d, 0x89c9c940, 0xfa7d7d87, 0xeffafa15, 0xb25959eb, 0x8e4747c9, 0xfbf0f00b, 0x41adadec, 0xb3d4d467, 0x5fa2a2fd, 0x45afafea, 0x239c9cbf, 0x53a4a4f7, 0xe4727296, 0x9bc0c05b, 0x75b7b7c2, 0xe1fdfd1c, 0x3d9393ae, 0x4c26266a, 0x6c36365a, 0x7e3f3f41, 0xf5f7f702, 0x83cccc4f, 0x6834345c, 0x51a5a5f4, 0xd1e5e534, 0xf9f1f108, 0xe2717193, 0xabd8d873, 0x62313153, 0x2a15153f, 0x0804040c, 0x95c7c752, 0x46232365, 0x9dc3c35e, 0x30181828, 0x379696a1, 0x0a05050f, 0x2f9a9ab5, 0x0e070709, 0x24121236, 0x1b80809b, 0xdfe2e23d, 0xcdebeb26, 0x4e272769, 0x7fb2b2cd, 0xea75759f, 0x1209091b, 0x1d83839e, 0x582c2c74, 0x341a1a2e, 0x361b1b2d, 0xdc6e6eb2, 0xb45a5aee, 0x5ba0a0fb, 0xa45252f6, 0x763b3b4d, 0xb7d6d661, 0x7db3b3ce, 0x5229297b, 0xdde3e33e, 0x5e2f2f71, 0x13848497, 0xa65353f5, 0xb9d1d168, 0x00000000, 0xc1eded2c, 0x40202060, 0xe3fcfc1f, 0x79b1b1c8, 0xb65b5bed, 0xd46a6abe, 0x8dcbcb46, 0x67bebed9, 0x7239394b, 0x944a4ade, 0x984c4cd4, 0xb05858e8, 0x85cfcf4a, 0xbbd0d06b, 0xc5efef2a, 0x4faaaae5, 0xedfbfb16, 0x864343c5, 0x9a4d4dd7, 0x66333355, 0x11858594, 0x8a4545cf, 0xe9f9f910, 0x04020206, 0xfe7f7f81, 0xa05050f0, 0x783c3c44, 0x259f9fba, 0x4ba8a8e3, 0xa25151f3, 0x5da3a3fe, 0x804040c0, 0x058f8f8a, 0x3f9292ad, 0x219d9dbc, 0x70383848, 0xf1f5f504, 0x63bcbcdf, 0x77b6b6c1, 0xafdada75, 0x42212163, 0x20101030, 0xe5ffff1a, 0xfdf3f30e, 0xbfd2d26d, 0x81cdcd4c, 0x180c0c14, 0x26131335, 0xc3ecec2f, 0xbe5f5fe1, 0x359797a2, 0x884444cc, 0x2e171739, 0x93c4c457, 0x55a7a7f2, 0xfc7e7e82, 0x7a3d3d47, 0xc86464ac, 0xba5d5de7, 0x3219192b, 0xe6737395, 0xc06060a0, 0x19818198, 0x9e4f4fd1, 0xa3dcdc7f, 0x44222266, 0x542a2a7e, 0x3b9090ab, 0x0b888883, 0x8c4646ca, 0xc7eeee29, 0x6bb8b8d3, 0x2814143c, 0xa7dede79, 0xbc5e5ee2, 0x160b0b1d, 0xaddbdb76, 0xdbe0e03b, 0x64323256, 0x743a3a4e, 0x140a0a1e, 0x924949db, 0x0c06060a, 0x4824246c, 0xb85c5ce4, 0x9fc2c25d, 0xbdd3d36e, 0x43acacef, 0xc46262a6, 0x399191a8, 0x319595a4, 0xd3e4e437, 0xf279798b, 0xd5e7e732, 0x8bc8c843, 0x6e373759, 0xda6d6db7, 0x018d8d8c, 0xb1d5d564, 0x9c4e4ed2, 0x49a9a9e0, 0xd86c6cb4, 0xac5656fa, 0xf3f4f407, 0xcfeaea25, 0xca6565af, 0xf47a7a8e, 0x47aeaee9, 0x10080818, 0x6fbabad5, 0xf0787888, 0x4a25256f, 0x5c2e2e72, 0x381c1c24, 0x57a6a6f1, 0x73b4b4c7, 0x97c6c651, 0xcbe8e823, 0xa1dddd7c, 0xe874749c, 0x3e1f1f21, 0x964b4bdd, 0x61bdbddc, 0x0d8b8b86, 0x0f8a8a85, 0xe0707090, 0x7c3e3e42, 0x71b5b5c4, 0xcc6666aa, 0x904848d8, 0x06030305, 0xf7f6f601, 0x1c0e0e12, 0xc26161a3, 0x6a35355f, 0xae5757f9, 0x69b9b9d0, 0x17868691, 0x99c1c158, 0x3a1d1d27, 0x279e9eb9, 0xd9e1e138, 0xebf8f813, 0x2b9898b3, 0x22111133, 0xd26969bb, 0xa9d9d970, 0x078e8e89, 0x339494a7, 0x2d9b9bb6, 0x3c1e1e22, 0x15878792, 0xc9e9e920, 0x87cece49, 0xaa5555ff, 0x50282878, 0xa5dfdf7a, 0x038c8c8f, 0x59a1a1f8, 0x09898980, 0x1a0d0d17, 0x65bfbfda, 0xd7e6e631, 0x844242c6, 0xd06868b8, 0x824141c3, 0x299999b0, 0x5a2d2d77, 0x1e0f0f11, 0x7bb0b0cb, 0xa85454fc, 0x6dbbbbd6, 0x2c16163a];
    var T2 = [0xa5c66363, 0x84f87c7c, 0x99ee7777, 0x8df67b7b, 0x0dfff2f2, 0xbdd66b6b, 0xb1de6f6f, 0x5491c5c5, 0x50603030, 0x03020101, 0xa9ce6767, 0x7d562b2b, 0x19e7fefe, 0x62b5d7d7, 0xe64dabab, 0x9aec7676, 0x458fcaca, 0x9d1f8282, 0x4089c9c9, 0x87fa7d7d, 0x15effafa, 0xebb25959, 0xc98e4747, 0x0bfbf0f0, 0xec41adad, 0x67b3d4d4, 0xfd5fa2a2, 0xea45afaf, 0xbf239c9c, 0xf753a4a4, 0x96e47272, 0x5b9bc0c0, 0xc275b7b7, 0x1ce1fdfd, 0xae3d9393, 0x6a4c2626, 0x5a6c3636, 0x417e3f3f, 0x02f5f7f7, 0x4f83cccc, 0x5c683434, 0xf451a5a5, 0x34d1e5e5, 0x08f9f1f1, 0x93e27171, 0x73abd8d8, 0x53623131, 0x3f2a1515, 0x0c080404, 0x5295c7c7, 0x65462323, 0x5e9dc3c3, 0x28301818, 0xa1379696, 0x0f0a0505, 0xb52f9a9a, 0x090e0707, 0x36241212, 0x9b1b8080, 0x3ddfe2e2, 0x26cdebeb, 0x694e2727, 0xcd7fb2b2, 0x9fea7575, 0x1b120909, 0x9e1d8383, 0x74582c2c, 0x2e341a1a, 0x2d361b1b, 0xb2dc6e6e, 0xeeb45a5a, 0xfb5ba0a0, 0xf6a45252, 0x4d763b3b, 0x61b7d6d6, 0xce7db3b3, 0x7b522929, 0x3edde3e3, 0x715e2f2f, 0x97138484, 0xf5a65353, 0x68b9d1d1, 0x00000000, 0x2cc1eded, 0x60402020, 0x1fe3fcfc, 0xc879b1b1, 0xedb65b5b, 0xbed46a6a, 0x468dcbcb, 0xd967bebe, 0x4b723939, 0xde944a4a, 0xd4984c4c, 0xe8b05858, 0x4a85cfcf, 0x6bbbd0d0, 0x2ac5efef, 0xe54faaaa, 0x16edfbfb, 0xc5864343, 0xd79a4d4d, 0x55663333, 0x94118585, 0xcf8a4545, 0x10e9f9f9, 0x06040202, 0x81fe7f7f, 0xf0a05050, 0x44783c3c, 0xba259f9f, 0xe34ba8a8, 0xf3a25151, 0xfe5da3a3, 0xc0804040, 0x8a058f8f, 0xad3f9292, 0xbc219d9d, 0x48703838, 0x04f1f5f5, 0xdf63bcbc, 0xc177b6b6, 0x75afdada, 0x63422121, 0x30201010, 0x1ae5ffff, 0x0efdf3f3, 0x6dbfd2d2, 0x4c81cdcd, 0x14180c0c, 0x35261313, 0x2fc3ecec, 0xe1be5f5f, 0xa2359797, 0xcc884444, 0x392e1717, 0x5793c4c4, 0xf255a7a7, 0x82fc7e7e, 0x477a3d3d, 0xacc86464, 0xe7ba5d5d, 0x2b321919, 0x95e67373, 0xa0c06060, 0x98198181, 0xd19e4f4f, 0x7fa3dcdc, 0x66442222, 0x7e542a2a, 0xab3b9090, 0x830b8888, 0xca8c4646, 0x29c7eeee, 0xd36bb8b8, 0x3c281414, 0x79a7dede, 0xe2bc5e5e, 0x1d160b0b, 0x76addbdb, 0x3bdbe0e0, 0x56643232, 0x4e743a3a, 0x1e140a0a, 0xdb924949, 0x0a0c0606, 0x6c482424, 0xe4b85c5c, 0x5d9fc2c2, 0x6ebdd3d3, 0xef43acac, 0xa6c46262, 0xa8399191, 0xa4319595, 0x37d3e4e4, 0x8bf27979, 0x32d5e7e7, 0x438bc8c8, 0x596e3737, 0xb7da6d6d, 0x8c018d8d, 0x64b1d5d5, 0xd29c4e4e, 0xe049a9a9, 0xb4d86c6c, 0xfaac5656, 0x07f3f4f4, 0x25cfeaea, 0xafca6565, 0x8ef47a7a, 0xe947aeae, 0x18100808, 0xd56fbaba, 0x88f07878, 0x6f4a2525, 0x725c2e2e, 0x24381c1c, 0xf157a6a6, 0xc773b4b4, 0x5197c6c6, 0x23cbe8e8, 0x7ca1dddd, 0x9ce87474, 0x213e1f1f, 0xdd964b4b, 0xdc61bdbd, 0x860d8b8b, 0x850f8a8a, 0x90e07070, 0x427c3e3e, 0xc471b5b5, 0xaacc6666, 0xd8904848, 0x05060303, 0x01f7f6f6, 0x121c0e0e, 0xa3c26161, 0x5f6a3535, 0xf9ae5757, 0xd069b9b9, 0x91178686, 0x5899c1c1, 0x273a1d1d, 0xb9279e9e, 0x38d9e1e1, 0x13ebf8f8, 0xb32b9898, 0x33221111, 0xbbd26969, 0x70a9d9d9, 0x89078e8e, 0xa7339494, 0xb62d9b9b, 0x223c1e1e, 0x92158787, 0x20c9e9e9, 0x4987cece, 0xffaa5555, 0x78502828, 0x7aa5dfdf, 0x8f038c8c, 0xf859a1a1, 0x80098989, 0x171a0d0d, 0xda65bfbf, 0x31d7e6e6, 0xc6844242, 0xb8d06868, 0xc3824141, 0xb0299999, 0x775a2d2d, 0x111e0f0f, 0xcb7bb0b0, 0xfca85454, 0xd66dbbbb, 0x3a2c1616];
    var T3 = [0x63a5c663, 0x7c84f87c, 0x7799ee77, 0x7b8df67b, 0xf20dfff2, 0x6bbdd66b, 0x6fb1de6f, 0xc55491c5, 0x30506030, 0x01030201, 0x67a9ce67, 0x2b7d562b, 0xfe19e7fe, 0xd762b5d7, 0xabe64dab, 0x769aec76, 0xca458fca, 0x829d1f82, 0xc94089c9, 0x7d87fa7d, 0xfa15effa, 0x59ebb259, 0x47c98e47, 0xf00bfbf0, 0xadec41ad, 0xd467b3d4, 0xa2fd5fa2, 0xafea45af, 0x9cbf239c, 0xa4f753a4, 0x7296e472, 0xc05b9bc0, 0xb7c275b7, 0xfd1ce1fd, 0x93ae3d93, 0x266a4c26, 0x365a6c36, 0x3f417e3f, 0xf702f5f7, 0xcc4f83cc, 0x345c6834, 0xa5f451a5, 0xe534d1e5, 0xf108f9f1, 0x7193e271, 0xd873abd8, 0x31536231, 0x153f2a15, 0x040c0804, 0xc75295c7, 0x23654623, 0xc35e9dc3, 0x18283018, 0x96a13796, 0x050f0a05, 0x9ab52f9a, 0x07090e07, 0x12362412, 0x809b1b80, 0xe23ddfe2, 0xeb26cdeb, 0x27694e27, 0xb2cd7fb2, 0x759fea75, 0x091b1209, 0x839e1d83, 0x2c74582c, 0x1a2e341a, 0x1b2d361b, 0x6eb2dc6e, 0x5aeeb45a, 0xa0fb5ba0, 0x52f6a452, 0x3b4d763b, 0xd661b7d6, 0xb3ce7db3, 0x297b5229, 0xe33edde3, 0x2f715e2f, 0x84971384, 0x53f5a653, 0xd168b9d1, 0x00000000, 0xed2cc1ed, 0x20604020, 0xfc1fe3fc, 0xb1c879b1, 0x5bedb65b, 0x6abed46a, 0xcb468dcb, 0xbed967be, 0x394b7239, 0x4ade944a, 0x4cd4984c, 0x58e8b058, 0xcf4a85cf, 0xd06bbbd0, 0xef2ac5ef, 0xaae54faa, 0xfb16edfb, 0x43c58643, 0x4dd79a4d, 0x33556633, 0x85941185, 0x45cf8a45, 0xf910e9f9, 0x02060402, 0x7f81fe7f, 0x50f0a050, 0x3c44783c, 0x9fba259f, 0xa8e34ba8, 0x51f3a251, 0xa3fe5da3, 0x40c08040, 0x8f8a058f, 0x92ad3f92, 0x9dbc219d, 0x38487038, 0xf504f1f5, 0xbcdf63bc, 0xb6c177b6, 0xda75afda, 0x21634221, 0x10302010, 0xff1ae5ff, 0xf30efdf3, 0xd26dbfd2, 0xcd4c81cd, 0x0c14180c, 0x13352613, 0xec2fc3ec, 0x5fe1be5f, 0x97a23597, 0x44cc8844, 0x17392e17, 0xc45793c4, 0xa7f255a7, 0x7e82fc7e, 0x3d477a3d, 0x64acc864, 0x5de7ba5d, 0x192b3219, 0x7395e673, 0x60a0c060, 0x81981981, 0x4fd19e4f, 0xdc7fa3dc, 0x22664422, 0x2a7e542a, 0x90ab3b90, 0x88830b88, 0x46ca8c46, 0xee29c7ee, 0xb8d36bb8, 0x143c2814, 0xde79a7de, 0x5ee2bc5e, 0x0b1d160b, 0xdb76addb, 0xe03bdbe0, 0x32566432, 0x3a4e743a, 0x0a1e140a, 0x49db9249, 0x060a0c06, 0x246c4824, 0x5ce4b85c, 0xc25d9fc2, 0xd36ebdd3, 0xacef43ac, 0x62a6c462, 0x91a83991, 0x95a43195, 0xe437d3e4, 0x798bf279, 0xe732d5e7, 0xc8438bc8, 0x37596e37, 0x6db7da6d, 0x8d8c018d, 0xd564b1d5, 0x4ed29c4e, 0xa9e049a9, 0x6cb4d86c, 0x56faac56, 0xf407f3f4, 0xea25cfea, 0x65afca65, 0x7a8ef47a, 0xaee947ae, 0x08181008, 0xbad56fba, 0x7888f078, 0x256f4a25, 0x2e725c2e, 0x1c24381c, 0xa6f157a6, 0xb4c773b4, 0xc65197c6, 0xe823cbe8, 0xdd7ca1dd, 0x749ce874, 0x1f213e1f, 0x4bdd964b, 0xbddc61bd, 0x8b860d8b, 0x8a850f8a, 0x7090e070, 0x3e427c3e, 0xb5c471b5, 0x66aacc66, 0x48d89048, 0x03050603, 0xf601f7f6, 0x0e121c0e, 0x61a3c261, 0x355f6a35, 0x57f9ae57, 0xb9d069b9, 0x86911786, 0xc15899c1, 0x1d273a1d, 0x9eb9279e, 0xe138d9e1, 0xf813ebf8, 0x98b32b98, 0x11332211, 0x69bbd269, 0xd970a9d9, 0x8e89078e, 0x94a73394, 0x9bb62d9b, 0x1e223c1e, 0x87921587, 0xe920c9e9, 0xce4987ce, 0x55ffaa55, 0x28785028, 0xdf7aa5df, 0x8c8f038c, 0xa1f859a1, 0x89800989, 0x0d171a0d, 0xbfda65bf, 0xe631d7e6, 0x42c68442, 0x68b8d068, 0x41c38241, 0x99b02999, 0x2d775a2d, 0x0f111e0f, 0xb0cb7bb0, 0x54fca854, 0xbbd66dbb, 0x163a2c16];
    var T4 = [0x6363a5c6, 0x7c7c84f8, 0x777799ee, 0x7b7b8df6, 0xf2f20dff, 0x6b6bbdd6, 0x6f6fb1de, 0xc5c55491, 0x30305060, 0x01010302, 0x6767a9ce, 0x2b2b7d56, 0xfefe19e7, 0xd7d762b5, 0xababe64d, 0x76769aec, 0xcaca458f, 0x82829d1f, 0xc9c94089, 0x7d7d87fa, 0xfafa15ef, 0x5959ebb2, 0x4747c98e, 0xf0f00bfb, 0xadadec41, 0xd4d467b3, 0xa2a2fd5f, 0xafafea45, 0x9c9cbf23, 0xa4a4f753, 0x727296e4, 0xc0c05b9b, 0xb7b7c275, 0xfdfd1ce1, 0x9393ae3d, 0x26266a4c, 0x36365a6c, 0x3f3f417e, 0xf7f702f5, 0xcccc4f83, 0x34345c68, 0xa5a5f451, 0xe5e534d1, 0xf1f108f9, 0x717193e2, 0xd8d873ab, 0x31315362, 0x15153f2a, 0x04040c08, 0xc7c75295, 0x23236546, 0xc3c35e9d, 0x18182830, 0x9696a137, 0x05050f0a, 0x9a9ab52f, 0x0707090e, 0x12123624, 0x80809b1b, 0xe2e23ddf, 0xebeb26cd, 0x2727694e, 0xb2b2cd7f, 0x75759fea, 0x09091b12, 0x83839e1d, 0x2c2c7458, 0x1a1a2e34, 0x1b1b2d36, 0x6e6eb2dc, 0x5a5aeeb4, 0xa0a0fb5b, 0x5252f6a4, 0x3b3b4d76, 0xd6d661b7, 0xb3b3ce7d, 0x29297b52, 0xe3e33edd, 0x2f2f715e, 0x84849713, 0x5353f5a6, 0xd1d168b9, 0x00000000, 0xeded2cc1, 0x20206040, 0xfcfc1fe3, 0xb1b1c879, 0x5b5bedb6, 0x6a6abed4, 0xcbcb468d, 0xbebed967, 0x39394b72, 0x4a4ade94, 0x4c4cd498, 0x5858e8b0, 0xcfcf4a85, 0xd0d06bbb, 0xefef2ac5, 0xaaaae54f, 0xfbfb16ed, 0x4343c586, 0x4d4dd79a, 0x33335566, 0x85859411, 0x4545cf8a, 0xf9f910e9, 0x02020604, 0x7f7f81fe, 0x5050f0a0, 0x3c3c4478, 0x9f9fba25, 0xa8a8e34b, 0x5151f3a2, 0xa3a3fe5d, 0x4040c080, 0x8f8f8a05, 0x9292ad3f, 0x9d9dbc21, 0x38384870, 0xf5f504f1, 0xbcbcdf63, 0xb6b6c177, 0xdada75af, 0x21216342, 0x10103020, 0xffff1ae5, 0xf3f30efd, 0xd2d26dbf, 0xcdcd4c81, 0x0c0c1418, 0x13133526, 0xecec2fc3, 0x5f5fe1be, 0x9797a235, 0x4444cc88, 0x1717392e, 0xc4c45793, 0xa7a7f255, 0x7e7e82fc, 0x3d3d477a, 0x6464acc8, 0x5d5de7ba, 0x19192b32, 0x737395e6, 0x6060a0c0, 0x81819819, 0x4f4fd19e, 0xdcdc7fa3, 0x22226644, 0x2a2a7e54, 0x9090ab3b, 0x8888830b, 0x4646ca8c, 0xeeee29c7, 0xb8b8d36b, 0x14143c28, 0xdede79a7, 0x5e5ee2bc, 0x0b0b1d16, 0xdbdb76ad, 0xe0e03bdb, 0x32325664, 0x3a3a4e74, 0x0a0a1e14, 0x4949db92, 0x06060a0c, 0x24246c48, 0x5c5ce4b8, 0xc2c25d9f, 0xd3d36ebd, 0xacacef43, 0x6262a6c4, 0x9191a839, 0x9595a431, 0xe4e437d3, 0x79798bf2, 0xe7e732d5, 0xc8c8438b, 0x3737596e, 0x6d6db7da, 0x8d8d8c01, 0xd5d564b1, 0x4e4ed29c, 0xa9a9e049, 0x6c6cb4d8, 0x5656faac, 0xf4f407f3, 0xeaea25cf, 0x6565afca, 0x7a7a8ef4, 0xaeaee947, 0x08081810, 0xbabad56f, 0x787888f0, 0x25256f4a, 0x2e2e725c, 0x1c1c2438, 0xa6a6f157, 0xb4b4c773, 0xc6c65197, 0xe8e823cb, 0xdddd7ca1, 0x74749ce8, 0x1f1f213e, 0x4b4bdd96, 0xbdbddc61, 0x8b8b860d, 0x8a8a850f, 0x707090e0, 0x3e3e427c, 0xb5b5c471, 0x6666aacc, 0x4848d890, 0x03030506, 0xf6f601f7, 0x0e0e121c, 0x6161a3c2, 0x35355f6a, 0x5757f9ae, 0xb9b9d069, 0x86869117, 0xc1c15899, 0x1d1d273a, 0x9e9eb927, 0xe1e138d9, 0xf8f813eb, 0x9898b32b, 0x11113322, 0x6969bbd2, 0xd9d970a9, 0x8e8e8907, 0x9494a733, 0x9b9bb62d, 0x1e1e223c, 0x87879215, 0xe9e920c9, 0xcece4987, 0x5555ffaa, 0x28287850, 0xdfdf7aa5, 0x8c8c8f03, 0xa1a1f859, 0x89898009, 0x0d0d171a, 0xbfbfda65, 0xe6e631d7, 0x4242c684, 0x6868b8d0, 0x4141c382, 0x9999b029, 0x2d2d775a, 0x0f0f111e, 0xb0b0cb7b, 0x5454fca8, 0xbbbbd66d, 0x16163a2c];

    // Transformations for decryption
    var T5 = [0x51f4a750, 0x7e416553, 0x1a17a4c3, 0x3a275e96, 0x3bab6bcb, 0x1f9d45f1, 0xacfa58ab, 0x4be30393, 0x2030fa55, 0xad766df6, 0x88cc7691, 0xf5024c25, 0x4fe5d7fc, 0xc52acbd7, 0x26354480, 0xb562a38f, 0xdeb15a49, 0x25ba1b67, 0x45ea0e98, 0x5dfec0e1, 0xc32f7502, 0x814cf012, 0x8d4697a3, 0x6bd3f9c6, 0x038f5fe7, 0x15929c95, 0xbf6d7aeb, 0x955259da, 0xd4be832d, 0x587421d3, 0x49e06929, 0x8ec9c844, 0x75c2896a, 0xf48e7978, 0x99583e6b, 0x27b971dd, 0xbee14fb6, 0xf088ad17, 0xc920ac66, 0x7dce3ab4, 0x63df4a18, 0xe51a3182, 0x97513360, 0x62537f45, 0xb16477e0, 0xbb6bae84, 0xfe81a01c, 0xf9082b94, 0x70486858, 0x8f45fd19, 0x94de6c87, 0x527bf8b7, 0xab73d323, 0x724b02e2, 0xe31f8f57, 0x6655ab2a, 0xb2eb2807, 0x2fb5c203, 0x86c57b9a, 0xd33708a5, 0x302887f2, 0x23bfa5b2, 0x02036aba, 0xed16825c, 0x8acf1c2b, 0xa779b492, 0xf307f2f0, 0x4e69e2a1, 0x65daf4cd, 0x0605bed5, 0xd134621f, 0xc4a6fe8a, 0x342e539d, 0xa2f355a0, 0x058ae132, 0xa4f6eb75, 0x0b83ec39, 0x4060efaa, 0x5e719f06, 0xbd6e1051, 0x3e218af9, 0x96dd063d, 0xdd3e05ae, 0x4de6bd46, 0x91548db5, 0x71c45d05, 0x0406d46f, 0x605015ff, 0x1998fb24, 0xd6bde997, 0x894043cc, 0x67d99e77, 0xb0e842bd, 0x07898b88, 0xe7195b38, 0x79c8eedb, 0xa17c0a47, 0x7c420fe9, 0xf8841ec9, 0x00000000, 0x09808683, 0x322bed48, 0x1e1170ac, 0x6c5a724e, 0xfd0efffb, 0x0f853856, 0x3daed51e, 0x362d3927, 0x0a0fd964, 0x685ca621, 0x9b5b54d1, 0x24362e3a, 0x0c0a67b1, 0x9357e70f, 0xb4ee96d2, 0x1b9b919e, 0x80c0c54f, 0x61dc20a2, 0x5a774b69, 0x1c121a16, 0xe293ba0a, 0xc0a02ae5, 0x3c22e043, 0x121b171d, 0x0e090d0b, 0xf28bc7ad, 0x2db6a8b9, 0x141ea9c8, 0x57f11985, 0xaf75074c, 0xee99ddbb, 0xa37f60fd, 0xf701269f, 0x5c72f5bc, 0x44663bc5, 0x5bfb7e34, 0x8b432976, 0xcb23c6dc, 0xb6edfc68, 0xb8e4f163, 0xd731dcca, 0x42638510, 0x13972240, 0x84c61120, 0x854a247d, 0xd2bb3df8, 0xaef93211, 0xc729a16d, 0x1d9e2f4b, 0xdcb230f3, 0x0d8652ec, 0x77c1e3d0, 0x2bb3166c, 0xa970b999, 0x119448fa, 0x47e96422, 0xa8fc8cc4, 0xa0f03f1a, 0x567d2cd8, 0x223390ef, 0x87494ec7, 0xd938d1c1, 0x8ccaa2fe, 0x98d40b36, 0xa6f581cf, 0xa57ade28, 0xdab78e26, 0x3fadbfa4, 0x2c3a9de4, 0x5078920d, 0x6a5fcc9b, 0x547e4662, 0xf68d13c2, 0x90d8b8e8, 0x2e39f75e, 0x82c3aff5, 0x9f5d80be, 0x69d0937c, 0x6fd52da9, 0xcf2512b3, 0xc8ac993b, 0x10187da7, 0xe89c636e, 0xdb3bbb7b, 0xcd267809, 0x6e5918f4, 0xec9ab701, 0x834f9aa8, 0xe6956e65, 0xaaffe67e, 0x21bccf08, 0xef15e8e6, 0xbae79bd9, 0x4a6f36ce, 0xea9f09d4, 0x29b07cd6, 0x31a4b2af, 0x2a3f2331, 0xc6a59430, 0x35a266c0, 0x744ebc37, 0xfc82caa6, 0xe090d0b0, 0x33a7d815, 0xf104984a, 0x41ecdaf7, 0x7fcd500e, 0x1791f62f, 0x764dd68d, 0x43efb04d, 0xccaa4d54, 0xe49604df, 0x9ed1b5e3, 0x4c6a881b, 0xc12c1fb8, 0x4665517f, 0x9d5eea04, 0x018c355d, 0xfa877473, 0xfb0b412e, 0xb3671d5a, 0x92dbd252, 0xe9105633, 0x6dd64713, 0x9ad7618c, 0x37a10c7a, 0x59f8148e, 0xeb133c89, 0xcea927ee, 0xb761c935, 0xe11ce5ed, 0x7a47b13c, 0x9cd2df59, 0x55f2733f, 0x1814ce79, 0x73c737bf, 0x53f7cdea, 0x5ffdaa5b, 0xdf3d6f14, 0x7844db86, 0xcaaff381, 0xb968c43e, 0x3824342c, 0xc2a3405f, 0x161dc372, 0xbce2250c, 0x283c498b, 0xff0d9541, 0x39a80171, 0x080cb3de, 0xd8b4e49c, 0x6456c190, 0x7bcb8461, 0xd532b670, 0x486c5c74, 0xd0b85742];
    var T6 = [0x5051f4a7, 0x537e4165, 0xc31a17a4, 0x963a275e, 0xcb3bab6b, 0xf11f9d45, 0xabacfa58, 0x934be303, 0x552030fa, 0xf6ad766d, 0x9188cc76, 0x25f5024c, 0xfc4fe5d7, 0xd7c52acb, 0x80263544, 0x8fb562a3, 0x49deb15a, 0x6725ba1b, 0x9845ea0e, 0xe15dfec0, 0x02c32f75, 0x12814cf0, 0xa38d4697, 0xc66bd3f9, 0xe7038f5f, 0x9515929c, 0xebbf6d7a, 0xda955259, 0x2dd4be83, 0xd3587421, 0x2949e069, 0x448ec9c8, 0x6a75c289, 0x78f48e79, 0x6b99583e, 0xdd27b971, 0xb6bee14f, 0x17f088ad, 0x66c920ac, 0xb47dce3a, 0x1863df4a, 0x82e51a31, 0x60975133, 0x4562537f, 0xe0b16477, 0x84bb6bae, 0x1cfe81a0, 0x94f9082b, 0x58704868, 0x198f45fd, 0x8794de6c, 0xb7527bf8, 0x23ab73d3, 0xe2724b02, 0x57e31f8f, 0x2a6655ab, 0x07b2eb28, 0x032fb5c2, 0x9a86c57b, 0xa5d33708, 0xf2302887, 0xb223bfa5, 0xba02036a, 0x5ced1682, 0x2b8acf1c, 0x92a779b4, 0xf0f307f2, 0xa14e69e2, 0xcd65daf4, 0xd50605be, 0x1fd13462, 0x8ac4a6fe, 0x9d342e53, 0xa0a2f355, 0x32058ae1, 0x75a4f6eb, 0x390b83ec, 0xaa4060ef, 0x065e719f, 0x51bd6e10, 0xf93e218a, 0x3d96dd06, 0xaedd3e05, 0x464de6bd, 0xb591548d, 0x0571c45d, 0x6f0406d4, 0xff605015, 0x241998fb, 0x97d6bde9, 0xcc894043, 0x7767d99e, 0xbdb0e842, 0x8807898b, 0x38e7195b, 0xdb79c8ee, 0x47a17c0a, 0xe97c420f, 0xc9f8841e, 0x00000000, 0x83098086, 0x48322bed, 0xac1e1170, 0x4e6c5a72, 0xfbfd0eff, 0x560f8538, 0x1e3daed5, 0x27362d39, 0x640a0fd9, 0x21685ca6, 0xd19b5b54, 0x3a24362e, 0xb10c0a67, 0x0f9357e7, 0xd2b4ee96, 0x9e1b9b91, 0x4f80c0c5, 0xa261dc20, 0x695a774b, 0x161c121a, 0x0ae293ba, 0xe5c0a02a, 0x433c22e0, 0x1d121b17, 0x0b0e090d, 0xadf28bc7, 0xb92db6a8, 0xc8141ea9, 0x8557f119, 0x4caf7507, 0xbbee99dd, 0xfda37f60, 0x9ff70126, 0xbc5c72f5, 0xc544663b, 0x345bfb7e, 0x768b4329, 0xdccb23c6, 0x68b6edfc, 0x63b8e4f1, 0xcad731dc, 0x10426385, 0x40139722, 0x2084c611, 0x7d854a24, 0xf8d2bb3d, 0x11aef932, 0x6dc729a1, 0x4b1d9e2f, 0xf3dcb230, 0xec0d8652, 0xd077c1e3, 0x6c2bb316, 0x99a970b9, 0xfa119448, 0x2247e964, 0xc4a8fc8c, 0x1aa0f03f, 0xd8567d2c, 0xef223390, 0xc787494e, 0xc1d938d1, 0xfe8ccaa2, 0x3698d40b, 0xcfa6f581, 0x28a57ade, 0x26dab78e, 0xa43fadbf, 0xe42c3a9d, 0x0d507892, 0x9b6a5fcc, 0x62547e46, 0xc2f68d13, 0xe890d8b8, 0x5e2e39f7, 0xf582c3af, 0xbe9f5d80, 0x7c69d093, 0xa96fd52d, 0xb3cf2512, 0x3bc8ac99, 0xa710187d, 0x6ee89c63, 0x7bdb3bbb, 0x09cd2678, 0xf46e5918, 0x01ec9ab7, 0xa8834f9a, 0x65e6956e, 0x7eaaffe6, 0x0821bccf, 0xe6ef15e8, 0xd9bae79b, 0xce4a6f36, 0xd4ea9f09, 0xd629b07c, 0xaf31a4b2, 0x312a3f23, 0x30c6a594, 0xc035a266, 0x37744ebc, 0xa6fc82ca, 0xb0e090d0, 0x1533a7d8, 0x4af10498, 0xf741ecda, 0x0e7fcd50, 0x2f1791f6, 0x8d764dd6, 0x4d43efb0, 0x54ccaa4d, 0xdfe49604, 0xe39ed1b5, 0x1b4c6a88, 0xb8c12c1f, 0x7f466551, 0x049d5eea, 0x5d018c35, 0x73fa8774, 0x2efb0b41, 0x5ab3671d, 0x5292dbd2, 0x33e91056, 0x136dd647, 0x8c9ad761, 0x7a37a10c, 0x8e59f814, 0x89eb133c, 0xeecea927, 0x35b761c9, 0xede11ce5, 0x3c7a47b1, 0x599cd2df, 0x3f55f273, 0x791814ce, 0xbf73c737, 0xea53f7cd, 0x5b5ffdaa, 0x14df3d6f, 0x867844db, 0x81caaff3, 0x3eb968c4, 0x2c382434, 0x5fc2a340, 0x72161dc3, 0x0cbce225, 0x8b283c49, 0x41ff0d95, 0x7139a801, 0xde080cb3, 0x9cd8b4e4, 0x906456c1, 0x617bcb84, 0x70d532b6, 0x74486c5c, 0x42d0b857];
    var T7 = [0xa75051f4, 0x65537e41, 0xa4c31a17, 0x5e963a27, 0x6bcb3bab, 0x45f11f9d, 0x58abacfa, 0x03934be3, 0xfa552030, 0x6df6ad76, 0x769188cc, 0x4c25f502, 0xd7fc4fe5, 0xcbd7c52a, 0x44802635, 0xa38fb562, 0x5a49deb1, 0x1b6725ba, 0x0e9845ea, 0xc0e15dfe, 0x7502c32f, 0xf012814c, 0x97a38d46, 0xf9c66bd3, 0x5fe7038f, 0x9c951592, 0x7aebbf6d, 0x59da9552, 0x832dd4be, 0x21d35874, 0x692949e0, 0xc8448ec9, 0x896a75c2, 0x7978f48e, 0x3e6b9958, 0x71dd27b9, 0x4fb6bee1, 0xad17f088, 0xac66c920, 0x3ab47dce, 0x4a1863df, 0x3182e51a, 0x33609751, 0x7f456253, 0x77e0b164, 0xae84bb6b, 0xa01cfe81, 0x2b94f908, 0x68587048, 0xfd198f45, 0x6c8794de, 0xf8b7527b, 0xd323ab73, 0x02e2724b, 0x8f57e31f, 0xab2a6655, 0x2807b2eb, 0xc2032fb5, 0x7b9a86c5, 0x08a5d337, 0x87f23028, 0xa5b223bf, 0x6aba0203, 0x825ced16, 0x1c2b8acf, 0xb492a779, 0xf2f0f307, 0xe2a14e69, 0xf4cd65da, 0xbed50605, 0x621fd134, 0xfe8ac4a6, 0x539d342e, 0x55a0a2f3, 0xe132058a, 0xeb75a4f6, 0xec390b83, 0xefaa4060, 0x9f065e71, 0x1051bd6e, 0x8af93e21, 0x063d96dd, 0x05aedd3e, 0xbd464de6, 0x8db59154, 0x5d0571c4, 0xd46f0406, 0x15ff6050, 0xfb241998, 0xe997d6bd, 0x43cc8940, 0x9e7767d9, 0x42bdb0e8, 0x8b880789, 0x5b38e719, 0xeedb79c8, 0x0a47a17c, 0x0fe97c42, 0x1ec9f884, 0x00000000, 0x86830980, 0xed48322b, 0x70ac1e11, 0x724e6c5a, 0xfffbfd0e, 0x38560f85, 0xd51e3dae, 0x3927362d, 0xd9640a0f, 0xa621685c, 0x54d19b5b, 0x2e3a2436, 0x67b10c0a, 0xe70f9357, 0x96d2b4ee, 0x919e1b9b, 0xc54f80c0, 0x20a261dc, 0x4b695a77, 0x1a161c12, 0xba0ae293, 0x2ae5c0a0, 0xe0433c22, 0x171d121b, 0x0d0b0e09, 0xc7adf28b, 0xa8b92db6, 0xa9c8141e, 0x198557f1, 0x074caf75, 0xddbbee99, 0x60fda37f, 0x269ff701, 0xf5bc5c72, 0x3bc54466, 0x7e345bfb, 0x29768b43, 0xc6dccb23, 0xfc68b6ed, 0xf163b8e4, 0xdccad731, 0x85104263, 0x22401397, 0x112084c6, 0x247d854a, 0x3df8d2bb, 0x3211aef9, 0xa16dc729, 0x2f4b1d9e, 0x30f3dcb2, 0x52ec0d86, 0xe3d077c1, 0x166c2bb3, 0xb999a970, 0x48fa1194, 0x642247e9, 0x8cc4a8fc, 0x3f1aa0f0, 0x2cd8567d, 0x90ef2233, 0x4ec78749, 0xd1c1d938, 0xa2fe8cca, 0x0b3698d4, 0x81cfa6f5, 0xde28a57a, 0x8e26dab7, 0xbfa43fad, 0x9de42c3a, 0x920d5078, 0xcc9b6a5f, 0x4662547e, 0x13c2f68d, 0xb8e890d8, 0xf75e2e39, 0xaff582c3, 0x80be9f5d, 0x937c69d0, 0x2da96fd5, 0x12b3cf25, 0x993bc8ac, 0x7da71018, 0x636ee89c, 0xbb7bdb3b, 0x7809cd26, 0x18f46e59, 0xb701ec9a, 0x9aa8834f, 0x6e65e695, 0xe67eaaff, 0xcf0821bc, 0xe8e6ef15, 0x9bd9bae7, 0x36ce4a6f, 0x09d4ea9f, 0x7cd629b0, 0xb2af31a4, 0x23312a3f, 0x9430c6a5, 0x66c035a2, 0xbc37744e, 0xcaa6fc82, 0xd0b0e090, 0xd81533a7, 0x984af104, 0xdaf741ec, 0x500e7fcd, 0xf62f1791, 0xd68d764d, 0xb04d43ef, 0x4d54ccaa, 0x04dfe496, 0xb5e39ed1, 0x881b4c6a, 0x1fb8c12c, 0x517f4665, 0xea049d5e, 0x355d018c, 0x7473fa87, 0x412efb0b, 0x1d5ab367, 0xd25292db, 0x5633e910, 0x47136dd6, 0x618c9ad7, 0x0c7a37a1, 0x148e59f8, 0x3c89eb13, 0x27eecea9, 0xc935b761, 0xe5ede11c, 0xb13c7a47, 0xdf599cd2, 0x733f55f2, 0xce791814, 0x37bf73c7, 0xcdea53f7, 0xaa5b5ffd, 0x6f14df3d, 0xdb867844, 0xf381caaf, 0xc43eb968, 0x342c3824, 0x405fc2a3, 0xc372161d, 0x250cbce2, 0x498b283c, 0x9541ff0d, 0x017139a8, 0xb3de080c, 0xe49cd8b4, 0xc1906456, 0x84617bcb, 0xb670d532, 0x5c74486c, 0x5742d0b8];
    var T8 = [0xf4a75051, 0x4165537e, 0x17a4c31a, 0x275e963a, 0xab6bcb3b, 0x9d45f11f, 0xfa58abac, 0xe303934b, 0x30fa5520, 0x766df6ad, 0xcc769188, 0x024c25f5, 0xe5d7fc4f, 0x2acbd7c5, 0x35448026, 0x62a38fb5, 0xb15a49de, 0xba1b6725, 0xea0e9845, 0xfec0e15d, 0x2f7502c3, 0x4cf01281, 0x4697a38d, 0xd3f9c66b, 0x8f5fe703, 0x929c9515, 0x6d7aebbf, 0x5259da95, 0xbe832dd4, 0x7421d358, 0xe0692949, 0xc9c8448e, 0xc2896a75, 0x8e7978f4, 0x583e6b99, 0xb971dd27, 0xe14fb6be, 0x88ad17f0, 0x20ac66c9, 0xce3ab47d, 0xdf4a1863, 0x1a3182e5, 0x51336097, 0x537f4562, 0x6477e0b1, 0x6bae84bb, 0x81a01cfe, 0x082b94f9, 0x48685870, 0x45fd198f, 0xde6c8794, 0x7bf8b752, 0x73d323ab, 0x4b02e272, 0x1f8f57e3, 0x55ab2a66, 0xeb2807b2, 0xb5c2032f, 0xc57b9a86, 0x3708a5d3, 0x2887f230, 0xbfa5b223, 0x036aba02, 0x16825ced, 0xcf1c2b8a, 0x79b492a7, 0x07f2f0f3, 0x69e2a14e, 0xdaf4cd65, 0x05bed506, 0x34621fd1, 0xa6fe8ac4, 0x2e539d34, 0xf355a0a2, 0x8ae13205, 0xf6eb75a4, 0x83ec390b, 0x60efaa40, 0x719f065e, 0x6e1051bd, 0x218af93e, 0xdd063d96, 0x3e05aedd, 0xe6bd464d, 0x548db591, 0xc45d0571, 0x06d46f04, 0x5015ff60, 0x98fb2419, 0xbde997d6, 0x4043cc89, 0xd99e7767, 0xe842bdb0, 0x898b8807, 0x195b38e7, 0xc8eedb79, 0x7c0a47a1, 0x420fe97c, 0x841ec9f8, 0x00000000, 0x80868309, 0x2bed4832, 0x1170ac1e, 0x5a724e6c, 0x0efffbfd, 0x8538560f, 0xaed51e3d, 0x2d392736, 0x0fd9640a, 0x5ca62168, 0x5b54d19b, 0x362e3a24, 0x0a67b10c, 0x57e70f93, 0xee96d2b4, 0x9b919e1b, 0xc0c54f80, 0xdc20a261, 0x774b695a, 0x121a161c, 0x93ba0ae2, 0xa02ae5c0, 0x22e0433c, 0x1b171d12, 0x090d0b0e, 0x8bc7adf2, 0xb6a8b92d, 0x1ea9c814, 0xf1198557, 0x75074caf, 0x99ddbbee, 0x7f60fda3, 0x01269ff7, 0x72f5bc5c, 0x663bc544, 0xfb7e345b, 0x4329768b, 0x23c6dccb, 0xedfc68b6, 0xe4f163b8, 0x31dccad7, 0x63851042, 0x97224013, 0xc6112084, 0x4a247d85, 0xbb3df8d2, 0xf93211ae, 0x29a16dc7, 0x9e2f4b1d, 0xb230f3dc, 0x8652ec0d, 0xc1e3d077, 0xb3166c2b, 0x70b999a9, 0x9448fa11, 0xe9642247, 0xfc8cc4a8, 0xf03f1aa0, 0x7d2cd856, 0x3390ef22, 0x494ec787, 0x38d1c1d9, 0xcaa2fe8c, 0xd40b3698, 0xf581cfa6, 0x7ade28a5, 0xb78e26da, 0xadbfa43f, 0x3a9de42c, 0x78920d50, 0x5fcc9b6a, 0x7e466254, 0x8d13c2f6, 0xd8b8e890, 0x39f75e2e, 0xc3aff582, 0x5d80be9f, 0xd0937c69, 0xd52da96f, 0x2512b3cf, 0xac993bc8, 0x187da710, 0x9c636ee8, 0x3bbb7bdb, 0x267809cd, 0x5918f46e, 0x9ab701ec, 0x4f9aa883, 0x956e65e6, 0xffe67eaa, 0xbccf0821, 0x15e8e6ef, 0xe79bd9ba, 0x6f36ce4a, 0x9f09d4ea, 0xb07cd629, 0xa4b2af31, 0x3f23312a, 0xa59430c6, 0xa266c035, 0x4ebc3774, 0x82caa6fc, 0x90d0b0e0, 0xa7d81533, 0x04984af1, 0xecdaf741, 0xcd500e7f, 0x91f62f17, 0x4dd68d76, 0xefb04d43, 0xaa4d54cc, 0x9604dfe4, 0xd1b5e39e, 0x6a881b4c, 0x2c1fb8c1, 0x65517f46, 0x5eea049d, 0x8c355d01, 0x877473fa, 0x0b412efb, 0x671d5ab3, 0xdbd25292, 0x105633e9, 0xd647136d, 0xd7618c9a, 0xa10c7a37, 0xf8148e59, 0x133c89eb, 0xa927eece, 0x61c935b7, 0x1ce5ede1, 0x47b13c7a, 0xd2df599c, 0xf2733f55, 0x14ce7918, 0xc737bf73, 0xf7cdea53, 0xfdaa5b5f, 0x3d6f14df, 0x44db8678, 0xaff381ca, 0x68c43eb9, 0x24342c38, 0xa3405fc2, 0x1dc37216, 0xe2250cbc, 0x3c498b28, 0x0d9541ff, 0xa8017139, 0x0cb3de08, 0xb4e49cd8, 0x56c19064, 0xcb84617b, 0x32b670d5, 0x6c5c7448, 0xb85742d0];

    // Transformations for decryption key expansion
    var U1 = [0x00000000, 0x0e090d0b, 0x1c121a16, 0x121b171d, 0x3824342c, 0x362d3927, 0x24362e3a, 0x2a3f2331, 0x70486858, 0x7e416553, 0x6c5a724e, 0x62537f45, 0x486c5c74, 0x4665517f, 0x547e4662, 0x5a774b69, 0xe090d0b0, 0xee99ddbb, 0xfc82caa6, 0xf28bc7ad, 0xd8b4e49c, 0xd6bde997, 0xc4a6fe8a, 0xcaaff381, 0x90d8b8e8, 0x9ed1b5e3, 0x8ccaa2fe, 0x82c3aff5, 0xa8fc8cc4, 0xa6f581cf, 0xb4ee96d2, 0xbae79bd9, 0xdb3bbb7b, 0xd532b670, 0xc729a16d, 0xc920ac66, 0xe31f8f57, 0xed16825c, 0xff0d9541, 0xf104984a, 0xab73d323, 0xa57ade28, 0xb761c935, 0xb968c43e, 0x9357e70f, 0x9d5eea04, 0x8f45fd19, 0x814cf012, 0x3bab6bcb, 0x35a266c0, 0x27b971dd, 0x29b07cd6, 0x038f5fe7, 0x0d8652ec, 0x1f9d45f1, 0x119448fa, 0x4be30393, 0x45ea0e98, 0x57f11985, 0x59f8148e, 0x73c737bf, 0x7dce3ab4, 0x6fd52da9, 0x61dc20a2, 0xad766df6, 0xa37f60fd, 0xb16477e0, 0xbf6d7aeb, 0x955259da, 0x9b5b54d1, 0x894043cc, 0x87494ec7, 0xdd3e05ae, 0xd33708a5, 0xc12c1fb8, 0xcf2512b3, 0xe51a3182, 0xeb133c89, 0xf9082b94, 0xf701269f, 0x4de6bd46, 0x43efb04d, 0x51f4a750, 0x5ffdaa5b, 0x75c2896a, 0x7bcb8461, 0x69d0937c, 0x67d99e77, 0x3daed51e, 0x33a7d815, 0x21bccf08, 0x2fb5c203, 0x058ae132, 0x0b83ec39, 0x1998fb24, 0x1791f62f, 0x764dd68d, 0x7844db86, 0x6a5fcc9b, 0x6456c190, 0x4e69e2a1, 0x4060efaa, 0x527bf8b7, 0x5c72f5bc, 0x0605bed5, 0x080cb3de, 0x1a17a4c3, 0x141ea9c8, 0x3e218af9, 0x302887f2, 0x223390ef, 0x2c3a9de4, 0x96dd063d, 0x98d40b36, 0x8acf1c2b, 0x84c61120, 0xaef93211, 0xa0f03f1a, 0xb2eb2807, 0xbce2250c, 0xe6956e65, 0xe89c636e, 0xfa877473, 0xf48e7978, 0xdeb15a49, 0xd0b85742, 0xc2a3405f, 0xccaa4d54, 0x41ecdaf7, 0x4fe5d7fc, 0x5dfec0e1, 0x53f7cdea, 0x79c8eedb, 0x77c1e3d0, 0x65daf4cd, 0x6bd3f9c6, 0x31a4b2af, 0x3fadbfa4, 0x2db6a8b9, 0x23bfa5b2, 0x09808683, 0x07898b88, 0x15929c95, 0x1b9b919e, 0xa17c0a47, 0xaf75074c, 0xbd6e1051, 0xb3671d5a, 0x99583e6b, 0x97513360, 0x854a247d, 0x8b432976, 0xd134621f, 0xdf3d6f14, 0xcd267809, 0xc32f7502, 0xe9105633, 0xe7195b38, 0xf5024c25, 0xfb0b412e, 0x9ad7618c, 0x94de6c87, 0x86c57b9a, 0x88cc7691, 0xa2f355a0, 0xacfa58ab, 0xbee14fb6, 0xb0e842bd, 0xea9f09d4, 0xe49604df, 0xf68d13c2, 0xf8841ec9, 0xd2bb3df8, 0xdcb230f3, 0xcea927ee, 0xc0a02ae5, 0x7a47b13c, 0x744ebc37, 0x6655ab2a, 0x685ca621, 0x42638510, 0x4c6a881b, 0x5e719f06, 0x5078920d, 0x0a0fd964, 0x0406d46f, 0x161dc372, 0x1814ce79, 0x322bed48, 0x3c22e043, 0x2e39f75e, 0x2030fa55, 0xec9ab701, 0xe293ba0a, 0xf088ad17, 0xfe81a01c, 0xd4be832d, 0xdab78e26, 0xc8ac993b, 0xc6a59430, 0x9cd2df59, 0x92dbd252, 0x80c0c54f, 0x8ec9c844, 0xa4f6eb75, 0xaaffe67e, 0xb8e4f163, 0xb6edfc68, 0x0c0a67b1, 0x02036aba, 0x10187da7, 0x1e1170ac, 0x342e539d, 0x3a275e96, 0x283c498b, 0x26354480, 0x7c420fe9, 0x724b02e2, 0x605015ff, 0x6e5918f4, 0x44663bc5, 0x4a6f36ce, 0x587421d3, 0x567d2cd8, 0x37a10c7a, 0x39a80171, 0x2bb3166c, 0x25ba1b67, 0x0f853856, 0x018c355d, 0x13972240, 0x1d9e2f4b, 0x47e96422, 0x49e06929, 0x5bfb7e34, 0x55f2733f, 0x7fcd500e, 0x71c45d05, 0x63df4a18, 0x6dd64713, 0xd731dcca, 0xd938d1c1, 0xcb23c6dc, 0xc52acbd7, 0xef15e8e6, 0xe11ce5ed, 0xf307f2f0, 0xfd0efffb, 0xa779b492, 0xa970b999, 0xbb6bae84, 0xb562a38f, 0x9f5d80be, 0x91548db5, 0x834f9aa8, 0x8d4697a3];
    var U2 = [0x00000000, 0x0b0e090d, 0x161c121a, 0x1d121b17, 0x2c382434, 0x27362d39, 0x3a24362e, 0x312a3f23, 0x58704868, 0x537e4165, 0x4e6c5a72, 0x4562537f, 0x74486c5c, 0x7f466551, 0x62547e46, 0x695a774b, 0xb0e090d0, 0xbbee99dd, 0xa6fc82ca, 0xadf28bc7, 0x9cd8b4e4, 0x97d6bde9, 0x8ac4a6fe, 0x81caaff3, 0xe890d8b8, 0xe39ed1b5, 0xfe8ccaa2, 0xf582c3af, 0xc4a8fc8c, 0xcfa6f581, 0xd2b4ee96, 0xd9bae79b, 0x7bdb3bbb, 0x70d532b6, 0x6dc729a1, 0x66c920ac, 0x57e31f8f, 0x5ced1682, 0x41ff0d95, 0x4af10498, 0x23ab73d3, 0x28a57ade, 0x35b761c9, 0x3eb968c4, 0x0f9357e7, 0x049d5eea, 0x198f45fd, 0x12814cf0, 0xcb3bab6b, 0xc035a266, 0xdd27b971, 0xd629b07c, 0xe7038f5f, 0xec0d8652, 0xf11f9d45, 0xfa119448, 0x934be303, 0x9845ea0e, 0x8557f119, 0x8e59f814, 0xbf73c737, 0xb47dce3a, 0xa96fd52d, 0xa261dc20, 0xf6ad766d, 0xfda37f60, 0xe0b16477, 0xebbf6d7a, 0xda955259, 0xd19b5b54, 0xcc894043, 0xc787494e, 0xaedd3e05, 0xa5d33708, 0xb8c12c1f, 0xb3cf2512, 0x82e51a31, 0x89eb133c, 0x94f9082b, 0x9ff70126, 0x464de6bd, 0x4d43efb0, 0x5051f4a7, 0x5b5ffdaa, 0x6a75c289, 0x617bcb84, 0x7c69d093, 0x7767d99e, 0x1e3daed5, 0x1533a7d8, 0x0821bccf, 0x032fb5c2, 0x32058ae1, 0x390b83ec, 0x241998fb, 0x2f1791f6, 0x8d764dd6, 0x867844db, 0x9b6a5fcc, 0x906456c1, 0xa14e69e2, 0xaa4060ef, 0xb7527bf8, 0xbc5c72f5, 0xd50605be, 0xde080cb3, 0xc31a17a4, 0xc8141ea9, 0xf93e218a, 0xf2302887, 0xef223390, 0xe42c3a9d, 0x3d96dd06, 0x3698d40b, 0x2b8acf1c, 0x2084c611, 0x11aef932, 0x1aa0f03f, 0x07b2eb28, 0x0cbce225, 0x65e6956e, 0x6ee89c63, 0x73fa8774, 0x78f48e79, 0x49deb15a, 0x42d0b857, 0x5fc2a340, 0x54ccaa4d, 0xf741ecda, 0xfc4fe5d7, 0xe15dfec0, 0xea53f7cd, 0xdb79c8ee, 0xd077c1e3, 0xcd65daf4, 0xc66bd3f9, 0xaf31a4b2, 0xa43fadbf, 0xb92db6a8, 0xb223bfa5, 0x83098086, 0x8807898b, 0x9515929c, 0x9e1b9b91, 0x47a17c0a, 0x4caf7507, 0x51bd6e10, 0x5ab3671d, 0x6b99583e, 0x60975133, 0x7d854a24, 0x768b4329, 0x1fd13462, 0x14df3d6f, 0x09cd2678, 0x02c32f75, 0x33e91056, 0x38e7195b, 0x25f5024c, 0x2efb0b41, 0x8c9ad761, 0x8794de6c, 0x9a86c57b, 0x9188cc76, 0xa0a2f355, 0xabacfa58, 0xb6bee14f, 0xbdb0e842, 0xd4ea9f09, 0xdfe49604, 0xc2f68d13, 0xc9f8841e, 0xf8d2bb3d, 0xf3dcb230, 0xeecea927, 0xe5c0a02a, 0x3c7a47b1, 0x37744ebc, 0x2a6655ab, 0x21685ca6, 0x10426385, 0x1b4c6a88, 0x065e719f, 0x0d507892, 0x640a0fd9, 0x6f0406d4, 0x72161dc3, 0x791814ce, 0x48322bed, 0x433c22e0, 0x5e2e39f7, 0x552030fa, 0x01ec9ab7, 0x0ae293ba, 0x17f088ad, 0x1cfe81a0, 0x2dd4be83, 0x26dab78e, 0x3bc8ac99, 0x30c6a594, 0x599cd2df, 0x5292dbd2, 0x4f80c0c5, 0x448ec9c8, 0x75a4f6eb, 0x7eaaffe6, 0x63b8e4f1, 0x68b6edfc, 0xb10c0a67, 0xba02036a, 0xa710187d, 0xac1e1170, 0x9d342e53, 0x963a275e, 0x8b283c49, 0x80263544, 0xe97c420f, 0xe2724b02, 0xff605015, 0xf46e5918, 0xc544663b, 0xce4a6f36, 0xd3587421, 0xd8567d2c, 0x7a37a10c, 0x7139a801, 0x6c2bb316, 0x6725ba1b, 0x560f8538, 0x5d018c35, 0x40139722, 0x4b1d9e2f, 0x2247e964, 0x2949e069, 0x345bfb7e, 0x3f55f273, 0x0e7fcd50, 0x0571c45d, 0x1863df4a, 0x136dd647, 0xcad731dc, 0xc1d938d1, 0xdccb23c6, 0xd7c52acb, 0xe6ef15e8, 0xede11ce5, 0xf0f307f2, 0xfbfd0eff, 0x92a779b4, 0x99a970b9, 0x84bb6bae, 0x8fb562a3, 0xbe9f5d80, 0xb591548d, 0xa8834f9a, 0xa38d4697];
    var U3 = [0x00000000, 0x0d0b0e09, 0x1a161c12, 0x171d121b, 0x342c3824, 0x3927362d, 0x2e3a2436, 0x23312a3f, 0x68587048, 0x65537e41, 0x724e6c5a, 0x7f456253, 0x5c74486c, 0x517f4665, 0x4662547e, 0x4b695a77, 0xd0b0e090, 0xddbbee99, 0xcaa6fc82, 0xc7adf28b, 0xe49cd8b4, 0xe997d6bd, 0xfe8ac4a6, 0xf381caaf, 0xb8e890d8, 0xb5e39ed1, 0xa2fe8cca, 0xaff582c3, 0x8cc4a8fc, 0x81cfa6f5, 0x96d2b4ee, 0x9bd9bae7, 0xbb7bdb3b, 0xb670d532, 0xa16dc729, 0xac66c920, 0x8f57e31f, 0x825ced16, 0x9541ff0d, 0x984af104, 0xd323ab73, 0xde28a57a, 0xc935b761, 0xc43eb968, 0xe70f9357, 0xea049d5e, 0xfd198f45, 0xf012814c, 0x6bcb3bab, 0x66c035a2, 0x71dd27b9, 0x7cd629b0, 0x5fe7038f, 0x52ec0d86, 0x45f11f9d, 0x48fa1194, 0x03934be3, 0x0e9845ea, 0x198557f1, 0x148e59f8, 0x37bf73c7, 0x3ab47dce, 0x2da96fd5, 0x20a261dc, 0x6df6ad76, 0x60fda37f, 0x77e0b164, 0x7aebbf6d, 0x59da9552, 0x54d19b5b, 0x43cc8940, 0x4ec78749, 0x05aedd3e, 0x08a5d337, 0x1fb8c12c, 0x12b3cf25, 0x3182e51a, 0x3c89eb13, 0x2b94f908, 0x269ff701, 0xbd464de6, 0xb04d43ef, 0xa75051f4, 0xaa5b5ffd, 0x896a75c2, 0x84617bcb, 0x937c69d0, 0x9e7767d9, 0xd51e3dae, 0xd81533a7, 0xcf0821bc, 0xc2032fb5, 0xe132058a, 0xec390b83, 0xfb241998, 0xf62f1791, 0xd68d764d, 0xdb867844, 0xcc9b6a5f, 0xc1906456, 0xe2a14e69, 0xefaa4060, 0xf8b7527b, 0xf5bc5c72, 0xbed50605, 0xb3de080c, 0xa4c31a17, 0xa9c8141e, 0x8af93e21, 0x87f23028, 0x90ef2233, 0x9de42c3a, 0x063d96dd, 0x0b3698d4, 0x1c2b8acf, 0x112084c6, 0x3211aef9, 0x3f1aa0f0, 0x2807b2eb, 0x250cbce2, 0x6e65e695, 0x636ee89c, 0x7473fa87, 0x7978f48e, 0x5a49deb1, 0x5742d0b8, 0x405fc2a3, 0x4d54ccaa, 0xdaf741ec, 0xd7fc4fe5, 0xc0e15dfe, 0xcdea53f7, 0xeedb79c8, 0xe3d077c1, 0xf4cd65da, 0xf9c66bd3, 0xb2af31a4, 0xbfa43fad, 0xa8b92db6, 0xa5b223bf, 0x86830980, 0x8b880789, 0x9c951592, 0x919e1b9b, 0x0a47a17c, 0x074caf75, 0x1051bd6e, 0x1d5ab367, 0x3e6b9958, 0x33609751, 0x247d854a, 0x29768b43, 0x621fd134, 0x6f14df3d, 0x7809cd26, 0x7502c32f, 0x5633e910, 0x5b38e719, 0x4c25f502, 0x412efb0b, 0x618c9ad7, 0x6c8794de, 0x7b9a86c5, 0x769188cc, 0x55a0a2f3, 0x58abacfa, 0x4fb6bee1, 0x42bdb0e8, 0x09d4ea9f, 0x04dfe496, 0x13c2f68d, 0x1ec9f884, 0x3df8d2bb, 0x30f3dcb2, 0x27eecea9, 0x2ae5c0a0, 0xb13c7a47, 0xbc37744e, 0xab2a6655, 0xa621685c, 0x85104263, 0x881b4c6a, 0x9f065e71, 0x920d5078, 0xd9640a0f, 0xd46f0406, 0xc372161d, 0xce791814, 0xed48322b, 0xe0433c22, 0xf75e2e39, 0xfa552030, 0xb701ec9a, 0xba0ae293, 0xad17f088, 0xa01cfe81, 0x832dd4be, 0x8e26dab7, 0x993bc8ac, 0x9430c6a5, 0xdf599cd2, 0xd25292db, 0xc54f80c0, 0xc8448ec9, 0xeb75a4f6, 0xe67eaaff, 0xf163b8e4, 0xfc68b6ed, 0x67b10c0a, 0x6aba0203, 0x7da71018, 0x70ac1e11, 0x539d342e, 0x5e963a27, 0x498b283c, 0x44802635, 0x0fe97c42, 0x02e2724b, 0x15ff6050, 0x18f46e59, 0x3bc54466, 0x36ce4a6f, 0x21d35874, 0x2cd8567d, 0x0c7a37a1, 0x017139a8, 0x166c2bb3, 0x1b6725ba, 0x38560f85, 0x355d018c, 0x22401397, 0x2f4b1d9e, 0x642247e9, 0x692949e0, 0x7e345bfb, 0x733f55f2, 0x500e7fcd, 0x5d0571c4, 0x4a1863df, 0x47136dd6, 0xdccad731, 0xd1c1d938, 0xc6dccb23, 0xcbd7c52a, 0xe8e6ef15, 0xe5ede11c, 0xf2f0f307, 0xfffbfd0e, 0xb492a779, 0xb999a970, 0xae84bb6b, 0xa38fb562, 0x80be9f5d, 0x8db59154, 0x9aa8834f, 0x97a38d46];
    var U4 = [0x00000000, 0x090d0b0e, 0x121a161c, 0x1b171d12, 0x24342c38, 0x2d392736, 0x362e3a24, 0x3f23312a, 0x48685870, 0x4165537e, 0x5a724e6c, 0x537f4562, 0x6c5c7448, 0x65517f46, 0x7e466254, 0x774b695a, 0x90d0b0e0, 0x99ddbbee, 0x82caa6fc, 0x8bc7adf2, 0xb4e49cd8, 0xbde997d6, 0xa6fe8ac4, 0xaff381ca, 0xd8b8e890, 0xd1b5e39e, 0xcaa2fe8c, 0xc3aff582, 0xfc8cc4a8, 0xf581cfa6, 0xee96d2b4, 0xe79bd9ba, 0x3bbb7bdb, 0x32b670d5, 0x29a16dc7, 0x20ac66c9, 0x1f8f57e3, 0x16825ced, 0x0d9541ff, 0x04984af1, 0x73d323ab, 0x7ade28a5, 0x61c935b7, 0x68c43eb9, 0x57e70f93, 0x5eea049d, 0x45fd198f, 0x4cf01281, 0xab6bcb3b, 0xa266c035, 0xb971dd27, 0xb07cd629, 0x8f5fe703, 0x8652ec0d, 0x9d45f11f, 0x9448fa11, 0xe303934b, 0xea0e9845, 0xf1198557, 0xf8148e59, 0xc737bf73, 0xce3ab47d, 0xd52da96f, 0xdc20a261, 0x766df6ad, 0x7f60fda3, 0x6477e0b1, 0x6d7aebbf, 0x5259da95, 0x5b54d19b, 0x4043cc89, 0x494ec787, 0x3e05aedd, 0x3708a5d3, 0x2c1fb8c1, 0x2512b3cf, 0x1a3182e5, 0x133c89eb, 0x082b94f9, 0x01269ff7, 0xe6bd464d, 0xefb04d43, 0xf4a75051, 0xfdaa5b5f, 0xc2896a75, 0xcb84617b, 0xd0937c69, 0xd99e7767, 0xaed51e3d, 0xa7d81533, 0xbccf0821, 0xb5c2032f, 0x8ae13205, 0x83ec390b, 0x98fb2419, 0x91f62f17, 0x4dd68d76, 0x44db8678, 0x5fcc9b6a, 0x56c19064, 0x69e2a14e, 0x60efaa40, 0x7bf8b752, 0x72f5bc5c, 0x05bed506, 0x0cb3de08, 0x17a4c31a, 0x1ea9c814, 0x218af93e, 0x2887f230, 0x3390ef22, 0x3a9de42c, 0xdd063d96, 0xd40b3698, 0xcf1c2b8a, 0xc6112084, 0xf93211ae, 0xf03f1aa0, 0xeb2807b2, 0xe2250cbc, 0x956e65e6, 0x9c636ee8, 0x877473fa, 0x8e7978f4, 0xb15a49de, 0xb85742d0, 0xa3405fc2, 0xaa4d54cc, 0xecdaf741, 0xe5d7fc4f, 0xfec0e15d, 0xf7cdea53, 0xc8eedb79, 0xc1e3d077, 0xdaf4cd65, 0xd3f9c66b, 0xa4b2af31, 0xadbfa43f, 0xb6a8b92d, 0xbfa5b223, 0x80868309, 0x898b8807, 0x929c9515, 0x9b919e1b, 0x7c0a47a1, 0x75074caf, 0x6e1051bd, 0x671d5ab3, 0x583e6b99, 0x51336097, 0x4a247d85, 0x4329768b, 0x34621fd1, 0x3d6f14df, 0x267809cd, 0x2f7502c3, 0x105633e9, 0x195b38e7, 0x024c25f5, 0x0b412efb, 0xd7618c9a, 0xde6c8794, 0xc57b9a86, 0xcc769188, 0xf355a0a2, 0xfa58abac, 0xe14fb6be, 0xe842bdb0, 0x9f09d4ea, 0x9604dfe4, 0x8d13c2f6, 0x841ec9f8, 0xbb3df8d2, 0xb230f3dc, 0xa927eece, 0xa02ae5c0, 0x47b13c7a, 0x4ebc3774, 0x55ab2a66, 0x5ca62168, 0x63851042, 0x6a881b4c, 0x719f065e, 0x78920d50, 0x0fd9640a, 0x06d46f04, 0x1dc37216, 0x14ce7918, 0x2bed4832, 0x22e0433c, 0x39f75e2e, 0x30fa5520, 0x9ab701ec, 0x93ba0ae2, 0x88ad17f0, 0x81a01cfe, 0xbe832dd4, 0xb78e26da, 0xac993bc8, 0xa59430c6, 0xd2df599c, 0xdbd25292, 0xc0c54f80, 0xc9c8448e, 0xf6eb75a4, 0xffe67eaa, 0xe4f163b8, 0xedfc68b6, 0x0a67b10c, 0x036aba02, 0x187da710, 0x1170ac1e, 0x2e539d34, 0x275e963a, 0x3c498b28, 0x35448026, 0x420fe97c, 0x4b02e272, 0x5015ff60, 0x5918f46e, 0x663bc544, 0x6f36ce4a, 0x7421d358, 0x7d2cd856, 0xa10c7a37, 0xa8017139, 0xb3166c2b, 0xba1b6725, 0x8538560f, 0x8c355d01, 0x97224013, 0x9e2f4b1d, 0xe9642247, 0xe0692949, 0xfb7e345b, 0xf2733f55, 0xcd500e7f, 0xc45d0571, 0xdf4a1863, 0xd647136d, 0x31dccad7, 0x38d1c1d9, 0x23c6dccb, 0x2acbd7c5, 0x15e8e6ef, 0x1ce5ede1, 0x07f2f0f3, 0x0efffbfd, 0x79b492a7, 0x70b999a9, 0x6bae84bb, 0x62a38fb5, 0x5d80be9f, 0x548db591, 0x4f9aa883, 0x4697a38d];

    function convertToInt32(bytes) {
        var result = [];
        for (var i = 0; i < bytes.length; i += 4) {
            result.push(
                (bytes[i    ] << 24) |
                (bytes[i + 1] << 16) |
                (bytes[i + 2] <<  8) |
                 bytes[i + 3]
            );
        }
        return result;
    }

    var AES = function(key) {
        if (!(this instanceof AES)) {
            throw Error('AES must be instanitated with `new`');
        }

        Object.defineProperty(this, 'key', {
            value: coerceArray(key, true)
        });

        this._prepare();
    }


    AES.prototype._prepare = function() {

        var rounds = numberOfRounds[this.key.length];
        if (rounds == null) {
            throw new Error('invalid key size (must be 16, 24 or 32 bytes)');
        }

        // encryption round keys
        this._Ke = [];

        // decryption round keys
        this._Kd = [];

        for (var i = 0; i <= rounds; i++) {
            this._Ke.push([0, 0, 0, 0]);
            this._Kd.push([0, 0, 0, 0]);
        }

        var roundKeyCount = (rounds + 1) * 4;
        var KC = this.key.length / 4;

        // convert the key into ints
        var tk = convertToInt32(this.key);

        // copy values into round key arrays
        var index;
        for (var i = 0; i < KC; i++) {
            index = i >> 2;
            this._Ke[index][i % 4] = tk[i];
            this._Kd[rounds - index][i % 4] = tk[i];
        }

        // key expansion (fips-197 section 5.2)
        var rconpointer = 0;
        var t = KC, tt;
        while (t < roundKeyCount) {
            tt = tk[KC - 1];
            tk[0] ^= ((S[(tt >> 16) & 0xFF] << 24) ^
                      (S[(tt >>  8) & 0xFF] << 16) ^
                      (S[ tt        & 0xFF] <<  8) ^
                       S[(tt >> 24) & 0xFF]        ^
                      (rcon[rconpointer] << 24));
            rconpointer += 1;

            // key expansion (for non-256 bit)
            if (KC != 8) {
                for (var i = 1; i < KC; i++) {
                    tk[i] ^= tk[i - 1];
                }

            // key expansion for 256-bit keys is "slightly different" (fips-197)
            } else {
                for (var i = 1; i < (KC / 2); i++) {
                    tk[i] ^= tk[i - 1];
                }
                tt = tk[(KC / 2) - 1];

                tk[KC / 2] ^= (S[ tt        & 0xFF]        ^
                              (S[(tt >>  8) & 0xFF] <<  8) ^
                              (S[(tt >> 16) & 0xFF] << 16) ^
                              (S[(tt >> 24) & 0xFF] << 24));

                for (var i = (KC / 2) + 1; i < KC; i++) {
                    tk[i] ^= tk[i - 1];
                }
            }

            // copy values into round key arrays
            var i = 0, r, c;
            while (i < KC && t < roundKeyCount) {
                r = t >> 2;
                c = t % 4;
                this._Ke[r][c] = tk[i];
                this._Kd[rounds - r][c] = tk[i++];
                t++;
            }
        }

        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
        for (var r = 1; r < rounds; r++) {
            for (var c = 0; c < 4; c++) {
                tt = this._Kd[r][c];
                this._Kd[r][c] = (U1[(tt >> 24) & 0xFF] ^
                                  U2[(tt >> 16) & 0xFF] ^
                                  U3[(tt >>  8) & 0xFF] ^
                                  U4[ tt        & 0xFF]);
            }
        }
    }

    AES.prototype.encrypt = function(plaintext) {
        if (plaintext.length != 16) {
            throw new Error('invalid plaintext size (must be 16 bytes)');
        }

        var rounds = this._Ke.length - 1;
        var a = [0, 0, 0, 0];

        // convert plaintext to (ints ^ key)
        var t = convertToInt32(plaintext);
        for (var i = 0; i < 4; i++) {
            t[i] ^= this._Ke[0][i];
        }

        // apply round transforms
        for (var r = 1; r < rounds; r++) {
            for (var i = 0; i < 4; i++) {
                a[i] = (T1[(t[ i         ] >> 24) & 0xff] ^
                        T2[(t[(i + 1) % 4] >> 16) & 0xff] ^
                        T3[(t[(i + 2) % 4] >>  8) & 0xff] ^
                        T4[ t[(i + 3) % 4]        & 0xff] ^
                        this._Ke[r][i]);
            }
            t = a.slice();
        }

        // the last round is special
        var result = createArray(16), tt;
        for (var i = 0; i < 4; i++) {
            tt = this._Ke[rounds][i];
            result[4 * i    ] = (S[(t[ i         ] >> 24) & 0xff] ^ (tt >> 24)) & 0xff;
            result[4 * i + 1] = (S[(t[(i + 1) % 4] >> 16) & 0xff] ^ (tt >> 16)) & 0xff;
            result[4 * i + 2] = (S[(t[(i + 2) % 4] >>  8) & 0xff] ^ (tt >>  8)) & 0xff;
            result[4 * i + 3] = (S[ t[(i + 3) % 4]        & 0xff] ^  tt       ) & 0xff;
        }

        return result;
    }

    AES.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length != 16) {
            throw new Error('invalid ciphertext size (must be 16 bytes)');
        }

        var rounds = this._Kd.length - 1;
        var a = [0, 0, 0, 0];

        // convert plaintext to (ints ^ key)
        var t = convertToInt32(ciphertext);
        for (var i = 0; i < 4; i++) {
            t[i] ^= this._Kd[0][i];
        }

        // apply round transforms
        for (var r = 1; r < rounds; r++) {
            for (var i = 0; i < 4; i++) {
                a[i] = (T5[(t[ i          ] >> 24) & 0xff] ^
                        T6[(t[(i + 3) % 4] >> 16) & 0xff] ^
                        T7[(t[(i + 2) % 4] >>  8) & 0xff] ^
                        T8[ t[(i + 1) % 4]        & 0xff] ^
                        this._Kd[r][i]);
            }
            t = a.slice();
        }

        // the last round is special
        var result = createArray(16), tt;
        for (var i = 0; i < 4; i++) {
            tt = this._Kd[rounds][i];
            result[4 * i    ] = (Si[(t[ i         ] >> 24) & 0xff] ^ (tt >> 24)) & 0xff;
            result[4 * i + 1] = (Si[(t[(i + 3) % 4] >> 16) & 0xff] ^ (tt >> 16)) & 0xff;
            result[4 * i + 2] = (Si[(t[(i + 2) % 4] >>  8) & 0xff] ^ (tt >>  8)) & 0xff;
            result[4 * i + 3] = (Si[ t[(i + 1) % 4]        & 0xff] ^  tt       ) & 0xff;
        }

        return result;
    }


    /**
     *  Mode Of Operation - Electonic Codebook (ECB)
     */
    var ModeOfOperationECB = function(key) {
        if (!(this instanceof ModeOfOperationECB)) {
            throw Error('AES must be instanitated with `new`');
        }

        this.description = "Electronic Code Block";
        this.name = "ecb";

        this._aes = new AES(key);
    }

    ModeOfOperationECB.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);

        if ((plaintext.length % 16) !== 0) {
            throw new Error('invalid plaintext size (must be multiple of 16 bytes)');
        }

        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);

        for (var i = 0; i < plaintext.length; i += 16) {
            copyArray(plaintext, block, 0, i, i + 16);
            block = this._aes.encrypt(block);
            copyArray(block, ciphertext, i);
        }

        return ciphertext;
    }

    ModeOfOperationECB.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);

        if ((ciphertext.length % 16) !== 0) {
            throw new Error('invalid ciphertext size (must be multiple of 16 bytes)');
        }

        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);

        for (var i = 0; i < ciphertext.length; i += 16) {
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            copyArray(block, plaintext, i);
        }

        return plaintext;
    }


    /**
     *  Mode Of Operation - Cipher Block Chaining (CBC)
     */
    var ModeOfOperationCBC = function(key, iv) {
        if (!(this instanceof ModeOfOperationCBC)) {
            throw Error('AES must be instanitated with `new`');
        }

        this.description = "Cipher Block Chaining";
        this.name = "cbc";

        if (!iv) {
            iv = createArray(16);

        } else if (iv.length != 16) {
            throw new Error('invalid initialation vector size (must be 16 bytes)');
        }

        this._lastCipherblock = coerceArray(iv, true);

        this._aes = new AES(key);
    }

    ModeOfOperationCBC.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);

        if ((plaintext.length % 16) !== 0) {
            throw new Error('invalid plaintext size (must be multiple of 16 bytes)');
        }

        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);

        for (var i = 0; i < plaintext.length; i += 16) {
            copyArray(plaintext, block, 0, i, i + 16);

            for (var j = 0; j < 16; j++) {
                block[j] ^= this._lastCipherblock[j];
            }

            this._lastCipherblock = this._aes.encrypt(block);
            copyArray(this._lastCipherblock, ciphertext, i);
        }

        return ciphertext;
    }

    ModeOfOperationCBC.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);

        if ((ciphertext.length % 16) !== 0) {
            throw new Error('invalid ciphertext size (must be multiple of 16 bytes)');
        }

        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);

        for (var i = 0; i < ciphertext.length; i += 16) {
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);

            for (var j = 0; j < 16; j++) {
                plaintext[i + j] = block[j] ^ this._lastCipherblock[j];
            }

            copyArray(ciphertext, this._lastCipherblock, 0, i, i + 16);
        }

        return plaintext;
    }


    /**
     *  Mode Of Operation - Cipher Feedback (CFB)
     */
    var ModeOfOperationCFB = function(key, iv, segmentSize) {
        if (!(this instanceof ModeOfOperationCFB)) {
            throw Error('AES must be instanitated with `new`');
        }

        this.description = "Cipher Feedback";
        this.name = "cfb";

        if (!iv) {
            iv = createArray(16);

        } else if (iv.length != 16) {
            throw new Error('invalid initialation vector size (must be 16 size)');
        }

        if (!segmentSize) { segmentSize = 1; }

        this.segmentSize = segmentSize;

        this._shiftRegister = coerceArray(iv, true);

        this._aes = new AES(key);
    }

    ModeOfOperationCFB.prototype.encrypt = function(plaintext) {
        if ((plaintext.length % this.segmentSize) != 0) {
            throw new Error('invalid plaintext size (must be segmentSize bytes)');
        }

        var encrypted = coerceArray(plaintext, true);

        var xorSegment;
        for (var i = 0; i < encrypted.length; i += this.segmentSize) {
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for (var j = 0; j < this.segmentSize; j++) {
                encrypted[i + j] ^= xorSegment[j];
            }

            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(encrypted, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }

        return encrypted;
    }

    ModeOfOperationCFB.prototype.decrypt = function(ciphertext) {
        if ((ciphertext.length % this.segmentSize) != 0) {
            throw new Error('invalid ciphertext size (must be segmentSize bytes)');
        }

        var plaintext = coerceArray(ciphertext, true);

        var xorSegment;
        for (var i = 0; i < plaintext.length; i += this.segmentSize) {
            xorSegment = this._aes.encrypt(this._shiftRegister);

            for (var j = 0; j < this.segmentSize; j++) {
                plaintext[i + j] ^= xorSegment[j];
            }

            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(ciphertext, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }

        return plaintext;
    }

    /**
     *  Mode Of Operation - Output Feedback (OFB)
     */
    var ModeOfOperationOFB = function(key, iv) {
        if (!(this instanceof ModeOfOperationOFB)) {
            throw Error('AES must be instanitated with `new`');
        }

        this.description = "Output Feedback";
        this.name = "ofb";

        if (!iv) {
            iv = createArray(16);

        } else if (iv.length != 16) {
            throw new Error('invalid initialation vector size (must be 16 bytes)');
        }

        this._lastPrecipher = coerceArray(iv, true);
        this._lastPrecipherIndex = 16;

        this._aes = new AES(key);
    }

    ModeOfOperationOFB.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);

        for (var i = 0; i < encrypted.length; i++) {
            if (this._lastPrecipherIndex === 16) {
                this._lastPrecipher = this._aes.encrypt(this._lastPrecipher);
                this._lastPrecipherIndex = 0;
            }
            encrypted[i] ^= this._lastPrecipher[this._lastPrecipherIndex++];
        }

        return encrypted;
    }

    // Decryption is symetric
    ModeOfOperationOFB.prototype.decrypt = ModeOfOperationOFB.prototype.encrypt;


    /**
     *  Counter object for CTR common mode of operation
     */
    var Counter = function(initialValue) {
        if (!(this instanceof Counter)) {
            throw Error('Counter must be instanitated with `new`');
        }

        // We allow 0, but anything false-ish uses the default 1
        if (initialValue !== 0 && !initialValue) { initialValue = 1; }

        if (typeof(initialValue) === 'number') {
            this._counter = createArray(16);
            this.setValue(initialValue);

        } else {
            this.setBytes(initialValue);
        }
    }

    Counter.prototype.setValue = function(value) {
        if (typeof(value) !== 'number' || parseInt(value) != value) {
            throw new Error('invalid counter value (must be an integer)');
        }

        // We cannot safely handle numbers beyond the safe range for integers
        if (value > Number.MAX_SAFE_INTEGER) {
            throw new Error('integer value out of safe range');
        }

        for (var index = 15; index >= 0; --index) {
            this._counter[index] = value % 256;
            value = parseInt(value / 256);
        }
    }

    Counter.prototype.setBytes = function(bytes) {
        bytes = coerceArray(bytes, true);

        if (bytes.length != 16) {
            throw new Error('invalid counter bytes size (must be 16 bytes)');
        }

        this._counter = bytes;
    };

    Counter.prototype.increment = function() {
        for (var i = 15; i >= 0; i--) {
            if (this._counter[i] === 255) {
                this._counter[i] = 0;
            } else {
                this._counter[i]++;
                break;
            }
        }
    }


    /**
     *  Mode Of Operation - Counter (CTR)
     */
    var ModeOfOperationCTR = function(key, counter) {
        if (!(this instanceof ModeOfOperationCTR)) {
            throw Error('AES must be instanitated with `new`');
        }

        this.description = "Counter";
        this.name = "ctr";

        if (!(counter instanceof Counter)) {
            counter = new Counter(counter)
        }

        this._counter = counter;

        this._remainingCounter = null;
        this._remainingCounterIndex = 16;

        this._aes = new AES(key);
    }

    ModeOfOperationCTR.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);

        for (var i = 0; i < encrypted.length; i++) {
            if (this._remainingCounterIndex === 16) {
                this._remainingCounter = this._aes.encrypt(this._counter._counter);
                this._remainingCounterIndex = 0;
                this._counter.increment();
            }
            encrypted[i] ^= this._remainingCounter[this._remainingCounterIndex++];
        }

        return encrypted;
    }

    // Decryption is symetric
    ModeOfOperationCTR.prototype.decrypt = ModeOfOperationCTR.prototype.encrypt;


    ///////////////////////
    // Padding

    // See:https://tools.ietf.org/html/rfc2315
    function pkcs7pad(data) {
        data = coerceArray(data, true);
        var padder = 16 - (data.length % 16);
        var result = createArray(data.length + padder);
        copyArray(data, result);
        for (var i = data.length; i < result.length; i++) {
            result[i] = padder;
        }
        return result;
    }

    function pkcs7strip(data) {
        data = coerceArray(data, true);
        if (data.length < 16) { throw new Error('PKCS#7 invalid length'); }

        var padder = data[data.length - 1];
        if (padder > 16) { throw new Error('PKCS#7 padding byte out of range'); }

        var length = data.length - padder;
        for (var i = 0; i < padder; i++) {
            if (data[length + i] !== padder) {
                throw new Error('PKCS#7 invalid padding byte');
            }
        }

        var result = createArray(length);
        copyArray(data, result, 0, 0, length);
        return result;
    }

    ///////////////////////
    // Exporting


    // The block cipher
    var aesjs = {
        AES: AES,
        Counter: Counter,

        ModeOfOperation: {
            ecb: ModeOfOperationECB,
            cbc: ModeOfOperationCBC,
            cfb: ModeOfOperationCFB,
            ofb: ModeOfOperationOFB,
            ctr: ModeOfOperationCTR
        },

        utils: {
            hex: convertHex,
            utf8: convertUtf8
        },

        padding: {
            pkcs7: {
                pad: pkcs7pad,
                strip: pkcs7strip
            }
        },

        _arrayTest: {
            coerceArray: coerceArray,
            createArray: createArray,
            copyArray: copyArray,
        }
    };


    // node.js
    if (true) {
        module.exports = aesjs

    // RequireJS/AMD
    // http://www.requirejs.org/docs/api.html
    // https://github.com/amdjs/amdjs-api/wiki/AMD
    } else if (typeof(define) === 'function' && define.amd) {
        define([], function() { return aesjs; });

    // Web Browsers
    } else {

        // If there was an existing library at "aesjs" make sure it's still available
        if (root.aesjs) {
            aesjs._aesjs = root.aesjs;
        }

        root.aesjs = aesjs;
    }


})(this);


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var _globalThis;
try {
	_globalThis = __webpack_require__(280);
} catch (error) {
} finally {
	if (!_globalThis && typeof window !== 'undefined') { _globalThis = window; }
	if (!_globalThis) { throw new Error('Could not determine global this'); }
}

var NativeWebSocket = _globalThis.WebSocket || _globalThis.MozWebSocket;
var websocket_version = __webpack_require__(281);


/**
 * Expose a W3C WebSocket class with just one or two arguments.
 */
function W3CWebSocket(uri, protocols) {
	var native_instance;

	if (protocols) {
		native_instance = new NativeWebSocket(uri, protocols);
	}
	else {
		native_instance = new NativeWebSocket(uri);
	}

	/**
	 * 'native_instance' is an instance of nativeWebSocket (the browser's WebSocket
	 * class). Since it is an Object it will be returned as it is when creating an
	 * instance of W3CWebSocket via 'new W3CWebSocket()'.
	 *
	 * ECMAScript 5: http://bclary.com/2004/11/07/#a-13.2.2
	 */
	return native_instance;
}
if (NativeWebSocket) {
	['CONNECTING', 'OPEN', 'CLOSING', 'CLOSED'].forEach(function(prop) {
		Object.defineProperty(W3CWebSocket, prop, {
			get: function() { return NativeWebSocket[prop]; }
		});
	});
}

/**
 * Module exports.
 */
module.exports = {
    'w3cwebsocket' : NativeWebSocket ? W3CWebSocket : null,
    'version'      : websocket_version
};


/***/ }),
/* 280 */
/***/ (function(module, exports) {

var naiveFallback = function () {
	if (typeof self === "object" && self) return self;
	if (typeof window === "object" && window) return window;
	throw new Error("Unable to resolve global `this`");
};

module.exports = (function () {
	if (this) return this;

	// Unexpected strict mode (may happen if e.g. bundled into ESM module)

	// Fallback to standard globalThis if available
	if (typeof globalThis === "object" && globalThis) return globalThis;

	// Thanks @mathiasbynens -> https://mathiasbynens.be/notes/globalthis
	// In all ES5+ engines global object inherits from Object.prototype
	// (if you approached one that doesn't please report)
	try {
		Object.defineProperty(Object.prototype, "__global__", {
			get: function () { return this; },
			configurable: true
		});
	} catch (error) {
		// Unfortunate case of updates to Object.prototype being restricted
		// via preventExtensions, seal or freeze
		return naiveFallback();
	}
	try {
		// Safari case (window.__global__ works, but __global__ does not)
		if (!__global__) return naiveFallback();
		return __global__;
	} finally {
		delete Object.prototype.__global__;
	}
})();


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(282).version;


/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports = {"_args":[["websocket@1.0.31","C:\\Users\\Minion\\Documents\\JET\\Aekiti\\DevStudyJaem\\Projects\\AEchat"]],"_from":"websocket@1.0.31","_id":"websocket@1.0.31","_inBundle":false,"_integrity":"sha512-VAouplvGKPiKFDTeCCO65vYHsyay8DqoBSlzIO3fayrfOgU94lQN5a1uWVnFrMLceTJw/+fQXR5PGbUVRaHshQ==","_location":"/websocket","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"websocket@1.0.31","name":"websocket","escapedName":"websocket","rawSpec":"1.0.31","saveSpec":null,"fetchSpec":"1.0.31"},"_requiredBy":["/@aeternity/aepp-sdk"],"_resolved":"https://registry.npmjs.org/websocket/-/websocket-1.0.31.tgz","_spec":"1.0.31","_where":"C:\\Users\\Minion\\Documents\\JET\\Aekiti\\DevStudyJaem\\Projects\\AEchat","author":{"name":"Brian McKelvey","email":"theturtle32@gmail.com","url":"https://github.com/theturtle32"},"browser":"lib/browser.js","bugs":{"url":"https://github.com/theturtle32/WebSocket-Node/issues"},"config":{"verbose":false},"contributors":[{"name":"Iñaki Baz Castillo","email":"ibc@aliax.net","url":"http://dev.sipdoc.net"}],"dependencies":{"debug":"^2.2.0","es5-ext":"^0.10.50","nan":"^2.14.0","typedarray-to-buffer":"^3.1.5","yaeti":"^0.0.6"},"description":"Websocket Client & Server Library implementing the WebSocket protocol as specified in RFC 6455.","devDependencies":{"buffer-equal":"^1.0.0","faucet":"^0.0.1","gulp":"^4.0.2","gulp-jshint":"^2.0.4","jshint":"^2.0.0","jshint-stylish":"^2.2.1","tape":"^4.9.1"},"directories":{"lib":"./lib"},"engines":{"node":">=0.10.0"},"homepage":"https://github.com/theturtle32/WebSocket-Node","keywords":["websocket","websockets","socket","networking","comet","push","RFC-6455","realtime","server","client"],"license":"Apache-2.0","main":"index","name":"websocket","repository":{"type":"git","url":"git+https://github.com/theturtle32/WebSocket-Node.git"},"scripts":{"gulp":"gulp","install":"(node-gyp rebuild 2> builderror.log) || (exit 0)","test":"faucet test/unit"},"version":"1.0.31"}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(284);
var v4 = __webpack_require__(285);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(108);
var bytesToUuid = __webpack_require__(109);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(108);
var bytesToUuid = __webpack_require__(109);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 286 */
/***/ (function(module, exports) {

/*
 * Bitcoin BIP32 path helpers
 * (C) 2016 Alex Beregszaszi
 */

const HARDENED = 0x80000000

var BIPPath = function (path) {
  if (!Array.isArray(path)) {
    throw new Error('Input must be an Array')
  }
  if (path.length === 0) {
    throw new Error('Path must contain at least one level')
  }
  for (var i = 0; i < path.length; i++) {
    if (typeof path[i] !== 'number') {
      throw new Error('Path element is not a number')
    }
  }
  this.path = path
}

BIPPath.validatePathArray = function (path) {
  try {
    BIPPath.fromPathArray(path)
    return true
  } catch (e) {
    return false
  }
}

BIPPath.validateString = function (text, reqRoot) {
  try {
    BIPPath.fromString(text, reqRoot)
    return true
  } catch (e) {
    return false
  }
}

BIPPath.fromPathArray = function (path) {
  return new BIPPath(path)
}

BIPPath.fromString = function (text, reqRoot) {
  // skip the root
  if (/^m\//i.test(text)) {
    text = text.slice(2)
  } else if (reqRoot) {
    throw new Error('Root element is required')
  }

  var path = text.split('/')
  var ret = new Array(path.length)
  for (var i = 0; i < path.length; i++) {
    var tmp = /(\d+)([hH\']?)/.exec(path[i])
    if (tmp === null) {
      throw new Error('Invalid input')
    }
    ret[i] = parseInt(tmp[1], 10)

    if (ret[i] >= HARDENED) {
      throw new Error('Invalid child index')
    }

    if (tmp[2] === 'h' || tmp[2] === 'H' || tmp[2] === '\'') {
      ret[i] += HARDENED
    } else if (tmp[2].length != 0) {
      throw new Error('Invalid modifier')
    }
  }
  return new BIPPath(ret)
}

BIPPath.prototype.toPathArray = function () {
  return this.path
}

BIPPath.prototype.toString = function (noRoot, oldStyle) {
  var ret = new Array(this.path.length)
  for (var i = 0; i < this.path.length; i++) {
    var tmp = this.path[i]
    if (tmp & HARDENED) {
      ret[i] = (tmp & ~HARDENED) + (oldStyle ? 'h' : '\'')
    } else {
      ret[i] = tmp
    }
  }
  return (noRoot ? '' : 'm/') + ret.join('/')
}

BIPPath.prototype.inspect = function () {
  return 'BIPPath <' + this.toString() + '>'
}

module.exports = BIPPath


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(e){function t(e,t){"use strict";var r,a="uint8array",_=t.ready.then(function(){function a(){if(0!==r._sodium_init())throw new Error("libsodium was not correctly initialized.");for(var t=["crypto_aead_chacha20poly1305_decrypt","crypto_aead_chacha20poly1305_decrypt_detached","crypto_aead_chacha20poly1305_encrypt","crypto_aead_chacha20poly1305_encrypt_detached","crypto_aead_chacha20poly1305_ietf_decrypt","crypto_aead_chacha20poly1305_ietf_decrypt_detached","crypto_aead_chacha20poly1305_ietf_encrypt","crypto_aead_chacha20poly1305_ietf_encrypt_detached","crypto_aead_chacha20poly1305_ietf_keygen","crypto_aead_chacha20poly1305_keygen","crypto_aead_xchacha20poly1305_ietf_decrypt","crypto_aead_xchacha20poly1305_ietf_decrypt_detached","crypto_aead_xchacha20poly1305_ietf_encrypt","crypto_aead_xchacha20poly1305_ietf_encrypt_detached","crypto_aead_xchacha20poly1305_ietf_keygen","crypto_auth","crypto_auth_hmacsha256","crypto_auth_hmacsha256_keygen","crypto_auth_hmacsha256_verify","crypto_auth_hmacsha512","crypto_auth_hmacsha512_keygen","crypto_auth_hmacsha512_verify","crypto_auth_keygen","crypto_auth_verify","crypto_box_beforenm","crypto_box_curve25519xchacha20poly1305_keypair","crypto_box_curve25519xchacha20poly1305_seal","crypto_box_curve25519xchacha20poly1305_seal_open","crypto_box_detached","crypto_box_easy","crypto_box_easy_afternm","crypto_box_keypair","crypto_box_open_detached","crypto_box_open_easy","crypto_box_open_easy_afternm","crypto_box_seal","crypto_box_seal_open","crypto_box_seed_keypair","crypto_core_ristretto255_add","crypto_core_ristretto255_from_hash","crypto_core_ristretto255_is_valid_point","crypto_core_ristretto255_random","crypto_core_ristretto255_scalar_add","crypto_core_ristretto255_scalar_complement","crypto_core_ristretto255_scalar_invert","crypto_core_ristretto255_scalar_mul","crypto_core_ristretto255_scalar_negate","crypto_core_ristretto255_scalar_random","crypto_core_ristretto255_scalar_reduce","crypto_core_ristretto255_scalar_sub","crypto_core_ristretto255_sub","crypto_generichash","crypto_generichash_blake2b_salt_personal","crypto_generichash_final","crypto_generichash_init","crypto_generichash_keygen","crypto_generichash_update","crypto_hash","crypto_hash_sha256","crypto_hash_sha512","crypto_kdf_derive_from_key","crypto_kdf_keygen","crypto_kx_client_session_keys","crypto_kx_keypair","crypto_kx_seed_keypair","crypto_kx_server_session_keys","crypto_onetimeauth","crypto_onetimeauth_final","crypto_onetimeauth_init","crypto_onetimeauth_keygen","crypto_onetimeauth_update","crypto_onetimeauth_verify","crypto_pwhash","crypto_pwhash_scryptsalsa208sha256","crypto_pwhash_scryptsalsa208sha256_ll","crypto_pwhash_scryptsalsa208sha256_str","crypto_pwhash_scryptsalsa208sha256_str_verify","crypto_pwhash_str","crypto_pwhash_str_verify","crypto_scalarmult","crypto_scalarmult_base","crypto_scalarmult_ristretto255","crypto_scalarmult_ristretto255_base","crypto_secretbox_detached","crypto_secretbox_easy","crypto_secretbox_keygen","crypto_secretbox_open_detached","crypto_secretbox_open_easy","crypto_secretstream_xchacha20poly1305_init_pull","crypto_secretstream_xchacha20poly1305_init_push","crypto_secretstream_xchacha20poly1305_keygen","crypto_secretstream_xchacha20poly1305_pull","crypto_secretstream_xchacha20poly1305_push","crypto_secretstream_xchacha20poly1305_rekey","crypto_shorthash","crypto_shorthash_keygen","crypto_shorthash_siphashx24","crypto_sign","crypto_sign_detached","crypto_sign_ed25519_pk_to_curve25519","crypto_sign_ed25519_sk_to_curve25519","crypto_sign_ed25519_sk_to_pk","crypto_sign_ed25519_sk_to_seed","crypto_sign_final_create","crypto_sign_final_verify","crypto_sign_init","crypto_sign_keypair","crypto_sign_open","crypto_sign_seed_keypair","crypto_sign_update","crypto_sign_verify_detached","crypto_stream_chacha20","crypto_stream_chacha20_ietf_xor","crypto_stream_chacha20_ietf_xor_ic","crypto_stream_chacha20_keygen","crypto_stream_chacha20_xor","crypto_stream_chacha20_xor_ic","crypto_stream_keygen","crypto_stream_xchacha20_keygen","crypto_stream_xchacha20_xor","crypto_stream_xchacha20_xor_ic","randombytes_buf","randombytes_buf_deterministic","randombytes_close","randombytes_random","randombytes_set_implementation","randombytes_stir","randombytes_uniform","sodium_version_string"],a=[x,E,w,S,T,Y,A,B,K,I,M,L,N,U,O,R,P,C,G,D,X,V,F,H,z,j,q,W,J,Q,Z,$,ee,te,re,ae,_e,ne,se,ce,he,oe,pe,ye,ie,le,ue,ve,de,ge,be,fe,me,ke,xe,Ee,we,Se,Te,Ye,Ae,Be,Ke,Ie,Me,Le,Ne,Ue,Oe,Re,Pe,Ce,Ge,De,Xe,Ve,Fe,He,ze,je,qe,We,Je,Qe,Ze,$e,et,tt,rt,at,_t,nt,st,ct,ht,ot,pt,yt,it,lt,ut,vt,dt,gt,bt,ft,mt,kt,xt,Et,wt,St,Tt,Yt,At,Bt,Kt,It,Mt,Lt,Nt,Ut,Ot,Rt,Pt,Ct,Gt,Dt,Xt],_=0;_<a.length;_++)"function"==typeof r["_"+t[_]]&&(e[t[_]]=a[_]);var n=["SODIUM_LIBRARY_VERSION_MAJOR","SODIUM_LIBRARY_VERSION_MINOR","crypto_aead_chacha20poly1305_ABYTES","crypto_aead_chacha20poly1305_KEYBYTES","crypto_aead_chacha20poly1305_MESSAGEBYTES_MAX","crypto_aead_chacha20poly1305_NPUBBYTES","crypto_aead_chacha20poly1305_NSECBYTES","crypto_aead_chacha20poly1305_ietf_ABYTES","crypto_aead_chacha20poly1305_ietf_KEYBYTES","crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX","crypto_aead_chacha20poly1305_ietf_NPUBBYTES","crypto_aead_chacha20poly1305_ietf_NSECBYTES","crypto_aead_xchacha20poly1305_ietf_ABYTES","crypto_aead_xchacha20poly1305_ietf_KEYBYTES","crypto_aead_xchacha20poly1305_ietf_MESSAGEBYTES_MAX","crypto_aead_xchacha20poly1305_ietf_NPUBBYTES","crypto_aead_xchacha20poly1305_ietf_NSECBYTES","crypto_auth_BYTES","crypto_auth_KEYBYTES","crypto_auth_hmacsha256_BYTES","crypto_auth_hmacsha256_KEYBYTES","crypto_auth_hmacsha512_BYTES","crypto_auth_hmacsha512_KEYBYTES","crypto_box_BEFORENMBYTES","crypto_box_MACBYTES","crypto_box_MESSAGEBYTES_MAX","crypto_box_NONCEBYTES","crypto_box_PUBLICKEYBYTES","crypto_box_SEALBYTES","crypto_box_SECRETKEYBYTES","crypto_box_SEEDBYTES","crypto_box_curve25519xchacha20poly1305_NONCEBYTES","crypto_box_curve25519xchacha20poly1305_PUBLICKEYBYTES","crypto_box_curve25519xchacha20poly1305_SECRETKEYBYTES","crypto_core_hchacha20_CONSTBYTES","crypto_core_hchacha20_INPUTBYTES","crypto_core_hchacha20_KEYBYTES","crypto_core_hchacha20_OUTPUTBYTES","crypto_core_ristretto255_BYTES","crypto_core_ristretto255_HASHBYTES","crypto_core_ristretto255_NONREDUCEDSCALARBYTES","crypto_core_ristretto255_SCALARBYTES","crypto_generichash_BYTES","crypto_generichash_BYTES_MAX","crypto_generichash_BYTES_MIN","crypto_generichash_KEYBYTES","crypto_generichash_KEYBYTES_MAX","crypto_generichash_KEYBYTES_MIN","crypto_generichash_blake2b_BYTES","crypto_generichash_blake2b_BYTES_MAX","crypto_generichash_blake2b_BYTES_MIN","crypto_generichash_blake2b_KEYBYTES","crypto_generichash_blake2b_KEYBYTES_MAX","crypto_generichash_blake2b_KEYBYTES_MIN","crypto_generichash_blake2b_PERSONALBYTES","crypto_generichash_blake2b_SALTBYTES","crypto_hash_BYTES","crypto_hash_sha256_BYTES","crypto_hash_sha512_BYTES","crypto_kdf_BYTES_MAX","crypto_kdf_BYTES_MIN","crypto_kdf_CONTEXTBYTES","crypto_kdf_KEYBYTES","crypto_kx_PUBLICKEYBYTES","crypto_kx_SECRETKEYBYTES","crypto_kx_SEEDBYTES","crypto_kx_SESSIONKEYBYTES","crypto_onetimeauth_BYTES","crypto_onetimeauth_KEYBYTES","crypto_pwhash_ALG_ARGON2I13","crypto_pwhash_ALG_ARGON2ID13","crypto_pwhash_ALG_DEFAULT","crypto_pwhash_BYTES_MAX","crypto_pwhash_BYTES_MIN","crypto_pwhash_MEMLIMIT_INTERACTIVE","crypto_pwhash_MEMLIMIT_MAX","crypto_pwhash_MEMLIMIT_MIN","crypto_pwhash_MEMLIMIT_MODERATE","crypto_pwhash_MEMLIMIT_SENSITIVE","crypto_pwhash_OPSLIMIT_INTERACTIVE","crypto_pwhash_OPSLIMIT_MAX","crypto_pwhash_OPSLIMIT_MIN","crypto_pwhash_OPSLIMIT_MODERATE","crypto_pwhash_OPSLIMIT_SENSITIVE","crypto_pwhash_PASSWD_MAX","crypto_pwhash_PASSWD_MIN","crypto_pwhash_SALTBYTES","crypto_pwhash_STRBYTES","crypto_pwhash_STR_VERIFY","crypto_pwhash_scryptsalsa208sha256_BYTES_MAX","crypto_pwhash_scryptsalsa208sha256_BYTES_MIN","crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_INTERACTIVE","crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MAX","crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MIN","crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_SENSITIVE","crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_INTERACTIVE","crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MAX","crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MIN","crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_SENSITIVE","crypto_pwhash_scryptsalsa208sha256_SALTBYTES","crypto_pwhash_scryptsalsa208sha256_STRBYTES","crypto_pwhash_scryptsalsa208sha256_STR_VERIFY","crypto_scalarmult_BYTES","crypto_scalarmult_SCALARBYTES","crypto_scalarmult_ristretto255_BYTES","crypto_scalarmult_ristretto255_SCALARBYTES","crypto_secretbox_KEYBYTES","crypto_secretbox_MACBYTES","crypto_secretbox_MESSAGEBYTES_MAX","crypto_secretbox_NONCEBYTES","crypto_secretstream_xchacha20poly1305_ABYTES","crypto_secretstream_xchacha20poly1305_HEADERBYTES","crypto_secretstream_xchacha20poly1305_KEYBYTES","crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX","crypto_secretstream_xchacha20poly1305_MESSAGESBYTES_MAX","crypto_secretstream_xchacha20poly1305_NPUBBYTES","crypto_secretstream_xchacha20poly1305_TAG_FINAL","crypto_secretstream_xchacha20poly1305_TAG_MESSAGE","crypto_secretstream_xchacha20poly1305_TAG_PUSH","crypto_secretstream_xchacha20poly1305_TAG_REKEY","crypto_shorthash_BYTES","crypto_shorthash_KEYBYTES","crypto_shorthash_siphashx24_BYTES","crypto_shorthash_siphashx24_KEYBYTES","crypto_sign_BYTES","crypto_sign_MESSAGEBYTES_MAX","crypto_sign_PUBLICKEYBYTES","crypto_sign_SECRETKEYBYTES","crypto_sign_SEEDBYTES","crypto_stream_KEYBYTES","crypto_stream_MESSAGEBYTES_MAX","crypto_stream_NONCEBYTES","crypto_stream_chacha20_KEYBYTES","crypto_stream_chacha20_NONCEBYTES","crypto_stream_chacha20_ietf_KEYBYTES","crypto_stream_chacha20_ietf_MESSAGEBYTES_MAX","crypto_stream_chacha20_ietf_NONCEBYTES","crypto_stream_xchacha20_KEYBYTES","crypto_stream_xchacha20_MESSAGEBYTES_MAX","crypto_stream_xchacha20_NONCEBYTES","randombytes_SEEDBYTES"];for(_=0;_<n.length;_++)"function"==typeof(c=r["_"+n[_].toLowerCase()])&&(e[n[_]]=c());var s=["SODIUM_VERSION_STRING","crypto_pwhash_STRPREFIX","crypto_pwhash_scryptsalsa208sha256_STRPREFIX"];for(_=0;_<s.length;_++){var c;"function"==typeof(c=r["_"+s[_].toLowerCase()])&&(e[s[_]]=r.UTF8ToString(c()))}}r=t;try{a();var _=new Uint8Array([98,97,108,108,115]),n=e.randombytes_buf(e.crypto_secretbox_NONCEBYTES),s=e.randombytes_buf(e.crypto_secretbox_KEYBYTES),c=e.crypto_secretbox_easy(_,n,s),h=e.crypto_secretbox_open_easy(c,n,s);if(e.memcmp(_,h))return}catch(e){if(null==r.useBackupModule)throw new Error("Both wasm and asm failed to load"+e)}r.useBackupModule(),a()});function n(e){if("function"==typeof TextEncoder)return(new TextEncoder).encode(e);e=unescape(encodeURIComponent(e));for(var t=new Uint8Array(e.length),r=0,a=e.length;r<a;r++)t[r]=e.charCodeAt(r);return t}function s(e){if("function"==typeof TextDecoder)return new TextDecoder("utf-8",{fatal:!0}).decode(e);var t=Math.ceil(e.length/8192);if(t<=1)try{return decodeURIComponent(escape(String.fromCharCode.apply(null,e)))}catch(e){throw new TypeError("The encoded data was not valid.")}for(var r="",a=0,_=0;_<t;_++){var n=Array.prototype.slice.call(e,8192*_+a,8192*(_+1)+a);if(0!=n.length){var c,h=n.length,o=0;do{var p=n[--h];p>=240?(o=4,c=!0):p>=224?(o=3,c=!0):p>=192?(o=2,c=!0):p<128&&(o=1,c=!0)}while(!c);for(var y=o-(n.length-h),i=0;i<y;i++)a--,n.pop();r+=s(n)}}return r}function c(e){e=k(null,e,"input");for(var t,r,a,_="",n=0;n<e.length;n++)a=87+(r=15&e[n])+(r-10>>8&-39)<<8|87+(t=e[n]>>>4)+(t-10>>8&-39),_+=String.fromCharCode(255&a)+String.fromCharCode(a>>>8);return _}var h={ORIGINAL:1,ORIGINAL_NO_PADDING:3,URLSAFE:5,URLSAFE_NO_PADDING:7};function o(e){if(null==e)return h.URLSAFE_NO_PADDING;if(e!==h.ORIGINAL&&e!==h.ORIGINAL_NO_PADDING&&e!==h.URLSAFE&&e!=h.URLSAFE_NO_PADDING)throw new Error("unsupported base64 variant");return e}function p(e,t){t=o(t),e=k(_,e,"input");var a,_=[],n=0|Math.floor(e.length/3),c=e.length-3*n,h=4*n+(0!==c?0==(2&t)?4:2+(c>>>1):0),p=new u(h+1),y=v(e);return _.push(y),_.push(p.address),0===r._sodium_bin2base64(p.address,p.length,y,e.length,t)&&b(_,"conversion failed"),p.length=h,a=s(p.to_Uint8Array()),g(_),a}function y(e,t){var r=t||a;if(!i(r))throw new Error(r+" output format is not available");if(e instanceof u){if("uint8array"===r)return e.to_Uint8Array();if("text"===r)return s(e.to_Uint8Array());if("hex"===r)return c(e.to_Uint8Array());if("base64"===r)return p(e.to_Uint8Array(),h.URLSAFE_NO_PADDING);throw new Error('What is output format "'+r+'"?')}if("object"==typeof e){for(var _=Object.keys(e),n={},o=0;o<_.length;o++)n[_[o]]=y(e[_[o]],r);return n}if("string"==typeof e)return e;throw new TypeError("Cannot format output")}function i(e){for(var t=["uint8array","text","hex","base64"],r=0;r<t.length;r++)if(t[r]===e)return!0;return!1}function l(e){if(e){if("string"!=typeof e)throw new TypeError("When defined, the output format must be a string");if(!i(e))throw new Error(e+" is not a supported output format")}}function u(e){this.length=e,this.address=d(e)}function v(e){var t=d(e.length);return r.HEAPU8.set(e,t),t}function d(e){var t=r._malloc(e);if(0===t)throw{message:"_malloc() failed",length:e};return t}function g(e){if(e)for(var t=0;t<e.length;t++)a=e[t],r._free(a);var a}function b(e,t){throw g(e),new Error(t)}function f(e,t){throw g(e),new TypeError(t)}function m(e,t,r){null==t&&f(e,r+" cannot be null or undefined")}function k(e,t,r){return m(e,t,r),t instanceof Uint8Array?t:"string"==typeof t?n(t):void f(e,"unsupported input type for "+r)}function x(e,t,a,_,n,s){var c=[];l(s);var h=null;null!=e&&(h=v(e=k(c,e,"secret_nonce")),e.length,c.push(h)),t=k(c,t,"ciphertext");var o,p=r._crypto_aead_chacha20poly1305_abytes(),i=t.length;i<p&&f(c,"ciphertext is too short"),o=v(t),c.push(o);var d=null,m=0;null!=a&&(d=v(a=k(c,a,"additional_data")),m=a.length,c.push(d)),_=k(c,_,"public_nonce");var x,E=0|r._crypto_aead_chacha20poly1305_npubbytes();_.length!==E&&f(c,"invalid public_nonce length"),x=v(_),c.push(x),n=k(c,n,"key");var w,S=0|r._crypto_aead_chacha20poly1305_keybytes();n.length!==S&&f(c,"invalid key length"),w=v(n),c.push(w);var T=new u(i-r._crypto_aead_chacha20poly1305_abytes()|0),Y=T.address;if(c.push(Y),0===r._crypto_aead_chacha20poly1305_decrypt(Y,null,h,o,i,0,d,m,0,x,w)){var A=y(T,s);return g(c),A}b(c,"ciphertext cannot be decrypted using that key")}function E(e,t,a,_,n,s,c){var h=[];l(c);var o=null;null!=e&&(o=v(e=k(h,e,"secret_nonce")),e.length,h.push(o));var p=v(t=k(h,t,"ciphertext")),i=t.length;h.push(p),a=k(h,a,"mac");var d,m=0|r._crypto_box_macbytes();a.length!==m&&f(h,"invalid mac length"),d=v(a),h.push(d);var x=null,E=0;null!=_&&(x=v(_=k(h,_,"additional_data")),E=_.length,h.push(x)),n=k(h,n,"public_nonce");var w,S=0|r._crypto_aead_chacha20poly1305_npubbytes();n.length!==S&&f(h,"invalid public_nonce length"),w=v(n),h.push(w),s=k(h,s,"key");var T,Y=0|r._crypto_aead_chacha20poly1305_keybytes();s.length!==Y&&f(h,"invalid key length"),T=v(s),h.push(T);var A=new u(0|i),B=A.address;if(h.push(B),0===r._crypto_aead_chacha20poly1305_decrypt_detached(B,o,p,i,0,d,x,E,0,w,T)){var K=y(A,c);return g(h),K}b(h,"ciphertext cannot be decrypted using that key")}function w(e,t,a,_,n,s){var c=[];l(s);var h=v(e=k(c,e,"message")),o=e.length;c.push(h);var p=null,i=0;null!=t&&(p=v(t=k(c,t,"additional_data")),i=t.length,c.push(p));var d=null;null!=a&&(d=v(a=k(c,a,"secret_nonce")),a.length,c.push(d)),_=k(c,_,"public_nonce");var m,x=0|r._crypto_aead_chacha20poly1305_npubbytes();_.length!==x&&f(c,"invalid public_nonce length"),m=v(_),c.push(m),n=k(c,n,"key");var E,w=0|r._crypto_aead_chacha20poly1305_keybytes();n.length!==w&&f(c,"invalid key length"),E=v(n),c.push(E);var S=new u(o+r._crypto_aead_chacha20poly1305_abytes()|0),T=S.address;if(c.push(T),0===r._crypto_aead_chacha20poly1305_encrypt(T,null,h,o,0,p,i,0,d,m,E)){var Y=y(S,s);return g(c),Y}b(c,"invalid usage")}function S(e,t,a,_,n,s){var c=[];l(s);var h=v(e=k(c,e,"message")),o=e.length;c.push(h);var p=null,i=0;null!=t&&(p=v(t=k(c,t,"additional_data")),i=t.length,c.push(p));var d=null;null!=a&&(d=v(a=k(c,a,"secret_nonce")),a.length,c.push(d)),_=k(c,_,"public_nonce");var m,x=0|r._crypto_aead_chacha20poly1305_npubbytes();_.length!==x&&f(c,"invalid public_nonce length"),m=v(_),c.push(m),n=k(c,n,"key");var E,w=0|r._crypto_aead_chacha20poly1305_keybytes();n.length!==w&&f(c,"invalid key length"),E=v(n),c.push(E);var S=new u(0|o),T=S.address;c.push(T);var Y=new u(0|r._crypto_aead_chacha20poly1305_abytes()),A=Y.address;if(c.push(A),0===r._crypto_aead_chacha20poly1305_encrypt_detached(T,A,null,h,o,0,p,i,0,d,m,E)){var B=y({ciphertext:S,mac:Y},s);return g(c),B}b(c,"invalid usage")}function T(e,t,a,_,n,s){var c=[];l(s);var h=null;null!=e&&(h=v(e=k(c,e,"secret_nonce")),e.length,c.push(h)),t=k(c,t,"ciphertext");var o,p=r._crypto_aead_chacha20poly1305_ietf_abytes(),i=t.length;i<p&&f(c,"ciphertext is too short"),o=v(t),c.push(o);var d=null,m=0;null!=a&&(d=v(a=k(c,a,"additional_data")),m=a.length,c.push(d)),_=k(c,_,"public_nonce");var x,E=0|r._crypto_aead_chacha20poly1305_ietf_npubbytes();_.length!==E&&f(c,"invalid public_nonce length"),x=v(_),c.push(x),n=k(c,n,"key");var w,S=0|r._crypto_aead_chacha20poly1305_ietf_keybytes();n.length!==S&&f(c,"invalid key length"),w=v(n),c.push(w);var T=new u(i-r._crypto_aead_chacha20poly1305_ietf_abytes()|0),Y=T.address;if(c.push(Y),0===r._crypto_aead_chacha20poly1305_ietf_decrypt(Y,null,h,o,i,0,d,m,0,x,w)){var A=y(T,s);return g(c),A}b(c,"ciphertext cannot be decrypted using that key")}function Y(e,t,a,_,n,s,c){var h=[];l(c);var o=null;null!=e&&(o=v(e=k(h,e,"secret_nonce")),e.length,h.push(o));var p=v(t=k(h,t,"ciphertext")),i=t.length;h.push(p),a=k(h,a,"mac");var d,m=0|r._crypto_box_macbytes();a.length!==m&&f(h,"invalid mac length"),d=v(a),h.push(d);var x=null,E=0;null!=_&&(x=v(_=k(h,_,"additional_data")),E=_.length,h.push(x)),n=k(h,n,"public_nonce");var w,S=0|r._crypto_aead_chacha20poly1305_ietf_npubbytes();n.length!==S&&f(h,"invalid public_nonce length"),w=v(n),h.push(w),s=k(h,s,"key");var T,Y=0|r._crypto_aead_chacha20poly1305_ietf_keybytes();s.length!==Y&&f(h,"invalid key length"),T=v(s),h.push(T);var A=new u(0|i),B=A.address;if(h.push(B),0===r._crypto_aead_chacha20poly1305_ietf_decrypt_detached(B,o,p,i,0,d,x,E,0,w,T)){var K=y(A,c);return g(h),K}b(h,"ciphertext cannot be decrypted using that key")}function A(e,t,a,_,n,s){var c=[];l(s);var h=v(e=k(c,e,"message")),o=e.length;c.push(h);var p=null,i=0;null!=t&&(p=v(t=k(c,t,"additional_data")),i=t.length,c.push(p));var d=null;null!=a&&(d=v(a=k(c,a,"secret_nonce")),a.length,c.push(d)),_=k(c,_,"public_nonce");var m,x=0|r._crypto_aead_chacha20poly1305_ietf_npubbytes();_.length!==x&&f(c,"invalid public_nonce length"),m=v(_),c.push(m),n=k(c,n,"key");var E,w=0|r._crypto_aead_chacha20poly1305_ietf_keybytes();n.length!==w&&f(c,"invalid key length"),E=v(n),c.push(E);var S=new u(o+r._crypto_aead_chacha20poly1305_ietf_abytes()|0),T=S.address;if(c.push(T),0===r._crypto_aead_chacha20poly1305_ietf_encrypt(T,null,h,o,0,p,i,0,d,m,E)){var Y=y(S,s);return g(c),Y}b(c,"invalid usage")}function B(e,t,a,_,n,s){var c=[];l(s);var h=v(e=k(c,e,"message")),o=e.length;c.push(h);var p=null,i=0;null!=t&&(p=v(t=k(c,t,"additional_data")),i=t.length,c.push(p));var d=null;null!=a&&(d=v(a=k(c,a,"secret_nonce")),a.length,c.push(d)),_=k(c,_,"public_nonce");var m,x=0|r._crypto_aead_chacha20poly1305_ietf_npubbytes();_.length!==x&&f(c,"invalid public_nonce length"),m=v(_),c.push(m),n=k(c,n,"key");var E,w=0|r._crypto_aead_chacha20poly1305_ietf_keybytes();n.length!==w&&f(c,"invalid key length"),E=v(n),c.push(E);var S=new u(0|o),T=S.address;c.push(T);var Y=new u(0|r._crypto_aead_chacha20poly1305_ietf_abytes()),A=Y.address;if(c.push(A),0===r._crypto_aead_chacha20poly1305_ietf_encrypt_detached(T,A,null,h,o,0,p,i,0,d,m,E)){var B=y({ciphertext:S,mac:Y},s);return g(c),B}b(c,"invalid usage")}function K(e){var t=[];l(e);var a=new u(0|r._crypto_aead_chacha20poly1305_ietf_keybytes()),_=a.address;t.push(_),r._crypto_aead_chacha20poly1305_ietf_keygen(_);var n=y(a,e);return g(t),n}function I(e){var t=[];l(e);var a=new u(0|r._crypto_aead_chacha20poly1305_keybytes()),_=a.address;t.push(_),r._crypto_aead_chacha20poly1305_keygen(_);var n=y(a,e);return g(t),n}function M(e,t,a,_,n,s){var c=[];l(s);var h=null;null!=e&&(h=v(e=k(c,e,"secret_nonce")),e.length,c.push(h)),t=k(c,t,"ciphertext");var o,p=r._crypto_aead_xchacha20poly1305_ietf_abytes(),i=t.length;i<p&&f(c,"ciphertext is too short"),o=v(t),c.push(o);var d=null,m=0;null!=a&&(d=v(a=k(c,a,"additional_data")),m=a.length,c.push(d)),_=k(c,_,"public_nonce");var x,E=0|r._crypto_aead_xchacha20poly1305_ietf_npubbytes();_.length!==E&&f(c,"invalid public_nonce length"),x=v(_),c.push(x),n=k(c,n,"key");var w,S=0|r._crypto_aead_xchacha20poly1305_ietf_keybytes();n.length!==S&&f(c,"invalid key length"),w=v(n),c.push(w);var T=new u(i-r._crypto_aead_xchacha20poly1305_ietf_abytes()|0),Y=T.address;if(c.push(Y),0===r._crypto_aead_xchacha20poly1305_ietf_decrypt(Y,null,h,o,i,0,d,m,0,x,w)){var A=y(T,s);return g(c),A}b(c,"ciphertext cannot be decrypted using that key")}function L(e,t,a,_,n,s,c){var h=[];l(c);var o=null;null!=e&&(o=v(e=k(h,e,"secret_nonce")),e.length,h.push(o));var p=v(t=k(h,t,"ciphertext")),i=t.length;h.push(p),a=k(h,a,"mac");var d,m=0|r._crypto_box_macbytes();a.length!==m&&f(h,"invalid mac length"),d=v(a),h.push(d);var x=null,E=0;null!=_&&(x=v(_=k(h,_,"additional_data")),E=_.length,h.push(x)),n=k(h,n,"public_nonce");var w,S=0|r._crypto_aead_xchacha20poly1305_ietf_npubbytes();n.length!==S&&f(h,"invalid public_nonce length"),w=v(n),h.push(w),s=k(h,s,"key");var T,Y=0|r._crypto_aead_xchacha20poly1305_ietf_keybytes();s.length!==Y&&f(h,"invalid key length"),T=v(s),h.push(T);var A=new u(0|i),B=A.address;if(h.push(B),0===r._crypto_aead_xchacha20poly1305_ietf_decrypt_detached(B,o,p,i,0,d,x,E,0,w,T)){var K=y(A,c);return g(h),K}b(h,"ciphertext cannot be decrypted using that key")}function N(e,t,a,_,n,s){var c=[];l(s);var h=v(e=k(c,e,"message")),o=e.length;c.push(h);var p=null,i=0;null!=t&&(p=v(t=k(c,t,"additional_data")),i=t.length,c.push(p));var d=null;null!=a&&(d=v(a=k(c,a,"secret_nonce")),a.length,c.push(d)),_=k(c,_,"public_nonce");var m,x=0|r._crypto_aead_xchacha20poly1305_ietf_npubbytes();_.length!==x&&f(c,"invalid public_nonce length"),m=v(_),c.push(m),n=k(c,n,"key");var E,w=0|r._crypto_aead_xchacha20poly1305_ietf_keybytes();n.length!==w&&f(c,"invalid key length"),E=v(n),c.push(E);var S=new u(o+r._crypto_aead_xchacha20poly1305_ietf_abytes()|0),T=S.address;if(c.push(T),0===r._crypto_aead_xchacha20poly1305_ietf_encrypt(T,null,h,o,0,p,i,0,d,m,E)){var Y=y(S,s);return g(c),Y}b(c,"invalid usage")}function U(e,t,a,_,n,s){var c=[];l(s);var h=v(e=k(c,e,"message")),o=e.length;c.push(h);var p=null,i=0;null!=t&&(p=v(t=k(c,t,"additional_data")),i=t.length,c.push(p));var d=null;null!=a&&(d=v(a=k(c,a,"secret_nonce")),a.length,c.push(d)),_=k(c,_,"public_nonce");var m,x=0|r._crypto_aead_xchacha20poly1305_ietf_npubbytes();_.length!==x&&f(c,"invalid public_nonce length"),m=v(_),c.push(m),n=k(c,n,"key");var E,w=0|r._crypto_aead_xchacha20poly1305_ietf_keybytes();n.length!==w&&f(c,"invalid key length"),E=v(n),c.push(E);var S=new u(0|o),T=S.address;c.push(T);var Y=new u(0|r._crypto_aead_xchacha20poly1305_ietf_abytes()),A=Y.address;if(c.push(A),0===r._crypto_aead_xchacha20poly1305_ietf_encrypt_detached(T,A,null,h,o,0,p,i,0,d,m,E)){var B=y({ciphertext:S,mac:Y},s);return g(c),B}b(c,"invalid usage")}function O(e){var t=[];l(e);var a=new u(0|r._crypto_aead_xchacha20poly1305_ietf_keybytes()),_=a.address;t.push(_),r._crypto_aead_xchacha20poly1305_ietf_keygen(_);var n=y(a,e);return g(t),n}function R(e,t,a){var _=[];l(a);var n=v(e=k(_,e,"message")),s=e.length;_.push(n),t=k(_,t,"key");var c,h=0|r._crypto_auth_keybytes();t.length!==h&&f(_,"invalid key length"),c=v(t),_.push(c);var o=new u(0|r._crypto_auth_bytes()),p=o.address;if(_.push(p),0==(0|r._crypto_auth(p,n,s,0,c))){var i=y(o,a);return g(_),i}b(_,"invalid usage")}function P(e,t,a){var _=[];l(a);var n=v(e=k(_,e,"message")),s=e.length;_.push(n),t=k(_,t,"key");var c,h=0|r._crypto_auth_hmacsha256_keybytes();t.length!==h&&f(_,"invalid key length"),c=v(t),_.push(c);var o=new u(0|r._crypto_auth_hmacsha256_bytes()),p=o.address;if(_.push(p),0==(0|r._crypto_auth_hmacsha256(p,n,s,0,c))){var i=y(o,a);return g(_),i}b(_,"invalid usage")}function C(e){var t=[];l(e);var a=new u(0|r._crypto_auth_hmacsha256_keybytes()),_=a.address;t.push(_),r._crypto_auth_hmacsha256_keygen(_);var n=y(a,e);return g(t),n}function G(e,t,a){var _=[];e=k(_,e,"tag");var n,s=0|r._crypto_auth_hmacsha256_bytes();e.length!==s&&f(_,"invalid tag length"),n=v(e),_.push(n);var c=v(t=k(_,t,"message")),h=t.length;_.push(c),a=k(_,a,"key");var o,p=0|r._crypto_auth_hmacsha256_keybytes();a.length!==p&&f(_,"invalid key length"),o=v(a),_.push(o);var y=0==(0|r._crypto_auth_hmacsha256_verify(n,c,h,0,o));return g(_),y}function D(e,t,a){var _=[];l(a);var n=v(e=k(_,e,"message")),s=e.length;_.push(n),t=k(_,t,"key");var c,h=0|r._crypto_auth_hmacsha512_keybytes();t.length!==h&&f(_,"invalid key length"),c=v(t),_.push(c);var o=new u(0|r._crypto_auth_hmacsha512_bytes()),p=o.address;if(_.push(p),0==(0|r._crypto_auth_hmacsha512(p,n,s,0,c))){var i=y(o,a);return g(_),i}b(_,"invalid usage")}function X(e){var t=[];l(e);var a=new u(0|r._crypto_auth_hmacsha512_keybytes()),_=a.address;t.push(_),r._crypto_auth_hmacsha512_keygen(_);var n=y(a,e);return g(t),n}function V(e,t,a){var _=[];e=k(_,e,"tag");var n,s=0|r._crypto_auth_hmacsha512_bytes();e.length!==s&&f(_,"invalid tag length"),n=v(e),_.push(n);var c=v(t=k(_,t,"message")),h=t.length;_.push(c),a=k(_,a,"key");var o,p=0|r._crypto_auth_hmacsha512_keybytes();a.length!==p&&f(_,"invalid key length"),o=v(a),_.push(o);var y=0==(0|r._crypto_auth_hmacsha512_verify(n,c,h,0,o));return g(_),y}function F(e){var t=[];l(e);var a=new u(0|r._crypto_auth_keybytes()),_=a.address;t.push(_),r._crypto_auth_keygen(_);var n=y(a,e);return g(t),n}function H(e,t,a){var _=[];e=k(_,e,"tag");var n,s=0|r._crypto_auth_bytes();e.length!==s&&f(_,"invalid tag length"),n=v(e),_.push(n);var c=v(t=k(_,t,"message")),h=t.length;_.push(c),a=k(_,a,"key");var o,p=0|r._crypto_auth_keybytes();a.length!==p&&f(_,"invalid key length"),o=v(a),_.push(o);var y=0==(0|r._crypto_auth_verify(n,c,h,0,o));return g(_),y}function z(e,t,a){var _=[];l(a),e=k(_,e,"publicKey");var n,s=0|r._crypto_box_publickeybytes();e.length!==s&&f(_,"invalid publicKey length"),n=v(e),_.push(n),t=k(_,t,"privateKey");var c,h=0|r._crypto_box_secretkeybytes();t.length!==h&&f(_,"invalid privateKey length"),c=v(t),_.push(c);var o=new u(0|r._crypto_box_beforenmbytes()),p=o.address;if(_.push(p),0==(0|r._crypto_box_beforenm(p,n,c))){var i=y(o,a);return g(_),i}b(_,"invalid usage")}function j(e){var t=[];l(e);var a=new u(0|r._crypto_box_curve25519xchacha20poly1305_publickeybytes()),_=a.address;t.push(_);var n=new u(0|r._crypto_box_curve25519xchacha20poly1305_secretkeybytes()),s=n.address;t.push(s),r._crypto_box_curve25519xchacha20poly1305_keypair(_,s);var c=y({publicKey:a,privateKey:n,keyType:"curve25519"},e);return g(t),c}function q(e,t,a){var _=[];l(a);var n=v(e=k(_,e,"message")),s=e.length;_.push(n),t=k(_,t,"publicKey");var c,h=0|r._crypto_box_curve25519xchacha20poly1305_publickeybytes();t.length!==h&&f(_,"invalid publicKey length"),c=v(t),_.push(c);var o=new u(s+r._crypto_box_curve25519xchacha20poly1305_sealbytes()|0),p=o.address;_.push(p),r._crypto_box_curve25519xchacha20poly1305_seal(p,n,s,0,c);var i=y(o,a);return g(_),i}function W(e,t,a,_){var n=[];l(_),e=k(n,e,"ciphertext");var s,c=r._crypto_box_curve25519xchacha20poly1305_sealbytes(),h=e.length;h<c&&f(n,"ciphertext is too short"),s=v(e),n.push(s),t=k(n,t,"publicKey");var o,p=0|r._crypto_box_curve25519xchacha20poly1305_publickeybytes();t.length!==p&&f(n,"invalid publicKey length"),o=v(t),n.push(o),a=k(n,a,"secretKey");var i,d=0|r._crypto_box_curve25519xchacha20poly1305_secretkeybytes();a.length!==d&&f(n,"invalid secretKey length"),i=v(a),n.push(i);var b=new u(h-r._crypto_box_curve25519xchacha20poly1305_sealbytes()|0),m=b.address;n.push(m),r._crypto_box_curve25519xchacha20poly1305_seal_open(m,s,h,0,o,i);var x=y(b,_);return g(n),x}function J(e,t,a,_,n){var s=[];l(n);var c=v(e=k(s,e,"message")),h=e.length;s.push(c),t=k(s,t,"nonce");var o,p=0|r._crypto_box_noncebytes();t.length!==p&&f(s,"invalid nonce length"),o=v(t),s.push(o),a=k(s,a,"publicKey");var i,d=0|r._crypto_box_publickeybytes();a.length!==d&&f(s,"invalid publicKey length"),i=v(a),s.push(i),_=k(s,_,"privateKey");var m,x=0|r._crypto_box_secretkeybytes();_.length!==x&&f(s,"invalid privateKey length"),m=v(_),s.push(m);var E=new u(0|h),w=E.address;s.push(w);var S=new u(0|r._crypto_box_macbytes()),T=S.address;if(s.push(T),0==(0|r._crypto_box_detached(w,T,c,h,0,o,i,m))){var Y=y({ciphertext:E,mac:S},n);return g(s),Y}b(s,"invalid usage")}function Q(e,t,a,_,n){var s=[];l(n);var c=v(e=k(s,e,"message")),h=e.length;s.push(c),t=k(s,t,"nonce");var o,p=0|r._crypto_box_noncebytes();t.length!==p&&f(s,"invalid nonce length"),o=v(t),s.push(o),a=k(s,a,"publicKey");var i,d=0|r._crypto_box_publickeybytes();a.length!==d&&f(s,"invalid publicKey length"),i=v(a),s.push(i),_=k(s,_,"privateKey");var m,x=0|r._crypto_box_secretkeybytes();_.length!==x&&f(s,"invalid privateKey length"),m=v(_),s.push(m);var E=new u(h+r._crypto_box_macbytes()|0),w=E.address;if(s.push(w),0==(0|r._crypto_box_easy(w,c,h,0,o,i,m))){var S=y(E,n);return g(s),S}b(s,"invalid usage")}function Z(e,t,a,_){var n=[];l(_);var s=v(e=k(n,e,"message")),c=e.length;n.push(s),t=k(n,t,"nonce");var h,o=0|r._crypto_box_noncebytes();t.length!==o&&f(n,"invalid nonce length"),h=v(t),n.push(h),a=k(n,a,"sharedKey");var p,i=0|r._crypto_box_beforenmbytes();a.length!==i&&f(n,"invalid sharedKey length"),p=v(a),n.push(p);var d=new u(c+r._crypto_box_macbytes()|0),m=d.address;if(n.push(m),0==(0|r._crypto_box_easy_afternm(m,s,c,0,h,p))){var x=y(d,_);return g(n),x}b(n,"invalid usage")}function $(e){var t=[];l(e);var a=new u(0|r._crypto_box_publickeybytes()),_=a.address;t.push(_);var n=new u(0|r._crypto_box_secretkeybytes()),s=n.address;if(t.push(s),0==(0|r._crypto_box_keypair(_,s))){var c={publicKey:y(a,e),privateKey:y(n,e),keyType:"x25519"};return g(t),c}b(t,"internal error")}function ee(e,t,a,_,n,s){var c=[];l(s);var h=v(e=k(c,e,"ciphertext")),o=e.length;c.push(h),t=k(c,t,"mac");var p,i=0|r._crypto_box_macbytes();t.length!==i&&f(c,"invalid mac length"),p=v(t),c.push(p),a=k(c,a,"nonce");var d,m=0|r._crypto_box_noncebytes();a.length!==m&&f(c,"invalid nonce length"),d=v(a),c.push(d),_=k(c,_,"publicKey");var x,E=0|r._crypto_box_publickeybytes();_.length!==E&&f(c,"invalid publicKey length"),x=v(_),c.push(x),n=k(c,n,"privateKey");var w,S=0|r._crypto_box_secretkeybytes();n.length!==S&&f(c,"invalid privateKey length"),w=v(n),c.push(w);var T=new u(0|o),Y=T.address;if(c.push(Y),0==(0|r._crypto_box_open_detached(Y,h,p,o,0,d,x,w))){var A=y(T,s);return g(c),A}b(c,"incorrect key pair for the given ciphertext")}function te(e,t,a,_,n){var s=[];l(n),e=k(s,e,"ciphertext");var c,h=r._crypto_box_macbytes(),o=e.length;o<h&&f(s,"ciphertext is too short"),c=v(e),s.push(c),t=k(s,t,"nonce");var p,i=0|r._crypto_box_noncebytes();t.length!==i&&f(s,"invalid nonce length"),p=v(t),s.push(p),a=k(s,a,"publicKey");var d,m=0|r._crypto_box_publickeybytes();a.length!==m&&f(s,"invalid publicKey length"),d=v(a),s.push(d),_=k(s,_,"privateKey");var x,E=0|r._crypto_box_secretkeybytes();_.length!==E&&f(s,"invalid privateKey length"),x=v(_),s.push(x);var w=new u(o-r._crypto_box_macbytes()|0),S=w.address;if(s.push(S),0==(0|r._crypto_box_open_easy(S,c,o,0,p,d,x))){var T=y(w,n);return g(s),T}b(s,"incorrect key pair for the given ciphertext")}function re(e,t,a,_){var n=[];l(_);var s=v(e=k(n,e,"ciphertext")),c=e.length;n.push(s),t=k(n,t,"nonce");var h,o=0|r._crypto_box_noncebytes();t.length!==o&&f(n,"invalid nonce length"),h=v(t),n.push(h),a=k(n,a,"sharedKey");var p,i=0|r._crypto_box_beforenmbytes();a.length!==i&&f(n,"invalid sharedKey length"),p=v(a),n.push(p);var d=new u(c-r._crypto_box_macbytes()|0),m=d.address;if(n.push(m),0==(0|r._crypto_box_open_easy_afternm(m,s,c,0,h,p))){var x=y(d,_);return g(n),x}b(n,"incorrect secret key for the given ciphertext")}function ae(e,t,a){var _=[];l(a);var n=v(e=k(_,e,"message")),s=e.length;_.push(n),t=k(_,t,"publicKey");var c,h=0|r._crypto_box_publickeybytes();t.length!==h&&f(_,"invalid publicKey length"),c=v(t),_.push(c);var o=new u(s+r._crypto_box_sealbytes()|0),p=o.address;if(_.push(p),0==(0|r._crypto_box_seal(p,n,s,0,c))){var i=y(o,a);return g(_),i}b(_,"invalid usage")}function _e(e,t,a,_){var n=[];l(_),e=k(n,e,"ciphertext");var s,c=r._crypto_box_sealbytes(),h=e.length;h<c&&f(n,"ciphertext is too short"),s=v(e),n.push(s),t=k(n,t,"publicKey");var o,p=0|r._crypto_box_publickeybytes();t.length!==p&&f(n,"invalid publicKey length"),o=v(t),n.push(o),a=k(n,a,"privateKey");var i,d=0|r._crypto_box_secretkeybytes();a.length!==d&&f(n,"invalid privateKey length"),i=v(a),n.push(i);var m=new u(h-r._crypto_box_sealbytes()|0),x=m.address;if(n.push(x),0==(0|r._crypto_box_seal_open(x,s,h,0,o,i))){var E=y(m,_);return g(n),E}b(n,"incorrect key pair for the given ciphertext")}function ne(e,t){var a=[];l(t),e=k(a,e,"seed");var _,n=0|r._crypto_box_seedbytes();e.length!==n&&f(a,"invalid seed length"),_=v(e),a.push(_);var s=new u(0|r._crypto_box_publickeybytes()),c=s.address;a.push(c);var h=new u(0|r._crypto_box_secretkeybytes()),o=h.address;if(a.push(o),0==(0|r._crypto_box_seed_keypair(c,o,_))){var p={publicKey:y(s,t),privateKey:y(h,t),keyType:"x25519"};return g(a),p}b(a,"invalid usage")}function se(e,t,a){var _=[];l(a),e=k(_,e,"p");var n,s=0|r._crypto_core_ristretto255_bytes();e.length!==s&&f(_,"invalid p length"),n=v(e),_.push(n),t=k(_,t,"q");var c,h=0|r._crypto_core_ristretto255_bytes();t.length!==h&&f(_,"invalid q length"),c=v(t),_.push(c);var o=new u(0|r._crypto_core_ristretto255_bytes()),p=o.address;if(_.push(p),0==(0|r._crypto_core_ristretto255_add(p,n,c))){var i=y(o,a);return g(_),i}b(_,"inputs is invalid element")}function ce(e,t){var a=[];l(t);var _=v(e=k(a,e,"r"));e.length,a.push(_);var n=new u(0|r._crypto_core_ristretto255_bytes()),s=n.address;if(a.push(s),0==(0|r._crypto_core_ristretto255_from_hash(s,_))){var c=y(n,t);return g(a),c}b(a,"invalid usage")}function he(e,t){var a=[];l(t);var _=v(e=k(a,e,"point"));e.length,a.push(_);var n=1==(0|r._crypto_core_ristretto255_is_valid_point(_));return g(a),n}function oe(e){var t=[];l(e);var a=new u(0|r._crypto_core_ristretto255_bytes()),_=a.address;t.push(_),r._crypto_core_ristretto255_random(_);var n=y(a,e);return g(t),n}function pe(e,t,a){var _=[];l(a),e=k(_,e,"x");var n,s=0|r._crypto_core_ristretto255_scalarbytes();e.length!==s&&f(_,"invalid x length"),n=v(e),_.push(n),t=k(_,t,"y");var c,h=0|r._crypto_core_ristretto255_scalarbytes();t.length!==h&&f(_,"invalid y length"),c=v(t),_.push(c);var o=new u(0|r._crypto_core_ristretto255_scalarbytes()),p=o.address;_.push(p),r._crypto_core_ristretto255_scalar_add(p,n,c);var i=y(o,a);return g(_),i}function ye(e,t){var a=[];l(t);var _=v(e=k(a,e,"s"));e.length,a.push(_);var n=new u(0|r._crypto_core_ristretto255_scalarbytes()),s=n.address;a.push(s),r._crypto_core_ristretto255_scalar_complement(s,_);var c=y(n,t);return g(a),c}function ie(e,t){var a=[];l(t);var _=v(e=k(a,e,"s"));e.length,a.push(_);var n=new u(0|r._crypto_core_ristretto255_scalarbytes()),s=n.address;if(a.push(s),0==(0|r._crypto_core_ristretto255_scalar_invert(s,_))){var c=y(n,t);return g(a),c}b(a,"invalid reciprocate")}function le(e,t,a){var _=[];l(a),e=k(_,e,"x");var n,s=0|r._crypto_core_ristretto255_scalarbytes();e.length!==s&&f(_,"invalid x length"),n=v(e),_.push(n),t=k(_,t,"y");var c,h=0|r._crypto_core_ristretto255_scalarbytes();t.length!==h&&f(_,"invalid y length"),c=v(t),_.push(c);var o=new u(0|r._crypto_core_ristretto255_scalarbytes()),p=o.address;_.push(p),r._crypto_core_ristretto255_scalar_mul(p,n,c);var i=y(o,a);return g(_),i}function ue(e,t){var a=[];l(t);var _=v(e=k(a,e,"s"));e.length,a.push(_);var n=new u(0|r._crypto_core_ristretto255_scalarbytes()),s=n.address;a.push(s),r._crypto_core_ristretto255_scalar_negate(s,_);var c=y(n,t);return g(a),c}function ve(e){var t=[];l(e);var a=new u(0|r._crypto_core_ristretto255_scalarbytes()),_=a.address;t.push(_),r._crypto_core_ristretto255_random(_);var n=y(a,e);return g(t),n}function de(e,t){var a=[];l(t);var _=v(e=k(a,e,"sample"));e.length,a.push(_);var n=new u(0|r._crypto_core_ristretto255_scalarbytes()),s=n.address;a.push(s),r._crypto_core_ristretto255_scalar_reduce(s,_);var c=y(n,t);return g(a),c}function ge(e,t,a){var _=[];l(a),e=k(_,e,"x");var n,s=0|r._crypto_core_ristretto255_scalarbytes();e.length!==s&&f(_,"invalid x length"),n=v(e),_.push(n),t=k(_,t,"y");var c,h=0|r._crypto_core_ristretto255_scalarbytes();t.length!==h&&f(_,"invalid y length"),c=v(t),_.push(c);var o=new u(0|r._crypto_core_ristretto255_scalarbytes()),p=o.address;_.push(p),r._crypto_core_ristretto255_scalar_sub(p,n,c);var i=y(o,a);return g(_),i}function be(e,t,a){var _=[];l(a),e=k(_,e,"p");var n,s=0|r._crypto_core_ristretto255_bytes();e.length!==s&&f(_,"invalid p length"),n=v(e),_.push(n),t=k(_,t,"q");var c,h=0|r._crypto_core_ristretto255_bytes();t.length!==h&&f(_,"invalid q length"),c=v(t),_.push(c);var o=new u(0|r._crypto_core_ristretto255_bytes()),p=o.address;if(_.push(p),0==(0|r._crypto_core_ristretto255_sub(p,n,c))){var i=y(o,a);return g(_),i}b(_,"inputs is invalid element")}function fe(e,t,a,_){var n=[];l(_),m(n,e,"hash_length"),("number"!=typeof e||(0|e)!==e||e<0)&&f(n,"hash_length must be an unsigned integer");var s=v(t=k(n,t,"message")),c=t.length;n.push(s);var h=null,o=0;null!=a&&(h=v(a=k(n,a,"key")),o=a.length,n.push(h));var p=new u(e|=0),i=p.address;if(n.push(i),0==(0|r._crypto_generichash(i,e,s,c,0,h,o))){var d=y(p,_);return g(n),d}b(n,"invalid usage")}function me(e,t,a,_,n){var s=[];l(n),m(s,e,"subkey_len"),("number"!=typeof e||(0|e)!==e||e<0)&&f(s,"subkey_len must be an unsigned integer");var c=null,h=0;null!=t&&(c=v(t=k(s,t,"key")),h=t.length,s.push(c)),a=k(s,a,"id");var o,p=0|r._crypto_generichash_blake2b_saltbytes();a.length!==p&&f(s,"invalid id length"),o=v(a),s.push(o),_=k(s,_,"ctx");var i,d=0|r._crypto_generichash_blake2b_personalbytes();_.length!==d&&f(s,"invalid ctx length"),i=v(_),s.push(i);var x=new u(0|e),E=x.address;if(s.push(E),0==(0|r._crypto_generichash_blake2b_salt_personal(E,e,null,0,0,c,h,o,i))){var w=y(x,n);return g(s),w}b(s,"invalid usage")}function ke(e,t,a){var _=[];l(a),m(_,e,"state_address"),m(_,t,"hash_length"),("number"!=typeof t||(0|t)!==t||t<0)&&f(_,"hash_length must be an unsigned integer");var n=new u(t|=0),s=n.address;if(_.push(s),0==(0|r._crypto_generichash_final(e,s,t))){var c=(r._free(e),y(n,a));return g(_),c}b(_,"invalid usage")}function xe(e,t,a){var _=[];l(a);var n=null,s=0;null!=e&&(n=v(e=k(_,e,"key")),s=e.length,_.push(n)),m(_,t,"hash_length"),("number"!=typeof t||(0|t)!==t||t<0)&&f(_,"hash_length must be an unsigned integer");var c=new u(357).address;if(0==(0|r._crypto_generichash_init(c,n,s,t))){var h=c;return g(_),h}b(_,"invalid usage")}function Ee(e){var t=[];l(e);var a=new u(0|r._crypto_generichash_keybytes()),_=a.address;t.push(_),r._crypto_generichash_keygen(_);var n=y(a,e);return g(t),n}function we(e,t,a){var _=[];l(a),m(_,e,"state_address");var n=v(t=k(_,t,"message_chunk")),s=t.length;_.push(n),0!=(0|r._crypto_generichash_update(e,n,s))&&b(_,"invalid usage"),g(_)}function Se(e,t){var a=[];l(t);var _=v(e=k(a,e,"message")),n=e.length;a.push(_);var s=new u(0|r._crypto_hash_bytes()),c=s.address;if(a.push(c),0==(0|r._crypto_hash(c,_,n,0))){var h=y(s,t);return g(a),h}b(a,"invalid usage")}function Te(e,t){var a=[];l(t);var _=v(e=k(a,e,"message")),n=e.length;a.push(_);var s=new u(0|r._crypto_hash_sha256_bytes()),c=s.address;if(a.push(c),0==(0|r._crypto_hash_sha256(c,_,n,0))){var h=y(s,t);return g(a),h}b(a,"invalid usage")}function Ye(e,t){var a=[];l(t);var _=v(e=k(a,e,"message")),n=e.length;a.push(_);var s=new u(0|r._crypto_hash_sha512_bytes()),c=s.address;if(a.push(c),0==(0|r._crypto_hash_sha512(c,_,n,0))){var h=y(s,t);return g(a),h}b(a,"invalid usage")}function Ae(e,t,a,_,s){var c=[];l(s),m(c,e,"subkey_len"),("number"!=typeof e||(0|e)!==e||e<0)&&f(c,"subkey_len must be an unsigned integer"),m(c,t,"subkey_id"),("number"!=typeof t||(0|t)!==t||t<0)&&f(c,"subkey_id must be an unsigned integer"),"string"!=typeof a&&f(c,"ctx must be a string");var h=v(a=n(a+"\0"));a.length,c.push(h),_=k(c,_,"key");var o,p=0|r._crypto_kdf_keybytes();_.length!==p&&f(c,"invalid key length"),o=v(_),c.push(o);var i=new u(0|e),d=i.address;c.push(d),r._crypto_kdf_derive_from_key(d,e,t,t>>>24>>>8,h,o);var b=y(i,s);return g(c),b}function Be(e){var t=[];l(e);var a=new u(0|r._crypto_kdf_keybytes()),_=a.address;t.push(_),r._crypto_kdf_keygen(_);var n=y(a,e);return g(t),n}function Ke(e,t,a,_){var n=[];l(_),e=k(n,e,"clientPublicKey");var s,c=0|r._crypto_kx_publickeybytes();e.length!==c&&f(n,"invalid clientPublicKey length"),s=v(e),n.push(s),t=k(n,t,"clientSecretKey");var h,o=0|r._crypto_kx_secretkeybytes();t.length!==o&&f(n,"invalid clientSecretKey length"),h=v(t),n.push(h),a=k(n,a,"serverPublicKey");var p,i=0|r._crypto_kx_publickeybytes();a.length!==i&&f(n,"invalid serverPublicKey length"),p=v(a),n.push(p);var d=new u(0|r._crypto_kx_sessionkeybytes()),m=d.address;n.push(m);var x=new u(0|r._crypto_kx_sessionkeybytes()),E=x.address;if(n.push(E),0==(0|r._crypto_kx_client_session_keys(m,E,s,h,p))){var w=y({sharedRx:d,sharedTx:x},_);return g(n),w}b(n,"invalid usage")}function Ie(e){var t=[];l(e);var a=new u(0|r._crypto_kx_publickeybytes()),_=a.address;t.push(_);var n=new u(0|r._crypto_kx_secretkeybytes()),s=n.address;if(t.push(s),0==(0|r._crypto_kx_keypair(_,s))){var c={publicKey:y(a,e),privateKey:y(n,e),keyType:"x25519"};return g(t),c}b(t,"internal error")}function Me(e,t){var a=[];l(t),e=k(a,e,"seed");var _,n=0|r._crypto_kx_seedbytes();e.length!==n&&f(a,"invalid seed length"),_=v(e),a.push(_);var s=new u(0|r._crypto_kx_publickeybytes()),c=s.address;a.push(c);var h=new u(0|r._crypto_kx_secretkeybytes()),o=h.address;if(a.push(o),0==(0|r._crypto_kx_seed_keypair(c,o,_))){var p={publicKey:y(s,t),privateKey:y(h,t),keyType:"x25519"};return g(a),p}b(a,"internal error")}function Le(e,t,a,_){var n=[];l(_),e=k(n,e,"serverPublicKey");var s,c=0|r._crypto_kx_publickeybytes();e.length!==c&&f(n,"invalid serverPublicKey length"),s=v(e),n.push(s),t=k(n,t,"serverSecretKey");var h,o=0|r._crypto_kx_secretkeybytes();t.length!==o&&f(n,"invalid serverSecretKey length"),h=v(t),n.push(h),a=k(n,a,"clientPublicKey");var p,i=0|r._crypto_kx_publickeybytes();a.length!==i&&f(n,"invalid clientPublicKey length"),p=v(a),n.push(p);var d=new u(0|r._crypto_kx_sessionkeybytes()),m=d.address;n.push(m);var x=new u(0|r._crypto_kx_sessionkeybytes()),E=x.address;if(n.push(E),0==(0|r._crypto_kx_server_session_keys(m,E,s,h,p))){var w=y({sharedRx:d,sharedTx:x},_);return g(n),w}b(n,"invalid usage")}function Ne(e,t,a){var _=[];l(a);var n=v(e=k(_,e,"message")),s=e.length;_.push(n),t=k(_,t,"key");var c,h=0|r._crypto_onetimeauth_keybytes();t.length!==h&&f(_,"invalid key length"),c=v(t),_.push(c);var o=new u(0|r._crypto_onetimeauth_bytes()),p=o.address;if(_.push(p),0==(0|r._crypto_onetimeauth(p,n,s,0,c))){var i=y(o,a);return g(_),i}b(_,"invalid usage")}function Ue(e,t){var a=[];l(t),m(a,e,"state_address");var _=new u(0|r._crypto_onetimeauth_bytes()),n=_.address;if(a.push(n),0==(0|r._crypto_onetimeauth_final(e,n))){var s=(r._free(e),y(_,t));return g(a),s}b(a,"invalid usage")}function Oe(e,t){var a=[];l(t);var _=null;null!=e&&(_=v(e=k(a,e,"key")),e.length,a.push(_));var n=new u(144).address;if(0==(0|r._crypto_onetimeauth_init(n,_))){var s=n;return g(a),s}b(a,"invalid usage")}function Re(e){var t=[];l(e);var a=new u(0|r._crypto_onetimeauth_keybytes()),_=a.address;t.push(_),r._crypto_onetimeauth_keygen(_);var n=y(a,e);return g(t),n}function Pe(e,t,a){var _=[];l(a),m(_,e,"state_address");var n=v(t=k(_,t,"message_chunk")),s=t.length;_.push(n),0!=(0|r._crypto_onetimeauth_update(e,n,s))&&b(_,"invalid usage"),g(_)}function Ce(e,t,a){var _=[];e=k(_,e,"hash");var n,s=0|r._crypto_onetimeauth_bytes();e.length!==s&&f(_,"invalid hash length"),n=v(e),_.push(n);var c=v(t=k(_,t,"message")),h=t.length;_.push(c),a=k(_,a,"key");var o,p=0|r._crypto_onetimeauth_keybytes();a.length!==p&&f(_,"invalid key length"),o=v(a),_.push(o);var y=0==(0|r._crypto_onetimeauth_verify(n,c,h,0,o));return g(_),y}function Ge(e,t,a,_,n,s,c){var h=[];l(c),m(h,e,"keyLength"),("number"!=typeof e||(0|e)!==e||e<0)&&f(h,"keyLength must be an unsigned integer");var o=v(t=k(h,t,"password")),p=t.length;h.push(o),a=k(h,a,"salt");var i,d=0|r._crypto_pwhash_saltbytes();a.length!==d&&f(h,"invalid salt length"),i=v(a),h.push(i),m(h,_,"opsLimit"),("number"!=typeof _||(0|_)!==_||_<0)&&f(h,"opsLimit must be an unsigned integer"),m(h,n,"memLimit"),("number"!=typeof n||(0|n)!==n||n<0)&&f(h,"memLimit must be an unsigned integer"),m(h,s,"algorithm"),("number"!=typeof s||(0|s)!==s||s<0)&&f(h,"algorithm must be an unsigned integer");var x=new u(0|e),E=x.address;if(h.push(E),0==(0|r._crypto_pwhash(E,e,0,o,p,0,i,_,0,n,s))){var w=y(x,c);return g(h),w}b(h,"invalid usage")}function De(e,t,a,_,n,s){var c=[];l(s),m(c,e,"keyLength"),("number"!=typeof e||(0|e)!==e||e<0)&&f(c,"keyLength must be an unsigned integer");var h=v(t=k(c,t,"password")),o=t.length;c.push(h),a=k(c,a,"salt");var p,i=0|r._crypto_pwhash_scryptsalsa208sha256_saltbytes();a.length!==i&&f(c,"invalid salt length"),p=v(a),c.push(p),m(c,_,"opsLimit"),("number"!=typeof _||(0|_)!==_||_<0)&&f(c,"opsLimit must be an unsigned integer"),m(c,n,"memLimit"),("number"!=typeof n||(0|n)!==n||n<0)&&f(c,"memLimit must be an unsigned integer");var d=new u(0|e),x=d.address;if(c.push(x),0==(0|r._crypto_pwhash_scryptsalsa208sha256(x,e,0,h,o,0,p,_,0,n))){var E=y(d,s);return g(c),E}b(c,"invalid usage")}function Xe(e,t,a,_,n,s,c){var h=[];l(c);var o=v(e=k(h,e,"password")),p=e.length;h.push(o);var i=v(t=k(h,t,"salt")),d=t.length;h.push(i),m(h,a,"opsLimit"),("number"!=typeof a||(0|a)!==a||a<0)&&f(h,"opsLimit must be an unsigned integer"),m(h,_,"r"),("number"!=typeof _||(0|_)!==_||_<0)&&f(h,"r must be an unsigned integer"),m(h,n,"p"),("number"!=typeof n||(0|n)!==n||n<0)&&f(h,"p must be an unsigned integer"),m(h,s,"keyLength"),("number"!=typeof s||(0|s)!==s||s<0)&&f(h,"keyLength must be an unsigned integer");var x=new u(0|s),E=x.address;if(h.push(E),0==(0|r._crypto_pwhash_scryptsalsa208sha256_ll(o,p,i,d,a,0,_,n,E,s))){var w=y(x,c);return g(h),w}b(h,"invalid usage")}function Ve(e,t,a,_){var n=[];l(_);var s=v(e=k(n,e,"password")),c=e.length;n.push(s),m(n,t,"opsLimit"),("number"!=typeof t||(0|t)!==t||t<0)&&f(n,"opsLimit must be an unsigned integer"),m(n,a,"memLimit"),("number"!=typeof a||(0|a)!==a||a<0)&&f(n,"memLimit must be an unsigned integer");var h=new u(0|r._crypto_pwhash_scryptsalsa208sha256_strbytes()).address;if(n.push(h),0==(0|r._crypto_pwhash_scryptsalsa208sha256_str(h,s,c,0,t,0,a))){var o=r.UTF8ToString(h);return g(n),o}b(n,"invalid usage")}function Fe(e,t,a){var _=[];l(a),"string"!=typeof e&&f(_,"hashed_password must be a string");var s=v(e=n(e+"\0"));e.length,_.push(s);var c=v(t=k(_,t,"password")),h=t.length;_.push(c);var o=0==(0|r._crypto_pwhash_scryptsalsa208sha256_str_verify(s,c,h,0));return g(_),o}function He(e,t,a,_){var n=[];l(_);var s=v(e=k(n,e,"password")),c=e.length;n.push(s),m(n,t,"opsLimit"),("number"!=typeof t||(0|t)!==t||t<0)&&f(n,"opsLimit must be an unsigned integer"),m(n,a,"memLimit"),("number"!=typeof a||(0|a)!==a||a<0)&&f(n,"memLimit must be an unsigned integer");var h=new u(0|r._crypto_pwhash_strbytes()).address;if(n.push(h),0==(0|r._crypto_pwhash_str(h,s,c,0,t,0,a))){var o=r.UTF8ToString(h);return g(n),o}b(n,"invalid usage")}function ze(e,t,a){var _=[];l(a),"string"!=typeof e&&f(_,"hashed_password must be a string");var s=v(e=n(e+"\0"));e.length,_.push(s);var c=v(t=k(_,t,"password")),h=t.length;_.push(c);var o=0==(0|r._crypto_pwhash_str_verify(s,c,h,0));return g(_),o}function je(e,t,a){var _=[];l(a),e=k(_,e,"privateKey");var n,s=0|r._crypto_scalarmult_scalarbytes();e.length!==s&&f(_,"invalid privateKey length"),n=v(e),_.push(n),t=k(_,t,"publicKey");var c,h=0|r._crypto_scalarmult_scalarbytes();t.length!==h&&f(_,"invalid publicKey length"),c=v(t),_.push(c);var o=new u(0|r._crypto_scalarmult_bytes()),p=o.address;if(_.push(p),0==(0|r._crypto_scalarmult(p,n,c))){var i=y(o,a);return g(_),i}b(_,"weak public key")}function qe(e,t){var a=[];l(t),e=k(a,e,"privateKey");var _,n=0|r._crypto_scalarmult_scalarbytes();e.length!==n&&f(a,"invalid privateKey length"),_=v(e),a.push(_);var s=new u(0|r._crypto_scalarmult_scalarbytes()),c=s.address;if(a.push(c),0==(0|r._crypto_scalarmult_base(c,_))){var h=y(s,t);return g(a),h}b(a,"insecure scalar")}function We(e,t,a){var _=[];l(a),e=k(_,e,"scalar");var n,s=0|r._crypto_scalarmult_ristretto255_scalarbytes();e.length!==s&&f(_,"invalid scalar length"),n=v(e),_.push(n),t=k(_,t,"privateKey");var c,h=0|r._crypto_scalarmult_ristretto255_bytes();t.length!==h&&f(_,"invalid privateKey length"),c=v(t),_.push(c);var o=new u(0|r._crypto_scalarmult_ristretto255_bytes()),p=o.address;if(_.push(p),0==(0|r._crypto_scalarmult_ristretto255(p,n,c))){var i=y(o,a);return g(_),i}b(_,"input is zero element")}function Je(e,t){var a=[];l(t);var _=v(e=k(a,e,"scalar"));e.length,a.push(_);var n=new u(0|r._crypto_core_ristretto255_bytes()),s=n.address;if(a.push(s),0==(0|r._crypto_scalarmult_ristretto255_base(s,_))){var c=y(n,t);return g(a),c}b(a,"scalar is 0")}function Qe(e,t,a,_){var n=[];l(_);var s=v(e=k(n,e,"message")),c=e.length;n.push(s),t=k(n,t,"nonce");var h,o=0|r._crypto_secretbox_noncebytes();t.length!==o&&f(n,"invalid nonce length"),h=v(t),n.push(h),a=k(n,a,"key");var p,i=0|r._crypto_secretbox_keybytes();a.length!==i&&f(n,"invalid key length"),p=v(a),n.push(p);var d=new u(0|c),m=d.address;n.push(m);var x=new u(0|r._crypto_secretbox_macbytes()),E=x.address;if(n.push(E),0==(0|r._crypto_secretbox_detached(m,E,s,c,0,h,p))){var w=y({mac:x,cipher:d},_);return g(n),w}b(n,"invalid usage")}function Ze(e,t,a,_){var n=[];l(_);var s=v(e=k(n,e,"message")),c=e.length;n.push(s),t=k(n,t,"nonce");var h,o=0|r._crypto_secretbox_noncebytes();t.length!==o&&f(n,"invalid nonce length"),h=v(t),n.push(h),a=k(n,a,"key");var p,i=0|r._crypto_secretbox_keybytes();a.length!==i&&f(n,"invalid key length"),p=v(a),n.push(p);var d=new u(c+r._crypto_secretbox_macbytes()|0),m=d.address;if(n.push(m),0==(0|r._crypto_secretbox_easy(m,s,c,0,h,p))){var x=y(d,_);return g(n),x}b(n,"invalid usage")}function $e(e){var t=[];l(e);var a=new u(0|r._crypto_secretbox_keybytes()),_=a.address;t.push(_),r._crypto_secretbox_keygen(_);var n=y(a,e);return g(t),n}function et(e,t,a,_,n){var s=[];l(n);var c=v(e=k(s,e,"ciphertext")),h=e.length;s.push(c),t=k(s,t,"mac");var o,p=0|r._crypto_secretbox_macbytes();t.length!==p&&f(s,"invalid mac length"),o=v(t),s.push(o),a=k(s,a,"nonce");var i,d=0|r._crypto_secretbox_noncebytes();a.length!==d&&f(s,"invalid nonce length"),i=v(a),s.push(i),_=k(s,_,"key");var m,x=0|r._crypto_secretbox_keybytes();_.length!==x&&f(s,"invalid key length"),m=v(_),s.push(m);var E=new u(0|h),w=E.address;if(s.push(w),0==(0|r._crypto_secretbox_open_detached(w,c,o,h,0,i,m))){var S=y(E,n);return g(s),S}b(s,"wrong secret key for the given ciphertext")}function tt(e,t,a,_){var n=[];l(_),e=k(n,e,"ciphertext");var s,c=r._crypto_secretbox_macbytes(),h=e.length;h<c&&f(n,"ciphertext is too short"),s=v(e),n.push(s),t=k(n,t,"nonce");var o,p=0|r._crypto_secretbox_noncebytes();t.length!==p&&f(n,"invalid nonce length"),o=v(t),n.push(o),a=k(n,a,"key");var i,d=0|r._crypto_secretbox_keybytes();a.length!==d&&f(n,"invalid key length"),i=v(a),n.push(i);var m=new u(h-r._crypto_secretbox_macbytes()|0),x=m.address;if(n.push(x),0==(0|r._crypto_secretbox_open_easy(x,s,h,0,o,i))){var E=y(m,_);return g(n),E}b(n,"wrong secret key for the given ciphertext")}function rt(e,t,a){var _=[];l(a),e=k(_,e,"header");var n,s=0|r._crypto_secretstream_xchacha20poly1305_headerbytes();e.length!==s&&f(_,"invalid header length"),n=v(e),_.push(n),t=k(_,t,"key");var c,h=0|r._crypto_secretstream_xchacha20poly1305_keybytes();t.length!==h&&f(_,"invalid key length"),c=v(t),_.push(c);var o=new u(52).address;if(0==(0|r._crypto_secretstream_xchacha20poly1305_init_pull(o,n,c))){var p=o;return g(_),p}b(_,"invalid usage")}function at(e,t){var a=[];l(t),e=k(a,e,"key");var _,n=0|r._crypto_secretstream_xchacha20poly1305_keybytes();e.length!==n&&f(a,"invalid key length"),_=v(e),a.push(_);var s=new u(52).address,c=new u(0|r._crypto_secretstream_xchacha20poly1305_headerbytes()),h=c.address;if(a.push(h),0==(0|r._crypto_secretstream_xchacha20poly1305_init_push(s,h,_))){var o={state:s,header:y(c,t)};return g(a),o}b(a,"invalid usage")}function _t(e){var t=[];l(e);var a=new u(0|r._crypto_secretstream_xchacha20poly1305_keybytes()),_=a.address;t.push(_),r._crypto_secretstream_xchacha20poly1305_keygen(_);var n=y(a,e);return g(t),n}function nt(e,t,a,_){var n=[];l(_),m(n,e,"state_address"),t=k(n,t,"cipher");var s,c=r._crypto_secretstream_xchacha20poly1305_abytes(),h=t.length;h<c&&f(n,"cipher is too short"),s=v(t),n.push(s);var o=null,p=0;null!=a&&(o=v(a=k(n,a,"ad")),p=a.length,n.push(o));var i=new u(h-r._crypto_secretstream_xchacha20poly1305_abytes()|0),b=i.address;n.push(b);var x,E=(x=d(1),n.push(x),(E=0===r._crypto_secretstream_xchacha20poly1305_pull(e,b,0,x,s,h,0,o,p)&&{tag:r.HEAPU8[x],message:i})&&{message:y(E.message,_),tag:E.tag});return g(n),E}function st(e,t,a,_,n){var s=[];l(n),m(s,e,"state_address");var c=v(t=k(s,t,"message_chunk")),h=t.length;s.push(c);var o=null,p=0;null!=a&&(o=v(a=k(s,a,"ad")),p=a.length,s.push(o)),m(s,_,"tag"),("number"!=typeof _||(0|_)!==_||_<0)&&f(s,"tag must be an unsigned integer");var i=new u(h+r._crypto_secretstream_xchacha20poly1305_abytes()|0),d=i.address;if(s.push(d),0==(0|r._crypto_secretstream_xchacha20poly1305_push(e,d,0,c,h,0,o,p,0,_))){var x=y(i,n);return g(s),x}b(s,"invalid usage")}function ct(e,t){var a=[];return l(t),m(a,e,"state_address"),r._crypto_secretstream_xchacha20poly1305_rekey(e),g(a),!0}function ht(e,t,a){var _=[];l(a);var n=v(e=k(_,e,"message")),s=e.length;_.push(n),t=k(_,t,"key");var c,h=0|r._crypto_shorthash_keybytes();t.length!==h&&f(_,"invalid key length"),c=v(t),_.push(c);var o=new u(0|r._crypto_shorthash_bytes()),p=o.address;if(_.push(p),0==(0|r._crypto_shorthash(p,n,s,0,c))){var i=y(o,a);return g(_),i}b(_,"invalid usage")}function ot(e){var t=[];l(e);var a=new u(0|r._crypto_shorthash_keybytes()),_=a.address;t.push(_),r._crypto_shorthash_keygen(_);var n=y(a,e);return g(t),n}function pt(e,t,a){var _=[];l(a);var n=v(e=k(_,e,"message")),s=e.length;_.push(n),t=k(_,t,"key");var c,h=0|r._crypto_shorthash_siphashx24_keybytes();t.length!==h&&f(_,"invalid key length"),c=v(t),_.push(c);var o=new u(0|r._crypto_shorthash_siphashx24_bytes()),p=o.address;if(_.push(p),0==(0|r._crypto_shorthash_siphashx24(p,n,s,0,c))){var i=y(o,a);return g(_),i}b(_,"invalid usage")}function yt(e,t,a){var _=[];l(a);var n=v(e=k(_,e,"message")),s=e.length;_.push(n),t=k(_,t,"privateKey");var c,h=0|r._crypto_sign_secretkeybytes();t.length!==h&&f(_,"invalid privateKey length"),c=v(t),_.push(c);var o=new u(e.length+r._crypto_sign_bytes()|0),p=o.address;if(_.push(p),0==(0|r._crypto_sign(p,null,n,s,0,c))){var i=y(o,a);return g(_),i}b(_,"invalid usage")}function it(e,t,a){var _=[];l(a);var n=v(e=k(_,e,"message")),s=e.length;_.push(n),t=k(_,t,"privateKey");var c,h=0|r._crypto_sign_secretkeybytes();t.length!==h&&f(_,"invalid privateKey length"),c=v(t),_.push(c);var o=new u(0|r._crypto_sign_bytes()),p=o.address;if(_.push(p),0==(0|r._crypto_sign_detached(p,null,n,s,0,c))){var i=y(o,a);return g(_),i}b(_,"invalid usage")}function lt(e,t){var a=[];l(t),e=k(a,e,"edPk");var _,n=0|r._crypto_sign_publickeybytes();e.length!==n&&f(a,"invalid edPk length"),_=v(e),a.push(_);var s=new u(0|r._crypto_scalarmult_scalarbytes()),c=s.address;if(a.push(c),0==(0|r._crypto_sign_ed25519_pk_to_curve25519(c,_))){var h=y(s,t);return g(a),h}b(a,"invalid key")}function ut(e,t){var a=[];l(t),e=k(a,e,"edSk");var _,n=0|r._crypto_sign_secretkeybytes();e.length!==n&&f(a,"invalid edSk length"),_=v(e),a.push(_);var s=new u(0|r._crypto_scalarmult_scalarbytes()),c=s.address;if(a.push(c),0==(0|r._crypto_sign_ed25519_sk_to_curve25519(c,_))){var h=y(s,t);return g(a),h}b(a,"invalid key")}function vt(e,t){var a=[];l(t),e=k(a,e,"privateKey");var _,n=0|r._crypto_sign_secretkeybytes();e.length!==n&&f(a,"invalid privateKey length"),_=v(e),a.push(_);var s=new u(0|r._crypto_sign_publickeybytes()),c=s.address;if(a.push(c),0==(0|r._crypto_sign_ed25519_sk_to_pk(c,_))){var h=y(s,t);return g(a),h}b(a,"invalid key")}function dt(e,t){var a=[];l(t),e=k(a,e,"privateKey");var _,n=0|r._crypto_sign_secretkeybytes();e.length!==n&&f(a,"invalid privateKey length"),_=v(e),a.push(_);var s=new u(0|r._crypto_sign_seedbytes()),c=s.address;if(a.push(c),0==(0|r._crypto_sign_ed25519_sk_to_seed(c,_))){var h=y(s,t);return g(a),h}b(a,"invalid key")}function gt(e,t,a){var _=[];l(a),m(_,e,"state_address"),t=k(_,t,"privateKey");var n,s=0|r._crypto_sign_secretkeybytes();t.length!==s&&f(_,"invalid privateKey length"),n=v(t),_.push(n);var c=new u(0|r._crypto_sign_bytes()),h=c.address;if(_.push(h),0==(0|r._crypto_sign_final_create(e,h,null,n))){var o=(r._free(e),y(c,a));return g(_),o}b(_,"invalid usage")}function bt(e,t,a,_){var n=[];l(_),m(n,e,"state_address"),t=k(n,t,"signature");var s,c=0|r._crypto_sign_bytes();t.length!==c&&f(n,"invalid signature length"),s=v(t),n.push(s),a=k(n,a,"publicKey");var h,o=0|r._crypto_sign_publickeybytes();a.length!==o&&f(n,"invalid publicKey length"),h=v(a),n.push(h);var p=0==(0|r._crypto_sign_final_verify(e,s,h));return g(n),p}function ft(e){var t=[];l(e);var a=new u(208).address;if(0==(0|r._crypto_sign_init(a))){var _=a;return g(t),_}b(t,"internal error")}function mt(e){var t=[];l(e);var a=new u(0|r._crypto_sign_publickeybytes()),_=a.address;t.push(_);var n=new u(0|r._crypto_sign_secretkeybytes()),s=n.address;if(t.push(s),0==(0|r._crypto_sign_keypair(_,s))){var c={publicKey:y(a,e),privateKey:y(n,e),keyType:"ed25519"};return g(t),c}b(t,"internal error")}function kt(e,t,a){var _=[];l(a),e=k(_,e,"signedMessage");var n,s=r._crypto_sign_bytes(),c=e.length;c<s&&f(_,"signedMessage is too short"),n=v(e),_.push(n),t=k(_,t,"publicKey");var h,o=0|r._crypto_sign_publickeybytes();t.length!==o&&f(_,"invalid publicKey length"),h=v(t),_.push(h);var p=new u(c-r._crypto_sign_bytes()|0),i=p.address;if(_.push(i),0==(0|r._crypto_sign_open(i,null,n,c,0,h))){var d=y(p,a);return g(_),d}b(_,"incorrect signature for the given public key")}function xt(e,t){var a=[];l(t),e=k(a,e,"seed");var _,n=0|r._crypto_sign_seedbytes();e.length!==n&&f(a,"invalid seed length"),_=v(e),a.push(_);var s=new u(0|r._crypto_sign_publickeybytes()),c=s.address;a.push(c);var h=new u(0|r._crypto_sign_secretkeybytes()),o=h.address;if(a.push(o),0==(0|r._crypto_sign_seed_keypair(c,o,_))){var p={publicKey:y(s,t),privateKey:y(h,t),keyType:"ed25519"};return g(a),p}b(a,"invalid usage")}function Et(e,t,a){var _=[];l(a),m(_,e,"state_address");var n=v(t=k(_,t,"message_chunk")),s=t.length;_.push(n),0!=(0|r._crypto_sign_update(e,n,s))&&b(_,"invalid usage"),g(_)}function wt(e,t,a){var _=[];e=k(_,e,"signature");var n,s=0|r._crypto_sign_bytes();e.length!==s&&f(_,"invalid signature length"),n=v(e),_.push(n);var c=v(t=k(_,t,"message")),h=t.length;_.push(c),a=k(_,a,"publicKey");var o,p=0|r._crypto_sign_publickeybytes();a.length!==p&&f(_,"invalid publicKey length"),o=v(a),_.push(o);var y=0==(0|r._crypto_sign_verify_detached(n,c,h,0,o));return g(_),y}function St(e,t,a,_){var n=[];l(_),m(n,e,"outLength"),("number"!=typeof e||(0|e)!==e||e<0)&&f(n,"outLength must be an unsigned integer"),t=k(n,t,"key");var s,c=0|r._crypto_stream_chacha20_keybytes();t.length!==c&&f(n,"invalid key length"),s=v(t),n.push(s),a=k(n,a,"nonce");var h,o=0|r._crypto_stream_chacha20_noncebytes();a.length!==o&&f(n,"invalid nonce length"),h=v(a),n.push(h);var p=new u(0|e),i=p.address;n.push(i),r._crypto_stream_chacha20(i,e,0,h,s);var d=y(p,_);return g(n),d}function Tt(e,t,a,_){var n=[];l(_);var s=v(e=k(n,e,"input_message")),c=e.length;n.push(s),t=k(n,t,"nonce");var h,o=0|r._crypto_stream_chacha20_ietf_noncebytes();t.length!==o&&f(n,"invalid nonce length"),h=v(t),n.push(h),a=k(n,a,"key");var p,i=0|r._crypto_stream_chacha20_ietf_keybytes();a.length!==i&&f(n,"invalid key length"),p=v(a),n.push(p);var d=new u(0|c),m=d.address;if(n.push(m),0===r._crypto_stream_chacha20_ietf_xor(m,s,c,0,h,p)){var x=y(d,_);return g(n),x}b(n,"invalid usage")}function Yt(e,t,a,_,n){var s=[];l(n);var c=v(e=k(s,e,"input_message")),h=e.length;s.push(c),t=k(s,t,"nonce");var o,p=0|r._crypto_stream_chacha20_ietf_noncebytes();t.length!==p&&f(s,"invalid nonce length"),o=v(t),s.push(o),m(s,a,"nonce_increment"),("number"!=typeof a||(0|a)!==a||a<0)&&f(s,"nonce_increment must be an unsigned integer"),_=k(s,_,"key");var i,d=0|r._crypto_stream_chacha20_ietf_keybytes();_.length!==d&&f(s,"invalid key length"),i=v(_),s.push(i);var x=new u(0|h),E=x.address;if(s.push(E),0===r._crypto_stream_chacha20_ietf_xor_ic(E,c,h,0,o,a,0,i)){var w=y(x,n);return g(s),w}b(s,"invalid usage")}function At(e){var t=[];l(e);var a=new u(0|r._crypto_stream_chacha20_keybytes()),_=a.address;t.push(_),r._crypto_stream_chacha20_keygen(_);var n=y(a,e);return g(t),n}function Bt(e,t,a,_){var n=[];l(_);var s=v(e=k(n,e,"input_message")),c=e.length;n.push(s),t=k(n,t,"nonce");var h,o=0|r._crypto_stream_chacha20_noncebytes();t.length!==o&&f(n,"invalid nonce length"),h=v(t),n.push(h),a=k(n,a,"key");var p,i=0|r._crypto_stream_chacha20_keybytes();a.length!==i&&f(n,"invalid key length"),p=v(a),n.push(p);var d=new u(0|c),m=d.address;if(n.push(m),0===r._crypto_stream_chacha20_xor(m,s,c,0,h,p)){var x=y(d,_);return g(n),x}b(n,"invalid usage")}function Kt(e,t,a,_,n){var s=[];l(n);var c=v(e=k(s,e,"input_message")),h=e.length;s.push(c),t=k(s,t,"nonce");var o,p=0|r._crypto_stream_chacha20_noncebytes();t.length!==p&&f(s,"invalid nonce length"),o=v(t),s.push(o),m(s,a,"nonce_increment"),("number"!=typeof a||(0|a)!==a||a<0)&&f(s,"nonce_increment must be an unsigned integer"),_=k(s,_,"key");var i,d=0|r._crypto_stream_chacha20_keybytes();_.length!==d&&f(s,"invalid key length"),i=v(_),s.push(i);var x=new u(0|h),E=x.address;if(s.push(E),0===r._crypto_stream_chacha20_xor_ic(E,c,h,0,o,a,0,i)){var w=y(x,n);return g(s),w}b(s,"invalid usage")}function It(e){var t=[];l(e);var a=new u(0|r._crypto_stream_keybytes()),_=a.address;t.push(_),r._crypto_stream_keygen(_);var n=y(a,e);return g(t),n}function Mt(e){var t=[];l(e);var a=new u(0|r._crypto_stream_xchacha20_keybytes()),_=a.address;t.push(_),r._crypto_stream_xchacha20_keygen(_);var n=y(a,e);return g(t),n}function Lt(e,t,a,_){var n=[];l(_);var s=v(e=k(n,e,"input_message")),c=e.length;n.push(s),t=k(n,t,"nonce");var h,o=0|r._crypto_stream_xchacha20_noncebytes();t.length!==o&&f(n,"invalid nonce length"),h=v(t),n.push(h),a=k(n,a,"key");var p,i=0|r._crypto_stream_xchacha20_keybytes();a.length!==i&&f(n,"invalid key length"),p=v(a),n.push(p);var d=new u(0|c),m=d.address;if(n.push(m),0===r._crypto_stream_xchacha20_xor(m,s,c,0,h,p)){var x=y(d,_);return g(n),x}b(n,"invalid usage")}function Nt(e,t,a,_,n){var s=[];l(n);var c=v(e=k(s,e,"input_message")),h=e.length;s.push(c),t=k(s,t,"nonce");var o,p=0|r._crypto_stream_xchacha20_noncebytes();t.length!==p&&f(s,"invalid nonce length"),o=v(t),s.push(o),m(s,a,"nonce_increment"),("number"!=typeof a||(0|a)!==a||a<0)&&f(s,"nonce_increment must be an unsigned integer"),_=k(s,_,"key");var i,d=0|r._crypto_stream_xchacha20_keybytes();_.length!==d&&f(s,"invalid key length"),i=v(_),s.push(i);var x=new u(0|h),E=x.address;if(s.push(E),0===r._crypto_stream_xchacha20_xor_ic(E,c,h,0,o,a,0,i)){var w=y(x,n);return g(s),w}b(s,"invalid usage")}function Ut(e,t){var a=[];l(t),m(a,e,"length"),("number"!=typeof e||(0|e)!==e||e<0)&&f(a,"length must be an unsigned integer");var _=new u(0|e),n=_.address;a.push(n),r._randombytes_buf(n,e);var s=y(_,t);return g(a),s}function Ot(e,t,a){var _=[];l(a),m(_,e,"length"),("number"!=typeof e||(0|e)!==e||e<0)&&f(_,"length must be an unsigned integer"),t=k(_,t,"seed");var n,s=0|r._randombytes_seedbytes();t.length!==s&&f(_,"invalid seed length"),n=v(t),_.push(n);var c=new u(0|e),h=c.address;_.push(h),r._randombytes_buf_deterministic(h,e,n);var o=y(c,a);return g(_),o}function Rt(e){l(e),r._randombytes_close()}function Pt(e){l(e);var t=r._randombytes_random()>>>0;return g([]),t}function Ct(e,t){var a=[];l(t);for(var _=r._malloc(24),n=0;n<6;n++)r.setValue(_+4*n,r.Runtime.addFunction(e[["implementation_name","random","stir","uniform","buf","close"][n]]),"i32");0!=(0|r._randombytes_set_implementation(_))&&b(a,"unsupported implementation"),g(a)}function Gt(e){l(e),r._randombytes_stir()}function Dt(e,t){var a=[];l(t),m(a,e,"upper_bound"),("number"!=typeof e||(0|e)!==e||e<0)&&f(a,"upper_bound must be an unsigned integer");var _=r._randombytes_uniform(e)>>>0;return g(a),_}function Xt(){var e=r._sodium_version_string(),t=r.UTF8ToString(e);return g([]),t}return u.prototype.to_Uint8Array=function(){var e=new Uint8Array(this.length);return e.set(r.HEAPU8.subarray(this.address,this.address+this.length)),e},e.add=function(e,t){if(!(e instanceof Uint8Array&&t instanceof Uint8Array))throw new TypeError("Only Uint8Array instances can added");var r=e.length,a=0,_=0;if(t.length!=e.length)throw new TypeError("Arguments must have the same length");for(_=0;_<r;_++)a>>=8,a+=e[_]+t[_],e[_]=255&a},e.base64_variants=h,e.compare=function(e,t){if(!(e instanceof Uint8Array&&t instanceof Uint8Array))throw new TypeError("Only Uint8Array instances can be compared");if(e.length!==t.length)throw new TypeError("Only instances of identical length can be compared");for(var r=0,a=1,_=e.length;_-- >0;)r|=t[_]-e[_]>>8&a,a&=(t[_]^e[_])-1>>8;return r+r+a-1},e.from_base64=function(e,t){t=o(t);var a,_=[],n=new u(3*(e=k(_,e,"input")).length/4),s=v(e),c=d(4),h=d(4);return _.push(s),_.push(n.address),_.push(n.result_bin_len_p),_.push(n.b64_end_p),0!==r._sodium_base642bin(n.address,n.length,s,e.length,0,c,h,t)&&b(_,"invalid input"),r.getValue(h,"i32")-s!==e.length&&b(_,"incomplete input"),n.length=r.getValue(c,"i32"),a=n.to_Uint8Array(),g(_),a},e.from_hex=function(e){var t,a=[],_=new u((e=k(a,e,"input")).length/2),n=v(e),s=d(4);return a.push(n),a.push(_.address),a.push(_.hex_end_p),0!==r._sodium_hex2bin(_.address,_.length,n,e.length,0,0,s)&&b(a,"invalid input"),r.getValue(s,"i32")-n!==e.length&&b(a,"incomplete input"),t=_.to_Uint8Array(),g(a),t},e.from_string=n,e.increment=function(e){if(!(e instanceof Uint8Array))throw new TypeError("Only Uint8Array instances can be incremented");for(var t=256,r=0,a=e.length;r<a;r++)t>>=8,t+=e[r],e[r]=255&t},e.is_zero=function(e){if(!(e instanceof Uint8Array))throw new TypeError("Only Uint8Array instances can be checked");for(var t=0,r=0,a=e.length;r<a;r++)t|=e[r];return 0===t},e.libsodium=t,e.memcmp=function(e,t){if(!(e instanceof Uint8Array&&t instanceof Uint8Array))throw new TypeError("Only Uint8Array instances can be compared");if(e.length!==t.length)throw new TypeError("Only instances of identical length can be compared");for(var r=0,a=0,_=e.length;a<_;a++)r|=e[a]^t[a];return 0===r},e.memzero=function(e){if(!(e instanceof Uint8Array))throw new TypeError("Only Uint8Array instances can be wiped");for(var t=0,r=e.length;t<r;t++)e[t]=0},e.output_formats=function(){return["uint8array","text","hex","base64"]},e.pad=function(e,t){if(!(e instanceof Uint8Array))throw new TypeError("buffer must be a Uint8Array");if((t|=0)<=0)throw new Error("block size must be > 0");var a,_=[],n=d(4),s=1,c=0,h=0|e.length,o=new u(h+t);_.push(n),_.push(o.address);for(var p=o.address,y=o.address+h+t;p<y;p++)r.HEAPU8[p]=e[c],c+=s=1&~((65535&((h-=s)>>>48|h>>>32|h>>>16|h))-1>>16);return 0!==r._sodium_pad(n,o.address,e.length,t,o.length)&&b(_,"internal error"),o.length=r.getValue(n,"i32"),a=o.to_Uint8Array(),g(_),a},e.unpad=function(e,t){if(!(e instanceof Uint8Array))throw new TypeError("buffer must be a Uint8Array");if((t|=0)<=0)throw new Error("block size must be > 0");var a=[],_=v(e),n=d(4);return a.push(_),a.push(n),0!==r._sodium_unpad(n,_,e.length,t)&&b(a,"unsupported/invalid padding"),e=(e=new Uint8Array(e)).subarray(0,r.getValue(n,"i32")),g(a),e},e.ready=_,e.symbols=function(){return Object.keys(e).sort()},e.to_base64=p,e.to_hex=c,e.to_string=s,e}var r="object"==typeof e.sodium&&"function"==typeof e.sodium.onload?e.sodium.onload:null; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports,__webpack_require__(288)], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports&&"string"!=typeof exports.nodeName?t(exports,require("libsodium-sumo")):e.sodium=t(e.commonJsStrict={},e.libsodium),r&&e.sodium.ready.then(function(){r(e.sodium)})}(this);


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process, __dirname, Buffer) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(A){function I(A){"use strict";var I;void 0===(I=A)&&(I={});var g=I;"object"!=typeof g.sodium&&("object"==typeof global?g=global:"object"==typeof window&&(g=window)),"object"==typeof g.sodium&&"number"==typeof g.sodium.totalMemory&&(I.TOTAL_MEMORY=g.sodium.totalMemory);var B=I;return I.ready=new Promise(function(A,I){(C=B).onAbort=I,C.print=function(A){},C.printErr=function(A){},C.onRuntimeInitialized=function(){try{C._crypto_secretbox_keybytes(),A()}catch(A){I(A)}},C.useBackupModule=function(){var A,I=void 0!==(I={})?I:{},g={};for(A in I)I.hasOwnProperty(A)&&(g[A]=I[A]);var C,a,t,r,Q=[],e=!1;C="object"==typeof window,a="function"==typeof importScripts,t="object"==typeof process&&"object"==typeof process.versions&&"string"==typeof process.versions.node,e=t&&!C&&!a,r=!C&&!e&&!a;var o,c,i,_,E,n="";e?(n=__dirname+"/",o=function(A,I){var g;return(g=rA(A))||(_||(_=__webpack_require__(110)),E||(E=__webpack_require__(111)),A=E.normalize(A),g=_.readFileSync(A)),I?g:g.toString()},i=function(A){var I=o(A,!0);return I.buffer||(I=new Uint8Array(I)),f(I.buffer),I},process.argv.length>1&&process.argv[1].replace(/\\/g,"/"),Q=process.argv.slice(2),"undefined"!=typeof module&&(module.exports=I),process.on("unhandledRejection",X),I.inspect=function(){return"[Emscripten Module object]"}):r?("undefined"!=typeof read&&(o=function(A){var I=rA(A);return I?aA(I):read(A)}),i=function(A){var I;return(I=rA(A))?I:"function"==typeof readbuffer?new Uint8Array(readbuffer(A)):(f("object"==typeof(I=read(A,"binary"))),I)},"undefined"!=typeof scriptArgs?Q=scriptArgs:void 0!==arguments&&(Q=arguments),"undefined"!=typeof print&&("undefined"==typeof console&&(console={}),console.log=print,console.warn=console.error="undefined"!=typeof printErr?printErr:print)):(C||a)&&(a?n=self.location.href:document.currentScript&&(n=document.currentScript.src),n=0!==n.indexOf("blob:")?n.substr(0,n.lastIndexOf("/")+1):"",o=function(A){try{var I=new XMLHttpRequest;return I.open("GET",A,!1),I.send(null),I.responseText}catch(I){var g=rA(A);if(g)return aA(g);throw I}},a&&(i=function(A){try{var I=new XMLHttpRequest;return I.open("GET",A,!1),I.responseType="arraybuffer",I.send(null),new Uint8Array(I.response)}catch(I){var g=rA(A);if(g)return g;throw I}}),c=function(A,I,g){var B=new XMLHttpRequest;B.open("GET",A,!0),B.responseType="arraybuffer",B.onload=function(){if(200==B.status||0==B.status&&B.response)I(B.response);else{var C=rA(A);C?I(C.buffer):g()}},B.onerror=g,B.send(null)});var s=I.print||void 0,y=I.printErr||void 0;for(A in g)g.hasOwnProperty(A)&&(I[A]=g[A]);g=null,I.arguments&&(Q=I.arguments),I.thisProgram&&I.thisProgram,I.quit&&I.quit,new Array(8);var h=0;I.wasmBinary&&I.wasmBinary,I.noExitRuntime&&I.noExitRuntime;var p=!1;function f(A,I){A||X("Assertion failed: "+I)}var w,l,u,D,m,F,k,b="undefined"!=typeof TextDecoder?new TextDecoder("utf8"):void 0;function d(A,I){return A?function(A,I,g){for(var B=I+g,C=I;A[C]&&!(C>=B);)++C;if(C-I>16&&A.subarray&&b)return b.decode(A.subarray(I,C));for(var a="";I<C;){var t=A[I++];if(128&t){var r=63&A[I++];if(192!=(224&t)){var Q=63&A[I++];if((t=224==(240&t)?(15&t)<<12|r<<6|Q:(7&t)<<18|r<<12|Q<<6|63&A[I++])<65536)a+=String.fromCharCode(t);else{var e=t-65536;a+=String.fromCharCode(55296|e>>10,56320|1023&e)}}else a+=String.fromCharCode((31&t)<<6|r)}else a+=String.fromCharCode(t)}return a}(u,A,I):""}function H(A,I){return A%I>0&&(A+=I-A%I),A}function G(A){w=A,I.HEAP8=l=new Int8Array(A),I.HEAP16=D=new Int16Array(A),I.HEAP32=m=new Int32Array(A),I.HEAPU8=u=new Uint8Array(A),I.HEAPU16=new Uint16Array(A),I.HEAPU32=new Uint32Array(A),I.HEAPF32=F=new Float32Array(A),I.HEAPF64=k=new Float64Array(A)}"undefined"!=typeof TextDecoder&&new TextDecoder("utf-16le");var S=I.TOTAL_MEMORY||16777216;function x(A){for(;A.length>0;){var g=A.shift();if("function"!=typeof g){var B=g.func;"number"==typeof B?void 0===g.arg?I.dynCall_v(B):I.dynCall_vi(B,g.arg):B(void 0===g.arg?null:g.arg)}else g()}}S=(w=I.buffer?I.buffer:new ArrayBuffer(S)).byteLength,G(w),m[9016]=5279136;var U=[],M=[],J=[],v=[],N=Math.abs,R=Math.ceil,Y=Math.floor,L=Math.min,P=0,K=null,q=null;function X(A){throw I.onAbort&&I.onAbort(A),s(A+=""),y(A),p=!0,"abort("+A+"). Build with -s ASSERTIONS=1 for more info."}I.preloadedImages={},I.preloadedAudios={};var j,T,V=null,W="data:application/octet-stream;base64,";function z(A){return String.prototype.startsWith?A.startsWith(W):0===A.indexOf(W)}var Z=[function(){return I.getRandomValue()},function(){if(void 0===I.getRandomValue)try{var A="object"==typeof window?window:self,g=void 0!==A.crypto?A.crypto:A.msCrypto,B=function(){var A=new Uint32Array(1);return g.getRandomValues(A),A[0]>>>0};B(),I.getRandomValue=B}catch(A){try{var C=__webpack_require__(112),a=function(){var A=C.randomBytes(4);return(A[0]<<24|A[1]<<16|A[2]<<8|A[3])>>>0};a(),I.getRandomValue=a}catch(A){throw"No secure random number generator found"}}}];function O(A){return A}function $(A){return A.replace(/\b__Z[\w\d_]+/g,function(A){var I=O(A);return A===I?A:I+" ["+A+"]"})}function AA(){var A=new Error;if(!A.stack){try{throw new Error(0)}catch(I){A=I}if(!A.stack)return"(no stack trace available)"}return A.stack.toString()}function IA(){return l.length}function gA(A){try{var I=new ArrayBuffer(A);if(I.byteLength!=A)return;return new Int8Array(I).set(l),cA(I),G(I),1}catch(A){}}function BA(A){return I.___errno_location&&(m[I.___errno_location()>>2]=A),A}V="data:application/octet-stream;base64,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";var CA=!1;function aA(A){for(var I=[],g=0;g<A.length;g++){var B=A[g];B>255&&(CA&&f(!1,"Character code "+B+" ("+String.fromCharCode(B)+")  at offset "+g+" not in 0x00-0xFF."),B&=255),I.push(String.fromCharCode(B))}return I.join("")}var tA="function"==typeof atob?atob:function(A){var I,g,B,C,a,t,r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",Q="",e=0;A=A.replace(/[^A-Za-z0-9\+\/\=]/g,"");do{I=r.indexOf(A.charAt(e++))<<2|(C=r.indexOf(A.charAt(e++)))>>4,g=(15&C)<<4|(a=r.indexOf(A.charAt(e++)))>>2,B=(3&a)<<6|(t=r.indexOf(A.charAt(e++))),Q+=String.fromCharCode(I),64!==a&&(Q+=String.fromCharCode(g)),64!==t&&(Q+=String.fromCharCode(B))}while(e<A.length);return Q};function rA(A){if(z(A))return function(A){if("boolean"==typeof e&&e){var I;try{I=Buffer.from(A,"base64")}catch(g){I=new Buffer(A,"base64")}return new Uint8Array(I.buffer,I.byteOffset,I.byteLength)}try{for(var g=tA(A),B=new Uint8Array(g.length),C=0;C<g.length;++C)B[C]=g.charCodeAt(C);return B}catch(A){throw new Error("Converting base64 string to bytes failed.")}}(A.slice(W.length))}var QA,eA,oA=function(A,I,g){"almost asm";var B=new A.Int8Array(g),C=new A.Int16Array(g),a=new A.Int32Array(g),t=new A.Uint8Array(g),r=(new A.Uint16Array(g),A.Math.imul),Q=A.Math.clz32,e=I.b,o=I.c,c=I.d,i=I.f,_=I.g,E=I.h,n=I.i,s=I.j,y=I.k,h=36256;function p(A,I){A|=0,I|=0;var g,C,r,Q,e,c,i=0,_=0,E=0,n=0,s=0,y=0,p=0,f=0,w=0,l=0,u=0,D=0,m=0,F=0,k=0,b=0,d=0,H=0,G=0,S=0,x=0,U=0,M=0,J=0,v=0,N=0,R=0,Y=0,L=0,P=0,K=0,q=0,X=0,j=0,T=0,V=0,W=0,z=0,Z=0,O=0,$=0,AA=0,IA=0,gA=0,BA=0,CA=0,aA=0,tA=0,rA=0,QA=0,eA=0,oA=0,cA=0,iA=0,_A=0,EA=0,nA=0,sA=0,yA=0,hA=0;g=h,C=h=h+63&-64,h=h+256|0,i=0;do{n=0|wB(I+(i<<3)|0),E=0|o(),a[(_=C+128+(i<<3)|0)>>2]=n,a[_+4>>2]=E,i=i+1|0}while(16!=(0|i));i=A,_=(I=C)+64|0;do{B[I>>0]=0|B[i>>0],I=I+1|0,i=i+1|0}while((0|I)<(0|_));for(a[C+88>>2]=1595750129,a[C+88+4>>2]=-1521486534,q=-1377402159^(t[A+64>>0]|t[A+64+1>>0]<<8|t[A+64+2>>0]<<16|t[A+64+3>>0]<<24),K=1359893119^(t[A+64+4>>0]|t[A+64+4+1>>0]<<8|t[A+64+4+2>>0]<<16|t[A+64+4+3>>0]<<24),S=725511199^(t[A+72>>0]|t[A+72+1>>0]<<8|t[A+72+2>>0]<<16|t[A+72+3>>0]<<24),x=-1694144372^(t[A+72+4>>0]|t[A+72+4+1>>0]<<8|t[A+72+4+2>>0]<<16|t[A+72+4+3>>0]<<24),u=-79577749^(t[A+80>>0]|t[A+80+1>>0]<<8|t[A+80+2>>0]<<16|t[A+80+3>>0]<<24),D=528734635^(t[A+80+4>>0]|t[A+80+4+1>>0]<<8|t[A+80+4+2>>0]<<16|t[A+80+4+3>>0]<<24),AA=327033209^(t[A+88>>0]|t[A+88+1>>0]<<8|t[A+88+2>>0]<<16|t[A+88+3>>0]<<24),$=1541459225^(t[A+88+4>>0]|t[A+88+4+1>>0]<<8|t[A+88+4+2>>0]<<16|t[A+88+4+3>>0]<<24),p=0|a[C+32>>2],f=0|a[C+32+4>>2],f=0|bB((I=0|bC(0|(K=0|bB((sA=0|bC(0|(yA=0|bC(0|(X=0|a[C+128>>2]),0|(j=0|a[C+128+4>>2]),0|p,0|f)),0|(sA=0|o()),0|a[C>>2],0|a[C+4>>2]))^q,(yA=0|o())^K,32)),0|(q=0|o()),-205731576,1779033703))^p,(n=0|o())^f,24),p=0|o(),IA=0|a[C+128+8>>2],gA=0|a[C+128+8+4>>2],q=0|bB((yA=0|bC(0|(yA=0|bC(0|f,0|p,0|sA,0|yA)),0|o(),0|IA,0|gA))^K,(sA=0|o())^q,16),K=0|o(),a[C+96>>2]=q,a[C+96+4>>2]=K,n=0|bC(0|q,0|K,0|I,0|n),I=0|o(),a[C+64>>2]=n,a[C+64+4>>2]=I,p=0|bB(n^f,I^p,63),f=0|o(),a[C+32>>2]=p,a[C+32+4>>2]=f,z=0|a[C+40>>2],Z=0|a[C+40+4>>2],Z=0|bB((y=0|bC(0|(x=0|bB((iA=0|bC(0|(cA=0|bC(0|(_=0|a[C+128+16>>2]),0|(i=0|a[C+128+16+4>>2]),0|z,0|Z)),0|(iA=0|o()),0|a[C+8>>2],0|a[C+8+4>>2]))^S,(cA=0|o())^x,32)),0|(S=0|o()),-2067093701,-1150833019))^z,(w=0|o())^Z,24),z=0|o(),l=0|a[C+128+24>>2],m=0|a[C+128+24+4>>2],S=0|bB((cA=0|bC(0|(cA=0|bC(0|Z,0|z,0|iA,0|cA)),0|o(),0|l,0|m))^x,(iA=0|o())^S,16),x=0|o(),a[C+104>>2]=S,a[C+104+4>>2]=x,w=0|bC(0|S,0|x,0|y,0|w),y=0|o(),a[C+72>>2]=w,a[C+72+4>>2]=y,z=0|bB(w^Z,y^z,63),Z=0|o(),Y=0|a[C+48>>2],L=0|a[C+48+4>>2],L=0|bB((W=0|bC(0|(D=0|bB((eA=0|bC(0|(QA=0|bC(0|(c=0|a[C+128+32>>2]),0|(_A=0|a[C+128+32+4>>2]),0|Y,0|L)),0|(eA=0|o()),0|a[C+16>>2],0|a[C+16+4>>2]))^u,(QA=0|o())^D,32)),0|(u=0|o()),-23791573,1013904242))^Y,(O=0|o())^L,24),Y=0|o(),r=0|a[C+128+40>>2],b=0|a[C+128+40+4>>2],Y=0|bB((O=0|bC(0|(u=0|bB((QA=0|bC(0|(QA=0|bC(0|L,0|Y,0|eA,0|QA)),0|o(),0|r,0|b))^D,(eA=0|o())^u,16)),0|(D=0|o()),0|W,0|O))^L,(W=0|o())^Y,63),L=0|o(),H=0|a[C+56>>2],d=0|a[C+56+4>>2],d=0|bB((R=0|bC(0|($=0|bB((tA=0|bC(0|(aA=0|bC(0|(k=0|a[C+128+48>>2]),0|(F=0|a[C+128+48+4>>2]),0|H,0|d)),0|(tA=0|o()),0|a[C+24>>2],0|a[C+24+4>>2]))^AA,(aA=0|o())^$,32)),0|(AA=0|o()),1595750129,-1521486534))^H,(P=0|o())^d,24),H=0|o(),G=0|a[C+128+56>>2],U=0|a[C+128+56+4>>2],H=0|bB((P=0|bC(0|(AA=0|bB((aA=0|bC(0|(aA=0|bC(0|d,0|H,0|tA,0|aA)),0|o(),0|G,0|U))^$,(tA=0|o())^AA,16)),0|($=0|o()),0|R,0|P))^d,(R=0|o())^H,63),d=0|o(),T=0|a[C+128+64>>2],V=0|a[C+128+64+4>>2],Z=0|bB((W=0|bC(0|($=0|bB((sA=0|bC(0|(sA=0|bC(0|z,0|Z,0|yA,0|sA)),0|o(),0|T,0|V))^AA,(yA=0|o())^$,32)),0|(AA=0|o()),0|O,0|W))^z,(O=0|o())^Z,24),z=0|o(),e=0|a[C+128+72>>2],oA=0|a[C+128+72+4>>2],AA=0|bB((yA=0|bC(0|(yA=0|bC(0|Z,0|z,0|sA,0|yA)),0|o(),0|e,0|oA))^$,(sA=0|o())^AA,16),$=0|o(),a[C+120>>2]=AA,a[C+120+4>>2]=$,O=0|bC(0|AA,0|$,0|W,0|O),W=0|o(),a[C+80>>2]=O,a[C+80+4>>2]=W,z=0|bB(O^Z,W^z,63),Z=0|o(),BA=0|a[C+128+80>>2],CA=0|a[C+128+80+4>>2],L=0|bB((R=0|bC(0|(K=0|bB((iA=0|bC(0|(iA=0|bC(0|Y,0|L,0|cA,0|iA)),0|o(),0|BA,0|CA))^q,(cA=0|o())^K,32)),0|(q=0|o()),0|P,0|R))^Y,(P=0|o())^L,24),Y=0|o(),M=0|a[C+128+88>>2],J=0|a[C+128+88+4>>2],Y=0|bB((P=0|bC(0|(q=0|bB((cA=0|bC(0|(cA=0|bC(0|L,0|Y,0|iA,0|cA)),0|o(),0|M,0|J))^K,(iA=0|o())^q,16)),0|(K=0|o()),0|R,0|P))^L,(R=0|o())^Y,63),L=0|o(),E=0|a[C+128+96>>2],s=0|a[C+128+96+4>>2],d=0|bB((I=0|bC(0|(x=0|bB((eA=0|bC(0|(eA=0|bC(0|H,0|d,0|QA,0|eA)),0|o(),0|E,0|s))^S,(QA=0|o())^x,32)),0|(S=0|o()),0|n,0|I))^H,(n=0|o())^d,24),H=0|o(),Q=0|a[C+128+104>>2],rA=0|a[C+128+104+4>>2],H=0|bB((n=0|bC(0|(S=0|bB((QA=0|bC(0|(QA=0|bC(0|d,0|H,0|eA,0|QA)),0|o(),0|Q,0|rA))^x,(eA=0|o())^S,16)),0|(x=0|o()),0|I,0|n))^d,(I=0|o())^H,63),d=0|o(),EA=0|a[C+128+112>>2],nA=0|a[C+128+112+4>>2],f=0|bB((y=0|bC(0|(D=0|bB((tA=0|bC(0|(tA=0|bC(0|aA,0|tA,0|p,0|f)),0|o(),0|EA,0|nA))^u,(aA=0|o())^D,32)),0|(u=0|o()),0|w,0|y))^p,(w=0|o())^f,24),p=0|o(),v=0|a[C+128+120>>2],N=0|a[C+128+120+4>>2],p=0|bB((w=0|bC(0|(u=0|bB((aA=0|bC(0|(aA=0|bC(0|f,0|p,0|tA,0|aA)),0|o(),0|v,0|N))^D,(tA=0|o())^u,16)),0|(D=0|o()),0|y,0|w))^f,(y=0|o())^p,63),f=0|o(),f=0|bB((I=0|bC(0|(K=0|bB((sA=0|bC(0|(sA=0|bC(0|EA,0|nA,0|yA,0|sA)),0|o(),0|p,0|f))^q,(yA=0|o())^K,32)),0|(q=0|o()),0|n,0|I))^p,(n=0|o())^f,24),p=0|o(),p=0|bB((n=0|bC(0|(q=0|bB((yA=0|bC(0|(yA=0|bC(0|sA,0|yA,0|BA,0|CA)),0|o(),0|f,0|p))^K,(sA=0|o())^q,16)),0|(K=0|o()),0|I,0|n))^f,(I=0|o())^p,63),f=0|o(),a[C+32>>2]=p,a[C+32+4>>2]=f,Z=0|bB((y=0|bC(0|(x=0|bB(S^(iA=0|bC(0|(hA=0|bC(0|z,0|Z,0|c,0|_A)),0|o(),0|cA,0|iA)),x^(cA=0|o()),32)),0|(S=0|o()),0|w,0|y))^z,(w=0|o())^Z,24),z=0|o(),z=0|bB((w=0|bC(0|(S=0|bB((cA=0|bC(0|(cA=0|bC(0|iA,0|cA,0|T,0|V)),0|o(),0|Z,0|z))^x,(iA=0|o())^S,16)),0|(x=0|o()),0|y,0|w))^Z,(y=0|o())^z,63),Z=0|o(),L=0|bB((W=0|bC(0|(D=0|bB(u^(eA=0|bC(0|(hA=0|bC(0|Y,0|L,0|e,0|oA)),0|o(),0|QA,0|eA)),D^(QA=0|o()),32)),0|(u=0|o()),0|O,0|W))^Y,(O=0|o())^L,24),Y=0|o(),Y=0|bB((O=0|bC(0|(u=0|bB((QA=0|bC(0|(QA=0|bC(0|v,0|N,0|eA,0|QA)),0|o(),0|L,0|Y))^D,(eA=0|o())^u,16)),0|(D=0|o()),0|W,0|O))^L,(W=0|o())^Y,63),L=0|o(),d=0|bB((R=0|bC(0|($=0|bB((tA=0|bC(0|(hA=0|bC(0|H,0|d,0|Q,0|rA)),0|o(),0|aA,0|tA))^AA,(aA=0|o())^$,32)),0|(AA=0|o()),0|P,0|R))^H,(P=0|o())^d,24),H=0|o(),H=0|bB((P=0|bC(0|(AA=0|bB((aA=0|bC(0|(aA=0|bC(0|tA,0|aA,0|k,0|F)),0|o(),0|d,0|H))^$,(tA=0|o())^AA,16)),0|($=0|o()),0|R,0|P))^d,(R=0|o())^H,63),d=0|o(),Z=0|bB((W=0|bC(0|($=0|bB(AA^(sA=0|bC(0|(sA=0|bC(0|yA,0|sA,0|IA,0|gA)),0|o(),0|z,0|Z)),$^(yA=0|o()),32)),0|(AA=0|o()),0|O,0|W))^z,(O=0|o())^Z,24),z=0|o(),AA=0|bB((yA=0|bC(0|(yA=0|bC(0|sA,0|yA,0|E,0|s)),0|o(),0|Z,0|z))^$,(sA=0|o())^AA,16),$=0|o(),a[C+120>>2]=AA,a[C+120+4>>2]=$,z=0|bB((O=0|bC(0|AA,0|$,0|W,0|O))^Z,(W=0|o())^z,63),Z=0|o(),L=0|bB((R=0|bC(0|(K=0|bB((iA=0|bC(0|(iA=0|bC(0|cA,0|iA,0|X,0|j)),0|o(),0|Y,0|L))^q,(cA=0|o())^K,32)),0|(q=0|o()),0|P,0|R))^Y,(P=0|o())^L,24),Y=0|o(),Y=0|bB((P=0|bC(0|(q=0|bB((cA=0|bC(0|(cA=0|bC(0|iA,0|cA,0|_,0|i)),0|o(),0|L,0|Y))^K,(iA=0|o())^q,16)),0|(K=0|o()),0|R,0|P))^L,(R=0|o())^Y,63),L=0|o(),d=0|bB((I=0|bC(0|(x=0|bB((eA=0|bC(0|(eA=0|bC(0|QA,0|eA,0|M,0|J)),0|o(),0|H,0|d))^S,(QA=0|o())^x,32)),0|(S=0|o()),0|n,0|I))^H,(n=0|o())^d,24),H=0|o(),H=0|bB((n=0|bC(0|(S=0|bB((QA=0|bC(0|(QA=0|bC(0|eA,0|QA,0|G,0|U)),0|o(),0|d,0|H))^x,(eA=0|o())^S,16)),0|(x=0|o()),0|I,0|n))^d,(I=0|o())^H,63),d=0|o(),f=0|bB((y=0|bC(0|(D=0|bB((tA=0|bC(0|(hA=0|bC(0|p,0|f,0|r,0|b)),0|o(),0|aA,0|tA))^u,(aA=0|o())^D,32)),0|(u=0|o()),0|w,0|y))^p,(w=0|o())^f,24),p=0|o(),p=0|bB((w=0|bC(0|(u=0|bB((aA=0|bC(0|(aA=0|bC(0|tA,0|aA,0|l,0|m)),0|o(),0|f,0|p))^D,(tA=0|o())^u,16)),0|(D=0|o()),0|y,0|w))^f,(y=0|o())^p,63),f=0|o(),f=0|bB((I=0|bC(0|(K=0|bB((sA=0|bC(0|(sA=0|bC(0|yA,0|sA,0|M,0|J)),0|o(),0|p,0|f))^q,(yA=0|o())^K,32)),0|(q=0|o()),0|n,0|I))^p,(n=0|o())^f,24),p=0|o(),p=0|bB((n=0|bC(0|(q=0|bB((yA=0|bC(0|(yA=0|bC(0|sA,0|yA,0|T,0|V)),0|o(),0|f,0|p))^K,(sA=0|o())^q,16)),0|(K=0|o()),0|I,0|n))^f,(I=0|o())^p,63),f=0|o(),a[C+32>>2]=p,a[C+32+4>>2]=f,Z=0|bB((y=0|bC(0|(x=0|bB(S^(iA=0|bC(0|(hA=0|bC(0|z,0|Z,0|E,0|s)),0|o(),0|cA,0|iA)),x^(cA=0|o()),32)),0|(S=0|o()),0|w,0|y))^z,(w=0|o())^Z,24),z=0|o(),z=0|bB((w=0|bC(0|(S=0|bB((cA=0|bC(0|(cA=0|bC(0|iA,0|cA,0|X,0|j)),0|o(),0|Z,0|z))^x,(iA=0|o())^S,16)),0|(x=0|o()),0|y,0|w))^Z,(y=0|o())^z,63),Z=0|o(),L=0|bB((W=0|bC(0|(D=0|bB(u^(eA=0|bC(0|(hA=0|bC(0|Y,0|L,0|r,0|b)),0|o(),0|QA,0|eA)),D^(QA=0|o()),32)),0|(u=0|o()),0|O,0|W))^Y,(O=0|o())^L,24),Y=0|o(),Y=0|bB((O=0|bC(0|(u=0|bB((QA=0|bC(0|(QA=0|bC(0|eA,0|QA,0|_,0|i)),0|o(),0|L,0|Y))^D,(eA=0|o())^u,16)),0|(D=0|o()),0|W,0|O))^L,(W=0|o())^Y,63),L=0|o(),d=0|bB((R=0|bC(0|($=0|bB((tA=0|bC(0|(hA=0|bC(0|H,0|d,0|v,0|N)),0|o(),0|aA,0|tA))^AA,(aA=0|o())^$,32)),0|(AA=0|o()),0|P,0|R))^H,(P=0|o())^d,24),H=0|o(),H=0|bB((P=0|bC(0|(AA=0|bB((aA=0|bC(0|(aA=0|bC(0|tA,0|aA,0|Q,0|rA)),0|o(),0|d,0|H))^$,(tA=0|o())^AA,16)),0|($=0|o()),0|R,0|P))^d,(R=0|o())^H,63),d=0|o(),Z=0|bB((W=0|bC(0|($=0|bB(AA^(sA=0|bC(0|(sA=0|bC(0|yA,0|sA,0|BA,0|CA)),0|o(),0|z,0|Z)),$^(yA=0|o()),32)),0|(AA=0|o()),0|O,0|W))^z,(O=0|o())^Z,24),z=0|o(),AA=0|bB((yA=0|bC(0|(yA=0|bC(0|sA,0|yA,0|EA,0|nA)),0|o(),0|Z,0|z))^$,(sA=0|o())^AA,16),$=0|o(),a[C+120>>2]=AA,a[C+120+4>>2]=$,z=0|bB((O=0|bC(0|AA,0|$,0|W,0|O))^Z,(W=0|o())^z,63),Z=0|o(),L=0|bB((R=0|bC(0|(K=0|bB((iA=0|bC(0|(iA=0|bC(0|cA,0|iA,0|l,0|m)),0|o(),0|Y,0|L))^q,(cA=0|o())^K,32)),0|(q=0|o()),0|P,0|R))^Y,(P=0|o())^L,24),Y=0|o(),Y=0|bB((P=0|bC(0|(q=0|bB((cA=0|bC(0|(cA=0|bC(0|iA,0|cA,0|k,0|F)),0|o(),0|L,0|Y))^K,(iA=0|o())^q,16)),0|(K=0|o()),0|R,0|P))^L,(R=0|o())^Y,63),L=0|o(),d=0|bB((I=0|bC(0|(x=0|bB((eA=0|bC(0|(eA=0|bC(0|QA,0|eA,0|G,0|U)),0|o(),0|H,0|d))^S,(QA=0|o())^x,32)),0|(S=0|o()),0|n,0|I))^H,(n=0|o())^d,24),H=0|o(),H=0|bB((n=0|bC(0|(S=0|bB((QA=0|bC(0|(QA=0|bC(0|eA,0|QA,0|IA,0|gA)),0|o(),0|d,0|H))^x,(eA=0|o())^S,16)),0|(x=0|o()),0|I,0|n))^d,(I=0|o())^H,63),d=0|o(),f=0|bB((y=0|bC(0|(D=0|bB((tA=0|bC(0|(hA=0|bC(0|p,0|f,0|e,0|oA)),0|o(),0|aA,0|tA))^u,(aA=0|o())^D,32)),0|(u=0|o()),0|w,0|y))^p,(w=0|o())^f,24),p=0|o(),p=0|bB((w=0|bC(0|(u=0|bB((aA=0|bC(0|(aA=0|bC(0|tA,0|aA,0|c,0|_A)),0|o(),0|f,0|p))^D,(tA=0|o())^u,16)),0|(D=0|o()),0|y,0|w))^f,(y=0|o())^p,63),f=0|o(),f=0|bB((I=0|bC(0|(K=0|bB((sA=0|bC(0|(sA=0|bC(0|yA,0|sA,0|G,0|U)),0|o(),0|p,0|f))^q,(yA=0|o())^K,32)),0|(q=0|o()),0|n,0|I))^p,(n=0|o())^f,24),p=0|o(),p=0|bB((n=0|bC(0|(q=0|bB((yA=0|bC(0|(yA=0|bC(0|sA,0|yA,0|e,0|oA)),0|o(),0|f,0|p))^K,(sA=0|o())^q,16)),0|(K=0|o()),0|I,0|n))^f,(I=0|o())^p,63),f=0|o(),a[C+32>>2]=p,a[C+32+4>>2]=f,Z=0|bB((y=0|bC(0|(x=0|bB(S^(iA=0|bC(0|(hA=0|bC(0|z,0|Z,0|l,0|m)),0|o(),0|cA,0|iA)),x^(cA=0|o()),32)),0|(S=0|o()),0|w,0|y))^z,(w=0|o())^Z,24),z=0|o(),z=0|bB((w=0|bC(0|(S=0|bB((cA=0|bC(0|(cA=0|bC(0|iA,0|cA,0|IA,0|gA)),0|o(),0|Z,0|z))^x,(iA=0|o())^S,16)),0|(x=0|o()),0|y,0|w))^Z,(y=0|o())^z,63),Z=0|o(),L=0|bB((W=0|bC(0|(D=0|bB(u^(eA=0|bC(0|(hA=0|bC(0|Y,0|L,0|Q,0|rA)),0|o(),0|QA,0|eA)),D^(QA=0|o()),32)),0|(u=0|o()),0|O,0|W))^Y,(O=0|o())^L,24),Y=0|o(),Y=0|bB((O=0|bC(0|(u=0|bB((QA=0|bC(0|(QA=0|bC(0|eA,0|QA,0|E,0|s)),0|o(),0|L,0|Y))^D,(eA=0|o())^u,16)),0|(D=0|o()),0|W,0|O))^L,(W=0|o())^Y,63),L=0|o(),d=0|bB((R=0|bC(0|($=0|bB((tA=0|bC(0|(hA=0|bC(0|H,0|d,0|M,0|J)),0|o(),0|aA,0|tA))^AA,(aA=0|o())^$,32)),0|(AA=0|o()),0|P,0|R))^H,(P=0|o())^d,24),H=0|o(),H=0|bB((P=0|bC(0|(AA=0|bB((aA=0|bC(0|(aA=0|bC(0|tA,0|aA,0|EA,0|nA)),0|o(),0|d,0|H))^$,(tA=0|o())^AA,16)),0|($=0|o()),0|R,0|P))^d,(R=0|o())^H,63),d=0|o(),Z=0|bB((W=0|bC(0|($=0|bB(AA^(sA=0|bC(0|(sA=0|bC(0|yA,0|sA,0|_,0|i)),0|o(),0|z,0|Z)),$^(yA=0|o()),32)),0|(AA=0|o()),0|O,0|W))^z,(O=0|o())^Z,24),z=0|o(),AA=0|bB((yA=0|bC(0|(yA=0|bC(0|sA,0|yA,0|k,0|F)),0|o(),0|Z,0|z))^$,(sA=0|o())^AA,16),$=0|o(),a[C+120>>2]=AA,a[C+120+4>>2]=$,z=0|bB((O=0|bC(0|AA,0|$,0|W,0|O))^Z,(W=0|o())^z,63),Z=0|o(),L=0|bB((R=0|bC(0|(K=0|bB((iA=0|bC(0|(iA=0|bC(0|cA,0|iA,0|r,0|b)),0|o(),0|Y,0|L))^q,(cA=0|o())^K,32)),0|(q=0|o()),0|P,0|R))^Y,(P=0|o())^L,24),Y=0|o(),Y=0|bB((P=0|bC(0|(q=0|bB((cA=0|bC(0|(cA=0|bC(0|iA,0|cA,0|BA,0|CA)),0|o(),0|L,0|Y))^K,(iA=0|o())^q,16)),0|(K=0|o()),0|R,0|P))^L,(R=0|o())^Y,63),L=0|o(),d=0|bB((I=0|bC(0|(x=0|bB((eA=0|bC(0|(eA=0|bC(0|QA,0|eA,0|c,0|_A)),0|o(),0|H,0|d))^S,(QA=0|o())^x,32)),0|(S=0|o()),0|n,0|I))^H,(n=0|o())^d,24),H=0|o(),H=0|bB((n=0|bC(0|(S=0|bB((QA=0|bC(0|(QA=0|bC(0|eA,0|QA,0|X,0|j)),0|o(),0|d,0|H))^x,(eA=0|o())^S,16)),0|(x=0|o()),0|I,0|n))^d,(I=0|o())^H,63),d=0|o(),f=0|bB((y=0|bC(0|(D=0|bB((tA=0|bC(0|(hA=0|bC(0|p,0|f,0|v,0|N)),0|o(),0|aA,0|tA))^u,(aA=0|o())^D,32)),0|(u=0|o()),0|w,0|y))^p,(w=0|o())^f,24),p=0|o(),p=0|bB((w=0|bC(0|(u=0|bB((aA=0|bC(0|(aA=0|bC(0|tA,0|aA,0|T,0|V)),0|o(),0|f,0|p))^D,(tA=0|o())^u,16)),0|(D=0|o()),0|y,0|w))^f,(y=0|o())^p,63),f=0|o(),f=0|bB((I=0|bC(0|(K=0|bB((sA=0|bC(0|(sA=0|bC(0|yA,0|sA,0|e,0|oA)),0|o(),0|p,0|f))^q,(yA=0|o())^K,32)),0|(q=0|o()),0|n,0|I))^p,(n=0|o())^f,24),p=0|o(),p=0|bB((n=0|bC(0|(q=0|bB((yA=0|bC(0|(yA=0|bC(0|sA,0|yA,0|X,0|j)),0|o(),0|f,0|p))^K,(sA=0|o())^q,16)),0|(K=0|o()),0|I,0|n))^f,(I=0|o())^p,63),f=0|o(),a[C+32>>2]=p,a[C+32+4>>2]=f,Z=0|bB((y=0|bC(0|(x=0|bB(S^(iA=0|bC(0|(hA=0|bC(0|z,0|Z,0|r,0|b)),0|o(),0|cA,0|iA)),x^(cA=0|o()),32)),0|(S=0|o()),0|w,0|y))^z,(w=0|o())^Z,24),z=0|o(),z=0|bB((w=0|bC(0|(S=0|bB((cA=0|bC(0|(cA=0|bC(0|iA,0|cA,0|G,0|U)),0|o(),0|Z,0|z))^x,(iA=0|o())^S,16)),0|(x=0|o()),0|y,0|w))^Z,(y=0|o())^z,63),Z=0|o(),L=0|bB((W=0|bC(0|(D=0|bB(u^(eA=0|bC(0|(hA=0|bC(0|Y,0|L,0|_,0|i)),0|o(),0|QA,0|eA)),D^(QA=0|o()),32)),0|(u=0|o()),0|O,0|W))^Y,(O=0|o())^L,24),Y=0|o(),Y=0|bB((O=0|bC(0|(u=0|bB((QA=0|bC(0|(QA=0|bC(0|eA,0|QA,0|c,0|_A)),0|o(),0|L,0|Y))^D,(eA=0|o())^u,16)),0|(D=0|o()),0|W,0|O))^L,(W=0|o())^Y,63),L=0|o(),d=0|bB((R=0|bC(0|($=0|bB((tA=0|bC(0|(hA=0|bC(0|H,0|d,0|BA,0|CA)),0|o(),0|aA,0|tA))^AA,(aA=0|o())^$,32)),0|(AA=0|o()),0|P,0|R))^H,(P=0|o())^d,24),H=0|o(),H=0|bB((P=0|bC(0|(AA=0|bB((aA=0|bC(0|(aA=0|bC(0|tA,0|aA,0|v,0|N)),0|o(),0|d,0|H))^$,(tA=0|o())^AA,16)),0|($=0|o()),0|R,0|P))^d,(R=0|o())^H,63),d=0|o(),Z=0|bB((W=0|bC(0|($=0|bB(AA^(sA=0|bC(0|(sA=0|bC(0|yA,0|sA,0|EA,0|nA)),0|o(),0|z,0|Z)),$^(yA=0|o()),32)),0|(AA=0|o()),0|O,0|W))^z,(O=0|o())^Z,24),z=0|o(),AA=0|bB((yA=0|bC(0|(yA=0|bC(0|sA,0|yA,0|IA,0|gA)),0|o(),0|Z,0|z))^$,(sA=0|o())^AA,16),$=0|o(),a[C+120>>2]=AA,a[C+120+4>>2]=$,z=0|bB((O=0|bC(0|AA,0|$,0|W,0|O))^Z,(W=0|o())^z,63),Z=0|o(),L=0|bB((R=0|bC(0|(K=0|bB((iA=0|bC(0|(iA=0|bC(0|cA,0|iA,0|M,0|J)),0|o(),0|Y,0|L))^q,(cA=0|o())^K,32)),0|(q=0|o()),0|P,0|R))^Y,(P=0|o())^L,24),Y=0|o(),Y=0|bB((P=0|bC(0|(q=0|bB((cA=0|bC(0|(cA=0|bC(0|iA,0|cA,0|E,0|s)),0|o(),0|L,0|Y))^K,(iA=0|o())^q,16)),0|(K=0|o()),0|R,0|P))^L,(R=0|o())^Y,63),L=0|o(),d=0|bB((I=0|bC(0|(x=0|bB((eA=0|bC(0|(eA=0|bC(0|QA,0|eA,0|k,0|F)),0|o(),0|H,0|d))^S,(QA=0|o())^x,32)),0|(S=0|o()),0|n,0|I))^H,(n=0|o())^d,24),H=0|o(),H=0|bB((n=0|bC(0|(S=0|bB((QA=0|bC(0|(QA=0|bC(0|eA,0|QA,0|T,0|V)),0|o(),0|d,0|H))^x,(eA=0|o())^S,16)),0|(x=0|o()),0|I,0|n))^d,(I=0|o())^H,63),d=0|o(),f=0|bB((y=0|bC(0|(D=0|bB((tA=0|bC(0|(hA=0|bC(0|p,0|f,0|l,0|m)),0|o(),0|aA,0|tA))^u,(aA=0|o())^D,32)),0|(u=0|o()),0|w,0|y))^p,(w=0|o())^f,24),p=0|o(),p=0|bB((w=0|bC(0|(u=0|bB((aA=0|bC(0|(aA=0|bC(0|tA,0|aA,0|Q,0|rA)),0|o(),0|f,0|p))^D,(tA=0|o())^u,16)),0|(D=0|o()),0|y,0|w))^f,(y=0|o())^p,63),f=0|o(),f=0|bB((I=0|bC(0|(K=0|bB((sA=0|bC(0|(sA=0|bC(0|yA,0|sA,0|_,0|i)),0|o(),0|p,0|f))^q,(yA=0|o())^K,32)),0|(q=0|o()),0|n,0|I))^p,(n=0|o())^f,24),p=0|o(),p=0|bB((n=0|bC(0|(q=0|bB((yA=0|bC(0|(yA=0|bC(0|sA,0|yA,0|E,0|s)),0|o(),0|f,0|p))^K,(sA=0|o())^q,16)),0|(K=0|o()),0|I,0|n))^f,(I=0|o())^p,63),f=0|o(),a[C+32>>2]=p,a[C+32+4>>2]=f,Z=0|bB((y=0|bC(0|(x=0|bB(S^(iA=0|bC(0|(hA=0|bC(0|z,0|Z,0|k,0|F)),0|o(),0|cA,0|iA)),x^(cA=0|o()),32)),0|(S=0|o()),0|w,0|y))^z,(w=0|o())^Z,24),z=0|o(),z=0|bB((w=0|bC(0|(S=0|bB((cA=0|bC(0|(cA=0|bC(0|iA,0|cA,0|BA,0|CA)),0|o(),0|Z,0|z))^x,(iA=0|o())^S,16)),0|(x=0|o()),0|y,0|w))^Z,(y=0|o())^z,63),Z=0|o(),L=0|bB((W=0|bC(0|(D=0|bB(u^(eA=0|bC(0|(hA=0|bC(0|Y,0|L,0|X,0|j)),0|o(),0|QA,0|eA)),D^(QA=0|o()),32)),0|(u=0|o()),0|O,0|W))^Y,(O=0|o())^L,24),Y=0|o(),Y=0|bB((O=0|bC(0|(u=0|bB((QA=0|bC(0|(QA=0|bC(0|eA,0|QA,0|M,0|J)),0|o(),0|L,0|Y))^D,(eA=0|o())^u,16)),0|(D=0|o()),0|W,0|O))^L,(W=0|o())^Y,63),L=0|o(),d=0|bB((R=0|bC(0|($=0|bB((tA=0|bC(0|(hA=0|bC(0|H,0|d,0|T,0|V)),0|o(),0|aA,0|tA))^AA,(aA=0|o())^$,32)),0|(AA=0|o()),0|P,0|R))^H,(P=0|o())^d,24),H=0|o(),H=0|bB((P=0|bC(0|(AA=0|bB((aA=0|bC(0|(aA=0|bC(0|tA,0|aA,0|l,0|m)),0|o(),0|d,0|H))^$,(tA=0|o())^AA,16)),0|($=0|o()),0|R,0|P))^d,(R=0|o())^H,63),d=0|o(),Z=0|bB((W=0|bC(0|($=0|bB(AA^(sA=0|bC(0|(sA=0|bC(0|yA,0|sA,0|c,0|_A)),0|o(),0|z,0|Z)),$^(yA=0|o()),32)),0|(AA=0|o()),0|O,0|W))^z,(O=0|o())^Z,24),z=0|o(),AA=0|bB((yA=0|bC(0|(yA=0|bC(0|sA,0|yA,0|Q,0|rA)),0|o(),0|Z,0|z))^$,(sA=0|o())^AA,16),$=0|o(),a[C+120>>2]=AA,a[C+120+4>>2]=$,z=0|bB((O=0|bC(0|AA,0|$,0|W,0|O))^Z,(W=0|o())^z,63),Z=0|o(),L=0|bB((R=0|bC(0|(K=0|bB((iA=0|bC(0|(iA=0|bC(0|cA,0|iA,0|G,0|U)),0|o(),0|Y,0|L))^q,(cA=0|o())^K,32)),0|(q=0|o()),0|P,0|R))^Y,(P=0|o())^L,24),Y=0|o(),Y=0|bB((P=0|bC(0|(q=0|bB((cA=0|bC(0|(cA=0|bC(0|iA,0|cA,0|r,0|b)),0|o(),0|L,0|Y))^K,(iA=0|o())^q,16)),0|(K=0|o()),0|R,0|P))^L,(R=0|o())^Y,63),L=0|o(),d=0|bB((I=0|bC(0|(x=0|bB((eA=0|bC(0|(eA=0|bC(0|QA,0|eA,0|v,0|N)),0|o(),0|H,0|d))^S,(QA=0|o())^x,32)),0|(S=0|o()),0|n,0|I))^H,(n=0|o())^d,24),H=0|o(),H=0|bB((n=0|bC(0|(S=0|bB((QA=0|bC(0|(QA=0|bC(0|eA,0|QA,0|EA,0|nA)),0|o(),0|d,0|H))^x,(eA=0|o())^S,16)),0|(x=0|o()),0|I,0|n))^d,(I=0|o())^H,63),d=0|o(),f=0|bB((y=0|bC(0|(D=0|bB((tA=0|bC(0|(hA=0|bC(0|p,0|f,0|IA,0|gA)),0|o(),0|aA,0|tA))^u,(aA=0|o())^D,32)),0|(u=0|o()),0|w,0|y))^p,(w=0|o())^f,24),p=0|o(),p=0|bB((w=0|bC(0|(u=0|bB((aA=0|bC(0|(aA=0|bC(0|tA,0|aA,0|e,0|oA)),0|o(),0|f,0|p))^D,(tA=0|o())^u,16)),0|(D=0|o()),0|y,0|w))^f,(y=0|o())^p,63),f=0|o(),f=0|bB((I=0|bC(0|(K=0|bB((sA=0|bC(0|(sA=0|bC(0|yA,0|sA,0|E,0|s)),0|o(),0|p,0|f))^q,(yA=0|o())^K,32)),0|(q=0|o()),0|n,0|I))^p,(n=0|o())^f,24),p=0|o(),p=0|bB((n=0|bC(0|(q=0|bB((yA=0|bC(0|(yA=0|bC(0|sA,0|yA,0|r,0|b)),0|o(),0|f,0|p))^K,(sA=0|o())^q,16)),0|(K=0|o()),0|I,0|n))^f,(I=0|o())^p,63),f=0|o(),a[C+32>>2]=p,a[C+32+4>>2]=f,Z=0|bB((y=0|bC(0|(x=0|bB(S^(iA=0|bC(0|(hA=0|bC(0|z,0|Z,0|IA,0|gA)),0|o(),0|cA,0|iA)),x^(cA=0|o()),32)),0|(S=0|o()),0|w,0|y))^z,(w=0|o())^Z,24),z=0|o(),z=0|bB((w=0|bC(0|(S=0|bB((cA=0|bC(0|(cA=0|bC(0|iA,0|cA,0|v,0|N)),0|o(),0|Z,0|z))^x,(iA=0|o())^S,16)),0|(x=0|o()),0|y,0|w))^Z,(y=0|o())^z,63),Z=0|o(),L=0|bB((W=0|bC(0|(D=0|bB(u^(eA=0|bC(0|(hA=0|bC(0|Y,0|L,0|EA,0|nA)),0|o(),0|QA,0|eA)),D^(QA=0|o()),32)),0|(u=0|o()),0|O,0|W))^Y,(O=0|o())^L,24),Y=0|o(),Y=0|bB((O=0|bC(0|(u=0|bB((QA=0|bC(0|(QA=0|bC(0|eA,0|QA,0|Q,0|rA)),0|o(),0|L,0|Y))^D,(eA=0|o())^u,16)),0|(D=0|o()),0|W,0|O))^L,(W=0|o())^Y,63),L=0|o(),d=0|bB((R=0|bC(0|($=0|bB((tA=0|bC(0|(hA=0|bC(0|H,0|d,0|c,0|_A)),0|o(),0|aA,0|tA))^AA,(aA=0|o())^$,32)),0|(AA=0|o()),0|P,0|R))^H,(P=0|o())^d,24),H=0|o(),H=0|bB((P=0|bC(0|(AA=0|bB((aA=0|bC(0|(aA=0|bC(0|tA,0|aA,0|BA,0|CA)),0|o(),0|d,0|H))^$,(tA=0|o())^AA,16)),0|($=0|o()),0|R,0|P))^d,(R=0|o())^H,63),d=0|o(),Z=0|bB((W=0|bC(0|($=0|bB(AA^(sA=0|bC(0|(sA=0|bC(0|yA,0|sA,0|X,0|j)),0|o(),0|z,0|Z)),$^(yA=0|o()),32)),0|(AA=0|o()),0|O,0|W))^z,(O=0|o())^Z,24),z=0|o(),AA=0|bB((yA=0|bC(0|(yA=0|bC(0|sA,0|yA,0|G,0|U)),0|o(),0|Z,0|z))^$,(sA=0|o())^AA,16),$=0|o(),a[C+120>>2]=AA,a[C+120+4>>2]=$,z=0|bB((O=0|bC(0|AA,0|$,0|W,0|O))^Z,(W=0|o())^z,63),Z=0|o(),L=0|bB((R=0|bC(0|(K=0|bB((iA=0|bC(0|(iA=0|bC(0|cA,0|iA,0|k,0|F)),0|o(),0|Y,0|L))^q,(cA=0|o())^K,32)),0|(q=0|o()),0|P,0|R))^Y,(P=0|o())^L,24),Y=0|o(),Y=0|bB((P=0|bC(0|(q=0|bB((cA=0|bC(0|(cA=0|bC(0|iA,0|cA,0|l,0|m)),0|o(),0|L,0|Y))^K,(iA=0|o())^q,16)),0|(K=0|o()),0|R,0|P))^L,(R=0|o())^Y,63),L=0|o(),d=0|bB((I=0|bC(0|(x=0|bB((eA=0|bC(0|(eA=0|bC(0|QA,0|eA,0|e,0|oA)),0|o(),0|H,0|d))^S,(QA=0|o())^x,32)),0|(S=0|o()),0|n,0|I))^H,(n=0|o())^d,24),H=0|o(),H=0|bB((n=0|bC(0|(S=0|bB((QA=0|bC(0|(QA=0|bC(0|eA,0|QA,0|_,0|i)),0|o(),0|d,0|H))^x,(eA=0|o())^S,16)),0|(x=0|o()),0|I,0|n))^d,(I=0|o())^H,63),d=0|o(),f=0|bB((y=0|bC(0|(D=0|bB((tA=0|bC(0|(hA=0|bC(0|p,0|f,0|T,0|V)),0|o(),0|aA,0|tA))^u,(aA=0|o())^D,32)),0|(u=0|o()),0|w,0|y))^p,(w=0|o())^f,24),p=0|o(),p=0|bB((w=0|bC(0|(u=0|bB((aA=0|bC(0|(aA=0|bC(0|tA,0|aA,0|M,0|J)),0|o(),0|f,0|p))^D,(tA=0|o())^u,16)),0|(D=0|o()),0|y,0|w))^f,(y=0|o())^p,63),f=0|o(),f=0|bB((I=0|bC(0|(K=0|bB((sA=0|bC(0|(sA=0|bC(0|yA,0|sA,0|Q,0|rA)),0|o(),0|p,0|f))^q,(yA=0|o())^K,32)),0|(q=0|o()),0|n,0|I))^p,(n=0|o())^f,24),p=0|o(),p=0|bB((n=0|bC(0|(q=0|bB((yA=0|bC(0|(yA=0|bC(0|sA,0|yA,0|M,0|J)),0|o(),0|f,0|p))^K,(sA=0|o())^q,16)),0|(K=0|o()),0|I,0|n))^f,(I=0|o())^p,63),f=0|o(),a[C+32>>2]=p,a[C+32+4>>2]=f,Z=0|bB((y=0|bC(0|(x=0|bB(S^(iA=0|bC(0|(hA=0|bC(0|z,0|Z,0|G,0|U)),0|o(),0|cA,0|iA)),x^(cA=0|o()),32)),0|(S=0|o()),0|w,0|y))^z,(w=0|o())^Z,24),z=0|o(),z=0|bB((w=0|bC(0|(S=0|bB((cA=0|bC(0|(cA=0|bC(0|iA,0|cA,0|EA,0|nA)),0|o(),0|Z,0|z))^x,(iA=0|o())^S,16)),0|(x=0|o()),0|y,0|w))^Z,(y=0|o())^z,63),Z=0|o(),L=0|bB((W=0|bC(0|(D=0|bB(u^(eA=0|bC(0|(hA=0|bC(0|Y,0|L,0|E,0|s)),0|o(),0|QA,0|eA)),D^(QA=0|o()),32)),0|(u=0|o()),0|O,0|W))^Y,(O=0|o())^L,24),Y=0|o(),Y=0|bB((O=0|bC(0|(u=0|bB((QA=0|bC(0|(QA=0|bC(0|eA,0|QA,0|IA,0|gA)),0|o(),0|L,0|Y))^D,(eA=0|o())^u,16)),0|(D=0|o()),0|W,0|O))^L,(W=0|o())^Y,63),L=0|o(),d=0|bB((R=0|bC(0|($=0|bB((tA=0|bC(0|(hA=0|bC(0|H,0|d,0|l,0|m)),0|o(),0|aA,0|tA))^AA,(aA=0|o())^$,32)),0|(AA=0|o()),0|P,0|R))^H,(P=0|o())^d,24),H=0|o(),H=0|bB((P=0|bC(0|(AA=0|bB((aA=0|bC(0|(aA=0|bC(0|tA,0|aA,0|e,0|oA)),0|o(),0|d,0|H))^$,(tA=0|o())^AA,16)),0|($=0|o()),0|R,0|P))^d,(R=0|o())^H,63),d=0|o(),Z=0|bB((W=0|bC(0|($=0|bB(AA^(sA=0|bC(0|(sA=0|bC(0|yA,0|sA,0|r,0|b)),0|o(),0|z,0|Z)),$^(yA=0|o()),32)),0|(AA=0|o()),0|O,0|W))^z,(O=0|o())^Z,24),z=0|o(),AA=0|bB((yA=0|bC(0|(yA=0|bC(0|sA,0|yA,0|X,0|j)),0|o(),0|Z,0|z))^$,(sA=0|o())^AA,16),$=0|o(),a[C+120>>2]=AA,a[C+120+4>>2]=$,z=0|bB((O=0|bC(0|AA,0|$,0|W,0|O))^Z,(W=0|o())^z,63),Z=0|o(),L=0|bB((R=0|bC(0|(K=0|bB((iA=0|bC(0|(iA=0|bC(0|cA,0|iA,0|v,0|N)),0|o(),0|Y,0|L))^q,(cA=0|o())^K,32)),0|(q=0|o()),0|P,0|R))^Y,(P=0|o())^L,24),Y=0|o(),Y=0|bB((P=0|bC(0|(q=0|bB((cA=0|bC(0|(cA=0|bC(0|iA,0|cA,0|c,0|_A)),0|o(),0|L,0|Y))^K,(iA=0|o())^q,16)),0|(K=0|o()),0|R,0|P))^L,(R=0|o())^Y,63),L=0|o(),d=0|bB((I=0|bC(0|(x=0|bB((eA=0|bC(0|(eA=0|bC(0|QA,0|eA,0|T,0|V)),0|o(),0|H,0|d))^S,(QA=0|o())^x,32)),0|(S=0|o()),0|n,0|I))^H,(n=0|o())^d,24),H=0|o(),H=0|bB((n=0|bC(0|(S=0|bB((QA=0|bC(0|(QA=0|bC(0|eA,0|QA,0|k,0|F)),0|o(),0|d,0|H))^x,(eA=0|o())^S,16)),0|(x=0|o()),0|I,0|n))^d,(I=0|o())^H,63),d=0|o(),f=0|bB((y=0|bC(0|(D=0|bB((tA=0|bC(0|(hA=0|bC(0|p,0|f,0|_,0|i)),0|o(),0|aA,0|tA))^u,(aA=0|o())^D,32)),0|(u=0|o()),0|w,0|y))^p,(w=0|o())^f,24),p=0|o(),p=0|bB((w=0|bC(0|(u=0|bB((aA=0|bC(0|(aA=0|bC(0|tA,0|aA,0|BA,0|CA)),0|o(),0|f,0|p))^D,(tA=0|o())^u,16)),0|(D=0|o()),0|y,0|w))^f,(y=0|o())^p,63),f=0|o(),f=0|bB((I=0|bC(0|(K=0|bB((sA=0|bC(0|(sA=0|bC(0|yA,0|sA,0|k,0|F)),0|o(),0|p,0|f))^q,(yA=0|o())^K,32)),0|(q=0|o()),0|n,0|I))^p,(n=0|o())^f,24),p=0|o(),p=0|bB((n=0|bC(0|(q=0|bB((yA=0|bC(0|(yA=0|bC(0|sA,0|yA,0|v,0|N)),0|o(),0|f,0|p))^K,(sA=0|o())^q,16)),0|(K=0|o()),0|I,0|n))^f,(I=0|o())^p,63),f=0|o(),a[C+32>>2]=p,a[C+32+4>>2]=f,Z=0|bB((y=0|bC(0|(x=0|bB(S^(iA=0|bC(0|(hA=0|bC(0|z,0|Z,0|EA,0|nA)),0|o(),0|cA,0|iA)),x^(cA=0|o()),32)),0|(S=0|o()),0|w,0|y))^z,(w=0|o())^Z,24),z=0|o(),z=0|bB((w=0|bC(0|(S=0|bB((cA=0|bC(0|(cA=0|bC(0|iA,0|cA,0|e,0|oA)),0|o(),0|Z,0|z))^x,(iA=0|o())^S,16)),0|(x=0|o()),0|y,0|w))^Z,(y=0|o())^z,63),Z=0|o(),L=0|bB((W=0|bC(0|(D=0|bB(u^(eA=0|bC(0|(hA=0|bC(0|Y,0|L,0|M,0|J)),0|o(),0|QA,0|eA)),D^(QA=0|o()),32)),0|(u=0|o()),0|O,0|W))^Y,(O=0|o())^L,24),Y=0|o(),Y=0|bB((O=0|bC(0|(u=0|bB((QA=0|bC(0|(QA=0|bC(0|eA,0|QA,0|l,0|m)),0|o(),0|L,0|Y))^D,(eA=0|o())^u,16)),0|(D=0|o()),0|W,0|O))^L,(W=0|o())^Y,63),L=0|o(),d=0|bB((R=0|bC(0|($=0|bB((tA=0|bC(0|(hA=0|bC(0|H,0|d,0|X,0|j)),0|o(),0|aA,0|tA))^AA,(aA=0|o())^$,32)),0|(AA=0|o()),0|P,0|R))^H,(P=0|o())^d,24),H=0|o(),H=0|bB((P=0|bC(0|(AA=0|bB((aA=0|bC(0|(aA=0|bC(0|tA,0|aA,0|T,0|V)),0|o(),0|d,0|H))^$,(tA=0|o())^AA,16)),0|($=0|o()),0|R,0|P))^d,(R=0|o())^H,63),d=0|o(),Z=0|bB((W=0|bC(0|($=0|bB(AA^(sA=0|bC(0|(sA=0|bC(0|yA,0|sA,0|E,0|s)),0|o(),0|z,0|Z)),$^(yA=0|o()),32)),0|(AA=0|o()),0|O,0|W))^z,(O=0|o())^Z,24),z=0|o(),AA=0|bB((yA=0|bC(0|(yA=0|bC(0|sA,0|yA,0|_,0|i)),0|o(),0|Z,0|z))^$,(sA=0|o())^AA,16),$=0|o(),a[C+120>>2]=AA,a[C+120+4>>2]=$,z=0|bB((O=0|bC(0|AA,0|$,0|W,0|O))^Z,(W=0|o())^z,63),Z=0|o(),L=0|bB((R=0|bC(0|(K=0|bB((iA=0|bC(0|(iA=0|bC(0|cA,0|iA,0|Q,0|rA)),0|o(),0|Y,0|L))^q,(cA=0|o())^K,32)),0|(q=0|o()),0|P,0|R))^Y,(P=0|o())^L,24),Y=0|o(),Y=0|bB((P=0|bC(0|(q=0|bB((cA=0|bC(0|(cA=0|bC(0|iA,0|cA,0|G,0|U)),0|o(),0|L,0|Y))^K,(iA=0|o())^q,16)),0|(K=0|o()),0|R,0|P))^L,(R=0|o())^Y,63),L=0|o(),d=0|bB((I=0|bC(0|(x=0|bB((eA=0|bC(0|(eA=0|bC(0|QA,0|eA,0|IA,0|gA)),0|o(),0|H,0|d))^S,(QA=0|o())^x,32)),0|(S=0|o()),0|n,0|I))^H,(n=0|o())^d,24),H=0|o(),H=0|bB((n=0|bC(0|(S=0|bB((QA=0|bC(0|(QA=0|bC(0|eA,0|QA,0|c,0|_A)),0|o(),0|d,0|H))^x,(eA=0|o())^S,16)),0|(x=0|o()),0|I,0|n))^d,(I=0|o())^H,63),d=0|o(),f=0|bB((y=0|bC(0|(D=0|bB((tA=0|bC(0|(hA=0|bC(0|p,0|f,0|BA,0|CA)),0|o(),0|aA,0|tA))^u,(aA=0|o())^D,32)),0|(u=0|o()),0|w,0|y))^p,(w=0|o())^f,24),p=0|o(),p=0|bB((w=0|bC(0|(u=0|bB((aA=0|bC(0|(aA=0|bC(0|tA,0|aA,0|r,0|b)),0|o(),0|f,0|p))^D,(tA=0|o())^u,16)),0|(D=0|o()),0|y,0|w))^f,(y=0|o())^p,63),f=0|o(),f=0|bB((I=0|bC(0|(K=0|bB((sA=0|bC(0|(sA=0|bC(0|yA,0|sA,0|BA,0|CA)),0|o(),0|p,0|f))^q,(yA=0|o())^K,32)),0|(q=0|o()),0|n,0|I))^p,(n=0|o())^f,24),p=0|o(),p=0|bB((n=0|bC(0|(q=0|bB((yA=0|bC(0|(yA=0|bC(0|sA,0|yA,0|_,0|i)),0|o(),0|f,0|p))^K,(sA=0|o())^q,16)),0|(K=0|o()),0|I,0|n))^f,(I=0|o())^p,63),f=0|o(),a[C+32>>2]=p,a[C+32+4>>2]=f,Z=0|bB((y=0|bC(0|(x=0|bB(S^(iA=0|bC(0|(hA=0|bC(0|z,0|Z,0|T,0|V)),0|o(),0|cA,0|iA)),x^(cA=0|o()),32)),0|(S=0|o()),0|w,0|y))^z,(w=0|o())^Z,24),z=0|o(),z=0|bB((w=0|bC(0|(S=0|bB((cA=0|bC(0|(cA=0|bC(0|iA,0|cA,0|c,0|_A)),0|o(),0|Z,0|z))^x,(iA=0|o())^S,16)),0|(x=0|o()),0|y,0|w))^Z,(y=0|o())^z,63),Z=0|o(),L=0|bB((W=0|bC(0|(D=0|bB(u^(eA=0|bC(0|(hA=0|bC(0|Y,0|L,0|G,0|U)),0|o(),0|QA,0|eA)),D^(QA=0|o()),32)),0|(u=0|o()),0|O,0|W))^Y,(O=0|o())^L,24),Y=0|o(),Y=0|bB((O=0|bC(0|(u=0|bB((QA=0|bC(0|(QA=0|bC(0|eA,0|QA,0|k,0|F)),0|o(),0|L,0|Y))^D,(eA=0|o())^u,16)),0|(D=0|o()),0|W,0|O))^L,(W=0|o())^Y,63),L=0|o(),d=0|bB((R=0|bC(0|($=0|bB((tA=0|bC(0|(hA=0|bC(0|H,0|d,0|IA,0|gA)),0|o(),0|aA,0|tA))^AA,(aA=0|o())^$,32)),0|(AA=0|o()),0|P,0|R))^H,(P=0|o())^d,24),H=0|o(),H=0|bB((P=0|bC(0|(AA=0|bB((aA=0|bC(0|(aA=0|bC(0|tA,0|aA,0|r,0|b)),0|o(),0|d,0|H))^$,(tA=0|o())^AA,16)),0|($=0|o()),0|R,0|P))^d,(R=0|o())^H,63),d=0|o(),Z=0|bB((W=0|bC(0|($=0|bB(AA^(sA=0|bC(0|(sA=0|bC(0|yA,0|sA,0|v,0|N)),0|o(),0|z,0|Z)),$^(yA=0|o()),32)),0|(AA=0|o()),0|O,0|W))^z,(O=0|o())^Z,24),z=0|o(),AA=0|bB((yA=0|bC(0|(yA=0|bC(0|sA,0|yA,0|M,0|J)),0|o(),0|Z,0|z))^$,(sA=0|o())^AA,16),$=0|o(),a[C+120>>2]=AA,a[C+120+4>>2]=$,z=0|bB((O=0|bC(0|AA,0|$,0|W,0|O))^Z,(W=0|o())^z,63),Z=0|o(),L=0|bB((R=0|bC(0|(K=0|bB((iA=0|bC(0|(iA=0|bC(0|cA,0|iA,0|e,0|oA)),0|o(),0|Y,0|L))^q,(cA=0|o())^K,32)),0|(q=0|o()),0|P,0|R))^Y,(P=0|o())^L,24),Y=0|o(),Y=0|bB((P=0|bC(0|(q=0|bB((cA=0|bC(0|(cA=0|bC(0|iA,0|cA,0|EA,0|nA)),0|o(),0|L,0|Y))^K,(iA=0|o())^q,16)),0|(K=0|o()),0|R,0|P))^L,(R=0|o())^Y,63),L=0|o(),d=0|bB((I=0|bC(0|(x=0|bB((eA=0|bC(0|(eA=0|bC(0|QA,0|eA,0|l,0|m)),0|o(),0|H,0|d))^S,(QA=0|o())^x,32)),0|(S=0|o()),0|n,0|I))^H,(n=0|o())^d,24),H=0|o(),H=0|bB((n=0|bC(0|(S=0|bB((QA=0|bC(0|(QA=0|bC(0|eA,0|QA,0|E,0|s)),0|o(),0|d,0|H))^x,(eA=0|o())^S,16)),0|(x=0|o()),0|I,0|n))^d,(I=0|o())^H,63),d=0|o(),f=0|bB((y=0|bC(0|(D=0|bB((tA=0|bC(0|(hA=0|bC(0|p,0|f,0|Q,0|rA)),0|o(),0|aA,0|tA))^u,(aA=0|o())^D,32)),0|(u=0|o()),0|w,0|y))^p,(w=0|o())^f,24),p=0|o(),p=0|bB((w=0|bC(0|(u=0|bB((aA=0|bC(0|(aA=0|bC(0|tA,0|aA,0|X,0|j)),0|o(),0|f,0|p))^D,(tA=0|o())^u,16)),0|(D=0|o()),0|y,0|w))^f,(y=0|o())^p,63),f=0|o(),f=0|bB((I=0|bC(0|(K=0|bB((sA=0|bC(0|(sA=0|bC(0|yA,0|sA,0|X,0|j)),0|o(),0|p,0|f))^q,(yA=0|o())^K,32)),0|(q=0|o()),0|n,0|I))^p,(n=0|o())^f,24),p=0|o(),p=0|bB((n=0|bC(0|(q=0|bB((yA=0|bC(0|(yA=0|bC(0|sA,0|yA,0|IA,0|gA)),0|o(),0|f,0|p))^K,(sA=0|o())^q,16)),0|(K=0|o()),0|I,0|n))^f,(I=0|o())^p,63),f=0|o(),a[C+32>>2]=p,a[C+32+4>>2]=f,Z=0|bB((y=0|bC(0|(x=0|bB(S^(iA=0|bC(0|(hA=0|bC(0|z,0|Z,0|_,0|i)),0|o(),0|cA,0|iA)),x^(cA=0|o()),32)),0|(S=0|o()),0|w,0|y))^z,(w=0|o())^Z,24),z=0|o(),z=0|bB((w=0|bC(0|(S=0|bB((cA=0|bC(0|(cA=0|bC(0|iA,0|cA,0|l,0|m)),0|o(),0|Z,0|z))^x,(iA=0|o())^S,16)),0|(x=0|o()),0|y,0|w))^Z,(y=0|o())^z,63),Z=0|o(),L=0|bB((W=0|bC(0|(D=0|bB(u^(eA=0|bC(0|(hA=0|bC(0|Y,0|L,0|c,0|_A)),0|o(),0|QA,0|eA)),D^(QA=0|o()),32)),0|(u=0|o()),0|O,0|W))^Y,(O=0|o())^L,24),Y=0|o(),Y=0|bB((O=0|bC(0|(u=0|bB((QA=0|bC(0|(QA=0|bC(0|eA,0|QA,0|r,0|b)),0|o(),0|L,0|Y))^D,(eA=0|o())^u,16)),0|(D=0|o()),0|W,0|O))^L,(W=0|o())^Y,63),L=0|o(),d=0|bB((R=0|bC(0|($=0|bB((tA=0|bC(0|(hA=0|bC(0|H,0|d,0|k,0|F)),0|o(),0|aA,0|tA))^AA,(aA=0|o())^$,32)),0|(AA=0|o()),0|P,0|R))^H,(P=0|o())^d,24),H=0|o(),H=0|bB((P=0|bC(0|(AA=0|bB((aA=0|bC(0|(aA=0|bC(0|tA,0|aA,0|G,0|U)),0|o(),0|d,0|H))^$,(tA=0|o())^AA,16)),0|($=0|o()),0|R,0|P))^d,(R=0|o())^H,63),d=0|o(),Z=0|bB((W=0|bC(0|($=0|bB(AA^(sA=0|bC(0|(sA=0|bC(0|yA,0|sA,0|T,0|V)),0|o(),0|z,0|Z)),$^(yA=0|o()),32)),0|(AA=0|o()),0|O,0|W))^z,(O=0|o())^Z,24),z=0|o(),AA=0|bB((yA=0|bC(0|(yA=0|bC(0|sA,0|yA,0|e,0|oA)),0|o(),0|Z,0|z))^$,(sA=0|o())^AA,16),$=0|o(),a[C+120>>2]=AA,a[C+120+4>>2]=$,z=0|bB((O=0|bC(0|AA,0|$,0|W,0|O))^Z,(W=0|o())^z,63),Z=0|o(),L=0|bB((R=0|bC(0|(K=0|bB((iA=0|bC(0|(iA=0|bC(0|cA,0|iA,0|BA,0|CA)),0|o(),0|Y,0|L))^q,(cA=0|o())^K,32)),0|(q=0|o()),0|P,0|R))^Y,(P=0|o())^L,24),Y=0|o(),Y=0|bB((P=0|bC(0|(q=0|bB((cA=0|bC(0|(cA=0|bC(0|iA,0|cA,0|M,0|J)),0|o(),0|L,0|Y))^K,(iA=0|o())^q,16)),0|(K=0|o()),0|R,0|P))^L,(R=0|o())^Y,63),L=0|o(),d=0|bB((I=0|bC(0|(x=0|bB((eA=0|bC(0|(eA=0|bC(0|QA,0|eA,0|E,0|s)),0|o(),0|H,0|d))^S,(QA=0|o())^x,32)),0|(S=0|o()),0|n,0|I))^H,(n=0|o())^d,24),H=0|o(),H=0|bB((n=0|bC(0|(S=0|bB((QA=0|bC(0|(QA=0|bC(0|eA,0|QA,0|Q,0|rA)),0|o(),0|d,0|H))^x,(eA=0|o())^S,16)),0|(x=0|o()),0|I,0|n))^d,(I=0|o())^H,63),d=0|o(),f=0|bB((y=0|bC(0|(D=0|bB((tA=0|bC(0|(hA=0|bC(0|p,0|f,0|EA,0|nA)),0|o(),0|aA,0|tA))^u,(aA=0|o())^D,32)),0|(u=0|o()),0|w,0|y))^p,(w=0|o())^f,24),p=0|o(),p=0|bB((w=0|bC(0|(u=0|bB((aA=0|bC(0|(aA=0|bC(0|tA,0|aA,0|v,0|N)),0|o(),0|f,0|p))^D,(tA=0|o())^u,16)),0|(D=0|o()),0|y,0|w))^f,(y=0|o())^p,63),f=0|o(),f=0|bB((I=0|bC(0|(K=0|bB((nA=0|bC(0|(nA=0|bC(0|yA,0|sA,0|EA,0|nA)),0|o(),0|p,0|f))^q,(EA=0|o())^K,32)),0|(q=0|o()),0|n,0|I))^p,(n=0|o())^f,24),p=0|o(),p=0|bB((n=0|bC(0|(q=0|bB((CA=0|bC(0|(CA=0|bC(0|nA,0|EA,0|BA,0|CA)),0|o(),0|f,0|p))^K,(BA=0|o())^q,16)),0|(K=0|o()),0|I,0|n))^f,(I=0|o())^p,63),f=0|o(),a[C+32>>2]=p,a[C+32+4>>2]=f,Z=0|bB((y=0|bC(0|(x=0|bB(S^(iA=0|bC(0|(_A=0|bC(0|z,0|Z,0|c,0|_A)),0|o(),0|cA,0|iA)),x^(cA=0|o()),32)),0|(S=0|o()),0|w,0|y))^z,(w=0|o())^Z,24),z=0|o(),z=0|bB((w=0|bC(0|(S=0|bB((V=0|bC(0|(V=0|bC(0|iA,0|cA,0|T,0|V)),0|o(),0|Z,0|z))^x,(T=0|o())^S,16)),0|(x=0|o()),0|y,0|w))^Z,(y=0|o())^z,63),Z=0|o(),L=0|bB((W=0|bC(0|(D=0|bB(u^(eA=0|bC(0|(oA=0|bC(0|Y,0|L,0|e,0|oA)),0|o(),0|QA,0|eA)),D^(QA=0|o()),32)),0|(u=0|o()),0|O,0|W))^Y,(O=0|o())^L,24),Y=0|o(),Y=0|bB((O=0|bC(0|(u=0|bB((N=0|bC(0|(N=0|bC(0|eA,0|QA,0|v,0|N)),0|o(),0|L,0|Y))^D,(v=0|o())^u,16)),0|(D=0|o()),0|W,0|O))^L,(W=0|o())^Y,63),L=0|o(),d=0|bB((R=0|bC(0|($=0|bB((tA=0|bC(0|(rA=0|bC(0|H,0|d,0|Q,0|rA)),0|o(),0|aA,0|tA))^AA,(aA=0|o())^$,32)),0|(AA=0|o()),0|P,0|R))^H,(P=0|o())^d,24),H=0|o(),H=0|bB((P=0|bC(0|(AA=0|bB((F=0|bC(0|(F=0|bC(0|tA,0|aA,0|k,0|F)),0|o(),0|d,0|H))^$,(k=0|o())^AA,16)),0|($=0|o()),0|R,0|P))^d,(R=0|o())^H,63),d=0|o(),Z=0|bB((W=0|bC(0|($=0|bB(AA^(gA=0|bC(0|(gA=0|bC(0|CA,0|BA,0|IA,0|gA)),0|o(),0|z,0|Z)),$^(IA=0|o()),32)),0|(AA=0|o()),0|O,0|W))^z,(O=0|o())^Z,24),z=0|o(),s=0|bC(0|(s=0|bC(0|gA,0|IA,0|E,0|s)),0|o(),0|Z,0|z),E=0|o(),a[C>>2]=s,a[C+4>>2]=E,AA=0|bB(s^$,E^AA,16),$=0|o(),a[C+120>>2]=AA,a[C+120+4>>2]=$,O=0|bC(0|AA,0|$,0|W,0|O),W=0|o(),a[C+80>>2]=O,a[C+80+4>>2]=W,z=0|bB(O^Z,W^z,63),W=0|o(),a[C+40>>2]=z,a[C+40+4>>2]=W,L=0|bB((R=0|bC(0|(K=0|bB((j=0|bC(0|(j=0|bC(0|V,0|T,0|X,0|j)),0|o(),0|Y,0|L))^q,(X=0|o())^K,32)),0|(q=0|o()),0|P,0|R))^Y,(P=0|o())^L,24),Y=0|o(),i=0|bC(0|(i=0|bC(0|j,0|X,0|_,0|i)),0|o(),0|L,0|Y),_=0|o(),a[C+8>>2]=i,a[C+8+4>>2]=_,q=0|bB(i^K,_^q,16),K=0|o(),a[C+96>>2]=q,a[C+96+4>>2]=K,P=0|bC(0|q,0|K,0|R,0|P),R=0|o(),a[C+88>>2]=P,a[C+88+4>>2]=R,Y=0|bB(P^L,R^Y,63),R=0|o(),a[C+48>>2]=Y,a[C+48+4>>2]=R,d=0|bB((I=0|bC(0|(x=0|bB((J=0|bC(0|(J=0|bC(0|N,0|v,0|M,0|J)),0|o(),0|H,0|d))^S,(M=0|o())^x,32)),0|(S=0|o()),0|n,0|I))^H,(n=0|o())^d,24),H=0|o(),U=0|bC(0|(U=0|bC(0|J,0|M,0|G,0|U)),0|o(),0|d,0|H),G=0|o(),a[C+16>>2]=U,a[C+16+4>>2]=G,S=0|bB(U^x,G^S,16),G=0|o(),a[C+104>>2]=S,a[C+104+4>>2]=G,n=0|bC(0|S,0|G,0|I,0|n),I=0|o(),a[C+64>>2]=n,a[C+64+4>>2]=I,H=0|bB(n^d,I^H,63),d=0|o(),a[C+56>>2]=H,a[C+56+4>>2]=d,f=0|bB((y=0|bC(0|(D=0|bB((k=0|bC(0|(b=0|bC(0|p,0|f,0|r,0|b)),0|o(),0|F,0|k))^u,(F=0|o())^D,32)),0|(u=0|o()),0|w,0|y))^p,(w=0|o())^f,24),p=0|o(),m=0|bC(0|(m=0|bC(0|k,0|F,0|l,0|m)),0|o(),0|f,0|p),l=0|o(),a[C+24>>2]=m,a[C+24+4>>2]=l,u=0|bB(m^D,l^u,16),l=0|o(),a[C+112>>2]=u,a[C+112+4>>2]=l,w=0|bC(0|u,0|l,0|y,0|w),y=0|o(),a[C+72>>2]=w,a[C+72+4>>2]=y,p=0|bB(w^f,y^p,63),y=0|o(),a[C+32>>2]=p,a[C+32+4>>2]=y,n=s^(t[A>>0]|t[A+1>>0]<<8|t[A+2>>0]<<16|t[A+3>>0]<<24)^n,I=E^(t[A+4>>0]|t[A+4+1>>0]<<8|t[A+4+2>>0]<<16|t[A+4+3>>0]<<24)^I,B[A>>0]=n,B[A+1>>0]=n>>8,B[A+2>>0]=n>>16,B[A+3>>0]=n>>24,B[A+4>>0]=I,B[A+4+1>>0]=I>>8,B[A+4+2>>0]=I>>16,B[A+4+3>>0]=I>>24,I=1;yA=C+(I+8<<3)|0,sA=i^(t[(hA=A+(I<<3)|0)>>0]|t[hA+1>>0]<<8|t[hA+2>>0]<<16|t[hA+3>>0]<<24)^a[yA>>2],yA=_^(t[hA+4>>0]|t[hA+4+1>>0]<<8|t[hA+4+2>>0]<<16|t[hA+4+3>>0]<<24)^a[yA+4>>2],B[hA>>0]=sA,B[hA+1>>0]=sA>>8,B[hA+2>>0]=sA>>16,B[hA+3>>0]=sA>>24,B[hA+4>>0]=yA,B[hA+4+1>>0]=yA>>8,B[hA+4+2>>0]=yA>>16,B[hA+4+3>>0]=yA>>24,8!=(0|(I=I+1|0));)i=0|a[C+(I<<3)>>2],_=0|a[C+(I<<3)+4>>2];h=g}function f(A,I,g,C){A|=0,g|=0,C|=0;var a,t,r,Q,e,c,i,_,E,n,s,y,h,p,f,w,l,u,D,m,F,k=0,b=0,d=0,H=0,G=0,S=0,x=0,U=0,M=0,J=0,v=0,N=0,R=0,Y=0,L=0,P=0,K=0,q=0,X=0,j=0,T=0,V=0,W=0,z=0,Z=0,O=0,$=0,AA=0,IA=0,gA=0,BA=0,CA=0,aA=0,tA=0,rA=0,QA=0,eA=0,oA=0,cA=0,iA=0,_A=0,EA=0,nA=0,sA=0,yA=0,hA=0,pA=0,fA=0,wA=0,lA=0,uA=0,DA=0,mA=0,FA=0,kA=0,bA=0,dA=0,HA=0,GA=0,SA=0,xA=0,UA=0,MA=0,JA=0,vA=0,NA=0,RA=0,YA=0,LA=0,PA=0,KA=0,qA=0,XA=0,jA=0,TA=0,VA=0,WA=0,zA=0,ZA=0,OA=0,$A=0,AI=0,II=0,gI=0,BI=0,CI=0,aI=0,tI=0,rI=0,QI=0,eI=0,oI=0,cI=0,iI=0,_I=0,EI=0,nI=0,sI=0,yI=0,hI=0,pI=0,fI=0,wI=0,lI=0,uI=0,DI=0,mI=0,FI=0,kI=0,bI=0,dI=0,HI=0,GI=0,SI=0,xI=0,UI=0,MI=0,JI=0,vI=0,NI=0,RI=0,YI=0,LI=0,PI=0,KI=0,qI=0,XI=0,jI=0,TI=0,VI=0,WI=0,zI=0,ZI=0,OI=0,$I=0,Ag=0,Ig=0,gg=0,Bg=0,Cg=0,ag=0,tg=0,rg=0,Qg=0,eg=0,og=0,cg=0,ig=0,_g=0,Eg=0,ng=0,sg=0,yg=0;sA=0|JB(0|B[(I|=0)>>0],0|B[I+1>>0],0|B[I+2>>0]),o(),SI=0|CC(0|(SI=0|dg(I+2|0)),0|o(),5),o(),uI=0|CC(0|(uI=0|JB(0|B[I+5>>0],0|B[I+6>>0],0|B[I+7>>0])),0|o(),2),o(),GI=0|CC(0|(GI=0|dg(I+7|0)),0|o(),7),o(),yI=0|CC(0|(yI=0|dg(I+10|0)),0|o(),4),o(),CA=0|CC(0|(CA=0|JB(0|B[I+13>>0],0|B[I+14>>0],0|B[I+15>>0])),0|o(),1),o(),wA=0|CC(0|(wA=0|dg(I+15|0)),0|o(),6),o(),k=0|CC(0|(k=0|JB(0|B[I+18>>0],0|B[I+19>>0],0|B[I+20>>0])),0|o(),3),o(),aA=0|JB(0|B[I+21>>0],0|B[I+22>>0],0|B[I+23>>0]),o(),T=0|CC(0|(T=0|dg(I+23|0)),0|o(),5),o(),DA=0|CC(0|(DA=0|JB(0|B[I+26>>0],0|B[I+27>>0],0|B[I+28>>0])),0|o(),2),o(),bA=0|CC(0|(bA=0|dg(I+28|0)),0|o(),7),dA=0|o(),KI=0|JB(0|B[g>>0],0|B[g+1>>0],0|B[g+2>>0]),o(),pI=0|CC(0|(pI=0|dg(g+2|0)),0|o(),5),o(),gI=0|CC(0|(gI=0|JB(0|B[g+5>>0],0|B[g+6>>0],0|B[g+7>>0])),0|o(),2),o(),b=0|CC(0|(b=0|dg(g+7|0)),0|o(),7),o(),d=0|CC(0|(d=0|dg(g+10|0)),0|o(),4),o(),P=0|CC(0|(P=0|JB(0|B[g+13>>0],0|B[g+14>>0],0|B[g+15>>0])),0|o(),1),o(),WA=0|CC(0|(WA=0|dg(g+15|0)),0|o(),6),o(),hA=0|CC(0|(hA=0|JB(0|B[g+18>>0],0|B[g+19>>0],0|B[g+20>>0])),0|o(),3),o(),NA=0|JB(0|B[g+21>>0],0|B[g+22>>0],0|B[g+23>>0]),o(),IA=0|CC(0|(IA=0|dg(g+23|0)),0|o(),5),o(),NI=0|CC(0|(NI=0|JB(0|B[g+26>>0],0|B[g+27>>0],0|B[g+28>>0])),0|o(),2),o(),_A=0|CC(0|(_A=0|dg(g+28|0)),0|o(),7),iA=0|o(),LA=0|JB(0|B[C>>0],0|B[C+1>>0],0|B[C+2>>0]),o(),BA=0|CC(0|(BA=0|dg(C+2|0)),0|o(),5),o(),KA=0|CC(0|(KA=0|JB(0|B[C+5>>0],0|B[C+6>>0],0|B[C+7>>0])),0|o(),2),o(),MA=0|CC(0|(MA=0|dg(C+7|0)),0|o(),7),o(),vA=0|CC(0|(vA=0|dg(C+10|0)),0|o(),4),o(),zA=0|CC(0|(zA=0|JB(0|B[C+13>>0],0|B[C+14>>0],0|B[C+15>>0])),0|o(),1),o(),FI=0|CC(0|(FI=0|dg(C+15|0)),0|o(),6),o(),x=0|CC(0|(x=0|JB(0|B[C+18>>0],0|B[C+19>>0],0|B[C+20>>0])),0|o(),3),o(),oI=0|JB(0|B[C+21>>0],0|B[C+22>>0],0|B[C+23>>0]),o(),jA=0|CC(0|(jA=0|dg(C+23|0)),0|o(),5),o(),EA=0|CC(0|(EA=0|JB(0|B[C+26>>0],0|B[C+27>>0],0|B[C+28>>0])),0|o(),2),o(),wI=0|CC(0|(wI=0|dg(C+28|0)),0|o(),7),kI=0|o(),YA=0|bC(2097151&LA|0,0,0|(YA=0|NB(2097151&KI|0,0,2097151&sA|0,0)),0|o()),LA=0|o(),w=0|NB(2097151&pI|0,0,2097151&sA|0,0),f=0|o(),p=0|NB(2097151&KI|0,0,2097151&SI|0,0),$A=0|o(),O=0|NB(2097151&gI|0,0,2097151&sA|0,0),PA=0|o(),KA=0|bC(0|(PA=0|bC(0|(UA=0|bC(0|(Z=0|NB(2097151&pI|0,0,2097151&SI|0,0)),0|o(),0|(UA=0|NB(2097151&KI|0,0,2097151&uI|0,0)),0|o())),0|o(),0|O,0|PA)),0|o(),2097151&KA|0,0),PA=0|o(),O=0|NB(2097151&b|0,0,2097151&sA|0,0),UA=0|o(),F=0|NB(2097151&gI|0,0,2097151&SI|0,0),Z=0|o(),h=0|NB(2097151&pI|0,0,2097151&uI|0,0),y=0|o(),s=0|NB(2097151&KI|0,0,2097151&GI|0,0),yg=0|o(),cA=0|NB(2097151&d|0,0,2097151&sA|0,0),JA=0|o(),ig=0|NB(2097151&b|0,0,2097151&SI|0,0),ZA=0|o(),Eg=0|NB(2097151&gI|0,0,2097151&uI|0,0),v=0|o(),vA=0|bC(0|(JA=0|bC(0|(ZA=0|bC(0|(v=0|bC(0|(_g=0|bC(0|(ng=0|NB(2097151&pI|0,0,2097151&GI|0,0)),0|o(),0|(_g=0|NB(2097151&KI|0,0,2097151&yI|0,0)),0|o())),0|o(),0|Eg,0|v)),0|o(),0|ig,0|ZA)),0|o(),0|cA,0|JA)),0|o(),2097151&vA|0,0),JA=0|o(),cA=0|NB(2097151&P|0,0,2097151&sA|0,0),ZA=0|o(),ig=0|NB(2097151&d|0,0,2097151&SI|0,0),v=0|o(),Eg=0|NB(2097151&b|0,0,2097151&uI|0,0),_g=0|o(),m=0|NB(2097151&gI|0,0,2097151&GI|0,0),ng=0|o(),n=0|NB(2097151&pI|0,0,2097151&yI|0,0),E=0|o(),_=0|NB(2097151&KI|0,0,2097151&CA|0,0),sg=0|o(),I=0|NB(2097151&WA|0,0,2097151&sA|0,0),fI=0|o(),Bg=0|NB(2097151&P|0,0,2097151&SI|0,0),H=0|o(),ag=0|NB(2097151&d|0,0,2097151&uI|0,0),S=0|o(),rg=0|NB(2097151&b|0,0,2097151&GI|0,0),Cg=0|o(),eg=0|NB(2097151&gI|0,0,2097151&yI|0,0),tg=0|o(),FI=0|bC(0|(fI=0|bC(0|(H=0|bC(0|(S=0|bC(0|(Cg=0|bC(0|(tg=0|bC(0|(Qg=0|bC(0|(og=0|NB(2097151&pI|0,0,2097151&CA|0,0)),0|o(),0|(Qg=0|NB(2097151&KI|0,0,2097151&wA|0,0)),0|o())),0|o(),0|eg,0|tg)),0|o(),0|rg,0|Cg)),0|o(),0|ag,0|S)),0|o(),0|Bg,0|H)),0|o(),0|I,0|fI)),0|o(),2097151&FI|0,0),fI=0|o(),I=0|NB(2097151&hA|0,0,2097151&sA|0,0),H=0|o(),Bg=0|NB(2097151&WA|0,0,2097151&SI|0,0),S=0|o(),ag=0|NB(2097151&P|0,0,2097151&uI|0,0),Cg=0|o(),rg=0|NB(2097151&d|0,0,2097151&GI|0,0),tg=0|o(),eg=0|NB(2097151&b|0,0,2097151&yI|0,0),Qg=0|o(),D=0|NB(2097151&gI|0,0,2097151&CA|0,0),og=0|o(),i=0|NB(2097151&pI|0,0,2097151&wA|0,0),c=0|o(),e=0|NB(2097151&KI|0,0,2097151&k|0,0),cg=0|o(),jI=0|NB(2097151&NA|0,0,2097151&sA|0,0),G=0|o(),j=0|NB(2097151&hA|0,0,2097151&SI|0,0),cI=0|o(),qI=0|NB(2097151&WA|0,0,2097151&uI|0,0),XI=0|o(),VI=0|NB(2097151&P|0,0,2097151&GI|0,0),X=0|o(),zI=0|NB(2097151&d|0,0,2097151&yI|0,0),TI=0|o(),OI=0|NB(2097151&b|0,0,2097151&CA|0,0),WI=0|o(),Ag=0|NB(2097151&gI|0,0,2097151&wA|0,0),ZI=0|o(),oI=0|bC(0|(cI=0|bC(0|(G=0|bC(0|(XI=0|bC(0|(X=0|bC(0|(TI=0|bC(0|(WI=0|bC(0|(ZI=0|bC(0|($I=0|bC(0|(Ig=0|NB(2097151&pI|0,0,2097151&k|0,0)),0|o(),0|($I=0|NB(2097151&KI|0,0,2097151&aA|0,0)),0|o())),0|o(),0|Ag,0|ZI)),0|o(),0|OI,0|WI)),0|o(),0|zI,0|TI)),0|o(),0|VI,0|X)),0|o(),0|qI,0|XI)),0|o(),0|jI,0|G)),0|o(),0|j,0|cI)),0|o(),2097151&oI|0,0),cI=0|o(),j=0|NB(2097151&IA|0,0,2097151&sA|0,0),G=0|o(),jI=0|NB(2097151&NA|0,0,2097151&SI|0,0),XI=0|o(),qI=0|NB(2097151&hA|0,0,2097151&uI|0,0),X=0|o(),VI=0|NB(2097151&WA|0,0,2097151&GI|0,0),TI=0|o(),zI=0|NB(2097151&P|0,0,2097151&yI|0,0),WI=0|o(),OI=0|NB(2097151&d|0,0,2097151&CA|0,0),ZI=0|o(),Ag=0|NB(2097151&b|0,0,2097151&wA|0,0),$I=0|o(),u=0|NB(2097151&gI|0,0,2097151&k|0,0),Ig=0|o(),Q=0|NB(2097151&pI|0,0,2097151&aA|0,0),r=0|o(),t=0|NB(2097151&KI|0,0,2097151&T|0,0),gg=0|o(),yA=0|NB(2097151&NI|0,0,2097151&sA|0,0),nA=0|o(),z=0|NB(2097151&IA|0,0,2097151&SI|0,0),W=0|o(),rI=0|NB(2097151&NA|0,0,2097151&uI|0,0),tI=0|o(),MI=0|NB(2097151&hA|0,0,2097151&GI|0,0),UI=0|o(),tA=0|NB(2097151&WA|0,0,2097151&yI|0,0),M=0|o(),mI=0|NB(2097151&P|0,0,2097151&CA|0,0),DI=0|o(),II=0|NB(2097151&d|0,0,2097151&wA|0,0),AI=0|o(),_I=0|NB(2097151&b|0,0,2097151&k|0,0),iI=0|o(),V=0|NB(2097151&gI|0,0,2097151&aA|0,0),C=0|o(),EA=0|bC(0|(nA=0|bC(0|(W=0|bC(0|(UI=0|bC(0|(tI=0|bC(0|(M=0|bC(0|(DI=0|bC(0|(AI=0|bC(0|(iI=0|bC(0|(C=0|bC(0|(LI=0|bC(0|NB(2097151&pI|0,0,2097151&T|0,0),0|(YI=0|o()),0|(LI=0|NB(2097151&KI|0,0,2097151&DA|0,0)),0|o())),0|o(),0|V,0|C)),0|o(),0|_I,0|iI)),0|o(),0|II,0|AI)),0|o(),0|mI,0|DI)),0|o(),0|tA,0|M)),0|o(),0|rI,0|tI)),0|o(),0|MI,0|UI)),0|o(),0|z,0|W)),0|o(),0|yA,0|nA)),0|o(),2097151&EA|0,0),nA=0|o(),sA=0|NB(0|_A,0|iA,2097151&sA|0,0),yA=0|o(),W=0|NB(2097151&NI|0,0,2097151&SI|0,0),z=0|o(),UI=0|NB(2097151&IA|0,0,2097151&uI|0,0),MI=0|o(),tI=0|NB(2097151&NA|0,0,2097151&GI|0,0),rI=0|o(),M=0|NB(2097151&hA|0,0,2097151&yI|0,0),tA=0|o(),DI=0|NB(2097151&WA|0,0,2097151&CA|0,0),mI=0|o(),AI=0|NB(2097151&P|0,0,2097151&wA|0,0),II=0|o(),iI=0|NB(2097151&d|0,0,2097151&k|0,0),_I=0|o(),C=0|NB(2097151&b|0,0,2097151&aA|0,0),V=0|o(),LI=0|NB(2097151&gI|0,0,2097151&T|0,0),YI=0|o(),l=0|NB(2097151&pI|0,0,2097151&DA|0,0),a=0|o(),KI=0|NB(2097151&KI|0,0,0|bA,0|dA),PI=0|o(),SI=0|NB(0|_A,0|iA,2097151&SI|0,0),xI=0|o(),pA=0|NB(2097151&NI|0,0,2097151&uI|0,0),lI=0|o(),JI=0|NB(2097151&IA|0,0,2097151&GI|0,0),R=0|o(),uA=0|NB(2097151&NA|0,0,2097151&yI|0,0),oA=0|o(),eA=0|NB(2097151&hA|0,0,2097151&CA|0,0),vI=0|o(),SA=0|NB(2097151&WA|0,0,2097151&wA|0,0),L=0|o(),mA=0|NB(2097151&P|0,0,2097151&k|0,0),xA=0|o(),nI=0|NB(2097151&d|0,0,2097151&aA|0,0),HA=0|o(),hI=0|NB(2097151&b|0,0,2097151&T|0,0),EI=0|o(),xI=0|bC(0|(lI=0|bC(0|(R=0|bC(0|(vI=0|bC(0|(oA=0|bC(0|(L=0|bC(0|(xA=0|bC(0|(HA=0|bC(0|(EI=0|bC(0|(pI=0|bC(0|(HI=0|NB(2097151&gI|0,0,2097151&DA|0,0)),0|(BI=0|o()),0|(pI=0|NB(2097151&pI|0,0,0|bA,0|dA)),0|o())),0|o(),0|hI,0|EI)),0|o(),0|nI,0|HA)),0|o(),0|mA,0|xA)),0|o(),0|SA,0|L)),0|o(),0|uA,0|oA)),0|o(),0|eA,0|vI)),0|o(),0|JI,0|R)),0|o(),0|pA,0|lI)),0|o(),0|SI,0|xI),SI=0|o(),uI=0|NB(0|_A,0|iA,2097151&uI|0,0),lI=0|o(),pA=0|NB(2097151&NI|0,0,2097151&GI|0,0),R=0|o(),JI=0|NB(2097151&IA|0,0,2097151&yI|0,0),vI=0|o(),eA=0|NB(2097151&NA|0,0,2097151&CA|0,0),oA=0|o(),uA=0|NB(2097151&hA|0,0,2097151&wA|0,0),L=0|o(),SA=0|NB(2097151&WA|0,0,2097151&k|0,0),xA=0|o(),mA=0|NB(2097151&P|0,0,2097151&aA|0,0),HA=0|o(),nI=0|NB(2097151&d|0,0,2097151&T|0,0),EI=0|o(),hI=0|NB(2097151&b|0,0,2097151&DA|0,0),pI=0|o(),gI=0|NB(2097151&gI|0,0,0|bA,0|dA),BI=0|o(),GI=0|NB(0|_A,0|iA,2097151&GI|0,0),HI=0|o(),bI=0|NB(2097151&NI|0,0,2097151&yI|0,0),sI=0|o(),K=0|NB(2097151&IA|0,0,2097151&CA|0,0),dI=0|o(),TA=0|NB(2097151&NA|0,0,2097151&wA|0,0),$=0|o(),J=0|NB(2097151&hA|0,0,2097151&k|0,0),g=0|o(),U=0|NB(2097151&WA|0,0,2097151&aA|0,0),OA=0|o(),lA=0|NB(2097151&P|0,0,2097151&T|0,0),fA=0|o(),HI=0|bC(0|(sI=0|bC(0|(dI=0|bC(0|(g=0|bC(0|($=0|bC(0|(OA=0|bC(0|(fA=0|bC(0|(b=0|bC(0|(RI=0|NB(2097151&d|0,0,2097151&DA|0,0)),0|(Y=0|o()),0|(b=0|NB(2097151&b|0,0,0|bA,0|dA)),0|o())),0|o(),0|lA,0|fA)),0|o(),0|U,0|OA)),0|o(),0|TA,0|$)),0|o(),0|J,0|g)),0|o(),0|K,0|dI)),0|o(),0|bI,0|sI)),0|o(),0|GI,0|HI),GI=0|o(),yI=0|NB(0|_A,0|iA,2097151&yI|0,0),sI=0|o(),bI=0|NB(2097151&NI|0,0,2097151&CA|0,0),dI=0|o(),K=0|NB(2097151&IA|0,0,2097151&wA|0,0),g=0|o(),J=0|NB(2097151&NA|0,0,2097151&k|0,0),$=0|o(),TA=0|NB(2097151&hA|0,0,2097151&aA|0,0),OA=0|o(),U=0|NB(2097151&WA|0,0,2097151&T|0,0),fA=0|o(),lA=0|NB(2097151&P|0,0,2097151&DA|0,0),b=0|o(),d=0|NB(2097151&d|0,0,0|bA,0|dA),Y=0|o(),CA=0|NB(0|_A,0|iA,2097151&CA|0,0),RI=0|o(),aI=0|NB(2097151&NI|0,0,2097151&wA|0,0),gA=0|o(),kA=0|NB(2097151&IA|0,0,2097151&k|0,0),CI=0|o(),q=0|NB(2097151&NA|0,0,2097151&aA|0,0),rA=0|o(),QA=0|NB(2097151&hA|0,0,2097151&T|0,0),FA=0|o(),RI=0|bC(0|(gA=0|bC(0|(CI=0|bC(0|(FA=0|bC(0|(rA=0|bC(0|(P=0|bC(0|(N=0|NB(2097151&WA|0,0,2097151&DA|0,0)),0|(VA=0|o()),0|(P=0|NB(2097151&P|0,0,0|bA,0|dA)),0|o())),0|o(),0|q,0|rA)),0|o(),0|QA,0|FA)),0|o(),0|kA,0|CI)),0|o(),0|aI,0|gA)),0|o(),0|CA,0|RI),CA=0|o(),wA=0|NB(0|_A,0|iA,2097151&wA|0,0),gA=0|o(),aI=0|NB(2097151&NI|0,0,2097151&k|0,0),CI=0|o(),kA=0|NB(2097151&IA|0,0,2097151&aA|0,0),FA=0|o(),QA=0|NB(2097151&NA|0,0,2097151&T|0,0),rA=0|o(),q=0|NB(2097151&hA|0,0,2097151&DA|0,0),P=0|o(),WA=0|NB(2097151&WA|0,0,0|bA,0|dA),VA=0|o(),k=0|NB(0|_A,0|iA,2097151&k|0,0),N=0|o(),qA=0|NB(2097151&NI|0,0,2097151&aA|0,0),AA=0|o(),eI=0|NB(2097151&IA|0,0,2097151&T|0,0),XA=0|o(),RA=0|NB(2097151&NA|0,0,2097151&DA|0,0),QI=0|o(),N=0|bC(0|(AA=0|bC(0|(XA=0|bC(0|(QI=0|bC(0|(hA=0|NB(2097151&hA|0,0,0|bA,0|dA)),0|o(),0|RA,0|QI)),0|o(),0|eI,0|XA)),0|o(),0|qA,0|AA)),0|o(),0|k,0|N),k=0|o(),aA=0|NB(0|_A,0|iA,2097151&aA|0,0),AA=0|o(),qA=0|NB(2097151&NI|0,0,2097151&T|0,0),XA=0|o(),eI=0|NB(2097151&IA|0,0,2097151&DA|0,0),QI=0|o(),NA=0|NB(2097151&NA|0,0,0|bA,0|dA),RA=0|o(),T=0|NB(0|_A,0|iA,2097151&T|0,0),hA=0|o(),hA=0|bC(0|(IA=0|bC(0|NB(2097151&NI|0,0,2097151&DA|0,0),0|(GA=0|o()),0|(IA=0|NB(2097151&IA|0,0,0|bA,0|dA)),0|o())),0|o(),0|T,0|hA),T=0|o(),NI=0|bC(0|(DA=0|NB(0|_A,0|iA,2097151&DA|0,0)),0|(IA=0|o()),0|(NI=0|NB(2097151&NI|0,0,0|bA,0|dA)),0|o()),IA=0|o(),dA=0|NB(0|_A,0|iA,0|bA,0|dA),bA=0|o(),DA=0|CC(0|(iA=0|bC(0|YA,0|LA,1048576,0)),0|(_A=0|o()),21),GA=0|o(),GA=0|bC(0|(BA=0|bC(0|($A=0|bC(0|w,0|f,0|p,0|$A)),0|o(),2097151&BA|0,0)),0|o(),0|DA,0|GA),DA=0|o(),_A=0|FC(0|YA,0|LA,-2097152&iA|0,4095&_A|0),iA=0|o(),BA=0|CC(0|(LA=0|bC(0|KA,0|PA,1048576,0)),0|(YA=0|o()),21),$A=0|o(),$A=0|bC(0|(MA=0|bC(0|(UA=0|bC(0|(Z=0|bC(0|(yg=0|bC(0|h,0|y,0|s,0|yg)),0|o(),0|F,0|Z)),0|o(),0|O,0|UA)),0|o(),2097151&MA|0,0)),0|o(),0|BA,0|$A),BA=0|o(),O=0|KB(0|(MA=0|bC(0|vA,0|JA,1048576,0)),0|(UA=0|o()),21),Z=0|o(),Z=0|bC(0|(zA=0|bC(0|(ZA=0|bC(0|(v=0|bC(0|(_g=0|bC(0|(ng=0|bC(0|(sg=0|bC(0|n,0|E,0|_,0|sg)),0|o(),0|m,0|ng)),0|o(),0|Eg,0|_g)),0|o(),0|ig,0|v)),0|o(),0|cA,0|ZA)),0|o(),2097151&zA|0,0)),0|o(),0|O,0|Z),O=0|o(),cA=0|KB(0|(zA=0|bC(0|FI,0|fI,1048576,0)),0|(ZA=0|o()),21),v=0|o(),v=0|bC(0|(x=0|bC(0|(H=0|bC(0|(S=0|bC(0|(Cg=0|bC(0|(tg=0|bC(0|(Qg=0|bC(0|(og=0|bC(0|(cg=0|bC(0|i,0|c,0|e,0|cg)),0|o(),0|D,0|og)),0|o(),0|eg,0|Qg)),0|o(),0|rg,0|tg)),0|o(),0|ag,0|Cg)),0|o(),0|Bg,0|S)),0|o(),0|I,0|H)),0|o(),2097151&x|0,0)),0|o(),0|cA,0|v),cA=0|o(),I=0|KB(0|(x=0|bC(0|oI,0|cI,1048576,0)),0|(H=0|o()),21),S=0|o(),S=0|bC(0|(jA=0|bC(0|(G=0|bC(0|(X=0|bC(0|(XI=0|bC(0|(TI=0|bC(0|(WI=0|bC(0|(ZI=0|bC(0|($I=0|bC(0|(Ig=0|bC(0|(gg=0|bC(0|Q,0|r,0|t,0|gg)),0|o(),0|u,0|Ig)),0|o(),0|Ag,0|$I)),0|o(),0|OI,0|ZI)),0|o(),0|zI,0|WI)),0|o(),0|VI,0|TI)),0|o(),0|jI,0|XI)),0|o(),0|qI,0|X)),0|o(),0|j,0|G)),0|o(),2097151&jA|0,0)),0|o(),0|I,0|S),I=0|o(),j=0|KB(0|(jA=0|bC(0|EA,0|nA,1048576,0)),0|(G=0|o()),21),X=0|o(),X=0|bC(0|(kI=0|bC(0|(z=0|bC(0|(yA=0|bC(0|(MI=0|bC(0|(tA=0|bC(0|(rI=0|bC(0|(mI=0|bC(0|(II=0|bC(0|(_I=0|bC(0|(V=0|bC(0|(YI=0|bC(0|(PI=0|bC(0|l,0|a,0|KI,0|PI)),0|o(),0|LI,0|YI)),0|o(),0|C,0|V)),0|o(),0|iI,0|_I)),0|o(),0|AI,0|II)),0|o(),0|DI,0|mI)),0|o(),0|tI,0|rI)),0|o(),0|M,0|tA)),0|o(),0|UI,0|MI)),0|o(),0|sA,0|yA)),0|o(),0|W,0|z)),0|o(),0|wI,0|kI)),0|o(),0|j,0|X),j=0|o(),z=0|KB(0|(kI=0|bC(0|xI,0|SI,1048576,0)),0|(wI=0|o()),21),W=0|o(),W=0|bC(0|(lI=0|bC(0|(R=0|bC(0|(vI=0|bC(0|(L=0|bC(0|(oA=0|bC(0|(xA=0|bC(0|(HA=0|bC(0|(EI=0|bC(0|(BI=0|bC(0|hI,0|pI,0|gI,0|BI)),0|o(),0|nI,0|EI)),0|o(),0|mA,0|HA)),0|o(),0|SA,0|xA)),0|o(),0|eA,0|oA)),0|o(),0|uA,0|L)),0|o(),0|JI,0|vI)),0|o(),0|pA,0|R)),0|o(),0|uI,0|lI)),0|o(),0|z,0|W),z=0|o(),R=0|KB(0|(lI=0|bC(0|HI,0|GI,1048576,0)),0|(uI=0|o()),21),pA=0|o(),pA=0|bC(0|(sI=0|bC(0|(dI=0|bC(0|(g=0|bC(0|(OA=0|bC(0|($=0|bC(0|(fA=0|bC(0|(Y=0|bC(0|lA,0|b,0|d,0|Y)),0|o(),0|U,0|fA)),0|o(),0|J,0|$)),0|o(),0|TA,0|OA)),0|o(),0|K,0|g)),0|o(),0|bI,0|dI)),0|o(),0|yI,0|sI)),0|o(),0|R,0|pA),R=0|o(),dI=0|KB(0|(sI=0|bC(0|RI,0|CA,1048576,0)),0|(yI=0|o()),21),bI=0|o(),bI=0|bC(0|(gA=0|bC(0|(CI=0|bC(0|(FA=0|bC(0|(P=0|bC(0|(VA=0|bC(0|QA,0|rA,0|WA,0|VA)),0|o(),0|q,0|P)),0|o(),0|kA,0|FA)),0|o(),0|aI,0|CI)),0|o(),0|wA,0|gA)),0|o(),0|dI,0|bI),dI=0|o(),CI=0|KB(0|(gA=0|bC(0|N,0|k,1048576,0)),0|(wA=0|o()),21),aI=0|o(),aI=0|bC(0|(AA=0|bC(0|(XA=0|bC(0|(RA=0|bC(0|eI,0|QI,0|NA,0|RA)),0|o(),0|qA,0|XA)),0|o(),0|aA,0|AA)),0|o(),0|CI,0|aI),CI=0|o(),wA=0|FC(0|N,0|k,-2097152&gA|0,0|wA),gA=0|o(),AA=0|bC(0|NI,0|IA,0|(AA=0|KB(0|(k=0|bC(0|hA,0|T,1048576,0)),0|(N=0|o()),21)),0|o()),IA=0|o(),N=0|FC(0|hA,0|T,-2097152&k|0,0|N),k=0|o(),NI=0|KB(0|(T=0|bC(0|dA,0|bA,1048576,0)),0|(hA=0|o()),21),aA=0|o(),hA=0|FC(0|dA,0|bA,-2097152&T|0,0|hA),T=0|o(),XA=0|CC(0|(bA=0|bC(0|GA,0|DA,1048576,0)),0|(dA=0|o()),21),qA=0|o(),dA=0|FC(0|GA,0|DA,-2097152&bA|0,0|dA),bA=0|o(),RA=0|KB(0|(DA=0|bC(0|$A,0|BA,1048576,0)),0|(GA=0|o()),21),NA=0|o(),GA=0|FC(0|$A,0|BA,-2097152&DA|0,0|GA),DA=0|o(),QI=0|KB(0|(BA=0|bC(0|Z,0|O,1048576,0)),0|($A=0|o()),21),eI=0|o(),$A=0|FC(0|Z,0|O,-2097152&BA|0,0|$A),BA=0|o(),FA=0|KB(0|(O=0|bC(0|v,0|cA,1048576,0)),0|(Z=0|o()),21),kA=0|o(),VA=0|KB(0|(P=0|bC(0|S,0|I,1048576,0)),0|(q=0|o()),21),WA=0|o(),g=0|KB(0|(rA=0|bC(0|X,0|j,1048576,0)),0|(QA=0|o()),21),K=0|o(),$=0|KB(0|(OA=0|bC(0|W,0|z,1048576,0)),0|(TA=0|o()),21),J=0|o(),Y=0|KB(0|(fA=0|bC(0|pA,0|R,1048576,0)),0|(U=0|o()),21),d=0|o(),gA=0|bC(0|(vI=0|KB(0|(b=0|bC(0|bI,0|dI,1048576,0)),0|(lA=0|o()),21)),0|o(),0|wA,0|gA),wA=0|o(),lA=0|FC(0|bI,0|dI,-2097152&b|0,0|lA),b=0|o(),k=0|bC(0|(vI=0|KB(0|(dI=0|bC(0|aI,0|CI,1048576,0)),0|(bI=0|o()),21)),0|o(),0|N,0|k),N=0|o(),bI=0|FC(0|aI,0|CI,-2097152&dI|0,0|bI),dI=0|o(),T=0|bC(0|(vI=0|KB(0|(CI=0|bC(0|AA,0|IA,1048576,0)),0|(aI=0|o()),21)),0|o(),0|hA,0|T),hA=0|o(),aI=0|FC(0|AA,0|IA,-2097152&CI|0,0|aI),CI=0|o(),IA=0|NB(0|NI,0|aA,666643,0),AA=0|o(),vI=0|NB(0|NI,0|aA,470296,0),JI=0|o(),L=0|NB(0|NI,0|aA,654183,0),uA=0|o(),oA=0|NB(0|NI,0|aA,-997805,-1),eA=0|o(),xA=0|NB(0|NI,0|aA,136657,0),SA=0|o(),d=0|bC(0|(yI=0|FC(0|(aA=0|bC(0|RI,0|CA,0|(aA=0|NB(0|NI,0|aA,-683901,-1)),0|o())),0|o(),-2097152&sI|0,0|yI)),0|o(),0|Y,0|d),Y=0|o(),yI=0|NB(0|T,0|hA,666643,0),sI=0|o(),aA=0|NB(0|T,0|hA,470296,0),CA=0|o(),RI=0|NB(0|T,0|hA,654183,0),NI=0|o(),HA=0|NB(0|T,0|hA,-997805,-1),mA=0|o(),EI=0|NB(0|T,0|hA,136657,0),nI=0|o(),hA=0|NB(0|T,0|hA,-683901,-1),T=0|o(),BI=0|NB(0|aI,0|CI,666643,0),gI=0|o(),pI=0|NB(0|aI,0|CI,470296,0),hI=0|o(),yA=0|NB(0|aI,0|CI,654183,0),sA=0|o(),MI=0|NB(0|aI,0|CI,-997805,-1),UI=0|o(),tA=0|NB(0|aI,0|CI,136657,0),M=0|o(),CI=0|NB(0|aI,0|CI,-683901,-1),aI=0|o(),J=0|bC(0|(uI=0|FC(0|(aI=0|bC(0|(nI=0|bC(0|(eA=0|bC(0|HI,0|GI,0|oA,0|eA)),0|o(),0|EI,0|nI)),0|o(),0|CI,0|aI)),0|o(),-2097152&lI|0,0|uI)),0|o(),0|$,0|J),$=0|o(),uI=0|NB(0|k,0|N,666643,0),lI=0|o(),aI=0|NB(0|k,0|N,470296,0),CI=0|o(),nI=0|NB(0|k,0|N,654183,0),EI=0|o(),eA=0|NB(0|k,0|N,-997805,-1),oA=0|o(),GI=0|NB(0|k,0|N,136657,0),HI=0|o(),N=0|NB(0|k,0|N,-683901,-1),k=0|o(),rI=0|NB(0|bI,0|dI,666643,0),tI=0|o(),mI=0|NB(0|bI,0|dI,470296,0),DI=0|o(),II=0|NB(0|bI,0|dI,654183,0),AI=0|o(),_I=0|NB(0|bI,0|dI,-997805,-1),iI=0|o(),V=0|NB(0|bI,0|dI,136657,0),C=0|o(),dI=0|NB(0|bI,0|dI,-683901,-1),bI=0|o(),K=0|bC(0|(wI=0|FC(0|(bI=0|bC(0|(HI=0|bC(0|(SI=0|bC(0|(UI=0|bC(0|(JI=0|bC(0|RI,0|NI,0|vI,0|JI)),0|o(),0|MI,0|UI)),0|o(),0|xI,0|SI)),0|o(),0|GI,0|HI)),0|o(),0|dI,0|bI)),0|o(),-2097152&kI|0,0|wI)),0|o(),0|g,0|K),g=0|o(),ZA=0|FC(0|(eI=0|bC(0|(wI=0|bC(0|FI,0|fI,0|(wI=0|NB(0|gA,0|wA,666643,0)),0|o())),0|o(),0|QI,0|eI)),0|o(),-2097152&zA|0,0|ZA),zA=0|o(),eI=0|NB(0|gA,0|wA,470296,0),QI=0|o(),wI=0|NB(0|gA,0|wA,654183,0),fI=0|o(),kA=0|bC(0|(H=0|FC(0|(cI=0|bC(0|(fI=0|bC(0|(lI=0|bC(0|mI,0|DI,0|uI,0|lI)),0|o(),0|wI,0|fI)),0|o(),0|oI,0|cI)),0|o(),-2097152&x|0,0|H)),0|o(),0|FA,0|kA),FA=0|o(),H=0|NB(0|gA,0|wA,-997805,-1),x=0|o(),cI=0|NB(0|gA,0|wA,136657,0),oI=0|o(),G=0|FC(0|(WA=0|bC(0|(nA=0|bC(0|(oI=0|bC(0|(iI=0|bC(0|(EI=0|bC(0|(sI=0|bC(0|pI,0|hI,0|yI,0|sI)),0|o(),0|nI,0|EI)),0|o(),0|_I,0|iI)),0|o(),0|cI,0|oI)),0|o(),0|EA,0|nA)),0|o(),0|VA,0|WA)),0|o(),-2097152&jA|0,0|G),jA=0|o(),wA=0|NB(0|gA,0|wA,-683901,-1),gA=0|o(),nA=0|KB(0|(WA=0|bC(0|ZA,0|zA,1048576,0)),0|(VA=0|o()),21),EA=0|o(),EA=0|bC(0|(Z=0|FC(0|(cA=0|bC(0|(tI=0|bC(0|eI,0|QI,0|rI,0|tI)),0|o(),0|v,0|cA)),0|o(),-2097152&O|0,0|Z)),0|o(),0|nA,0|EA),nA=0|o(),cA=0|KB(0|(Z=0|bC(0|kA,0|FA,1048576,0)),0|(O=0|o()),21),v=0|o(),v=0|bC(0|(q=0|FC(0|(I=0|bC(0|(x=0|bC(0|(AI=0|bC(0|(gI=0|bC(0|aI,0|CI,0|BI,0|gI)),0|o(),0|II,0|AI)),0|o(),0|H,0|x)),0|o(),0|S,0|I)),0|o(),-2097152&P|0,0|q)),0|o(),0|cA,0|v),cA=0|o(),I=0|KB(0|(q=0|bC(0|G,0|jA,1048576,0)),0|(P=0|o()),21),S=0|o(),S=0|bC(0|(QA=0|FC(0|(j=0|bC(0|(gA=0|bC(0|(C=0|bC(0|(oA=0|bC(0|(sA=0|bC(0|(AA=0|bC(0|aA,0|CA,0|IA,0|AA)),0|o(),0|yA,0|sA)),0|o(),0|eA,0|oA)),0|o(),0|V,0|C)),0|o(),0|wA,0|gA)),0|o(),0|X,0|j)),0|o(),-2097152&rA|0,0|QA)),0|o(),0|I,0|S),I=0|o(),j=0|KB(0|(QA=0|bC(0|K,0|g,1048576,0)),0|(rA=0|o()),21),X=0|o(),X=0|bC(0|(TA=0|FC(0|(z=0|bC(0|(k=0|bC(0|(M=0|bC(0|(uA=0|bC(0|HA,0|mA,0|L,0|uA)),0|o(),0|tA,0|M)),0|o(),0|N,0|k)),0|o(),0|W,0|z)),0|o(),-2097152&OA|0,0|TA)),0|o(),0|j,0|X),j=0|o(),rA=0|FC(0|K,0|g,-2097152&QA|0,0|rA),QA=0|o(),TA=0|KB(0|(g=0|bC(0|J,0|$,1048576,0)),0|(K=0|o()),21),OA=0|o(),OA=0|bC(0|(U=0|FC(0|(R=0|bC(0|(SA=0|bC(0|hA,0|T,0|xA,0|SA)),0|o(),0|pA,0|R)),0|o(),-2097152&fA|0,0|U)),0|o(),0|TA,0|OA),TA=0|o(),K=0|FC(0|J,0|$,-2097152&g|0,0|K),g=0|o(),b=0|bC(0|(U=0|KB(0|($=0|bC(0|d,0|Y,1048576,0)),0|(J=0|o()),21)),0|o(),0|lA,0|b),lA=0|o(),J=0|FC(0|d,0|Y,-2097152&$|0,0|J),$=0|o(),U=0|KB(0|(Y=0|bC(0|EA,0|nA,1048576,0)),0|(d=0|o()),21),fA=0|o(),SA=0|KB(0|(R=0|bC(0|v,0|cA,1048576,0)),0|(pA=0|o()),21),xA=0|o(),QA=0|bC(0|(z=0|KB(0|(T=0|bC(0|S,0|I,1048576,0)),0|(hA=0|o()),21)),0|o(),0|rA,0|QA),rA=0|o(),hA=0|FC(0|S,0|I,-2097152&T|0,0|hA),T=0|o(),g=0|bC(0|(z=0|KB(0|(I=0|bC(0|X,0|j,1048576,0)),0|(S=0|o()),21)),0|o(),0|K,0|g),K=0|o(),S=0|FC(0|X,0|j,-2097152&I|0,0|S),I=0|o(),$=0|bC(0|(z=0|KB(0|(j=0|bC(0|OA,0|TA,1048576,0)),0|(X=0|o()),21)),0|o(),0|J,0|$),J=0|o(),X=0|FC(0|OA,0|TA,-2097152&j|0,0|X),j=0|o(),TA=0|bC(0|$A,0|BA,0|(TA=0|NB(0|b,0|lA,666643,0)),0|o()),BA=0|o(),$A=0|NB(0|b,0|lA,470296,0),OA=0|o(),z=0|NB(0|b,0|lA,654183,0),W=0|o(),k=0|NB(0|b,0|lA,-997805,-1),N=0|o(),M=0|NB(0|b,0|lA,136657,0),tA=0|o(),P=0|FC(0|(xA=0|bC(0|(lA=0|bC(0|G,0|jA,0|(lA=0|NB(0|b,0|lA,-683901,-1)),0|o())),0|o(),0|SA,0|xA)),0|o(),-2097152&q|0,0|P),q=0|o(),xA=0|NB(0|$,0|J,666643,0),SA=0|o(),lA=0|bC(0|TA,0|BA,0|(lA=0|NB(0|$,0|J,470296,0)),0|o()),BA=0|o(),TA=0|NB(0|$,0|J,654183,0),jA=0|o(),G=0|NB(0|$,0|J,-997805,-1),b=0|o(),uA=0|NB(0|$,0|J,136657,0),L=0|o(),J=0|NB(0|$,0|J,-683901,-1),$=0|o(),mA=0|bC(0|GA,0|DA,0|(mA=0|NB(0|X,0|j,666643,0)),0|o()),DA=0|o(),GA=0|NB(0|X,0|j,470296,0),HA=0|o(),gA=0|bC(0|lA,0|BA,0|(gA=0|NB(0|X,0|j,654183,0)),0|o()),BA=0|o(),lA=0|NB(0|X,0|j,-997805,-1),wA=0|o(),C=0|NB(0|X,0|j,136657,0),V=0|o(),j=0|NB(0|X,0|j,-683901,-1),X=0|o(),X=0|bC(0|(L=0|bC(0|(O=0|FC(0|(fA=0|bC(0|(N=0|bC(0|kA,0|FA,0|k,0|N)),0|o(),0|U,0|fA)),0|o(),-2097152&Z|0,0|O)),0|o(),0|uA,0|L)),0|o(),0|j,0|X),j=0|o(),L=0|NB(0|g,0|K,666643,0),uA=0|o(),O=0|NB(0|g,0|K,470296,0),Z=0|o(),fA=0|NB(0|g,0|K,654183,0),U=0|o(),N=0|NB(0|g,0|K,-997805,-1),k=0|o(),FA=0|NB(0|g,0|K,136657,0),kA=0|o(),K=0|NB(0|g,0|K,-683901,-1),g=0|o(),oA=0|NB(0|S,0|I,666643,0),eA=0|o(),sA=0|NB(0|S,0|I,470296,0),yA=0|o(),AA=0|NB(0|S,0|I,654183,0),IA=0|o(),CA=0|NB(0|S,0|I,-997805,-1),aA=0|o(),x=0|NB(0|S,0|I,136657,0),H=0|o(),I=0|NB(0|S,0|I,-683901,-1),S=0|o(),S=0|bC(0|(kA=0|bC(0|(wA=0|bC(0|(jA=0|bC(0|(VA=0|FC(0|(zA=0|bC(0|$A,0|OA,0|ZA,0|zA)),0|o(),-2097152&WA|0,0|VA)),0|o(),0|TA,0|jA)),0|o(),0|lA,0|wA)),0|o(),0|FA,0|kA)),0|o(),0|I,0|S),I=0|o(),iA=0|bC(0|(kA=0|NB(0|QA,0|rA,666643,0)),0|o(),0|_A,0|iA),_A=0|o(),kA=0|NB(0|QA,0|rA,470296,0),FA=0|o(),wA=0|NB(0|QA,0|rA,654183,0),lA=0|o(),yA=0|bC(0|(uA=0|bC(0|(lA=0|bC(0|(YA=0|FC(0|(PA=0|bC(0|XA,0|qA,0|KA,0|PA)),0|o(),-2097152&LA|0,0|YA)),0|o(),0|wA,0|lA)),0|o(),0|L,0|uA)),0|o(),0|sA,0|yA),sA=0|o(),uA=0|NB(0|QA,0|rA,-997805,-1),L=0|o(),lA=0|NB(0|QA,0|rA,136657,0),wA=0|o(),aA=0|bC(0|(U=0|bC(0|(wA=0|bC(0|(HA=0|bC(0|(SA=0|bC(0|(UA=0|FC(0|(JA=0|bC(0|RA,0|NA,0|vA,0|JA)),0|o(),-2097152&MA|0,0|UA)),0|o(),0|xA,0|SA)),0|o(),0|GA,0|HA)),0|o(),0|lA,0|wA)),0|o(),0|fA,0|U)),0|o(),0|CA,0|aA),CA=0|o(),rA=0|NB(0|QA,0|rA,-683901,-1),QA=0|o(),wA=0|KB(0|(U=0|bC(0|iA,0|_A,1048576,0)),0|(fA=0|o()),21),lA=0|o(),lA=0|bC(0|(eA=0|bC(0|(FA=0|bC(0|dA,0|bA,0|kA,0|FA)),0|o(),0|oA,0|eA)),0|o(),0|wA,0|lA),wA=0|o(),fA=0|FC(0|iA,0|_A,-2097152&U|0,0|fA),U=0|o(),eA=0|KB(0|(_A=0|bC(0|yA,0|sA,1048576,0)),0|(iA=0|o()),21),oA=0|o(),oA=0|bC(0|(IA=0|bC(0|(Z=0|bC(0|(L=0|bC(0|mA,0|DA,0|uA,0|L)),0|o(),0|O,0|Z)),0|o(),0|AA,0|IA)),0|o(),0|eA,0|oA),eA=0|o(),Z=0|KB(0|(IA=0|bC(0|aA,0|CA,1048576,0)),0|(AA=0|o()),21),O=0|o(),O=0|bC(0|(H=0|bC(0|(k=0|bC(0|(QA=0|bC(0|gA,0|BA,0|rA,0|QA)),0|o(),0|N,0|k)),0|o(),0|x,0|H)),0|o(),0|Z,0|O),Z=0|o(),k=0|KB(0|(H=0|bC(0|S,0|I,1048576,0)),0|(x=0|o()),21),N=0|o(),N=0|bC(0|(g=0|bC(0|(V=0|bC(0|(b=0|bC(0|(d=0|FC(0|(W=0|bC(0|EA,0|nA,0|z,0|W)),0|o(),-2097152&Y|0,0|d)),0|o(),0|G,0|b)),0|o(),0|C,0|V)),0|o(),0|K,0|g)),0|o(),0|k,0|N),k=0|o(),x=0|FC(0|S,0|I,-2097152&H|0,0|x),H=0|o(),g=0|KB(0|(I=0|bC(0|X,0|j,1048576,0)),0|(S=0|o()),21),K=0|o(),K=0|bC(0|(pA=0|FC(0|(cA=0|bC(0|(tA=0|bC(0|J,0|$,0|M,0|tA)),0|o(),0|v,0|cA)),0|o(),-2097152&R|0,0|pA)),0|o(),0|g,0|K),g=0|o(),S=0|FC(0|X,0|j,-2097152&I|0,0|S),I=0|o(),pA=0|bC(0|hA,0|T,0|(pA=0|KB(0|(j=0|bC(0|P,0|q,1048576,0)),0|(X=0|o()),21)),0|o()),T=0|o(),cA=0|KB(0|(hA=0|bC(0|lA,0|wA,1048576,0)),0|(R=0|o()),21),v=0|o(),$=0|KB(0|(tA=0|bC(0|oA,0|eA,1048576,0)),0|(M=0|o()),21),J=0|o(),b=0|bC(0|x,0|H,0|(b=0|KB(0|(V=0|bC(0|O,0|Z,1048576,0)),0|(C=0|o()),21)),0|o()),H=0|o(),d=0|bC(0|S,0|I,0|(d=0|KB(0|(x=0|bC(0|N,0|k,1048576,0)),0|(G=0|o()),21)),0|o()),I=0|o(),G=0|FC(0|N,0|k,-2097152&x|0,0|G),x=0|o(),S=0|KB(0|(k=0|bC(0|K,0|g,1048576,0)),0|(N=0|o()),21),Y=0|o(),N=0|FC(0|K,0|g,-2097152&k|0,0|N),k=0|o(),W=0|KB(0|(g=0|bC(0|pA,0|T,1048576,0)),0|(K=0|o()),21),z=0|o(),K=0|FC(0|pA,0|T,-2097152&g|0,0|K),g=0|o(),T=0|bC(0|fA,0|U,0|(T=0|NB(0|W,0|z,666643,0)),0|o()),U=0|o(),fA=0|NB(0|W,0|z,470296,0),pA=0|o(),nA=0|NB(0|W,0|z,654183,0),EA=0|o(),QA=0|NB(0|W,0|z,-997805,-1),rA=0|o(),BA=0|NB(0|W,0|z,136657,0),gA=0|o(),z=0|NB(0|W,0|z,-683901,-1),W=0|o(),U=0|KB(0|T,0|U,21),L=0|o(),U=0|KB(0|(L=0|bC(0|(R=0|FC(0|(pA=0|bC(0|lA,0|wA,0|fA,0|pA)),0|o(),-2097152&hA|0,0|R)),0|o(),0|U,0|L)),0|o(),21),R=0|o(),U=0|KB(0|(R=0|bC(0|(v=0|bC(0|(iA=0|FC(0|(EA=0|bC(0|yA,0|sA,0|nA,0|EA)),0|o(),-2097152&_A|0,0|iA)),0|o(),0|cA,0|v)),0|o(),0|U,0|R)),0|o(),21),v=0|o(),U=0|KB(0|(v=0|bC(0|(M=0|FC(0|(rA=0|bC(0|oA,0|eA,0|QA,0|rA)),0|o(),-2097152&tA|0,0|M)),0|o(),0|U,0|v)),0|o(),21),M=0|o(),U=0|KB(0|(M=0|bC(0|(J=0|bC(0|(AA=0|FC(0|(gA=0|bC(0|aA,0|CA,0|BA,0|gA)),0|o(),-2097152&IA|0,0|AA)),0|o(),0|$,0|J)),0|o(),0|U,0|M)),0|o(),21),J=0|o(),N=0|KB(0|(k=0|bC(0|(I=0|KB(0|(G=0|bC(0|d,0|I,0|(G=0|KB(0|(x=0|bC(0|(H=0|KB(0|(U=0|bC(0|b,0|H,0|(U=0|KB(0|(J=0|bC(0|(C=0|FC(0|(W=0|bC(0|O,0|Z,0|z,0|W)),0|o(),-2097152&V|0,0|C)),0|o(),0|U,0|J)),0|o(),21)),0|o())),0|o(),21)),0|o(),0|G,0|x)),0|o(),21)),0|o())),0|o(),21)),0|o(),0|N,0|k)),0|o(),21),I=0|o(),T=0|bC(0|(X=0|NB(0|(K=0|KB(0|(g=0|bC(0|(N=0|KB(0|(I=0|bC(0|(X=0|FC(0|(q=0|bC(0|S,0|Y,0|P,0|q)),0|o(),-2097152&j|0,0|X)),0|o(),0|N,0|I)),0|o(),21)),0|o(),0|K,0|g)),0|o(),21)),0|(N=0|o()),666643,0)),0|o(),2097151&T|0,0),X=0|o(),L=0|bC(0|(j=0|NB(0|K,0|N,470296,0)),0|o(),2097151&L|0,0),j=0|o(),R=0|bC(0|(q=0|NB(0|K,0|N,654183,0)),0|o(),2097151&R|0,0),q=0|o(),v=0|bC(0|(P=0|NB(0|K,0|N,-997805,-1)),0|o(),2097151&v|0,0),P=0|o(),M=0|bC(0|(Y=0|NB(0|K,0|N,136657,0)),0|o(),2097151&M|0,0),Y=0|o(),g=0|bC(0|(C=0|KB(0|(I=0|bC(0|(b=0|KB(0|(k=0|bC(0|(H=0|KB(0|(G=0|bC(0|(d=0|KB(0|(x=0|bC(0|(S=0|KB(0|(U=0|bC(0|(J=0|KB(0|(M=0|bC(0|(J=0|bC(0|(N=0|NB(0|K,0|N,-683901,-1)),0|o(),2097151&J|0,0)),0|(N=0|o()),0|(M=0|KB(0|(v=0|bC(0|M,0|Y,0|(v=0|KB(0|(R=0|bC(0|v,0|P,0|(R=0|KB(0|(L=0|bC(0|R,0|q,0|(L=0|KB(0|(K=0|bC(0|L,0|j,0|(K=0|KB(0|T,0|X,21)),0|o())),0|(j=0|o()),21)),0|o())),0|(q=0|o()),21)),0|o())),0|(P=0|o()),21)),0|o())),0|(Y=0|o()),21)),0|o())),0|(N=0|o()),21)),0|o(),2097151&U|0,0)),0|(J=0|o()),21)),0|o(),2097151&x|0,0)),0|(S=0|o()),21)),0|o(),2097151&G|0,0)),0|(d=0|o()),21)),0|o(),2097151&k|0,0)),0|(H=0|o()),21)),0|o(),2097151&I|0,0)),0|(b=0|o()),21)),0|o(),2097151&g|0,0),C=0|o(),B[A>>0]=T,V=0|CC(0|T,0|X,8),o(),B[A+1>>0]=V,X=0|CC(0|T,0|X,16),o(),T=0|$B(2097151&K|0,0,5),o(),B[A+2>>0]=T|31&X,X=0|CC(0|K,0|j,3),o(),B[A+3>>0]=X,j=0|CC(0|K,0|j,11),o(),B[A+4>>0]=j,K=0|CC(2097151&K|0,0,19),j=0|o(),X=0|$B(2097151&L|0,0,2),o(),B[A+5>>0]=X|K,q=0|CC(0|L,0|q,6),o(),B[A+6>>0]=q,L=0|CC(2097151&L|0,0,14),q=0|o(),K=0|$B(2097151&R|0,0,7),o(),B[A+7>>0]=K|L,L=0|CC(0|R,0|P,1),o(),B[A+8>>0]=L,P=0|CC(0|R,0|P,9),o(),B[A+9>>0]=P,R=0|CC(2097151&R|0,0,17),P=0|o(),L=0|$B(2097151&v|0,0,4),o(),B[A+10>>0]=L|R,R=0|CC(0|v,0|Y,4),o(),B[A+11>>0]=R,Y=0|CC(0|v,0|Y,12),o(),B[A+12>>0]=Y,v=0|CC(2097151&v|0,0,20),Y=0|o(),R=0|$B(2097151&M|0,0,1),o(),B[A+13>>0]=R|v,N=0|CC(0|M,0|N,7),o(),B[A+14>>0]=N,M=0|CC(2097151&M|0,0,15),N=0|o(),v=0|$B(2097151&U|0,0,6),o(),B[A+15>>0]=v|M,M=0|CC(0|U,0|J,2),o(),B[A+16>>0]=M,J=0|CC(0|U,0|J,10),o(),B[A+17>>0]=J,U=0|CC(2097151&U|0,0,18),J=0|o(),M=0|$B(0|x,0|S,3),o(),B[A+18>>0]=M|U,U=0|CC(0|x,0|S,5),o(),B[A+19>>0]=U,S=0|CC(0|x,0|S,13),o(),B[A+20>>0]=S,B[A+21>>0]=G,S=0|CC(0|G,0|d,8),o(),B[A+22>>0]=S,d=0|CC(0|G,0|d,16),o(),G=0|$B(2097151&k|0,0,5),o(),B[A+23>>0]=G|31&d,d=0|CC(0|k,0|H,3),o(),B[A+24>>0]=d,H=0|CC(0|k,0|H,11),o(),B[A+25>>0]=H,k=0|CC(2097151&k|0,0,19),H=0|o(),d=0|$B(2097151&I|0,0,2),o(),B[A+26>>0]=d|k,b=0|CC(0|I,0|b,6),o(),B[A+27>>0]=b,I=0|CC(2097151&I|0,0,14),b=0|o(),k=0|$B(0|g,0|C,7),o(),B[A+28>>0]=k|I,I=0|CC(0|g,0|C,1),o(),B[A+29>>0]=I,I=0|CC(0|g,0|C,9),o(),B[A+30>>0]=I,C=0|KB(0|g,0|C,17),o(),B[A+31>>0]=C}function w(A,I,g){A|=0,g|=0;var C,a,t,r,Q,e,c,i,_,E,n,s,y,h,p,f,w,l,u=0,D=0,m=0,F=0,k=0,b=0,d=0,H=0,G=0,S=0,x=0,U=0,M=0,J=0,v=0,N=0,R=0,Y=0,L=0,P=0,K=0,q=0,X=0,j=0,T=0,V=0,W=0,z=0,Z=0,O=0,$=0,AA=0,IA=0,gA=0,BA=0,CA=0,aA=0,tA=0,rA=0,QA=0,eA=0,oA=0,cA=0,iA=0,_A=0,EA=0,nA=0,sA=0,yA=0,hA=0,pA=0,fA=0,wA=0,lA=0,uA=0,DA=0,mA=0,FA=0,kA=0,bA=0,dA=0,HA=0,GA=0,SA=0,xA=0,UA=0,MA=0,JA=0,vA=0,NA=0,RA=0,YA=0,LA=0,PA=0,KA=0,qA=0,XA=0,jA=0,TA=0,VA=0,WA=0,zA=0,ZA=0,OA=0,$A=0,AI=0,II=0,gI=0,BI=0,CI=0,aI=0,tI=0,rI=0,QI=0,eI=0,oI=0,cI=0,iI=0,_I=0,EI=0,nI=0,sI=0,yI=0,hI=0,pI=0,fI=0,wI=0,lI=0,uI=0,DI=0,mI=0,FI=0,kI=0,bI=0,dI=0,HI=0,GI=0,SI=0,xI=0,UI=0,MI=0,JI=0,vI=0,NI=0,RI=0,YI=0,LI=0,PI=0,KI=0,qI=0,XI=0,jI=0,TI=0,VI=0,WI=0,zI=0,ZI=0,OI=0,$I=0,Ag=0,Ig=0,gg=0,Bg=0,Cg=0,ag=0,tg=0,rg=0,Qg=0;M=0|JB(0|B[(I|=0)>>0],0|B[I+1>>0],0|B[I+2>>0]),o(),yI=0|CC(0|(yI=0|dg(I+2|0)),0|o(),5),o(),jA=0|CC(0|(jA=0|JB(0|B[I+5>>0],0|B[I+6>>0],0|B[I+7>>0])),0|o(),2),o(),J=0|CC(0|(J=0|dg(I+7|0)),0|o(),7),o(),QI=0|CC(0|(QI=0|dg(I+10|0)),0|o(),4),o(),KA=0|CC(0|(KA=0|JB(0|B[I+13>>0],0|B[I+14>>0],0|B[I+15>>0])),0|o(),1),o(),d=0|CC(0|(d=0|dg(I+15|0)),0|o(),6),o(),EA=0|CC(0|(EA=0|JB(0|B[I+18>>0],0|B[I+19>>0],0|B[I+20>>0])),0|o(),3),o(),qA=0|JB(0|B[I+21>>0],0|B[I+22>>0],0|B[I+23>>0]),o(),Z=0|CC(0|(Z=0|dg(I+23|0)),0|o(),5),o(),AA=0|CC(0|(AA=0|JB(0|B[I+26>>0],0|B[I+27>>0],0|B[I+28>>0])),0|o(),2),o(),QA=0|CC(0|(QA=0|dg(I+28|0)),0|o(),7),rA=0|o(),MI=0|JB(0|B[g>>0],0|B[g+1>>0],0|B[g+2>>0]),o(),fI=0|CC(0|(fI=0|dg(g+2|0)),0|o(),5),o(),RA=0|CC(0|(RA=0|JB(0|B[g+5>>0],0|B[g+6>>0],0|B[g+7>>0])),0|o(),2),o(),HA=0|CC(0|(HA=0|dg(g+7|0)),0|o(),7),o(),wI=0|CC(0|(wI=0|dg(g+10|0)),0|o(),4),o(),S=0|CC(0|(S=0|JB(0|B[g+13>>0],0|B[g+14>>0],0|B[g+15>>0])),0|o(),1),o(),Y=0|CC(0|(Y=0|dg(g+15|0)),0|o(),6),o(),O=0|CC(0|(O=0|JB(0|B[g+18>>0],0|B[g+19>>0],0|B[g+20>>0])),0|o(),3),o(),pA=0|JB(0|B[g+21>>0],0|B[g+22>>0],0|B[g+23>>0]),o(),PA=0|CC(0|(PA=0|dg(g+23|0)),0|o(),5),o(),uI=0|CC(0|(uI=0|JB(0|B[g+26>>0],0|B[g+27>>0],0|B[g+28>>0])),0|o(),2),o(),tA=0|CC(0|(tA=0|dg(g+28|0)),0|o(),7),aA=0|o(),wA=0|NB(2097151&MI|0,0,2097151&M|0,0),lA=0|o(),j=0|bC(0|(uA=0|NB(2097151&fI|0,0,2097151&M|0,0)),0|(v=0|o()),0|(j=0|NB(2097151&MI|0,0,2097151&yI|0,0)),0|o()),v=0|o(),uA=0|NB(2097151&RA|0,0,2097151&M|0,0),DA=0|o(),DA=0|bC(0|(N=0|bC(0|(L=0|NB(2097151&fI|0,0,2097151&yI|0,0)),0|(sA=0|o()),0|(N=0|NB(2097151&MI|0,0,2097151&jA|0,0)),0|o())),0|o(),0|uA,0|DA),uA=0|o(),N=0|NB(2097151&HA|0,0,2097151&M|0,0),sA=0|o(),L=0|NB(2097151&RA|0,0,2097151&yI|0,0),I=0|o(),h=0|NB(2097151&fI|0,0,2097151&jA|0,0),y=0|o(),s=0|NB(2097151&MI|0,0,2097151&J|0,0),Qg=0|o(),yA=0|NB(2097151&wI|0,0,2097151&M|0,0),hA=0|o(),P=0|NB(2097151&HA|0,0,2097151&yI|0,0),q=0|o(),zA=0|NB(2097151&RA|0,0,2097151&jA|0,0),WA=0|o(),hA=0|bC(0|(q=0|bC(0|(WA=0|bC(0|(ag=0|bC(0|NB(2097151&fI|0,0,2097151&J|0,0),0|(Cg=0|o()),0|(ag=0|NB(2097151&MI|0,0,2097151&QI|0,0)),0|o())),0|o(),0|zA,0|WA)),0|o(),0|P,0|q)),0|o(),0|yA,0|hA),yA=0|o(),q=0|NB(2097151&S|0,0,2097151&M|0,0),P=0|o(),WA=0|NB(2097151&wI|0,0,2097151&yI|0,0),zA=0|o(),ag=0|NB(2097151&HA|0,0,2097151&jA|0,0),Cg=0|o(),l=0|NB(2097151&RA|0,0,2097151&J|0,0),tg=0|o(),n=0|NB(2097151&fI|0,0,2097151&QI|0,0),E=0|o(),_=0|NB(2097151&MI|0,0,2097151&KA|0,0),rg=0|o(),eA=0|NB(2097151&Y|0,0,2097151&M|0,0),g=0|o(),cA=0|NB(2097151&S|0,0,2097151&yI|0,0),CI=0|o(),ZA=0|NB(2097151&wI|0,0,2097151&jA|0,0),OA=0|o(),zI=0|NB(2097151&HA|0,0,2097151&J|0,0),ZI=0|o(),OI=0|NB(2097151&RA|0,0,2097151&QI|0,0),$I=0|o(),g=0|bC(0|(CI=0|bC(0|(OA=0|bC(0|(ZI=0|bC(0|($I=0|bC(0|(Ig=0|bC(0|NB(2097151&fI|0,0,2097151&KA|0,0),0|(Ag=0|o()),0|(Ig=0|NB(2097151&MI|0,0,2097151&d|0,0)),0|o())),0|o(),0|OI,0|$I)),0|o(),0|zI,0|ZI)),0|o(),0|ZA,0|OA)),0|o(),0|cA,0|CI)),0|o(),0|eA,0|g),eA=0|o(),CI=0|NB(2097151&O|0,0,2097151&M|0,0),cA=0|o(),OA=0|NB(2097151&Y|0,0,2097151&yI|0,0),ZA=0|o(),ZI=0|NB(2097151&S|0,0,2097151&jA|0,0),zI=0|o(),$I=0|NB(2097151&wI|0,0,2097151&J|0,0),OI=0|o(),Ig=0|NB(2097151&HA|0,0,2097151&QI|0,0),Ag=0|o(),w=0|NB(2097151&RA|0,0,2097151&KA|0,0),gg=0|o(),i=0|NB(2097151&fI|0,0,2097151&d|0,0),c=0|o(),e=0|NB(2097151&MI|0,0,2097151&EA|0,0),Bg=0|o(),F=0|NB(2097151&pA|0,0,2097151&M|0,0),K=0|o(),xA=0|NB(2097151&O|0,0,2097151&yI|0,0),UA=0|o(),NI=0|NB(2097151&Y|0,0,2097151&jA|0,0),RI=0|o(),JI=0|NB(2097151&S|0,0,2097151&J|0,0),vI=0|o(),YI=0|NB(2097151&wI|0,0,2097151&QI|0,0),LI=0|o(),PI=0|NB(2097151&HA|0,0,2097151&KA|0,0),KI=0|o(),qI=0|NB(2097151&RA|0,0,2097151&d|0,0),XI=0|o(),K=0|bC(0|(UA=0|bC(0|(RI=0|bC(0|(vI=0|bC(0|(LI=0|bC(0|(KI=0|bC(0|(XI=0|bC(0|(TI=0|bC(0|NB(2097151&fI|0,0,2097151&EA|0,0),0|(jI=0|o()),0|(TI=0|NB(2097151&MI|0,0,2097151&qA|0,0)),0|o())),0|o(),0|qI,0|XI)),0|o(),0|PI,0|KI)),0|o(),0|YI,0|LI)),0|o(),0|JI,0|vI)),0|o(),0|NI,0|RI)),0|o(),0|xA,0|UA)),0|o(),0|F,0|K),F=0|o(),UA=0|NB(2097151&PA|0,0,2097151&M|0,0),xA=0|o(),RI=0|NB(2097151&pA|0,0,2097151&yI|0,0),NI=0|o(),vI=0|NB(2097151&O|0,0,2097151&jA|0,0),JI=0|o(),LI=0|NB(2097151&Y|0,0,2097151&J|0,0),YI=0|o(),KI=0|NB(2097151&S|0,0,2097151&QI|0,0),PI=0|o(),XI=0|NB(2097151&wI|0,0,2097151&KA|0,0),qI=0|o(),TI=0|NB(2097151&HA|0,0,2097151&d|0,0),jI=0|o(),f=0|NB(2097151&RA|0,0,2097151&EA|0,0),VI=0|o(),Q=0|NB(2097151&fI|0,0,2097151&qA|0,0),r=0|o(),t=0|NB(2097151&MI|0,0,2097151&Z|0,0),WI=0|o(),aI=0|NB(2097151&uI|0,0,2097151&M|0,0),tI=0|o(),R=0|NB(2097151&PA|0,0,2097151&yI|0,0),G=0|o(),MA=0|NB(2097151&pA|0,0,2097151&jA|0,0),bA=0|o(),kA=0|NB(2097151&O|0,0,2097151&J|0,0),H=0|o(),U=0|NB(2097151&Y|0,0,2097151&QI|0,0),JA=0|o(),FI=0|NB(2097151&S|0,0,2097151&KA|0,0),CA=0|o(),bI=0|NB(2097151&wI|0,0,2097151&d|0,0),mI=0|o(),HI=0|NB(2097151&HA|0,0,2097151&EA|0,0),kI=0|o(),SI=0|NB(2097151&RA|0,0,2097151&qA|0,0),dI=0|o(),tI=0|bC(0|(G=0|bC(0|(H=0|bC(0|(bA=0|bC(0|(JA=0|bC(0|(CA=0|bC(0|(mI=0|bC(0|(kI=0|bC(0|(dI=0|bC(0|(GI=0|bC(0|(xI=0|NB(2097151&fI|0,0,2097151&Z|0,0)),0|o(),0|(GI=0|NB(2097151&MI|0,0,2097151&AA|0,0)),0|o())),0|o(),0|SI,0|dI)),0|o(),0|HI,0|kI)),0|o(),0|bI,0|mI)),0|o(),0|FI,0|CA)),0|o(),0|U,0|JA)),0|o(),0|MA,0|bA)),0|o(),0|kA,0|H)),0|o(),0|R,0|G)),0|o(),0|aI,0|tI),aI=0|o(),M=0|NB(0|tA,0|aA,2097151&M|0,0),G=0|o(),R=0|NB(2097151&uI|0,0,2097151&yI|0,0),H=0|o(),kA=0|NB(2097151&PA|0,0,2097151&jA|0,0),bA=0|o(),MA=0|NB(2097151&pA|0,0,2097151&J|0,0),JA=0|o(),U=0|NB(2097151&O|0,0,2097151&QI|0,0),CA=0|o(),FI=0|NB(2097151&Y|0,0,2097151&KA|0,0),mI=0|o(),bI=0|NB(2097151&S|0,0,2097151&d|0,0),kI=0|o(),HI=0|NB(2097151&wI|0,0,2097151&EA|0,0),dI=0|o(),SI=0|NB(2097151&HA|0,0,2097151&qA|0,0),GI=0|o(),p=0|NB(2097151&RA|0,0,2097151&Z|0,0),xI=0|o(),a=0|NB(2097151&fI|0,0,2097151&AA|0,0),C=0|o(),MI=0|NB(2097151&MI|0,0,0|QA,0|rA),UI=0|o(),yI=0|NB(0|tA,0|aA,2097151&yI|0,0),hI=0|o(),oA=0|NB(2097151&uI|0,0,2097151&jA|0,0),TA=0|o(),sI=0|NB(2097151&PA|0,0,2097151&J|0,0),m=0|o(),T=0|NB(2097151&pA|0,0,2097151&QI|0,0),SA=0|o(),GA=0|NB(2097151&O|0,0,2097151&KA|0,0),nI=0|o(),NA=0|NB(2097151&Y|0,0,2097151&d|0,0),V=0|o(),$A=0|NB(2097151&S|0,0,2097151&EA|0,0),vA=0|o(),eI=0|NB(2097151&wI|0,0,2097151&qA|0,0),AI=0|o(),pI=0|NB(2097151&HA|0,0,2097151&Z|0,0),oI=0|o(),hI=0|bC(0|(TA=0|bC(0|(m=0|bC(0|(nI=0|bC(0|(SA=0|bC(0|(V=0|bC(0|(vA=0|bC(0|(AI=0|bC(0|(oI=0|bC(0|(fI=0|bC(0|(XA=0|NB(2097151&RA|0,0,2097151&AA|0,0)),0|(YA=0|o()),0|(fI=0|NB(2097151&fI|0,0,0|QA,0|rA)),0|o())),0|o(),0|pI,0|oI)),0|o(),0|eI,0|AI)),0|o(),0|$A,0|vA)),0|o(),0|NA,0|V)),0|o(),0|T,0|SA)),0|o(),0|GA,0|nI)),0|o(),0|sI,0|m)),0|o(),0|oA,0|TA)),0|o(),0|yI,0|hI),yI=0|o(),jA=0|NB(0|tA,0|aA,2097151&jA|0,0),TA=0|o(),oA=0|NB(2097151&uI|0,0,2097151&J|0,0),m=0|o(),sI=0|NB(2097151&PA|0,0,2097151&QI|0,0),nI=0|o(),GA=0|NB(2097151&pA|0,0,2097151&KA|0,0),SA=0|o(),T=0|NB(2097151&O|0,0,2097151&d|0,0),V=0|o(),NA=0|NB(2097151&Y|0,0,2097151&EA|0,0),vA=0|o(),$A=0|NB(2097151&S|0,0,2097151&qA|0,0),AI=0|o(),eI=0|NB(2097151&wI|0,0,2097151&Z|0,0),oI=0|o(),pI=0|NB(2097151&HA|0,0,2097151&AA|0,0),fI=0|o(),RA=0|NB(2097151&RA|0,0,0|QA,0|rA),YA=0|o(),J=0|NB(0|tA,0|aA,2097151&J|0,0),XA=0|o(),_I=0|NB(2097151&uI|0,0,2097151&QI|0,0),rI=0|o(),iA=0|NB(2097151&PA|0,0,2097151&KA|0,0),EI=0|o(),b=0|NB(2097151&pA|0,0,2097151&d|0,0),D=0|o(),x=0|NB(2097151&O|0,0,2097151&EA|0,0),IA=0|o(),z=0|NB(2097151&Y|0,0,2097151&qA|0,0),_A=0|o(),dA=0|NB(2097151&S|0,0,2097151&Z|0,0),W=0|o(),XA=0|bC(0|(rI=0|bC(0|(EI=0|bC(0|(IA=0|bC(0|(D=0|bC(0|(_A=0|bC(0|(W=0|bC(0|(HA=0|bC(0|(DI=0|NB(2097151&wI|0,0,2097151&AA|0,0)),0|(lI=0|o()),0|(HA=0|NB(2097151&HA|0,0,0|QA,0|rA)),0|o())),0|o(),0|dA,0|W)),0|o(),0|z,0|_A)),0|o(),0|b,0|D)),0|o(),0|x,0|IA)),0|o(),0|iA,0|EI)),0|o(),0|_I,0|rI)),0|o(),0|J,0|XA),J=0|o(),QI=0|NB(0|tA,0|aA,2097151&QI|0,0),rI=0|o(),_I=0|NB(2097151&uI|0,0,2097151&KA|0,0),EI=0|o(),iA=0|NB(2097151&PA|0,0,2097151&d|0,0),IA=0|o(),x=0|NB(2097151&pA|0,0,2097151&EA|0,0),D=0|o(),b=0|NB(2097151&O|0,0,2097151&qA|0,0),_A=0|o(),z=0|NB(2097151&Y|0,0,2097151&Z|0,0),W=0|o(),dA=0|NB(2097151&S|0,0,2097151&AA|0,0),HA=0|o(),wI=0|NB(2097151&wI|0,0,0|QA,0|rA),lI=0|o(),KA=0|NB(0|tA,0|aA,2097151&KA|0,0),DI=0|o(),gI=0|NB(2097151&uI|0,0,2097151&d|0,0),k=0|o(),BI=0|NB(2097151&PA|0,0,2097151&EA|0,0),II=0|o(),$=0|NB(2097151&pA|0,0,2097151&qA|0,0),u=0|o(),BA=0|NB(2097151&O|0,0,2097151&Z|0,0),VA=0|o(),DI=0|bC(0|(k=0|bC(0|(II=0|bC(0|(VA=0|bC(0|(u=0|bC(0|(S=0|bC(0|(nA=0|NB(2097151&Y|0,0,2097151&AA|0,0)),0|(gA=0|o()),0|(S=0|NB(2097151&S|0,0,0|QA,0|rA)),0|o())),0|o(),0|$,0|u)),0|o(),0|BA,0|VA)),0|o(),0|BI,0|II)),0|o(),0|gI,0|k)),0|o(),0|KA,0|DI),KA=0|o(),d=0|NB(0|tA,0|aA,2097151&d|0,0),k=0|o(),gI=0|NB(2097151&uI|0,0,2097151&EA|0,0),II=0|o(),BI=0|NB(2097151&PA|0,0,2097151&qA|0,0),VA=0|o(),BA=0|NB(2097151&pA|0,0,2097151&Z|0,0),u=0|o(),$=0|NB(2097151&O|0,0,2097151&AA|0,0),S=0|o(),Y=0|NB(2097151&Y|0,0,0|QA,0|rA),gA=0|o(),EA=0|NB(0|tA,0|aA,2097151&EA|0,0),nA=0|o(),mA=0|NB(2097151&uI|0,0,2097151&qA|0,0),LA=0|o(),cI=0|NB(2097151&PA|0,0,2097151&Z|0,0),FA=0|o(),fA=0|NB(2097151&pA|0,0,2097151&AA|0,0),iI=0|o(),nA=0|bC(0|(LA=0|bC(0|(FA=0|bC(0|(iI=0|bC(0|(O=0|NB(2097151&O|0,0,0|QA,0|rA)),0|o(),0|fA,0|iI)),0|o(),0|cI,0|FA)),0|o(),0|mA,0|LA)),0|o(),0|EA,0|nA),EA=0|o(),qA=0|NB(0|tA,0|aA,2097151&qA|0,0),LA=0|o(),mA=0|NB(2097151&uI|0,0,2097151&Z|0,0),FA=0|o(),cI=0|NB(2097151&PA|0,0,2097151&AA|0,0),iI=0|o(),pA=0|NB(2097151&pA|0,0,0|QA,0|rA),fA=0|o(),Z=0|NB(0|tA,0|aA,2097151&Z|0,0),O=0|o(),O=0|bC(0|(PA=0|bC(0|NB(2097151&uI|0,0,2097151&AA|0,0),0|(X=0|o()),0|(PA=0|NB(2097151&PA|0,0,0|QA,0|rA)),0|o())),0|o(),0|Z,0|O),Z=0|o(),uI=0|bC(0|(AA=0|NB(0|tA,0|aA,2097151&AA|0,0)),0|(PA=0|o()),0|(uI=0|NB(2097151&uI|0,0,0|QA,0|rA)),0|o()),PA=0|o(),rA=0|NB(0|tA,0|aA,0|QA,0|rA),QA=0|o(),AA=0|bC(0|j,0|v,0|(AA=0|CC(0|(aA=0|bC(0|wA,0|lA,1048576,0)),0|(tA=0|o()),21)),0|o()),v=0|o(),tA=0|FC(0|wA,0|lA,-2097152&aA|0,2047&tA|0),aA=0|o(),j=0|CC(0|(lA=0|bC(0|DA,0|uA,1048576,0)),0|(wA=0|o()),21),X=0|o(),X=0|bC(0|(sA=0|bC(0|(I=0|bC(0|(Qg=0|bC(0|h,0|y,0|s,0|Qg)),0|o(),0|L,0|I)),0|o(),0|N,0|sA)),0|o(),0|j,0|X),j=0|o(),I=0|KB(0|(sA=0|bC(0|hA,0|yA,1048576,0)),0|(N=0|o()),21),L=0|o(),L=0|bC(0|(P=0|bC(0|(zA=0|bC(0|(Cg=0|bC(0|(tg=0|bC(0|(rg=0|bC(0|n,0|E,0|_,0|rg)),0|o(),0|l,0|tg)),0|o(),0|ag,0|Cg)),0|o(),0|WA,0|zA)),0|o(),0|q,0|P)),0|o(),0|I,0|L),I=0|o(),zA=0|KB(0|(P=0|bC(0|g,0|eA,1048576,0)),0|(q=0|o()),21),WA=0|o(),WA=0|bC(0|(cA=0|bC(0|(ZA=0|bC(0|(zI=0|bC(0|(OI=0|bC(0|(Ag=0|bC(0|(gg=0|bC(0|(Bg=0|bC(0|i,0|c,0|e,0|Bg)),0|o(),0|w,0|gg)),0|o(),0|Ig,0|Ag)),0|o(),0|$I,0|OI)),0|o(),0|ZI,0|zI)),0|o(),0|OA,0|ZA)),0|o(),0|CI,0|cA)),0|o(),0|zA,0|WA),zA=0|o(),ZA=0|KB(0|(cA=0|bC(0|K,0|F,1048576,0)),0|(CI=0|o()),21),OA=0|o(),OA=0|bC(0|(xA=0|bC(0|(JI=0|bC(0|(NI=0|bC(0|(YI=0|bC(0|(PI=0|bC(0|(qI=0|bC(0|(jI=0|bC(0|(VI=0|bC(0|(WI=0|bC(0|Q,0|r,0|t,0|WI)),0|o(),0|f,0|VI)),0|o(),0|TI,0|jI)),0|o(),0|XI,0|qI)),0|o(),0|KI,0|PI)),0|o(),0|LI,0|YI)),0|o(),0|RI,0|NI)),0|o(),0|vI,0|JI)),0|o(),0|UA,0|xA)),0|o(),0|ZA,0|OA),ZA=0|o(),CI=0|FC(0|K,0|F,-2097152&cA|0,0|CI),cA=0|o(),xA=0|KB(0|(F=0|bC(0|tI,0|aI,1048576,0)),0|(K=0|o()),21),UA=0|o(),UA=0|bC(0|(G=0|bC(0|(H=0|bC(0|(bA=0|bC(0|(CA=0|bC(0|(JA=0|bC(0|(mI=0|bC(0|(kI=0|bC(0|(dI=0|bC(0|(GI=0|bC(0|(xI=0|bC(0|(UI=0|bC(0|a,0|C,0|MI,0|UI)),0|o(),0|p,0|xI)),0|o(),0|SI,0|GI)),0|o(),0|HI,0|dI)),0|o(),0|bI,0|kI)),0|o(),0|FI,0|mI)),0|o(),0|MA,0|JA)),0|o(),0|U,0|CA)),0|o(),0|kA,0|bA)),0|o(),0|R,0|H)),0|o(),0|M,0|G)),0|o(),0|xA,0|UA),xA=0|o(),H=0|KB(0|(G=0|bC(0|hI,0|yI,1048576,0)),0|(M=0|o()),21),R=0|o(),R=0|bC(0|(TA=0|bC(0|(m=0|bC(0|(nI=0|bC(0|(V=0|bC(0|(SA=0|bC(0|(vA=0|bC(0|(AI=0|bC(0|(oI=0|bC(0|(YA=0|bC(0|pI,0|fI,0|RA,0|YA)),0|o(),0|eI,0|oI)),0|o(),0|$A,0|AI)),0|o(),0|NA,0|vA)),0|o(),0|GA,0|SA)),0|o(),0|T,0|V)),0|o(),0|sI,0|nI)),0|o(),0|oA,0|m)),0|o(),0|jA,0|TA)),0|o(),0|H,0|R),H=0|o(),m=0|KB(0|(TA=0|bC(0|XA,0|J,1048576,0)),0|(jA=0|o()),21),oA=0|o(),oA=0|bC(0|(rI=0|bC(0|(EI=0|bC(0|(IA=0|bC(0|(_A=0|bC(0|(D=0|bC(0|(W=0|bC(0|(lI=0|bC(0|dA,0|HA,0|wI,0|lI)),0|o(),0|z,0|W)),0|o(),0|x,0|D)),0|o(),0|b,0|_A)),0|o(),0|iA,0|IA)),0|o(),0|_I,0|EI)),0|o(),0|QI,0|rI)),0|o(),0|m,0|oA),m=0|o(),EI=0|KB(0|(rI=0|bC(0|DI,0|KA,1048576,0)),0|(QI=0|o()),21),_I=0|o(),_I=0|bC(0|(k=0|bC(0|(II=0|bC(0|(VA=0|bC(0|(S=0|bC(0|(gA=0|bC(0|BA,0|u,0|Y,0|gA)),0|o(),0|$,0|S)),0|o(),0|BI,0|VA)),0|o(),0|gI,0|II)),0|o(),0|d,0|k)),0|o(),0|EI,0|_I),EI=0|o(),II=0|KB(0|(k=0|bC(0|nA,0|EA,1048576,0)),0|(d=0|o()),21),gI=0|o(),gI=0|bC(0|(LA=0|bC(0|(FA=0|bC(0|(fA=0|bC(0|cI,0|iI,0|pA,0|fA)),0|o(),0|mA,0|FA)),0|o(),0|qA,0|LA)),0|o(),0|II,0|gI),II=0|o(),d=0|FC(0|nA,0|EA,-2097152&k|0,0|d),k=0|o(),LA=0|bC(0|uI,0|PA,0|(LA=0|KB(0|(EA=0|bC(0|O,0|Z,1048576,0)),0|(nA=0|o()),21)),0|o()),PA=0|o(),nA=0|FC(0|O,0|Z,-2097152&EA|0,0|nA),EA=0|o(),uI=0|KB(0|(Z=0|bC(0|rA,0|QA,1048576,0)),0|(O=0|o()),21),qA=0|o(),O=0|FC(0|rA,0|QA,-2097152&Z|0,0|O),Z=0|o(),FA=0|CC(0|(QA=0|bC(0|AA,0|v,1048576,0)),0|(rA=0|o()),21),mA=0|o(),rA=0|FC(0|AA,0|v,-2097152&QA|0,8191&rA|0),QA=0|o(),fA=0|KB(0|(v=0|bC(0|X,0|j,1048576,0)),0|(AA=0|o()),21),pA=0|o(),AA=0|FC(0|X,0|j,-2097152&v|0,0|AA),v=0|o(),iI=0|KB(0|(j=0|bC(0|L,0|I,1048576,0)),0|(X=0|o()),21),cI=0|o(),X=0|FC(0|L,0|I,-2097152&j|0,0|X),j=0|o(),VA=0|bC(0|CI,0|cA,0|(VA=0|KB(0|(I=0|bC(0|WA,0|zA,1048576,0)),0|(L=0|o()),21)),0|o()),cA=0|o(),L=0|FC(0|WA,0|zA,-2097152&I|0,0|L),I=0|o(),CI=0|KB(0|(zA=0|bC(0|OA,0|ZA,1048576,0)),0|(WA=0|o()),21),BI=0|o(),gA=0|KB(0|(S=0|bC(0|UA,0|xA,1048576,0)),0|($=0|o()),21),Y=0|o(),IA=0|KB(0|(u=0|bC(0|R,0|H,1048576,0)),0|(BA=0|o()),21),iA=0|o(),D=0|KB(0|(_A=0|bC(0|oA,0|m,1048576,0)),0|(b=0|o()),21),x=0|o(),k=0|bC(0|(lI=0|KB(0|(W=0|bC(0|_I,0|EI,1048576,0)),0|(z=0|o()),21)),0|o(),0|d,0|k),d=0|o(),z=0|FC(0|_I,0|EI,-2097152&W|0,0|z),W=0|o(),EA=0|bC(0|(lI=0|KB(0|(EI=0|bC(0|gI,0|II,1048576,0)),0|(_I=0|o()),21)),0|o(),0|nA,0|EA),nA=0|o(),_I=0|FC(0|gI,0|II,-2097152&EI|0,0|_I),EI=0|o(),Z=0|bC(0|(lI=0|KB(0|(II=0|bC(0|LA,0|PA,1048576,0)),0|(gI=0|o()),21)),0|o(),0|O,0|Z),O=0|o(),gI=0|FC(0|LA,0|PA,-2097152&II|0,0|gI),II=0|o(),PA=0|NB(0|uI,0|qA,666643,0),LA=0|o(),lI=0|NB(0|uI,0|qA,470296,0),wI=0|o(),HA=0|NB(0|uI,0|qA,654183,0),dA=0|o(),nI=0|NB(0|uI,0|qA,-997805,-1),sI=0|o(),V=0|NB(0|uI,0|qA,136657,0),T=0|o(),x=0|bC(0|(QI=0|FC(0|(qA=0|bC(0|DI,0|KA,0|(qA=0|NB(0|uI,0|qA,-683901,-1)),0|o())),0|o(),-2097152&rI|0,0|QI)),0|o(),0|D,0|x),D=0|o(),QI=0|NB(0|Z,0|O,666643,0),rI=0|o(),qA=0|NB(0|Z,0|O,470296,0),KA=0|o(),DI=0|NB(0|Z,0|O,654183,0),uI=0|o(),SA=0|NB(0|Z,0|O,-997805,-1),GA=0|o(),vA=0|NB(0|Z,0|O,136657,0),NA=0|o(),O=0|NB(0|Z,0|O,-683901,-1),Z=0|o(),AI=0|NB(0|gI,0|II,666643,0),$A=0|o(),oI=0|NB(0|gI,0|II,470296,0),eI=0|o(),YA=0|NB(0|gI,0|II,654183,0),RA=0|o(),fI=0|NB(0|gI,0|II,-997805,-1),pI=0|o(),bA=0|NB(0|gI,0|II,136657,0),kA=0|o(),II=0|NB(0|gI,0|II,-683901,-1),gI=0|o(),iA=0|bC(0|(jA=0|FC(0|(gI=0|bC(0|(NA=0|bC(0|(sI=0|bC(0|XA,0|J,0|nI,0|sI)),0|o(),0|vA,0|NA)),0|o(),0|II,0|gI)),0|o(),-2097152&TA|0,0|jA)),0|o(),0|IA,0|iA),IA=0|o(),jA=0|bC(0|VA,0|cA,0|(jA=0|NB(0|EA,0|nA,666643,0)),0|o()),cA=0|o(),VA=0|NB(0|EA,0|nA,470296,0),TA=0|o(),gI=0|NB(0|EA,0|nA,654183,0),II=0|o(),NA=0|NB(0|EA,0|nA,-997805,-1),vA=0|o(),sI=0|NB(0|EA,0|nA,136657,0),nI=0|o(),nA=0|NB(0|EA,0|nA,-683901,-1),EA=0|o(),J=0|bC(0|L,0|I,0|(J=0|NB(0|_I,0|EI,666643,0)),0|o()),I=0|o(),L=0|bC(0|jA,0|cA,0|(L=0|NB(0|_I,0|EI,470296,0)),0|o()),cA=0|o(),jA=0|NB(0|_I,0|EI,654183,0),XA=0|o(),CA=0|NB(0|_I,0|EI,-997805,-1),U=0|o(),JA=0|NB(0|_I,0|EI,136657,0),MA=0|o(),EI=0|NB(0|_I,0|EI,-683901,-1),_I=0|o(),Y=0|bC(0|(M=0|FC(0|(_I=0|bC(0|(nI=0|bC(0|(yI=0|bC(0|(pI=0|bC(0|(wI=0|bC(0|DI,0|uI,0|lI,0|wI)),0|o(),0|fI,0|pI)),0|o(),0|hI,0|yI)),0|o(),0|sI,0|nI)),0|o(),0|EI,0|_I)),0|o(),-2097152&G|0,0|M)),0|o(),0|gA,0|Y),gA=0|o(),M=0|NB(0|k,0|d,666643,0),G=0|o(),G=0|bC(0|(q=0|FC(0|(eA=0|bC(0|iI,0|cI,0|g,0|eA)),0|o(),-2097152&P|0,0|q)),0|o(),0|M,0|G),M=0|o(),q=0|bC(0|J,0|I,0|(q=0|NB(0|k,0|d,470296,0)),0|o()),I=0|o(),J=0|bC(0|L,0|cA,0|(J=0|NB(0|k,0|d,654183,0)),0|o()),cA=0|o(),L=0|NB(0|k,0|d,-997805,-1),P=0|o(),eA=0|NB(0|k,0|d,136657,0),g=0|o(),g=0|bC(0|(K=0|FC(0|(U=0|bC(0|(II=0|bC(0|(BI=0|bC(0|(aI=0|bC(0|(rI=0|bC(0|oI,0|eI,0|QI,0|rI)),0|o(),0|tI,0|aI)),0|o(),0|CI,0|BI)),0|o(),0|gI,0|II)),0|o(),0|CA,0|U)),0|o(),-2097152&F|0,0|K)),0|o(),0|eA,0|g),eA=0|o(),d=0|NB(0|k,0|d,-683901,-1),k=0|o(),U=0|bC(0|q,0|I,0|(U=0|KB(0|(K=0|bC(0|G,0|M,1048576,0)),0|(F=0|o()),21)),0|o()),I=0|o(),F=0|FC(0|G,0|M,-2097152&K|0,0|F),K=0|o(),q=0|KB(0|(M=0|bC(0|J,0|cA,1048576,0)),0|(G=0|o()),21),CA=0|o(),CA=0|bC(0|(P=0|bC(0|(XA=0|bC(0|(TA=0|bC(0|(WA=0|FC(0|(ZA=0|bC(0|AI,0|$A,0|OA,0|ZA)),0|o(),-2097152&zA|0,0|WA)),0|o(),0|VA,0|TA)),0|o(),0|jA,0|XA)),0|o(),0|L,0|P)),0|o(),0|q,0|CA),q=0|o(),G=0|FC(0|J,0|cA,-2097152&M|0,0|G),M=0|o(),P=0|KB(0|(cA=0|bC(0|g,0|eA,1048576,0)),0|(J=0|o()),21),L=0|o(),L=0|bC(0|($=0|FC(0|(k=0|bC(0|(xA=0|bC(0|(MA=0|bC(0|(vA=0|bC(0|(RA=0|bC(0|(LA=0|bC(0|qA,0|KA,0|PA,0|LA)),0|o(),0|YA,0|RA)),0|o(),0|NA,0|vA)),0|o(),0|JA,0|MA)),0|o(),0|UA,0|xA)),0|o(),0|d,0|k)),0|o(),-2097152&S|0,0|$)),0|o(),0|P,0|L),P=0|o(),k=0|KB(0|($=0|bC(0|Y,0|gA,1048576,0)),0|(S=0|o()),21),d=0|o(),d=0|bC(0|(BA=0|FC(0|(H=0|bC(0|(EA=0|bC(0|(kA=0|bC(0|(dA=0|bC(0|SA,0|GA,0|HA,0|dA)),0|o(),0|bA,0|kA)),0|o(),0|nA,0|EA)),0|o(),0|R,0|H)),0|o(),-2097152&u|0,0|BA)),0|o(),0|k,0|d),k=0|o(),S=0|FC(0|Y,0|gA,-2097152&$|0,0|S),$=0|o(),BA=0|KB(0|(gA=0|bC(0|iA,0|IA,1048576,0)),0|(Y=0|o()),21),u=0|o(),u=0|bC(0|(b=0|FC(0|(m=0|bC(0|(T=0|bC(0|O,0|Z,0|V,0|T)),0|o(),0|oA,0|m)),0|o(),-2097152&_A|0,0|b)),0|o(),0|BA,0|u),BA=0|o(),Y=0|FC(0|iA,0|IA,-2097152&gA|0,0|Y),gA=0|o(),W=0|bC(0|(b=0|KB(0|(IA=0|bC(0|x,0|D,1048576,0)),0|(iA=0|o()),21)),0|o(),0|z,0|W),z=0|o(),iA=0|FC(0|x,0|D,-2097152&IA|0,0|iA),IA=0|o(),b=0|bC(0|G,0|M,0|(b=0|KB(0|(D=0|bC(0|U,0|I,1048576,0)),0|(x=0|o()),21)),0|o()),M=0|o(),x=0|FC(0|U,0|I,-2097152&D|0,0|x),D=0|o(),G=0|KB(0|(I=0|bC(0|CA,0|q,1048576,0)),0|(U=0|o()),21),_A=0|o(),U=0|FC(0|CA,0|q,-2097152&I|0,0|U),I=0|o(),$=0|bC(0|(m=0|KB(0|(q=0|bC(0|L,0|P,1048576,0)),0|(CA=0|o()),21)),0|o(),0|S,0|$),S=0|o(),CA=0|FC(0|L,0|P,-2097152&q|0,0|CA),q=0|o(),gA=0|bC(0|(m=0|KB(0|(P=0|bC(0|d,0|k,1048576,0)),0|(L=0|o()),21)),0|o(),0|Y,0|gA),Y=0|o(),L=0|FC(0|d,0|k,-2097152&P|0,0|L),P=0|o(),IA=0|bC(0|(m=0|KB(0|(k=0|bC(0|u,0|BA,1048576,0)),0|(d=0|o()),21)),0|o(),0|iA,0|IA),iA=0|o(),d=0|FC(0|u,0|BA,-2097152&k|0,0|d),k=0|o(),BA=0|bC(0|X,0|j,0|(BA=0|NB(0|W,0|z,666643,0)),0|o()),j=0|o(),X=0|bC(0|F,0|K,0|(X=0|NB(0|W,0|z,470296,0)),0|o()),K=0|o(),F=0|bC(0|x,0|D,0|(F=0|NB(0|W,0|z,654183,0)),0|o()),D=0|o(),x=0|bC(0|b,0|M,0|(x=0|NB(0|W,0|z,-997805,-1)),0|o()),M=0|o(),b=0|bC(0|U,0|I,0|(b=0|NB(0|W,0|z,136657,0)),0|o()),I=0|o(),z=0|NB(0|W,0|z,-683901,-1),W=0|o(),J=0|FC(0|(W=0|bC(0|(eA=0|bC(0|G,0|_A,0|g,0|eA)),0|o(),0|z,0|W)),0|o(),-2097152&cA|0,0|J),cA=0|o(),W=0|NB(0|IA,0|iA,666643,0),z=0|o(),eA=0|bC(0|BA,0|j,0|(eA=0|NB(0|IA,0|iA,470296,0)),0|o()),j=0|o(),BA=0|bC(0|X,0|K,0|(BA=0|NB(0|IA,0|iA,654183,0)),0|o()),K=0|o(),X=0|bC(0|F,0|D,0|(X=0|NB(0|IA,0|iA,-997805,-1)),0|o()),D=0|o(),F=0|bC(0|x,0|M,0|(F=0|NB(0|IA,0|iA,136657,0)),0|o()),M=0|o(),iA=0|bC(0|b,0|I,0|(iA=0|NB(0|IA,0|iA,-683901,-1)),0|o()),I=0|o(),b=0|bC(0|AA,0|v,0|(b=0|NB(0|d,0|k,666643,0)),0|o()),v=0|o(),AA=0|NB(0|d,0|k,470296,0),IA=0|o(),x=0|bC(0|eA,0|j,0|(x=0|NB(0|d,0|k,654183,0)),0|o()),j=0|o(),eA=0|bC(0|BA,0|K,0|(eA=0|NB(0|d,0|k,-997805,-1)),0|o()),K=0|o(),BA=0|bC(0|X,0|D,0|(BA=0|NB(0|d,0|k,136657,0)),0|o()),D=0|o(),k=0|bC(0|F,0|M,0|(k=0|NB(0|d,0|k,-683901,-1)),0|o()),M=0|o(),F=0|NB(0|gA,0|Y,666643,0),d=0|o(),X=0|NB(0|gA,0|Y,470296,0),g=0|o(),_A=0|NB(0|gA,0|Y,654183,0),G=0|o(),U=0|NB(0|gA,0|Y,-997805,-1),u=0|o(),m=0|bC(0|eA,0|K,0|(m=0|NB(0|gA,0|Y,136657,0)),0|o()),K=0|o(),Y=0|bC(0|BA,0|D,0|(Y=0|NB(0|gA,0|Y,-683901,-1)),0|o()),D=0|o(),BA=0|NB(0|L,0|P,666643,0),gA=0|o(),eA=0|NB(0|L,0|P,470296,0),oA=0|o(),T=0|NB(0|L,0|P,654183,0),V=0|o(),Z=0|NB(0|L,0|P,-997805,-1),O=0|o(),H=0|NB(0|L,0|P,136657,0),R=0|o(),P=0|bC(0|m,0|K,0|(P=0|NB(0|L,0|P,-683901,-1)),0|o()),K=0|o(),aA=0|bC(0|(m=0|NB(0|$,0|S,666643,0)),0|o(),0|tA,0|aA),tA=0|o(),m=0|NB(0|$,0|S,470296,0),L=0|o(),EA=0|NB(0|$,0|S,654183,0),nA=0|o(),oA=0|bC(0|(d=0|bC(0|(nA=0|bC(0|(wA=0|FC(0|(uA=0|bC(0|FA,0|mA,0|DA,0|uA)),0|o(),-2097152&lA|0,8191&wA|0)),0|o(),0|EA,0|nA)),0|o(),0|F,0|d)),0|o(),0|eA,0|oA),eA=0|o(),d=0|NB(0|$,0|S,-997805,-1),F=0|o(),nA=0|NB(0|$,0|S,136657,0),EA=0|o(),O=0|bC(0|(G=0|bC(0|(EA=0|bC(0|(IA=0|bC(0|(z=0|bC(0|(N=0|FC(0|(yA=0|bC(0|fA,0|pA,0|hA,0|yA)),0|o(),-2097152&sA|0,0|N)),0|o(),0|W,0|z)),0|o(),0|AA,0|IA)),0|o(),0|nA,0|EA)),0|o(),0|_A,0|G)),0|o(),0|Z,0|O),Z=0|o(),S=0|NB(0|$,0|S,-683901,-1),$=0|o(),EA=0|KB(0|(G=0|bC(0|aA,0|tA,1048576,0)),0|(_A=0|o()),21),nA=0|o(),nA=0|bC(0|(gA=0|bC(0|(L=0|bC(0|rA,0|QA,0|m,0|L)),0|o(),0|BA,0|gA)),0|o(),0|EA,0|nA),EA=0|o(),_A=0|FC(0|aA,0|tA,-2097152&G|0,0|_A),G=0|o(),gA=0|KB(0|(tA=0|bC(0|oA,0|eA,1048576,0)),0|(aA=0|o()),21),BA=0|o(),BA=0|bC(0|(V=0|bC(0|(g=0|bC(0|(F=0|bC(0|b,0|v,0|d,0|F)),0|o(),0|X,0|g)),0|o(),0|T,0|V)),0|o(),0|gA,0|BA),gA=0|o(),g=0|KB(0|(V=0|bC(0|O,0|Z,1048576,0)),0|(T=0|o()),21),X=0|o(),X=0|bC(0|(R=0|bC(0|(u=0|bC(0|($=0|bC(0|x,0|j,0|S,0|$)),0|o(),0|U,0|u)),0|o(),0|H,0|R)),0|o(),0|g,0|X),g=0|o(),u=0|bC(0|Y,0|D,0|(u=0|KB(0|(R=0|bC(0|P,0|K,1048576,0)),0|(H=0|o()),21)),0|o()),D=0|o(),H=0|FC(0|P,0|K,-2097152&R|0,0|H),R=0|o(),Y=0|bC(0|iA,0|I,0|(Y=0|KB(0|(K=0|bC(0|k,0|M,1048576,0)),0|(P=0|o()),21)),0|o()),I=0|o(),P=0|FC(0|k,0|M,-2097152&K|0,0|P),K=0|o(),iA=0|bC(0|CA,0|q,0|(iA=0|KB(0|(M=0|bC(0|J,0|cA,1048576,0)),0|(k=0|o()),21)),0|o()),q=0|o(),k=0|FC(0|J,0|cA,-2097152&M|0,0|k),M=0|o(),CA=0|KB(0|(cA=0|bC(0|nA,0|EA,1048576,0)),0|(J=0|o()),21),U=0|o(),j=0|KB(0|($=0|bC(0|BA,0|gA,1048576,0)),0|(S=0|o()),21),x=0|o(),v=0|bC(0|H,0|R,0|(v=0|KB(0|(F=0|bC(0|X,0|g,1048576,0)),0|(d=0|o()),21)),0|o()),R=0|o(),L=0|bC(0|P,0|K,0|(L=0|KB(0|(H=0|bC(0|u,0|D,1048576,0)),0|(b=0|o()),21)),0|o()),K=0|o(),b=0|FC(0|u,0|D,-2097152&H|0,0|b),H=0|o(),P=0|bC(0|k,0|M,0|(P=0|KB(0|(D=0|bC(0|Y,0|I,1048576,0)),0|(u=0|o()),21)),0|o()),M=0|o(),u=0|FC(0|Y,0|I,-2097152&D|0,0|u),D=0|o(),k=0|KB(0|(I=0|bC(0|iA,0|q,1048576,0)),0|(Y=0|o()),21),m=0|o(),Y=0|FC(0|iA,0|q,-2097152&I|0,0|Y),I=0|o(),q=0|bC(0|_A,0|G,0|(q=0|NB(0|k,0|m,666643,0)),0|o()),G=0|o(),_A=0|NB(0|k,0|m,470296,0),iA=0|o(),QA=0|NB(0|k,0|m,654183,0),rA=0|o(),IA=0|NB(0|k,0|m,-997805,-1),AA=0|o(),z=0|NB(0|k,0|m,136657,0),W=0|o(),m=0|NB(0|k,0|m,-683901,-1),k=0|o(),G=0|KB(0|q,0|G,21),N=0|o(),G=0|KB(0|(N=0|bC(0|(J=0|FC(0|(iA=0|bC(0|nA,0|EA,0|_A,0|iA)),0|o(),-2097152&cA|0,0|J)),0|o(),0|G,0|N)),0|o(),21),J=0|o(),G=0|KB(0|(J=0|bC(0|(U=0|bC(0|(aA=0|FC(0|(rA=0|bC(0|oA,0|eA,0|QA,0|rA)),0|o(),-2097152&tA|0,0|aA)),0|o(),0|CA,0|U)),0|o(),0|G,0|J)),0|o(),21),U=0|o(),G=0|KB(0|(U=0|bC(0|(S=0|FC(0|(AA=0|bC(0|BA,0|gA,0|IA,0|AA)),0|o(),-2097152&$|0,0|S)),0|o(),0|G,0|U)),0|o(),21),S=0|o(),G=0|KB(0|(S=0|bC(0|(x=0|bC(0|(T=0|FC(0|(W=0|bC(0|O,0|Z,0|z,0|W)),0|o(),-2097152&V|0,0|T)),0|o(),0|j,0|x)),0|o(),0|G,0|S)),0|o(),21),x=0|o(),q=0|bC(0|(P=0|NB(0|(Y=0|KB(0|(I=0|bC(0|(M=0|KB(0|(u=0|bC(0|P,0|M,0|(u=0|KB(0|(D=0|bC(0|(K=0|KB(0|(b=0|bC(0|L,0|K,0|(b=0|KB(0|(H=0|bC(0|(R=0|KB(0|(G=0|bC(0|v,0|R,0|(G=0|KB(0|(x=0|bC(0|(d=0|FC(0|(k=0|bC(0|X,0|g,0|m,0|k)),0|o(),-2097152&F|0,0|d)),0|o(),0|G,0|x)),0|o(),21)),0|o())),0|o(),21)),0|o(),0|b,0|H)),0|o(),21)),0|o())),0|o(),21)),0|o(),0|u,0|D)),0|o(),21)),0|o())),0|o(),21)),0|o(),0|Y,0|I)),0|o(),21)),0|(M=0|o()),666643,0)),0|o(),2097151&q|0,0),P=0|o(),N=0|bC(0|(K=0|NB(0|Y,0|M,470296,0)),0|o(),2097151&N|0,0),K=0|o(),J=0|bC(0|(L=0|NB(0|Y,0|M,654183,0)),0|o(),2097151&J|0,0),L=0|o(),U=0|bC(0|(R=0|NB(0|Y,0|M,-997805,-1)),0|o(),2097151&U|0,0),R=0|o(),S=0|bC(0|(v=0|NB(0|Y,0|M,136657,0)),0|o(),2097151&S|0,0),v=0|o(),I=0|bC(0|(g=0|KB(0|(u=0|bC(0|(m=0|KB(0|(D=0|bC(0|(k=0|KB(0|(b=0|bC(0|(F=0|KB(0|(H=0|bC(0|(d=0|KB(0|(G=0|bC(0|(x=0|KB(0|(S=0|bC(0|(x=0|bC(0|(M=0|NB(0|Y,0|M,-683901,-1)),0|o(),2097151&x|0,0)),0|(M=0|o()),0|(S=0|KB(0|(U=0|bC(0|S,0|v,0|(U=0|KB(0|(J=0|bC(0|U,0|R,0|(J=0|KB(0|(N=0|bC(0|J,0|L,0|(N=0|KB(0|(Y=0|bC(0|N,0|K,0|(Y=0|KB(0|q,0|P,21)),0|o())),0|(K=0|o()),21)),0|o())),0|(L=0|o()),21)),0|o())),0|(R=0|o()),21)),0|o())),0|(v=0|o()),21)),0|o())),0|(M=0|o()),21)),0|o(),2097151&G|0,0)),0|(x=0|o()),21)),0|o(),2097151&H|0,0)),0|(d=0|o()),21)),0|o(),2097151&b|0,0)),0|(F=0|o()),21)),0|o(),2097151&D|0,0)),0|(k=0|o()),21)),0|o(),2097151&u|0,0)),0|(m=0|o()),21)),0|o(),2097151&I|0,0),g=0|o(),B[A>>0]=q,X=0|CC(0|q,0|P,8),o(),B[A+1>>0]=X,P=0|CC(0|q,0|P,16),o(),q=0|$B(2097151&Y|0,0,5),o(),B[A+2>>0]=q|31&P,P=0|CC(0|Y,0|K,3),o(),B[A+3>>0]=P,K=0|CC(0|Y,0|K,11),o(),B[A+4>>0]=K,Y=0|CC(2097151&Y|0,0,19),K=0|o(),P=0|$B(2097151&N|0,0,2),o(),B[A+5>>0]=P|Y,L=0|CC(0|N,0|L,6),o(),B[A+6>>0]=L,N=0|CC(2097151&N|0,0,14),L=0|o(),Y=0|$B(2097151&J|0,0,7),o(),B[A+7>>0]=Y|N,N=0|CC(0|J,0|R,1),o(),B[A+8>>0]=N,R=0|CC(0|J,0|R,9),o(),B[A+9>>0]=R,J=0|CC(2097151&J|0,0,17),R=0|o(),N=0|$B(2097151&U|0,0,4),o(),B[A+10>>0]=N|J,J=0|CC(0|U,0|v,4),o(),B[A+11>>0]=J,v=0|CC(0|U,0|v,12),o(),B[A+12>>0]=v,U=0|CC(2097151&U|0,0,20),v=0|o(),J=0|$B(2097151&S|0,0,1),o(),B[A+13>>0]=J|U,M=0|CC(0|S,0|M,7),o(),B[A+14>>0]=M,S=0|CC(2097151&S|0,0,15),M=0|o(),U=0|$B(2097151&G|0,0,6),o(),B[A+15>>0]=U|S,S=0|CC(0|G,0|x,2),o(),B[A+16>>0]=S,x=0|CC(0|G,0|x,10),o(),B[A+17>>0]=x,G=0|CC(2097151&G|0,0,18),x=0|o(),S=0|$B(0|H,0|d,3),o(),B[A+18>>0]=S|G,G=0|CC(0|H,0|d,5),o(),B[A+19>>0]=G,d=0|CC(0|H,0|d,13),o(),B[A+20>>0]=d,B[A+21>>0]=b,d=0|CC(0|b,0|F,8),o(),B[A+22>>0]=d,F=0|CC(0|b,0|F,16),o(),b=0|$B(2097151&D|0,0,5),o(),B[A+23>>0]=b|31&F,F=0|CC(0|D,0|k,3),o(),B[A+24>>0]=F,k=0|CC(0|D,0|k,11),o(),B[A+25>>0]=k,D=0|CC(2097151&D|0,0,19),k=0|o(),F=0|$B(2097151&u|0,0,2),o(),B[A+26>>0]=F|D,m=0|CC(0|u,0|m,6),o(),B[A+27>>0]=m,u=0|CC(2097151&u|0,0,14),m=0|o(),D=0|$B(0|I,0|g,7),o(),B[A+28>>0]=D|u,u=0|CC(0|I,0|g,1),o(),B[A+29>>0]=u,u=0|CC(0|I,0|g,9),o(),B[A+30>>0]=u,g=0|KB(0|I,0|g,17),o(),B[A+31>>0]=g}function l(A,I,g,B){A|=0,B|=0;var C=0,t=0,r=0,Q=0,e=0,c=0,i=0,_=0,E=0,n=0,s=0,y=0,h=0,p=0,f=0,w=0,l=0,u=0,D=0,m=0,F=0,k=0,b=0,d=0,H=0,G=0,S=0,x=0,U=0,M=0,J=0,v=0,N=0,R=0,Y=0,L=0,P=0,K=0,q=0;!function(A,I){A|=0,I|=0;var g=0,B=0,C=0,t=0;g=0;do{t=0|FI(I+(g<<3)|0),C=0|o(),a[(B=A+(g<<3)|0)>>2]=t,a[B+4>>2]=C,g=g+1|0}while(16!=(0|g))}(g|=0,I|=0),C=A,t=(I=B)+64|0;do{a[I>>2]=a[C>>2],I=I+4|0,C=C+4|0}while((0|I)<(0|t));I=0|a[g>>2],C=0|a[g+4>>2],f=0;do{if(y=0|bB(D=0|a[B+32>>2],Q=0|a[B+32+4>>2],14),_=0|o(),b=0|bB(D,Q,18),_=(0|o())^_,L=0|bB(D,Q,41),_^=0|o(),M=0|a[B+40>>2],r=0|a[B+40+4>>2],p=0|a[B+48>>2],t=0|a[B+48+4>>2],e=0|a[(v=32976+(f<<3)|0)>>2],v=0|a[v+4>>2],E=0|a[B+56>>2],u=0|a[B+56+4>>2],v=0|bC(0|(u=0|bC(0|(v=0|bC(0|(v=0|bC(0|(_=0|bC(0|I,0|C,b^y^L|0,0|_)),0|o(),0|e,0|v)),0|o(),(p^M)&D^p|0,(t^r)&Q^t|0)),0|o(),0|E,0|u)),0|(E=0|o()),0|a[B+24>>2],0|a[B+24+4>>2]),e=0|o(),a[B+24>>2]=v,a[B+24+4>>2]=e,y=0|bB(_=0|a[B>>2],L=0|a[B+4>>2],28),I=0|o(),b=0|bB(_,L,34),I=(0|o())^I,x=0|bB(_,L,39),I^=0|o(),i=0|a[B+8>>2],Y=0|a[B+8+4>>2],c=0|a[B+16>>2],R=0|a[B+16+4>>2],E=0|bC(0|(E=0|bC(b^y^x|0,0|I,0|u,0|E)),0|o(),(c|i)&_|c&i|0,(R|Y)&L|R&Y|0),u=0|o(),a[B+56>>2]=E,a[B+56+4>>2]=u,I=0|bB(v,e,14),x=0|o(),y=0|bB(v,e,18),x=(0|o())^x,b=0|bB(v,e,41),x^=0|o(),n=0|a[g+((s=1|f)<<3)>>2],C=0|a[g+(s<<3)+4>>2],h=0|a[32976+(s<<3)>>2],d=0|a[32976+(s<<3)+4>>2],R=0|bC(0|(d=0|bC(0|(C=0|bC(0|(x=0|bC(0|(t=0|bC(v&(M^D)^M|0,e&(r^Q)^r|0,0|p,0|t)),0|o(),y^I^b|0,0|x)),0|o(),0|n,0|C)),0|o(),0|h,0|d)),0|(h=0|o()),0|c,0|R),c=0|o(),a[B+16>>2]=R,a[B+16+4>>2]=c,C=0|bB(E,u,28),n=0|o(),x=0|bB(E,u,34),n=(0|o())^n,b=0|bB(E,u,39),n^=0|o(),n=0|bC(0|(h=0|bC(0|d,0|h,E&(i|_)|i&_|0,u&(Y|L)|Y&L|0)),0|o(),x^C^b|0,0|n),b=0|o(),a[B+48>>2]=n,a[B+48+4>>2]=b,C=0|bB(R,c,14),x=0|o(),h=0|bB(R,c,18),x=(0|o())^x,d=0|bB(R,c,41),x^=0|o(),y=0|a[g+((I=2|f)<<3)>>2],t=0|a[g+(I<<3)+4>>2],p=0|a[32976+(I<<3)>>2],H=0|a[32976+(I<<3)+4>>2],Y=0|bC(0|(H=0|bC(0|(t=0|bC(0|(x=0|bC(0|(r=0|bC(R&(v^D)^D|0,c&(e^Q)^Q|0,0|M,0|r)),0|o(),h^C^d|0,0|x)),0|o(),0|y,0|t)),0|o(),0|p,0|H)),0|(p=0|o()),0|i,0|Y),i=0|o(),a[B+8>>2]=Y,a[B+8+4>>2]=i,t=0|bB(n,b,28),y=0|o(),x=0|bB(n,b,34),y=(0|o())^y,d=0|bB(n,b,39),y^=0|o(),y=0|bC(0|(p=0|bC(0|H,0|p,n&(E|_)|E&_|0,b&(u|L)|u&L|0)),0|o(),x^t^d|0,0|y),d=0|o(),a[B+40>>2]=y,a[B+40+4>>2]=d,t=0|bB(Y,i,14),x=0|o(),p=0|bB(Y,i,18),x=(0|o())^x,H=0|bB(Y,i,41),x^=0|o(),h=0|a[g+((C=3|f)<<3)>>2],r=0|a[g+(C<<3)+4>>2],M=0|a[32976+(C<<3)>>2],w=0|a[32976+(C<<3)+4>>2],L=0|bC(0|(w=0|bC(0|(r=0|bC(0|(x=0|bC(0|(Q=0|bC(Y&(R^v)^v|0,i&(c^e)^e|0,0|D,0|Q)),0|o(),p^t^H|0,0|x)),0|o(),0|h,0|r)),0|o(),0|M,0|w)),0|(M=0|o()),0|_,0|L),_=0|o(),a[B>>2]=L,a[B+4>>2]=_,r=0|bB(y,d,28),h=0|o(),x=0|bB(y,d,34),h=(0|o())^h,H=0|bB(y,d,39),h^=0|o(),h=0|bC(0|(M=0|bC(0|w,0|M,y&(n|E)|n&E|0,d&(b|u)|b&u|0)),0|o(),x^r^H|0,0|h),H=0|o(),a[B+32>>2]=h,a[B+32+4>>2]=H,r=0|bB(L,_,14),x=0|o(),M=0|bB(L,_,18),x=(0|o())^x,w=0|bB(L,_,41),x^=0|o(),p=0|a[g+((t=4|f)<<3)>>2],Q=0|a[g+(t<<3)+4>>2],D=0|a[32976+(t<<3)>>2],J=0|a[32976+(t<<3)+4>>2],u=0|bC(0|(J=0|bC(0|(Q=0|bC(0|(x=0|bC(0|(e=0|bC(L&(Y^R)^R|0,_&(i^c)^c|0,0|v,0|e)),0|o(),M^r^w|0,0|x)),0|o(),0|p,0|Q)),0|o(),0|D,0|J)),0|(D=0|o()),0|E,0|u),E=0|o(),a[B+56>>2]=u,a[B+56+4>>2]=E,Q=0|bB(h,H,28),p=0|o(),x=0|bB(h,H,34),p=(0|o())^p,w=0|bB(h,H,39),p^=0|o(),p=0|bC(0|(D=0|bC(0|J,0|D,h&(y|n)|y&n|0,H&(d|b)|d&b|0)),0|o(),x^Q^w|0,0|p),w=0|o(),a[B+24>>2]=p,a[B+24+4>>2]=w,Q=0|bB(u,E,14),x=0|o(),D=0|bB(u,E,18),x=(0|o())^x,J=0|bB(u,E,41),x^=0|o(),M=0|a[g+((r=5|f)<<3)>>2],e=0|a[g+(r<<3)+4>>2],v=0|a[32976+(r<<3)>>2],G=0|a[32976+(r<<3)+4>>2],b=0|bC(0|(G=0|bC(0|(e=0|bC(0|(x=0|bC(0|(c=0|bC(u&(L^Y)^Y|0,E&(_^i)^i|0,0|R,0|c)),0|o(),D^Q^J|0,0|x)),0|o(),0|M,0|e)),0|o(),0|v,0|G)),0|(v=0|o()),0|n,0|b),n=0|o(),a[B+48>>2]=b,a[B+48+4>>2]=n,e=0|bB(p,w,28),M=0|o(),x=0|bB(p,w,34),M=(0|o())^M,J=0|bB(p,w,39),M^=0|o(),M=0|bC(0|(v=0|bC(0|G,0|v,p&(h|y)|h&y|0,w&(H|d)|H&d|0)),0|o(),x^e^J|0,0|M),J=0|o(),a[B+16>>2]=M,a[B+16+4>>2]=J,e=0|bB(b,n,14),x=0|o(),v=0|bB(b,n,18),x=(0|o())^x,G=0|bB(b,n,41),x^=0|o(),D=0|a[g+((Q=6|f)<<3)>>2],c=0|a[g+(Q<<3)+4>>2],R=0|a[32976+(Q<<3)>>2],N=0|a[32976+(Q<<3)+4>>2],d=0|bC(0|(N=0|bC(0|(c=0|bC(0|(x=0|bC(0|(i=0|bC(b&(u^L)^L|0,n&(E^_)^_|0,0|Y,0|i)),0|o(),v^e^G|0,0|x)),0|o(),0|D,0|c)),0|o(),0|R,0|N)),0|(R=0|o()),0|y,0|d),y=0|o(),a[B+40>>2]=d,a[B+40+4>>2]=y,c=0|bB(M,J,28),D=0|o(),x=0|bB(M,J,34),D=(0|o())^D,G=0|bB(M,J,39),D^=0|o(),D=0|bC(0|(R=0|bC(0|N,0|R,M&(p|h)|p&h|0,J&(w|H)|w&H|0)),0|o(),x^c^G|0,0|D),G=0|o(),a[B+8>>2]=D,a[B+8+4>>2]=G,c=0|bB(d,y,14),x=0|o(),R=0|bB(d,y,18),x=(0|o())^x,N=0|bB(d,y,41),x^=0|o(),v=0|a[g+((e=7|f)<<3)>>2],i=0|a[g+(e<<3)+4>>2],Y=0|a[32976+(e<<3)>>2],P=0|a[32976+(e<<3)+4>>2],H=0|bC(0|(P=0|bC(0|(i=0|bC(0|(x=0|bC(0|(_=0|bC(d&(b^u)^u|0,y&(n^E)^E|0,0|L,0|_)),0|o(),R^c^N|0,0|x)),0|o(),0|v,0|i)),0|o(),0|Y,0|P)),0|(Y=0|o()),0|h,0|H),h=0|o(),a[B+32>>2]=H,a[B+32+4>>2]=h,i=0|bB(D,G,28),v=0|o(),x=0|bB(D,G,34),v=(0|o())^v,N=0|bB(D,G,39),v^=0|o(),v=0|bC(0|(Y=0|bC(0|P,0|Y,D&(M|p)|M&p|0,G&(J|w)|J&w|0)),0|o(),x^i^N|0,0|v),N=0|o(),a[B>>2]=v,a[B+4>>2]=N,i=0|bB(H,h,14),x=0|o(),Y=0|bB(H,h,18),x=(0|o())^x,P=0|bB(H,h,41),x^=0|o(),R=0|a[g+((c=8|f)<<3)>>2],_=0|a[g+(c<<3)+4>>2],L=0|a[32976+(c<<3)>>2],K=0|a[32976+(c<<3)+4>>2],w=0|bC(0|(K=0|bC(0|(_=0|bC(0|(x=0|bC(0|(E=0|bC(H&(d^b)^b|0,h&(y^n)^n|0,0|u,0|E)),0|o(),Y^i^P|0,0|x)),0|o(),0|R,0|_)),0|o(),0|L,0|K)),0|(L=0|o()),0|p,0|w),p=0|o(),a[B+24>>2]=w,a[B+24+4>>2]=p,_=0|bB(v,N,28),R=0|o(),x=0|bB(v,N,34),R=(0|o())^R,P=0|bB(v,N,39),R^=0|o(),R=0|bC(0|(L=0|bC(0|K,0|L,v&(D|M)|D&M|0,N&(G|J)|G&J|0)),0|o(),x^_^P|0,0|R),P=0|o(),a[B+56>>2]=R,a[B+56+4>>2]=P,_=0|bB(w,p,14),x=0|o(),L=0|bB(w,p,18),x=(0|o())^x,K=0|bB(w,p,41),x^=0|o(),Y=0|a[g+((i=9|f)<<3)>>2],E=0|a[g+(i<<3)+4>>2],u=0|a[32976+(i<<3)>>2],q=0|a[32976+(i<<3)+4>>2],J=0|bC(0|(q=0|bC(0|(E=0|bC(0|(x=0|bC(0|(n=0|bC(w&(H^d)^d|0,p&(h^y)^y|0,0|b,0|n)),0|o(),L^_^K|0,0|x)),0|o(),0|Y,0|E)),0|o(),0|u,0|q)),0|(u=0|o()),0|M,0|J),M=0|o(),a[B+16>>2]=J,a[B+16+4>>2]=M,E=0|bB(R,P,28),Y=0|o(),x=0|bB(R,P,34),Y=(0|o())^Y,K=0|bB(R,P,39),Y^=0|o(),Y=0|bC(0|(u=0|bC(0|q,0|u,R&(v|D)|v&D|0,P&(N|G)|N&G|0)),0|o(),x^E^K|0,0|Y),K=0|o(),a[B+48>>2]=Y,a[B+48+4>>2]=K,E=0|bB(J,M,14),x=0|o(),u=0|bB(J,M,18),x=(0|o())^x,q=0|bB(J,M,41),x^=0|o(),L=0|a[g+((_=10|f)<<3)>>2],n=0|a[g+(_<<3)+4>>2],b=0|a[32976+(_<<3)>>2],l=0|a[32976+(_<<3)+4>>2],G=0|bC(0|(l=0|bC(0|(n=0|bC(0|(x=0|bC(0|(y=0|bC(J&(w^H)^H|0,M&(p^h)^h|0,0|d,0|y)),0|o(),u^E^q|0,0|x)),0|o(),0|L,0|n)),0|o(),0|b,0|l)),0|(b=0|o()),0|D,0|G),D=0|o(),a[B+8>>2]=G,a[B+8+4>>2]=D,n=0|bB(Y,K,28),L=0|o(),x=0|bB(Y,K,34),L=(0|o())^L,q=0|bB(Y,K,39),L^=0|o(),L=0|bC(0|(b=0|bC(0|l,0|b,Y&(R|v)|R&v|0,K&(P|N)|P&N|0)),0|o(),x^n^q|0,0|L),q=0|o(),a[B+40>>2]=L,a[B+40+4>>2]=q,n=0|bB(G,D,14),x=0|o(),b=0|bB(G,D,18),x=(0|o())^x,l=0|bB(G,D,41),x^=0|o(),u=0|a[g+((E=11|f)<<3)>>2],y=0|a[g+(E<<3)+4>>2],d=0|a[32976+(E<<3)>>2],m=0|a[32976+(E<<3)+4>>2],N=0|bC(0|(m=0|bC(0|(y=0|bC(0|(x=0|bC(0|(h=0|bC(G&(J^w)^w|0,D&(M^p)^p|0,0|H,0|h)),0|o(),b^n^l|0,0|x)),0|o(),0|u,0|y)),0|o(),0|d,0|m)),0|(d=0|o()),0|v,0|N),v=0|o(),a[B>>2]=N,a[B+4>>2]=v,y=0|bB(L,q,28),u=0|o(),x=0|bB(L,q,34),u=(0|o())^u,l=0|bB(L,q,39),u^=0|o(),u=0|bC(0|(d=0|bC(0|m,0|d,L&(Y|R)|Y&R|0,q&(K|P)|K&P|0)),0|o(),x^y^l|0,0|u),l=0|o(),a[B+32>>2]=u,a[B+32+4>>2]=l,y=0|bB(N,v,14),x=0|o(),d=0|bB(N,v,18),x=(0|o())^x,m=0|bB(N,v,41),x^=0|o(),b=0|a[g+((n=12|f)<<3)>>2],h=0|a[g+(n<<3)+4>>2],H=0|a[32976+(n<<3)>>2],F=0|a[32976+(n<<3)+4>>2],P=0|bC(0|(F=0|bC(0|(h=0|bC(0|(x=0|bC(0|(p=0|bC(N&(G^J)^J|0,v&(D^M)^M|0,0|w,0|p)),0|o(),d^y^m|0,0|x)),0|o(),0|b,0|h)),0|o(),0|H,0|F)),0|(H=0|o()),0|R,0|P),R=0|o(),a[B+56>>2]=P,a[B+56+4>>2]=R,h=0|bB(u,l,28),b=0|o(),x=0|bB(u,l,34),b=(0|o())^b,m=0|bB(u,l,39),b^=0|o(),b=0|bC(0|(H=0|bC(0|F,0|H,u&(L|Y)|L&Y|0,l&(q|K)|q&K|0)),0|o(),x^h^m|0,0|b),m=0|o(),a[B+24>>2]=b,a[B+24+4>>2]=m,h=0|bB(P,R,14),x=0|o(),H=0|bB(P,R,18),x=(0|o())^x,F=0|bB(P,R,41),x^=0|o(),d=0|a[g+((y=13|f)<<3)>>2],p=0|a[g+(y<<3)+4>>2],w=0|a[32976+(y<<3)>>2],k=0|a[32976+(y<<3)+4>>2],K=0|bC(0|(k=0|bC(0|(p=0|bC(0|(x=0|bC(0|(M=0|bC(P&(N^G)^G|0,R&(v^D)^D|0,0|J,0|M)),0|o(),H^h^F|0,0|x)),0|o(),0|d,0|p)),0|o(),0|w,0|k)),0|(w=0|o()),0|Y,0|K),Y=0|o(),a[B+48>>2]=K,a[B+48+4>>2]=Y,p=0|bB(b,m,28),d=0|o(),x=0|bB(b,m,34),d=(0|o())^d,F=0|bB(b,m,39),d^=0|o(),d=0|bC(0|(w=0|bC(0|k,0|w,b&(u|L)|u&L|0,m&(l|q)|l&q|0)),0|o(),x^p^F|0,0|d),F=0|o(),a[B+16>>2]=d,a[B+16+4>>2]=F,p=0|bB(K,Y,14),x=0|o(),w=0|bB(K,Y,18),x=(0|o())^x,k=0|bB(K,Y,41),x^=0|o(),H=0|a[g+((h=14|f)<<3)>>2],M=0|a[g+(h<<3)+4>>2],J=0|a[32976+(h<<3)>>2],U=0|a[32976+(h<<3)+4>>2],q=0|bC(0|(U=0|bC(0|(M=0|bC(0|(x=0|bC(0|(D=0|bC(K&(P^N)^N|0,Y&(R^v)^v|0,0|G,0|D)),0|o(),w^p^k|0,0|x)),0|o(),0|H,0|M)),0|o(),0|J,0|U)),0|(J=0|o()),0|L,0|q),L=0|o(),a[B+40>>2]=q,a[B+40+4>>2]=L,M=0|bB(d,F,28),H=0|o(),x=0|bB(d,F,34),H=(0|o())^H,k=0|bB(d,F,39),H^=0|o(),H=0|bC(0|(J=0|bC(0|U,0|J,d&(b|u)|b&u|0,F&(m|l)|m&l|0)),0|o(),x^M^k|0,0|H),k=0|o(),a[B+8>>2]=H,a[B+8+4>>2]=k,M=0|bB(q,L,14),x=0|o(),J=0|bB(q,L,18),x=(0|o())^x,U=0|bB(q,L,41),x^=0|o(),w=0|a[g+((p=15|f)<<3)>>2],D=0|a[g+(p<<3)+4>>2],G=0|a[32976+(p<<3)>>2],S=0|a[32976+(p<<3)+4>>2],l=0|bC(0|(S=0|bC(0|(D=0|bC(0|(x=0|bC(0|(v=0|bC(q&(K^P)^P|0,L&(Y^R)^R|0,0|N,0|v)),0|o(),J^M^U|0,0|x)),0|o(),0|w,0|D)),0|o(),0|G,0|S)),0|(G=0|o()),0|u,0|l),u=0|o(),a[B+32>>2]=l,a[B+32+4>>2]=u,u=0|bB(H,k,28),l=0|o(),D=0|bB(H,k,34),l=(0|o())^l,w=0|bB(H,k,39),l^=0|o(),l=0|bC(0|(m=0|bC(0|S,0|G,H&(d|b)|d&b|0,k&(F|m)|F&m|0)),0|o(),D^u^w|0,0|l),w=0|o(),a[B>>2]=l,a[B+4>>2]=w,64==(0|f))break;d=0|bB(K=0|a[g+(h<<3)>>2],q=0|a[g+(h<<3)+4>>2],19),R=0|o(),D=0|bB(K,q,61),m=0|o(),m=0|bC((N=0|CC(0|K,0|q,6))^d^D|0,0|(m=(0|o())^R^m),0|(R=0|a[g+(i<<3)>>2]),0|(H=0|a[g+(i<<3)+4>>2])),D=0|o(),M=0|bB(d=0|a[g+(s<<3)>>2],N=0|a[g+(s<<3)+4>>2],1),l=0|o(),Y=0|bB(d,N,8),v=0|o(),J=0|CC(0|d,0|N,7),v=(0|o())^l^v,v=0|bC(0|(l=0|bC(0|m,0|D,0|a[(l=g+(f<<3)|0)>>2],0|a[l+4>>2])),0|o(),J^M^Y|0,0|v),Y=0|o(),a[(M=g+((f=f+16|0)<<3)|0)>>2]=v,a[M+4>>2]=Y,l=0|bB(M=0|a[g+(p<<3)>>2],J=0|a[g+(p<<3)+4>>2],19),D=0|o(),m=0|bB(M,J,61),F=0|o(),w=0|CC(0|M,0|J,6),F=(0|o())^D^F,D=0|a[g+(s+9<<3)>>2],L=0|a[g+(s+9<<3)+4>>2],u=0|bB(k=0|a[g+(s+1<<3)>>2],G=0|a[g+(s+1<<3)+4>>2],1),x=0|o(),b=0|bB(k,G,8),S=0|o(),U=0|CC(0|k,0|G,7),S=(0|o())^x^S,S=0|bC(0|(F=0|bC(0|(N=0|bC(0|D,0|L,0|d,0|N)),0|o(),w^l^m|0,0|F)),0|o(),U^u^b|0,0|S),b=0|o(),a[g+(s+16<<3)>>2]=S,a[g+(s+16<<3)+4>>2]=b,u=0|bB(v,Y,19),U=0|o(),F=0|bB(v,Y,61),s=0|o(),s=0|bC((Y=0|CC(0|v,0|Y,6))^u^F|0,0|(s=(0|o())^U^s),0|(U=0|a[g+(E<<3)>>2]),0|(v=0|a[g+(E<<3)+4>>2])),F=0|o(),m=0|bB(u=0|a[g+(C<<3)>>2],Y=0|a[g+(C<<3)+4>>2],1),l=0|o(),w=0|bB(u,Y,8),N=0|o(),d=0|CC(0|u,0|Y,7),N=(0|o())^l^N,N=0|bC(0|(G=0|bC(0|s,0|F,0|k,0|G)),0|o(),d^m^w|0,0|N),w=0|o(),a[g+(I+16<<3)>>2]=N,a[g+(I+16<<3)+4>>2]=w,m=0|bB(S,b,19),d=0|o(),G=0|bB(S,b,61),k=0|o(),b=0|CC(0|S,0|b,6),k=(0|o())^d^k,d=0|a[g+(C+9<<3)>>2],S=0|a[g+(C+9<<3)+4>>2],s=0|bB(F=0|a[g+(C+1<<3)>>2],I=0|a[g+(C+1<<3)+4>>2],1),l=0|o(),L=0|bB(F,I,8),D=0|o(),x=0|CC(0|F,0|I,7),D=(0|o())^l^D,D=0|bC(0|(k=0|bC(0|(Y=0|bC(0|d,0|S,0|u,0|Y)),0|o(),b^m^G|0,0|k)),0|o(),x^s^L|0,0|D),L=0|o(),a[g+(C+16<<3)>>2]=D,a[g+(C+16<<3)+4>>2]=L,s=0|bB(N,w,19),x=0|o(),k=0|bB(N,w,61),G=0|o(),G=0|bC((w=0|CC(0|N,0|w,6))^s^k|0,0|(G=(0|o())^x^G),0|(x=0|a[g+(y<<3)>>2]),0|(N=0|a[g+(y<<3)+4>>2])),k=0|o(),m=0|bB(s=0|a[g+(r<<3)>>2],w=0|a[g+(r<<3)+4>>2],1),b=0|o(),Y=0|bB(s,w,8),u=0|o(),S=0|CC(0|s,0|w,7),u=(0|o())^b^u,u=0|bC(0|(I=0|bC(0|G,0|k,0|F,0|I)),0|o(),S^m^Y|0,0|u),Y=0|o(),a[g+(t+16<<3)>>2]=u,a[g+(t+16<<3)+4>>2]=Y,m=0|bB(D,L,19),S=0|o(),I=0|bB(D,L,61),F=0|o(),L=0|CC(0|D,0|L,6),F=(0|o())^S^F,S=0|a[g+(r+9<<3)>>2],D=0|a[g+(r+9<<3)+4>>2],b=0|bB(k=0|a[g+(r+1<<3)>>2],G=0|a[g+(r+1<<3)+4>>2],1),d=0|o(),l=0|bB(k,G,8),P=0|o(),C=0|CC(0|k,0|G,7),P=(0|o())^d^P,P=0|bC(0|(F=0|bC(0|(w=0|bC(0|S,0|D,0|s,0|w)),0|o(),L^m^I|0,0|F)),0|o(),C^b^l|0,0|P),l=0|o(),a[g+(r+16<<3)>>2]=P,a[g+(r+16<<3)+4>>2]=l,b=0|bB(u,Y,19),C=0|o(),F=0|bB(u,Y,61),I=0|o(),I=0|bC((Y=0|CC(0|u,0|Y,6))^b^F|0,(0|o())^C^I|0,0|M,0|J),C=0|o(),Y=0|bB(F=0|a[g+(e<<3)>>2],b=0|a[g+(e<<3)+4>>2],1),u=0|o(),m=0|bB(F,b,8),L=0|o(),w=0|CC(0|F,0|b,7),L=(0|o())^u^L,L=0|bC(0|(G=0|bC(0|I,0|C,0|k,0|G)),0|o(),w^Y^m|0,0|L),m=0|o(),a[g+(Q+16<<3)>>2]=L,a[g+(Q+16<<3)+4>>2]=m,Y=0|bB(P,l,19),w=0|o(),G=0|bB(P,l,61),k=0|o(),l=0|CC(0|P,0|l,6),k=(0|o())^w^k,w=0|a[g+(e+9<<3)>>2],P=0|a[g+(e+9<<3)+4>>2],u=0|bB(C=0|a[g+(e+1<<3)>>2],I=0|a[g+(e+1<<3)+4>>2],1),s=0|o(),D=0|bB(C,I,8),S=0|o(),d=0|CC(0|C,0|I,7),S=(0|o())^s^S,S=0|bC(0|(k=0|bC(0|(b=0|bC(0|w,0|P,0|F,0|b)),0|o(),l^Y^G|0,0|k)),0|o(),d^u^D|0,0|S),D=0|o(),a[g+(e+16<<3)>>2]=S,a[g+(e+16<<3)+4>>2]=D,u=0|bB(L,m,19),d=0|o(),k=0|bB(L,m,61),G=0|o(),G=0|bC((m=0|CC(0|L,0|m,6))^u^k|0,0|(G=(0|o())^d^G),0|a[g+(c+9<<3)>>2],0|a[g+(c+9<<3)+4>>2]),k=0|o(),u=0|bB(R,H,1),m=0|o(),d=0|bB(R,H,8),L=0|o(),Y=0|CC(0|R,0|H,7),L=m^(0|o())^L,L=0|bC(0|(I=0|bC(0|G,0|k,0|C,0|I)),0|o(),u^Y^d|0,0|L),d=0|o(),a[g+(c+16<<3)>>2]=L,a[g+(c+16<<3)+4>>2]=d,Y=0|bB(S,D,19),u=0|o(),I=0|bB(S,D,61),C=0|o(),D=0|CC(0|S,0|D,6),C=(0|o())^u^C,u=0|a[g+(i+9<<3)>>2],S=0|a[g+(i+9<<3)+4>>2],m=0|bB(k=0|a[g+(i+1<<3)>>2],G=0|a[g+(i+1<<3)+4>>2],1),l=0|o(),b=0|bB(k,G,8),F=0|o(),P=0|CC(0|k,0|G,7),F=(0|o())^l^F,F=0|bC(0|(C=0|bC(0|(H=0|bC(0|u,0|S,0|R,0|H)),0|o(),D^Y^I|0,0|C)),0|o(),P^m^b|0,0|F),b=0|o(),a[g+(i+16<<3)>>2]=F,a[g+(i+16<<3)+4>>2]=b,m=0|bB(L,d,19),P=0|o(),C=0|bB(L,d,61),I=0|o(),I=0|bC((d=0|CC(0|L,0|d,6))^m^C|0,0|(I=(0|o())^P^I),0|a[g+(_+9<<3)>>2],0|a[g+(_+9<<3)+4>>2]),C=0|o(),m=0|bB(U,v,1),d=0|o(),P=0|bB(U,v,8),L=0|o(),Y=0|CC(0|U,0|v,7),L=d^(0|o())^L,L=0|bC(0|(G=0|bC(0|I,0|C,0|k,0|G)),0|o(),m^Y^P|0,0|L),P=0|o(),a[g+(_+16<<3)>>2]=L,a[g+(_+16<<3)+4>>2]=P,Y=0|bB(F,b,19),m=0|o(),G=0|bB(F,b,61),k=0|o(),b=0|CC(0|F,0|b,6),k=(0|o())^m^k,m=0|a[g+(E+9<<3)>>2],F=0|a[g+(E+9<<3)+4>>2],d=0|bB(C=0|a[g+(E+1<<3)>>2],I=0|a[g+(E+1<<3)+4>>2],1),D=0|o(),H=0|bB(C,I,8),R=0|o(),S=0|CC(0|C,0|I,7),R=(0|o())^D^R,R=0|bC(0|(k=0|bC(0|(v=0|bC(0|m,0|F,0|U,0|v)),0|o(),b^Y^G|0,0|k)),0|o(),S^d^H|0,0|R),H=0|o(),a[g+(E+16<<3)>>2]=R,a[g+(E+16<<3)+4>>2]=H,d=0|bB(L,P,19),S=0|o(),k=0|bB(L,P,61),G=0|o(),G=0|bC((P=0|CC(0|L,0|P,6))^d^k|0,0|(G=(0|o())^S^G),0|a[g+(n+9<<3)>>2],0|a[g+(n+9<<3)+4>>2]),k=0|o(),d=0|bB(x,N,1),P=0|o(),S=0|bB(x,N,8),L=0|o(),Y=0|CC(0|x,0|N,7),L=P^(0|o())^L,L=0|bC(0|(I=0|bC(0|G,0|k,0|C,0|I)),0|o(),d^Y^S|0,0|L),S=0|o(),a[g+(n+16<<3)>>2]=L,a[g+(n+16<<3)+4>>2]=S,Y=0|bB(R,H,19),d=0|o(),I=0|bB(R,H,61),C=0|o(),H=0|CC(0|R,0|H,6),C=(0|o())^d^C,d=0|a[g+(y+9<<3)>>2],R=0|a[g+(y+9<<3)+4>>2],P=0|bB(k=0|a[g+(y+1<<3)>>2],G=0|a[g+(y+1<<3)+4>>2],1),b=0|o(),v=0|bB(k,G,8),U=0|o(),G=0|CC(0|k,0|G,7),U=(0|o())^b^U,U=0|bC(0|(C=0|bC(0|(N=0|bC(0|d,0|R,0|x,0|N)),0|o(),H^Y^I|0,0|C)),0|o(),G^P^v|0,0|U),v=0|o(),a[g+(y+16<<3)>>2]=U,a[g+(y+16<<3)+4>>2]=v,P=0|bB(L,S,19),G=0|o(),C=0|bB(L,S,61),I=0|o(),S=0|CC(0|L,0|S,6),I=(0|o())^G^I,G=0|a[g+(h+9<<3)>>2],L=0|a[g+(h+9<<3)+4>>2],Y=0|bB(M,J,1),H=0|o(),N=0|bB(M,J,8),x=0|o(),R=0|CC(0|M,0|J,7),x=H^(0|o())^x,x=0|bC(0|(I=0|bC(0|(q=0|bC(0|G,0|L,0|K,0|q)),0|o(),S^P^C|0,0|I)),0|o(),Y^R^N|0,0|x),N=0|o(),a[g+(h+16<<3)>>2]=x,a[g+(h+16<<3)+4>>2]=N,N=0|bB(U,v,19),x=0|o(),R=0|bB(U,v,61),Y=0|o(),v=0|CC(0|U,0|v,6),Y=(0|o())^x^Y,x=0|a[g+(p+9<<3)>>2],U=0|a[g+(p+9<<3)+4>>2],P=0|bB(I=0|a[g+(p+1<<3)>>2],C=0|a[g+(p+1<<3)+4>>2],1),S=0|o(),q=0|bB(I,C,8),K=0|o(),L=0|CC(0|I,0|C,7),K=(0|o())^S^K,K=0|bC(0|(Y=0|bC(0|(J=0|bC(0|x,0|U,0|M,0|J)),0|o(),v^N^R|0,0|Y)),0|o(),L^P^q|0,0|K),q=0|o(),a[g+(p+16<<3)>>2]=K,a[g+(p+16<<3)+4>>2]=q}while(f>>>0<80);I=0;do{P=B+(I<<3)|0,P=0|bC(0|a[(q=A+(I<<3)|0)>>2],0|a[q+4>>2],0|a[P>>2],0|a[P+4>>2]),K=0|o(),a[q>>2]=P,a[q+4>>2]=K,I=I+1|0}while(8!=(0|I))}function u(A){A|=0;var I,g=0,B=0,C=0,t=0,r=0,Q=0,e=0,o=0,c=0,i=0,_=0,E=0,n=0,s=0,y=0,p=0,f=0,w=0,l=0,u=0;I=h,n=h=h+63&-64,h=h+16|0;do{if(A>>>0<245){if(E=A>>>0<11?16:A+11&-8,(i=0|a[8887])>>>(E>>>3)&3|0)return A=0|a[8+(B=35588+((i>>>(E>>>3)&1^1)+(E>>>3)<<1<<2)|0)>>2],(0|(g=0|a[A+8>>2]))==(0|B)?a[8887]=i&~(1<<(i>>>(E>>>3)&1^1)+(E>>>3)):(a[g+12>>2]=B,a[B+8>>2]=g),u=(i>>>(E>>>3)&1^1)+(E>>>3)<<3,a[A+4>>2]=3|u,a[A+u+4>>2]=1|a[A+u+4>>2],h=I,0|A+8;if(E>>>0>(_=0|a[8889])>>>0){if(i>>>(E>>>3)|0)return C=0|a[35588+((t=((C=(((A=i>>>(E>>>3)<<(E>>>3)&(2<<(E>>>3)|0-(2<<(E>>>3))))&0-A)-1|0)>>>(((A&0-A)-1|0)>>>12&16))>>>5&8|((A&0-A)-1|0)>>>12&16|C>>>(C>>>5&8)>>>2&4|(t=C>>>(C>>>5&8)>>>(C>>>(C>>>5&8)>>>2&4))>>>1&2|t>>>(t>>>1&2)>>>1&1)+(t>>>(t>>>1&2)>>>(t>>>(t>>>1&2)>>>1&1))|0)<<1<<2)+8>>2],(0|(A=0|a[C+8>>2]))==(35588+(t<<1<<2)|0)?(a[8887]=i&~(1<<t),A=i&~(1<<t)):(a[A+12>>2]=35588+(t<<1<<2),a[35588+(t<<1<<2)+8>>2]=A,A=i),a[C+4>>2]=3|E,a[C+E+4>>2]=(t<<3)-E|1,a[C+(t<<3)>>2]=(t<<3)-E,0|_&&(B=0|a[8892],A&1<<(_>>>3)?(A=35588+(_>>>3<<1<<2)+8|0,g=0|a[35588+(_>>>3<<1<<2)+8>>2]):(a[8887]=A|1<<(_>>>3),A=35588+(_>>>3<<1<<2)+8|0,g=35588+(_>>>3<<1<<2)|0),a[A>>2]=B,a[g+12>>2]=B,a[B+8>>2]=g,a[B+12>>2]=35588+(_>>>3<<1<<2)),a[8889]=(t<<3)-E,a[8892]=C+E,h=I,0|C+8;if(Q=0|a[8888]){for(c=0|a[35852+(((o=((Q&0-Q)-1|0)>>>(((Q&0-Q)-1|0)>>>12&16))>>>5&8|((Q&0-Q)-1|0)>>>12&16|o>>>(o>>>5&8)>>>2&4|(c=o>>>(o>>>5&8)>>>(o>>>(o>>>5&8)>>>2&4))>>>1&2|c>>>(c>>>1&2)>>>1&1)+(c>>>(c>>>1&2)>>>(c>>>(c>>>1&2)>>>1&1))<<2)>>2],o=(-8&a[c+4>>2])-E|0,g=c;(A=0|a[g+16>>2])||(A=0|a[g+20>>2]);)o=(e=(g=(-8&a[A+4>>2])-E|0)>>>0<o>>>0)?g:o,g=A,c=e?A:c;if((e=c+E|0)>>>0>c>>>0){t=0|a[c+24>>2],A=0|a[c+12>>2];do{if((0|A)==(0|c)){if(!(A=0|a[(g=c+20|0)>>2])&&!(A=0|a[(g=c+16|0)>>2])){g=0;break}for(;;)if(B=0|a[(C=A+20|0)>>2])A=B,g=C;else{if(!(B=0|a[(C=A+16|0)>>2]))break;A=B,g=C}a[g>>2]=0,g=A}else g=0|a[c+8>>2],a[g+12>>2]=A,a[A+8>>2]=g,g=A}while(0);do{if(0|t){if(A=0|a[c+28>>2],(0|c)==(0|a[35852+(A<<2)>>2])){if(a[35852+(A<<2)>>2]=g,!g){a[8888]=Q&~(1<<A);break}}else if(a[((0|a[t+16>>2])==(0|c)?t+16|0:t+20|0)>>2]=g,!g)break;a[g+24>>2]=t,0|(A=0|a[c+16>>2])&&(a[g+16>>2]=A,a[A+24>>2]=g),0|(A=0|a[c+20>>2])&&(a[g+20>>2]=A,a[A+24>>2]=g)}}while(0);return o>>>0<16?(u=o+E|0,a[c+4>>2]=3|u,a[(u=c+u+4|0)>>2]=1|a[u>>2]):(a[c+4>>2]=3|E,a[e+4>>2]=1|o,a[e+o>>2]=o,0|_&&(B=0|a[8892],1<<(_>>>3)&i?(A=35588+(_>>>3<<1<<2)+8|0,g=0|a[35588+(_>>>3<<1<<2)+8>>2]):(a[8887]=1<<(_>>>3)|i,A=35588+(_>>>3<<1<<2)+8|0,g=35588+(_>>>3<<1<<2)|0),a[A>>2]=B,a[g+12>>2]=B,a[B+8>>2]=g,a[B+12>>2]=35588+(_>>>3<<1<<2)),a[8889]=o,a[8892]=e),h=I,0|c+8}}}}else if(A>>>0<=4294967231){if(E=A+11&-8,C=0|a[8888]){o=(A+11|0)>>>8?E>>>0>16777215?31:E>>>(7+(o=14-((520192+(o=(A+11|0)>>>8<<((1048320+((A+11|0)>>>8)|0)>>>16&8))|0)>>>16&4|(1048320+((A+11|0)>>>8)|0)>>>16&8|(245760+(o<<((o+520192|0)>>>16&4))|0)>>>16&2)+(o<<((o+520192|0)>>>16&4)<<((245760+(o<<((o+520192|0)>>>16&4))|0)>>>16&2)>>>15)|0)|0)&1|o<<1:0,A=0|a[35852+(o<<2)>>2];A:do{if(A)for(B=0-E|0,g=0,e=E<<(31==(0|o)?0:25-(o>>>1)|0),Q=0;;){if((t=(-8&a[A+4>>2])-E|0)>>>0<B>>>0){if(!t){B=0,g=A,p=65;break A}B=t,Q=A}if(g=0==(0|(p=0|a[A+20>>2]))|(0|p)==(0|(A=0|a[A+16+(e>>>31<<2)>>2]))?g:p,!A){A=Q,p=61;break}e<<=1}else B=0-E|0,g=0,A=0,p=61}while(0);if(61==(0|p)){if(0==(0|g)&0==(0|A)){if(!(((A=2<<o)|0-A)&C))break;g=0|a[35852+(((_=((A|0-A)&C&0-((A|0-A)&C))-1|0)>>>(_>>>12&16)>>>5&8|_>>>12&16|(A=_>>>(_>>>12&16)>>>(_>>>(_>>>12&16)>>>5&8))>>>2&4|A>>>(A>>>2&4)>>>1&2|(g=A>>>(A>>>2&4)>>>(A>>>(A>>>2&4)>>>1&2))>>>1&1)+(g>>>(g>>>1&1))<<2)>>2],A=0}g?p=65:(Q=B,e=A)}if(65==(0|p))for(;;){if(B=(t=(_=(-8&a[g+4>>2])-E|0)>>>0<B>>>0)?_:B,t=t?g:A,(A=0|a[g+16>>2])||(A=0|a[g+20>>2]),!A){Q=B,e=t;break}g=A,A=t}if(0!=(0|e)&&Q>>>0<((0|a[8889])-E|0)>>>0&&(c=e+E|0)>>>0>e>>>0){r=0|a[e+24>>2],A=0|a[e+12>>2];do{if((0|A)==(0|e)){if(!(A=0|a[(g=e+20|0)>>2])&&!(A=0|a[(g=e+16|0)>>2])){A=0;break}for(;;)if(B=0|a[(t=A+20|0)>>2])A=B,g=t;else{if(!(B=0|a[(t=A+16|0)>>2]))break;A=B,g=t}a[g>>2]=0}else u=0|a[e+8>>2],a[u+12>>2]=A,a[A+8>>2]=u}while(0);do{if(r){if(g=0|a[e+28>>2],(0|e)==(0|a[35852+(g<<2)>>2])){if(a[35852+(g<<2)>>2]=A,!A){a[8888]=C&~(1<<g),C&=~(1<<g);break}}else if(a[((0|a[r+16>>2])==(0|e)?r+16|0:r+20|0)>>2]=A,!A)break;a[A+24>>2]=r,0|(g=0|a[e+16>>2])&&(a[A+16>>2]=g,a[g+24>>2]=A),(g=0|a[e+20>>2])&&(a[A+20>>2]=g,a[g+24>>2]=A)}}while(0);A:do{if(Q>>>0<16)u=Q+E|0,a[e+4>>2]=3|u,a[(u=e+u+4|0)>>2]=1|a[u>>2];else{if(a[e+4>>2]=3|E,a[c+4>>2]=1|Q,a[c+Q>>2]=Q,B=Q>>>3,Q>>>0<256){(A=0|a[8887])&1<<B?(A=35588+(B<<1<<2)+8|0,g=0|a[35588+(B<<1<<2)+8>>2]):(a[8887]=A|1<<B,A=35588+(B<<1<<2)+8|0,g=35588+(B<<1<<2)|0),a[A>>2]=c,a[g+12>>2]=c,a[c+8>>2]=g,a[c+12>>2]=35588+(B<<1<<2);break}if(A=35852+((B=(A=Q>>>8)?Q>>>0>16777215?31:Q>>>(7+(B=14-((520192+(A<<((A+1048320|0)>>>16&8))|0)>>>16&4|(A+1048320|0)>>>16&8|(245760+(B=A<<((A+1048320|0)>>>16&8)<<((520192+(A<<((A+1048320|0)>>>16&8))|0)>>>16&4))|0)>>>16&2)+(B<<((B+245760|0)>>>16&2)>>>15)|0)|0)&1|B<<1:0)<<2)|0,a[c+28>>2]=B,a[c+16+4>>2]=0,a[c+16>>2]=0,!(C&(g=1<<B))){a[8888]=C|g,a[A>>2]=c,a[c+24>>2]=A,a[c+12>>2]=c,a[c+8>>2]=c;break}A=0|a[A>>2];I:do{if((-8&a[A+4>>2]|0)!=(0|Q)){for(C=Q<<(31==(0|B)?0:25-(B>>>1)|0);g=0|a[(B=A+16+(C>>>31<<2)|0)>>2];){if((-8&a[g+4>>2]|0)==(0|Q)){A=g;break I}C<<=1,A=g}a[B>>2]=c,a[c+24>>2]=A,a[c+12>>2]=c,a[c+8>>2]=c;break A}}while(0);u=0|a[(l=A+8|0)>>2],a[u+12>>2]=c,a[l>>2]=c,a[c+8>>2]=u,a[c+12>>2]=A,a[c+24>>2]=0}}while(0);return h=I,0|e+8}}}else E=-1}while(0);if((B=0|a[8889])>>>0>=E>>>0)return g=B-E|0,A=0|a[8892],g>>>0>15?(u=A+E|0,a[8892]=u,a[8889]=g,a[u+4>>2]=1|g,a[A+B>>2]=g,a[A+4>>2]=3|E):(a[8889]=0,a[8892]=0,a[A+4>>2]=3|B,a[A+B+4>>2]=1|a[A+B+4>>2]),h=I,0|A+8;if((t=0|a[8890])>>>0>E>>>0)return w=t-E|0,a[8890]=w,l=(u=0|a[8893])+E|0,a[8893]=l,a[l+4>>2]=1|w,a[u+4>>2]=3|E,h=I,0|u+8;if(0|a[9005]?A=0|a[9007]:(a[9007]=4096,a[9006]=4096,a[9008]=-1,a[9009]=-1,a[9010]=0,a[8998]=0,a[9005]=-16&n^1431655768,A=4096),Q=E+48|0,((c=A+(e=E+47|0)|0)&(o=0-A|0))>>>0<=E>>>0)return h=I,0;if(0|(A=0|a[8997])&&(((n=0|a[8995])+(c&o)|0)>>>0<=n>>>0||(n+(c&o)|0)>>>0>A>>>0))return h=I,0;A:do{if(4&a[8998])A=0,p=143;else{g=0|a[8893];I:do{if(g){for(B=35996;!((A=0|a[B>>2])>>>0<=g>>>0&&(A+(0|a[(y=B+4|0)>>2])|0)>>>0>g>>>0);){if(!(A=0|a[B+8>>2])){p=128;break I}B=A}if((c-t&o)>>>0<2147483647)if((0|(A=0|AB(c-t&o)))==((0|a[B>>2])+(0|a[y>>2])|0)){if(-1!=(0|A)){Q=A,r=c-t&o,p=145;break A}A=c-t&o}else C=A,B=c-t&o,p=136;else A=0}else p=128}while(0);do{if(128==(0|p))if(-1!=(0|(g=0|AB(0)))&&(r=(0==((r=0|a[9006])-1&g|0)?0:(r+-1+g&0-r)-g|0)+(c&o)|0,s=0|a[8995],r>>>0>E>>>0&r>>>0<2147483647)){if(0|(y=0|a[8997])&&(r+s|0)>>>0<=s>>>0|(r+s|0)>>>0>y>>>0){A=0;break}if((0|(A=0|AB(r)))==(0|g)){Q=g,p=145;break A}C=A,B=r,p=136}else A=0}while(0);do{if(136==(0|p)){if(g=0-B|0,!(Q>>>0>B>>>0&B>>>0<2147483647&-1!=(0|C))){if(-1==(0|C)){A=0;break}Q=C,r=B,p=145;break A}if((A=e-B+(A=0|a[9007])&0-A)>>>0>=2147483647){Q=C,r=B,p=145;break A}if(-1==(0|AB(A))){AB(g),A=0;break}Q=C,r=A+B|0,p=145;break A}}while(0);a[8998]=4|a[8998],p=143}}while(0);if(143==(0|p)&&(c&o)>>>0<2147483647&&!(-1==(0|(f=0|AB(c&o)))|1^(l=((w=0|AB(0))-f|0)>>>0>(E+40|0)>>>0)|f>>>0<w>>>0&-1!=(0|f)&-1!=(0|w)^1)&&(Q=f,r=l?w-f|0:A,p=145),145==(0|p)){A=(0|a[8995])+r|0,a[8995]=A,A>>>0>(0|a[8996])>>>0&&(a[8996]=A),o=0|a[8893];A:do{if(o){for(t=35996;;){if((0|Q)==((A=0|a[t>>2])+(g=0|a[(C=t+4|0)>>2])|0)){p=154;break}if(!(B=0|a[t+8>>2]))break;t=B}if(154==(0|p)&&0==(8&a[t+12>>2]|0)&&Q>>>0>o>>>0&A>>>0<=o>>>0){a[C>>2]=g+r,u=(0|a[8890])+r|0,l=0==(o+8&7|0)?0:0-(o+8)&7,a[8893]=o+l,a[8890]=u-l,a[o+l+4>>2]=u-l|1,a[o+u+4>>2]=40,a[8894]=a[9009];break}for(Q>>>0<(0|a[8891])>>>0&&(a[8891]=Q),B=Q+r|0,g=35996;;){if((0|a[g>>2])==(0|B)){p=162;break}if(!(A=0|a[g+8>>2]))break;g=A}if(162==(0|p)&&0==(8&a[g+12>>2]|0)){a[g>>2]=Q,a[(i=g+4|0)>>2]=(0|a[i>>2])+r,c=(i=Q+(0==(7&(i=Q+8|0)|0)?0:0-i&7)|0)+E|0,e=(A=B+(0==(B+8&7|0)?0:0-(B+8)&7)|0)-i-E|0,a[i+4>>2]=3|E;I:do{if((0|o)==(0|A))u=(0|a[8890])+e|0,a[8890]=u,a[8893]=c,a[c+4>>2]=1|u;else{if((0|a[8892])==(0|A)){u=(0|a[8889])+e|0,a[8889]=u,a[8892]=c,a[c+4>>2]=1|u,a[c+u>>2]=u;break}if(1==(3&(Q=0|a[A+4>>2])|0)){g:do{if(Q>>>0<256){if(g=0|a[A+8>>2],(0|(B=0|a[A+12>>2]))==(0|g)){a[8887]=a[8887]&~(1<<(Q>>>3));break}a[g+12>>2]=B,a[B+8>>2]=g;break}r=0|a[A+24>>2],g=0|a[A+12>>2];do{if((0|g)==(0|A)){if(g=0|a[A+16+4>>2])B=A+16+4|0;else{if(!(g=0|a[A+16>>2])){g=0;break}B=A+16|0}for(;;)if(C=0|a[(t=g+20|0)>>2])g=C,B=t;else{if(!(C=0|a[(t=g+16|0)>>2]))break;g=C,B=t}a[B>>2]=0}else u=0|a[A+8>>2],a[u+12>>2]=g,a[g+8>>2]=u}while(0);if(!r)break;B=0|a[A+28>>2];do{if((0|a[35852+(B<<2)>>2])==(0|A)){if(a[35852+(B<<2)>>2]=g,0|g)break;a[8888]=a[8888]&~(1<<B);break g}if(a[((0|a[r+16>>2])==(0|A)?r+16|0:r+20|0)>>2]=g,!g)break g}while(0);if(a[g+24>>2]=r,0|(B=0|a[A+16>>2])&&(a[g+16>>2]=B,a[B+24>>2]=g),!(B=0|a[A+16+4>>2]))break;a[g+20>>2]=B,a[B+24>>2]=g}while(0);A=A+(-8&Q)|0,t=(-8&Q)+e|0}else t=e;if(a[(B=A+4|0)>>2]=-2&a[B>>2],a[c+4>>2]=1|t,a[c+t>>2]=t,B=t>>>3,t>>>0<256){(A=0|a[8887])&1<<B?(A=35588+(B<<1<<2)+8|0,g=0|a[35588+(B<<1<<2)+8>>2]):(a[8887]=A|1<<B,A=35588+(B<<1<<2)+8|0,g=35588+(B<<1<<2)|0),a[A>>2]=c,a[g+12>>2]=c,a[c+8>>2]=g,a[c+12>>2]=35588+(B<<1<<2);break}A=t>>>8;do{if(A){if(t>>>0>16777215){C=31;break}C=t>>>(7+(C=14-((520192+(A<<((A+1048320|0)>>>16&8))|0)>>>16&4|(A+1048320|0)>>>16&8|(245760+(C=A<<((A+1048320|0)>>>16&8)<<((520192+(A<<((A+1048320|0)>>>16&8))|0)>>>16&4))|0)>>>16&2)+(C<<((C+245760|0)>>>16&2)>>>15)|0)|0)&1|C<<1}else C=0}while(0);if(g=35852+(C<<2)|0,a[c+28>>2]=C,a[c+16+4>>2]=0,a[c+16>>2]=0,!((A=0|a[8888])&(B=1<<C))){a[8888]=A|B,a[g>>2]=c,a[c+24>>2]=g,a[c+12>>2]=c,a[c+8>>2]=c;break}A=0|a[g>>2];g:do{if((-8&a[A+4>>2]|0)!=(0|t)){for(C=t<<(31==(0|C)?0:25-(C>>>1)|0);g=0|a[(B=A+16+(C>>>31<<2)|0)>>2];){if((-8&a[g+4>>2]|0)==(0|t)){A=g;break g}C<<=1,A=g}a[B>>2]=c,a[c+24>>2]=A,a[c+12>>2]=c,a[c+8>>2]=c;break I}}while(0);u=0|a[(l=A+8|0)>>2],a[u+12>>2]=c,a[l>>2]=c,a[c+8>>2]=u,a[c+12>>2]=A,a[c+24>>2]=0}}while(0);return h=I,0|i+8}for(g=35996;!((A=0|a[g>>2])>>>0<=o>>>0&&(u=A+(0|a[g+4>>2])|0)>>>0>o>>>0);)g=0|a[g+8>>2];t=(t=u+-47+(0==(u+-47+8&7|0)?0:0-(u+-47+8)&7)|0)>>>0<(o+16|0)>>>0?o:t,A=r+-40|0,l=Q+(w=0==(7&(w=Q+8|0)|0)?0:0-w&7)|0,a[8893]=l,a[8890]=A-w,a[l+4>>2]=A-w|1,a[Q+A+4>>2]=40,a[8894]=a[9009],a[t+4>>2]=27,a[t+8>>2]=a[8999],a[t+8+4>>2]=a[9e3],a[t+8+8>>2]=a[9001],a[t+8+12>>2]=a[9002],a[8999]=Q,a[9e3]=r,a[9002]=0,a[9001]=t+8,A=t+24|0;do{l=A,a[(A=A+4|0)>>2]=7}while((l+8|0)>>>0<u>>>0);if((0|t)!=(0|o)){if(a[t+4>>2]=-2&a[t+4>>2],a[o+4>>2]=t-o|1,a[t>>2]=t-o,(t-o|0)>>>0<256){B=35588+((t-o|0)>>>3<<1<<2)|0,(A=0|a[8887])&1<<((t-o|0)>>>3)?(A=B+8|0,g=0|a[B+8>>2]):(a[8887]=A|1<<((t-o|0)>>>3),A=B+8|0,g=B),a[A>>2]=o,a[g+12>>2]=o,a[o+8>>2]=g,a[o+12>>2]=B;break}if(g=35852+((C=(t-o|0)>>>8?(t-o|0)>>>0>16777215?31:(t-o|0)>>>(7+(C=14-((520192+(C=(t-o|0)>>>8<<((1048320+((t-o|0)>>>8)|0)>>>16&8))|0)>>>16&4|(1048320+((t-o|0)>>>8)|0)>>>16&8|(245760+(C<<((C+520192|0)>>>16&4))|0)>>>16&2)+(C<<((C+520192|0)>>>16&4)<<((245760+(C<<((C+520192|0)>>>16&4))|0)>>>16&2)>>>15)|0)|0)&1|C<<1:0)<<2)|0,a[o+28>>2]=C,a[o+20>>2]=0,a[o+16>>2]=0,!((A=0|a[8888])&(B=1<<C))){a[8888]=A|B,a[g>>2]=o,a[o+24>>2]=g,a[o+12>>2]=o,a[o+8>>2]=o;break}A=0|a[g>>2];I:do{if((-8&a[A+4>>2]|0)!=(t-o|0)){for(C=t-o<<(31==(0|C)?0:25-(C>>>1)|0);g=0|a[(B=A+16+(C>>>31<<2)|0)>>2];){if((-8&a[g+4>>2]|0)==(t-o|0)){A=g;break I}C<<=1,A=g}a[B>>2]=o,a[o+24>>2]=A,a[o+12>>2]=o,a[o+8>>2]=o;break A}}while(0);u=0|a[(l=A+8|0)>>2],a[u+12>>2]=o,a[l>>2]=o,a[o+8>>2]=u,a[o+12>>2]=A,a[o+24>>2]=0}}else 0==(0|(u=0|a[8891]))|Q>>>0<u>>>0&&(a[8891]=Q),a[8999]=Q,a[9e3]=r,a[9002]=0,a[8896]=a[9005],a[8895]=-1,a[8900]=35588,a[8899]=35588,a[8902]=35596,a[8901]=35596,a[8904]=35604,a[8903]=35604,a[8906]=35612,a[8905]=35612,a[8908]=35620,a[8907]=35620,a[8910]=35628,a[8909]=35628,a[8912]=35636,a[8911]=35636,a[8914]=35644,a[8913]=35644,a[8916]=35652,a[8915]=35652,a[8918]=35660,a[8917]=35660,a[8920]=35668,a[8919]=35668,a[8922]=35676,a[8921]=35676,a[8924]=35684,a[8923]=35684,a[8926]=35692,a[8925]=35692,a[8928]=35700,a[8927]=35700,a[8930]=35708,a[8929]=35708,a[8932]=35716,a[8931]=35716,a[8934]=35724,a[8933]=35724,a[8936]=35732,a[8935]=35732,a[8938]=35740,a[8937]=35740,a[8940]=35748,a[8939]=35748,a[8942]=35756,a[8941]=35756,a[8944]=35764,a[8943]=35764,a[8946]=35772,a[8945]=35772,a[8948]=35780,a[8947]=35780,a[8950]=35788,a[8949]=35788,a[8952]=35796,a[8951]=35796,a[8954]=35804,a[8953]=35804,a[8956]=35812,a[8955]=35812,a[8958]=35820,a[8957]=35820,a[8960]=35828,a[8959]=35828,a[8962]=35836,a[8961]=35836,u=r+-40|0,l=Q+(w=0==(7&(w=Q+8|0)|0)?0:0-w&7)|0,a[8893]=l,a[8890]=u-w,a[l+4>>2]=u-w|1,a[Q+u+4>>2]=40,a[8894]=a[9009]}while(0);if((A=0|a[8890])>>>0>E>>>0)return w=A-E|0,a[8890]=w,l=(u=0|a[8893])+E|0,a[8893]=l,a[l+4>>2]=1|w,a[u+4>>2]=3|E,h=I,0|u+8}return a[8886]=48,h=I,0}function D(A){var I,g,C,a,t=0,r=0,Q=0,e=0,c=0,i=0,_=0,E=0,n=0,s=0,y=0,h=0,p=0,f=0,w=0,l=0,u=0,D=0,m=0,F=0,k=0,b=0,d=0,H=0,G=0,S=0,x=0,U=0,M=0,J=0,v=0,N=0,R=0,Y=0,L=0,P=0,K=0,q=0,X=0,j=0,T=0,V=0,W=0,z=0,Z=0,O=0,$=0,AA=0,IA=0,gA=0,BA=0,CA=0,aA=0,tA=0,rA=0,QA=0,eA=0,oA=0,cA=0,iA=0,_A=0,EA=0,nA=0,sA=0,yA=0;X=0|JB(0|B[(A|=0)>>0],0|B[A+1>>0],0|B[A+2>>0]),o(),V=0|CC(0|(V=0|dg(A+2|0)),0|o(),5),o(),J=0|CC(0|(J=0|JB(0|B[A+5>>0],0|B[A+6>>0],0|B[A+7>>0])),0|o(),2),o(),y=0|CC(0|(y=0|dg(A+7|0)),0|o(),7),o(),j=0|CC(0|(j=0|dg(A+10|0)),0|o(),4),o(),O=0|CC(0|(O=0|JB(0|B[A+13>>0],0|B[A+14>>0],0|B[A+15>>0])),0|o(),1),o(),F=0|CC(0|(F=0|dg(A+15|0)),0|o(),6),o(),eA=0|CC(0|(eA=0|JB(0|B[A+18>>0],0|B[A+19>>0],0|B[A+20>>0])),0|o(),3),o(),_A=0|JB(0|B[A+21>>0],0|B[A+22>>0],0|B[A+23>>0]),o(),tA=0|CC(0|(tA=0|dg(A+23|0)),0|o(),5),o(),iA=0|CC(0|(iA=0|JB(0|B[A+26>>0],0|B[A+27>>0],0|B[A+28>>0])),0|o(),2),o(),gA=0|CC(0|(gA=0|dg(A+28|0)),0|o(),7),o(),sA=0|CC(0|(sA=0|dg(A+31|0)),0|o(),4),o(),H=0|CC(0|(H=0|JB(0|B[A+34>>0],0|B[A+35>>0],0|B[A+36>>0])),0|o(),1),o(),K=0|CC(0|(K=0|dg(A+36|0)),0|o(),6),o(),l=0|CC(0|(l=0|JB(0|B[A+39>>0],0|B[A+40>>0],0|B[A+41>>0])),0|o(),3),o(),Q=0|JB(0|B[A+42>>0],0|B[A+43>>0],0|B[A+44>>0]),o(),L=0|CC(0|(L=0|dg(A+44|0)),0|o(),5),o(),CA=0|CC(0|(CA=0|JB(0|B[A+47>>0],0|B[A+48>>0],0|B[A+49>>0])),0|o(),2),o(),yA=0|CC(0|(yA=0|dg(A+49|0)),0|o(),7),o(),n=0|CC(0|(n=0|dg(A+52|0)),0|o(),4),o(),b=0|CC(0|(b=0|JB(0|B[A+55>>0],0|B[A+56>>0],0|B[A+57>>0])),0|o(),1),o(),x=0|CC(0|(x=0|dg(A+57|0)),0|o(),6),o(),_=0|NB(0|(T=0|CC(0|(T=0|dg(A+60|0)),0|o(),3)),0|(e=0|o()),666643,0),w=0|o(),cA=0|NB(0|T,0|e,470296,0),u=0|o(),G=0|NB(0|T,0|e,654183,0),c=0|o(),k=0|NB(0|T,0|e,-997805,-1),E=0|o(),l=0|bC(0|(t=0|NB(0|T,0|e,136657,0)),0|o(),2097151&l|0,0),t=0|o(),Q=0|bC(0|(e=0|NB(0|T,0|e,-683901,-1)),0|o(),2097151&Q|0,0),e=0|o(),T=0|NB(2097151&x|0,0,666643,0),P=0|o(),m=0|NB(2097151&x|0,0,470296,0),IA=0|o(),U=0|NB(2097151&x|0,0,654183,0),r=0|o(),z=0|NB(2097151&x|0,0,-997805,-1),W=0|o(),q=0|NB(2097151&x|0,0,136657,0),f=0|o(),x=0|bC(0|l,0|t,0|(x=0|NB(2097151&x|0,0,-683901,-1)),0|o()),t=0|o(),l=0|NB(2097151&b|0,0,666643,0),Z=0|o(),d=0|NB(2097151&b|0,0,470296,0),BA=0|o(),Y=0|NB(2097151&b|0,0,654183,0),i=0|o(),EA=0|NB(2097151&b|0,0,-997805,-1),oA=0|o(),AA=0|NB(2097151&b|0,0,136657,0),M=0|o(),f=0|bC(0|(E=0|bC(0|(K=0|bC(0|(b=0|NB(2097151&b|0,0,-683901,-1)),0|o(),2097151&K|0,0)),0|o(),0|k,0|E)),0|o(),0|q,0|f),q=0|o(),E=0|NB(2097151&n|0,0,666643,0),k=0|o(),K=0|NB(2097151&n|0,0,470296,0),b=0|o(),h=0|NB(2097151&n|0,0,654183,0),$=0|o(),v=0|NB(2097151&n|0,0,-997805,-1),N=0|o(),a=0|NB(2097151&n|0,0,136657,0),nA=0|o(),n=0|NB(2097151&n|0,0,-683901,-1),s=0|o(),p=0|NB(2097151&yA|0,0,666643,0),S=0|o(),rA=0|NB(2097151&yA|0,0,470296,0),QA=0|o(),g=0|NB(2097151&yA|0,0,654183,0),aA=0|o(),C=0|NB(2097151&yA|0,0,-997805,-1),R=0|o(),I=0|NB(2097151&yA|0,0,136657,0),D=0|o(),r=0|bC(0|(u=0|bC(0|(oA=0|bC(0|(nA=0|bC(0|(sA=0|bC(0|(yA=0|NB(2097151&yA|0,0,-683901,-1)),0|o(),2097151&sA|0,0)),0|o(),0|a,0|nA)),0|o(),0|EA,0|oA)),0|o(),0|cA,0|u)),0|o(),0|U,0|r),U=0|o(),F=0|bC(0|(u=0|NB(2097151&CA|0,0,666643,0)),0|o(),2097151&F|0,0),u=0|o(),cA=0|NB(2097151&CA|0,0,470296,0),oA=0|o(),k=0|bC(0|(QA=0|bC(0|(_A=0|bC(0|(EA=0|NB(2097151&CA|0,0,654183,0)),0|o(),2097151&_A|0,0)),0|o(),0|rA,0|QA)),0|o(),0|E,0|k),E=0|o(),QA=0|NB(2097151&CA|0,0,-997805,-1),rA=0|o(),P=0|bC(0|(BA=0|bC(0|($=0|bC(0|(R=0|bC(0|(iA=0|bC(0|(_A=0|NB(2097151&CA|0,0,136657,0)),0|o(),2097151&iA|0,0)),0|o(),0|C,0|R)),0|o(),0|h,0|$)),0|o(),0|d,0|BA)),0|o(),0|T,0|P),T=0|o(),CA=0|NB(2097151&CA|0,0,-683901,-1),BA=0|o(),h=0|CC(0|(d=0|bC(0|F,0|u,1048576,0)),0|($=0|o()),21),R=0|o(),R=0|bC(0|(S=0|bC(0|(eA=0|bC(0|cA,0|oA,2097151&eA|0,0)),0|o(),0|p,0|S)),0|o(),0|h,0|R),h=0|o(),$=0|FC(0|F,0|u,-2097152&d|0,2047&$|0),d=0|o(),S=0|CC(0|(u=0|bC(0|k,0|E,1048576,0)),0|(F=0|o()),21),p=0|o(),p=0|bC(0|(Z=0|bC(0|(b=0|bC(0|(aA=0|bC(0|(tA=0|bC(0|QA,0|rA,2097151&tA|0,0)),0|o(),0|g,0|aA)),0|o(),0|K,0|b)),0|o(),0|l,0|Z)),0|o(),0|S,0|p),S=0|o(),b=0|KB(0|(Z=0|bC(0|P,0|T,1048576,0)),0|(l=0|o()),21),K=0|o(),K=0|bC(0|(IA=0|bC(0|(w=0|bC(0|(i=0|bC(0|(N=0|bC(0|(D=0|bC(0|(gA=0|bC(0|CA,0|BA,2097151&gA|0,0)),0|o(),0|I,0|D)),0|o(),0|v,0|N)),0|o(),0|Y,0|i)),0|o(),0|_,0|w)),0|o(),0|m,0|IA)),0|o(),0|b,0|K),b=0|o(),w=0|KB(0|(IA=0|bC(0|r,0|U,1048576,0)),0|(m=0|o()),21),_=0|o(),_=0|bC(0|(W=0|bC(0|(c=0|bC(0|(M=0|bC(0|(H=0|bC(0|n,0|s,2097151&H|0,0)),0|o(),0|AA,0|M)),0|o(),0|G,0|c)),0|o(),0|z,0|W)),0|o(),0|w,0|_),w=0|o(),m=0|FC(0|r,0|U,-2097152&IA|0,0|m),IA=0|o(),W=0|bC(0|x,0|t,0|(W=0|KB(0|(U=0|bC(0|f,0|q,1048576,0)),0|(r=0|o()),21)),0|o()),t=0|o(),r=0|FC(0|f,0|q,-2097152&U|0,0|r),U=0|o(),L=0|bC(0|(x=0|KB(0|(q=0|bC(0|Q,0|e,1048576,0)),0|(f=0|o()),21)),0|o(),2097151&L|0,0),x=0|o(),f=0|FC(0|Q,0|e,-2097152&q|0,0|f),q=0|o(),z=0|CC(0|(e=0|bC(0|R,0|h,1048576,0)),0|(Q=0|o()),21),c=0|o(),Q=0|FC(0|R,0|h,-2097152&e|0,0|Q),e=0|o(),G=0|KB(0|(h=0|bC(0|p,0|S,1048576,0)),0|(R=0|o()),21),M=0|o(),IA=0|bC(0|(s=0|KB(0|(AA=0|bC(0|K,0|b,1048576,0)),0|(H=0|o()),21)),0|o(),0|m,0|IA),m=0|o(),H=0|FC(0|K,0|b,-2097152&AA|0,0|H),AA=0|o(),U=0|bC(0|(s=0|KB(0|(b=0|bC(0|_,0|w,1048576,0)),0|(K=0|o()),21)),0|o(),0|r,0|U),r=0|o(),K=0|FC(0|_,0|w,-2097152&b|0,0|K),b=0|o(),q=0|bC(0|(s=0|KB(0|(w=0|bC(0|W,0|t,1048576,0)),0|(_=0|o()),21)),0|o(),0|f,0|q),f=0|o(),_=0|FC(0|W,0|t,-2097152&w|0,0|_),w=0|o(),O=0|bC(0|(t=0|NB(0|L,0|x,666643,0)),0|o(),2097151&O|0,0),t=0|o(),W=0|bC(0|$,0|d,0|(W=0|NB(0|L,0|x,470296,0)),0|o()),d=0|o(),$=0|bC(0|Q,0|e,0|($=0|NB(0|L,0|x,654183,0)),0|o()),e=0|o(),Q=0|NB(0|L,0|x,-997805,-1),s=0|o(),n=0|NB(0|L,0|x,136657,0),i=0|o(),l=0|FC(0|(M=0|bC(0|(T=0|bC(0|(x=0|NB(0|L,0|x,-683901,-1)),0|o(),0|P,0|T)),0|o(),0|G,0|M)),0|o(),-2097152&Z|0,0|l),Z=0|o(),j=0|bC(0|(M=0|NB(0|q,0|f,666643,0)),0|o(),2097151&j|0,0),M=0|o(),G=0|bC(0|O,0|t,0|(G=0|NB(0|q,0|f,470296,0)),0|o()),t=0|o(),O=0|bC(0|W,0|d,0|(O=0|NB(0|q,0|f,654183,0)),0|o()),d=0|o(),W=0|bC(0|$,0|e,0|(W=0|NB(0|q,0|f,-997805,-1)),0|o()),e=0|o(),$=0|NB(0|q,0|f,136657,0),T=0|o(),f=0|NB(0|q,0|f,-683901,-1),q=0|o(),y=0|bC(0|(P=0|NB(0|_,0|w,666643,0)),0|o(),2097151&y|0,0),P=0|o(),x=0|bC(0|j,0|M,0|(x=0|NB(0|_,0|w,470296,0)),0|o()),M=0|o(),j=0|bC(0|G,0|t,0|(j=0|NB(0|_,0|w,654183,0)),0|o()),t=0|o(),G=0|bC(0|O,0|d,0|(G=0|NB(0|_,0|w,-997805,-1)),0|o()),d=0|o(),O=0|bC(0|W,0|e,0|(O=0|NB(0|_,0|w,136657,0)),0|o()),e=0|o(),w=0|NB(0|_,0|w,-683901,-1),_=0|o(),_=0|bC(0|(T=0|bC(0|(s=0|bC(0|(F=0|FC(0|(E=0|bC(0|z,0|c,0|k,0|E)),0|o(),-2097152&u|0,0|F)),0|o(),0|Q,0|s)),0|o(),0|$,0|T)),0|o(),0|w,0|_),w=0|o(),J=0|bC(0|(T=0|NB(0|U,0|r,666643,0)),0|o(),2097151&J|0,0),T=0|o(),$=0|bC(0|y,0|P,0|($=0|NB(0|U,0|r,470296,0)),0|o()),P=0|o(),y=0|bC(0|x,0|M,0|(y=0|NB(0|U,0|r,654183,0)),0|o()),M=0|o(),x=0|bC(0|j,0|t,0|(x=0|NB(0|U,0|r,-997805,-1)),0|o()),t=0|o(),j=0|bC(0|G,0|d,0|(j=0|NB(0|U,0|r,136657,0)),0|o()),d=0|o(),r=0|bC(0|O,0|e,0|(r=0|NB(0|U,0|r,-683901,-1)),0|o()),e=0|o(),V=0|bC(0|(O=0|NB(0|K,0|b,666643,0)),0|o(),2097151&V|0,0),O=0|o(),U=0|bC(0|J,0|T,0|(U=0|NB(0|K,0|b,470296,0)),0|o()),T=0|o(),J=0|bC(0|$,0|P,0|(J=0|NB(0|K,0|b,654183,0)),0|o()),P=0|o(),$=0|bC(0|y,0|M,0|($=0|NB(0|K,0|b,-997805,-1)),0|o()),M=0|o(),y=0|bC(0|x,0|t,0|(y=0|NB(0|K,0|b,136657,0)),0|o()),t=0|o(),b=0|bC(0|j,0|d,0|(b=0|NB(0|K,0|b,-683901,-1)),0|o()),d=0|o(),X=0|bC(0|(j=0|NB(0|IA,0|m,666643,0)),0|o(),2097151&X|0,0),j=0|o(),K=0|bC(0|V,0|O,0|(K=0|NB(0|IA,0|m,470296,0)),0|o()),O=0|o(),V=0|bC(0|U,0|T,0|(V=0|NB(0|IA,0|m,654183,0)),0|o()),T=0|o(),U=0|bC(0|J,0|P,0|(U=0|NB(0|IA,0|m,-997805,-1)),0|o()),P=0|o(),J=0|bC(0|$,0|M,0|(J=0|NB(0|IA,0|m,136657,0)),0|o()),M=0|o(),m=0|bC(0|y,0|t,0|(m=0|NB(0|IA,0|m,-683901,-1)),0|o()),t=0|o(),$=0|bC(0|K,0|O,0|($=0|KB(0|(y=0|bC(0|X,0|j,1048576,0)),0|(IA=0|o()),21)),0|o()),O=0|o(),IA=0|FC(0|X,0|j,-2097152&y|0,0|IA),y=0|o(),K=0|bC(0|U,0|P,0|(K=0|KB(0|(j=0|bC(0|V,0|T,1048576,0)),0|(X=0|o()),21)),0|o()),P=0|o(),G=0|bC(0|m,0|t,0|(G=0|KB(0|(U=0|bC(0|J,0|M,1048576,0)),0|(x=0|o()),21)),0|o()),t=0|o(),Q=0|bC(0|r,0|e,0|(Q=0|KB(0|(m=0|bC(0|b,0|d,1048576,0)),0|(s=0|o()),21)),0|o()),e=0|o(),s=0|FC(0|b,0|d,-2097152&m|0,0|s),m=0|o(),r=0|KB(0|(d=0|bC(0|_,0|w,1048576,0)),0|(b=0|o()),21),F=0|o(),F=0|bC(0|(q=0|bC(0|(R=0|FC(0|(S=0|bC(0|n,0|i,0|p,0|S)),0|o(),-2097152&h|0,0|R)),0|o(),0|f,0|q)),0|o(),0|r,0|F),r=0|o(),b=0|FC(0|_,0|w,-2097152&d|0,0|b),d=0|o(),AA=0|bC(0|(q=0|KB(0|(w=0|bC(0|l,0|Z,1048576,0)),0|(_=0|o()),21)),0|o(),0|H,0|AA),H=0|o(),_=0|FC(0|l,0|Z,-2097152&w|0,0|_),w=0|o(),q=0|KB(0|(Z=0|bC(0|$,0|O,1048576,0)),0|(l=0|o()),21),f=0|o(),S=0|KB(0|(R=0|bC(0|K,0|P,1048576,0)),0|(h=0|o()),21),p=0|o(),u=0|bC(0|s,0|m,0|(u=0|KB(0|(i=0|bC(0|G,0|t,1048576,0)),0|(n=0|o()),21)),0|o()),m=0|o(),k=0|bC(0|b,0|d,0|(k=0|KB(0|(s=0|bC(0|Q,0|e,1048576,0)),0|(E=0|o()),21)),0|o()),d=0|o(),E=0|FC(0|Q,0|e,-2097152&s|0,0|E),s=0|o(),b=0|bC(0|_,0|w,0|(b=0|KB(0|(e=0|bC(0|F,0|r,1048576,0)),0|(Q=0|o()),21)),0|o()),w=0|o(),Q=0|FC(0|F,0|r,-2097152&e|0,0|Q),e=0|o(),_=0|KB(0|(r=0|bC(0|AA,0|H,1048576,0)),0|(F=0|o()),21),c=0|o(),F=0|FC(0|AA,0|H,-2097152&r|0,0|F),r=0|o(),H=0|bC(0|IA,0|y,0|(H=0|NB(0|_,0|c,666643,0)),0|o()),y=0|o(),IA=0|NB(0|_,0|c,470296,0),AA=0|o(),z=0|NB(0|_,0|c,654183,0),W=0|o(),L=0|NB(0|_,0|c,-997805,-1),Y=0|o(),N=0|NB(0|_,0|c,136657,0),v=0|o(),c=0|NB(0|_,0|c,-683901,-1),_=0|o(),y=0|KB(0|H,0|y,21),D=0|o(),y=0|KB(0|(D=0|bC(0|(l=0|FC(0|(O=0|bC(0|IA,0|AA,0|$,0|O)),0|o(),-2097152&Z|0,0|l)),0|o(),0|y,0|D)),0|o(),21),l=0|o(),y=0|KB(0|(l=0|bC(0|(f=0|bC(0|(X=0|FC(0|(T=0|bC(0|z,0|W,0|V,0|T)),0|o(),-2097152&j|0,0|X)),0|o(),0|q,0|f)),0|o(),0|y,0|l)),0|o(),21),f=0|o(),y=0|KB(0|(f=0|bC(0|(h=0|FC(0|(Y=0|bC(0|K,0|P,0|L,0|Y)),0|o(),-2097152&R|0,0|h)),0|o(),0|y,0|f)),0|o(),21),h=0|o(),y=0|KB(0|(h=0|bC(0|(p=0|bC(0|(x=0|FC(0|(M=0|bC(0|N,0|v,0|J,0|M)),0|o(),-2097152&U|0,0|x)),0|o(),0|S,0|p)),0|o(),0|y,0|h)),0|o(),21),p=0|o(),H=0|bC(0|(b=0|NB(0|(F=0|KB(0|(r=0|bC(0|(w=0|KB(0|(Q=0|bC(0|b,0|w,0|(Q=0|KB(0|(e=0|bC(0|(d=0|KB(0|(E=0|bC(0|k,0|d,0|(E=0|KB(0|(s=0|bC(0|(m=0|KB(0|(y=0|bC(0|u,0|m,0|(y=0|KB(0|(p=0|bC(0|(n=0|FC(0|(_=0|bC(0|G,0|t,0|c,0|_)),0|o(),-2097152&i|0,0|n)),0|o(),0|y,0|p)),0|o(),21)),0|o())),0|o(),21)),0|o(),0|E,0|s)),0|o(),21)),0|o())),0|o(),21)),0|o(),0|Q,0|e)),0|o(),21)),0|o())),0|o(),21)),0|o(),0|F,0|r)),0|o(),21)),0|(w=0|o()),666643,0)),0|o(),2097151&H|0,0),b=0|o(),D=0|bC(0|(d=0|NB(0|F,0|w,470296,0)),0|o(),2097151&D|0,0),d=0|o(),l=0|bC(0|(k=0|NB(0|F,0|w,654183,0)),0|o(),2097151&l|0,0),k=0|o(),f=0|bC(0|(m=0|NB(0|F,0|w,-997805,-1)),0|o(),2097151&f|0,0),m=0|o(),h=0|bC(0|(u=0|NB(0|F,0|w,136657,0)),0|o(),2097151&h|0,0),u=0|o(),r=0|bC(0|(t=0|KB(0|(Q=0|bC(0|(c=0|KB(0|(e=0|bC(0|(_=0|KB(0|(E=0|bC(0|(i=0|KB(0|(s=0|bC(0|(n=0|KB(0|(y=0|bC(0|(p=0|KB(0|(h=0|bC(0|(p=0|bC(0|(w=0|NB(0|F,0|w,-683901,-1)),0|o(),2097151&p|0,0)),0|(w=0|o()),0|(h=0|KB(0|(f=0|bC(0|h,0|u,0|(f=0|KB(0|(l=0|bC(0|f,0|m,0|(l=0|KB(0|(D=0|bC(0|l,0|k,0|(D=0|KB(0|(F=0|bC(0|D,0|d,0|(F=0|KB(0|H,0|b,21)),0|o())),0|(d=0|o()),21)),0|o())),0|(k=0|o()),21)),0|o())),0|(m=0|o()),21)),0|o())),0|(u=0|o()),21)),0|o())),0|(w=0|o()),21)),0|o(),2097151&y|0,0)),0|(p=0|o()),21)),0|o(),2097151&s|0,0)),0|(n=0|o()),21)),0|o(),2097151&E|0,0)),0|(i=0|o()),21)),0|o(),2097151&e|0,0)),0|(_=0|o()),21)),0|o(),2097151&Q|0,0)),0|(c=0|o()),21)),0|o(),2097151&r|0,0),t=0|o(),B[A>>0]=H,G=0|CC(0|H,0|b,8),o(),B[A+1>>0]=G,b=0|CC(0|H,0|b,16),o(),H=0|$B(2097151&F|0,0,5),o(),B[A+2>>0]=H|31&b,b=0|CC(0|F,0|d,3),o(),B[A+3>>0]=b,d=0|CC(0|F,0|d,11),o(),B[A+4>>0]=d,F=0|CC(2097151&F|0,0,19),d=0|o(),b=0|$B(2097151&D|0,0,2),o(),B[A+5>>0]=b|F,k=0|CC(0|D,0|k,6),o(),B[A+6>>0]=k,D=0|CC(2097151&D|0,0,14),k=0|o(),F=0|$B(2097151&l|0,0,7),o(),B[A+7>>0]=F|D,D=0|CC(0|l,0|m,1),o(),B[A+8>>0]=D,m=0|CC(0|l,0|m,9),o(),B[A+9>>0]=m,l=0|CC(2097151&l|0,0,17),m=0|o(),D=0|$B(2097151&f|0,0,4),o(),B[A+10>>0]=D|l,l=0|CC(0|f,0|u,4),o(),B[A+11>>0]=l,u=0|CC(0|f,0|u,12),o(),B[A+12>>0]=u,f=0|CC(2097151&f|0,0,20),u=0|o(),l=0|$B(2097151&h|0,0,1),o(),B[A+13>>0]=l|f,w=0|CC(0|h,0|w,7),o(),B[A+14>>0]=w,h=0|CC(2097151&h|0,0,15),w=0|o(),f=0|$B(2097151&y|0,0,6),o(),B[A+15>>0]=f|h,h=0|CC(0|y,0|p,2),o(),B[A+16>>0]=h,p=0|CC(0|y,0|p,10),o(),B[A+17>>0]=p,y=0|CC(2097151&y|0,0,18),p=0|o(),h=0|$B(0|s,0|n,3),o(),B[A+18>>0]=h|y,y=0|CC(0|s,0|n,5),o(),B[A+19>>0]=y,n=0|CC(0|s,0|n,13),o(),B[A+20>>0]=n,B[A+21>>0]=E,n=0|CC(0|E,0|i,8),o(),B[A+22>>0]=n,i=0|CC(0|E,0|i,16),o(),E=0|$B(2097151&e|0,0,5),o(),B[A+23>>0]=E|31&i,i=0|CC(0|e,0|_,3),o(),B[A+24>>0]=i,_=0|CC(0|e,0|_,11),o(),B[A+25>>0]=_,e=0|CC(2097151&e|0,0,19),_=0|o(),i=0|$B(2097151&Q|0,0,2),o(),B[A+26>>0]=i|e,c=0|CC(0|Q,0|c,6),o(),B[A+27>>0]=c,Q=0|CC(2097151&Q|0,0,14),c=0|o(),e=0|$B(0|r,0|t,7),o(),B[A+28>>0]=e|Q,Q=0|CC(0|r,0|t,1),o(),B[A+29>>0]=Q,Q=0|CC(0|r,0|t,9),o(),B[A+30>>0]=Q,t=0|KB(0|r,0|t,17),o(),B[A+31>>0]=t}function m(A,I,g){A|=0,g|=0;var B,C,t,r,Q,e,c,i,_,E,n,s,y,h,p,f,w,l,u,D,m,F,k,b,d,H,G,S,x,U,M,J,v,N,R,Y,L,P,K,q,X,j,T,V,W,z,Z,O,$,AA,IA,gA,BA,CA,aA,tA,rA,QA,eA,oA,cA,iA,_A,EA,nA,sA,yA,hA,pA,fA,wA,lA,uA,DA,mA,FA,kA,bA,dA,HA,GA,SA,xA,UA,MA,JA,vA,NA,RA,YA=0,LA=0,PA=0,KA=0,qA=0,XA=0,jA=0,TA=0,VA=0,WA=0,zA=0,ZA=0,OA=0,$A=0,AI=0,II=0,gI=0,BI=0,CI=0,aI=0,tI=0,rI=0,QI=0,eI=0,oI=0,cI=0,iI=0,_I=0,EI=0,nI=0,sI=0,yI=0,hI=0,pI=0,fI=0,wI=0,lI=0,uI=0,DI=0,mI=0,FI=0,kI=0,bI=0,dI=0,HI=0,GI=0,SI=0,xI=0,UI=0,MI=0,JI=0,vI=0,NI=0,RI=0,YI=0,LI=0,PI=0,KI=0,qI=0,XI=0,jI=0,TI=0,VI=0,WI=0,zI=0,ZI=0,OI=0,$I=0,Ag=0,Ig=0,gg=0,Bg=0,Cg=0,ag=0,tg=0,rg=0,Qg=0,eg=0,og=0,cg=0,ig=0,_g=0,Eg=0,ng=0,sg=0,yg=0,hg=0,pg=0,fg=0,wg=0,lg=0,ug=0,Dg=0,mg=0,Fg=0,kg=0,bg=0,dg=0,Hg=0,Gg=0,Sg=0,xg=0,Ug=0,Mg=0,Jg=0,vg=0,Ng=0,Rg=0,Yg=0,Lg=0;AI=0|a[(I|=0)>>2],TA=0|a[I+4>>2],XA=0|a[I+8>>2],OA=0|a[I+12>>2],SI=0|a[I+16>>2],ZA=0|a[I+20>>2],tg=0|a[I+24>>2],YA=0|a[I+28>>2],lI=0|a[I+32>>2],iI=0|a[I+36>>2],eI=0|a[g>>2],Lg=0|a[g+4>>2],ug=0|a[g+8>>2],Bg=0|a[g+12>>2],NI=0|a[g+16>>2],kg=0|a[g+20>>2],eg=0|a[g+24>>2],KI=0|a[g+28>>2],uI=0|a[g+32>>2],RA=0|a[g+36>>2],vA=0|NB(0|eI,((0|eI)<0)<<31>>31|0,0|AI,((0|AI)<0)<<31>>31|0),Yg=0|o(),dA=0|NB(0|Lg,((0|Lg)<0)<<31>>31|0,0|AI,((0|AI)<0)<<31>>31|0),bA=0|o(),gA=0|NB(0|ug,((0|ug)<0)<<31>>31|0,0|AI,((0|AI)<0)<<31>>31|0),Cg=0|o(),v=0|NB(0|Bg,((0|Bg)<0)<<31>>31|0,0|AI,((0|AI)<0)<<31>>31|0),RI=0|o(),lA=0|NB(0|NI,((0|NI)<0)<<31>>31|0,0|AI,((0|AI)<0)<<31>>31|0),dg=0|o(),QA=0|NB(0|kg,((0|kg)<0)<<31>>31|0,0|AI,((0|AI)<0)<<31>>31|0),cg=0|o(),K=0|NB(0|eg,((0|eg)<0)<<31>>31|0,0|AI,((0|AI)<0)<<31>>31|0),XI=0|o(),D=0|NB(0|KI,((0|KI)<0)<<31>>31|0,0|AI,((0|AI)<0)<<31>>31|0),mI=0|o(),E=0|NB(0|uI,((0|uI)<0)<<31>>31|0,0|AI,((0|AI)<0)<<31>>31|0),_I=0|o(),AI=0|NB(0|RA,((0|RA)<0)<<31>>31|0,0|AI,((0|AI)<0)<<31>>31|0),$A=0|o(),Dg=0|NB(0|eI,((0|eI)<0)<<31>>31|0,0|TA,((0|TA)<0)<<31>>31|0),mg=0|o(),aA=0|NB(0|Lg,((0|Lg)<0)<<31>>31|0,TA<<1|0,((TA<<1|0)<0)<<31>>31|0),CA=0|o(),N=0|NB(0|ug,((0|ug)<0)<<31>>31|0,0|TA,((0|TA)<0)<<31>>31|0),YI=0|o(),uA=0|NB(0|Bg,((0|Bg)<0)<<31>>31|0,TA<<1|0,((TA<<1|0)<0)<<31>>31|0),Hg=0|o(),eA=0|NB(0|NI,((0|NI)<0)<<31>>31|0,0|TA,((0|TA)<0)<<31>>31|0),ig=0|o(),q=0|NB(0|kg,((0|kg)<0)<<31>>31|0,TA<<1|0,((TA<<1|0)<0)<<31>>31|0),jI=0|o(),m=0|NB(0|eg,((0|eg)<0)<<31>>31|0,0|TA,((0|TA)<0)<<31>>31|0),FI=0|o(),n=0|NB(0|KI,((0|KI)<0)<<31>>31|0,TA<<1|0,((TA<<1|0)<0)<<31>>31|0),EI=0|o(),B=0|NB(0|uI,((0|uI)<0)<<31>>31|0,0|TA,((0|TA)<0)<<31>>31|0),II=0|o(),TA=0|NB(19*RA|0,0|(cI=((19*RA|0)<0)<<31>>31),TA<<1|0,((TA<<1|0)<0)<<31>>31|0),I=0|o(),BA=0|NB(0|eI,((0|eI)<0)<<31>>31|0,0|XA,((0|XA)<0)<<31>>31|0),ag=0|o(),L=0|NB(0|Lg,((0|Lg)<0)<<31>>31|0,0|XA,((0|XA)<0)<<31>>31|0),Y=0|o(),DA=0|NB(0|ug,((0|ug)<0)<<31>>31|0,0|XA,((0|XA)<0)<<31>>31|0),Gg=0|o(),oA=0|NB(0|Bg,((0|Bg)<0)<<31>>31|0,0|XA,((0|XA)<0)<<31>>31|0),_g=0|o(),X=0|NB(0|NI,((0|NI)<0)<<31>>31|0,0|XA,((0|XA)<0)<<31>>31|0),TI=0|o(),F=0|NB(0|kg,((0|kg)<0)<<31>>31|0,0|XA,((0|XA)<0)<<31>>31|0),kI=0|o(),s=0|NB(0|eg,((0|eg)<0)<<31>>31|0,0|XA,((0|XA)<0)<<31>>31|0),nI=0|o(),C=0|NB(0|KI,((0|KI)<0)<<31>>31|0,0|XA,((0|XA)<0)<<31>>31|0),gI=0|o(),HA=0|NB(19*uI|0,0|(DI=((19*uI|0)<0)<<31>>31),0|XA,((0|XA)<0)<<31>>31|0),xg=0|o(),XA=0|NB(19*RA|0,0|cI,0|XA,((0|XA)<0)<<31>>31|0),jA=0|o(),R=0|NB(0|eI,((0|eI)<0)<<31>>31|0,0|OA,((0|OA)<0)<<31>>31|0),LI=0|o(),kA=0|NB(0|Lg,((0|Lg)<0)<<31>>31|0,OA<<1|0,((OA<<1|0)<0)<<31>>31|0),FA=0|o(),cA=0|NB(0|ug,((0|ug)<0)<<31>>31|0,0|OA,((0|OA)<0)<<31>>31|0),Eg=0|o(),j=0|NB(0|Bg,((0|Bg)<0)<<31>>31|0,OA<<1|0,((OA<<1|0)<0)<<31>>31|0),VI=0|o(),k=0|NB(0|NI,((0|NI)<0)<<31>>31|0,0|OA,((0|OA)<0)<<31>>31|0),bI=0|o(),y=0|NB(0|kg,((0|kg)<0)<<31>>31|0,OA<<1|0,((OA<<1|0)<0)<<31>>31|0),sI=0|o(),t=0|NB(0|eg,((0|eg)<0)<<31>>31|0,0|OA,((0|OA)<0)<<31>>31|0),BI=0|o(),GA=0|NB(19*KI|0,0|(qI=((19*KI|0)<0)<<31>>31),OA<<1|0,((OA<<1|0)<0)<<31>>31|0),Ug=0|o(),nA=0|NB(19*uI|0,0|DI,0|OA,((0|OA)<0)<<31>>31|0),sg=0|o(),OA=0|NB(19*RA|0,0|cI,OA<<1|0,((OA<<1|0)<0)<<31>>31|0),qA=0|o(),mA=0|NB(0|eI,((0|eI)<0)<<31>>31|0,0|SI,((0|SI)<0)<<31>>31|0),Sg=0|o(),EA=0|NB(0|Lg,((0|Lg)<0)<<31>>31|0,0|SI,((0|SI)<0)<<31>>31|0),_A=0|o(),T=0|NB(0|ug,((0|ug)<0)<<31>>31|0,0|SI,((0|SI)<0)<<31>>31|0),WI=0|o(),b=0|NB(0|Bg,((0|Bg)<0)<<31>>31|0,0|SI,((0|SI)<0)<<31>>31|0),dI=0|o(),h=0|NB(0|NI,((0|NI)<0)<<31>>31|0,0|SI,((0|SI)<0)<<31>>31|0),yI=0|o(),r=0|NB(0|kg,((0|kg)<0)<<31>>31|0,0|SI,((0|SI)<0)<<31>>31|0),CI=0|o(),SA=0|NB(19*eg|0,0|(og=((19*eg|0)<0)<<31>>31),0|SI,((0|SI)<0)<<31>>31|0),Mg=0|o(),sA=0|NB(19*KI|0,0|qI,0|SI,((0|SI)<0)<<31>>31|0),yg=0|o(),Z=0|NB(19*uI|0,0|DI,0|SI,((0|SI)<0)<<31>>31|0),ZI=0|o(),SI=0|NB(19*RA|0,0|cI,0|SI,((0|SI)<0)<<31>>31|0),PA=0|o(),iA=0|NB(0|eI,((0|eI)<0)<<31>>31|0,0|ZA,((0|ZA)<0)<<31>>31|0),ng=0|o(),z=0|NB(0|Lg,((0|Lg)<0)<<31>>31|0,ZA<<1|0,((ZA<<1|0)<0)<<31>>31|0),W=0|o(),d=0|NB(0|ug,((0|ug)<0)<<31>>31|0,0|ZA,((0|ZA)<0)<<31>>31|0),HI=0|o(),p=0|NB(0|Bg,((0|Bg)<0)<<31>>31|0,ZA<<1|0,((ZA<<1|0)<0)<<31>>31|0),hI=0|o(),Q=0|NB(0|NI,((0|NI)<0)<<31>>31|0,0|ZA,((0|ZA)<0)<<31>>31|0),aI=0|o(),xA=0|NB(19*kg|0,0|(bg=((19*kg|0)<0)<<31>>31),ZA<<1|0,((ZA<<1|0)<0)<<31>>31|0),Jg=0|o(),yA=0|NB(19*eg|0,0|og,0|ZA,((0|ZA)<0)<<31>>31|0),hg=0|o(),O=0|NB(19*KI|0,0|qI,ZA<<1|0,((ZA<<1|0)<0)<<31>>31|0),OI=0|o(),x=0|NB(19*uI|0,0|DI,0|ZA,((0|ZA)<0)<<31>>31|0),xI=0|o(),ZA=0|NB(19*RA|0,0|cI,ZA<<1|0,((ZA<<1|0)<0)<<31>>31|0),LA=0|o(),V=0|NB(0|eI,((0|eI)<0)<<31>>31|0,0|tg,((0|tg)<0)<<31>>31|0),zI=0|o(),S=0|NB(0|Lg,((0|Lg)<0)<<31>>31|0,0|tg,((0|tg)<0)<<31>>31|0),G=0|o(),f=0|NB(0|ug,((0|ug)<0)<<31>>31|0,0|tg,((0|tg)<0)<<31>>31|0),pI=0|o(),e=0|NB(0|Bg,((0|Bg)<0)<<31>>31|0,0|tg,((0|tg)<0)<<31>>31|0),tI=0|o(),UA=0|NB(19*NI|0,((19*NI|0)<0)<<31>>31|0,0|tg,((0|tg)<0)<<31>>31|0),vg=0|o(),hA=0|NB(19*kg|0,0|bg,0|tg,((0|tg)<0)<<31>>31|0),pg=0|o(),$=0|NB(19*eg|0,0|og,0|tg,((0|tg)<0)<<31>>31|0),$I=0|o(),U=0|NB(19*KI|0,0|qI,0|tg,((0|tg)<0)<<31>>31|0),UI=0|o(),VA=0|NB(19*uI|0,0|DI,0|tg,((0|tg)<0)<<31>>31|0),WA=0|o(),tg=0|NB(19*RA|0,0|cI,0|tg,((0|tg)<0)<<31>>31|0),KA=0|o(),H=0|NB(0|eI,((0|eI)<0)<<31>>31|0,0|YA,((0|YA)<0)<<31>>31|0),GI=0|o(),u=0|NB(0|Lg,((0|Lg)<0)<<31>>31|0,YA<<1|0,((YA<<1|0)<0)<<31>>31|0),l=0|o(),c=0|NB(0|ug,((0|ug)<0)<<31>>31|0,0|YA,((0|YA)<0)<<31>>31|0),rI=0|o(),MA=0|NB(19*Bg|0,((19*Bg|0)<0)<<31>>31|0,YA<<1|0,((YA<<1|0)<0)<<31>>31|0),Ng=0|o(),pA=0|NB(19*NI|0,((19*NI|0)<0)<<31>>31|0,0|YA,((0|YA)<0)<<31>>31|0),fg=0|o(),AA=0|NB(19*kg|0,0|bg,YA<<1|0,((YA<<1|0)<0)<<31>>31|0),Ag=0|o(),M=0|NB(19*eg|0,0|og,0|YA,((0|YA)<0)<<31>>31|0),MI=0|o(),oI=0|NB(19*KI|0,0|qI,YA<<1|0,((YA<<1|0)<0)<<31>>31|0),zA=0|o(),tA=0|NB(19*uI|0,0|DI,0|YA,((0|YA)<0)<<31>>31|0),rg=0|o(),g=0|NB(19*RA|0,0|cI,YA<<1|0,((YA<<1|0)<0)<<31>>31|0),YA=0|o(),w=0|NB(0|eI,((0|eI)<0)<<31>>31|0,0|lI,((0|lI)<0)<<31>>31|0),fI=0|o(),_=0|NB(0|Lg,((0|Lg)<0)<<31>>31|0,0|lI,((0|lI)<0)<<31>>31|0),i=0|o(),JA=0|NB(19*ug|0,((19*ug|0)<0)<<31>>31|0,0|lI,((0|lI)<0)<<31>>31|0),Rg=0|o(),fA=0|NB(19*Bg|0,((19*Bg|0)<0)<<31>>31|0,0|lI,((0|lI)<0)<<31>>31|0),wg=0|o(),IA=0|NB(19*NI|0,((19*NI|0)<0)<<31>>31|0,0|lI,((0|lI)<0)<<31>>31|0),Ig=0|o(),J=0|NB(19*kg|0,0|bg,0|lI,((0|lI)<0)<<31>>31|0),JI=0|o(),wA=0|NB(19*eg|0,0|og,0|lI,((0|lI)<0)<<31>>31|0),Fg=0|o(),rA=0|NB(19*KI|0,0|qI,0|lI,((0|lI)<0)<<31>>31|0),Qg=0|o(),P=0|NB(19*uI|0,0|DI,0|lI,((0|lI)<0)<<31>>31|0),PI=0|o(),lI=0|NB(19*RA|0,0|cI,0|lI,((0|lI)<0)<<31>>31|0),wI=0|o(),eI=0|NB(0|eI,((0|eI)<0)<<31>>31|0,0|iI,((0|iI)<0)<<31>>31|0),QI=0|o(),Lg=0|NB(19*Lg|0,((19*Lg|0)<0)<<31>>31|0,iI<<1|0,((iI<<1|0)<0)<<31>>31|0),NA=0|o(),ug=0|NB(19*ug|0,((19*ug|0)<0)<<31>>31|0,0|iI,((0|iI)<0)<<31>>31|0),lg=0|o(),Bg=0|NB(19*Bg|0,((19*Bg|0)<0)<<31>>31|0,iI<<1|0,((iI<<1|0)<0)<<31>>31|0),gg=0|o(),NI=0|NB(19*NI|0,((19*NI|0)<0)<<31>>31|0,0|iI,((0|iI)<0)<<31>>31|0),vI=0|o(),bg=0|NB(19*kg|0,0|bg,iI<<1|0,((iI<<1|0)<0)<<31>>31|0),kg=0|o(),og=0|NB(19*eg|0,0|og,0|iI,((0|iI)<0)<<31>>31|0),eg=0|o(),qI=0|NB(19*KI|0,0|qI,iI<<1|0,((iI<<1|0)<0)<<31>>31|0),KI=0|o(),DI=0|NB(19*uI|0,0|DI,0|iI,((0|iI)<0)<<31>>31|0),uI=0|o(),iI=0|NB(19*RA|0,0|cI,iI<<1|0,((iI<<1|0)<0)<<31>>31|0),cI=0|o(),I=0|bC(0|(xg=0|bC(0|(Ug=0|bC(0|(Mg=0|bC(0|(Jg=0|bC(0|(vg=0|bC(0|(Ng=0|bC(0|(Rg=0|bC(0|(Yg=0|bC(0|Lg,0|NA,0|vA,0|Yg)),0|o(),0|JA,0|Rg)),0|o(),0|MA,0|Ng)),0|o(),0|UA,0|vg)),0|o(),0|xA,0|Jg)),0|o(),0|SA,0|Mg)),0|o(),0|GA,0|Ug)),0|o(),0|HA,0|xg)),0|o(),0|TA,0|I),TA=0|o(),mg=0|bC(0|dA,0|bA,0|Dg,0|mg),Dg=0|o(),LA=0|bC(0|(WA=0|bC(0|(zA=0|bC(0|(Fg=0|bC(0|(kg=0|bC(0|(dg=0|bC(0|(Hg=0|bC(0|(Gg=0|bC(0|(Sg=0|bC(0|kA,0|FA,0|mA,0|Sg)),0|o(),0|DA,0|Gg)),0|o(),0|uA,0|Hg)),0|o(),0|lA,0|dg)),0|o(),0|bg,0|kg)),0|o(),0|wA,0|Fg)),0|o(),0|oI,0|zA)),0|o(),0|VA,0|WA)),0|o(),0|ZA,0|LA),ZA=0|o(),zA=0|KB(0|(WA=0|bC(0|I,0|TA,33554432,0)),0|(VA=0|o()),26),oI=0|o(),oI=0|bC(0|(jA=0|bC(0|(sg=0|bC(0|(yg=0|bC(0|(hg=0|bC(0|(pg=0|bC(0|(fg=0|bC(0|(wg=0|bC(0|(lg=0|bC(0|mg,0|Dg,0|ug,0|lg)),0|o(),0|fA,0|wg)),0|o(),0|pA,0|fg)),0|o(),0|hA,0|pg)),0|o(),0|yA,0|hg)),0|o(),0|sA,0|yg)),0|o(),0|nA,0|sg)),0|o(),0|XA,0|jA)),0|o(),0|zA,0|oI),zA=0|o(),VA=0|FC(0|I,0|TA,-67108864&WA|0,0|VA),WA=0|o(),jA=0|KB(0|(TA=0|bC(0|LA,0|ZA,33554432,0)),0|(I=0|o()),26),XA=0|o(),XA=0|bC(0|(KA=0|bC(0|(rg=0|bC(0|(Qg=0|bC(0|(eg=0|bC(0|(cg=0|bC(0|(ig=0|bC(0|(_g=0|bC(0|(Eg=0|bC(0|(ng=0|bC(0|EA,0|_A,0|iA,0|ng)),0|o(),0|cA,0|Eg)),0|o(),0|oA,0|_g)),0|o(),0|eA,0|ig)),0|o(),0|QA,0|cg)),0|o(),0|og,0|eg)),0|o(),0|rA,0|Qg)),0|o(),0|tA,0|rg)),0|o(),0|tg,0|KA)),0|o(),0|jA,0|XA),jA=0|o(),I=0|FC(0|LA,0|ZA,-67108864&TA|0,0|I),TA=0|o(),LA=0|KB(0|(ZA=0|bC(0|oI,0|zA,16777216,0)),0|o(),25),KA=0|o(),KA=0|bC(0|(qA=0|bC(0|(ZI=0|bC(0|(OI=0|bC(0|($I=0|bC(0|(Ag=0|bC(0|(Ig=0|bC(0|(gg=0|bC(0|(Cg=0|bC(0|(ag=0|bC(0|aA,0|CA,0|BA,0|ag)),0|o(),0|gA,0|Cg)),0|o(),0|Bg,0|gg)),0|o(),0|IA,0|Ig)),0|o(),0|AA,0|Ag)),0|o(),0|$,0|$I)),0|o(),0|O,0|OI)),0|o(),0|Z,0|ZI)),0|o(),0|OA,0|qA)),0|o(),0|LA,0|KA),LA=0|o(),ZA=0|FC(0|oI,0|zA,-33554432&ZA|0,0),zA=0|o(),qA=0|KB(0|(oI=0|bC(0|XA,0|jA,16777216,0)),0|o(),25),OA=0|o(),OA=0|bC(0|(YA=0|bC(0|(PI=0|bC(0|(KI=0|bC(0|(XI=0|bC(0|(jI=0|bC(0|(TI=0|bC(0|(VI=0|bC(0|(WI=0|bC(0|(zI=0|bC(0|z,0|W,0|V,0|zI)),0|o(),0|T,0|WI)),0|o(),0|j,0|VI)),0|o(),0|X,0|TI)),0|o(),0|q,0|jI)),0|o(),0|K,0|XI)),0|o(),0|qI,0|KI)),0|o(),0|P,0|PI)),0|o(),0|g,0|YA)),0|o(),0|qA,0|OA),qA=0|o(),oI=0|FC(0|XA,0|jA,-33554432&oI|0,0),jA=0|o(),YA=0|KB(0|(XA=0|bC(0|KA,0|LA,33554432,0)),0|o(),26),g=0|o(),g=0|bC(0|(PA=0|bC(0|(xI=0|bC(0|(UI=0|bC(0|(MI=0|bC(0|(JI=0|bC(0|(vI=0|bC(0|(RI=0|bC(0|(YI=0|bC(0|(LI=0|bC(0|L,0|Y,0|R,0|LI)),0|o(),0|N,0|YI)),0|o(),0|v,0|RI)),0|o(),0|NI,0|vI)),0|o(),0|J,0|JI)),0|o(),0|M,0|MI)),0|o(),0|U,0|UI)),0|o(),0|x,0|xI)),0|o(),0|SI,0|PA)),0|o(),0|YA,0|g),YA=0|o(),XA=0|FC(0|KA,0|LA,-67108864&XA|0,0),o(),KA=0|KB(0|(LA=0|bC(0|OA,0|qA,33554432,0)),0|o(),26),PA=0|o(),PA=0|bC(0|(wI=0|bC(0|(uI=0|bC(0|(mI=0|bC(0|(FI=0|bC(0|(kI=0|bC(0|(bI=0|bC(0|(dI=0|bC(0|(HI=0|bC(0|(GI=0|bC(0|S,0|G,0|H,0|GI)),0|o(),0|d,0|HI)),0|o(),0|b,0|dI)),0|o(),0|k,0|bI)),0|o(),0|F,0|kI)),0|o(),0|m,0|FI)),0|o(),0|D,0|mI)),0|o(),0|DI,0|uI)),0|o(),0|lI,0|wI)),0|o(),0|KA,0|PA),KA=0|o(),LA=0|FC(0|OA,0|qA,-67108864&LA|0,0),o(),TA=0|bC(0|(OA=0|KB(0|(qA=0|bC(0|g,0|YA,16777216,0)),0|o(),25)),0|o(),0|I,0|TA),I=0|o(),qA=0|FC(0|g,0|YA,-33554432&qA|0,0),o(),g=0|KB(0|(YA=0|bC(0|PA,0|KA,16777216,0)),0|o(),25),OA=0|o(),OA=0|bC(0|(cI=0|bC(0|(_I=0|bC(0|(EI=0|bC(0|(nI=0|bC(0|(sI=0|bC(0|(yI=0|bC(0|(hI=0|bC(0|(pI=0|bC(0|(fI=0|bC(0|u,0|l,0|w,0|fI)),0|o(),0|f,0|pI)),0|o(),0|p,0|hI)),0|o(),0|h,0|yI)),0|o(),0|y,0|sI)),0|o(),0|s,0|nI)),0|o(),0|n,0|EI)),0|o(),0|E,0|_I)),0|o(),0|iI,0|cI)),0|o(),0|g,0|OA),g=0|o(),YA=0|FC(0|PA,0|KA,-33554432&YA|0,0),o(),PA=0|bC(0|oI,0|jA,0|(PA=0|CC(0|(KA=0|bC(0|TA,0|I,33554432,0)),0|o(),26)),0|o()),o(),KA=0|FC(0|TA,0|I,-67108864&KA|0,0),o(),TA=0|KB(0|(I=0|bC(0|OA,0|g,33554432,0)),0|o(),26),jA=0|o(),jA=0|bC(0|($A=0|bC(0|(II=0|bC(0|(gI=0|bC(0|(BI=0|bC(0|(CI=0|bC(0|(aI=0|bC(0|(tI=0|bC(0|(rI=0|bC(0|(QI=0|bC(0|_,0|i,0|eI,0|QI)),0|o(),0|c,0|rI)),0|o(),0|e,0|tI)),0|o(),0|Q,0|aI)),0|o(),0|r,0|CI)),0|o(),0|t,0|BI)),0|o(),0|C,0|gI)),0|o(),0|B,0|II)),0|o(),0|AI,0|$A)),0|o(),0|TA,0|jA),TA=0|o(),I=0|FC(0|OA,0|g,-67108864&I|0,0),o(),WA=0|bC(0|(OA=0|NB(0|(OA=0|KB(0|(g=0|bC(0|jA,0|TA,16777216,0)),0|o(),25)),0|o(),19,0)),0|o(),0|VA,0|WA),VA=0|o(),g=0|FC(0|jA,0|TA,-33554432&g|0,0),o(),jA=0|bC(0|ZA,0|zA,0|(jA=0|CC(0|(TA=0|bC(0|WA,0|VA,33554432,0)),0|o(),26)),0|o()),o(),TA=0|FC(0|WA,0|VA,-67108864&TA|0,0),o(),a[A>>2]=TA,a[A+4>>2]=jA,a[A+8>>2]=XA,a[A+12>>2]=qA,a[A+16>>2]=KA,a[A+20>>2]=PA,a[A+24>>2]=LA,a[A+28>>2]=YA,a[A+32>>2]=I,a[A+36>>2]=g}function F(A,I,g){A|=0,g|=0;var B,C,t=0,r=0,Q=0,e=0,c=0,i=0,_=0,E=0,n=0,s=0,y=0,p=0,f=0,w=0,l=0,u=0,D=0,m=0,F=0,k=0,b=0,d=0,H=0,G=0,S=0,x=0,U=0,M=0,J=0,v=0,N=0,R=0;B=h,C=h=h+63&-64,h=h+2048|0,da(C+1024|0,I|=0),Pg(C+1024|0,A),da(C,C+1024|0),Pg(C,g),A=0;do{r=0|a[C+1024+((4|(I=A<<4))<<3)>>2],Q=0|a[C+1024+((4|I)<<3)+4>>2],M=0|kg(0|a[C+1024+(I<<3)>>2],0|a[C+1024+(I<<3)+4>>2],r,Q),R=0|o(),H=0|bB(a[C+1024+((12|I)<<3)>>2]^M,a[C+1024+((12|I)<<3)+4>>2]^R,32),D=0|o(),D=0|bB((R=0|kg(M,R,Q=0|bB((w=0|kg(0|a[C+1024+((8|I)<<3)>>2],0|a[C+1024+((8|I)<<3)+4>>2],H,D))^r,(f=0|o())^Q,24),r=0|o()))^H,(M=0|o())^D,16),H=0|o(),a[C+1024+((12|I)<<3)>>2]=D,a[C+1024+((12|I)<<3)+4>>2]=H,f=0|kg(w,f,D,H),w=0|o(),a[C+1024+((8|I)<<3)>>2]=f,a[C+1024+((8|I)<<3)+4>>2]=w,r=0|bB(f^Q,w^r,63),Q=0|o(),a[C+1024+((4|I)<<3)>>2]=r,a[C+1024+((4|I)<<3)+4>>2]=Q,x=0|a[C+1024+((5|I)<<3)>>2],U=0|a[C+1024+((5|I)<<3)+4>>2],k=0|kg(0|a[C+1024+((1|I)<<3)>>2],0|a[C+1024+((1|I)<<3)+4>>2],x,U),G=0|o(),l=0|bB(a[C+1024+((13|I)<<3)>>2]^k,a[C+1024+((13|I)<<3)+4>>2]^G,32),n=0|o(),c=0|kg(i=0|kg(0|a[C+1024+((9|I)<<3)>>2],0|a[C+1024+((9|I)<<3)+4>>2],l,n),c=0|o(),n=0|bB((G=0|kg(k,G,U=0|bB(i^x,c^U,24),x=0|o()))^l,(k=0|o())^n,16),l=0|o()),i=0|o(),a[C+1024+((9|I)<<3)>>2]=c,a[C+1024+((9|I)<<3)+4>>2]=i,x=0|bB(c^U,i^x,63),U=0|o(),m=0|a[C+1024+((6|I)<<3)>>2],F=0|a[C+1024+((6|I)<<3)+4>>2],p=0|kg(0|a[C+1024+((2|I)<<3)>>2],0|a[C+1024+((2|I)<<3)+4>>2],m,F),u=0|o(),_=0|bB(a[C+1024+((14|I)<<3)>>2]^p,a[C+1024+((14|I)<<3)+4>>2]^u,32),t=0|o(),m=0|bB((J=0|kg(v=0|kg(0|a[C+1024+((10|I)<<3)>>2],0|a[C+1024+((10|I)<<3)+4>>2],_,t),J=0|o(),t=0|bB((u=0|kg(p,u,F=0|bB(v^m,J^F,24),m=0|o()))^_,(p=0|o())^t,16),_=0|o()))^F,(v=0|o())^m,63),F=0|o(),s=0|a[C+1024+((7|I)<<3)>>2],y=0|a[C+1024+((7|I)<<3)+4>>2],e=0|kg(0|a[C+1024+((3|I)<<3)>>2],0|a[C+1024+((3|I)<<3)+4>>2],s,y),E=0|o(),N=0|bB(a[C+1024+((15|I)<<3)>>2]^e,a[C+1024+((15|I)<<3)+4>>2]^E,32),S=0|o(),s=0|bB((b=0|kg(d=0|kg(0|a[C+1024+((11|I)<<3)>>2],0|a[C+1024+((11|I)<<3)+4>>2],N,S),b=0|o(),S=0|bB((E=0|kg(e,E,y=0|bB(d^s,b^y,24),s=0|o()))^N,(e=0|o())^S,16),N=0|o()))^y,(d=0|o())^s,63),y=0|o(),R=0|kg(M=0|kg(R,M,x,U),R=0|o(),U=0|bB((v=0|kg(J,v,N=0|bB(M^S,R^N,32),S=0|o()))^x,(J=0|o())^U,24),x=0|o()),M=0|o(),a[C+1024+(I<<3)>>2]=R,a[C+1024+(I<<3)+4>>2]=M,S=0|bB(R^N,M^S,16),M=0|o(),a[C+1024+((15|I)<<3)>>2]=S,a[C+1024+((15|I)<<3)+4>>2]=M,M=0|kg(v,J,S,M),S=0|o(),a[C+1024+((10|I)<<3)>>2]=M,a[C+1024+((10|I)<<3)+4>>2]=S,x=0|bB(M^U,S^x,63),S=0|o(),a[C+1024+((5|I)<<3)>>2]=x,a[C+1024+((5|I)<<3)+4>>2]=S,G=0|kg(k=0|kg(G,k,m,F),G=0|o(),F=0|bB((d=0|kg(b,d,H=0|bB(k^D,G^H,32),D=0|o()))^m,(b=0|o())^F,24),m=0|o()),k=0|o(),a[C+1024+((1|I)<<3)>>2]=G,a[C+1024+((1|I)<<3)+4>>2]=k,D=0|bB(G^H,k^D,16),k=0|o(),a[C+1024+((12|I)<<3)>>2]=D,a[C+1024+((12|I)<<3)+4>>2]=k,k=0|kg(d,b,D,k),D=0|o(),a[C+1024+((11|I)<<3)>>2]=k,a[C+1024+((11|I)<<3)+4>>2]=D,m=0|bB(k^F,D^m,63),D=0|o(),a[C+1024+((6|I)<<3)>>2]=m,a[C+1024+((6|I)<<3)+4>>2]=D,u=0|kg(p=0|kg(u,p,s,y),u=0|o(),y=0|bB((w=0|kg(f,w,l=0|bB(p^n,u^l,32),n=0|o()))^s,(f=0|o())^y,24),s=0|o()),p=0|o(),a[C+1024+((2|I)<<3)>>2]=u,a[C+1024+((2|I)<<3)+4>>2]=p,n=0|bB(u^l,p^n,16),p=0|o(),a[C+1024+((13|I)<<3)>>2]=n,a[C+1024+((13|I)<<3)+4>>2]=p,p=0|kg(w,f,n,p),n=0|o(),a[C+1024+((8|I)<<3)>>2]=p,a[C+1024+((8|I)<<3)+4>>2]=n,s=0|bB(p^y,n^s,63),n=0|o(),a[C+1024+((7|I)<<3)>>2]=s,a[C+1024+((7|I)<<3)+4>>2]=n,E=0|kg(e=0|kg(E,e,r,Q),E=0|o(),Q=0|bB((i=0|kg(c,i,_=0|bB(e^t,E^_,32),t=0|o()))^r,(c=0|o())^Q,24),r=0|o()),e=0|o(),a[C+1024+((3|I)<<3)>>2]=E,a[C+1024+((3|I)<<3)+4>>2]=e,t=0|bB(E^_,e^t,16),e=0|o(),a[C+1024+((14|I)<<3)>>2]=t,a[C+1024+((14|I)<<3)+4>>2]=e,e=0|kg(i,c,t,e),t=0|o(),a[C+1024+((9|I)<<3)>>2]=e,a[C+1024+((9|I)<<3)+4>>2]=t,r=0|bB(e^Q,t^r,63),t=0|o(),a[C+1024+((4|I)<<3)>>2]=r,a[C+1024+((4|I)<<3)+4>>2]=t,A=A+1|0}while(8!=(0|A));A=0;do{v=0|a[(J=C+1024+(32+(R=A<<1)<<3)|0)>>2],J=0|a[J+4>>2],e=0|kg(0|a[C+1024+(R<<3)>>2],0|a[C+1024+(R<<3)+4>>2],v,J),I=0|o(),n=0|bB(a[(n=C+1024+(R+96<<3)|0)>>2]^e,a[n+4>>2]^I,32),w=0|o(),w=0|bB((I=0|kg(e,I,J=0|bB((m=0|kg(0|a[(m=C+1024+(R+64<<3)|0)>>2],0|a[m+4>>2],n,w))^v,(F=0|o())^J,24),v=0|o()))^n,(e=0|o())^w,16),n=0|o(),a[(_=C+1024+(R+96<<3)|0)>>2]=w,a[_+4>>2]=n,F=0|kg(m,F,w,n),m=0|o(),a[(_=C+1024+(R+64<<3)|0)>>2]=F,a[_+4>>2]=m,v=0|bB(F^J,m^v,63),J=0|o(),a[(_=C+1024+(R+32<<3)|0)>>2]=v,a[_+4>>2]=J,c=0|a[(_=C+1024+(R+33<<3)|0)>>2],_=0|a[_+4>>2],p=0|kg(0|a[C+1024+((1|R)<<3)>>2],0|a[C+1024+((1|R)<<3)+4>>2],c,_),E=0|o(),D=0|bB(a[(D=C+1024+(R+97<<3)|0)>>2]^p,a[D+4>>2]^E,32),d=0|o(),U=0|kg(x=0|kg(0|a[(x=C+1024+(R+65<<3)|0)>>2],0|a[x+4>>2],D,d),U=0|o(),d=0|bB((E=0|kg(p,E,_=0|bB(x^c,U^_,24),c=0|o()))^D,(p=0|o())^d,16),D=0|o()),x=0|o(),a[(k=C+1024+(R+65<<3)|0)>>2]=U,a[k+4>>2]=x,c=0|bB(U^_,x^c,63),_=0|o(),k=C+1024+(R+16<<3)|0,f=0|a[(l=C+1024+(R+48<<3)|0)>>2],l=0|a[l+4>>2],k=0|kg(0|a[k>>2],0|a[k+4>>2],f,l),u=0|o(),S=0|bB(a[(S=C+1024+(R+112<<3)|0)>>2]^k,a[S+4>>2]^u,32),N=0|o(),f=0|bB((Q=0|kg(r=0|kg(0|a[(r=C+1024+(R+80<<3)|0)>>2],0|a[r+4>>2],S,N),Q=0|o(),N=0|bB((u=0|kg(k,u,l=0|bB(r^f,Q^l,24),f=0|o()))^S,(k=0|o())^N,16),S=0|o()))^l,(r=0|o())^f,63),l=0|o(),M=C+1024+(R+17<<3)|0,b=0|a[(H=C+1024+(R+49<<3)|0)>>2],H=0|a[H+4>>2],M=0|kg(0|a[M>>2],0|a[M+4>>2],b,H),G=0|o(),t=0|bB(a[(t=C+1024+(R+113<<3)|0)>>2]^M,a[t+4>>2]^G,32),i=0|o(),b=0|bB((y=0|kg(s=0|kg(0|a[(s=C+1024+(R+81<<3)|0)>>2],0|a[s+4>>2],t,i),y=0|o(),i=0|bB((G=0|kg(M,G,H=0|bB(s^b,y^H,24),b=0|o()))^t,(M=0|o())^i,16),t=0|o()))^H,(s=0|o())^b,63),H=0|o(),I=0|kg(e=0|kg(I,e,c,_),I=0|o(),_=0|bB((r=0|kg(Q,r,t=0|bB(e^i,I^t,32),i=0|o()))^c,(Q=0|o())^_,24),c=0|o()),e=0|o(),a[C+1024+(R<<3)>>2]=I,a[C+1024+(R<<3)+4>>2]=e,i=0|bB(I^t,e^i,16),e=0|o(),a[(t=C+1024+(R+113<<3)|0)>>2]=i,a[t+4>>2]=e,e=0|kg(r,Q,i,e),i=0|o(),a[(Q=C+1024+(R+80<<3)|0)>>2]=e,a[Q+4>>2]=i,c=0|bB(e^_,i^c,63),i=0|o(),a[(_=C+1024+(R+33<<3)|0)>>2]=c,a[_+4>>2]=i,E=0|kg(p=0|kg(E,p,f,l),E=0|o(),l=0|bB((s=0|kg(y,s,n=0|bB(p^w,E^n,32),w=0|o()))^f,(y=0|o())^l,24),f=0|o()),p=0|o(),a[C+1024+((1|R)<<3)>>2]=E,a[C+1024+((1|R)<<3)+4>>2]=p,w=0|bB(E^n,p^w,16),p=0|o(),a[(n=C+1024+(R+96<<3)|0)>>2]=w,a[n+4>>2]=p,p=0|kg(s,y,w,p),w=0|o(),a[(y=C+1024+(R+81<<3)|0)>>2]=p,a[y+4>>2]=w,f=0|bB(p^l,w^f,63),w=0|o(),a[(l=C+1024+(R+48<<3)|0)>>2]=f,a[l+4>>2]=w,u=0|kg(k=0|kg(u,k,b,H),u=0|o(),H=0|bB((m=0|kg(F,m,D=0|bB(k^d,u^D,32),d=0|o()))^b,(F=0|o())^H,24),b=0|o()),k=0|o(),a[(l=C+1024+(R+16<<3)|0)>>2]=u,a[l+4>>2]=k,d=0|bB(u^D,k^d,16),k=0|o(),a[(D=C+1024+(R+97<<3)|0)>>2]=d,a[D+4>>2]=k,k=0|kg(m,F,d,k),d=0|o(),a[(F=C+1024+(R+64<<3)|0)>>2]=k,a[F+4>>2]=d,b=0|bB(k^H,d^b,63),d=0|o(),a[(H=C+1024+(R+49<<3)|0)>>2]=b,a[H+4>>2]=d,G=0|kg(M=0|kg(G,M,v,J),G=0|o(),J=0|bB((x=0|kg(U,x,S=0|bB(M^N,G^S,32),N=0|o()))^v,(U=0|o())^J,24),v=0|o()),M=0|o(),a[(H=C+1024+(R+17<<3)|0)>>2]=G,a[H+4>>2]=M,N=0|bB(G^S,M^N,16),M=0|o(),a[(S=C+1024+(R+112<<3)|0)>>2]=N,a[S+4>>2]=M,M=0|kg(x,U,N,M),N=0|o(),a[(U=C+1024+(R+65<<3)|0)>>2]=M,a[U+4>>2]=N,v=0|bB(M^J,N^v,63),N=0|o(),a[(R=C+1024+(R+32<<3)|0)>>2]=v,a[R+4>>2]=N,A=A+1|0}while(8!=(0|A));da(g,C),Pg(g,C+1024|0),h=B}function k(A,I,g){A|=0,g|=0;var B,C,t=0,r=0,Q=0,e=0,c=0,i=0,_=0,E=0,n=0,s=0,y=0,p=0,f=0,w=0,l=0,u=0,D=0,m=0,F=0,k=0,b=0,d=0,H=0,G=0,S=0,x=0,U=0,M=0,J=0,v=0,N=0,R=0;B=h,C=h=h+63&-64,h=h+2048|0,da(C+1024|0,I|=0),Pg(C+1024|0,A),da(C,C+1024|0),A=0;do{r=0|a[C+1024+((4|(I=A<<4))<<3)>>2],Q=0|a[C+1024+((4|I)<<3)+4>>2],M=0|kg(0|a[C+1024+(I<<3)>>2],0|a[C+1024+(I<<3)+4>>2],r,Q),R=0|o(),H=0|bB(a[C+1024+((12|I)<<3)>>2]^M,a[C+1024+((12|I)<<3)+4>>2]^R,32),D=0|o(),D=0|bB((R=0|kg(M,R,Q=0|bB((w=0|kg(0|a[C+1024+((8|I)<<3)>>2],0|a[C+1024+((8|I)<<3)+4>>2],H,D))^r,(f=0|o())^Q,24),r=0|o()))^H,(M=0|o())^D,16),H=0|o(),a[C+1024+((12|I)<<3)>>2]=D,a[C+1024+((12|I)<<3)+4>>2]=H,f=0|kg(w,f,D,H),w=0|o(),a[C+1024+((8|I)<<3)>>2]=f,a[C+1024+((8|I)<<3)+4>>2]=w,r=0|bB(f^Q,w^r,63),Q=0|o(),a[C+1024+((4|I)<<3)>>2]=r,a[C+1024+((4|I)<<3)+4>>2]=Q,x=0|a[C+1024+((5|I)<<3)>>2],U=0|a[C+1024+((5|I)<<3)+4>>2],k=0|kg(0|a[C+1024+((1|I)<<3)>>2],0|a[C+1024+((1|I)<<3)+4>>2],x,U),G=0|o(),l=0|bB(a[C+1024+((13|I)<<3)>>2]^k,a[C+1024+((13|I)<<3)+4>>2]^G,32),n=0|o(),c=0|kg(i=0|kg(0|a[C+1024+((9|I)<<3)>>2],0|a[C+1024+((9|I)<<3)+4>>2],l,n),c=0|o(),n=0|bB((G=0|kg(k,G,U=0|bB(i^x,c^U,24),x=0|o()))^l,(k=0|o())^n,16),l=0|o()),i=0|o(),a[C+1024+((9|I)<<3)>>2]=c,a[C+1024+((9|I)<<3)+4>>2]=i,x=0|bB(c^U,i^x,63),U=0|o(),m=0|a[C+1024+((6|I)<<3)>>2],F=0|a[C+1024+((6|I)<<3)+4>>2],p=0|kg(0|a[C+1024+((2|I)<<3)>>2],0|a[C+1024+((2|I)<<3)+4>>2],m,F),u=0|o(),_=0|bB(a[C+1024+((14|I)<<3)>>2]^p,a[C+1024+((14|I)<<3)+4>>2]^u,32),t=0|o(),m=0|bB((J=0|kg(v=0|kg(0|a[C+1024+((10|I)<<3)>>2],0|a[C+1024+((10|I)<<3)+4>>2],_,t),J=0|o(),t=0|bB((u=0|kg(p,u,F=0|bB(v^m,J^F,24),m=0|o()))^_,(p=0|o())^t,16),_=0|o()))^F,(v=0|o())^m,63),F=0|o(),s=0|a[C+1024+((7|I)<<3)>>2],y=0|a[C+1024+((7|I)<<3)+4>>2],e=0|kg(0|a[C+1024+((3|I)<<3)>>2],0|a[C+1024+((3|I)<<3)+4>>2],s,y),E=0|o(),N=0|bB(a[C+1024+((15|I)<<3)>>2]^e,a[C+1024+((15|I)<<3)+4>>2]^E,32),S=0|o(),s=0|bB((b=0|kg(d=0|kg(0|a[C+1024+((11|I)<<3)>>2],0|a[C+1024+((11|I)<<3)+4>>2],N,S),b=0|o(),S=0|bB((E=0|kg(e,E,y=0|bB(d^s,b^y,24),s=0|o()))^N,(e=0|o())^S,16),N=0|o()))^y,(d=0|o())^s,63),y=0|o(),R=0|kg(M=0|kg(R,M,x,U),R=0|o(),U=0|bB((v=0|kg(J,v,N=0|bB(M^S,R^N,32),S=0|o()))^x,(J=0|o())^U,24),x=0|o()),M=0|o(),a[C+1024+(I<<3)>>2]=R,a[C+1024+(I<<3)+4>>2]=M,S=0|bB(R^N,M^S,16),M=0|o(),a[C+1024+((15|I)<<3)>>2]=S,a[C+1024+((15|I)<<3)+4>>2]=M,M=0|kg(v,J,S,M),S=0|o(),a[C+1024+((10|I)<<3)>>2]=M,a[C+1024+((10|I)<<3)+4>>2]=S,x=0|bB(M^U,S^x,63),S=0|o(),a[C+1024+((5|I)<<3)>>2]=x,a[C+1024+((5|I)<<3)+4>>2]=S,G=0|kg(k=0|kg(G,k,m,F),G=0|o(),F=0|bB((d=0|kg(b,d,H=0|bB(k^D,G^H,32),D=0|o()))^m,(b=0|o())^F,24),m=0|o()),k=0|o(),a[C+1024+((1|I)<<3)>>2]=G,a[C+1024+((1|I)<<3)+4>>2]=k,D=0|bB(G^H,k^D,16),k=0|o(),a[C+1024+((12|I)<<3)>>2]=D,a[C+1024+((12|I)<<3)+4>>2]=k,k=0|kg(d,b,D,k),D=0|o(),a[C+1024+((11|I)<<3)>>2]=k,a[C+1024+((11|I)<<3)+4>>2]=D,m=0|bB(k^F,D^m,63),D=0|o(),a[C+1024+((6|I)<<3)>>2]=m,a[C+1024+((6|I)<<3)+4>>2]=D,u=0|kg(p=0|kg(u,p,s,y),u=0|o(),y=0|bB((w=0|kg(f,w,l=0|bB(p^n,u^l,32),n=0|o()))^s,(f=0|o())^y,24),s=0|o()),p=0|o(),a[C+1024+((2|I)<<3)>>2]=u,a[C+1024+((2|I)<<3)+4>>2]=p,n=0|bB(u^l,p^n,16),p=0|o(),a[C+1024+((13|I)<<3)>>2]=n,a[C+1024+((13|I)<<3)+4>>2]=p,p=0|kg(w,f,n,p),n=0|o(),a[C+1024+((8|I)<<3)>>2]=p,a[C+1024+((8|I)<<3)+4>>2]=n,s=0|bB(p^y,n^s,63),n=0|o(),a[C+1024+((7|I)<<3)>>2]=s,a[C+1024+((7|I)<<3)+4>>2]=n,E=0|kg(e=0|kg(E,e,r,Q),E=0|o(),Q=0|bB((i=0|kg(c,i,_=0|bB(e^t,E^_,32),t=0|o()))^r,(c=0|o())^Q,24),r=0|o()),e=0|o(),a[C+1024+((3|I)<<3)>>2]=E,a[C+1024+((3|I)<<3)+4>>2]=e,t=0|bB(E^_,e^t,16),e=0|o(),a[C+1024+((14|I)<<3)>>2]=t,a[C+1024+((14|I)<<3)+4>>2]=e,e=0|kg(i,c,t,e),t=0|o(),a[C+1024+((9|I)<<3)>>2]=e,a[C+1024+((9|I)<<3)+4>>2]=t,r=0|bB(e^Q,t^r,63),t=0|o(),a[C+1024+((4|I)<<3)>>2]=r,a[C+1024+((4|I)<<3)+4>>2]=t,A=A+1|0}while(8!=(0|A));A=0;do{v=0|a[(J=C+1024+(32+(R=A<<1)<<3)|0)>>2],J=0|a[J+4>>2],e=0|kg(0|a[C+1024+(R<<3)>>2],0|a[C+1024+(R<<3)+4>>2],v,J),I=0|o(),n=0|bB(a[(n=C+1024+(R+96<<3)|0)>>2]^e,a[n+4>>2]^I,32),w=0|o(),w=0|bB((I=0|kg(e,I,J=0|bB((m=0|kg(0|a[(m=C+1024+(R+64<<3)|0)>>2],0|a[m+4>>2],n,w))^v,(F=0|o())^J,24),v=0|o()))^n,(e=0|o())^w,16),n=0|o(),a[(_=C+1024+(R+96<<3)|0)>>2]=w,a[_+4>>2]=n,F=0|kg(m,F,w,n),m=0|o(),a[(_=C+1024+(R+64<<3)|0)>>2]=F,a[_+4>>2]=m,v=0|bB(F^J,m^v,63),J=0|o(),a[(_=C+1024+(R+32<<3)|0)>>2]=v,a[_+4>>2]=J,c=0|a[(_=C+1024+(R+33<<3)|0)>>2],_=0|a[_+4>>2],p=0|kg(0|a[C+1024+((1|R)<<3)>>2],0|a[C+1024+((1|R)<<3)+4>>2],c,_),E=0|o(),D=0|bB(a[(D=C+1024+(R+97<<3)|0)>>2]^p,a[D+4>>2]^E,32),d=0|o(),U=0|kg(x=0|kg(0|a[(x=C+1024+(R+65<<3)|0)>>2],0|a[x+4>>2],D,d),U=0|o(),d=0|bB((E=0|kg(p,E,_=0|bB(x^c,U^_,24),c=0|o()))^D,(p=0|o())^d,16),D=0|o()),x=0|o(),a[(k=C+1024+(R+65<<3)|0)>>2]=U,a[k+4>>2]=x,c=0|bB(U^_,x^c,63),_=0|o(),k=C+1024+(R+16<<3)|0,f=0|a[(l=C+1024+(R+48<<3)|0)>>2],l=0|a[l+4>>2],k=0|kg(0|a[k>>2],0|a[k+4>>2],f,l),u=0|o(),S=0|bB(a[(S=C+1024+(R+112<<3)|0)>>2]^k,a[S+4>>2]^u,32),N=0|o(),f=0|bB((Q=0|kg(r=0|kg(0|a[(r=C+1024+(R+80<<3)|0)>>2],0|a[r+4>>2],S,N),Q=0|o(),N=0|bB((u=0|kg(k,u,l=0|bB(r^f,Q^l,24),f=0|o()))^S,(k=0|o())^N,16),S=0|o()))^l,(r=0|o())^f,63),l=0|o(),M=C+1024+(R+17<<3)|0,b=0|a[(H=C+1024+(R+49<<3)|0)>>2],H=0|a[H+4>>2],M=0|kg(0|a[M>>2],0|a[M+4>>2],b,H),G=0|o(),t=0|bB(a[(t=C+1024+(R+113<<3)|0)>>2]^M,a[t+4>>2]^G,32),i=0|o(),b=0|bB((y=0|kg(s=0|kg(0|a[(s=C+1024+(R+81<<3)|0)>>2],0|a[s+4>>2],t,i),y=0|o(),i=0|bB((G=0|kg(M,G,H=0|bB(s^b,y^H,24),b=0|o()))^t,(M=0|o())^i,16),t=0|o()))^H,(s=0|o())^b,63),H=0|o(),I=0|kg(e=0|kg(I,e,c,_),I=0|o(),_=0|bB((r=0|kg(Q,r,t=0|bB(e^i,I^t,32),i=0|o()))^c,(Q=0|o())^_,24),c=0|o()),e=0|o(),a[C+1024+(R<<3)>>2]=I,a[C+1024+(R<<3)+4>>2]=e,i=0|bB(I^t,e^i,16),e=0|o(),a[(t=C+1024+(R+113<<3)|0)>>2]=i,a[t+4>>2]=e,e=0|kg(r,Q,i,e),i=0|o(),a[(Q=C+1024+(R+80<<3)|0)>>2]=e,a[Q+4>>2]=i,c=0|bB(e^_,i^c,63),i=0|o(),a[(_=C+1024+(R+33<<3)|0)>>2]=c,a[_+4>>2]=i,E=0|kg(p=0|kg(E,p,f,l),E=0|o(),l=0|bB((s=0|kg(y,s,n=0|bB(p^w,E^n,32),w=0|o()))^f,(y=0|o())^l,24),f=0|o()),p=0|o(),a[C+1024+((1|R)<<3)>>2]=E,a[C+1024+((1|R)<<3)+4>>2]=p,w=0|bB(E^n,p^w,16),p=0|o(),a[(n=C+1024+(R+96<<3)|0)>>2]=w,a[n+4>>2]=p,p=0|kg(s,y,w,p),w=0|o(),a[(y=C+1024+(R+81<<3)|0)>>2]=p,a[y+4>>2]=w,f=0|bB(p^l,w^f,63),w=0|o(),a[(l=C+1024+(R+48<<3)|0)>>2]=f,a[l+4>>2]=w,u=0|kg(k=0|kg(u,k,b,H),u=0|o(),H=0|bB((m=0|kg(F,m,D=0|bB(k^d,u^D,32),d=0|o()))^b,(F=0|o())^H,24),b=0|o()),k=0|o(),a[(l=C+1024+(R+16<<3)|0)>>2]=u,a[l+4>>2]=k,d=0|bB(u^D,k^d,16),k=0|o(),a[(D=C+1024+(R+97<<3)|0)>>2]=d,a[D+4>>2]=k,k=0|kg(m,F,d,k),d=0|o(),a[(F=C+1024+(R+64<<3)|0)>>2]=k,a[F+4>>2]=d,b=0|bB(k^H,d^b,63),d=0|o(),a[(H=C+1024+(R+49<<3)|0)>>2]=b,a[H+4>>2]=d,G=0|kg(M=0|kg(G,M,v,J),G=0|o(),J=0|bB((x=0|kg(U,x,S=0|bB(M^N,G^S,32),N=0|o()))^v,(U=0|o())^J,24),v=0|o()),M=0|o(),a[(H=C+1024+(R+17<<3)|0)>>2]=G,a[H+4>>2]=M,N=0|bB(G^S,M^N,16),M=0|o(),a[(S=C+1024+(R+112<<3)|0)>>2]=N,a[S+4>>2]=M,M=0|kg(x,U,N,M),N=0|o(),a[(U=C+1024+(R+65<<3)|0)>>2]=M,a[U+4>>2]=N,v=0|bB(M^J,N^v,63),N=0|o(),a[(R=C+1024+(R+32<<3)|0)>>2]=v,a[R+4>>2]=N,A=A+1|0}while(8!=(0|A));da(g,C),Pg(g,C+1024|0),h=B}function b(A,I){A|=0;var g,B,C,t,r,Q,e,c,i,_,E,n,s,y,h,p,f,w,l,u,D,m,F,k,b,d,H,G,S,x,U,M,J,v,N,R,Y,L,P,K,q,X,j,T,V,W,z,Z,O,$,AA,IA,gA=0,BA=0,CA=0,aA=0,tA=0,rA=0,QA=0,eA=0,oA=0,cA=0,iA=0,_A=0,EA=0,nA=0,sA=0,yA=0,hA=0,pA=0,fA=0,wA=0,lA=0,uA=0,DA=0,mA=0,FA=0,kA=0,bA=0,dA=0,HA=0,GA=0,SA=0,xA=0,UA=0,MA=0,JA=0,vA=0,NA=0,RA=0,YA=0,LA=0,PA=0,KA=0,qA=0,XA=0,jA=0,TA=0,VA=0,WA=0,zA=0,ZA=0,OA=0,$A=0,AI=0,II=0,gI=0,BI=0,CI=0;eA=0|a[(I|=0)>>2],sA=0|a[I+4>>2],_A=0|a[I+8>>2],wA=0|a[I+12>>2],BA=0|a[I+16>>2],lA=0|a[I+20>>2],yA=0|a[I+24>>2],rA=0|a[I+28>>2],tA=0|a[I+32>>2],I=0|a[I+36>>2],$=0|NB(0|eA,((0|eA)<0)<<31>>31|0,0|eA,((0|eA)<0)<<31>>31|0),CI=0|o(),T=0|NB(eA<<1|0,0|(oA=((eA<<1|0)<0)<<31>>31),0|sA,((0|sA)<0)<<31>>31|0),AI=0|o(),q=0|NB(0|_A,((0|_A)<0)<<31>>31|0,eA<<1|0,0|oA),K=0|o(),N=0|NB(0|wA,((0|wA)<0)<<31>>31|0,eA<<1|0,0|oA),v=0|o(),H=0|NB(0|BA,((0|BA)<0)<<31>>31|0,eA<<1|0,0|oA),KA=0|o(),m=0|NB(0|lA,((0|lA)<0)<<31>>31|0,eA<<1|0,0|oA),NA=0|o(),p=0|NB(0|yA,((0|yA)<0)<<31>>31|0,eA<<1|0,0|oA),UA=0|o(),E=0|NB(0|rA,((0|rA)<0)<<31>>31|0,eA<<1|0,0|oA),dA=0|o(),r=0|NB(0|tA,((0|tA)<0)<<31>>31|0,eA<<1|0,0|oA),mA=0|o(),oA=0|NB(0|I,((0|I)<0)<<31>>31|0,eA<<1|0,0|oA),eA=0|o(),P=0|NB(sA<<1|0,0|(gA=((sA<<1|0)<0)<<31>>31),0|sA,((0|sA)<0)<<31>>31|0),ZA=0|o(),J=0|NB(sA<<1|0,0|gA,0|_A,((0|_A)<0)<<31>>31|0),TA=0|o(),x=0|NB(wA<<1|0,0|(CA=((wA<<1|0)<0)<<31>>31),sA<<1|0,0|gA),S=0|o(),b=0|NB(0|BA,((0|BA)<0)<<31>>31|0,sA<<1|0,0|gA),k=0|o(),f=0|NB(lA<<1|0,((lA<<1|0)<0)<<31>>31|0,sA<<1|0,0|gA),MA=0|o(),n=0|NB(0|yA,((0|yA)<0)<<31>>31|0,sA<<1|0,0|gA),HA=0|o(),Q=0|NB(rA<<1|0,((rA<<1|0)<0)<<31>>31|0,sA<<1|0,0|gA),FA=0|o(),cA=0|NB(0|tA,((0|tA)<0)<<31>>31|0,sA<<1|0,0|gA),iA=0|o(),gA=0|NB(38*I|0,0|(nA=((38*I|0)<0)<<31>>31),sA<<1|0,0|gA),sA=0|o(),G=0|NB(0|_A,((0|_A)<0)<<31>>31|0,0|_A,((0|_A)<0)<<31>>31|0),qA=0|o(),F=0|NB(_A<<1|0,((_A<<1|0)<0)<<31>>31|0,0|wA,((0|wA)<0)<<31>>31|0),RA=0|o(),w=0|NB(0|BA,((0|BA)<0)<<31>>31|0,_A<<1|0,((_A<<1|0)<0)<<31>>31|0),JA=0|o(),h=0|NB(0|lA,((0|lA)<0)<<31>>31|0,_A<<1|0,((_A<<1|0)<0)<<31>>31|0),y=0|o(),_=0|NB(0|yA,((0|yA)<0)<<31>>31|0,_A<<1|0,((_A<<1|0)<0)<<31>>31|0),i=0|o(),g=0|NB(0|rA,((0|rA)<0)<<31>>31|0,_A<<1|0,((_A<<1|0)<0)<<31>>31|0),uA=0|o(),z=0|NB(19*tA|0,0|(xA=((19*tA|0)<0)<<31>>31),_A<<1|0,((_A<<1|0)<0)<<31>>31|0),II=0|o(),_A=0|NB(38*I|0,0|nA,0|_A,((0|_A)<0)<<31>>31|0),hA=0|o(),u=0|NB(wA<<1|0,0|CA,0|wA,((0|wA)<0)<<31>>31|0),l=0|o(),s=0|NB(wA<<1|0,0|CA,0|BA,((0|BA)<0)<<31>>31|0),GA=0|o(),e=0|NB(lA<<1|0,((lA<<1|0)<0)<<31>>31|0,wA<<1|0,0|CA),kA=0|o(),t=0|NB(0|yA,((0|yA)<0)<<31>>31|0,wA<<1|0,0|CA),C=0|o(),Z=0|NB(38*rA|0,0|(PA=((38*rA|0)<0)<<31>>31),wA<<1|0,0|CA),gI=0|o(),X=0|NB(19*tA|0,0|xA,wA<<1|0,0|CA),OA=0|o(),CA=0|NB(38*I|0,0|nA,wA<<1|0,0|CA),wA=0|o(),c=0|NB(0|BA,((0|BA)<0)<<31>>31|0,0|BA,((0|BA)<0)<<31>>31|0),bA=0|o(),B=0|NB(BA<<1|0,((BA<<1|0)<0)<<31>>31|0,0|lA,((0|lA)<0)<<31>>31|0),DA=0|o(),O=0|NB(19*yA|0,((19*yA|0)<0)<<31>>31|0,BA<<1|0,((BA<<1|0)<0)<<31>>31|0),BI=0|o(),j=0|NB(38*rA|0,0|PA,0|BA,((0|BA)<0)<<31>>31|0),$A=0|o(),R=0|NB(19*tA|0,0|xA,BA<<1|0,((BA<<1|0)<0)<<31>>31|0),VA=0|o(),BA=0|NB(38*I|0,0|nA,0|BA,((0|BA)<0)<<31>>31|0),pA=0|o(),IA=0|NB(38*lA|0,((38*lA|0)<0)<<31>>31|0,0|lA,((0|lA)<0)<<31>>31|0),AA=0|o(),W=0|NB(19*yA|0,((19*yA|0)<0)<<31>>31|0,lA<<1|0,((lA<<1|0)<0)<<31>>31|0),V=0|o(),Y=0|NB(38*rA|0,0|PA,lA<<1|0,((lA<<1|0)<0)<<31>>31|0),WA=0|o(),U=0|NB(19*tA|0,0|xA,lA<<1|0,((lA<<1|0)<0)<<31>>31|0),XA=0|o(),lA=0|NB(38*I|0,0|nA,lA<<1|0,((lA<<1|0)<0)<<31>>31|0),EA=0|o(),L=0|NB(19*yA|0,((19*yA|0)<0)<<31>>31|0,0|yA,((0|yA)<0)<<31>>31|0),zA=0|o(),M=0|NB(38*rA|0,0|PA,0|yA,((0|yA)<0)<<31>>31|0),jA=0|o(),d=0|NB(19*tA|0,0|xA,yA<<1|0,((yA<<1|0)<0)<<31>>31|0),YA=0|o(),yA=0|NB(38*I|0,0|nA,0|yA,((0|yA)<0)<<31>>31|0),QA=0|o(),PA=0|NB(38*rA|0,0|PA,0|rA,((0|rA)<0)<<31>>31|0),LA=0|o(),D=0|NB(19*tA|0,0|xA,rA<<1|0,((rA<<1|0)<0)<<31>>31|0),vA=0|o(),rA=0|NB(38*I|0,0|nA,rA<<1|0,((rA<<1|0)<0)<<31>>31|0),fA=0|o(),xA=0|NB(19*tA|0,0|xA,0|tA,((0|tA)<0)<<31>>31|0),SA=0|o(),tA=0|NB(38*I|0,0|nA,0|tA,((0|tA)<0)<<31>>31|0),aA=0|o(),I=0|NB(38*I|0,0|nA,0|I,((0|I)<0)<<31>>31|0),nA=0|o(),sA=0|bC(0|(II=0|bC(0|(gI=0|bC(0|(BI=0|bC(0|(CI=0|bC(0|IA,0|AA,0|$,0|CI)),0|o(),0|O,0|BI)),0|o(),0|Z,0|gI)),0|o(),0|z,0|II)),0|o(),0|gA,0|sA),gA=0|o(),hA=0|bC(0|(OA=0|bC(0|($A=0|bC(0|(AI=0|bC(0|W,0|V,0|T,0|AI)),0|o(),0|j,0|$A)),0|o(),0|X,0|OA)),0|o(),0|_A,0|hA),_A=0|o(),wA=0|bC(0|(VA=0|bC(0|(WA=0|bC(0|(zA=0|bC(0|(ZA=0|bC(0|q,0|K,0|P,0|ZA)),0|o(),0|L,0|zA)),0|o(),0|Y,0|WA)),0|o(),0|R,0|VA)),0|o(),0|CA,0|wA),CA=0|o(),pA=0|bC(0|(XA=0|bC(0|(jA=0|bC(0|(TA=0|bC(0|N,0|v,0|J,0|TA)),0|o(),0|M,0|jA)),0|o(),0|U,0|XA)),0|o(),0|BA,0|pA),BA=0|o(),EA=0|bC(0|(YA=0|bC(0|(LA=0|bC(0|(KA=0|bC(0|(qA=0|bC(0|x,0|S,0|G,0|qA)),0|o(),0|H,0|KA)),0|o(),0|PA,0|LA)),0|o(),0|d,0|YA)),0|o(),0|lA,0|EA),lA=0|o(),QA=0|bC(0|(vA=0|bC(0|(NA=0|bC(0|(RA=0|bC(0|b,0|k,0|F,0|RA)),0|o(),0|m,0|NA)),0|o(),0|D,0|vA)),0|o(),0|yA,0|QA),yA=0|o(),fA=0|bC(0|(SA=0|bC(0|(UA=0|bC(0|(MA=0|bC(0|(JA=0|bC(0|u,0|l,0|w,0|JA)),0|o(),0|f,0|MA)),0|o(),0|p,0|UA)),0|o(),0|xA,0|SA)),0|o(),0|rA,0|fA),rA=0|o(),aA=0|bC(0|(dA=0|bC(0|(HA=0|bC(0|(GA=0|bC(0|h,0|y,0|s,0|GA)),0|o(),0|n,0|HA)),0|o(),0|E,0|dA)),0|o(),0|tA,0|aA),tA=0|o(),nA=0|bC(0|(mA=0|bC(0|(FA=0|bC(0|(kA=0|bC(0|(bA=0|bC(0|_,0|i,0|c,0|bA)),0|o(),0|e,0|kA)),0|o(),0|Q,0|FA)),0|o(),0|r,0|mA)),0|o(),0|I,0|nA),I=0|o(),eA=0|bC(0|(iA=0|bC(0|(uA=0|bC(0|(DA=0|bC(0|t,0|C,0|B,0|DA)),0|o(),0|g,0|uA)),0|o(),0|cA,0|iA)),0|o(),0|oA,0|eA),oA=0|o(),gA=0|$B(0|sA,0|gA,1),sA=0|o(),_A=0|$B(0|hA,0|_A,1),hA=0|o(),CA=0|$B(0|wA,0|CA,1),wA=0|o(),BA=0|$B(0|pA,0|BA,1),pA=0|o(),lA=0|$B(0|EA,0|lA,1),EA=0|o(),yA=0|$B(0|QA,0|yA,1),QA=0|o(),rA=0|$B(0|fA,0|rA,1),fA=0|o(),tA=0|$B(0|aA,0|tA,1),aA=0|o(),I=0|$B(0|nA,0|I,1),nA=0|o(),oA=0|$B(0|eA,0|oA,1),eA=0|o(),hA=0|bC(0|(uA=0|KB(0|(iA=0|bC(0|gA,0|sA,33554432,0)),0|(cA=0|o()),26)),0|o(),0|_A,0|hA),_A=0|o(),cA=0|FC(0|gA,0|sA,-67108864&iA|0,0|cA),iA=0|o(),QA=0|bC(0|(uA=0|KB(0|(sA=0|bC(0|lA,0|EA,33554432,0)),0|(gA=0|o()),26)),0|o(),0|yA,0|QA),yA=0|o(),gA=0|FC(0|lA,0|EA,-67108864&sA|0,0|gA),sA=0|o(),wA=0|bC(0|(lA=0|KB(0|(EA=0|bC(0|hA,0|_A,16777216,0)),0|o(),25)),0|o(),0|CA,0|wA),CA=0|o(),EA=0|FC(0|hA,0|_A,-33554432&EA|0,0),_A=0|o(),fA=0|bC(0|(lA=0|KB(0|(hA=0|bC(0|QA,0|yA,16777216,0)),0|o(),25)),0|o(),0|rA,0|fA),rA=0|o(),hA=0|FC(0|QA,0|yA,-33554432&hA|0,0),yA=0|o(),pA=0|bC(0|(lA=0|KB(0|(QA=0|bC(0|wA,0|CA,33554432,0)),0|o(),26)),0|o(),0|BA,0|pA),BA=0|o(),QA=0|FC(0|wA,0|CA,-67108864&QA|0,0),o(),aA=0|bC(0|(wA=0|KB(0|(CA=0|bC(0|fA,0|rA,33554432,0)),0|o(),26)),0|o(),0|tA,0|aA),tA=0|o(),CA=0|FC(0|fA,0|rA,-67108864&CA|0,0),o(),sA=0|bC(0|(fA=0|KB(0|(rA=0|bC(0|pA,0|BA,16777216,0)),0|o(),25)),0|o(),0|gA,0|sA),gA=0|o(),rA=0|FC(0|pA,0|BA,-33554432&rA|0,0),o(),nA=0|bC(0|(pA=0|KB(0|(BA=0|bC(0|aA,0|tA,16777216,0)),0|o(),25)),0|o(),0|I,0|nA),I=0|o(),BA=0|FC(0|aA,0|tA,-33554432&BA|0,0),o(),aA=0|bC(0|hA,0|yA,0|(aA=0|CC(0|(tA=0|bC(0|sA,0|gA,33554432,0)),0|o(),26)),0|o()),o(),tA=0|FC(0|sA,0|gA,-67108864&tA|0,0),o(),eA=0|bC(0|(sA=0|KB(0|(gA=0|bC(0|nA,0|I,33554432,0)),0|o(),26)),0|o(),0|oA,0|eA),oA=0|o(),gA=0|FC(0|nA,0|I,-67108864&gA|0,0),o(),iA=0|bC(0|(nA=0|NB(0|(nA=0|KB(0|(I=0|bC(0|eA,0|oA,16777216,0)),0|o(),25)),0|o(),19,0)),0|o(),0|cA,0|iA),cA=0|o(),I=0|FC(0|eA,0|oA,-33554432&I|0,0),o(),eA=0|bC(0|EA,0|_A,0|(eA=0|CC(0|(oA=0|bC(0|iA,0|cA,33554432,0)),0|o(),26)),0|o()),o(),oA=0|FC(0|iA,0|cA,-67108864&oA|0,0),o(),a[A>>2]=oA,a[A+4>>2]=eA,a[A+8>>2]=QA,a[A+12>>2]=rA,a[A+16>>2]=tA,a[A+20>>2]=aA,a[A+24>>2]=CA,a[A+28>>2]=BA,a[A+32>>2]=gA,a[A+36>>2]=I}function d(A,I){A|=0;var g,B,C,t,r,Q,e,c,i,_,E,n,s,y,h,p,f,w,l,u,D,m,F,k,b,d,H,G,S,x,U,M,J,v,N,R,Y,L,P,K,q,X,j,T,V,W,z,Z,O,$,AA=0,IA=0,gA=0,BA=0,CA=0,aA=0,tA=0,rA=0,QA=0,eA=0,oA=0,cA=0,iA=0,_A=0,EA=0,nA=0,sA=0,yA=0,hA=0,pA=0,fA=0,wA=0,lA=0,uA=0,DA=0,mA=0,FA=0,kA=0,bA=0,dA=0,HA=0,GA=0,SA=0,xA=0,UA=0,MA=0,JA=0,vA=0,NA=0,RA=0,YA=0,LA=0,PA=0,KA=0,qA=0,XA=0,jA=0,TA=0,VA=0,WA=0,zA=0,ZA=0,OA=0,$A=0,AI=0,II=0,gI=0,BI=0,CI=0;EA=0|a[(I|=0)>>2],AA=0|a[I+4>>2],tA=0|a[I+8>>2],aA=0|a[I+12>>2],GA=0|a[I+16>>2],iA=0|a[I+20>>2],jA=0|a[I+24>>2],IA=0|a[I+28>>2],kA=0|a[I+32>>2],wA=0|a[I+36>>2],Z=0|NB(0|EA,((0|EA)<0)<<31>>31|0,0|EA,((0|EA)<0)<<31>>31|0),CI=0|o(),v=0|NB(EA<<1|0,0|(nA=((EA<<1|0)<0)<<31>>31),0|AA,((0|AA)<0)<<31>>31|0),OA=0|o(),T=0|NB(0|tA,((0|tA)<0)<<31>>31|0,EA<<1|0,0|nA),j=0|o(),X=0|NB(0|aA,((0|aA)<0)<<31>>31|0,EA<<1|0,0|nA),q=0|o(),Y=0|NB(0|GA,((0|GA)<0)<<31>>31|0,EA<<1|0,0|nA),$A=0|o(),G=0|NB(0|iA,((0|iA)<0)<<31>>31|0,EA<<1|0,0|nA),VA=0|o(),l=0|NB(0|jA,((0|jA)<0)<<31>>31|0,EA<<1|0,0|nA),NA=0|o(),n=0|NB(0|IA,((0|IA)<0)<<31>>31|0,EA<<1|0,0|nA),bA=0|o(),Q=0|NB(0|kA,((0|kA)<0)<<31>>31|0,EA<<1|0,0|nA),lA=0|o(),nA=0|NB(0|wA,((0|wA)<0)<<31>>31|0,EA<<1|0,0|nA),EA=0|o(),qA=0|NB(AA<<1|0,0|(QA=((AA<<1|0)<0)<<31>>31),0|AA,((0|AA)<0)<<31>>31|0),XA=0|o(),UA=0|NB(AA<<1|0,0|QA,0|tA,((0|tA)<0)<<31>>31|0),MA=0|o(),K=0|NB(aA<<1|0,0|(_A=((aA<<1|0)<0)<<31>>31),AA<<1|0,0|QA),P=0|o(),U=0|NB(0|GA,((0|GA)<0)<<31>>31|0,AA<<1|0,0|QA),x=0|o(),u=0|NB(iA<<1|0,((iA<<1|0)<0)<<31>>31|0,AA<<1|0,0|QA),RA=0|o(),s=0|NB(0|jA,((0|jA)<0)<<31>>31|0,AA<<1|0,0|QA),dA=0|o(),e=0|NB(IA<<1|0,((IA<<1|0)<0)<<31>>31|0,AA<<1|0,0|QA),uA=0|o(),g=0|NB(0|kA,((0|kA)<0)<<31>>31|0,AA<<1|0,0|QA),sA=0|o(),QA=0|NB(38*wA|0,0|(fA=((38*wA|0)<0)<<31>>31),AA<<1|0,0|QA),AA=0|o(),L=0|NB(0|tA,((0|tA)<0)<<31>>31|0,0|tA,((0|tA)<0)<<31>>31|0),AI=0|o(),S=0|NB(tA<<1|0,((tA<<1|0)<0)<<31>>31|0,0|aA,((0|aA)<0)<<31>>31|0),WA=0|o(),D=0|NB(0|GA,((0|GA)<0)<<31>>31|0,tA<<1|0,((tA<<1|0)<0)<<31>>31|0),YA=0|o(),p=0|NB(0|iA,((0|iA)<0)<<31>>31|0,tA<<1|0,((tA<<1|0)<0)<<31>>31|0),h=0|o(),E=0|NB(0|jA,((0|jA)<0)<<31>>31|0,tA<<1|0,((tA<<1|0)<0)<<31>>31|0),_=0|o(),B=0|NB(0|IA,((0|IA)<0)<<31>>31|0,tA<<1|0,((tA<<1|0)<0)<<31>>31|0),yA=0|o(),V=0|NB(19*kA|0,0|(vA=((19*kA|0)<0)<<31>>31),tA<<1|0,((tA<<1|0)<0)<<31>>31|0),II=0|o(),tA=0|NB(38*wA|0,0|fA,0|tA,((0|tA)<0)<<31>>31|0),rA=0|o(),F=0|NB(aA<<1|0,0|_A,0|aA,((0|aA)<0)<<31>>31|0),m=0|o(),y=0|NB(aA<<1|0,0|_A,0|GA,((0|GA)<0)<<31>>31|0),HA=0|o(),c=0|NB(iA<<1|0,((iA<<1|0)<0)<<31>>31|0,aA<<1|0,0|_A),DA=0|o(),r=0|NB(0|jA,((0|jA)<0)<<31>>31|0,aA<<1|0,0|_A),t=0|o(),W=0|NB(38*IA|0,0|(pA=((38*IA|0)<0)<<31>>31),aA<<1|0,0|_A),gI=0|o(),M=0|NB(19*kA|0,0|vA,aA<<1|0,0|_A),zA=0|o(),_A=0|NB(38*wA|0,0|fA,aA<<1|0,0|_A),aA=0|o(),i=0|NB(0|GA,((0|GA)<0)<<31>>31|0,0|GA,((0|GA)<0)<<31>>31|0),mA=0|o(),C=0|NB(GA<<1|0,((GA<<1|0)<0)<<31>>31|0,0|iA,((0|iA)<0)<<31>>31|0),hA=0|o(),z=0|NB(19*jA|0,((19*jA|0)<0)<<31>>31|0,GA<<1|0,((GA<<1|0)<0)<<31>>31|0),BI=0|o(),J=0|NB(38*IA|0,0|pA,0|GA,((0|GA)<0)<<31>>31|0),ZA=0|o(),k=0|NB(19*kA|0,0|vA,GA<<1|0,((GA<<1|0)<0)<<31>>31|0),LA=0|o(),GA=0|NB(38*wA|0,0|fA,0|GA,((0|GA)<0)<<31>>31|0),BA=0|o(),$=0|NB(38*iA|0,((38*iA|0)<0)<<31>>31|0,0|iA,((0|iA)<0)<<31>>31|0),O=0|o(),R=0|NB(19*jA|0,((19*jA|0)<0)<<31>>31|0,iA<<1|0,((iA<<1|0)<0)<<31>>31|0),N=0|o(),b=0|NB(38*IA|0,0|pA,iA<<1|0,((iA<<1|0)<0)<<31>>31|0),PA=0|o(),f=0|NB(19*kA|0,0|vA,iA<<1|0,((iA<<1|0)<0)<<31>>31|0),SA=0|o(),iA=0|NB(38*wA|0,0|fA,iA<<1|0,((iA<<1|0)<0)<<31>>31|0),gA=0|o(),d=0|NB(19*jA|0,((19*jA|0)<0)<<31>>31|0,0|jA,((0|jA)<0)<<31>>31|0),KA=0|o(),w=0|NB(38*IA|0,0|pA,0|jA,((0|jA)<0)<<31>>31|0),xA=0|o(),eA=0|NB(19*kA|0,0|vA,jA<<1|0,((jA<<1|0)<0)<<31>>31|0),oA=0|o(),jA=0|NB(38*wA|0,0|fA,0|jA,((0|jA)<0)<<31>>31|0),CA=0|o(),pA=0|NB(38*IA|0,0|pA,0|IA,((0|IA)<0)<<31>>31|0),cA=0|o(),H=0|NB(19*kA|0,0|vA,IA<<1|0,((IA<<1|0)<0)<<31>>31|0),TA=0|o(),I=0|NB(38*wA|0,0|fA,IA<<1|0,((IA<<1|0)<0)<<31>>31|0),IA=0|o(),vA=0|NB(19*kA|0,0|vA,0|kA,((0|kA)<0)<<31>>31|0),JA=0|o(),kA=0|NB(38*wA|0,0|fA,0|kA,((0|kA)<0)<<31>>31|0),FA=0|o(),wA=0|NB(38*wA|0,0|fA,0|wA,((0|wA)<0)<<31>>31|0),fA=0|o(),AA=0|bC(0|(II=0|bC(0|(gI=0|bC(0|(BI=0|bC(0|(CI=0|bC(0|$,0|O,0|Z,0|CI)),0|o(),0|z,0|BI)),0|o(),0|W,0|gI)),0|o(),0|V,0|II)),0|o(),0|QA,0|AA),QA=0|o(),XA=0|bC(0|T,0|j,0|qA,0|XA),qA=0|o(),MA=0|bC(0|X,0|q,0|UA,0|MA),UA=0|o(),gA=0|bC(0|(oA=0|bC(0|(cA=0|bC(0|($A=0|bC(0|(AI=0|bC(0|K,0|P,0|L,0|AI)),0|o(),0|Y,0|$A)),0|o(),0|pA,0|cA)),0|o(),0|eA,0|oA)),0|o(),0|iA,0|gA),iA=0|o(),cA=0|KB(0|(oA=0|bC(0|AA,0|QA,33554432,0)),0|(eA=0|o()),26),pA=0|o(),pA=0|bC(0|(rA=0|bC(0|(zA=0|bC(0|(ZA=0|bC(0|(OA=0|bC(0|R,0|N,0|v,0|OA)),0|o(),0|J,0|ZA)),0|o(),0|M,0|zA)),0|o(),0|tA,0|rA)),0|o(),0|cA,0|pA),cA=0|o(),eA=0|FC(0|AA,0|QA,-67108864&oA|0,0|eA),oA=0|o(),rA=0|KB(0|(QA=0|bC(0|gA,0|iA,33554432,0)),0|(AA=0|o()),26),tA=0|o(),tA=0|bC(0|(CA=0|bC(0|(TA=0|bC(0|(VA=0|bC(0|(WA=0|bC(0|U,0|x,0|S,0|WA)),0|o(),0|G,0|VA)),0|o(),0|H,0|TA)),0|o(),0|jA,0|CA)),0|o(),0|rA,0|tA),rA=0|o(),AA=0|FC(0|gA,0|iA,-67108864&QA|0,0|AA),QA=0|o(),gA=0|KB(0|(iA=0|bC(0|pA,0|cA,16777216,0)),0|o(),25),CA=0|o(),CA=0|bC(0|(aA=0|bC(0|(LA=0|bC(0|(PA=0|bC(0|(KA=0|bC(0|XA,0|qA,0|d,0|KA)),0|o(),0|b,0|PA)),0|o(),0|k,0|LA)),0|o(),0|_A,0|aA)),0|o(),0|gA,0|CA),gA=0|o(),iA=0|FC(0|pA,0|cA,-33554432&iA|0,0),cA=0|o(),aA=0|KB(0|(pA=0|bC(0|tA,0|rA,16777216,0)),0|o(),25),_A=0|o(),_A=0|bC(0|(IA=0|bC(0|(JA=0|bC(0|(NA=0|bC(0|(RA=0|bC(0|(YA=0|bC(0|F,0|m,0|D,0|YA)),0|o(),0|u,0|RA)),0|o(),0|l,0|NA)),0|o(),0|vA,0|JA)),0|o(),0|I,0|IA)),0|o(),0|aA,0|_A),aA=0|o(),pA=0|FC(0|tA,0|rA,-33554432&pA|0,0),rA=0|o(),IA=0|KB(0|(tA=0|bC(0|CA,0|gA,33554432,0)),0|o(),26),I=0|o(),I=0|bC(0|(BA=0|bC(0|(SA=0|bC(0|(xA=0|bC(0|MA,0|UA,0|w,0|xA)),0|o(),0|f,0|SA)),0|o(),0|GA,0|BA)),0|o(),0|IA,0|I),IA=0|o(),tA=0|FC(0|CA,0|gA,-67108864&tA|0,0),o(),CA=0|KB(0|(gA=0|bC(0|_A,0|aA,33554432,0)),0|o(),26),BA=0|o(),BA=0|bC(0|(FA=0|bC(0|(bA=0|bC(0|(dA=0|bC(0|(HA=0|bC(0|p,0|h,0|y,0|HA)),0|o(),0|s,0|dA)),0|o(),0|n,0|bA)),0|o(),0|kA,0|FA)),0|o(),0|CA,0|BA),CA=0|o(),gA=0|FC(0|_A,0|aA,-67108864&gA|0,0),o(),QA=0|bC(0|(_A=0|KB(0|(aA=0|bC(0|I,0|IA,16777216,0)),0|o(),25)),0|o(),0|AA,0|QA),AA=0|o(),aA=0|FC(0|I,0|IA,-33554432&aA|0,0),o(),I=0|KB(0|(IA=0|bC(0|BA,0|CA,16777216,0)),0|o(),25),_A=0|o(),_A=0|bC(0|(fA=0|bC(0|(lA=0|bC(0|(uA=0|bC(0|(DA=0|bC(0|(mA=0|bC(0|E,0|_,0|i,0|mA)),0|o(),0|c,0|DA)),0|o(),0|e,0|uA)),0|o(),0|Q,0|lA)),0|o(),0|wA,0|fA)),0|o(),0|I,0|_A),I=0|o(),IA=0|FC(0|BA,0|CA,-33554432&IA|0,0),o(),BA=0|bC(0|pA,0|rA,0|(BA=0|CC(0|(CA=0|bC(0|QA,0|AA,33554432,0)),0|o(),26)),0|o()),o(),CA=0|FC(0|QA,0|AA,-67108864&CA|0,0),o(),QA=0|KB(0|(AA=0|bC(0|_A,0|I,33554432,0)),0|o(),26),rA=0|o(),rA=0|bC(0|(EA=0|bC(0|(sA=0|bC(0|(yA=0|bC(0|(hA=0|bC(0|r,0|t,0|C,0|hA)),0|o(),0|B,0|yA)),0|o(),0|g,0|sA)),0|o(),0|nA,0|EA)),0|o(),0|QA,0|rA),QA=0|o(),AA=0|FC(0|_A,0|I,-67108864&AA|0,0),o(),oA=0|bC(0|(_A=0|NB(0|(_A=0|KB(0|(I=0|bC(0|rA,0|QA,16777216,0)),0|o(),25)),0|o(),19,0)),0|o(),0|eA,0|oA),eA=0|o(),I=0|FC(0|rA,0|QA,-33554432&I|0,0),o(),rA=0|bC(0|iA,0|cA,0|(rA=0|CC(0|(QA=0|bC(0|oA,0|eA,33554432,0)),0|o(),26)),0|o()),o(),QA=0|FC(0|oA,0|eA,-67108864&QA|0,0),o(),a[A>>2]=QA,a[A+4>>2]=rA,a[A+8>>2]=tA,a[A+12>>2]=aA,a[A+16>>2]=CA,a[A+20>>2]=BA,a[A+24>>2]=gA,a[A+28>>2]=IA,a[A+32>>2]=AA,a[A+36>>2]=I}function H(A,I,g,B){A|=0,B|=0;var C=0,t=0,r=0,Q=0,e=0,o=0,c=0,i=0,_=0,E=0,n=0,s=0,y=0,h=0,p=0,f=0,w=0,l=0,u=0,D=0,m=0,F=0,k=0,b=0,d=0,H=0,G=0,S=0;!function(A,I){A|=0,I|=0;var g=0,B=0;g=0;do{B=0|vC(I+(g<<2)|0),a[A+(g<<2)>>2]=B,g=g+1|0}while(16!=(0|g))}(g|=0,I|=0),a[B>>2]=a[A>>2],a[B+4>>2]=a[A+4>>2],a[B+8>>2]=a[A+8>>2],a[B+12>>2]=a[A+12>>2],a[B+16>>2]=a[A+16>>2],a[B+20>>2]=a[A+20>>2],a[B+24>>2]=a[A+24>>2],a[B+28>>2]=a[A+28>>2],I=0|a[g>>2],p=0;do{if(k=0|xa(w=0|a[B+16>>2],6),k=(0|xa(w,11))^k,k^=0|xa(w,25),G=0|a[B+20>>2],d=0|a[B+24>>2],r=(k=I+k+(0|a[32592+(p<<2)>>2])+((d^G)&w^d)+(0|a[B+28>>2])|0)+(0|a[B+12>>2])|0,a[B+12>>2]=r,l=0|xa(m=0|a[B>>2],2),l=(0|xa(m,13))^l,l^=0|xa(m,22),f=0|a[B+4>>2],u=0|a[B+8>>2],a[B+28>>2]=l+k+((u|f)&m|u&f),F=0|xa(r,6),F=(0|xa(r,11))^F,F=(r&(G^w)^G)+d+(F^=0|xa(r,25))+(0|a[g+((n=1|p)<<2)>>2])+(0|a[32592+(n<<2)>>2])|0,a[B+8>>2]=F+u,d=0|xa(l+k+((u|f)&m|u&f)|0,2),d=F+(l+k+((u|f)&m|u&f)&(f|m)|f&m)+((d=(0|xa(l+k+((u|f)&m|u&f)|0,13))^d)^(0|xa(l+k+((u|f)&m|u&f)|0,22)))|0,a[B+24>>2]=d,b=0|xa(F+u|0,6),b=(0|xa(F+u|0,11))^b,b=(F+u&(r^w)^w)+G+(b^=0|xa(F+u|0,25))+(0|a[g+((I=2|p)<<2)>>2])+(0|a[32592+(I<<2)>>2])|0,a[B+4>>2]=b+f,G=0|xa(d,2),G=b+(d&(l+k+((u|f)&m|u&f)|m)|l+k+((u|f)&m|u&f)&m)+((G=(0|xa(d,13))^G)^(0|xa(d,22)))|0,a[B+20>>2]=G,H=0|xa(b+f|0,6),H=(0|xa(b+f|0,11))^H,H=(b+f&(F+u^r)^r)+w+(H^=0|xa(b+f|0,25))+(0|a[g+((C=3|p)<<2)>>2])+(0|a[32592+(C<<2)>>2])|0,a[B>>2]=H+m,w=0|xa(G,2),w=H+(G&(d|l+k+((u|f)&m|u&f))|d&l+k+((u|f)&m|u&f))+((w=(0|xa(G,13))^w)^(0|xa(G,22)))|0,a[B+16>>2]=w,D=0|xa(H+m|0,6),D=(0|xa(H+m|0,11))^D,k=(D=(H+m&(b+f^F+u)^F+u)+r+(D^=0|xa(H+m|0,25))+(0|a[g+((t=4|p)<<2)>>2])+(0|a[32592+(t<<2)>>2])|0)+(l+k+((u|f)&m|u&f))|0,a[B+28>>2]=k,l=0|xa(w,2),l=D+(w&(G|d)|G&d)+((l=(0|xa(w,13))^l)^(0|xa(w,22)))|0,a[B+12>>2]=l,D=0|xa(k,6),D=(0|xa(k,11))^D,D=(k&(H+m^b+f)^b+f)+(F+u)+(D^=0|xa(k,25))+(0|a[g+((r=5|p)<<2)>>2])+(0|a[32592+(r<<2)>>2])|0,a[B+24>>2]=D+d,u=0|xa(l,2),u=D+(l&(w|G)|w&G)+((u=(0|xa(l,13))^u)^(0|xa(l,22)))|0,a[B+8>>2]=u,F=0|xa(D+d|0,6),F=(0|xa(D+d|0,11))^F,F=(D+d&(k^H+m)^H+m)+(b+f)+(F^=0|xa(D+d|0,25))+(0|a[g+((Q=6|p)<<2)>>2])+(0|a[32592+(Q<<2)>>2])|0,a[B+20>>2]=F+G,f=0|xa(u,2),f=F+(u&(l|w)|l&w)+((f=(0|xa(u,13))^f)^(0|xa(u,22)))|0,a[B+4>>2]=f,b=0|xa(F+G|0,6),b=(0|xa(F+G|0,11))^b,b=(F+G&(D+d^k)^k)+(H+m)+(b^=0|xa(F+G|0,25))+(0|a[g+((e=7|p)<<2)>>2])+(0|a[32592+(e<<2)>>2])|0,a[B+16>>2]=b+w,m=0|xa(f,2),m=b+(f&(u|l)|u&l)+((m=(0|xa(f,13))^m)^(0|xa(f,22)))|0,a[B>>2]=m,H=0|xa(b+w|0,6),H=(0|xa(b+w|0,11))^H,H=(b+w&(F+G^D+d)^D+d)+k+(H^=0|xa(b+w|0,25))+(0|a[g+((o=8|p)<<2)>>2])+(0|a[32592+(o<<2)>>2])|0,a[B+12>>2]=H+l,k=0|xa(m,2),k=H+(m&(f|u)|f&u)+((k=(0|xa(m,13))^k)^(0|xa(m,22)))|0,a[B+28>>2]=k,S=0|xa(H+l|0,6),S=(0|xa(H+l|0,11))^S,S=(H+l&(b+w^F+G)^F+G)+(D+d)+(S^=0|xa(H+l|0,25))+(0|a[g+((c=9|p)<<2)>>2])+(0|a[32592+(c<<2)>>2])|0,a[B+8>>2]=S+u,d=0|xa(k,2),d=S+(k&(m|f)|m&f)+((d=(0|xa(k,13))^d)^(0|xa(k,22)))|0,a[B+24>>2]=d,D=0|xa(S+u|0,6),D=(0|xa(S+u|0,11))^D,D=(S+u&(H+l^b+w)^b+w)+(F+G)+(D^=0|xa(S+u|0,25))+(0|a[g+((i=10|p)<<2)>>2])+(0|a[32592+(i<<2)>>2])|0,a[B+4>>2]=D+f,G=0|xa(d,2),G=D+(d&(k|m)|k&m)+((G=(0|xa(d,13))^G)^(0|xa(d,22)))|0,a[B+20>>2]=G,F=0|xa(D+f|0,6),F=(0|xa(D+f|0,11))^F,F=(D+f&(S+u^H+l)^H+l)+(b+w)+(F^=0|xa(D+f|0,25))+(0|a[g+((_=11|p)<<2)>>2])+(0|a[32592+(_<<2)>>2])|0,a[B>>2]=F+m,w=0|xa(G,2),w=F+(G&(d|k)|d&k)+((w=(0|xa(G,13))^w)^(0|xa(G,22)))|0,a[B+16>>2]=w,b=0|xa(F+m|0,6),b=(0|xa(F+m|0,11))^b,b=(F+m&(D+f^S+u)^S+u)+(H+l)+(b^=0|xa(F+m|0,25))+(0|a[g+((E=12|p)<<2)>>2])+(0|a[32592+(E<<2)>>2])|0,a[B+28>>2]=b+k,l=0|xa(w,2),l=b+(w&(G|d)|G&d)+((l=(0|xa(w,13))^l)^(0|xa(w,22)))|0,a[B+12>>2]=l,H=0|xa(b+k|0,6),H=(0|xa(b+k|0,11))^H,H=(b+k&(F+m^D+f)^D+f)+(S+u)+(H^=0|xa(b+k|0,25))+(0|a[g+((s=13|p)<<2)>>2])+(0|a[32592+(s<<2)>>2])|0,a[B+24>>2]=H+d,u=0|xa(l,2),u=H+(l&(w|G)|w&G)+((u=(0|xa(l,13))^u)^(0|xa(l,22)))|0,a[B+8>>2]=u,S=0|xa(H+d|0,6),S=(0|xa(H+d|0,11))^S,S=(H+d&(b+k^F+m)^F+m)+(D+f)+(S^=0|xa(H+d|0,25))+(0|a[g+((y=14|p)<<2)>>2])+(0|a[32592+(y<<2)>>2])|0,a[B+20>>2]=S+G,f=0|xa(u,2),f=S+(u&(l|w)|l&w)+((f=(0|xa(u,13))^f)^(0|xa(u,22)))|0,a[B+4>>2]=f,D=0|xa(S+G|0,6),D=(0|xa(S+G|0,11))^D,D=(S+G&(H+d^b+k)^b+k)+(F+m)+(D^=0|xa(S+G|0,25))+(0|a[g+((h=15|p)<<2)>>2])+(0|a[32592+(h<<2)>>2])|0,a[B+16>>2]=D+w,w=0|xa(f,2),f=D+(f&(u|l)|u&l)+((w=(0|xa(f,13))^w)^(0|xa(f,22)))|0,a[B>>2]=f,48==(0|p))break;H=(S=0|a[g+(y<<2)>>2])>>>10^(H=0|xa(S,17))^(0|xa(S,19)),d=0|a[g+(c<<2)>>2],G=(m=0|a[g+(n<<2)>>2])>>>3^(G=0|xa(m,7))^(0|xa(m,18)),G=H+d+(0|a[g+(p<<2)>>2])+G|0,a[g+((p=p+16|0)<<2)>>2]=G,b=(H=0|a[g+(h<<2)>>2])>>>10^(b=0|xa(H,17))^(0|xa(H,19)),k=(u=0|a[g+(n+9<<2)>>2])+m+b+((D=0|a[g+(n+1<<2)>>2])>>>3^(k=0|xa(D,7))^(0|xa(D,18)))|0,a[g+(n+16<<2)>>2]=k,u=(G=G>>>10^(b=0|xa(G,17))^(0|xa(G,19)))+(b=0|a[g+(_<<2)>>2])+D+((m=0|a[g+(C<<2)>>2])>>>3^(u=0|xa(m,7))^(0|xa(m,18)))|0,a[g+(I+16<<2)>>2]=u,k=k>>>10^(D=0|xa(k,17))^(0|xa(k,19)),I=(D=0|a[g+(C+9<<2)>>2])+m+k+((G=0|a[g+(C+1<<2)>>2])>>>3^(I=0|xa(G,7))^(0|xa(G,18)))|0,a[g+(C+16<<2)>>2]=I,D=(u=u>>>10^(k=0|xa(u,17))^(0|xa(u,19)))+(k=0|a[g+(s<<2)>>2])+G+((m=0|a[g+(r<<2)>>2])>>>3^(D=0|xa(m,7))^(0|xa(m,18)))|0,a[g+(t+16<<2)>>2]=D,I=I>>>10^(G=0|xa(I,17))^(0|xa(I,19)),F=(G=0|a[g+(r+9<<2)>>2])+m+I+((u=0|a[g+(r+1<<2)>>2])>>>3^(F=0|xa(u,7))^(0|xa(u,18)))|0,a[g+(r+16<<2)>>2]=F,m=(D=(D>>>10^(I=0|xa(D,17))^(0|xa(D,19)))+H|0)+u+((I=0|a[g+(e<<2)>>2])>>>3^(m=0|xa(I,7))^(0|xa(I,18)))|0,a[g+(Q+16<<2)>>2]=m,F=F>>>10^(u=0|xa(F,17))^(0|xa(F,19)),G=(u=0|a[g+(e+9<<2)>>2])+I+F+((D=0|a[g+(e+1<<2)>>2])>>>3^(G=0|xa(D,7))^(0|xa(D,18)))|0,a[g+(e+16<<2)>>2]=G,F=(m=(m=m>>>10^(F=0|xa(m,17))^(0|xa(m,19)))+(0|a[g+(o+9<<2)>>2])|0)+D+((F=0|xa(d,7))^d>>>3^(0|xa(d,18)))|0,a[g+(o+16<<2)>>2]=F,G=G>>>10^(D=0|xa(G,17))^(0|xa(G,19)),I=(D=0|a[g+(c+9<<2)>>2])+d+G+((m=0|a[g+(c+1<<2)>>2])>>>3^(I=0|xa(m,7))^(0|xa(m,18)))|0,a[g+(c+16<<2)>>2]=I,G=(F=(F=F>>>10^(G=0|xa(F,17))^(0|xa(F,19)))+(0|a[g+(i+9<<2)>>2])|0)+m+((G=0|xa(b,7))^b>>>3^(0|xa(b,18)))|0,a[g+(i+16<<2)>>2]=G,I=I>>>10^(m=0|xa(I,17))^(0|xa(I,19)),d=(m=0|a[g+(_+9<<2)>>2])+b+I+((F=0|a[g+(_+1<<2)>>2])>>>3^(d=0|xa(F,7))^(0|xa(F,18)))|0,a[g+(_+16<<2)>>2]=d,I=(G=(G=G>>>10^(I=0|xa(G,17))^(0|xa(G,19)))+(0|a[g+(E+9<<2)>>2])|0)+F+((I=0|xa(k,7))^k>>>3^(0|xa(k,18)))|0,a[g+(E+16<<2)>>2]=I,d=d>>>10^(F=0|xa(d,17))^(0|xa(d,19)),G=(F=0|a[g+(s+9<<2)>>2])+k+d+((G=0|a[g+(s+1<<2)>>2])>>>3^(b=0|xa(G,7))^(0|xa(G,18)))|0,a[g+(s+16<<2)>>2]=G,I=I>>>10^(b=0|xa(I,17))^(0|xa(I,19)),d=(b=0|a[g+(y+9<<2)>>2])+S+I+((d=0|xa(H,7))^H>>>3^(0|xa(H,18)))|0,a[g+(y+16<<2)>>2]=d,G=G>>>10^(d=0|xa(G,17))^(0|xa(G,19)),S=(d=0|a[g+(h+9<<2)>>2])+H+G+((I=0|a[g+(h+1<<2)>>2])>>>3^(S=0|xa(I,7))^(0|xa(I,18)))|0,a[g+(h+16<<2)>>2]=S}while(p>>>0<64);I=0;do{a[(S=A+(I<<2)|0)>>2]=(0|a[S>>2])+(0|a[B+(I<<2)>>2]),I=I+1|0}while(8!=(0|I))}function G(A,I,g,B,C){A|=0,I|=0,g|=0,B|=0;var a=0,r=0,Q=0,e=0,c=0,i=0,_=0,E=0,n=0,s=0,y=0,h=0,p=0,f=0,w=0,l=0,u=0;if(i=0|wB(C|=0),E=0|o(),a=0|wB(C+8|0),r=0|o(),B=0|$B(0|g,0|B,56),C=0|o(),(I+g+(0-(7&g))|0)==(0|I))y=2037671283^a,Q=1952801890^r,s=1886610805^i,_=1936682341^E,c=1852075885^a,e=1685025377^r,w=1852142177^i,a=1819895653^E,r=I;else for(f=2037671283^a,Q=1952801890^r,y=1886610805^i,_=1936682341^E,c=1852075885^a,e=1685025377^r,r=1852142177^i,a=1819895653^E,s=I;;){if(u=(h=0|wB(s))^f,Q^=p=0|o(),w=0|bC(0|y,0|_,0|c,0|e),f=0|o(),i=0|dB(c,e,13),c=(0|o())^f,e=0|dB(w,f,32),f=0|o(),E=0|bC(0|u,0|Q,0|r,0|a),n=0|o(),f=0|bC((Q=0|dB(u,Q,16))^E|0,0|(r=(0|o())^n),0|e,0|f),e=0|o(),r=0|dB(Q^E,r,21),Q=e^(0|o()),n=0|bC(0|E,0|n,i^w|0,0|c),E=0|o(),c=0|dB(i^w,c,17),a=(0|o())^E,E=0|dB(n,E,32),w=0|o(),e=0|bC(c^n|0,0|a,0|f,0|e),i=0|o(),a=0|dB(c^n,a,13),n=(0|o())^i,i=0|dB(e,i,32),c=0|o(),w=0|bC(0|E,0|w,f^r|0,0|Q),E=0|o(),c=0|bC((Q=0|dB(f^r,Q,16))^w|0,0|(r=(0|o())^E),0|i,0|c),i=0|o(),r=0|dB(Q^w,r,21),Q=i^(0|o()),E=0|bC(a^e|0,0|n,0|w,0|E),w=0|o(),n=0|dB(a^e,n,17),e=(0|o())^w,w=0|dB(E,w,32),a=0|o(),(0|(s=s+8|0))==(I+g+(0-(7&g))|0)){y=c^r,s=c^h,_=i^p,c=n^E,r=I+g+(0-(7&g))|0;break}f=c^r,y=c^h,_=i^p,c=n^E,r=w}switch(7&g){case 7:l=0|$B(0|t[r+6>>0],0,48),C=0|o()|C,B|=l,l=6;break;case 6:l=6;break;case 5:l=7;break;case 4:l=8;break;case 3:l=9;break;case 2:l=10;break;case 1:l=11}return 6==(0|l)&&(u=0|$B(0|t[r+5>>0],0,40),C=0|o()|C,B|=u,l=7),7==(0|l)&&(C=0|t[r+4>>0]|C,l=8),8==(0|l)&&(B|=u=0|$B(0|t[r+3>>0],0,24),C=0|o()|C,l=9),9==(0|l)&&(B|=u=0|$B(0|t[r+2>>0],0,16),C=0|o()|C,l=10),10==(0|l)&&(B|=u=0|$B(0|t[r+1>>0],0,8),C=0|o()|C,l=11),11==(0|l)&&(B=0|B|t[r>>0]),g=B^y,p=C^Q,s=0|bC(0|s,0|_,0|c,0|e),y=0|o(),h=0|dB(c,e,13),I=(0|o())^y,y=0|dB(s,y,32),l=0|o(),w=0|bC(0|g,0|p,0|w,0|a),u=0|o(),l=0|bC((p=0|dB(g,p,16))^w|0,0|(g=(0|o())^u),0|y,0|l),y=0|o(),g=0|dB(p^w,g,21),p=y^(0|o()),u=0|bC(0|w,0|u,h^s|0,0|I),w=0|o(),I=0|dB(h^s,I,17),s=(0|o())^w,w=0|dB(u,w,32),h=0|o(),y=0|bC(I^u|0,0|s,0|l,0|y),f=0|o(),s=0|dB(I^u,s,13),u=(0|o())^f,f=0|dB(y,f,32),I=0|o(),h=0|bC(0|w,0|h,l^g|0,0|p),w=0|o(),I=0|bC((p=0|dB(l^g,p,16))^h|0,0|(g=(0|o())^w),0|f,0|I),f=0|o(),g=0|dB(p^h,g,21),p=f^(0|o()),w=0|bC(s^y|0,0|u,0|h,0|w),h=0|o(),u=0|dB(s^y,u,17),y=(0|o())^h,h=0|dB(w,h,32),s=0|o(),f=0|bC(I^B|0,f^C|0,u^w|0,0|y),l=0|o(),y=0|dB(u^w,y,13),w=(0|o())^l,l=0|dB(f,l,32),u=0|o(),s=0|bC(255^h|0,0|s,I^g|0,0|p),h=0|o(),u=0|bC((p=0|dB(I^g,p,16))^s|0,0|(g=(0|o())^h),0|l,0|u),l=0|o(),g=0|dB(p^s,g,21),p=l^(0|o()),h=0|bC(0|s,0|h,y^f|0,0|w),s=0|o(),w=0|dB(y^f,w,17),f=(0|o())^s,s=0|dB(h,s,32),y=0|o(),l=0|bC(w^h|0,0|f,0|u,0|l),I=0|o(),f=0|dB(w^h,f,13),h=(0|o())^I,I=0|dB(l,I,32),w=0|o(),y=0|bC(0|s,0|y,u^g|0,0|p),s=0|o(),w=0|bC((p=0|dB(u^g,p,16))^y|0,0|(g=(0|o())^s),0|I,0|w),I=0|o(),g=0|dB(p^y,g,21),p=I^(0|o()),s=0|bC(f^l|0,0|h,0|y,0|s),y=0|o(),h=0|dB(f^l,h,17),l=(0|o())^y,y=0|dB(s,y,32),f=0|o(),I=0|bC(h^s|0,0|l,0|w,0|I),u=0|o(),l=0|dB(h^s,l,13),s=(0|o())^u,u=0|dB(I,u,32),h=0|o(),f=0|bC(0|y,0|f,w^g|0,0|p),y=0|o(),h=0|bC((p=0|dB(w^g,p,16))^f|0,0|(g=(0|o())^y),0|u,0|h),u=0|o(),g=0|dB(p^f,g,21),p=u^(0|o()),y=0|bC(l^I|0,0|s,0|f,0|y),f=0|o(),s=0|dB(l^I,s,17),I=(0|o())^f,f=0|dB(y,f,32),l=0|o(),u=0|bC(s^y|0,0|I,0|h,0|u),w=0|o(),I=0|dB(s^y,I,13),w=(0|o())^w,l=0|bC(0|f,0|l,h^g|0,0|p),f=0|o(),p=0|dB((p=0|dB(h^g,p,16))^l,(0|o())^f,21),g=0|o(),f=0|bC(I^u|0,0|w,0|l,0|f),l=0|o(),w=0|dB(I^u,w,17),u=0|o(),tB(A,p^f^w^(I=0|dB(f,l,32)),g^l^u^(0|o())),0}function S(A){var I=0,g=0,B=0,C=0,t=0,r=0,Q=0,e=0,o=0;if(A|=0){I=0|a[8891],o=A+-8+(-8&(g=0|a[A+-4>>2]))|0;do{if(1&g)Q=A+-8|0,e=A+-8|0,A=-8&g;else{if(B=0|a[A+-8>>2],!(3&g))return;if(r=B+(-8&g)|0,(t=A+-8+(0-B)|0)>>>0<I>>>0)return;if((0|a[8892])==(0|t)){if(3!=(3&(A=0|a[o+4>>2])|0)){Q=t,e=t,A=r;break}return a[8889]=r,a[o+4>>2]=-2&A,a[t+4>>2]=1|r,void(a[t+r>>2]=r)}if(B>>>0<256){if(A=0|a[t+8>>2],(0|(I=0|a[t+12>>2]))==(0|A)){a[8887]=a[8887]&~(1<<(B>>>3)),Q=t,e=t,A=r;break}a[A+12>>2]=I,a[I+8>>2]=A,Q=t,e=t,A=r;break}C=0|a[t+24>>2],A=0|a[t+12>>2];do{if((0|A)==(0|t)){if(A=0|a[t+16+4>>2])I=t+16+4|0;else{if(!(A=0|a[t+16>>2])){A=0;break}I=t+16|0}for(;;)if(g=0|a[(B=A+20|0)>>2])A=g,I=B;else{if(!(g=0|a[(B=A+16|0)>>2]))break;A=g,I=B}a[I>>2]=0}else e=0|a[t+8>>2],a[e+12>>2]=A,a[A+8>>2]=e}while(0);if(C){if(I=0|a[t+28>>2],(0|a[35852+(I<<2)>>2])==(0|t)){if(a[35852+(I<<2)>>2]=A,!A){a[8888]=a[8888]&~(1<<I),Q=t,e=t,A=r;break}}else if(a[((0|a[C+16>>2])==(0|t)?C+16|0:C+20|0)>>2]=A,!A){Q=t,e=t,A=r;break}a[A+24>>2]=C,0|(I=0|a[t+16>>2])&&(a[A+16>>2]=I,a[I+24>>2]=A),(I=0|a[t+16+4>>2])?(a[A+20>>2]=I,a[I+24>>2]=A,Q=t,e=t,A=r):(Q=t,e=t,A=r)}else Q=t,e=t,A=r}}while(0);if(!(Q>>>0>=o>>>0)&&1&(g=0|a[o+4>>2])){if(2&g)a[o+4>>2]=-2&g,a[e+4>>2]=1|A,a[Q+A>>2]=A,C=A;else{if((0|a[8893])==(0|o)){if(o=(0|a[8890])+A|0,a[8890]=o,a[8893]=e,a[e+4>>2]=1|o,(0|e)!=(0|a[8892]))return;return a[8892]=0,void(a[8889]=0)}if((0|a[8892])==(0|o))return o=(0|a[8889])+A|0,a[8889]=o,a[8892]=Q,a[e+4>>2]=1|o,void(a[Q+o>>2]=o);C=(-8&g)+A|0;do{if(g>>>0<256){if(I=0|a[o+8>>2],(0|(A=0|a[o+12>>2]))==(0|I)){a[8887]=a[8887]&~(1<<(g>>>3));break}a[I+12>>2]=A,a[A+8>>2]=I;break}t=0|a[o+24>>2],A=0|a[o+12>>2];do{if((0|A)==(0|o)){if(A=0|a[o+16+4>>2])I=o+16+4|0;else{if(!(A=0|a[o+16>>2])){I=0;break}I=o+16|0}for(;;)if(g=0|a[(B=A+20|0)>>2])A=g,I=B;else{if(!(g=0|a[(B=A+16|0)>>2]))break;A=g,I=B}a[I>>2]=0,I=A}else I=0|a[o+8>>2],a[I+12>>2]=A,a[A+8>>2]=I,I=A}while(0);if(0|t){if(A=0|a[o+28>>2],(0|a[35852+(A<<2)>>2])==(0|o)){if(a[35852+(A<<2)>>2]=I,!I){a[8888]=a[8888]&~(1<<A);break}}else if(a[((0|a[t+16>>2])==(0|o)?t+16|0:t+20|0)>>2]=I,!I)break;a[I+24>>2]=t,0|(A=0|a[o+16>>2])&&(a[I+16>>2]=A,a[A+24>>2]=I),0|(A=0|a[o+16+4>>2])&&(a[I+20>>2]=A,a[A+24>>2]=I)}}while(0);if(a[e+4>>2]=1|C,a[Q+C>>2]=C,(0|e)==(0|a[8892]))return void(a[8889]=C)}if(g=C>>>3,C>>>0<256)return(A=0|a[8887])&1<<g?(A=35588+(g<<1<<2)+8|0,I=0|a[35588+(g<<1<<2)+8>>2]):(a[8887]=A|1<<g,A=35588+(g<<1<<2)+8|0,I=35588+(g<<1<<2)|0),a[A>>2]=e,a[I+12>>2]=e,a[e+8>>2]=I,void(a[e+12>>2]=35588+(g<<1<<2));I=35852+((B=(A=C>>>8)?C>>>0>16777215?31:C>>>(7+(B=14-((520192+(A<<((A+1048320|0)>>>16&8))|0)>>>16&4|(A+1048320|0)>>>16&8|(245760+(B=A<<((A+1048320|0)>>>16&8)<<((520192+(A<<((A+1048320|0)>>>16&8))|0)>>>16&4))|0)>>>16&2)+(B<<((B+245760|0)>>>16&2)>>>15)|0)|0)&1|B<<1:0)<<2)|0,a[e+28>>2]=B,a[e+20>>2]=0,a[e+16>>2]=0,A=0|a[8888],g=1<<B;A:do{if(A&g){A=0|a[I>>2];I:do{if((-8&a[A+4>>2]|0)!=(0|C)){for(B=C<<(31==(0|B)?0:25-(B>>>1)|0);I=0|a[(g=A+16+(B>>>31<<2)|0)>>2];){if((-8&a[I+4>>2]|0)==(0|C)){A=I;break I}B<<=1,A=I}a[g>>2]=e,a[e+24>>2]=A,a[e+12>>2]=e,a[e+8>>2]=e;break A}}while(0);o=0|a[(Q=A+8|0)>>2],a[o+12>>2]=e,a[Q>>2]=e,a[e+8>>2]=o,a[e+12>>2]=A,a[e+24>>2]=0}else a[8888]=A|g,a[I>>2]=e,a[e+24>>2]=I,a[e+12>>2]=e,a[e+8>>2]=e}while(0);if(o=(0|a[8895])-1|0,a[8895]=o,!(0|o)){for(A=36004;A=0|a[A>>2];)A=A+8|0;a[8895]=-1}}}}function x(A,I){I|=0;var g=0,B=0,C=0,t=0,r=0,Q=0,e=0;g=0|a[4+(A|=0)>>2];do{if(1&g)e=A,g=I;else{if(Q=0|a[A>>2],!(3&g))return;if((0|a[8892])==(A+(0-Q)|0)){if(3!=(3&(g=0|a[A+I+4>>2])|0)){e=A+(0-Q)|0,g=Q+I|0;break}return a[8889]=Q+I,a[A+I+4>>2]=-2&g,a[A+(0-Q)+4>>2]=Q+I|1,void(a[A+I>>2]=Q+I)}if(Q>>>0<256){if(g=0|a[A+(0-Q)+8>>2],(0|(B=0|a[A+(0-Q)+12>>2]))==(0|g)){a[8887]=a[8887]&~(1<<(Q>>>3)),e=A+(0-Q)|0,g=Q+I|0;break}a[g+12>>2]=B,a[B+8>>2]=g,e=A+(0-Q)|0,g=Q+I|0;break}r=0|a[A+(0-Q)+24>>2],g=0|a[A+(0-Q)+12>>2];do{if((0|g)==(A+(0-Q)|0)){if(g=0|a[4+(B=A+(0-Q)+16|0)>>2])B=B+4|0;else if(!(g=0|a[B>>2])){B=0;break}for(;;)if(C=0|a[(t=g+20|0)>>2])g=C,B=t;else{if(!(C=0|a[(t=g+16|0)>>2]))break;g=C,B=t}a[B>>2]=0,B=g}else B=0|a[A+(0-Q)+8>>2],a[B+12>>2]=g,a[g+8>>2]=B,B=g}while(0);if(r){if(g=0|a[A+(0-Q)+28>>2],(0|a[35852+(g<<2)>>2])==(A+(0-Q)|0)){if(a[35852+(g<<2)>>2]=B,!B){a[8888]=a[8888]&~(1<<g),e=A+(0-Q)|0,g=Q+I|0;break}}else if(a[((0|a[r+16>>2])==(A+(0-Q)|0)?r+16|0:r+20|0)>>2]=B,!B){e=A+(0-Q)|0,g=Q+I|0;break}a[B+24>>2]=r,0|(g=0|a[A+(0-Q)+16>>2])&&(a[B+16>>2]=g,a[g+24>>2]=B),(g=0|a[A+(0-Q)+16+4>>2])?(a[B+20>>2]=g,a[g+24>>2]=B,e=A+(0-Q)|0,g=Q+I|0):(e=A+(0-Q)|0,g=Q+I|0)}else e=A+(0-Q)|0,g=Q+I|0}}while(0);if(2&(C=0|a[A+I+4>>2]))a[A+I+4>>2]=-2&C,a[e+4>>2]=1|g,a[e+g>>2]=g,r=g;else{if((0|a[8893])==(A+I|0)){if(I=(0|a[8890])+g|0,a[8890]=I,a[8893]=e,a[e+4>>2]=1|I,(0|e)!=(0|a[8892]))return;return a[8892]=0,void(a[8889]=0)}if((0|a[8892])==(A+I|0))return I=(0|a[8889])+g|0,a[8889]=I,a[8892]=e,a[e+4>>2]=1|I,void(a[e+I>>2]=I);r=(-8&C)+g|0;do{if(C>>>0<256){if(B=0|a[A+I+8>>2],(0|(g=0|a[A+I+12>>2]))==(0|B)){a[8887]=a[8887]&~(1<<(C>>>3));break}a[B+12>>2]=g,a[g+8>>2]=B;break}Q=0|a[A+I+24>>2],g=0|a[A+I+12>>2];do{if((0|g)==(A+I|0)){if(g=0|a[A+I+16+4>>2])B=A+I+16+4|0;else{if(!(g=0|a[A+I+16>>2])){B=0;break}B=A+I+16|0}for(;;)if(C=0|a[(t=g+20|0)>>2])g=C,B=t;else{if(!(C=0|a[(t=g+16|0)>>2]))break;g=C,B=t}a[B>>2]=0,B=g}else B=0|a[A+I+8>>2],a[B+12>>2]=g,a[g+8>>2]=B,B=g}while(0);if(0|Q){if(g=0|a[A+I+28>>2],(0|a[35852+(g<<2)>>2])==(A+I|0)){if(a[35852+(g<<2)>>2]=B,!B){a[8888]=a[8888]&~(1<<g);break}}else if(a[((0|a[Q+16>>2])==(A+I|0)?Q+16|0:Q+20|0)>>2]=B,!B)break;a[B+24>>2]=Q,0|(g=0|a[A+I+16>>2])&&(a[B+16>>2]=g,a[g+24>>2]=B),0|(g=0|a[A+I+16+4>>2])&&(a[B+20>>2]=g,a[g+24>>2]=B)}}while(0);if(a[e+4>>2]=1|r,a[e+r>>2]=r,(0|e)==(0|a[8892]))return void(a[8889]=r)}if(C=r>>>3,r>>>0<256)return(g=0|a[8887])&1<<C?(g=35588+(C<<1<<2)+8|0,B=0|a[35588+(C<<1<<2)+8>>2]):(a[8887]=g|1<<C,g=35588+(C<<1<<2)+8|0,B=35588+(C<<1<<2)|0),a[g>>2]=e,a[B+12>>2]=e,a[e+8>>2]=B,void(a[e+12>>2]=35588+(C<<1<<2));if(B=35852+((t=(g=r>>>8)?r>>>0>16777215?31:r>>>(7+(t=14-((520192+(g<<((g+1048320|0)>>>16&8))|0)>>>16&4|(g+1048320|0)>>>16&8|(245760+(t=g<<((g+1048320|0)>>>16&8)<<((520192+(g<<((g+1048320|0)>>>16&8))|0)>>>16&4))|0)>>>16&2)+(t<<((t+245760|0)>>>16&2)>>>15)|0)|0)&1|t<<1:0)<<2)|0,a[e+28>>2]=t,a[e+20>>2]=0,a[e+16>>2]=0,!((g=0|a[8888])&(C=1<<t)))return a[8888]=g|C,a[B>>2]=e,a[e+24>>2]=B,a[e+12>>2]=e,void(a[e+8>>2]=e);g=0|a[B>>2];A:do{if((-8&a[g+4>>2]|0)!=(0|r)){for(t=r<<(31==(0|t)?0:25-(t>>>1)|0);B=0|a[(C=g+16+(t>>>31<<2)|0)>>2];){if((-8&a[B+4>>2]|0)==(0|r)){g=B;break A}t<<=1,g=B}return a[C>>2]=e,a[e+24>>2]=g,a[e+12>>2]=e,void(a[e+8>>2]=e)}}while(0);I=0|a[(A=g+8|0)>>2],a[I+12>>2]=e,a[A>>2]=e,a[e+8>>2]=I,a[e+12>>2]=g,a[e+24>>2]=0}function U(A,I,g,C,t){A|=0,I|=0,g|=0;var r,Q,e=0,c=0,i=0,_=0,E=0,n=0,s=0,y=0,p=0,f=0,w=0,l=0,u=0,D=0,m=0,F=0,k=0,b=0,d=0,H=0,G=0,S=0,x=0,U=0,M=0,J=0,v=0,N=0,R=0,Y=0,L=0,P=0,K=0,q=0,X=0,j=0,T=0,V=0,W=0,z=0,Z=0,O=0,$=0,AA=0,IA=0,gA=0,BA=0,CA=0,aA=0,tA=0,rA=0,QA=0,eA=0,oA=0,cA=0,iA=0,_A=0;if(Q=h,r=h=h+63&-64,h=h+64|0,!(0==(0|(C|=0))&0==(0|(t|=0)))){for(L=0|a[A>>2],P=0|a[A+4>>2],K=0|a[A+8>>2],q=0|a[A+12>>2],X=0|a[A+16>>2],S=0|a[A+20>>2],x=0|a[A+24>>2],U=0|a[A+28>>2],M=0|a[A+32>>2],J=0|a[A+36>>2],v=0|a[A+40>>2],N=0|a[A+44>>2],R=0|a[A+56>>2],Y=0|a[A+60>>2],c=0,H=0|a[A+48>>2],G=0|a[A+52>>2],i=I;;){if(d=t>>>0<0|0==(0|t)&C>>>0<64){e=(I=r)+64|0;do{a[I>>2]=0,I=I+4|0}while((0|I)<(0|e));I=0;do{B[r+I>>0]=0|B[i+I>>0],I=I+1|0}while(t>>>0>0|0==(0|t)&C>>>0>I>>>0);b=r,c=g,i=r}else b=g;g=20,I=L,e=P,_=v,E=N,n=H,s=G,y=R,p=Y,f=K,w=q,l=X,u=S,D=x,m=U,F=M,k=J;do{z=0|Ga((AA=0|Ga((iA=0|Ga(($=(AA=0|Ga((cA=I+l|0)^n,16))+F|0)^l,12))+cA^AA,8))+$^iA,7),_A=0|Ga((V=0|Ga((QA=0|Ga((T=(V=0|Ga((rA=e+u|0)^s,16))+k|0)^u,12))+rA^V,8))+T^QA,7),eA=0|Ga((W=0|Ga((BA=0|Ga((IA=(W=0|Ga((gA=f+D|0)^y,16))+_|0)^D,12))+gA^W,8))+IA^BA,7),CA=0|Ga((aA=0|Ga((O=0|Ga((j=(aA=0|Ga((Z=w+m|0)^p,16))+E|0)^m,12))+Z^aA,8))+j^O,7),u=0|Ga((_=(p=0|Ga((I=(tA=0|Ga((oA=0|Ga(aA^_A+(iA+cA),16))+(W+IA)^_A,12))+(_A+(iA+cA))|0)^oA,8))+(oA+(W+IA))|0)^tA,7),D=0|Ga((E=(n=0|Ga((e=(IA=0|Ga((tA=0|Ga(eA+(QA+rA)^AA,16))+(aA+j)^eA,12))+(eA+(QA+rA))|0)^tA,8))+(tA+(aA+j))|0)^IA,7),m=0|Ga((F=(s=0|Ga((f=(j=0|Ga((IA=0|Ga(CA+(BA+gA)^V,16))+(AA+$)^CA,12))+(CA+(BA+gA))|0)^IA,8))+(IA+(AA+$))|0)^j,7),l=0|Ga((k=(y=0|Ga((w=(j=0|Ga((W=0|Ga(O+Z+z^W,16))+(V+T)^z,12))+(O+Z+z)|0)^W,8))+(W+(V+T))|0)^j,7),g=g+-2|0}while(0!=(0|g));if(O=(0|ga(i))^I+L,$=(0|ga(i+4|0))^e+P,AA=(0|ga(i+8|0))^f+K,IA=(0|ga(i+12|0))^w+q,gA=(0|ga(i+16|0))^l+X,BA=(0|ga(i+20|0))^u+S,CA=(0|ga(i+24|0))^D+x,aA=(0|ga(i+28|0))^m+U,tA=(0|ga(i+32|0))^F+M,rA=(0|ga(i+36|0))^k+J,QA=(0|ga(i+40|0))^_+v,eA=(0|ga(i+44|0))^E+N,oA=(0|ga(i+48|0))^n+H,cA=(0|ga(i+52|0))^s+G,iA=(0|ga(i+56|0))^y+R,_A=(0|ga(i+60|0))^p+Y,e=G+(0==(0|(I=H+1|0))&1)|0,UC(b,O),UC(b+4|0,$),UC(b+8|0,AA),UC(b+12|0,IA),UC(b+16|0,gA),UC(b+20|0,BA),UC(b+24|0,CA),UC(b+28|0,aA),UC(b+32|0,tA),UC(b+36|0,rA),UC(b+40|0,QA),UC(b+44|0,eA),UC(b+48|0,oA),UC(b+52|0,cA),UC(b+56|0,iA),UC(b+60|0,_A),t>>>0<0|0==(0|t)&C>>>0<65)break;g=0|bC(0|C,0|t,-64,-1),t=0|o(),C=g,g=b+64|0,H=I,G=e,i=i+64|0}if(d&&0|C){t=0;do{B[c+t>>0]=0|B[b+t>>0],t=t+1|0}while((0|t)!=(0|C))}a[A+48>>2]=I,a[A+52>>2]=e}h=Q}function M(A,I,g,C){I|=0,g|=0,C|=0;var t,r,Q,e,c,i=0,_=0,E=0,n=0,s=0,y=0,h=0,p=0,f=0,w=0,l=0,u=0,D=0,m=0,F=0;if(c=0==(0|B[80+(A|=0)>>0])?16777216:0,t=0|a[A+4>>2],r=0|a[A+8>>2],Q=0|a[A+12>>2],e=0|a[A+16>>2],s=0|a[A+20>>2],n=0|a[A+24>>2],E=0|a[A+28>>2],_=0|a[A+32>>2],i=0|a[A+36>>2],C>>>0>0|0==(0|C)&g>>>0>15)for(f=0|a[A>>2];;){if(m=(67108863&(0|ga(I)))+s|0,F=((0|ga(I+3|0))>>>2&67108863)+n|0,D=((0|ga(I+6|0))>>>4&67108863)+E|0,u=((0|ga(I+9|0))>>>6)+_|0,s=((0|ga(I+12|0))>>>8|c)+i|0,i=0|NB(0|m,0,0|f,0),y=0|o(),E=0|bC(0|(y=0|bC(0|(E=0|bC(0|(y=0|bC(0|(E=0|NB(0|F,0,5*e|0,0)),0|o(),0|i,0|y)),0|(i=0|o()),0|(E=0|NB(0|D,0,5*Q|0,0)),0|o())),0|(i=0|o()),0|(y=0|NB(0|u,0,5*r|0,0)),0|o())),0|(i=0|o()),0|(E=0|NB(0|s,0,5*t|0,0)),0|o()),i=0|o(),y=0|NB(0|m,0,0|t,0),h=0|o(),l=0|bC(0|(h=0|bC(0|(l=0|bC(0|(h=0|bC(0|(l=0|NB(0|F,0,0|f,0)),0|o(),0|y,0|h)),0|(y=0|o()),0|(l=0|NB(0|D,0,5*e|0,0)),0|o())),0|(y=0|o()),0|(h=0|NB(0|u,0,5*Q|0,0)),0|o())),0|(y=0|o()),0|(l=0|NB(0|s,0,5*r|0,0)),0|o()),y=0|o(),h=0|NB(0|m,0,0|r,0),p=0|o(),w=0|bC(0|(p=0|bC(0|(w=0|bC(0|(p=0|bC(0|(w=0|NB(0|F,0,0|t,0)),0|o(),0|h,0|p)),0|(h=0|o()),0|(w=0|NB(0|D,0,0|f,0)),0|o())),0|(h=0|o()),0|(p=0|NB(0|u,0,5*e|0,0)),0|o())),0|(h=0|o()),0|(w=0|NB(0|s,0,5*Q|0,0)),0|o()),h=0|o(),p=0|NB(0|m,0,0|Q,0),_=0|o(),n=0|bC(0|(_=0|bC(0|(n=0|bC(0|(_=0|bC(0|(n=0|NB(0|F,0,0|r,0)),0|o(),0|p,0|_)),0|(p=0|o()),0|(n=0|NB(0|D,0,0|t,0)),0|o())),0|(p=0|o()),0|(_=0|NB(0|u,0,0|f,0)),0|o())),0|(p=0|o()),0|(n=0|NB(0|s,0,5*e|0,0)),0|o()),p=0|o(),_=0|NB(0|m,0,0|e,0),m=0|o(),s=0|bC(0|(u=0|bC(0|(D=0|bC(0|(m=0|bC(0|(F=0|NB(0|F,0,0|Q,0)),0|o(),0|_,0|m)),0|(_=0|o()),0|(D=0|NB(0|D,0,0|r,0)),0|o())),0|(_=0|o()),0|(u=0|NB(0|u,0,0|t,0)),0|o())),0|(_=0|o()),0|(s=0|NB(0|s,0,0|f,0)),0|o()),_=0|o(),i=0|CC(0|E,0|i,26),o(),y=0|CC(0|(i=0|bC(0|l,0|y,0|i,0)),0|o(),26),o(),h=0|CC(0|(y=0|bC(0|w,0|h,0|y,0)),0|o(),26),o(),p=0|CC(0|(h=0|bC(0|n,0|p,0|h,0)),0|o(),26),o(),_=0|CC(0|(p=0|bC(0|s,0|_,0|p,0)),0|o(),26),o(),g=0|bC(0|g,0|C,-16,-1),!((C=0|o())>>>0>0|0==(0|C)&g>>>0>15)){g=(5*_|0)+(67108863&E)&67108863,n=(((5*_|0)+(67108863&E)|0)>>>26)+(67108863&i)|0,E=67108863&y,_=67108863&h,i=67108863&p;break}s=(5*_|0)+(67108863&E)&67108863,n=(((5*_|0)+(67108863&E)|0)>>>26)+(67108863&i)|0,E=67108863&y,_=67108863&h,i=67108863&p,I=I+16|0}else g=s;a[A+20>>2]=g,a[A+24>>2]=n,a[A+28>>2]=E,a[A+32>>2]=_,a[A+36>>2]=i}function J(A,I){A|=0;var g=0,C=0,t=0,r=0,Q=0,e=0,c=0,i=0,_=0,E=0,n=0,s=0,y=0,h=0,p=0,f=0,w=0,l=0,u=0,D=0,m=0;c=0|dg(I|=0),e=0|o(),u=0|$B(0|(u=0|JB(0|B[I+4>>0],0|B[I+5>>0],0|B[I+6>>0])),0|o(),6),D=0|o(),Q=0|$B(0|(Q=0|JB(0|B[I+7>>0],0|B[I+8>>0],0|B[I+9>>0])),0|o(),5),r=0|o(),w=0|$B(0|(w=0|JB(0|B[I+10>>0],0|B[I+11>>0],0|B[I+12>>0])),0|o(),3),l=0|o(),t=0|$B(0|(t=0|JB(0|B[I+13>>0],0|B[I+14>>0],0|B[I+15>>0])),0|o(),2),C=0|o(),p=0|dg(I+16|0),f=0|o(),i=0|$B(0|(i=0|JB(0|B[I+20>>0],0|B[I+21>>0],0|B[I+22>>0])),0|o(),7),g=0|o(),_=0|$B(0|(_=0|JB(0|B[I+23>>0],0|B[I+24>>0],0|B[I+25>>0])),0|o(),5),h=0|o(),E=0|$B(0|(E=0|JB(0|B[I+26>>0],0|B[I+27>>0],0|B[I+28>>0])),0|o(),4),n=0|o(),s=0|$B(0|(s=0|JB(0|B[I+29>>0],0|B[I+30>>0],0|B[I+31>>0])),0|o(),2),o(),m=0|FC(0,0,0|(m=0|CC(0|(y=0|bC(33554428&s|0,0,16777216,0)),0|o(),25)),0|o()),o(),e=0|bC(19&m|0,0,0|c,0|e),c=0|o(),y=0|FC(33554428&s|0,0,33554432&y|0,0),s=0|o(),r=0|bC(0|(I=0|KB(0|(m=0|bC(0|u,0|D,16777216,0)),0|o(),25)),0|o(),0|Q,0|r),Q=0|o(),m=0|FC(0|u,0|D,-33554432&m|0,0),D=0|o(),C=0|bC(0|(I=0|KB(0|(u=0|bC(0|w,0|l,16777216,0)),0|o(),25)),0|o(),0|t,0|C),t=0|o(),u=0|FC(0|w,0|l,-33554432&u|0,0),l=0|o(),I=0|bC(0|i,0|g,0|(I=0|KB(0|(w=0|bC(0|p,0|f,16777216,0)),0|o(),25)),0|o()),g=0|o(),w=0|FC(0|p,0|f,-33554432&w|0,0),f=0|o(),n=0|bC(0|(i=0|KB(0|(p=0|bC(0|_,0|h,16777216,0)),0|o(),25)),0|o(),0|E,0|n),E=0|o(),p=0|FC(0|_,0|h,-33554432&p|0,0),h=0|o(),i=0|bC(0|m,0|D,0|(i=0|CC(0|(_=0|bC(0|e,0|c,33554432,0)),0|o(),26)),0|o()),o(),_=0|FC(0|e,0|c,-67108864&_|0,0),o(),e=0|bC(0|u,0|l,0|(e=0|CC(0|(c=0|bC(0|r,0|Q,33554432,0)),0|o(),26)),0|o()),o(),c=0|FC(0|r,0|Q,-67108864&c|0,0),o(),r=0|bC(0|w,0|f,0|(r=0|CC(0|(Q=0|bC(0|C,0|t,33554432,0)),0|o(),26)),0|o()),o(),Q=0|FC(0|C,0|t,-67108864&Q|0,0),o(),C=0|bC(0|p,0|h,0|(C=0|CC(0|(t=0|bC(0|I,0|g,33554432,0)),0|o(),26)),0|o()),o(),t=0|FC(0|I,0|g,-67108864&t|0,0),o(),I=0|bC(0|y,0|s,0|(I=0|CC(0|(g=0|bC(0|n,0|E,33554432,0)),0|o(),26)),0|o()),o(),g=0|FC(0|n,0|E,-67108864&g|0,0),o(),a[A>>2]=_,a[A+4>>2]=i,a[A+8>>2]=c,a[A+12>>2]=e,a[A+16>>2]=Q,a[A+20>>2]=r,a[A+24>>2]=t,a[A+28>>2]=C,a[A+32>>2]=g,a[A+36>>2]=I}function v(A,I){A|=0;var g=0,B=0,C=0,t=0,r=0,Q=0,e=0,c=0,i=0,_=0,E=0,n=0,s=0,y=0,h=0,p=0,f=0,w=0,l=0,u=0,D=0;e=0|a[(I|=0)>>2],l=0|a[I+4>>2],r=0|a[I+8>>2],f=0|a[I+12>>2],C=0|a[I+16>>2],h=0|a[I+20>>2],g=0|a[I+24>>2],i=0|a[I+28>>2],_=0|a[I+32>>2],D=0|a[I+36>>2],e=0|NB(0|e,((0|e)<0)<<31>>31|0,121666,0),Q=0|o(),l=0|NB(0|l,((0|l)<0)<<31>>31|0,121666,0),u=0|o(),r=0|NB(0|r,((0|r)<0)<<31>>31|0,121666,0),t=0|o(),f=0|NB(0|f,((0|f)<0)<<31>>31|0,121666,0),w=0|o(),C=0|NB(0|C,((0|C)<0)<<31>>31|0,121666,0),B=0|o(),h=0|NB(0|h,((0|h)<0)<<31>>31|0,121666,0),p=0|o(),g=0|NB(0|g,((0|g)<0)<<31>>31|0,121666,0),I=0|o(),i=0|NB(0|i,((0|i)<0)<<31>>31|0,121666,0),y=0|o(),_=0|NB(0|_,((0|_)<0)<<31>>31|0,121666,0),E=0|o(),Q=0|bC(0|(c=0|NB(0|(c=0|KB(0|(s=0|bC(0|(D=0|NB(0|D,((0|D)<0)<<31>>31|0,121666,0)),0|(n=0|o()),16777216,0)),0|o(),25)),0|o(),19,0)),0|o(),0|e,0|Q),e=0|o(),s=0|FC(0|D,0|n,-33554432&s|0,0),n=0|o(),t=0|bC(0|(c=0|KB(0|(D=0|bC(0|l,0|u,16777216,0)),0|o(),25)),0|o(),0|r,0|t),r=0|o(),D=0|FC(0|l,0|u,-33554432&D|0,0),u=0|o(),B=0|bC(0|(c=0|KB(0|(l=0|bC(0|f,0|w,16777216,0)),0|o(),25)),0|o(),0|C,0|B),C=0|o(),l=0|FC(0|f,0|w,-33554432&l|0,0),w=0|o(),I=0|bC(0|(c=0|KB(0|(f=0|bC(0|h,0|p,16777216,0)),0|o(),25)),0|o(),0|g,0|I),g=0|o(),f=0|FC(0|h,0|p,-33554432&f|0,0),p=0|o(),E=0|bC(0|(c=0|KB(0|(h=0|bC(0|i,0|y,16777216,0)),0|o(),25)),0|o(),0|_,0|E),_=0|o(),h=0|FC(0|i,0|y,-33554432&h|0,0),y=0|o(),c=0|bC(0|D,0|u,0|(c=0|CC(0|(i=0|bC(0|Q,0|e,33554432,0)),0|o(),26)),0|o()),o(),i=0|FC(0|Q,0|e,-67108864&i|0,0),o(),Q=0|bC(0|l,0|w,0|(Q=0|CC(0|(e=0|bC(0|t,0|r,33554432,0)),0|o(),26)),0|o()),o(),e=0|FC(0|t,0|r,-67108864&e|0,0),o(),t=0|bC(0|f,0|p,0|(t=0|CC(0|(r=0|bC(0|B,0|C,33554432,0)),0|o(),26)),0|o()),o(),r=0|FC(0|B,0|C,-67108864&r|0,0),o(),B=0|bC(0|h,0|y,0|(B=0|CC(0|(C=0|bC(0|I,0|g,33554432,0)),0|o(),26)),0|o()),o(),C=0|FC(0|I,0|g,-67108864&C|0,0),o(),I=0|bC(0|s,0|n,0|(I=0|CC(0|(g=0|bC(0|E,0|_,33554432,0)),0|o(),26)),0|o()),o(),g=0|FC(0|E,0|_,-67108864&g|0,0),o(),a[A>>2]=i,a[A+4>>2]=c,a[A+8>>2]=e,a[A+12>>2]=Q,a[A+16>>2]=r,a[A+20>>2]=t,a[A+24>>2]=C,a[A+28>>2]=B,a[A+32>>2]=g,a[A+36>>2]=I}function N(A,I,g,B,C){A|=0,g|=0,B|=0,C|=0;var t=0,r=0,c=0,i=0,_=0,E=0,n=0,s=0,y=0,h=0;if(!(I|=0))return B?C?(a[C>>2]=0|A,a[C+4>>2]=0&I,C=0,0|(e(0|(B=0)),C)):(C=0,0|(e(0|(B=0)),C)):(0|C&&(a[C>>2]=(A>>>0)%(g>>>0),a[C+4>>2]=0),C=(A>>>0)/(g>>>0)>>>0,0|(e(0|(B=0)),C));do{if(g){if(0|B){if((r=(0|Q(0|B))-(0|Q(0|I))|0)>>>0<=31){s=r+1|0,c=A>>>((r+1|0)>>>0)&r-31>>31|I<<31-r,n=I>>>((r+1|0)>>>0)&r-31>>31,t=0,r=A<<31-r;break}return C?(a[C>>2]=0|A,a[C+4>>2]=I|0&I,C=0,0|(e(0|(B=0)),C)):(C=0,0|(e(0|(B=0)),C))}if(g-1&g|0){s=r=33+(0|Q(0|g))-(0|Q(0|I))|0,c=32-r-1>>31&I>>>((r-32|0)>>>0)|(I<<32-r|A>>>(r>>>0))&r-32>>31,n=r-32>>31&I>>>(r>>>0),t=A<<64-r&32-r>>31,r=(I<<64-r|A>>>((r-32|0)>>>0))&32-r>>31|A<<32-r&r-33>>31;break}return 0|C&&(a[C>>2]=g-1&A,a[C+4>>2]=0),1==(0|g)?(C=0|A,0|(e(0|(B=I|0&I)),C)):(B=I>>>((C=0|ma(0|g))>>>0)|0,C=I<<32-C|A>>>(C>>>0)|0,0|(e(0|B),C))}if(!B)return 0|C&&(a[C>>2]=(I>>>0)%(g>>>0),a[C+4>>2]=0),C=(I>>>0)/(g>>>0)>>>0,0|(e(0|(B=0)),C);if(!A)return 0|C&&(a[C>>2]=0,a[C+4>>2]=(I>>>0)%(B>>>0)),C=(I>>>0)/(B>>>0)>>>0,0|(e(0|(g=0)),C);if(!(B-1&B))return 0|C&&(a[C>>2]=0|A,a[C+4>>2]=B-1&I|0&I),g=0,C=I>>>((0|ma(0|B))>>>0),0|(e(0|g),C);if((r=(0|Q(0|B))-(0|Q(0|I))|0)>>>0<=30){s=r+1|0,c=I<<31-r|A>>>((r+1|0)>>>0),n=I>>>((r+1|0)>>>0),t=0,r=A<<31-r;break}return C?(a[C>>2]=0|A,a[C+4>>2]=I|0&I,C=0,0|(e(0|(B=0)),C)):(C=0,0|(e(0|(B=0)),C))}while(0);if(s){_=0|bC(0|g,B|0&B|0,-1,-1),E=0|o(),i=r,I=n,A=s,r=0;do{h=i,i=t>>>31|i<<1,t=r|t<<1,FC(0|_,0|E,0|(h=c<<1|h>>>31|0),0|(y=c>>>31|I<<1|0)),r=1&(n=(s=0|o())>>31|((0|s)<0?-1:0)<<1),c=0|FC(0|h,0|y,n&(0|g)|0,(((0|s)<0?-1:0)>>31|((0|s)<0?-1:0)<<1)&(B|0&B)|0),I=0|o(),A=A-1|0}while(0!=(0|A));A=0}else i=r,I=n,A=0,r=0;return 0|C&&(a[C>>2]=c,a[C+4>>2]=I),h=-2&(t<<1|0)|r,0|(e(0|(y=(0|t)>>>31|i<<1|0&(0|t>>>31)|A)),h)}function R(A,I,g){A|=0,I|=0;var C,a,r=0,Q=0,e=0;if(a=h,C=h=h+63&-64,h=h+64|0,(g|=0)<<24>>24&&(255&g)<=64){if(0|function(A,I){return 1&(0!=(0|(A|=0))|0!=(0|(I|=0)))|0}(t[A+80>>0]|t[A+80+1>>0]<<8|t[A+80+2>>0]<<16|t[A+80+3>>0]<<24,t[A+80+4>>0]|t[A+80+4+1>>0]<<8|t[A+80+4+2>>0]<<16|t[A+80+4+3>>0]<<24))r=-1;else{r=t[A+352>>0]|t[A+352+1>>0]<<8|t[A+352+2>>0]<<16|t[A+352+3>>0]<<24;do{if(r>>>0>128){if(xA(A,128,0),p(A,A+96|0),r=(t[A+352>>0]|t[A+352+1>>0]<<8|t[A+352+2>>0]<<16|t[A+352+3>>0]<<24)-128|0,B[A+352>>0]=r,B[A+352+1>>0]=r>>8,B[A+352+2>>0]=r>>16,B[A+352+3>>0]=r>>24,r>>>0<129){sA(A+96|0,A+224|0,0|r),Q=t[A+352>>0]|t[A+352+1>>0]<<8|t[A+352+2>>0]<<16|t[A+352+3>>0]<<24,e=A+96|0;break}c(34089,34121,306,34166)}else Q=r,e=A+96|0}while(0);xA(A,Q,0),function(A){0|B[356+(A|=0)>>0]&&function(A){B[88+(A|=0)>>0]=-1,B[A+88+1>>0]=-1,B[A+88+2>>0]=-1,B[A+88+3>>0]=-1,B[A+88+4>>0]=-1,B[A+88+4+1>>0]=-1,B[A+88+4+2>>0]=-1,B[A+88+4+3>>0]=-1}(A),B[A+80>>0]=-1,B[A+80+1>>0]=-1,B[A+80+2>>0]=-1,B[A+80+3>>0]=-1,B[A+80+4>>0]=-1,B[A+80+4+1>>0]=-1,B[A+80+4+2>>0]=-1,B[A+80+4+3>>0]=-1}(A),tI(A+96+(r=t[A+352>>0]|t[A+352+1>>0]<<8|t[A+352+2>>0]<<16|t[A+352+3>>0]<<24)|0,0,256-r|0),p(A,e),tB(C,t[A>>0]|t[A+1>>0]<<8|t[A+2>>0]<<16|t[A+3>>0]<<24,t[A+4>>0]|t[A+4+1>>0]<<8|t[A+4+2>>0]<<16|t[A+4+3>>0]<<24),tB(C+8|0,t[A+8>>0]|t[A+8+1>>0]<<8|t[A+8+2>>0]<<16|t[A+8+3>>0]<<24,t[A+8+4>>0]|t[A+8+4+1>>0]<<8|t[A+8+4+2>>0]<<16|t[A+8+4+3>>0]<<24),tB(C+16|0,t[A+16>>0]|t[A+16+1>>0]<<8|t[A+16+2>>0]<<16|t[A+16+3>>0]<<24,t[A+16+4>>0]|t[A+16+4+1>>0]<<8|t[A+16+4+2>>0]<<16|t[A+16+4+3>>0]<<24),tB(C+24|0,t[A+24>>0]|t[A+24+1>>0]<<8|t[A+24+2>>0]<<16|t[A+24+3>>0]<<24,t[A+24+4>>0]|t[A+24+4+1>>0]<<8|t[A+24+4+2>>0]<<16|t[A+24+4+3>>0]<<24),tB(C+32|0,t[A+32>>0]|t[A+32+1>>0]<<8|t[A+32+2>>0]<<16|t[A+32+3>>0]<<24,t[A+32+4>>0]|t[A+32+4+1>>0]<<8|t[A+32+4+2>>0]<<16|t[A+32+4+3>>0]<<24),tB(C+40|0,t[A+40>>0]|t[A+40+1>>0]<<8|t[A+40+2>>0]<<16|t[A+40+3>>0]<<24,t[A+40+4>>0]|t[A+40+4+1>>0]<<8|t[A+40+4+2>>0]<<16|t[A+40+4+3>>0]<<24),tB(C+48|0,t[A+48>>0]|t[A+48+1>>0]<<8|t[A+48+2>>0]<<16|t[A+48+3>>0]<<24,t[A+48+4>>0]|t[A+48+4+1>>0]<<8|t[A+48+4+2>>0]<<16|t[A+48+4+3>>0]<<24),tB(C+56|0,t[A+56>>0]|t[A+56+1>>0]<<8|t[A+56+2>>0]<<16|t[A+56+3>>0]<<24,t[A+56+4>>0]|t[A+56+4+1>>0]<<8|t[A+56+4+2>>0]<<16|t[A+56+4+3>>0]<<24),sA(0|I,0|C,255&g|0),Lg(A,64),Lg(e,256),r=0}return h=a,0|r}return st(),0}function Y(A){var I,g,B=0,C=0,t=0,r=0,Q=0,e=0,o=0,c=0,i=0,_=0,E=0,n=0,s=0,y=0,p=0,f=0,w=0,l=0,u=0,D=0,m=0,F=0,k=0,b=0,d=0,H=0,G=0,S=0,x=0,U=0,M=0,J=0,v=0;I=h,g=h=h+63&-64,h=h+64|0,iC(g,A|=0),B=0|a[g+48>>2],t=0|a[g>>2],r=0|a[g+56>>2],Q=0|a[g+8>>2],e=0|a[g+44>>2],o=0|a[g+60>>2],c=0|a[g+12>>2],i=0|a[g+28>>2],_=0|a[g+16>>2],E=0|a[g+32>>2],C=0|a[g+4>>2],n=0|a[g+20>>2],s=0|a[g+36>>2],y=0|a[g+52>>2],p=0|a[g+24>>2],f=0|a[g+40>>2],w=0;do{H=((v=((D=((D=(k=((k=C+n|0)<<7|k>>>25)^s)+n|0)<<9|D>>>23)^y)+k<<13|(D+k|0)>>>19)^C)+D<<18|(v+D|0)>>>14)^n,F=((S=((J=((J=(u=((u=p+f|0)<<7|u>>>25)^r)+f|0)<<9|J>>>23)^Q)+u<<13|(J+u|0)>>>19)^p)+J<<18|(S+J|0)>>>14)^f,l=((d=((x=((x=(M=((M=e+o|0)<<7|M>>>25)^c)+o|0)<<9|x>>>23)^i)+M<<13|(x+M|0)>>>19)^e)+x<<18|(d+x|0)>>>14)^o,t=((M=(c=((J=(Q=((v=(C=(M+(U=((m=((b=((b=(G=((G=B+t|0)<<7|G>>>25)^_)+t|0)<<9|b>>>23)^E)+G<<13|(b+G|0)>>>19)^B)+b<<18|(m+b|0)>>>14)^t)<<7|(M+U|0)>>>25)^v)+U|0)<<9|v>>>23)^J)+C|0)<<13|J>>>19)^M)+Q|0)<<18|M>>>14)^U,n=((G=(_=((S=(i=x^((S=(p=S^(H+G<<7|(H+G|0)>>>25))+H|0)<<9|S>>>23))+p|0)<<13|S>>>19)^G)+i|0)<<18|G>>>14)^H,f=((k=(s=((b=(E=((d=(e=d^(F+k<<7|(F+k|0)>>>25))+F|0)<<9|d>>>23)^b)+e|0)<<13|b>>>19)^k)+E|0)<<18|k>>>14)^F,o=((u=(r=((D=(y=((m=(B=(l+u<<7|(l+u|0)>>>25)^m)+l|0)<<9|m>>>23)^D)+B|0)<<13|D>>>19)^u)+y|0)<<18|u>>>14)^l,w=w+2|0}while(w>>>0<8);for(a[g>>2]=t,a[g+48>>2]=B,a[g+16>>2]=_,a[g+32>>2]=E,a[g+20>>2]=n,a[g+4>>2]=C,a[g+36>>2]=s,a[g+52>>2]=y,a[g+40>>2]=f,a[g+24>>2]=p,a[g+56>>2]=r,a[g+8>>2]=Q,a[g+60>>2]=o,a[g+44>>2]=e,a[g+12>>2]=c,a[g+28>>2]=i,a[A>>2]=(0|a[A>>2])+t,B=1;a[(v=A+(B<<2)|0)>>2]=(0|a[v>>2])+C,16!=(0|(B=B+1|0));)C=0|a[g+(B<<2)>>2];h=I}function L(A,I,g,B,C){A|=0,I|=0,g|=0,C|=0;var a,t,r,Q,e,o,c,i,_,E,n,s=0,y=0,h=0,p=0,f=0,w=0,l=0,u=0,D=0,m=0,F=0,k=0,b=0,d=0,H=0,G=0,S=0,x=0,U=0,M=0,J=0,v=0,N=0,R=0,Y=0,L=0,P=0,K=0,q=0,X=0,j=0,T=0,V=0,W=0,z=0;(B|=0)?(S=0|ga(B),x=0|ga(B+4|0),U=0|ga(B+8|0),G=0|ga(B+12|0)):(S=1634760805,x=857760878,U=2036477234,G=1797285236),n=0|ga(g),e=0|ga(g+4|0),o=0|ga(g+8|0),c=0|ga(g+12|0),i=0|ga(g+16|0),_=0|ga(g+20|0),E=0|ga(g+24|0),a=0|ga(g+28|0),t=0|ga(I),r=0|ga(I+4|0),Q=0|ga(I+8|0),B=0|ga(I+12|0),g=0,I=S,s=n,y=U,h=i,p=_,f=E,w=a,l=G,u=e,D=o,m=c,F=x,k=t,b=r,d=Q,H=B;do{T=(0|Ga((N=(0|Ga((L=(0|Ga((q=(0|Ga(I+p|0,7))^m)+I|0,9))^d)+q|0,13))^p)+L|0,18))^I,K=(0|Ga((z=(0|Ga((v=(0|Ga((Y=(0|Ga(s+F|0,7))^H)+F|0,9))^f)+Y|0,13))^s)+v|0,18))^F,R=(0|Ga((j=(0|Ga((W=(0|Ga((J=(0|Ga(k+y|0,7))^w)+y|0,9))^u)+J|0,13))^k)+W|0,18))^y,M=(0|Ga((P=(0|Ga((X=(0|Ga((V=(0|Ga(h+l|0,7))^D)+l|0,9))^b)+V|0,13))^h)+X|0,18))^l,I=(0|Ga((D=(0|Ga((u=(0|Ga((s=(0|Ga(V+T|0,7))^z)+T|0,9))^W)+s|0,13))^V)+u|0,18))^T,F=(0|Ga((m=(0|Ga((b=(0|Ga((k=(0|Ga(K+q|0,7))^j)+K|0,9))^X)+k|0,13))^q)+b|0,18))^K,y=(0|Ga((H=(0|Ga((d=(0|Ga((h=(0|Ga(R+Y|0,7))^P)+R|0,9))^L)+h|0,13))^Y)+d|0,18))^R,l=(0|Ga((w=(0|Ga((f=(0|Ga((p=(0|Ga(M+J|0,7))^N)+M|0,9))^v)+p|0,13))^J)+f|0,18))^M,g=g+2|0}while((0|g)<(0|C));UC(A,I+S|0),UC(A+4|0,s+n|0),UC(A+8|0,u+e|0),UC(A+12|0,D+o|0),UC(A+16|0,m+c|0),UC(A+20|0,F+x|0),UC(A+24|0,k+t|0),UC(A+28|0,b+r|0),UC(A+32|0,d+Q|0),UC(A+36|0,H+B|0),UC(A+40|0,y+U|0),UC(A+44|0,h+i|0),UC(A+48|0,p+_|0),UC(A+52|0,f+E|0),UC(A+56|0,w+a|0),UC(A+60|0,l+G|0)}function P(A,I,g,C){A|=0,I|=0,g|=0;var t,r,Q=0,e=0,o=0,c=0,i=0,_=0;switch(r=h,t=h=h+63&-64,h=h+16|0,0|(C|=0)){case 2:if(I>>>0<13)C=-31;else{Q=34359,e=(C=A)+13|0;do{B[C>>0]=0|B[Q>>0],C=C+1|0,Q=Q+1|0}while((0|C)<(0|e));A=A+12|0,e=I+-12|0,Q=6}break;case 1:if(I>>>0<12)C=-31;else{Q=34372,e=(C=A)+12|0;do{B[C>>0]=0|B[Q>>0],C=C+1|0,Q=Q+1|0}while((0|C)<(0|e));A=A+11|0,e=I+-11|0,Q=6}break;default:C=-31}do{if(6==(0|Q)&&!(C=0|kA(g))){if(Bg(t,19),Q=A+(C=0|MI(t))|0,c=e-C|0,e>>>0<=C>>>0){C=-31;break}if(sA(0|A,0|t,C+1|0),c>>>0>=4){if(B[Q>>0]=36,B[Q+1>>0]=109,B[Q+2>>0]=61,B[Q+3>>0]=0,Bg(t,0|a[g+44>>2]),e=Q+3+(A=0|MI(t))|0,(c+-3|0)>>>0<=A>>>0){C=-31;break}if(sA(Q+3|0,0|t,A+1|0),(c+-3-A|0)>>>0>=4){if(B[e>>0]=44,B[e+1>>0]=116,B[e+2>>0]=61,B[e+3>>0]=0,Bg(t,0|a[g+40>>2]),I=e+3+(C=0|MI(t))|0,o=c+-3-A-3-C|0,(c+-3-A-3|0)>>>0<=C>>>0){C=-31;break}if(sA(e+3|0,0|t,C+1|0),o>>>0>=4){if(B[I>>0]=44,B[I+1>>0]=112,B[I+2>>0]=61,B[I+3>>0]=0,Bg(t,0|a[g+48>>2]),(o+-3|0)>>>0<=(Q=0|MI(t))>>>0){C=-31;break}if(sA(I+3|0,0|t,Q+1|0),C=I+3+Q+1|0,(o+-3-Q|0)>>>0>=2&&(B[I+3+Q>>0]=36,B[I+3+Q+1>>0]=0,gA(C,o+-3-Q-1|0,0|a[g+16>>2],0|a[g+20>>2],3),(_=o+-3-Q-1-(i=0|MI(C))|0)>>>0>=2))return B[C+i>>0]=36,B[C+i+1>>0]=0,gA(C+i+1|0,_+-1|0,0|a[g>>2],0|a[g+4>>2],3),h=r,0;C=-31}else C=-31}else C=-31}else C=-31}}while(0);return h=r,0|C}function K(A,I,g,B){A|=0,I|=0,g|=0;var C=0,a=0,t=0,r=0,Q=0,e=0,o=0,c=0,i=0,_=0,E=0,n=0,s=0,y=0,h=0,p=0,f=0,w=0,l=0,u=0,D=0,m=0,F=0,k=0,b=0,d=0,H=0,G=0,S=0,x=0,U=0,M=0,J=0,v=0,N=0,R=0;(B|=0)?(C=0|ga(B),a=0|ga(B+4|0),t=0|ga(B+8|0),B=0|ga(B+12|0)):(C=1634760805,a=857760878,t=2036477234,B=1797285236),p=0|ga(g),h=0|ga(g+4|0),r=0|ga(g+8|0),Q=0|ga(g+12|0),e=0|ga(g+16|0),o=0|ga(g+20|0),i=0|ga(g+24|0),_=0|ga(g+28|0),E=0|ga(I),n=0|ga(I+4|0),s=0|ga(I+8|0),y=0,c=0|ga(I+12|0),g=p,I=h;do{l=0|Ga((F=0|Ga((N=0|Ga((m=(F=0|Ga(E^(v=g+C|0),16))+e|0)^g,12))+v^F,8))+m^N,7),R=0|Ga((f=0|Ga((U=0|Ga((h=(f=0|Ga(n^(x=I+a|0),16))+o|0)^I,12))+x^f,8))+h^U,7),M=0|Ga((w=0|Ga((d=0|Ga((k=(w=0|Ga(s^(b=r+t|0),16))+i|0)^r,12))+b^w,8))+k^d,7),H=0|Ga((G=0|Ga((D=0|Ga((p=(G=0|Ga(c^(u=Q+B|0),16))+_|0)^Q,12))+u^G,8))+p^D,7),I=0|Ga((i=(c=0|Ga((C=(S=0|Ga((J=0|Ga(G^R+(N+v),16))+(w+k)^R,12))+(R+(N+v))|0)^J,8))+(J+(w+k))|0)^S,7),r=0|Ga((_=(E=0|Ga((a=(k=0|Ga((S=0|Ga(M+(U+x)^F,16))+(G+p)^M,12))+(M+(U+x))|0)^S,8))+(S+(G+p))|0)^k,7),Q=0|Ga((e=(n=0|Ga((t=(p=0|Ga((k=0|Ga(H+(d+b)^f,16))+(F+m)^H,12))+(H+(d+b))|0)^k,8))+(k+(F+m))|0)^p,7),g=0|Ga((o=(s=0|Ga((B=(p=0|Ga((w=0|Ga(D+u+l^w,16))+(f+h)^l,12))+(D+u+l)|0)^w,8))+(w+(f+h))|0)^p,7),y=y+1|0}while(10!=(0|y));return UC(A,C),UC(A+4|0,a),UC(A+8|0,t),UC(A+12|0,B),UC(A+16|0,E),UC(A+20|0,n),UC(A+24|0,s),UC(A+28|0,c),0}function q(A,I,g,C){A|=0,I|=0,g|=0,C|=0;var t,r,Q=0,e=0,c=0,i=0,_=0,E=0,n=0,s=0,y=0;r=h,t=h=h+63&-64,h=h+704|0;A:do{if(!(0==(0|g)&0==(0|C))){if(_=0|CC(0|(y=0|a[A+72>>2]),0|(n=0|a[A+72+4>>2]),3),o(),E=0|$B(0|g,0|C,3),s=0|o(),c=0|CC(0|g,0|C,61),i=0|o(),n=0|bC(0|y,0|n,0|E,0|s),y=0|o(),a[A+72>>2]=n,a[A+72+4>>2]=y,Q=0|a[A+64>>2],e=0|a[A+64+4>>2],y>>>0<s>>>0|(0|y)==(0|s)&n>>>0<E>>>0&&(Q=0|bC(0|Q,0|e,1,0),e=0|o(),a[A+64>>2]=Q,a[A+64+4>>2]=e),Q=0|bC(0|Q,0|e,0|c,0|i),i=0|o(),a[A+64>>2]=Q,a[A+64+4>>2]=i,i=0|FC(128,0,127&_|0,0),(Q=0|o())>>>0>C>>>0|(0|Q)==(0|C)&i>>>0>g>>>0)for(Q=0,e=0;;)if(s=0|B[I+Q>>0],y=0|bC(0|Q,0|e,127&_|0,0),o(),B[A+80+y>>0]=s,Q=0|bC(0|Q,0|e,1,0),!((e=0|o())>>>0<C>>>0|(0|e)==(0|C)&Q>>>0<g>>>0))break A;if(!(0==(0|i)&0==(0|Q))){e=0,c=0;do{s=0|B[I+e>>0],y=0|bC(0|e,0|c,127&_|0,0),o(),B[A+80+y>>0]=s,e=0|bC(0|e,0|c,1,0),c=0|o()}while(c>>>0<Q>>>0|(0|c)==(0|Q)&e>>>0<i>>>0)}if(l(A,A+80|0,t,t+640|0),Q=0|FC(0|g,0|C,0|i,0|Q),(c=0|o())>>>0>0|0==(0|c)&Q>>>0>127){e=I+i|0;do{l(A,e,t,t+640|0),e=e+128|0,Q=0|bC(0|Q,0|c,-128,-1),c=0|o()}while(c>>>0>0|0==(0|c)&Q>>>0>127)}else e=I+i|0;if(!(0==(0|(i=127&Q))&!0)){Q=0,c=0;do{B[A+80+Q>>0]=0|B[e+Q>>0],Q=0|bC(0|Q,0|c,1,0),c=0|o()}while(c>>>0<0|0==(0|c)&Q>>>0<i>>>0)}Lg(t,704)}}while(0);return h=r,0}function X(A,I,g,C){A|=0,g|=0,C|=0;var a,t,r=0,Q=0;for(a=h,t=h=h+63&-64,h=h+2272|0,KA(t+1536|0,I|=0),KA(t+1280|0,C),TB(t,g),VB(t+2112|0,g),YB(t+1792|0,t+2112|0),RI(t+2112|0,t+1792|0,t),YB(t+1952|0,t+2112|0),TB(t+160|0,t+1952|0),RI(t+2112|0,t+1792|0,t+160|0),YB(t+1952|0,t+2112|0),TB(t+320|0,t+1952|0),RI(t+2112|0,t+1792|0,t+320|0),YB(t+1952|0,t+2112|0),TB(t+480|0,t+1952|0),RI(t+2112|0,t+1792|0,t+480|0),YB(t+1952|0,t+2112|0),TB(t+640|0,t+1952|0),RI(t+2112|0,t+1792|0,t+640|0),YB(t+1952|0,t+2112|0),TB(t+800|0,t+1952|0),RI(t+2112|0,t+1792|0,t+800|0),YB(t+1952|0,t+2112|0),TB(t+960|0,t+1952|0),RI(t+2112|0,t+1792|0,t+960|0),YB(t+1952|0,t+2112|0),TB(t+1120|0,t+1952|0),function(A){jC(A|=0),mC(A+40|0),mC(A+80|0)}(A),g=255;;){if(0|B[t+1536+g>>0]){r=g,Q=5;break}if(0|B[t+1280+g>>0]){r=g,Q=5;break}if(!g)break;g=g+-1|0}if(5==(0|Q)&&(0|r)>-1)for(;Cg(t+2112|0,A),(g=0|B[t+1536+r>>0])<<24>>24<=0?g<<24>>24<0&&(YB(t+1952|0,t+2112|0),NI(t+2112|0,t+1952|0,t+(160*(((g<<24>>24)/-2|0)<<24>>24)|0)|0)):(YB(t+1952|0,t+2112|0),RI(t+2112|0,t+1952|0,t+(160*((255&g)>>>1&255)|0)|0)),(g=0|B[t+1280+r>>0])<<24>>24<=0?g<<24>>24<0&&(YB(t+1952|0,t+2112|0),LI(t+2112|0,t+1952|0,160+(120*(((g<<24>>24)/-2|0)<<24>>24)|0)|0)):(YB(t+1952|0,t+2112|0),PI(t+2112|0,t+1952|0,160+(120*((255&g)>>>1&255)|0)|0)),EC(A,t+2112|0),(0|r)>0;)r=r+-1|0;h=a}function j(A,I,g,C,t,r,Q,e){A|=0,I|=0,g|=0,C|=0,t|=0,r|=0,Q|=0,e|=0;var o,c,i=0,_=0,E=0,n=0,s=0,y=0,p=0;if(c=h,o=h=h+63&-64,h=h+16|0,a[o>>2]=0,sa(e),C){n=0,_=0,E=0,i=0;A:for(;;){for(y=i;i=0|B[g+y>>0],255==(0|(s=4&e?0|GI(i):0|SI(i)));){if(!t){s=18;break A}if(!(0|zC(t,i))){s=19;break A}if(!((i=y+1|0)>>>0<C>>>0)){s=17;break A}y=i}if(n=s+(n<<6)|0,(i=_+6|0)>>>0>7){if(_=_+-2|0,E>>>0>=I>>>0){s=13;break}B[A+E>>0]=n>>>_,E=E+1|0}else _=i;if((i=y+1|0)>>>0>=C>>>0){s=16;break}}13==(0|s)?(a[o>>2]=y,a[8886]=68,i=-1):16==(0|s)?(a[o>>2]=i,i=0):17==(0|s)?(a[o>>2]=i,i=0):18==(0|s)?(a[o>>2]=y,i=0):19==(0|s)&&(a[o>>2]=y,i=0),_>>>0>4?(E=0,i=-1):s=21}else n=0,_=0,E=0,i=0,s=21;do{if(21==(0|s))if((1<<_)-1&n)E=0,i=-1;else if(i|2&e||(i=0|pI(g,C,o,t,_>>>1)),i)E=0;else if(0!=(0|t)&&(p=0|a[o>>2])>>>0<C>>>0){for(i=p;;){if(!(0|zC(t,0|B[g+i>>0]))){s=31;break}if((i=i+1|0)>>>0>=C>>>0){s=30;break}}if(30==(0|s)){a[o>>2]=i,i=0;break}if(31==(0|s)){a[o>>2]=i,i=0;break}}else i=0}while(0);return _=0|a[o>>2],Q?a[Q>>2]=g+_:(0|_)!=(0|C)&&(a[8886]=28,i=-1),0|r&&(a[r>>2]=E),h=c,0|i}function T(A,I,g,B){A|=0,I|=0,g|=0;var C=0,a=0,t=0,r=0,Q=0,e=0,o=0,c=0,i=0,_=0,E=0,n=0,s=0,y=0,h=0,p=0,f=0,w=0,l=0,u=0,D=0,m=0,F=0,k=0,b=0,d=0,H=0,G=0,S=0,x=0;(B|=0)?(C=0|ga(B),t=0|ga(B+4|0),a=0|ga(B+8|0),B=0|ga(B+12|0)):(C=1634760805,a=2036477234,B=1797285236,t=857760878),y=0|ga(g),o=0|ga(g+4|0),c=0|ga(g+8|0),i=0|ga(g+12|0),_=0|ga(g+16|0),E=0|ga(g+20|0),n=0|ga(g+24|0),s=0|ga(g+28|0),r=0|ga(I),Q=0|ga(I+4|0),e=0|ga(I+8|0),h=20,g=0|ga(I+12|0);do{H=(0|Ga((w=(0|Ga((D=(0|Ga((k=(0|Ga(E+C|0,7))^i)+C|0,9))^e)+k|0,13))^E)+D|0,18))^C,F=(0|Ga((x=(0|Ga((f=(0|Ga((u=(0|Ga(t+y|0,7))^g)+t|0,9))^n)+u|0,13))^y)+f|0,18))^t,l=(0|Ga((d=(0|Ga((S=(0|Ga((p=(0|Ga(a+r|0,7))^s)+a|0,9))^o)+p|0,13))^r)+S|0,18))^a,I=(0|Ga((m=(0|Ga((b=(0|Ga((G=(0|Ga(B+_|0,7))^c)+B|0,9))^Q)+G|0,13))^_)+b|0,18))^B,C=(0|Ga((c=(0|Ga((o=(0|Ga((y=(0|Ga(G+H|0,7))^x)+H|0,9))^S)+y|0,13))^G)+o|0,18))^H,t=(0|Ga((i=(0|Ga((Q=(0|Ga((r=(0|Ga(F+k|0,7))^d)+F|0,9))^b)+r|0,13))^k)+Q|0,18))^F,a=(0|Ga((g=(0|Ga((e=(0|Ga((_=(0|Ga(l+u|0,7))^m)+l|0,9))^D)+_|0,13))^u)+e|0,18))^l,B=(0|Ga((s=(0|Ga((n=(0|Ga((E=(0|Ga(I+p|0,7))^w)+I|0,9))^f)+E|0,13))^p)+n|0,18))^I,h=h+-2|0}while(0!=(0|h));return UC(A,C),UC(A+4|0,t),UC(A+8|0,a),UC(A+12|0,B),UC(A+16|0,r),UC(A+20|0,Q),UC(A+24|0,e),UC(A+28|0,g),0}function V(A,I,g){I|=0,g|=0;var C,t,r,Q=0,e=0,o=0;switch(r=h,t=h=h+63&-64,h=h+16|0,o=0|a[20+(A|=0)>>2],C=0|a[A+4>>2],a[A+20>>2]=0,a[A+4>>2]=0,0|g){case 2:0|$I(I,34324,9)?I=-32:(I=I+9|0,e=4);break;case 1:0|$I(I,34334,8)?I=-32:(I=I+8|0,e=4);break;default:I=-26}do{if(4==(0|e))if(0==(0|$I(I,34343,3))&&0!=(0|(Q=0|dI(I+3|0,t+4|0))))if(19==(0|a[t+4>>2]))if(0|$I(Q,34347,3))I=-32;else{if(!(I=0|dI(Q+3|0,t+4|0))){I=-32;break}if(a[A+44>>2]=a[t+4>>2],0|$I(I,34351,3))I=-32;else{if(!(I=0|dI(I+3|0,t+4|0))){I=-32;break}if(a[A+40>>2]=a[t+4>>2],0|$I(I,34355,3))I=-32;else{if(!(I=0|dI(I+3|0,t+4|0))){I=-32;break}if(e=0|a[t+4>>2],a[A+48>>2]=e,a[A+52>>2]=e,I=(e=36==(0|B[I>>0]))?I+1|0:I,e){if(a[t+4>>2]=o,0|j(e=0|a[A+16>>2],o,I,0|MI(I),0,t+4|0,t,3)){I=-32;break}if(a[A+20>>2]=a[t+4>>2],I=0|a[t>>2],I=(o=36==(0|B[I>>0]))?I+1|0:I,o){if(a[t+4>>2]=C,0|j(o=0|a[A>>2],C,I,0|MI(I),0,t+4|0,t,3)){I=-32;break}a[A+4>>2]=a[t+4>>2],g=0|a[t>>2],(I=0|kA(A))||(I=0==(0|B[g>>0])?0:-32)}else I=-32}else I=-32}}}else I=-26;else I=-32}while(0);return h=r,0|I}function W(A,I,g){A|=0,I|=0;var C,a,r=0,Q=0;C=h,a=h=h+63&-64,h=h+4032|0,TB(a,g|=0),VB(a+3584|0,g),YB(a+2464|0,a+3584|0),TB(a+160|0,a+2464|0),RI(a+3424|0,g,a+160|0),YB(a+2304|0,a+3424|0),TB(a+320|0,a+2304|0),VB(a+3264|0,a+2464|0),YB(a+2144|0,a+3264|0),TB(a+480|0,a+2144|0),RI(a+3104|0,g,a+480|0),YB(a+1984|0,a+3104|0),TB(a+640|0,a+1984|0),VB(a+2944|0,a+2304|0),YB(a+1824|0,a+2944|0),TB(a+800|0,a+1824|0),RI(a+2784|0,g,a+800|0),YB(a+1664|0,a+2784|0),TB(a+960|0,a+1664|0),VB(a+2624|0,a+2144|0),YB(a+1504|0,a+2624|0),TB(a+1120|0,a+1504|0),g=0;do{Q=0|B[I+g>>0],B[a+1280+(r=g<<1)>>0]=15&Q,B[a+1280+(1|r)>>0]=(255&Q)>>>4,g=g+1|0}while(32!=(0|g));g=0,I=0;do{g=134217728+((r=g+(0|t[(Q=a+1280+I|0)>>0])|0)<<24)>>28,B[Q>>0]=r-(g<<4),I=I+1|0}while(63!=(0|I));g=g+(0|t[a+1280+63>>0])&255,B[a+1280+63>>0]=g,ta(A),BI(a+1344|0,a,g),RI(a+3864|0,A,a+1344|0),g=63;do{EC(a+3744|0,a+3864|0),Cg(a+3864|0,a+3744|0),EC(a+3744|0,a+3864|0),Cg(a+3864|0,a+3744|0),EC(a+3744|0,a+3864|0),Cg(a+3864|0,a+3744|0),EC(a+3744|0,a+3864|0),Cg(a+3864|0,a+3744|0),YB(A,a+3864|0),BI(a+1344|0,a,0|B[a+1280+(g=g+-1|0)>>0]),RI(a+3864|0,A,a+1344|0)}while(0!=(0|g));YB(A,a+3864|0),h=C}function z(A,I,g,C){A|=0,I|=0,g|=0,C|=0;var t,r=0,Q=0,e=0,c=0,i=0,_=0,E=0,n=0;t=h,_=h=h+63&-64,h=h+288|0;A:do{if(!(0==(0|g)&0==(0|C))){if(c=0|CC(0|(e=0|a[A+32>>2]),0|(i=0|a[A+32+4>>2]),3),o(),r=0|bC(0|e,0|i,0|(r=0|$B(0|g,0|C,3)),0|o()),i=0|o(),a[A+32>>2]=r,a[A+32+4>>2]=i,i=0|FC(64,0,63&c|0,0),(r=0|o())>>>0>C>>>0|(0|r)==(0|C)&i>>>0>g>>>0)for(r=0,Q=0;;)if(i=0|B[I+r>>0],_=0|bC(0|r,0|Q,63&c|0,0),o(),B[A+40+_>>0]=i,r=0|bC(0|r,0|Q,1,0),!((Q=0|o())>>>0<C>>>0|(0|Q)==(0|C)&r>>>0<g>>>0))break A;if(!(0==(0|i)&0==(0|r))){Q=0,e=0;do{n=0|B[I+Q>>0],E=0|bC(0|Q,0|e,63&c|0,0),o(),B[A+40+E>>0]=n,Q=0|bC(0|Q,0|e,1,0),e=0|o()}while(e>>>0<r>>>0|(0|e)==(0|r)&Q>>>0<i>>>0)}if(H(A,A+40|0,_,_+256|0),r=0|FC(0|g,0|C,0|i,0|r),(e=0|o())>>>0>0|0==(0|e)&r>>>0>63){Q=I+i|0;do{H(A,Q,_,_+256|0),Q=Q+64|0,r=0|bC(0|r,0|e,-64,-1),e=0|o()}while(e>>>0>0|0==(0|e)&r>>>0>63)}else Q=I+i|0;if(!(0==(0|(r&=63))&!0)){e=0,g=0;do{B[A+40+e>>0]=0|B[Q+e>>0],e=0|bC(0|e,0|g,1,0),g=0|o()}while(g>>>0<0|0==(0|g)&e>>>0<r>>>0)}Lg(_,288)}}while(0);return h=t,0}function Z(A,I,g,C){I|=0,g|=0,C|=0;var t=0,r=0,Q=0,e=0,c=0,i=0,_=0,E=0;if(0==(0|(r=0|a[56+(A|=0)>>2]))&0==(0|(t=0|a[A+56+4>>2])))_=7;else{if(e=0|FC(16,0,0|r,0|t),!(0==(0|(i=(c=0|o())>>>0>C>>>0|(0|c)==(0|C)&e>>>0>g>>>0?g:e))&0==(0|(c=c>>>0>C>>>0|(0|c)==(0|C)&e>>>0>g>>>0?C:c)))){e=0,Q=0;do{E=0|B[I+e>>0],r=0|bC(0|r,0|t,0|e,0|Q),o(),B[A+64+r>>0]=E,e=0|bC(0|e,0|Q,1,0),Q=0|o(),r=0|a[A+56>>2],t=0|a[A+56+4>>2]}while(Q>>>0<c>>>0|(0|Q)==(0|c)&e>>>0<i>>>0)}E=0|bC(0|r,0|t,0|i,0|c),e=0|o(),a[A+56>>2]=E,a[A+56+4>>2]=e,e>>>0<0|0==(0|e)&E>>>0<16||(g=0|FC(0|g,0|C,0|i,0|c),C=0|o(),M(A,A+64|0,16,0),a[A+56>>2]=0,a[A+56+4>>2]=0,I=I+i|0,_=7)}if(7==(0|_)&&(t=-16&g,C>>>0>0|0==(0|C)&g>>>0>15?(r=0|FC(0|g,0|C,0|t,0|C),E=0|o(),M(A,I,t,C),C=E,I=I+t|0):r=g,!(0==(0|r)&0==(0|C)))){t=0,g=0;do{_=0|B[I+t>>0],E=0|bC(0|a[A+56>>2],0|a[A+56+4>>2],0|t,0|g),o(),B[A+64+E>>0]=_,t=0|bC(0|t,0|g,1,0),g=0|o()}while(g>>>0<C>>>0|(0|g)==(0|C)&t>>>0<r>>>0);_=0|bC(0|a[A+56>>2],0|a[A+56+4>>2],0|r,0|C),E=0|o(),a[A+56>>2]=_,a[A+56+4>>2]=E}}function O(A,I,g){var B,C;g|=0,B=h,C=h=h+63&-64,h=h+400|0,0==(0|(A|=0))|0==(0|(I|=0))||(bg(C,0,0,64),UC(C+384|0,0|a[I+48>>2]),XC(C,C+384|0,4,0),UC(C+384|0,0|a[I+4>>2]),XC(C,C+384|0,4,0),UC(C+384|0,0|a[I+44>>2]),XC(C,C+384|0,4,0),UC(C+384|0,0|a[I+40>>2]),XC(C,C+384|0,4,0),UC(C+384|0,19),XC(C,C+384|0,4,0),UC(C+384|0,g),XC(C,C+384|0,4,0),UC(C+384|0,0|a[I+12>>2]),XC(C,C+384|0,4,0),0|(g=0|a[I+8>>2])&&(XC(C,g,0|a[I+12>>2],0),1&a[I+56>>2]|0)&&(Lg(0|a[I+8>>2],0|a[I+12>>2]),a[I+12>>2]=0),UC(C+384|0,0|a[I+20>>2]),XC(C,C+384|0,4,0),0|(g=0|a[I+16>>2])&&XC(C,g,0|a[I+20>>2],0),UC(C+384|0,0|a[I+28>>2]),XC(C,C+384|0,4,0),0|(g=0|a[I+24>>2])&&(XC(C,g,0|a[I+28>>2],0),2&a[I+56>>2]|0)&&(Lg(0|a[I+24>>2],0|a[I+28>>2]),a[I+28>>2]=0),UC(C+384|0,0|a[I+36>>2]),XC(C,C+384|0,4,0),0|(g=0|a[I+32>>2])&&XC(C,g,0|a[I+36>>2],0),gC(C,A,64)),h=B}function $(A,I){A|=0,I|=0;var g=0,C=0,Q=0,e=0,c=0,i=0,_=0,E=0,n=0,s=0,y=0;A:do{if(0|A){do{if(2==(0|a[A+36>>2])){if(0==(0|(g=0|a[I>>2]))&&(0|t[I+8>>0])<=1){C=6;break}E=0|a[A+4>>2],_=0}else C=6}while(0);if(6==(0|C)&&(wA(A,I,E=0|a[A+4>>2]),g=0|a[I>>2],_=1),g=0==(0|g)&(Q=0|B[I+8>>0])<<24>>24==0?2:0,C=0|a[A+24>>2],c=0|r(C,0|a[I+4>>2]),i=0|a[A+20>>2],Q=c+g+(0|r(i,255&Q))|0,g>>>0<i>>>0)for(e=C,i=Q,C=(0==(0|(Q>>>0)%(C>>>0))?C+-1|0:-1)+Q|0;;){if(c=1==(0|(i>>>0)%(e>>>0))?i+-1|0:C,C=_?E+(g<<3)|0:(0|a[4+(0|a[A>>2])>>2])+(c<<10)|0,y=0|a[(e=C)>>2],e=0|GB(0|a[e+4>>2],0,0|a[A+28>>2],0),Q=0|o(),n=0|a[I>>2],C=0|B[I+8>>0],s=0|a[I+4>>2],e=0==(0|n)&C<<24>>24==0?s:e,a[I+12>>2]=g,Q=0|XA(A,n,C,g,y,1&((0|e)==(0|s)?0==(0|(0==(0|n)&C<<24>>24==0?0:Q)):0)),Q=(C=0|a[4+(0|a[A>>2])>>2])+((0|r(0|a[A+24>>2],e))<<10)+(Q<<10)|0,e=C+(i<<10)|0,n?F(C+(c<<10)|0,Q,e):k(C+(c<<10)|0,Q,e),(g=g+1|0)>>>0>=(0|a[A+20>>2])>>>0)break A;e=0|a[A+24>>2],i=i+1|0,C=c+1|0}}}while(0)}function AA(A,I,g,C){A|=0,I|=0,g|=0,C|=0;var t,r,Q=0,e=0,o=0;if(t=h,r=h=h+63&-64,h=h+528|0,a[r+512>>2]=0,UC(r+512|0,I),I>>>0<65)(0|bg(r,0,0,I))>=0&&(XC(r,r+512|0,4,0),XC(r,g,C,0),gC(r,A,I));else A:do{if((0|bg(r,0,0,64))>=0&&(XC(r,r+512|0,4,0),XC(r,g,C,0),(0|gC(r,r+448|0,64))>=0)){e=r+448|0,o=(Q=A)+32|0;do{B[Q>>0]=0|B[e>>0],Q=Q+1|0,e=e+1|0}while((0|Q)<(0|o));e=r+448|0,o=64+(Q=r+384|0)|0;do{a[Q>>2]=a[e>>2],Q=Q+4|0,e=e+4|0}while((0|Q)<(0|o));if((I+-32|0)>>>0>64){C=A+32|0,g=I+-32|0;do{if((0|yB(r+448|0,64,r+384|0,64,0,0,0))<0)break A;e=r+448|0,o=(Q=C)+32|0;do{B[Q>>0]=0|B[e>>0],Q=Q+1|0,e=e+1|0}while((0|Q)<(0|o));g=g+-32|0,C=C+32|0,e=r+448|0,o=64+(Q=r+384|0)|0;do{a[Q>>2]=a[e>>2],Q=Q+4|0,e=e+4|0}while((0|Q)<(0|o))}while(g>>>0>64)}else C=A+32|0,g=I+-32|0;(0|yB(r+448|0,g,r+384|0,64,0,0,0))>=0&&sA(0|C,r+448|0,0|g)}}while(0);Lg(r,384),h=t}function IA(A,I,g,C,r,Q,e,c){A|=0,I|=0,r|=0,Q|=0,e|=0,c|=0;var i,_,E=0,n=0;if(i=h,_=h=h+63&-64,h=h+112|0,!(0==(0|(g|=0))&0==(0|(C|=0)))){E=(n=_)+32|0;do{B[n>>0]=0|B[c>>0],n=n+1|0,c=c+1|0}while((0|n)<(0|E));c=t[r+4>>0]|t[r+4+1>>0]<<8|t[r+4+2>>0]<<16|t[r+4+3>>0]<<24,a[_+96>>2]=t[r>>0]|t[r+1>>0]<<8|t[r+2>>0]<<16|t[r+3>>0]<<24,a[_+96+4>>2]=c,c=8;do{B[_+96+c>>0]=Q,Q=0|CC(0|Q,0|e,8),e=0|o(),c=c+1|0}while(16!=(0|c));if(C>>>0>0|0==(0|C)&g>>>0>63)for(Q=C;;){$C(_+32|0,_+96|0,_,0),e=0;do{B[A+e>>0]=B[_+32+e>>0]^B[I+e>>0],e=e+1|0}while(64!=(0|e));for(c=8,e=1;e=e+(0|t[(C=_+96+c|0)>>0])|0,B[C>>0]=e,16!=(0|(c=c+1|0));)e>>>=8;if(e=0|bC(0|g,0|Q,-64,-1),A=A+64|0,I=I+64|0,!((c=0|o())>>>0>0|0==(0|c)&e>>>0>63)){Q=e;break}g=e,Q=c}else Q=g,c=C;if(!(0==(0|Q)&0==(0|c))&&($C(_+32|0,_+96|0,_,0),0|Q)){e=0;do{B[A+e>>0]=B[_+32+e>>0]^B[I+e>>0],e=e+1|0}while((0|e)!=(0|Q))}Lg(_+32|0,64),Lg(_,32)}return h=i,0}function gA(A,I,g,C,a){A|=0,I|=0,g|=0,C|=0;var Q=0,e=0,o=0,i=0,_=0,E=0;sa(a|=0),e=(0|r((C>>>0)/3|0,-3))+C|0,Q=((C>>>0)/3|0)<<2;do{if(e){if(2&a){Q=(2|Q)+(e>>>1)|0;break}Q=Q+4|0;break}}while(0);if(Q>>>0>=I>>>0&&st(),4&a)if(0|C){i=0,a=0,e=0,_=0;do{if(E=_,_=_+1|0,i=i<<8|0|t[g+E>>0],(a=a+8|0)>>>0>5)for(;;){if(E=255&(0|cB(i>>>(a=a+-6|0)&63)),o=e+1|0,B[A+e>>0]=E,!(a>>>0>5)){e=o;break}e=o}}while((0|_)!=(0|C));a&&(E=255&(0|cB(i<<6-a&63)),B[A+e>>0]=E,e=e+1|0)}else e=0;else if(0|C){i=0,a=0,e=0,_=0;do{if(o=_,_=_+1|0,i=i<<8|0|t[g+o>>0],(a=a+8|0)>>>0>5)for(;;){if(E=255&(0|nB(i>>>(a=a+-6|0)&63)),o=e+1|0,B[A+e>>0]=E,!(a>>>0>5)){e=o;break}e=o}}while((0|_)!=(0|C));a&&(E=255&(0|nB(i<<6-a&63)),B[A+e>>0]=E,e=e+1|0)}else e=0;return Q>>>0<e>>>0&&c(35301,35320,230,35336),Q>>>0>e>>>0?tI(A+e|0,61,Q-e|0):Q=e,tI(A+Q|0,0,((E=Q+1|0)>>>0<I>>>0?I:E)-Q|0),0|A}function BA(A,I){I|=0;var g,C,t,r,Q,e,c=0,i=0,_=0,E=0;0==(0|(i=0|a[56+(A|=0)>>2]))&0==(0|(c=0|a[A+56+4>>2]))||(B[A+64+i>>0]=1,c=0|bC(0|i,0|c,1,0),(_=0|o())>>>0<0|0==(0|_)&c>>>0<16&&tI(A+64+c|0,0,14-i+1|0),B[A+80>>0]=1,M(A,A+64|0,16,0)),i=0|a[A+24>>2],E=(t=(-67108864|(C=((E=((_=(0|a[A+28>>2])+(i>>>26)|0)>>>26)+(0|a[A+32>>2])|0)>>>26)+(0|a[A+36>>2])|0))+((((((r=((e=(5*(C>>>26)|0)+(0|a[A+20>>2])|0)>>>26)+(67108863&i)+((5+(67108863&e)|0)>>>26)|0)>>>26)+(67108863&_)|0)>>>26)+(67108863&E)|0)>>>26)|0)>>31&67108863&E|(Q=(t>>>31)-1&67108863)&(((r>>>26)+(67108863&_)|0)>>>26)+(67108863&E),g=0|bC(t>>31&67108863&e|Q&5+(67108863&e)|(t>>31&(e>>>26)+(67108863&i)|Q&r)<<26|0,0,0|a[A+40>>2],0),c=0|o(),c=0|bC(0|(i=0|bC((t>>31&(e>>>26)+(67108863&i)|Q&r)>>>6|(t>>31&67108863&_|Q&(r>>>26)+(67108863&_))<<20|0,0,0|a[A+44>>2],0)),0|o(),0|c,0),i=0|o(),i=0|bC(0|(_=0|bC((t>>31&67108863&_|Q&(r>>>26)+(67108863&_))>>>12|E<<14|0,0,0|a[A+48>>2],0)),0|o(),0|i,0),_=0|o(),_=0|bC(0|(E=0|bC(((t>>>31)-1&t|t>>31&C)<<8|E>>>18|0,0,0|a[A+52>>2],0)),0|o(),0|_,0),o(),UC(I,g),UC(I+4|0,c),UC(I+8|0,i),UC(I+12|0,_),Lg(A,88)}function CA(A,I){var g,B;A|=0,g=h,B=h=h+63&-64,h=h+192|0,d(B+144|0,I|=0),d(B+96|0,B+144|0),d(B+96|0,B+96|0),m(B+96|0,I,B+96|0),m(B+144|0,B+144|0,B+96|0),d(B+48|0,B+144|0),m(B+96|0,B+96|0,B+48|0),d(B+48|0,B+96|0),I=1;do{d(B+48|0,B+48|0),I=I+1|0}while(5!=(0|I));m(B+96|0,B+48|0,B+96|0),d(B+48|0,B+96|0),I=1;do{d(B+48|0,B+48|0),I=I+1|0}while(10!=(0|I));m(B+48|0,B+48|0,B+96|0),d(B,B+48|0),I=1;do{d(B,B),I=I+1|0}while(20!=(0|I));m(B+48|0,B,B+48|0),d(B+48|0,B+48|0),I=1;do{d(B+48|0,B+48|0),I=I+1|0}while(10!=(0|I));m(B+96|0,B+48|0,B+96|0),d(B+48|0,B+96|0),I=1;do{d(B+48|0,B+48|0),I=I+1|0}while(50!=(0|I));m(B+48|0,B+48|0,B+96|0),d(B,B+48|0),I=1;do{d(B,B),I=I+1|0}while(100!=(0|I));m(B+48|0,B,B+48|0),d(B+48|0,B+48|0),I=1;do{d(B+48|0,B+48|0),I=I+1|0}while(50!=(0|I));m(B+96|0,B+48|0,B+96|0),d(B+96|0,B+96|0),I=1;do{d(B+96|0,B+96|0),I=I+1|0}while(5!=(0|I));m(A,B+96|0,B+144|0),h=g}function aA(A,I,g,B,C,t,r){A|=0,I|=0,g|=0,B|=0,C|=0;var Q,e,c=0,i=0;return Q=h,e=h=h+63&-64,h=h+352|0,K(e,t|=0,r|=0,0),A>>>0>g>>>0&&0<C>>>0|0==(0|C)&(A-g|0)>>>0<B>>>0?i=5:g>>>0>A>>>0&&0<C>>>0|0==(0|C)&(g-A|0)>>>0<B>>>0?i=5:c=g,5==(0|i)&&(Rg(0|A,0|g,0|B),c=A),a[e+32>>2]=0,a[e+32+4>>2]=0,a[e+32+8>>2]=0,a[e+32+12>>2]=0,a[e+32+16>>2]=0,a[e+32+20>>2]=0,a[e+32+24>>2]=0,a[e+32+28>>2]=0,0==(0|(r=C>>>0>0|0==(0|C)&B>>>0>32?32:B))&0==(0|(g=C>>>0>0|0==(0|C)&B>>>0>32?0:C))||sA(e+32+32|0,0|c,-2-(i=~C>>>0>4294967295|-1==(0|~C)&~B>>>0>4294967263?~B:-33)+1|0),hB(e+32|0,e+32|0,i=0|bC(0|r,0|g,32,0),0|o(),t+16|0,e),ca(e+96|0,e+32|0),0==(0|r)&0==(0|g)||sA(0|A,e+32+32|0,-2-(i=~C>>>0>4294967295|-1==(0|~C)&~B>>>0>4294967263?~B:-33)+1|0),Lg(e+32|0,64),C>>>0>0|0==(0|C)&B>>>0>32&&Tg(A+r|0,c+r|0,i=0|FC(0|B,0|C,0|r,0|g),0|o(),t+16|0,1,0,e),Lg(e,32),GC(e+96|0,A,B,C),oa(e+96|0,I),Lg(e+96|0,256),h=Q,0}function tA(A,I,g,B,C,t,r){A|=0,I|=0,g|=0,B|=0,C|=0;var Q,e,c=0,i=0;return Q=h,e=h=h+63&-64,h=h+352|0,T(e,t|=0,r|=0,0),A>>>0>g>>>0&&0<C>>>0|0==(0|C)&(A-g|0)>>>0<B>>>0?i=5:g>>>0>A>>>0&&0<C>>>0|0==(0|C)&(g-A|0)>>>0<B>>>0?i=5:c=g,5==(0|i)&&(Rg(0|A,0|g,0|B),c=A),a[e+32>>2]=0,a[e+32+4>>2]=0,a[e+32+8>>2]=0,a[e+32+12>>2]=0,a[e+32+16>>2]=0,a[e+32+20>>2]=0,a[e+32+24>>2]=0,a[e+32+28>>2]=0,0==(0|(r=C>>>0>0|0==(0|C)&B>>>0>32?32:B))&0==(0|(g=C>>>0>0|0==(0|C)&B>>>0>32?0:C))||sA(e+32+32|0,0|c,-2-(i=~C>>>0>4294967295|-1==(0|~C)&~B>>>0>4294967263?~B:-33)+1|0),fC(e+32|0,e+32|0,i=0|bC(0|r,0|g,32,0),0|o(),t+16|0,e),ca(e+96|0,e+32|0),0==(0|r)&0==(0|g)||sA(0|A,e+32+32|0,-2-(i=~C>>>0>4294967295|-1==(0|~C)&~B>>>0>4294967263?~B:-33)+1|0),Lg(e+32|0,64),C>>>0>0|0==(0|C)&B>>>0>32&&XB(A+r|0,c+r|0,i=0|FC(0|B,0|C,0|r,0|g),0|o(),t+16|0,1,0,e),Lg(e,32),GC(e+96|0,A,B,C),oa(e+96|0,I),Lg(e+96|0,256),h=Q,0}function rA(A,I){A|=0;var g,C,a=0;for(g=h,C=h=h+63&-64,h=h+1760|0,TB(C,I|=0),VB(C+1600|0,I),YB(C+1280|0,C+1600|0),RI(C+1600|0,C+1280|0,C),YB(C+1440|0,C+1600|0),TB(C+160|0,C+1440|0),RI(C+1600|0,C+1280|0,C+160|0),YB(C+1440|0,C+1600|0),TB(C+320|0,C+1440|0),RI(C+1600|0,C+1280|0,C+320|0),YB(C+1440|0,C+1600|0),TB(C+480|0,C+1440|0),RI(C+1600|0,C+1280|0,C+480|0),YB(C+1440|0,C+1600|0),TB(C+640|0,C+1440|0),RI(C+1600|0,C+1280|0,C+640|0),YB(C+1440|0,C+1600|0),TB(C+800|0,C+1440|0),RI(C+1600|0,C+1280|0,C+800|0),YB(C+1440|0,C+1600|0),TB(C+960|0,C+1440|0),RI(C+1600|0,C+1280|0,C+960|0),YB(C+1440|0,C+1600|0),TB(C+1120|0,C+1440|0),ta(A),a=252;VB(C+1600|0,A),(I=0|B[31840+a>>0])<<24>>24<=0?I<<24>>24<0&&(YB(C+1440|0,C+1600|0),NI(C+1600|0,C+1440|0,C+(160*(((I<<24>>24)/-2|0)<<24>>24)|0)|0)):(YB(C+1440|0,C+1600|0),RI(C+1600|0,C+1440|0,C+(160*((255&I)>>>1&255)|0)|0)),YB(A,C+1600|0),a;)a=a+-1|0;h=g}function QA(A,I){A|=0;var g,B,C=0;g=h,B=h=h+63&-64,h=h+144|0,d(B+96|0,I|=0),d(B+48|0,B+96|0),d(B+48|0,B+48|0),m(B+48|0,I,B+48|0),m(B+96|0,B+96|0,B+48|0),d(B+96|0,B+96|0),m(B+96|0,B+48|0,B+96|0),d(B+48|0,B+96|0),C=1;do{d(B+48|0,B+48|0),C=C+1|0}while(5!=(0|C));m(B+96|0,B+48|0,B+96|0),d(B+48|0,B+96|0),C=1;do{d(B+48|0,B+48|0),C=C+1|0}while(10!=(0|C));m(B+48|0,B+48|0,B+96|0),d(B,B+48|0),C=1;do{d(B,B),C=C+1|0}while(20!=(0|C));m(B+48|0,B,B+48|0),d(B+48|0,B+48|0),C=1;do{d(B+48|0,B+48|0),C=C+1|0}while(10!=(0|C));m(B+96|0,B+48|0,B+96|0),d(B+48|0,B+96|0),C=1;do{d(B+48|0,B+48|0),C=C+1|0}while(50!=(0|C));m(B+48|0,B+48|0,B+96|0),d(B,B+48|0),C=1;do{d(B,B),C=C+1|0}while(100!=(0|C));m(B+48|0,B,B+48|0),d(B+48|0,B+48|0),C=1;do{d(B+48|0,B+48|0),C=C+1|0}while(50!=(0|C));m(B+96|0,B+48|0,B+96|0),d(B+96|0,B+96|0),d(B+96|0,B+96|0),m(A,B+96|0,I),h=g}function eA(A,I,g,B,C,t,Q,e,c,i,_){A|=0,I|=0,g|=0,B|=0,C|=0,t|=0,Q|=0,i|=0,_|=0;var E=0,n=0,s=0;s=0|NB(0|(c|=0),0,0|(e|=0),0),n=0|o();do{if(n>>>0>0|0==(0|n)&s>>>0>1073741823)a[8886]=22,E=-1;else{if(Q>>>0>0|0==(0|Q)&t>>>0>4294967295){a[8886]=22,E=-1;break}if(Q>>>0<0|0==(0|Q)&t>>>0<2|0!=((s=0|bC(0|t,0|Q,-1,-1))&t|0)|0!=((0|o())&Q|0)){a[8886]=28,E=-1;break}if(0==(0|e)|0==(0|c)){a[8886]=28,E=-1;break}if(!(e>>>0>16777215||(33554431/(c>>>0)|0)>>>0<e>>>0||0<Q>>>0|(0==(0|Q)?(33554431/(e>>>0)|0)>>>0<t>>>0:0))){if(((n=0|r(e<<7,c))+(s=0|r(e<<7,t))|0)>>>0<s>>>0){a[8886]=48,E=-1;break}if((E=n+s+(e<<8|64)|0)>>>0<(e<<8|64)>>>0){a[8886]=48,E=-1;break}if((0|a[A+8>>2])>>>0<E>>>0&&(aa(A),0==(0|hg(A,E)))){E=-1;break}fI(I,g,B,C,A=0|a[A+4>>2],n),E=0;do{cA(A+(0|r(e<<7,E))|0,e,t,Q,A+n|0,A+n+s|0),E=E+1|0}while((0|E)!=(0|c));fI(I,g,A,n,i,_),E=0;break}a[8886]=48,E=-1}}while(0);return 0|E}function oA(A,I,g,C){A|=0,I|=0,g|=0,C|=0;var a=0,r=0,Q=0,e=0;A:do{if(!(0==(0|g)&0==(0|C))){for(a=t[A+352>>0]|t[A+352+1>>0]<<8|t[A+352+2>>0]<<16|t[A+352+3>>0]<<24,Q=I;I=A+96+a|0,C>>>0>0|0==(0|C)&g>>>0>(e=256-a|0)>>>0;){sA(0|I,0|Q,0|e),I=(t[A+352>>0]|t[A+352+1>>0]<<8|t[A+352+2>>0]<<16|t[A+352+3>>0]<<24)+e|0,B[A+352>>0]=I,B[A+352+1>>0]=I>>8,B[A+352+2>>0]=I>>16,B[A+352+3>>0]=I>>24,xA(A,128,0),p(A,A+96|0),a=A+224|0,r=128+(I=A+96|0)|0;do{B[I>>0]=0|B[a>>0],I=I+1|0,a=a+1|0}while((0|I)<(0|r));if(a=(t[A+352>>0]|t[A+352+1>>0]<<8|t[A+352+2>>0]<<16|t[A+352+3>>0]<<24)-128|0,B[A+352>>0]=a,B[A+352+1>>0]=a>>8,B[A+352+2>>0]=a>>16,B[A+352+3>>0]=a>>24,0==(0|(g=0|FC(0|g,0|C,0|e,0)))&0==(0|(C=0|o())))break A;Q=Q+e|0}sA(0|I,0|Q,0|g),e=(t[A+352>>0]|t[A+352+1>>0]<<8|t[A+352+2>>0]<<16|t[A+352+3>>0]<<24)+g|0,B[A+352>>0]=e,B[A+352+1>>0]=e>>8,B[A+352+2>>0]=e>>16,B[A+352+3>>0]=e>>24}}while(0)}function cA(A,I,g,B,C,t){A|=0,g|=0,B|=0,C|=0,t|=0;var Q=0,e=0,c=0,i=0,_=0;if((I|=0)<<5|0){Q=0;do{i=0|ga(A+(Q<<2)|0),a[t+(Q<<2)>>2]=i,Q=Q+1|0}while((0|Q)!=(I<<5|0))}if(!(0==(0|g)&0==(0|B))){Q=0,e=0;do{MB(C+((0|r(I<<5,Q))<<2)|0,t,I<<7),gg(t,t+(I<<5<<2)|0,t+(I<<6<<2)|0,I),MB(C+((0|r(1|Q,I<<5))<<2)|0,t+(I<<5<<2)|0,I<<7),gg(t+(I<<5<<2)|0,t,t+(I<<6<<2)|0,I),Q=0|bC(0|Q,0|e,2,0),e=0|o()}while(e>>>0<B>>>0|(0|e)==(0|B)&Q>>>0<g>>>0);Q=0|bC(0|g,0|B,-1,-1),e=0|o(),c=0,i=0;do{_=0|HC(t,I),o(),EB(t,C+((0|r(I<<5,_&Q))<<2)|0,I<<7),gg(t,t+(I<<5<<2)|0,t+(I<<6<<2)|0,I),_=0|HC(t+(I<<5<<2)|0,I),o(),EB(t+(I<<5<<2)|0,C+((0|r(I<<5,_&Q))<<2)|0,I<<7),gg(t+(I<<5<<2)|0,t,t+(I<<6<<2)|0,I),c=0|bC(0|c,0|i,2,0),i=0|o()}while(i>>>0<B>>>0|(0|i)==(0|B)&c>>>0<g>>>0)}if(I<<5|0){Q=0;do{UC(A+(Q<<2)|0,0|a[t+(Q<<2)>>2]),Q=Q+1|0}while((0|Q)!=(I<<5|0))}}function iA(A,I,g){var B,C,t,r,Q,e,o,c,i,_,E,n,s,y,h,p,f,w,l,u;I|=0,g|=0,u=0|a[(A|=0)>>2],w=0|a[A+4>>2],p=0|a[A+8>>2],y=0|a[A+12>>2],n=0|a[A+16>>2],_=0|a[A+20>>2],c=0|a[A+24>>2],e=0|a[A+28>>2],r=0|a[A+32>>2],C=0|a[A+36>>2],l=0|a[I>>2],f=0|a[I+4>>2],h=0|a[I+8>>2],s=0|a[I+12>>2],E=0|a[I+16>>2],i=0|a[I+20>>2],o=0|a[I+24>>2],Q=0|a[I+28>>2],t=0|a[I+32>>2],B=0|a[I+36>>2],a[A>>2]=(l^u)&0-g^u,a[A+4>>2]=(f^w)&0-g^w,a[A+8>>2]=(h^p)&0-g^p,a[A+12>>2]=(s^y)&0-g^y,a[A+16>>2]=(E^n)&0-g^n,a[A+20>>2]=(i^_)&0-g^_,a[A+24>>2]=(o^c)&0-g^c,a[A+28>>2]=(Q^e)&0-g^e,a[A+32>>2]=(t^r)&0-g^r,a[A+36>>2]=(B^C)&0-g^C,a[I>>2]=(l^u)&0-g^l,a[I+4>>2]=(f^w)&0-g^f,a[I+8>>2]=(h^p)&0-g^h,a[I+12>>2]=(s^y)&0-g^s,a[I+16>>2]=(E^n)&0-g^E,a[I+20>>2]=(i^_)&0-g^i,a[I+24>>2]=(o^c)&0-g^o,a[I+28>>2]=(Q^e)&0-g^Q,a[I+32>>2]=(t^r)&0-g^t,a[I+36>>2]=(B^C)&0-g^B}function _A(A,I,g,B,C,a,t){A|=0,I|=0,g|=0,B|=0,C|=0;var r,Q,e=0;return Q=h,r=h=h+63&-64,h=h+96|0,K(r,a|=0,t|=0,0),RB(r+32|0,32,0,a+16|0,r),0|lC(g,I,B,C,r+32|0)?(Lg(r,32),I=-1):A?(I>>>0>=A>>>0&&0<C>>>0|0==(0|C)&(I-A|0)>>>0<B>>>0?e=8:A>>>0>=I>>>0&&0<C>>>0|0==(0|C)&(A-I|0)>>>0<B>>>0?e=8:g=I,8==(0|e)&&(Rg(0|A,0|I,0|B),g=A),0==(0|(I=C>>>0>0|0==(0|C)&B>>>0>32?32:B))&0==(0|(t=C>>>0>0|0==(0|C)&B>>>0>32?0:C))?hB(r+32|0,r+32|0,32,0,a+16|0,r):(sA(r+32+32|0,0|g,-2-(e=~C>>>0>4294967295|-1==(0|~C)&~B>>>0>4294967263?~B:-33)+1|0),hB(r+32|0,r+32|0,0|bC(0|I,0|t,32,0),0|o(),a+16|0,r),sA(0|A,r+32+32|0,-2-e+1|0)),C>>>0>0|0==(0|C)&B>>>0>32&&Tg(A+I|0,g+I|0,0|FC(0|B,0|C,0|I,0|t),0|o(),a+16|0,1,0,r),Lg(r,32),I=0):I=0,h=Q,0|I}function EA(A,I,g,B,C,a,t){A|=0,I|=0,g|=0,B|=0,C|=0;var r,Q,e=0;return Q=h,r=h=h+63&-64,h=h+96|0,T(r,a|=0,t|=0,0),RC(r+32|0,32,0,a+16|0,r),0|lC(g,I,B,C,r+32|0)?(Lg(r,32),I=-1):A?(I>>>0>=A>>>0&&0<C>>>0|0==(0|C)&(I-A|0)>>>0<B>>>0?e=8:A>>>0>=I>>>0&&0<C>>>0|0==(0|C)&(A-I|0)>>>0<B>>>0?e=8:g=I,8==(0|e)&&(Rg(0|A,0|I,0|B),g=A),0==(0|(I=C>>>0>0|0==(0|C)&B>>>0>32?32:B))&0==(0|(t=C>>>0>0|0==(0|C)&B>>>0>32?0:C))?fC(r+32|0,r+32|0,32,0,a+16|0,r):(sA(r+32+32|0,0|g,-2-(e=~C>>>0>4294967295|-1==(0|~C)&~B>>>0>4294967263?~B:-33)+1|0),fC(r+32|0,r+32|0,0|bC(0|I,0|t,32,0),0|o(),a+16|0,r),sA(0|A,r+32+32|0,-2-e+1|0)),C>>>0>0|0==(0|C)&B>>>0>32&&XB(A+I|0,g+I|0,0|FC(0|B,0|C,0|I,0|t),0|o(),a+16|0,1,0,r),Lg(r,32),I=0):I=0,h=Q,0|I}function nA(A,I,g,C,r){A|=0,C|=0,r|=0;var Q,e,c=0,i=0,_=0,E=0,n=0;if(Q=h,e=h=h+63&-64,h=h+112|0,!(0==(0|(I|=0))&0==(0|(g|=0)))){c=(i=e)+32|0;do{B[i>>0]=0|B[r>>0],i=i+1|0,r=r+1|0}while((0|i)<(0|c));if(i=t[C+4>>0]|t[C+4+1>>0]<<8|t[C+4+2>>0]<<16|t[C+4+3>>0]<<24,a[e+96>>2]=t[C>>0]|t[C+1>>0]<<8|t[C+2>>0]<<16|t[C+3>>0]<<24,a[e+96+4>>2]=i,a[e+96+8>>2]=0,a[e+96+8+4>>2]=0,g>>>0>0|0==(0|g)&I>>>0>63){do{for($C(A,e+96|0,e,0),c=8,r=1;r=r+(0|t[(i=e+96+c|0)>>0])|0,B[i>>0]=r,16!=(0|(c=c+1|0));)r>>>=8;I=0|bC(0|I,0|g,-64,-1),g=0|o(),A=A+64|0}while(g>>>0>0|0==(0|g)&I>>>0>63);0==(0|I)&0==(0|g)||(E=A,n=I,_=8)}else E=A,n=I,_=8;if(8==(0|_)&&($C(e+32|0,e+96|0,e,0),0|n)){r=0;do{B[E+r>>0]=0|B[e+32+r>>0],r=r+1|0}while((0|r)!=(0|n))}Lg(e+32|0,64),Lg(e,32)}return h=Q,0}function sA(A,I,g){A|=0,I|=0;var C,t,r=0;if((0|(g|=0))>=8192)return n(0|A,0|I,0|g),0|A;if(t=0|A,C=A+g|0,(3&A)==(3&I)){for(;3&A;){if(!g)return 0|t;B[A>>0]=0|B[I>>0],A=A+1|0,I=I+1|0,g=g-1|0}for(r=(g=-4&C|0)-64|0;(0|A)<=(0|r);)a[A>>2]=a[I>>2],a[A+4>>2]=a[I+4>>2],a[A+8>>2]=a[I+8>>2],a[A+12>>2]=a[I+12>>2],a[A+16>>2]=a[I+16>>2],a[A+20>>2]=a[I+20>>2],a[A+24>>2]=a[I+24>>2],a[A+28>>2]=a[I+28>>2],a[A+32>>2]=a[I+32>>2],a[A+36>>2]=a[I+36>>2],a[A+40>>2]=a[I+40>>2],a[A+44>>2]=a[I+44>>2],a[A+48>>2]=a[I+48>>2],a[A+52>>2]=a[I+52>>2],a[A+56>>2]=a[I+56>>2],a[A+60>>2]=a[I+60>>2],A=A+64|0,I=I+64|0;for(;(0|A)<(0|g);)a[A>>2]=a[I>>2],A=A+4|0,I=I+4|0}else for(g=C-4|0;(0|A)<(0|g);)B[A>>0]=0|B[I>>0],B[A+1>>0]=0|B[I+1>>0],B[A+2>>0]=0|B[I+2>>0],B[A+3>>0]=0|B[I+3>>0],A=A+4|0,I=I+4|0;for(;(0|A)<(0|C);)B[A>>0]=0|B[I>>0],A=A+1|0,I=I+1|0;return 0|t}function yA(A,I,g){var C,t;if(A|=0,g|=0,C=h,t=h=h+63&-64,h=h+960|0,b(t+384|0,I|=0),a[t+384>>2]=1+(0|a[t+384>>2]),CA(t+384|0,t+384|0),m(t+336|0,32320,t+384|0),lI(t+336|0,t+336|0),d(t+288|0,t+336|0),m(t+240|0,t+336|0,t+288|0),$A(t+480|0,t+240|0,t+336|0),m(t+288|0,t+288|0,32320),$A(t+480|0,t+288|0,t+480|0),function(A,I){var g,B;A|=0,g=h,B=h=h+63&-64,h=h+192|0,d(B+144|0,I|=0),m(B+96|0,B+144|0,I),d(B+144|0,B+96|0),d(B+48|0,B+144|0),d(B+48|0,B+48|0),m(B+48|0,B+48|0,B+144|0),m(B+96|0,B+48|0,I),d(B+48|0,B+96|0),I=1;do{d(B+48|0,B+48|0),I=I+1|0}while(5!=(0|I));m(B+96|0,B+48|0,B+96|0),d(B+48|0,B+96|0),I=1;do{d(B+48|0,B+48|0),I=I+1|0}while(10!=(0|I));m(B+48|0,B+48|0,B+96|0),d(B,B+48|0),I=1;do{d(B,B),I=I+1|0}while(20!=(0|I));m(B+48|0,B,B+48|0),d(B+48|0,B+48|0),I=1;do{d(B+48|0,B+48|0),I=I+1|0}while(10!=(0|I));m(B+96|0,B+48|0,B+96|0),d(B+48|0,B+96|0),I=1;do{d(B+48|0,B+48|0),I=I+1|0}while(50!=(0|I));m(B+48|0,B+48|0,B+96|0),d(B,B+48|0),I=1;do{d(B,B),I=I+1|0}while(100!=(0|I));m(B+48|0,B,B+48|0),d(B+48|0,B+48|0),I=1;do{d(B+48|0,B+48|0),I=I+1|0}while(50!=(0|I));m(B+96|0,B+48|0,B+96|0),d(B+96|0,B+96|0),I=1;do{d(B+96|0,B+96|0),I=I+1|0}while(4!=(0|I));m(A,B+96|0,B+144|0),h=g}(t+480|0,t+480|0),pA(A,t+480|0),I=1&B[A+1>>0],lI(t+432|0,t+336|0),NA(t+336|0,t+432|0,I),jC(t+288|0),NA(t+288|0,32320,I),OA(t+336|0,t+336|0,t+288|0),mC(t+192|0),$A(t+144|0,t+336|0,t+192|0),OA(t+48|0,t+336|0,t+192|0),CA(t+96|0,t+144|0),m(t,t+48|0,t+96|0),pA(A,t),B[A+31>>0]=B[A+31>>0]|g,!(0|YA(t+800|0,A)))return VB(t+640|0,t+800|0),EC(t+520|0,t+640|0),Cg(t+640|0,t+520|0),EC(t+520|0,t+640|0),Cg(t+640|0,t+520|0),YB(t+800|0,t+640|0),yg(A,t+800|0),void(h=C);i()}function hA(A,I){var g,B,C;A|=0,I|=0,g=h,B=h=h+63&-64,h=h+672|0,mC(B+528|0),d(B+480|0,I),m(B+480|0,64,B+480|0),$A(B+240|0,B+480|0,B+528|0),m(B+240|0,B+240|0,32416),mC(B+624|0),lI(B+624|0,B+624|0),$A(B+432|0,B+480|0,16),m(B+192|0,B+480|0,16),OA(B+192|0,B+624|0,B+192|0),m(B+192|0,B+192|0,B+432|0),C=1-(0|QI(B+384|0,B+240|0,B+192|0))|0,m(B+336|0,B+384|0,I),la(B+336|0,B+336|0),lI(B+336|0,B+336|0),NA(B+384|0,B+336|0,C),NA(B+624|0,B+480|0,C),OA(B+576|0,B+480|0,B+528|0),m(B+576|0,B+576|0,B+624|0),m(B+576|0,B+576|0,32464),OA(B+576|0,B+576|0,B+192|0),$A(B+144|0,B+384|0,B+384|0),m(B+144|0,B+144|0,B+192|0),m(B+96|0,B+576|0,32512),d(B+288|0,B+384|0),OA(B+48|0,B+528|0,B+288|0),$A(B,B+528|0,B+288|0),m(A,B+144|0,B),m(A+40|0,B+48|0,B+96|0),m(A+80|0,B+96|0,B),m(A+120|0,B+144|0,B+48|0),h=g}function pA(A,I){A|=0;var g,C,t=0;g=h,C=h=h+63&-64,h=h+48|0,mA(C,I|=0),I=0|a[C>>2],B[A>>0]=I,B[A+1>>0]=I>>>8,B[A+2>>0]=I>>>16,t=0|a[C+4>>2],B[A+3>>0]=t<<2|I>>>24,B[A+4>>0]=t>>>6,B[A+5>>0]=t>>>14,I=0|a[C+8>>2],B[A+6>>0]=I<<3|t>>>22,B[A+7>>0]=I>>>5,B[A+8>>0]=I>>>13,t=0|a[C+12>>2],B[A+9>>0]=t<<5|I>>>21,B[A+10>>0]=t>>>3,B[A+11>>0]=t>>>11,I=0|a[C+16>>2],B[A+12>>0]=I<<6|t>>>19,B[A+13>>0]=I>>>2,B[A+14>>0]=I>>>10,B[A+15>>0]=I>>>18,I=0|a[C+20>>2],B[A+16>>0]=I,B[A+17>>0]=I>>>8,B[A+18>>0]=I>>>16,t=0|a[C+24>>2],B[A+19>>0]=t<<1|I>>>24,B[A+20>>0]=t>>>7,B[A+21>>0]=t>>>15,I=0|a[C+28>>2],B[A+22>>0]=I<<3|t>>>23,B[A+23>>0]=I>>>5,B[A+24>>0]=I>>>13,t=0|a[C+32>>2],B[A+25>>0]=t<<4|I>>>21,B[A+26>>0]=t>>>4,B[A+27>>0]=t>>>12,I=0|a[C+36>>2],B[A+28>>0]=I<<6|t>>>20,B[A+29>>0]=I>>>2,B[A+30>>0]=I>>>10,B[A+31>>0]=I>>>18,h=g}function fA(A,I){var g,B,C;A|=0,g=h,B=h=h+63&-64,h=h+864|0,$A(B+336|0,80+(I|=0)|0,I+40|0),OA(B,I+80|0,I+40|0),m(B+336|0,B+336|0,B),m(B+288|0,I,I+40|0),d(B+240|0,B+288|0),m(B+240|0,B+336|0,B+240|0),mC(B+480|0),QI(B+624|0,B+480|0,B+240|0),m(B+816|0,B+624|0,B+336|0),m(B+768|0,B+624|0,B+288|0),m(B+48|0,B+816|0,B+768|0),m(B+48|0,B+48|0,I+120|0),m(B+576|0,I,64),m(B+528|0,I+40|0,64),m(B+672|0,B+816|0,32368),m(B+384|0,I+120|0,B+48|0),C=0|tC(B+384|0),UI(B+192|0,I),UI(B+144|0,I+40|0),UI(B+720|0,B+768|0),NA(B+192|0,B+528|0,C),NA(B+144|0,B+576|0,C),NA(B+720|0,B+672|0,C),m(B+96|0,B+192|0,B+48|0),xB(B+144|0,B+144|0,0|tC(B+96|0)),OA(B+432|0,I+80|0,B+144|0),m(B+432|0,B+720|0,B+432|0),la(B+432|0,B+432|0),pA(A,B+432|0),h=g}function wA(A,I,g){A|=0,I|=0,g|=0;var B,C,r=0,Q=0,e=0;if(B=h,C=h=h+63&-64,h=h+4096|0,Ua(C+3072|0),Ua(C+2048|0),0!=(0|A)&0!=(0|I)&&(a[C+2048>>2]=a[I>>2],a[C+2048+4>>2]=0,a[C+2048+8>>2]=a[I+4>>2],a[C+2048+8+4>>2]=0,a[C+2048+16>>2]=t[I+8>>0],a[C+2048+16+4>>2]=0,a[C+2048+24>>2]=a[A+16>>2],a[C+2048+24+4>>2]=0,a[C+2048+32>>2]=a[A+8>>2],a[C+2048+32+4>>2]=0,a[C+2048+40>>2]=a[A+36>>2],a[C+2048+40+4>>2]=0,0|a[A+20>>2])){I=0;do{(r=127&I)||(e=0|bC(0|a[C+2048+48>>2],0|a[C+2048+48+4>>2],1,0),Q=0|o(),a[C+2048+48>>2]=e,a[C+2048+48+4>>2]=Q,Ua(C),Ua(C+1024|0),F(C+3072|0,C+2048|0,C),F(C+3072|0,C,C+1024|0)),Q=0|a[C+1024+(r<<3)+4>>2],a[(e=g+(I<<3)|0)>>2]=a[C+1024+(r<<3)>>2],a[e+4>>2]=Q,I=I+1|0}while(I>>>0<(0|a[A+20>>2])>>>0)}h=B}function lA(A,I,g,B){A|=0,I|=0,g|=0,B|=0;var C,t,r,Q,e=0,o=0,c=0;Q=h,r=h=h+63&-64,h=h+64|0,o=52+(e=r+8|0)|0;do{a[e>>2]=0,e=e+4|0}while((0|e)<(0|o));e=0|MI(A),a[r+36>>2]=e,a[r+20>>2]=e,a[r+4>>2]=e,o=0|u(e),a[r+32>>2]=o,C=0|u(e),a[r+16>>2]=C,t=0|u(e),a[r>>2]=t;do{if(0==(0|o)|0==(0|C)|0==(0|t))S(o),S(C),S(t),e=-22;else{if(!(c=0|u(e))){S(o),S(C),S(t),e=-22;break}if(0|(e=0|V(r,A,B))){S(0|a[r+32>>2]),S(0|a[r+16>>2]),S(0|a[r>>2]),S(c);break}B=0|MA(0|a[r+40>>2],0|a[r+44>>2],0|a[r+52>>2],I,g,0|a[r+16>>2],0|a[r+20>>2],c,0|a[r+4>>2],0,0,B),S(0|a[r+32>>2]),S(0|a[r+16>>2]),e=0==(0|B)&&0==(0|XI(c,0|a[r>>2],0|a[r+4>>2]))?0:-35,S(c),S(0|a[r>>2])}}while(0);return h=Q,0|e}function uA(A,I,g,B,C,a,t,r,Q,e,c){var i;A|=0,I|=0,g|=0,B|=0,C|=0,a|=0,t|=0,r|=0,Q|=0,i=h,h=h+352|0,DB(i+16|0,64,0,e|=0,c|=0),ca(i+80|0,i+16|0),Lg(i+16|0,64),GC(i+80|0,t,r,Q),I=0|FC(0,0,0|r,0|Q),o(),GC(i+80|0,35440,15&I,0),GC(i+80|0,g,B,C),I=0|FC(0,0,0|B,0|C),o(),GC(i+80|0,35440,15&I,0),tB(i+336|0,r,Q),GC(i+80|0,i+336|0,8,0),tB(i+336|0,B,C),GC(i+80|0,i+336|0,8,0),oa(i+80|0,i),Lg(i+80|0,256),I=0|ba(i,a),Lg(i,16);do{if(A){if(I){tI(0|A,0,0|B),I=-1;break}Ig(A,g,B,C,e,1,c),I=0;break}}while(0);return h=i,0|I}function DA(A,I){A|=0,I|=0;var g,C,a=0,r=0,Q=0;g=h,C=h=h+63&-64,h=h+464|0,a=0;do{Q=0|B[I+a>>0],B[C+(r=a<<1)>>0]=15&Q,B[C+(1|r)>>0]=(255&Q)>>>4,a=a+1|0}while(32!=(0|a));I=0,a=0;do{I=134217728+((r=I+(0|t[(Q=C+a|0)>>0])|0)<<24)>>28,B[Q>>0]=r-(I<<4),a=a+1|0}while(63!=(0|a));B[C+63>>0]=I+(0|t[C+63>>0]),ta(A),I=1;do{Qa(C+64|0,I>>>1,0|B[C+I>>0]),PI(C+304|0,A,C+64|0),YB(A,C+304|0),I=I+2|0}while(I>>>0<64);VB(C+304|0,A),EC(C+184|0,C+304|0),Cg(C+304|0,C+184|0),EC(C+184|0,C+304|0),Cg(C+304|0,C+184|0),EC(C+184|0,C+304|0),Cg(C+304|0,C+184|0),YB(A,C+304|0),I=0;do{Qa(C+64|0,I>>>1,0|B[C+I>>0]),PI(C+304|0,A,C+64|0),YB(A,C+304|0),I=I+2|0}while(I>>>0<64);h=g}function mA(A,I){var g,B,C,t,r,Q,e,o,c,i,_;A|=0,c=0|a[(I|=0)>>2],_=0|a[I+4>>2],e=0|a[I+8>>2],Q=0|a[I+12>>2],r=0|a[I+16>>2],i=0|a[I+20>>2],C=0|a[I+24>>2],B=0|a[I+28>>2],g=0|a[I+32>>2],t=(((((o=((19*((((((((((((16777216+(19*(I=0|a[I+36>>2])|0)|0)>>>25)+c>>26)+_>>25)+e>>26)+Q>>25)+r>>26)+i>>25)+C>>26)+B>>25)+g>>26)+I>>25)|0)+c>>26)+_|0)>>25)+e>>26)+Q>>25)+r>>26)+i|0,a[A>>2]=(19*((((((((((((16777216+(19*I|0)|0)>>>25)+c>>26)+_>>25)+e>>26)+Q>>25)+r>>26)+i>>25)+C>>26)+B>>25)+g>>26)+I>>25)|0)+c&67108863,a[A+4>>2]=33554431&o,a[A+8>>2]=(o>>25)+e&67108863,a[A+12>>2]=((o>>25)+e>>26)+Q&33554431,a[A+16>>2]=(((o>>25)+e>>26)+Q>>25)+r&67108863,a[A+20>>2]=33554431&t,a[A+24>>2]=(t>>25)+C&67108863,a[A+28>>2]=((t>>25)+C>>26)+B&33554431,a[A+32>>2]=(((t>>25)+C>>26)+B>>25)+g&67108863,a[A+36>>2]=((((t>>25)+C>>26)+B>>25)+g>>26)+I&33554431}function FA(A,I,g,B,C,t){g|=0,B|=0,C|=0;var r,Q=0,e=0;r=(I|=0)>>>0>0|0==(0|I)&(A|=0)>>>0>32768?A:32768,I=I>>>0>0|0==(0|I)&A>>>0>32768?I:0,a[(t|=0)>>2]=8;A:do{if(I>>>0<0|0==(0|I)&r>>>0<g>>>5>>>0){a[C>>2]=1,I=0|ia(0|r,0|I,a[t>>2]<<2|0,0),A=0|o(),a[B>>2]=1,A=0|CC(0|I,0|A,1),I=0|o(),g=1;do{if(t=0|$B(1,0,0|g),g=g+1|0,(C=0|o())>>>0>I>>>0|(0|C)==(0|I)&t>>>0>A>>>0)break A;a[B>>2]=g}while(g>>>0<63)}else{for(a[B>>2]=1,A=1;Q=0|$B(1,0,0|A),!((e=0|o())>>>0>0|0==(0|e)&Q>>>0>g>>>11>>>0);)if(A=A+1|0,a[B>>2]=A,A>>>0>=63){A=63;break}B=0|CC(0|(B=0|CC(0|r,0|I,2)),0|o(),0|A),e=(Q=0|o())>>>0<0|0==(0|Q)&B>>>0<1073741823?B:1073741823,a[C>>2]=(e>>>0)/((0|a[t>>2])>>>0)|0}}while(0)}function kA(A){A|=0;var I=0,g=0;do{if(A)if(0|a[A>>2])if((0|a[A+4>>2])>>>0>=16){if(0==(0|a[A+8>>2])&&0|a[A+12>>2]){I=-18;break}if(I=0|a[A+20>>2],!(0|a[A+16>>2]))return 0|(0==(0|I)?-6:-19);if(I>>>0>=8){if(0==(0|a[A+24>>2])&&0|a[A+28>>2]){I=-20;break}if(0==(0|a[A+32>>2])&&0|a[A+36>>2]){I=-21;break}if((I=0|a[A+44>>2])>>>0>=8)if(I>>>0<=2097152)if(I>>>0>=(g=0|a[A+48>>2])<<3>>>0)if(0|a[A+40>>2])if(g){if(!(g>>>0>16777215))return 0|(0==(0|(A=0|a[A+52>>2]))?-28:A>>>0>16777215?-29:0);I=-17}else I=-16;else I=-12;else I=-14;else I=-15;else I=-14}else I=-6}else I=-2;else I=-1;else I=-25}while(0);return 0|I}function bA(A,I,g,C,t,r){var Q,e;if(A|=0,g|=0,C|=0,t|=0,r|=0,Q=h,e=h=h+63&-64,h=h+192|0,((I|=0)-1&255)>63&&st(),0!=(0|g)&C<<24>>24!=0&&(255&C)<=64)return B[e+128>>0]=I,B[e+128+1>>0]=C,B[e+128+2>>0]=1,B[e+128+3>>0]=1,Ca(e+128+4|0),tB(e+128+8|0,0,0),a[e+128+16>>2]=0,a[e+128+16+4>>2]=0,a[e+128+16+8>>2]=0,a[e+128+16+12>>2]=0,t?WB(e+128|0,t):(a[e+128+32>>2]=0,a[e+128+32+4>>2]=0,a[e+128+32+8>>2]=0,a[e+128+32+12>>2]=0),r?jB(e+128|0,r):(a[e+128+48>>2]=0,a[e+128+48+4>>2]=0,a[e+128+48+8>>2]=0,a[e+128+48+12>>2]=0),mI(A,e+128|0),tI(e+(255&C)|0,0,128-(255&C)|0),sA(0|e,0|g,255&C|0),oA(A,e,128,0),Lg(e,128),void(h=Q);st()}function dA(A,I,g){A|=0,I|=0;var C,t=0,r=0,Q=0;C=h,h=h+192|0,(g|=0)>>>0>128?(Og(A),q(A,I,g,0),fB(A,C),I=C,Q=64):Q=g,Og(A),t=128+(g=C+64|0)|0;do{a[g>>2]=909522486,g=g+4|0}while((0|g)<(0|t));if(!(r=0==(0|Q))&&(B[C+64>>0]=54^B[I>>0],1!=(0|Q))){g=1;do{B[(t=C+64+g|0)>>0]=B[t>>0]^B[I+g>>0],g=g+1|0}while((0|g)!=(0|Q))}q(A,C+64|0,128,0),Og(A+208|0),t=128+(g=C+64|0)|0;do{a[g>>2]=1549556828,g=g+4|0}while((0|g)<(0|t));if(!r&&(B[C+64>>0]=92^B[I>>0],1!=(0|Q))){g=1;do{B[(r=C+64+g|0)>>0]=B[r>>0]^B[I+g>>0],g=g+1|0}while((0|g)!=(0|Q))}return q(A+208|0,C+64|0,128,0),Lg(C+64|0,128),Lg(C,64),h=C,0}function HA(A,I,g){A|=0,I|=0;var C,t=0,r=0,Q=0;C=h,h=h+96|0,(g|=0)>>>0>64?(Fg(A),z(A,I,g,0),lB(A,C),I=C,Q=32):Q=g,Fg(A),t=64+(g=C+32|0)|0;do{a[g>>2]=909522486,g=g+4|0}while((0|g)<(0|t));if(!(r=0==(0|Q))&&(B[C+32>>0]=54^B[I>>0],1!=(0|Q))){g=1;do{B[(t=C+32+g|0)>>0]=B[t>>0]^B[I+g>>0],g=g+1|0}while((0|g)!=(0|Q))}z(A,C+32|0,64,0),Fg(A+104|0),t=64+(g=C+32|0)|0;do{a[g>>2]=1549556828,g=g+4|0}while((0|g)<(0|t));if(!r&&(B[C+32>>0]=92^B[I>>0],1!=(0|Q))){g=1;do{B[(r=C+32+g|0)>>0]=B[r>>0]^B[I+g>>0],g=g+1|0}while((0|g)!=(0|Q))}return z(A+104|0,C+32|0,64,0),Lg(C+32|0,64),Lg(C,32),h=C,0}function GA(A,I){A|=0,I|=0;var g,C,t=0,r=0;g=h,C=h=h+63&-64,h=h+128|0,a[C+64>>2]=0,a[C+64+4>>2]=0,a[C+64+8>>2]=0,a[C+64+12>>2]=0,a[C+64+16>>2]=0,a[C+64+20>>2]=0,a[C+64+24>>2]=0,a[C+64+28>>2]=0,B[C+64>>0]=1,a[(r=C+64+32|0)>>2]=a[8504],a[r+4>>2]=a[8505],a[r+8>>2]=a[8506],a[r+12>>2]=a[8507],a[r+16>>2]=a[8508],a[r+20>>2]=a[8509],a[r+24>>2]=a[8510],a[r+28>>2]=a[8511],a[C+32>>2]=0,a[C+32+4>>2]=0,a[C+32+8>>2]=0,a[C+32+12>>2]=0,a[C+32+16>>2]=0,a[C+32+20>>2]=0,a[C+32+24>>2]=0,a[C+32+28>>2]=0,t=(r=C)+32|0;do{B[r>>0]=0|B[I>>0],r=r+1|0,I=I+1|0}while((0|r)<(0|t));eB(C+64|0,C),D(C+64|0),I=C+64|0,t=(r=A)+32|0;do{B[r>>0]=0|B[I>>0],r=r+1|0,I=I+1|0}while((0|r)<(0|t));h=g}function SA(A,I){A|=0,I|=0;var g,C,t=0,r=0;g=h,C=h=h+63&-64,h=h+128|0,a[C+64>>2]=0,a[C+64+4>>2]=0,a[C+64+8>>2]=0,a[C+64+12>>2]=0,a[C+64+16>>2]=0,a[C+64+20>>2]=0,a[C+64+24>>2]=0,a[C+64+28>>2]=0,a[(r=C+64+32|0)>>2]=a[8504],a[r+4>>2]=a[8505],a[r+8>>2]=a[8506],a[r+12>>2]=a[8507],a[r+16>>2]=a[8508],a[r+20>>2]=a[8509],a[r+24>>2]=a[8510],a[r+28>>2]=a[8511],a[C+32>>2]=0,a[C+32+4>>2]=0,a[C+32+8>>2]=0,a[C+32+12>>2]=0,a[C+32+16>>2]=0,a[C+32+20>>2]=0,a[C+32+24>>2]=0,a[C+32+28>>2]=0,t=(r=C)+32|0;do{B[r>>0]=0|B[I>>0],r=r+1|0,I=I+1|0}while((0|r)<(0|t));eB(C+64|0,C),D(C+64|0),I=C+64|0,t=(r=A)+32|0;do{B[r>>0]=0|B[I>>0],r=r+1|0,I=I+1|0}while((0|r)<(0|t));h=g}function xA(A,I,g){var C,a;I|=0,g|=0,C=0|bC(t[64+(A|=0)>>0]|t[A+64+1>>0]<<8|t[A+64+2>>0]<<16|t[A+64+3>>0]<<24|0,t[A+64+4>>0]|t[A+64+4+1>>0]<<8|t[A+64+4+2>>0]<<16|t[A+64+4+3>>0]<<24|0,0|I,0|g),a=0|o(),B[A+64>>0]=C,B[A+64+1>>0]=C>>8,B[A+64+2>>0]=C>>16,B[A+64+3>>0]=C>>24,B[A+64+4>>0]=a,B[A+64+4+1>>0]=a>>8,B[A+64+4+2>>0]=a>>16,B[A+64+4+3>>0]=a>>24,I=0|bC(t[A+72>>0]|t[A+72+1>>0]<<8|t[A+72+2>>0]<<16|t[A+72+3>>0]<<24|0,t[A+72+4>>0]|t[A+72+4+1>>0]<<8|t[A+72+4+2>>0]<<16|t[A+72+4+3>>0]<<24|0,1&(a>>>0<g>>>0|(0|a)==(0|g)&C>>>0<I>>>0)|0,0),g=0|o(),B[A+72>>0]=I,B[A+72+1>>0]=I>>8,B[A+72+2>>0]=I>>16,B[A+72+3>>0]=I>>24,B[A+72+4>>0]=g,B[A+72+4+1>>0]=g>>8,B[A+72+4+2>>0]=g>>16,B[A+72+4+3>>0]=g>>24}function UA(A,I){A|=0;var g,B=0;return g=h,B=h=h+63&-64,h=h+480|0,0|_B(I|=0)?(J(B+336|0,I),d(B+288|0,B+336|0),mC(B+240|0),OA(B+240|0,B+240|0,B+288|0),d(B+144|0,B+240|0),mC(B+192|0),$A(B+192|0,B+192|0,B+288|0),d(B+96|0,B+192|0),m(B+48|0,16,B+144|0),lI(B+48|0,B+48|0),OA(B+48|0,B+48|0,B+96|0),m(B,B+48|0,B+96|0),mC(B+384|0),I=0|QI(B+432|0,B+384|0,B),m(A,B+432|0,B+192|0),m(A+40|0,B+432|0,A),m(A+40|0,A+40|0,B+48|0),m(A,A,B+336|0),$A(A,A,A),la(A,A),m(A+40|0,B+240|0,A+40|0),mC(A+80|0),m(A+120|0,A,A+40|0),A=0-(0|(B=0|tC(A+120|0)|1-I)|zB(A+40|0))|0):A=-1,h=g,0|A}function MA(A,I,g,B,C,t,r,Q,e,o,c,i){var _,E,n;A|=0,I|=0,g|=0,B|=0,C|=0,t|=0,r|=0,Q|=0,o|=0,c|=0,i|=0,n=h,E=h=h+63&-64,h=h+64|0,_=0|u(e|=0);do{if(_){if(a[E>>2]=_,a[E+4>>2]=e,a[E+8>>2]=B,a[E+12>>2]=C,a[E+16>>2]=t,a[E+20>>2]=r,a[E+24>>2]=0,a[E+24+4>>2]=0,a[E+24+8>>2]=0,a[E+24+12>>2]=0,a[E+40>>2]=A,a[E+44>>2]=I,a[E+48>>2]=g,a[E+52>>2]=g,a[E+56>>2]=0,0|(I=0|TA(E,i))){Lg(_,e),S(_);break}if(0|Q&&sA(0|Q,0|_,0|e),0!=(0|o)&0!=(0|c)&&0|P(o,c,E,i)){Lg(_,e),Lg(o,c),S(_),I=-31;break}Lg(_,e),S(_),I=0}else I=-22}while(0);return h=n,0|I}function JA(A,I,g,B,C,t,r,Q,e,c,i,_){return A|=0,I|=0,g|=0,B|=0,C|=0,t|=0,r|=0,Q|=0,e|=0,c|=0,c=h,h=h+336|0,DB(c,64,0,i|=0,_|=0),ca(c+64|0,c),Lg(c,64),GC(c+64|0,r,Q,e),r=0|FC(0,0,0|Q,0|e),o(),GC(c+64|0,35440,15&r,0),Ig(A,B,C,t,i,1,_),GC(c+64|0,A,C,t),i=0|FC(0,0,0|C,0|t),o(),GC(c+64|0,35440,15&i,0),tB(c+320|0,Q,e),GC(c+64|0,c+320|0,8,0),tB(c+320|0,C,t),GC(c+64|0,c+320|0,8,0),oa(c+64|0,I),Lg(c+64|0,256),0|g&&(a[g>>2]=16,a[g+4>>2]=0),h=c,0}function vA(A,I){var g,B,C=0;return B=h,g=h=h+63&-64,h=h+288|0,J(40+(A|=0)|0,I|=0),mC(A+80|0),d(g+240|0,A+40|0),m(g+192|0,g+240|0,16),OA(g+240|0,g+240|0,A+80|0),$A(g+192|0,g+192|0,A+80|0),d(g+144|0,g+192|0),m(g+144|0,g+144|0,g+192|0),d(A,g+144|0),m(A,A,g+192|0),m(A,A,g+240|0),QA(A,A),m(A,A,g+144|0),m(A,A,g+240|0),d(g+96|0,A),m(g+96|0,g+96|0,g+192|0),OA(g+48|0,g+96|0,g+240|0),0|zB(g+48|0)?C=4:($A(g,g+96|0,g+240|0),0|zB(g)?(m(A,A,64),C=4):A=-1),4==(0|C)&&((0|(C=0|tC(A)))==((0|t[I+31>>0])>>>7|0)&&lI(A,A),m(A+120|0,A,A+40|0),A=0),h=B,0|A}function NA(A,I,g){var B,C,t,r,Q,e,o,c,i,_,E,n,s,y,h,p,f,w,l;I|=0,g|=0,l=0|a[(A|=0)>>2],f=0|a[A+4>>2],h=0|a[A+8>>2],s=0|a[A+12>>2],E=0|a[A+16>>2],i=0|a[A+20>>2],o=0|a[A+24>>2],Q=0|a[A+28>>2],t=0|a[A+32>>2],B=0|a[A+36>>2],w=(a[I+4>>2]^f)&0-g,p=(a[I+8>>2]^h)&0-g,y=(a[I+12>>2]^s)&0-g,n=(a[I+16>>2]^E)&0-g,_=(a[I+20>>2]^i)&0-g,c=(a[I+24>>2]^o)&0-g,e=(a[I+28>>2]^Q)&0-g,r=(a[I+32>>2]^t)&0-g,C=(a[I+36>>2]^B)&0-g,a[A>>2]=(a[I>>2]^l)&0-g^l,a[A+4>>2]=w^f,a[A+8>>2]=p^h,a[A+12>>2]=y^s,a[A+16>>2]=n^E,a[A+20>>2]=_^i,a[A+24>>2]=c^o,a[A+28>>2]=e^Q,a[A+32>>2]=r^t,a[A+36>>2]=C^B}function RA(A){var I,g,C=0,r=0,Q=0;I=h,g=h=h+63&-64,h=h+48|0,r=A|=0,Q=(C=g)+32|0;do{B[C>>0]=0|B[r>>0],C=C+1|0,r=r+1|0}while((0|C)<(0|Q));C=t[A+36+4>>0]|t[A+36+4+1>>0]<<8|t[A+36+4+2>>0]<<16|t[A+36+4+3>>0]<<24,a[g+32>>2]=t[A+36>>0]|t[A+36+1>>0]<<8|t[A+36+2>>0]<<16|t[A+36+3>>0]<<24,a[g+32+4>>2]=C,oB(g,g,40,0,A+32|0,A),r=g,Q=(C=A)+32|0;do{B[C>>0]=0|B[r>>0],C=C+1|0,r=r+1|0}while((0|C)<(0|Q));r=0|a[g+32>>2],Q=0|a[g+32+4>>2],B[A+36>>0]=r,B[A+36+1>>0]=r>>8,B[A+36+2>>0]=r>>16,B[A+36+3>>0]=r>>24,B[A+36+4>>0]=Q,B[A+36+4+1>>0]=Q>>8,B[A+36+4+2>>0]=Q>>16,B[A+36+4+3>>0]=Q>>24,DC(A),h=I}function YA(A,I){var g,B,C,a,r;return C=h,r=h=h+63&-64,h=h+384|0,J(40+(A|=0)|0,I|=0),mC(A+80|0),d(r+336|0,A+40|0),m(r+288|0,r+336|0,16),OA(r+336|0,r+336|0,A+80|0),$A(r+288|0,r+288|0,A+80|0),d(r+240|0,r+288|0),m(r+240|0,r+240|0,r+288|0),d(A,r+240|0),m(A,A,r+288|0),m(A,A,r+336|0),QA(A,A),m(A,A,r+240|0),m(A,A,r+336|0),d(r+192|0,A),m(r+192|0,r+192|0,r+288|0),OA(r+144|0,r+192|0,r+336|0),$A(r+96|0,r+192|0,r+336|0),g=0|zB(r+144|0),B=0|zB(r+96|0),m(r,A,64),NA(A,r,1-g|0),lI(r+48|0,A),a=0|tC(A),NA(A,r+48|0,(0|t[I+31>>0])>>>7^a),m(A+120|0,A,A+40|0),h=C,(B|g)-1|0}function LA(A,I,g,B,C,a,t,r,Q,e,o){var c;A|=0,I|=0,g|=0,B|=0,C|=0,a|=0,t|=0,r|=0,Q|=0,c=h,h=h+352|0,RB(c+16|0,64,0,e|=0,o|=0),ca(c+80|0,c+16|0),Lg(c+16|0,64),GC(c+80|0,t,r,Q),tB(c+336|0,r,Q),GC(c+80|0,c+336|0,8,0),GC(c+80|0,g,B,C),tB(c+336|0,B,C),GC(c+80|0,c+336|0,8,0),oa(c+80|0,c),Lg(c+80|0,256),I=0|ba(c,a),Lg(c,16);do{if(A){if(I){tI(0|A,0,0|B),I=-1;break}Tg(A,g,B,C,e,1,0,o),I=0;break}}while(0);return h=c,0|I}function PA(A){A|=0;var I=0,g=0,C=0,t=0;A:do{g=65,I=35361;do{if((0|B[I>>0])==(255&A)<<24>>24){t=6;break A}I=I+1|0,C=0!=(0|(g=g+-1|0))}while(C&0!=(3&I|0));C?t=6:I=0}while(0);A:do{if(6==(0|t)&&(0|B[I>>0])!=(255&A)<<24>>24){C=0|r(255&A,16843009);I:do{if(g>>>0>3){do{if((-2139062144&(t=a[I>>2]^C)^-2139062144)&t+-16843009|0)break I;I=I+4|0,g=g+-4|0}while(g>>>0>3);if(!g){I=0;break A}}}while(0);for(;;){if((0|B[I>>0])==(255&A)<<24>>24)break A;if(!(g=g+-1|0)){I=0;break}I=I+1|0}}}while(0);return 0|I}function KA(A,I){A|=0,I|=0;var g=0,C=0,a=0,r=0,Q=0;g=0;do{B[A+g>>0]=(0|t[I+(g>>>3)>>0])>>>(7&g)&1,g=g+1|0}while(256!=(0|g));Q=0;do{a=A+Q|0;A:do{if(0|B[a>>0]){r=1;do{if((g=r+Q|0)>>>0>=256)break A;I=0|B[A+g>>0];I:do{if(I<<24>>24){if(((C=I<<24>>24<<r)+(I=0|B[a>>0])|0)<16){B[a>>0]=C+I,B[A+g>>0]=0;break}if((I-C|0)<-15)break A;for(B[a>>0]=I-C;0|B[(I=A+g|0)>>0];)if(B[I>>0]=0,(g=g+1|0)>>>0>=256)break I;B[I>>0]=1}}while(0);r=r+1|0}while(r>>>0<7)}}while(0);Q=Q+1|0}while(256!=(0|Q))}function qA(A,I,g,B,C,t,r){var Q,e;A|=0,I|=0,g|=0,B|=0,C|=0,t|=0,Q=h,e=h=h+63&-64,h=h+560|0,dC(e+192|0,r|=0),Xg(e+128|0,t,32,0),q(e+192|0,e+128+32|0,32,0),q(e+192|0,g,B,C),fB(e+192|0,e+64|0),Rg(A+32|0,t+32|0,32),D(e+64|0),DA(e+400|0,e+64|0),yg(A,e+400|0),dC(e+192|0,r),q(e+192|0,A,64,0),q(e+192|0,g,B,C),fB(e+192|0,e),D(e),WC(e+128|0),f(A+32|0,e,e+128|0,e+64|0),Lg(e+128|0,64),Lg(e+64|0,64),0|I&&(a[I>>2]=64,a[I+4>>2]=0),h=Q}function XA(A,I,g,B,C,t){A|=0,I|=0,g|=0,B|=0,C|=0,t|=0;var Q=0;do{if(I){if(Q=(0|a[A+24>>2])-(0|a[A+20>>2])|0,t){Q=B+-1+Q|0;break}Q=Q+((0==(0|B))<<31>>31)|0;break}if(!(g<<24>>24)){Q=B+-1|0;break}if(Q=0|r(0|a[A+20>>2],255&g),t){Q=B+-1+Q|0;break}Q=Q+((0==(0|B))<<31>>31)|0;break}while(0);return NB(0|C,0,0|C,0),NB(0|o(),0,0|Q,0),t=0|FC(Q+-1|0,0,0|o(),0),C=0|o(),0==(0|I)|g<<24>>24==3?(Q=0,B=0):(Q=0|r(0|a[A+20>>2],1+(255&g)|0),B=0),A=0|GB(0|(I=0|bC(0|t,0|C,0|Q,0|B)),0|(g=0|o()),0|a[A+24>>2],0),o(),0|A}function jA(A,I,g,B,C){B|=0,C|=0;var t,r,Q,e=0;if(Q=h,r=h=h+63&-64,h=h+64|0,(g|=0)>>>0>0|0==(0|g)&(I|=0)>>>0>4294967295|(t=0|MI(A|=0))>>>0>127)a[8886]=28,g=-1;else{e=(g=r)+60|0;do{a[g>>2]=0,g=g+4|0}while((0|g)<(0|e));(e=0|function(A){var I;return(I=0|u(A|=0))&&3&a[I+-4>>2]?(tI(0|I,0,0|A),0|I):0|I}(t))?(a[r+16>>2]=e,a[r+8>>2]=e,a[r>>2]=e,a[r+20>>2]=t,a[r+12>>2]=t,a[r+4>>2]=t,a[r+24>>2]=0,a[r+24+4>>2]=0,a[r+24+8>>2]=0,a[r+24+12>>2]=0,0|V(r,A,C)?(a[8886]=28,g=-1):g=(0|a[r+40>>2])==(0|I)?(0|a[r+44>>2])!=(B>>>10|0)&1:1,S(e)):g=-1}return h=Q,0|g}function TA(A,I){I|=0;var g,B,C=0,t=0,Q=0;if(B=h,g=h=h+63&-64,h=h+48|0,!(C=0|kA(A|=0)))if((I+-1|0)>>>0<=1){if(t=0|a[A+44>>2],C=0|a[A+48>>2],Q=0|r(t=((t>>>0<C<<3>>>0?C<<3:t)>>>0)/(C<<2>>>0)|0,C<<2),a[g>>2]=0,a[g+8>>2]=a[A+40>>2],a[g+12>>2]=-1,a[g+16>>2]=Q,a[g+20>>2]=t,a[g+24>>2]=t<<2,a[g+28>>2]=C,a[g+32>>2]=a[A+52>>2],a[g+36>>2]=I,!(C=0|function(A,I){A|=0,I|=0;var g,B,C=0;B=h,g=h=h+63&-64,h=h+80|0;do{if(0==(0|A)|0==(0|I))C=-25;else{if(C=0|u(a[A+20>>2]<<3),a[A+4>>2]=C,C){if(C=0|nI(A,0|a[A+16>>2])){_C(A,0|a[I+56>>2]);break}O(g,I,0|a[A+36>>2]),Lg(g+64|0,8),DI(g,A),Lg(g,72),C=0;break}C=-22}}while(0);return h=B,0|C}(g,A))){if(0|a[g+8>>2]){C=0;do{iI(g,C),C=C+1|0}while(C>>>0<(0|a[g+8>>2])>>>0)}!function(A,I){var g,B,C=0,t=0;if(g=h,B=h=h+63&-64,h=h+2048|0,0!=(0|(A|=0))&0!=(0|(I|=0))){if(da(B+1024|0,(0|a[4+(0|a[I>>2])>>2])+(a[I+24>>2]<<10)-1024|0),(0|a[I+28>>2])>>>0>1){C=1;do{t=(t=0|a[I+24>>2])-1+(0|r(t,C))|0,Pg(B+1024|0,(0|a[4+(0|a[I>>2])>>2])+(t<<10)|0),C=C+1|0}while(C>>>0<(0|a[I+28>>2])>>>0)}!function(A,I){A|=0,I|=0;var g=0,B=0;g=0;do{tB(A+(g<<3)|0,0|a[(B=I+(g<<3)|0)>>2],0|a[B+4>>2]),g=g+1|0}while(128!=(0|g))}(B,B+1024|0),AA(0|a[A>>2],0|a[A+4>>2],B,1024),Lg(B+1024|0,1024),Lg(B,1024),_C(I,0|a[A+56>>2])}h=g}(A,g),C=0}}else C=-26;return h=B,0|C}function VA(A,I,g,B,C,a){var t,r;return I|=0,g|=0,B|=0,C|=0,a|=0,r=h,t=h=h+63&-64,h=h+592|0,0!=(0|mg(32+(A|=0)|0))&&0==(0|gI(A))&&0!=(0|uB(C))&&0==(0|gI(C))&&0==(0|vA(t+424|0,C))?(dC(t+96|0,a),q(t+96|0,A,32,0),q(t+96|0,C,32,0),q(t+96|0,I,g,B),fB(t+96|0,t+32|0),D(t+32|0),X(t+304|0,t+32|0,t+424|0,A+32|0),yg(t,t+304|0),g=0|ka(t,A),g=0|((0|t)==(0|A)?-1:g)|XI(A,t,32)):g=-1,h=r,0|g}function WA(A,I,g,C,t){A|=0,I|=0,g|=0,t|=0;var r,Q,e,c=0,i=0,_=0,E=0,n=0;return e=h,Q=h=h+63&-64,h=h+48|0,(r=0|Dg(C|=0,Q+40|0,Q+36|0,Q+32|0))?(_=0|$B(1,0,0|a[Q+40>>2]),E=0|o(),!((45+(c=(i=(c=0|function(A){return 0|$g(A|=0,1+(0|MI(A))|0)}(r))?c-r|0:0|MI(r))+(r-C)|0)|0)>>>0>102|(c+45|0)>>>0<i>>>0||0!=(0|eA(A,I,g,r,i,_,E,0|a[Q+36>>2],0|a[Q+32>>2],Q,32)))&&(sA(0|t,0|C,0|c),B[t+c>>0]=36,n=0|OI(t+c+1|0,t+102-(t+c+1)|0,Q),Lg(Q,32),0!=(0|n)&n>>>0<(t+102|0)>>>0)?B[n>>0]=0:t=0):t=0,h=e,0|t}function zA(A,I,g){A|=0,I|=0,g|=0;var C,t,r=0,Q=0;C=h,t=h=h+63&-64,h=h+128|0,a[(Q=t+64+32|0)>>2]=0,a[Q+4>>2]=0,a[Q+8>>2]=0,a[Q+12>>2]=0,a[Q+16>>2]=0,a[Q+20>>2]=0,a[Q+24>>2]=0,a[Q+28>>2]=0,r=32+(Q=t+64|0)|0;do{B[Q>>0]=0|B[I>>0],Q=Q+1|0,I=I+1|0}while((0|Q)<(0|r));a[t+32>>2]=0,a[t+32+4>>2]=0,a[t+32+8>>2]=0,a[t+32+12>>2]=0,a[t+32+16>>2]=0,a[t+32+20>>2]=0,a[t+32+24>>2]=0,a[t+32+28>>2]=0,I=g,r=(Q=t)+32|0;do{B[Q>>0]=0|B[I>>0],Q=Q+1|0,I=I+1|0}while((0|Q)<(0|r));iB(t+64|0,t),WI(A,t+64|0),h=C}function ZA(A,I){A|=0,I|=0;var g=0,C=0;A:do{if(255&I){if(3&A)do{if((C=0|B[A>>0])<<24>>24==0||C<<24>>24==(255&I)<<24>>24)break A;A=A+1|0}while(0!=(3&A|0));C=0|r(255&I,16843009),g=0|a[A>>2];I:do{if(!((-2139062144&g^-2139062144)&g+-16843009))do{if((-2139062144&(g^=C)^-2139062144)&g+-16843009|0)break I;g=0|a[(A=A+4|0)>>2]}while(!((-2139062144&g^-2139062144)&g+-16843009|0))}while(0);for(;(C=0|B[A>>0])<<24>>24!=0&&C<<24>>24!=(255&I)<<24>>24;)A=A+1|0}else A=A+(0|MI(A))|0}while(0);return 0|A}function OA(A,I,g){var B,C,t,r,Q,e,o,c,i;A|=0,g|=0,i=(0|a[4+(I|=0)>>2])-(0|a[g+4>>2])|0,c=(0|a[I+8>>2])-(0|a[g+8>>2])|0,o=(0|a[I+12>>2])-(0|a[g+12>>2])|0,e=(0|a[I+16>>2])-(0|a[g+16>>2])|0,Q=(0|a[I+20>>2])-(0|a[g+20>>2])|0,r=(0|a[I+24>>2])-(0|a[g+24>>2])|0,t=(0|a[I+28>>2])-(0|a[g+28>>2])|0,C=(0|a[I+32>>2])-(0|a[g+32>>2])|0,B=(0|a[I+36>>2])-(0|a[g+36>>2])|0,a[A>>2]=(0|a[I>>2])-(0|a[g>>2]),a[A+4>>2]=i,a[A+8>>2]=c,a[A+12>>2]=o,a[A+16>>2]=e,a[A+20>>2]=Q,a[A+24>>2]=r,a[A+28>>2]=t,a[A+32>>2]=C,a[A+36>>2]=B}function $A(A,I,g){var B,C,t,r,Q,e,o,c,i;A|=0,I|=0,i=(0|a[4+(g|=0)>>2])+(0|a[I+4>>2])|0,c=(0|a[g+8>>2])+(0|a[I+8>>2])|0,o=(0|a[g+12>>2])+(0|a[I+12>>2])|0,e=(0|a[g+16>>2])+(0|a[I+16>>2])|0,Q=(0|a[g+20>>2])+(0|a[I+20>>2])|0,r=(0|a[g+24>>2])+(0|a[I+24>>2])|0,t=(0|a[g+28>>2])+(0|a[I+28>>2])|0,C=(0|a[g+32>>2])+(0|a[I+32>>2])|0,B=(0|a[g+36>>2])+(0|a[I+36>>2])|0,a[A>>2]=(0|a[g>>2])+(0|a[I>>2]),a[A+4>>2]=i,a[A+8>>2]=c,a[A+12>>2]=o,a[A+16>>2]=e,a[A+20>>2]=Q,a[A+24>>2]=r,a[A+28>>2]=t,a[A+32>>2]=C,a[A+36>>2]=B}function AI(A,I){A|=0;var g,C,r,Q=0;C=h,r=h=h+63&-64,h=h+160|0,g=0|B[(I|=0)>>0],Q=0;do{B[r+128+Q>>0]=0|B[I+(63-Q)>>0],B[r+96+Q>>0]=0|B[I+(31-Q)>>0],Q=Q+1|0}while(32!=(0|Q));B[r+128+31>>0]=127&B[r+128+31>>0],B[r+96+31>>0]=127&B[r+96+31>>0],J(r+48|0,r+128|0),J(r,r+96|0),a[r+48>>2]=(0-((0|t[I+32>>0])>>>7)&19)+(0|a[r+48>>2])+(38*(0|a[r>>2])|0),I=1;do{a[(Q=r+48+(I<<2)|0)>>2]=(0|a[Q>>2])+(38*(0|a[r+(I<<2)>>2])|0),I=I+1|0}while(10!=(0|I));mA(r+48|0,r+48|0),yA(A,r+48|0,-128&g),h=C}function II(A,I,g,B,C,t,r,Q,e,o,c,i){return A|=0,I|=0,g|=0,B|=0,C|=0,t|=0,r|=0,Q|=0,e|=0,o|=0,o=h,h=h+336|0,RB(o,64,0,c|=0,i|=0),ca(o+64|0,o),Lg(o,64),GC(o+64|0,r,Q,e),tB(o+320|0,Q,e),GC(o+64|0,o+320|0,8,0),Tg(A,B,C,t,c,1,0,i),GC(o+64|0,A,C,t),tB(o+320|0,C,t),GC(o+64|0,o+320|0,8,0),oa(o+64|0,I),Lg(o+64|0,256),0|g&&(a[g>>2]=16,a[g+4>>2]=0),h=o,0}function gI(A){A|=0;var I,g,C=0,a=0,r=0,Q=0;I=h,g=h=h+63&-64,h=h+16|0,B[g>>0]=0,B[g+1>>0]=0,B[g+2>>0]=0,B[g+3>>0]=0,B[g+4>>0]=0,B[g+5>>0]=0,B[g+6>>0]=0,r=0;do{C=0|B[A+r>>0],a=0;do{B[(Q=g+a|0)>>0]=B[Q>>0]|B[32096+(a<<5)+r>>0]^C,a=a+1|0}while(7!=(0|a));r=r+1|0}while(31!=(0|r));C=127&B[A+31>>0],a=0;do{B[(Q=g+a|0)>>0]=B[Q>>0]|C^B[32096+(a<<5)+31>>0],a=a+1|0}while(7!=(0|a));C=0,a=0;do{a=(0|t[g+C>>0])-1|a,C=C+1|0}while(7!=(0|C));return h=I,a>>>8&1|0}function BI(A,I,g){var B,C,a;A|=0,I|=0,B=h,a=h=h+63&-64,h=h+160|0,g=((g|=0)<<24>>24)-((0-(255&(C=0|Pa(g)))&g<<24>>24)<<1)&255,function(A){mC(A|=0),mC(A+40|0),mC(A+80|0),jC(A+120|0)}(A),HB(A,I,0|Da(g,1)),HB(A,I+160|0,0|Da(g,2)),HB(A,I+320|0,0|Da(g,3)),HB(A,I+480|0,0|Da(g,4)),HB(A,I+640|0,0|Da(g,5)),HB(A,I+800|0,0|Da(g,6)),HB(A,I+960|0,0|Da(g,7)),HB(A,I+1120|0,0|Da(g,8)),UI(a,A+40|0),UI(a+40|0,A),UI(a+80|0,A+80|0),lI(a+120|0,A+120|0),HB(A,a,C),h=B}function CI(A,I,g,B,C,t,r,Q,e,o,c){g|=0,B|=0,C|=0,t|=0,r|=0,Q|=0,e|=0,o|=0,c|=0,tI(0|(A|=0),0,0|(I|=0));do{if(!(g>>>0>0|0==(0|g)&I>>>0>4294967295)){if(g>>>0<0|0==(0|g)&I>>>0<16){a[8886]=28,I=-1;break}if((e|t)>>>0>0|0==(e|t|0)&(Q|C)>>>0>4294967295|o>>>0>2147483648){a[8886]=22,I=-1;break}if(e>>>0<0|0==(0|e)&Q>>>0<3|o>>>0<8192){a[8886]=28,I=-1;break}if(1==(0|c)){I=(0!=(0|oC(Q,o>>>10,B,C,r,A,I)))<<31>>31;break}a[8886]=28,I=-1;break}a[8886]=22,I=-1}while(0);return 0|I}function aI(A,I,g,C){var t,r;A|=0,g|=0,C|=0,t=h,r=h=h+63&-64,h=h+64|0,((I|=0)-1&255)>63&&st(),B[r>>0]=I,B[r+1>>0]=0,B[r+2>>0]=1,B[r+3>>0]=1,Ca(r+4|0),tB(r+8|0,0,0),a[r+16>>2]=0,a[r+16+4>>2]=0,a[r+16+8>>2]=0,a[r+16+12>>2]=0,g?WB(r,g):(a[r+32>>2]=0,a[r+32+4>>2]=0,a[r+32+8>>2]=0,a[r+32+12>>2]=0),C?jB(r,C):(a[r+48>>2]=0,a[r+48+4>>2]=0,a[r+48+8>>2]=0,a[r+48+12>>2]=0),mI(A,r),h=t}function tI(A,I,g){I|=0;var C,t=0;if(C=(A|=0)+(g|=0)|0,I&=255,(0|g)>=67){for(;3&A;)B[A>>0]=I,A=A+1|0;for(t=I|I<<8|I<<16|I<<24;(0|A)<=((-4&C)-64|0);)a[A>>2]=t,a[A+4>>2]=t,a[A+8>>2]=t,a[A+12>>2]=t,a[A+16>>2]=t,a[A+20>>2]=t,a[A+24>>2]=t,a[A+28>>2]=t,a[A+32>>2]=t,a[A+36>>2]=t,a[A+40>>2]=t,a[A+44>>2]=t,a[A+48>>2]=t,a[A+52>>2]=t,a[A+56>>2]=t,a[A+60>>2]=t,A=A+64|0;for(;(0|A)<(-4&C|0);)a[A>>2]=t,A=A+4|0}for(;(0|A)<(0|C);)B[A>>0]=I,A=A+1|0;return C-g|0}function rI(A,I,g,B,C,t,r,Q,e,o,c){g|=0,B|=0,C|=0,t|=0,r|=0,Q|=0,e|=0,o|=0,c|=0,tI(0|(A|=0),0,0|(I|=0));do{if(!(g>>>0>0|0==(0|g)&I>>>0>4294967295)){if(g>>>0<0|0==(0|g)&I>>>0<16){a[8886]=28,I=-1;break}if((e|t)>>>0>0|0==(e|t|0)&(Q|C)>>>0>4294967295|o>>>0>2147483648){a[8886]=22,I=-1;break}if(0==(0|Q)&0==(0|e)|o>>>0<8192){a[8886]=28,I=-1;break}if(2==(0|c)){I=(0!=(0|eC(Q,o>>>10,B,C,r,A,I)))<<31>>31;break}a[8886]=28,I=-1;break}a[8886]=22,I=-1}while(0);return 0|I}function QI(A,I,g){var B,C,a;return A|=0,I|=0,B=h,a=h=h+63&-64,h=h+288|0,d(a+240|0,g|=0),m(a+240|0,a+240|0,g),d(A,a+240|0),m(A,A,g),m(A,A,I),QA(A,A),m(A,A,a+240|0),m(A,A,I),d(a+192|0,A),m(a+192|0,a+192|0,g),OA(a+144|0,a+192|0,I),$A(a+96|0,a+192|0,I),m(a+48|0,I,64),$A(a+48|0,a+192|0,a+48|0),g=0|zB(a+144|0),I=0|zB(a+96|0),C=0|zB(a+48|0),m(a,A,64),NA(A,a,C|I),la(A,A),h=B,I|g|0}function eI(A,I){A|=0;var g=0;g=67108863&(0|ga(I|=0)),a[A>>2]=g,g=(0|ga(I+3|0))>>>2&67108611,a[A+4>>2]=g,g=(0|ga(I+6|0))>>>4&67092735,a[A+8>>2]=g,g=(0|ga(I+9|0))>>>6&66076671,a[A+12>>2]=g,g=(0|ga(I+12|0))>>>8&1048575,a[A+16>>2]=g,a[A+20>>2]=0,a[A+20+4>>2]=0,a[A+20+8>>2]=0,a[A+20+12>>2]=0,a[A+20+16>>2]=0,g=0|ga(I+16|0),a[A+40>>2]=g,g=0|ga(I+20|0),a[A+44>>2]=g,g=0|ga(I+24|0),a[A+48>>2]=g,I=0|ga(I+28|0),a[A+52>>2]=I,a[A+56>>2]=0,a[A+56+4>>2]=0,B[A+80>>0]=0}function oI(A,I,g,B,C,t){A|=0,I|=0,g|=0,B|=0,C|=0,t|=0;var r=0,Q=0,e=0;do{if(C>>>0<0|0==(0|C)&B>>>0<64||(r=0|bC(0|B,0|C,-64,-1),(Q=0|o())>>>0>0|0==(0|Q)&r>>>0>4294967231))e=10;else{if(0|wC(g,g+64|0,r,Q,t)){if(!A){e=10;break}tI(0|A,0,0|r),e=10;break}0|I&&(a[I>>2]=r,a[I+4>>2]=Q),A?(Rg(0|A,g+64|0,0|r),B=0):B=0}}while(0);return 10==(0|e)&&(I?(a[I>>2]=0,a[I+4>>2]=0,B=-1):B=-1),0|B}function cI(A,I,g,C){var a,t;if(A|=0,I|=0,C|=0,t=h,a=h=h+63&-64,h=h+320|0,0!=(0|uB(g|=0))&&0==(0|gI(g))&&0==(0|YA(a,g))&&0!=(0|qB(a))){g=0;do{B[A+g>>0]=0|B[I+g>>0],g=g+1|0}while(32!=(0|g));0|C&&TC(A),B[A+31>>0]=127&B[A+31>>0],W(a+160|0,A,a),yg(A,a+160|0),g=0|mB(A)?-1:(0!=(0|Hg(I,32)))<<31>>31}else g=-1;return h=t,0|g}function iI(A,I){I|=0;var g,C,t=0,r=0;if(g=h,C=h=h+63&-64,h=h+32|0,0|(A|=0)&&0|(t=0|a[A+28>>2])){a[C>>2]=I,r=0;do{if(B[C+8>>0]=r,t){I=0;do{a[C+4>>2]=I,a[C+12>>2]=0,a[C+16>>2]=a[C>>2],a[C+16+4>>2]=a[C+4>>2],a[C+16+8>>2]=a[C+8>>2],a[C+16+12>>2]=a[C+12>>2],$(A,C+16|0),I=I+1|0,t=0|a[A+28>>2]}while(I>>>0<t>>>0)}else t=0;r=r+1|0}while(4!=(0|r))}h=g}function _I(A,I,g,C){A|=0,g|=0,C|=0;var t,r,Q=0;if(t=h,r=h=h+63&-64,h=h+192|0,((I|=0)-1&255)>63&&st(),!((C+-1&255)>63|0==(0|g))){B[r+128>>0]=I,B[r+128+1>>0]=C,B[r+128+2>>0]=1,B[r+128+3>>0]=1,Ca(r+128+4|0),tB(r+128+8|0,0,0),Q=48+(I=r+128+16|0)|0;do{a[I>>2]=0,I=I+4|0}while((0|I)<(0|Q));return mI(A,r+128|0),tI(r+(255&C)|0,0,128-(255&C)|0),sA(0|r,0|g,255&C|0),oA(A,r,128,0),Lg(r,128),void(h=t)}st()}function EI(A,I,g,B,C,r){var Q,e,o;return A|=0,I|=0,g|=0,B|=0,r|=0,e=h,Q=h=h+63&-64,h=h+32|0,o=t[4+(C|=0)>>0]|t[C+4+1>>0]<<8|t[C+4+2>>0]<<16|t[C+4+3>>0]<<24,a[Q+16>>2]=t[C>>0]|t[C+1>>0]<<8|t[C+2>>0]<<16|t[C+3>>0]<<24,a[Q+16+4>>2]=o,a[Q+16+8>>2]=0,a[Q+16+8+4>>2]=0,tB(Q,g,B),a[Q+8>>2]=0,a[Q+8+4>>2]=0,(I+-16|0)>>>0>48?(a[8886]=28,g=-1):g=0|Yg(A,I,0,0,0,r,32,Q,Q+16|0),h=e,0|g}function nI(A,I){A|=0,I|=0;var g,B,C=0;B=h,g=h=h+63&-64,h=h+16|0;do{if(0!=(0|A)&&0!=(0|I)&&1024==(0|(I<<10>>>0)/(I>>>0))&&(C=0|u(12),a[A>>2]=C,0!=(0|C))){if(a[C+4>>2]=0,a[C>>2]=0,C=0|BC(g,I<<10),a[8886]=C,C)a[g>>2]=0;else if(0|(C=0|a[g>>2])){a[a[A>>2]>>2]=C,a[4+(0|a[A>>2])>>2]=C,a[8+(0|a[A>>2])>>2]=I<<10,C=0;break}S(0|a[A>>2]),a[A>>2]=0,C=-22}else C=-22}while(0);return h=B,0|C}function sI(A,I,g,B,C,r,Q,e,c,i,_){var E;return A|=0,I|=0,g|=0,B|=0,C|=0,r|=0,Q|=0,e|=0,c|=0,i|=0,_|=0,E=h,h=h+48|0,a[E+32>>2]=0,K(E,i,_,0),I=t[i+16+4>>0]|t[i+16+4+1>>0]<<8|t[i+16+4+2>>0]<<16|t[i+16+4+3>>0]<<24,a[E+32+4>>2]=t[i+16>>0]|t[i+16+1>>0]<<8|t[i+16+2>>0]<<16|t[i+16+3>>0]<<24,a[E+32+4+4>>2]=I,I=0|function(A,I,g,B,C,a,t,r,Q,e){var c;A|=0,I|=0,g|=0,B|=0,C|=0,a|=0,t|=0,r|=0,c=h,h=h+352|0,FB(c+16|0,64,0,Q|=0,e|=0),ca(c+80|0,c+16|0),Lg(c+16|0,64),GC(c+80|0,a,t,r),a=0|FC(0,0,0|t,0|r),o(),GC(c+80|0,35456,15&a,0),GC(c+80|0,I,g,B),a=0|FC(0,0,0|g,0|B),o(),GC(c+80|0,35456,15&a,0),tB(c+336|0,t,r),GC(c+80|0,c+336|0,8,0),tB(c+336|0,g,B),GC(c+80|0,c+336|0,8,0),oa(c+80|0,c),Lg(c+80|0,256),t=0|ba(c,C),Lg(c,16);do{if(A){if(t){tI(0|A,0,0|g),t=-1;break}Zg(A,I,g,B,Q,1,e),t=0;break}}while(0);return h=c,0|t}(A,g,B,C,r,Q,e,c,E+32|0,E),Lg(E,32),h=E,0|I}function yI(A,I,g,B,C,r,Q,e,c,i,_,E){return A|=0,I|=0,g|=0,B|=0,C|=0,r|=0,Q|=0,e|=0,c|=0,i|=0,_|=0,E|=0,i=h,h=h+48|0,a[i+32>>2]=0,K(i,_,E,0),E=t[_+16+4>>0]|t[_+16+4+1>>0]<<8|t[_+16+4+2>>0]<<16|t[_+16+4+3>>0]<<24,a[i+32+4>>2]=t[_+16>>0]|t[_+16+1>>0]<<8|t[_+16+2>>0]<<16|t[_+16+3>>0]<<24,a[i+32+4+4>>2]=E,function(A,I,g,B,C,t,r,Q,e,c,i){var _;A|=0,I|=0,g|=0,B|=0,C|=0,t|=0,r|=0,Q|=0,e|=0,_=h,h=h+336|0,FB(_,64,0,c|=0,i|=0),ca(_+64|0,_),Lg(_,64),GC(_+64|0,r,Q,e),r=0|FC(0,0,0|Q,0|e),o(),GC(_+64|0,35456,15&r,0),Zg(A,B,C,t,c,1,i),GC(_+64|0,A,C,t),c=0|FC(0,0,0|C,0|t),o(),GC(_+64|0,35456,15&c,0),tB(_+320|0,Q,e),GC(_+64|0,_+320|0,8,0),tB(_+320|0,C,t),GC(_+64|0,_+320|0,8,0),oa(_+64|0,I),Lg(_+64|0,256),0|g&&(a[g>>2]=16,a[g+4>>2]=0),h=_}(A,I,g,B,C,r,Q,e,c,i+32|0,i),Lg(i,32),h=i,0}function hI(A,I,g,C,t,r,Q){I|=0,g|=0,C|=0,t|=0,r|=0,Q|=0;var e,o,c,i=0;c=h,e=h=h+63&-64,h=h+16|0,o=128+(i=A|=0)|0;do{B[i>>0]=0,i=i+1|0}while((0|i)<(0|o));do{if(!((r|C)>>>0>0|0==(r|C|0)&(t|g)>>>0>4294967295|Q>>>0>2147483648)){if(r>>>0<0|0==(0|r)&t>>>0<3|Q>>>0<8192){a[8886]=28,g=-1;break}vB(e,16),g=(0!=(0|pC(t,Q>>>10,I,g,e,A)))<<31>>31;break}a[8886]=22,g=-1}while(0);return h=c,0|g}function pI(A,I,g,C,t){A|=0,I|=0,g|=0,C|=0,t|=0;var r=0,Q=0;A:do{if(t){for(Q=0|a[g>>2];;){if(Q>>>0>=I>>>0){r=4;break}if((r=0|B[A+Q>>0])<<24>>24!=61){if(!C){r=9;break}if(!(0|zC(C,r<<24>>24))){r=9;break}}else t=t+-1|0;if(Q=Q+1|0,a[g>>2]=Q,!t){t=0;break A}}if(4==(0|r)){a[8886]=68,t=-1;break}if(9==(0|r)){a[8886]=28,t=-1;break}}else t=0}while(0);return 0|t}function fI(A,I,g,B,C,a){var t,r;if(g|=0,B|=0,C|=0,a|=0,t=h,r=h=h+63&-64,h=h+464|0,HA(r+240|0,A|=0,I|=0),NC(r+240|0,g,B,0),0|a){A=0,I=0;do{SC(r+448|0,A=A+1|0),sA(r+32|0,r+240|0,208),NC(r+32|0,r+448|0,4,0),aB(r+32|0,r),sA(C+I|0,0|r,0|((B=a-I|0)>>>0<32?B:32)),I=A<<5}while(I>>>0<a>>>0)}Lg(r+240|0,208),h=t}function wI(A,I,g,C,t,r,Q){I|=0,g|=0,C|=0,t|=0,r|=0,Q|=0;var e,o,c,i=0;c=h,e=h=h+63&-64,h=h+16|0,o=128+(i=A|=0)|0;do{B[i>>0]=0,i=i+1|0}while((0|i)<(0|o));do{if(!((r|C)>>>0>0|0==(r|C|0)&(t|g)>>>0>4294967295|Q>>>0>2147483648)){if(0==(0|t)&0==(0|r)|Q>>>0<8192){a[8886]=28,g=-1;break}vB(e,16),g=(0!=(0|hC(t,Q>>>10,I,g,e,A)))<<31>>31;break}a[8886]=22,g=-1}while(0);return h=c,0|g}function lI(A,I){var g,B,C,t,r,Q,e,o,c;A|=0,c=0-(0|a[4+(I|=0)>>2])|0,o=0-(0|a[I+8>>2])|0,e=0-(0|a[I+12>>2])|0,Q=0-(0|a[I+16>>2])|0,r=0-(0|a[I+20>>2])|0,t=0-(0|a[I+24>>2])|0,C=0-(0|a[I+28>>2])|0,B=0-(0|a[I+32>>2])|0,g=0-(0|a[I+36>>2])|0,a[A>>2]=0-(0|a[I>>2]),a[A+4>>2]=c,a[A+8>>2]=o,a[A+12>>2]=e,a[A+16>>2]=Q,a[A+20>>2]=r,a[A+24>>2]=t,a[A+28>>2]=C,a[A+32>>2]=B,a[A+36>>2]=g}function uI(A,I){I|=0;var g,B=0,C=0;if(g=0|CC(0|(C=0|a[32+(A|=0)>>2]),0|(B=0|a[A+32+4>>2]),3),o(),(63&g)>>>0<56)56-(63&g)|0&&sA(A+40+(63&g)|0,32848,56-(63&g)|0);else{64-(63&g)|0&&sA(A+40+(63&g)|0,32848,64-(63&g)|0),H(A,A+40|0,I,I+256|0),C=56+(B=A+40|0)|0;do{a[B>>2]=0,B=B+4|0}while((0|B)<(0|C));C=0|a[A+32>>2],B=0|a[A+32+4>>2]}vI(A+96|0,C,B),H(A,A+40|0,I,I+256|0)}function DI(A,I){A|=0;var g,B,C=0;if(g=h,B=h=h+63&-64,h=h+1024|0,0|a[28+(I|=0)>>2]){C=0;do{UC(A+64|0,0),UC(A+68|0,C),AA(B,1024,A,72),rB((0|a[4+(0|a[I>>2])>>2])+((0|r(0|a[I+24>>2],C))<<10)|0,B),UC(A+64|0,1),AA(B,1024,A,72),rB((0|a[4+(0|a[I>>2])>>2])+(1+(0|r(0|a[I+24>>2],C))<<10)|0,B),C=C+1|0}while(C>>>0<(0|a[I+28>>2])>>>0)}Lg(B,1024),h=g}function mI(A,I){I|=0;var g=0,C=0,a=0,r=0;!function(A){var I,g=0,C=0;C=32912,I=64+(g=A|=0)|0;do{B[g>>0]=0|B[C>>0],g=g+1|0,C=C+1|0}while((0|g)<(0|I));tI(A+64|0,0,293)}(A|=0),g=0;do{r=0|wB(I+(g<<3)|0),a=0|o(),r=(t[(C=A+(g<<3)|0)>>0]|t[C+1>>0]<<8|t[C+2>>0]<<16|t[C+3>>0]<<24)^r,a=(t[C+4>>0]|t[C+4+1>>0]<<8|t[C+4+2>>0]<<16|t[C+4+3>>0]<<24)^a,B[C>>0]=r,B[C+1>>0]=r>>8,B[C+2>>0]=r>>16,B[C+3>>0]=r>>24,B[C+4>>0]=a,B[C+4+1>>0]=a>>8,B[C+4+2>>0]=a>>16,B[C+4+3>>0]=a>>24,g=g+1|0}while(8!=(0|g))}function FI(A){var I,g,B,C,a,r,Q=0;return a=0|t[7+(A|=0)>>0],r=0|$B(0|t[A+6>>0],0,8),Q=0|o(),C=0|$B(0|t[A+5>>0],0,16),Q=0|Q|o(),B=0|$B(0|t[A+4>>0],0,24),Q=0|(Q=0|Q|o())|t[A+3>>0],g=0|$B(0|t[A+2>>0],0,40),Q=0|Q|o(),I=0|$B(0|t[A+1>>0],0,48),Q=0|Q|o(),A=0|$B(0|t[A>>0],0,56),e(0|Q|o()|0),r|a|C|B|g|I|A|0}function kI(A,I,g,B,C,t){I|=0,C|=0,t|=0;var r,Q=0;return r=h,Q=h=h+63&-64,h=h+16|0,Rg(64+(A|=0)|0,0|(g|=0),0|(B|=0)),sC(A,Q,A+64|0,B,C,t),64==(0|a[Q>>2])&0==(0|a[Q+4>>2])?0|I?(Q=0|bC(0|B,0|C,64,0),B=0|o(),a[I>>2]=Q,a[I+4>>2]=B,B=0):B=0:(0|I&&(a[I>>2]=0,a[I+4>>2]=0),tI(0|A,0,B+64|0),B=-1),h=r,0|B}function bI(A,I,g,C,a){I|=0,g|=0,C|=0,a|=0;var t=0,r=0,Q=0,e=0,c=0;return(A|=0)>>>0<=63&&(e=0|NB(0|g,0,0|I,0),!((c=0|o())>>>0>0|0==(0|c)&e>>>0>1073741823))&&(B[a>>0]=36,B[a+1>>0]=55,B[a+2>>0]=36,B[a+3>>0]=0|B[35361+A>>0],0!=(0|(t=0|eg(a+4|0,54,I,30))))&&0!=(0|(r=0|eg(t,a+58-t|0,g,30)))&&0!=(0|(Q=0|OI(r,a+58-r|0,C)))&Q>>>0<(a+58|0)>>>0?B[Q>>0]=0:a=0,0|a}function dI(A,I){I|=0;var g,C=0,t=0,r=0,Q=0;g=0|B[(A|=0)>>0];A:do{if((g+-48&255)<=9){for(t=g,r=0,Q=A;;){if(!(r>>>0<429496730&((t=(t<<24>>24)-48|0)>>>0>~(C=10*r|0)>>>0^1))){C=0;break A}if(r=(t>>>0>~C>>>0?0:t)+C|0,((t=0|B[(C=Q+1|0)>>0])-48&255)>9)break;Q=C}(0|C)!=(0|A)&&(0|Q)==(0|A)|g<<24>>24!=48?a[I>>2]=r:C=0}else C=0}while(0);return 0|C}function HI(A,I,g,C,a,t){var r,Q;if(A|=0,I|=0,a|=0,t|=0,Q=h,r=h=h+63&-64,h=h+32|0,(C|=0)>>>0<0|0==(0|C)&(g|=0)>>>0<32||(xg(r,32,0,a,t),0!=(0|lC(I+16|0,I+32|0,0|bC(0|g,0|C,-32,-1),0|o(),r))))A=-1;else{nC(A,I,g,C,a,t),g=A+32|0;do{B[A>>0]=0,A=A+1|0}while((0|A)<(0|g));A=0}return h=Q,0|A}function GI(A){return((0-((0-(95^(A|=0))|0)>>>8&63^63|(0-(45^A)|0)>>>8&62^62|((A+65439|0)>>>8^255)&A+185&((122-A|0)>>>8&255^255)|((A+-65|0)>>>8^255)&A+-65&((90-A|0)>>>8&255^255)|((A+65488|0)>>>8^255)&A+4&((57-A|0)>>>8&255^255))|0)>>>8&255^255)&(0-(65^A)|0)>>>8|(0-(95^A)|0)>>>8&63^63|(0-(45^A)|0)>>>8&62^62|((A+65439|0)>>>8^255)&A+185&((122-A|0)>>>8&255^255)|((A+-65|0)>>>8^255)&A+-65&((90-A|0)>>>8&255^255)|((A+65488|0)>>>8^255)&A+4&((57-A|0)>>>8&255^255)|0}function SI(A){return((0-((0-(47^(A|=0))|0)>>>8&63^63|(0-(43^A)|0)>>>8&62^62|((A+65439|0)>>>8^255)&A+185&((122-A|0)>>>8&255^255)|((A+-65|0)>>>8^255)&A+-65&((90-A|0)>>>8&255^255)|((A+65488|0)>>>8^255)&A+4&((57-A|0)>>>8&255^255))|0)>>>8&255^255)&(0-(65^A)|0)>>>8|(0-(47^A)|0)>>>8&63^63|(0-(43^A)|0)>>>8&62^62|((A+65439|0)>>>8^255)&A+185&((122-A|0)>>>8&255^255)|((A+-65|0)>>>8^255)&A+-65&((90-A|0)>>>8&255^255)|((A+65488|0)>>>8^255)&A+4&((57-A|0)>>>8&255^255)|0}function xI(A,I){I|=0;var g=0,B=0;if(g=0|CC(0|a[72+(A|=0)>>2],0|a[A+72+4>>2],3),o(),(127&g)>>>0<112)112-(127&g)|0&&sA(A+80+(127&g)|0,33616,112-(127&g)|0);else{128-(127&g)|0&&sA(A+80+(127&g)|0,33616,128-(127&g)|0),l(A,A+80|0,I,I+640|0),B=112+(g=A+80|0)|0;do{a[g>>2]=0,g=g+4|0}while((0|g)<(0|B))}BB(A+192|0,A+64|0,16),l(A,A+80|0,I,I+640|0)}function UI(A,I){var g,B,C,t,r,Q,e,o,c;A|=0,c=0|a[4+(I|=0)>>2],o=0|a[I+8>>2],e=0|a[I+12>>2],Q=0|a[I+16>>2],r=0|a[I+20>>2],t=0|a[I+24>>2],C=0|a[I+28>>2],B=0|a[I+32>>2],g=0|a[I+36>>2],a[A>>2]=a[I>>2],a[A+4>>2]=c,a[A+8>>2]=o,a[A+12>>2]=e,a[A+16>>2]=Q,a[A+20>>2]=r,a[A+24>>2]=t,a[A+28>>2]=C,a[A+32>>2]=B,a[A+36>>2]=g}function MI(A){A|=0;var I=0,g=0,C=0;A:do{if(3&A)for(I=A,g=A;;){if(!(0|B[g>>0]))break A;if(!(3&(I=g=g+1|0))){I=g,C=5;break}}else I=A,C=5}while(0);if(5==(0|C)){for(;!((-2139062144&(g=0|a[I>>2])^-2139062144)&g+-16843009);)I=I+4|0;if((255&g)<<24>>24)do{I=I+1|0}while(0!=(0|B[I>>0]))}return I-A|0}function JI(A,I){I|=0;var g=0;a[(A|=0)>>2]=1634760805,a[A+4>>2]=857760878,a[A+8>>2]=2036477234,a[A+12>>2]=1797285236,g=0|ga(I),a[A+16>>2]=g,g=0|ga(I+4|0),a[A+20>>2]=g,g=0|ga(I+8|0),a[A+24>>2]=g,g=0|ga(I+12|0),a[A+28>>2]=g,g=0|ga(I+16|0),a[A+32>>2]=g,g=0|ga(I+20|0),a[A+36>>2]=g,g=0|ga(I+24|0),a[A+40>>2]=g,I=0|ga(I+28|0),a[A+44>>2]=I}function vI(A,I,g){I|=0,g|=0;var C=0;B[7+(A|=0)>>0]=I,C=0|CC(0|I,0|g,8),o(),B[A+6>>0]=C,C=0|CC(0|I,0|g,16),o(),B[A+5>>0]=C,C=0|CC(0|I,0|g,24),o(),B[A+4>>0]=C,B[A+3>>0]=g,C=0|CC(0|I,0|g,40),o(),B[A+2>>0]=C,C=0|CC(0|I,0|g,48),o(),B[A+1>>0]=C,g=0|CC(0|I,0|g,56),o(),B[A>>0]=g}function NI(A,I,g){var B,C;g|=0,B=h,C=h=h+63&-64,h=h+48|0,$A(A|=0,40+(I|=0)|0,I),OA(A+40|0,I+40|0,I),m(A+80|0,A,g+40|0),m(A+40|0,A+40|0,g),m(A+120|0,g+120|0,I+120|0),m(A,I+80|0,g+80|0),$A(C,A,A),OA(A,A+80|0,A+40|0),$A(A+40|0,A+80|0,A+40|0),OA(A+80|0,C,A+120|0),$A(A+120|0,C,A+120|0),h=B}function RI(A,I,g){var B,C;g|=0,B=h,C=h=h+63&-64,h=h+48|0,$A(A|=0,40+(I|=0)|0,I),OA(A+40|0,I+40|0,I),m(A+80|0,A,g),m(A+40|0,A+40|0,g+40|0),m(A+120|0,g+120|0,I+120|0),m(A,I+80|0,g+80|0),$A(C,A,A),OA(A,A+80|0,A+40|0),$A(A+40|0,A+80|0,A+40|0),$A(A+80|0,C,A+120|0),OA(A+120|0,C,A+120|0),h=B}function YI(A,I,g){A|=0,I|=0,g|=0;var C,a,t=0;a=h,C=h=h+63&-64,h=h+160|0,t=0;do{B[A+t>>0]=0|B[I+t>>0],t=t+1|0}while(32!=(0|t));return 0|g&&TC(A),B[A+31>>0]=127&B[A+31>>0],DA(C,A),yg(A,C),g=0|mB(A)?-1:(0!=(0|Hg(I,32)))<<31>>31,h=a,0|g}function LI(A,I,g){var B,C;g|=0,B=h,C=h=h+63&-64,h=h+48|0,$A(A|=0,40+(I|=0)|0,I),OA(A+40|0,I+40|0,I),m(A+80|0,A,g+40|0),m(A+40|0,A+40|0,g),m(A+120|0,g+80|0,I+120|0),$A(C,I+80|0,I+80|0),OA(A,A+80|0,A+40|0),$A(A+40|0,A+80|0,A+40|0),OA(A+80|0,C,A+120|0),$A(A+120|0,C,A+120|0),h=B}function PI(A,I,g){var B,C;g|=0,B=h,C=h=h+63&-64,h=h+48|0,$A(A|=0,40+(I|=0)|0,I),OA(A+40|0,I+40|0,I),m(A+80|0,A,g),m(A+40|0,A+40|0,g+40|0),m(A+120|0,g+80|0,I+120|0),$A(C,I+80|0,I+80|0),OA(A,A+80|0,A+40|0),$A(A+40|0,A+80|0,A+40|0),$A(A+80|0,C,A+120|0),OA(A+120|0,C,A+120|0),h=B}function KI(A){var I,g;return I=h,g=h=h+63&-64,h=h+288|0,d(g+240|0,A|=0),d(g+192|0,A+40|0),d(g+144|0,A+80|0),OA(g+48|0,g+192|0,g+240|0),m(g+48|0,g+48|0,g+144|0),m(g,g+240|0,g+192|0),m(g,g,16),d(g+96|0,g+144|0),$A(g,g,g+96|0),OA(g+48|0,g+48|0,g),A=0|zB(g+48|0),h=I,0|A}function qI(A,I){A|=0,I|=0;var g,C,a=0;g=h,C=h=h+63&-64,h=h+208|0,a=0;do{B[A+a>>0]=0|B[I+a>>0],a=a+1|0}while(32!=(0|a));return B[A>>0]=-8&B[A>>0],B[A+31>>0]=63&B[A+31>>0]|64,DA(C+40|0,A),function(A,I,g){var B,C;A|=0,B=h,C=h=h+63&-64,h=h+96|0,$A(C+48|0,g|=0,I|=0),OA(C,g,I),CA(C,C),m(A,C+48|0,C),h=B}(C,C+40+40|0,C+40+80|0),pA(A,C),h=g,0}function XI(A,I,g){var C,r;if(A|=0,I|=0,g|=0,C=h,r=h=h+63&-64,h=h+16|0,a[r+4>>2]=A,a[r>>2]=I,B[r+8>>0]=0,0|g){A=0;do{B[r+8>>0]=B[r+8>>0]|B[(0|a[r>>2])+A>>0]^B[(0|a[r+4>>2])+A>>0],A=A+1|0}while((0|A)!=(0|g))}return h=C,((511+(0|t[r+8>>0])|0)>>>8&1)-1|0}function jI(A,I,g,B,C,a,t,r){var Q,e;return A|=0,I|=0,g|=0,B|=0,C|=0,a|=0,e=h,Q=h=h+63&-64,h=h+32|0,0|Ug(Q,t|=0,r|=0)?B=-1:(B=0|kB(A,I,g,B,C,a,Q),Lg(Q,32)),h=e,0|B}function TI(A,I){A|=0;var g,C,t=0;if(g=h,C=h=h+63&-64,h=h+64|0,!(((I|=0)-1&255)>63)){B[C>>0]=I,B[C+1>>0]=0,B[C+2>>0]=1,B[C+3>>0]=1,Ca(C+4|0),tB(C+8|0,0,0),t=48+(I=C+16|0)|0;do{a[I>>2]=0,I=I+4|0}while((0|I)<(0|t));return mI(A,C),void(h=g)}st()}function VI(A,I,g,B,C,a,t,r){var Q,e;return A|=0,I|=0,g|=0,B|=0,C|=0,a|=0,e=h,Q=h=h+63&-64,h=h+32|0,0|Ug(Q,t|=0,r|=0)?B=-1:(UB(A,I,g,B,C,a,Q),Lg(Q,32),B=0),h=e,0|B}function WI(A,I){A|=0,I|=0;var g,C,a=0,t=0;g=h,C=h=h+63&-64,h=h+64|0,a=(t=C)+64|0;do{B[t>>0]=0|B[I>>0],t=t+1|0,I=I+1|0}while((0|t)<(0|a));D(C),I=C,a=(t=A)+32|0;do{B[t>>0]=0|B[I>>0],t=t+1|0,I=I+1|0}while((0|t)<(0|a));Lg(C,64),h=g}function zI(A,I,g,B,C,a,t,r){var Q,e;return A|=0,I|=0,C|=0,t|=0,r|=0,Q=h,e=h=h+63&-64,h=h+80|0,0==(0|(g|=0))&0==(0|(B|=0))||(UC(e+64|0,a|=0),UC(e+64+4|0,t),JI(e,r),Gg(e,C,e+64|0),U(e,I,A,g,B),Lg(e,64)),h=Q,0}function ZI(A,I,g){var C,t;A|=0,I|=0,g|=0,C=h,t=h=h+63&-64,h=h+16|0,a[t+8>>2]=A,a[t+4>>2]=I,a[t>>2]=0,A=0;do{a[t>>2]=a[t>>2]|255&(B[(0|a[t+4>>2])+A>>0]^B[(0|a[t+8>>2])+A>>0]),A=A+1|0}while((0|A)!=(0|g));return h=C,((511+(0|a[t>>2])|0)>>>8&1)-1|0}function OI(A,I,g){I|=0,g|=0;var B=0,C=0,a=0,r=0;for(r=A|=0,A=0;;){B=0,a=A,A=0;do{C=a,a=a+1|0,A=(0|t[g+C>>0])<<B|A,B=B+8|0,C=a>>>0<32}while(C&B>>>0<24);if(!(A=0|eg(r,I,A,B))){A=0;break}if(I=I+r-A|0,!C)break;r=A,A=a}return 0|A}function $I(A,I,g){I|=0,g|=0;var C=0,a=0;C=0|B[(A|=0)>>0];A:do{if(C<<24>>24)for(;;){if(g=g+-1|0,!(C<<24>>24==(a=0|B[I>>0])<<24>>24&0!=(0|g)&a<<24>>24!=0))break A;if(I=I+1|0,!((C=0|B[(A=A+1|0)>>0])<<24>>24)){C=0;break}}else C=0}while(0);return(255&C)-(0|t[I>>0])|0}function Ag(A,I){A|=0,I|=0;var g,C,t=0,r=0;for(C=h,g=h=h+63&-64,h=h+16|0,t=0,r=0;;){if(0|xC(g,0|B[I>>0])){t=3;break}if(I=I+1|0,r=a[g>>2]<<t|r,(t=t+6|0)>>>0>=30){t=5;break}}return 3==(0|t)?(a[A>>2]=0,I=0):5==(0|t)&&(a[A>>2]=r),h=C,0|I}function Ig(A,I,g,B,C,a,t){A|=0,I|=0,C|=0,a|=0,t|=0;var r,Q=0;return Q=0|FC(0,1,0|(Q=0|CC(0|(Q=0|bC(0|(g|=0),0|(B|=0),63,0)),0|o(),6)),0|o()),(r=0|o())>>>0<0|0==(0|r)&Q>>>0<a>>>0?(st(),0):0|Zg(A,I,g,B,C,a,t)}function gg(A,I,g,B){I|=0;var C=0,a=0,t=0;if(iC(g|=0,(A|=0)+(((B|=0)<<5)-16<<2)|0),B<<1|0){C=0;do{LB(g,A+((t=C<<4)<<2)|0),Y(g),iC(I+((a=C<<3)<<2)|0,g),LB(g,A+((16|t)<<2)|0),Y(g),iC(I+(a+(B<<4)<<2)|0,g),C=C+2|0}while(C>>>0<B<<1>>>0)}}function Bg(A,I){A|=0,I|=0;var g,C,a=0,t=0,Q=0,e=0;for(g=h,C=h=h+63&-64,h=h+16|0,t=10;e=255&((Q=I)+(0|r(I=(I>>>0)/10|0,-10))|48),B[C+(a=t+-1|0)>>0]=e,Q>>>0>9&0!=(0|a);)t=a;sA(0|A,C+a|0,0|(e=11-t|0)),B[A+e>>0]=0,h=g}function Cg(A,I){var g,B;g=h,B=h=h+63&-64,h=h+48|0,d(A|=0,I|=0),d(A+80|0,I+40|0),b(A+120|0,I+80|0),$A(A+40|0,I,I+40|0),d(B,A+40|0),$A(A+40|0,A+80|0,A),OA(A+80|0,A+80|0,A),OA(A,B,A+40|0),OA(A+120|0,A+120|0,A+80|0),h=g}function ag(A,I,g){var C,a;if(A|=0,I|=0,g|=0,a=h,C=h=h+63&-64,h=h+16|0,B[C>>0]=0,0|function(A,I,g){A|=0,I|=0;var C,a,r=0;if(a=h,C=h=h+63&-64,h=h+336|0,0|function(A){A|=0;var I,g,C=0,a=0,r=0,Q=0;I=h,g=h=h+63&-64,h=h+16|0,B[g>>0]=0,B[g+1>>0]=0,B[g+2>>0]=0,B[g+3>>0]=0,B[g+4>>0]=0,B[g+5>>0]=0,B[g+6>>0]=0,r=0;do{C=0|B[A+r>>0],a=0;do{B[(Q=g+a|0)>>0]=B[Q>>0]|B[33744+(a<<5)+r>>0]^C,a=a+1|0}while(7!=(0|a));r=r+1|0}while(31!=(0|r));C=127&B[A+31>>0],a=0;do{B[(Q=g+a|0)>>0]=B[Q>>0]|C^B[33744+(a<<5)+31>>0],a=a+1|0}while(7!=(0|a));C=0,a=0;do{a=(0|t[g+C>>0])-1|a,C=C+1|0}while(7!=(0|C));return h=I,a>>>8&1|0}(g|=0))r=-1;else{r=0;do{B[A+r>>0]=0|B[I+r>>0],r=r+1|0}while(32!=(0|r));for(B[A>>0]=-8&B[A>>0],B[A+31>>0]=63&B[A+31>>0]|64,J(C+288|0,g),mC(C+240|0),jC(C+192|0),UI(C+144|0,C+288|0),mC(C+96|0),r=254,I=0;g=I,iA(C+240|0,C+144|0,g^=I=(0|t[A+(r>>>3)>>0])>>>(7&r)&1),iA(C+192|0,C+96|0,g),OA(C+48|0,C+144|0,C+96|0),OA(C,C+240|0,C+192|0),$A(C+240|0,C+240|0,C+192|0),$A(C+192|0,C+144|0,C+96|0),m(C+96|0,C+48|0,C+240|0),m(C+192|0,C+192|0,C),d(C+48|0,C),d(C,C+240|0),$A(C+144|0,C+96|0,C+192|0),OA(C+192|0,C+96|0,C+192|0),m(C+240|0,C,C+48|0),OA(C,C,C+48|0),d(C+192|0,C+192|0),v(C+96|0,C),d(C+144|0,C+144|0),$A(C+48|0,C+48|0,C+96|0),m(C+96|0,C+288|0,C+192|0),m(C+192|0,C,C+48|0),r;)r=r+-1|0;iA(C+240|0,C+144|0,I),iA(C+192|0,C+96|0,I),CA(C+192|0,C+192|0),m(C+240|0,C+240|0,C+192|0),pA(A,C+240|0),r=0}return h=a,0|r}(A,I,g))I=-1;else{I=0;do{B[C>>0]=B[C>>0]|B[A+I>>0],I=I+1|0}while(32!=(0|I));I=0-((511+(0|t[C>>0])|0)>>>8&1)|0}return h=a,0|I}function tg(A,I,g,C,a,t){if(A|=0,(C|=0)>>>0<0|0==(0|C)&(g|=0)>>>0<32)A=-1;else{nC(A,I|=0,g,C,a|=0,t|=0),kC(A+16|0,A+32|0,g=0|bC(0|g,0|C,-32,-1),0|o(),A),g=A+16|0;do{B[A>>0]=0,A=A+1|0}while((0|A)<(0|g));A=0}return 0|A}function rg(A,I,g){A|=0,I|=0;var C,a,t=0,r=0;a=h,r=h=h+63&-64,h=h+64|0,Xg(r,g|=0,32,0),t=r,C=(g=I)+32|0;do{B[g>>0]=0|B[t>>0],g=g+1|0,t=t+1|0}while((0|g)<(0|C));return Lg(r,64),r=0|ea(A,I),h=a,0|r}function Qg(A,I,g,B,C,a,t){var r,Q;return A|=0,I|=0,C|=0,t|=0,r=h,Q=h=h+63&-64,h=h+80|0,0==(0|(g|=0))&0==(0|(B|=0))||(UC(Q+64|0,a|=0),JI(Q,t),Kg(Q,C,Q+64|0),U(Q,I,A,g,B),Lg(Q,64)),h=r,0}function eg(A,I,g,C){A|=0,I|=0,g|=0,C|=0;var a=0,t=0;A:do{if(C)for(t=0;;){if(!I){A=0;break A}if(a=A+1|0,B[A>>0]=0|B[35361+(63&g)>>0],(t=t+6|0)>>>0>=C>>>0){A=a;break}A=a,I=I+-1|0,g>>>=6}}while(0);return 0|A}function og(A,I,g,B,C,a,t,r,Q,e){var o,c;return A|=0,I|=0,g|=0,B|=0,C|=0,a|=0,t|=0,r|=0,Q|=0,e|=0,o=h,c=h=h+63&-64,h=h+16|0,Na(c),B=0|eA(c,A,I,g,B,C,a,t,r,Q,e),Ma(c),h=o,0|B}function cg(A,I,g,B,C,a,t){var r,Q;return A|=0,I|=0,g|=0,B|=0,C|=0,Q=h,r=h=h+63&-64,h=h+32|0,0|Mg(r,a|=0,t|=0)?g=-1:(g=0|yC(A,I,g,B,C,r),Lg(r,32)),h=Q,0|g}function ig(A,I,g){var C,a;return A|=0,C=h,a=h=h+63&-64,h=h+160|0,Xg(I|=0,g|=0,32,0),B[I>>0]=-8&B[I>>0],B[I+31>>0]=63&B[I+31>>0]|64,DA(a,I),yg(A,a),Rg(0|I,0|g,32),Rg(I+32|0,0|A,32),h=C,0}function _g(A,I,g,B,C,a,t){var r,Q;return A|=0,I|=0,g|=0,B|=0,C|=0,Q=h,r=h=h+63&-64,h=h+32|0,0|Mg(r,a|=0,t|=0)?g=-1:(g=0|uC(A,I,g,B,C,r),Lg(r,32)),h=Q,0|g}function Eg(A,I){I|=0;var g,C,a,r=0;C=h,a=h=h+63&-64,h=h+48|0,g=32+(r=A|=0)|0;do{B[r>>0]=0|B[I>>0],r=r+1|0,I=I+1|0}while((0|r)<(0|g));r=0|t[A+31>>0],B[A+31>>0]=127&r,J(a,A),yA(A,a,128&r),h=C}function ng(A,I,g,B,C,a,t,r){var Q,e;return A|=0,I|=0,g|=0,B|=0,a|=0,t|=0,Q=h,e=h=h+63&-64,h=h+32|0,T(e,C|=0,r|=0,0),C=0|XB(A,I,g,B,C+16|0,a,t,e),Lg(e,32),h=Q,0|C}function sg(A,I,g,B){A|=0,I|=0,g|=0,B|=0;A:do{if(B>>>0>0|0==(0|B)&g>>>0>4294967295)a[8886]=22,g=-1;else{switch(0|fa(A,I,g)){case 0:g=0;break A;case-35:a[8886]=28}g=-1}}while(0);return 0|g}function yg(A,I){var g,C;A|=0,g=h,C=h=h+63&-64,h=h+144|0,CA(C+96|0,80+(I|=0)|0),m(C+48|0,I,C+96|0),m(C,I+40|0,C+96|0),pA(A,C),I=(0|tC(C+48|0))<<7,B[A+31>>0]=I^(0|t[A+31>>0]),h=g}function hg(A,I){A|=0;var g,B,C=0;return g=h,C=h=h+63&-64,h=h+16|0,B=0|BC(C,I|=0),a[8886]=B,B?(a[C>>2]=0,C=0):C=0|a[C>>2],a[A>>2]=C,a[A+4>>2]=C,a[A+8>>2]=0==(0|C)?0:I,h=g,0|C}function pg(A,I,g,B){A|=0,I|=0,g|=0,B|=0;A:do{if(B>>>0>0|0==(0|B)&g>>>0>4294967295)a[8886]=22,g=-1;else{switch(0|wa(A,I,g)){case 0:g=0;break A;case-35:a[8886]=28}g=-1}}while(0);return 0|g}function fg(A,I,g,B,C,a,t,r){var Q,e;return A|=0,I|=0,g|=0,B|=0,a|=0,t|=0,Q=h,e=h=h+63&-64,h=h+32|0,K(e,C|=0,r|=0,0),C=0|Tg(A,I,g,B,C+16|0,a,t,e),h=Q,0|C}function wg(A,I,g,B,C,a,t,r){var Q;return A|=0,I|=0,g|=0,B|=0,C|=0,a|=0,Q=h,h=h+32|0,0|VC(Q,t|=0,r|=0)?B=-1:(B=0|OB(A,I,g,B,C,a,Q),Lg(Q,32)),h=Q,0|B}function lg(A,I,g,B,C,a,t){return I|=0,C|=0,a|=0,t|=0,0|((B|=0)>>>0<0|0==(0|B)&(g|=0)>>>0<16?-1:0|jI(A|=0,I+16|0,I,g=0|bC(0|g,0|B,-16,-1),0|o(),C,a,t))}function ug(A,I,g,B,C,a,t,r){var Q;return A|=0,I|=0,g|=0,B|=0,C|=0,a|=0,Q=h,h=h+32|0,0|VC(Q,t|=0,r|=0)?B=-1:(IC(A,I,g,B,C,a,Q),Lg(Q,32),B=0),h=Q,0|B}function Dg(A,I,g,C){I|=0,g|=0,C|=0;var a=0;return 0|(36==(0|B[(A|=0)>>0])&&55==(0|B[A+1>>0])&&36==(0|B[A+2>>0])&&0==(0|xC(I,0|B[A+3>>0]))&&0!=(0|(a=0|Ag(g,A+4|0)))?0|Ag(C,a):0)}function mg(A){A|=0;var I=0,g=0,C=0,a=0,t=0;for(a=0,t=32,I=1;a=(255&(g=0|B[A+(t=t+-1|0)>>0]))-(255&(C=0|B[34016+t>>0]))>>8&(I&=255)|255&a,t;)I&=(65535+(255&(C^g))|0)>>>8;return 0!=(0|a)|0}function Fg(A){return a[32+(A|=0)>>2]=0,a[A+32+4>>2]=0,a[A>>2]=a[8140],a[A+4>>2]=a[8141],a[A+8>>2]=a[8142],a[A+12>>2]=a[8143],a[A+16>>2]=a[8144],a[A+20>>2]=a[8145],a[A+24>>2]=a[8146],a[A+28>>2]=a[8147],0}function kg(A,I,g,B){return B=0|bC(0|bC(0|(g|=0),0|(B|=0),0|(A|=0),0|(I|=0)),0|o(),0|(B=0|NB(-2&(B=0|$B(0|A,0|I,1))|0,1&(0|o())|0,0|g,0)),0|o()),e(0|o()),0|B}function bg(A,I,g,B){A|=0,I|=0,g|=0,B|=0;do{if(!(g>>>0>64|(B+-1|0)>>>0>63)){if(0==(0|I)|0==(0|g)){TI(A,255&B),I=0;break}_I(A,255&B,I,255&g),I=0;break}I=-1}while(0);return 0|I}function dg(A){var I,g,B,C=0;return g=0|t[(A|=0)>>0],B=0|$B(0|t[A+1>>0],0,8),C=0|o(),I=0|$B(0|t[A+2>>0],0,16),C=0|C|o(),A=0|$B(0|t[A+3>>0],0,24),e(0|C|o()|0),B|g|I|A|0}function Hg(A,I){A|=0,I|=0;var g,C,a=0;g=h,C=h=h+63&-64,h=h+16|0,B[C>>0]=0,a=0;do{B[C>>0]=B[C>>0]|B[A+a>>0],a=a+1|0}while((0|a)!=(0|I));return h=g,(511+(0|t[C>>0])|0)>>>8&1|0}function Gg(A,I,g){A|=0,I|=0;var B=0;(g|=0)?(B=0|ga(g),a[A+48>>2]=B,g=0|ga(g+4|0)):(a[A+48>>2]=0,g=0),a[A+52>>2]=g,B=0|ga(I),a[A+56>>2]=B,B=0|ga(I+4|0),a[A+60>>2]=B}function Sg(A,I,g){var B,C;A|=0,I|=0,g|=0,B=h,C=h=h+63&-64,h=h+384|0,KC(C,0,0,24),MC(C,I,32,0),MC(C,g,32,0),Ba(C,A,24),h=B}function xg(A,I,g,B,C){var a,t;return A|=0,I|=0,g|=0,a=h,t=h=h+63&-64,h=h+32|0,T(t,B|=0,C|=0,0),B=0|RC(A,I,g,B+16|0,t),Lg(t,32),h=a,0|B}function Ug(A,I,g){var B,C;return A|=0,C=h,B=h=h+63&-64,h=h+32|0,0|ag(B,g|=0,I|=0)?A=-1:(K(A,35520,B,0),A=0),h=C,0|A}function Mg(A,I,g){var B,C;return A|=0,C=h,B=h=h+63&-64,h=h+32|0,0|ag(B,g|=0,I|=0)?A=-1:(T(A,35472,B,0),A=0),h=C,0|A}function Jg(A,I,g,B,C){var a;return A|=0,a=h,h=h+32|0,zg(a,I|=0,g|=0,B|=0,C|=0),C=0|ka(A,a),C=0|((0|a)==(0|A)?-1:C)|XI(a,A,32),h=a,0|C}function vg(A,I,g,B,C,a,t){return I|=0,C|=0,a|=0,t|=0,0|((B|=0)>>>0<0|0==(0|B)&(g|=0)>>>0<16?-1:0|wg(A|=0,I+16|0,I,g=0|bC(0|g,0|B,-16,-1),0|o(),C,a,t))}function Ng(A,I,g,B,C,a,t){return A|=0,I|=0,C|=0,a|=0,t|=0,(B|=0)>>>0>0|0==(0|B)&(g|=0)>>>0>4294967279?(st(),0):0|VI(A+16|0,A,I,g,B,C,a,t)}function Rg(A,I,g){var C=0;if((0|(I|=0))<(0|(A|=0))&(0|A)<(I+(g|=0)|0)){for(C=A,I=I+g|0,A=A+g|0;(0|g)>0;)I=I-1|0,g=g-1|0,B[(A=A-1|0)>>0]=0|B[I>>0];A=C}else sA(A,I,g);return 0|A}function Yg(A,I,g,B,C,a,t,r,Q){return B|=0,((I|=0)-1|0)>>>0>63|(t|=0)>>>0>64?B=-1:(function(A,I,g,B,C,a,t,r,Q){var e,o;A|=0,g|=0,B|=0,t|=0,r|=0,Q|=0,e=h,o=h=h+63&-64,h=h+368|0,0==(0|(I|=0))&(0!=(0|(C|=0))|0!=(0|(a|=0)))&&st(),A||st(),(B+-1&255)>63&&st(),0!=(0|g)|t<<24>>24==0||st(),(255&t)>64&&st(),t<<24>>24?bA(o,B,g,t,r,Q):aI(o,B,r,Q),oA(o,I,C,a),R(o,A,B),h=e}(A|=0,g|=0,a|=0,255&I,B,C|=0,255&t,r|=0,Q|=0),B=0),0|B}function Lg(A,I){var g,C;if(A|=0,I|=0,g=h,C=h=h+63&-64,h=h+16|0,a[C>>2]=A,0|I){A=0;do{B[(0|a[C>>2])+A>>0]=0,A=A+1|0}while((0|A)!=(0|I))}h=g}function Pg(A,I){A|=0,I|=0;var g=0,B=0,C=0,t=0;g=0;do{t=I+(g<<3)|0,C=a[4+(B=A+(g<<3)|0)>>2]^a[t+4>>2],a[B>>2]=a[B>>2]^a[t>>2],a[B+4>>2]=C,g=g+1|0}while(128!=(0|g))}function Kg(A,I,g){A|=0,I|=0,g=(g|=0)?0|ga(g):0,a[A+48>>2]=g,g=0|ga(I),a[A+52>>2]=g,g=0|ga(I+4|0),a[A+56>>2]=g,I=0|ga(I+8|0),a[A+60>>2]=I}function qg(A,I){var g,C;I|=0,C=h,h=h+64|0,CB(A|=0,C),A=C,g=I+32|0;do{B[I>>0]=0|B[A>>0],I=I+1|0,A=A+1|0}while((0|I)<(0|g));return h=C,0}function Xg(A,I,g,B){var C,a;return A|=0,I|=0,g|=0,B|=0,C=h,a=h=h+63&-64,h=h+208|0,Og(a),q(a,I,g,B),fB(a,A),h=C,0}function jg(A,I,g,B,C){var a;return A|=0,I|=0,g|=0,B|=0,a=h,h=h+208|0,HA(a,C|=0,32),NC(a,I,g,B),aB(a,A),h=a,0}function Tg(A,I,g,B,C,a,t,r){return A|=0,I|=0,C|=0,a|=0,t|=0,r|=0,(B|=0)>>>0>0|0==(0|B)&(g|=0)>>>0>4294967295?(st(),0):0|zI(A,I,g,B,C,a,t,r)}function Vg(A,I,g,B,C){var a,t;return A|=0,I|=0,g|=0,B|=0,a=h,t=h=h+63&-64,h=h+96|0,eI(t,C|=0),Z(t,I,g,B),BA(t,A),h=a,0}function Wg(A,I,g,B,C){var a;return A|=0,I|=0,g|=0,B|=0,a=h,h=h+416|0,dA(a,C|=0,32),YC(a,I,g,B),CB(a,A),h=a,0}function zg(A,I,g,B,C){var a;return A|=0,I|=0,g|=0,B|=0,a=h,h=h+416|0,Ia(a,C|=0,32),qC(a,I,g,B),qg(a,A),h=a,0}function Zg(A,I,g,B,C,a,t){return A|=0,I|=0,C|=0,a|=0,t|=0,(B|=0)>>>0>0|0==(0|B)&(g|=0)>>>0>4294967295?(st(),0):0|Qg(A,I,g,B,C,a,t)}function Og(A){var I,g=0;a[64+(A|=0)>>2]=0,a[A+64+4>>2]=0,a[A+64+8>>2]=0,a[A+64+12>>2]=0,g=32912,I=A+64|0;do{a[A>>2]=a[g>>2],A=A+4|0,g=g+4|0}while((0|A)<(0|I));return 0}function $g(A,I){A|=0,I|=0;var g=0;A:do{if(I)for(g=I;;){if(36==(0|B[(I=A+(g=g+-1|0)|0)>>0]))break A;if(!g){I=0;break}}else I=0}while(0);return 0|I}function AB(A){var I;return A|=0,((I=0|a[9016])+A|0)>>>0>(0|E())>>>0&&0==(0|s(I+A|0))?(a[8886]=48,0|(A=-1)):(a[9016]=I+A,0|(A=I))}function IB(A,I,g,B){var C,a;return I|=0,g|=0,B|=0,C=h,a=h=h+63&-64,h=h+64|0,fB(A|=0,a),qA(I,g,a,64,0,B,1),h=C,0}function gB(A,I,g){var B,C;return I|=0,g|=0,B=h,C=h=h+63&-64,h=h+64|0,fB(A|=0,C),A=0|VA(I,C,64,0,g,1),h=B,0|A}function BB(A,I,g){A|=0,I|=0;var B=0,C=0;if((g|=0)>>>3|0){B=0;do{vI(A+(B<<3)|0,0|a[(C=I+(B<<3)|0)>>2],0|a[C+4>>2]),B=B+1|0}while((0|B)!=(g>>>3|0))}}function CB(A,I){var g;return I|=0,g=h,h=h+64|0,fB(A|=0,g),q(A+208|0,g,64,0),fB(A+208|0,I),Lg(g,64),h=g,0}function aB(A,I){var g;return I|=0,g=h,h=h+32|0,lB(A|=0,g),z(A+104|0,g,32,0),lB(A+104|0,I),Lg(g,32),h=g,0}function tB(A,I,g){I|=0,g|=0,B[(A|=0)>>0]=I,B[A+1>>0]=I>>8,B[A+2>>0]=I>>16,B[A+3>>0]=I>>24,B[A+4>>0]=g,B[A+4+1>>0]=g>>8,B[A+4+2>>0]=g>>16,B[A+4+3>>0]=g>>24}function rB(A,I){A|=0,I|=0;var g=0,B=0,C=0,t=0;g=0;do{t=0|wB(I+(g<<3)|0),C=0|o(),a[(B=A+(g<<3)|0)>>2]=t,a[B+4>>2]=C,g=g+1|0}while(128!=(0|g))}function QB(A,I,g,B,C,a,t){return A|=0,I|=0,C|=0,a|=0,t|=0,(B|=0)>>>0>0|0==(0|B)&(g|=0)>>>0>4294967279?(st(),0):0|ug(A+16|0,A,I,g,B,C,a,t)}function eB(A,I){A|=0,I|=0;var g=0,C=0,a=0;for(g=0,C=0;g=(0|t[(a=A+C|0)>>0])-(0|t[I+C>>0])-g|0,B[a>>0]=g,64!=(0|(C=C+1|0));)g=g>>>8&1}function oB(A,I,g,B,C,a){return A|=0,I|=0,C|=0,a|=0,(B|=0)>>>0>0|0==(0|B)&(g|=0)>>>0>4294967295?(st(),0):0|function(A,I,g,B,C,a){return(B|=0)>>>0>0|0==(0|B)&(g|=0)>>>0>4294967295?(st(),0):0|Qg(A|=0,I|=0,g,B,C|=0,0,a|=0)}(A,I,g,B,C,a)}function cB(A){return(0-(62^(A|=0))|0)>>>8&45^45|(A+65510|0)>>>8&255&A+65|(0-(63^A)|0)>>>8&95^95|(A+65484|0)>>>8&A+71&((A+65510|0)>>>8&255^255)|(A+65474|0)>>>8&A+252&((A+65484|0)>>>8&255^255)|0}function iB(A,I){A|=0,I|=0;var g=0,C=0,a=0;for(g=0,C=0;g=g+(0|t[(a=A+C|0)>>0])+(0|t[I+C>>0])|0,B[a>>0]=g,32!=(0|(C=C+1|0));)g>>>=8}function _B(A){var I=0,g=0;I=127&B[31+(A|=0)>>0]^127,g=30;do{I|=~B[A+g>>0],g=g+-1|0}while(0!=(0|g));return 1&((236-(A=0|t[A>>0])&511+(255&I))>>>8|A)^1|0}function EB(A,I,g){A|=0,I|=0;var B=0,C=0;if((g|=0)>>>2|0){B=0;do{a[(C=A+(B<<2)|0)>>2]=a[C>>2]^a[I+(B<<2)>>2],B=B+1|0}while((0|B)!=(g>>>2|0))}}function nB(A){return(0-(62^(A|=0))|0)>>>8&43^43|(A+65510|0)>>>8&255&A+65|(0-(63^A)|0)>>>8&47^47|(A+65484|0)>>>8&A+71&((A+65510|0)>>>8&255^255)|(A+65474|0)>>>8&A+252&((A+65484|0)>>>8&255^255)|0}function sB(A,I,g){var B,C;A|=0,I|=0,B=h,C=h=h+63&-64,h=h+32|0,SA(C,g|=0),zA(A,I,C),h=B}function yB(A,I,g,B,C,a,t){return B|=0,((I|=0)-1|0)>>>0>63|(t|=0)>>>0>64?B=-1:(function(A,I,g,B,C,a,t){var r,Q;A|=0,g|=0,B|=0,t|=0,r=h,Q=h=h+63&-64,h=h+368|0,0==(0|(I|=0))&(0!=(0|(C|=0))|0!=(0|(a|=0)))&&st(),A||st(),(B+-1&255)>63&&st(),0!=(0|g)|t<<24>>24==0||st(),(255&t)>64&&st(),t<<24>>24?_I(Q,B,g,t):TI(Q,B),oA(Q,I,C,a),R(Q,A,B),h=r}(A|=0,g|=0,a|=0,255&I,B,C|=0,255&t),B=0),0|B}function hB(A,I,g,B,C,a){return A|=0,I|=0,C|=0,a|=0,(B|=0)>>>0>0|0==(0|B)&(g|=0)>>>0>4294967295?(st(),0):0|zI(A,I,g,B,C,0,0,a)}function pB(A,I){var g,B;return A|=0,I|=0,g=h,B=h=h+63&-64,h=h+32|0,vB(B,32),ig(A,I,B),Lg(B,32),h=g,0}function fB(A,I){var g,B;return I|=0,g=h,B=h=h+63&-64,h=h+704|0,xI(A|=0,B),BB(I,A,64),Lg(B,704),Lg(A,208),h=g,0}function wB(A){var I;return I=t[(A|=0)>>0]|t[A+1>>0]<<8|t[A+2>>0]<<16|t[A+3>>0]<<24,e(t[A+4>>0]|t[A+4+1>>0]<<8|t[A+4+2>>0]<<16|t[A+4+3>>0]<<24|0),0|I}function lB(A,I){var g,B;return I|=0,g=h,B=h=h+63&-64,h=h+288|0,uI(A|=0,B),aC(I,A),Lg(B,288),Lg(A,104),h=g,0}function uB(A){var I=0,g=0;I=127&B[31+(A|=0)>>0]^127,g=30;do{I|=~B[A+g>>0],g=g+-1|0}while(0!=(0|g));return(236-(0|t[A>>0])&511+(255&I))>>>8&1^1|0}function DB(A,I,g,B,C){return A|=0,B|=0,C|=0,(g|=0)>>>0>0|0==(0|g)&(I|=0)>>>0>4294967295?(st(),0):0|FB(A,I,g,B,C)}function mB(A){var I=0,g=0;I=1^B[(A|=0)>>0],g=1;do{I=B[A+g>>0]|I,g=g+1|0}while(31!=(0|g));return(511+(255&(127&B[A+31>>0]|I))|0)>>>8&1|0}function FB(A,I,g,B,C){return A|=0,B|=0,C|=0,(g|=0)>>>0>0|0==(0|g)&(I|=0)>>>0>4294967295?(st(),0):0|function(A,I,g,B,C){var a,t;return A|=0,B|=0,a=h,t=h=h+63&-64,h=h+64|0,0==(0|(I|=0))&0==(0|(g|=0))||(JI(t,C|=0),Kg(t,B,0),tI(0|A,0,0|I),U(t,A,A,I,g),Lg(t,64)),h=a,0}(A,I,g,B,C)}function kB(A,I,g,B,C,a,t){return 0|_A(A|=0,I|=0,g|=0,B|=0,C|=0,a|=0,t|=0)}function bB(A,I,g){var B,C;return B=0|CC(0|(A|=0),0|(I|=0),0|(g|=0)),C=0|o(),g=0|$B(0|A,0|I,64-g|0),e(0|o()|C|0),g|B|0}function dB(A,I,g){var B,C;return B=0|$B(0|(A|=0),0|(I|=0),0|(g|=0)),C=0|o(),g=0|CC(0|A,0|I,64-g|0),e(0|o()|C|0),g|B|0}function HB(A,I,g){NA(A|=0,I|=0,255&(g|=0)),NA(A+40|0,I+40|0,255&g),NA(A+80|0,I+80|0,255&g),NA(A+120|0,I+120|0,255&g)}function GB(A,I,g,B){var C;return C=h,h=h+16|0,N(A|=0,I|=0,g|=0,B|=0,0|C),h=C,0|(e(0|a[C+4>>2]),0|a[C>>2])}function SB(A){A|=0;var I=0,g=0,C=0;for(I=1,g=0;I=I+(0|t[(C=A+g|0)>>0])|0,B[C>>0]=I,4!=(0|(g=g+1|0));)I>>>=8}function xB(A,I,g){var B,C;A|=0,g|=0,B=h,C=h=h+63&-64,h=h+48|0,lI(C,I|=0),UI(A,I),NA(A,C,g),h=B}function UB(A,I,g,B,C,a,t){return aA(A|=0,I|=0,g|=0,B|=0,C|=0,a|=0,t|=0),0}function MB(A,I,g){A|=0,I|=0;var B=0;if((g|=0)>>>2|0){B=0;do{a[A+(B<<2)>>2]=a[I+(B<<2)>>2],B=B+1|0}while((0|B)!=(g>>>2|0))}}function JB(A,I,g){var B;return A|=0,g|=0,I=0|$B(255&(I|=0)|0,0,8),B=0|o(),g=0|$B(255&g|0,0,16),e(0|B|o()|0),I|255&A|g|0}function vB(A,I){A|=0;var g=0,C=0;if(0|(I|=0)){g=0;do{C=255&(0|La()),B[A+g>>0]=C,g=g+1|0}while((0|g)!=(0|I))}}function NB(A,I,g,B){var C,a;return I|=0,B|=0,C=0|function(A,I){var g,B,C;return C=((g=0|r(65535&(I|=0),65535&(A|=0)))>>>16)+(0|r(65535&I,A>>>16))|0,B=0|r(I>>>16,65535&A),0|(e((C>>>16)+(0|r(I>>>16,A>>>16))+(((65535&C)+B|0)>>>16)|0),C+B<<16|65535&g|0)}(A|=0,g|=0),a=0|o(),0|(e((0|r(I,g))+(0|r(B,A))+a|0&a|0),0|C)}function RB(A,I,g,B,C){return A|=0,B|=0,C|=0,(g|=0)>>>0>0|0==(0|g)&(I|=0)>>>0>4294967295?(st(),0):0|function(A,I,g,B,C){var a,t;return A|=0,B|=0,a=h,t=h=h+63&-64,h=h+64|0,0==(0|(I|=0))&0==(0|(g|=0))||(JI(t,C|=0),Gg(t,B,0),tI(0|A,0,0|I),U(t,A,A,I,g),Lg(t,64)),h=a,0}(A,I,g,B,C)}function YB(A,I){m(A|=0,I|=0,I+120|0),m(A+40|0,I+40|0,I+80|0),m(A+80|0,I+80|0,I+120|0),m(A+120|0,I,I+40|0)}function LB(A,I){A|=0,I|=0;var g=0,B=0;g=0;do{a[(B=A+(g<<2)|0)>>2]=a[B>>2]^a[I+(g<<2)>>2],g=g+1|0}while(16!=(0|g))}function PB(A){A|=0;do{vB(A,32),B[A+31>>0]=31&B[A+31>>0]}while(!(0|mg(A)&&0==(0|Hg(A,32))))}function KB(A,I,g){return A|=0,I|=0,(0|(g|=0))<32?(e(I>>g|0),A>>>g|(I&(1<<g)-1)<<32-g):(e(0|((0|I)<0?-1:0)),I>>g-32|0)}function qB(A){var I,g;return I=h,g=h=h+63&-64,h=h+160|0,rA(g,A|=0),A=0|zB(g),h=I,0|A}function XB(A,I,g,B,C,a,t,r){return 0|IA(A|=0,I|=0,g|=0,B|=0,C|=0,a|=0,t|=0,r|=0)}function jB(A,I){I|=0;var g=0;A=16+(g=48+(A|=0)|0)|0;do{B[g>>0]=0|B[I>>0],g=g+1|0,I=I+1|0}while((0|g)<(0|A))}function TB(A,I){$A(A|=0,40+(I|=0)|0,I),OA(A+40|0,I+40|0,I),UI(A+80|0,I+80|0),m(A+120|0,I+120|0,112)}function VB(A,I){var g,B;A|=0,g=h,B=h=h+63&-64,h=h+128|0,function(A,I){UI(A|=0,I|=0),UI(A+40|0,I+40|0),UI(A+80|0,I+80|0)}(B,I|=0),Cg(A,B),h=g}function WB(A,I){I|=0;var g=0;A=16+(g=32+(A|=0)|0)|0;do{B[g>>0]=0|B[I>>0],g=g+1|0,I=I+1|0}while((0|g)<(0|A))}function zB(A){var I,g;return I=h,g=h=h+63&-64,h=h+32|0,pA(g,A|=0),A=0|Hg(g,32),h=I,0|A}function ZB(A,I){A|=0,I|=0;var g=0,C=0;g=0;do{B[(C=A+g|0)>>0]=B[C>>0]^B[I+g>>0],g=g+1|0}while(8!=(0|g))}function OB(A,I,g,B,C,a,t){return 0|EA(A|=0,I|=0,g|=0,B|=0,C|=0,a|=0,t|=0)}function $B(A,I,g){return A|=0,(0|(g|=0))<32?(e((I|=0)<<g|(A&(1<<g)-1<<32-g)>>>32-g|0),A<<g):(e(A<<g-32|0),0)}function AC(A,I,g){A|=0,I|=0,g|=0;var B=0;B=0;do{Sa(A,A),B=B+1|0}while((0|B)!=(0|I));w(A,A,g)}function IC(A,I,g,B,C,a,t){return tA(A|=0,I|=0,g|=0,B|=0,C|=0,a|=0,t|=0),0}function gC(A,I,g){return(g|=0)>>>0<256?0|R(A|=0,I|=0,255&g):(c(34180,34200,107,34253),0)}function BC(A,I){A|=0;var g=0;return(I|=0)>>>0<=4294967168&&0!=(0|(g=0|function(A){var I,g=0,B=0,C=0,t=0;if((A|=0)>>>0>=4294967168)return a[8886]=48,0;if(!(B=0|u(76+(I=A>>>0<11?16:A+11&-8)|0)))return 0;do{if(63&B){if(g=(C=((B+63&-64)-8-(B+-8)|0)>>>0>15?(B+63&-64)-8|0:56+(B+63&-64)|0)-(B+-8)|0,3&(A=0|a[B+-4>>2])){a[C+4>>2]=(-8&A)-g|1&a[C+4>>2]|2,a[C+((-8&A)-g)+4>>2]=1|a[C+((-8&A)-g)+4>>2],a[B+-4>>2]=g|1&a[B+-4>>2]|2,a[C+4>>2]=1|a[C+4>>2],x(B+-8|0,g),t=C,A=C;break}a[C>>2]=(0|a[B+-8>>2])+g,a[C+4>>2]=(-8&A)-g,t=C,A=C;break}t=B+-8|0,A=B+-8|0}while(0);return 3&(A=0|a[(g=A+4|0)>>2])|0&&(-8&A)>>>0>(I+16|0)>>>0&&(C=t+I|0,a[g>>2]=I|1&A|2,a[C+4>>2]=(-8&A)-I|3,a[(B=t+(-8&A)+4|0)>>2]=1|a[B>>2],x(C,(-8&A)-I|0)),0|t+8}(I)))?(a[A>>2]=g,I=0):I=48,0|I}function CC(A,I,g){return A|=0,I|=0,(0|(g|=0))<32?(e(I>>>g|0),A>>>g|(I&(1<<g)-1)<<32-g):(e(0),I>>>g-32|0)}function aC(A,I){A|=0,I|=0;var g=0;g=0;do{SC(A+(g<<2)|0,0|a[I+(g<<2)>>2]),g=g+1|0}while(8!=(0|g))}function tC(A){var I,g;return g=h,I=h=h+63&-64,h=h+32|0,pA(I,A|=0),h=g,1&B[I>>0]|0}function rC(A,I,g){NA(A|=0,I|=0,255&(g|=0)),NA(A+40|0,I+40|0,255&g),NA(A+80|0,I+80|0,255&g)}function QC(A,I,g,B,C,a,t){return 0|yB(A|=0,I|=0,g|=0,B|=0,C|=0,a|=0,t|=0)}function eC(A,I,g,B,C,a,t){return 0|MA(A|=0,I|=0,1,g|=0,B|=0,C|=0,16,a|=0,t|=0,0,0,2)}function oC(A,I,g,B,C,a,t){return 0|MA(A|=0,I|=0,1,g|=0,B|=0,C|=0,16,a|=0,t|=0,0,0,1)}function cC(A){A|=0;var I=0;for(I=0;0|B[A+I>>0];)if((I=I+1|0)>>>0>=102){I=102;break}return 0|I}function iC(A,I){A|=0,I|=0;var g=0;g=0;do{a[A+(g<<2)>>2]=a[I+(g<<2)>>2],g=g+1|0}while(16!=(0|g))}function _C(A,I){(function(A,I){A|=0,0|(I|=0)&&(0|(I=0|a[A>>2])&&Lg(0|a[I+4>>2],a[A+16>>2]<<10),0|(I=0|a[A+4>>2])&&Lg(I,a[A+20>>2]<<3))})(A|=0,4&(I|=0)),S(0|a[A+4>>2]),a[A+4>>2]=0,function(A){var I=0;0|(A|=0)&&0|(I=0|a[A>>2])&&S(I),S(A)}(0|a[A>>2]),a[A>>2]=0}function EC(A,I){m(A|=0,I|=0,I+120|0),m(A+40|0,I+40|0,I+80|0),m(A+80|0,I+80|0,I+120|0)}function nC(A,I,g,B,C,a){return 0|ng(A|=0,I|=0,g|=0,B|=0,C|=0,0,0,a|=0)}function sC(A,I,g,B,C,a){return qA(A|=0,I|=0,g|=0,B|=0,C|=0,a|=0,0),0}function yC(A,I,g,B,C,a){return 0|HI(A|=0,I|=0,g|=0,B|=0,C|=0,a|=0)}function hC(A,I,g,B,C,a){return 0|MA(A|=0,I|=0,1,g|=0,B|=0,C|=0,16,0,32,a|=0,128,2)}function pC(A,I,g,B,C,a){return 0|MA(A|=0,I|=0,1,g|=0,B|=0,C|=0,16,0,32,a|=0,128,1)}function fC(A,I,g,B,C,a){return 0|IA(A|=0,I|=0,g|=0,B|=0,C|=0,0,0,a|=0)}function wC(A,I,g,B,C){return 0|VA(A|=0,I|=0,g|=0,B|=0,C|=0,0)}function lC(A,I,g,B,C){return 0|function(A,I,g,B,C){var a,t;return A|=0,a=h,t=h=h+63&-64,h=h+16|0,Vg(t,I|=0,g|=0,B|=0,C|=0),C=0|ba(A,t),h=a,0|C}(A|=0,I|=0,g|=0,B|=0,C|=0)}function uC(A,I,g,B,C,a){return 0|tg(A|=0,I|=0,g|=0,B|=0,C|=0,a|=0)}function DC(A){B[32+(A|=0)>>0]=1,B[A+32+1>>0]=0,B[A+32+2>>0]=0,B[A+32+3>>0]=0}function mC(A){var I;a[(A|=0)>>2]=1,I=36+(A=A+4|0)|0;do{a[A>>2]=0,A=A+4|0}while((0|A)<(0|I))}function FC(A,I,g,B){return 0|(e(0|(B=(I|=0)-(B|=0)-((g|=0)>>>0>(A|=0)>>>0|0)>>>0)),A-g>>>0|0)}function kC(A,I,g,B,C){return 0|Vg(A|=0,I|=0,g|=0,B|=0,C|=0)}function bC(A,I,g,B){return 0|(e((I|=0)+(B|=0)+((A|=0)+(g|=0)>>>0>>>0<A>>>0|0)>>>0|0),A+g>>>0|0)}function dC(A,I){I|=0,Og(A|=0),0|I&&q(A,33968,34,0)}function HC(A,I){var g;return g=0|a[(A|=0)-64+((I|=0)<<7)>>2],e(0|a[A+-64+(I<<7)+4>>2]),0|g}function GC(A,I,g,B){return 0|function(A,I,g,B){return Z(A|=0,I|=0,g|=0,B|=0),0}(A|=0,I|=0,g|=0,B|=0)}function SC(A,I){I|=0,B[3+(A|=0)>>0]=I,B[A+2>>0]=I>>>8,B[A+1>>0]=I>>>16,B[A>>0]=I>>>24}function xC(A,I){return A|=0,I=0|PA(255&(I|=0)),a[A>>2]=0==(0|I)?0:I-35361|0,(0==(0|I))<<31>>31|0}function UC(A,I){I|=0,B[(A|=0)>>0]=I,B[A+1>>0]=I>>8,B[A+2>>0]=I>>16,B[A+3>>0]=I>>24}function MC(A,I,g,B){return XC(A|=0,I|=0,g|=0,B|=0),0}function JC(A,I){return A|=0,vB(I|=0,32),0|ea(A,I)}function vC(A){return(0|t[2+(A|=0)>>0])<<8|0|t[A+3>>0]|(0|t[A+1>>0])<<16|(0|t[A>>0])<<24|0}function NC(A,I,g,B){return z(A|=0,I|=0,g|=0,B|=0),0}function RC(A,I,g,B,C){return 0|nA(A|=0,I|=0,g|=0,B|=0,C|=0)}function YC(A,I,g,B){return q(A|=0,I|=0,g|=0,B|=0),0}function LC(A,I,g,B){return 0|jA(A|=0,I|=0,g|=0,B|=0,2)}function PC(A,I,g,B){return 0|jA(A|=0,I|=0,g|=0,B|=0,1)}function KC(A,I,g,B){return 0|bg(A|=0,I|=0,g|=0,B|=0)}function qC(A,I,g,B){return YC(A|=0,I|=0,g|=0,B|=0),0}function XC(A,I,g,B){return oA(A|=0,I|=0,g|=0,B|=0),0}function jC(A){var I;I=40+(A|=0)|0;do{a[A>>2]=0,A=A+4|0}while((0|A)<(0|I))}function TC(A){B[(A|=0)>>0]=-8&B[A>>0],B[A+31>>0]=64|B[A+31>>0]}function VC(A,I,g){return 0|Mg(A|=0,I|=0,g|=0)}function WC(A){B[(A|=0)>>0]=-8&B[A>>0],B[A+31>>0]=63&B[A+31>>0]|64}function zC(A,I){return A=0|ZA(A|=0,I|=0),0|((0|B[A>>0])==(255&I)<<24>>24?A:0)}function ZC(A,I,g,B){return L(A|=0,I|=0,g|=0,B|=0,12),0}function OC(A,I,g,B){return L(A|=0,I|=0,g|=0,B|=0,8),0}function $C(A,I,g,B){return L(A|=0,I|=0,g|=0,B|=0,20),0}function Aa(A,I){return function(A,I){var g,B;A|=0,g=h,B=h=h+63&-64,h=h+256|0,Sa(B+224|0,I|=0),Sa(B+192|0,B+224|0),w(B+160|0,B+224|0,I),w(B+128|0,B+224|0,B+160|0),w(B+96|0,B+224|0,B+128|0),w(B+64|0,B+224|0,B+96|0),w(B+32|0,B+224|0,B+64|0),w(B,B+192|0,B+32|0),w(A,B,I),AC(A,126,B+128|0),AC(A,4,B+160|0),AC(A,5,B),AC(A,5,B),AC(A,4,B+64|0),AC(A,2,B+160|0),AC(A,5,B),AC(A,4,B+128|0),AC(A,6,B+128|0),AC(A,3,B+96|0),AC(A,5,B),AC(A,5,B+96|0),AC(A,4,B+160|0),AC(A,5,B+32|0),AC(A,6,B+32|0),AC(A,10,B+64|0),AC(A,4,B+160|0),AC(A,5,B+160|0),AC(A,5,B+160|0),AC(A,5,B+64|0),AC(A,4,B+96|0),AC(A,6,B),AC(A,5,B+32|0),AC(A,3,B+128|0),AC(A,6,B),AC(A,3,B+128|0),AC(A,3,B+160|0),h=g}(A|=0,I|=0),0-(0|Hg(I,32))|0}function Ia(A,I,g){return dA(A|=0,I|=0,g|=0),0}function ga(A){return t[(A|=0)>>0]|t[A+1>>0]<<8|t[A+2>>0]<<16|t[A+3>>0]<<24|0}function Ba(A,I,g){return 0|gC(A|=0,I|=0,g|=0)}function Ca(A){B[(A|=0)>>0]=0,B[A+1>>0]=0,B[A+2>>0]=0,B[A+3>>0]=0}function aa(A){var I;0|(I=0|a[(A|=0)>>2])&&S(I),pa(A)}function ta(A){jC(A|=0),mC(A+40|0),mC(A+80|0),jC(A+120|0)}function ra(A){a[(A|=0)>>2]=0,a[A+4>>2]=0,a[A+8>>2]=0,a[A+12>>2]=0}function Qa(A,I,g){!function(A,I,g){var B,C,a;A|=0,I|=0,B=h,a=h=h+63&-64,h=h+128|0,g=((g|=0)<<24>>24)-((0-(255&(C=0|Pa(g)))&g<<24>>24)<<1)&255,function(A){mC(A|=0),mC(A+40|0),jC(A+80|0)}(A),rC(A,I,0|Da(g,1)),rC(A,I+120|0,0|Da(g,2)),rC(A,I+240|0,0|Da(g,3)),rC(A,I+360|0,0|Da(g,4)),rC(A,I+480|0,0|Da(g,5)),rC(A,I+600|0,0|Da(g,6)),rC(A,I+720|0,0|Da(g,7)),rC(A,I+840|0,0|Da(g,8)),UI(a,A+40|0),UI(a+40|0,A),lI(a+80|0,A+80|0),rC(A,a,C),h=B}(A|=0,1120+(960*(I|=0)|0)|0,g|=0)}function ea(A,I){return 0|qI(A|=0,I|=0)}function oa(A,I){return 0|function(A,I){return BA(A|=0,I|=0),0}(A|=0,I|=0)}function ca(A,I){return 0|function(A,I){return eI(A|=0,I|=0),0}(A|=0,I|=0)}function ia(A,I,g,B){return 0|N(A|=0,I|=0,g|=0,B|=0,0)}function _a(A,I,g){return 0|ag(A|=0,I|=0,g|=0)}function Ea(A,I){return 0|JC(A|=0,I|=0)}function na(A,I,g){w(A|=0,I|=0,g|=0)}function sa(A){1!=(-7&(A|=0)|0)&&st()}function ya(A,I){return function(A,I){var g,B;A|=0,g=h,B=h=h+63&-64,h=h+896|0,J(B+48|0,I|=0),J(B,I+32|0),hA(B+408|0,B+48|0),hA(B+248|0,B),TB(B+728|0,B+248|0),RI(B+568|0,B+408|0,B+728|0),YB(B+88|0,B+568|0),fA(A,B+88|0),h=g}(A|=0,I|=0),0}function ha(A,I){return 0|ea(A|=0,I|=0)}function pa(A){a[4+(A|=0)>>2]=0,a[A>>2]=0,a[A+8>>2]=0}function fa(A,I,g){return 0|lA(A|=0,I|=0,g|=0,2)}function wa(A,I,g){return 0|lA(A|=0,I|=0,g|=0,1)}function la(A,I){xB(A|=0,I|=0,0|tC(I))}function ua(A,I){return AI(A|=0,I|=0),0}function Da(A,I){return((255&((I|=0)^(A|=0)))-1|0)>>>31&255|0}function ma(A){return 0|((A|=0)?31-(0|Q(A^A-1))|0:32)}function Fa(A,I){return 0|ZI(A|=0,I|=0,64)}function ka(A,I){return 0|ZI(A|=0,I|=0,32)}function ba(A,I){return 0|ZI(A|=0,I|=0,16)}function da(A,I){sA(0|(A|=0),0|(I|=0),1024)}function Ha(A){return Og(A|=0),0}function Ga(A,I){return(A|=0)>>>(32-(I|=0)|0)|A<<I|0}function Sa(A,I){w(A|=0,I|=0,I)}function xa(A,I){return(A|=0)<<32-(I|=0)|A>>>I|0}function Ua(A){tI(0|(A|=0),0,1024)}function Ma(A){aa(A|=0)}function Ja(A){vB(A|=0,32)}function va(){return 16777216}function Na(A){pa(A|=0)}function Ra(){return 33554432}function Ya(){_(1)}function La(){return 0|_(0)}function Pa(A){return(255&(A|=0))>>>7|0}function Ka(){return 1073741824}function qa(){return 67108864}function Xa(){return 12}function ja(){return 268435456}function Ta(){return-2147483648}function Va(){return 416}function Wa(){return 4}function za(){return 256}function Za(){return 384}function Oa(){return-65}function $a(){return 8192}function At(){return-17}function It(){return 3}function gt(){return 34384}function Bt(){return 1}function Ct(){return 2}function at(){return 208}function tt(){return 128}function rt(){return-1}function Qt(){return 34293}function et(){return 8}function ot(){return 24}function ct(){return 48}function it(){return 16}function _t(){return 64}function Et(){return 32}function nt(){return 0}function st(){i()}return{___errno_location:function(){return 35544},___muldi3:NB,___udivdi3:ia,___uremdi3:GB,_bitshift64Ashr:KB,_bitshift64Lshr:CC,_bitshift64Shl:$B,_crypto_aead_chacha20poly1305_abytes:it,_crypto_aead_chacha20poly1305_decrypt:function(A,I,g,B,C,t,r,Q,e,c,i){I|=0,g|=0,B|=0,r|=0,Q|=0,e|=0,c|=0,i|=0;var _=0,E=0;return(t|=0)>>>0>0|0==(0|t)&(C|=0)>>>0>15?(t=0|LA(A|=0,0,B,g=0|bC(0|C,0|t,-16,-1),_=0|o(),B+C+-16|0,r,Q,e,c,i),I&&(C=0==(0|t)?g:0,g=0==(0|t)?_:0,E=4)):I?(C=0,g=0,t=-1,E=4):t=-1,4==(0|E)&&(a[I>>2]=C,a[I+4>>2]=g),0|t},_crypto_aead_chacha20poly1305_decrypt_detached:LA,_crypto_aead_chacha20poly1305_encrypt:function(A,I,g,B,C,t,r,Q,e,c,i){return A|=0,I|=0,g|=0,t|=0,r|=0,Q|=0,e|=0,c|=0,i|=0,(C|=0)>>>0>0|0==(0|C)&(B|=0)>>>0>4294967279&&st(),II(A,A+B|0,0,g,B,C,t,r,Q,0,c,i),0|I&&(c=0|bC(0|B,0|C,16,0),e=0|o(),a[I>>2]=c,a[I+4>>2]=e),0},_crypto_aead_chacha20poly1305_encrypt_detached:II,_crypto_aead_chacha20poly1305_ietf_abytes:it,_crypto_aead_chacha20poly1305_ietf_decrypt:function(A,I,g,B,C,t,r,Q,e,c,i){I|=0,g|=0,B|=0,r|=0,Q|=0,e|=0,c|=0,i|=0;var _=0,E=0;return(t|=0)>>>0>0|0==(0|t)&(C|=0)>>>0>15?(t=0|uA(A|=0,0,B,g=0|bC(0|C,0|t,-16,-1),_=0|o(),B+C+-16|0,r,Q,e,c,i),I&&(C=0==(0|t)?g:0,g=0==(0|t)?_:0,E=4)):I?(C=0,g=0,t=-1,E=4):t=-1,4==(0|E)&&(a[I>>2]=C,a[I+4>>2]=g),0|t},_crypto_aead_chacha20poly1305_ietf_decrypt_detached:uA,_crypto_aead_chacha20poly1305_ietf_encrypt:function(A,I,g,B,C,t,r,Q,e,c,i){return A|=0,I|=0,g|=0,t|=0,r|=0,Q|=0,e|=0,c|=0,i|=0,(C|=0)>>>0>0|0==(0|C)&(B|=0)>>>0>4294967279&&st(),JA(A,A+B|0,0,g,B,C,t,r,Q,0,c,i),0|I&&(c=0|bC(0|B,0|C,16,0),e=0|o(),a[I>>2]=c,a[I+4>>2]=e),0},_crypto_aead_chacha20poly1305_ietf_encrypt_detached:JA,_crypto_aead_chacha20poly1305_ietf_keybytes:Et,_crypto_aead_chacha20poly1305_ietf_keygen:Ja,_crypto_aead_chacha20poly1305_ietf_messagebytes_max:At,_crypto_aead_chacha20poly1305_ietf_npubbytes:Xa,_crypto_aead_chacha20poly1305_ietf_nsecbytes:nt,_crypto_aead_chacha20poly1305_keybytes:Et,_crypto_aead_chacha20poly1305_keygen:Ja,_crypto_aead_chacha20poly1305_messagebytes_max:At,_crypto_aead_chacha20poly1305_npubbytes:et,_crypto_aead_chacha20poly1305_nsecbytes:nt,_crypto_aead_xchacha20poly1305_ietf_abytes:it,_crypto_aead_xchacha20poly1305_ietf_decrypt:function(A,I,g,B,C,t,r,Q,e,c,i){I|=0,g|=0,B|=0,r|=0,Q|=0,e|=0,c|=0,i|=0;var _=0,E=0;return(t|=0)>>>0>0|0==(0|t)&(C|=0)>>>0>15?(t=0|sI(A|=0,0,B,g=0|bC(0|C,0|t,-16,-1),_=0|o(),B+C+-16|0,r,Q,e,c,i),I&&(C=0==(0|t)?g:0,g=0==(0|t)?_:0,E=4)):I?(C=0,g=0,t=-1,E=4):t=-1,4==(0|E)&&(a[I>>2]=C,a[I+4>>2]=g),0|t},_crypto_aead_xchacha20poly1305_ietf_decrypt_detached:sI,_crypto_aead_xchacha20poly1305_ietf_encrypt:function(A,I,g,B,C,t,r,Q,e,c,i){return A|=0,I|=0,g|=0,t|=0,r|=0,Q|=0,e|=0,c|=0,i|=0,(C|=0)>>>0>0|0==(0|C)&(B|=0)>>>0>4294967279&&st(),yI(A,A+B|0,0,g,B,C,t,r,Q,0,c,i),0|I&&(c=0|bC(0|B,0|C,16,0),e=0|o(),a[I>>2]=c,a[I+4>>2]=e),0},_crypto_aead_xchacha20poly1305_ietf_encrypt_detached:yI,_crypto_aead_xchacha20poly1305_ietf_keybytes:Et,_crypto_aead_xchacha20poly1305_ietf_keygen:Ja,_crypto_aead_xchacha20poly1305_ietf_messagebytes_max:At,_crypto_aead_xchacha20poly1305_ietf_npubbytes:ot,_crypto_aead_xchacha20poly1305_ietf_nsecbytes:nt,_crypto_auth:function(A,I,g,B,C){return zg(A|=0,I|=0,g|=0,B|=0,C|=0),0},_crypto_auth_bytes:Et,_crypto_auth_hmacsha256:jg,_crypto_auth_hmacsha256_bytes:Et,_crypto_auth_hmacsha256_final:aB,_crypto_auth_hmacsha256_init:HA,_crypto_auth_hmacsha256_keybytes:Et,_crypto_auth_hmacsha256_keygen:Ja,_crypto_auth_hmacsha256_statebytes:at,_crypto_auth_hmacsha256_update:NC,_crypto_auth_hmacsha256_verify:function(A,I,g,B,C){var a;return A|=0,a=h,h=h+32|0,jg(a,I|=0,g|=0,B|=0,C|=0),C=0|ka(A,a),C=0|((0|a)==(0|A)?-1:C)|XI(a,A,32),h=a,0|C},_crypto_auth_hmacsha512:Wg,_crypto_auth_hmacsha512256:zg,_crypto_auth_hmacsha512256_bytes:Et,_crypto_auth_hmacsha512256_final:qg,_crypto_auth_hmacsha512256_init:Ia,_crypto_auth_hmacsha512256_keybytes:Et,_crypto_auth_hmacsha512256_keygen:Ja,_crypto_auth_hmacsha512256_statebytes:Va,_crypto_auth_hmacsha512256_update:qC,_crypto_auth_hmacsha512256_verify:Jg,_crypto_auth_hmacsha512_bytes:_t,_crypto_auth_hmacsha512_final:CB,_crypto_auth_hmacsha512_init:dA,_crypto_auth_hmacsha512_keybytes:Et,_crypto_auth_hmacsha512_keygen:Ja,_crypto_auth_hmacsha512_statebytes:Va,_crypto_auth_hmacsha512_update:YC,_crypto_auth_hmacsha512_verify:function(A,I,g,B,C){var a;return A|=0,a=h,h=h+64|0,Wg(a,I|=0,g|=0,B|=0,C|=0),C=0|Fa(A,a),C=0|((0|a)==(0|A)?-1:C)|XI(a,A,64),h=a,0|C},_crypto_auth_keybytes:Et,_crypto_auth_keygen:Ja,_crypto_auth_primitive:function(){return 34048},_crypto_auth_verify:function(A,I,g,B,C){return 0|Jg(A|=0,I|=0,g|=0,B|=0,C|=0)},_crypto_box:function(A,I,g,B,C,a,t){return 0|_g(A|=0,I|=0,g|=0,B|=0,C|=0,a|=0,t|=0)},_crypto_box_afternm:function(A,I,g,B,C,a){return 0|uC(A|=0,I|=0,g|=0,B|=0,C|=0,a|=0)},_crypto_box_beforenm:VC,_crypto_box_beforenmbytes:Et,_crypto_box_boxzerobytes:it,_crypto_box_curve25519xchacha20poly1305_beforenm:Ug,_crypto_box_curve25519xchacha20poly1305_beforenmbytes:Et,_crypto_box_curve25519xchacha20poly1305_detached:VI,_crypto_box_curve25519xchacha20poly1305_detached_afternm:UB,_crypto_box_curve25519xchacha20poly1305_easy:Ng,_crypto_box_curve25519xchacha20poly1305_easy_afternm:function(A,I,g,B,C,a){return A|=0,I|=0,C|=0,a|=0,(B|=0)>>>0>0|0==(0|B)&(g|=0)>>>0>4294967279?(st(),0):(UB(A+16|0,A,I,g,B,C,a),0)},_crypto_box_curve25519xchacha20poly1305_keypair:JC,_crypto_box_curve25519xchacha20poly1305_macbytes:it,_crypto_box_curve25519xchacha20poly1305_messagebytes_max:At,_crypto_box_curve25519xchacha20poly1305_noncebytes:ot,_crypto_box_curve25519xchacha20poly1305_open_detached:jI,_crypto_box_curve25519xchacha20poly1305_open_detached_afternm:kB,_crypto_box_curve25519xchacha20poly1305_open_easy:lg,_crypto_box_curve25519xchacha20poly1305_open_easy_afternm:function(A,I,g,B,C,a){return I|=0,C|=0,a|=0,0|((B|=0)>>>0<0|0==(0|B)&(g|=0)>>>0<16?-1:0|kB(A|=0,I+16|0,I,g=0|bC(0|g,0|B,-16,-1),0|o(),C,a))},_crypto_box_curve25519xchacha20poly1305_publickeybytes:Et,_crypto_box_curve25519xchacha20poly1305_seal:function(A,I,g,C,a){A|=0,I|=0,g|=0,C|=0,a|=0;var t,r,Q=0,e=0,o=0;if(r=h,t=h=h+63&-64,h=h+96|0,0|JC(t+32|0,t))g=-1;else{e=t+32|0,o=(Q=A)+32|0;do{B[Q>>0]=0|B[e>>0],Q=Q+1|0,e=e+1|0}while((0|Q)<(0|o));Sg(t+64|0,t+32|0,a),g=0|Ng(A+32|0,I,g,C,t+64|0,a,t),Lg(t,32),Lg(t+32|0,32),Lg(t+64|0,24)}return h=r,0|g},_crypto_box_curve25519xchacha20poly1305_seal_open:function(A,I,g,B,C,a){var t,r;return A|=0,I|=0,C|=0,a|=0,r=h,t=h=h+63&-64,h=h+32|0,(B|=0)>>>0<0|0==(0|B)&(g|=0)>>>0<48?g=-1:(B=0|bC(0|g,0|B,-32,-1),g=0|o(),Sg(t,I,C),g=0|lg(A,I+32|0,B,g,t,I,a)),h=r,0|g},_crypto_box_curve25519xchacha20poly1305_sealbytes:ct,_crypto_box_curve25519xchacha20poly1305_secretkeybytes:Et,_crypto_box_curve25519xchacha20poly1305_seed_keypair:rg,_crypto_box_curve25519xchacha20poly1305_seedbytes:Et,_crypto_box_curve25519xsalsa20poly1305:_g,_crypto_box_curve25519xsalsa20poly1305_afternm:uC,_crypto_box_curve25519xsalsa20poly1305_beforenm:Mg,_crypto_box_curve25519xsalsa20poly1305_beforenmbytes:Et,_crypto_box_curve25519xsalsa20poly1305_boxzerobytes:it,_crypto_box_curve25519xsalsa20poly1305_keypair:JC,_crypto_box_curve25519xsalsa20poly1305_macbytes:it,_crypto_box_curve25519xsalsa20poly1305_messagebytes_max:At,_crypto_box_curve25519xsalsa20poly1305_noncebytes:ot,_crypto_box_curve25519xsalsa20poly1305_open:cg,_crypto_box_curve25519xsalsa20poly1305_open_afternm:yC,_crypto_box_curve25519xsalsa20poly1305_publickeybytes:Et,_crypto_box_curve25519xsalsa20poly1305_secretkeybytes:Et,_crypto_box_curve25519xsalsa20poly1305_seed_keypair:rg,_crypto_box_curve25519xsalsa20poly1305_seedbytes:Et,_crypto_box_curve25519xsalsa20poly1305_zerobytes:Et,_crypto_box_detached:ug,_crypto_box_detached_afternm:IC,_crypto_box_easy:QB,_crypto_box_easy_afternm:function(A,I,g,B,C,a){return A|=0,I|=0,C|=0,a|=0,(B|=0)>>>0>0|0==(0|B)&(g|=0)>>>0>4294967279?(st(),0):(IC(A+16|0,A,I,g,B,C,a),0)},_crypto_box_keypair:Ea,_crypto_box_macbytes:it,_crypto_box_messagebytes_max:At,_crypto_box_noncebytes:ot,_crypto_box_open:function(A,I,g,B,C,a,t){return 0|cg(A|=0,I|=0,g|=0,B|=0,C|=0,a|=0,t|=0)},_crypto_box_open_afternm:function(A,I,g,B,C,a){return 0|yC(A|=0,I|=0,g|=0,B|=0,C|=0,a|=0)},_crypto_box_open_detached:wg,_crypto_box_open_detached_afternm:OB,_crypto_box_open_easy:vg,_crypto_box_open_easy_afternm:function(A,I,g,B,C,a){return I|=0,C|=0,a|=0,0|((B|=0)>>>0<0|0==(0|B)&(g|=0)>>>0<16?-1:0|OB(A|=0,I+16|0,I,g=0|bC(0|g,0|B,-16,-1),0|o(),C,a))},_crypto_box_primitive:function(){return 34062},_crypto_box_publickeybytes:Et,_crypto_box_seal:function(A,I,g,C,a){A|=0,I|=0,g|=0,C|=0,a|=0;var t,r=0,Q=0,e=0;if(t=h,h=h+96|0,0|Ea(t+32|0,t))g=-1;else{Q=t+32|0,e=(r=A)+32|0;do{B[r>>0]=0|B[Q>>0],r=r+1|0,Q=Q+1|0}while((0|r)<(0|e));Sg(t+64|0,t+32|0,a),g=0|QB(A+32|0,I,g,C,t+64|0,a,t),Lg(t,32),Lg(t+32|0,32),Lg(t+64|0,24)}return h=t,0|g},_crypto_box_seal_open:function(A,I,g,B,C,a){var t,r;return A|=0,I|=0,C|=0,a|=0,r=h,t=h=h+63&-64,h=h+32|0,(B|=0)>>>0<0|0==(0|B)&(g|=0)>>>0<48?g=-1:(B=0|bC(0|g,0|B,-32,-1),g=0|o(),Sg(t,I,C),g=0|vg(A,I+32|0,B,g,t,I,a)),h=r,0|g},_crypto_box_sealbytes:ct,_crypto_box_secretkeybytes:Et,_crypto_box_seed_keypair:function(A,I,g){return 0|rg(A|=0,I|=0,g|=0)},_crypto_box_seedbytes:Et,_crypto_box_zerobytes:Et,_crypto_core_ed25519_add:function(A,I,g){var B,C;return A|=0,g|=0,C=h,B=h=h+63&-64,h=h+800|0,0==(0|YA(B+640|0,I|=0))&&0!=(0|KI(B+640|0))&&0==(0|YA(B+480|0,g))&&0!=(0|KI(B+480|0))?(TB(B,B+480|0),RI(B+160|0,B+640|0,B),YB(B+320|0,B+160|0),yg(A,B+320|0),I=0):I=-1,h=C,0|I},_crypto_core_ed25519_bytes:Et,_crypto_core_ed25519_from_hash:ua,_crypto_core_ed25519_from_uniform:function(A,I){return Eg(A|=0,I|=0),0},_crypto_core_ed25519_hashbytes:_t,_crypto_core_ed25519_is_valid_point:function(A){var I,g;return g=h,I=h=h+63&-64,h=h+160|0,A=0!=(0|uB(A|=0))&&0==(0|gI(A))&&0==(0|YA(I,A))&&0!=(0|KI(I))?0!=(0|qB(I))&1:0,h=g,0|A},_crypto_core_ed25519_nonreducedscalarbytes:_t,_crypto_core_ed25519_random:function(A){var I,g;A|=0,I=h,g=h=h+63&-64,h=h+64|0,vB(g,64),ua(A,g),h=I},_crypto_core_ed25519_scalar_add:zA,_crypto_core_ed25519_scalar_complement:GA,_crypto_core_ed25519_scalar_invert:Aa,_crypto_core_ed25519_scalar_mul:na,_crypto_core_ed25519_scalar_negate:SA,_crypto_core_ed25519_scalar_random:PB,_crypto_core_ed25519_scalar_reduce:WI,_crypto_core_ed25519_scalar_sub:sB,_crypto_core_ed25519_scalarbytes:Et,_crypto_core_ed25519_sub:function(A,I,g){var B,C;return A|=0,g|=0,C=h,B=h=h+63&-64,h=h+800|0,0==(0|YA(B+640|0,I|=0))&&0!=(0|KI(B+640|0))&&0==(0|YA(B+480|0,g))&&0!=(0|KI(B+480|0))?(TB(B,B+480|0),NI(B+160|0,B+640|0,B),YB(B+320|0,B+160|0),yg(A,B+320|0),I=0):I=-1,h=C,0|I},_crypto_core_ed25519_uniformbytes:Et,_crypto_core_hchacha20:K,_crypto_core_hchacha20_constbytes:it,_crypto_core_hchacha20_inputbytes:it,_crypto_core_hchacha20_keybytes:Et,_crypto_core_hchacha20_outputbytes:Et,_crypto_core_hsalsa20:T,_crypto_core_hsalsa20_constbytes:it,_crypto_core_hsalsa20_inputbytes:it,_crypto_core_hsalsa20_keybytes:Et,_crypto_core_hsalsa20_outputbytes:Et,_crypto_core_ristretto255_add:function(A,I,g){var B,C;return A|=0,g|=0,C=h,B=h=h+63&-64,h=h+800|0,0==(0|UA(B+640|0,I|=0))&&0==(0|UA(B+480|0,g))?(TB(B,B+480|0),RI(B+160|0,B+640|0,B),YB(B+320|0,B+160|0),fA(A,B+320|0),I=0):I=-1,h=C,0|I},_crypto_core_ristretto255_bytes:Et,_crypto_core_ristretto255_from_hash:ya,_crypto_core_ristretto255_hashbytes:_t,_crypto_core_ristretto255_is_valid_point:function(A){var I,g;return I=h,g=h=h+63&-64,h=h+160|0,A=0==(0|UA(g,A|=0))&1,h=I,0|A},_crypto_core_ristretto255_nonreducedscalarbytes:_t,_crypto_core_ristretto255_random:function(A){var I,g;A|=0,I=h,g=h=h+63&-64,h=h+64|0,vB(g,64),ya(A,g),h=I},_crypto_core_ristretto255_scalar_add:function(A,I,g){zA(A|=0,I|=0,g|=0)},_crypto_core_ristretto255_scalar_complement:function(A,I){GA(A|=0,I|=0)},_crypto_core_ristretto255_scalar_invert:function(A,I){return 0|Aa(A|=0,I|=0)},_crypto_core_ristretto255_scalar_mul:na,_crypto_core_ristretto255_scalar_negate:function(A,I){SA(A|=0,I|=0)},_crypto_core_ristretto255_scalar_random:function(A){PB(A|=0)},_crypto_core_ristretto255_scalar_reduce:function(A,I){WI(A|=0,I|=0)},_crypto_core_ristretto255_scalar_sub:function(A,I,g){sB(A|=0,I|=0,g|=0)},_crypto_core_ristretto255_scalarbytes:Et,_crypto_core_ristretto255_sub:function(A,I,g){var B,C;return A|=0,g|=0,C=h,B=h=h+63&-64,h=h+800|0,0==(0|UA(B+640|0,I|=0))&&0==(0|UA(B+480|0,g))?(TB(B,B+480|0),NI(B+160|0,B+640|0,B),YB(B+320|0,B+160|0),fA(A,B+320|0),I=0):I=-1,h=C,0|I},_crypto_core_salsa20:$C,_crypto_core_salsa2012:ZC,_crypto_core_salsa2012_constbytes:it,_crypto_core_salsa2012_inputbytes:it,_crypto_core_salsa2012_keybytes:Et,_crypto_core_salsa2012_outputbytes:_t,_crypto_core_salsa208:OC,_crypto_core_salsa208_constbytes:it,_crypto_core_salsa208_inputbytes:it,_crypto_core_salsa208_keybytes:Et,_crypto_core_salsa208_outputbytes:_t,_crypto_core_salsa20_constbytes:it,_crypto_core_salsa20_inputbytes:it,_crypto_core_salsa20_keybytes:Et,_crypto_core_salsa20_outputbytes:_t,_crypto_generichash:QC,_crypto_generichash_blake2b:yB,_crypto_generichash_blake2b_bytes:Et,_crypto_generichash_blake2b_bytes_max:_t,_crypto_generichash_blake2b_bytes_min:it,_crypto_generichash_blake2b_final:gC,_crypto_generichash_blake2b_init:bg,_crypto_generichash_blake2b_init_salt_personal:function(A,I,g,B,C,a){A|=0,I|=0,g|=0,B|=0,C|=0,a|=0;do{if(!(g>>>0>64|(B+-1|0)>>>0>63)){if(0==(0|I)|0==(0|g)){aI(A,255&B,C,a),I=0;break}bA(A,255&B,I,255&g,C,a),I=0;break}I=-1}while(0);return 0|I},_crypto_generichash_blake2b_keybytes:Et,_crypto_generichash_blake2b_keybytes_max:_t,_crypto_generichash_blake2b_keybytes_min:it,_crypto_generichash_blake2b_keygen:Ja,_crypto_generichash_blake2b_personalbytes:it,_crypto_generichash_blake2b_salt_personal:Yg,_crypto_generichash_blake2b_saltbytes:it,_crypto_generichash_blake2b_statebytes:Za,_crypto_generichash_blake2b_update:XC,_crypto_generichash_bytes:Et,_crypto_generichash_bytes_max:_t,_crypto_generichash_bytes_min:it,_crypto_generichash_final:Ba,_crypto_generichash_init:KC,_crypto_generichash_keybytes:Et,_crypto_generichash_keybytes_max:_t,_crypto_generichash_keybytes_min:it,_crypto_generichash_keygen:Ja,_crypto_generichash_primitive:Qt,_crypto_generichash_statebytes:Za,_crypto_generichash_update:MC,_crypto_hash:function(A,I,g,B){return Xg(A|=0,I|=0,g|=0,B|=0),0},_crypto_hash_bytes:_t,_crypto_hash_primitive:function(){return 34286},_crypto_hash_sha256:function(A,I,g,B){var C,a;return A|=0,I|=0,g|=0,B|=0,C=h,a=h=h+63&-64,h=h+112|0,Fg(a),z(a,I,g,B),lB(a,A),h=C,0},_crypto_hash_sha256_bytes:Et,_crypto_hash_sha256_final:lB,_crypto_hash_sha256_init:Fg,_crypto_hash_sha256_statebytes:function(){return 104},_crypto_hash_sha256_update:z,_crypto_hash_sha512:Xg,_crypto_hash_sha512_bytes:_t,_crypto_hash_sha512_final:fB,_crypto_hash_sha512_init:Og,_crypto_hash_sha512_statebytes:at,_crypto_hash_sha512_update:q,_crypto_kdf_blake2b_bytes_max:_t,_crypto_kdf_blake2b_bytes_min:it,_crypto_kdf_blake2b_contextbytes:et,_crypto_kdf_blake2b_derive_from_key:EI,_crypto_kdf_blake2b_keybytes:Et,_crypto_kdf_bytes_max:_t,_crypto_kdf_bytes_min:it,_crypto_kdf_contextbytes:et,_crypto_kdf_derive_from_key:function(A,I,g,B,C,a){return 0|EI(A|=0,I|=0,g|=0,B|=0,C|=0,a|=0)},_crypto_kdf_keybytes:Et,_crypto_kdf_keygen:Ja,_crypto_kdf_primitive:Qt,_crypto_kx_client_session_keys:function(A,I,g,C,a){var t,r,Q;if(I|=0,g|=0,C|=0,a|=0,Q=h,r=h=h+63&-64,h=h+480|0,t=0==(0|(A|=0))?I:A,I=0==(0|I)?t:I,t||st(),0|_a(r+448|0,C,a))A=-1;else{KC(r,0,0,64),MC(r,r+448|0,32,0),Lg(r+448|0,32),MC(r,g,32,0),MC(r,a,32,0),Ba(r,r+384|0,64),Lg(r,384),A=0;do{B[t+A>>0]=0|B[r+384+A>>0],B[I+A>>0]=0|B[r+384+(A+32)>>0],A=A+1|0}while(32!=(0|A));Lg(r+384|0,64),A=0}return h=Q,0|A},_crypto_kx_keypair:function(A,I){return A|=0,vB(I|=0,32),0|ha(A,I)},_crypto_kx_primitive:function(){return 34301},_crypto_kx_publickeybytes:Et,_crypto_kx_secretkeybytes:Et,_crypto_kx_seed_keypair:function(A,I,g){return A|=0,QC(I|=0,32,g|=0,32,0,0,0),0|ha(A,I)},_crypto_kx_seedbytes:Et,_crypto_kx_server_session_keys:function(A,I,g,C,a){var t,r,Q;if(I|=0,g|=0,C|=0,a|=0,Q=h,r=h=h+63&-64,h=h+480|0,t=0==(0|(A|=0))?I:A,I=0==(0|I)?t:I,t||st(),0|_a(r+448|0,C,a))A=-1;else{KC(r,0,0,64),MC(r,r+448|0,32,0),Lg(r+448|0,32),MC(r,a,32,0),MC(r,g,32,0),Ba(r,r+384|0,64),Lg(r,384),A=0;do{B[I+A>>0]=0|B[r+384+A>>0],B[t+A>>0]=0|B[r+384+(A+32)>>0],A=A+1|0}while(32!=(0|A));Lg(r+384|0,64),A=0}return h=Q,0|A},_crypto_kx_sessionkeybytes:Et,_crypto_onetimeauth:function(A,I,g,B,C){return 0|kC(A|=0,I|=0,g|=0,B|=0,C|=0)},_crypto_onetimeauth_bytes:it,_crypto_onetimeauth_final:function(A,I){return 0|oa(A|=0,I|=0)},_crypto_onetimeauth_init:function(A,I){return 0|ca(A|=0,I|=0)},_crypto_onetimeauth_keybytes:Et,_crypto_onetimeauth_keygen:Ja,_crypto_onetimeauth_poly1305:kC,_crypto_onetimeauth_poly1305_bytes:it,_crypto_onetimeauth_poly1305_final:oa,_crypto_onetimeauth_poly1305_init:ca,_crypto_onetimeauth_poly1305_keybytes:Et,_crypto_onetimeauth_poly1305_keygen:Ja,_crypto_onetimeauth_poly1305_statebytes:za,_crypto_onetimeauth_poly1305_update:GC,_crypto_onetimeauth_poly1305_verify:lC,_crypto_onetimeauth_primitive:function(){return 34315},_crypto_onetimeauth_statebytes:za,_crypto_onetimeauth_update:function(A,I,g,B){return 0|GC(A|=0,I|=0,g|=0,B|=0)},_crypto_onetimeauth_verify:function(A,I,g,B,C){return 0|lC(A|=0,I|=0,g|=0,B|=0,C|=0)},_crypto_pwhash:function(A,I,g,B,C,t,r,Q,e,o,c){switch(A|=0,I|=0,g|=0,B|=0,C|=0,t|=0,r|=0,Q|=0,e|=0,o|=0,0|(c|=0)){case 1:I=0|CI(A,I,g,B,C,t,r,Q,e,o,1);break;case 2:I=0|rI(A,I,g,B,C,t,r,Q,e,o,2);break;default:a[8886]=28,I=-1}return 0|I},_crypto_pwhash_alg_argon2i13:Bt,_crypto_pwhash_alg_argon2id13:Ct,_crypto_pwhash_alg_default:Ct,_crypto_pwhash_argon2i:CI,_crypto_pwhash_argon2i_alg_argon2i13:Bt,_crypto_pwhash_argon2i_bytes_max:rt,_crypto_pwhash_argon2i_bytes_min:it,_crypto_pwhash_argon2i_memlimit_interactive:Ra,_crypto_pwhash_argon2i_memlimit_max:Ta,_crypto_pwhash_argon2i_memlimit_min:$a,_crypto_pwhash_argon2i_memlimit_moderate:function(){return 134217728},_crypto_pwhash_argon2i_memlimit_sensitive:function(){return 536870912},_crypto_pwhash_argon2i_opslimit_interactive:Wa,_crypto_pwhash_argon2i_opslimit_max:rt,_crypto_pwhash_argon2i_opslimit_min:It,_crypto_pwhash_argon2i_opslimit_moderate:function(){return 6},_crypto_pwhash_argon2i_opslimit_sensitive:et,_crypto_pwhash_argon2i_passwd_max:rt,_crypto_pwhash_argon2i_passwd_min:nt,_crypto_pwhash_argon2i_saltbytes:it,_crypto_pwhash_argon2i_str:hI,_crypto_pwhash_argon2i_str_needs_rehash:PC,_crypto_pwhash_argon2i_str_verify:pg,_crypto_pwhash_argon2i_strbytes:tt,_crypto_pwhash_argon2i_strprefix:function(){return 34395},_crypto_pwhash_argon2id:rI,_crypto_pwhash_argon2id_alg_argon2id13:Ct,_crypto_pwhash_argon2id_bytes_max:rt,_crypto_pwhash_argon2id_bytes_min:it,_crypto_pwhash_argon2id_memlimit_interactive:qa,_crypto_pwhash_argon2id_memlimit_max:Ta,_crypto_pwhash_argon2id_memlimit_min:$a,_crypto_pwhash_argon2id_memlimit_moderate:ja,_crypto_pwhash_argon2id_memlimit_sensitive:Ka,_crypto_pwhash_argon2id_opslimit_interactive:Ct,_crypto_pwhash_argon2id_opslimit_max:rt,_crypto_pwhash_argon2id_opslimit_min:Bt,_crypto_pwhash_argon2id_opslimit_moderate:It,_crypto_pwhash_argon2id_opslimit_sensitive:Wa,_crypto_pwhash_argon2id_passwd_max:rt,_crypto_pwhash_argon2id_passwd_min:nt,_crypto_pwhash_argon2id_saltbytes:it,_crypto_pwhash_argon2id_str:wI,_crypto_pwhash_argon2id_str_needs_rehash:LC,_crypto_pwhash_argon2id_str_verify:sg,_crypto_pwhash_argon2id_strbytes:tt,_crypto_pwhash_argon2id_strprefix:gt,_crypto_pwhash_bytes_max:rt,_crypto_pwhash_bytes_min:it,_crypto_pwhash_memlimit_interactive:qa,_crypto_pwhash_memlimit_max:Ta,_crypto_pwhash_memlimit_min:$a,_crypto_pwhash_memlimit_moderate:ja,_crypto_pwhash_memlimit_sensitive:Ka,_crypto_pwhash_opslimit_interactive:Ct,_crypto_pwhash_opslimit_max:rt,_crypto_pwhash_opslimit_min:Bt,_crypto_pwhash_opslimit_moderate:It,_crypto_pwhash_opslimit_sensitive:Wa,_crypto_pwhash_passwd_max:rt,_crypto_pwhash_passwd_min:nt,_crypto_pwhash_primitive:function(){return 34405},_crypto_pwhash_saltbytes:it,_crypto_pwhash_scryptsalsa208sha256:function(A,I,g,B,C,t,r,Q,e,c){var i,_;g|=0,B|=0,C|=0,t|=0,r|=0,Q|=0,e|=0,c|=0,_=h,i=h=h+63&-64,h=h+16|0,tI(0|(A|=0),0,0|(I|=0));do{if(!((t|g)>>>0>0|0==(t|g|0)&(C|I)>>>0>4294967295)){if(g>>>0<0|0==(0|g)&I>>>0<16){a[8886]=28,I=-1;break}FA(Q,e,c,i+8|0,i+4|0,i),I=0|og(B,C,r,32,e=0|$B(1,0,0|a[i+8>>2]),c=0|o(),0|a[i>>2],0|a[i+4>>2],A,I);break}a[8886]=22,I=-1}while(0);return h=_,0|I},_crypto_pwhash_scryptsalsa208sha256_bytes_max:rt,_crypto_pwhash_scryptsalsa208sha256_bytes_min:it,_crypto_pwhash_scryptsalsa208sha256_ll:og,_crypto_pwhash_scryptsalsa208sha256_memlimit_interactive:va,_crypto_pwhash_scryptsalsa208sha256_memlimit_max:rt,_crypto_pwhash_scryptsalsa208sha256_memlimit_min:va,_crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive:Ka,_crypto_pwhash_scryptsalsa208sha256_opslimit_interactive:function(){return 524288},_crypto_pwhash_scryptsalsa208sha256_opslimit_max:rt,_crypto_pwhash_scryptsalsa208sha256_opslimit_min:function(){return 32768},_crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive:Ra,_crypto_pwhash_scryptsalsa208sha256_passwd_max:rt,_crypto_pwhash_scryptsalsa208sha256_passwd_min:nt,_crypto_pwhash_scryptsalsa208sha256_saltbytes:Et,_crypto_pwhash_scryptsalsa208sha256_str:function(A,I,g,C,t,r,Q){I|=0,g|=0,C|=0,t|=0,r|=0,Q|=0;var e,o,c=0,i=0;o=h,e=h=h+63&-64,h=h+128|0,i=102+(c=A|=0)|0;do{B[c>>0]=0,c=c+1|0}while((0|c)<(0|i));do{if(C>>>0>0|0==(0|C)&g>>>0>4294967295)a[8886]=22,g=-1;else{if(FA(t,r,Q,e+104|0,e+100|0,e+96|0),vB(e+64|0,32),!(0|bI(0|a[e+104>>2],0|a[e+96>>2],0|a[e+100>>2],e+64|0,e))){a[8886]=28,g=-1;break}Na(e+108|0),i=0==(0|WA(e+108|0,I,g,e,A)),Ma(e+108|0),i?(a[8886]=28,g=-1):g=0}}while(0);return h=o,0|g},_crypto_pwhash_scryptsalsa208sha256_str_needs_rehash:function(A,I,g,B){var C,t;A|=0,t=h,C=h=h+63&-64,h=h+32|0,FA(I|=0,g|=0,B|=0,C+20|0,C+12|0,C+4|0);do{if(101==(0|cC(A))){if(!(0|Dg(A,C+16|0,C,C+8|0))){a[8886]=28,I=-1;break}I=(0|a[C+20>>2])==(0|a[C+16>>2])&&(0|a[C+4>>2])==(0|a[C>>2])?(0|a[C+12>>2])!=(0|a[C+8>>2])&1:1}else a[8886]=28,I=-1}while(0);return h=t,0|I},_crypto_pwhash_scryptsalsa208sha256_str_verify:function(A,I,g,B){I|=0,g|=0,B|=0;var t,r,Q=0;if(r=h,t=h=h+63&-64,h=h+128|0,101==(0|cC(A|=0))){Na(t+104|0),Q=(B=t)+100|0;do{a[B>>2]=0,B=B+4|0}while((0|B)<(0|Q));C[t+100>>1]=0,I=0==(0|WA(t+104|0,I,g,A,t)),Ma(t+104|0),I?B=-1:(B=0|XI(t,A,102),Lg(t,102))}else B=-1;return h=r,0|B},_crypto_pwhash_scryptsalsa208sha256_strbytes:function(){return 102},_crypto_pwhash_scryptsalsa208sha256_strprefix:function(){return 35426},_crypto_pwhash_str:function(A,I,g,B,C,a,t){return 0|wI(A|=0,I|=0,g|=0,B|=0,C|=0,a|=0,t|=0)},_crypto_pwhash_str_alg:function(A,I,g,B,C,a,t,r){A|=0,I|=0,g|=0,B|=0,C|=0,a|=0,t|=0;var Q=0;switch(0|(r|=0)){case 1:Q=0|hI(A,I,g,B,C,a,t);break;case 2:Q=0|wI(A,I,g,B,C,a,t);break;default:st()}return 0|Q},_crypto_pwhash_str_needs_rehash:function(A,I,g,B){A|=0,I|=0,g|=0,B|=0;do{if(0|$I(A,34384,10)){if(0|$I(A,34395,9)){a[8886]=28,I=-1;break}I=0|PC(A,I,g,B);break}I=0|LC(A,I,g,B)}while(0);return 0|I},_crypto_pwhash_str_verify:function(A,I,g,B){A|=0,I|=0,g|=0,B|=0;do{if(0|$I(A,34384,10)){if(0|$I(A,34395,9)){a[8886]=28,g=-1;break}g=0|pg(A,I,g,B);break}g=0|sg(A,I,g,B)}while(0);return 0|g},_crypto_pwhash_strbytes:tt,_crypto_pwhash_strprefix:gt,_crypto_scalarmult:_a,_crypto_scalarmult_base:ha,_crypto_scalarmult_bytes:Et,_crypto_scalarmult_curve25519:ag,_crypto_scalarmult_curve25519_base:ea,_crypto_scalarmult_curve25519_bytes:Et,_crypto_scalarmult_curve25519_scalarbytes:Et,_crypto_scalarmult_ed25519:function(A,I,g){return 0|cI(A|=0,I|=0,g|=0,1)},_crypto_scalarmult_ed25519_base:function(A,I){return 0|YI(A|=0,I|=0,1)},_crypto_scalarmult_ed25519_base_noclamp:function(A,I){return 0|YI(A|=0,I|=0,0)},_crypto_scalarmult_ed25519_bytes:Et,_crypto_scalarmult_ed25519_noclamp:function(A,I,g){return 0|cI(A|=0,I|=0,g|=0,0)},_crypto_scalarmult_ed25519_scalarbytes:Et,_crypto_scalarmult_primitive:function(){return 34413},_crypto_scalarmult_ristretto255:function(A,I,g){var C,a;if(A|=0,I|=0,a=h,C=h=h+63&-64,h=h+320|0,0|UA(C,g|=0))g=-1;else{g=0;do{B[A+g>>0]=0|B[I+g>>0],g=g+1|0}while(32!=(0|g));B[A+31>>0]=127&B[A+31>>0],W(C+160|0,A,C),fA(A,C+160|0),g=(0!=(0|Hg(A,32)))<<31>>31}return h=a,0|g},_crypto_scalarmult_ristretto255_base:function(A,I){A|=0,I|=0;var g,C=0,a=0;g=h,a=h=h+63&-64,h=h+160|0,C=0;do{B[A+C>>0]=0|B[I+C>>0],C=C+1|0}while(32!=(0|C));return B[A+31>>0]=127&B[A+31>>0],DA(a,A),fA(A,a),a=(0!=(0|Hg(A,32)))<<31>>31,h=g,0|a},_crypto_scalarmult_ristretto255_bytes:Et,_crypto_scalarmult_ristretto255_scalarbytes:Et,_crypto_scalarmult_scalarbytes:Et,_crypto_secretbox:uC,_crypto_secretbox_boxzerobytes:it,_crypto_secretbox_detached:tA,_crypto_secretbox_easy:function(A,I,g,B,C,a){return A|=0,I|=0,C|=0,a|=0,(B|=0)>>>0>0|0==(0|B)&(g|=0)>>>0>4294967279?(st(),0):(tA(A+16|0,A,I,g,B,C,a),0)},_crypto_secretbox_keybytes:Et,_crypto_secretbox_keygen:Ja,_crypto_secretbox_macbytes:it,_crypto_secretbox_messagebytes_max:At,_crypto_secretbox_noncebytes:ot,_crypto_secretbox_open:yC,_crypto_secretbox_open_detached:EA,_crypto_secretbox_open_easy:function(A,I,g,B,C,a){return I|=0,C|=0,a|=0,0|((B|=0)>>>0<0|0==(0|B)&(g|=0)>>>0<16?-1:0|EA(A|=0,I+16|0,I,g=0|bC(0|g,0|B,-16,-1),0|o(),C,a))},_crypto_secretbox_primitive:function(){return 34424},_crypto_secretbox_xchacha20poly1305_detached:aA,_crypto_secretbox_xchacha20poly1305_easy:function(A,I,g,B,C,a){return A|=0,I|=0,C|=0,a|=0,(B|=0)>>>0>0|0==(0|B)&(g|=0)>>>0>4294967279?(st(),0):(aA(A+16|0,A,I,g,B,C,a),0)},_crypto_secretbox_xchacha20poly1305_keybytes:Et,_crypto_secretbox_xchacha20poly1305_macbytes:it,_crypto_secretbox_xchacha20poly1305_messagebytes_max:At,_crypto_secretbox_xchacha20poly1305_noncebytes:ot,_crypto_secretbox_xchacha20poly1305_open_detached:_A,_crypto_secretbox_xchacha20poly1305_open_easy:function(A,I,g,B,C,a){return I|=0,C|=0,a|=0,0|((B|=0)>>>0<0|0==(0|B)&(g|=0)>>>0<16?-1:0|_A(A|=0,I+16|0,I,g=0|bC(0|g,0|B,-16,-1),0|o(),C,a))},_crypto_secretbox_xsalsa20poly1305:tg,_crypto_secretbox_xsalsa20poly1305_boxzerobytes:it,_crypto_secretbox_xsalsa20poly1305_keybytes:Et,_crypto_secretbox_xsalsa20poly1305_keygen:Ja,_crypto_secretbox_xsalsa20poly1305_macbytes:it,_crypto_secretbox_xsalsa20poly1305_messagebytes_max:At,_crypto_secretbox_xsalsa20poly1305_noncebytes:ot,_crypto_secretbox_xsalsa20poly1305_open:HI,_crypto_secretbox_xsalsa20poly1305_zerobytes:Et,_crypto_secretbox_zerobytes:Et,_crypto_secretstream_xchacha20poly1305_abytes:function(){return 17},_crypto_secretstream_xchacha20poly1305_headerbytes:ot,_crypto_secretstream_xchacha20poly1305_init_pull:function(A,I,g){var C;return K(A|=0,I|=0,g|=0,0),DC(A),C=t[I+16>>0]|t[I+16+1>>0]<<8|t[I+16+2>>0]<<16|t[I+16+3>>0]<<24,g=t[I+16+4>>0]|t[I+16+4+1>>0]<<8|t[I+16+4+2>>0]<<16|t[I+16+4+3>>0]<<24,B[A+36>>0]=C,B[A+36+1>>0]=C>>8,B[A+36+2>>0]=C>>16,B[A+36+3>>0]=C>>24,B[A+36+4>>0]=g,B[A+36+4+1>>0]=g>>8,B[A+36+4+2>>0]=g>>16,B[A+36+4+3>>0]=g>>24,B[A+44>>0]=0,B[A+44+1>>0]=0,B[A+44+2>>0]=0,B[A+44+3>>0]=0,B[A+44+4>>0]=0,B[A+44+4+1>>0]=0,B[A+44+4+2>>0]=0,B[A+44+4+3>>0]=0,0},_crypto_secretstream_xchacha20poly1305_init_push:function(A,I,g){return A|=0,g|=0,vB(I|=0,24),K(A,I,g,0),DC(A),g=t[I+16>>0]|t[I+16+1>>0]<<8|t[I+16+2>>0]<<16|t[I+16+3>>0]<<24,I=t[I+16+4>>0]|t[I+16+4+1>>0]<<8|t[I+16+4+2>>0]<<16|t[I+16+4+3>>0]<<24,B[A+36>>0]=g,B[A+36+1>>0]=g>>8,B[A+36+2>>0]=g>>16,B[A+36+3>>0]=g>>24,B[A+36+4>>0]=I,B[A+36+4+1>>0]=I>>8,B[A+36+4+2>>0]=I>>16,B[A+36+4+3>>0]=I>>24,B[A+44>>0]=0,B[A+44+1>>0]=0,B[A+44+2>>0]=0,B[A+44+3>>0]=0,B[A+44+4>>0]=0,B[A+44+4+1>>0]=0,B[A+44+4+2>>0]=0,B[A+44+4+3>>0]=0,0},_crypto_secretstream_xchacha20poly1305_keybytes:Et,_crypto_secretstream_xchacha20poly1305_keygen:Ja,_crypto_secretstream_xchacha20poly1305_messagebytes_max:function(){return-18},_crypto_secretstream_xchacha20poly1305_pull:function(A,I,g,C,t,r,Q,e,c,i){A|=0,I|=0,C|=0,t|=0,r|=0,Q|=0,e|=0,c|=0,i|=0;var _,E,n=0,s=0,y=0;E=h,_=h=h+63&-64,h=h+352|0,0|(g|=0)&&(a[g>>2]=0,a[g+4>>2]=0),0|C&&(B[C>>0]=-1);do{if(Q>>>0<0|0==(0|Q)&r>>>0<17)e=-1;else{s=0|bC(0|r,0|Q,-17,-1),(y=0|o())>>>0>0|0==(0|y)&s>>>0>4294967278&&st(),DB(_+16|0,64,0,A+32|0,A),ca(_+80|0,_+16|0),Lg(_+16|0,64),GC(_+80|0,e,c,i),e=0|FC(0,0,0|c,0|i),o(),GC(_+80|0,35488,15&e,0),n=64+(e=_+16|0)|0;do{a[e>>2]=0,e=e+4|0}while((0|e)<(0|n));if(B[_+16>>0]=0|B[t>>0],Ig(_+16|0,_+16|0,64,0,A+32|0,1,A),e=0|B[_+16>>0],B[_+16>>0]=0|B[t>>0],GC(_+80|0,_+16|0,64,0),GC(_+80|0,t+1|0,s,y),n=0|bC(0|r,0|Q,15,0),o(),GC(_+80|0,35488,15&n,0),tB(_+336|0,c,i),GC(_+80|0,_+336|0,8,0),tB(_+336|0,i=0|bC(0|r,0|Q,47,0),0|o()),GC(_+80|0,_+336|0,8,0),oa(_+80|0,_),Lg(_+80|0,256),0|XI(_,t+1+s|0,16)){Lg(_,16),e=-1;break}Ig(I,t+1|0,s,y,A+32|0,2,A),ZB(A+36|0,_),SB(A+32|0),(0!=(2&e)||0|Hg(A+32|0,4))&&RA(A),0|g&&(a[g>>2]=s,a[g+4>>2]=y),0|C?(B[C>>0]=e,e=0):e=0}}while(0);return h=E,0|e},_crypto_secretstream_xchacha20poly1305_push:function(A,I,g,C,t,r,Q,e,c,i){A|=0,I|=0,C|=0,t|=0,r|=0,Q|=0,e|=0,c|=0,i|=0;var _,E,n=0;E=h,n=h=h+63&-64,h=h+336|0,0|(g|=0)&&(a[g>>2]=0,a[g+4>>2]=0),r>>>0>0|0==(0|r)&t>>>0>4294967278&&st(),DB(n,64,0,A+32|0,A),ca(n+64|0,n),Lg(n,64),GC(n+64|0,Q,e,c),Q=0|FC(0,0,0|e,0|c),o(),GC(n+64|0,35488,15&Q,0),_=(Q=n)+64|0;do{a[Q>>2]=0,Q=Q+4|0}while((0|Q)<(0|_));return B[n>>0]=i,Ig(n,n,64,0,A+32|0,1,A),GC(n+64|0,n,64,0),B[I>>0]=0|B[n>>0],Ig(I+1|0,C,t,r,A+32|0,2,A),GC(n+64|0,I+1|0,t,r),GC(n+64|0,35488,15&t,0),tB(n+320|0,e,c),GC(n+64|0,n+320|0,8,0),tB(n+320|0,C=0|bC(0|t,0|r,64,0),0|o()),GC(n+64|0,n+320|0,8,0),oa(n+64|0,I+1+t|0),Lg(n+64|0,256),ZB(A+36|0,I+1+t|0),SB(A+32|0),(0!=(2&i)||0|Hg(A+32|0,4))&&RA(A),0|g&&(i=0|bC(0|t,0|r,17,0),n=0|o(),a[g>>2]=i,a[g+4>>2]=n),h=E,0},_crypto_secretstream_xchacha20poly1305_rekey:RA,_crypto_secretstream_xchacha20poly1305_statebytes:function(){return 52},_crypto_secretstream_xchacha20poly1305_tag_final:It,_crypto_secretstream_xchacha20poly1305_tag_message:nt,_crypto_secretstream_xchacha20poly1305_tag_push:Bt,_crypto_secretstream_xchacha20poly1305_tag_rekey:Ct,_crypto_shorthash:function(A,I,g,B,C){return G(A|=0,I|=0,g|=0,B|=0,C|=0),0},_crypto_shorthash_bytes:et,_crypto_shorthash_keybytes:it,_crypto_shorthash_keygen:function(A){vB(A|=0,16)},_crypto_shorthash_primitive:function(){return 34441},_crypto_shorthash_siphash24:G,_crypto_shorthash_siphash24_bytes:et,_crypto_shorthash_siphash24_keybytes:it,_crypto_shorthash_siphashx24:function(A,I,g,B,C){A|=0,I|=0,g|=0,B|=0;var a=0,r=0,Q=0,e=0,c=0,i=0,_=0,E=0,n=0,s=0,y=0,h=0,p=0,f=0,w=0,l=0,u=0;if(i=0|wB(C|=0),E=0|o(),a=0|wB(C+8|0),r=0|o(),B=0|$B(0|g,0|B,56),C=0|o(),(I+g+(0-(7&g))|0)==(0|I))y=2037671283^a,Q=1952801890^r,s=1886610805^i,_=1936682341^E,c=1852075907^a,e=1685025377^r,w=1852142177^i,a=1819895653^E,r=I;else for(f=2037671283^a,Q=1952801890^r,y=1886610805^i,_=1936682341^E,c=1852075907^a,e=1685025377^r,r=1852142177^i,a=1819895653^E,s=I;;){if(u=(h=0|wB(s))^f,Q^=p=0|o(),w=0|bC(0|y,0|_,0|c,0|e),f=0|o(),i=0|dB(c,e,13),c=(0|o())^f,e=0|dB(w,f,32),f=0|o(),E=0|bC(0|u,0|Q,0|r,0|a),n=0|o(),f=0|bC((Q=0|dB(u,Q,16))^E|0,0|(r=(0|o())^n),0|e,0|f),e=0|o(),r=0|dB(Q^E,r,21),Q=e^(0|o()),n=0|bC(0|E,0|n,i^w|0,0|c),E=0|o(),c=0|dB(i^w,c,17),a=(0|o())^E,E=0|dB(n,E,32),w=0|o(),e=0|bC(c^n|0,0|a,0|f,0|e),i=0|o(),a=0|dB(c^n,a,13),n=(0|o())^i,i=0|dB(e,i,32),c=0|o(),w=0|bC(0|E,0|w,f^r|0,0|Q),E=0|o(),c=0|bC((Q=0|dB(f^r,Q,16))^w|0,0|(r=(0|o())^E),0|i,0|c),i=0|o(),r=0|dB(Q^w,r,21),Q=i^(0|o()),E=0|bC(a^e|0,0|n,0|w,0|E),w=0|o(),n=0|dB(a^e,n,17),e=(0|o())^w,w=0|dB(E,w,32),a=0|o(),(0|(s=s+8|0))==(I+g+(0-(7&g))|0)){y=c^r,s=c^h,_=i^p,c=n^E,r=I+g+(0-(7&g))|0;break}f=c^r,y=c^h,_=i^p,c=n^E,r=w}switch(7&g){case 7:l=0|$B(0|t[r+6>>0],0,48),C=0|o()|C,B|=l,l=6;break;case 6:l=6;break;case 5:l=7;break;case 4:l=8;break;case 3:l=9;break;case 2:l=10;break;case 1:l=11}return 6==(0|l)&&(u=0|$B(0|t[r+5>>0],0,40),C=0|o()|C,B|=u,l=7),7==(0|l)&&(C=0|t[r+4>>0]|C,l=8),8==(0|l)&&(B|=u=0|$B(0|t[r+3>>0],0,24),C=0|o()|C,l=9),9==(0|l)&&(B|=u=0|$B(0|t[r+2>>0],0,16),C=0|o()|C,l=10),10==(0|l)&&(B|=u=0|$B(0|t[r+1>>0],0,8),C=0|o()|C,l=11),11==(0|l)&&(B=0|B|t[r>>0]),g=B^y,p=C^Q,I=0|bC(0|s,0|_,0|c,0|e),u=0|o(),l=0|dB(c,e,13),s=(0|o())^u,u=0|dB(I,u,32),h=0|o(),f=0|bC(0|g,0|p,0|w,0|a),y=0|o(),h=0|bC((p=0|dB(g,p,16))^f|0,0|(g=(0|o())^y),0|u,0|h),u=0|o(),g=0|dB(p^f,g,21),p=u^(0|o()),y=0|bC(0|f,0|y,l^I|0,0|s),f=0|o(),s=0|dB(l^I,s,17),I=(0|o())^f,f=0|dB(y,f,32),l=0|o(),u=0|bC(s^y|0,0|I,0|h,0|u),w=0|o(),I=0|dB(s^y,I,13),y=(0|o())^w,w=0|dB(u,w,32),s=0|o(),l=0|bC(0|f,0|l,h^g|0,0|p),f=0|o(),s=0|bC((p=0|dB(h^g,p,16))^l|0,0|(g=(0|o())^f),0|w,0|s),w=0|o(),g=0|dB(p^l,g,21),p=w^(0|o()),f=0|bC(I^u|0,0|y,0|l,0|f),l=0|o(),y=0|dB(I^u,y,17),u=(0|o())^l,l=0|dB(f,l,32),I=0|o(),w=0|bC(s^B|0,w^C|0,y^f|0,0|u),h=0|o(),u=0|dB(y^f,u,13),f=(0|o())^h,h=0|dB(w,h,32),y=0|o(),I=0|bC(238^l|0,0|I,s^g|0,0|p),l=0|o(),y=0|bC((p=0|dB(s^g,p,16))^I|0,0|(g=(0|o())^l),0|h,0|y),h=0|o(),g=0|dB(p^I,g,21),p=h^(0|o()),l=0|bC(0|I,0|l,u^w|0,0|f),I=0|o(),f=0|dB(u^w,f,17),w=(0|o())^I,I=0|dB(l,I,32),u=0|o(),h=0|bC(f^l|0,0|w,0|y,0|h),s=0|o(),w=0|dB(f^l,w,13),l=(0|o())^s,s=0|dB(h,s,32),f=0|o(),u=0|bC(0|I,0|u,y^g|0,0|p),I=0|o(),f=0|bC((p=0|dB(y^g,p,16))^u|0,0|(g=(0|o())^I),0|s,0|f),s=0|o(),g=0|dB(p^u,g,21),p=s^(0|o()),I=0|bC(w^h|0,0|l,0|u,0|I),u=0|o(),l=0|dB(w^h,l,17),h=(0|o())^u,u=0|dB(I,u,32),w=0|o(),s=0|bC(l^I|0,0|h,0|f,0|s),y=0|o(),h=0|dB(l^I,h,13),I=(0|o())^y,y=0|dB(s,y,32),l=0|o(),w=0|bC(0|u,0|w,f^g|0,0|p),u=0|o(),l=0|bC((p=0|dB(f^g,p,16))^w|0,0|(g=(0|o())^u),0|y,0|l),y=0|o(),g=0|dB(p^w,g,21),p=y^(0|o()),u=0|bC(h^s|0,0|I,0|w,0|u),w=0|o(),I=0|dB(h^s,I,17),s=(0|o())^w,w=0|dB(u,w,32),h=0|o(),y=0|bC(I^u|0,0|s,0|l,0|y),f=0|o(),s=0|dB(I^u,s,13),u=(0|o())^f,f=0|dB(y,f,32),I=0|o(),h=0|bC(0|w,0|h,l^g|0,0|p),w=0|o(),I=0|bC((p=0|dB(l^g,p,16))^h|0,0|(g=(0|o())^w),0|f,0|I),f=0|o(),g=0|dB(p^h,g,21),p=f^(0|o()),w=0|bC(s^y|0,0|u,0|h,0|w),h=0|o(),u=0|dB(s^y,u,17),y=(0|o())^h,tB(A,u^w^I^(h=0|dB(w,h,32))^I^g,y^f^(s=0|o())^p),f=0|bC(u^w^221|0,0|y,0|I,0|f),l=0|o(),y=0|dB(u^w^221,y,13),w=(0|o())^l,l=0|dB(f,l,32),u=0|o(),s=0|bC(0|h,0|s,I^g|0,0|p),h=0|o(),u=0|bC((p=0|dB(I^g,p,16))^s|0,0|(g=(0|o())^h),0|l,0|u),l=0|o(),g=0|dB(p^s,g,21),p=l^(0|o()),h=0|bC(y^f|0,0|w,0|s,0|h),s=0|o(),w=0|dB(y^f,w,17),f=(0|o())^s,s=0|dB(h,s,32),y=0|o(),l=0|bC(w^h|0,0|f,0|u,0|l),I=0|o(),f=0|dB(w^h,f,13),h=(0|o())^I,I=0|dB(l,I,32),w=0|o(),y=0|bC(0|s,0|y,u^g|0,0|p),s=0|o(),w=0|bC((p=0|dB(u^g,p,16))^y|0,0|(g=(0|o())^s),0|I,0|w),I=0|o(),g=0|dB(p^y,g,21),p=I^(0|o()),s=0|bC(f^l|0,0|h,0|y,0|s),y=0|o(),h=0|dB(f^l,h,17),l=(0|o())^y,y=0|dB(s,y,32),f=0|o(),I=0|bC(h^s|0,0|l,0|w,0|I),u=0|o(),l=0|dB(h^s,l,13),s=(0|o())^u,u=0|dB(I,u,32),h=0|o(),f=0|bC(0|y,0|f,w^g|0,0|p),y=0|o(),h=0|bC((p=0|dB(w^g,p,16))^f|0,0|(g=(0|o())^y),0|u,0|h),u=0|o(),g=0|dB(p^f,g,21),p=u^(0|o()),y=0|bC(l^I|0,0|s,0|f,0|y),f=0|o(),s=0|dB(l^I,s,17),I=(0|o())^f,f=0|dB(y,f,32),l=0|o(),u=0|bC(s^y|0,0|I,0|h,0|u),w=0|o(),I=0|dB(s^y,I,13),w=(0|o())^w,l=0|bC(0|f,0|l,h^g|0,0|p),f=0|o(),p=0|dB((p=0|dB(h^g,p,16))^l,(0|o())^f,21),g=0|o(),f=0|bC(I^u|0,0|w,0|l,0|f),l=0|o(),w=0|dB(I^u,w,17),u=0|o(),tB(A+8|0,p^f^w^(I=0|dB(f,l,32)),g^l^u^(0|o())),0},_crypto_shorthash_siphashx24_bytes:it,_crypto_shorthash_siphashx24_keybytes:it,_crypto_sign:function(A,I,g,B,C,a){return 0|kI(A|=0,I|=0,g|=0,B|=0,C|=0,a|=0)},_crypto_sign_bytes:_t,_crypto_sign_detached:function(A,I,g,B,C,a){return sC(A|=0,I|=0,g|=0,B|=0,C|=0,a|=0),0},_crypto_sign_ed25519:kI,_crypto_sign_ed25519_bytes:_t,_crypto_sign_ed25519_detached:sC,_crypto_sign_ed25519_keypair:pB,_crypto_sign_ed25519_messagebytes_max:Oa,_crypto_sign_ed25519_open:oI,_crypto_sign_ed25519_pk_to_curve25519:function(A,I){var g,B;return A|=0,B=h,g=h=h+63&-64,h=h+256|0,0==(0|gI(I|=0))&&0==(0|vA(g+88|0,I))&&0!=(0|qB(g+88|0))?(mC(g),OA(g,g,g+88+40|0),mC(g+48|0),$A(g+48|0,g+48|0,g+88+40|0),CA(g,g),m(g+48|0,g+48|0,g),pA(A,g+48|0),A=0):A=-1,h=B,0|A},_crypto_sign_ed25519_publickeybytes:Et,_crypto_sign_ed25519_secretkeybytes:_t,_crypto_sign_ed25519_seed_keypair:ig,_crypto_sign_ed25519_seedbytes:Et,_crypto_sign_ed25519_sk_to_curve25519:function(A,I){var g,C,a;A|=0,C=h,a=h=h+63&-64,h=h+64|0,Xg(a,I|=0,32,0),B[a>>0]=-8&B[a>>0],B[a+31>>0]=63&B[a+31>>0]|64,I=a,g=A+32|0;do{B[A>>0]=0|B[I>>0],A=A+1|0,I=I+1|0}while((0|A)<(0|g));return Lg(a,64),h=C,0},_crypto_sign_ed25519_sk_to_pk:function(A,I){return Rg(0|(A|=0),32+(I|=0)|0,32),0},_crypto_sign_ed25519_sk_to_seed:function(A,I){return Rg(0|(A|=0),0|(I|=0),32),0},_crypto_sign_ed25519_verify_detached:wC,_crypto_sign_ed25519ph_final_create:IB,_crypto_sign_ed25519ph_final_verify:gB,_crypto_sign_ed25519ph_init:Ha,_crypto_sign_ed25519ph_statebytes:at,_crypto_sign_ed25519ph_update:YC,_crypto_sign_final_create:function(A,I,g,B){return IB(A|=0,I|=0,g|=0,B|=0),0},_crypto_sign_final_verify:function(A,I,g){return 0|gB(A|=0,I|=0,g|=0)},_crypto_sign_init:function(A){return Ha(A|=0),0},_crypto_sign_keypair:function(A,I){return pB(A|=0,I|=0),0},_crypto_sign_messagebytes_max:Oa,_crypto_sign_open:function(A,I,g,B,C,a){return 0|oI(A|=0,I|=0,g|=0,B|=0,C|=0,a|=0)},_crypto_sign_primitive:function(){return 34451},_crypto_sign_publickeybytes:Et,_crypto_sign_secretkeybytes:_t,_crypto_sign_seed_keypair:function(A,I,g){return ig(A|=0,I|=0,g|=0),0},_crypto_sign_seedbytes:Et,_crypto_sign_statebytes:at,_crypto_sign_update:qC,_crypto_sign_verify_detached:function(A,I,g,B,C){return 0|wC(A|=0,I|=0,g|=0,B|=0,C|=0)},_crypto_stream:function(A,I,g,B,C){return 0|xg(A|=0,I|=0,g|=0,B|=0,C|=0)},_crypto_stream_chacha20:RB,_crypto_stream_chacha20_ietf:DB,_crypto_stream_chacha20_ietf_keybytes:Et,_crypto_stream_chacha20_ietf_keygen:Ja,_crypto_stream_chacha20_ietf_messagebytes_max:rt,_crypto_stream_chacha20_ietf_noncebytes:Xa,_crypto_stream_chacha20_ietf_xor:oB,_crypto_stream_chacha20_ietf_xor_ic:Ig,_crypto_stream_chacha20_keybytes:Et,_crypto_stream_chacha20_keygen:Ja,_crypto_stream_chacha20_messagebytes_max:rt,_crypto_stream_chacha20_noncebytes:et,_crypto_stream_chacha20_xor:hB,_crypto_stream_chacha20_xor_ic:Tg,_crypto_stream_keybytes:Et,_crypto_stream_keygen:Ja,_crypto_stream_messagebytes_max:rt,_crypto_stream_noncebytes:ot,_crypto_stream_primitive:function(){return 34459},_crypto_stream_salsa20:RC,_crypto_stream_salsa2012:function(A,I,g,C,r){A|=0,C|=0,r|=0;var Q,e,c=0,i=0,_=0,E=0,n=0;if(Q=h,e=h=h+63&-64,h=h+112|0,!(0==(0|(I|=0))&0==(0|(g|=0)))){c=(i=e)+32|0;do{B[i>>0]=0|B[r>>0],i=i+1|0,r=r+1|0}while((0|i)<(0|c));if(i=t[C+4>>0]|t[C+4+1>>0]<<8|t[C+4+2>>0]<<16|t[C+4+3>>0]<<24,a[e+96>>2]=t[C>>0]|t[C+1>>0]<<8|t[C+2>>0]<<16|t[C+3>>0]<<24,a[e+96+4>>2]=i,a[e+96+8>>2]=0,a[e+96+8+4>>2]=0,g>>>0>0|0==(0|g)&I>>>0>63){do{for(ZC(A,e+96|0,e,0),c=8,r=1;r=r+(0|t[(i=e+96+c|0)>>0])|0,B[i>>0]=r,16!=(0|(c=c+1|0));)r>>>=8;I=0|bC(0|I,0|g,-64,-1),g=0|o(),A=A+64|0}while(g>>>0>0|0==(0|g)&I>>>0>63);0==(0|I)&0==(0|g)||(E=A,n=I,_=8)}else E=A,n=I,_=8;if(8==(0|_)&&(ZC(e+32|0,e+96|0,e,0),0|n)){r=0;do{B[E+r>>0]=0|B[e+32+r>>0],r=r+1|0}while((0|r)!=(0|n))}Lg(e+32|0,64),Lg(e,32)}return h=Q,0},_crypto_stream_salsa2012_keybytes:Et,_crypto_stream_salsa2012_keygen:Ja,_crypto_stream_salsa2012_messagebytes_max:rt,_crypto_stream_salsa2012_noncebytes:et,_crypto_stream_salsa2012_xor:function(A,I,g,C,r,Q){A|=0,I|=0,r|=0,Q|=0;var e,c,i=0,_=0,E=0,n=0,s=0,y=0;if(e=h,c=h=h+63&-64,h=h+112|0,!(0==(0|(g|=0))&0==(0|(C|=0)))){i=(_=c)+32|0;do{B[_>>0]=0|B[Q>>0],_=_+1|0,Q=Q+1|0}while((0|_)<(0|i));if(_=t[r+4>>0]|t[r+4+1>>0]<<8|t[r+4+2>>0]<<16|t[r+4+3>>0]<<24,a[c+96>>2]=t[r>>0]|t[r+1>>0]<<8|t[r+2>>0]<<16|t[r+3>>0]<<24,a[c+96+4>>2]=_,a[c+96+8>>2]=0,a[c+96+8+4>>2]=0,C>>>0>0|0==(0|C)&g>>>0>63){do{ZC(c+32|0,c+96|0,c,0),Q=0;do{B[A+Q>>0]=B[c+32+Q>>0]^B[I+Q>>0],Q=Q+1|0}while(64!=(0|Q));for(i=8,Q=1;Q=Q+(0|t[(_=c+96+i|0)>>0])|0,B[_>>0]=Q,16!=(0|(i=i+1|0));)Q>>>=8;g=0|bC(0|g,0|C,-64,-1),C=0|o(),A=A+64|0,I=I+64|0}while(C>>>0>0|0==(0|C)&g>>>0>63);0==(0|g)&0==(0|C)||(n=A,s=I,y=g,E=10)}else n=A,s=I,y=g,E=10;if(10==(0|E)&&(ZC(c+32|0,c+96|0,c,0),0|y)){Q=0;do{B[n+Q>>0]=B[c+32+Q>>0]^B[s+Q>>0],Q=Q+1|0}while((0|Q)!=(0|y))}Lg(c+32|0,64),Lg(c,32)}return h=e,0},_crypto_stream_salsa208:function(A,I,g,C,r){A|=0,C|=0,r|=0;var Q,e,c=0,i=0,_=0,E=0,n=0;if(Q=h,e=h=h+63&-64,h=h+112|0,!(0==(0|(I|=0))&0==(0|(g|=0)))){c=(i=e)+32|0;do{B[i>>0]=0|B[r>>0],i=i+1|0,r=r+1|0}while((0|i)<(0|c));if(i=t[C+4>>0]|t[C+4+1>>0]<<8|t[C+4+2>>0]<<16|t[C+4+3>>0]<<24,a[e+96>>2]=t[C>>0]|t[C+1>>0]<<8|t[C+2>>0]<<16|t[C+3>>0]<<24,a[e+96+4>>2]=i,a[e+96+8>>2]=0,a[e+96+8+4>>2]=0,g>>>0>0|0==(0|g)&I>>>0>63){do{for(OC(A,e+96|0,e,0),c=8,r=1;r=r+(0|t[(i=e+96+c|0)>>0])|0,B[i>>0]=r,16!=(0|(c=c+1|0));)r>>>=8;I=0|bC(0|I,0|g,-64,-1),g=0|o(),A=A+64|0}while(g>>>0>0|0==(0|g)&I>>>0>63);0==(0|I)&0==(0|g)||(E=A,n=I,_=8)}else E=A,n=I,_=8;if(8==(0|_)&&(OC(e+32|0,e+96|0,e,0),0|n)){r=0;do{B[E+r>>0]=0|B[e+32+r>>0],r=r+1|0}while((0|r)!=(0|n))}Lg(e+32|0,64),Lg(e,32)}return h=Q,0},_crypto_stream_salsa208_keybytes:Et,_crypto_stream_salsa208_keygen:Ja,_crypto_stream_salsa208_messagebytes_max:rt,_crypto_stream_salsa208_noncebytes:et,_crypto_stream_salsa208_xor:function(A,I,g,C,r,Q){A|=0,I|=0,r|=0,Q|=0;var e,c,i=0,_=0,E=0,n=0,s=0,y=0;if(e=h,c=h=h+63&-64,h=h+112|0,!(0==(0|(g|=0))&0==(0|(C|=0)))){i=(_=c)+32|0;do{B[_>>0]=0|B[Q>>0],_=_+1|0,Q=Q+1|0}while((0|_)<(0|i));if(_=t[r+4>>0]|t[r+4+1>>0]<<8|t[r+4+2>>0]<<16|t[r+4+3>>0]<<24,a[c+96>>2]=t[r>>0]|t[r+1>>0]<<8|t[r+2>>0]<<16|t[r+3>>0]<<24,a[c+96+4>>2]=_,a[c+96+8>>2]=0,a[c+96+8+4>>2]=0,C>>>0>0|0==(0|C)&g>>>0>63){do{OC(c+32|0,c+96|0,c,0),Q=0;do{B[A+Q>>0]=B[c+32+Q>>0]^B[I+Q>>0],Q=Q+1|0}while(64!=(0|Q));for(i=8,Q=1;Q=Q+(0|t[(_=c+96+i|0)>>0])|0,B[_>>0]=Q,16!=(0|(i=i+1|0));)Q>>>=8;g=0|bC(0|g,0|C,-64,-1),C=0|o(),A=A+64|0,I=I+64|0}while(C>>>0>0|0==(0|C)&g>>>0>63);0==(0|g)&0==(0|C)||(n=A,s=I,y=g,E=10)}else n=A,s=I,y=g,E=10;if(10==(0|E)&&(OC(c+32|0,c+96|0,c,0),0|y)){Q=0;do{B[n+Q>>0]=B[c+32+Q>>0]^B[s+Q>>0],Q=Q+1|0}while((0|Q)!=(0|y))}Lg(c+32|0,64),Lg(c,32)}return h=e,0},_crypto_stream_salsa20_keybytes:Et,_crypto_stream_salsa20_keygen:Ja,_crypto_stream_salsa20_messagebytes_max:rt,_crypto_stream_salsa20_noncebytes:et,_crypto_stream_salsa20_xor:fC,_crypto_stream_salsa20_xor_ic:XB,_crypto_stream_xchacha20:function(A,I,g,B,C){var a,t;return A|=0,I|=0,g|=0,a=h,t=h=h+63&-64,h=h+32|0,K(t,B|=0,C|=0,0),B=0|RB(A,I,g,B+16|0,t),h=a,0|B},_crypto_stream_xchacha20_keybytes:Et,_crypto_stream_xchacha20_keygen:Ja,_crypto_stream_xchacha20_messagebytes_max:rt,_crypto_stream_xchacha20_noncebytes:ot,_crypto_stream_xchacha20_xor:function(A,I,g,B,C,a){return 0|fg(A|=0,I|=0,g|=0,B|=0,C|=0,0,0,a|=0)},_crypto_stream_xchacha20_xor_ic:fg,_crypto_stream_xor:function(A,I,g,B,C,a){return 0|nC(A|=0,I|=0,g|=0,B|=0,C|=0,a|=0)},_crypto_stream_xsalsa20:xg,_crypto_stream_xsalsa20_keybytes:Et,_crypto_stream_xsalsa20_keygen:Ja,_crypto_stream_xsalsa20_messagebytes_max:rt,_crypto_stream_xsalsa20_noncebytes:ot,_crypto_stream_xsalsa20_xor:nC,_crypto_stream_xsalsa20_xor_ic:ng,_crypto_verify_16:ba,_crypto_verify_16_bytes:it,_crypto_verify_32:ka,_crypto_verify_32_bytes:Et,_crypto_verify_64:Fa,_crypto_verify_64_bytes:_t,_emscripten_get_sbrk_ptr:function(){return 36064},_emscripten_replace_memory:function(A){return B=new Int8Array(A),t=new Uint8Array(A),C=new Int16Array(A),new Uint16Array(A),a=new Int32Array(A),g=A,!0},_free:S,_i64Add:bC,_i64Subtract:FC,_malloc:u,_memcpy:sA,_memmove:Rg,_memset:tI,_randombytes:function(A,I,g){(g|=0)>>>0<1|1==(0|g)&(I|=0)>>>0<0?vB(A|=0,I):c(35243,35263,197,35289)},_randombytes_buf:vB,_randombytes_buf_deterministic:function(A,I,g){DB(A|=0,I|=0,0,35231,g|=0)},_randombytes_close:nt,_randombytes_implementation_name:function(){return 34468},_randombytes_random:La,_randombytes_seedbytes:Et,_randombytes_stir:Ya,_randombytes_uniform:function(A){var I=0;if((A|=0)>>>0<2)I=0;else{do{I=0|La()}while(I>>>0<(((0-A|0)>>>0)%(A>>>0)|0)>>>0);I=(I>>>0)%(A>>>0)|0}return 0|I},_sodium_base642bin:j,_sodium_base64_encoded_len:function(A,I){var g;return A|=0,sa(I|=0),(((A>>>0)/3|0)<<2|1)+(4-(3-(g=(0|r((A>>>0)/3|0,-3))+A|0)&0-(I>>>1&1))&0-(1&(g>>>1|g)))|0},_sodium_bin2base64:gA,_sodium_bin2hex:function(A,I,g,C){A|=0,g|=0;var a=0,r=0;if((C|=0)>>>0<2147483647&C<<1>>>0<(I|=0)>>>0||st(),C){I=0;do{r=0|t[g+I>>0],B[A+(a=I<<1)>>0]=87+(r>>>4)+((65526+(r>>>4)|0)>>>8&217),B[A+(1|a)>>0]=(22272+((15&r)<<8)+(65526+(15&r)&55552)|0)>>>8,I=I+1|0}while((0|I)!=(0|C));I=C<<1}else I=0;return B[A+I>>0]=0,0|A},_sodium_hex2bin:function(A,I,g,C,r,Q,e){A|=0,I|=0,g|=0,C|=0,r|=0,Q|=0,e|=0;var o=0,c=0,i=0,_=0,E=0,n=0,s=0;A:do{if(C){_=0,n=0,o=0,c=0;I:for(;;){for(;!(255&((E=(65526+(201+(223&(i=0|t[g+o>>0]))&255)^65520+(201+(223&i)&255))>>>8)|(65526+(48^i)|0)>>>8)|0);){if(!(0!=(0|r)&c<<24>>24==0)){i=0;break I}if(!(0|zC(r,i))){c=_,s=17;break A}if(!((o=o+1|0)>>>0<C>>>0)){c=_,s=17;break A}c=0}if(i=E&201+(223&i)|(65526+(48^i)|0)>>>8&(48^i),_>>>0>=I>>>0){s=9;break}if(c<<24>>24?(B[A+_>>0]=i|255&n,_=_+1|0,i=n):i=i<<4&255,c=~c,!((o=o+1|0)>>>0<C>>>0)){i=0;break}n=i}if(9==(0|s)&&(a[8886]=68,i=-1),c<<24>>24){a[8886]=28,i=0,c=o+-1|0,o=-1;break}if(i){i=0,c=o,o=-1;break}c=_,s=17;break}c=0,o=0,s=17}while(0);return 17==(0|s)&&(i=c,c=o,o=0),e?a[e>>2]=g+c:(0|c)!=(0|C)&&(a[8886]=28,o=-1),0|Q&&(a[Q>>2]=i),0|o},_sodium_init:function(){var A=0;return 0|a[8884]?A=1:(function(){return A=h,I=h=h+63&-64,h=h+16|0,ra(I),0|a[I>>2]&&ra(I),void(h=A);var A,I}(),Ya(),function(){var A=0;(0|(A=0|y(30)))>0?a[8885]=A:A=0|a[8885],A>>>0<16?st():vB(35504,16)}(),a[8884]=1,A=0),0|A},_sodium_library_minimal:nt,_sodium_library_version_major:function(){return 10},_sodium_library_version_minor:It,_sodium_pad:function(A,I,g,C,r){A|=0,I|=0,g|=0,r|=0;var Q,e,o=0,c=0;if(e=h,Q=h=h+63&-64,h=h+16|0,C|=0)if((c=C+-1-(o=C+-1&C?(g>>>0)%(C>>>0)|0:C+-1&g)|0)>>>0>=~g>>>0&&st(),(c+g|0)>>>0<r>>>0){0|A&&(a[A>>2]=c+g+1),B[Q>>0]=0,o=0;do{A=((o^c)-1|0)>>>24,B[(r=I+(c+g)+(0-o)|0)>>0]=128&A|B[Q>>0]&B[r>>0]&255,B[Q>>0]=0|A|t[Q>>0],o=o+1|0}while((0|o)!=(0|C));o=0}else o=-1;else o=-1;return h=e,0|o},_sodium_unpad:function(A,I,g,B){A|=0,I|=0,g|=0,B|=0;var C,r,Q=0,e=0,o=0,c=0,i=0;if(r=h,C=h=h+63&-64,h=h+16|0,a[C>>2]=0,(B+-1|0)>>>0<g>>>0){for(Q=0,o=0,c=0;Q&=255,e=0|t[I+(g+-1)+(0-o)>>0],i=(511+(0|a[C>>2])&Q+511&511+(128^e))>>>8&1,a[C>>2]=o&0-i|a[C>>2],c=i|255&c,(0|(o=o+1|0))!=(0|B);)Q|=e;a[A>>2]=g+-1-(0|a[C>>2]),Q=c+-1|0}else Q=-1;return h=r,0|Q},_sodium_version_string:function(){return 35354},establishStackSpace:function(A,I){h=A|=0},stackAlloc:function(A){var I;return I=h,h=15+(h=h+(A|=0)|0)&-16,0|I},stackRestore:function(A){h=A|=0},stackSave:function(){return 0|h}}}({Math:Math,Int8Array:Int8Array,Int16Array:Int16Array,Int32Array:Int32Array,Uint8Array:Uint8Array,Uint16Array:Uint16Array},{a:X,b:function(A){h=A},c:function(){return h},d:function(A,I,g,B){X("Assertion failed: "+d(A)+", at: "+[I?d(I):"unknown filename",g,B?d(B):"unknown function"])},e:BA,f:function(){X()},g:function(A){return Z[A]()},h:IA,i:function(A,I,g){u.set(u.subarray(I,I+g),A)},j:function(A){var I=IA();if(A>2130706432)return!1;for(var g=Math.max(I,16777216);g<A;)g=g<=536870912?H(2*g,16777216):Math.min(H((3*g+2147483648)/4,16777216),2130706432);return!!gA(g)},k:function(A){switch(A){case 30:return 16384;case 85:return 130048;case 132:case 133:case 12:case 137:case 138:case 15:case 235:case 16:case 17:case 18:case 19:case 20:case 149:case 13:case 10:case 236:case 153:case 9:case 21:case 22:case 159:case 154:case 14:case 77:case 78:case 139:case 80:case 81:case 82:case 68:case 67:case 164:case 11:case 29:case 47:case 48:case 95:case 52:case 51:case 46:return 200809;case 79:return 0;case 27:case 246:case 127:case 128:case 23:case 24:case 160:case 161:case 181:case 182:case 242:case 183:case 184:case 243:case 244:case 245:case 165:case 178:case 179:case 49:case 50:case 168:case 169:case 175:case 170:case 171:case 172:case 97:case 76:case 32:case 173:case 35:return-1;case 176:case 177:case 7:case 155:case 8:case 157:case 125:case 126:case 92:case 93:case 129:case 130:case 131:case 94:case 91:return 1;case 74:case 60:case 69:case 70:case 4:return 1024;case 31:case 42:case 72:return 32;case 87:case 26:case 33:return 2147483647;case 34:case 1:return 47839;case 38:case 36:return 99;case 43:case 37:return 2048;case 0:return 2097152;case 3:return 65536;case 28:return 32768;case 44:return 32767;case 75:return 16384;case 39:return 1e3;case 89:return 700;case 71:return 256;case 40:return 255;case 2:return 100;case 180:return 64;case 25:return 20;case 5:return 16;case 6:return 6;case 73:return 4;case 84:return"object"==typeof navigator&&navigator.hardwareConcurrency||1}return BA(28),-1},l:function(A){X("OOM")},m:O,n:$,o:gA,p:AA,q:function(){var A=AA();return I.extraStackTrace&&(A+="\n"+I.extraStackTrace()),$(A)},r:36240},w),cA=(I.___errno_location=oA.___errno_location,I.___muldi3=oA.___muldi3,I.___udivdi3=oA.___udivdi3,I.___uremdi3=oA.___uremdi3,I._bitshift64Ashr=oA._bitshift64Ashr,I._bitshift64Lshr=oA._bitshift64Lshr,I._bitshift64Shl=oA._bitshift64Shl,I._crypto_aead_chacha20poly1305_abytes=oA._crypto_aead_chacha20poly1305_abytes,I._crypto_aead_chacha20poly1305_decrypt=oA._crypto_aead_chacha20poly1305_decrypt,I._crypto_aead_chacha20poly1305_decrypt_detached=oA._crypto_aead_chacha20poly1305_decrypt_detached,I._crypto_aead_chacha20poly1305_encrypt=oA._crypto_aead_chacha20poly1305_encrypt,I._crypto_aead_chacha20poly1305_encrypt_detached=oA._crypto_aead_chacha20poly1305_encrypt_detached,I._crypto_aead_chacha20poly1305_ietf_abytes=oA._crypto_aead_chacha20poly1305_ietf_abytes,I._crypto_aead_chacha20poly1305_ietf_decrypt=oA._crypto_aead_chacha20poly1305_ietf_decrypt,I._crypto_aead_chacha20poly1305_ietf_decrypt_detached=oA._crypto_aead_chacha20poly1305_ietf_decrypt_detached,I._crypto_aead_chacha20poly1305_ietf_encrypt=oA._crypto_aead_chacha20poly1305_ietf_encrypt,I._crypto_aead_chacha20poly1305_ietf_encrypt_detached=oA._crypto_aead_chacha20poly1305_ietf_encrypt_detached,I._crypto_aead_chacha20poly1305_ietf_keybytes=oA._crypto_aead_chacha20poly1305_ietf_keybytes,I._crypto_aead_chacha20poly1305_ietf_keygen=oA._crypto_aead_chacha20poly1305_ietf_keygen,I._crypto_aead_chacha20poly1305_ietf_messagebytes_max=oA._crypto_aead_chacha20poly1305_ietf_messagebytes_max,I._crypto_aead_chacha20poly1305_ietf_npubbytes=oA._crypto_aead_chacha20poly1305_ietf_npubbytes,I._crypto_aead_chacha20poly1305_ietf_nsecbytes=oA._crypto_aead_chacha20poly1305_ietf_nsecbytes,I._crypto_aead_chacha20poly1305_keybytes=oA._crypto_aead_chacha20poly1305_keybytes,I._crypto_aead_chacha20poly1305_keygen=oA._crypto_aead_chacha20poly1305_keygen,I._crypto_aead_chacha20poly1305_messagebytes_max=oA._crypto_aead_chacha20poly1305_messagebytes_max,I._crypto_aead_chacha20poly1305_npubbytes=oA._crypto_aead_chacha20poly1305_npubbytes,I._crypto_aead_chacha20poly1305_nsecbytes=oA._crypto_aead_chacha20poly1305_nsecbytes,I._crypto_aead_xchacha20poly1305_ietf_abytes=oA._crypto_aead_xchacha20poly1305_ietf_abytes,I._crypto_aead_xchacha20poly1305_ietf_decrypt=oA._crypto_aead_xchacha20poly1305_ietf_decrypt,I._crypto_aead_xchacha20poly1305_ietf_decrypt_detached=oA._crypto_aead_xchacha20poly1305_ietf_decrypt_detached,I._crypto_aead_xchacha20poly1305_ietf_encrypt=oA._crypto_aead_xchacha20poly1305_ietf_encrypt,I._crypto_aead_xchacha20poly1305_ietf_encrypt_detached=oA._crypto_aead_xchacha20poly1305_ietf_encrypt_detached,I._crypto_aead_xchacha20poly1305_ietf_keybytes=oA._crypto_aead_xchacha20poly1305_ietf_keybytes,I._crypto_aead_xchacha20poly1305_ietf_keygen=oA._crypto_aead_xchacha20poly1305_ietf_keygen,I._crypto_aead_xchacha20poly1305_ietf_messagebytes_max=oA._crypto_aead_xchacha20poly1305_ietf_messagebytes_max,I._crypto_aead_xchacha20poly1305_ietf_npubbytes=oA._crypto_aead_xchacha20poly1305_ietf_npubbytes,I._crypto_aead_xchacha20poly1305_ietf_nsecbytes=oA._crypto_aead_xchacha20poly1305_ietf_nsecbytes,I._crypto_auth=oA._crypto_auth,I._crypto_auth_bytes=oA._crypto_auth_bytes,I._crypto_auth_hmacsha256=oA._crypto_auth_hmacsha256,I._crypto_auth_hmacsha256_bytes=oA._crypto_auth_hmacsha256_bytes,I._crypto_auth_hmacsha256_final=oA._crypto_auth_hmacsha256_final,I._crypto_auth_hmacsha256_init=oA._crypto_auth_hmacsha256_init,I._crypto_auth_hmacsha256_keybytes=oA._crypto_auth_hmacsha256_keybytes,I._crypto_auth_hmacsha256_keygen=oA._crypto_auth_hmacsha256_keygen,I._crypto_auth_hmacsha256_statebytes=oA._crypto_auth_hmacsha256_statebytes,I._crypto_auth_hmacsha256_update=oA._crypto_auth_hmacsha256_update,I._crypto_auth_hmacsha256_verify=oA._crypto_auth_hmacsha256_verify,I._crypto_auth_hmacsha512=oA._crypto_auth_hmacsha512,I._crypto_auth_hmacsha512256=oA._crypto_auth_hmacsha512256,I._crypto_auth_hmacsha512256_bytes=oA._crypto_auth_hmacsha512256_bytes,I._crypto_auth_hmacsha512256_final=oA._crypto_auth_hmacsha512256_final,I._crypto_auth_hmacsha512256_init=oA._crypto_auth_hmacsha512256_init,I._crypto_auth_hmacsha512256_keybytes=oA._crypto_auth_hmacsha512256_keybytes,I._crypto_auth_hmacsha512256_keygen=oA._crypto_auth_hmacsha512256_keygen,I._crypto_auth_hmacsha512256_statebytes=oA._crypto_auth_hmacsha512256_statebytes,I._crypto_auth_hmacsha512256_update=oA._crypto_auth_hmacsha512256_update,I._crypto_auth_hmacsha512256_verify=oA._crypto_auth_hmacsha512256_verify,I._crypto_auth_hmacsha512_bytes=oA._crypto_auth_hmacsha512_bytes,I._crypto_auth_hmacsha512_final=oA._crypto_auth_hmacsha512_final,I._crypto_auth_hmacsha512_init=oA._crypto_auth_hmacsha512_init,I._crypto_auth_hmacsha512_keybytes=oA._crypto_auth_hmacsha512_keybytes,I._crypto_auth_hmacsha512_keygen=oA._crypto_auth_hmacsha512_keygen,I._crypto_auth_hmacsha512_statebytes=oA._crypto_auth_hmacsha512_statebytes,I._crypto_auth_hmacsha512_update=oA._crypto_auth_hmacsha512_update,I._crypto_auth_hmacsha512_verify=oA._crypto_auth_hmacsha512_verify,I._crypto_auth_keybytes=oA._crypto_auth_keybytes,I._crypto_auth_keygen=oA._crypto_auth_keygen,I._crypto_auth_primitive=oA._crypto_auth_primitive,I._crypto_auth_verify=oA._crypto_auth_verify,I._crypto_box=oA._crypto_box,I._crypto_box_afternm=oA._crypto_box_afternm,I._crypto_box_beforenm=oA._crypto_box_beforenm,I._crypto_box_beforenmbytes=oA._crypto_box_beforenmbytes,I._crypto_box_boxzerobytes=oA._crypto_box_boxzerobytes,I._crypto_box_curve25519xchacha20poly1305_beforenm=oA._crypto_box_curve25519xchacha20poly1305_beforenm,I._crypto_box_curve25519xchacha20poly1305_beforenmbytes=oA._crypto_box_curve25519xchacha20poly1305_beforenmbytes,I._crypto_box_curve25519xchacha20poly1305_detached=oA._crypto_box_curve25519xchacha20poly1305_detached,I._crypto_box_curve25519xchacha20poly1305_detached_afternm=oA._crypto_box_curve25519xchacha20poly1305_detached_afternm,I._crypto_box_curve25519xchacha20poly1305_easy=oA._crypto_box_curve25519xchacha20poly1305_easy,I._crypto_box_curve25519xchacha20poly1305_easy_afternm=oA._crypto_box_curve25519xchacha20poly1305_easy_afternm,I._crypto_box_curve25519xchacha20poly1305_keypair=oA._crypto_box_curve25519xchacha20poly1305_keypair,I._crypto_box_curve25519xchacha20poly1305_macbytes=oA._crypto_box_curve25519xchacha20poly1305_macbytes,I._crypto_box_curve25519xchacha20poly1305_messagebytes_max=oA._crypto_box_curve25519xchacha20poly1305_messagebytes_max,I._crypto_box_curve25519xchacha20poly1305_noncebytes=oA._crypto_box_curve25519xchacha20poly1305_noncebytes,I._crypto_box_curve25519xchacha20poly1305_open_detached=oA._crypto_box_curve25519xchacha20poly1305_open_detached,I._crypto_box_curve25519xchacha20poly1305_open_detached_afternm=oA._crypto_box_curve25519xchacha20poly1305_open_detached_afternm,I._crypto_box_curve25519xchacha20poly1305_open_easy=oA._crypto_box_curve25519xchacha20poly1305_open_easy,I._crypto_box_curve25519xchacha20poly1305_open_easy_afternm=oA._crypto_box_curve25519xchacha20poly1305_open_easy_afternm,I._crypto_box_curve25519xchacha20poly1305_publickeybytes=oA._crypto_box_curve25519xchacha20poly1305_publickeybytes,I._crypto_box_curve25519xchacha20poly1305_seal=oA._crypto_box_curve25519xchacha20poly1305_seal,I._crypto_box_curve25519xchacha20poly1305_seal_open=oA._crypto_box_curve25519xchacha20poly1305_seal_open,I._crypto_box_curve25519xchacha20poly1305_sealbytes=oA._crypto_box_curve25519xchacha20poly1305_sealbytes,I._crypto_box_curve25519xchacha20poly1305_secretkeybytes=oA._crypto_box_curve25519xchacha20poly1305_secretkeybytes,I._crypto_box_curve25519xchacha20poly1305_seed_keypair=oA._crypto_box_curve25519xchacha20poly1305_seed_keypair,I._crypto_box_curve25519xchacha20poly1305_seedbytes=oA._crypto_box_curve25519xchacha20poly1305_seedbytes,I._crypto_box_curve25519xsalsa20poly1305=oA._crypto_box_curve25519xsalsa20poly1305,I._crypto_box_curve25519xsalsa20poly1305_afternm=oA._crypto_box_curve25519xsalsa20poly1305_afternm,I._crypto_box_curve25519xsalsa20poly1305_beforenm=oA._crypto_box_curve25519xsalsa20poly1305_beforenm,I._crypto_box_curve25519xsalsa20poly1305_beforenmbytes=oA._crypto_box_curve25519xsalsa20poly1305_beforenmbytes,I._crypto_box_curve25519xsalsa20poly1305_boxzerobytes=oA._crypto_box_curve25519xsalsa20poly1305_boxzerobytes,I._crypto_box_curve25519xsalsa20poly1305_keypair=oA._crypto_box_curve25519xsalsa20poly1305_keypair,I._crypto_box_curve25519xsalsa20poly1305_macbytes=oA._crypto_box_curve25519xsalsa20poly1305_macbytes,I._crypto_box_curve25519xsalsa20poly1305_messagebytes_max=oA._crypto_box_curve25519xsalsa20poly1305_messagebytes_max,I._crypto_box_curve25519xsalsa20poly1305_noncebytes=oA._crypto_box_curve25519xsalsa20poly1305_noncebytes,I._crypto_box_curve25519xsalsa20poly1305_open=oA._crypto_box_curve25519xsalsa20poly1305_open,I._crypto_box_curve25519xsalsa20poly1305_open_afternm=oA._crypto_box_curve25519xsalsa20poly1305_open_afternm,I._crypto_box_curve25519xsalsa20poly1305_publickeybytes=oA._crypto_box_curve25519xsalsa20poly1305_publickeybytes,I._crypto_box_curve25519xsalsa20poly1305_secretkeybytes=oA._crypto_box_curve25519xsalsa20poly1305_secretkeybytes,I._crypto_box_curve25519xsalsa20poly1305_seed_keypair=oA._crypto_box_curve25519xsalsa20poly1305_seed_keypair,I._crypto_box_curve25519xsalsa20poly1305_seedbytes=oA._crypto_box_curve25519xsalsa20poly1305_seedbytes,I._crypto_box_curve25519xsalsa20poly1305_zerobytes=oA._crypto_box_curve25519xsalsa20poly1305_zerobytes,I._crypto_box_detached=oA._crypto_box_detached,I._crypto_box_detached_afternm=oA._crypto_box_detached_afternm,I._crypto_box_easy=oA._crypto_box_easy,I._crypto_box_easy_afternm=oA._crypto_box_easy_afternm,I._crypto_box_keypair=oA._crypto_box_keypair,I._crypto_box_macbytes=oA._crypto_box_macbytes,I._crypto_box_messagebytes_max=oA._crypto_box_messagebytes_max,I._crypto_box_noncebytes=oA._crypto_box_noncebytes,I._crypto_box_open=oA._crypto_box_open,I._crypto_box_open_afternm=oA._crypto_box_open_afternm,I._crypto_box_open_detached=oA._crypto_box_open_detached,I._crypto_box_open_detached_afternm=oA._crypto_box_open_detached_afternm,I._crypto_box_open_easy=oA._crypto_box_open_easy,I._crypto_box_open_easy_afternm=oA._crypto_box_open_easy_afternm,I._crypto_box_primitive=oA._crypto_box_primitive,I._crypto_box_publickeybytes=oA._crypto_box_publickeybytes,I._crypto_box_seal=oA._crypto_box_seal,I._crypto_box_seal_open=oA._crypto_box_seal_open,I._crypto_box_sealbytes=oA._crypto_box_sealbytes,I._crypto_box_secretkeybytes=oA._crypto_box_secretkeybytes,I._crypto_box_seed_keypair=oA._crypto_box_seed_keypair,I._crypto_box_seedbytes=oA._crypto_box_seedbytes,I._crypto_box_zerobytes=oA._crypto_box_zerobytes,I._crypto_core_ed25519_add=oA._crypto_core_ed25519_add,I._crypto_core_ed25519_bytes=oA._crypto_core_ed25519_bytes,I._crypto_core_ed25519_from_hash=oA._crypto_core_ed25519_from_hash,I._crypto_core_ed25519_from_uniform=oA._crypto_core_ed25519_from_uniform,I._crypto_core_ed25519_hashbytes=oA._crypto_core_ed25519_hashbytes,I._crypto_core_ed25519_is_valid_point=oA._crypto_core_ed25519_is_valid_point,I._crypto_core_ed25519_nonreducedscalarbytes=oA._crypto_core_ed25519_nonreducedscalarbytes,I._crypto_core_ed25519_random=oA._crypto_core_ed25519_random,I._crypto_core_ed25519_scalar_add=oA._crypto_core_ed25519_scalar_add,I._crypto_core_ed25519_scalar_complement=oA._crypto_core_ed25519_scalar_complement,I._crypto_core_ed25519_scalar_invert=oA._crypto_core_ed25519_scalar_invert,I._crypto_core_ed25519_scalar_mul=oA._crypto_core_ed25519_scalar_mul,I._crypto_core_ed25519_scalar_negate=oA._crypto_core_ed25519_scalar_negate,I._crypto_core_ed25519_scalar_random=oA._crypto_core_ed25519_scalar_random,I._crypto_core_ed25519_scalar_reduce=oA._crypto_core_ed25519_scalar_reduce,I._crypto_core_ed25519_scalar_sub=oA._crypto_core_ed25519_scalar_sub,I._crypto_core_ed25519_scalarbytes=oA._crypto_core_ed25519_scalarbytes,I._crypto_core_ed25519_sub=oA._crypto_core_ed25519_sub,I._crypto_core_ed25519_uniformbytes=oA._crypto_core_ed25519_uniformbytes,I._crypto_core_hchacha20=oA._crypto_core_hchacha20,I._crypto_core_hchacha20_constbytes=oA._crypto_core_hchacha20_constbytes,I._crypto_core_hchacha20_inputbytes=oA._crypto_core_hchacha20_inputbytes,I._crypto_core_hchacha20_keybytes=oA._crypto_core_hchacha20_keybytes,I._crypto_core_hchacha20_outputbytes=oA._crypto_core_hchacha20_outputbytes,I._crypto_core_hsalsa20=oA._crypto_core_hsalsa20,I._crypto_core_hsalsa20_constbytes=oA._crypto_core_hsalsa20_constbytes,I._crypto_core_hsalsa20_inputbytes=oA._crypto_core_hsalsa20_inputbytes,I._crypto_core_hsalsa20_keybytes=oA._crypto_core_hsalsa20_keybytes,I._crypto_core_hsalsa20_outputbytes=oA._crypto_core_hsalsa20_outputbytes,I._crypto_core_ristretto255_add=oA._crypto_core_ristretto255_add,I._crypto_core_ristretto255_bytes=oA._crypto_core_ristretto255_bytes,I._crypto_core_ristretto255_from_hash=oA._crypto_core_ristretto255_from_hash,I._crypto_core_ristretto255_hashbytes=oA._crypto_core_ristretto255_hashbytes,I._crypto_core_ristretto255_is_valid_point=oA._crypto_core_ristretto255_is_valid_point,I._crypto_core_ristretto255_nonreducedscalarbytes=oA._crypto_core_ristretto255_nonreducedscalarbytes,I._crypto_core_ristretto255_random=oA._crypto_core_ristretto255_random,I._crypto_core_ristretto255_scalar_add=oA._crypto_core_ristretto255_scalar_add,I._crypto_core_ristretto255_scalar_complement=oA._crypto_core_ristretto255_scalar_complement,I._crypto_core_ristretto255_scalar_invert=oA._crypto_core_ristretto255_scalar_invert,I._crypto_core_ristretto255_scalar_mul=oA._crypto_core_ristretto255_scalar_mul,I._crypto_core_ristretto255_scalar_negate=oA._crypto_core_ristretto255_scalar_negate,I._crypto_core_ristretto255_scalar_random=oA._crypto_core_ristretto255_scalar_random,I._crypto_core_ristretto255_scalar_reduce=oA._crypto_core_ristretto255_scalar_reduce,I._crypto_core_ristretto255_scalar_sub=oA._crypto_core_ristretto255_scalar_sub,I._crypto_core_ristretto255_scalarbytes=oA._crypto_core_ristretto255_scalarbytes,I._crypto_core_ristretto255_sub=oA._crypto_core_ristretto255_sub,I._crypto_core_salsa20=oA._crypto_core_salsa20,I._crypto_core_salsa2012=oA._crypto_core_salsa2012,I._crypto_core_salsa2012_constbytes=oA._crypto_core_salsa2012_constbytes,I._crypto_core_salsa2012_inputbytes=oA._crypto_core_salsa2012_inputbytes,I._crypto_core_salsa2012_keybytes=oA._crypto_core_salsa2012_keybytes,I._crypto_core_salsa2012_outputbytes=oA._crypto_core_salsa2012_outputbytes,I._crypto_core_salsa208=oA._crypto_core_salsa208,I._crypto_core_salsa208_constbytes=oA._crypto_core_salsa208_constbytes,I._crypto_core_salsa208_inputbytes=oA._crypto_core_salsa208_inputbytes,I._crypto_core_salsa208_keybytes=oA._crypto_core_salsa208_keybytes,I._crypto_core_salsa208_outputbytes=oA._crypto_core_salsa208_outputbytes,I._crypto_core_salsa20_constbytes=oA._crypto_core_salsa20_constbytes,I._crypto_core_salsa20_inputbytes=oA._crypto_core_salsa20_inputbytes,I._crypto_core_salsa20_keybytes=oA._crypto_core_salsa20_keybytes,I._crypto_core_salsa20_outputbytes=oA._crypto_core_salsa20_outputbytes,I._crypto_generichash=oA._crypto_generichash,I._crypto_generichash_blake2b=oA._crypto_generichash_blake2b,I._crypto_generichash_blake2b_bytes=oA._crypto_generichash_blake2b_bytes,I._crypto_generichash_blake2b_bytes_max=oA._crypto_generichash_blake2b_bytes_max,I._crypto_generichash_blake2b_bytes_min=oA._crypto_generichash_blake2b_bytes_min,I._crypto_generichash_blake2b_final=oA._crypto_generichash_blake2b_final,I._crypto_generichash_blake2b_init=oA._crypto_generichash_blake2b_init,I._crypto_generichash_blake2b_init_salt_personal=oA._crypto_generichash_blake2b_init_salt_personal,I._crypto_generichash_blake2b_keybytes=oA._crypto_generichash_blake2b_keybytes,I._crypto_generichash_blake2b_keybytes_max=oA._crypto_generichash_blake2b_keybytes_max,I._crypto_generichash_blake2b_keybytes_min=oA._crypto_generichash_blake2b_keybytes_min,I._crypto_generichash_blake2b_keygen=oA._crypto_generichash_blake2b_keygen,I._crypto_generichash_blake2b_personalbytes=oA._crypto_generichash_blake2b_personalbytes,I._crypto_generichash_blake2b_salt_personal=oA._crypto_generichash_blake2b_salt_personal,I._crypto_generichash_blake2b_saltbytes=oA._crypto_generichash_blake2b_saltbytes,I._crypto_generichash_blake2b_statebytes=oA._crypto_generichash_blake2b_statebytes,I._crypto_generichash_blake2b_update=oA._crypto_generichash_blake2b_update,I._crypto_generichash_bytes=oA._crypto_generichash_bytes,I._crypto_generichash_bytes_max=oA._crypto_generichash_bytes_max,I._crypto_generichash_bytes_min=oA._crypto_generichash_bytes_min,I._crypto_generichash_final=oA._crypto_generichash_final,I._crypto_generichash_init=oA._crypto_generichash_init,I._crypto_generichash_keybytes=oA._crypto_generichash_keybytes,I._crypto_generichash_keybytes_max=oA._crypto_generichash_keybytes_max,I._crypto_generichash_keybytes_min=oA._crypto_generichash_keybytes_min,I._crypto_generichash_keygen=oA._crypto_generichash_keygen,I._crypto_generichash_primitive=oA._crypto_generichash_primitive,I._crypto_generichash_statebytes=oA._crypto_generichash_statebytes,I._crypto_generichash_update=oA._crypto_generichash_update,I._crypto_hash=oA._crypto_hash,I._crypto_hash_bytes=oA._crypto_hash_bytes,I._crypto_hash_primitive=oA._crypto_hash_primitive,I._crypto_hash_sha256=oA._crypto_hash_sha256,I._crypto_hash_sha256_bytes=oA._crypto_hash_sha256_bytes,I._crypto_hash_sha256_final=oA._crypto_hash_sha256_final,I._crypto_hash_sha256_init=oA._crypto_hash_sha256_init,I._crypto_hash_sha256_statebytes=oA._crypto_hash_sha256_statebytes,I._crypto_hash_sha256_update=oA._crypto_hash_sha256_update,I._crypto_hash_sha512=oA._crypto_hash_sha512,I._crypto_hash_sha512_bytes=oA._crypto_hash_sha512_bytes,I._crypto_hash_sha512_final=oA._crypto_hash_sha512_final,I._crypto_hash_sha512_init=oA._crypto_hash_sha512_init,I._crypto_hash_sha512_statebytes=oA._crypto_hash_sha512_statebytes,I._crypto_hash_sha512_update=oA._crypto_hash_sha512_update,I._crypto_kdf_blake2b_bytes_max=oA._crypto_kdf_blake2b_bytes_max,I._crypto_kdf_blake2b_bytes_min=oA._crypto_kdf_blake2b_bytes_min,I._crypto_kdf_blake2b_contextbytes=oA._crypto_kdf_blake2b_contextbytes,I._crypto_kdf_blake2b_derive_from_key=oA._crypto_kdf_blake2b_derive_from_key,I._crypto_kdf_blake2b_keybytes=oA._crypto_kdf_blake2b_keybytes,I._crypto_kdf_bytes_max=oA._crypto_kdf_bytes_max,I._crypto_kdf_bytes_min=oA._crypto_kdf_bytes_min,I._crypto_kdf_contextbytes=oA._crypto_kdf_contextbytes,I._crypto_kdf_derive_from_key=oA._crypto_kdf_derive_from_key,I._crypto_kdf_keybytes=oA._crypto_kdf_keybytes,I._crypto_kdf_keygen=oA._crypto_kdf_keygen,I._crypto_kdf_primitive=oA._crypto_kdf_primitive,I._crypto_kx_client_session_keys=oA._crypto_kx_client_session_keys,I._crypto_kx_keypair=oA._crypto_kx_keypair,I._crypto_kx_primitive=oA._crypto_kx_primitive,I._crypto_kx_publickeybytes=oA._crypto_kx_publickeybytes,I._crypto_kx_secretkeybytes=oA._crypto_kx_secretkeybytes,I._crypto_kx_seed_keypair=oA._crypto_kx_seed_keypair,I._crypto_kx_seedbytes=oA._crypto_kx_seedbytes,I._crypto_kx_server_session_keys=oA._crypto_kx_server_session_keys,I._crypto_kx_sessionkeybytes=oA._crypto_kx_sessionkeybytes,I._crypto_onetimeauth=oA._crypto_onetimeauth,I._crypto_onetimeauth_bytes=oA._crypto_onetimeauth_bytes,I._crypto_onetimeauth_final=oA._crypto_onetimeauth_final,I._crypto_onetimeauth_init=oA._crypto_onetimeauth_init,I._crypto_onetimeauth_keybytes=oA._crypto_onetimeauth_keybytes,I._crypto_onetimeauth_keygen=oA._crypto_onetimeauth_keygen,I._crypto_onetimeauth_poly1305=oA._crypto_onetimeauth_poly1305,I._crypto_onetimeauth_poly1305_bytes=oA._crypto_onetimeauth_poly1305_bytes,I._crypto_onetimeauth_poly1305_final=oA._crypto_onetimeauth_poly1305_final,I._crypto_onetimeauth_poly1305_init=oA._crypto_onetimeauth_poly1305_init,I._crypto_onetimeauth_poly1305_keybytes=oA._crypto_onetimeauth_poly1305_keybytes,I._crypto_onetimeauth_poly1305_keygen=oA._crypto_onetimeauth_poly1305_keygen,I._crypto_onetimeauth_poly1305_statebytes=oA._crypto_onetimeauth_poly1305_statebytes,I._crypto_onetimeauth_poly1305_update=oA._crypto_onetimeauth_poly1305_update,I._crypto_onetimeauth_poly1305_verify=oA._crypto_onetimeauth_poly1305_verify,I._crypto_onetimeauth_primitive=oA._crypto_onetimeauth_primitive,I._crypto_onetimeauth_statebytes=oA._crypto_onetimeauth_statebytes,I._crypto_onetimeauth_update=oA._crypto_onetimeauth_update,I._crypto_onetimeauth_verify=oA._crypto_onetimeauth_verify,I._crypto_pwhash=oA._crypto_pwhash,I._crypto_pwhash_alg_argon2i13=oA._crypto_pwhash_alg_argon2i13,I._crypto_pwhash_alg_argon2id13=oA._crypto_pwhash_alg_argon2id13,I._crypto_pwhash_alg_default=oA._crypto_pwhash_alg_default,I._crypto_pwhash_argon2i=oA._crypto_pwhash_argon2i,I._crypto_pwhash_argon2i_alg_argon2i13=oA._crypto_pwhash_argon2i_alg_argon2i13,I._crypto_pwhash_argon2i_bytes_max=oA._crypto_pwhash_argon2i_bytes_max,I._crypto_pwhash_argon2i_bytes_min=oA._crypto_pwhash_argon2i_bytes_min,I._crypto_pwhash_argon2i_memlimit_interactive=oA._crypto_pwhash_argon2i_memlimit_interactive,I._crypto_pwhash_argon2i_memlimit_max=oA._crypto_pwhash_argon2i_memlimit_max,I._crypto_pwhash_argon2i_memlimit_min=oA._crypto_pwhash_argon2i_memlimit_min,I._crypto_pwhash_argon2i_memlimit_moderate=oA._crypto_pwhash_argon2i_memlimit_moderate,I._crypto_pwhash_argon2i_memlimit_sensitive=oA._crypto_pwhash_argon2i_memlimit_sensitive,I._crypto_pwhash_argon2i_opslimit_interactive=oA._crypto_pwhash_argon2i_opslimit_interactive,I._crypto_pwhash_argon2i_opslimit_max=oA._crypto_pwhash_argon2i_opslimit_max,I._crypto_pwhash_argon2i_opslimit_min=oA._crypto_pwhash_argon2i_opslimit_min,I._crypto_pwhash_argon2i_opslimit_moderate=oA._crypto_pwhash_argon2i_opslimit_moderate,I._crypto_pwhash_argon2i_opslimit_sensitive=oA._crypto_pwhash_argon2i_opslimit_sensitive,I._crypto_pwhash_argon2i_passwd_max=oA._crypto_pwhash_argon2i_passwd_max,I._crypto_pwhash_argon2i_passwd_min=oA._crypto_pwhash_argon2i_passwd_min,I._crypto_pwhash_argon2i_saltbytes=oA._crypto_pwhash_argon2i_saltbytes,I._crypto_pwhash_argon2i_str=oA._crypto_pwhash_argon2i_str,I._crypto_pwhash_argon2i_str_needs_rehash=oA._crypto_pwhash_argon2i_str_needs_rehash,I._crypto_pwhash_argon2i_str_verify=oA._crypto_pwhash_argon2i_str_verify,I._crypto_pwhash_argon2i_strbytes=oA._crypto_pwhash_argon2i_strbytes,I._crypto_pwhash_argon2i_strprefix=oA._crypto_pwhash_argon2i_strprefix,I._crypto_pwhash_argon2id=oA._crypto_pwhash_argon2id,I._crypto_pwhash_argon2id_alg_argon2id13=oA._crypto_pwhash_argon2id_alg_argon2id13,I._crypto_pwhash_argon2id_bytes_max=oA._crypto_pwhash_argon2id_bytes_max,I._crypto_pwhash_argon2id_bytes_min=oA._crypto_pwhash_argon2id_bytes_min,I._crypto_pwhash_argon2id_memlimit_interactive=oA._crypto_pwhash_argon2id_memlimit_interactive,I._crypto_pwhash_argon2id_memlimit_max=oA._crypto_pwhash_argon2id_memlimit_max,I._crypto_pwhash_argon2id_memlimit_min=oA._crypto_pwhash_argon2id_memlimit_min,I._crypto_pwhash_argon2id_memlimit_moderate=oA._crypto_pwhash_argon2id_memlimit_moderate,I._crypto_pwhash_argon2id_memlimit_sensitive=oA._crypto_pwhash_argon2id_memlimit_sensitive,I._crypto_pwhash_argon2id_opslimit_interactive=oA._crypto_pwhash_argon2id_opslimit_interactive,I._crypto_pwhash_argon2id_opslimit_max=oA._crypto_pwhash_argon2id_opslimit_max,I._crypto_pwhash_argon2id_opslimit_min=oA._crypto_pwhash_argon2id_opslimit_min,I._crypto_pwhash_argon2id_opslimit_moderate=oA._crypto_pwhash_argon2id_opslimit_moderate,I._crypto_pwhash_argon2id_opslimit_sensitive=oA._crypto_pwhash_argon2id_opslimit_sensitive,I._crypto_pwhash_argon2id_passwd_max=oA._crypto_pwhash_argon2id_passwd_max,I._crypto_pwhash_argon2id_passwd_min=oA._crypto_pwhash_argon2id_passwd_min,I._crypto_pwhash_argon2id_saltbytes=oA._crypto_pwhash_argon2id_saltbytes,I._crypto_pwhash_argon2id_str=oA._crypto_pwhash_argon2id_str,I._crypto_pwhash_argon2id_str_needs_rehash=oA._crypto_pwhash_argon2id_str_needs_rehash,I._crypto_pwhash_argon2id_str_verify=oA._crypto_pwhash_argon2id_str_verify,I._crypto_pwhash_argon2id_strbytes=oA._crypto_pwhash_argon2id_strbytes,I._crypto_pwhash_argon2id_strprefix=oA._crypto_pwhash_argon2id_strprefix,I._crypto_pwhash_bytes_max=oA._crypto_pwhash_bytes_max,I._crypto_pwhash_bytes_min=oA._crypto_pwhash_bytes_min,I._crypto_pwhash_memlimit_interactive=oA._crypto_pwhash_memlimit_interactive,I._crypto_pwhash_memlimit_max=oA._crypto_pwhash_memlimit_max,I._crypto_pwhash_memlimit_min=oA._crypto_pwhash_memlimit_min,I._crypto_pwhash_memlimit_moderate=oA._crypto_pwhash_memlimit_moderate,I._crypto_pwhash_memlimit_sensitive=oA._crypto_pwhash_memlimit_sensitive,I._crypto_pwhash_opslimit_interactive=oA._crypto_pwhash_opslimit_interactive,I._crypto_pwhash_opslimit_max=oA._crypto_pwhash_opslimit_max,I._crypto_pwhash_opslimit_min=oA._crypto_pwhash_opslimit_min,I._crypto_pwhash_opslimit_moderate=oA._crypto_pwhash_opslimit_moderate,I._crypto_pwhash_opslimit_sensitive=oA._crypto_pwhash_opslimit_sensitive,I._crypto_pwhash_passwd_max=oA._crypto_pwhash_passwd_max,I._crypto_pwhash_passwd_min=oA._crypto_pwhash_passwd_min,I._crypto_pwhash_primitive=oA._crypto_pwhash_primitive,I._crypto_pwhash_saltbytes=oA._crypto_pwhash_saltbytes,I._crypto_pwhash_scryptsalsa208sha256=oA._crypto_pwhash_scryptsalsa208sha256,I._crypto_pwhash_scryptsalsa208sha256_bytes_max=oA._crypto_pwhash_scryptsalsa208sha256_bytes_max,I._crypto_pwhash_scryptsalsa208sha256_bytes_min=oA._crypto_pwhash_scryptsalsa208sha256_bytes_min,I._crypto_pwhash_scryptsalsa208sha256_ll=oA._crypto_pwhash_scryptsalsa208sha256_ll,I._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive=oA._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive,I._crypto_pwhash_scryptsalsa208sha256_memlimit_max=oA._crypto_pwhash_scryptsalsa208sha256_memlimit_max,I._crypto_pwhash_scryptsalsa208sha256_memlimit_min=oA._crypto_pwhash_scryptsalsa208sha256_memlimit_min,I._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive=oA._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive,I._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive=oA._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive,I._crypto_pwhash_scryptsalsa208sha256_opslimit_max=oA._crypto_pwhash_scryptsalsa208sha256_opslimit_max,I._crypto_pwhash_scryptsalsa208sha256_opslimit_min=oA._crypto_pwhash_scryptsalsa208sha256_opslimit_min,I._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive=oA._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive,I._crypto_pwhash_scryptsalsa208sha256_passwd_max=oA._crypto_pwhash_scryptsalsa208sha256_passwd_max,I._crypto_pwhash_scryptsalsa208sha256_passwd_min=oA._crypto_pwhash_scryptsalsa208sha256_passwd_min,I._crypto_pwhash_scryptsalsa208sha256_saltbytes=oA._crypto_pwhash_scryptsalsa208sha256_saltbytes,I._crypto_pwhash_scryptsalsa208sha256_str=oA._crypto_pwhash_scryptsalsa208sha256_str,I._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash=oA._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash,I._crypto_pwhash_scryptsalsa208sha256_str_verify=oA._crypto_pwhash_scryptsalsa208sha256_str_verify,I._crypto_pwhash_scryptsalsa208sha256_strbytes=oA._crypto_pwhash_scryptsalsa208sha256_strbytes,I._crypto_pwhash_scryptsalsa208sha256_strprefix=oA._crypto_pwhash_scryptsalsa208sha256_strprefix,I._crypto_pwhash_str=oA._crypto_pwhash_str,I._crypto_pwhash_str_alg=oA._crypto_pwhash_str_alg,I._crypto_pwhash_str_needs_rehash=oA._crypto_pwhash_str_needs_rehash,I._crypto_pwhash_str_verify=oA._crypto_pwhash_str_verify,I._crypto_pwhash_strbytes=oA._crypto_pwhash_strbytes,I._crypto_pwhash_strprefix=oA._crypto_pwhash_strprefix,I._crypto_scalarmult=oA._crypto_scalarmult,I._crypto_scalarmult_base=oA._crypto_scalarmult_base,I._crypto_scalarmult_bytes=oA._crypto_scalarmult_bytes,I._crypto_scalarmult_curve25519=oA._crypto_scalarmult_curve25519,I._crypto_scalarmult_curve25519_base=oA._crypto_scalarmult_curve25519_base,I._crypto_scalarmult_curve25519_bytes=oA._crypto_scalarmult_curve25519_bytes,I._crypto_scalarmult_curve25519_scalarbytes=oA._crypto_scalarmult_curve25519_scalarbytes,I._crypto_scalarmult_ed25519=oA._crypto_scalarmult_ed25519,I._crypto_scalarmult_ed25519_base=oA._crypto_scalarmult_ed25519_base,I._crypto_scalarmult_ed25519_base_noclamp=oA._crypto_scalarmult_ed25519_base_noclamp,I._crypto_scalarmult_ed25519_bytes=oA._crypto_scalarmult_ed25519_bytes,I._crypto_scalarmult_ed25519_noclamp=oA._crypto_scalarmult_ed25519_noclamp,I._crypto_scalarmult_ed25519_scalarbytes=oA._crypto_scalarmult_ed25519_scalarbytes,I._crypto_scalarmult_primitive=oA._crypto_scalarmult_primitive,I._crypto_scalarmult_ristretto255=oA._crypto_scalarmult_ristretto255,I._crypto_scalarmult_ristretto255_base=oA._crypto_scalarmult_ristretto255_base,I._crypto_scalarmult_ristretto255_bytes=oA._crypto_scalarmult_ristretto255_bytes,I._crypto_scalarmult_ristretto255_scalarbytes=oA._crypto_scalarmult_ristretto255_scalarbytes,I._crypto_scalarmult_scalarbytes=oA._crypto_scalarmult_scalarbytes,I._crypto_secretbox=oA._crypto_secretbox,I._crypto_secretbox_boxzerobytes=oA._crypto_secretbox_boxzerobytes,I._crypto_secretbox_detached=oA._crypto_secretbox_detached,I._crypto_secretbox_easy=oA._crypto_secretbox_easy,I._crypto_secretbox_keybytes=oA._crypto_secretbox_keybytes,I._crypto_secretbox_keygen=oA._crypto_secretbox_keygen,I._crypto_secretbox_macbytes=oA._crypto_secretbox_macbytes,I._crypto_secretbox_messagebytes_max=oA._crypto_secretbox_messagebytes_max,I._crypto_secretbox_noncebytes=oA._crypto_secretbox_noncebytes,I._crypto_secretbox_open=oA._crypto_secretbox_open,I._crypto_secretbox_open_detached=oA._crypto_secretbox_open_detached,I._crypto_secretbox_open_easy=oA._crypto_secretbox_open_easy,I._crypto_secretbox_primitive=oA._crypto_secretbox_primitive,I._crypto_secretbox_xchacha20poly1305_detached=oA._crypto_secretbox_xchacha20poly1305_detached,I._crypto_secretbox_xchacha20poly1305_easy=oA._crypto_secretbox_xchacha20poly1305_easy,I._crypto_secretbox_xchacha20poly1305_keybytes=oA._crypto_secretbox_xchacha20poly1305_keybytes,I._crypto_secretbox_xchacha20poly1305_macbytes=oA._crypto_secretbox_xchacha20poly1305_macbytes,I._crypto_secretbox_xchacha20poly1305_messagebytes_max=oA._crypto_secretbox_xchacha20poly1305_messagebytes_max,I._crypto_secretbox_xchacha20poly1305_noncebytes=oA._crypto_secretbox_xchacha20poly1305_noncebytes,I._crypto_secretbox_xchacha20poly1305_open_detached=oA._crypto_secretbox_xchacha20poly1305_open_detached,I._crypto_secretbox_xchacha20poly1305_open_easy=oA._crypto_secretbox_xchacha20poly1305_open_easy,I._crypto_secretbox_xsalsa20poly1305=oA._crypto_secretbox_xsalsa20poly1305,I._crypto_secretbox_xsalsa20poly1305_boxzerobytes=oA._crypto_secretbox_xsalsa20poly1305_boxzerobytes,I._crypto_secretbox_xsalsa20poly1305_keybytes=oA._crypto_secretbox_xsalsa20poly1305_keybytes,I._crypto_secretbox_xsalsa20poly1305_keygen=oA._crypto_secretbox_xsalsa20poly1305_keygen,I._crypto_secretbox_xsalsa20poly1305_macbytes=oA._crypto_secretbox_xsalsa20poly1305_macbytes,I._crypto_secretbox_xsalsa20poly1305_messagebytes_max=oA._crypto_secretbox_xsalsa20poly1305_messagebytes_max,I._crypto_secretbox_xsalsa20poly1305_noncebytes=oA._crypto_secretbox_xsalsa20poly1305_noncebytes,I._crypto_secretbox_xsalsa20poly1305_open=oA._crypto_secretbox_xsalsa20poly1305_open,I._crypto_secretbox_xsalsa20poly1305_zerobytes=oA._crypto_secretbox_xsalsa20poly1305_zerobytes,I._crypto_secretbox_zerobytes=oA._crypto_secretbox_zerobytes,I._crypto_secretstream_xchacha20poly1305_abytes=oA._crypto_secretstream_xchacha20poly1305_abytes,I._crypto_secretstream_xchacha20poly1305_headerbytes=oA._crypto_secretstream_xchacha20poly1305_headerbytes,I._crypto_secretstream_xchacha20poly1305_init_pull=oA._crypto_secretstream_xchacha20poly1305_init_pull,I._crypto_secretstream_xchacha20poly1305_init_push=oA._crypto_secretstream_xchacha20poly1305_init_push,I._crypto_secretstream_xchacha20poly1305_keybytes=oA._crypto_secretstream_xchacha20poly1305_keybytes,I._crypto_secretstream_xchacha20poly1305_keygen=oA._crypto_secretstream_xchacha20poly1305_keygen,I._crypto_secretstream_xchacha20poly1305_messagebytes_max=oA._crypto_secretstream_xchacha20poly1305_messagebytes_max,I._crypto_secretstream_xchacha20poly1305_pull=oA._crypto_secretstream_xchacha20poly1305_pull,I._crypto_secretstream_xchacha20poly1305_push=oA._crypto_secretstream_xchacha20poly1305_push,I._crypto_secretstream_xchacha20poly1305_rekey=oA._crypto_secretstream_xchacha20poly1305_rekey,I._crypto_secretstream_xchacha20poly1305_statebytes=oA._crypto_secretstream_xchacha20poly1305_statebytes,I._crypto_secretstream_xchacha20poly1305_tag_final=oA._crypto_secretstream_xchacha20poly1305_tag_final,I._crypto_secretstream_xchacha20poly1305_tag_message=oA._crypto_secretstream_xchacha20poly1305_tag_message,I._crypto_secretstream_xchacha20poly1305_tag_push=oA._crypto_secretstream_xchacha20poly1305_tag_push,I._crypto_secretstream_xchacha20poly1305_tag_rekey=oA._crypto_secretstream_xchacha20poly1305_tag_rekey,I._crypto_shorthash=oA._crypto_shorthash,I._crypto_shorthash_bytes=oA._crypto_shorthash_bytes,I._crypto_shorthash_keybytes=oA._crypto_shorthash_keybytes,I._crypto_shorthash_keygen=oA._crypto_shorthash_keygen,I._crypto_shorthash_primitive=oA._crypto_shorthash_primitive,I._crypto_shorthash_siphash24=oA._crypto_shorthash_siphash24,I._crypto_shorthash_siphash24_bytes=oA._crypto_shorthash_siphash24_bytes,I._crypto_shorthash_siphash24_keybytes=oA._crypto_shorthash_siphash24_keybytes,I._crypto_shorthash_siphashx24=oA._crypto_shorthash_siphashx24,I._crypto_shorthash_siphashx24_bytes=oA._crypto_shorthash_siphashx24_bytes,I._crypto_shorthash_siphashx24_keybytes=oA._crypto_shorthash_siphashx24_keybytes,I._crypto_sign=oA._crypto_sign,I._crypto_sign_bytes=oA._crypto_sign_bytes,I._crypto_sign_detached=oA._crypto_sign_detached,I._crypto_sign_ed25519=oA._crypto_sign_ed25519,I._crypto_sign_ed25519_bytes=oA._crypto_sign_ed25519_bytes,I._crypto_sign_ed25519_detached=oA._crypto_sign_ed25519_detached,I._crypto_sign_ed25519_keypair=oA._crypto_sign_ed25519_keypair,I._crypto_sign_ed25519_messagebytes_max=oA._crypto_sign_ed25519_messagebytes_max,I._crypto_sign_ed25519_open=oA._crypto_sign_ed25519_open,I._crypto_sign_ed25519_pk_to_curve25519=oA._crypto_sign_ed25519_pk_to_curve25519,I._crypto_sign_ed25519_publickeybytes=oA._crypto_sign_ed25519_publickeybytes,I._crypto_sign_ed25519_secretkeybytes=oA._crypto_sign_ed25519_secretkeybytes,I._crypto_sign_ed25519_seed_keypair=oA._crypto_sign_ed25519_seed_keypair,I._crypto_sign_ed25519_seedbytes=oA._crypto_sign_ed25519_seedbytes,I._crypto_sign_ed25519_sk_to_curve25519=oA._crypto_sign_ed25519_sk_to_curve25519,I._crypto_sign_ed25519_sk_to_pk=oA._crypto_sign_ed25519_sk_to_pk,I._crypto_sign_ed25519_sk_to_seed=oA._crypto_sign_ed25519_sk_to_seed,I._crypto_sign_ed25519_verify_detached=oA._crypto_sign_ed25519_verify_detached,I._crypto_sign_ed25519ph_final_create=oA._crypto_sign_ed25519ph_final_create,I._crypto_sign_ed25519ph_final_verify=oA._crypto_sign_ed25519ph_final_verify,I._crypto_sign_ed25519ph_init=oA._crypto_sign_ed25519ph_init,I._crypto_sign_ed25519ph_statebytes=oA._crypto_sign_ed25519ph_statebytes,I._crypto_sign_ed25519ph_update=oA._crypto_sign_ed25519ph_update,I._crypto_sign_final_create=oA._crypto_sign_final_create,I._crypto_sign_final_verify=oA._crypto_sign_final_verify,I._crypto_sign_init=oA._crypto_sign_init,I._crypto_sign_keypair=oA._crypto_sign_keypair,I._crypto_sign_messagebytes_max=oA._crypto_sign_messagebytes_max,I._crypto_sign_open=oA._crypto_sign_open,I._crypto_sign_primitive=oA._crypto_sign_primitive,I._crypto_sign_publickeybytes=oA._crypto_sign_publickeybytes,I._crypto_sign_secretkeybytes=oA._crypto_sign_secretkeybytes,I._crypto_sign_seed_keypair=oA._crypto_sign_seed_keypair,I._crypto_sign_seedbytes=oA._crypto_sign_seedbytes,I._crypto_sign_statebytes=oA._crypto_sign_statebytes,I._crypto_sign_update=oA._crypto_sign_update,I._crypto_sign_verify_detached=oA._crypto_sign_verify_detached,I._crypto_stream=oA._crypto_stream,I._crypto_stream_chacha20=oA._crypto_stream_chacha20,I._crypto_stream_chacha20_ietf=oA._crypto_stream_chacha20_ietf,I._crypto_stream_chacha20_ietf_keybytes=oA._crypto_stream_chacha20_ietf_keybytes,I._crypto_stream_chacha20_ietf_keygen=oA._crypto_stream_chacha20_ietf_keygen,I._crypto_stream_chacha20_ietf_messagebytes_max=oA._crypto_stream_chacha20_ietf_messagebytes_max,I._crypto_stream_chacha20_ietf_noncebytes=oA._crypto_stream_chacha20_ietf_noncebytes,I._crypto_stream_chacha20_ietf_xor=oA._crypto_stream_chacha20_ietf_xor,I._crypto_stream_chacha20_ietf_xor_ic=oA._crypto_stream_chacha20_ietf_xor_ic,I._crypto_stream_chacha20_keybytes=oA._crypto_stream_chacha20_keybytes,I._crypto_stream_chacha20_keygen=oA._crypto_stream_chacha20_keygen,I._crypto_stream_chacha20_messagebytes_max=oA._crypto_stream_chacha20_messagebytes_max,I._crypto_stream_chacha20_noncebytes=oA._crypto_stream_chacha20_noncebytes,I._crypto_stream_chacha20_xor=oA._crypto_stream_chacha20_xor,I._crypto_stream_chacha20_xor_ic=oA._crypto_stream_chacha20_xor_ic,I._crypto_stream_keybytes=oA._crypto_stream_keybytes,I._crypto_stream_keygen=oA._crypto_stream_keygen,I._crypto_stream_messagebytes_max=oA._crypto_stream_messagebytes_max,I._crypto_stream_noncebytes=oA._crypto_stream_noncebytes,I._crypto_stream_primitive=oA._crypto_stream_primitive,I._crypto_stream_salsa20=oA._crypto_stream_salsa20,I._crypto_stream_salsa2012=oA._crypto_stream_salsa2012,I._crypto_stream_salsa2012_keybytes=oA._crypto_stream_salsa2012_keybytes,I._crypto_stream_salsa2012_keygen=oA._crypto_stream_salsa2012_keygen,I._crypto_stream_salsa2012_messagebytes_max=oA._crypto_stream_salsa2012_messagebytes_max,I._crypto_stream_salsa2012_noncebytes=oA._crypto_stream_salsa2012_noncebytes,I._crypto_stream_salsa2012_xor=oA._crypto_stream_salsa2012_xor,I._crypto_stream_salsa208=oA._crypto_stream_salsa208,I._crypto_stream_salsa208_keybytes=oA._crypto_stream_salsa208_keybytes,I._crypto_stream_salsa208_keygen=oA._crypto_stream_salsa208_keygen,I._crypto_stream_salsa208_messagebytes_max=oA._crypto_stream_salsa208_messagebytes_max,I._crypto_stream_salsa208_noncebytes=oA._crypto_stream_salsa208_noncebytes,I._crypto_stream_salsa208_xor=oA._crypto_stream_salsa208_xor,I._crypto_stream_salsa20_keybytes=oA._crypto_stream_salsa20_keybytes,I._crypto_stream_salsa20_keygen=oA._crypto_stream_salsa20_keygen,I._crypto_stream_salsa20_messagebytes_max=oA._crypto_stream_salsa20_messagebytes_max,I._crypto_stream_salsa20_noncebytes=oA._crypto_stream_salsa20_noncebytes,I._crypto_stream_salsa20_xor=oA._crypto_stream_salsa20_xor,I._crypto_stream_salsa20_xor_ic=oA._crypto_stream_salsa20_xor_ic,I._crypto_stream_xchacha20=oA._crypto_stream_xchacha20,I._crypto_stream_xchacha20_keybytes=oA._crypto_stream_xchacha20_keybytes,I._crypto_stream_xchacha20_keygen=oA._crypto_stream_xchacha20_keygen,I._crypto_stream_xchacha20_messagebytes_max=oA._crypto_stream_xchacha20_messagebytes_max,I._crypto_stream_xchacha20_noncebytes=oA._crypto_stream_xchacha20_noncebytes,I._crypto_stream_xchacha20_xor=oA._crypto_stream_xchacha20_xor,I._crypto_stream_xchacha20_xor_ic=oA._crypto_stream_xchacha20_xor_ic,I._crypto_stream_xor=oA._crypto_stream_xor,I._crypto_stream_xsalsa20=oA._crypto_stream_xsalsa20,I._crypto_stream_xsalsa20_keybytes=oA._crypto_stream_xsalsa20_keybytes,I._crypto_stream_xsalsa20_keygen=oA._crypto_stream_xsalsa20_keygen,I._crypto_stream_xsalsa20_messagebytes_max=oA._crypto_stream_xsalsa20_messagebytes_max,I._crypto_stream_xsalsa20_noncebytes=oA._crypto_stream_xsalsa20_noncebytes,I._crypto_stream_xsalsa20_xor=oA._crypto_stream_xsalsa20_xor,I._crypto_stream_xsalsa20_xor_ic=oA._crypto_stream_xsalsa20_xor_ic,I._crypto_verify_16=oA._crypto_verify_16,I._crypto_verify_16_bytes=oA._crypto_verify_16_bytes,I._crypto_verify_32=oA._crypto_verify_32,I._crypto_verify_32_bytes=oA._crypto_verify_32_bytes,I._crypto_verify_64=oA._crypto_verify_64,I._crypto_verify_64_bytes=oA._crypto_verify_64_bytes,I._emscripten_get_sbrk_ptr=oA._emscripten_get_sbrk_ptr,I._emscripten_replace_memory=oA._emscripten_replace_memory);if(I._free=oA._free,I._i64Add=oA._i64Add,I._i64Subtract=oA._i64Subtract,I._malloc=oA._malloc,I._memcpy=oA._memcpy,I._memmove=oA._memmove,I._memset=oA._memset,I._randombytes=oA._randombytes,I._randombytes_buf=oA._randombytes_buf,I._randombytes_buf_deterministic=oA._randombytes_buf_deterministic,I._randombytes_close=oA._randombytes_close,I._randombytes_implementation_name=oA._randombytes_implementation_name,I._randombytes_random=oA._randombytes_random,I._randombytes_seedbytes=oA._randombytes_seedbytes,I._randombytes_stir=oA._randombytes_stir,I._randombytes_uniform=oA._randombytes_uniform,I._sodium_base642bin=oA._sodium_base642bin,I._sodium_base64_encoded_len=oA._sodium_base64_encoded_len,I._sodium_bin2base64=oA._sodium_bin2base64,I._sodium_bin2hex=oA._sodium_bin2hex,I._sodium_hex2bin=oA._sodium_hex2bin,I._sodium_init=oA._sodium_init,I._sodium_library_minimal=oA._sodium_library_minimal,I._sodium_library_version_major=oA._sodium_library_version_major,I._sodium_library_version_minor=oA._sodium_library_version_minor,I._sodium_pad=oA._sodium_pad,I._sodium_unpad=oA._sodium_unpad,I._sodium_version_string=oA._sodium_version_string,I.establishStackSpace=oA.establishStackSpace,I.stackAlloc=oA.stackAlloc,I.stackRestore=oA.stackRestore,I.stackSave=oA.stackSave,I.asm=oA,I.setValue=function(A,I,g,B){switch("*"===(g=g||"i8").charAt(g.length-1)&&(g="i32"),g){case"i1":case"i8":l[A>>0]=I;break;case"i16":D[A>>1]=I;break;case"i32":m[A>>2]=I;break;case"i64":T=[I>>>0,(j=I,+N(j)>=1?j>0?(0|L(+Y(j/4294967296),4294967295))>>>0:~~+R((j-+(~~j>>>0))/4294967296)>>>0:0)],m[A>>2]=T[0],m[A+4>>2]=T[1];break;case"float":F[A>>2]=I;break;case"double":k[A>>3]=I;break;default:X("invalid type for setValue: "+g)}},I.getValue=function(A,I,g){switch("*"===(I=I||"i8").charAt(I.length-1)&&(I="i32"),I){case"i1":case"i8":return l[A>>0];case"i16":return D[A>>1];case"i32":case"i64":return m[A>>2];case"float":return F[A>>2];case"double":return k[A>>3];default:X("invalid type for getValue: "+I)}return null},I.UTF8ToString=d,V)if(z(V)||(QA=V,V=I.locateFile?I.locateFile(QA,n):n+QA),e||r){var iA=i(V);u.set(iA,8)}else{P++,I.monitorRunDependencies&&I.monitorRunDependencies(P);var _A=function(A){A.byteLength&&(A=new Uint8Array(A)),u.set(A,8),I.memoryInitializerRequest&&delete I.memoryInitializerRequest.response,function(A){if(P--,I.monitorRunDependencies&&I.monitorRunDependencies(P),0==P&&(null!==K&&(clearInterval(K),K=null),q)){var g=q;q=null,g()}}()},EA=function(){c(V,_A,function(){throw"could not load memory initializer "+V})},nA=rA(V);if(nA)_A(nA.buffer);else if(I.memoryInitializerRequest){var sA=function(){var A=I.memoryInitializerRequest,g=A.response;if(200!==A.status&&0!==A.status){var B=rA(I.memoryInitializerRequestURL);if(!B)return void EA();g=B.buffer}_A(g)};I.memoryInitializerRequest.response?setTimeout(sA,0):I.memoryInitializerRequest.addEventListener("load",sA)}else EA()}function yA(A){function g(){eA||(eA=!0,p||(x(M),x(J),I.onRuntimeInitialized&&I.onRuntimeInitialized(),function(){if(I.postRun)for("function"==typeof I.postRun&&(I.postRun=[I.postRun]);I.postRun.length;)A=I.postRun.shift(),v.unshift(A);var A;x(v)}()))}A=A||Q,P>0||(function(){if(I.preRun)for("function"==typeof I.preRun&&(I.preRun=[I.preRun]);I.preRun.length;)A=I.preRun.shift(),U.unshift(A);var A;x(U)}(),P>0||(I.setStatus?(I.setStatus("Running..."),setTimeout(function(){setTimeout(function(){I.setStatus("")},1),g()},1)):g()))}if(q=function A(){eA||yA(),eA||(q=A)},I.run=yA,I.preInit)for("function"==typeof I.preInit&&(I.preInit=[I.preInit]);I.preInit.length>0;)I.preInit.pop()();yA(),Object.keys(B).forEach(function(A){"getRandomValue"!==A&&delete B[A]}),Object.keys(I).forEach(function(A){B[A]=I[A]})};var g,C=void 0!==C?C:{},a={};for(g in C)C.hasOwnProperty(g)&&(a[g]=C[g]);var t,r,Q=[],e=!1,o=!1,c=!1;e="object"==typeof window,o="function"==typeof importScripts,t="object"==typeof process&&"object"==typeof process.versions&&"string"==typeof process.versions.node,c=t&&!e&&!o,r=!e&&!c&&!o;var i,_,E,n,s="";c?(s=__dirname+"/",i=function(A,I){var g;return(g=QA(A))||(E||(E=__webpack_require__(110)),n||(n=__webpack_require__(111)),A=n.normalize(A),g=E.readFileSync(A)),I?g:g.toString()},_=function(A){var I=i(A,!0);return I.buffer||(I=new Uint8Array(I)),D(I.buffer),I},process.argv.length>1&&process.argv[1].replace(/\\/g,"/"),Q=process.argv.slice(2),"undefined"!=typeof module&&(module.exports=C),process.on("unhandledRejection",W),C.inspect=function(){return"[Emscripten Module object]"}):r?("undefined"!=typeof read&&(i=function(A){var I=QA(A);return I?tA(I):read(A)}),_=function(A){var I;return(I=QA(A))?I:"function"==typeof readbuffer?new Uint8Array(readbuffer(A)):(D("object"==typeof(I=read(A,"binary"))),I)},"undefined"!=typeof scriptArgs?Q=scriptArgs:void 0!==arguments&&(Q=arguments),"undefined"!=typeof print&&("undefined"==typeof console&&(console={}),console.log=print,console.warn=console.error="undefined"!=typeof printErr?printErr:print)):(e||o)&&(o?s=self.location.href:document.currentScript&&(s=document.currentScript.src),s=0!==s.indexOf("blob:")?s.substr(0,s.lastIndexOf("/")+1):"",i=function(A){try{var I=new XMLHttpRequest;return I.open("GET",A,!1),I.send(null),I.responseText}catch(I){var g=QA(A);if(g)return tA(g);throw I}},o&&(_=function(A){try{var I=new XMLHttpRequest;return I.open("GET",A,!1),I.responseType="arraybuffer",I.send(null),new Uint8Array(I.response)}catch(I){var g=QA(A);if(g)return g;throw I}}));var y=C.print||void 0,h=C.printErr||void 0;for(g in a)a.hasOwnProperty(g)&&(C[g]=a[g]);a=null,C.arguments&&(Q=C.arguments),C.thisProgram&&C.thisProgram,C.quit&&C.quit;var p,f,w={"f64-rem":function(A,I){return A%I},debugger:function(){}};new Array(8),C.wasmBinary&&(p=C.wasmBinary),C.noExitRuntime&&C.noExitRuntime,"object"!=typeof WebAssembly&&h("no native wasm support detected");var l=new WebAssembly.Table({initial:0,maximum:0,element:"anyfunc"}),u=!1;function D(A,I){A||W("Assertion failed: "+I)}var m,F,k,b,d,H,G,S="undefined"!=typeof TextDecoder?new TextDecoder("utf8"):void 0;function x(A,I){return A?function(A,I,g){for(var B=I+g,C=I;A[C]&&!(C>=B);)++C;if(C-I>16&&A.subarray&&S)return S.decode(A.subarray(I,C));for(var a="";I<C;){var t=A[I++];if(128&t){var r=63&A[I++];if(192!=(224&t)){var Q=63&A[I++];if((t=224==(240&t)?(15&t)<<12|r<<6|Q:(7&t)<<18|r<<12|Q<<6|63&A[I++])<65536)a+=String.fromCharCode(t);else{var e=t-65536;a+=String.fromCharCode(55296|e>>10,56320|1023&e)}}else a+=String.fromCharCode((31&t)<<6|r)}else a+=String.fromCharCode(t)}return a}(k,A,I):""}function U(A,I){return A%I>0&&(A+=I-A%I),A}function M(A){m=A,C.HEAP8=F=new Int8Array(A),C.HEAP16=b=new Int16Array(A),C.HEAP32=d=new Int32Array(A),C.HEAPU8=k=new Uint8Array(A),C.HEAPU16=new Uint16Array(A),C.HEAPU32=new Uint32Array(A),C.HEAPF32=H=new Float32Array(A),C.HEAPF64=G=new Float64Array(A)}"undefined"!=typeof TextDecoder&&new TextDecoder("utf-16le");var J=C.TOTAL_MEMORY||16777216;function v(A){for(;A.length>0;){var I=A.shift();if("function"!=typeof I){var g=I.func;"number"==typeof g?void 0===I.arg?C.dynCall_v(g):C.dynCall_vi(g,I.arg):g(void 0===I.arg?null:I.arg)}else I()}}(f=C.wasmMemory?C.wasmMemory:new WebAssembly.Memory({initial:J/65536}))&&(m=f.buffer),J=m.byteLength,M(m),d[9520]=5281152;var N=[],R=[],Y=[],L=[],P=Math.abs,K=Math.ceil,q=Math.floor,X=Math.min,j=0,T=null,V=null;function W(A){throw C.onAbort&&C.onAbort(A),y(A+=""),h(A),u=!0,"abort("+A+"). Build with -s ASSERTIONS=1 for more info."}C.preloadedImages={},C.preloadedAudios={};var z="data:application/octet-stream;base64,";function Z(A){return String.prototype.startsWith?A.startsWith(z):0===A.indexOf(z)}var O,$,AA,IA="data:application/octet-stream;base64,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";function gA(){try{if(p)return new Uint8Array(p);var A=QA(IA);if(A)return A;if(_)return _(IA);throw"both async and sync fetching of the wasm failed"}catch(A){W(A)}}Z(IA)||(O=IA,IA=C.locateFile?C.locateFile(O,s):s+O),C.asm=function(){var A={env:oA,wasi_unstable:oA,global:{NaN:NaN,Infinity:1/0},"global.Math":Math,asm2wasm:w};function I(A,I){var g=A.exports;C.asm=g,function(A){if(j--,C.monitorRunDependencies&&C.monitorRunDependencies(j),0==j&&(null!==T&&(clearInterval(T),T=null),V)){var I=V;V=null,I()}}()}function g(A){I(A.instance)}function B(I){return(p||!e&&!o||"function"!=typeof fetch?new Promise(function(A,I){A(gA())}):fetch(IA,{credentials:"same-origin"}).then(function(A){if(!A.ok)throw"failed to load wasm binary file at '"+IA+"'";return A.arrayBuffer()}).catch(function(){return gA()})).then(function(I){return WebAssembly.instantiate(I,A)}).then(I,function(A){h("failed to asynchronously prepare wasm: "+A),W(A)})}if(j++,C.monitorRunDependencies&&C.monitorRunDependencies(j),C.instantiateWasm)try{return C.instantiateWasm(A,I)}catch(A){return h("Module.instantiateWasm callback failed with error: "+A),!1}return function(){if(p||"function"!=typeof WebAssembly.instantiateStreaming||Z(IA)||"function"!=typeof fetch)return B(g);fetch(IA,{credentials:"same-origin"}).then(function(I){return WebAssembly.instantiateStreaming(I,A).then(g,function(A){h("wasm streaming compile failed: "+A),h("falling back to ArrayBuffer instantiation"),B(g)})})}(),{}};var BA=[function(){return C.getRandomValue()},function(){if(void 0===C.getRandomValue)try{var A="object"==typeof window?window:self,I=void 0!==A.crypto?A.crypto:A.msCrypto,g=function(){var A=new Uint32Array(1);return I.getRandomValues(A),A[0]>>>0};g(),C.getRandomValue=g}catch(A){try{var B=__webpack_require__(112),a=function(){var A=B.randomBytes(4);return(A[0]<<24|A[1]<<16|A[2]<<8|A[3])>>>0};a(),C.getRandomValue=a}catch(A){throw"No secure random number generator found"}}}];function CA(){return F.length}var aA=!1;function tA(A){for(var I=[],g=0;g<A.length;g++){var B=A[g];B>255&&(aA&&D(!1,"Character code "+B+" ("+String.fromCharCode(B)+")  at offset "+g+" not in 0x00-0xFF."),B&=255),I.push(String.fromCharCode(B))}return I.join("")}var rA="function"==typeof atob?atob:function(A){var I,g,B,C,a,t,r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",Q="",e=0;A=A.replace(/[^A-Za-z0-9\+\/\=]/g,"");do{I=r.indexOf(A.charAt(e++))<<2|(C=r.indexOf(A.charAt(e++)))>>4,g=(15&C)<<4|(a=r.indexOf(A.charAt(e++)))>>2,B=(3&a)<<6|(t=r.indexOf(A.charAt(e++))),Q+=String.fromCharCode(I),64!==a&&(Q+=String.fromCharCode(g)),64!==t&&(Q+=String.fromCharCode(B))}while(e<A.length);return Q};function QA(A){if(Z(A))return function(A){if("boolean"==typeof c&&c){var I;try{I=Buffer.from(A,"base64")}catch(g){I=new Buffer(A,"base64")}return new Uint8Array(I.buffer,I.byteOffset,I.byteLength)}try{for(var g=rA(A),B=new Uint8Array(g.length),C=0;C<g.length;++C)B[C]=g.charCodeAt(C);return B}catch(A){throw new Error("Converting base64 string to bytes failed.")}}(A.slice(z.length))}var eA,oA={c:function(A,I,g,B){W("Assertion failed: "+x(A)+", at: "+[I?x(I):"unknown filename",g,B?x(B):"unknown function"])},__memory_base:1024,__table_base:0,a:function(){W()},b:function(A){return BA[A]()},g:CA,f:function(A,I,g){k.set(k.subarray(I,I+g),A)},e:function(A){var I=CA();if(A>2147418112)return!1;for(var g=Math.max(I,16777216);g<A;)g=g<=536870912?U(2*g,65536):Math.min(U((3*g+2147483648)/4,65536),2147418112);return!!function(A){try{return f.grow(A-m.byteLength+65535>>16),M(f.buffer),1}catch(A){}}(g)},d:function(A){switch(A){case 30:return 16384;case 85:return 131068;case 132:case 133:case 12:case 137:case 138:case 15:case 235:case 16:case 17:case 18:case 19:case 20:case 149:case 13:case 10:case 236:case 153:case 9:case 21:case 22:case 159:case 154:case 14:case 77:case 78:case 139:case 80:case 81:case 82:case 68:case 67:case 164:case 11:case 29:case 47:case 48:case 95:case 52:case 51:case 46:return 200809;case 79:return 0;case 27:case 246:case 127:case 128:case 23:case 24:case 160:case 161:case 181:case 182:case 242:case 183:case 184:case 243:case 244:case 245:case 165:case 178:case 179:case 49:case 50:case 168:case 169:case 175:case 170:case 171:case 172:case 97:case 76:case 32:case 173:case 35:return-1;case 176:case 177:case 7:case 155:case 8:case 157:case 125:case 126:case 92:case 93:case 129:case 130:case 131:case 94:case 91:return 1;case 74:case 60:case 69:case 70:case 4:return 1024;case 31:case 42:case 72:return 32;case 87:case 26:case 33:return 2147483647;case 34:case 1:return 47839;case 38:case 36:return 99;case 43:case 37:return 2048;case 0:return 2097152;case 3:return 65536;case 28:return 32768;case 44:return 32767;case 75:return 16384;case 39:return 1e3;case 89:return 700;case 71:return 256;case 40:return 255;case 2:return 100;case 180:return 64;case 25:return 20;case 5:return 16;case 6:return 6;case 73:return 4;case 84:return"object"==typeof navigator&&navigator.hardwareConcurrency||1}return C.___errno_location&&(d[C.___errno_location()>>2]=28),-1},memory:f,table:l},cA=C.asm({},oA,m);function iA(A){function I(){eA||(eA=!0,u||(v(R),v(Y),C.onRuntimeInitialized&&C.onRuntimeInitialized(),function(){if(C.postRun)for("function"==typeof C.postRun&&(C.postRun=[C.postRun]);C.postRun.length;)A=C.postRun.shift(),L.unshift(A);var A;v(L)}()))}A=A||Q,j>0||(function(){if(C.preRun)for("function"==typeof C.preRun&&(C.preRun=[C.preRun]);C.preRun.length;)A=C.preRun.shift(),N.unshift(A);var A;v(N)}(),j>0||(C.setStatus?(C.setStatus("Running..."),setTimeout(function(){setTimeout(function(){C.setStatus("")},1),I()},1)):I()))}if(C.asm=cA,C.___errno_location=function(){return C.asm.h.apply(null,arguments)},C._crypto_aead_chacha20poly1305_abytes=function(){return C.asm.i.apply(null,arguments)},C._crypto_aead_chacha20poly1305_decrypt=function(){return C.asm.j.apply(null,arguments)},C._crypto_aead_chacha20poly1305_decrypt_detached=function(){return C.asm.k.apply(null,arguments)},C._crypto_aead_chacha20poly1305_encrypt=function(){return C.asm.l.apply(null,arguments)},C._crypto_aead_chacha20poly1305_encrypt_detached=function(){return C.asm.m.apply(null,arguments)},C._crypto_aead_chacha20poly1305_ietf_abytes=function(){return C.asm.n.apply(null,arguments)},C._crypto_aead_chacha20poly1305_ietf_decrypt=function(){return C.asm.o.apply(null,arguments)},C._crypto_aead_chacha20poly1305_ietf_decrypt_detached=function(){return C.asm.p.apply(null,arguments)},C._crypto_aead_chacha20poly1305_ietf_encrypt=function(){return C.asm.q.apply(null,arguments)},C._crypto_aead_chacha20poly1305_ietf_encrypt_detached=function(){return C.asm.r.apply(null,arguments)},C._crypto_aead_chacha20poly1305_ietf_keybytes=function(){return C.asm.s.apply(null,arguments)},C._crypto_aead_chacha20poly1305_ietf_keygen=function(){return C.asm.t.apply(null,arguments)},C._crypto_aead_chacha20poly1305_ietf_messagebytes_max=function(){return C.asm.u.apply(null,arguments)},C._crypto_aead_chacha20poly1305_ietf_npubbytes=function(){return C.asm.v.apply(null,arguments)},C._crypto_aead_chacha20poly1305_ietf_nsecbytes=function(){return C.asm.w.apply(null,arguments)},C._crypto_aead_chacha20poly1305_keybytes=function(){return C.asm.x.apply(null,arguments)},C._crypto_aead_chacha20poly1305_keygen=function(){return C.asm.y.apply(null,arguments)},C._crypto_aead_chacha20poly1305_messagebytes_max=function(){return C.asm.z.apply(null,arguments)},C._crypto_aead_chacha20poly1305_npubbytes=function(){return C.asm.A.apply(null,arguments)},C._crypto_aead_chacha20poly1305_nsecbytes=function(){return C.asm.B.apply(null,arguments)},C._crypto_aead_xchacha20poly1305_ietf_abytes=function(){return C.asm.C.apply(null,arguments)},C._crypto_aead_xchacha20poly1305_ietf_decrypt=function(){return C.asm.D.apply(null,arguments)},C._crypto_aead_xchacha20poly1305_ietf_decrypt_detached=function(){return C.asm.E.apply(null,arguments)},C._crypto_aead_xchacha20poly1305_ietf_encrypt=function(){return C.asm.F.apply(null,arguments)},C._crypto_aead_xchacha20poly1305_ietf_encrypt_detached=function(){return C.asm.G.apply(null,arguments)},C._crypto_aead_xchacha20poly1305_ietf_keybytes=function(){return C.asm.H.apply(null,arguments)},C._crypto_aead_xchacha20poly1305_ietf_keygen=function(){return C.asm.I.apply(null,arguments)},C._crypto_aead_xchacha20poly1305_ietf_messagebytes_max=function(){return C.asm.J.apply(null,arguments)},C._crypto_aead_xchacha20poly1305_ietf_npubbytes=function(){return C.asm.K.apply(null,arguments)},C._crypto_aead_xchacha20poly1305_ietf_nsecbytes=function(){return C.asm.L.apply(null,arguments)},C._crypto_auth=function(){return C.asm.M.apply(null,arguments)},C._crypto_auth_bytes=function(){return C.asm.N.apply(null,arguments)},C._crypto_auth_hmacsha256=function(){return C.asm.O.apply(null,arguments)},C._crypto_auth_hmacsha256_bytes=function(){return C.asm.P.apply(null,arguments)},C._crypto_auth_hmacsha256_final=function(){return C.asm.Q.apply(null,arguments)},C._crypto_auth_hmacsha256_init=function(){return C.asm.R.apply(null,arguments)},C._crypto_auth_hmacsha256_keybytes=function(){return C.asm.S.apply(null,arguments)},C._crypto_auth_hmacsha256_keygen=function(){return C.asm.T.apply(null,arguments)},C._crypto_auth_hmacsha256_statebytes=function(){return C.asm.U.apply(null,arguments)},C._crypto_auth_hmacsha256_update=function(){return C.asm.V.apply(null,arguments)},C._crypto_auth_hmacsha256_verify=function(){return C.asm.W.apply(null,arguments)},C._crypto_auth_hmacsha512=function(){return C.asm.X.apply(null,arguments)},C._crypto_auth_hmacsha512256=function(){return C.asm.Y.apply(null,arguments)},C._crypto_auth_hmacsha512256_bytes=function(){return C.asm.Z.apply(null,arguments)},C._crypto_auth_hmacsha512256_final=function(){return C.asm._.apply(null,arguments)},C._crypto_auth_hmacsha512256_init=function(){return C.asm.$.apply(null,arguments)},C._crypto_auth_hmacsha512256_keybytes=function(){return C.asm.aa.apply(null,arguments)},C._crypto_auth_hmacsha512256_keygen=function(){return C.asm.ba.apply(null,arguments)},C._crypto_auth_hmacsha512256_statebytes=function(){return C.asm.ca.apply(null,arguments)},C._crypto_auth_hmacsha512256_update=function(){return C.asm.da.apply(null,arguments)},C._crypto_auth_hmacsha512256_verify=function(){return C.asm.ea.apply(null,arguments)},C._crypto_auth_hmacsha512_bytes=function(){return C.asm.fa.apply(null,arguments)},C._crypto_auth_hmacsha512_final=function(){return C.asm.ga.apply(null,arguments)},C._crypto_auth_hmacsha512_init=function(){return C.asm.ha.apply(null,arguments)},C._crypto_auth_hmacsha512_keybytes=function(){return C.asm.ia.apply(null,arguments)},C._crypto_auth_hmacsha512_keygen=function(){return C.asm.ja.apply(null,arguments)},C._crypto_auth_hmacsha512_statebytes=function(){return C.asm.ka.apply(null,arguments)},C._crypto_auth_hmacsha512_update=function(){return C.asm.la.apply(null,arguments)},C._crypto_auth_hmacsha512_verify=function(){return C.asm.ma.apply(null,arguments)},C._crypto_auth_keybytes=function(){return C.asm.na.apply(null,arguments)},C._crypto_auth_keygen=function(){return C.asm.oa.apply(null,arguments)},C._crypto_auth_primitive=function(){return C.asm.pa.apply(null,arguments)},C._crypto_auth_verify=function(){return C.asm.qa.apply(null,arguments)},C._crypto_box=function(){return C.asm.ra.apply(null,arguments)},C._crypto_box_afternm=function(){return C.asm.sa.apply(null,arguments)},C._crypto_box_beforenm=function(){return C.asm.ta.apply(null,arguments)},C._crypto_box_beforenmbytes=function(){return C.asm.ua.apply(null,arguments)},C._crypto_box_boxzerobytes=function(){return C.asm.va.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_beforenm=function(){return C.asm.wa.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_beforenmbytes=function(){return C.asm.xa.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_detached=function(){return C.asm.ya.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_detached_afternm=function(){return C.asm.za.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_easy=function(){return C.asm.Aa.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_easy_afternm=function(){return C.asm.Ba.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_keypair=function(){return C.asm.Ca.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_macbytes=function(){return C.asm.Da.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_messagebytes_max=function(){return C.asm.Ea.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_noncebytes=function(){return C.asm.Fa.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_open_detached=function(){return C.asm.Ga.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_open_detached_afternm=function(){return C.asm.Ha.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_open_easy=function(){return C.asm.Ia.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_open_easy_afternm=function(){return C.asm.Ja.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_publickeybytes=function(){return C.asm.Ka.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_seal=function(){return C.asm.La.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_seal_open=function(){return C.asm.Ma.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_sealbytes=function(){return C.asm.Na.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_secretkeybytes=function(){return C.asm.Oa.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_seed_keypair=function(){return C.asm.Pa.apply(null,arguments)},C._crypto_box_curve25519xchacha20poly1305_seedbytes=function(){return C.asm.Qa.apply(null,arguments)},C._crypto_box_curve25519xsalsa20poly1305=function(){return C.asm.Ra.apply(null,arguments)},C._crypto_box_curve25519xsalsa20poly1305_afternm=function(){return C.asm.Sa.apply(null,arguments)},C._crypto_box_curve25519xsalsa20poly1305_beforenm=function(){return C.asm.Ta.apply(null,arguments)},C._crypto_box_curve25519xsalsa20poly1305_beforenmbytes=function(){return C.asm.Ua.apply(null,arguments)},C._crypto_box_curve25519xsalsa20poly1305_boxzerobytes=function(){return C.asm.Va.apply(null,arguments)},C._crypto_box_curve25519xsalsa20poly1305_keypair=function(){return C.asm.Wa.apply(null,arguments)},C._crypto_box_curve25519xsalsa20poly1305_macbytes=function(){return C.asm.Xa.apply(null,arguments)},C._crypto_box_curve25519xsalsa20poly1305_messagebytes_max=function(){return C.asm.Ya.apply(null,arguments)},C._crypto_box_curve25519xsalsa20poly1305_noncebytes=function(){return C.asm.Za.apply(null,arguments)},C._crypto_box_curve25519xsalsa20poly1305_open=function(){return C.asm._a.apply(null,arguments)},C._crypto_box_curve25519xsalsa20poly1305_open_afternm=function(){return C.asm.$a.apply(null,arguments)},C._crypto_box_curve25519xsalsa20poly1305_publickeybytes=function(){return C.asm.ab.apply(null,arguments)},C._crypto_box_curve25519xsalsa20poly1305_secretkeybytes=function(){return C.asm.bb.apply(null,arguments)},C._crypto_box_curve25519xsalsa20poly1305_seed_keypair=function(){return C.asm.cb.apply(null,arguments)},C._crypto_box_curve25519xsalsa20poly1305_seedbytes=function(){return C.asm.db.apply(null,arguments)},C._crypto_box_curve25519xsalsa20poly1305_zerobytes=function(){return C.asm.eb.apply(null,arguments)},C._crypto_box_detached=function(){return C.asm.fb.apply(null,arguments)},C._crypto_box_detached_afternm=function(){return C.asm.gb.apply(null,arguments)},C._crypto_box_easy=function(){return C.asm.hb.apply(null,arguments)},C._crypto_box_easy_afternm=function(){return C.asm.ib.apply(null,arguments)},C._crypto_box_keypair=function(){return C.asm.jb.apply(null,arguments)},C._crypto_box_macbytes=function(){return C.asm.kb.apply(null,arguments)},C._crypto_box_messagebytes_max=function(){return C.asm.lb.apply(null,arguments)},C._crypto_box_noncebytes=function(){return C.asm.mb.apply(null,arguments)},C._crypto_box_open=function(){return C.asm.nb.apply(null,arguments)},C._crypto_box_open_afternm=function(){return C.asm.ob.apply(null,arguments)},C._crypto_box_open_detached=function(){return C.asm.pb.apply(null,arguments)},C._crypto_box_open_detached_afternm=function(){return C.asm.qb.apply(null,arguments)},C._crypto_box_open_easy=function(){return C.asm.rb.apply(null,arguments)},C._crypto_box_open_easy_afternm=function(){return C.asm.sb.apply(null,arguments)},C._crypto_box_primitive=function(){return C.asm.tb.apply(null,arguments)},C._crypto_box_publickeybytes=function(){return C.asm.ub.apply(null,arguments)},C._crypto_box_seal=function(){return C.asm.vb.apply(null,arguments)},C._crypto_box_seal_open=function(){return C.asm.wb.apply(null,arguments)},C._crypto_box_sealbytes=function(){return C.asm.xb.apply(null,arguments)},C._crypto_box_secretkeybytes=function(){return C.asm.yb.apply(null,arguments)},C._crypto_box_seed_keypair=function(){return C.asm.zb.apply(null,arguments)},C._crypto_box_seedbytes=function(){return C.asm.Ab.apply(null,arguments)},C._crypto_box_zerobytes=function(){return C.asm.Bb.apply(null,arguments)},C._crypto_core_ed25519_add=function(){return C.asm.Cb.apply(null,arguments)},C._crypto_core_ed25519_bytes=function(){return C.asm.Db.apply(null,arguments)},C._crypto_core_ed25519_from_hash=function(){return C.asm.Eb.apply(null,arguments)},C._crypto_core_ed25519_from_uniform=function(){return C.asm.Fb.apply(null,arguments)},C._crypto_core_ed25519_hashbytes=function(){return C.asm.Gb.apply(null,arguments)},C._crypto_core_ed25519_is_valid_point=function(){return C.asm.Hb.apply(null,arguments)},C._crypto_core_ed25519_nonreducedscalarbytes=function(){return C.asm.Ib.apply(null,arguments)},C._crypto_core_ed25519_random=function(){return C.asm.Jb.apply(null,arguments)},C._crypto_core_ed25519_scalar_add=function(){return C.asm.Kb.apply(null,arguments)},C._crypto_core_ed25519_scalar_complement=function(){return C.asm.Lb.apply(null,arguments)},C._crypto_core_ed25519_scalar_invert=function(){return C.asm.Mb.apply(null,arguments)},C._crypto_core_ed25519_scalar_mul=function(){return C.asm.Nb.apply(null,arguments)},C._crypto_core_ed25519_scalar_negate=function(){return C.asm.Ob.apply(null,arguments)},C._crypto_core_ed25519_scalar_random=function(){return C.asm.Pb.apply(null,arguments)},C._crypto_core_ed25519_scalar_reduce=function(){return C.asm.Qb.apply(null,arguments)},C._crypto_core_ed25519_scalar_sub=function(){return C.asm.Rb.apply(null,arguments)},C._crypto_core_ed25519_scalarbytes=function(){return C.asm.Sb.apply(null,arguments)},C._crypto_core_ed25519_sub=function(){return C.asm.Tb.apply(null,arguments)},C._crypto_core_ed25519_uniformbytes=function(){return C.asm.Ub.apply(null,arguments)},C._crypto_core_hchacha20=function(){return C.asm.Vb.apply(null,arguments)},C._crypto_core_hchacha20_constbytes=function(){return C.asm.Wb.apply(null,arguments)},C._crypto_core_hchacha20_inputbytes=function(){return C.asm.Xb.apply(null,arguments)},C._crypto_core_hchacha20_keybytes=function(){return C.asm.Yb.apply(null,arguments)},C._crypto_core_hchacha20_outputbytes=function(){return C.asm.Zb.apply(null,arguments)},C._crypto_core_hsalsa20=function(){return C.asm._b.apply(null,arguments)},C._crypto_core_hsalsa20_constbytes=function(){return C.asm.$b.apply(null,arguments)},C._crypto_core_hsalsa20_inputbytes=function(){return C.asm.ac.apply(null,arguments)},C._crypto_core_hsalsa20_keybytes=function(){return C.asm.bc.apply(null,arguments)},C._crypto_core_hsalsa20_outputbytes=function(){return C.asm.cc.apply(null,arguments)},C._crypto_core_ristretto255_add=function(){return C.asm.dc.apply(null,arguments)},C._crypto_core_ristretto255_bytes=function(){return C.asm.ec.apply(null,arguments)},C._crypto_core_ristretto255_from_hash=function(){return C.asm.fc.apply(null,arguments)},C._crypto_core_ristretto255_hashbytes=function(){return C.asm.gc.apply(null,arguments)},C._crypto_core_ristretto255_is_valid_point=function(){return C.asm.hc.apply(null,arguments)},C._crypto_core_ristretto255_nonreducedscalarbytes=function(){return C.asm.ic.apply(null,arguments)},C._crypto_core_ristretto255_random=function(){return C.asm.jc.apply(null,arguments)},C._crypto_core_ristretto255_scalar_add=function(){return C.asm.kc.apply(null,arguments)},C._crypto_core_ristretto255_scalar_complement=function(){return C.asm.lc.apply(null,arguments)},C._crypto_core_ristretto255_scalar_invert=function(){return C.asm.mc.apply(null,arguments)},C._crypto_core_ristretto255_scalar_mul=function(){return C.asm.nc.apply(null,arguments)},C._crypto_core_ristretto255_scalar_negate=function(){return C.asm.oc.apply(null,arguments)},C._crypto_core_ristretto255_scalar_random=function(){return C.asm.pc.apply(null,arguments)},C._crypto_core_ristretto255_scalar_reduce=function(){return C.asm.qc.apply(null,arguments)},C._crypto_core_ristretto255_scalar_sub=function(){return C.asm.rc.apply(null,arguments)},C._crypto_core_ristretto255_scalarbytes=function(){return C.asm.sc.apply(null,arguments)},C._crypto_core_ristretto255_sub=function(){return C.asm.tc.apply(null,arguments)},C._crypto_core_salsa20=function(){return C.asm.uc.apply(null,arguments)},C._crypto_core_salsa2012=function(){return C.asm.vc.apply(null,arguments)},C._crypto_core_salsa2012_constbytes=function(){return C.asm.wc.apply(null,arguments)},C._crypto_core_salsa2012_inputbytes=function(){return C.asm.xc.apply(null,arguments)},C._crypto_core_salsa2012_keybytes=function(){return C.asm.yc.apply(null,arguments)},C._crypto_core_salsa2012_outputbytes=function(){return C.asm.zc.apply(null,arguments)},C._crypto_core_salsa208=function(){return C.asm.Ac.apply(null,arguments)},C._crypto_core_salsa208_constbytes=function(){return C.asm.Bc.apply(null,arguments)},C._crypto_core_salsa208_inputbytes=function(){return C.asm.Cc.apply(null,arguments)},C._crypto_core_salsa208_keybytes=function(){return C.asm.Dc.apply(null,arguments)},C._crypto_core_salsa208_outputbytes=function(){return C.asm.Ec.apply(null,arguments)},C._crypto_core_salsa20_constbytes=function(){return C.asm.Fc.apply(null,arguments)},C._crypto_core_salsa20_inputbytes=function(){return C.asm.Gc.apply(null,arguments)},C._crypto_core_salsa20_keybytes=function(){return C.asm.Hc.apply(null,arguments)},C._crypto_core_salsa20_outputbytes=function(){return C.asm.Ic.apply(null,arguments)},C._crypto_generichash=function(){return C.asm.Jc.apply(null,arguments)},C._crypto_generichash_blake2b=function(){return C.asm.Kc.apply(null,arguments)},C._crypto_generichash_blake2b_bytes=function(){return C.asm.Lc.apply(null,arguments)},C._crypto_generichash_blake2b_bytes_max=function(){return C.asm.Mc.apply(null,arguments)},C._crypto_generichash_blake2b_bytes_min=function(){return C.asm.Nc.apply(null,arguments)},C._crypto_generichash_blake2b_final=function(){return C.asm.Oc.apply(null,arguments)},C._crypto_generichash_blake2b_init=function(){return C.asm.Pc.apply(null,arguments)},C._crypto_generichash_blake2b_init_salt_personal=function(){return C.asm.Qc.apply(null,arguments)},C._crypto_generichash_blake2b_keybytes=function(){return C.asm.Rc.apply(null,arguments)},C._crypto_generichash_blake2b_keybytes_max=function(){return C.asm.Sc.apply(null,arguments)},C._crypto_generichash_blake2b_keybytes_min=function(){return C.asm.Tc.apply(null,arguments)},C._crypto_generichash_blake2b_keygen=function(){return C.asm.Uc.apply(null,arguments)},C._crypto_generichash_blake2b_personalbytes=function(){return C.asm.Vc.apply(null,arguments)},C._crypto_generichash_blake2b_salt_personal=function(){return C.asm.Wc.apply(null,arguments)},C._crypto_generichash_blake2b_saltbytes=function(){return C.asm.Xc.apply(null,arguments)},C._crypto_generichash_blake2b_statebytes=function(){return C.asm.Yc.apply(null,arguments)},C._crypto_generichash_blake2b_update=function(){return C.asm.Zc.apply(null,arguments)},C._crypto_generichash_bytes=function(){return C.asm._c.apply(null,arguments)},C._crypto_generichash_bytes_max=function(){return C.asm.$c.apply(null,arguments)},C._crypto_generichash_bytes_min=function(){return C.asm.ad.apply(null,arguments)},C._crypto_generichash_final=function(){return C.asm.bd.apply(null,arguments)},C._crypto_generichash_init=function(){return C.asm.cd.apply(null,arguments)},C._crypto_generichash_keybytes=function(){return C.asm.dd.apply(null,arguments)},C._crypto_generichash_keybytes_max=function(){return C.asm.ed.apply(null,arguments)},C._crypto_generichash_keybytes_min=function(){return C.asm.fd.apply(null,arguments)},C._crypto_generichash_keygen=function(){return C.asm.gd.apply(null,arguments)},C._crypto_generichash_primitive=function(){return C.asm.hd.apply(null,arguments)},C._crypto_generichash_statebytes=function(){return C.asm.id.apply(null,arguments)},C._crypto_generichash_update=function(){return C.asm.jd.apply(null,arguments)},C._crypto_hash=function(){return C.asm.kd.apply(null,arguments)},C._crypto_hash_bytes=function(){return C.asm.ld.apply(null,arguments)},C._crypto_hash_primitive=function(){return C.asm.md.apply(null,arguments)},C._crypto_hash_sha256=function(){return C.asm.nd.apply(null,arguments)},C._crypto_hash_sha256_bytes=function(){return C.asm.od.apply(null,arguments)},C._crypto_hash_sha256_final=function(){return C.asm.pd.apply(null,arguments)},C._crypto_hash_sha256_init=function(){return C.asm.qd.apply(null,arguments)},C._crypto_hash_sha256_statebytes=function(){return C.asm.rd.apply(null,arguments)},C._crypto_hash_sha256_update=function(){return C.asm.sd.apply(null,arguments)},C._crypto_hash_sha512=function(){return C.asm.td.apply(null,arguments)},C._crypto_hash_sha512_bytes=function(){return C.asm.ud.apply(null,arguments)},C._crypto_hash_sha512_final=function(){return C.asm.vd.apply(null,arguments)},C._crypto_hash_sha512_init=function(){return C.asm.wd.apply(null,arguments)},C._crypto_hash_sha512_statebytes=function(){return C.asm.xd.apply(null,arguments)},C._crypto_hash_sha512_update=function(){return C.asm.yd.apply(null,arguments)},C._crypto_kdf_blake2b_bytes_max=function(){return C.asm.zd.apply(null,arguments)},C._crypto_kdf_blake2b_bytes_min=function(){return C.asm.Ad.apply(null,arguments)},C._crypto_kdf_blake2b_contextbytes=function(){return C.asm.Bd.apply(null,arguments)},C._crypto_kdf_blake2b_derive_from_key=function(){return C.asm.Cd.apply(null,arguments)},C._crypto_kdf_blake2b_keybytes=function(){return C.asm.Dd.apply(null,arguments)},C._crypto_kdf_bytes_max=function(){return C.asm.Ed.apply(null,arguments)},C._crypto_kdf_bytes_min=function(){return C.asm.Fd.apply(null,arguments)},C._crypto_kdf_contextbytes=function(){return C.asm.Gd.apply(null,arguments)},C._crypto_kdf_derive_from_key=function(){return C.asm.Hd.apply(null,arguments)},C._crypto_kdf_keybytes=function(){return C.asm.Id.apply(null,arguments)},C._crypto_kdf_keygen=function(){return C.asm.Jd.apply(null,arguments)},C._crypto_kdf_primitive=function(){return C.asm.Kd.apply(null,arguments)},C._crypto_kx_client_session_keys=function(){return C.asm.Ld.apply(null,arguments)},C._crypto_kx_keypair=function(){return C.asm.Md.apply(null,arguments)},C._crypto_kx_primitive=function(){return C.asm.Nd.apply(null,arguments)},C._crypto_kx_publickeybytes=function(){return C.asm.Od.apply(null,arguments)},C._crypto_kx_secretkeybytes=function(){return C.asm.Pd.apply(null,arguments)},C._crypto_kx_seed_keypair=function(){return C.asm.Qd.apply(null,arguments)},C._crypto_kx_seedbytes=function(){return C.asm.Rd.apply(null,arguments)},C._crypto_kx_server_session_keys=function(){return C.asm.Sd.apply(null,arguments)},C._crypto_kx_sessionkeybytes=function(){return C.asm.Td.apply(null,arguments)},C._crypto_onetimeauth=function(){return C.asm.Ud.apply(null,arguments)},C._crypto_onetimeauth_bytes=function(){return C.asm.Vd.apply(null,arguments)},C._crypto_onetimeauth_final=function(){return C.asm.Wd.apply(null,arguments)},C._crypto_onetimeauth_init=function(){return C.asm.Xd.apply(null,arguments)},C._crypto_onetimeauth_keybytes=function(){return C.asm.Yd.apply(null,arguments)},C._crypto_onetimeauth_keygen=function(){return C.asm.Zd.apply(null,arguments)},C._crypto_onetimeauth_poly1305=function(){return C.asm._d.apply(null,arguments)},C._crypto_onetimeauth_poly1305_bytes=function(){return C.asm.$d.apply(null,arguments)},C._crypto_onetimeauth_poly1305_final=function(){return C.asm.ae.apply(null,arguments)},C._crypto_onetimeauth_poly1305_init=function(){return C.asm.be.apply(null,arguments)},C._crypto_onetimeauth_poly1305_keybytes=function(){return C.asm.ce.apply(null,arguments)},C._crypto_onetimeauth_poly1305_keygen=function(){return C.asm.de.apply(null,arguments)},C._crypto_onetimeauth_poly1305_statebytes=function(){return C.asm.ee.apply(null,arguments)},C._crypto_onetimeauth_poly1305_update=function(){return C.asm.fe.apply(null,arguments)},C._crypto_onetimeauth_poly1305_verify=function(){return C.asm.ge.apply(null,arguments)},C._crypto_onetimeauth_primitive=function(){return C.asm.he.apply(null,arguments)},C._crypto_onetimeauth_statebytes=function(){return C.asm.ie.apply(null,arguments)},C._crypto_onetimeauth_update=function(){return C.asm.je.apply(null,arguments)},C._crypto_onetimeauth_verify=function(){return C.asm.ke.apply(null,arguments)},C._crypto_pwhash=function(){return C.asm.le.apply(null,arguments)},C._crypto_pwhash_alg_argon2i13=function(){return C.asm.me.apply(null,arguments)},C._crypto_pwhash_alg_argon2id13=function(){return C.asm.ne.apply(null,arguments)},C._crypto_pwhash_alg_default=function(){return C.asm.oe.apply(null,arguments)},C._crypto_pwhash_argon2i=function(){return C.asm.pe.apply(null,arguments)},C._crypto_pwhash_argon2i_alg_argon2i13=function(){return C.asm.qe.apply(null,arguments)},C._crypto_pwhash_argon2i_bytes_max=function(){return C.asm.re.apply(null,arguments)},C._crypto_pwhash_argon2i_bytes_min=function(){return C.asm.se.apply(null,arguments)},C._crypto_pwhash_argon2i_memlimit_interactive=function(){return C.asm.te.apply(null,arguments)},C._crypto_pwhash_argon2i_memlimit_max=function(){return C.asm.ue.apply(null,arguments)},C._crypto_pwhash_argon2i_memlimit_min=function(){return C.asm.ve.apply(null,arguments)},C._crypto_pwhash_argon2i_memlimit_moderate=function(){return C.asm.we.apply(null,arguments)},C._crypto_pwhash_argon2i_memlimit_sensitive=function(){return C.asm.xe.apply(null,arguments)},C._crypto_pwhash_argon2i_opslimit_interactive=function(){return C.asm.ye.apply(null,arguments)},C._crypto_pwhash_argon2i_opslimit_max=function(){return C.asm.ze.apply(null,arguments)},C._crypto_pwhash_argon2i_opslimit_min=function(){return C.asm.Ae.apply(null,arguments)},C._crypto_pwhash_argon2i_opslimit_moderate=function(){return C.asm.Be.apply(null,arguments)},C._crypto_pwhash_argon2i_opslimit_sensitive=function(){return C.asm.Ce.apply(null,arguments)},C._crypto_pwhash_argon2i_passwd_max=function(){return C.asm.De.apply(null,arguments)},C._crypto_pwhash_argon2i_passwd_min=function(){return C.asm.Ee.apply(null,arguments)},C._crypto_pwhash_argon2i_saltbytes=function(){return C.asm.Fe.apply(null,arguments)},C._crypto_pwhash_argon2i_str=function(){return C.asm.Ge.apply(null,arguments)},C._crypto_pwhash_argon2i_str_needs_rehash=function(){return C.asm.He.apply(null,arguments)},C._crypto_pwhash_argon2i_str_verify=function(){return C.asm.Ie.apply(null,arguments)},C._crypto_pwhash_argon2i_strbytes=function(){return C.asm.Je.apply(null,arguments)},C._crypto_pwhash_argon2i_strprefix=function(){return C.asm.Ke.apply(null,arguments)},C._crypto_pwhash_argon2id=function(){return C.asm.Le.apply(null,arguments)},C._crypto_pwhash_argon2id_alg_argon2id13=function(){return C.asm.Me.apply(null,arguments)},C._crypto_pwhash_argon2id_bytes_max=function(){return C.asm.Ne.apply(null,arguments)},C._crypto_pwhash_argon2id_bytes_min=function(){return C.asm.Oe.apply(null,arguments)},C._crypto_pwhash_argon2id_memlimit_interactive=function(){return C.asm.Pe.apply(null,arguments)},C._crypto_pwhash_argon2id_memlimit_max=function(){return C.asm.Qe.apply(null,arguments)},C._crypto_pwhash_argon2id_memlimit_min=function(){return C.asm.Re.apply(null,arguments)},C._crypto_pwhash_argon2id_memlimit_moderate=function(){return C.asm.Se.apply(null,arguments)},C._crypto_pwhash_argon2id_memlimit_sensitive=function(){return C.asm.Te.apply(null,arguments)},C._crypto_pwhash_argon2id_opslimit_interactive=function(){return C.asm.Ue.apply(null,arguments)},C._crypto_pwhash_argon2id_opslimit_max=function(){return C.asm.Ve.apply(null,arguments)},C._crypto_pwhash_argon2id_opslimit_min=function(){return C.asm.We.apply(null,arguments)},C._crypto_pwhash_argon2id_opslimit_moderate=function(){return C.asm.Xe.apply(null,arguments)},C._crypto_pwhash_argon2id_opslimit_sensitive=function(){return C.asm.Ye.apply(null,arguments)},C._crypto_pwhash_argon2id_passwd_max=function(){return C.asm.Ze.apply(null,arguments)},C._crypto_pwhash_argon2id_passwd_min=function(){return C.asm._e.apply(null,arguments)},C._crypto_pwhash_argon2id_saltbytes=function(){return C.asm.$e.apply(null,arguments)},C._crypto_pwhash_argon2id_str=function(){return C.asm.af.apply(null,arguments)},C._crypto_pwhash_argon2id_str_needs_rehash=function(){return C.asm.bf.apply(null,arguments)},C._crypto_pwhash_argon2id_str_verify=function(){return C.asm.cf.apply(null,arguments)},C._crypto_pwhash_argon2id_strbytes=function(){return C.asm.df.apply(null,arguments)},C._crypto_pwhash_argon2id_strprefix=function(){return C.asm.ef.apply(null,arguments)},C._crypto_pwhash_bytes_max=function(){return C.asm.ff.apply(null,arguments)},C._crypto_pwhash_bytes_min=function(){return C.asm.gf.apply(null,arguments)},C._crypto_pwhash_memlimit_interactive=function(){return C.asm.hf.apply(null,arguments)},C._crypto_pwhash_memlimit_max=function(){return C.asm.jf.apply(null,arguments)},C._crypto_pwhash_memlimit_min=function(){return C.asm.kf.apply(null,arguments)},C._crypto_pwhash_memlimit_moderate=function(){return C.asm.lf.apply(null,arguments)},C._crypto_pwhash_memlimit_sensitive=function(){return C.asm.mf.apply(null,arguments)},C._crypto_pwhash_opslimit_interactive=function(){return C.asm.nf.apply(null,arguments)},C._crypto_pwhash_opslimit_max=function(){return C.asm.of.apply(null,arguments)},C._crypto_pwhash_opslimit_min=function(){return C.asm.pf.apply(null,arguments)},C._crypto_pwhash_opslimit_moderate=function(){return C.asm.qf.apply(null,arguments)},C._crypto_pwhash_opslimit_sensitive=function(){return C.asm.rf.apply(null,arguments)},C._crypto_pwhash_passwd_max=function(){return C.asm.sf.apply(null,arguments)},C._crypto_pwhash_passwd_min=function(){return C.asm.tf.apply(null,arguments)},C._crypto_pwhash_primitive=function(){return C.asm.uf.apply(null,arguments)},C._crypto_pwhash_saltbytes=function(){return C.asm.vf.apply(null,arguments)},C._crypto_pwhash_scryptsalsa208sha256=function(){return C.asm.wf.apply(null,arguments)},C._crypto_pwhash_scryptsalsa208sha256_bytes_max=function(){return C.asm.xf.apply(null,arguments)},C._crypto_pwhash_scryptsalsa208sha256_bytes_min=function(){return C.asm.yf.apply(null,arguments)},C._crypto_pwhash_scryptsalsa208sha256_ll=function(){return C.asm.zf.apply(null,arguments)},C._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive=function(){return C.asm.Af.apply(null,arguments)},C._crypto_pwhash_scryptsalsa208sha256_memlimit_max=function(){return C.asm.Bf.apply(null,arguments)},C._crypto_pwhash_scryptsalsa208sha256_memlimit_min=function(){return C.asm.Cf.apply(null,arguments)},C._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive=function(){return C.asm.Df.apply(null,arguments)},C._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive=function(){return C.asm.Ef.apply(null,arguments)},C._crypto_pwhash_scryptsalsa208sha256_opslimit_max=function(){return C.asm.Ff.apply(null,arguments)},C._crypto_pwhash_scryptsalsa208sha256_opslimit_min=function(){return C.asm.Gf.apply(null,arguments)},C._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive=function(){return C.asm.Hf.apply(null,arguments)},C._crypto_pwhash_scryptsalsa208sha256_passwd_max=function(){return C.asm.If.apply(null,arguments)},C._crypto_pwhash_scryptsalsa208sha256_passwd_min=function(){return C.asm.Jf.apply(null,arguments)},C._crypto_pwhash_scryptsalsa208sha256_saltbytes=function(){return C.asm.Kf.apply(null,arguments)},C._crypto_pwhash_scryptsalsa208sha256_str=function(){return C.asm.Lf.apply(null,arguments)},C._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash=function(){return C.asm.Mf.apply(null,arguments)},C._crypto_pwhash_scryptsalsa208sha256_str_verify=function(){return C.asm.Nf.apply(null,arguments)},C._crypto_pwhash_scryptsalsa208sha256_strbytes=function(){return C.asm.Of.apply(null,arguments)},C._crypto_pwhash_scryptsalsa208sha256_strprefix=function(){return C.asm.Pf.apply(null,arguments)},C._crypto_pwhash_str=function(){return C.asm.Qf.apply(null,arguments)},C._crypto_pwhash_str_alg=function(){return C.asm.Rf.apply(null,arguments)},C._crypto_pwhash_str_needs_rehash=function(){return C.asm.Sf.apply(null,arguments)},C._crypto_pwhash_str_verify=function(){return C.asm.Tf.apply(null,arguments)},C._crypto_pwhash_strbytes=function(){return C.asm.Uf.apply(null,arguments)},C._crypto_pwhash_strprefix=function(){return C.asm.Vf.apply(null,arguments)},C._crypto_scalarmult=function(){return C.asm.Wf.apply(null,arguments)},C._crypto_scalarmult_base=function(){return C.asm.Xf.apply(null,arguments)},C._crypto_scalarmult_bytes=function(){return C.asm.Yf.apply(null,arguments)},C._crypto_scalarmult_curve25519=function(){return C.asm.Zf.apply(null,arguments)},C._crypto_scalarmult_curve25519_base=function(){return C.asm._f.apply(null,arguments)},C._crypto_scalarmult_curve25519_bytes=function(){return C.asm.$f.apply(null,arguments)},C._crypto_scalarmult_curve25519_scalarbytes=function(){return C.asm.ag.apply(null,arguments)},C._crypto_scalarmult_ed25519=function(){return C.asm.bg.apply(null,arguments)},C._crypto_scalarmult_ed25519_base=function(){return C.asm.cg.apply(null,arguments)},C._crypto_scalarmult_ed25519_base_noclamp=function(){return C.asm.dg.apply(null,arguments)},C._crypto_scalarmult_ed25519_bytes=function(){return C.asm.eg.apply(null,arguments)},C._crypto_scalarmult_ed25519_noclamp=function(){return C.asm.fg.apply(null,arguments)},C._crypto_scalarmult_ed25519_scalarbytes=function(){return C.asm.gg.apply(null,arguments)},C._crypto_scalarmult_primitive=function(){return C.asm.hg.apply(null,arguments)},C._crypto_scalarmult_ristretto255=function(){return C.asm.ig.apply(null,arguments)},C._crypto_scalarmult_ristretto255_base=function(){return C.asm.jg.apply(null,arguments)},C._crypto_scalarmult_ristretto255_bytes=function(){return C.asm.kg.apply(null,arguments)},C._crypto_scalarmult_ristretto255_scalarbytes=function(){return C.asm.lg.apply(null,arguments)},C._crypto_scalarmult_scalarbytes=function(){return C.asm.mg.apply(null,arguments)},C._crypto_secretbox=function(){return C.asm.ng.apply(null,arguments)},C._crypto_secretbox_boxzerobytes=function(){return C.asm.og.apply(null,arguments)},C._crypto_secretbox_detached=function(){return C.asm.pg.apply(null,arguments)},C._crypto_secretbox_easy=function(){return C.asm.qg.apply(null,arguments)},C._crypto_secretbox_keybytes=function(){return C.asm.rg.apply(null,arguments)},C._crypto_secretbox_keygen=function(){return C.asm.sg.apply(null,arguments)},C._crypto_secretbox_macbytes=function(){return C.asm.tg.apply(null,arguments)},C._crypto_secretbox_messagebytes_max=function(){return C.asm.ug.apply(null,arguments)},C._crypto_secretbox_noncebytes=function(){return C.asm.vg.apply(null,arguments)},C._crypto_secretbox_open=function(){return C.asm.wg.apply(null,arguments)},C._crypto_secretbox_open_detached=function(){return C.asm.xg.apply(null,arguments)},C._crypto_secretbox_open_easy=function(){return C.asm.yg.apply(null,arguments)},C._crypto_secretbox_primitive=function(){return C.asm.zg.apply(null,arguments)},C._crypto_secretbox_xchacha20poly1305_detached=function(){return C.asm.Ag.apply(null,arguments)},C._crypto_secretbox_xchacha20poly1305_easy=function(){return C.asm.Bg.apply(null,arguments)},C._crypto_secretbox_xchacha20poly1305_keybytes=function(){return C.asm.Cg.apply(null,arguments)},C._crypto_secretbox_xchacha20poly1305_macbytes=function(){return C.asm.Dg.apply(null,arguments)},C._crypto_secretbox_xchacha20poly1305_messagebytes_max=function(){return C.asm.Eg.apply(null,arguments)},C._crypto_secretbox_xchacha20poly1305_noncebytes=function(){return C.asm.Fg.apply(null,arguments)},C._crypto_secretbox_xchacha20poly1305_open_detached=function(){return C.asm.Gg.apply(null,arguments)},C._crypto_secretbox_xchacha20poly1305_open_easy=function(){return C.asm.Hg.apply(null,arguments)},C._crypto_secretbox_xsalsa20poly1305=function(){return C.asm.Ig.apply(null,arguments)},C._crypto_secretbox_xsalsa20poly1305_boxzerobytes=function(){return C.asm.Jg.apply(null,arguments)},C._crypto_secretbox_xsalsa20poly1305_keybytes=function(){return C.asm.Kg.apply(null,arguments)},C._crypto_secretbox_xsalsa20poly1305_keygen=function(){return C.asm.Lg.apply(null,arguments)},C._crypto_secretbox_xsalsa20poly1305_macbytes=function(){return C.asm.Mg.apply(null,arguments)},C._crypto_secretbox_xsalsa20poly1305_messagebytes_max=function(){return C.asm.Ng.apply(null,arguments)},C._crypto_secretbox_xsalsa20poly1305_noncebytes=function(){return C.asm.Og.apply(null,arguments)},C._crypto_secretbox_xsalsa20poly1305_open=function(){return C.asm.Pg.apply(null,arguments)},C._crypto_secretbox_xsalsa20poly1305_zerobytes=function(){return C.asm.Qg.apply(null,arguments)},C._crypto_secretbox_zerobytes=function(){return C.asm.Rg.apply(null,arguments)},C._crypto_secretstream_xchacha20poly1305_abytes=function(){return C.asm.Sg.apply(null,arguments)},C._crypto_secretstream_xchacha20poly1305_headerbytes=function(){return C.asm.Tg.apply(null,arguments)},C._crypto_secretstream_xchacha20poly1305_init_pull=function(){return C.asm.Ug.apply(null,arguments)},C._crypto_secretstream_xchacha20poly1305_init_push=function(){return C.asm.Vg.apply(null,arguments)},C._crypto_secretstream_xchacha20poly1305_keybytes=function(){return C.asm.Wg.apply(null,arguments)},C._crypto_secretstream_xchacha20poly1305_keygen=function(){return C.asm.Xg.apply(null,arguments)},C._crypto_secretstream_xchacha20poly1305_messagebytes_max=function(){return C.asm.Yg.apply(null,arguments)},C._crypto_secretstream_xchacha20poly1305_pull=function(){return C.asm.Zg.apply(null,arguments)},C._crypto_secretstream_xchacha20poly1305_push=function(){return C.asm._g.apply(null,arguments)},C._crypto_secretstream_xchacha20poly1305_rekey=function(){return C.asm.$g.apply(null,arguments)},C._crypto_secretstream_xchacha20poly1305_statebytes=function(){return C.asm.ah.apply(null,arguments)},C._crypto_secretstream_xchacha20poly1305_tag_final=function(){return C.asm.bh.apply(null,arguments)},C._crypto_secretstream_xchacha20poly1305_tag_message=function(){return C.asm.ch.apply(null,arguments)},C._crypto_secretstream_xchacha20poly1305_tag_push=function(){return C.asm.dh.apply(null,arguments)},C._crypto_secretstream_xchacha20poly1305_tag_rekey=function(){return C.asm.eh.apply(null,arguments)},C._crypto_shorthash=function(){return C.asm.fh.apply(null,arguments)},C._crypto_shorthash_bytes=function(){return C.asm.gh.apply(null,arguments)},C._crypto_shorthash_keybytes=function(){return C.asm.hh.apply(null,arguments)},C._crypto_shorthash_keygen=function(){return C.asm.ih.apply(null,arguments)},C._crypto_shorthash_primitive=function(){return C.asm.jh.apply(null,arguments)},C._crypto_shorthash_siphash24=function(){return C.asm.kh.apply(null,arguments)},C._crypto_shorthash_siphash24_bytes=function(){return C.asm.lh.apply(null,arguments)},C._crypto_shorthash_siphash24_keybytes=function(){return C.asm.mh.apply(null,arguments)},C._crypto_shorthash_siphashx24=function(){return C.asm.nh.apply(null,arguments)},C._crypto_shorthash_siphashx24_bytes=function(){return C.asm.oh.apply(null,arguments)},C._crypto_shorthash_siphashx24_keybytes=function(){return C.asm.ph.apply(null,arguments)},C._crypto_sign=function(){return C.asm.qh.apply(null,arguments)},C._crypto_sign_bytes=function(){return C.asm.rh.apply(null,arguments)},C._crypto_sign_detached=function(){return C.asm.sh.apply(null,arguments)},C._crypto_sign_ed25519=function(){return C.asm.th.apply(null,arguments)},C._crypto_sign_ed25519_bytes=function(){return C.asm.uh.apply(null,arguments)},C._crypto_sign_ed25519_detached=function(){return C.asm.vh.apply(null,arguments)},C._crypto_sign_ed25519_keypair=function(){return C.asm.wh.apply(null,arguments)},C._crypto_sign_ed25519_messagebytes_max=function(){return C.asm.xh.apply(null,arguments)},C._crypto_sign_ed25519_open=function(){return C.asm.yh.apply(null,arguments)},C._crypto_sign_ed25519_pk_to_curve25519=function(){return C.asm.zh.apply(null,arguments)},C._crypto_sign_ed25519_publickeybytes=function(){return C.asm.Ah.apply(null,arguments)},C._crypto_sign_ed25519_secretkeybytes=function(){return C.asm.Bh.apply(null,arguments)},C._crypto_sign_ed25519_seed_keypair=function(){return C.asm.Ch.apply(null,arguments)},C._crypto_sign_ed25519_seedbytes=function(){return C.asm.Dh.apply(null,arguments)},C._crypto_sign_ed25519_sk_to_curve25519=function(){return C.asm.Eh.apply(null,arguments)},C._crypto_sign_ed25519_sk_to_pk=function(){return C.asm.Fh.apply(null,arguments)},C._crypto_sign_ed25519_sk_to_seed=function(){return C.asm.Gh.apply(null,arguments)},C._crypto_sign_ed25519_verify_detached=function(){return C.asm.Hh.apply(null,arguments)},C._crypto_sign_ed25519ph_final_create=function(){return C.asm.Ih.apply(null,arguments)},C._crypto_sign_ed25519ph_final_verify=function(){return C.asm.Jh.apply(null,arguments)},C._crypto_sign_ed25519ph_init=function(){return C.asm.Kh.apply(null,arguments)},C._crypto_sign_ed25519ph_statebytes=function(){return C.asm.Lh.apply(null,arguments)},C._crypto_sign_ed25519ph_update=function(){return C.asm.Mh.apply(null,arguments)},C._crypto_sign_final_create=function(){return C.asm.Nh.apply(null,arguments)},C._crypto_sign_final_verify=function(){return C.asm.Oh.apply(null,arguments)},C._crypto_sign_init=function(){return C.asm.Ph.apply(null,arguments)},C._crypto_sign_keypair=function(){return C.asm.Qh.apply(null,arguments)},C._crypto_sign_messagebytes_max=function(){return C.asm.Rh.apply(null,arguments)},C._crypto_sign_open=function(){return C.asm.Sh.apply(null,arguments)},C._crypto_sign_primitive=function(){return C.asm.Th.apply(null,arguments)},C._crypto_sign_publickeybytes=function(){return C.asm.Uh.apply(null,arguments)},C._crypto_sign_secretkeybytes=function(){return C.asm.Vh.apply(null,arguments)},C._crypto_sign_seed_keypair=function(){return C.asm.Wh.apply(null,arguments)},C._crypto_sign_seedbytes=function(){return C.asm.Xh.apply(null,arguments)},C._crypto_sign_statebytes=function(){return C.asm.Yh.apply(null,arguments)},C._crypto_sign_update=function(){return C.asm.Zh.apply(null,arguments)},C._crypto_sign_verify_detached=function(){return C.asm._h.apply(null,arguments)},C._crypto_stream=function(){return C.asm.$h.apply(null,arguments)},C._crypto_stream_chacha20=function(){return C.asm.ai.apply(null,arguments)},C._crypto_stream_chacha20_ietf=function(){return C.asm.bi.apply(null,arguments)},C._crypto_stream_chacha20_ietf_keybytes=function(){return C.asm.ci.apply(null,arguments)},C._crypto_stream_chacha20_ietf_keygen=function(){return C.asm.di.apply(null,arguments)},C._crypto_stream_chacha20_ietf_messagebytes_max=function(){return C.asm.ei.apply(null,arguments)},C._crypto_stream_chacha20_ietf_noncebytes=function(){return C.asm.fi.apply(null,arguments)},C._crypto_stream_chacha20_ietf_xor=function(){return C.asm.gi.apply(null,arguments)},C._crypto_stream_chacha20_ietf_xor_ic=function(){return C.asm.hi.apply(null,arguments)},C._crypto_stream_chacha20_keybytes=function(){return C.asm.ii.apply(null,arguments)},C._crypto_stream_chacha20_keygen=function(){return C.asm.ji.apply(null,arguments)},C._crypto_stream_chacha20_messagebytes_max=function(){return C.asm.ki.apply(null,arguments)},C._crypto_stream_chacha20_noncebytes=function(){return C.asm.li.apply(null,arguments)},C._crypto_stream_chacha20_xor=function(){return C.asm.mi.apply(null,arguments)},C._crypto_stream_chacha20_xor_ic=function(){return C.asm.ni.apply(null,arguments)},C._crypto_stream_keybytes=function(){return C.asm.oi.apply(null,arguments)},C._crypto_stream_keygen=function(){return C.asm.pi.apply(null,arguments)},C._crypto_stream_messagebytes_max=function(){return C.asm.qi.apply(null,arguments)},C._crypto_stream_noncebytes=function(){return C.asm.ri.apply(null,arguments)},C._crypto_stream_primitive=function(){return C.asm.si.apply(null,arguments)},C._crypto_stream_salsa20=function(){return C.asm.ti.apply(null,arguments)},C._crypto_stream_salsa2012=function(){return C.asm.ui.apply(null,arguments)},C._crypto_stream_salsa2012_keybytes=function(){return C.asm.vi.apply(null,arguments)},C._crypto_stream_salsa2012_keygen=function(){return C.asm.wi.apply(null,arguments)},C._crypto_stream_salsa2012_messagebytes_max=function(){return C.asm.xi.apply(null,arguments)},C._crypto_stream_salsa2012_noncebytes=function(){return C.asm.yi.apply(null,arguments)},C._crypto_stream_salsa2012_xor=function(){return C.asm.zi.apply(null,arguments)},C._crypto_stream_salsa208=function(){return C.asm.Ai.apply(null,arguments)},C._crypto_stream_salsa208_keybytes=function(){return C.asm.Bi.apply(null,arguments)},C._crypto_stream_salsa208_keygen=function(){return C.asm.Ci.apply(null,arguments)},C._crypto_stream_salsa208_messagebytes_max=function(){return C.asm.Di.apply(null,arguments)},C._crypto_stream_salsa208_noncebytes=function(){return C.asm.Ei.apply(null,arguments)},C._crypto_stream_salsa208_xor=function(){return C.asm.Fi.apply(null,arguments)},C._crypto_stream_salsa20_keybytes=function(){return C.asm.Gi.apply(null,arguments)},C._crypto_stream_salsa20_keygen=function(){return C.asm.Hi.apply(null,arguments)},C._crypto_stream_salsa20_messagebytes_max=function(){return C.asm.Ii.apply(null,arguments)},C._crypto_stream_salsa20_noncebytes=function(){return C.asm.Ji.apply(null,arguments)},C._crypto_stream_salsa20_xor=function(){return C.asm.Ki.apply(null,arguments)},C._crypto_stream_salsa20_xor_ic=function(){return C.asm.Li.apply(null,arguments)},C._crypto_stream_xchacha20=function(){return C.asm.Mi.apply(null,arguments)},C._crypto_stream_xchacha20_keybytes=function(){return C.asm.Ni.apply(null,arguments)},C._crypto_stream_xchacha20_keygen=function(){return C.asm.Oi.apply(null,arguments)},C._crypto_stream_xchacha20_messagebytes_max=function(){return C.asm.Pi.apply(null,arguments)},C._crypto_stream_xchacha20_noncebytes=function(){return C.asm.Qi.apply(null,arguments)},C._crypto_stream_xchacha20_xor=function(){return C.asm.Ri.apply(null,arguments)},C._crypto_stream_xchacha20_xor_ic=function(){return C.asm.Si.apply(null,arguments)},C._crypto_stream_xor=function(){return C.asm.Ti.apply(null,arguments)},C._crypto_stream_xsalsa20=function(){return C.asm.Ui.apply(null,arguments)},C._crypto_stream_xsalsa20_keybytes=function(){return C.asm.Vi.apply(null,arguments)},C._crypto_stream_xsalsa20_keygen=function(){return C.asm.Wi.apply(null,arguments)},C._crypto_stream_xsalsa20_messagebytes_max=function(){return C.asm.Xi.apply(null,arguments)},C._crypto_stream_xsalsa20_noncebytes=function(){return C.asm.Yi.apply(null,arguments)},C._crypto_stream_xsalsa20_xor=function(){return C.asm.Zi.apply(null,arguments)},C._crypto_stream_xsalsa20_xor_ic=function(){return C.asm._i.apply(null,arguments)},C._crypto_verify_16=function(){return C.asm.$i.apply(null,arguments)},C._crypto_verify_16_bytes=function(){return C.asm.aj.apply(null,arguments)},C._crypto_verify_32=function(){return C.asm.bj.apply(null,arguments)},C._crypto_verify_32_bytes=function(){return C.asm.cj.apply(null,arguments)},C._crypto_verify_64=function(){return C.asm.dj.apply(null,arguments)},C._crypto_verify_64_bytes=function(){return C.asm.ej.apply(null,arguments)},C._free=function(){return C.asm.fj.apply(null,arguments)},C._malloc=function(){return C.asm.gj.apply(null,arguments)},C._randombytes=function(){return C.asm.hj.apply(null,arguments)},C._randombytes_buf=function(){return C.asm.ij.apply(null,arguments)},C._randombytes_buf_deterministic=function(){return C.asm.jj.apply(null,arguments)},C._randombytes_close=function(){return C.asm.kj.apply(null,arguments)},C._randombytes_implementation_name=function(){return C.asm.lj.apply(null,arguments)},C._randombytes_random=function(){return C.asm.mj.apply(null,arguments)},C._randombytes_seedbytes=function(){return C.asm.nj.apply(null,arguments)},C._randombytes_stir=function(){return C.asm.oj.apply(null,arguments)},C._randombytes_uniform=function(){return C.asm.pj.apply(null,arguments)},C._sodium_base642bin=function(){return C.asm.qj.apply(null,arguments)},C._sodium_base64_encoded_len=function(){return C.asm.rj.apply(null,arguments)},C._sodium_bin2base64=function(){return C.asm.sj.apply(null,arguments)},C._sodium_bin2hex=function(){return C.asm.tj.apply(null,arguments)},C._sodium_hex2bin=function(){return C.asm.uj.apply(null,arguments)},C._sodium_init=function(){return C.asm.vj.apply(null,arguments)},C._sodium_library_minimal=function(){return C.asm.wj.apply(null,arguments)},C._sodium_library_version_major=function(){return C.asm.xj.apply(null,arguments)},C._sodium_library_version_minor=function(){return C.asm.yj.apply(null,arguments)},C._sodium_pad=function(){return C.asm.zj.apply(null,arguments)},C._sodium_unpad=function(){return C.asm.Aj.apply(null,arguments)},C._sodium_version_string=function(){return C.asm.Bj.apply(null,arguments)},C.asm=cA,C.setValue=function(A,I,g,B){switch("*"===(g=g||"i8").charAt(g.length-1)&&(g="i32"),g){case"i1":case"i8":F[A>>0]=I;break;case"i16":b[A>>1]=I;break;case"i32":d[A>>2]=I;break;case"i64":AA=[I>>>0,($=I,+P($)>=1?$>0?(0|X(+q($/4294967296),4294967295))>>>0:~~+K(($-+(~~$>>>0))/4294967296)>>>0:0)],d[A>>2]=AA[0],d[A+4>>2]=AA[1];break;case"float":H[A>>2]=I;break;case"double":G[A>>3]=I;break;default:W("invalid type for setValue: "+g)}},C.getValue=function(A,I,g){switch("*"===(I=I||"i8").charAt(I.length-1)&&(I="i32"),I){case"i1":case"i8":return F[A>>0];case"i16":return b[A>>1];case"i32":case"i64":return d[A>>2];case"float":return H[A>>2];case"double":return G[A>>3];default:W("invalid type for getValue: "+I)}return null},C.UTF8ToString=x,V=function A(){eA||iA(),eA||(V=A)},C.run=iA,C.preInit)for("function"==typeof C.preInit&&(C.preInit=[C.preInit]);C.preInit.length>0;)C.preInit.pop()();iA()}).catch(function(){B.useBackupModule()}),"object"==typeof process&&"function"==typeof process.removeAllListeners&&(process.removeAllListeners("uncaughtException"),process.removeAllListeners("unhandledRejection")),I} true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (I),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports&&"string"!=typeof exports.nodeName?I(exports):A.libsodium=I(A.libsodium_mod||(A.commonJsStrict={}))}(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(9), "/", __webpack_require__(4).Buffer))

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(1)
var Buffer = __webpack_require__(0).Buffer

var Base = __webpack_require__(13)

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(114)


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var DES = __webpack_require__(292)
var aes = __webpack_require__(57)
var aesModes = __webpack_require__(58)
var desModes = __webpack_require__(305)
var ebtk = __webpack_require__(36)

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var CipherBase = __webpack_require__(13)
var des = __webpack_require__(293)
var inherits = __webpack_require__(1)
var Buffer = __webpack_require__(0).Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.utils = __webpack_require__(115);
exports.Cipher = __webpack_require__(56);
exports.DES = __webpack_require__(116);
exports.CBC = __webpack_require__(294);
exports.EDE = __webpack_require__(295);


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(7);
var inherits = __webpack_require__(1);

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(7);
var inherits = __webpack_require__(1);

var Cipher = __webpack_require__(56);
var DES = __webpack_require__(116);

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var MODES = __webpack_require__(58)
var AuthCipher = __webpack_require__(120)
var Buffer = __webpack_require__(0).Buffer
var StreamCipher = __webpack_require__(121)
var Transform = __webpack_require__(13)
var aes = __webpack_require__(35)
var ebtk = __webpack_require__(36)
var inherits = __webpack_require__(1)

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher


/***/ }),
/* 297 */
/***/ (function(module, exports) {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(26)

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(0).Buffer
var xor = __webpack_require__(26)

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(0).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(0).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(26)

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4).Buffer))

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(0).Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var AuthCipher = __webpack_require__(120)
var Buffer = __webpack_require__(0).Buffer
var MODES = __webpack_require__(58)
var StreamCipher = __webpack_require__(121)
var Transform = __webpack_require__(13)
var aes = __webpack_require__(35)
var ebtk = __webpack_require__(36)
var inherits = __webpack_require__(1)

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv


/***/ }),
/* 305 */
/***/ (function(module, exports) {

exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var generatePrime = __webpack_require__(122)
var primes = __webpack_require__(308)

var DH = __webpack_require__(309)

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4).Buffer))

/***/ }),
/* 307 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__(3);
var MillerRabin = __webpack_require__(123);
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__(122);
var randomBytes = __webpack_require__(19);
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4).Buffer))

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(17)
var stream = __webpack_require__(49)
var inherits = __webpack_require__(1)
var sign = __webpack_require__(311)
var verify = __webpack_require__(343)

var algorithms = __webpack_require__(114)
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = new Buffer(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = new Buffer(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4).Buffer))

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var createHmac = __webpack_require__(113)
var crt = __webpack_require__(60)
var EC = __webpack_require__(61).ec
var BN = __webpack_require__(3)
var parseKeys = __webpack_require__(38)
var curves = __webpack_require__(133)

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [ 0, 1 ]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return new Buffer(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [ 0 ].concat(r)
  if (s[0] & 0x80) s = [ 0 ].concat(s)

  var total = r.length + s.length + 4
  var res = [ 0x30, total, 0x02, r.length ]
  res = res.concat(r, [ 0x02, s.length ], s)
  return new Buffer(res)
}

function getKey (x, q, hash, algo) {
  x = new Buffer(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - x.length)
    zeros.fill(0)
    x = Buffer.concat([ zeros, x ])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = new Buffer(hlen)
  v.fill(1)
  var k = new Buffer(hlen)
  k.fill(0)
  k = createHmac(algo, k).update(v).update(new Buffer([ 0 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(new Buffer([ 1 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = new Buffer(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - out.length)
    zeros.fill(0)
    out = Buffer.concat([ zeros, out ])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = new Buffer(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([ t, kv.v ])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(new Buffer([ 0 ])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4).Buffer))

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.5.2","C:\\Users\\Minion\\Documents\\JET\\Aekiti\\DevStudyJaem\\Projects\\AEchat"]],"_from":"elliptic@6.5.2","_id":"elliptic@6.5.2","_inBundle":false,"_integrity":"sha512-f4x70okzZbIQl/NSRLkI/+tteV/9WqL98zx+SQ69KbXxmVrmjwsNUPn/gYJJ0sHvEak24cZgHIPegRePAtA/xw==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.5.2","name":"elliptic","escapedName":"elliptic","rawSpec":"6.5.2","saveSpec":null,"fetchSpec":"6.5.2"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.2.tgz","_spec":"6.5.2","_where":"C:\\Users\\Minion\\Documents\\JET\\Aekiti\\DevStudyJaem\\Projects\\AEchat","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^3.0.8","grunt":"^1.0.4","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.2","jscs":"^3.0.7","jshint":"^2.10.3","mocha":"^6.2.2"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.2"}

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var BN = __webpack_require__(3);
var inherits = __webpack_require__(1);
var Base = __webpack_require__(37);

var assert = utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16)
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 }
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
  var npoints = this._endoWnafT1;
  var ncoeffs = this._endoWnafT2;
  for (var i = 0; i < points.length; i++) {
    var split = this._endoSplit(coeffs[i]);
    var p = points[i];
    var beta = p._getBeta();

    if (split.k1.negative) {
      split.k1.ineg();
      p = p.neg(true);
    }
    if (split.k2.negative) {
      split.k2.ineg();
      beta = beta.neg(true);
    }

    npoints[i * 2] = p;
    npoints[i * 2 + 1] = beta;
    ncoeffs[i * 2] = split.k1;
    ncoeffs[i * 2 + 1] = split.k2;
  }
  var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

  // Clean-up references to points and coefficients
  for (var j = 0; j < i * 2; j++) {
    npoints[j] = null;
    ncoeffs[j] = null;
  }
  return res;
};

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul)
      }
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point))
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point))
    }
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);
  if (this.isInfinity())
    return this;
  else if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate)
      }
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (var i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (var i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(3);
var inherits = __webpack_require__(1);
var Base = __webpack_require__(37);

var utils = __webpack_require__(8);

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var BN = __webpack_require__(3);
var inherits = __webpack_require__(1);
var Base = __webpack_require__(37);

var assert = utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  if (this.curve.twisted) {
    // E = a * C
    var e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      var h = this.z.redSqr();
      // J = F - 2 * H
      var j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    var e = c.redAdd(d);
    // H = (c * Z1)^2
    var h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    var j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
                          this.y,
                          this.z,
                          this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.sha1 = __webpack_require__(317);
exports.sha224 = __webpack_require__(318);
exports.sha256 = __webpack_require__(127);
exports.sha384 = __webpack_require__(319);
exports.sha512 = __webpack_require__(128);


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);
var common = __webpack_require__(27);
var shaCommon = __webpack_require__(126);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);
var SHA256 = __webpack_require__(127);

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};



/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

var SHA512 = __webpack_require__(128);

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);
var common = __webpack_require__(27);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);
var assert = __webpack_require__(7);

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
      ]
    ]
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
      ]
    ]
  }
};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(3);
var HmacDRBG = __webpack_require__(324);
var utils = __webpack_require__(8);
var curves = __webpack_require__(62);
var rand = __webpack_require__(59);
var assert = utils.assert;

var KeyPair = __webpack_require__(325);
var Signature = __webpack_require__(326);

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(curves.hasOwnProperty(options), 'Unknown curve ' + options);

    options = curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray()
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  do {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  } while (true);
};

EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8'
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; true; iter++) {
    var k = options.k ?
        options.k(iter) :
        new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);

  if (!this.curve._maxwellTrick) {
    var p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  var p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(63);
var utils = __webpack_require__(124);
var assert = __webpack_require__(7);

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(3);
var utils = __webpack_require__(8);
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(3);

var utils = __webpack_require__(8);
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;
  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
  }
  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0 && (r[1] & 0x80)) {
    r = r.slice(1);
  }
  if (s[0] === 0 && (s[1] & 0x80)) {
    s = s.slice(1);
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(63);
var curves = __webpack_require__(62);
var utils = __webpack_require__(8);
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__(328);
var Signature = __webpack_require__(329);

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  var curve = curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
               .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(3);
var utils = __webpack_require__(8);
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength)
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.


var asn1 = __webpack_require__(28)

exports.certificate = __webpack_require__(340)

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(28);
var inherits = __webpack_require__(1);

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = __webpack_require__(332).runInThisContext(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};


/***/ }),
/* 332 */
/***/ (function(module, exports) {

var indexOf = function (xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for (var i = 0; i < xs.length; i++) {
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    if (context) {
        forEach(Object_keys(ctx), function (key) {
            context[key] = ctx[key];
        });
    }

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.isContext = function (context) {
    return context instanceof Context;
};

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(1);

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var Reporter = __webpack_require__(29).Reporter;
var EncoderBuffer = __webpack_require__(29).EncoderBuffer;
var DecoderBuffer = __webpack_require__(29).DecoderBuffer;
var assert = __webpack_require__(7);

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input, options);
    else
      result = this._decodeChoice(input, options);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
          ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
        ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var constants = __webpack_require__(130);

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var decoders = exports;

decoders.der = __webpack_require__(131);
decoders.pem = __webpack_require__(337);


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(1);
var Buffer = __webpack_require__(4).Buffer;

var DERDecoder = __webpack_require__(131);

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var encoders = exports;

encoders.der = __webpack_require__(132);
encoders.pem = __webpack_require__(339);


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(1);

var DEREncoder = __webpack_require__(132);

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__(28)

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional(),
    this.key('curve').objid().optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int().optional(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate


/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m
var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m
var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m
var evp = __webpack_require__(36)
var ciphers = __webpack_require__(57)
var Buffer = __webpack_require__(0).Buffer
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = new Buffer(match2[2].replace(/[\r\n]/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = Buffer.from(match[2], 'hex')
    var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var BN = __webpack_require__(3)
var EC = __webpack_require__(61).ec
var parseKeys = __webpack_require__(38)
var curves = __webpack_require__(133)

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [ 1 ]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = new Buffer(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = new Buffer(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4).Buffer))

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var elliptic = __webpack_require__(61)
var BN = __webpack_require__(3)

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4).Buffer))

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

exports.publicEncrypt = __webpack_require__(346)
exports.privateDecrypt = __webpack_require__(347)

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(38)
var randomBytes = __webpack_require__(19)
var createHash = __webpack_require__(17)
var mgf = __webpack_require__(134)
var xor = __webpack_require__(135)
var BN = __webpack_require__(3)
var withPublic = __webpack_require__(136)
var crt = __webpack_require__(60)
var Buffer = __webpack_require__(0).Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(38)
var mgf = __webpack_require__(134)
var xor = __webpack_require__(135)
var BN = __webpack_require__(3)
var crt = __webpack_require__(60)
var createHash = __webpack_require__(17)
var withPublic = __webpack_require__(136)
var Buffer = __webpack_require__(0).Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = __webpack_require__(0)
var randombytes = __webpack_require__(19)
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(9)))

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var contractAddress="ct_2UfoQwSMA4DthdbWLpKAYiEADFtvCXPVb2ziCC929Rga9Yo1Be";var contractSource='\ninclude "List.aes"\ncontract AEchat =\n  record user =\n    { name: string,\n      about: string,\n      image: string,\n      user: address }\n\n  record message =\n    { message: string,\n      time: string,\n      sender: address,\n      seen: bool }\n\n  record state =\n    { profile: map(address, user),\n      friends: map(address, list(address)),\n      messages: map(address, map(address, list(message))),\n      requests: map(address, list(address)),\n      newest_friend: map(address, address) }\n\n  stateful entrypoint init() =\n    { profile={},\n      friends={},\n      messages={},\n      requests={},\n      newest_friend={} }\n\n  function empty_profile() =\n    let empty_profile = { name="", about="", image="", user=Call.caller }\n    empty_profile\n\n  stateful entrypoint register_profile(name\': string, about\': string, image\': string) =\n    let new_profile = {name = name\', about = about\', image = image\', user = Call.caller}\n    put(state{profile[Call.caller] = new_profile})\n\n  entrypoint get_profile()=\n    Map.lookup_default(Call.caller, state.profile, empty_profile())\n\n  stateful entrypoint send_friend_request(friends_address: address) =\n    let empty_address_list: list(address) = [Call.caller]\n    switch(Map.lookup(friends_address, state.requests))\n      None =>   only_one_friend_request(friends_address, empty_address_list)\n      Some(x) => modify_friends_request(x, empty_address_list, friends_address)\n\n  stateful function modify_friends_request(old_list: list(address), new_friend_list: list(address), friends_address: address) : list(address) =\n    let new_list = new_friend_list ++ old_list\n    put(state{requests[friends_address] = new_list})\n    new_list\n\n  stateful function only_one_friend_request(friends_address: address, new_friend_list: list(address)) =\n    put(state{requests[friends_address] = new_friend_list})\n    new_friend_list\n\n  entrypoint get_friend_request() =\n    let friends_request = List.map((request) => Map.lookup_default(request, state.profile, empty_profile()), Map.lookup_default(Call.caller, state.requests, []))\n    friends_request\n\n  stateful entrypoint reject_friend_request(new_friends_address: address) =\n    let friend_request_list = Map.lookup_default(Call.caller, state.requests, [])\n    let new_friend_request_list = List.filter((request) => request != new_friends_address, friend_request_list)\n    put(state{requests[Call.caller] = new_friend_request_list})\n\n  stateful entrypoint accept_friend_request(new_friends_address: address) =\n    let friend_request_list = Map.lookup_default(Call.caller, state.requests, [])\n    let new_friend_request_list = List.filter((request) => request != new_friends_address, friend_request_list)\n\n    let friends_list = Map.lookup_default(Call.caller, state.friends, [])\n    let request_senders_friend_list = Map.lookup_default(new_friends_address, state.friends, [])\n    let new_request_senders_friend_list = Call.caller::request_senders_friend_list\n    let new_friends_list = new_friends_address::friends_list\n    let new_friendsMap = state.friends{[Call.caller] = new_friends_list, [new_friends_address] = new_request_senders_friend_list}\n    put(state{friends = new_friendsMap, requests[Call.caller] = new_friend_request_list})\n\n  entrypoint get_friends()=\n    let friends = List.map((friend) => Map.lookup_default(friend, state.profile, empty_profile()), Map.lookup_default(Call.caller, state.friends, []))\n    friends\n\n  stateful entrypoint send_message(receiver: address, message\': string, time\': string) =\n    let new_message = {message = message\', time = time\', sender = Call.caller, seen = false}\n    let old_state_senders_messages = Map.lookup_default(Call.caller, state.messages, {})\n    let old_state_receiver_messages = Map.lookup_default(receiver, state.messages, {})\n\n    let old_single_receiver_messages = Map.lookup_default(Call.caller, old_state_receiver_messages, [])\n    let old_single_sender_messages = Map.lookup_default(receiver, old_state_senders_messages, [])\n\n    let new_single_receiver_messages = new_message::old_single_receiver_messages\n    let new_single_sender_messages = new_message::old_single_sender_messages\n\n    let new_state_senders_message = old_state_senders_messages{[receiver] = new_single_sender_messages}\n    let new_state_receivers_message = old_state_receiver_messages{[Call.caller] = new_single_receiver_messages}\n\n    let new_updated_state = state.messages{[Call.caller] = new_state_senders_message, [receiver] = new_state_receivers_message}\n\n    put(state{messages = new_updated_state})\n\n  entrypoint get_messages() =\n    Map.lookup_default(Call.caller, state.messages, {})\n\n  entrypoint get_friend_message(friend_address: address) =\n    let all_messages = get_messages()\n    let friend_message = Map.lookup_default(friend_address, all_messages, [])\n    friend_message\n';/* harmony default export */ __webpack_exports__["a"] = ({contractAddress:contractAddress,contractSource:contractSource,url:'https://sdk-testnet.aepps.com',internalUrl:'https://sdk-testnet.aepps.com/',compilerUrl:'https://compiler.aepps.com'});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
window.addEventListener('activate',function(event){event.waitUntil(caches.keys().then(function(names){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=names[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var name=_step.value;caches.delete(name);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}));});window.location.reload();// console.log('Reload for new content.');
}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dp_png__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dp_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__dp_png__);
var initialState={client:"null",currentChat:null,generalImage:__WEBPACK_IMPORTED_MODULE_0__dp_png___default.a,usersProfile:{},prevImage:null};var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];if(action.type==="SET_CLIENT"){return Object.assign({},state,{client:action.client});}if(action.type==="SET_CURRENT_CHAT"){return Object.assign({},state,{currentChat:action.currentChat});}if(action.type==="SET_GENERAL_IMAGE"){return Object.assign({},state,{generalImage:action.generalImage});}if(action.type==="SET_USER_PROFILE"){return Object.assign({},state,{usersProfile:action.usersProfile});}if(action.type==="SET_PREV_IMAGE"){return Object.assign({},state,{prevImage:action.prevImage});}return Object.assign({},state);};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.4c8f1134.js